import * as C from "react";
import Ha, { forwardRef as hk, useContext as qA, Children as E8, isValidElement as m1, cloneElement as h1, createElement as Ch, createContext as T8, useState as O8, useMemo as j$ } from "react";
function YA(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gR = { exports: {} }, hb = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H$;
function R8() {
  if (H$)
    return hb;
  H$ = 1;
  var e = Ha, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(m, h, v) {
    var b, x = {}, E = null, T = null;
    v !== void 0 && (E = "" + v), h.key !== void 0 && (E = "" + h.key), h.ref !== void 0 && (T = h.ref);
    for (b in h)
      i.call(h, b) && !c.hasOwnProperty(b) && (x[b] = h[b]);
    if (m && m.defaultProps)
      for (b in h = m.defaultProps, h)
        x[b] === void 0 && (x[b] = h[b]);
    return { $$typeof: t, type: m, key: E, ref: T, props: x, _owner: s.current };
  }
  return hb.Fragment = o, hb.jsx = f, hb.jsxs = f, hb;
}
var gb = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U$;
function k8() {
  return U$ || (U$ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ha, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), m = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P = Symbol.iterator, O = "@@iterator";
    function k(fe) {
      if (fe === null || typeof fe != "object")
        return null;
      var at = P && fe[P] || fe[O];
      return typeof at == "function" ? at : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(fe) {
      {
        for (var at = arguments.length, Et = new Array(at > 1 ? at - 1 : 0), Ie = 1; Ie < at; Ie++)
          Et[Ie - 1] = arguments[Ie];
        _("error", fe, Et);
      }
    }
    function _(fe, at, Et) {
      {
        var Ie = I.ReactDebugCurrentFrame, xe = Ie.getStackAddendum();
        xe !== "" && (at += "%s", Et = Et.concat([xe]));
        var ze = Et.map(function(mt) {
          return String(mt);
        });
        ze.unshift("Warning: " + at), Function.prototype.apply.call(console[fe], console, ze);
      }
    }
    var z = !1, V = !1, M = !1, A = !1, W = !1, Y;
    Y = Symbol.for("react.module.reference");
    function H(fe) {
      return !!(typeof fe == "string" || typeof fe == "function" || fe === i || fe === c || W || fe === s || fe === v || fe === b || A || fe === T || z || V || M || typeof fe == "object" && fe !== null && (fe.$$typeof === E || fe.$$typeof === x || fe.$$typeof === f || fe.$$typeof === m || fe.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      fe.$$typeof === Y || fe.getModuleId !== void 0));
    }
    function G(fe, at, Et) {
      var Ie = fe.displayName;
      if (Ie)
        return Ie;
      var xe = at.displayName || at.name || "";
      return xe !== "" ? Et + "(" + xe + ")" : Et;
    }
    function ne(fe) {
      return fe.displayName || "Context";
    }
    function K(fe) {
      if (fe == null)
        return null;
      if (typeof fe.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof fe == "function")
        return fe.displayName || fe.name || null;
      if (typeof fe == "string")
        return fe;
      switch (fe) {
        case i:
          return "Fragment";
        case o:
          return "Portal";
        case c:
          return "Profiler";
        case s:
          return "StrictMode";
        case v:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof fe == "object")
        switch (fe.$$typeof) {
          case m:
            var at = fe;
            return ne(at) + ".Consumer";
          case f:
            var Et = fe;
            return ne(Et._context) + ".Provider";
          case h:
            return G(fe, fe.render, "ForwardRef");
          case x:
            var Ie = fe.displayName || null;
            return Ie !== null ? Ie : K(fe.type) || "Memo";
          case E: {
            var xe = fe, ze = xe._payload, mt = xe._init;
            try {
              return K(mt(ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, q = 0, X, J, U, Z, ee, ie, oe;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function de() {
      {
        if (q === 0) {
          X = console.log, J = console.info, U = console.warn, Z = console.error, ee = console.group, ie = console.groupCollapsed, oe = console.groupEnd;
          var fe = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: fe,
            log: fe,
            warn: fe,
            error: fe,
            group: fe,
            groupCollapsed: fe,
            groupEnd: fe
          });
        }
        q++;
      }
    }
    function Ce() {
      {
        if (q--, q === 0) {
          var fe = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, fe, {
              value: X
            }),
            info: B({}, fe, {
              value: J
            }),
            warn: B({}, fe, {
              value: U
            }),
            error: B({}, fe, {
              value: Z
            }),
            group: B({}, fe, {
              value: ee
            }),
            groupCollapsed: B({}, fe, {
              value: ie
            }),
            groupEnd: B({}, fe, {
              value: oe
            })
          });
        }
        q < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var me = I.ReactCurrentDispatcher, Oe;
    function he(fe, at, Et) {
      {
        if (Oe === void 0)
          try {
            throw Error();
          } catch (xe) {
            var Ie = xe.stack.trim().match(/\n( *(at )?)/);
            Oe = Ie && Ie[1] || "";
          }
        return `
` + Oe + fe;
      }
    }
    var $e = !1, Ne;
    {
      var Pe = typeof WeakMap == "function" ? WeakMap : Map;
      Ne = new Pe();
    }
    function Se(fe, at) {
      if (!fe || $e)
        return "";
      {
        var Et = Ne.get(fe);
        if (Et !== void 0)
          return Et;
      }
      var Ie;
      $e = !0;
      var xe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ze;
      ze = me.current, me.current = null, de();
      try {
        if (at) {
          var mt = function() {
            throw Error();
          };
          if (Object.defineProperty(mt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(mt, []);
            } catch (An) {
              Ie = An;
            }
            Reflect.construct(fe, [], mt);
          } else {
            try {
              mt.call();
            } catch (An) {
              Ie = An;
            }
            fe.call(mt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (An) {
            Ie = An;
          }
          fe();
        }
      } catch (An) {
        if (An && Ie && typeof An.stack == "string") {
          for (var Ct = An.stack.split(`
`), Qt = Ie.stack.split(`
`), dn = Ct.length - 1, yn = Qt.length - 1; dn >= 1 && yn >= 0 && Ct[dn] !== Qt[yn]; )
            yn--;
          for (; dn >= 1 && yn >= 0; dn--, yn--)
            if (Ct[dn] !== Qt[yn]) {
              if (dn !== 1 || yn !== 1)
                do
                  if (dn--, yn--, yn < 0 || Ct[dn] !== Qt[yn]) {
                    var Wt = `
` + Ct[dn].replace(" at new ", " at ");
                    return fe.displayName && Wt.includes("<anonymous>") && (Wt = Wt.replace("<anonymous>", fe.displayName)), typeof fe == "function" && Ne.set(fe, Wt), Wt;
                  }
                while (dn >= 1 && yn >= 0);
              break;
            }
        }
      } finally {
        $e = !1, me.current = ze, Ce(), Error.prepareStackTrace = xe;
      }
      var Ar = fe ? fe.displayName || fe.name : "", dp = Ar ? he(Ar) : "";
      return typeof fe == "function" && Ne.set(fe, dp), dp;
    }
    function Fe(fe, at, Et) {
      return Se(fe, !1);
    }
    function ce(fe) {
      var at = fe.prototype;
      return !!(at && at.isReactComponent);
    }
    function ge(fe, at, Et) {
      if (fe == null)
        return "";
      if (typeof fe == "function")
        return Se(fe, ce(fe));
      if (typeof fe == "string")
        return he(fe);
      switch (fe) {
        case v:
          return he("Suspense");
        case b:
          return he("SuspenseList");
      }
      if (typeof fe == "object")
        switch (fe.$$typeof) {
          case h:
            return Fe(fe.render);
          case x:
            return ge(fe.type, at, Et);
          case E: {
            var Ie = fe, xe = Ie._payload, ze = Ie._init;
            try {
              return ge(ze(xe), at, Et);
            } catch {
            }
          }
        }
      return "";
    }
    var we = Object.prototype.hasOwnProperty, Me = {}, Qe = I.ReactDebugCurrentFrame;
    function ct(fe) {
      if (fe) {
        var at = fe._owner, Et = ge(fe.type, fe._source, at ? at.type : null);
        Qe.setExtraStackFrame(Et);
      } else
        Qe.setExtraStackFrame(null);
    }
    function Ze(fe, at, Et, Ie, xe) {
      {
        var ze = Function.call.bind(we);
        for (var mt in fe)
          if (ze(fe, mt)) {
            var Ct = void 0;
            try {
              if (typeof fe[mt] != "function") {
                var Qt = Error((Ie || "React class") + ": " + Et + " type `" + mt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof fe[mt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Qt.name = "Invariant Violation", Qt;
              }
              Ct = fe[mt](at, mt, Ie, Et, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (dn) {
              Ct = dn;
            }
            Ct && !(Ct instanceof Error) && (ct(xe), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ie || "React class", Et, mt, typeof Ct), ct(null)), Ct instanceof Error && !(Ct.message in Me) && (Me[Ct.message] = !0, ct(xe), $("Failed %s type: %s", Et, Ct.message), ct(null));
          }
      }
    }
    var Ge = Array.isArray;
    function Be(fe) {
      return Ge(fe);
    }
    function rt(fe) {
      {
        var at = typeof Symbol == "function" && Symbol.toStringTag, Et = at && fe[Symbol.toStringTag] || fe.constructor.name || "Object";
        return Et;
      }
    }
    function wt(fe) {
      try {
        return We(fe), !1;
      } catch {
        return !0;
      }
    }
    function We(fe) {
      return "" + fe;
    }
    function ut(fe) {
      if (wt(fe))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", rt(fe)), We(fe);
    }
    var ft = I.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pt, At, Ye;
    Ye = {};
    function st(fe) {
      if (we.call(fe, "ref")) {
        var at = Object.getOwnPropertyDescriptor(fe, "ref").get;
        if (at && at.isReactWarning)
          return !1;
      }
      return fe.ref !== void 0;
    }
    function _e(fe) {
      if (we.call(fe, "key")) {
        var at = Object.getOwnPropertyDescriptor(fe, "key").get;
        if (at && at.isReactWarning)
          return !1;
      }
      return fe.key !== void 0;
    }
    function vt(fe, at) {
      if (typeof fe.ref == "string" && ft.current && at && ft.current.stateNode !== at) {
        var Et = K(ft.current.type);
        Ye[Et] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(ft.current.type), fe.ref), Ye[Et] = !0);
      }
    }
    function et(fe, at) {
      {
        var Et = function() {
          pt || (pt = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", at));
        };
        Et.isReactWarning = !0, Object.defineProperty(fe, "key", {
          get: Et,
          configurable: !0
        });
      }
    }
    function gt(fe, at) {
      {
        var Et = function() {
          At || (At = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", at));
        };
        Et.isReactWarning = !0, Object.defineProperty(fe, "ref", {
          get: Et,
          configurable: !0
        });
      }
    }
    var kt = function(fe, at, Et, Ie, xe, ze, mt) {
      var Ct = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: fe,
        key: at,
        ref: Et,
        props: mt,
        // Record the component responsible for creating this element.
        _owner: ze
      };
      return Ct._store = {}, Object.defineProperty(Ct._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ct, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.defineProperty(Ct, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.freeze && (Object.freeze(Ct.props), Object.freeze(Ct)), Ct;
    };
    function Lt(fe, at, Et, Ie, xe) {
      {
        var ze, mt = {}, Ct = null, Qt = null;
        Et !== void 0 && (ut(Et), Ct = "" + Et), _e(at) && (ut(at.key), Ct = "" + at.key), st(at) && (Qt = at.ref, vt(at, xe));
        for (ze in at)
          we.call(at, ze) && !Je.hasOwnProperty(ze) && (mt[ze] = at[ze]);
        if (fe && fe.defaultProps) {
          var dn = fe.defaultProps;
          for (ze in dn)
            mt[ze] === void 0 && (mt[ze] = dn[ze]);
        }
        if (Ct || Qt) {
          var yn = typeof fe == "function" ? fe.displayName || fe.name || "Unknown" : fe;
          Ct && et(mt, yn), Qt && gt(mt, yn);
        }
        return kt(fe, Ct, Qt, xe, Ie, ft.current, mt);
      }
    }
    var Ut = I.ReactCurrentOwner, Sn = I.ReactDebugCurrentFrame;
    function an(fe) {
      if (fe) {
        var at = fe._owner, Et = ge(fe.type, fe._source, at ? at.type : null);
        Sn.setExtraStackFrame(Et);
      } else
        Sn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function wn(fe) {
      return typeof fe == "object" && fe !== null && fe.$$typeof === t;
    }
    function hn() {
      {
        if (Ut.current) {
          var fe = K(Ut.current.type);
          if (fe)
            return `

Check the render method of \`` + fe + "`.";
        }
        return "";
      }
    }
    function Br(fe) {
      {
        if (fe !== void 0) {
          var at = fe.fileName.replace(/^.*[\\\/]/, ""), Et = fe.lineNumber;
          return `

Check your code at ` + at + ":" + Et + ".";
        }
        return "";
      }
    }
    var zo = {};
    function wo(fe) {
      {
        var at = hn();
        if (!at) {
          var Et = typeof fe == "string" ? fe : fe.displayName || fe.name;
          Et && (at = `

Check the top-level render call using <` + Et + ">.");
        }
        return at;
      }
    }
    function to(fe, at) {
      {
        if (!fe._store || fe._store.validated || fe.key != null)
          return;
        fe._store.validated = !0;
        var Et = wo(at);
        if (zo[Et])
          return;
        zo[Et] = !0;
        var Ie = "";
        fe && fe._owner && fe._owner !== Ut.current && (Ie = " It was passed a child from " + K(fe._owner.type) + "."), an(fe), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Et, Ie), an(null);
      }
    }
    function Dr(fe, at) {
      {
        if (typeof fe != "object")
          return;
        if (Be(fe))
          for (var Et = 0; Et < fe.length; Et++) {
            var Ie = fe[Et];
            wn(Ie) && to(Ie, at);
          }
        else if (wn(fe))
          fe._store && (fe._store.validated = !0);
        else if (fe) {
          var xe = k(fe);
          if (typeof xe == "function" && xe !== fe.entries)
            for (var ze = xe.call(fe), mt; !(mt = ze.next()).done; )
              wn(mt.value) && to(mt.value, at);
        }
      }
    }
    function Vn(fe) {
      {
        var at = fe.type;
        if (at == null || typeof at == "string")
          return;
        var Et;
        if (typeof at == "function")
          Et = at.propTypes;
        else if (typeof at == "object" && (at.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        at.$$typeof === x))
          Et = at.propTypes;
        else
          return;
        if (Et) {
          var Ie = K(at);
          Ze(Et, fe.props, "prop", Ie, fe);
        } else if (at.PropTypes !== void 0 && !un) {
          un = !0;
          var xe = K(at);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xe || "Unknown");
        }
        typeof at.getDefaultProps == "function" && !at.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Dn(fe) {
      {
        for (var at = Object.keys(fe.props), Et = 0; Et < at.length; Et++) {
          var Ie = at[Et];
          if (Ie !== "children" && Ie !== "key") {
            an(fe), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ie), an(null);
            break;
          }
        }
        fe.ref !== null && (an(fe), $("Invalid attribute `ref` supplied to `React.Fragment`."), an(null));
      }
    }
    function Zn(fe, at, Et, Ie, xe, ze) {
      {
        var mt = H(fe);
        if (!mt) {
          var Ct = "";
          (fe === void 0 || typeof fe == "object" && fe !== null && Object.keys(fe).length === 0) && (Ct += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Qt = Br(xe);
          Qt ? Ct += Qt : Ct += hn();
          var dn;
          fe === null ? dn = "null" : Be(fe) ? dn = "array" : fe !== void 0 && fe.$$typeof === t ? (dn = "<" + (K(fe.type) || "Unknown") + " />", Ct = " Did you accidentally export a JSX literal instead of a component?") : dn = typeof fe, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", dn, Ct);
        }
        var yn = Lt(fe, at, Et, xe, ze);
        if (yn == null)
          return yn;
        if (mt) {
          var Wt = at.children;
          if (Wt !== void 0)
            if (Ie)
              if (Be(Wt)) {
                for (var Ar = 0; Ar < Wt.length; Ar++)
                  Dr(Wt[Ar], fe);
                Object.freeze && Object.freeze(Wt);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dr(Wt, fe);
        }
        return fe === i ? Dn(yn) : Vn(yn), yn;
      }
    }
    function _r(fe, at, Et) {
      return Zn(fe, at, Et, !0);
    }
    function ur(fe, at, Et) {
      return Zn(fe, at, Et, !1);
    }
    var Bn = ur, xr = _r;
    gb.Fragment = i, gb.jsx = Bn, gb.jsxs = xr;
  }()), gb;
}
process.env.NODE_ENV === "production" ? gR.exports = R8() : gR.exports = k8();
var KA = gR.exports;
const L = KA.jsx, ht = KA.jsxs;
function pe(e, t) {
  if (e == null)
    return {};
  var o = {}, i = Object.keys(e), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(t.indexOf(s) >= 0) && (o[s] = e[s]);
  return o;
}
function S() {
  return S = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (e[i] = o[i]);
    }
    return e;
  }, S.apply(this, arguments);
}
var vR = { exports: {} }, nr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G$;
function P8() {
  if (G$)
    return nr;
  G$ = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), m = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P;
  P = Symbol.for("react.module.reference");
  function O(k) {
    if (typeof k == "object" && k !== null) {
      var I = k.$$typeof;
      switch (I) {
        case e:
          switch (k = k.type, k) {
            case o:
            case s:
            case i:
            case v:
            case b:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case m:
                case f:
                case h:
                case E:
                case x:
                case c:
                  return k;
                default:
                  return I;
              }
          }
        case t:
          return I;
      }
    }
  }
  return nr.ContextConsumer = f, nr.ContextProvider = c, nr.Element = e, nr.ForwardRef = h, nr.Fragment = o, nr.Lazy = E, nr.Memo = x, nr.Portal = t, nr.Profiler = s, nr.StrictMode = i, nr.Suspense = v, nr.SuspenseList = b, nr.isAsyncMode = function() {
    return !1;
  }, nr.isConcurrentMode = function() {
    return !1;
  }, nr.isContextConsumer = function(k) {
    return O(k) === f;
  }, nr.isContextProvider = function(k) {
    return O(k) === c;
  }, nr.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, nr.isForwardRef = function(k) {
    return O(k) === h;
  }, nr.isFragment = function(k) {
    return O(k) === o;
  }, nr.isLazy = function(k) {
    return O(k) === E;
  }, nr.isMemo = function(k) {
    return O(k) === x;
  }, nr.isPortal = function(k) {
    return O(k) === t;
  }, nr.isProfiler = function(k) {
    return O(k) === s;
  }, nr.isStrictMode = function(k) {
    return O(k) === i;
  }, nr.isSuspense = function(k) {
    return O(k) === v;
  }, nr.isSuspenseList = function(k) {
    return O(k) === b;
  }, nr.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === o || k === s || k === i || k === v || k === b || k === T || typeof k == "object" && k !== null && (k.$$typeof === E || k.$$typeof === x || k.$$typeof === c || k.$$typeof === f || k.$$typeof === h || k.$$typeof === P || k.getModuleId !== void 0);
  }, nr.typeOf = O, nr;
}
var rr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W$;
function M8() {
  return W$ || (W$ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), m = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P = !1, O = !1, k = !1, I = !1, $ = !1, _;
    _ = Symbol.for("react.module.reference");
    function z(ce) {
      return !!(typeof ce == "string" || typeof ce == "function" || ce === o || ce === s || $ || ce === i || ce === v || ce === b || I || ce === T || P || O || k || typeof ce == "object" && ce !== null && (ce.$$typeof === E || ce.$$typeof === x || ce.$$typeof === c || ce.$$typeof === f || ce.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ce.$$typeof === _ || ce.getModuleId !== void 0));
    }
    function V(ce) {
      if (typeof ce == "object" && ce !== null) {
        var ge = ce.$$typeof;
        switch (ge) {
          case e:
            var we = ce.type;
            switch (we) {
              case o:
              case s:
              case i:
              case v:
              case b:
                return we;
              default:
                var Me = we && we.$$typeof;
                switch (Me) {
                  case m:
                  case f:
                  case h:
                  case E:
                  case x:
                  case c:
                    return Me;
                  default:
                    return ge;
                }
            }
          case t:
            return ge;
        }
      }
    }
    var M = f, A = c, W = e, Y = h, H = o, G = E, ne = x, K = t, B = s, q = i, X = v, J = b, U = !1, Z = !1;
    function ee(ce) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(ce) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function oe(ce) {
      return V(ce) === f;
    }
    function le(ce) {
      return V(ce) === c;
    }
    function de(ce) {
      return typeof ce == "object" && ce !== null && ce.$$typeof === e;
    }
    function Ce(ce) {
      return V(ce) === h;
    }
    function me(ce) {
      return V(ce) === o;
    }
    function Oe(ce) {
      return V(ce) === E;
    }
    function he(ce) {
      return V(ce) === x;
    }
    function $e(ce) {
      return V(ce) === t;
    }
    function Ne(ce) {
      return V(ce) === s;
    }
    function Pe(ce) {
      return V(ce) === i;
    }
    function Se(ce) {
      return V(ce) === v;
    }
    function Fe(ce) {
      return V(ce) === b;
    }
    rr.ContextConsumer = M, rr.ContextProvider = A, rr.Element = W, rr.ForwardRef = Y, rr.Fragment = H, rr.Lazy = G, rr.Memo = ne, rr.Portal = K, rr.Profiler = B, rr.StrictMode = q, rr.Suspense = X, rr.SuspenseList = J, rr.isAsyncMode = ee, rr.isConcurrentMode = ie, rr.isContextConsumer = oe, rr.isContextProvider = le, rr.isElement = de, rr.isForwardRef = Ce, rr.isFragment = me, rr.isLazy = Oe, rr.isMemo = he, rr.isPortal = $e, rr.isProfiler = Ne, rr.isStrictMode = Pe, rr.isSuspense = Se, rr.isSuspenseList = Fe, rr.isValidElementType = z, rr.typeOf = V;
  }()), rr;
}
process.env.NODE_ENV === "production" ? vR.exports = P8() : vR.exports = M8();
var Kl = vR.exports, bR = { exports: {} }, LS = { exports: {} }, or = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q$;
function I8() {
  if (q$)
    return or;
  q$ = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, P = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function _(V) {
    if (typeof V == "object" && V !== null) {
      var M = V.$$typeof;
      switch (M) {
        case t:
          switch (V = V.type, V) {
            case h:
            case v:
            case i:
            case c:
            case s:
            case x:
              return V;
            default:
              switch (V = V && V.$$typeof, V) {
                case m:
                case b:
                case P:
                case T:
                case f:
                  return V;
                default:
                  return M;
              }
          }
        case o:
          return M;
      }
    }
  }
  function z(V) {
    return _(V) === v;
  }
  return or.AsyncMode = h, or.ConcurrentMode = v, or.ContextConsumer = m, or.ContextProvider = f, or.Element = t, or.ForwardRef = b, or.Fragment = i, or.Lazy = P, or.Memo = T, or.Portal = o, or.Profiler = c, or.StrictMode = s, or.Suspense = x, or.isAsyncMode = function(V) {
    return z(V) || _(V) === h;
  }, or.isConcurrentMode = z, or.isContextConsumer = function(V) {
    return _(V) === m;
  }, or.isContextProvider = function(V) {
    return _(V) === f;
  }, or.isElement = function(V) {
    return typeof V == "object" && V !== null && V.$$typeof === t;
  }, or.isForwardRef = function(V) {
    return _(V) === b;
  }, or.isFragment = function(V) {
    return _(V) === i;
  }, or.isLazy = function(V) {
    return _(V) === P;
  }, or.isMemo = function(V) {
    return _(V) === T;
  }, or.isPortal = function(V) {
    return _(V) === o;
  }, or.isProfiler = function(V) {
    return _(V) === c;
  }, or.isStrictMode = function(V) {
    return _(V) === s;
  }, or.isSuspense = function(V) {
    return _(V) === x;
  }, or.isValidElementType = function(V) {
    return typeof V == "string" || typeof V == "function" || V === i || V === v || V === c || V === s || V === x || V === E || typeof V == "object" && V !== null && (V.$$typeof === P || V.$$typeof === T || V.$$typeof === f || V.$$typeof === m || V.$$typeof === b || V.$$typeof === k || V.$$typeof === I || V.$$typeof === $ || V.$$typeof === O);
  }, or.typeOf = _, or;
}
var ar = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y$;
function N8() {
  return Y$ || (Y$ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, P = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function _(Se) {
      return typeof Se == "string" || typeof Se == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Se === i || Se === v || Se === c || Se === s || Se === x || Se === E || typeof Se == "object" && Se !== null && (Se.$$typeof === P || Se.$$typeof === T || Se.$$typeof === f || Se.$$typeof === m || Se.$$typeof === b || Se.$$typeof === k || Se.$$typeof === I || Se.$$typeof === $ || Se.$$typeof === O);
    }
    function z(Se) {
      if (typeof Se == "object" && Se !== null) {
        var Fe = Se.$$typeof;
        switch (Fe) {
          case t:
            var ce = Se.type;
            switch (ce) {
              case h:
              case v:
              case i:
              case c:
              case s:
              case x:
                return ce;
              default:
                var ge = ce && ce.$$typeof;
                switch (ge) {
                  case m:
                  case b:
                  case P:
                  case T:
                  case f:
                    return ge;
                  default:
                    return Fe;
                }
            }
          case o:
            return Fe;
        }
      }
    }
    var V = h, M = v, A = m, W = f, Y = t, H = b, G = i, ne = P, K = T, B = o, q = c, X = s, J = x, U = !1;
    function Z(Se) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ee(Se) || z(Se) === h;
    }
    function ee(Se) {
      return z(Se) === v;
    }
    function ie(Se) {
      return z(Se) === m;
    }
    function oe(Se) {
      return z(Se) === f;
    }
    function le(Se) {
      return typeof Se == "object" && Se !== null && Se.$$typeof === t;
    }
    function de(Se) {
      return z(Se) === b;
    }
    function Ce(Se) {
      return z(Se) === i;
    }
    function me(Se) {
      return z(Se) === P;
    }
    function Oe(Se) {
      return z(Se) === T;
    }
    function he(Se) {
      return z(Se) === o;
    }
    function $e(Se) {
      return z(Se) === c;
    }
    function Ne(Se) {
      return z(Se) === s;
    }
    function Pe(Se) {
      return z(Se) === x;
    }
    ar.AsyncMode = V, ar.ConcurrentMode = M, ar.ContextConsumer = A, ar.ContextProvider = W, ar.Element = Y, ar.ForwardRef = H, ar.Fragment = G, ar.Lazy = ne, ar.Memo = K, ar.Portal = B, ar.Profiler = q, ar.StrictMode = X, ar.Suspense = J, ar.isAsyncMode = Z, ar.isConcurrentMode = ee, ar.isContextConsumer = ie, ar.isContextProvider = oe, ar.isElement = le, ar.isForwardRef = de, ar.isFragment = Ce, ar.isLazy = me, ar.isMemo = Oe, ar.isPortal = he, ar.isProfiler = $e, ar.isStrictMode = Ne, ar.isSuspense = Pe, ar.isValidElementType = _, ar.typeOf = z;
  }()), ar;
}
var K$;
function gk() {
  return K$ || (K$ = 1, process.env.NODE_ENV === "production" ? LS.exports = I8() : LS.exports = N8()), LS.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var PO, X$;
function $8() {
  if (X$)
    return PO;
  X$ = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function i(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var f = {}, m = 0; m < 10; m++)
        f["_" + String.fromCharCode(m)] = m;
      var h = Object.getOwnPropertyNames(f).map(function(b) {
        return f[b];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var v = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        v[b] = b;
      }), Object.keys(Object.assign({}, v)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return PO = s() ? Object.assign : function(c, f) {
    for (var m, h = i(c), v, b = 1; b < arguments.length; b++) {
      m = Object(arguments[b]);
      for (var x in m)
        t.call(m, x) && (h[x] = m[x]);
      if (e) {
        v = e(m);
        for (var E = 0; E < v.length; E++)
          o.call(m, v[E]) && (h[v[E]] = m[v[E]]);
      }
    }
    return h;
  }, PO;
}
var MO, Q$;
function vk() {
  if (Q$)
    return MO;
  Q$ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return MO = e, MO;
}
var IO, Z$;
function XA() {
  return Z$ || (Z$ = 1, IO = Function.call.bind(Object.prototype.hasOwnProperty)), IO;
}
var NO, J$;
function D8() {
  if (J$)
    return NO;
  J$ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = vk(), o = {}, i = XA();
    e = function(c) {
      var f = "Warning: " + c;
      typeof console < "u" && console.error(f);
      try {
        throw new Error(f);
      } catch {
      }
    };
  }
  function s(c, f, m, h, v) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in c)
        if (i(c, b)) {
          var x;
          try {
            if (typeof c[b] != "function") {
              var E = Error(
                (h || "React class") + ": " + m + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            x = c[b](f, b, h, m, null, t);
          } catch (P) {
            x = P;
          }
          if (x && !(x instanceof Error) && e(
            (h || "React class") + ": type specification of " + m + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in o)) {
            o[x.message] = !0;
            var T = v ? v() : "";
            e(
              "Failed " + m + " type: " + x.message + (T ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, NO = s, NO;
}
var $O, e2;
function _8() {
  if (e2)
    return $O;
  e2 = 1;
  var e = gk(), t = $8(), o = vk(), i = XA(), s = D8(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(m) {
    var h = "Warning: " + m;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function f() {
    return null;
  }
  return $O = function(m, h) {
    var v = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function x(ee) {
      var ie = ee && (v && ee[v] || ee[b]);
      if (typeof ie == "function")
        return ie;
    }
    var E = "<<anonymous>>", T = {
      array: I("array"),
      bigint: I("bigint"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: $(),
      arrayOf: _,
      element: z(),
      elementType: V(),
      instanceOf: M,
      node: H(),
      objectOf: W,
      oneOf: A,
      oneOfType: Y,
      shape: ne,
      exact: K
    };
    function P(ee, ie) {
      return ee === ie ? ee !== 0 || 1 / ee === 1 / ie : ee !== ee && ie !== ie;
    }
    function O(ee, ie) {
      this.message = ee, this.data = ie && typeof ie == "object" ? ie : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function k(ee) {
      if (process.env.NODE_ENV !== "production")
        var ie = {}, oe = 0;
      function le(Ce, me, Oe, he, $e, Ne, Pe) {
        if (he = he || E, Ne = Ne || Oe, Pe !== o) {
          if (h) {
            var Se = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Se.name = "Invariant Violation", Se;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = he + ":" + Oe;
            !ie[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            oe < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + Ne + "` prop on `" + he + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ie[Fe] = !0, oe++);
          }
        }
        return me[Oe] == null ? Ce ? me[Oe] === null ? new O("The " + $e + " `" + Ne + "` is marked as required " + ("in `" + he + "`, but its value is `null`.")) : new O("The " + $e + " `" + Ne + "` is marked as required in " + ("`" + he + "`, but its value is `undefined`.")) : null : ee(me, Oe, he, $e, Ne);
      }
      var de = le.bind(null, !1);
      return de.isRequired = le.bind(null, !0), de;
    }
    function I(ee) {
      function ie(oe, le, de, Ce, me, Oe) {
        var he = oe[le], $e = X(he);
        if ($e !== ee) {
          var Ne = J(he);
          return new O(
            "Invalid " + Ce + " `" + me + "` of type " + ("`" + Ne + "` supplied to `" + de + "`, expected ") + ("`" + ee + "`."),
            { expectedType: ee }
          );
        }
        return null;
      }
      return k(ie);
    }
    function $() {
      return k(f);
    }
    function _(ee) {
      function ie(oe, le, de, Ce, me) {
        if (typeof ee != "function")
          return new O("Property `" + me + "` of component `" + de + "` has invalid PropType notation inside arrayOf.");
        var Oe = oe[le];
        if (!Array.isArray(Oe)) {
          var he = X(Oe);
          return new O("Invalid " + Ce + " `" + me + "` of type " + ("`" + he + "` supplied to `" + de + "`, expected an array."));
        }
        for (var $e = 0; $e < Oe.length; $e++) {
          var Ne = ee(Oe, $e, de, Ce, me + "[" + $e + "]", o);
          if (Ne instanceof Error)
            return Ne;
        }
        return null;
      }
      return k(ie);
    }
    function z() {
      function ee(ie, oe, le, de, Ce) {
        var me = ie[oe];
        if (!m(me)) {
          var Oe = X(me);
          return new O("Invalid " + de + " `" + Ce + "` of type " + ("`" + Oe + "` supplied to `" + le + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(ee);
    }
    function V() {
      function ee(ie, oe, le, de, Ce) {
        var me = ie[oe];
        if (!e.isValidElementType(me)) {
          var Oe = X(me);
          return new O("Invalid " + de + " `" + Ce + "` of type " + ("`" + Oe + "` supplied to `" + le + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(ee);
    }
    function M(ee) {
      function ie(oe, le, de, Ce, me) {
        if (!(oe[le] instanceof ee)) {
          var Oe = ee.name || E, he = Z(oe[le]);
          return new O("Invalid " + Ce + " `" + me + "` of type " + ("`" + he + "` supplied to `" + de + "`, expected ") + ("instance of `" + Oe + "`."));
        }
        return null;
      }
      return k(ie);
    }
    function A(ee) {
      if (!Array.isArray(ee))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), f;
      function ie(oe, le, de, Ce, me) {
        for (var Oe = oe[le], he = 0; he < ee.length; he++)
          if (P(Oe, ee[he]))
            return null;
        var $e = JSON.stringify(ee, function(Pe, Se) {
          var Fe = J(Se);
          return Fe === "symbol" ? String(Se) : Se;
        });
        return new O("Invalid " + Ce + " `" + me + "` of value `" + String(Oe) + "` " + ("supplied to `" + de + "`, expected one of " + $e + "."));
      }
      return k(ie);
    }
    function W(ee) {
      function ie(oe, le, de, Ce, me) {
        if (typeof ee != "function")
          return new O("Property `" + me + "` of component `" + de + "` has invalid PropType notation inside objectOf.");
        var Oe = oe[le], he = X(Oe);
        if (he !== "object")
          return new O("Invalid " + Ce + " `" + me + "` of type " + ("`" + he + "` supplied to `" + de + "`, expected an object."));
        for (var $e in Oe)
          if (i(Oe, $e)) {
            var Ne = ee(Oe, $e, de, Ce, me + "." + $e, o);
            if (Ne instanceof Error)
              return Ne;
          }
        return null;
      }
      return k(ie);
    }
    function Y(ee) {
      if (!Array.isArray(ee))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), f;
      for (var ie = 0; ie < ee.length; ie++) {
        var oe = ee[ie];
        if (typeof oe != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(oe) + " at index " + ie + "."
          ), f;
      }
      function le(de, Ce, me, Oe, he) {
        for (var $e = [], Ne = 0; Ne < ee.length; Ne++) {
          var Pe = ee[Ne], Se = Pe(de, Ce, me, Oe, he, o);
          if (Se == null)
            return null;
          Se.data && i(Se.data, "expectedType") && $e.push(Se.data.expectedType);
        }
        var Fe = $e.length > 0 ? ", expected one of type [" + $e.join(", ") + "]" : "";
        return new O("Invalid " + Oe + " `" + he + "` supplied to " + ("`" + me + "`" + Fe + "."));
      }
      return k(le);
    }
    function H() {
      function ee(ie, oe, le, de, Ce) {
        return B(ie[oe]) ? null : new O("Invalid " + de + " `" + Ce + "` supplied to " + ("`" + le + "`, expected a ReactNode."));
      }
      return k(ee);
    }
    function G(ee, ie, oe, le, de) {
      return new O(
        (ee || "React class") + ": " + ie + " type `" + oe + "." + le + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + de + "`."
      );
    }
    function ne(ee) {
      function ie(oe, le, de, Ce, me) {
        var Oe = oe[le], he = X(Oe);
        if (he !== "object")
          return new O("Invalid " + Ce + " `" + me + "` of type `" + he + "` " + ("supplied to `" + de + "`, expected `object`."));
        for (var $e in ee) {
          var Ne = ee[$e];
          if (typeof Ne != "function")
            return G(de, Ce, me, $e, J(Ne));
          var Pe = Ne(Oe, $e, de, Ce, me + "." + $e, o);
          if (Pe)
            return Pe;
        }
        return null;
      }
      return k(ie);
    }
    function K(ee) {
      function ie(oe, le, de, Ce, me) {
        var Oe = oe[le], he = X(Oe);
        if (he !== "object")
          return new O("Invalid " + Ce + " `" + me + "` of type `" + he + "` " + ("supplied to `" + de + "`, expected `object`."));
        var $e = t({}, oe[le], ee);
        for (var Ne in $e) {
          var Pe = ee[Ne];
          if (i(ee, Ne) && typeof Pe != "function")
            return G(de, Ce, me, Ne, J(Pe));
          if (!Pe)
            return new O(
              "Invalid " + Ce + " `" + me + "` key `" + Ne + "` supplied to `" + de + "`.\nBad object: " + JSON.stringify(oe[le], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ee), null, "  ")
            );
          var Se = Pe(Oe, Ne, de, Ce, me + "." + Ne, o);
          if (Se)
            return Se;
        }
        return null;
      }
      return k(ie);
    }
    function B(ee) {
      switch (typeof ee) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ee;
        case "object":
          if (Array.isArray(ee))
            return ee.every(B);
          if (ee === null || m(ee))
            return !0;
          var ie = x(ee);
          if (ie) {
            var oe = ie.call(ee), le;
            if (ie !== ee.entries) {
              for (; !(le = oe.next()).done; )
                if (!B(le.value))
                  return !1;
            } else
              for (; !(le = oe.next()).done; ) {
                var de = le.value;
                if (de && !B(de[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function q(ee, ie) {
      return ee === "symbol" ? !0 : ie ? ie["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ie instanceof Symbol : !1;
    }
    function X(ee) {
      var ie = typeof ee;
      return Array.isArray(ee) ? "array" : ee instanceof RegExp ? "object" : q(ie, ee) ? "symbol" : ie;
    }
    function J(ee) {
      if (typeof ee > "u" || ee === null)
        return "" + ee;
      var ie = X(ee);
      if (ie === "object") {
        if (ee instanceof Date)
          return "date";
        if (ee instanceof RegExp)
          return "regexp";
      }
      return ie;
    }
    function U(ee) {
      var ie = J(ee);
      switch (ie) {
        case "array":
        case "object":
          return "an " + ie;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ie;
        default:
          return ie;
      }
    }
    function Z(ee) {
      return !ee.constructor || !ee.constructor.name ? E : ee.constructor.name;
    }
    return T.checkPropTypes = s, T.resetWarningCache = s.resetWarningCache, T.PropTypes = T, T;
  }, $O;
}
var DO, t2;
function A8() {
  if (t2)
    return DO;
  t2 = 1;
  var e = vk();
  function t() {
  }
  function o() {
  }
  return o.resetWarningCache = t, DO = function() {
    function i(f, m, h, v, b, x) {
      if (x !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    i.isRequired = i;
    function s() {
      return i;
    }
    var c = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: s,
      element: i,
      elementType: i,
      instanceOf: s,
      node: i,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: o,
      resetWarningCache: t
    };
    return c.PropTypes = c, c;
  }, DO;
}
if (process.env.NODE_ENV !== "production") {
  var L8 = gk(), F8 = !0;
  bR.exports = _8()(L8.isElement, F8);
} else
  bR.exports = A8()();
var z8 = bR.exports;
const n = /* @__PURE__ */ YA(z8);
function QA(e) {
  var t, o, i = "";
  if (typeof e == "string" || typeof e == "number")
    i += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (o = QA(e[t])) && (i && (i += " "), i += o);
    else
      for (t in e)
        e[t] && (i && (i += " "), i += t);
  return i;
}
function be() {
  for (var e, t, o = 0, i = ""; o < arguments.length; )
    (e = arguments[o++]) && (t = QA(e)) && (i && (i += " "), i += t);
  return i;
}
function co(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...i) {
    return e(...i) || t(...i);
  };
}
function Bf(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function ZA(e) {
  if (!Bf(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((o) => {
    t[o] = ZA(e[o]);
  }), t;
}
function So(e, t, o = {
  clone: !0
}) {
  const i = o.clone ? S({}, e) : e;
  return Bf(e) && Bf(t) && Object.keys(t).forEach((s) => {
    s !== "__proto__" && (Bf(t[s]) && s in e && Bf(e[s]) ? i[s] = So(e[s], t[s], o) : o.clone ? i[s] = Bf(t[s]) ? ZA(t[s]) : t[s] : i[s] = t[s]);
  }), i;
}
function V8(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function JA(e, t, o, i, s) {
  const c = e[t], f = s || t;
  if (c == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let m;
  const h = c.type;
  return typeof h == "function" && !V8(h) && (m = "Did you accidentally use a plain function component for an element instead?"), m !== void 0 ? new Error(`Invalid ${i} \`${f}\` supplied to \`${o}\`. Expected an element that can hold a ref. ${m} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const eL = co(n.element, JA);
eL.isRequired = co(n.element.isRequired, JA);
const vd = eL;
function B8(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function j8(e, t, o, i, s) {
  const c = e[t], f = s || t;
  if (c == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let m;
  return typeof c == "function" && !B8(c) && (m = "Did you accidentally provide a plain function component instead?"), m !== void 0 ? new Error(`Invalid ${i} \`${f}\` supplied to \`${o}\`. Expected an element type that can hold a ref. ${m} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const dd = co(n.elementType, j8), H8 = "exact-prop: ​";
function ip(e) {
  return process.env.NODE_ENV === "production" ? e : S({}, e, {
    [H8]: (t) => {
      const o = Object.keys(t).filter((i) => !e.hasOwnProperty(i));
      return o.length > 0 ? new Error(`The following props are not supported: ${o.map((i) => `\`${i}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function gi(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let o = 1; o < arguments.length; o += 1)
    t += "&args[]=" + encodeURIComponent(arguments[o]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var yR = { exports: {} }, ir = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n2;
function U8() {
  if (n2)
    return ir;
  n2 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), m = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P;
  P = Symbol.for("react.module.reference");
  function O(k) {
    if (typeof k == "object" && k !== null) {
      var I = k.$$typeof;
      switch (I) {
        case e:
          switch (k = k.type, k) {
            case o:
            case s:
            case i:
            case v:
            case b:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case m:
                case f:
                case h:
                case E:
                case x:
                case c:
                  return k;
                default:
                  return I;
              }
          }
        case t:
          return I;
      }
    }
  }
  return ir.ContextConsumer = f, ir.ContextProvider = c, ir.Element = e, ir.ForwardRef = h, ir.Fragment = o, ir.Lazy = E, ir.Memo = x, ir.Portal = t, ir.Profiler = s, ir.StrictMode = i, ir.Suspense = v, ir.SuspenseList = b, ir.isAsyncMode = function() {
    return !1;
  }, ir.isConcurrentMode = function() {
    return !1;
  }, ir.isContextConsumer = function(k) {
    return O(k) === f;
  }, ir.isContextProvider = function(k) {
    return O(k) === c;
  }, ir.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, ir.isForwardRef = function(k) {
    return O(k) === h;
  }, ir.isFragment = function(k) {
    return O(k) === o;
  }, ir.isLazy = function(k) {
    return O(k) === E;
  }, ir.isMemo = function(k) {
    return O(k) === x;
  }, ir.isPortal = function(k) {
    return O(k) === t;
  }, ir.isProfiler = function(k) {
    return O(k) === s;
  }, ir.isStrictMode = function(k) {
    return O(k) === i;
  }, ir.isSuspense = function(k) {
    return O(k) === v;
  }, ir.isSuspenseList = function(k) {
    return O(k) === b;
  }, ir.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === o || k === s || k === i || k === v || k === b || k === T || typeof k == "object" && k !== null && (k.$$typeof === E || k.$$typeof === x || k.$$typeof === c || k.$$typeof === f || k.$$typeof === h || k.$$typeof === P || k.getModuleId !== void 0);
  }, ir.typeOf = O, ir;
}
var lr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r2;
function G8() {
  return r2 || (r2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), m = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), P = !1, O = !1, k = !1, I = !1, $ = !1, _;
    _ = Symbol.for("react.module.reference");
    function z(ce) {
      return !!(typeof ce == "string" || typeof ce == "function" || ce === o || ce === s || $ || ce === i || ce === v || ce === b || I || ce === T || P || O || k || typeof ce == "object" && ce !== null && (ce.$$typeof === E || ce.$$typeof === x || ce.$$typeof === c || ce.$$typeof === f || ce.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ce.$$typeof === _ || ce.getModuleId !== void 0));
    }
    function V(ce) {
      if (typeof ce == "object" && ce !== null) {
        var ge = ce.$$typeof;
        switch (ge) {
          case e:
            var we = ce.type;
            switch (we) {
              case o:
              case s:
              case i:
              case v:
              case b:
                return we;
              default:
                var Me = we && we.$$typeof;
                switch (Me) {
                  case m:
                  case f:
                  case h:
                  case E:
                  case x:
                  case c:
                    return Me;
                  default:
                    return ge;
                }
            }
          case t:
            return ge;
        }
      }
    }
    var M = f, A = c, W = e, Y = h, H = o, G = E, ne = x, K = t, B = s, q = i, X = v, J = b, U = !1, Z = !1;
    function ee(ce) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(ce) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function oe(ce) {
      return V(ce) === f;
    }
    function le(ce) {
      return V(ce) === c;
    }
    function de(ce) {
      return typeof ce == "object" && ce !== null && ce.$$typeof === e;
    }
    function Ce(ce) {
      return V(ce) === h;
    }
    function me(ce) {
      return V(ce) === o;
    }
    function Oe(ce) {
      return V(ce) === E;
    }
    function he(ce) {
      return V(ce) === x;
    }
    function $e(ce) {
      return V(ce) === t;
    }
    function Ne(ce) {
      return V(ce) === s;
    }
    function Pe(ce) {
      return V(ce) === i;
    }
    function Se(ce) {
      return V(ce) === v;
    }
    function Fe(ce) {
      return V(ce) === b;
    }
    lr.ContextConsumer = M, lr.ContextProvider = A, lr.Element = W, lr.ForwardRef = Y, lr.Fragment = H, lr.Lazy = G, lr.Memo = ne, lr.Portal = K, lr.Profiler = B, lr.StrictMode = q, lr.Suspense = X, lr.SuspenseList = J, lr.isAsyncMode = ee, lr.isConcurrentMode = ie, lr.isContextConsumer = oe, lr.isContextProvider = le, lr.isElement = de, lr.isForwardRef = Ce, lr.isFragment = me, lr.isLazy = Oe, lr.isMemo = he, lr.isPortal = $e, lr.isProfiler = Ne, lr.isStrictMode = Pe, lr.isSuspense = Se, lr.isSuspenseList = Fe, lr.isValidElementType = z, lr.typeOf = V;
  }()), lr;
}
process.env.NODE_ENV === "production" ? yR.exports = U8() : yR.exports = G8();
var o2 = yR.exports;
const W8 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function q8(e) {
  const t = `${e}`.match(W8);
  return t && t[1] || "";
}
function tL(e, t = "") {
  return e.displayName || e.name || q8(e) || t;
}
function a2(e, t, o) {
  const i = tL(t);
  return e.displayName || (i !== "" ? `${o}(${i})` : o);
}
function nL(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return tL(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case o2.ForwardRef:
          return a2(e, e.render, "ForwardRef");
        case o2.Memo:
          return a2(e, e.type, "memo");
        default:
          return;
      }
  }
}
function il(e, t, o, i, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const c = e[t], f = s || t;
  return c == null ? null : c && c.nodeType !== 1 ? new Error(`Invalid ${i} \`${f}\` supplied to \`${o}\`. Expected an HTMLElement.`) : null;
}
const Y8 = n.oneOfType([n.func, n.object]), Fo = Y8;
function ve(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : gi(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function CR(...e) {
  return e.reduce((t, o) => o == null ? t : function(...s) {
    t.apply(this, s), o.apply(this, s);
  }, () => {
  });
}
function lp(e, t = 166) {
  let o;
  function i(...s) {
    const c = () => {
      e.apply(this, s);
    };
    clearTimeout(o), o = setTimeout(c, t);
  }
  return i.clear = () => {
    clearTimeout(o);
  }, i;
}
function lSe(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (o, i, s, c, f) => {
    const m = s || "<<anonymous>>", h = f || i;
    return typeof o[i] < "u" ? new Error(`The ${c} \`${h}\` of \`${m}\` is deprecated. ${t}`) : null;
  };
}
function zc(e, t) {
  var o, i;
  return /* @__PURE__ */ C.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (o = e.type.muiName) != null ? o : (i = e.type) == null || (i = i._payload) == null || (i = i.value) == null ? void 0 : i.muiName
  ) !== -1;
}
function qn(e) {
  return e && e.ownerDocument || document;
}
function Ta(e) {
  return qn(e).defaultView || window;
}
function K8(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const o = t ? S({}, t.propTypes) : null;
  return (s) => (c, f, m, h, v, ...b) => {
    const x = v || f, E = o == null ? void 0 : o[x];
    if (E) {
      const T = E(c, f, m, h, v, ...b);
      if (T)
        return T;
    }
    return typeof c[f] < "u" && !c[s] ? new Error(`The prop \`${x}\` of \`${e}\` can only be used together with the \`${s}\` prop.`) : null;
  };
}
function O1(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const X8 = typeof window < "u" ? C.useLayoutEffect : C.useEffect, Hn = X8;
let i2 = 0;
function Q8(e) {
  const [t, o] = C.useState(e), i = e || t;
  return C.useEffect(() => {
    t == null && (i2 += 1, o(`mui-${i2}`));
  }, [t]), i;
}
const l2 = C["useId".toString()];
function Qn(e) {
  if (l2 !== void 0) {
    const t = l2();
    return e ?? t;
  }
  return Q8(e);
}
function bk(e, t, o, i, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const c = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${c}\` is not supported. Please remove it.`) : null;
}
function _i({
  controlled: e,
  default: t,
  name: o,
  state: i = "value"
}) {
  const {
    current: s
  } = C.useRef(e !== void 0), [c, f] = C.useState(t), m = s ? e : c;
  if (process.env.NODE_ENV !== "production") {
    C.useEffect(() => {
      s !== (e !== void 0) && console.error([`MUI: A component is changing the ${s ? "" : "un"}controlled ${i} state of ${o} to be ${s ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${o} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [i, o, e]);
    const {
      current: v
    } = C.useRef(t);
    C.useEffect(() => {
      !s && v !== t && console.error([`MUI: A component is changing the default ${i} state of an uncontrolled ${o} after being initialized. To suppress this warning opt to use a controlled ${o}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const h = C.useCallback((v) => {
    s || f(v);
  }, []);
  return [m, h];
}
function zn(e) {
  const t = C.useRef(e);
  return Hn(() => {
    t.current = e;
  }), C.useCallback((...o) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, t.current)(...o)
  ), []);
}
function Cn(...e) {
  return C.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((o) => {
      O1(o, t);
    });
  }, e);
}
let lx = !0, SR = !1, s2;
const Z8 = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function J8(e) {
  const {
    type: t,
    tagName: o
  } = e;
  return !!(o === "INPUT" && Z8[t] && !e.readOnly || o === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function e9(e) {
  e.metaKey || e.altKey || e.ctrlKey || (lx = !0);
}
function _O() {
  lx = !1;
}
function t9() {
  this.visibilityState === "hidden" && SR && (lx = !0);
}
function n9(e) {
  e.addEventListener("keydown", e9, !0), e.addEventListener("mousedown", _O, !0), e.addEventListener("pointerdown", _O, !0), e.addEventListener("touchstart", _O, !0), e.addEventListener("visibilitychange", t9, !0);
}
function r9(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return lx || J8(t);
}
function vy() {
  const e = C.useCallback((s) => {
    s != null && n9(s.ownerDocument);
  }, []), t = C.useRef(!1);
  function o() {
    return t.current ? (SR = !0, window.clearTimeout(s2), s2 = window.setTimeout(() => {
      SR = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function i(s) {
    return r9(s) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: i,
    onBlur: o,
    ref: e
  };
}
function rL(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let oh;
function oL() {
  if (oh)
    return oh;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), oh = "reverse", e.scrollLeft > 0 ? oh = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (oh = "negative")), document.body.removeChild(e), oh;
}
function o9(e, t) {
  const o = e.scrollLeft;
  if (t !== "rtl")
    return o;
  switch (oL()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + o;
    case "reverse":
      return e.scrollWidth - e.clientWidth - o;
    default:
      return o;
  }
}
const a9 = (e) => {
  const t = C.useRef({});
  return C.useEffect(() => {
    t.current = e;
  }), t.current;
}, yk = a9, i9 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, aL = i9;
function l9(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function s9(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const c9 = Number.isInteger || s9;
function iL(e, t, o, i) {
  const s = e[t];
  if (s == null || !c9(s)) {
    const c = l9(s);
    return new RangeError(`Invalid ${i} \`${t}\` of type \`${c}\` supplied to \`${o}\`, expected \`integer\`.`);
  }
  return null;
}
function lL(e, t, ...o) {
  return e[t] === void 0 ? null : iL(e, t, ...o);
}
function xR() {
  return null;
}
lL.isRequired = iL;
xR.isRequired = xR;
const eo = process.env.NODE_ENV === "production" ? xR : lL;
function Ck(e, t) {
  const o = S({}, t);
  return Object.keys(e).forEach((i) => {
    if (i.toString().match(/^(components|slots)$/))
      o[i] = S({}, e[i], o[i]);
    else if (i.toString().match(/^(componentsProps|slotProps)$/)) {
      const s = e[i] || {}, c = t[i];
      o[i] = {}, !c || !Object.keys(c) ? o[i] = s : !s || !Object.keys(s) ? o[i] = c : (o[i] = S({}, c), Object.keys(s).forEach((f) => {
        o[i][f] = Ck(s[f], c[f]);
      }));
    } else
      o[i] === void 0 && (o[i] = e[i]);
  }), o;
}
function je(e, t, o = void 0) {
  const i = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      i[s] = e[s].reduce((c, f) => {
        if (f) {
          const m = t(f);
          m !== "" && c.push(m), o && o[f] && c.push(o[f]);
        }
        return c;
      }, []).join(" ");
    }
  ), i;
}
const c2 = (e) => e, u9 = () => {
  let e = c2;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = c2;
    }
  };
}, d9 = u9(), Sk = d9, f9 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ot(e, t, o = "Mui") {
  const i = f9[t];
  return i ? `${o}-${i}` : `${Sk.generate(e)}-${t}`;
}
function lt(e, t, o = "Mui") {
  const i = {};
  return t.forEach((s) => {
    i[s] = ot(e, s, o);
  }), i;
}
function sL(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(o) {
    return t[o] === void 0 && (t[o] = e(o)), t[o];
  };
}
var p9 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, m9 = /* @__PURE__ */ sL(
  function(e) {
    return p9.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function h9(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function g9(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var v9 = /* @__PURE__ */ function() {
  function e(o) {
    var i = this;
    this._insertTag = function(s) {
      var c;
      i.tags.length === 0 ? i.insertionPoint ? c = i.insertionPoint.nextSibling : i.prepend ? c = i.container.firstChild : c = i.before : c = i.tags[i.tags.length - 1].nextSibling, i.container.insertBefore(s, c), i.tags.push(s);
    }, this.isSpeedy = o.speedy === void 0 ? process.env.NODE_ENV === "production" : o.speedy, this.tags = [], this.ctr = 0, this.nonce = o.nonce, this.key = o.key, this.container = o.container, this.prepend = o.prepend, this.insertionPoint = o.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(i) {
    i.forEach(this._insertTag);
  }, t.insert = function(i) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(g9(this));
    var s = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var c = i.charCodeAt(0) === 64 && i.charCodeAt(1) === 105;
      c && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + i + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !c;
    }
    if (this.isSpeedy) {
      var f = h9(s);
      try {
        f.insertRule(i, f.cssRules.length);
      } catch (m) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(i) && console.error('There was a problem inserting the following rule: "' + i + '"', m);
      }
    } else
      s.appendChild(document.createTextNode(i));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(i) {
      return i.parentNode && i.parentNode.removeChild(i);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), xa = "-ms-", R1 = "-moz-", Kn = "-webkit-", xk = "comm", wk = "rule", Ek = "decl", b9 = "@import", cL = "@keyframes", y9 = "@layer", C9 = Math.abs, sx = String.fromCharCode, S9 = Object.assign;
function x9(e, t) {
  return ia(e, 0) ^ 45 ? (((t << 2 ^ ia(e, 0)) << 2 ^ ia(e, 1)) << 2 ^ ia(e, 2)) << 2 ^ ia(e, 3) : 0;
}
function uL(e) {
  return e.trim();
}
function w9(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Xn(e, t, o) {
  return e.replace(t, o);
}
function wR(e, t) {
  return e.indexOf(t);
}
function ia(e, t) {
  return e.charCodeAt(t) | 0;
}
function Xb(e, t, o) {
  return e.slice(t, o);
}
function Ds(e) {
  return e.length;
}
function Tk(e) {
  return e.length;
}
function FS(e, t) {
  return t.push(e), e;
}
function E9(e, t) {
  return e.map(t).join("");
}
var cx = 1, Ph = 1, dL = 0, bi = 0, Co = 0, Bh = "";
function ux(e, t, o, i, s, c, f) {
  return { value: e, root: t, parent: o, type: i, props: s, children: c, line: cx, column: Ph, length: f, return: "" };
}
function vb(e, t) {
  return S9(ux("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function T9() {
  return Co;
}
function O9() {
  return Co = bi > 0 ? ia(Bh, --bi) : 0, Ph--, Co === 10 && (Ph = 1, cx--), Co;
}
function Ai() {
  return Co = bi < dL ? ia(Bh, bi++) : 0, Ph++, Co === 10 && (Ph = 1, cx++), Co;
}
function Fs() {
  return ia(Bh, bi);
}
function g1() {
  return bi;
}
function by(e, t) {
  return Xb(Bh, e, t);
}
function Qb(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function fL(e) {
  return cx = Ph = 1, dL = Ds(Bh = e), bi = 0, [];
}
function pL(e) {
  return Bh = "", e;
}
function v1(e) {
  return uL(by(bi - 1, ER(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function R9(e) {
  for (; (Co = Fs()) && Co < 33; )
    Ai();
  return Qb(e) > 2 || Qb(Co) > 3 ? "" : " ";
}
function k9(e, t) {
  for (; --t && Ai() && !(Co < 48 || Co > 102 || Co > 57 && Co < 65 || Co > 70 && Co < 97); )
    ;
  return by(e, g1() + (t < 6 && Fs() == 32 && Ai() == 32));
}
function ER(e) {
  for (; Ai(); )
    switch (Co) {
      case e:
        return bi;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ER(Co);
        break;
      case 40:
        e === 41 && ER(e);
        break;
      case 92:
        Ai();
        break;
    }
  return bi;
}
function P9(e, t) {
  for (; Ai() && e + Co !== 47 + 10; )
    if (e + Co === 42 + 42 && Fs() === 47)
      break;
  return "/*" + by(t, bi - 1) + "*" + sx(e === 47 ? e : Ai());
}
function M9(e) {
  for (; !Qb(Fs()); )
    Ai();
  return by(e, bi);
}
function I9(e) {
  return pL(b1("", null, null, null, [""], e = fL(e), 0, [0], e));
}
function b1(e, t, o, i, s, c, f, m, h) {
  for (var v = 0, b = 0, x = f, E = 0, T = 0, P = 0, O = 1, k = 1, I = 1, $ = 0, _ = "", z = s, V = c, M = i, A = _; k; )
    switch (P = $, $ = Ai()) {
      case 40:
        if (P != 108 && ia(A, x - 1) == 58) {
          wR(A += Xn(v1($), "&", "&\f"), "&\f") != -1 && (I = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += v1($);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += R9(P);
        break;
      case 92:
        A += k9(g1() - 1, 7);
        continue;
      case 47:
        switch (Fs()) {
          case 42:
          case 47:
            FS(N9(P9(Ai(), g1()), t, o), h);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * O:
        m[v++] = Ds(A) * I;
      case 125 * O:
      case 59:
      case 0:
        switch ($) {
          case 0:
          case 125:
            k = 0;
          case 59 + b:
            I == -1 && (A = Xn(A, /\f/g, "")), T > 0 && Ds(A) - x && FS(T > 32 ? d2(A + ";", i, o, x - 1) : d2(Xn(A, " ", "") + ";", i, o, x - 2), h);
            break;
          case 59:
            A += ";";
          default:
            if (FS(M = u2(A, t, o, v, b, s, m, _, z = [], V = [], x), c), $ === 123)
              if (b === 0)
                b1(A, t, M, M, z, c, x, m, V);
              else
                switch (E === 99 && ia(A, 3) === 110 ? 100 : E) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    b1(e, M, M, i && FS(u2(e, M, M, 0, 0, s, m, _, s, z = [], x), V), s, V, x, m, i ? z : V);
                    break;
                  default:
                    b1(A, M, M, M, [""], V, 0, m, V);
                }
        }
        v = b = T = 0, O = I = 1, _ = A = "", x = f;
        break;
      case 58:
        x = 1 + Ds(A), T = P;
      default:
        if (O < 1) {
          if ($ == 123)
            --O;
          else if ($ == 125 && O++ == 0 && O9() == 125)
            continue;
        }
        switch (A += sx($), $ * O) {
          case 38:
            I = b > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            m[v++] = (Ds(A) - 1) * I, I = 1;
            break;
          case 64:
            Fs() === 45 && (A += v1(Ai())), E = Fs(), b = x = Ds(_ = A += M9(g1())), $++;
            break;
          case 45:
            P === 45 && Ds(A) == 2 && (O = 0);
        }
    }
  return c;
}
function u2(e, t, o, i, s, c, f, m, h, v, b) {
  for (var x = s - 1, E = s === 0 ? c : [""], T = Tk(E), P = 0, O = 0, k = 0; P < i; ++P)
    for (var I = 0, $ = Xb(e, x + 1, x = C9(O = f[P])), _ = e; I < T; ++I)
      (_ = uL(O > 0 ? E[I] + " " + $ : Xn($, /&\f/g, E[I]))) && (h[k++] = _);
  return ux(e, t, o, s === 0 ? wk : m, h, v, b);
}
function N9(e, t, o) {
  return ux(e, t, o, xk, sx(T9()), Xb(e, 2, -2), 0);
}
function d2(e, t, o, i) {
  return ux(e, t, o, Ek, Xb(e, 0, i), Xb(e, i + 1, -1), i);
}
function Sh(e, t) {
  for (var o = "", i = Tk(e), s = 0; s < i; s++)
    o += t(e[s], s, e, t) || "";
  return o;
}
function $9(e, t, o, i) {
  switch (e.type) {
    case y9:
      if (e.children.length)
        break;
    case b9:
    case Ek:
      return e.return = e.return || e.value;
    case xk:
      return "";
    case cL:
      return e.return = e.value + "{" + Sh(e.children, i) + "}";
    case wk:
      e.value = e.props.join(",");
  }
  return Ds(o = Sh(e.children, i)) ? e.return = e.value + "{" + o + "}" : "";
}
function D9(e) {
  var t = Tk(e);
  return function(o, i, s, c) {
    for (var f = "", m = 0; m < t; m++)
      f += e[m](o, i, s, c) || "";
    return f;
  };
}
function _9(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var A9 = function(t, o, i) {
  for (var s = 0, c = 0; s = c, c = Fs(), s === 38 && c === 12 && (o[i] = 1), !Qb(c); )
    Ai();
  return by(t, bi);
}, L9 = function(t, o) {
  var i = -1, s = 44;
  do
    switch (Qb(s)) {
      case 0:
        s === 38 && Fs() === 12 && (o[i] = 1), t[i] += A9(bi - 1, o, i);
        break;
      case 2:
        t[i] += v1(s);
        break;
      case 4:
        if (s === 44) {
          t[++i] = Fs() === 58 ? "&\f" : "", o[i] = t[i].length;
          break;
        }
      default:
        t[i] += sx(s);
    }
  while (s = Ai());
  return t;
}, F9 = function(t, o) {
  return pL(L9(fL(t), o));
}, f2 = /* @__PURE__ */ new WeakMap(), z9 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var o = t.value, i = t.parent, s = t.column === i.column && t.line === i.line; i.type !== "rule"; )
      if (i = i.parent, !i)
        return;
    if (!(t.props.length === 1 && o.charCodeAt(0) !== 58 && !f2.get(i)) && !s) {
      f2.set(t, !0);
      for (var c = [], f = F9(o, c), m = i.props, h = 0, v = 0; h < f.length; h++)
        for (var b = 0; b < m.length; b++, v++)
          t.props[v] = c[h] ? f[h].replace(/&\f/g, m[b]) : m[b] + " " + f[h];
    }
  }
}, V9 = function(t) {
  if (t.type === "decl") {
    var o = t.value;
    // charcode for l
    o.charCodeAt(0) === 108 && // charcode for b
    o.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, B9 = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", j9 = function(t) {
  return t.type === "comm" && t.children.indexOf(B9) > -1;
}, H9 = function(t) {
  return function(o, i, s) {
    if (!(o.type !== "rule" || t.compat)) {
      var c = o.value.match(/(:first|:nth|:nth-last)-child/g);
      if (c) {
        for (var f = !!o.parent, m = f ? o.parent.children : (
          // global rule at the root level
          s
        ), h = m.length - 1; h >= 0; h--) {
          var v = m[h];
          if (v.line < o.line)
            break;
          if (v.column < o.column) {
            if (j9(v))
              return;
            break;
          }
        }
        c.forEach(function(b) {
          console.error('The pseudo class "' + b + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + b.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, mL = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, U9 = function(t, o) {
  for (var i = t - 1; i >= 0; i--)
    if (!mL(o[i]))
      return !0;
  return !1;
}, p2 = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, G9 = function(t, o, i) {
  mL(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), p2(t)) : U9(o, i) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), p2(t)));
};
function hL(e, t) {
  switch (x9(e, t)) {
    case 5103:
      return Kn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Kn + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Kn + e + R1 + e + xa + e + e;
    case 6828:
    case 4268:
      return Kn + e + xa + e + e;
    case 6165:
      return Kn + e + xa + "flex-" + e + e;
    case 5187:
      return Kn + e + Xn(e, /(\w+).+(:[^]+)/, Kn + "box-$1$2" + xa + "flex-$1$2") + e;
    case 5443:
      return Kn + e + xa + "flex-item-" + Xn(e, /flex-|-self/, "") + e;
    case 4675:
      return Kn + e + xa + "flex-line-pack" + Xn(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Kn + e + xa + Xn(e, "shrink", "negative") + e;
    case 5292:
      return Kn + e + xa + Xn(e, "basis", "preferred-size") + e;
    case 6060:
      return Kn + "box-" + Xn(e, "-grow", "") + Kn + e + xa + Xn(e, "grow", "positive") + e;
    case 4554:
      return Kn + Xn(e, /([^-])(transform)/g, "$1" + Kn + "$2") + e;
    case 6187:
      return Xn(Xn(Xn(e, /(zoom-|grab)/, Kn + "$1"), /(image-set)/, Kn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Xn(e, /(image-set\([^]*)/, Kn + "$1$`$1");
    case 4968:
      return Xn(Xn(e, /(.+:)(flex-)?(.*)/, Kn + "box-pack:$3" + xa + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Kn + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Xn(e, /(.+)-inline(.+)/, Kn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ds(e) - 1 - t > 6)
        switch (ia(e, t + 1)) {
          case 109:
            if (ia(e, t + 4) !== 45)
              break;
          case 102:
            return Xn(e, /(.+:)(.+)-([^]+)/, "$1" + Kn + "$2-$3$1" + R1 + (ia(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~wR(e, "stretch") ? hL(Xn(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (ia(e, t + 1) !== 115)
        break;
    case 6444:
      switch (ia(e, Ds(e) - 3 - (~wR(e, "!important") && 10))) {
        case 107:
          return Xn(e, ":", ":" + Kn) + e;
        case 101:
          return Xn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Kn + (ia(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Kn + "$2$3$1" + xa + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (ia(e, t + 11)) {
        case 114:
          return Kn + e + xa + Xn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Kn + e + xa + Xn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Kn + e + xa + Xn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Kn + e + xa + e + e;
  }
  return e;
}
var W9 = function(t, o, i, s) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Ek:
        t.return = hL(t.value, t.length);
        break;
      case cL:
        return Sh([vb(t, {
          value: Xn(t.value, "@", "@" + Kn)
        })], s);
      case wk:
        if (t.length)
          return E9(t.props, function(c) {
            switch (w9(c, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Sh([vb(t, {
                  props: [Xn(c, /:(read-\w+)/, ":" + R1 + "$1")]
                })], s);
              case "::placeholder":
                return Sh([vb(t, {
                  props: [Xn(c, /:(plac\w+)/, ":" + Kn + "input-$1")]
                }), vb(t, {
                  props: [Xn(c, /:(plac\w+)/, ":" + R1 + "$1")]
                }), vb(t, {
                  props: [Xn(c, /:(plac\w+)/, xa + "input-$1")]
                })], s);
            }
            return "";
          });
    }
}, q9 = [W9], gL = function(t) {
  var o = t.key;
  if (process.env.NODE_ENV !== "production" && !o)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (o === "css") {
    var i = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(i, function(O) {
      var k = O.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(O), O.setAttribute("data-s", ""));
    });
  }
  var s = t.stylisPlugins || q9;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(o))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + o + '" was passed');
  var c = {}, f, m = [];
  f = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + o + ' "]'),
    function(O) {
      for (var k = O.getAttribute("data-emotion").split(" "), I = 1; I < k.length; I++)
        c[k[I]] = !0;
      m.push(O);
    }
  );
  var h, v = [z9, V9];
  process.env.NODE_ENV !== "production" && v.push(H9({
    get compat() {
      return P.compat;
    }
  }), G9);
  {
    var b, x = [$9, process.env.NODE_ENV !== "production" ? function(O) {
      O.root || (O.return ? b.insert(O.return) : O.value && O.type !== xk && b.insert(O.value + "{}"));
    } : _9(function(O) {
      b.insert(O);
    })], E = D9(v.concat(s, x)), T = function(k) {
      return Sh(I9(k), E);
    };
    h = function(k, I, $, _) {
      b = $, process.env.NODE_ENV !== "production" && I.map !== void 0 && (b = {
        insert: function(V) {
          $.insert(V + I.map);
        }
      }), T(k ? k + "{" + I.styles + "}" : I.styles), _ && (P.inserted[I.name] = !0);
    };
  }
  var P = {
    key: o,
    sheet: new v9({
      key: o,
      container: f,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: c,
    registered: {},
    insert: h
  };
  return P.sheet.hydrate(m), P;
}, vL = gk(), Y9 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, K9 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, bL = {};
bL[vL.ForwardRef] = Y9;
bL[vL.Memo] = K9;
var X9 = !0;
function Ok(e, t, o) {
  var i = "";
  return o.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : i += s + " ";
  }), i;
}
var dx = function(t, o, i) {
  var s = t.key + "-" + o.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (i === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  X9 === !1) && t.registered[s] === void 0 && (t.registered[s] = o.styles);
}, fx = function(t, o, i) {
  dx(t, o, i);
  var s = t.key + "-" + o.name;
  if (t.inserted[o.name] === void 0) {
    var c = o;
    do
      t.insert(o === c ? "." + s : "", c, t.sheet, !0), c = c.next;
    while (c !== void 0);
  }
};
function Q9(e) {
  for (var t = 0, o, i = 0, s = e.length; s >= 4; ++i, s -= 4)
    o = e.charCodeAt(i) & 255 | (e.charCodeAt(++i) & 255) << 8 | (e.charCodeAt(++i) & 255) << 16 | (e.charCodeAt(++i) & 255) << 24, o = /* Math.imul(k, m): */
    (o & 65535) * 1540483477 + ((o >>> 16) * 59797 << 16), o ^= /* k >>> r: */
    o >>> 24, t = /* Math.imul(k, m): */
    (o & 65535) * 1540483477 + ((o >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(i + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(i + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(i) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Z9 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, m2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, J9 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", eG = /[A-Z]|^ms/g, yL = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Rk = function(t) {
  return t.charCodeAt(1) === 45;
}, h2 = function(t) {
  return t != null && typeof t != "boolean";
}, AO = /* @__PURE__ */ sL(function(e) {
  return Rk(e) ? e : e.replace(eG, "-$&").toLowerCase();
}), k1 = function(t, o) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof o == "string")
        return o.replace(yL, function(i, s, c) {
          return Fl = {
            name: s,
            styles: c,
            next: Fl
          }, s;
        });
  }
  return Z9[t] !== 1 && !Rk(t) && typeof o == "number" && o !== 0 ? o + "px" : o;
};
if (process.env.NODE_ENV !== "production") {
  var tG = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, nG = ["normal", "none", "initial", "inherit", "unset"], rG = k1, oG = /^-ms-/, aG = /-(.)/g, g2 = {};
  k1 = function(t, o) {
    if (t === "content" && (typeof o != "string" || nG.indexOf(o) === -1 && !tG.test(o) && (o.charAt(0) !== o.charAt(o.length - 1) || o.charAt(0) !== '"' && o.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + o + "\"'`");
    var i = rG(t, o);
    return i !== "" && !Rk(t) && t.indexOf("-") !== -1 && g2[t] === void 0 && (g2[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(oG, "ms-").replace(aG, function(s, c) {
      return c.toUpperCase();
    }) + "?")), i;
  };
}
var CL = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Zb(e, t, o) {
  if (o == null)
    return "";
  if (o.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && o.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(CL);
    return o;
  }
  switch (typeof o) {
    case "boolean":
      return "";
    case "object": {
      if (o.anim === 1)
        return Fl = {
          name: o.name,
          styles: o.styles,
          next: Fl
        }, o.name;
      if (o.styles !== void 0) {
        var i = o.next;
        if (i !== void 0)
          for (; i !== void 0; )
            Fl = {
              name: i.name,
              styles: i.styles,
              next: Fl
            }, i = i.next;
        var s = o.styles + ";";
        return process.env.NODE_ENV !== "production" && o.map !== void 0 && (s += o.map), s;
      }
      return iG(e, t, o);
    }
    case "function": {
      if (e !== void 0) {
        var c = Fl, f = o(e);
        return Fl = c, Zb(e, t, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var m = [], h = o.replace(yL, function(b, x, E) {
          var T = "animation" + m.length;
          return m.push("const " + T + " = keyframes`" + E.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + T + "}";
        });
        m.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(m, ["`" + h + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + h + "`"));
      }
      break;
  }
  if (t == null)
    return o;
  var v = t[o];
  return v !== void 0 ? v : o;
}
function iG(e, t, o) {
  var i = "";
  if (Array.isArray(o))
    for (var s = 0; s < o.length; s++)
      i += Zb(e, t, o[s]) + ";";
  else
    for (var c in o) {
      var f = o[c];
      if (typeof f != "object")
        t != null && t[f] !== void 0 ? i += c + "{" + t[f] + "}" : h2(f) && (i += AO(c) + ":" + k1(c, f) + ";");
      else {
        if (c === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(CL);
        if (Array.isArray(f) && typeof f[0] == "string" && (t == null || t[f[0]] === void 0))
          for (var m = 0; m < f.length; m++)
            h2(f[m]) && (i += AO(c) + ":" + k1(c, f[m]) + ";");
        else {
          var h = Zb(e, t, f);
          switch (c) {
            case "animation":
            case "animationName": {
              i += AO(c) + ":" + h + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && c === "undefined" && console.error(J9), i += c + "{" + h + "}";
          }
        }
      }
    }
  return i;
}
var v2 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, SL;
process.env.NODE_ENV !== "production" && (SL = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Fl, Mh = function(t, o, i) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, c = "";
  Fl = void 0;
  var f = t[0];
  f == null || f.raw === void 0 ? (s = !1, c += Zb(i, o, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(m2), c += f[0]);
  for (var m = 1; m < t.length; m++)
    c += Zb(i, o, t[m]), s && (process.env.NODE_ENV !== "production" && f[m] === void 0 && console.error(m2), c += f[m]);
  var h;
  process.env.NODE_ENV !== "production" && (c = c.replace(SL, function(E) {
    return h = E, "";
  })), v2.lastIndex = 0;
  for (var v = "", b; (b = v2.exec(c)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    b[1];
  var x = Q9(c) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: x,
    styles: c,
    map: h,
    next: Fl,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: x,
    styles: c,
    next: Fl
  };
}, lG = function(t) {
  return t();
}, xL = C["useInsertionEffect"] ? C["useInsertionEffect"] : !1, kk = xL || lG, b2 = xL || C.useLayoutEffect, sG = {}.hasOwnProperty, Pk = /* @__PURE__ */ C.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ gL({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Pk.displayName = "EmotionCacheContext");
var cG = Pk.Provider, px = function(t) {
  return /* @__PURE__ */ hk(function(o, i) {
    var s = qA(Pk);
    return t(o, s, i);
  });
}, sp = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (sp.displayName = "EmotionThemeContext");
var y2 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", C2 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", uG = function(t) {
  var o = t.cache, i = t.serialized, s = t.isStringTag;
  return dx(o, i, s), kk(function() {
    return fx(o, i, s);
  }), null;
}, dG = /* @__PURE__ */ px(function(e, t, o) {
  var i = e.css;
  typeof i == "string" && t.registered[i] !== void 0 && (i = t.registered[i]);
  var s = e[y2], c = [i], f = "";
  typeof e.className == "string" ? f = Ok(t.registered, c, e.className) : e.className != null && (f = e.className + " ");
  var m = Mh(c, void 0, C.useContext(sp));
  if (process.env.NODE_ENV !== "production" && m.name.indexOf("-") === -1) {
    var h = e[C2];
    h && (m = Mh([m, "label:" + h + ";"]));
  }
  f += t.key + "-" + m.name;
  var v = {};
  for (var b in e)
    sG.call(e, b) && b !== "css" && b !== y2 && (process.env.NODE_ENV === "production" || b !== C2) && (v[b] = e[b]);
  return v.ref = o, v.className = f, /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(uG, {
    cache: t,
    serialized: m,
    isStringTag: typeof s == "string"
  }), /* @__PURE__ */ C.createElement(s, v));
});
process.env.NODE_ENV !== "production" && (dG.displayName = "EmotionCssPropInternal");
var fG = {
  name: "@emotion/react",
  version: "11.11.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.2",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.0",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, S2 = !1, wL = /* @__PURE__ */ px(function(e, t) {
  process.env.NODE_ENV !== "production" && !S2 && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), S2 = !0);
  var o = e.styles, i = Mh([o], void 0, C.useContext(sp)), s = C.useRef();
  return b2(function() {
    var c = t.key + "-global", f = new t.sheet.constructor({
      key: c,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), m = !1, h = document.querySelector('style[data-emotion="' + c + " " + i.name + '"]');
    return t.sheet.tags.length && (f.before = t.sheet.tags[0]), h !== null && (m = !0, h.setAttribute("data-emotion", c), f.hydrate([h])), s.current = [f, m], function() {
      f.flush();
    };
  }, [t]), b2(function() {
    var c = s.current, f = c[0], m = c[1];
    if (m) {
      c[1] = !1;
      return;
    }
    if (i.next !== void 0 && fx(t, i.next, !0), f.tags.length) {
      var h = f.tags[f.tags.length - 1].nextElementSibling;
      f.before = h, f.flush();
    }
    t.insert("", i, f, !1);
  }, [t, i.name]), null;
});
process.env.NODE_ENV !== "production" && (wL.displayName = "EmotionGlobal");
function fd() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return Mh(t);
}
var Gs = function() {
  var t = fd.apply(void 0, arguments), o = "animation-" + t.name;
  return {
    name: o,
    styles: "@keyframes " + o + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, pG = function e(t) {
  for (var o = t.length, i = 0, s = ""; i < o; i++) {
    var c = t[i];
    if (c != null) {
      var f = void 0;
      switch (typeof c) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(c))
            f = e(c);
          else {
            process.env.NODE_ENV !== "production" && c.styles !== void 0 && c.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), f = "";
            for (var m in c)
              c[m] && m && (f && (f += " "), f += m);
          }
          break;
        }
        default:
          f = c;
      }
      f && (s && (s += " "), s += f);
    }
  }
  return s;
};
function mG(e, t, o) {
  var i = [], s = Ok(e, i, o);
  return i.length < 2 ? o : s + t(i);
}
var hG = function(t) {
  var o = t.cache, i = t.serializedArr;
  return kk(function() {
    for (var s = 0; s < i.length; s++)
      fx(o, i[s], !1);
  }), null;
}, gG = /* @__PURE__ */ px(function(e, t) {
  var o = !1, i = [], s = function() {
    if (o && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var v = arguments.length, b = new Array(v), x = 0; x < v; x++)
      b[x] = arguments[x];
    var E = Mh(b, t.registered);
    return i.push(E), dx(t, E, !1), t.key + "-" + E.name;
  }, c = function() {
    if (o && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var v = arguments.length, b = new Array(v), x = 0; x < v; x++)
      b[x] = arguments[x];
    return mG(t.registered, s, pG(b));
  }, f = {
    css: s,
    cx: c,
    theme: C.useContext(sp)
  }, m = e.children(f);
  return o = !0, /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(hG, {
    cache: t,
    serializedArr: i
  }), m);
});
process.env.NODE_ENV !== "production" && (gG.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var x2 = !0, vG = typeof jest < "u" || typeof vi < "u";
  if (x2 && !vG) {
    var w2 = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : x2 ? window : global
    ), E2 = "__EMOTION_REACT_" + fG.version.split(".")[0] + "__";
    w2[E2] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), w2[E2] = !0;
  }
}
var bG = m9, yG = function(t) {
  return t !== "theme";
}, T2 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? bG : yG;
}, O2 = function(t, o, i) {
  var s;
  if (o) {
    var c = o.shouldForwardProp;
    s = t.__emotion_forwardProp && c ? function(f) {
      return t.__emotion_forwardProp(f) && c(f);
    } : c;
  }
  return typeof s != "function" && i && (s = t.__emotion_forwardProp), s;
}, R2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, CG = function(t) {
  var o = t.cache, i = t.serialized, s = t.isStringTag;
  return dx(o, i, s), kk(function() {
    return fx(o, i, s);
  }), null;
}, SG = function e(t, o) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var i = t.__emotion_real === t, s = i && t.__emotion_base || t, c, f;
  o !== void 0 && (c = o.label, f = o.target);
  var m = O2(t, o, i), h = m || T2(s), v = !h("as");
  return function() {
    var b = arguments, x = i && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (c !== void 0 && x.push("label:" + c + ";"), b[0] == null || b[0].raw === void 0)
      x.push.apply(x, b);
    else {
      process.env.NODE_ENV !== "production" && b[0][0] === void 0 && console.error(R2), x.push(b[0][0]);
      for (var E = b.length, T = 1; T < E; T++)
        process.env.NODE_ENV !== "production" && b[0][T] === void 0 && console.error(R2), x.push(b[T], b[0][T]);
    }
    var P = px(function(O, k, I) {
      var $ = v && O.as || s, _ = "", z = [], V = O;
      if (O.theme == null) {
        V = {};
        for (var M in O)
          V[M] = O[M];
        V.theme = C.useContext(sp);
      }
      typeof O.className == "string" ? _ = Ok(k.registered, z, O.className) : O.className != null && (_ = O.className + " ");
      var A = Mh(x.concat(z), k.registered, V);
      _ += k.key + "-" + A.name, f !== void 0 && (_ += " " + f);
      var W = v && m === void 0 ? T2($) : h, Y = {};
      for (var H in O)
        v && H === "as" || // $FlowFixMe
        W(H) && (Y[H] = O[H]);
      return Y.className = _, Y.ref = I, /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(CG, {
        cache: k,
        serialized: A,
        isStringTag: typeof $ == "string"
      }), /* @__PURE__ */ C.createElement($, Y));
    });
    return P.displayName = c !== void 0 ? c : "Styled(" + (typeof s == "string" ? s : s.displayName || s.name || "Component") + ")", P.defaultProps = t.defaultProps, P.__emotion_real = P, P.__emotion_base = s, P.__emotion_styles = x, P.__emotion_forwardProp = m, Object.defineProperty(P, "toString", {
      value: function() {
        return f === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + f;
      }
    }), P.withComponent = function(O, k) {
      return e(O, S({}, o, k, {
        shouldForwardProp: O2(P, k, !0)
      })).apply(void 0, x);
    }, P;
  };
}, xG = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], TR = SG.bind();
xG.forEach(function(e) {
  TR[e] = TR(e);
});
let OR;
typeof document == "object" && (OR = gL({
  key: "css",
  prepend: !0
}));
function wG(e) {
  const {
    injectFirst: t,
    children: o
  } = e;
  return t && OR ? /* @__PURE__ */ L(cG, {
    value: OR,
    children: o
  }) : o;
}
process.env.NODE_ENV !== "production" && (wG.propTypes = {
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: n.bool
});
function EG(e) {
  return e == null || Object.keys(e).length === 0;
}
function zb(e) {
  const {
    styles: t,
    defaultTheme: o = {}
  } = e;
  return /* @__PURE__ */ L(wL, {
    styles: typeof t == "function" ? (s) => t(EG(s) ? o : s) : t
  });
}
process.env.NODE_ENV !== "production" && (zb.propTypes = {
  defaultTheme: n.object,
  styles: n.oneOfType([n.array, n.string, n.object, n.func])
});
/**
 * @mui/styled-engine v5.14.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function EL(e, t) {
  const o = TR(e, t);
  return process.env.NODE_ENV !== "production" ? (...i) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return i.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : i.some((c) => c === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), o(...i);
  } : o;
}
const TG = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, OG = ["values", "unit", "step"], RG = (e) => {
  const t = Object.keys(e).map((o) => ({
    key: o,
    val: e[o]
  })) || [];
  return t.sort((o, i) => o.val - i.val), t.reduce((o, i) => S({}, o, {
    [i.key]: i.val
  }), {});
};
function TL(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: o = "px",
    step: i = 5
  } = e, s = pe(e, OG), c = RG(t), f = Object.keys(c);
  function m(E) {
    return `@media (min-width:${typeof t[E] == "number" ? t[E] : E}${o})`;
  }
  function h(E) {
    return `@media (max-width:${(typeof t[E] == "number" ? t[E] : E) - i / 100}${o})`;
  }
  function v(E, T) {
    const P = f.indexOf(T);
    return `@media (min-width:${typeof t[E] == "number" ? t[E] : E}${o}) and (max-width:${(P !== -1 && typeof t[f[P]] == "number" ? t[f[P]] : T) - i / 100}${o})`;
  }
  function b(E) {
    return f.indexOf(E) + 1 < f.length ? v(E, f[f.indexOf(E) + 1]) : m(E);
  }
  function x(E) {
    const T = f.indexOf(E);
    return T === 0 ? m(f[1]) : T === f.length - 1 ? h(f[T]) : v(E, f[f.indexOf(E) + 1]).replace("@media", "@media not all and");
  }
  return S({
    keys: f,
    values: c,
    up: m,
    down: h,
    between: v,
    only: b,
    not: x,
    unit: o
  }, s);
}
const kG = {
  borderRadius: 4
}, PG = kG, MG = process.env.NODE_ENV !== "production" ? n.oneOfType([n.number, n.string, n.object, n.array]) : {}, bd = MG;
function Vb(e, t) {
  return t ? So(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Mk = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, k2 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Mk[e]}px)`
};
function yi(e, t, o) {
  const i = e.theme || {};
  if (Array.isArray(t)) {
    const c = i.breakpoints || k2;
    return t.reduce((f, m, h) => (f[c.up(c.keys[h])] = o(t[h]), f), {});
  }
  if (typeof t == "object") {
    const c = i.breakpoints || k2;
    return Object.keys(t).reduce((f, m) => {
      if (Object.keys(c.values || Mk).indexOf(m) !== -1) {
        const h = c.up(m);
        f[h] = o(t[m], m);
      } else {
        const h = m;
        f[h] = t[h];
      }
      return f;
    }, {});
  }
  return o(t);
}
function OL(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((i, s) => {
    const c = e.up(s);
    return i[c] = {}, i;
  }, {})) || {};
}
function RL(e, t) {
  return e.reduce((o, i) => {
    const s = o[i];
    return (!s || Object.keys(s).length === 0) && delete o[i], o;
  }, t);
}
function IG(e, ...t) {
  const o = OL(e), i = [o, ...t].reduce((s, c) => So(s, c), {});
  return RL(Object.keys(o), i);
}
function NG(e, t) {
  if (typeof e != "object")
    return {};
  const o = {}, i = Object.keys(t);
  return Array.isArray(e) ? i.forEach((s, c) => {
    c < e.length && (o[s] = !0);
  }) : i.forEach((s) => {
    e[s] != null && (o[s] = !0);
  }), o;
}
function Wf({
  values: e,
  breakpoints: t,
  base: o
}) {
  const i = o || NG(e, t), s = Object.keys(i);
  if (s.length === 0)
    return e;
  let c;
  return s.reduce((f, m, h) => (Array.isArray(e) ? (f[m] = e[h] != null ? e[h] : e[c], c = h) : typeof e == "object" ? (f[m] = e[m] != null ? e[m] : e[c], c = m) : f[m] = e, f), {});
}
function Ih(e, t, o = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && o) {
    const i = `vars.${t}`.split(".").reduce((s, c) => s && s[c] ? s[c] : null, e);
    if (i != null)
      return i;
  }
  return t.split(".").reduce((i, s) => i && i[s] != null ? i[s] : null, e);
}
function P1(e, t, o, i = o) {
  let s;
  return typeof e == "function" ? s = e(o) : Array.isArray(e) ? s = e[o] || i : s = Ih(e, o) || i, t && (s = t(s, i, e)), s;
}
function cr(e) {
  const {
    prop: t,
    cssProperty: o = e.prop,
    themeKey: i,
    transform: s
  } = e, c = (f) => {
    if (f[t] == null)
      return null;
    const m = f[t], h = f.theme, v = Ih(h, i) || {};
    return yi(f, m, (x) => {
      let E = P1(v, s, x);
      return x === E && typeof x == "string" && (E = P1(v, s, `${t}${x === "default" ? "" : ve(x)}`, x)), o === !1 ? E : {
        [o]: E
      };
    });
  };
  return c.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: bd
  } : {}, c.filterProps = [t], c;
}
function $G(e) {
  const t = {};
  return (o) => (t[o] === void 0 && (t[o] = e(o)), t[o]);
}
const DG = {
  m: "margin",
  p: "padding"
}, _G = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, P2 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, AG = $G((e) => {
  if (e.length > 2)
    if (P2[e])
      e = P2[e];
    else
      return [e];
  const [t, o] = e.split(""), i = DG[t], s = _G[o] || "";
  return Array.isArray(s) ? s.map((c) => i + c) : [i + s];
}), mx = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], hx = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], LG = [...mx, ...hx];
function yy(e, t, o, i) {
  var s;
  const c = (s = Ih(e, t, !1)) != null ? s : o;
  return typeof c == "number" ? (f) => typeof f == "string" ? f : (process.env.NODE_ENV !== "production" && typeof f != "number" && console.error(`MUI: Expected ${i} argument to be a number or a string, got ${f}.`), c * f) : Array.isArray(c) ? (f) => typeof f == "string" ? f : (process.env.NODE_ENV !== "production" && (Number.isInteger(f) ? f > c.length - 1 && console.error([`MUI: The value provided (${f}) overflows.`, `The supported values are: ${JSON.stringify(c)}.`, `${f} > ${c.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), c[f]) : typeof c == "function" ? c : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${c}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Ik(e) {
  return yy(e, "spacing", 8, "spacing");
}
function Zf(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const o = Math.abs(t), i = e(o);
  return t >= 0 ? i : typeof i == "number" ? -i : `-${i}`;
}
function FG(e, t) {
  return (o) => e.reduce((i, s) => (i[s] = Zf(t, o), i), {});
}
function zG(e, t, o, i) {
  if (t.indexOf(o) === -1)
    return null;
  const s = AG(o), c = FG(s, i), f = e[o];
  return yi(e, f, c);
}
function kL(e, t) {
  const o = Ik(e.theme);
  return Object.keys(e).map((i) => zG(e, t, i, o)).reduce(Vb, {});
}
function Qr(e) {
  return kL(e, mx);
}
Qr.propTypes = process.env.NODE_ENV !== "production" ? mx.reduce((e, t) => (e[t] = bd, e), {}) : {};
Qr.filterProps = mx;
function Zr(e) {
  return kL(e, hx);
}
Zr.propTypes = process.env.NODE_ENV !== "production" ? hx.reduce((e, t) => (e[t] = bd, e), {}) : {};
Zr.filterProps = hx;
process.env.NODE_ENV !== "production" && LG.reduce((e, t) => (e[t] = bd, e), {});
function PL(e = 8) {
  if (e.mui)
    return e;
  const t = Ik({
    spacing: e
  }), o = (...i) => (process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${i.length}`)), (i.length === 0 ? [1] : i).map((c) => {
    const f = t(c);
    return typeof f == "number" ? `${f}px` : f;
  }).join(" "));
  return o.mui = !0, o;
}
function gx(...e) {
  const t = e.reduce((i, s) => (s.filterProps.forEach((c) => {
    i[c] = s;
  }), i), {}), o = (i) => Object.keys(i).reduce((s, c) => t[c] ? Vb(s, t[c](i)) : s, {});
  return o.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((i, s) => Object.assign(i, s.propTypes), {}) : {}, o.filterProps = e.reduce((i, s) => i.concat(s.filterProps), []), o;
}
function _s(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const VG = cr({
  prop: "border",
  themeKey: "borders",
  transform: _s
}), BG = cr({
  prop: "borderTop",
  themeKey: "borders",
  transform: _s
}), jG = cr({
  prop: "borderRight",
  themeKey: "borders",
  transform: _s
}), HG = cr({
  prop: "borderBottom",
  themeKey: "borders",
  transform: _s
}), UG = cr({
  prop: "borderLeft",
  themeKey: "borders",
  transform: _s
}), GG = cr({
  prop: "borderColor",
  themeKey: "palette"
}), WG = cr({
  prop: "borderTopColor",
  themeKey: "palette"
}), qG = cr({
  prop: "borderRightColor",
  themeKey: "palette"
}), YG = cr({
  prop: "borderBottomColor",
  themeKey: "palette"
}), KG = cr({
  prop: "borderLeftColor",
  themeKey: "palette"
}), vx = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = yy(e.theme, "shape.borderRadius", 4, "borderRadius"), o = (i) => ({
      borderRadius: Zf(t, i)
    });
    return yi(e, e.borderRadius, o);
  }
  return null;
};
vx.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: bd
} : {};
vx.filterProps = ["borderRadius"];
gx(VG, BG, jG, HG, UG, GG, WG, qG, YG, KG, vx);
const bx = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = yy(e.theme, "spacing", 8, "gap"), o = (i) => ({
      gap: Zf(t, i)
    });
    return yi(e, e.gap, o);
  }
  return null;
};
bx.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: bd
} : {};
bx.filterProps = ["gap"];
const yx = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = yy(e.theme, "spacing", 8, "columnGap"), o = (i) => ({
      columnGap: Zf(t, i)
    });
    return yi(e, e.columnGap, o);
  }
  return null;
};
yx.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: bd
} : {};
yx.filterProps = ["columnGap"];
const Cx = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = yy(e.theme, "spacing", 8, "rowGap"), o = (i) => ({
      rowGap: Zf(t, i)
    });
    return yi(e, e.rowGap, o);
  }
  return null;
};
Cx.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: bd
} : {};
Cx.filterProps = ["rowGap"];
const XG = cr({
  prop: "gridColumn"
}), QG = cr({
  prop: "gridRow"
}), ZG = cr({
  prop: "gridAutoFlow"
}), JG = cr({
  prop: "gridAutoColumns"
}), e7 = cr({
  prop: "gridAutoRows"
}), t7 = cr({
  prop: "gridTemplateColumns"
}), n7 = cr({
  prop: "gridTemplateRows"
}), r7 = cr({
  prop: "gridTemplateAreas"
}), o7 = cr({
  prop: "gridArea"
});
gx(bx, yx, Cx, XG, QG, ZG, JG, e7, t7, n7, r7, o7);
function xh(e, t) {
  return t === "grey" ? t : e;
}
const a7 = cr({
  prop: "color",
  themeKey: "palette",
  transform: xh
}), i7 = cr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: xh
}), l7 = cr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: xh
});
gx(a7, i7, l7);
function Di(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const s7 = cr({
  prop: "width",
  transform: Di
}), Nk = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (o) => {
      var i, s;
      const c = ((i = e.theme) == null || (i = i.breakpoints) == null || (i = i.values) == null ? void 0 : i[o]) || Mk[o];
      return c ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${c}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: c
      } : {
        maxWidth: Di(o)
      };
    };
    return yi(e, e.maxWidth, t);
  }
  return null;
};
Nk.filterProps = ["maxWidth"];
const c7 = cr({
  prop: "minWidth",
  transform: Di
}), u7 = cr({
  prop: "height",
  transform: Di
}), d7 = cr({
  prop: "maxHeight",
  transform: Di
}), f7 = cr({
  prop: "minHeight",
  transform: Di
});
cr({
  prop: "size",
  cssProperty: "width",
  transform: Di
});
cr({
  prop: "size",
  cssProperty: "height",
  transform: Di
});
const p7 = cr({
  prop: "boxSizing"
});
gx(s7, Nk, c7, u7, d7, f7, p7);
const m7 = {
  // borders
  border: {
    themeKey: "borders",
    transform: _s
  },
  borderTop: {
    themeKey: "borders",
    transform: _s
  },
  borderRight: {
    themeKey: "borders",
    transform: _s
  },
  borderBottom: {
    themeKey: "borders",
    transform: _s
  },
  borderLeft: {
    themeKey: "borders",
    transform: _s
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: vx
  },
  // palette
  color: {
    themeKey: "palette",
    transform: xh
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: xh
  },
  backgroundColor: {
    themeKey: "palette",
    transform: xh
  },
  // spacing
  p: {
    style: Zr
  },
  pt: {
    style: Zr
  },
  pr: {
    style: Zr
  },
  pb: {
    style: Zr
  },
  pl: {
    style: Zr
  },
  px: {
    style: Zr
  },
  py: {
    style: Zr
  },
  padding: {
    style: Zr
  },
  paddingTop: {
    style: Zr
  },
  paddingRight: {
    style: Zr
  },
  paddingBottom: {
    style: Zr
  },
  paddingLeft: {
    style: Zr
  },
  paddingX: {
    style: Zr
  },
  paddingY: {
    style: Zr
  },
  paddingInline: {
    style: Zr
  },
  paddingInlineStart: {
    style: Zr
  },
  paddingInlineEnd: {
    style: Zr
  },
  paddingBlock: {
    style: Zr
  },
  paddingBlockStart: {
    style: Zr
  },
  paddingBlockEnd: {
    style: Zr
  },
  m: {
    style: Qr
  },
  mt: {
    style: Qr
  },
  mr: {
    style: Qr
  },
  mb: {
    style: Qr
  },
  ml: {
    style: Qr
  },
  mx: {
    style: Qr
  },
  my: {
    style: Qr
  },
  margin: {
    style: Qr
  },
  marginTop: {
    style: Qr
  },
  marginRight: {
    style: Qr
  },
  marginBottom: {
    style: Qr
  },
  marginLeft: {
    style: Qr
  },
  marginX: {
    style: Qr
  },
  marginY: {
    style: Qr
  },
  marginInline: {
    style: Qr
  },
  marginInlineStart: {
    style: Qr
  },
  marginInlineEnd: {
    style: Qr
  },
  marginBlock: {
    style: Qr
  },
  marginBlockStart: {
    style: Qr
  },
  marginBlockEnd: {
    style: Qr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: bx
  },
  rowGap: {
    style: Cx
  },
  columnGap: {
    style: yx
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Di
  },
  maxWidth: {
    style: Nk
  },
  minWidth: {
    transform: Di
  },
  height: {
    transform: Di
  },
  maxHeight: {
    transform: Di
  },
  minHeight: {
    transform: Di
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Cy = m7;
function h7(...e) {
  const t = e.reduce((i, s) => i.concat(Object.keys(s)), []), o = new Set(t);
  return e.every((i) => o.size === Object.keys(i).length);
}
function g7(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function v7() {
  function e(o, i, s, c) {
    const f = {
      [o]: i,
      theme: s
    }, m = c[o];
    if (!m)
      return {
        [o]: i
      };
    const {
      cssProperty: h = o,
      themeKey: v,
      transform: b,
      style: x
    } = m;
    if (i == null)
      return null;
    if (v === "typography" && i === "inherit")
      return {
        [o]: i
      };
    const E = Ih(s, v) || {};
    return x ? x(f) : yi(f, i, (P) => {
      let O = P1(E, b, P);
      return P === O && typeof P == "string" && (O = P1(E, b, `${o}${P === "default" ? "" : ve(P)}`, P)), h === !1 ? O : {
        [h]: O
      };
    });
  }
  function t(o) {
    var i;
    const {
      sx: s,
      theme: c = {}
    } = o || {};
    if (!s)
      return null;
    const f = (i = c.unstable_sxConfig) != null ? i : Cy;
    function m(h) {
      let v = h;
      if (typeof h == "function")
        v = h(c);
      else if (typeof h != "object")
        return h;
      if (!v)
        return null;
      const b = OL(c.breakpoints), x = Object.keys(b);
      let E = b;
      return Object.keys(v).forEach((T) => {
        const P = g7(v[T], c);
        if (P != null)
          if (typeof P == "object")
            if (f[T])
              E = Vb(E, e(T, P, c, f));
            else {
              const O = yi({
                theme: c
              }, P, (k) => ({
                [T]: k
              }));
              h7(O, P) ? E[T] = t({
                sx: P,
                theme: c
              }) : E = Vb(E, O);
            }
          else
            E = Vb(E, e(T, P, c, f));
      }), RL(x, E);
    }
    return Array.isArray(s) ? s.map(m) : m(s);
  }
  return t;
}
const ML = v7();
ML.filterProps = ["sx"];
const jh = ML, b7 = ["breakpoints", "palette", "spacing", "shape"];
function Hh(e = {}, ...t) {
  const {
    breakpoints: o = {},
    palette: i = {},
    spacing: s,
    shape: c = {}
  } = e, f = pe(e, b7), m = TL(o), h = PL(s);
  let v = So({
    breakpoints: m,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: S({
      mode: "light"
    }, i),
    spacing: h,
    shape: S({}, PG, c)
  }, f);
  return v = t.reduce((b, x) => So(b, x), v), v.unstable_sxConfig = S({}, Cy, f == null ? void 0 : f.unstable_sxConfig), v.unstable_sx = function(x) {
    return jh({
      sx: x,
      theme: this
    });
  }, v;
}
function y7(e) {
  return Object.keys(e).length === 0;
}
function Sx(e = null) {
  const t = C.useContext(sp);
  return !t || y7(t) ? e : t;
}
const C7 = Hh();
function Sy(e = C7) {
  return Sx(e);
}
function IL({
  styles: e,
  themeId: t,
  defaultTheme: o = {}
}) {
  const i = Sy(o), s = typeof e == "function" ? e(t && i[t] || i) : e;
  return /* @__PURE__ */ L(zb, {
    styles: s
  });
}
process.env.NODE_ENV !== "production" && (IL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  defaultTheme: n.object,
  /**
   * @ignore
   */
  styles: n.oneOfType([n.array, n.func, n.number, n.object, n.string, n.bool]),
  /**
   * @ignore
   */
  themeId: n.string
});
const S7 = ["sx"], x7 = (e) => {
  var t, o;
  const i = {
    systemProps: {},
    otherProps: {}
  }, s = (t = e == null || (o = e.theme) == null ? void 0 : o.unstable_sxConfig) != null ? t : Cy;
  return Object.keys(e).forEach((c) => {
    s[c] ? i.systemProps[c] = e[c] : i.otherProps[c] = e[c];
  }), i;
};
function xy(e) {
  const {
    sx: t
  } = e, o = pe(e, S7), {
    systemProps: i,
    otherProps: s
  } = x7(o);
  let c;
  return Array.isArray(t) ? c = [i, ...t] : typeof t == "function" ? c = (...f) => {
    const m = t(...f);
    return Bf(m) ? S({}, i, m) : i;
  } : c = S({}, i, t), S({}, s, {
    sx: c
  });
}
const w7 = ["className", "component"];
function E7(e = {}) {
  const {
    themeId: t,
    defaultTheme: o,
    defaultClassName: i = "MuiBox-root",
    generateClassName: s
  } = e, c = EL("div", {
    shouldForwardProp: (m) => m !== "theme" && m !== "sx" && m !== "as"
  })(jh);
  return /* @__PURE__ */ C.forwardRef(function(h, v) {
    const b = Sy(o), x = xy(h), {
      className: E,
      component: T = "div"
    } = x, P = pe(x, w7);
    return /* @__PURE__ */ L(c, S({
      as: T,
      ref: v,
      className: be(E, s ? s(i) : i),
      theme: t && b[t] || b
    }, P));
  });
}
const T7 = ["variant"];
function M2(e) {
  return e.length === 0;
}
function NL(e) {
  const {
    variant: t
  } = e, o = pe(e, T7);
  let i = t || "";
  return Object.keys(o).sort().forEach((s) => {
    s === "color" ? i += M2(i) ? e[s] : ve(e[s]) : i += `${M2(i) ? s : ve(s)}${ve(e[s].toString())}`;
  }), i;
}
const O7 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function R7(e) {
  return Object.keys(e).length === 0;
}
function k7(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
const P7 = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, M7 = (e, t) => {
  let o = [];
  t && t.components && t.components[e] && t.components[e].variants && (o = t.components[e].variants);
  const i = {};
  return o.forEach((s) => {
    const c = NL(s.props);
    i[c] = s.style;
  }), i;
}, I7 = (e, t, o, i) => {
  var s;
  const {
    ownerState: c = {}
  } = e, f = [], m = o == null || (s = o.components) == null || (s = s[i]) == null ? void 0 : s.variants;
  return m && m.forEach((h) => {
    let v = !0;
    Object.keys(h.props).forEach((b) => {
      c[b] !== h.props[b] && e[b] !== h.props[b] && (v = !1);
    }), v && f.push(t[NL(h.props)]);
  }), f;
};
function Bb(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const N7 = Hh(), I2 = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function bb({
  defaultTheme: e,
  theme: t,
  themeId: o
}) {
  return R7(t) ? e : t[o] || t;
}
function $7(e) {
  return e ? (t, o) => o[e] : null;
}
function $L(e = {}) {
  const {
    themeId: t,
    defaultTheme: o = N7,
    rootShouldForwardProp: i = Bb,
    slotShouldForwardProp: s = Bb
  } = e, c = (f) => jh(S({}, f, {
    theme: bb(S({}, f, {
      defaultTheme: o,
      themeId: t
    }))
  }));
  return c.__mui_systemSx = !0, (f, m = {}) => {
    TG(f, (z) => z.filter((V) => !(V != null && V.__mui_systemSx)));
    const {
      name: h,
      slot: v,
      skipVariantsResolver: b,
      skipSx: x,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: E = $7(I2(v))
    } = m, T = pe(m, O7), P = b !== void 0 ? b : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      v && v !== "Root" && v !== "root" || !1
    ), O = x || !1;
    let k;
    process.env.NODE_ENV !== "production" && h && (k = `${h}-${I2(v || "Root")}`);
    let I = Bb;
    v === "Root" || v === "root" ? I = i : v ? I = s : k7(f) && (I = void 0);
    const $ = EL(f, S({
      shouldForwardProp: I,
      label: k
    }, T)), _ = (z, ...V) => {
      const M = V ? V.map((H) => typeof H == "function" && H.__emotion_real !== H ? (G) => H(S({}, G, {
        theme: bb(S({}, G, {
          defaultTheme: o,
          themeId: t
        }))
      })) : H) : [];
      let A = z;
      h && E && M.push((H) => {
        const G = bb(S({}, H, {
          defaultTheme: o,
          themeId: t
        })), ne = P7(h, G);
        if (ne) {
          const K = {};
          return Object.entries(ne).forEach(([B, q]) => {
            K[B] = typeof q == "function" ? q(S({}, H, {
              theme: G
            })) : q;
          }), E(H, K);
        }
        return null;
      }), h && !P && M.push((H) => {
        const G = bb(S({}, H, {
          defaultTheme: o,
          themeId: t
        }));
        return I7(H, M7(h, G), G, h);
      }), O || M.push(c);
      const W = M.length - V.length;
      if (Array.isArray(z) && W > 0) {
        const H = new Array(W).fill("");
        A = [...z, ...H], A.raw = [...z.raw, ...H];
      } else
        typeof z == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        z.__emotion_real !== z && (A = (H) => z(S({}, H, {
          theme: bb(S({}, H, {
            defaultTheme: o,
            themeId: t
          }))
        })));
      const Y = $(A, ...M);
      if (process.env.NODE_ENV !== "production") {
        let H;
        h && (H = `${h}${ve(v || "")}`), H === void 0 && (H = `Styled(${nL(f)})`), Y.displayName = H;
      }
      return f.muiName && (Y.muiName = f.muiName), Y;
    };
    return $.withConfig && (_.withConfig = $.withConfig), _;
  };
}
const D7 = $L(), xo = D7;
function $k(e) {
  const {
    theme: t,
    name: o,
    props: i
  } = e;
  return !t || !t.components || !t.components[o] || !t.components[o].defaultProps ? i : Ck(t.components[o].defaultProps, i);
}
function wy({
  props: e,
  name: t,
  defaultTheme: o,
  themeId: i
}) {
  let s = Sy(o);
  return i && (s = s[i] || s), $k({
    theme: s,
    name: t,
    props: e
  });
}
function Dk(e, t = 0, o = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > o) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${o}].`), Math.min(Math.max(t, e), o);
}
function _7(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let o = e.match(t);
  return o && o[0].length === 1 && (o = o.map((i) => i + i)), o ? `rgb${o.length === 4 ? "a" : ""}(${o.map((i, s) => s < 3 ? parseInt(i, 16) : Math.round(parseInt(i, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function A7(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Bc(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Bc(_7(e));
  const t = e.indexOf("("), o = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(o) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : gi(9, e));
  let i = e.substring(t + 1, e.length - 1), s;
  if (o === "color") {
    if (i = i.split(" "), s = i.shift(), i.length === 4 && i[3].charAt(0) === "/" && (i[3] = i[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : gi(10, s));
  } else
    i = i.split(",");
  return i = i.map((c) => parseFloat(c)), {
    type: o,
    values: i,
    colorSpace: s
  };
}
const L7 = (e) => {
  const t = Bc(e);
  return t.values.slice(0, 3).map((o, i) => t.type.indexOf("hsl") !== -1 && i !== 0 ? `${o}%` : o).join(" ");
}, Ib = (e, t) => {
  try {
    return L7(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function xx(e) {
  const {
    type: t,
    colorSpace: o
  } = e;
  let {
    values: i
  } = e;
  return t.indexOf("rgb") !== -1 ? i = i.map((s, c) => c < 3 ? parseInt(s, 10) : s) : t.indexOf("hsl") !== -1 && (i[1] = `${i[1]}%`, i[2] = `${i[2]}%`), t.indexOf("color") !== -1 ? i = `${o} ${i.join(" ")}` : i = `${i.join(", ")}`, `${t}(${i})`;
}
function sSe(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = Bc(e);
  return `#${t.map((o, i) => A7(i === 3 ? Math.round(255 * o) : o)).join("")}`;
}
function F7(e) {
  e = Bc(e);
  const {
    values: t
  } = e, o = t[0], i = t[1] / 100, s = t[2] / 100, c = i * Math.min(s, 1 - s), f = (v, b = (v + o / 30) % 12) => s - c * Math.max(Math.min(b - 3, 9 - b, 1), -1);
  let m = "rgb";
  const h = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  return e.type === "hsla" && (m += "a", h.push(t[3])), xx({
    type: m,
    values: h
  });
}
function RR(e) {
  e = Bc(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Bc(F7(e)).values : e.values;
  return t = t.map((o) => (e.type !== "color" && (o /= 255), o <= 0.03928 ? o / 12.92 : ((o + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function N2(e, t) {
  const o = RR(e), i = RR(t);
  return (Math.max(o, i) + 0.05) / (Math.min(o, i) + 0.05);
}
function _t(e, t) {
  return e = Bc(e), t = Dk(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, xx(e);
}
function zS(e, t, o) {
  try {
    return _t(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function Wl(e, t) {
  if (e = Bc(e), t = Dk(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let o = 0; o < 3; o += 1)
      e.values[o] *= 1 - t;
  return xx(e);
}
function Cr(e, t, o) {
  try {
    return Wl(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function ql(e, t) {
  if (e = Bc(e), t = Dk(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (255 - e.values[o]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (1 - e.values[o]) * t;
  return xx(e);
}
function Sr(e, t, o) {
  try {
    return ql(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function M1(e, t = 0.15) {
  return RR(e) > 0.5 ? Wl(e, t) : ql(e, t);
}
function Nb(e, t, o) {
  try {
    return Nb(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
const DL = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (DL.displayName = "ThemeContext");
const _L = DL;
function _k() {
  const e = C.useContext(_L);
  return process.env.NODE_ENV !== "production" && C.useDebugValue(e), e;
}
const z7 = typeof Symbol == "function" && Symbol.for, V7 = z7 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function B7(e, t) {
  if (typeof t == "function") {
    const o = t(e);
    return process.env.NODE_ENV !== "production" && (o || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), o;
  }
  return S({}, e, t);
}
function I1(e) {
  const {
    children: t,
    theme: o
  } = e, i = _k();
  process.env.NODE_ENV !== "production" && i === null && typeof o == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = C.useMemo(() => {
    const c = i === null ? o : B7(i, o);
    return c != null && (c[V7] = i !== null), c;
  }, [o, i]);
  return /* @__PURE__ */ L(_L.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (I1.propTypes = {
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: n.oneOfType([n.object, n.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (I1.propTypes = ip(I1.propTypes));
const $2 = {};
function D2(e, t, o, i = !1) {
  return C.useMemo(() => {
    const s = e && t[e] || t;
    if (typeof o == "function") {
      const c = o(s), f = e ? S({}, t, {
        [e]: c
      }) : c;
      return i ? () => f : f;
    }
    return e ? S({}, t, {
      [e]: o
    }) : S({}, t, o);
  }, [e, t, o, i]);
}
function Jb(e) {
  const {
    children: t,
    theme: o,
    themeId: i
  } = e, s = Sx($2), c = _k() || $2;
  process.env.NODE_ENV !== "production" && (s === null && typeof o == "function" || i && s && !s[i] && typeof o == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const f = D2(i, s, o), m = D2(i, c, o, !0);
  return /* @__PURE__ */ L(I1, {
    theme: m,
    children: /* @__PURE__ */ L(sp.Provider, {
      value: f,
      children: t
    })
  });
}
process.env.NODE_ENV !== "production" && (Jb.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: n.oneOfType([n.func, n.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: n.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Jb.propTypes = ip(Jb.propTypes));
const Ak = "mode", Lk = "color-scheme", AL = "data-color-scheme";
function j7(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: o = "light",
    defaultDarkColorScheme: i = "dark",
    modeStorageKey: s = Ak,
    colorSchemeStorageKey: c = Lk,
    attribute: f = AL,
    colorSchemeNode: m = "document.documentElement"
  } = e || {};
  return /* @__PURE__ */ L("script", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  var mode = localStorage.getItem('${s}') || '${t}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${c}-dark') || '${i}';
    } else {
      colorScheme = localStorage.getItem('${c}-light') || '${o}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${c}-light') || '${o}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${c}-dark') || '${i}';
  }
  if (colorScheme) {
    ${m}.setAttribute('${f}', colorScheme);
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function _2(e) {
  if (typeof window < "u" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function LL(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function H7(e) {
  return LL(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function LO(e, t) {
  if (typeof window > "u")
    return;
  let o;
  try {
    o = localStorage.getItem(e) || void 0, o || localStorage.setItem(e, t);
  } catch {
  }
  return o || t;
}
function U7(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: o,
    defaultDarkColorScheme: i,
    supportedColorSchemes: s = [],
    modeStorageKey: c = Ak,
    colorSchemeStorageKey: f = Lk,
    storageWindow: m = typeof window > "u" ? void 0 : window
  } = e, h = s.join(","), [v, b] = C.useState(() => {
    const k = LO(c, t), I = LO(`${f}-light`, o), $ = LO(`${f}-dark`, i);
    return {
      mode: k,
      systemMode: _2(k),
      lightColorScheme: I,
      darkColorScheme: $
    };
  }), x = H7(v), E = C.useCallback((k) => {
    b((I) => {
      if (k === I.mode)
        return I;
      const $ = k || t;
      try {
        localStorage.setItem(c, $);
      } catch {
      }
      return S({}, I, {
        mode: $,
        systemMode: _2($)
      });
    });
  }, [c, t]), T = C.useCallback((k) => {
    k ? typeof k == "string" ? k && !h.includes(k) ? console.error(`\`${k}\` does not exist in \`theme.colorSchemes\`.`) : b((I) => {
      const $ = S({}, I);
      return LL(I, (_) => {
        try {
          localStorage.setItem(`${f}-${_}`, k);
        } catch {
        }
        _ === "light" && ($.lightColorScheme = k), _ === "dark" && ($.darkColorScheme = k);
      }), $;
    }) : b((I) => {
      const $ = S({}, I), _ = k.light === null ? o : k.light, z = k.dark === null ? i : k.dark;
      if (_)
        if (!h.includes(_))
          console.error(`\`${_}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          $.lightColorScheme = _;
          try {
            localStorage.setItem(`${f}-light`, _);
          } catch {
          }
        }
      if (z)
        if (!h.includes(z))
          console.error(`\`${z}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          $.darkColorScheme = z;
          try {
            localStorage.setItem(`${f}-dark`, z);
          } catch {
          }
        }
      return $;
    }) : b((I) => {
      try {
        localStorage.setItem(`${f}-light`, o), localStorage.setItem(`${f}-dark`, i);
      } catch {
      }
      return S({}, I, {
        lightColorScheme: o,
        darkColorScheme: i
      });
    });
  }, [h, f, o, i]), P = C.useCallback((k) => {
    v.mode === "system" && b((I) => S({}, I, {
      systemMode: k != null && k.matches ? "dark" : "light"
    }));
  }, [v.mode]), O = C.useRef(P);
  return O.current = P, C.useEffect(() => {
    const k = (...$) => O.current(...$), I = window.matchMedia("(prefers-color-scheme: dark)");
    return I.addListener(k), k(I), () => I.removeListener(k);
  }, []), C.useEffect(() => {
    const k = (I) => {
      const $ = I.newValue;
      typeof I.key == "string" && I.key.startsWith(f) && (!$ || h.match($)) && (I.key.endsWith("light") && T({
        light: $
      }), I.key.endsWith("dark") && T({
        dark: $
      })), I.key === c && (!$ || ["light", "dark", "system"].includes($)) && E($ || t);
    };
    if (m)
      return m.addEventListener("storage", k), () => m.removeEventListener("storage", k);
  }, [T, E, c, f, h, t, m]), S({}, v, {
    colorScheme: x,
    setMode: E,
    setColorScheme: T
  });
}
const G7 = ["colorSchemes", "components", "generateCssVars", "cssVarPrefix"], W7 = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function q7(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: o = {},
    attribute: i = AL,
    modeStorageKey: s = Ak,
    colorSchemeStorageKey: c = Lk,
    defaultMode: f = "light",
    defaultColorScheme: m,
    disableTransitionOnChange: h = !1,
    resolveTheme: v,
    excludeVariablesFromRoot: b
  } = e;
  (!o.colorSchemes || typeof m == "string" && !o.colorSchemes[m] || typeof m == "object" && !o.colorSchemes[m == null ? void 0 : m.light] || typeof m == "object" && !o.colorSchemes[m == null ? void 0 : m.dark]) && console.error(`MUI: \`${m}\` does not exist in \`theme.colorSchemes\`.`);
  const x = /* @__PURE__ */ C.createContext(void 0), E = () => {
    const I = C.useContext(x);
    if (!I)
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `useColorScheme` must be called under <CssVarsProvider />" : gi(19));
    return I;
  };
  function T({
    children: I,
    theme: $ = o,
    modeStorageKey: _ = s,
    colorSchemeStorageKey: z = c,
    attribute: V = i,
    defaultMode: M = f,
    defaultColorScheme: A = m,
    disableTransitionOnChange: W = h,
    storageWindow: Y = typeof window > "u" ? void 0 : window,
    documentNode: H = typeof document > "u" ? void 0 : document,
    colorSchemeNode: G = typeof document > "u" ? void 0 : document.documentElement,
    colorSchemeSelector: ne = ":root",
    disableNestedContext: K = !1,
    disableStyleSheetGeneration: B = !1
  }) {
    const q = C.useRef(!1), X = _k(), J = C.useContext(x), U = !!J && !K, Z = $[t], ee = Z || $, {
      colorSchemes: ie = {},
      components: oe = {},
      generateCssVars: le = () => ({
        vars: {},
        css: {}
      }),
      cssVarPrefix: de
    } = ee, Ce = pe(ee, G7), me = Object.keys(ie), Oe = typeof A == "string" ? A : A.light, he = typeof A == "string" ? A : A.dark, {
      mode: $e,
      setMode: Ne,
      systemMode: Pe,
      lightColorScheme: Se,
      darkColorScheme: Fe,
      colorScheme: ce,
      setColorScheme: ge
    } = U7({
      supportedColorSchemes: me,
      defaultLightColorScheme: Oe,
      defaultDarkColorScheme: he,
      modeStorageKey: _,
      colorSchemeStorageKey: z,
      defaultMode: M,
      storageWindow: Y
    });
    let we = $e, Me = ce;
    U && (we = J.mode, Me = J.colorScheme);
    const Qe = (() => we || (M === "system" ? f : M))(), ct = (() => Me || (Qe === "dark" ? he : Oe))(), {
      css: Ze,
      vars: Ge
    } = le(), Be = S({}, Ce, {
      components: oe,
      colorSchemes: ie,
      cssVarPrefix: de,
      vars: Ge,
      getColorSchemeSelector: (Je) => `[${V}="${Je}"] &`
    }), rt = {}, wt = {};
    Object.entries(ie).forEach(([Je, pt]) => {
      const {
        css: At,
        vars: Ye
      } = le(Je);
      Be.vars = So(Be.vars, Ye), Je === ct && (Object.keys(pt).forEach((_e) => {
        pt[_e] && typeof pt[_e] == "object" ? Be[_e] = S({}, Be[_e], pt[_e]) : Be[_e] = pt[_e];
      }), Be.palette && (Be.palette.colorScheme = Je));
      const st = (() => typeof A == "string" ? A : M === "dark" ? A.dark : A.light)();
      if (Je === st) {
        if (b) {
          const _e = {};
          b(de).forEach((vt) => {
            _e[vt] = At[vt], delete At[vt];
          }), rt[`[${V}="${Je}"]`] = _e;
        }
        rt[`${ne}, [${V}="${Je}"]`] = At;
      } else
        wt[`${ne === ":root" ? "" : ne}[${V}="${Je}"]`] = At;
    }), Be.vars = So(Be.vars, Ge), C.useEffect(() => {
      Me && G && G.setAttribute(V, Me);
    }, [Me, V, G]), C.useEffect(() => {
      let Je;
      if (W && q.current && H) {
        const pt = H.createElement("style");
        pt.appendChild(H.createTextNode(W7)), H.head.appendChild(pt), window.getComputedStyle(H.body), Je = setTimeout(() => {
          H.head.removeChild(pt);
        }, 1);
      }
      return () => {
        clearTimeout(Je);
      };
    }, [Me, W, H]), C.useEffect(() => (q.current = !0, () => {
      q.current = !1;
    }), []);
    const We = C.useMemo(() => ({
      mode: we,
      systemMode: Pe,
      setMode: Ne,
      lightColorScheme: Se,
      darkColorScheme: Fe,
      colorScheme: Me,
      setColorScheme: ge,
      allColorSchemes: me
    }), [me, Me, Fe, Se, we, ge, Ne, Pe]);
    let ut = !0;
    (B || U && (X == null ? void 0 : X.cssVarPrefix) === de) && (ut = !1);
    const ft = /* @__PURE__ */ ht(C.Fragment, {
      children: [ut && /* @__PURE__ */ ht(C.Fragment, {
        children: [/* @__PURE__ */ L(zb, {
          styles: {
            [ne]: Ze
          }
        }), /* @__PURE__ */ L(zb, {
          styles: rt
        }), /* @__PURE__ */ L(zb, {
          styles: wt
        })]
      }), /* @__PURE__ */ L(Jb, {
        themeId: Z ? t : void 0,
        theme: v ? v(Be) : Be,
        children: I
      })]
    });
    return U ? ft : /* @__PURE__ */ L(x.Provider, {
      value: We,
      children: ft
    });
  }
  process.env.NODE_ENV !== "production" && (T.propTypes = {
    /**
     * The body attribute name to attach colorScheme.
     */
    attribute: n.string,
    /**
     * The component tree.
     */
    children: n.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: n.any,
    /**
     * The CSS selector for attaching the generated custom properties
     */
    colorSchemeSelector: n.string,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: n.string,
    /**
     * The initial color scheme used.
     */
    defaultColorScheme: n.oneOfType([n.string, n.object]),
    /**
     * The initial mode used.
     */
    defaultMode: n.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: n.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: n.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: n.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: n.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: n.string,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: n.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: n.object
  });
  const P = typeof m == "string" ? m : m.light, O = typeof m == "string" ? m : m.dark;
  return {
    CssVarsProvider: T,
    useColorScheme: E,
    getInitColorSchemeScript: (I) => j7(S({
      attribute: i,
      colorSchemeStorageKey: c,
      defaultMode: f,
      defaultLightColorScheme: P,
      defaultDarkColorScheme: O,
      modeStorageKey: s
    }, I))
  };
}
function Y7(e = "") {
  function t(...i) {
    if (!i.length)
      return "";
    const s = i[0];
    return typeof s == "string" && !s.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${s}${t(...i.slice(1))})` : `, ${s}`;
  }
  return (i, ...s) => `var(--${e ? `${e}-` : ""}${i}${t(...s)})`;
}
const A2 = (e, t, o, i = []) => {
  let s = e;
  t.forEach((c, f) => {
    f === t.length - 1 ? Array.isArray(s) ? s[Number(c)] = o : s && typeof s == "object" && (s[c] = o) : s && typeof s == "object" && (s[c] || (s[c] = i.includes(c) ? [] : {}), s = s[c]);
  });
}, K7 = (e, t, o) => {
  function i(s, c = [], f = []) {
    Object.entries(s).forEach(([m, h]) => {
      (!o || o && !o([...c, m])) && h != null && (typeof h == "object" && Object.keys(h).length > 0 ? i(h, [...c, m], Array.isArray(h) ? [...f, m] : f) : t([...c, m], h, f));
    });
  }
  i(e);
}, X7 = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((i) => e.includes(i)) || e[e.length - 1].toLowerCase().indexOf("opacity") >= 0 ? t : `${t}px` : t;
function FO(e, t) {
  const {
    prefix: o,
    shouldSkipGeneratingVar: i
  } = t || {}, s = {}, c = {}, f = {};
  return K7(
    e,
    (m, h, v) => {
      if ((typeof h == "string" || typeof h == "number") && (!i || !i(m, h))) {
        const b = `--${o ? `${o}-` : ""}${m.join("-")}`;
        Object.assign(s, {
          [b]: X7(m, h)
        }), A2(c, m, `var(${b})`, v), A2(f, m, `var(${b}, ${h})`, v);
      }
    },
    (m) => m[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: s,
    vars: c,
    varsWithDefaults: f
  };
}
const Q7 = ["colorSchemes", "components"], Z7 = ["light"];
function J7(e, t) {
  const {
    colorSchemes: o = {}
  } = e, i = pe(e, Q7), {
    vars: s,
    css: c,
    varsWithDefaults: f
  } = FO(i, t);
  let m = f;
  const h = {}, {
    light: v
  } = o, b = pe(o, Z7);
  if (Object.entries(b || {}).forEach(([E, T]) => {
    const {
      vars: P,
      css: O,
      varsWithDefaults: k
    } = FO(T, t);
    m = So(m, k), h[E] = {
      css: O,
      vars: P
    };
  }), v) {
    const {
      css: E,
      vars: T,
      varsWithDefaults: P
    } = FO(v, t);
    m = So(m, P), h.light = {
      css: E,
      vars: T
    };
  }
  return {
    vars: m,
    generateCssVars: (E) => E ? {
      css: S({}, h[E].css),
      vars: h[E].vars
    } : {
      css: S({}, c),
      vars: s
    }
  };
}
const eW = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"], tW = Hh(), nW = xo("div", {
  name: "MuiContainer",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`maxWidth${ve(String(o.maxWidth))}`], o.fixed && t.fixed, o.disableGutters && t.disableGutters];
  }
}), rW = (e) => wy({
  props: e,
  name: "MuiContainer",
  defaultTheme: tW
}), oW = (e, t) => {
  const o = (h) => ot(t, h), {
    classes: i,
    fixed: s,
    disableGutters: c,
    maxWidth: f
  } = e, m = {
    root: ["root", f && `maxWidth${ve(String(f))}`, s && "fixed", c && "disableGutters"]
  };
  return je(m, o, i);
};
function aW(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = nW,
    useThemeProps: o = rW,
    componentName: i = "MuiContainer"
  } = e, s = t(({
    theme: f,
    ownerState: m
  }) => S({
    width: "100%",
    marginLeft: "auto",
    boxSizing: "border-box",
    marginRight: "auto",
    display: "block"
  }, !m.disableGutters && {
    paddingLeft: f.spacing(2),
    paddingRight: f.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [f.breakpoints.up("sm")]: {
      paddingLeft: f.spacing(3),
      paddingRight: f.spacing(3)
    }
  }), ({
    theme: f,
    ownerState: m
  }) => m.fixed && Object.keys(f.breakpoints.values).reduce((h, v) => {
    const b = v, x = f.breakpoints.values[b];
    return x !== 0 && (h[f.breakpoints.up(b)] = {
      maxWidth: `${x}${f.breakpoints.unit}`
    }), h;
  }, {}), ({
    theme: f,
    ownerState: m
  }) => S({}, m.maxWidth === "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [f.breakpoints.up("xs")]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(f.breakpoints.values.xs, 444)
    }
  }, m.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
  m.maxWidth !== "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [f.breakpoints.up(m.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${f.breakpoints.values[m.maxWidth]}${f.breakpoints.unit}`
    }
  })), c = /* @__PURE__ */ C.forwardRef(function(m, h) {
    const v = o(m), {
      className: b,
      component: x = "div",
      disableGutters: E = !1,
      fixed: T = !1,
      maxWidth: P = "lg"
    } = v, O = pe(v, eW), k = S({}, v, {
      component: x,
      disableGutters: E,
      fixed: T,
      maxWidth: P
    }), I = oW(k, i);
    return (
      // @ts-ignore theme is injected by the styled util
      /* @__PURE__ */ L(s, S({
        as: x,
        ownerState: k,
        className: be(I.root, b),
        ref: h
      }, O))
    );
  });
  return process.env.NODE_ENV !== "production" && (c.propTypes = {
    children: n.node,
    classes: n.object,
    className: n.string,
    component: n.elementType,
    disableGutters: n.bool,
    fixed: n.bool,
    maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
  }), c;
}
const iW = (e, t) => e.filter((o) => t.includes(o)), Uh = (e, t, o) => {
  const i = e.keys[0];
  Array.isArray(t) ? t.forEach((s, c) => {
    o((f, m) => {
      c <= e.keys.length - 1 && (c === 0 ? Object.assign(f, m) : f[e.up(e.keys[c])] = m);
    }, s);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : iW(e.keys, Object.keys(t))).forEach((c) => {
    if (e.keys.indexOf(c) !== -1) {
      const f = t[c];
      f !== void 0 && o((m, h) => {
        i === c ? Object.assign(m, h) : m[e.up(c)] = h;
      }, f);
    }
  }) : (typeof t == "number" || typeof t == "string") && o((s, c) => {
    Object.assign(s, c);
  }, t);
};
function jc(e) {
  return e ? `Level${e}` : "";
}
function Ey(e) {
  return e.unstable_level > 0 && e.container;
}
function FL(e) {
  return function(o) {
    return `var(--Grid-${o}Spacing${jc(e.unstable_level)})`;
  };
}
function Fk(e) {
  return function(o) {
    return e.unstable_level === 0 ? `var(--Grid-${o}Spacing)` : `var(--Grid-${o}Spacing${jc(e.unstable_level - 1)})`;
  };
}
function zk(e) {
  return e.unstable_level === 0 ? "var(--Grid-columns)" : `var(--Grid-columns${jc(e.unstable_level - 1)})`;
}
const lW = ({
  theme: e,
  ownerState: t
}) => {
  const o = FL(t), i = {};
  return Uh(e.breakpoints, t.gridSize, (s, c) => {
    let f = {};
    c === !0 && (f = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), c === "auto" && (f = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof c == "number" && (f = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${c} / ${zk(t)}${Ey(t) ? ` + ${o("column")}` : ""})`
    }), s(i, f);
  }), i;
}, sW = ({
  theme: e,
  ownerState: t
}) => {
  const o = {};
  return Uh(e.breakpoints, t.gridOffset, (i, s) => {
    let c = {};
    s === "auto" && (c = {
      marginLeft: "auto"
    }), typeof s == "number" && (c = {
      marginLeft: s === 0 ? "0px" : `calc(100% * ${s} / ${zk(t)})`
    }), i(o, c);
  }), o;
}, cW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const o = Ey(t) ? {
    [`--Grid-columns${jc(t.unstable_level)}`]: zk(t)
  } : {
    "--Grid-columns": 12
  };
  return Uh(e.breakpoints, t.columns, (i, s) => {
    i(o, {
      [`--Grid-columns${jc(t.unstable_level)}`]: s
    });
  }), o;
}, uW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const o = Fk(t), i = Ey(t) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-rowSpacing${jc(t.unstable_level)}`]: o("row")
  } : {};
  return Uh(e.breakpoints, t.rowSpacing, (s, c) => {
    var f;
    s(i, {
      [`--Grid-rowSpacing${jc(t.unstable_level)}`]: typeof c == "string" ? c : (f = e.spacing) == null ? void 0 : f.call(e, c)
    });
  }), i;
}, dW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const o = Fk(t), i = Ey(t) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-columnSpacing${jc(t.unstable_level)}`]: o("column")
  } : {};
  return Uh(e.breakpoints, t.columnSpacing, (s, c) => {
    var f;
    s(i, {
      [`--Grid-columnSpacing${jc(t.unstable_level)}`]: typeof c == "string" ? c : (f = e.spacing) == null ? void 0 : f.call(e, c)
    });
  }), i;
}, fW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const o = {};
  return Uh(e.breakpoints, t.direction, (i, s) => {
    i(o, {
      flexDirection: s
    });
  }), o;
}, pW = ({
  ownerState: e
}) => {
  const t = FL(e), o = Fk(e);
  return S({
    minWidth: 0,
    boxSizing: "border-box"
  }, e.container && S({
    display: "flex",
    flexWrap: "wrap"
  }, e.wrap && e.wrap !== "wrap" && {
    flexWrap: e.wrap
  }, {
    margin: `calc(${t("row")} / -2) calc(${t("column")} / -2)`
  }, e.disableEqualOverflow && {
    margin: `calc(${t("row")} * -1) 0px 0px calc(${t("column")} * -1)`
  }), (!e.container || Ey(e)) && S({
    padding: `calc(${o("row")} / 2) calc(${o("column")} / 2)`
  }, (e.disableEqualOverflow || e.parentDisableEqualOverflow) && {
    padding: `${o("row")} 0px 0px ${o("column")}`
  }));
}, mW = (e) => {
  const t = [];
  return Object.entries(e).forEach(([o, i]) => {
    i !== !1 && i !== void 0 && t.push(`grid-${o}-${String(i)}`);
  }), t;
}, hW = (e, t = "xs") => {
  function o(i) {
    return i === void 0 ? !1 : typeof i == "string" && !Number.isNaN(Number(i)) || typeof i == "number" && i > 0;
  }
  if (o(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const i = [];
    return Object.entries(e).forEach(([s, c]) => {
      o(c) && i.push(`spacing-${s}-${String(c)}`);
    }), i;
  }
  return [];
}, gW = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, o]) => `direction-${t}-${o}`) : [`direction-xs-${String(e)}`], vW = ["className", "children", "columns", "container", "component", "direction", "wrap", "spacing", "rowSpacing", "columnSpacing", "disableEqualOverflow", "unstable_level"], bW = Hh(), yW = xo("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function CW(e) {
  return wy({
    props: e,
    name: "MuiGrid",
    defaultTheme: bW
  });
}
function SW(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = yW,
    useThemeProps: o = CW,
    componentName: i = "MuiGrid"
  } = e, s = /* @__PURE__ */ C.createContext(void 0), c = (h, v) => {
    const {
      container: b,
      direction: x,
      spacing: E,
      wrap: T,
      gridSize: P
    } = h, O = {
      root: ["root", b && "container", T !== "wrap" && `wrap-xs-${String(T)}`, ...gW(x), ...mW(P), ...b ? hW(E, v.breakpoints.keys[0]) : []]
    };
    return je(O, (k) => ot(i, k), {});
  }, f = t(cW, dW, uW, lW, fW, pW, sW), m = /* @__PURE__ */ C.forwardRef(function(v, b) {
    var x, E, T, P, O, k, I, $;
    const _ = Sy(), z = o(v), V = xy(z), M = C.useContext(s), {
      className: A,
      children: W,
      columns: Y = 12,
      container: H = !1,
      component: G = "div",
      direction: ne = "row",
      wrap: K = "wrap",
      spacing: B = 0,
      rowSpacing: q = B,
      columnSpacing: X = B,
      disableEqualOverflow: J,
      unstable_level: U = 0
    } = V, Z = pe(V, vW);
    let ee = J;
    U && J !== void 0 && (ee = v.disableEqualOverflow);
    const ie = {}, oe = {}, le = {};
    Object.entries(Z).forEach(([Pe, Se]) => {
      _.breakpoints.values[Pe] !== void 0 ? ie[Pe] = Se : _.breakpoints.values[Pe.replace("Offset", "")] !== void 0 ? oe[Pe.replace("Offset", "")] = Se : le[Pe] = Se;
    });
    const de = (x = v.columns) != null ? x : U ? void 0 : Y, Ce = (E = v.spacing) != null ? E : U ? void 0 : B, me = (T = (P = v.rowSpacing) != null ? P : v.spacing) != null ? T : U ? void 0 : q, Oe = (O = (k = v.columnSpacing) != null ? k : v.spacing) != null ? O : U ? void 0 : X, he = S({}, V, {
      level: U,
      columns: de,
      container: H,
      direction: ne,
      wrap: K,
      spacing: Ce,
      rowSpacing: me,
      columnSpacing: Oe,
      gridSize: ie,
      gridOffset: oe,
      disableEqualOverflow: (I = ($ = ee) != null ? $ : M) != null ? I : !1,
      // use context value if exists.
      parentDisableEqualOverflow: M
      // for nested grid
    }), $e = c(he, _);
    let Ne = /* @__PURE__ */ L(f, S({
      ref: b,
      as: G,
      ownerState: he,
      className: be($e.root, A)
    }, le, {
      children: C.Children.map(W, (Pe) => {
        if (/* @__PURE__ */ C.isValidElement(Pe) && zc(Pe, ["Grid"])) {
          var Se;
          return /* @__PURE__ */ C.cloneElement(Pe, {
            unstable_level: (Se = Pe.props.unstable_level) != null ? Se : U + 1
          });
        }
        return Pe;
      })
    }));
    return ee !== void 0 && ee !== (M ?? !1) && (Ne = /* @__PURE__ */ L(s.Provider, {
      value: ee,
      children: Ne
    })), Ne;
  });
  return process.env.NODE_ENV !== "production" && (m.propTypes = {
    children: n.node,
    className: n.string,
    columns: n.oneOfType([n.arrayOf(n.number), n.number, n.object]),
    columnSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    component: n.elementType,
    container: n.bool,
    direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
    disableEqualOverflow: n.bool,
    lg: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
    lgOffset: n.oneOfType([n.oneOf(["auto"]), n.number]),
    md: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
    mdOffset: n.oneOfType([n.oneOf(["auto"]), n.number]),
    rowSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    sm: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
    smOffset: n.oneOfType([n.oneOf(["auto"]), n.number]),
    spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
    wrap: n.oneOf(["nowrap", "wrap-reverse", "wrap"]),
    xl: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
    xlOffset: n.oneOfType([n.oneOf(["auto"]), n.number]),
    xs: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
    xsOffset: n.oneOfType([n.oneOf(["auto"]), n.number])
  }), m.muiName = "Grid", m;
}
const xW = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], wW = Hh(), EW = xo("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function TW(e) {
  return wy({
    props: e,
    name: "MuiStack",
    defaultTheme: wW
  });
}
function OW(e, t) {
  const o = C.Children.toArray(e).filter(Boolean);
  return o.reduce((i, s, c) => (i.push(s), c < o.length - 1 && i.push(/* @__PURE__ */ C.cloneElement(t, {
    key: `separator-${c}`
  })), i), []);
}
const RW = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], kW = ({
  ownerState: e,
  theme: t
}) => {
  let o = S({
    display: "flex",
    flexDirection: "column"
  }, yi({
    theme: t
  }, Wf({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (i) => ({
    flexDirection: i
  })));
  if (e.spacing) {
    const i = Ik(t), s = Object.keys(t.breakpoints.values).reduce((h, v) => ((typeof e.spacing == "object" && e.spacing[v] != null || typeof e.direction == "object" && e.direction[v] != null) && (h[v] = !0), h), {}), c = Wf({
      values: e.direction,
      base: s
    }), f = Wf({
      values: e.spacing,
      base: s
    });
    typeof c == "object" && Object.keys(c).forEach((h, v, b) => {
      if (!c[h]) {
        const E = v > 0 ? c[b[v - 1]] : "column";
        c[h] = E;
      }
    }), o = So(o, yi({
      theme: t
    }, f, (h, v) => e.useFlexGap ? {
      gap: Zf(i, h)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${RW(v ? c[v] : e.direction)}`]: Zf(i, h)
      }
    }));
  }
  return o = IG(t.breakpoints, o), o;
};
function PW(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = EW,
    useThemeProps: o = TW,
    componentName: i = "MuiStack"
  } = e, s = () => je({
    root: ["root"]
  }, (h) => ot(i, h), {}), c = t(kW), f = /* @__PURE__ */ C.forwardRef(function(h, v) {
    const b = o(h), x = xy(b), {
      component: E = "div",
      direction: T = "column",
      spacing: P = 0,
      divider: O,
      children: k,
      className: I,
      useFlexGap: $ = !1
    } = x, _ = pe(x, xW), z = {
      direction: T,
      spacing: P,
      useFlexGap: $
    }, V = s();
    return /* @__PURE__ */ L(c, S({
      as: E,
      ownerState: z,
      ref: v,
      className: be(V.root, I)
    }, _, {
      children: O ? OW(k, O) : k
    }));
  });
  return process.env.NODE_ENV !== "production" && (f.propTypes = {
    children: n.node,
    direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
    divider: n.node,
    spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
    sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
  }), f;
}
function MW(e, t) {
  return S({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
const IW = {
  black: "#000",
  white: "#fff"
}, Nh = IW, NW = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, zL = NW, $W = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, $f = $W, DW = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Df = DW, _W = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, sh = _W, AW = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, _f = AW, LW = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Af = LW, FW = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Lf = FW, zW = ["mode", "contrastThreshold", "tonalOffset"], L2 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Nh.white,
    default: Nh.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, zO = {
  text: {
    primary: Nh.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Nh.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function F2(e, t, o, i) {
  const s = i.light || i, c = i.dark || i * 1.5;
  e[t] || (e.hasOwnProperty(o) ? e[t] = e[o] : t === "light" ? e.light = ql(e.main, s) : t === "dark" && (e.dark = Wl(e.main, c)));
}
function VW(e = "light") {
  return e === "dark" ? {
    main: _f[200],
    light: _f[50],
    dark: _f[400]
  } : {
    main: _f[700],
    light: _f[400],
    dark: _f[800]
  };
}
function BW(e = "light") {
  return e === "dark" ? {
    main: $f[200],
    light: $f[50],
    dark: $f[400]
  } : {
    main: $f[500],
    light: $f[300],
    dark: $f[700]
  };
}
function jW(e = "light") {
  return e === "dark" ? {
    main: Df[500],
    light: Df[300],
    dark: Df[700]
  } : {
    main: Df[700],
    light: Df[400],
    dark: Df[800]
  };
}
function HW(e = "light") {
  return e === "dark" ? {
    main: Af[400],
    light: Af[300],
    dark: Af[700]
  } : {
    main: Af[700],
    light: Af[500],
    dark: Af[900]
  };
}
function UW(e = "light") {
  return e === "dark" ? {
    main: Lf[400],
    light: Lf[300],
    dark: Lf[700]
  } : {
    main: Lf[800],
    light: Lf[500],
    dark: Lf[900]
  };
}
function GW(e = "light") {
  return e === "dark" ? {
    main: sh[400],
    light: sh[300],
    dark: sh[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: sh[500],
    dark: sh[900]
  };
}
function WW(e) {
  const {
    mode: t = "light",
    contrastThreshold: o = 3,
    tonalOffset: i = 0.2
  } = e, s = pe(e, zW), c = e.primary || VW(t), f = e.secondary || BW(t), m = e.error || jW(t), h = e.info || HW(t), v = e.success || UW(t), b = e.warning || GW(t);
  function x(O) {
    const k = N2(O, zO.text.primary) >= o ? zO.text.primary : L2.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const I = N2(O, k);
      I < 3 && console.error([`MUI: The contrast ratio of ${I}:1 for ${k} on ${O}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return k;
  }
  const E = ({
    color: O,
    name: k,
    mainShade: I = 500,
    lightShade: $ = 300,
    darkShade: _ = 700
  }) => {
    if (O = S({}, O), !O.main && O[I] && (O.main = O[I]), !O.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${k ? ` (${k})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${I}\` property.` : gi(11, k ? ` (${k})` : "", I));
    if (typeof O.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${k ? ` (${k})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(O.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : gi(12, k ? ` (${k})` : "", JSON.stringify(O.main)));
    return F2(O, "light", $, i), F2(O, "dark", _, i), O.contrastText || (O.contrastText = x(O.main)), O;
  }, T = {
    dark: zO,
    light: L2
  };
  return process.env.NODE_ENV !== "production" && (T[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), So(S({
    // A collection of common colors.
    common: S({}, Nh),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: E({
      color: c,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: E({
      color: f,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: E({
      color: m,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: E({
      color: b,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: E({
      color: h,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: E({
      color: v,
      name: "success"
    }),
    // The grey colors.
    grey: zL,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: o,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: x,
    // Generate a rich color object.
    augmentColor: E,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: i
  }, T[t]), s);
}
const qW = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function YW(e) {
  return Math.round(e * 1e5) / 1e5;
}
const z2 = {
  textTransform: "uppercase"
}, V2 = '"Roboto", "Helvetica", "Arial", sans-serif';
function VL(e, t) {
  const o = typeof t == "function" ? t(e) : t, {
    fontFamily: i = V2,
    // The default font size of the Material Specification.
    fontSize: s = 14,
    // px
    fontWeightLight: c = 300,
    fontWeightRegular: f = 400,
    fontWeightMedium: m = 500,
    fontWeightBold: h = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: v = 16,
    // Apply the CSS properties to all the variants.
    allVariants: b,
    pxToRem: x
  } = o, E = pe(o, qW);
  process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof v != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const T = s / 14, P = x || ((I) => `${I / v * T}rem`), O = (I, $, _, z, V) => S({
    fontFamily: i,
    fontWeight: I,
    fontSize: P($),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: _
  }, i === V2 ? {
    letterSpacing: `${YW(z / $)}em`
  } : {}, V, b), k = {
    h1: O(c, 96, 1.167, -1.5),
    h2: O(c, 60, 1.2, -0.5),
    h3: O(f, 48, 1.167, 0),
    h4: O(f, 34, 1.235, 0.25),
    h5: O(f, 24, 1.334, 0),
    h6: O(m, 20, 1.6, 0.15),
    subtitle1: O(f, 16, 1.75, 0.15),
    subtitle2: O(m, 14, 1.57, 0.1),
    body1: O(f, 16, 1.5, 0.15),
    body2: O(f, 14, 1.43, 0.15),
    button: O(m, 14, 1.75, 0.4, z2),
    caption: O(f, 12, 1.66, 0.4),
    overline: O(f, 12, 2.66, 1, z2),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return So(S({
    htmlFontSize: v,
    pxToRem: P,
    fontFamily: i,
    fontSize: s,
    fontWeightLight: c,
    fontWeightRegular: f,
    fontWeightMedium: m,
    fontWeightBold: h
  }, k), E, {
    clone: !1
    // No need to clone deep
  });
}
const KW = 0.2, XW = 0.14, QW = 0.12;
function Vr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${KW})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${XW})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${QW})`].join(",");
}
const ZW = ["none", Vr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Vr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Vr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Vr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Vr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Vr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Vr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Vr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Vr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Vr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Vr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Vr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Vr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Vr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Vr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Vr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Vr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Vr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Vr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Vr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Vr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Vr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Vr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Vr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], JW = ZW, eq = ["duration", "easing", "delay"], tq = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, BL = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function B2(e) {
  return `${Math.round(e)}ms`;
}
function nq(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function rq(e) {
  const t = S({}, tq, e.easing), o = S({}, BL, e.duration);
  return S({
    getAutoHeightDuration: nq,
    create: (s = ["all"], c = {}) => {
      const {
        duration: f = o.standard,
        easing: m = t.easeInOut,
        delay: h = 0
      } = c, v = pe(c, eq);
      if (process.env.NODE_ENV !== "production") {
        const b = (E) => typeof E == "string", x = (E) => !isNaN(parseFloat(E));
        !b(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !x(f) && !b(f) && console.error(`MUI: Argument "duration" must be a number or a string but found ${f}.`), b(m) || console.error('MUI: Argument "easing" must be a string.'), !x(h) && !b(h) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof c != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(v).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(v).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((b) => `${b} ${typeof f == "string" ? f : B2(f)} ${m} ${typeof h == "string" ? h : B2(h)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: o
  });
}
const oq = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, aq = oq, iq = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Jf(e = {}, ...t) {
  const {
    mixins: o = {},
    palette: i = {},
    transitions: s = {},
    typography: c = {}
  } = e, f = pe(e, iq);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : gi(18));
  const m = WW(i), h = Hh(e);
  let v = So(h, {
    mixins: MW(h.breakpoints, o),
    palette: m,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: JW.slice(),
    typography: VL(m, c),
    transitions: rq(s),
    zIndex: S({}, aq)
  });
  if (v = So(v, f), v = t.reduce((b, x) => So(b, x), v), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], x = (E, T) => {
      let P;
      for (P in E) {
        const O = E[P];
        if (b.indexOf(P) !== -1 && Object.keys(O).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const k = ot("", P);
            console.error([`MUI: The \`${T}\` component increases the CSS specificity of the \`${P}\` internal state.`, "You can not override it like this: ", JSON.stringify(E, null, 2), "", `Instead, you need to use the '&.${k}' syntax:`, JSON.stringify({
              root: {
                [`&.${k}`]: O
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          E[P] = {};
        }
      }
    };
    Object.keys(v.components).forEach((E) => {
      const T = v.components[E].styleOverrides;
      T && E.indexOf("Mui") === 0 && x(T, E);
    });
  }
  return v.unstable_sxConfig = S({}, Cy, f == null ? void 0 : f.unstable_sxConfig), v.unstable_sx = function(x) {
    return jh({
      sx: x,
      theme: this
    });
  }, v;
}
let j2 = !1;
function cSe(...e) {
  return process.env.NODE_ENV !== "production" && (j2 || (j2 = !0, console.error(["MUI: the createMuiTheme function was renamed to createTheme.", "", "You should use `import { createTheme } from '@mui/material/styles'`"].join(`
`)))), Jf(...e);
}
const lq = Jf(), wx = lq, pd = "$$material", Oa = (e) => Bb(e) && e !== "classes", Ty = Bb, sq = $L({
  themeId: pd,
  defaultTheme: wx,
  rootShouldForwardProp: Oa
}), se = sq;
function dt({
  props: e,
  name: t
}) {
  return wy({
    props: e,
    name: t,
    defaultTheme: wx,
    themeId: pd
  });
}
function kR(e, t) {
  return kR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
    return i.__proto__ = s, i;
  }, kR(e, t);
}
function jL(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, kR(e, t);
}
var PR = { exports: {} }, ui = {}, VS = { exports: {} }, VO = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H2;
function cq() {
  return H2 || (H2 = 1, function(e) {
    function t(U, Z) {
      var ee = U.length;
      U.push(Z);
      e:
        for (; 0 < ee; ) {
          var ie = ee - 1 >>> 1, oe = U[ie];
          if (0 < s(oe, Z))
            U[ie] = Z, U[ee] = oe, ee = ie;
          else
            break e;
        }
    }
    function o(U) {
      return U.length === 0 ? null : U[0];
    }
    function i(U) {
      if (U.length === 0)
        return null;
      var Z = U[0], ee = U.pop();
      if (ee !== Z) {
        U[0] = ee;
        e:
          for (var ie = 0, oe = U.length, le = oe >>> 1; ie < le; ) {
            var de = 2 * (ie + 1) - 1, Ce = U[de], me = de + 1, Oe = U[me];
            if (0 > s(Ce, ee))
              me < oe && 0 > s(Oe, Ce) ? (U[ie] = Oe, U[me] = ee, ie = me) : (U[ie] = Ce, U[de] = ee, ie = de);
            else if (me < oe && 0 > s(Oe, ee))
              U[ie] = Oe, U[me] = ee, ie = me;
            else
              break e;
          }
      }
      return Z;
    }
    function s(U, Z) {
      var ee = U.sortIndex - Z.sortIndex;
      return ee !== 0 ? ee : U.id - Z.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var c = performance;
      e.unstable_now = function() {
        return c.now();
      };
    } else {
      var f = Date, m = f.now();
      e.unstable_now = function() {
        return f.now() - m;
      };
    }
    var h = [], v = [], b = 1, x = null, E = 3, T = !1, P = !1, O = !1, k = typeof setTimeout == "function" ? setTimeout : null, I = typeof clearTimeout == "function" ? clearTimeout : null, $ = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function _(U) {
      for (var Z = o(v); Z !== null; ) {
        if (Z.callback === null)
          i(v);
        else if (Z.startTime <= U)
          i(v), Z.sortIndex = Z.expirationTime, t(h, Z);
        else
          break;
        Z = o(v);
      }
    }
    function z(U) {
      if (O = !1, _(U), !P)
        if (o(h) !== null)
          P = !0, X(V);
        else {
          var Z = o(v);
          Z !== null && J(z, Z.startTime - U);
        }
    }
    function V(U, Z) {
      P = !1, O && (O = !1, I(W), W = -1), T = !0;
      var ee = E;
      try {
        for (_(Z), x = o(h); x !== null && (!(x.expirationTime > Z) || U && !G()); ) {
          var ie = x.callback;
          if (typeof ie == "function") {
            x.callback = null, E = x.priorityLevel;
            var oe = ie(x.expirationTime <= Z);
            Z = e.unstable_now(), typeof oe == "function" ? x.callback = oe : x === o(h) && i(h), _(Z);
          } else
            i(h);
          x = o(h);
        }
        if (x !== null)
          var le = !0;
        else {
          var de = o(v);
          de !== null && J(z, de.startTime - Z), le = !1;
        }
        return le;
      } finally {
        x = null, E = ee, T = !1;
      }
    }
    var M = !1, A = null, W = -1, Y = 5, H = -1;
    function G() {
      return !(e.unstable_now() - H < Y);
    }
    function ne() {
      if (A !== null) {
        var U = e.unstable_now();
        H = U;
        var Z = !0;
        try {
          Z = A(!0, U);
        } finally {
          Z ? K() : (M = !1, A = null);
        }
      } else
        M = !1;
    }
    var K;
    if (typeof $ == "function")
      K = function() {
        $(ne);
      };
    else if (typeof MessageChannel < "u") {
      var B = new MessageChannel(), q = B.port2;
      B.port1.onmessage = ne, K = function() {
        q.postMessage(null);
      };
    } else
      K = function() {
        k(ne, 0);
      };
    function X(U) {
      A = U, M || (M = !0, K());
    }
    function J(U, Z) {
      W = k(function() {
        U(e.unstable_now());
      }, Z);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, e.unstable_continueExecution = function() {
      P || T || (P = !0, X(V));
    }, e.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Y = 0 < U ? Math.floor(1e3 / U) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return E;
    }, e.unstable_getFirstCallbackNode = function() {
      return o(h);
    }, e.unstable_next = function(U) {
      switch (E) {
        case 1:
        case 2:
        case 3:
          var Z = 3;
          break;
        default:
          Z = E;
      }
      var ee = E;
      E = Z;
      try {
        return U();
      } finally {
        E = ee;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(U, Z) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var ee = E;
      E = U;
      try {
        return Z();
      } finally {
        E = ee;
      }
    }, e.unstable_scheduleCallback = function(U, Z, ee) {
      var ie = e.unstable_now();
      switch (typeof ee == "object" && ee !== null ? (ee = ee.delay, ee = typeof ee == "number" && 0 < ee ? ie + ee : ie) : ee = ie, U) {
        case 1:
          var oe = -1;
          break;
        case 2:
          oe = 250;
          break;
        case 5:
          oe = 1073741823;
          break;
        case 4:
          oe = 1e4;
          break;
        default:
          oe = 5e3;
      }
      return oe = ee + oe, U = { id: b++, callback: Z, priorityLevel: U, startTime: ee, expirationTime: oe, sortIndex: -1 }, ee > ie ? (U.sortIndex = ee, t(v, U), o(h) === null && U === o(v) && (O ? (I(W), W = -1) : O = !0, J(z, ee - ie))) : (U.sortIndex = oe, t(h, U), P || T || (P = !0, X(V))), U;
    }, e.unstable_shouldYield = G, e.unstable_wrapCallback = function(U) {
      var Z = E;
      return function() {
        var ee = E;
        E = Z;
        try {
          return U.apply(this, arguments);
        } finally {
          E = ee;
        }
      };
    };
  }(VO)), VO;
}
var BO = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U2;
function uq() {
  return U2 || (U2 = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, o = !1, i = 5;
      function s(Ye, st) {
        var _e = Ye.length;
        Ye.push(st), m(Ye, st, _e);
      }
      function c(Ye) {
        return Ye.length === 0 ? null : Ye[0];
      }
      function f(Ye) {
        if (Ye.length === 0)
          return null;
        var st = Ye[0], _e = Ye.pop();
        return _e !== st && (Ye[0] = _e, h(Ye, _e, 0)), st;
      }
      function m(Ye, st, _e) {
        for (var vt = _e; vt > 0; ) {
          var et = vt - 1 >>> 1, gt = Ye[et];
          if (v(gt, st) > 0)
            Ye[et] = st, Ye[vt] = gt, vt = et;
          else
            return;
        }
      }
      function h(Ye, st, _e) {
        for (var vt = _e, et = Ye.length, gt = et >>> 1; vt < gt; ) {
          var kt = (vt + 1) * 2 - 1, Lt = Ye[kt], Ut = kt + 1, Sn = Ye[Ut];
          if (v(Lt, st) < 0)
            Ut < et && v(Sn, Lt) < 0 ? (Ye[vt] = Sn, Ye[Ut] = st, vt = Ut) : (Ye[vt] = Lt, Ye[kt] = st, vt = kt);
          else if (Ut < et && v(Sn, st) < 0)
            Ye[vt] = Sn, Ye[Ut] = st, vt = Ut;
          else
            return;
        }
      }
      function v(Ye, st) {
        var _e = Ye.sortIndex - st.sortIndex;
        return _e !== 0 ? _e : Ye.id - st.id;
      }
      var b = 1, x = 2, E = 3, T = 4, P = 5;
      function O(Ye, st) {
      }
      var k = typeof performance == "object" && typeof performance.now == "function";
      if (k) {
        var I = performance;
        e.unstable_now = function() {
          return I.now();
        };
      } else {
        var $ = Date, _ = $.now();
        e.unstable_now = function() {
          return $.now() - _;
        };
      }
      var z = 1073741823, V = -1, M = 250, A = 5e3, W = 1e4, Y = z, H = [], G = [], ne = 1, K = null, B = E, q = !1, X = !1, J = !1, U = typeof setTimeout == "function" ? setTimeout : null, Z = typeof clearTimeout == "function" ? clearTimeout : null, ee = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ie(Ye) {
        for (var st = c(G); st !== null; ) {
          if (st.callback === null)
            f(G);
          else if (st.startTime <= Ye)
            f(G), st.sortIndex = st.expirationTime, s(H, st);
          else
            return;
          st = c(G);
        }
      }
      function oe(Ye) {
        if (J = !1, ie(Ye), !X)
          if (c(H) !== null)
            X = !0, ut(le);
          else {
            var st = c(G);
            st !== null && ft(oe, st.startTime - Ye);
          }
      }
      function le(Ye, st) {
        X = !1, J && (J = !1, Je()), q = !0;
        var _e = B;
        try {
          var vt;
          if (!o)
            return de(Ye, st);
        } finally {
          K = null, B = _e, q = !1;
        }
      }
      function de(Ye, st) {
        var _e = st;
        for (ie(_e), K = c(H); K !== null && !t && !(K.expirationTime > _e && (!Ye || ct())); ) {
          var vt = K.callback;
          if (typeof vt == "function") {
            K.callback = null, B = K.priorityLevel;
            var et = K.expirationTime <= _e, gt = vt(et);
            _e = e.unstable_now(), typeof gt == "function" ? K.callback = gt : K === c(H) && f(H), ie(_e);
          } else
            f(H);
          K = c(H);
        }
        if (K !== null)
          return !0;
        var kt = c(G);
        return kt !== null && ft(oe, kt.startTime - _e), !1;
      }
      function Ce(Ye, st) {
        switch (Ye) {
          case b:
          case x:
          case E:
          case T:
          case P:
            break;
          default:
            Ye = E;
        }
        var _e = B;
        B = Ye;
        try {
          return st();
        } finally {
          B = _e;
        }
      }
      function me(Ye) {
        var st;
        switch (B) {
          case b:
          case x:
          case E:
            st = E;
            break;
          default:
            st = B;
            break;
        }
        var _e = B;
        B = st;
        try {
          return Ye();
        } finally {
          B = _e;
        }
      }
      function Oe(Ye) {
        var st = B;
        return function() {
          var _e = B;
          B = st;
          try {
            return Ye.apply(this, arguments);
          } finally {
            B = _e;
          }
        };
      }
      function he(Ye, st, _e) {
        var vt = e.unstable_now(), et;
        if (typeof _e == "object" && _e !== null) {
          var gt = _e.delay;
          typeof gt == "number" && gt > 0 ? et = vt + gt : et = vt;
        } else
          et = vt;
        var kt;
        switch (Ye) {
          case b:
            kt = V;
            break;
          case x:
            kt = M;
            break;
          case P:
            kt = Y;
            break;
          case T:
            kt = W;
            break;
          case E:
          default:
            kt = A;
            break;
        }
        var Lt = et + kt, Ut = {
          id: ne++,
          callback: st,
          priorityLevel: Ye,
          startTime: et,
          expirationTime: Lt,
          sortIndex: -1
        };
        return et > vt ? (Ut.sortIndex = et, s(G, Ut), c(H) === null && Ut === c(G) && (J ? Je() : J = !0, ft(oe, et - vt))) : (Ut.sortIndex = Lt, s(H, Ut), !X && !q && (X = !0, ut(le))), Ut;
      }
      function $e() {
      }
      function Ne() {
        !X && !q && (X = !0, ut(le));
      }
      function Pe() {
        return c(H);
      }
      function Se(Ye) {
        Ye.callback = null;
      }
      function Fe() {
        return B;
      }
      var ce = !1, ge = null, we = -1, Me = i, Qe = -1;
      function ct() {
        var Ye = e.unstable_now() - Qe;
        return !(Ye < Me);
      }
      function Ze() {
      }
      function Ge(Ye) {
        if (Ye < 0 || Ye > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Ye > 0 ? Me = Math.floor(1e3 / Ye) : Me = i;
      }
      var Be = function() {
        if (ge !== null) {
          var Ye = e.unstable_now();
          Qe = Ye;
          var st = !0, _e = !0;
          try {
            _e = ge(st, Ye);
          } finally {
            _e ? rt() : (ce = !1, ge = null);
          }
        } else
          ce = !1;
      }, rt;
      if (typeof ee == "function")
        rt = function() {
          ee(Be);
        };
      else if (typeof MessageChannel < "u") {
        var wt = new MessageChannel(), We = wt.port2;
        wt.port1.onmessage = Be, rt = function() {
          We.postMessage(null);
        };
      } else
        rt = function() {
          U(Be, 0);
        };
      function ut(Ye) {
        ge = Ye, ce || (ce = !0, rt());
      }
      function ft(Ye, st) {
        we = U(function() {
          Ye(e.unstable_now());
        }, st);
      }
      function Je() {
        Z(we), we = -1;
      }
      var pt = Ze, At = null;
      e.unstable_IdlePriority = P, e.unstable_ImmediatePriority = b, e.unstable_LowPriority = T, e.unstable_NormalPriority = E, e.unstable_Profiling = At, e.unstable_UserBlockingPriority = x, e.unstable_cancelCallback = Se, e.unstable_continueExecution = Ne, e.unstable_forceFrameRate = Ge, e.unstable_getCurrentPriorityLevel = Fe, e.unstable_getFirstCallbackNode = Pe, e.unstable_next = me, e.unstable_pauseExecution = $e, e.unstable_requestPaint = pt, e.unstable_runWithPriority = Ce, e.unstable_scheduleCallback = he, e.unstable_shouldYield = ct, e.unstable_wrapCallback = Oe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(BO)), BO;
}
var G2;
function HL() {
  return G2 || (G2 = 1, process.env.NODE_ENV === "production" ? VS.exports = cq() : VS.exports = uq()), VS.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W2;
function dq() {
  if (W2)
    return ui;
  W2 = 1;
  var e = Ha, t = HL();
  function o(l) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + l, g = 1; g < arguments.length; g++)
      u += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + l + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = /* @__PURE__ */ new Set(), s = {};
  function c(l, u) {
    f(l, u), f(l + "Capture", u);
  }
  function f(l, u) {
    for (s[l] = u, l = 0; l < u.length; l++)
      i.add(u[l]);
  }
  var m = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h = Object.prototype.hasOwnProperty, v = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, b = {}, x = {};
  function E(l) {
    return h.call(x, l) ? !0 : h.call(b, l) ? !1 : v.test(l) ? x[l] = !0 : (b[l] = !0, !1);
  }
  function T(l, u, g, w) {
    if (g !== null && g.type === 0)
      return !1;
    switch (typeof u) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return w ? !1 : g !== null ? !g.acceptsBooleans : (l = l.toLowerCase().slice(0, 5), l !== "data-" && l !== "aria-");
      default:
        return !1;
    }
  }
  function P(l, u, g, w) {
    if (u === null || typeof u > "u" || T(l, u, g, w))
      return !0;
    if (w)
      return !1;
    if (g !== null)
      switch (g.type) {
        case 3:
          return !u;
        case 4:
          return u === !1;
        case 5:
          return isNaN(u);
        case 6:
          return isNaN(u) || 1 > u;
      }
    return !1;
  }
  function O(l, u, g, w, N, F, te) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = w, this.attributeNamespace = N, this.mustUseProperty = g, this.propertyName = l, this.type = u, this.sanitizeURL = F, this.removeEmptyString = te;
  }
  var k = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(l) {
    k[l] = new O(l, 0, !1, l, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(l) {
    var u = l[0];
    k[u] = new O(u, 1, !1, l[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(l) {
    k[l] = new O(l, 2, !1, l.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(l) {
    k[l] = new O(l, 2, !1, l, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(l) {
    k[l] = new O(l, 3, !1, l.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(l) {
    k[l] = new O(l, 3, !0, l, null, !1, !1);
  }), ["capture", "download"].forEach(function(l) {
    k[l] = new O(l, 4, !1, l, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(l) {
    k[l] = new O(l, 6, !1, l, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(l) {
    k[l] = new O(l, 5, !1, l.toLowerCase(), null, !1, !1);
  });
  var I = /[\-:]([a-z])/g;
  function $(l) {
    return l[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(l) {
    var u = l.replace(
      I,
      $
    );
    k[u] = new O(u, 1, !1, l, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(l) {
    var u = l.replace(I, $);
    k[u] = new O(u, 1, !1, l, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(l) {
    var u = l.replace(I, $);
    k[u] = new O(u, 1, !1, l, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(l) {
    k[l] = new O(l, 1, !1, l.toLowerCase(), null, !1, !1);
  }), k.xlinkHref = new O("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(l) {
    k[l] = new O(l, 1, !1, l.toLowerCase(), null, !0, !0);
  });
  function _(l, u, g, w) {
    var N = k.hasOwnProperty(u) ? k[u] : null;
    (N !== null ? N.type !== 0 : w || !(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N") && (P(u, g, N, w) && (g = null), w || N === null ? E(u) && (g === null ? l.removeAttribute(u) : l.setAttribute(u, "" + g)) : N.mustUseProperty ? l[N.propertyName] = g === null ? N.type === 3 ? !1 : "" : g : (u = N.attributeName, w = N.attributeNamespace, g === null ? l.removeAttribute(u) : (N = N.type, g = N === 3 || N === 4 && g === !0 ? "" : "" + g, w ? l.setAttributeNS(w, u, g) : l.setAttribute(u, g))));
  }
  var z = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, V = Symbol.for("react.element"), M = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), W = Symbol.for("react.strict_mode"), Y = Symbol.for("react.profiler"), H = Symbol.for("react.provider"), G = Symbol.for("react.context"), ne = Symbol.for("react.forward_ref"), K = Symbol.for("react.suspense"), B = Symbol.for("react.suspense_list"), q = Symbol.for("react.memo"), X = Symbol.for("react.lazy"), J = Symbol.for("react.offscreen"), U = Symbol.iterator;
  function Z(l) {
    return l === null || typeof l != "object" ? null : (l = U && l[U] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var ee = Object.assign, ie;
  function oe(l) {
    if (ie === void 0)
      try {
        throw Error();
      } catch (g) {
        var u = g.stack.trim().match(/\n( *(at )?)/);
        ie = u && u[1] || "";
      }
    return `
` + ie + l;
  }
  var le = !1;
  function de(l, u) {
    if (!l || le)
      return "";
    le = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (u)
        if (u = function() {
          throw Error();
        }, Object.defineProperty(u.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(u, []);
          } catch (qe) {
            var w = qe;
          }
          Reflect.construct(l, [], u);
        } else {
          try {
            u.call();
          } catch (qe) {
            w = qe;
          }
          l.call(u.prototype);
        }
      else {
        try {
          throw Error();
        } catch (qe) {
          w = qe;
        }
        l();
      }
    } catch (qe) {
      if (qe && w && typeof qe.stack == "string") {
        for (var N = qe.stack.split(`
`), F = w.stack.split(`
`), te = N.length - 1, ue = F.length - 1; 1 <= te && 0 <= ue && N[te] !== F[ue]; )
          ue--;
        for (; 1 <= te && 0 <= ue; te--, ue--)
          if (N[te] !== F[ue]) {
            if (te !== 1 || ue !== 1)
              do
                if (te--, ue--, 0 > ue || N[te] !== F[ue]) {
                  var ye = `
` + N[te].replace(" at new ", " at ");
                  return l.displayName && ye.includes("<anonymous>") && (ye = ye.replace("<anonymous>", l.displayName)), ye;
                }
              while (1 <= te && 0 <= ue);
            break;
          }
      }
    } finally {
      le = !1, Error.prepareStackTrace = g;
    }
    return (l = l ? l.displayName || l.name : "") ? oe(l) : "";
  }
  function Ce(l) {
    switch (l.tag) {
      case 5:
        return oe(l.type);
      case 16:
        return oe("Lazy");
      case 13:
        return oe("Suspense");
      case 19:
        return oe("SuspenseList");
      case 0:
      case 2:
      case 15:
        return l = de(l.type, !1), l;
      case 11:
        return l = de(l.type.render, !1), l;
      case 1:
        return l = de(l.type, !0), l;
      default:
        return "";
    }
  }
  function me(l) {
    if (l == null)
      return null;
    if (typeof l == "function")
      return l.displayName || l.name || null;
    if (typeof l == "string")
      return l;
    switch (l) {
      case A:
        return "Fragment";
      case M:
        return "Portal";
      case Y:
        return "Profiler";
      case W:
        return "StrictMode";
      case K:
        return "Suspense";
      case B:
        return "SuspenseList";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case G:
          return (l.displayName || "Context") + ".Consumer";
        case H:
          return (l._context.displayName || "Context") + ".Provider";
        case ne:
          var u = l.render;
          return l = l.displayName, l || (l = u.displayName || u.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case q:
          return u = l.displayName || null, u !== null ? u : me(l.type) || "Memo";
        case X:
          u = l._payload, l = l._init;
          try {
            return me(l(u));
          } catch {
          }
      }
    return null;
  }
  function Oe(l) {
    var u = l.type;
    switch (l.tag) {
      case 24:
        return "Cache";
      case 9:
        return (u.displayName || "Context") + ".Consumer";
      case 10:
        return (u._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return l = u.render, l = l.displayName || l.name || "", u.displayName || (l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return u;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return me(u);
      case 8:
        return u === W ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof u == "function")
          return u.displayName || u.name || null;
        if (typeof u == "string")
          return u;
    }
    return null;
  }
  function he(l) {
    switch (typeof l) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function $e(l) {
    var u = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
  }
  function Ne(l) {
    var u = $e(l) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(l.constructor.prototype, u), w = "" + l[u];
    if (!l.hasOwnProperty(u) && typeof g < "u" && typeof g.get == "function" && typeof g.set == "function") {
      var N = g.get, F = g.set;
      return Object.defineProperty(l, u, { configurable: !0, get: function() {
        return N.call(this);
      }, set: function(te) {
        w = "" + te, F.call(this, te);
      } }), Object.defineProperty(l, u, { enumerable: g.enumerable }), { getValue: function() {
        return w;
      }, setValue: function(te) {
        w = "" + te;
      }, stopTracking: function() {
        l._valueTracker = null, delete l[u];
      } };
    }
  }
  function Pe(l) {
    l._valueTracker || (l._valueTracker = Ne(l));
  }
  function Se(l) {
    if (!l)
      return !1;
    var u = l._valueTracker;
    if (!u)
      return !0;
    var g = u.getValue(), w = "";
    return l && (w = $e(l) ? l.checked ? "true" : "false" : l.value), l = w, l !== g ? (u.setValue(l), !0) : !1;
  }
  function Fe(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u")
      return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  function ce(l, u) {
    var g = u.checked;
    return ee({}, u, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: g ?? l._wrapperState.initialChecked });
  }
  function ge(l, u) {
    var g = u.defaultValue == null ? "" : u.defaultValue, w = u.checked != null ? u.checked : u.defaultChecked;
    g = he(u.value != null ? u.value : g), l._wrapperState = { initialChecked: w, initialValue: g, controlled: u.type === "checkbox" || u.type === "radio" ? u.checked != null : u.value != null };
  }
  function we(l, u) {
    u = u.checked, u != null && _(l, "checked", u, !1);
  }
  function Me(l, u) {
    we(l, u);
    var g = he(u.value), w = u.type;
    if (g != null)
      w === "number" ? (g === 0 && l.value === "" || l.value != g) && (l.value = "" + g) : l.value !== "" + g && (l.value = "" + g);
    else if (w === "submit" || w === "reset") {
      l.removeAttribute("value");
      return;
    }
    u.hasOwnProperty("value") ? ct(l, u.type, g) : u.hasOwnProperty("defaultValue") && ct(l, u.type, he(u.defaultValue)), u.checked == null && u.defaultChecked != null && (l.defaultChecked = !!u.defaultChecked);
  }
  function Qe(l, u, g) {
    if (u.hasOwnProperty("value") || u.hasOwnProperty("defaultValue")) {
      var w = u.type;
      if (!(w !== "submit" && w !== "reset" || u.value !== void 0 && u.value !== null))
        return;
      u = "" + l._wrapperState.initialValue, g || u === l.value || (l.value = u), l.defaultValue = u;
    }
    g = l.name, g !== "" && (l.name = ""), l.defaultChecked = !!l._wrapperState.initialChecked, g !== "" && (l.name = g);
  }
  function ct(l, u, g) {
    (u !== "number" || Fe(l.ownerDocument) !== l) && (g == null ? l.defaultValue = "" + l._wrapperState.initialValue : l.defaultValue !== "" + g && (l.defaultValue = "" + g));
  }
  var Ze = Array.isArray;
  function Ge(l, u, g, w) {
    if (l = l.options, u) {
      u = {};
      for (var N = 0; N < g.length; N++)
        u["$" + g[N]] = !0;
      for (g = 0; g < l.length; g++)
        N = u.hasOwnProperty("$" + l[g].value), l[g].selected !== N && (l[g].selected = N), N && w && (l[g].defaultSelected = !0);
    } else {
      for (g = "" + he(g), u = null, N = 0; N < l.length; N++) {
        if (l[N].value === g) {
          l[N].selected = !0, w && (l[N].defaultSelected = !0);
          return;
        }
        u !== null || l[N].disabled || (u = l[N]);
      }
      u !== null && (u.selected = !0);
    }
  }
  function Be(l, u) {
    if (u.dangerouslySetInnerHTML != null)
      throw Error(o(91));
    return ee({}, u, { value: void 0, defaultValue: void 0, children: "" + l._wrapperState.initialValue });
  }
  function rt(l, u) {
    var g = u.value;
    if (g == null) {
      if (g = u.children, u = u.defaultValue, g != null) {
        if (u != null)
          throw Error(o(92));
        if (Ze(g)) {
          if (1 < g.length)
            throw Error(o(93));
          g = g[0];
        }
        u = g;
      }
      u == null && (u = ""), g = u;
    }
    l._wrapperState = { initialValue: he(g) };
  }
  function wt(l, u) {
    var g = he(u.value), w = he(u.defaultValue);
    g != null && (g = "" + g, g !== l.value && (l.value = g), u.defaultValue == null && l.defaultValue !== g && (l.defaultValue = g)), w != null && (l.defaultValue = "" + w);
  }
  function We(l) {
    var u = l.textContent;
    u === l._wrapperState.initialValue && u !== "" && u !== null && (l.value = u);
  }
  function ut(l) {
    switch (l) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ft(l, u) {
    return l == null || l === "http://www.w3.org/1999/xhtml" ? ut(u) : l === "http://www.w3.org/2000/svg" && u === "foreignObject" ? "http://www.w3.org/1999/xhtml" : l;
  }
  var Je, pt = function(l) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(u, g, w, N) {
      MSApp.execUnsafeLocalFunction(function() {
        return l(u, g, w, N);
      });
    } : l;
  }(function(l, u) {
    if (l.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in l)
      l.innerHTML = u;
    else {
      for (Je = Je || document.createElement("div"), Je.innerHTML = "<svg>" + u.valueOf().toString() + "</svg>", u = Je.firstChild; l.firstChild; )
        l.removeChild(l.firstChild);
      for (; u.firstChild; )
        l.appendChild(u.firstChild);
    }
  });
  function At(l, u) {
    if (u) {
      var g = l.firstChild;
      if (g && g === l.lastChild && g.nodeType === 3) {
        g.nodeValue = u;
        return;
      }
    }
    l.textContent = u;
  }
  var Ye = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, st = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ye).forEach(function(l) {
    st.forEach(function(u) {
      u = u + l.charAt(0).toUpperCase() + l.substring(1), Ye[u] = Ye[l];
    });
  });
  function _e(l, u, g) {
    return u == null || typeof u == "boolean" || u === "" ? "" : g || typeof u != "number" || u === 0 || Ye.hasOwnProperty(l) && Ye[l] ? ("" + u).trim() : u + "px";
  }
  function vt(l, u) {
    l = l.style;
    for (var g in u)
      if (u.hasOwnProperty(g)) {
        var w = g.indexOf("--") === 0, N = _e(g, u[g], w);
        g === "float" && (g = "cssFloat"), w ? l.setProperty(g, N) : l[g] = N;
      }
  }
  var et = ee({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function gt(l, u) {
    if (u) {
      if (et[l] && (u.children != null || u.dangerouslySetInnerHTML != null))
        throw Error(o(137, l));
      if (u.dangerouslySetInnerHTML != null) {
        if (u.children != null)
          throw Error(o(60));
        if (typeof u.dangerouslySetInnerHTML != "object" || !("__html" in u.dangerouslySetInnerHTML))
          throw Error(o(61));
      }
      if (u.style != null && typeof u.style != "object")
        throw Error(o(62));
    }
  }
  function kt(l, u) {
    if (l.indexOf("-") === -1)
      return typeof u.is == "string";
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Lt = null;
  function Ut(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var Sn = null, an = null, un = null;
  function wn(l) {
    if (l = Hd(l)) {
      if (typeof Sn != "function")
        throw Error(o(280));
      var u = l.stateNode;
      u && (u = Jt(u), Sn(l.stateNode, l.type, u));
    }
  }
  function hn(l) {
    an ? un ? un.push(l) : un = [l] : an = l;
  }
  function Br() {
    if (an) {
      var l = an, u = un;
      if (un = an = null, wn(l), u)
        for (l = 0; l < u.length; l++)
          wn(u[l]);
    }
  }
  function zo(l, u) {
    return l(u);
  }
  function wo() {
  }
  var to = !1;
  function Dr(l, u, g) {
    if (to)
      return l(u, g);
    to = !0;
    try {
      return zo(l, u, g);
    } finally {
      to = !1, (an !== null || un !== null) && (wo(), Br());
    }
  }
  function Vn(l, u) {
    var g = l.stateNode;
    if (g === null)
      return null;
    var w = Jt(g);
    if (w === null)
      return null;
    g = w[u];
    e:
      switch (u) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (w = !w.disabled) || (l = l.type, w = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !w;
          break e;
        default:
          l = !1;
      }
    if (l)
      return null;
    if (g && typeof g != "function")
      throw Error(o(231, u, typeof g));
    return g;
  }
  var Dn = !1;
  if (m)
    try {
      var Zn = {};
      Object.defineProperty(Zn, "passive", { get: function() {
        Dn = !0;
      } }), window.addEventListener("test", Zn, Zn), window.removeEventListener("test", Zn, Zn);
    } catch {
      Dn = !1;
    }
  function _r(l, u, g, w, N, F, te, ue, ye) {
    var qe = Array.prototype.slice.call(arguments, 3);
    try {
      u.apply(g, qe);
    } catch (yt) {
      this.onError(yt);
    }
  }
  var ur = !1, Bn = null, xr = !1, fe = null, at = { onError: function(l) {
    ur = !0, Bn = l;
  } };
  function Et(l, u, g, w, N, F, te, ue, ye) {
    ur = !1, Bn = null, _r.apply(at, arguments);
  }
  function Ie(l, u, g, w, N, F, te, ue, ye) {
    if (Et.apply(this, arguments), ur) {
      if (ur) {
        var qe = Bn;
        ur = !1, Bn = null;
      } else
        throw Error(o(198));
      xr || (xr = !0, fe = qe);
    }
  }
  function xe(l) {
    var u = l, g = l;
    if (l.alternate)
      for (; u.return; )
        u = u.return;
    else {
      l = u;
      do
        u = l, u.flags & 4098 && (g = u.return), l = u.return;
      while (l);
    }
    return u.tag === 3 ? g : null;
  }
  function ze(l) {
    if (l.tag === 13) {
      var u = l.memoizedState;
      if (u === null && (l = l.alternate, l !== null && (u = l.memoizedState)), u !== null)
        return u.dehydrated;
    }
    return null;
  }
  function mt(l) {
    if (xe(l) !== l)
      throw Error(o(188));
  }
  function Ct(l) {
    var u = l.alternate;
    if (!u) {
      if (u = xe(l), u === null)
        throw Error(o(188));
      return u !== l ? null : l;
    }
    for (var g = l, w = u; ; ) {
      var N = g.return;
      if (N === null)
        break;
      var F = N.alternate;
      if (F === null) {
        if (w = N.return, w !== null) {
          g = w;
          continue;
        }
        break;
      }
      if (N.child === F.child) {
        for (F = N.child; F; ) {
          if (F === g)
            return mt(N), l;
          if (F === w)
            return mt(N), u;
          F = F.sibling;
        }
        throw Error(o(188));
      }
      if (g.return !== w.return)
        g = N, w = F;
      else {
        for (var te = !1, ue = N.child; ue; ) {
          if (ue === g) {
            te = !0, g = N, w = F;
            break;
          }
          if (ue === w) {
            te = !0, w = N, g = F;
            break;
          }
          ue = ue.sibling;
        }
        if (!te) {
          for (ue = F.child; ue; ) {
            if (ue === g) {
              te = !0, g = F, w = N;
              break;
            }
            if (ue === w) {
              te = !0, w = F, g = N;
              break;
            }
            ue = ue.sibling;
          }
          if (!te)
            throw Error(o(189));
        }
      }
      if (g.alternate !== w)
        throw Error(o(190));
    }
    if (g.tag !== 3)
      throw Error(o(188));
    return g.stateNode.current === g ? l : u;
  }
  function Qt(l) {
    return l = Ct(l), l !== null ? dn(l) : null;
  }
  function dn(l) {
    if (l.tag === 5 || l.tag === 6)
      return l;
    for (l = l.child; l !== null; ) {
      var u = dn(l);
      if (u !== null)
        return u;
      l = l.sibling;
    }
    return null;
  }
  var yn = t.unstable_scheduleCallback, Wt = t.unstable_cancelCallback, Ar = t.unstable_shouldYield, dp = t.unstable_requestPaint, An = t.unstable_now, Zx = t.unstable_getCurrentPriorityLevel, cl = t.unstable_ImmediatePriority, On = t.unstable_UserBlockingPriority, Zl = t.unstable_NormalPriority, Fy = t.unstable_LowPriority, Jh = t.unstable_IdlePriority, xd = null, Si = null;
  function zy(l) {
    if (Si && typeof Si.onCommitFiberRoot == "function")
      try {
        Si.onCommitFiberRoot(xd, l, void 0, (l.current.flags & 128) === 128);
      } catch {
      }
  }
  var Ua = Math.clz32 ? Math.clz32 : Jx, Vy = Math.log, By = Math.LN2;
  function Jx(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (Vy(l) / By | 0) | 0;
  }
  var fp = 64, Xc = 4194304;
  function qs(l) {
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return l & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return l;
    }
  }
  function xi(l, u) {
    var g = l.pendingLanes;
    if (g === 0)
      return 0;
    var w = 0, N = l.suspendedLanes, F = l.pingedLanes, te = g & 268435455;
    if (te !== 0) {
      var ue = te & ~N;
      ue !== 0 ? w = qs(ue) : (F &= te, F !== 0 && (w = qs(F)));
    } else
      te = g & ~N, te !== 0 ? w = qs(te) : F !== 0 && (w = qs(F));
    if (w === 0)
      return 0;
    if (u !== 0 && u !== w && !(u & N) && (N = w & -w, F = u & -u, N >= F || N === 16 && (F & 4194240) !== 0))
      return u;
    if (w & 4 && (w |= g & 16), u = l.entangledLanes, u !== 0)
      for (l = l.entanglements, u &= w; 0 < u; )
        g = 31 - Ua(u), N = 1 << g, w |= l[g], u &= ~N;
    return w;
  }
  function eg(l, u) {
    switch (l) {
      case 1:
      case 2:
      case 4:
        return u + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function pp(l, u) {
    for (var g = l.suspendedLanes, w = l.pingedLanes, N = l.expirationTimes, F = l.pendingLanes; 0 < F; ) {
      var te = 31 - Ua(F), ue = 1 << te, ye = N[te];
      ye === -1 ? (!(ue & g) || ue & w) && (N[te] = eg(ue, u)) : ye <= u && (l.expiredLanes |= ue), F &= ~ue;
    }
  }
  function tg(l) {
    return l = l.pendingLanes & -1073741825, l !== 0 ? l : l & 1073741824 ? 1073741824 : 0;
  }
  function mp() {
    var l = fp;
    return fp <<= 1, !(fp & 4194240) && (fp = 64), l;
  }
  function ng(l) {
    for (var u = [], g = 0; 31 > g; g++)
      u.push(l);
    return u;
  }
  function Ys(l, u, g) {
    l.pendingLanes |= u, u !== 536870912 && (l.suspendedLanes = 0, l.pingedLanes = 0), l = l.eventTimes, u = 31 - Ua(u), l[u] = g;
  }
  function ew(l, u) {
    var g = l.pendingLanes & ~u;
    l.pendingLanes = u, l.suspendedLanes = 0, l.pingedLanes = 0, l.expiredLanes &= u, l.mutableReadLanes &= u, l.entangledLanes &= u, u = l.entanglements;
    var w = l.eventTimes;
    for (l = l.expirationTimes; 0 < g; ) {
      var N = 31 - Ua(g), F = 1 << N;
      u[N] = 0, w[N] = -1, l[N] = -1, g &= ~F;
    }
  }
  function wd(l, u) {
    var g = l.entangledLanes |= u;
    for (l = l.entanglements; g; ) {
      var w = 31 - Ua(g), N = 1 << w;
      N & u | l[w] & u && (l[w] |= u), g &= ~N;
    }
  }
  var Yn = 0;
  function rg(l) {
    return l &= -l, 1 < l ? 4 < l ? l & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var jy, hp, dr, Hy, og, mn = !1, Ed = [], Wr = null, Ga = null, Wa = null, Td = /* @__PURE__ */ new Map(), no = /* @__PURE__ */ new Map(), Jn = [], tw = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function wi(l, u) {
    switch (l) {
      case "focusin":
      case "focusout":
        Wr = null;
        break;
      case "dragenter":
      case "dragleave":
        Ga = null;
        break;
      case "mouseover":
      case "mouseout":
        Wa = null;
        break;
      case "pointerover":
      case "pointerout":
        Td.delete(u.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        no.delete(u.pointerId);
    }
  }
  function Vo(l, u, g, w, N, F) {
    return l === null || l.nativeEvent !== F ? (l = { blockedOn: u, domEventName: g, eventSystemFlags: w, nativeEvent: F, targetContainers: [N] }, u !== null && (u = Hd(u), u !== null && hp(u)), l) : (l.eventSystemFlags |= w, u = l.targetContainers, N !== null && u.indexOf(N) === -1 && u.push(N), l);
  }
  function Jl(l, u, g, w, N) {
    switch (u) {
      case "focusin":
        return Wr = Vo(Wr, l, u, g, w, N), !0;
      case "dragenter":
        return Ga = Vo(Ga, l, u, g, w, N), !0;
      case "mouseover":
        return Wa = Vo(Wa, l, u, g, w, N), !0;
      case "pointerover":
        var F = N.pointerId;
        return Td.set(F, Vo(Td.get(F) || null, l, u, g, w, N)), !0;
      case "gotpointercapture":
        return F = N.pointerId, no.set(F, Vo(no.get(F) || null, l, u, g, w, N)), !0;
    }
    return !1;
  }
  function Uy(l) {
    var u = Ya(l.target);
    if (u !== null) {
      var g = xe(u);
      if (g !== null) {
        if (u = g.tag, u === 13) {
          if (u = ze(g), u !== null) {
            l.blockedOn = u, og(l.priority, function() {
              dr(g);
            });
            return;
          }
        } else if (u === 3 && g.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = g.tag === 3 ? g.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Qc(l) {
    if (l.blockedOn !== null)
      return !1;
    for (var u = l.targetContainers; 0 < u.length; ) {
      var g = bp(l.domEventName, l.eventSystemFlags, u[0], l.nativeEvent);
      if (g === null) {
        g = l.nativeEvent;
        var w = new g.constructor(g.type, g);
        Lt = w, g.target.dispatchEvent(w), Lt = null;
      } else
        return u = Hd(g), u !== null && hp(u), l.blockedOn = g, !1;
      u.shift();
    }
    return !0;
  }
  function ag(l, u, g) {
    Qc(l) && g.delete(u);
  }
  function Gy() {
    mn = !1, Wr !== null && Qc(Wr) && (Wr = null), Ga !== null && Qc(Ga) && (Ga = null), Wa !== null && Qc(Wa) && (Wa = null), Td.forEach(ag), no.forEach(ag);
  }
  function Od(l, u) {
    l.blockedOn === u && (l.blockedOn = null, mn || (mn = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Gy)));
  }
  function Rd(l) {
    function u(N) {
      return Od(N, l);
    }
    if (0 < Ed.length) {
      Od(Ed[0], l);
      for (var g = 1; g < Ed.length; g++) {
        var w = Ed[g];
        w.blockedOn === l && (w.blockedOn = null);
      }
    }
    for (Wr !== null && Od(Wr, l), Ga !== null && Od(Ga, l), Wa !== null && Od(Wa, l), Td.forEach(u), no.forEach(u), g = 0; g < Jn.length; g++)
      w = Jn[g], w.blockedOn === l && (w.blockedOn = null);
    for (; 0 < Jn.length && (g = Jn[0], g.blockedOn === null); )
      Uy(g), g.blockedOn === null && Jn.shift();
  }
  var Zc = z.ReactCurrentBatchConfig, Ks = !0;
  function Wy(l, u, g, w) {
    var N = Yn, F = Zc.transition;
    Zc.transition = null;
    try {
      Yn = 1, vp(l, u, g, w);
    } finally {
      Yn = N, Zc.transition = F;
    }
  }
  function gp(l, u, g, w) {
    var N = Yn, F = Zc.transition;
    Zc.transition = null;
    try {
      Yn = 4, vp(l, u, g, w);
    } finally {
      Yn = N, Zc.transition = F;
    }
  }
  function vp(l, u, g, w) {
    if (Ks) {
      var N = bp(l, u, g, w);
      if (N === null)
        Mp(l, u, w, kd, g), wi(l, w);
      else if (Jl(N, l, u, g, w))
        w.stopPropagation();
      else if (wi(l, w), u & 4 && -1 < tw.indexOf(l)) {
        for (; N !== null; ) {
          var F = Hd(N);
          if (F !== null && jy(F), F = bp(l, u, g, w), F === null && Mp(l, u, w, kd, g), F === N)
            break;
          N = F;
        }
        N !== null && w.stopPropagation();
      } else
        Mp(l, u, w, null, g);
    }
  }
  var kd = null;
  function bp(l, u, g, w) {
    if (kd = null, l = Ut(w), l = Ya(l), l !== null)
      if (u = xe(l), u === null)
        l = null;
      else if (g = u.tag, g === 13) {
        if (l = ze(u), l !== null)
          return l;
        l = null;
      } else if (g === 3) {
        if (u.stateNode.current.memoizedState.isDehydrated)
          return u.tag === 3 ? u.stateNode.containerInfo : null;
        l = null;
      } else
        u !== l && (l = null);
    return kd = l, null;
  }
  function ig(l) {
    switch (l) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Zx()) {
          case cl:
            return 1;
          case On:
            return 4;
          case Zl:
          case Fy:
            return 16;
          case Jh:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var ul = null, Pd = null, Md = null;
  function lg() {
    if (Md)
      return Md;
    var l, u = Pd, g = u.length, w, N = "value" in ul ? ul.value : ul.textContent, F = N.length;
    for (l = 0; l < g && u[l] === N[l]; l++)
      ;
    var te = g - l;
    for (w = 1; w <= te && u[g - w] === N[F - w]; w++)
      ;
    return Md = N.slice(l, 1 < w ? 1 - w : void 0);
  }
  function Jc(l) {
    var u = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && u === 13 && (l = 13)) : l = u, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Id() {
    return !0;
  }
  function qy() {
    return !1;
  }
  function ka(l) {
    function u(g, w, N, F, te) {
      this._reactName = g, this._targetInst = N, this.type = w, this.nativeEvent = F, this.target = te, this.currentTarget = null;
      for (var ue in l)
        l.hasOwnProperty(ue) && (g = l[ue], this[ue] = g ? g(F) : F[ue]);
      return this.isDefaultPrevented = (F.defaultPrevented != null ? F.defaultPrevented : F.returnValue === !1) ? Id : qy, this.isPropagationStopped = qy, this;
    }
    return ee(u.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var g = this.nativeEvent;
      g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = Id);
    }, stopPropagation: function() {
      var g = this.nativeEvent;
      g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = Id);
    }, persist: function() {
    }, isPersistent: Id }), u;
  }
  var es = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(l) {
    return l.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, yp = ka(es), eu = ee({}, es, { view: 0, detail: 0 }), Yy = ka(eu), Cp, sg, Nd, uo = ee({}, eu, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: fg, button: 0, buttons: 0, relatedTarget: function(l) {
    return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
  }, movementX: function(l) {
    return "movementX" in l ? l.movementX : (l !== Nd && (Nd && l.type === "mousemove" ? (Cp = l.screenX - Nd.screenX, sg = l.screenY - Nd.screenY) : sg = Cp = 0, Nd = l), Cp);
  }, movementY: function(l) {
    return "movementY" in l ? l.movementY : sg;
  } }), Sp = ka(uo), Ky = ee({}, uo, { dataTransfer: 0 }), Xy = ka(Ky), nw = ee({}, eu, { relatedTarget: 0 }), ts = ka(nw), cg = ee({}, es, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Qy = ka(cg), rw = ee({}, es, { clipboardData: function(l) {
    return "clipboardData" in l ? l.clipboardData : window.clipboardData;
  } }), ow = ka(rw), aw = ee({}, es, { data: 0 }), ug = ka(aw), dg = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Zy = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Jy = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function eC(l) {
    var u = this.nativeEvent;
    return u.getModifierState ? u.getModifierState(l) : (l = Jy[l]) ? !!u[l] : !1;
  }
  function fg() {
    return eC;
  }
  var dl = ee({}, eu, { key: function(l) {
    if (l.key) {
      var u = dg[l.key] || l.key;
      if (u !== "Unidentified")
        return u;
    }
    return l.type === "keypress" ? (l = Jc(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? Zy[l.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: fg, charCode: function(l) {
    return l.type === "keypress" ? Jc(l) : 0;
  }, keyCode: function(l) {
    return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
  }, which: function(l) {
    return l.type === "keypress" ? Jc(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
  } }), iw = ka(dl), pg = ee({}, uo, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), xp = ka(pg), mg = ee({}, eu, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: fg }), lw = ka(mg), wp = ee({}, es, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), tC = ka(wp), sa = ee({}, uo, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), fl = ka(sa), qr = [9, 13, 27, 32], Ei = m && "CompositionEvent" in window, Xs = null;
  m && "documentMode" in document && (Xs = document.documentMode);
  var Ep = m && "TextEvent" in window && !Xs, nC = m && (!Ei || Xs && 8 < Xs && 11 >= Xs), tu = String.fromCharCode(32), rC = !1;
  function oC(l, u) {
    switch (l) {
      case "keyup":
        return qr.indexOf(u.keyCode) !== -1;
      case "keydown":
        return u.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Tp(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var nu = !1;
  function sw(l, u) {
    switch (l) {
      case "compositionend":
        return Tp(u);
      case "keypress":
        return u.which !== 32 ? null : (rC = !0, tu);
      case "textInput":
        return l = u.data, l === tu && rC ? null : l;
      default:
        return null;
    }
  }
  function cw(l, u) {
    if (nu)
      return l === "compositionend" || !Ei && oC(l, u) ? (l = lg(), Md = Pd = ul = null, nu = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(u.ctrlKey || u.altKey || u.metaKey) || u.ctrlKey && u.altKey) {
          if (u.char && 1 < u.char.length)
            return u.char;
          if (u.which)
            return String.fromCharCode(u.which);
        }
        return null;
      case "compositionend":
        return nC && u.locale !== "ko" ? null : u.data;
      default:
        return null;
    }
  }
  var aC = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function iC(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u === "input" ? !!aC[l.type] : u === "textarea";
  }
  function lC(l, u, g, w) {
    hn(w), u = Vd(u, "onChange"), 0 < u.length && (g = new yp("onChange", "change", null, g, w), l.push({ event: g, listeners: u }));
  }
  var $d = null, ru = null;
  function ou(l) {
    Pp(l, 0);
  }
  function au(l) {
    var u = lu(l);
    if (Se(u))
      return l;
  }
  function sC(l, u) {
    if (l === "change")
      return u;
  }
  var hg = !1;
  if (m) {
    var gg;
    if (m) {
      var vg = "oninput" in document;
      if (!vg) {
        var cC = document.createElement("div");
        cC.setAttribute("oninput", "return;"), vg = typeof cC.oninput == "function";
      }
      gg = vg;
    } else
      gg = !1;
    hg = gg && (!document.documentMode || 9 < document.documentMode);
  }
  function uC() {
    $d && ($d.detachEvent("onpropertychange", dC), ru = $d = null);
  }
  function dC(l) {
    if (l.propertyName === "value" && au(ru)) {
      var u = [];
      lC(u, ru, l, Ut(l)), Dr(ou, u);
    }
  }
  function uw(l, u, g) {
    l === "focusin" ? (uC(), $d = u, ru = g, $d.attachEvent("onpropertychange", dC)) : l === "focusout" && uC();
  }
  function dw(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return au(ru);
  }
  function fw(l, u) {
    if (l === "click")
      return au(u);
  }
  function fC(l, u) {
    if (l === "input" || l === "change")
      return au(u);
  }
  function pw(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var qa = typeof Object.is == "function" ? Object.is : pw;
  function Dd(l, u) {
    if (qa(l, u))
      return !0;
    if (typeof l != "object" || l === null || typeof u != "object" || u === null)
      return !1;
    var g = Object.keys(l), w = Object.keys(u);
    if (g.length !== w.length)
      return !1;
    for (w = 0; w < g.length; w++) {
      var N = g[w];
      if (!h.call(u, N) || !qa(l[N], u[N]))
        return !1;
    }
    return !0;
  }
  function pC(l) {
    for (; l && l.firstChild; )
      l = l.firstChild;
    return l;
  }
  function mC(l, u) {
    var g = pC(l);
    l = 0;
    for (var w; g; ) {
      if (g.nodeType === 3) {
        if (w = l + g.textContent.length, l <= u && w >= u)
          return { node: g, offset: u - l };
        l = w;
      }
      e: {
        for (; g; ) {
          if (g.nextSibling) {
            g = g.nextSibling;
            break e;
          }
          g = g.parentNode;
        }
        g = void 0;
      }
      g = pC(g);
    }
  }
  function hC(l, u) {
    return l && u ? l === u ? !0 : l && l.nodeType === 3 ? !1 : u && u.nodeType === 3 ? hC(l, u.parentNode) : "contains" in l ? l.contains(u) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(u) & 16) : !1 : !1;
  }
  function Op() {
    for (var l = window, u = Fe(); u instanceof l.HTMLIFrameElement; ) {
      try {
        var g = typeof u.contentWindow.location.href == "string";
      } catch {
        g = !1;
      }
      if (g)
        l = u.contentWindow;
      else
        break;
      u = Fe(l.document);
    }
    return u;
  }
  function pl(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u && (u === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || u === "textarea" || l.contentEditable === "true");
  }
  function Rp(l) {
    var u = Op(), g = l.focusedElem, w = l.selectionRange;
    if (u !== g && g && g.ownerDocument && hC(g.ownerDocument.documentElement, g)) {
      if (w !== null && pl(g)) {
        if (u = w.start, l = w.end, l === void 0 && (l = u), "selectionStart" in g)
          g.selectionStart = u, g.selectionEnd = Math.min(l, g.value.length);
        else if (l = (u = g.ownerDocument || document) && u.defaultView || window, l.getSelection) {
          l = l.getSelection();
          var N = g.textContent.length, F = Math.min(w.start, N);
          w = w.end === void 0 ? F : Math.min(w.end, N), !l.extend && F > w && (N = w, w = F, F = N), N = mC(g, F);
          var te = mC(
            g,
            w
          );
          N && te && (l.rangeCount !== 1 || l.anchorNode !== N.node || l.anchorOffset !== N.offset || l.focusNode !== te.node || l.focusOffset !== te.offset) && (u = u.createRange(), u.setStart(N.node, N.offset), l.removeAllRanges(), F > w ? (l.addRange(u), l.extend(te.node, te.offset)) : (u.setEnd(te.node, te.offset), l.addRange(u)));
        }
      }
      for (u = [], l = g; l = l.parentNode; )
        l.nodeType === 1 && u.push({ element: l, left: l.scrollLeft, top: l.scrollTop });
      for (typeof g.focus == "function" && g.focus(), g = 0; g < u.length; g++)
        l = u[g], l.element.scrollLeft = l.left, l.element.scrollTop = l.top;
    }
  }
  var gC = m && "documentMode" in document && 11 >= document.documentMode, Ti = null, bg = null, _d = null, yg = !1;
  function vC(l, u, g) {
    var w = g.window === g ? g.document : g.nodeType === 9 ? g : g.ownerDocument;
    yg || Ti == null || Ti !== Fe(w) || (w = Ti, "selectionStart" in w && pl(w) ? w = { start: w.selectionStart, end: w.selectionEnd } : (w = (w.ownerDocument && w.ownerDocument.defaultView || window).getSelection(), w = { anchorNode: w.anchorNode, anchorOffset: w.anchorOffset, focusNode: w.focusNode, focusOffset: w.focusOffset }), _d && Dd(_d, w) || (_d = w, w = Vd(bg, "onSelect"), 0 < w.length && (u = new yp("onSelect", "select", null, u, g), l.push({ event: u, listeners: w }), u.target = Ti)));
  }
  function kp(l, u) {
    var g = {};
    return g[l.toLowerCase()] = u.toLowerCase(), g["Webkit" + l] = "webkit" + u, g["Moz" + l] = "moz" + u, g;
  }
  var Qs = { animationend: kp("Animation", "AnimationEnd"), animationiteration: kp("Animation", "AnimationIteration"), animationstart: kp("Animation", "AnimationStart"), transitionend: kp("Transition", "TransitionEnd") }, Cg = {}, Sg = {};
  m && (Sg = document.createElement("div").style, "AnimationEvent" in window || (delete Qs.animationend.animation, delete Qs.animationiteration.animation, delete Qs.animationstart.animation), "TransitionEvent" in window || delete Qs.transitionend.transition);
  function fo(l) {
    if (Cg[l])
      return Cg[l];
    if (!Qs[l])
      return l;
    var u = Qs[l], g;
    for (g in u)
      if (u.hasOwnProperty(g) && g in Sg)
        return Cg[l] = u[g];
    return l;
  }
  var xg = fo("animationend"), bC = fo("animationiteration"), yC = fo("animationstart"), CC = fo("transitionend"), SC = /* @__PURE__ */ new Map(), xC = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ml(l, u) {
    SC.set(l, u), c(u, [l]);
  }
  for (var Ad = 0; Ad < xC.length; Ad++) {
    var Zs = xC[Ad], mw = Zs.toLowerCase(), Ld = Zs[0].toUpperCase() + Zs.slice(1);
    ml(mw, "on" + Ld);
  }
  ml(xg, "onAnimationEnd"), ml(bC, "onAnimationIteration"), ml(yC, "onAnimationStart"), ml("dblclick", "onDoubleClick"), ml("focusin", "onFocus"), ml("focusout", "onBlur"), ml(CC, "onTransitionEnd"), f("onMouseEnter", ["mouseout", "mouseover"]), f("onMouseLeave", ["mouseout", "mouseover"]), f("onPointerEnter", ["pointerout", "pointerover"]), f("onPointerLeave", ["pointerout", "pointerover"]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Fd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), hw = new Set("cancel close invalid load scroll toggle".split(" ").concat(Fd));
  function wC(l, u, g) {
    var w = l.type || "unknown-event";
    l.currentTarget = g, Ie(w, u, void 0, l), l.currentTarget = null;
  }
  function Pp(l, u) {
    u = (u & 4) !== 0;
    for (var g = 0; g < l.length; g++) {
      var w = l[g], N = w.event;
      w = w.listeners;
      e: {
        var F = void 0;
        if (u)
          for (var te = w.length - 1; 0 <= te; te--) {
            var ue = w[te], ye = ue.instance, qe = ue.currentTarget;
            if (ue = ue.listener, ye !== F && N.isPropagationStopped())
              break e;
            wC(N, ue, qe), F = ye;
          }
        else
          for (te = 0; te < w.length; te++) {
            if (ue = w[te], ye = ue.instance, qe = ue.currentTarget, ue = ue.listener, ye !== F && N.isPropagationStopped())
              break e;
            wC(N, ue, qe), F = ye;
          }
      }
    }
    if (xr)
      throw l = fe, xr = !1, fe = null, l;
  }
  function fr(l, u) {
    var g = u[Pg];
    g === void 0 && (g = u[Pg] = /* @__PURE__ */ new Set());
    var w = l + "__bubble";
    g.has(w) || (EC(u, l, 2, !1), g.add(w));
  }
  function ns(l, u, g) {
    var w = 0;
    u && (w |= 4), EC(g, l, w, u);
  }
  var hl = "_reactListening" + Math.random().toString(36).slice(2);
  function iu(l) {
    if (!l[hl]) {
      l[hl] = !0, i.forEach(function(g) {
        g !== "selectionchange" && (hw.has(g) || ns(g, !1, l), ns(g, !0, l));
      });
      var u = l.nodeType === 9 ? l : l.ownerDocument;
      u === null || u[hl] || (u[hl] = !0, ns("selectionchange", !1, u));
    }
  }
  function EC(l, u, g, w) {
    switch (ig(u)) {
      case 1:
        var N = Wy;
        break;
      case 4:
        N = gp;
        break;
      default:
        N = vp;
    }
    g = N.bind(null, u, g, l), N = void 0, !Dn || u !== "touchstart" && u !== "touchmove" && u !== "wheel" || (N = !0), w ? N !== void 0 ? l.addEventListener(u, g, { capture: !0, passive: N }) : l.addEventListener(u, g, !0) : N !== void 0 ? l.addEventListener(u, g, { passive: N }) : l.addEventListener(u, g, !1);
  }
  function Mp(l, u, g, w, N) {
    var F = w;
    if (!(u & 1) && !(u & 2) && w !== null)
      e:
        for (; ; ) {
          if (w === null)
            return;
          var te = w.tag;
          if (te === 3 || te === 4) {
            var ue = w.stateNode.containerInfo;
            if (ue === N || ue.nodeType === 8 && ue.parentNode === N)
              break;
            if (te === 4)
              for (te = w.return; te !== null; ) {
                var ye = te.tag;
                if ((ye === 3 || ye === 4) && (ye = te.stateNode.containerInfo, ye === N || ye.nodeType === 8 && ye.parentNode === N))
                  return;
                te = te.return;
              }
            for (; ue !== null; ) {
              if (te = Ya(ue), te === null)
                return;
              if (ye = te.tag, ye === 5 || ye === 6) {
                w = F = te;
                continue e;
              }
              ue = ue.parentNode;
            }
          }
          w = w.return;
        }
    Dr(function() {
      var qe = F, yt = Ut(g), St = [];
      e: {
        var bt = SC.get(l);
        if (bt !== void 0) {
          var Mt = yp, Vt = l;
          switch (l) {
            case "keypress":
              if (Jc(g) === 0)
                break e;
            case "keydown":
            case "keyup":
              Mt = iw;
              break;
            case "focusin":
              Vt = "focus", Mt = ts;
              break;
            case "focusout":
              Vt = "blur", Mt = ts;
              break;
            case "beforeblur":
            case "afterblur":
              Mt = ts;
              break;
            case "click":
              if (g.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Mt = Sp;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Mt = Xy;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Mt = lw;
              break;
            case xg:
            case bC:
            case yC:
              Mt = Qy;
              break;
            case CC:
              Mt = tC;
              break;
            case "scroll":
              Mt = Yy;
              break;
            case "wheel":
              Mt = fl;
              break;
            case "copy":
            case "cut":
            case "paste":
              Mt = ow;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Mt = xp;
          }
          var Gt = (u & 4) !== 0, Hr = !Gt && l === "scroll", De = Gt ? bt !== null ? bt + "Capture" : null : bt;
          Gt = [];
          for (var Re = qe, Ve; Re !== null; ) {
            Ve = Re;
            var Tt = Ve.stateNode;
            if (Ve.tag === 5 && Tt !== null && (Ve = Tt, De !== null && (Tt = Vn(Re, De), Tt != null && Gt.push(zd(Re, Tt, Ve)))), Hr)
              break;
            Re = Re.return;
          }
          0 < Gt.length && (bt = new Mt(bt, Vt, null, g, yt), St.push({ event: bt, listeners: Gt }));
        }
      }
      if (!(u & 7)) {
        e: {
          if (bt = l === "mouseover" || l === "pointerover", Mt = l === "mouseout" || l === "pointerout", bt && g !== Lt && (Vt = g.relatedTarget || g.fromElement) && (Ya(Vt) || Vt[gl]))
            break e;
          if ((Mt || bt) && (bt = yt.window === yt ? yt : (bt = yt.ownerDocument) ? bt.defaultView || bt.parentWindow : window, Mt ? (Vt = g.relatedTarget || g.toElement, Mt = qe, Vt = Vt ? Ya(Vt) : null, Vt !== null && (Hr = xe(Vt), Vt !== Hr || Vt.tag !== 5 && Vt.tag !== 6) && (Vt = null)) : (Mt = null, Vt = qe), Mt !== Vt)) {
            if (Gt = Sp, Tt = "onMouseLeave", De = "onMouseEnter", Re = "mouse", (l === "pointerout" || l === "pointerover") && (Gt = xp, Tt = "onPointerLeave", De = "onPointerEnter", Re = "pointer"), Hr = Mt == null ? bt : lu(Mt), Ve = Vt == null ? bt : lu(Vt), bt = new Gt(Tt, Re + "leave", Mt, g, yt), bt.target = Hr, bt.relatedTarget = Ve, Tt = null, Ya(yt) === qe && (Gt = new Gt(De, Re + "enter", Vt, g, yt), Gt.target = Ve, Gt.relatedTarget = Hr, Tt = Gt), Hr = Tt, Mt && Vt)
              t: {
                for (Gt = Mt, De = Vt, Re = 0, Ve = Gt; Ve; Ve = Js(Ve))
                  Re++;
                for (Ve = 0, Tt = De; Tt; Tt = Js(Tt))
                  Ve++;
                for (; 0 < Re - Ve; )
                  Gt = Js(Gt), Re--;
                for (; 0 < Ve - Re; )
                  De = Js(De), Ve--;
                for (; Re--; ) {
                  if (Gt === De || De !== null && Gt === De.alternate)
                    break t;
                  Gt = Js(Gt), De = Js(De);
                }
                Gt = null;
              }
            else
              Gt = null;
            Mt !== null && wg(St, bt, Mt, Gt, !1), Vt !== null && Hr !== null && wg(St, Hr, Vt, Gt, !0);
          }
        }
        e: {
          if (bt = qe ? lu(qe) : window, Mt = bt.nodeName && bt.nodeName.toLowerCase(), Mt === "select" || Mt === "input" && bt.type === "file")
            var qt = sC;
          else if (iC(bt))
            if (hg)
              qt = fC;
            else {
              qt = dw;
              var Bt = uw;
            }
          else
            (Mt = bt.nodeName) && Mt.toLowerCase() === "input" && (bt.type === "checkbox" || bt.type === "radio") && (qt = fw);
          if (qt && (qt = qt(l, qe))) {
            lC(St, qt, g, yt);
            break e;
          }
          Bt && Bt(l, bt, qe), l === "focusout" && (Bt = bt._wrapperState) && Bt.controlled && bt.type === "number" && ct(bt, "number", bt.value);
        }
        switch (Bt = qe ? lu(qe) : window, l) {
          case "focusin":
            (iC(Bt) || Bt.contentEditable === "true") && (Ti = Bt, bg = qe, _d = null);
            break;
          case "focusout":
            _d = bg = Ti = null;
            break;
          case "mousedown":
            yg = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            yg = !1, vC(St, g, yt);
            break;
          case "selectionchange":
            if (gC)
              break;
          case "keydown":
          case "keyup":
            vC(St, g, yt);
        }
        var Zt;
        if (Ei)
          e: {
            switch (l) {
              case "compositionstart":
                var cn = "onCompositionStart";
                break e;
              case "compositionend":
                cn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                cn = "onCompositionUpdate";
                break e;
            }
            cn = void 0;
          }
        else
          nu ? oC(l, g) && (cn = "onCompositionEnd") : l === "keydown" && g.keyCode === 229 && (cn = "onCompositionStart");
        cn && (nC && g.locale !== "ko" && (nu || cn !== "onCompositionStart" ? cn === "onCompositionEnd" && nu && (Zt = lg()) : (ul = yt, Pd = "value" in ul ? ul.value : ul.textContent, nu = !0)), Bt = Vd(qe, cn), 0 < Bt.length && (cn = new ug(cn, l, null, g, yt), St.push({ event: cn, listeners: Bt }), Zt ? cn.data = Zt : (Zt = Tp(g), Zt !== null && (cn.data = Zt)))), (Zt = Ep ? sw(l, g) : cw(l, g)) && (qe = Vd(qe, "onBeforeInput"), 0 < qe.length && (yt = new ug("onBeforeInput", "beforeinput", null, g, yt), St.push({ event: yt, listeners: qe }), yt.data = Zt));
      }
      Pp(St, u);
    });
  }
  function zd(l, u, g) {
    return { instance: l, listener: u, currentTarget: g };
  }
  function Vd(l, u) {
    for (var g = u + "Capture", w = []; l !== null; ) {
      var N = l, F = N.stateNode;
      N.tag === 5 && F !== null && (N = F, F = Vn(l, g), F != null && w.unshift(zd(l, F, N)), F = Vn(l, u), F != null && w.push(zd(l, F, N))), l = l.return;
    }
    return w;
  }
  function Js(l) {
    if (l === null)
      return null;
    do
      l = l.return;
    while (l && l.tag !== 5);
    return l || null;
  }
  function wg(l, u, g, w, N) {
    for (var F = u._reactName, te = []; g !== null && g !== w; ) {
      var ue = g, ye = ue.alternate, qe = ue.stateNode;
      if (ye !== null && ye === w)
        break;
      ue.tag === 5 && qe !== null && (ue = qe, N ? (ye = Vn(g, F), ye != null && te.unshift(zd(g, ye, ue))) : N || (ye = Vn(g, F), ye != null && te.push(zd(g, ye, ue)))), g = g.return;
    }
    te.length !== 0 && l.push({ event: u, listeners: te });
  }
  var Eg = /\r\n?/g, gw = /\u0000|\uFFFD/g;
  function Tg(l) {
    return (typeof l == "string" ? l : "" + l).replace(Eg, `
`).replace(gw, "");
  }
  function Ip(l, u, g) {
    if (u = Tg(u), Tg(l) !== u && g)
      throw Error(o(425));
  }
  function Np() {
  }
  var Og = null, ec = null;
  function Bd(l, u) {
    return l === "textarea" || l === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
  }
  var tc = typeof setTimeout == "function" ? setTimeout : void 0, TC = typeof clearTimeout == "function" ? clearTimeout : void 0, Rg = typeof Promise == "function" ? Promise : void 0, kg = typeof queueMicrotask == "function" ? queueMicrotask : typeof Rg < "u" ? function(l) {
    return Rg.resolve(null).then(l).catch(vw);
  } : tc;
  function vw(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function rs(l, u) {
    var g = u, w = 0;
    do {
      var N = g.nextSibling;
      if (l.removeChild(g), N && N.nodeType === 8)
        if (g = N.data, g === "/$") {
          if (w === 0) {
            l.removeChild(N), Rd(u);
            return;
          }
          w--;
        } else
          g !== "$" && g !== "$?" && g !== "$!" || w++;
      g = N;
    } while (g);
    Rd(u);
  }
  function Oi(l) {
    for (; l != null; l = l.nextSibling) {
      var u = l.nodeType;
      if (u === 1 || u === 3)
        break;
      if (u === 8) {
        if (u = l.data, u === "$" || u === "$!" || u === "$?")
          break;
        if (u === "/$")
          return null;
      }
    }
    return l;
  }
  function jd(l) {
    l = l.previousSibling;
    for (var u = 0; l; ) {
      if (l.nodeType === 8) {
        var g = l.data;
        if (g === "$" || g === "$!" || g === "$?") {
          if (u === 0)
            return l;
          u--;
        } else
          g === "/$" && u++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  var os = Math.random().toString(36).slice(2), zi = "__reactFiber$" + os, nc = "__reactProps$" + os, gl = "__reactContainer$" + os, Pg = "__reactEvents$" + os, bw = "__reactListeners$" + os, Mg = "__reactHandles$" + os;
  function Ya(l) {
    var u = l[zi];
    if (u)
      return u;
    for (var g = l.parentNode; g; ) {
      if (u = g[gl] || g[zi]) {
        if (g = u.alternate, u.child !== null || g !== null && g.child !== null)
          for (l = jd(l); l !== null; ) {
            if (g = l[zi])
              return g;
            l = jd(l);
          }
        return u;
      }
      l = g, g = l.parentNode;
    }
    return null;
  }
  function Hd(l) {
    return l = l[zi] || l[gl], !l || l.tag !== 5 && l.tag !== 6 && l.tag !== 13 && l.tag !== 3 ? null : l;
  }
  function lu(l) {
    if (l.tag === 5 || l.tag === 6)
      return l.stateNode;
    throw Error(o(33));
  }
  function Jt(l) {
    return l[nc] || null;
  }
  var as = [], hr = -1;
  function gn(l) {
    return { current: l };
  }
  function jn(l) {
    0 > hr || (l.current = as[hr], as[hr] = null, hr--);
  }
  function Un(l, u) {
    hr++, as[hr] = l.current, l.current = u;
  }
  var Vi = {}, sn = gn(Vi), Lr = gn(!1), ca = Vi;
  function Ka(l, u) {
    var g = l.type.contextTypes;
    if (!g)
      return Vi;
    var w = l.stateNode;
    if (w && w.__reactInternalMemoizedUnmaskedChildContext === u)
      return w.__reactInternalMemoizedMaskedChildContext;
    var N = {}, F;
    for (F in g)
      N[F] = u[F];
    return w && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = u, l.__reactInternalMemoizedMaskedChildContext = N), N;
  }
  function wr(l) {
    return l = l.childContextTypes, l != null;
  }
  function Xa() {
    jn(Lr), jn(sn);
  }
  function is(l, u, g) {
    if (sn.current !== Vi)
      throw Error(o(168));
    Un(sn, u), Un(Lr, g);
  }
  function Ud(l, u, g) {
    var w = l.stateNode;
    if (u = u.childContextTypes, typeof w.getChildContext != "function")
      return g;
    w = w.getChildContext();
    for (var N in w)
      if (!(N in u))
        throw Error(o(108, Oe(l) || "Unknown", N));
    return ee({}, g, w);
  }
  function $p(l) {
    return l = (l = l.stateNode) && l.__reactInternalMemoizedMergedChildContext || Vi, ca = sn.current, Un(sn, l), Un(Lr, Lr.current), !0;
  }
  function OC(l, u, g) {
    var w = l.stateNode;
    if (!w)
      throw Error(o(169));
    g ? (l = Ud(l, u, ca), w.__reactInternalMemoizedMergedChildContext = l, jn(Lr), jn(sn), Un(sn, l)) : jn(Lr), Un(Lr, g);
  }
  var Pa = null, po = !1, Gd = !1;
  function Ig(l) {
    Pa === null ? Pa = [l] : Pa.push(l);
  }
  function Ng(l) {
    po = !0, Ig(l);
  }
  function ua() {
    if (!Gd && Pa !== null) {
      Gd = !0;
      var l = 0, u = Yn;
      try {
        var g = Pa;
        for (Yn = 1; l < g.length; l++) {
          var w = g[l];
          do
            w = w(!0);
          while (w !== null);
        }
        Pa = null, po = !1;
      } catch (N) {
        throw Pa !== null && (Pa = Pa.slice(l + 1)), yn(cl, ua), N;
      } finally {
        Yn = u, Gd = !1;
      }
    }
    return null;
  }
  var ls = [], da = 0, rc = null, su = 0, fa = [], Bo = 0, Qa = null, Eo = 1, vl = "";
  function Ma(l, u) {
    ls[da++] = su, ls[da++] = rc, rc = l, su = u;
  }
  function $g(l, u, g) {
    fa[Bo++] = Eo, fa[Bo++] = vl, fa[Bo++] = Qa, Qa = l;
    var w = Eo;
    l = vl;
    var N = 32 - Ua(w) - 1;
    w &= ~(1 << N), g += 1;
    var F = 32 - Ua(u) + N;
    if (30 < F) {
      var te = N - N % 5;
      F = (w & (1 << te) - 1).toString(32), w >>= te, N -= te, Eo = 1 << 32 - Ua(u) + N | g << N | w, vl = F + l;
    } else
      Eo = 1 << F | g << N | w, vl = l;
  }
  function Dp(l) {
    l.return !== null && (Ma(l, 1), $g(l, 1, 0));
  }
  function Dg(l) {
    for (; l === rc; )
      rc = ls[--da], ls[da] = null, su = ls[--da], ls[da] = null;
    for (; l === Qa; )
      Qa = fa[--Bo], fa[Bo] = null, vl = fa[--Bo], fa[Bo] = null, Eo = fa[--Bo], fa[Bo] = null;
  }
  var Ia = null, pa = null, gr = !1, Za = null;
  function _g(l, u) {
    var g = oi(5, null, null, 0);
    g.elementType = "DELETED", g.stateNode = u, g.return = l, u = l.deletions, u === null ? (l.deletions = [g], l.flags |= 16) : u.push(g);
  }
  function RC(l, u) {
    switch (l.tag) {
      case 5:
        var g = l.type;
        return u = u.nodeType !== 1 || g.toLowerCase() !== u.nodeName.toLowerCase() ? null : u, u !== null ? (l.stateNode = u, Ia = l, pa = Oi(u.firstChild), !0) : !1;
      case 6:
        return u = l.pendingProps === "" || u.nodeType !== 3 ? null : u, u !== null ? (l.stateNode = u, Ia = l, pa = null, !0) : !1;
      case 13:
        return u = u.nodeType !== 8 ? null : u, u !== null ? (g = Qa !== null ? { id: Eo, overflow: vl } : null, l.memoizedState = { dehydrated: u, treeContext: g, retryLane: 1073741824 }, g = oi(18, null, null, 0), g.stateNode = u, g.return = l, l.child = g, Ia = l, pa = null, !0) : !1;
      default:
        return !1;
    }
  }
  function _p(l) {
    return (l.mode & 1) !== 0 && (l.flags & 128) === 0;
  }
  function Ap(l) {
    if (gr) {
      var u = pa;
      if (u) {
        var g = u;
        if (!RC(l, u)) {
          if (_p(l))
            throw Error(o(418));
          u = Oi(g.nextSibling);
          var w = Ia;
          u && RC(l, u) ? _g(w, g) : (l.flags = l.flags & -4097 | 2, gr = !1, Ia = l);
        }
      } else {
        if (_p(l))
          throw Error(o(418));
        l.flags = l.flags & -4097 | 2, gr = !1, Ia = l;
      }
    }
  }
  function kC(l) {
    for (l = l.return; l !== null && l.tag !== 5 && l.tag !== 3 && l.tag !== 13; )
      l = l.return;
    Ia = l;
  }
  function Lp(l) {
    if (l !== Ia)
      return !1;
    if (!gr)
      return kC(l), gr = !0, !1;
    var u;
    if ((u = l.tag !== 3) && !(u = l.tag !== 5) && (u = l.type, u = u !== "head" && u !== "body" && !Bd(l.type, l.memoizedProps)), u && (u = pa)) {
      if (_p(l))
        throw PC(), Error(o(418));
      for (; u; )
        _g(l, u), u = Oi(u.nextSibling);
    }
    if (kC(l), l.tag === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l)
        throw Error(o(317));
      e: {
        for (l = l.nextSibling, u = 0; l; ) {
          if (l.nodeType === 8) {
            var g = l.data;
            if (g === "/$") {
              if (u === 0) {
                pa = Oi(l.nextSibling);
                break e;
              }
              u--;
            } else
              g !== "$" && g !== "$!" && g !== "$?" || u++;
          }
          l = l.nextSibling;
        }
        pa = null;
      }
    } else
      pa = Ia ? Oi(l.stateNode.nextSibling) : null;
    return !0;
  }
  function PC() {
    for (var l = pa; l; )
      l = Oi(l.nextSibling);
  }
  function Or() {
    pa = Ia = null, gr = !1;
  }
  function Ag(l) {
    Za === null ? Za = [l] : Za.push(l);
  }
  var Fp = z.ReactCurrentBatchConfig;
  function Na(l, u) {
    if (l && l.defaultProps) {
      u = ee({}, u), l = l.defaultProps;
      for (var g in l)
        u[g] === void 0 && (u[g] = l[g]);
      return u;
    }
    return u;
  }
  var Bi = gn(null), zp = null, ss = null, Lg = null;
  function Fg() {
    Lg = ss = zp = null;
  }
  function cs(l) {
    var u = Bi.current;
    jn(Bi), l._currentValue = u;
  }
  function mo(l, u, g) {
    for (; l !== null; ) {
      var w = l.alternate;
      if ((l.childLanes & u) !== u ? (l.childLanes |= u, w !== null && (w.childLanes |= u)) : w !== null && (w.childLanes & u) !== u && (w.childLanes |= u), l === g)
        break;
      l = l.return;
    }
  }
  function Ot(l, u) {
    zp = l, Lg = ss = null, l = l.dependencies, l !== null && l.firstContext !== null && (l.lanes & u && (Yr = !0), l.firstContext = null);
  }
  function jr(l) {
    var u = l._currentValue;
    if (Lg !== l)
      if (l = { context: l, memoizedValue: u, next: null }, ss === null) {
        if (zp === null)
          throw Error(o(308));
        ss = l, zp.dependencies = { lanes: 0, firstContext: l };
      } else
        ss = ss.next = l;
    return u;
  }
  var To = null;
  function zg(l) {
    To === null ? To = [l] : To.push(l);
  }
  function MC(l, u, g, w) {
    var N = u.interleaved;
    return N === null ? (g.next = g, zg(u)) : (g.next = N.next, N.next = g), u.interleaved = g, bl(l, w);
  }
  function bl(l, u) {
    l.lanes |= u;
    var g = l.alternate;
    for (g !== null && (g.lanes |= u), g = l, l = l.return; l !== null; )
      l.childLanes |= u, g = l.alternate, g !== null && (g.childLanes |= u), g = l, l = l.return;
    return g.tag === 3 ? g.stateNode : null;
  }
  var us = !1;
  function Vg(l) {
    l.updateQueue = { baseState: l.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function ro(l, u) {
    l = l.updateQueue, u.updateQueue === l && (u.updateQueue = { baseState: l.baseState, firstBaseUpdate: l.firstBaseUpdate, lastBaseUpdate: l.lastBaseUpdate, shared: l.shared, effects: l.effects });
  }
  function yl(l, u) {
    return { eventTime: l, lane: u, tag: 0, payload: null, callback: null, next: null };
  }
  function ds(l, u, g) {
    var w = l.updateQueue;
    if (w === null)
      return null;
    if (w = w.shared, Rn & 2) {
      var N = w.pending;
      return N === null ? u.next = u : (u.next = N.next, N.next = u), w.pending = u, bl(l, g);
    }
    return N = w.interleaved, N === null ? (u.next = u, zg(w)) : (u.next = N.next, N.next = u), w.interleaved = u, bl(l, g);
  }
  function Vp(l, u, g) {
    if (u = u.updateQueue, u !== null && (u = u.shared, (g & 4194240) !== 0)) {
      var w = u.lanes;
      w &= l.pendingLanes, g |= w, u.lanes = g, wd(l, g);
    }
  }
  function Bg(l, u) {
    var g = l.updateQueue, w = l.alternate;
    if (w !== null && (w = w.updateQueue, g === w)) {
      var N = null, F = null;
      if (g = g.firstBaseUpdate, g !== null) {
        do {
          var te = { eventTime: g.eventTime, lane: g.lane, tag: g.tag, payload: g.payload, callback: g.callback, next: null };
          F === null ? N = F = te : F = F.next = te, g = g.next;
        } while (g !== null);
        F === null ? N = F = u : F = F.next = u;
      } else
        N = F = u;
      g = { baseState: w.baseState, firstBaseUpdate: N, lastBaseUpdate: F, shared: w.shared, effects: w.effects }, l.updateQueue = g;
      return;
    }
    l = g.lastBaseUpdate, l === null ? g.firstBaseUpdate = u : l.next = u, g.lastBaseUpdate = u;
  }
  function fs(l, u, g, w) {
    var N = l.updateQueue;
    us = !1;
    var F = N.firstBaseUpdate, te = N.lastBaseUpdate, ue = N.shared.pending;
    if (ue !== null) {
      N.shared.pending = null;
      var ye = ue, qe = ye.next;
      ye.next = null, te === null ? F = qe : te.next = qe, te = ye;
      var yt = l.alternate;
      yt !== null && (yt = yt.updateQueue, ue = yt.lastBaseUpdate, ue !== te && (ue === null ? yt.firstBaseUpdate = qe : ue.next = qe, yt.lastBaseUpdate = ye));
    }
    if (F !== null) {
      var St = N.baseState;
      te = 0, yt = qe = ye = null, ue = F;
      do {
        var bt = ue.lane, Mt = ue.eventTime;
        if ((w & bt) === bt) {
          yt !== null && (yt = yt.next = {
            eventTime: Mt,
            lane: 0,
            tag: ue.tag,
            payload: ue.payload,
            callback: ue.callback,
            next: null
          });
          e: {
            var Vt = l, Gt = ue;
            switch (bt = u, Mt = g, Gt.tag) {
              case 1:
                if (Vt = Gt.payload, typeof Vt == "function") {
                  St = Vt.call(Mt, St, bt);
                  break e;
                }
                St = Vt;
                break e;
              case 3:
                Vt.flags = Vt.flags & -65537 | 128;
              case 0:
                if (Vt = Gt.payload, bt = typeof Vt == "function" ? Vt.call(Mt, St, bt) : Vt, bt == null)
                  break e;
                St = ee({}, St, bt);
                break e;
              case 2:
                us = !0;
            }
          }
          ue.callback !== null && ue.lane !== 0 && (l.flags |= 64, bt = N.effects, bt === null ? N.effects = [ue] : bt.push(ue));
        } else
          Mt = { eventTime: Mt, lane: bt, tag: ue.tag, payload: ue.payload, callback: ue.callback, next: null }, yt === null ? (qe = yt = Mt, ye = St) : yt = yt.next = Mt, te |= bt;
        if (ue = ue.next, ue === null) {
          if (ue = N.shared.pending, ue === null)
            break;
          bt = ue, ue = bt.next, bt.next = null, N.lastBaseUpdate = bt, N.shared.pending = null;
        }
      } while (1);
      if (yt === null && (ye = St), N.baseState = ye, N.firstBaseUpdate = qe, N.lastBaseUpdate = yt, u = N.shared.interleaved, u !== null) {
        N = u;
        do
          te |= N.lane, N = N.next;
        while (N !== u);
      } else
        F === null && (N.shared.lanes = 0);
      wl |= te, l.lanes = te, l.memoizedState = St;
    }
  }
  function oc(l, u, g) {
    if (l = u.effects, u.effects = null, l !== null)
      for (u = 0; u < l.length; u++) {
        var w = l[u], N = w.callback;
        if (N !== null) {
          if (w.callback = null, w = g, typeof N != "function")
            throw Error(o(191, N));
          N.call(w);
        }
      }
  }
  var IC = new e.Component().refs;
  function jg(l, u, g, w) {
    u = l.memoizedState, g = g(w, u), g = g == null ? u : ee({}, u, g), l.memoizedState = g, l.lanes === 0 && (l.updateQueue.baseState = g);
  }
  var Bp = { isMounted: function(l) {
    return (l = l._reactInternals) ? xe(l) === l : !1;
  }, enqueueSetState: function(l, u, g) {
    l = l._reactInternals;
    var w = Go(), N = Kr(l), F = yl(w, N);
    F.payload = u, g != null && (F.callback = g), u = ds(l, F, N), u !== null && (Wo(u, l, N, w), Vp(u, l, N));
  }, enqueueReplaceState: function(l, u, g) {
    l = l._reactInternals;
    var w = Go(), N = Kr(l), F = yl(w, N);
    F.tag = 1, F.payload = u, g != null && (F.callback = g), u = ds(l, F, N), u !== null && (Wo(u, l, N, w), Vp(u, l, N));
  }, enqueueForceUpdate: function(l, u) {
    l = l._reactInternals;
    var g = Go(), w = Kr(l), N = yl(g, w);
    N.tag = 2, u != null && (N.callback = u), u = ds(l, N, w), u !== null && (Wo(u, l, w, g), Vp(u, l, w));
  } };
  function NC(l, u, g, w, N, F, te) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(w, F, te) : u.prototype && u.prototype.isPureReactComponent ? !Dd(g, w) || !Dd(N, F) : !0;
  }
  function $C(l, u, g) {
    var w = !1, N = Vi, F = u.contextType;
    return typeof F == "object" && F !== null ? F = jr(F) : (N = wr(u) ? ca : sn.current, w = u.contextTypes, F = (w = w != null) ? Ka(l, N) : Vi), u = new u(g, F), l.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = Bp, l.stateNode = u, u._reactInternals = l, w && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = N, l.__reactInternalMemoizedMaskedChildContext = F), u;
  }
  function DC(l, u, g, w) {
    l = u.state, typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(g, w), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(g, w), u.state !== l && Bp.enqueueReplaceState(u, u.state, null);
  }
  function jp(l, u, g, w) {
    var N = l.stateNode;
    N.props = g, N.state = l.memoizedState, N.refs = IC, Vg(l);
    var F = u.contextType;
    typeof F == "object" && F !== null ? N.context = jr(F) : (F = wr(u) ? ca : sn.current, N.context = Ka(l, F)), N.state = l.memoizedState, F = u.getDerivedStateFromProps, typeof F == "function" && (jg(l, u, F, g), N.state = l.memoizedState), typeof u.getDerivedStateFromProps == "function" || typeof N.getSnapshotBeforeUpdate == "function" || typeof N.UNSAFE_componentWillMount != "function" && typeof N.componentWillMount != "function" || (u = N.state, typeof N.componentWillMount == "function" && N.componentWillMount(), typeof N.UNSAFE_componentWillMount == "function" && N.UNSAFE_componentWillMount(), u !== N.state && Bp.enqueueReplaceState(N, N.state, null), fs(l, g, N, w), N.state = l.memoizedState), typeof N.componentDidMount == "function" && (l.flags |= 4194308);
  }
  function cu(l, u, g) {
    if (l = g.ref, l !== null && typeof l != "function" && typeof l != "object") {
      if (g._owner) {
        if (g = g._owner, g) {
          if (g.tag !== 1)
            throw Error(o(309));
          var w = g.stateNode;
        }
        if (!w)
          throw Error(o(147, l));
        var N = w, F = "" + l;
        return u !== null && u.ref !== null && typeof u.ref == "function" && u.ref._stringRef === F ? u.ref : (u = function(te) {
          var ue = N.refs;
          ue === IC && (ue = N.refs = {}), te === null ? delete ue[F] : ue[F] = te;
        }, u._stringRef = F, u);
      }
      if (typeof l != "string")
        throw Error(o(284));
      if (!g._owner)
        throw Error(o(290, l));
    }
    return l;
  }
  function Hp(l, u) {
    throw l = Object.prototype.toString.call(u), Error(o(31, l === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : l));
  }
  function _C(l) {
    var u = l._init;
    return u(l._payload);
  }
  function AC(l) {
    function u(De, Re) {
      if (l) {
        var Ve = De.deletions;
        Ve === null ? (De.deletions = [Re], De.flags |= 16) : Ve.push(Re);
      }
    }
    function g(De, Re) {
      if (!l)
        return null;
      for (; Re !== null; )
        u(De, Re), Re = Re.sibling;
      return null;
    }
    function w(De, Re) {
      for (De = /* @__PURE__ */ new Map(); Re !== null; )
        Re.key !== null ? De.set(Re.key, Re) : De.set(Re.index, Re), Re = Re.sibling;
      return De;
    }
    function N(De, Re) {
      return De = Cs(De, Re), De.index = 0, De.sibling = null, De;
    }
    function F(De, Re, Ve) {
      return De.index = Ve, l ? (Ve = De.alternate, Ve !== null ? (Ve = Ve.index, Ve < Re ? (De.flags |= 2, Re) : Ve) : (De.flags |= 2, Re)) : (De.flags |= 1048576, Re);
    }
    function te(De) {
      return l && De.alternate === null && (De.flags |= 2), De;
    }
    function ue(De, Re, Ve, Tt) {
      return Re === null || Re.tag !== 6 ? (Re = df(Ve, De.mode, Tt), Re.return = De, Re) : (Re = N(Re, Ve), Re.return = De, Re);
    }
    function ye(De, Re, Ve, Tt) {
      var qt = Ve.type;
      return qt === A ? yt(De, Re, Ve.props.children, Tt, Ve.key) : Re !== null && (Re.elementType === qt || typeof qt == "object" && qt !== null && qt.$$typeof === X && _C(qt) === Re.type) ? (Tt = N(Re, Ve.props), Tt.ref = cu(De, Re, Ve), Tt.return = De, Tt) : (Tt = Sm(Ve.type, Ve.key, Ve.props, null, De.mode, Tt), Tt.ref = cu(De, Re, Ve), Tt.return = De, Tt);
    }
    function qe(De, Re, Ve, Tt) {
      return Re === null || Re.tag !== 4 || Re.stateNode.containerInfo !== Ve.containerInfo || Re.stateNode.implementation !== Ve.implementation ? (Re = wc(Ve, De.mode, Tt), Re.return = De, Re) : (Re = N(Re, Ve.children || []), Re.return = De, Re);
    }
    function yt(De, Re, Ve, Tt, qt) {
      return Re === null || Re.tag !== 7 ? (Re = xc(Ve, De.mode, Tt, qt), Re.return = De, Re) : (Re = N(Re, Ve), Re.return = De, Re);
    }
    function St(De, Re, Ve) {
      if (typeof Re == "string" && Re !== "" || typeof Re == "number")
        return Re = df("" + Re, De.mode, Ve), Re.return = De, Re;
      if (typeof Re == "object" && Re !== null) {
        switch (Re.$$typeof) {
          case V:
            return Ve = Sm(Re.type, Re.key, Re.props, null, De.mode, Ve), Ve.ref = cu(De, null, Re), Ve.return = De, Ve;
          case M:
            return Re = wc(Re, De.mode, Ve), Re.return = De, Re;
          case X:
            var Tt = Re._init;
            return St(De, Tt(Re._payload), Ve);
        }
        if (Ze(Re) || Z(Re))
          return Re = xc(Re, De.mode, Ve, null), Re.return = De, Re;
        Hp(De, Re);
      }
      return null;
    }
    function bt(De, Re, Ve, Tt) {
      var qt = Re !== null ? Re.key : null;
      if (typeof Ve == "string" && Ve !== "" || typeof Ve == "number")
        return qt !== null ? null : ue(De, Re, "" + Ve, Tt);
      if (typeof Ve == "object" && Ve !== null) {
        switch (Ve.$$typeof) {
          case V:
            return Ve.key === qt ? ye(De, Re, Ve, Tt) : null;
          case M:
            return Ve.key === qt ? qe(De, Re, Ve, Tt) : null;
          case X:
            return qt = Ve._init, bt(
              De,
              Re,
              qt(Ve._payload),
              Tt
            );
        }
        if (Ze(Ve) || Z(Ve))
          return qt !== null ? null : yt(De, Re, Ve, Tt, null);
        Hp(De, Ve);
      }
      return null;
    }
    function Mt(De, Re, Ve, Tt, qt) {
      if (typeof Tt == "string" && Tt !== "" || typeof Tt == "number")
        return De = De.get(Ve) || null, ue(Re, De, "" + Tt, qt);
      if (typeof Tt == "object" && Tt !== null) {
        switch (Tt.$$typeof) {
          case V:
            return De = De.get(Tt.key === null ? Ve : Tt.key) || null, ye(Re, De, Tt, qt);
          case M:
            return De = De.get(Tt.key === null ? Ve : Tt.key) || null, qe(Re, De, Tt, qt);
          case X:
            var Bt = Tt._init;
            return Mt(De, Re, Ve, Bt(Tt._payload), qt);
        }
        if (Ze(Tt) || Z(Tt))
          return De = De.get(Ve) || null, yt(Re, De, Tt, qt, null);
        Hp(Re, Tt);
      }
      return null;
    }
    function Vt(De, Re, Ve, Tt) {
      for (var qt = null, Bt = null, Zt = Re, cn = Re = 0, vo = null; Zt !== null && cn < Ve.length; cn++) {
        Zt.index > cn ? (vo = Zt, Zt = null) : vo = Zt.sibling;
        var _n = bt(De, Zt, Ve[cn], Tt);
        if (_n === null) {
          Zt === null && (Zt = vo);
          break;
        }
        l && Zt && _n.alternate === null && u(De, Zt), Re = F(_n, Re, cn), Bt === null ? qt = _n : Bt.sibling = _n, Bt = _n, Zt = vo;
      }
      if (cn === Ve.length)
        return g(De, Zt), gr && Ma(De, cn), qt;
      if (Zt === null) {
        for (; cn < Ve.length; cn++)
          Zt = St(De, Ve[cn], Tt), Zt !== null && (Re = F(Zt, Re, cn), Bt === null ? qt = Zt : Bt.sibling = Zt, Bt = Zt);
        return gr && Ma(De, cn), qt;
      }
      for (Zt = w(De, Zt); cn < Ve.length; cn++)
        vo = Mt(Zt, De, cn, Ve[cn], Tt), vo !== null && (l && vo.alternate !== null && Zt.delete(vo.key === null ? cn : vo.key), Re = F(vo, Re, cn), Bt === null ? qt = vo : Bt.sibling = vo, Bt = vo);
      return l && Zt.forEach(function(Ss) {
        return u(De, Ss);
      }), gr && Ma(De, cn), qt;
    }
    function Gt(De, Re, Ve, Tt) {
      var qt = Z(Ve);
      if (typeof qt != "function")
        throw Error(o(150));
      if (Ve = qt.call(Ve), Ve == null)
        throw Error(o(151));
      for (var Bt = qt = null, Zt = Re, cn = Re = 0, vo = null, _n = Ve.next(); Zt !== null && !_n.done; cn++, _n = Ve.next()) {
        Zt.index > cn ? (vo = Zt, Zt = null) : vo = Zt.sibling;
        var Ss = bt(De, Zt, _n.value, Tt);
        if (Ss === null) {
          Zt === null && (Zt = vo);
          break;
        }
        l && Zt && Ss.alternate === null && u(De, Zt), Re = F(Ss, Re, cn), Bt === null ? qt = Ss : Bt.sibling = Ss, Bt = Ss, Zt = vo;
      }
      if (_n.done)
        return g(
          De,
          Zt
        ), gr && Ma(De, cn), qt;
      if (Zt === null) {
        for (; !_n.done; cn++, _n = Ve.next())
          _n = St(De, _n.value, Tt), _n !== null && (Re = F(_n, Re, cn), Bt === null ? qt = _n : Bt.sibling = _n, Bt = _n);
        return gr && Ma(De, cn), qt;
      }
      for (Zt = w(De, Zt); !_n.done; cn++, _n = Ve.next())
        _n = Mt(Zt, De, cn, _n.value, Tt), _n !== null && (l && _n.alternate !== null && Zt.delete(_n.key === null ? cn : _n.key), Re = F(_n, Re, cn), Bt === null ? qt = _n : Bt.sibling = _n, Bt = _n);
      return l && Zt.forEach(function(Fw) {
        return u(De, Fw);
      }), gr && Ma(De, cn), qt;
    }
    function Hr(De, Re, Ve, Tt) {
      if (typeof Ve == "object" && Ve !== null && Ve.type === A && Ve.key === null && (Ve = Ve.props.children), typeof Ve == "object" && Ve !== null) {
        switch (Ve.$$typeof) {
          case V:
            e: {
              for (var qt = Ve.key, Bt = Re; Bt !== null; ) {
                if (Bt.key === qt) {
                  if (qt = Ve.type, qt === A) {
                    if (Bt.tag === 7) {
                      g(De, Bt.sibling), Re = N(Bt, Ve.props.children), Re.return = De, De = Re;
                      break e;
                    }
                  } else if (Bt.elementType === qt || typeof qt == "object" && qt !== null && qt.$$typeof === X && _C(qt) === Bt.type) {
                    g(De, Bt.sibling), Re = N(Bt, Ve.props), Re.ref = cu(De, Bt, Ve), Re.return = De, De = Re;
                    break e;
                  }
                  g(De, Bt);
                  break;
                } else
                  u(De, Bt);
                Bt = Bt.sibling;
              }
              Ve.type === A ? (Re = xc(Ve.props.children, De.mode, Tt, Ve.key), Re.return = De, De = Re) : (Tt = Sm(Ve.type, Ve.key, Ve.props, null, De.mode, Tt), Tt.ref = cu(De, Re, Ve), Tt.return = De, De = Tt);
            }
            return te(De);
          case M:
            e: {
              for (Bt = Ve.key; Re !== null; ) {
                if (Re.key === Bt)
                  if (Re.tag === 4 && Re.stateNode.containerInfo === Ve.containerInfo && Re.stateNode.implementation === Ve.implementation) {
                    g(De, Re.sibling), Re = N(Re, Ve.children || []), Re.return = De, De = Re;
                    break e;
                  } else {
                    g(De, Re);
                    break;
                  }
                else
                  u(De, Re);
                Re = Re.sibling;
              }
              Re = wc(Ve, De.mode, Tt), Re.return = De, De = Re;
            }
            return te(De);
          case X:
            return Bt = Ve._init, Hr(De, Re, Bt(Ve._payload), Tt);
        }
        if (Ze(Ve))
          return Vt(De, Re, Ve, Tt);
        if (Z(Ve))
          return Gt(De, Re, Ve, Tt);
        Hp(De, Ve);
      }
      return typeof Ve == "string" && Ve !== "" || typeof Ve == "number" ? (Ve = "" + Ve, Re !== null && Re.tag === 6 ? (g(De, Re.sibling), Re = N(Re, Ve), Re.return = De, De = Re) : (g(De, Re), Re = df(Ve, De.mode, Tt), Re.return = De, De = Re), te(De)) : g(De, Re);
    }
    return Hr;
  }
  var uu = AC(!0), LC = AC(!1), Wd = {}, Ri = gn(Wd), qd = gn(Wd), du = gn(Wd);
  function ac(l) {
    if (l === Wd)
      throw Error(o(174));
    return l;
  }
  function Hg(l, u) {
    switch (Un(du, u), Un(qd, l), Un(Ri, Wd), l = u.nodeType, l) {
      case 9:
      case 11:
        u = (u = u.documentElement) ? u.namespaceURI : ft(null, "");
        break;
      default:
        l = l === 8 ? u.parentNode : u, u = l.namespaceURI || null, l = l.tagName, u = ft(u, l);
    }
    jn(Ri), Un(Ri, u);
  }
  function ps() {
    jn(Ri), jn(qd), jn(du);
  }
  function tn(l) {
    ac(du.current);
    var u = ac(Ri.current), g = ft(u, l.type);
    u !== g && (Un(qd, l), Un(Ri, g));
  }
  function xn(l) {
    qd.current === l && (jn(Ri), jn(qd));
  }
  var nn = gn(0);
  function Rr(l) {
    for (var u = l; u !== null; ) {
      if (u.tag === 13) {
        var g = u.memoizedState;
        if (g !== null && (g = g.dehydrated, g === null || g.data === "$?" || g.data === "$!"))
          return u;
      } else if (u.tag === 19 && u.memoizedProps.revealOrder !== void 0) {
        if (u.flags & 128)
          return u;
      } else if (u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === l)
        break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === l)
          return null;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
    return null;
  }
  var Ja = [];
  function Up() {
    for (var l = 0; l < Ja.length; l++)
      Ja[l]._workInProgressVersionPrimary = null;
    Ja.length = 0;
  }
  var Gp = z.ReactCurrentDispatcher, Ug = z.ReactCurrentBatchConfig, ic = 0, vr = null, nt = null, Pn = null, on = !1, ji = !1, $a = 0, lc = 0;
  function br() {
    throw Error(o(321));
  }
  function sc(l, u) {
    if (u === null)
      return !1;
    for (var g = 0; g < u.length && g < l.length; g++)
      if (!qa(l[g], u[g]))
        return !1;
    return !0;
  }
  function ms(l, u, g, w, N, F) {
    if (ic = F, vr = u, u.memoizedState = null, u.updateQueue = null, u.lanes = 0, Gp.current = l === null || l.memoizedState === null ? Cw : Sw, l = g(w, N), ji) {
      F = 0;
      do {
        if (ji = !1, $a = 0, 25 <= F)
          throw Error(o(301));
        F += 1, Pn = nt = null, u.updateQueue = null, Gp.current = Wg, l = g(w, N);
      } while (ji);
    }
    if (Gp.current = lm, u = nt !== null && nt.next !== null, ic = 0, Pn = nt = vr = null, on = !1, u)
      throw Error(o(300));
    return l;
  }
  function cc() {
    var l = $a !== 0;
    return $a = 0, l;
  }
  function ei() {
    var l = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Pn === null ? vr.memoizedState = Pn = l : Pn = Pn.next = l, Pn;
  }
  function ma() {
    if (nt === null) {
      var l = vr.alternate;
      l = l !== null ? l.memoizedState : null;
    } else
      l = nt.next;
    var u = Pn === null ? vr.memoizedState : Pn.next;
    if (u !== null)
      Pn = u, nt = l;
    else {
      if (l === null)
        throw Error(o(310));
      nt = l, l = { memoizedState: nt.memoizedState, baseState: nt.baseState, baseQueue: nt.baseQueue, queue: nt.queue, next: null }, Pn === null ? vr.memoizedState = Pn = l : Pn = Pn.next = l;
    }
    return Pn;
  }
  function uc(l, u) {
    return typeof u == "function" ? u(l) : u;
  }
  function Yd(l) {
    var u = ma(), g = u.queue;
    if (g === null)
      throw Error(o(311));
    g.lastRenderedReducer = l;
    var w = nt, N = w.baseQueue, F = g.pending;
    if (F !== null) {
      if (N !== null) {
        var te = N.next;
        N.next = F.next, F.next = te;
      }
      w.baseQueue = N = F, g.pending = null;
    }
    if (N !== null) {
      F = N.next, w = w.baseState;
      var ue = te = null, ye = null, qe = F;
      do {
        var yt = qe.lane;
        if ((ic & yt) === yt)
          ye !== null && (ye = ye.next = { lane: 0, action: qe.action, hasEagerState: qe.hasEagerState, eagerState: qe.eagerState, next: null }), w = qe.hasEagerState ? qe.eagerState : l(w, qe.action);
        else {
          var St = {
            lane: yt,
            action: qe.action,
            hasEagerState: qe.hasEagerState,
            eagerState: qe.eagerState,
            next: null
          };
          ye === null ? (ue = ye = St, te = w) : ye = ye.next = St, vr.lanes |= yt, wl |= yt;
        }
        qe = qe.next;
      } while (qe !== null && qe !== F);
      ye === null ? te = w : ye.next = ue, qa(w, u.memoizedState) || (Yr = !0), u.memoizedState = w, u.baseState = te, u.baseQueue = ye, g.lastRenderedState = w;
    }
    if (l = g.interleaved, l !== null) {
      N = l;
      do
        F = N.lane, vr.lanes |= F, wl |= F, N = N.next;
      while (N !== l);
    } else
      N === null && (g.lanes = 0);
    return [u.memoizedState, g.dispatch];
  }
  function Kd(l) {
    var u = ma(), g = u.queue;
    if (g === null)
      throw Error(o(311));
    g.lastRenderedReducer = l;
    var w = g.dispatch, N = g.pending, F = u.memoizedState;
    if (N !== null) {
      g.pending = null;
      var te = N = N.next;
      do
        F = l(F, te.action), te = te.next;
      while (te !== N);
      qa(F, u.memoizedState) || (Yr = !0), u.memoizedState = F, u.baseQueue === null && (u.baseState = F), g.lastRenderedState = F;
    }
    return [F, w];
  }
  function Wp() {
  }
  function qp(l, u) {
    var g = vr, w = ma(), N = u(), F = !qa(w.memoizedState, N);
    if (F && (w.memoizedState = N, Yr = !0), w = w.queue, Xd(Xp.bind(null, g, w, l), [l]), w.getSnapshot !== u || F || Pn !== null && Pn.memoizedState.tag & 1) {
      if (g.flags |= 2048, dc(9, Kp.bind(null, g, w, N, u), void 0, null), kr === null)
        throw Error(o(349));
      ic & 30 || Yp(g, u, N);
    }
    return N;
  }
  function Yp(l, u, g) {
    l.flags |= 16384, l = { getSnapshot: u, value: g }, u = vr.updateQueue, u === null ? (u = { lastEffect: null, stores: null }, vr.updateQueue = u, u.stores = [l]) : (g = u.stores, g === null ? u.stores = [l] : g.push(l));
  }
  function Kp(l, u, g, w) {
    u.value = g, u.getSnapshot = w, Qp(u) && Zp(l);
  }
  function Xp(l, u, g) {
    return g(function() {
      Qp(u) && Zp(l);
    });
  }
  function Qp(l) {
    var u = l.getSnapshot;
    l = l.value;
    try {
      var g = u();
      return !qa(l, g);
    } catch {
      return !0;
    }
  }
  function Zp(l) {
    var u = bl(l, 1);
    u !== null && Wo(u, l, 1, -1);
  }
  function Jp(l) {
    var u = ei();
    return typeof l == "function" && (l = l()), u.memoizedState = u.baseState = l, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: uc, lastRenderedState: l }, u.queue = l, l = l.dispatch = im.bind(null, vr, l), [u.memoizedState, l];
  }
  function dc(l, u, g, w) {
    return l = { tag: l, create: u, destroy: g, deps: w, next: null }, u = vr.updateQueue, u === null ? (u = { lastEffect: null, stores: null }, vr.updateQueue = u, u.lastEffect = l.next = l) : (g = u.lastEffect, g === null ? u.lastEffect = l.next = l : (w = g.next, g.next = l, l.next = w, u.lastEffect = l)), l;
  }
  function em() {
    return ma().memoizedState;
  }
  function fc(l, u, g, w) {
    var N = ei();
    vr.flags |= l, N.memoizedState = dc(1 | u, g, void 0, w === void 0 ? null : w);
  }
  function Cl(l, u, g, w) {
    var N = ma();
    w = w === void 0 ? null : w;
    var F = void 0;
    if (nt !== null) {
      var te = nt.memoizedState;
      if (F = te.destroy, w !== null && sc(w, te.deps)) {
        N.memoizedState = dc(u, g, F, w);
        return;
      }
    }
    vr.flags |= l, N.memoizedState = dc(1 | u, g, F, w);
  }
  function tm(l, u) {
    return fc(8390656, 8, l, u);
  }
  function Xd(l, u) {
    return Cl(2048, 8, l, u);
  }
  function nm(l, u) {
    return Cl(4, 2, l, u);
  }
  function rm(l, u) {
    return Cl(4, 4, l, u);
  }
  function Gg(l, u) {
    if (typeof u == "function")
      return l = l(), u(l), function() {
        u(null);
      };
    if (u != null)
      return l = l(), u.current = l, function() {
        u.current = null;
      };
  }
  function fu(l, u, g) {
    return g = g != null ? g.concat([l]) : null, Cl(4, 4, Gg.bind(null, u, l), g);
  }
  function om() {
  }
  function pu(l, u) {
    var g = ma();
    u = u === void 0 ? null : u;
    var w = g.memoizedState;
    return w !== null && u !== null && sc(u, w[1]) ? w[0] : (g.memoizedState = [l, u], l);
  }
  function hs(l, u) {
    var g = ma();
    u = u === void 0 ? null : u;
    var w = g.memoizedState;
    return w !== null && u !== null && sc(u, w[1]) ? w[0] : (l = l(), g.memoizedState = [l, u], l);
  }
  function ha(l, u, g) {
    return ic & 21 ? (qa(g, u) || (g = mp(), vr.lanes |= g, wl |= g, l.baseState = !0), u) : (l.baseState && (l.baseState = !1, Yr = !0), l.memoizedState = g);
  }
  function yw(l, u) {
    var g = Yn;
    Yn = g !== 0 && 4 > g ? g : 4, l(!0);
    var w = Ug.transition;
    Ug.transition = {};
    try {
      l(!1), u();
    } finally {
      Yn = g, Ug.transition = w;
    }
  }
  function pr() {
    return ma().memoizedState;
  }
  function am(l, u, g) {
    var w = Kr(l);
    if (g = { lane: w, action: g, hasEagerState: !1, eagerState: null, next: null }, mu(l))
      Qd(u, g);
    else if (g = MC(l, u, g, w), g !== null) {
      var N = Go();
      Wo(g, l, w, N), FC(g, u, w);
    }
  }
  function im(l, u, g) {
    var w = Kr(l), N = { lane: w, action: g, hasEagerState: !1, eagerState: null, next: null };
    if (mu(l))
      Qd(u, N);
    else {
      var F = l.alternate;
      if (l.lanes === 0 && (F === null || F.lanes === 0) && (F = u.lastRenderedReducer, F !== null))
        try {
          var te = u.lastRenderedState, ue = F(te, g);
          if (N.hasEagerState = !0, N.eagerState = ue, qa(ue, te)) {
            var ye = u.interleaved;
            ye === null ? (N.next = N, zg(u)) : (N.next = ye.next, ye.next = N), u.interleaved = N;
            return;
          }
        } catch {
        } finally {
        }
      g = MC(l, u, N, w), g !== null && (N = Go(), Wo(g, l, w, N), FC(g, u, w));
    }
  }
  function mu(l) {
    var u = l.alternate;
    return l === vr || u !== null && u === vr;
  }
  function Qd(l, u) {
    ji = on = !0;
    var g = l.pending;
    g === null ? u.next = u : (u.next = g.next, g.next = u), l.pending = u;
  }
  function FC(l, u, g) {
    if (g & 4194240) {
      var w = u.lanes;
      w &= l.pendingLanes, g |= w, u.lanes = g, wd(l, g);
    }
  }
  var lm = { readContext: jr, useCallback: br, useContext: br, useEffect: br, useImperativeHandle: br, useInsertionEffect: br, useLayoutEffect: br, useMemo: br, useReducer: br, useRef: br, useState: br, useDebugValue: br, useDeferredValue: br, useTransition: br, useMutableSource: br, useSyncExternalStore: br, useId: br, unstable_isNewReconciler: !1 }, Cw = { readContext: jr, useCallback: function(l, u) {
    return ei().memoizedState = [l, u === void 0 ? null : u], l;
  }, useContext: jr, useEffect: tm, useImperativeHandle: function(l, u, g) {
    return g = g != null ? g.concat([l]) : null, fc(
      4194308,
      4,
      Gg.bind(null, u, l),
      g
    );
  }, useLayoutEffect: function(l, u) {
    return fc(4194308, 4, l, u);
  }, useInsertionEffect: function(l, u) {
    return fc(4, 2, l, u);
  }, useMemo: function(l, u) {
    var g = ei();
    return u = u === void 0 ? null : u, l = l(), g.memoizedState = [l, u], l;
  }, useReducer: function(l, u, g) {
    var w = ei();
    return u = g !== void 0 ? g(u) : u, w.memoizedState = w.baseState = u, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: l, lastRenderedState: u }, w.queue = l, l = l.dispatch = am.bind(null, vr, l), [w.memoizedState, l];
  }, useRef: function(l) {
    var u = ei();
    return l = { current: l }, u.memoizedState = l;
  }, useState: Jp, useDebugValue: om, useDeferredValue: function(l) {
    return ei().memoizedState = l;
  }, useTransition: function() {
    var l = Jp(!1), u = l[0];
    return l = yw.bind(null, l[1]), ei().memoizedState = l, [u, l];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(l, u, g) {
    var w = vr, N = ei();
    if (gr) {
      if (g === void 0)
        throw Error(o(407));
      g = g();
    } else {
      if (g = u(), kr === null)
        throw Error(o(349));
      ic & 30 || Yp(w, u, g);
    }
    N.memoizedState = g;
    var F = { value: g, getSnapshot: u };
    return N.queue = F, tm(Xp.bind(
      null,
      w,
      F,
      l
    ), [l]), w.flags |= 2048, dc(9, Kp.bind(null, w, F, g, u), void 0, null), g;
  }, useId: function() {
    var l = ei(), u = kr.identifierPrefix;
    if (gr) {
      var g = vl, w = Eo;
      g = (w & ~(1 << 32 - Ua(w) - 1)).toString(32) + g, u = ":" + u + "R" + g, g = $a++, 0 < g && (u += "H" + g.toString(32)), u += ":";
    } else
      g = lc++, u = ":" + u + "r" + g.toString(32) + ":";
    return l.memoizedState = u;
  }, unstable_isNewReconciler: !1 }, Sw = {
    readContext: jr,
    useCallback: pu,
    useContext: jr,
    useEffect: Xd,
    useImperativeHandle: fu,
    useInsertionEffect: nm,
    useLayoutEffect: rm,
    useMemo: hs,
    useReducer: Yd,
    useRef: em,
    useState: function() {
      return Yd(uc);
    },
    useDebugValue: om,
    useDeferredValue: function(l) {
      var u = ma();
      return ha(u, nt.memoizedState, l);
    },
    useTransition: function() {
      var l = Yd(uc)[0], u = ma().memoizedState;
      return [l, u];
    },
    useMutableSource: Wp,
    useSyncExternalStore: qp,
    useId: pr,
    unstable_isNewReconciler: !1
  }, Wg = { readContext: jr, useCallback: pu, useContext: jr, useEffect: Xd, useImperativeHandle: fu, useInsertionEffect: nm, useLayoutEffect: rm, useMemo: hs, useReducer: Kd, useRef: em, useState: function() {
    return Kd(uc);
  }, useDebugValue: om, useDeferredValue: function(l) {
    var u = ma();
    return nt === null ? u.memoizedState = l : ha(u, nt.memoizedState, l);
  }, useTransition: function() {
    var l = Kd(uc)[0], u = ma().memoizedState;
    return [l, u];
  }, useMutableSource: Wp, useSyncExternalStore: qp, useId: pr, unstable_isNewReconciler: !1 };
  function hu(l, u) {
    try {
      var g = "", w = u;
      do
        g += Ce(w), w = w.return;
      while (w);
      var N = g;
    } catch (F) {
      N = `
Error generating stack: ` + F.message + `
` + F.stack;
    }
    return { value: l, source: u, stack: N, digest: null };
  }
  function Zd(l, u, g) {
    return { value: l, source: null, stack: g ?? null, digest: u ?? null };
  }
  function sm(l, u) {
    try {
      console.error(u.value);
    } catch (g) {
      setTimeout(function() {
        throw g;
      });
    }
  }
  var xw = typeof WeakMap == "function" ? WeakMap : Map;
  function zC(l, u, g) {
    g = yl(-1, g), g.tag = 3, g.payload = { element: null };
    var w = u.value;
    return g.callback = function() {
      hm || (hm = !0, vc = w), sm(l, u);
    }, g;
  }
  function Jd(l, u, g) {
    g = yl(-1, g), g.tag = 3;
    var w = l.type.getDerivedStateFromError;
    if (typeof w == "function") {
      var N = u.value;
      g.payload = function() {
        return w(N);
      }, g.callback = function() {
        sm(l, u);
      };
    }
    var F = l.stateNode;
    return F !== null && typeof F.componentDidCatch == "function" && (g.callback = function() {
      sm(l, u), typeof w != "function" && (Gi === null ? Gi = /* @__PURE__ */ new Set([this]) : Gi.add(this));
      var te = u.stack;
      this.componentDidCatch(u.value, { componentStack: te !== null ? te : "" });
    }), g;
  }
  function VC(l, u, g) {
    var w = l.pingCache;
    if (w === null) {
      w = l.pingCache = new xw();
      var N = /* @__PURE__ */ new Set();
      w.set(u, N);
    } else
      N = w.get(u), N === void 0 && (N = /* @__PURE__ */ new Set(), w.set(u, N));
    N.has(g) || (N.add(g), l = Pw.bind(null, l, u, g), u.then(l, l));
  }
  function qg(l) {
    do {
      var u;
      if ((u = l.tag === 13) && (u = l.memoizedState, u = u !== null ? u.dehydrated !== null : !0), u)
        return l;
      l = l.return;
    } while (l !== null);
    return null;
  }
  function Yg(l, u, g, w, N) {
    return l.mode & 1 ? (l.flags |= 65536, l.lanes = N, l) : (l === u ? l.flags |= 65536 : (l.flags |= 128, g.flags |= 131072, g.flags &= -52805, g.tag === 1 && (g.alternate === null ? g.tag = 17 : (u = yl(-1, 1), u.tag = 2, ds(g, u, 1))), g.lanes |= 1), l);
  }
  var ww = z.ReactCurrentOwner, Yr = !1;
  function oo(l, u, g, w) {
    u.child = l === null ? LC(u, null, g, w) : uu(u, l.child, g, w);
  }
  function gs(l, u, g, w, N) {
    g = g.render;
    var F = u.ref;
    return Ot(u, N), w = ms(l, u, g, w, F, N), g = cc(), l !== null && !Yr ? (u.updateQueue = l.updateQueue, u.flags &= -2053, l.lanes &= ~N, Oo(l, u, N)) : (gr && g && Dp(u), u.flags |= 1, oo(l, u, w, N), u.child);
  }
  function cm(l, u, g, w, N) {
    if (l === null) {
      var F = g.type;
      return typeof F == "function" && !pv(F) && F.defaultProps === void 0 && g.compare === null && g.defaultProps === void 0 ? (u.tag = 15, u.type = F, ga(l, u, F, w, N)) : (l = Sm(g.type, null, w, u, u.mode, N), l.ref = u.ref, l.return = u, u.child = l);
    }
    if (F = l.child, !(l.lanes & N)) {
      var te = F.memoizedProps;
      if (g = g.compare, g = g !== null ? g : Dd, g(te, w) && l.ref === u.ref)
        return Oo(l, u, N);
    }
    return u.flags |= 1, l = Cs(F, w), l.ref = u.ref, l.return = u, u.child = l;
  }
  function ga(l, u, g, w, N) {
    if (l !== null) {
      var F = l.memoizedProps;
      if (Dd(F, w) && l.ref === u.ref)
        if (Yr = !1, u.pendingProps = w = F, (l.lanes & N) !== 0)
          l.flags & 131072 && (Yr = !0);
        else
          return u.lanes = l.lanes, Oo(l, u, N);
    }
    return gu(l, u, g, w, N);
  }
  function pc(l, u, g) {
    var w = u.pendingProps, N = w.children, F = l !== null ? l.memoizedState : null;
    if (w.mode === "hidden")
      if (!(u.mode & 1))
        u.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Un(xu, Da), Da |= g;
      else {
        if (!(g & 1073741824))
          return l = F !== null ? F.baseLanes | g : g, u.lanes = u.childLanes = 1073741824, u.memoizedState = { baseLanes: l, cachePool: null, transitions: null }, u.updateQueue = null, Un(xu, Da), Da |= l, null;
        u.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, w = F !== null ? F.baseLanes : g, Un(xu, Da), Da |= w;
      }
    else
      F !== null ? (w = F.baseLanes | g, u.memoizedState = null) : w = g, Un(xu, Da), Da |= w;
    return oo(l, u, N, g), u.child;
  }
  function vn(l, u) {
    var g = u.ref;
    (l === null && g !== null || l !== null && l.ref !== g) && (u.flags |= 512, u.flags |= 2097152);
  }
  function gu(l, u, g, w, N) {
    var F = wr(g) ? ca : sn.current;
    return F = Ka(u, F), Ot(u, N), g = ms(l, u, g, w, F, N), w = cc(), l !== null && !Yr ? (u.updateQueue = l.updateQueue, u.flags &= -2053, l.lanes &= ~N, Oo(l, u, N)) : (gr && w && Dp(u), u.flags |= 1, oo(l, u, g, N), u.child);
  }
  function Kg(l, u, g, w, N) {
    if (wr(g)) {
      var F = !0;
      $p(u);
    } else
      F = !1;
    if (Ot(u, N), u.stateNode === null)
      jo(l, u), $C(u, g, w), jp(u, g, w, N), w = !0;
    else if (l === null) {
      var te = u.stateNode, ue = u.memoizedProps;
      te.props = ue;
      var ye = te.context, qe = g.contextType;
      typeof qe == "object" && qe !== null ? qe = jr(qe) : (qe = wr(g) ? ca : sn.current, qe = Ka(u, qe));
      var yt = g.getDerivedStateFromProps, St = typeof yt == "function" || typeof te.getSnapshotBeforeUpdate == "function";
      St || typeof te.UNSAFE_componentWillReceiveProps != "function" && typeof te.componentWillReceiveProps != "function" || (ue !== w || ye !== qe) && DC(u, te, w, qe), us = !1;
      var bt = u.memoizedState;
      te.state = bt, fs(u, w, te, N), ye = u.memoizedState, ue !== w || bt !== ye || Lr.current || us ? (typeof yt == "function" && (jg(u, g, yt, w), ye = u.memoizedState), (ue = us || NC(u, g, ue, w, bt, ye, qe)) ? (St || typeof te.UNSAFE_componentWillMount != "function" && typeof te.componentWillMount != "function" || (typeof te.componentWillMount == "function" && te.componentWillMount(), typeof te.UNSAFE_componentWillMount == "function" && te.UNSAFE_componentWillMount()), typeof te.componentDidMount == "function" && (u.flags |= 4194308)) : (typeof te.componentDidMount == "function" && (u.flags |= 4194308), u.memoizedProps = w, u.memoizedState = ye), te.props = w, te.state = ye, te.context = qe, w = ue) : (typeof te.componentDidMount == "function" && (u.flags |= 4194308), w = !1);
    } else {
      te = u.stateNode, ro(l, u), ue = u.memoizedProps, qe = u.type === u.elementType ? ue : Na(u.type, ue), te.props = qe, St = u.pendingProps, bt = te.context, ye = g.contextType, typeof ye == "object" && ye !== null ? ye = jr(ye) : (ye = wr(g) ? ca : sn.current, ye = Ka(u, ye));
      var Mt = g.getDerivedStateFromProps;
      (yt = typeof Mt == "function" || typeof te.getSnapshotBeforeUpdate == "function") || typeof te.UNSAFE_componentWillReceiveProps != "function" && typeof te.componentWillReceiveProps != "function" || (ue !== St || bt !== ye) && DC(u, te, w, ye), us = !1, bt = u.memoizedState, te.state = bt, fs(u, w, te, N);
      var Vt = u.memoizedState;
      ue !== St || bt !== Vt || Lr.current || us ? (typeof Mt == "function" && (jg(u, g, Mt, w), Vt = u.memoizedState), (qe = us || NC(u, g, qe, w, bt, Vt, ye) || !1) ? (yt || typeof te.UNSAFE_componentWillUpdate != "function" && typeof te.componentWillUpdate != "function" || (typeof te.componentWillUpdate == "function" && te.componentWillUpdate(w, Vt, ye), typeof te.UNSAFE_componentWillUpdate == "function" && te.UNSAFE_componentWillUpdate(w, Vt, ye)), typeof te.componentDidUpdate == "function" && (u.flags |= 4), typeof te.getSnapshotBeforeUpdate == "function" && (u.flags |= 1024)) : (typeof te.componentDidUpdate != "function" || ue === l.memoizedProps && bt === l.memoizedState || (u.flags |= 4), typeof te.getSnapshotBeforeUpdate != "function" || ue === l.memoizedProps && bt === l.memoizedState || (u.flags |= 1024), u.memoizedProps = w, u.memoizedState = Vt), te.props = w, te.state = Vt, te.context = ye, w = qe) : (typeof te.componentDidUpdate != "function" || ue === l.memoizedProps && bt === l.memoizedState || (u.flags |= 4), typeof te.getSnapshotBeforeUpdate != "function" || ue === l.memoizedProps && bt === l.memoizedState || (u.flags |= 1024), w = !1);
    }
    return BC(l, u, g, w, F, N);
  }
  function BC(l, u, g, w, N, F) {
    vn(l, u);
    var te = (u.flags & 128) !== 0;
    if (!w && !te)
      return N && OC(u, g, !1), Oo(l, u, F);
    w = u.stateNode, ww.current = u;
    var ue = te && typeof g.getDerivedStateFromError != "function" ? null : w.render();
    return u.flags |= 1, l !== null && te ? (u.child = uu(u, l.child, null, F), u.child = uu(u, null, ue, F)) : oo(l, u, ue, F), u.memoizedState = w.state, N && OC(u, g, !0), u.child;
  }
  function jC(l) {
    var u = l.stateNode;
    u.pendingContext ? is(l, u.pendingContext, u.pendingContext !== u.context) : u.context && is(l, u.context, !1), Hg(l, u.containerInfo);
  }
  function um(l, u, g, w, N) {
    return Or(), Ag(N), u.flags |= 256, oo(l, u, g, w), u.child;
  }
  var mc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Xg(l) {
    return { baseLanes: l, cachePool: null, transitions: null };
  }
  function Qg(l, u, g) {
    var w = u.pendingProps, N = nn.current, F = !1, te = (u.flags & 128) !== 0, ue;
    if ((ue = te) || (ue = l !== null && l.memoizedState === null ? !1 : (N & 2) !== 0), ue ? (F = !0, u.flags &= -129) : (l === null || l.memoizedState !== null) && (N |= 1), Un(nn, N & 1), l === null)
      return Ap(u), l = u.memoizedState, l !== null && (l = l.dehydrated, l !== null) ? (u.mode & 1 ? l.data === "$!" ? u.lanes = 8 : u.lanes = 1073741824 : u.lanes = 1, null) : (te = w.children, l = w.fallback, F ? (w = u.mode, F = u.child, te = { mode: "hidden", children: te }, !(w & 1) && F !== null ? (F.childLanes = 0, F.pendingProps = te) : F = uf(te, w, 0, null), l = xc(l, w, g, null), F.return = u, l.return = u, F.sibling = l, u.child = F, u.child.memoizedState = Xg(g), u.memoizedState = mc, l) : Zg(u, te));
    if (N = l.memoizedState, N !== null && (ue = N.dehydrated, ue !== null))
      return Ew(l, u, te, w, ue, N, g);
    if (F) {
      F = w.fallback, te = u.mode, N = l.child, ue = N.sibling;
      var ye = { mode: "hidden", children: w.children };
      return !(te & 1) && u.child !== N ? (w = u.child, w.childLanes = 0, w.pendingProps = ye, u.deletions = null) : (w = Cs(N, ye), w.subtreeFlags = N.subtreeFlags & 14680064), ue !== null ? F = Cs(ue, F) : (F = xc(F, te, g, null), F.flags |= 2), F.return = u, w.return = u, w.sibling = F, u.child = w, w = F, F = u.child, te = l.child.memoizedState, te = te === null ? Xg(g) : { baseLanes: te.baseLanes | g, cachePool: null, transitions: te.transitions }, F.memoizedState = te, F.childLanes = l.childLanes & ~g, u.memoizedState = mc, w;
    }
    return F = l.child, l = F.sibling, w = Cs(F, { mode: "visible", children: w.children }), !(u.mode & 1) && (w.lanes = g), w.return = u, w.sibling = null, l !== null && (g = u.deletions, g === null ? (u.deletions = [l], u.flags |= 16) : g.push(l)), u.child = w, u.memoizedState = null, w;
  }
  function Zg(l, u) {
    return u = uf({ mode: "visible", children: u }, l.mode, 0, null), u.return = l, l.child = u;
  }
  function vu(l, u, g, w) {
    return w !== null && Ag(w), uu(u, l.child, null, g), l = Zg(u, u.pendingProps.children), l.flags |= 2, u.memoizedState = null, l;
  }
  function Ew(l, u, g, w, N, F, te) {
    if (g)
      return u.flags & 256 ? (u.flags &= -257, w = Zd(Error(o(422))), vu(l, u, te, w)) : u.memoizedState !== null ? (u.child = l.child, u.flags |= 128, null) : (F = w.fallback, N = u.mode, w = uf({ mode: "visible", children: w.children }, N, 0, null), F = xc(F, N, te, null), F.flags |= 2, w.return = u, F.return = u, w.sibling = F, u.child = w, u.mode & 1 && uu(u, l.child, null, te), u.child.memoizedState = Xg(te), u.memoizedState = mc, F);
    if (!(u.mode & 1))
      return vu(l, u, te, null);
    if (N.data === "$!") {
      if (w = N.nextSibling && N.nextSibling.dataset, w)
        var ue = w.dgst;
      return w = ue, F = Error(o(419)), w = Zd(F, w, void 0), vu(l, u, te, w);
    }
    if (ue = (te & l.childLanes) !== 0, Yr || ue) {
      if (w = kr, w !== null) {
        switch (te & -te) {
          case 4:
            N = 2;
            break;
          case 16:
            N = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            N = 32;
            break;
          case 536870912:
            N = 268435456;
            break;
          default:
            N = 0;
        }
        N = N & (w.suspendedLanes | te) ? 0 : N, N !== 0 && N !== F.retryLane && (F.retryLane = N, bl(l, N), Wo(w, l, N, -1));
      }
      return uv(), w = Zd(Error(o(421))), vu(l, u, te, w);
    }
    return N.data === "$?" ? (u.flags |= 128, u.child = l.child, u = Mw.bind(null, l), N._reactRetry = u, null) : (l = F.treeContext, pa = Oi(N.nextSibling), Ia = u, gr = !0, Za = null, l !== null && (fa[Bo++] = Eo, fa[Bo++] = vl, fa[Bo++] = Qa, Eo = l.id, vl = l.overflow, Qa = u), u = Zg(u, w.children), u.flags |= 4096, u);
  }
  function Jg(l, u, g) {
    l.lanes |= u;
    var w = l.alternate;
    w !== null && (w.lanes |= u), mo(l.return, u, g);
  }
  function dm(l, u, g, w, N) {
    var F = l.memoizedState;
    F === null ? l.memoizedState = { isBackwards: u, rendering: null, renderingStartTime: 0, last: w, tail: g, tailMode: N } : (F.isBackwards = u, F.rendering = null, F.renderingStartTime = 0, F.last = w, F.tail = g, F.tailMode = N);
  }
  function ev(l, u, g) {
    var w = u.pendingProps, N = w.revealOrder, F = w.tail;
    if (oo(l, u, w.children, g), w = nn.current, w & 2)
      w = w & 1 | 2, u.flags |= 128;
    else {
      if (l !== null && l.flags & 128)
        e:
          for (l = u.child; l !== null; ) {
            if (l.tag === 13)
              l.memoizedState !== null && Jg(l, g, u);
            else if (l.tag === 19)
              Jg(l, g, u);
            else if (l.child !== null) {
              l.child.return = l, l = l.child;
              continue;
            }
            if (l === u)
              break e;
            for (; l.sibling === null; ) {
              if (l.return === null || l.return === u)
                break e;
              l = l.return;
            }
            l.sibling.return = l.return, l = l.sibling;
          }
      w &= 1;
    }
    if (Un(nn, w), !(u.mode & 1))
      u.memoizedState = null;
    else
      switch (N) {
        case "forwards":
          for (g = u.child, N = null; g !== null; )
            l = g.alternate, l !== null && Rr(l) === null && (N = g), g = g.sibling;
          g = N, g === null ? (N = u.child, u.child = null) : (N = g.sibling, g.sibling = null), dm(u, !1, N, g, F);
          break;
        case "backwards":
          for (g = null, N = u.child, u.child = null; N !== null; ) {
            if (l = N.alternate, l !== null && Rr(l) === null) {
              u.child = N;
              break;
            }
            l = N.sibling, N.sibling = g, g = N, N = l;
          }
          dm(u, !0, g, null, F);
          break;
        case "together":
          dm(u, !1, null, null, void 0);
          break;
        default:
          u.memoizedState = null;
      }
    return u.child;
  }
  function jo(l, u) {
    !(u.mode & 1) && l !== null && (l.alternate = null, u.alternate = null, u.flags |= 2);
  }
  function Oo(l, u, g) {
    if (l !== null && (u.dependencies = l.dependencies), wl |= u.lanes, !(g & u.childLanes))
      return null;
    if (l !== null && u.child !== l.child)
      throw Error(o(153));
    if (u.child !== null) {
      for (l = u.child, g = Cs(l, l.pendingProps), u.child = g, g.return = u; l.sibling !== null; )
        l = l.sibling, g = g.sibling = Cs(l, l.pendingProps), g.return = u;
      g.sibling = null;
    }
    return u.child;
  }
  function Sl(l, u, g) {
    switch (u.tag) {
      case 3:
        jC(u), Or();
        break;
      case 5:
        tn(u);
        break;
      case 1:
        wr(u.type) && $p(u);
        break;
      case 4:
        Hg(u, u.stateNode.containerInfo);
        break;
      case 10:
        var w = u.type._context, N = u.memoizedProps.value;
        Un(Bi, w._currentValue), w._currentValue = N;
        break;
      case 13:
        if (w = u.memoizedState, w !== null)
          return w.dehydrated !== null ? (Un(nn, nn.current & 1), u.flags |= 128, null) : g & u.child.childLanes ? Qg(l, u, g) : (Un(nn, nn.current & 1), l = Oo(l, u, g), l !== null ? l.sibling : null);
        Un(nn, nn.current & 1);
        break;
      case 19:
        if (w = (g & u.childLanes) !== 0, l.flags & 128) {
          if (w)
            return ev(l, u, g);
          u.flags |= 128;
        }
        if (N = u.memoizedState, N !== null && (N.rendering = null, N.tail = null, N.lastEffect = null), Un(nn, nn.current), w)
          break;
        return null;
      case 22:
      case 23:
        return u.lanes = 0, pc(l, u, g);
    }
    return Oo(l, u, g);
  }
  var ef, hc, ti, ao;
  ef = function(l, u) {
    for (var g = u.child; g !== null; ) {
      if (g.tag === 5 || g.tag === 6)
        l.appendChild(g.stateNode);
      else if (g.tag !== 4 && g.child !== null) {
        g.child.return = g, g = g.child;
        continue;
      }
      if (g === u)
        break;
      for (; g.sibling === null; ) {
        if (g.return === null || g.return === u)
          return;
        g = g.return;
      }
      g.sibling.return = g.return, g = g.sibling;
    }
  }, hc = function() {
  }, ti = function(l, u, g, w) {
    var N = l.memoizedProps;
    if (N !== w) {
      l = u.stateNode, ac(Ri.current);
      var F = null;
      switch (g) {
        case "input":
          N = ce(l, N), w = ce(l, w), F = [];
          break;
        case "select":
          N = ee({}, N, { value: void 0 }), w = ee({}, w, { value: void 0 }), F = [];
          break;
        case "textarea":
          N = Be(l, N), w = Be(l, w), F = [];
          break;
        default:
          typeof N.onClick != "function" && typeof w.onClick == "function" && (l.onclick = Np);
      }
      gt(g, w);
      var te;
      g = null;
      for (qe in N)
        if (!w.hasOwnProperty(qe) && N.hasOwnProperty(qe) && N[qe] != null)
          if (qe === "style") {
            var ue = N[qe];
            for (te in ue)
              ue.hasOwnProperty(te) && (g || (g = {}), g[te] = "");
          } else
            qe !== "dangerouslySetInnerHTML" && qe !== "children" && qe !== "suppressContentEditableWarning" && qe !== "suppressHydrationWarning" && qe !== "autoFocus" && (s.hasOwnProperty(qe) ? F || (F = []) : (F = F || []).push(qe, null));
      for (qe in w) {
        var ye = w[qe];
        if (ue = N != null ? N[qe] : void 0, w.hasOwnProperty(qe) && ye !== ue && (ye != null || ue != null))
          if (qe === "style")
            if (ue) {
              for (te in ue)
                !ue.hasOwnProperty(te) || ye && ye.hasOwnProperty(te) || (g || (g = {}), g[te] = "");
              for (te in ye)
                ye.hasOwnProperty(te) && ue[te] !== ye[te] && (g || (g = {}), g[te] = ye[te]);
            } else
              g || (F || (F = []), F.push(
                qe,
                g
              )), g = ye;
          else
            qe === "dangerouslySetInnerHTML" ? (ye = ye ? ye.__html : void 0, ue = ue ? ue.__html : void 0, ye != null && ue !== ye && (F = F || []).push(qe, ye)) : qe === "children" ? typeof ye != "string" && typeof ye != "number" || (F = F || []).push(qe, "" + ye) : qe !== "suppressContentEditableWarning" && qe !== "suppressHydrationWarning" && (s.hasOwnProperty(qe) ? (ye != null && qe === "onScroll" && fr("scroll", l), F || ue === ye || (F = [])) : (F = F || []).push(qe, ye));
      }
      g && (F = F || []).push("style", g);
      var qe = F;
      (u.updateQueue = qe) && (u.flags |= 4);
    }
  }, ao = function(l, u, g, w) {
    g !== w && (u.flags |= 4);
  };
  function tf(l, u) {
    if (!gr)
      switch (l.tailMode) {
        case "hidden":
          u = l.tail;
          for (var g = null; u !== null; )
            u.alternate !== null && (g = u), u = u.sibling;
          g === null ? l.tail = null : g.sibling = null;
          break;
        case "collapsed":
          g = l.tail;
          for (var w = null; g !== null; )
            g.alternate !== null && (w = g), g = g.sibling;
          w === null ? u || l.tail === null ? l.tail = null : l.tail.sibling = null : w.sibling = null;
      }
  }
  function Ho(l) {
    var u = l.alternate !== null && l.alternate.child === l.child, g = 0, w = 0;
    if (u)
      for (var N = l.child; N !== null; )
        g |= N.lanes | N.childLanes, w |= N.subtreeFlags & 14680064, w |= N.flags & 14680064, N.return = l, N = N.sibling;
    else
      for (N = l.child; N !== null; )
        g |= N.lanes | N.childLanes, w |= N.subtreeFlags, w |= N.flags, N.return = l, N = N.sibling;
    return l.subtreeFlags |= w, l.childLanes = g, u;
  }
  function Tw(l, u, g) {
    var w = u.pendingProps;
    switch (Dg(u), u.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ho(u), null;
      case 1:
        return wr(u.type) && Xa(), Ho(u), null;
      case 3:
        return w = u.stateNode, ps(), jn(Lr), jn(sn), Up(), w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), (l === null || l.child === null) && (Lp(u) ? u.flags |= 4 : l === null || l.memoizedState.isDehydrated && !(u.flags & 256) || (u.flags |= 1024, Za !== null && (cf(Za), Za = null))), hc(l, u), Ho(u), null;
      case 5:
        xn(u);
        var N = ac(du.current);
        if (g = u.type, l !== null && u.stateNode != null)
          ti(l, u, g, w, N), l.ref !== u.ref && (u.flags |= 512, u.flags |= 2097152);
        else {
          if (!w) {
            if (u.stateNode === null)
              throw Error(o(166));
            return Ho(u), null;
          }
          if (l = ac(Ri.current), Lp(u)) {
            w = u.stateNode, g = u.type;
            var F = u.memoizedProps;
            switch (w[zi] = u, w[nc] = F, l = (u.mode & 1) !== 0, g) {
              case "dialog":
                fr("cancel", w), fr("close", w);
                break;
              case "iframe":
              case "object":
              case "embed":
                fr("load", w);
                break;
              case "video":
              case "audio":
                for (N = 0; N < Fd.length; N++)
                  fr(Fd[N], w);
                break;
              case "source":
                fr("error", w);
                break;
              case "img":
              case "image":
              case "link":
                fr(
                  "error",
                  w
                ), fr("load", w);
                break;
              case "details":
                fr("toggle", w);
                break;
              case "input":
                ge(w, F), fr("invalid", w);
                break;
              case "select":
                w._wrapperState = { wasMultiple: !!F.multiple }, fr("invalid", w);
                break;
              case "textarea":
                rt(w, F), fr("invalid", w);
            }
            gt(g, F), N = null;
            for (var te in F)
              if (F.hasOwnProperty(te)) {
                var ue = F[te];
                te === "children" ? typeof ue == "string" ? w.textContent !== ue && (F.suppressHydrationWarning !== !0 && Ip(w.textContent, ue, l), N = ["children", ue]) : typeof ue == "number" && w.textContent !== "" + ue && (F.suppressHydrationWarning !== !0 && Ip(
                  w.textContent,
                  ue,
                  l
                ), N = ["children", "" + ue]) : s.hasOwnProperty(te) && ue != null && te === "onScroll" && fr("scroll", w);
              }
            switch (g) {
              case "input":
                Pe(w), Qe(w, F, !0);
                break;
              case "textarea":
                Pe(w), We(w);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof F.onClick == "function" && (w.onclick = Np);
            }
            w = N, u.updateQueue = w, w !== null && (u.flags |= 4);
          } else {
            te = N.nodeType === 9 ? N : N.ownerDocument, l === "http://www.w3.org/1999/xhtml" && (l = ut(g)), l === "http://www.w3.org/1999/xhtml" ? g === "script" ? (l = te.createElement("div"), l.innerHTML = "<script><\/script>", l = l.removeChild(l.firstChild)) : typeof w.is == "string" ? l = te.createElement(g, { is: w.is }) : (l = te.createElement(g), g === "select" && (te = l, w.multiple ? te.multiple = !0 : w.size && (te.size = w.size))) : l = te.createElementNS(l, g), l[zi] = u, l[nc] = w, ef(l, u, !1, !1), u.stateNode = l;
            e: {
              switch (te = kt(g, w), g) {
                case "dialog":
                  fr("cancel", l), fr("close", l), N = w;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  fr("load", l), N = w;
                  break;
                case "video":
                case "audio":
                  for (N = 0; N < Fd.length; N++)
                    fr(Fd[N], l);
                  N = w;
                  break;
                case "source":
                  fr("error", l), N = w;
                  break;
                case "img":
                case "image":
                case "link":
                  fr(
                    "error",
                    l
                  ), fr("load", l), N = w;
                  break;
                case "details":
                  fr("toggle", l), N = w;
                  break;
                case "input":
                  ge(l, w), N = ce(l, w), fr("invalid", l);
                  break;
                case "option":
                  N = w;
                  break;
                case "select":
                  l._wrapperState = { wasMultiple: !!w.multiple }, N = ee({}, w, { value: void 0 }), fr("invalid", l);
                  break;
                case "textarea":
                  rt(l, w), N = Be(l, w), fr("invalid", l);
                  break;
                default:
                  N = w;
              }
              gt(g, N), ue = N;
              for (F in ue)
                if (ue.hasOwnProperty(F)) {
                  var ye = ue[F];
                  F === "style" ? vt(l, ye) : F === "dangerouslySetInnerHTML" ? (ye = ye ? ye.__html : void 0, ye != null && pt(l, ye)) : F === "children" ? typeof ye == "string" ? (g !== "textarea" || ye !== "") && At(l, ye) : typeof ye == "number" && At(l, "" + ye) : F !== "suppressContentEditableWarning" && F !== "suppressHydrationWarning" && F !== "autoFocus" && (s.hasOwnProperty(F) ? ye != null && F === "onScroll" && fr("scroll", l) : ye != null && _(l, F, ye, te));
                }
              switch (g) {
                case "input":
                  Pe(l), Qe(l, w, !1);
                  break;
                case "textarea":
                  Pe(l), We(l);
                  break;
                case "option":
                  w.value != null && l.setAttribute("value", "" + he(w.value));
                  break;
                case "select":
                  l.multiple = !!w.multiple, F = w.value, F != null ? Ge(l, !!w.multiple, F, !1) : w.defaultValue != null && Ge(
                    l,
                    !!w.multiple,
                    w.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof N.onClick == "function" && (l.onclick = Np);
              }
              switch (g) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  w = !!w.autoFocus;
                  break e;
                case "img":
                  w = !0;
                  break e;
                default:
                  w = !1;
              }
            }
            w && (u.flags |= 4);
          }
          u.ref !== null && (u.flags |= 512, u.flags |= 2097152);
        }
        return Ho(u), null;
      case 6:
        if (l && u.stateNode != null)
          ao(l, u, l.memoizedProps, w);
        else {
          if (typeof w != "string" && u.stateNode === null)
            throw Error(o(166));
          if (g = ac(du.current), ac(Ri.current), Lp(u)) {
            if (w = u.stateNode, g = u.memoizedProps, w[zi] = u, (F = w.nodeValue !== g) && (l = Ia, l !== null))
              switch (l.tag) {
                case 3:
                  Ip(w.nodeValue, g, (l.mode & 1) !== 0);
                  break;
                case 5:
                  l.memoizedProps.suppressHydrationWarning !== !0 && Ip(w.nodeValue, g, (l.mode & 1) !== 0);
              }
            F && (u.flags |= 4);
          } else
            w = (g.nodeType === 9 ? g : g.ownerDocument).createTextNode(w), w[zi] = u, u.stateNode = w;
        }
        return Ho(u), null;
      case 13:
        if (jn(nn), w = u.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (gr && pa !== null && u.mode & 1 && !(u.flags & 128))
            PC(), Or(), u.flags |= 98560, F = !1;
          else if (F = Lp(u), w !== null && w.dehydrated !== null) {
            if (l === null) {
              if (!F)
                throw Error(o(318));
              if (F = u.memoizedState, F = F !== null ? F.dehydrated : null, !F)
                throw Error(o(317));
              F[zi] = u;
            } else
              Or(), !(u.flags & 128) && (u.memoizedState = null), u.flags |= 4;
            Ho(u), F = !1;
          } else
            Za !== null && (cf(Za), Za = null), F = !0;
          if (!F)
            return u.flags & 65536 ? u : null;
        }
        return u.flags & 128 ? (u.lanes = g, u) : (w = w !== null, w !== (l !== null && l.memoizedState !== null) && w && (u.child.flags |= 8192, u.mode & 1 && (l === null || nn.current & 1 ? lo === 0 && (lo = 3) : uv())), u.updateQueue !== null && (u.flags |= 4), Ho(u), null);
      case 4:
        return ps(), hc(l, u), l === null && iu(u.stateNode.containerInfo), Ho(u), null;
      case 10:
        return cs(u.type._context), Ho(u), null;
      case 17:
        return wr(u.type) && Xa(), Ho(u), null;
      case 19:
        if (jn(nn), F = u.memoizedState, F === null)
          return Ho(u), null;
        if (w = (u.flags & 128) !== 0, te = F.rendering, te === null)
          if (w)
            tf(F, !1);
          else {
            if (lo !== 0 || l !== null && l.flags & 128)
              for (l = u.child; l !== null; ) {
                if (te = Rr(l), te !== null) {
                  for (u.flags |= 128, tf(F, !1), w = te.updateQueue, w !== null && (u.updateQueue = w, u.flags |= 4), u.subtreeFlags = 0, w = g, g = u.child; g !== null; )
                    F = g, l = w, F.flags &= 14680066, te = F.alternate, te === null ? (F.childLanes = 0, F.lanes = l, F.child = null, F.subtreeFlags = 0, F.memoizedProps = null, F.memoizedState = null, F.updateQueue = null, F.dependencies = null, F.stateNode = null) : (F.childLanes = te.childLanes, F.lanes = te.lanes, F.child = te.child, F.subtreeFlags = 0, F.deletions = null, F.memoizedProps = te.memoizedProps, F.memoizedState = te.memoizedState, F.updateQueue = te.updateQueue, F.type = te.type, l = te.dependencies, F.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }), g = g.sibling;
                  return Un(nn, nn.current & 1 | 2), u.child;
                }
                l = l.sibling;
              }
            F.tail !== null && An() > Eu && (u.flags |= 128, w = !0, tf(F, !1), u.lanes = 4194304);
          }
        else {
          if (!w)
            if (l = Rr(te), l !== null) {
              if (u.flags |= 128, w = !0, g = l.updateQueue, g !== null && (u.updateQueue = g, u.flags |= 4), tf(F, !0), F.tail === null && F.tailMode === "hidden" && !te.alternate && !gr)
                return Ho(u), null;
            } else
              2 * An() - F.renderingStartTime > Eu && g !== 1073741824 && (u.flags |= 128, w = !0, tf(F, !1), u.lanes = 4194304);
          F.isBackwards ? (te.sibling = u.child, u.child = te) : (g = F.last, g !== null ? g.sibling = te : u.child = te, F.last = te);
        }
        return F.tail !== null ? (u = F.tail, F.rendering = u, F.tail = u.sibling, F.renderingStartTime = An(), u.sibling = null, g = nn.current, Un(nn, w ? g & 1 | 2 : g & 1), u) : (Ho(u), null);
      case 22:
      case 23:
        return cv(), w = u.memoizedState !== null, l !== null && l.memoizedState !== null !== w && (u.flags |= 8192), w && u.mode & 1 ? Da & 1073741824 && (Ho(u), u.subtreeFlags & 6 && (u.flags |= 8192)) : Ho(u), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(o(156, u.tag));
  }
  function tv(l, u) {
    switch (Dg(u), u.tag) {
      case 1:
        return wr(u.type) && Xa(), l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 3:
        return ps(), jn(Lr), jn(sn), Up(), l = u.flags, l & 65536 && !(l & 128) ? (u.flags = l & -65537 | 128, u) : null;
      case 5:
        return xn(u), null;
      case 13:
        if (jn(nn), l = u.memoizedState, l !== null && l.dehydrated !== null) {
          if (u.alternate === null)
            throw Error(o(340));
          Or();
        }
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 19:
        return jn(nn), null;
      case 4:
        return ps(), null;
      case 10:
        return cs(u.type._context), null;
      case 22:
      case 23:
        return cv(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var nf = !1, io = !1, HC = typeof WeakSet == "function" ? WeakSet : Set, Ft = null;
  function bu(l, u) {
    var g = l.ref;
    if (g !== null)
      if (typeof g == "function")
        try {
          g(null);
        } catch (w) {
          zr(l, u, w);
        }
      else
        g.current = null;
  }
  function rf(l, u, g) {
    try {
      g();
    } catch (w) {
      zr(l, u, w);
    }
  }
  var UC = !1;
  function GC(l, u) {
    if (Og = Ks, l = Op(), pl(l)) {
      if ("selectionStart" in l)
        var g = { start: l.selectionStart, end: l.selectionEnd };
      else
        e: {
          g = (g = l.ownerDocument) && g.defaultView || window;
          var w = g.getSelection && g.getSelection();
          if (w && w.rangeCount !== 0) {
            g = w.anchorNode;
            var N = w.anchorOffset, F = w.focusNode;
            w = w.focusOffset;
            try {
              g.nodeType, F.nodeType;
            } catch {
              g = null;
              break e;
            }
            var te = 0, ue = -1, ye = -1, qe = 0, yt = 0, St = l, bt = null;
            t:
              for (; ; ) {
                for (var Mt; St !== g || N !== 0 && St.nodeType !== 3 || (ue = te + N), St !== F || w !== 0 && St.nodeType !== 3 || (ye = te + w), St.nodeType === 3 && (te += St.nodeValue.length), (Mt = St.firstChild) !== null; )
                  bt = St, St = Mt;
                for (; ; ) {
                  if (St === l)
                    break t;
                  if (bt === g && ++qe === N && (ue = te), bt === F && ++yt === w && (ye = te), (Mt = St.nextSibling) !== null)
                    break;
                  St = bt, bt = St.parentNode;
                }
                St = Mt;
              }
            g = ue === -1 || ye === -1 ? null : { start: ue, end: ye };
          } else
            g = null;
        }
      g = g || { start: 0, end: 0 };
    } else
      g = null;
    for (ec = { focusedElem: l, selectionRange: g }, Ks = !1, Ft = u; Ft !== null; )
      if (u = Ft, l = u.child, (u.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = u, Ft = l;
      else
        for (; Ft !== null; ) {
          u = Ft;
          try {
            var Vt = u.alternate;
            if (u.flags & 1024)
              switch (u.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Vt !== null) {
                    var Gt = Vt.memoizedProps, Hr = Vt.memoizedState, De = u.stateNode, Re = De.getSnapshotBeforeUpdate(u.elementType === u.type ? Gt : Na(u.type, Gt), Hr);
                    De.__reactInternalSnapshotBeforeUpdate = Re;
                  }
                  break;
                case 3:
                  var Ve = u.stateNode.containerInfo;
                  Ve.nodeType === 1 ? Ve.textContent = "" : Ve.nodeType === 9 && Ve.documentElement && Ve.removeChild(Ve.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(o(163));
              }
          } catch (Tt) {
            zr(u, u.return, Tt);
          }
          if (l = u.sibling, l !== null) {
            l.return = u.return, Ft = l;
            break;
          }
          Ft = u.return;
        }
    return Vt = UC, UC = !1, Vt;
  }
  function of(l, u, g) {
    var w = u.updateQueue;
    if (w = w !== null ? w.lastEffect : null, w !== null) {
      var N = w = w.next;
      do {
        if ((N.tag & l) === l) {
          var F = N.destroy;
          N.destroy = void 0, F !== void 0 && rf(u, g, F);
        }
        N = N.next;
      } while (N !== w);
    }
  }
  function af(l, u) {
    if (u = u.updateQueue, u = u !== null ? u.lastEffect : null, u !== null) {
      var g = u = u.next;
      do {
        if ((g.tag & l) === l) {
          var w = g.create;
          g.destroy = w();
        }
        g = g.next;
      } while (g !== u);
    }
  }
  function nv(l) {
    var u = l.ref;
    if (u !== null) {
      var g = l.stateNode;
      switch (l.tag) {
        case 5:
          l = g;
          break;
        default:
          l = g;
      }
      typeof u == "function" ? u(l) : u.current = l;
    }
  }
  function rv(l) {
    var u = l.alternate;
    u !== null && (l.alternate = null, rv(u)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (u = l.stateNode, u !== null && (delete u[zi], delete u[nc], delete u[Pg], delete u[bw], delete u[Mg])), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  function WC(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 4;
  }
  function fm(l) {
    e:
      for (; ; ) {
        for (; l.sibling === null; ) {
          if (l.return === null || WC(l.return))
            return null;
          l = l.return;
        }
        for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
          if (l.flags & 2 || l.child === null || l.tag === 4)
            continue e;
          l.child.return = l, l = l.child;
        }
        if (!(l.flags & 2))
          return l.stateNode;
      }
  }
  function yu(l, u, g) {
    var w = l.tag;
    if (w === 5 || w === 6)
      l = l.stateNode, u ? g.nodeType === 8 ? g.parentNode.insertBefore(l, u) : g.insertBefore(l, u) : (g.nodeType === 8 ? (u = g.parentNode, u.insertBefore(l, g)) : (u = g, u.appendChild(l)), g = g._reactRootContainer, g != null || u.onclick !== null || (u.onclick = Np));
    else if (w !== 4 && (l = l.child, l !== null))
      for (yu(l, u, g), l = l.sibling; l !== null; )
        yu(l, u, g), l = l.sibling;
  }
  function Hi(l, u, g) {
    var w = l.tag;
    if (w === 5 || w === 6)
      l = l.stateNode, u ? g.insertBefore(l, u) : g.appendChild(l);
    else if (w !== 4 && (l = l.child, l !== null))
      for (Hi(l, u, g), l = l.sibling; l !== null; )
        Hi(l, u, g), l = l.sibling;
  }
  var Er = null, ho = !1;
  function ni(l, u, g) {
    for (g = g.child; g !== null; )
      Cu(l, u, g), g = g.sibling;
  }
  function Cu(l, u, g) {
    if (Si && typeof Si.onCommitFiberUnmount == "function")
      try {
        Si.onCommitFiberUnmount(xd, g);
      } catch {
      }
    switch (g.tag) {
      case 5:
        io || bu(g, u);
      case 6:
        var w = Er, N = ho;
        Er = null, ni(l, u, g), Er = w, ho = N, Er !== null && (ho ? (l = Er, g = g.stateNode, l.nodeType === 8 ? l.parentNode.removeChild(g) : l.removeChild(g)) : Er.removeChild(g.stateNode));
        break;
      case 18:
        Er !== null && (ho ? (l = Er, g = g.stateNode, l.nodeType === 8 ? rs(l.parentNode, g) : l.nodeType === 1 && rs(l, g), Rd(l)) : rs(Er, g.stateNode));
        break;
      case 4:
        w = Er, N = ho, Er = g.stateNode.containerInfo, ho = !0, ni(l, u, g), Er = w, ho = N;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!io && (w = g.updateQueue, w !== null && (w = w.lastEffect, w !== null))) {
          N = w = w.next;
          do {
            var F = N, te = F.destroy;
            F = F.tag, te !== void 0 && (F & 2 || F & 4) && rf(g, u, te), N = N.next;
          } while (N !== w);
        }
        ni(l, u, g);
        break;
      case 1:
        if (!io && (bu(g, u), w = g.stateNode, typeof w.componentWillUnmount == "function"))
          try {
            w.props = g.memoizedProps, w.state = g.memoizedState, w.componentWillUnmount();
          } catch (ue) {
            zr(g, u, ue);
          }
        ni(l, u, g);
        break;
      case 21:
        ni(l, u, g);
        break;
      case 22:
        g.mode & 1 ? (io = (w = io) || g.memoizedState !== null, ni(l, u, g), io = w) : ni(l, u, g);
        break;
      default:
        ni(l, u, g);
    }
  }
  function xl(l) {
    var u = l.updateQueue;
    if (u !== null) {
      l.updateQueue = null;
      var g = l.stateNode;
      g === null && (g = l.stateNode = new HC()), u.forEach(function(w) {
        var N = Iw.bind(null, l, w);
        g.has(w) || (g.add(w), w.then(N, N));
      });
    }
  }
  function ki(l, u) {
    var g = u.deletions;
    if (g !== null)
      for (var w = 0; w < g.length; w++) {
        var N = g[w];
        try {
          var F = l, te = u, ue = te;
          e:
            for (; ue !== null; ) {
              switch (ue.tag) {
                case 5:
                  Er = ue.stateNode, ho = !1;
                  break e;
                case 3:
                  Er = ue.stateNode.containerInfo, ho = !0;
                  break e;
                case 4:
                  Er = ue.stateNode.containerInfo, ho = !0;
                  break e;
              }
              ue = ue.return;
            }
          if (Er === null)
            throw Error(o(160));
          Cu(F, te, N), Er = null, ho = !1;
          var ye = N.alternate;
          ye !== null && (ye.return = null), N.return = null;
        } catch (qe) {
          zr(N, u, qe);
        }
      }
    if (u.subtreeFlags & 12854)
      for (u = u.child; u !== null; )
        qC(u, l), u = u.sibling;
  }
  function qC(l, u) {
    var g = l.alternate, w = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ki(u, l), Ui(l), w & 4) {
          try {
            of(3, l, l.return), af(3, l);
          } catch (Gt) {
            zr(l, l.return, Gt);
          }
          try {
            of(5, l, l.return);
          } catch (Gt) {
            zr(l, l.return, Gt);
          }
        }
        break;
      case 1:
        ki(u, l), Ui(l), w & 512 && g !== null && bu(g, g.return);
        break;
      case 5:
        if (ki(u, l), Ui(l), w & 512 && g !== null && bu(g, g.return), l.flags & 32) {
          var N = l.stateNode;
          try {
            At(N, "");
          } catch (Gt) {
            zr(l, l.return, Gt);
          }
        }
        if (w & 4 && (N = l.stateNode, N != null)) {
          var F = l.memoizedProps, te = g !== null ? g.memoizedProps : F, ue = l.type, ye = l.updateQueue;
          if (l.updateQueue = null, ye !== null)
            try {
              ue === "input" && F.type === "radio" && F.name != null && we(N, F), kt(ue, te);
              var qe = kt(ue, F);
              for (te = 0; te < ye.length; te += 2) {
                var yt = ye[te], St = ye[te + 1];
                yt === "style" ? vt(N, St) : yt === "dangerouslySetInnerHTML" ? pt(N, St) : yt === "children" ? At(N, St) : _(N, yt, St, qe);
              }
              switch (ue) {
                case "input":
                  Me(N, F);
                  break;
                case "textarea":
                  wt(N, F);
                  break;
                case "select":
                  var bt = N._wrapperState.wasMultiple;
                  N._wrapperState.wasMultiple = !!F.multiple;
                  var Mt = F.value;
                  Mt != null ? Ge(N, !!F.multiple, Mt, !1) : bt !== !!F.multiple && (F.defaultValue != null ? Ge(
                    N,
                    !!F.multiple,
                    F.defaultValue,
                    !0
                  ) : Ge(N, !!F.multiple, F.multiple ? [] : "", !1));
              }
              N[nc] = F;
            } catch (Gt) {
              zr(l, l.return, Gt);
            }
        }
        break;
      case 6:
        if (ki(u, l), Ui(l), w & 4) {
          if (l.stateNode === null)
            throw Error(o(162));
          N = l.stateNode, F = l.memoizedProps;
          try {
            N.nodeValue = F;
          } catch (Gt) {
            zr(l, l.return, Gt);
          }
        }
        break;
      case 3:
        if (ki(u, l), Ui(l), w & 4 && g !== null && g.memoizedState.isDehydrated)
          try {
            Rd(u.containerInfo);
          } catch (Gt) {
            zr(l, l.return, Gt);
          }
        break;
      case 4:
        ki(u, l), Ui(l);
        break;
      case 13:
        ki(u, l), Ui(l), N = l.child, N.flags & 8192 && (F = N.memoizedState !== null, N.stateNode.isHidden = F, !F || N.alternate !== null && N.alternate.memoizedState !== null || (iv = An())), w & 4 && xl(l);
        break;
      case 22:
        if (yt = g !== null && g.memoizedState !== null, l.mode & 1 ? (io = (qe = io) || yt, ki(u, l), io = qe) : ki(u, l), Ui(l), w & 8192) {
          if (qe = l.memoizedState !== null, (l.stateNode.isHidden = qe) && !yt && l.mode & 1)
            for (Ft = l, yt = l.child; yt !== null; ) {
              for (St = Ft = yt; Ft !== null; ) {
                switch (bt = Ft, Mt = bt.child, bt.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    of(4, bt, bt.return);
                    break;
                  case 1:
                    bu(bt, bt.return);
                    var Vt = bt.stateNode;
                    if (typeof Vt.componentWillUnmount == "function") {
                      w = bt, g = bt.return;
                      try {
                        u = w, Vt.props = u.memoizedProps, Vt.state = u.memoizedState, Vt.componentWillUnmount();
                      } catch (Gt) {
                        zr(w, g, Gt);
                      }
                    }
                    break;
                  case 5:
                    bu(bt, bt.return);
                    break;
                  case 22:
                    if (bt.memoizedState !== null) {
                      ov(St);
                      continue;
                    }
                }
                Mt !== null ? (Mt.return = bt, Ft = Mt) : ov(St);
              }
              yt = yt.sibling;
            }
          e:
            for (yt = null, St = l; ; ) {
              if (St.tag === 5) {
                if (yt === null) {
                  yt = St;
                  try {
                    N = St.stateNode, qe ? (F = N.style, typeof F.setProperty == "function" ? F.setProperty("display", "none", "important") : F.display = "none") : (ue = St.stateNode, ye = St.memoizedProps.style, te = ye != null && ye.hasOwnProperty("display") ? ye.display : null, ue.style.display = _e("display", te));
                  } catch (Gt) {
                    zr(l, l.return, Gt);
                  }
                }
              } else if (St.tag === 6) {
                if (yt === null)
                  try {
                    St.stateNode.nodeValue = qe ? "" : St.memoizedProps;
                  } catch (Gt) {
                    zr(l, l.return, Gt);
                  }
              } else if ((St.tag !== 22 && St.tag !== 23 || St.memoizedState === null || St === l) && St.child !== null) {
                St.child.return = St, St = St.child;
                continue;
              }
              if (St === l)
                break e;
              for (; St.sibling === null; ) {
                if (St.return === null || St.return === l)
                  break e;
                yt === St && (yt = null), St = St.return;
              }
              yt === St && (yt = null), St.sibling.return = St.return, St = St.sibling;
            }
        }
        break;
      case 19:
        ki(u, l), Ui(l), w & 4 && xl(l);
        break;
      case 21:
        break;
      default:
        ki(
          u,
          l
        ), Ui(l);
    }
  }
  function Ui(l) {
    var u = l.flags;
    if (u & 2) {
      try {
        e: {
          for (var g = l.return; g !== null; ) {
            if (WC(g)) {
              var w = g;
              break e;
            }
            g = g.return;
          }
          throw Error(o(160));
        }
        switch (w.tag) {
          case 5:
            var N = w.stateNode;
            w.flags & 32 && (At(N, ""), w.flags &= -33);
            var F = fm(l);
            Hi(l, F, N);
            break;
          case 3:
          case 4:
            var te = w.stateNode.containerInfo, ue = fm(l);
            yu(l, ue, te);
            break;
          default:
            throw Error(o(161));
        }
      } catch (ye) {
        zr(l, l.return, ye);
      }
      l.flags &= -3;
    }
    u & 4096 && (l.flags &= -4097);
  }
  function YC(l, u, g) {
    Ft = l, Su(l);
  }
  function Su(l, u, g) {
    for (var w = (l.mode & 1) !== 0; Ft !== null; ) {
      var N = Ft, F = N.child;
      if (N.tag === 22 && w) {
        var te = N.memoizedState !== null || nf;
        if (!te) {
          var ue = N.alternate, ye = ue !== null && ue.memoizedState !== null || io;
          ue = nf;
          var qe = io;
          if (nf = te, (io = ye) && !qe)
            for (Ft = N; Ft !== null; )
              te = Ft, ye = te.child, te.tag === 22 && te.memoizedState !== null ? XC(N) : ye !== null ? (ye.return = te, Ft = ye) : XC(N);
          for (; F !== null; )
            Ft = F, Su(F), F = F.sibling;
          Ft = N, nf = ue, io = qe;
        }
        KC(l);
      } else
        N.subtreeFlags & 8772 && F !== null ? (F.return = N, Ft = F) : KC(l);
    }
  }
  function KC(l) {
    for (; Ft !== null; ) {
      var u = Ft;
      if (u.flags & 8772) {
        var g = u.alternate;
        try {
          if (u.flags & 8772)
            switch (u.tag) {
              case 0:
              case 11:
              case 15:
                io || af(5, u);
                break;
              case 1:
                var w = u.stateNode;
                if (u.flags & 4 && !io)
                  if (g === null)
                    w.componentDidMount();
                  else {
                    var N = u.elementType === u.type ? g.memoizedProps : Na(u.type, g.memoizedProps);
                    w.componentDidUpdate(N, g.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                  }
                var F = u.updateQueue;
                F !== null && oc(u, F, w);
                break;
              case 3:
                var te = u.updateQueue;
                if (te !== null) {
                  if (g = null, u.child !== null)
                    switch (u.child.tag) {
                      case 5:
                        g = u.child.stateNode;
                        break;
                      case 1:
                        g = u.child.stateNode;
                    }
                  oc(u, te, g);
                }
                break;
              case 5:
                var ue = u.stateNode;
                if (g === null && u.flags & 4) {
                  g = ue;
                  var ye = u.memoizedProps;
                  switch (u.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      ye.autoFocus && g.focus();
                      break;
                    case "img":
                      ye.src && (g.src = ye.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (u.memoizedState === null) {
                  var qe = u.alternate;
                  if (qe !== null) {
                    var yt = qe.memoizedState;
                    if (yt !== null) {
                      var St = yt.dehydrated;
                      St !== null && Rd(St);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(o(163));
            }
          io || u.flags & 512 && nv(u);
        } catch (bt) {
          zr(u, u.return, bt);
        }
      }
      if (u === l) {
        Ft = null;
        break;
      }
      if (g = u.sibling, g !== null) {
        g.return = u.return, Ft = g;
        break;
      }
      Ft = u.return;
    }
  }
  function ov(l) {
    for (; Ft !== null; ) {
      var u = Ft;
      if (u === l) {
        Ft = null;
        break;
      }
      var g = u.sibling;
      if (g !== null) {
        g.return = u.return, Ft = g;
        break;
      }
      Ft = u.return;
    }
  }
  function XC(l) {
    for (; Ft !== null; ) {
      var u = Ft;
      try {
        switch (u.tag) {
          case 0:
          case 11:
          case 15:
            var g = u.return;
            try {
              af(4, u);
            } catch (ye) {
              zr(u, g, ye);
            }
            break;
          case 1:
            var w = u.stateNode;
            if (typeof w.componentDidMount == "function") {
              var N = u.return;
              try {
                w.componentDidMount();
              } catch (ye) {
                zr(u, N, ye);
              }
            }
            var F = u.return;
            try {
              nv(u);
            } catch (ye) {
              zr(u, F, ye);
            }
            break;
          case 5:
            var te = u.return;
            try {
              nv(u);
            } catch (ye) {
              zr(u, te, ye);
            }
        }
      } catch (ye) {
        zr(u, u.return, ye);
      }
      if (u === l) {
        Ft = null;
        break;
      }
      var ue = u.sibling;
      if (ue !== null) {
        ue.return = u.return, Ft = ue;
        break;
      }
      Ft = u.return;
    }
  }
  var pm = Math.ceil, lf = z.ReactCurrentDispatcher, av = z.ReactCurrentOwner, Uo = z.ReactCurrentBatchConfig, Rn = 0, kr = null, Fr = null, go = 0, Da = 0, xu = gn(0), lo = 0, sf = null, wl = 0, mm = 0, wu = 0, gc = null, Yo = null, iv = 0, Eu = 1 / 0, El = null, hm = !1, vc = null, Gi = null, vs = !1, bs = null, gm = 0, Tu = 0, vm = null, bc = -1, yc = 0;
  function Go() {
    return Rn & 6 ? An() : bc !== -1 ? bc : bc = An();
  }
  function Kr(l) {
    return l.mode & 1 ? Rn & 2 && go !== 0 ? go & -go : Fp.transition !== null ? (yc === 0 && (yc = mp()), yc) : (l = Yn, l !== 0 || (l = window.event, l = l === void 0 ? 16 : ig(l.type)), l) : 1;
  }
  function Wo(l, u, g, w) {
    if (50 < Tu)
      throw Tu = 0, vm = null, Error(o(185));
    Ys(l, g, w), (!(Rn & 2) || l !== kr) && (l === kr && (!(Rn & 2) && (mm |= g), lo === 4 && ri(l, go)), qo(l, w), g === 1 && Rn === 0 && !(u.mode & 1) && (Eu = An() + 500, po && ua()));
  }
  function qo(l, u) {
    var g = l.callbackNode;
    pp(l, u);
    var w = xi(l, l === kr ? go : 0);
    if (w === 0)
      g !== null && Wt(g), l.callbackNode = null, l.callbackPriority = 0;
    else if (u = w & -w, l.callbackPriority !== u) {
      if (g != null && Wt(g), u === 1)
        l.tag === 0 ? Ng(QC.bind(null, l)) : Ig(QC.bind(null, l)), kg(function() {
          !(Rn & 6) && ua();
        }), g = null;
      else {
        switch (rg(w)) {
          case 1:
            g = cl;
            break;
          case 4:
            g = On;
            break;
          case 16:
            g = Zl;
            break;
          case 536870912:
            g = Jh;
            break;
          default:
            g = Zl;
        }
        g = fv(g, Ou.bind(null, l));
      }
      l.callbackPriority = u, l.callbackNode = g;
    }
  }
  function Ou(l, u) {
    if (bc = -1, yc = 0, Rn & 6)
      throw Error(o(327));
    var g = l.callbackNode;
    if (ku() && l.callbackNode !== g)
      return null;
    var w = xi(l, l === kr ? go : 0);
    if (w === 0)
      return null;
    if (w & 30 || w & l.expiredLanes || u)
      u = ym(l, w);
    else {
      u = w;
      var N = Rn;
      Rn |= 2;
      var F = bm();
      (kr !== l || go !== u) && (El = null, Eu = An() + 500, Cc(l, u));
      do
        try {
          Rw();
          break;
        } catch (ue) {
          ZC(l, ue);
        }
      while (1);
      Fg(), lf.current = F, Rn = N, Fr !== null ? u = 0 : (kr = null, go = 0, u = lo);
    }
    if (u !== 0) {
      if (u === 2 && (N = tg(l), N !== 0 && (w = N, u = lv(l, N))), u === 1)
        throw g = sf, Cc(l, 0), ri(l, w), qo(l, An()), g;
      if (u === 6)
        ri(l, w);
      else {
        if (N = l.current.alternate, !(w & 30) && !sv(N) && (u = ym(l, w), u === 2 && (F = tg(l), F !== 0 && (w = F, u = lv(l, F))), u === 1))
          throw g = sf, Cc(l, 0), ri(l, w), qo(l, An()), g;
        switch (l.finishedWork = N, l.finishedLanes = w, u) {
          case 0:
          case 1:
            throw Error(o(345));
          case 2:
            Sc(l, Yo, El);
            break;
          case 3:
            if (ri(l, w), (w & 130023424) === w && (u = iv + 500 - An(), 10 < u)) {
              if (xi(l, 0) !== 0)
                break;
              if (N = l.suspendedLanes, (N & w) !== w) {
                Go(), l.pingedLanes |= l.suspendedLanes & N;
                break;
              }
              l.timeoutHandle = tc(Sc.bind(null, l, Yo, El), u);
              break;
            }
            Sc(l, Yo, El);
            break;
          case 4:
            if (ri(l, w), (w & 4194240) === w)
              break;
            for (u = l.eventTimes, N = -1; 0 < w; ) {
              var te = 31 - Ua(w);
              F = 1 << te, te = u[te], te > N && (N = te), w &= ~F;
            }
            if (w = N, w = An() - w, w = (120 > w ? 120 : 480 > w ? 480 : 1080 > w ? 1080 : 1920 > w ? 1920 : 3e3 > w ? 3e3 : 4320 > w ? 4320 : 1960 * pm(w / 1960)) - w, 10 < w) {
              l.timeoutHandle = tc(Sc.bind(null, l, Yo, El), w);
              break;
            }
            Sc(l, Yo, El);
            break;
          case 5:
            Sc(l, Yo, El);
            break;
          default:
            throw Error(o(329));
        }
      }
    }
    return qo(l, An()), l.callbackNode === g ? Ou.bind(null, l) : null;
  }
  function lv(l, u) {
    var g = gc;
    return l.current.memoizedState.isDehydrated && (Cc(l, u).flags |= 256), l = ym(l, u), l !== 2 && (u = Yo, Yo = g, u !== null && cf(u)), l;
  }
  function cf(l) {
    Yo === null ? Yo = l : Yo.push.apply(Yo, l);
  }
  function sv(l) {
    for (var u = l; ; ) {
      if (u.flags & 16384) {
        var g = u.updateQueue;
        if (g !== null && (g = g.stores, g !== null))
          for (var w = 0; w < g.length; w++) {
            var N = g[w], F = N.getSnapshot;
            N = N.value;
            try {
              if (!qa(F(), N))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (g = u.child, u.subtreeFlags & 16384 && g !== null)
        g.return = u, u = g;
      else {
        if (u === l)
          break;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === l)
            return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }
    return !0;
  }
  function ri(l, u) {
    for (u &= ~wu, u &= ~mm, l.suspendedLanes |= u, l.pingedLanes &= ~u, l = l.expirationTimes; 0 < u; ) {
      var g = 31 - Ua(u), w = 1 << g;
      l[g] = -1, u &= ~w;
    }
  }
  function QC(l) {
    if (Rn & 6)
      throw Error(o(327));
    ku();
    var u = xi(l, 0);
    if (!(u & 1))
      return qo(l, An()), null;
    var g = ym(l, u);
    if (l.tag !== 0 && g === 2) {
      var w = tg(l);
      w !== 0 && (u = w, g = lv(l, w));
    }
    if (g === 1)
      throw g = sf, Cc(l, 0), ri(l, u), qo(l, An()), g;
    if (g === 6)
      throw Error(o(345));
    return l.finishedWork = l.current.alternate, l.finishedLanes = u, Sc(l, Yo, El), qo(l, An()), null;
  }
  function Ru(l, u) {
    var g = Rn;
    Rn |= 1;
    try {
      return l(u);
    } finally {
      Rn = g, Rn === 0 && (Eu = An() + 500, po && ua());
    }
  }
  function ys(l) {
    bs !== null && bs.tag === 0 && !(Rn & 6) && ku();
    var u = Rn;
    Rn |= 1;
    var g = Uo.transition, w = Yn;
    try {
      if (Uo.transition = null, Yn = 1, l)
        return l();
    } finally {
      Yn = w, Uo.transition = g, Rn = u, !(Rn & 6) && ua();
    }
  }
  function cv() {
    Da = xu.current, jn(xu);
  }
  function Cc(l, u) {
    l.finishedWork = null, l.finishedLanes = 0;
    var g = l.timeoutHandle;
    if (g !== -1 && (l.timeoutHandle = -1, TC(g)), Fr !== null)
      for (g = Fr.return; g !== null; ) {
        var w = g;
        switch (Dg(w), w.tag) {
          case 1:
            w = w.type.childContextTypes, w != null && Xa();
            break;
          case 3:
            ps(), jn(Lr), jn(sn), Up();
            break;
          case 5:
            xn(w);
            break;
          case 4:
            ps();
            break;
          case 13:
            jn(nn);
            break;
          case 19:
            jn(nn);
            break;
          case 10:
            cs(w.type._context);
            break;
          case 22:
          case 23:
            cv();
        }
        g = g.return;
      }
    if (kr = l, Fr = l = Cs(l.current, null), go = Da = u, lo = 0, sf = null, wu = mm = wl = 0, Yo = gc = null, To !== null) {
      for (u = 0; u < To.length; u++)
        if (g = To[u], w = g.interleaved, w !== null) {
          g.interleaved = null;
          var N = w.next, F = g.pending;
          if (F !== null) {
            var te = F.next;
            F.next = N, w.next = te;
          }
          g.pending = w;
        }
      To = null;
    }
    return l;
  }
  function ZC(l, u) {
    do {
      var g = Fr;
      try {
        if (Fg(), Gp.current = lm, on) {
          for (var w = vr.memoizedState; w !== null; ) {
            var N = w.queue;
            N !== null && (N.pending = null), w = w.next;
          }
          on = !1;
        }
        if (ic = 0, Pn = nt = vr = null, ji = !1, $a = 0, av.current = null, g === null || g.return === null) {
          lo = 1, sf = u, Fr = null;
          break;
        }
        e: {
          var F = l, te = g.return, ue = g, ye = u;
          if (u = go, ue.flags |= 32768, ye !== null && typeof ye == "object" && typeof ye.then == "function") {
            var qe = ye, yt = ue, St = yt.tag;
            if (!(yt.mode & 1) && (St === 0 || St === 11 || St === 15)) {
              var bt = yt.alternate;
              bt ? (yt.updateQueue = bt.updateQueue, yt.memoizedState = bt.memoizedState, yt.lanes = bt.lanes) : (yt.updateQueue = null, yt.memoizedState = null);
            }
            var Mt = qg(te);
            if (Mt !== null) {
              Mt.flags &= -257, Yg(Mt, te, ue, F, u), Mt.mode & 1 && VC(F, qe, u), u = Mt, ye = qe;
              var Vt = u.updateQueue;
              if (Vt === null) {
                var Gt = /* @__PURE__ */ new Set();
                Gt.add(ye), u.updateQueue = Gt;
              } else
                Vt.add(ye);
              break e;
            } else {
              if (!(u & 1)) {
                VC(F, qe, u), uv();
                break e;
              }
              ye = Error(o(426));
            }
          } else if (gr && ue.mode & 1) {
            var Hr = qg(te);
            if (Hr !== null) {
              !(Hr.flags & 65536) && (Hr.flags |= 256), Yg(Hr, te, ue, F, u), Ag(hu(ye, ue));
              break e;
            }
          }
          F = ye = hu(ye, ue), lo !== 4 && (lo = 2), gc === null ? gc = [F] : gc.push(F), F = te;
          do {
            switch (F.tag) {
              case 3:
                F.flags |= 65536, u &= -u, F.lanes |= u;
                var De = zC(F, ye, u);
                Bg(F, De);
                break e;
              case 1:
                ue = ye;
                var Re = F.type, Ve = F.stateNode;
                if (!(F.flags & 128) && (typeof Re.getDerivedStateFromError == "function" || Ve !== null && typeof Ve.componentDidCatch == "function" && (Gi === null || !Gi.has(Ve)))) {
                  F.flags |= 65536, u &= -u, F.lanes |= u;
                  var Tt = Jd(F, ue, u);
                  Bg(F, Tt);
                  break e;
                }
            }
            F = F.return;
          } while (F !== null);
        }
        dv(g);
      } catch (qt) {
        u = qt, Fr === g && g !== null && (Fr = g = g.return);
        continue;
      }
      break;
    } while (1);
  }
  function bm() {
    var l = lf.current;
    return lf.current = lm, l === null ? lm : l;
  }
  function uv() {
    (lo === 0 || lo === 3 || lo === 2) && (lo = 4), kr === null || !(wl & 268435455) && !(mm & 268435455) || ri(kr, go);
  }
  function ym(l, u) {
    var g = Rn;
    Rn |= 2;
    var w = bm();
    (kr !== l || go !== u) && (El = null, Cc(l, u));
    do
      try {
        Ow();
        break;
      } catch (N) {
        ZC(l, N);
      }
    while (1);
    if (Fg(), Rn = g, lf.current = w, Fr !== null)
      throw Error(o(261));
    return kr = null, go = 0, lo;
  }
  function Ow() {
    for (; Fr !== null; )
      JC(Fr);
  }
  function Rw() {
    for (; Fr !== null && !Ar(); )
      JC(Fr);
  }
  function JC(l) {
    var u = t0(l.alternate, l, Da);
    l.memoizedProps = l.pendingProps, u === null ? dv(l) : Fr = u, av.current = null;
  }
  function dv(l) {
    var u = l;
    do {
      var g = u.alternate;
      if (l = u.return, u.flags & 32768) {
        if (g = tv(g, u), g !== null) {
          g.flags &= 32767, Fr = g;
          return;
        }
        if (l !== null)
          l.flags |= 32768, l.subtreeFlags = 0, l.deletions = null;
        else {
          lo = 6, Fr = null;
          return;
        }
      } else if (g = Tw(g, u, Da), g !== null) {
        Fr = g;
        return;
      }
      if (u = u.sibling, u !== null) {
        Fr = u;
        return;
      }
      Fr = u = l;
    } while (u !== null);
    lo === 0 && (lo = 5);
  }
  function Sc(l, u, g) {
    var w = Yn, N = Uo.transition;
    try {
      Uo.transition = null, Yn = 1, kw(l, u, g, w);
    } finally {
      Uo.transition = N, Yn = w;
    }
    return null;
  }
  function kw(l, u, g, w) {
    do
      ku();
    while (bs !== null);
    if (Rn & 6)
      throw Error(o(327));
    g = l.finishedWork;
    var N = l.finishedLanes;
    if (g === null)
      return null;
    if (l.finishedWork = null, l.finishedLanes = 0, g === l.current)
      throw Error(o(177));
    l.callbackNode = null, l.callbackPriority = 0;
    var F = g.lanes | g.childLanes;
    if (ew(l, F), l === kr && (Fr = kr = null, go = 0), !(g.subtreeFlags & 2064) && !(g.flags & 2064) || vs || (vs = !0, fv(Zl, function() {
      return ku(), null;
    })), F = (g.flags & 15990) !== 0, g.subtreeFlags & 15990 || F) {
      F = Uo.transition, Uo.transition = null;
      var te = Yn;
      Yn = 1;
      var ue = Rn;
      Rn |= 4, av.current = null, GC(l, g), qC(g, l), Rp(ec), Ks = !!Og, ec = Og = null, l.current = g, YC(g), dp(), Rn = ue, Yn = te, Uo.transition = F;
    } else
      l.current = g;
    if (vs && (vs = !1, bs = l, gm = N), F = l.pendingLanes, F === 0 && (Gi = null), zy(g.stateNode), qo(l, An()), u !== null)
      for (w = l.onRecoverableError, g = 0; g < u.length; g++)
        N = u[g], w(N.value, { componentStack: N.stack, digest: N.digest });
    if (hm)
      throw hm = !1, l = vc, vc = null, l;
    return gm & 1 && l.tag !== 0 && ku(), F = l.pendingLanes, F & 1 ? l === vm ? Tu++ : (Tu = 0, vm = l) : Tu = 0, ua(), null;
  }
  function ku() {
    if (bs !== null) {
      var l = rg(gm), u = Uo.transition, g = Yn;
      try {
        if (Uo.transition = null, Yn = 16 > l ? 16 : l, bs === null)
          var w = !1;
        else {
          if (l = bs, bs = null, gm = 0, Rn & 6)
            throw Error(o(331));
          var N = Rn;
          for (Rn |= 4, Ft = l.current; Ft !== null; ) {
            var F = Ft, te = F.child;
            if (Ft.flags & 16) {
              var ue = F.deletions;
              if (ue !== null) {
                for (var ye = 0; ye < ue.length; ye++) {
                  var qe = ue[ye];
                  for (Ft = qe; Ft !== null; ) {
                    var yt = Ft;
                    switch (yt.tag) {
                      case 0:
                      case 11:
                      case 15:
                        of(8, yt, F);
                    }
                    var St = yt.child;
                    if (St !== null)
                      St.return = yt, Ft = St;
                    else
                      for (; Ft !== null; ) {
                        yt = Ft;
                        var bt = yt.sibling, Mt = yt.return;
                        if (rv(yt), yt === qe) {
                          Ft = null;
                          break;
                        }
                        if (bt !== null) {
                          bt.return = Mt, Ft = bt;
                          break;
                        }
                        Ft = Mt;
                      }
                  }
                }
                var Vt = F.alternate;
                if (Vt !== null) {
                  var Gt = Vt.child;
                  if (Gt !== null) {
                    Vt.child = null;
                    do {
                      var Hr = Gt.sibling;
                      Gt.sibling = null, Gt = Hr;
                    } while (Gt !== null);
                  }
                }
                Ft = F;
              }
            }
            if (F.subtreeFlags & 2064 && te !== null)
              te.return = F, Ft = te;
            else
              e:
                for (; Ft !== null; ) {
                  if (F = Ft, F.flags & 2048)
                    switch (F.tag) {
                      case 0:
                      case 11:
                      case 15:
                        of(9, F, F.return);
                    }
                  var De = F.sibling;
                  if (De !== null) {
                    De.return = F.return, Ft = De;
                    break e;
                  }
                  Ft = F.return;
                }
          }
          var Re = l.current;
          for (Ft = Re; Ft !== null; ) {
            te = Ft;
            var Ve = te.child;
            if (te.subtreeFlags & 2064 && Ve !== null)
              Ve.return = te, Ft = Ve;
            else
              e:
                for (te = Re; Ft !== null; ) {
                  if (ue = Ft, ue.flags & 2048)
                    try {
                      switch (ue.tag) {
                        case 0:
                        case 11:
                        case 15:
                          af(9, ue);
                      }
                    } catch (qt) {
                      zr(ue, ue.return, qt);
                    }
                  if (ue === te) {
                    Ft = null;
                    break e;
                  }
                  var Tt = ue.sibling;
                  if (Tt !== null) {
                    Tt.return = ue.return, Ft = Tt;
                    break e;
                  }
                  Ft = ue.return;
                }
          }
          if (Rn = N, ua(), Si && typeof Si.onPostCommitFiberRoot == "function")
            try {
              Si.onPostCommitFiberRoot(xd, l);
            } catch {
            }
          w = !0;
        }
        return w;
      } finally {
        Yn = g, Uo.transition = u;
      }
    }
    return !1;
  }
  function e0(l, u, g) {
    u = hu(g, u), u = zC(l, u, 1), l = ds(l, u, 1), u = Go(), l !== null && (Ys(l, 1, u), qo(l, u));
  }
  function zr(l, u, g) {
    if (l.tag === 3)
      e0(l, l, g);
    else
      for (; u !== null; ) {
        if (u.tag === 3) {
          e0(u, l, g);
          break;
        } else if (u.tag === 1) {
          var w = u.stateNode;
          if (typeof u.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (Gi === null || !Gi.has(w))) {
            l = hu(g, l), l = Jd(u, l, 1), u = ds(u, l, 1), l = Go(), u !== null && (Ys(u, 1, l), qo(u, l));
            break;
          }
        }
        u = u.return;
      }
  }
  function Pw(l, u, g) {
    var w = l.pingCache;
    w !== null && w.delete(u), u = Go(), l.pingedLanes |= l.suspendedLanes & g, kr === l && (go & g) === g && (lo === 4 || lo === 3 && (go & 130023424) === go && 500 > An() - iv ? Cc(l, 0) : wu |= g), qo(l, u);
  }
  function Cm(l, u) {
    u === 0 && (l.mode & 1 ? (u = Xc, Xc <<= 1, !(Xc & 130023424) && (Xc = 4194304)) : u = 1);
    var g = Go();
    l = bl(l, u), l !== null && (Ys(l, u, g), qo(l, g));
  }
  function Mw(l) {
    var u = l.memoizedState, g = 0;
    u !== null && (g = u.retryLane), Cm(l, g);
  }
  function Iw(l, u) {
    var g = 0;
    switch (l.tag) {
      case 13:
        var w = l.stateNode, N = l.memoizedState;
        N !== null && (g = N.retryLane);
        break;
      case 19:
        w = l.stateNode;
        break;
      default:
        throw Error(o(314));
    }
    w !== null && w.delete(u), Cm(l, g);
  }
  var t0;
  t0 = function(l, u, g) {
    if (l !== null)
      if (l.memoizedProps !== u.pendingProps || Lr.current)
        Yr = !0;
      else {
        if (!(l.lanes & g) && !(u.flags & 128))
          return Yr = !1, Sl(l, u, g);
        Yr = !!(l.flags & 131072);
      }
    else
      Yr = !1, gr && u.flags & 1048576 && $g(u, su, u.index);
    switch (u.lanes = 0, u.tag) {
      case 2:
        var w = u.type;
        jo(l, u), l = u.pendingProps;
        var N = Ka(u, sn.current);
        Ot(u, g), N = ms(null, u, w, l, N, g);
        var F = cc();
        return u.flags |= 1, typeof N == "object" && N !== null && typeof N.render == "function" && N.$$typeof === void 0 ? (u.tag = 1, u.memoizedState = null, u.updateQueue = null, wr(w) ? (F = !0, $p(u)) : F = !1, u.memoizedState = N.state !== null && N.state !== void 0 ? N.state : null, Vg(u), N.updater = Bp, u.stateNode = N, N._reactInternals = u, jp(u, w, l, g), u = BC(null, u, w, !0, F, g)) : (u.tag = 0, gr && F && Dp(u), oo(null, u, N, g), u = u.child), u;
      case 16:
        w = u.elementType;
        e: {
          switch (jo(l, u), l = u.pendingProps, N = w._init, w = N(w._payload), u.type = w, N = u.tag = $w(w), l = Na(w, l), N) {
            case 0:
              u = gu(null, u, w, l, g);
              break e;
            case 1:
              u = Kg(null, u, w, l, g);
              break e;
            case 11:
              u = gs(null, u, w, l, g);
              break e;
            case 14:
              u = cm(null, u, w, Na(w.type, l), g);
              break e;
          }
          throw Error(o(
            306,
            w,
            ""
          ));
        }
        return u;
      case 0:
        return w = u.type, N = u.pendingProps, N = u.elementType === w ? N : Na(w, N), gu(l, u, w, N, g);
      case 1:
        return w = u.type, N = u.pendingProps, N = u.elementType === w ? N : Na(w, N), Kg(l, u, w, N, g);
      case 3:
        e: {
          if (jC(u), l === null)
            throw Error(o(387));
          w = u.pendingProps, F = u.memoizedState, N = F.element, ro(l, u), fs(u, w, null, g);
          var te = u.memoizedState;
          if (w = te.element, F.isDehydrated)
            if (F = { element: w, isDehydrated: !1, cache: te.cache, pendingSuspenseBoundaries: te.pendingSuspenseBoundaries, transitions: te.transitions }, u.updateQueue.baseState = F, u.memoizedState = F, u.flags & 256) {
              N = hu(Error(o(423)), u), u = um(l, u, w, g, N);
              break e;
            } else if (w !== N) {
              N = hu(Error(o(424)), u), u = um(l, u, w, g, N);
              break e;
            } else
              for (pa = Oi(u.stateNode.containerInfo.firstChild), Ia = u, gr = !0, Za = null, g = LC(u, null, w, g), u.child = g; g; )
                g.flags = g.flags & -3 | 4096, g = g.sibling;
          else {
            if (Or(), w === N) {
              u = Oo(l, u, g);
              break e;
            }
            oo(l, u, w, g);
          }
          u = u.child;
        }
        return u;
      case 5:
        return tn(u), l === null && Ap(u), w = u.type, N = u.pendingProps, F = l !== null ? l.memoizedProps : null, te = N.children, Bd(w, N) ? te = null : F !== null && Bd(w, F) && (u.flags |= 32), vn(l, u), oo(l, u, te, g), u.child;
      case 6:
        return l === null && Ap(u), null;
      case 13:
        return Qg(l, u, g);
      case 4:
        return Hg(u, u.stateNode.containerInfo), w = u.pendingProps, l === null ? u.child = uu(u, null, w, g) : oo(l, u, w, g), u.child;
      case 11:
        return w = u.type, N = u.pendingProps, N = u.elementType === w ? N : Na(w, N), gs(l, u, w, N, g);
      case 7:
        return oo(l, u, u.pendingProps, g), u.child;
      case 8:
        return oo(l, u, u.pendingProps.children, g), u.child;
      case 12:
        return oo(l, u, u.pendingProps.children, g), u.child;
      case 10:
        e: {
          if (w = u.type._context, N = u.pendingProps, F = u.memoizedProps, te = N.value, Un(Bi, w._currentValue), w._currentValue = te, F !== null)
            if (qa(F.value, te)) {
              if (F.children === N.children && !Lr.current) {
                u = Oo(l, u, g);
                break e;
              }
            } else
              for (F = u.child, F !== null && (F.return = u); F !== null; ) {
                var ue = F.dependencies;
                if (ue !== null) {
                  te = F.child;
                  for (var ye = ue.firstContext; ye !== null; ) {
                    if (ye.context === w) {
                      if (F.tag === 1) {
                        ye = yl(-1, g & -g), ye.tag = 2;
                        var qe = F.updateQueue;
                        if (qe !== null) {
                          qe = qe.shared;
                          var yt = qe.pending;
                          yt === null ? ye.next = ye : (ye.next = yt.next, yt.next = ye), qe.pending = ye;
                        }
                      }
                      F.lanes |= g, ye = F.alternate, ye !== null && (ye.lanes |= g), mo(
                        F.return,
                        g,
                        u
                      ), ue.lanes |= g;
                      break;
                    }
                    ye = ye.next;
                  }
                } else if (F.tag === 10)
                  te = F.type === u.type ? null : F.child;
                else if (F.tag === 18) {
                  if (te = F.return, te === null)
                    throw Error(o(341));
                  te.lanes |= g, ue = te.alternate, ue !== null && (ue.lanes |= g), mo(te, g, u), te = F.sibling;
                } else
                  te = F.child;
                if (te !== null)
                  te.return = F;
                else
                  for (te = F; te !== null; ) {
                    if (te === u) {
                      te = null;
                      break;
                    }
                    if (F = te.sibling, F !== null) {
                      F.return = te.return, te = F;
                      break;
                    }
                    te = te.return;
                  }
                F = te;
              }
          oo(l, u, N.children, g), u = u.child;
        }
        return u;
      case 9:
        return N = u.type, w = u.pendingProps.children, Ot(u, g), N = jr(N), w = w(N), u.flags |= 1, oo(l, u, w, g), u.child;
      case 14:
        return w = u.type, N = Na(w, u.pendingProps), N = Na(w.type, N), cm(l, u, w, N, g);
      case 15:
        return ga(l, u, u.type, u.pendingProps, g);
      case 17:
        return w = u.type, N = u.pendingProps, N = u.elementType === w ? N : Na(w, N), jo(l, u), u.tag = 1, wr(w) ? (l = !0, $p(u)) : l = !1, Ot(u, g), $C(u, w, N), jp(u, w, N, g), BC(null, u, w, !0, l, g);
      case 19:
        return ev(l, u, g);
      case 22:
        return pc(l, u, g);
    }
    throw Error(o(156, u.tag));
  };
  function fv(l, u) {
    return yn(l, u);
  }
  function Nw(l, u, g, w) {
    this.tag = l, this.key = g, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = u, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function oi(l, u, g, w) {
    return new Nw(l, u, g, w);
  }
  function pv(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function $w(l) {
    if (typeof l == "function")
      return pv(l) ? 1 : 0;
    if (l != null) {
      if (l = l.$$typeof, l === ne)
        return 11;
      if (l === q)
        return 14;
    }
    return 2;
  }
  function Cs(l, u) {
    var g = l.alternate;
    return g === null ? (g = oi(l.tag, u, l.key, l.mode), g.elementType = l.elementType, g.type = l.type, g.stateNode = l.stateNode, g.alternate = l, l.alternate = g) : (g.pendingProps = u, g.type = l.type, g.flags = 0, g.subtreeFlags = 0, g.deletions = null), g.flags = l.flags & 14680064, g.childLanes = l.childLanes, g.lanes = l.lanes, g.child = l.child, g.memoizedProps = l.memoizedProps, g.memoizedState = l.memoizedState, g.updateQueue = l.updateQueue, u = l.dependencies, g.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }, g.sibling = l.sibling, g.index = l.index, g.ref = l.ref, g;
  }
  function Sm(l, u, g, w, N, F) {
    var te = 2;
    if (w = l, typeof l == "function")
      pv(l) && (te = 1);
    else if (typeof l == "string")
      te = 5;
    else
      e:
        switch (l) {
          case A:
            return xc(g.children, N, F, u);
          case W:
            te = 8, N |= 8;
            break;
          case Y:
            return l = oi(12, g, u, N | 2), l.elementType = Y, l.lanes = F, l;
          case K:
            return l = oi(13, g, u, N), l.elementType = K, l.lanes = F, l;
          case B:
            return l = oi(19, g, u, N), l.elementType = B, l.lanes = F, l;
          case J:
            return uf(g, N, F, u);
          default:
            if (typeof l == "object" && l !== null)
              switch (l.$$typeof) {
                case H:
                  te = 10;
                  break e;
                case G:
                  te = 9;
                  break e;
                case ne:
                  te = 11;
                  break e;
                case q:
                  te = 14;
                  break e;
                case X:
                  te = 16, w = null;
                  break e;
              }
            throw Error(o(130, l == null ? l : typeof l, ""));
        }
    return u = oi(te, g, u, N), u.elementType = l, u.type = w, u.lanes = F, u;
  }
  function xc(l, u, g, w) {
    return l = oi(7, l, w, u), l.lanes = g, l;
  }
  function uf(l, u, g, w) {
    return l = oi(22, l, w, u), l.elementType = J, l.lanes = g, l.stateNode = { isHidden: !1 }, l;
  }
  function df(l, u, g) {
    return l = oi(6, l, null, u), l.lanes = g, l;
  }
  function wc(l, u, g) {
    return u = oi(4, l.children !== null ? l.children : [], l.key, u), u.lanes = g, u.stateNode = { containerInfo: l.containerInfo, pendingChildren: null, implementation: l.implementation }, u;
  }
  function Dw(l, u, g, w, N) {
    this.tag = u, this.containerInfo = l, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = ng(0), this.expirationTimes = ng(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ng(0), this.identifierPrefix = w, this.onRecoverableError = N, this.mutableSourceEagerHydrationData = null;
  }
  function xm(l, u, g, w, N, F, te, ue, ye) {
    return l = new Dw(l, u, g, ue, ye), u === 1 ? (u = 1, F === !0 && (u |= 8)) : u = 0, F = oi(3, null, null, u), l.current = F, F.stateNode = l, F.memoizedState = { element: w, isDehydrated: g, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Vg(F), l;
  }
  function n0(l, u, g) {
    var w = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: M, key: w == null ? null : "" + w, children: l, containerInfo: u, implementation: g };
  }
  function mv(l) {
    if (!l)
      return Vi;
    l = l._reactInternals;
    e: {
      if (xe(l) !== l || l.tag !== 1)
        throw Error(o(170));
      var u = l;
      do {
        switch (u.tag) {
          case 3:
            u = u.stateNode.context;
            break e;
          case 1:
            if (wr(u.type)) {
              u = u.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        u = u.return;
      } while (u !== null);
      throw Error(o(171));
    }
    if (l.tag === 1) {
      var g = l.type;
      if (wr(g))
        return Ud(l, g, u);
    }
    return u;
  }
  function r0(l, u, g, w, N, F, te, ue, ye) {
    return l = xm(g, w, !0, l, N, F, te, ue, ye), l.context = mv(null), g = l.current, w = Go(), N = Kr(g), F = yl(w, N), F.callback = u ?? null, ds(g, F, N), l.current.lanes = N, Ys(l, N, w), qo(l, w), l;
  }
  function ff(l, u, g, w) {
    var N = u.current, F = Go(), te = Kr(N);
    return g = mv(g), u.context === null ? u.context = g : u.pendingContext = g, u = yl(F, te), u.payload = { element: l }, w = w === void 0 ? null : w, w !== null && (u.callback = w), l = ds(N, u, te), l !== null && (Wo(l, N, te, F), Vp(l, N, te)), te;
  }
  function wm(l) {
    if (l = l.current, !l.child)
      return null;
    switch (l.child.tag) {
      case 5:
        return l.child.stateNode;
      default:
        return l.child.stateNode;
    }
  }
  function o0(l, u) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var g = l.retryLane;
      l.retryLane = g !== 0 && g < u ? g : u;
    }
  }
  function hv(l, u) {
    o0(l, u), (l = l.alternate) && o0(l, u);
  }
  function a0() {
    return null;
  }
  var gv = typeof reportError == "function" ? reportError : function(l) {
    console.error(l);
  };
  function Em(l) {
    this._internalRoot = l;
  }
  Tl.prototype.render = Em.prototype.render = function(l) {
    var u = this._internalRoot;
    if (u === null)
      throw Error(o(409));
    ff(l, u, null, null);
  }, Tl.prototype.unmount = Em.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var u = l.containerInfo;
      ys(function() {
        ff(null, l, null, null);
      }), u[gl] = null;
    }
  };
  function Tl(l) {
    this._internalRoot = l;
  }
  Tl.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var u = Hy();
      l = { blockedOn: null, target: l, priority: u };
      for (var g = 0; g < Jn.length && u !== 0 && u < Jn[g].priority; g++)
        ;
      Jn.splice(g, 0, l), g === 0 && Uy(l);
    }
  };
  function vv(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function Tm(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11 && (l.nodeType !== 8 || l.nodeValue !== " react-mount-point-unstable "));
  }
  function i0() {
  }
  function _w(l, u, g, w, N) {
    if (N) {
      if (typeof w == "function") {
        var F = w;
        w = function() {
          var qe = wm(te);
          F.call(qe);
        };
      }
      var te = r0(u, w, l, 0, null, !1, !1, "", i0);
      return l._reactRootContainer = te, l[gl] = te.current, iu(l.nodeType === 8 ? l.parentNode : l), ys(), te;
    }
    for (; N = l.lastChild; )
      l.removeChild(N);
    if (typeof w == "function") {
      var ue = w;
      w = function() {
        var qe = wm(ye);
        ue.call(qe);
      };
    }
    var ye = xm(l, 0, !1, null, null, !1, !1, "", i0);
    return l._reactRootContainer = ye, l[gl] = ye.current, iu(l.nodeType === 8 ? l.parentNode : l), ys(function() {
      ff(u, ye, g, w);
    }), ye;
  }
  function Om(l, u, g, w, N) {
    var F = g._reactRootContainer;
    if (F) {
      var te = F;
      if (typeof N == "function") {
        var ue = N;
        N = function() {
          var ye = wm(te);
          ue.call(ye);
        };
      }
      ff(u, te, l, N);
    } else
      te = _w(g, u, l, N, w);
    return wm(te);
  }
  jy = function(l) {
    switch (l.tag) {
      case 3:
        var u = l.stateNode;
        if (u.current.memoizedState.isDehydrated) {
          var g = qs(u.pendingLanes);
          g !== 0 && (wd(u, g | 1), qo(u, An()), !(Rn & 6) && (Eu = An() + 500, ua()));
        }
        break;
      case 13:
        ys(function() {
          var w = bl(l, 1);
          if (w !== null) {
            var N = Go();
            Wo(w, l, 1, N);
          }
        }), hv(l, 1);
    }
  }, hp = function(l) {
    if (l.tag === 13) {
      var u = bl(l, 134217728);
      if (u !== null) {
        var g = Go();
        Wo(u, l, 134217728, g);
      }
      hv(l, 134217728);
    }
  }, dr = function(l) {
    if (l.tag === 13) {
      var u = Kr(l), g = bl(l, u);
      if (g !== null) {
        var w = Go();
        Wo(g, l, u, w);
      }
      hv(l, u);
    }
  }, Hy = function() {
    return Yn;
  }, og = function(l, u) {
    var g = Yn;
    try {
      return Yn = l, u();
    } finally {
      Yn = g;
    }
  }, Sn = function(l, u, g) {
    switch (u) {
      case "input":
        if (Me(l, g), u = g.name, g.type === "radio" && u != null) {
          for (g = l; g.parentNode; )
            g = g.parentNode;
          for (g = g.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), u = 0; u < g.length; u++) {
            var w = g[u];
            if (w !== l && w.form === l.form) {
              var N = Jt(w);
              if (!N)
                throw Error(o(90));
              Se(w), Me(w, N);
            }
          }
        }
        break;
      case "textarea":
        wt(l, g);
        break;
      case "select":
        u = g.value, u != null && Ge(l, !!g.multiple, u, !1);
    }
  }, zo = Ru, wo = ys;
  var Aw = { usingClientEntryPoint: !1, Events: [Hd, lu, Jt, hn, Br, Ru] }, Pu = { findFiberByHostInstance: Ya, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, Lw = { bundleType: Pu.bundleType, version: Pu.version, rendererPackageName: Pu.rendererPackageName, rendererConfig: Pu.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: z.ReactCurrentDispatcher, findHostInstanceByFiber: function(l) {
    return l = Qt(l), l === null ? null : l.stateNode;
  }, findFiberByHostInstance: Pu.findFiberByHostInstance || a0, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Rm = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Rm.isDisabled && Rm.supportsFiber)
      try {
        xd = Rm.inject(Lw), Si = Rm;
      } catch {
      }
  }
  return ui.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Aw, ui.createPortal = function(l, u) {
    var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!vv(u))
      throw Error(o(200));
    return n0(l, u, null, g);
  }, ui.createRoot = function(l, u) {
    if (!vv(l))
      throw Error(o(299));
    var g = !1, w = "", N = gv;
    return u != null && (u.unstable_strictMode === !0 && (g = !0), u.identifierPrefix !== void 0 && (w = u.identifierPrefix), u.onRecoverableError !== void 0 && (N = u.onRecoverableError)), u = xm(l, 1, !1, null, null, g, !1, w, N), l[gl] = u.current, iu(l.nodeType === 8 ? l.parentNode : l), new Em(u);
  }, ui.findDOMNode = function(l) {
    if (l == null)
      return null;
    if (l.nodeType === 1)
      return l;
    var u = l._reactInternals;
    if (u === void 0)
      throw typeof l.render == "function" ? Error(o(188)) : (l = Object.keys(l).join(","), Error(o(268, l)));
    return l = Qt(u), l = l === null ? null : l.stateNode, l;
  }, ui.flushSync = function(l) {
    return ys(l);
  }, ui.hydrate = function(l, u, g) {
    if (!Tm(u))
      throw Error(o(200));
    return Om(null, l, u, !0, g);
  }, ui.hydrateRoot = function(l, u, g) {
    if (!vv(l))
      throw Error(o(405));
    var w = g != null && g.hydratedSources || null, N = !1, F = "", te = gv;
    if (g != null && (g.unstable_strictMode === !0 && (N = !0), g.identifierPrefix !== void 0 && (F = g.identifierPrefix), g.onRecoverableError !== void 0 && (te = g.onRecoverableError)), u = r0(u, null, l, 1, g ?? null, N, !1, F, te), l[gl] = u.current, iu(l), w)
      for (l = 0; l < w.length; l++)
        g = w[l], N = g._getVersion, N = N(g._source), u.mutableSourceEagerHydrationData == null ? u.mutableSourceEagerHydrationData = [g, N] : u.mutableSourceEagerHydrationData.push(
          g,
          N
        );
    return new Tl(u);
  }, ui.render = function(l, u, g) {
    if (!Tm(u))
      throw Error(o(200));
    return Om(null, l, u, !1, g);
  }, ui.unmountComponentAtNode = function(l) {
    if (!Tm(l))
      throw Error(o(40));
    return l._reactRootContainer ? (ys(function() {
      Om(null, null, l, !1, function() {
        l._reactRootContainer = null, l[gl] = null;
      });
    }), !0) : !1;
  }, ui.unstable_batchedUpdates = Ru, ui.unstable_renderSubtreeIntoContainer = function(l, u, g, w) {
    if (!Tm(g))
      throw Error(o(200));
    if (l == null || l._reactInternals === void 0)
      throw Error(o(38));
    return Om(l, u, g, !1, w);
  }, ui.version = "18.2.0-next-9e3b772b8-20220608", ui;
}
var di = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q2;
function fq() {
  return q2 || (q2 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Ha, t = HL(), o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, i = !1;
    function s(r) {
      i = r;
    }
    function c(r) {
      if (!i) {
        for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), p = 1; p < a; p++)
          d[p - 1] = arguments[p];
        m("warn", r, d);
      }
    }
    function f(r) {
      if (!i) {
        for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), p = 1; p < a; p++)
          d[p - 1] = arguments[p];
        m("error", r, d);
      }
    }
    function m(r, a, d) {
      {
        var p = o.ReactDebugCurrentFrame, y = p.getStackAddendum();
        y !== "" && (a += "%s", d = d.concat([y]));
        var R = d.map(function(D) {
          return String(D);
        });
        R.unshift("Warning: " + a), Function.prototype.apply.call(console[r], console, R);
      }
    }
    var h = 0, v = 1, b = 2, x = 3, E = 4, T = 5, P = 6, O = 7, k = 8, I = 9, $ = 10, _ = 11, z = 12, V = 13, M = 14, A = 15, W = 16, Y = 17, H = 18, G = 19, ne = 21, K = 22, B = 23, q = 24, X = 25, J = !0, U = !1, Z = !1, ee = !1, ie = !1, oe = !0, le = !1, de = !1, Ce = !0, me = !0, Oe = !0, he = /* @__PURE__ */ new Set(), $e = {}, Ne = {};
    function Pe(r, a) {
      Se(r, a), Se(r + "Capture", a);
    }
    function Se(r, a) {
      $e[r] && f("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", r), $e[r] = a;
      {
        var d = r.toLowerCase();
        Ne[d] = r, r === "onDoubleClick" && (Ne.ondblclick = r);
      }
      for (var p = 0; p < a.length; p++)
        he.add(a[p]);
    }
    var Fe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ce = Object.prototype.hasOwnProperty;
    function ge(r) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, d = a && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return d;
      }
    }
    function we(r) {
      try {
        return Me(r), !1;
      } catch {
        return !0;
      }
    }
    function Me(r) {
      return "" + r;
    }
    function Qe(r, a) {
      if (we(r))
        return f("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", a, ge(r)), Me(r);
    }
    function ct(r) {
      if (we(r))
        return f("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ge(r)), Me(r);
    }
    function Ze(r, a) {
      if (we(r))
        return f("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, ge(r)), Me(r);
    }
    function Ge(r, a) {
      if (we(r))
        return f("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", a, ge(r)), Me(r);
    }
    function Be(r) {
      if (we(r))
        return f("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", ge(r)), Me(r);
    }
    function rt(r) {
      if (we(r))
        return f("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", ge(r)), Me(r);
    }
    var wt = 0, We = 1, ut = 2, ft = 3, Je = 4, pt = 5, At = 6, Ye = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", st = Ye + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", _e = new RegExp("^[" + Ye + "][" + st + "]*$"), vt = {}, et = {};
    function gt(r) {
      return ce.call(et, r) ? !0 : ce.call(vt, r) ? !1 : _e.test(r) ? (et[r] = !0, !0) : (vt[r] = !0, f("Invalid attribute name: `%s`", r), !1);
    }
    function kt(r, a, d) {
      return a !== null ? a.type === wt : d ? !1 : r.length > 2 && (r[0] === "o" || r[0] === "O") && (r[1] === "n" || r[1] === "N");
    }
    function Lt(r, a, d, p) {
      if (d !== null && d.type === wt)
        return !1;
      switch (typeof a) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (p)
            return !1;
          if (d !== null)
            return !d.acceptsBooleans;
          var y = r.toLowerCase().slice(0, 5);
          return y !== "data-" && y !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Ut(r, a, d, p) {
      if (a === null || typeof a > "u" || Lt(r, a, d, p))
        return !0;
      if (p)
        return !1;
      if (d !== null)
        switch (d.type) {
          case ft:
            return !a;
          case Je:
            return a === !1;
          case pt:
            return isNaN(a);
          case At:
            return isNaN(a) || a < 1;
        }
      return !1;
    }
    function Sn(r) {
      return un.hasOwnProperty(r) ? un[r] : null;
    }
    function an(r, a, d, p, y, R, D) {
      this.acceptsBooleans = a === ut || a === ft || a === Je, this.attributeName = p, this.attributeNamespace = y, this.mustUseProperty = d, this.propertyName = r, this.type = a, this.sanitizeURL = R, this.removeEmptyString = D;
    }
    var un = {}, wn = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    wn.forEach(function(r) {
      un[r] = new an(
        r,
        wt,
        !1,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(r) {
      var a = r[0], d = r[1];
      un[a] = new an(
        a,
        We,
        !1,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(r) {
      un[r] = new an(
        r,
        ut,
        !1,
        // mustUseProperty
        r.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(r) {
      un[r] = new an(
        r,
        ut,
        !1,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(r) {
      un[r] = new an(
        r,
        ft,
        !1,
        // mustUseProperty
        r.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      un[r] = new an(
        r,
        ft,
        !0,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      un[r] = new an(
        r,
        Je,
        !1,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      un[r] = new an(
        r,
        At,
        !1,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(r) {
      un[r] = new an(
        r,
        pt,
        !1,
        // mustUseProperty
        r.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var hn = /[\-\:]([a-z])/g, Br = function(r) {
      return r[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      var a = r.replace(hn, Br);
      un[a] = new an(
        a,
        We,
        !1,
        // mustUseProperty
        r,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      var a = r.replace(hn, Br);
      un[a] = new an(
        a,
        We,
        !1,
        // mustUseProperty
        r,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(r) {
      var a = r.replace(hn, Br);
      un[a] = new an(
        a,
        We,
        !1,
        // mustUseProperty
        r,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(r) {
      un[r] = new an(
        r,
        We,
        !1,
        // mustUseProperty
        r.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var zo = "xlinkHref";
    un[zo] = new an(
      "xlinkHref",
      We,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(r) {
      un[r] = new an(
        r,
        We,
        !1,
        // mustUseProperty
        r.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var wo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, to = !1;
    function Dr(r) {
      !to && wo.test(r) && (to = !0, f("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(r)));
    }
    function Vn(r, a, d, p) {
      if (p.mustUseProperty) {
        var y = p.propertyName;
        return r[y];
      } else {
        Qe(d, a), p.sanitizeURL && Dr("" + d);
        var R = p.attributeName, D = null;
        if (p.type === Je) {
          if (r.hasAttribute(R)) {
            var j = r.getAttribute(R);
            return j === "" ? !0 : Ut(a, d, p, !1) ? j : j === "" + d ? d : j;
          }
        } else if (r.hasAttribute(R)) {
          if (Ut(a, d, p, !1))
            return r.getAttribute(R);
          if (p.type === ft)
            return d;
          D = r.getAttribute(R);
        }
        return Ut(a, d, p, !1) ? D === null ? d : D : D === "" + d ? d : D;
      }
    }
    function Dn(r, a, d, p) {
      {
        if (!gt(a))
          return;
        if (!r.hasAttribute(a))
          return d === void 0 ? void 0 : null;
        var y = r.getAttribute(a);
        return Qe(d, a), y === "" + d ? d : y;
      }
    }
    function Zn(r, a, d, p) {
      var y = Sn(a);
      if (!kt(a, y, p)) {
        if (Ut(a, d, y, p) && (d = null), p || y === null) {
          if (gt(a)) {
            var R = a;
            d === null ? r.removeAttribute(R) : (Qe(d, a), r.setAttribute(R, "" + d));
          }
          return;
        }
        var D = y.mustUseProperty;
        if (D) {
          var j = y.propertyName;
          if (d === null) {
            var Q = y.type;
            r[j] = Q === ft ? !1 : "";
          } else
            r[j] = d;
          return;
        }
        var re = y.attributeName, ae = y.attributeNamespace;
        if (d === null)
          r.removeAttribute(re);
        else {
          var ke = y.type, Ee;
          ke === ft || ke === Je && d === !0 ? Ee = "" : (Qe(d, re), Ee = "" + d, y.sanitizeURL && Dr(Ee.toString())), ae ? r.setAttributeNS(ae, re, Ee) : r.setAttribute(re, Ee);
        }
      }
    }
    var _r = Symbol.for("react.element"), ur = Symbol.for("react.portal"), Bn = Symbol.for("react.fragment"), xr = Symbol.for("react.strict_mode"), fe = Symbol.for("react.profiler"), at = Symbol.for("react.provider"), Et = Symbol.for("react.context"), Ie = Symbol.for("react.forward_ref"), xe = Symbol.for("react.suspense"), ze = Symbol.for("react.suspense_list"), mt = Symbol.for("react.memo"), Ct = Symbol.for("react.lazy"), Qt = Symbol.for("react.scope"), dn = Symbol.for("react.debug_trace_mode"), yn = Symbol.for("react.offscreen"), Wt = Symbol.for("react.legacy_hidden"), Ar = Symbol.for("react.cache"), dp = Symbol.for("react.tracing_marker"), An = Symbol.iterator, Zx = "@@iterator";
    function cl(r) {
      if (r === null || typeof r != "object")
        return null;
      var a = An && r[An] || r[Zx];
      return typeof a == "function" ? a : null;
    }
    var On = Object.assign, Zl = 0, Fy, Jh, xd, Si, zy, Ua, Vy;
    function By() {
    }
    By.__reactDisabledLog = !0;
    function Jx() {
      {
        if (Zl === 0) {
          Fy = console.log, Jh = console.info, xd = console.warn, Si = console.error, zy = console.group, Ua = console.groupCollapsed, Vy = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: By,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        Zl++;
      }
    }
    function fp() {
      {
        if (Zl--, Zl === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: On({}, r, {
              value: Fy
            }),
            info: On({}, r, {
              value: Jh
            }),
            warn: On({}, r, {
              value: xd
            }),
            error: On({}, r, {
              value: Si
            }),
            group: On({}, r, {
              value: zy
            }),
            groupCollapsed: On({}, r, {
              value: Ua
            }),
            groupEnd: On({}, r, {
              value: Vy
            })
          });
        }
        Zl < 0 && f("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xc = o.ReactCurrentDispatcher, qs;
    function xi(r, a, d) {
      {
        if (qs === void 0)
          try {
            throw Error();
          } catch (y) {
            var p = y.stack.trim().match(/\n( *(at )?)/);
            qs = p && p[1] || "";
          }
        return `
` + qs + r;
      }
    }
    var eg = !1, pp;
    {
      var tg = typeof WeakMap == "function" ? WeakMap : Map;
      pp = new tg();
    }
    function mp(r, a) {
      if (!r || eg)
        return "";
      {
        var d = pp.get(r);
        if (d !== void 0)
          return d;
      }
      var p;
      eg = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = Xc.current, Xc.current = null, Jx();
      try {
        if (a) {
          var D = function() {
            throw Error();
          };
          if (Object.defineProperty(D.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(D, []);
            } catch (Ue) {
              p = Ue;
            }
            Reflect.construct(r, [], D);
          } else {
            try {
              D.call();
            } catch (Ue) {
              p = Ue;
            }
            r.call(D.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ue) {
            p = Ue;
          }
          r();
        }
      } catch (Ue) {
        if (Ue && p && typeof Ue.stack == "string") {
          for (var j = Ue.stack.split(`
`), Q = p.stack.split(`
`), re = j.length - 1, ae = Q.length - 1; re >= 1 && ae >= 0 && j[re] !== Q[ae]; )
            ae--;
          for (; re >= 1 && ae >= 0; re--, ae--)
            if (j[re] !== Q[ae]) {
              if (re !== 1 || ae !== 1)
                do
                  if (re--, ae--, ae < 0 || j[re] !== Q[ae]) {
                    var ke = `
` + j[re].replace(" at new ", " at ");
                    return r.displayName && ke.includes("<anonymous>") && (ke = ke.replace("<anonymous>", r.displayName)), typeof r == "function" && pp.set(r, ke), ke;
                  }
                while (re >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        eg = !1, Xc.current = R, fp(), Error.prepareStackTrace = y;
      }
      var Ee = r ? r.displayName || r.name : "", He = Ee ? xi(Ee) : "";
      return typeof r == "function" && pp.set(r, He), He;
    }
    function ng(r, a, d) {
      return mp(r, !0);
    }
    function Ys(r, a, d) {
      return mp(r, !1);
    }
    function ew(r) {
      var a = r.prototype;
      return !!(a && a.isReactComponent);
    }
    function wd(r, a, d) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return mp(r, ew(r));
      if (typeof r == "string")
        return xi(r);
      switch (r) {
        case xe:
          return xi("Suspense");
        case ze:
          return xi("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case Ie:
            return Ys(r.render);
          case mt:
            return wd(r.type, a, d);
          case Ct: {
            var p = r, y = p._payload, R = p._init;
            try {
              return wd(R(y), a, d);
            } catch {
            }
          }
        }
      return "";
    }
    function Yn(r) {
      switch (r._debugOwner && r._debugOwner.type, r._debugSource, r.tag) {
        case T:
          return xi(r.type);
        case W:
          return xi("Lazy");
        case V:
          return xi("Suspense");
        case G:
          return xi("SuspenseList");
        case h:
        case b:
        case A:
          return Ys(r.type);
        case _:
          return Ys(r.type.render);
        case v:
          return ng(r.type);
        default:
          return "";
      }
    }
    function rg(r) {
      try {
        var a = "", d = r;
        do
          a += Yn(d), d = d.return;
        while (d);
        return a;
      } catch (p) {
        return `
Error generating stack: ` + p.message + `
` + p.stack;
      }
    }
    function jy(r, a, d) {
      var p = r.displayName;
      if (p)
        return p;
      var y = a.displayName || a.name || "";
      return y !== "" ? d + "(" + y + ")" : d;
    }
    function hp(r) {
      return r.displayName || "Context";
    }
    function dr(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && f("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case Bn:
          return "Fragment";
        case ur:
          return "Portal";
        case fe:
          return "Profiler";
        case xr:
          return "StrictMode";
        case xe:
          return "Suspense";
        case ze:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case Et:
            var a = r;
            return hp(a) + ".Consumer";
          case at:
            var d = r;
            return hp(d._context) + ".Provider";
          case Ie:
            return jy(r, r.render, "ForwardRef");
          case mt:
            var p = r.displayName || null;
            return p !== null ? p : dr(r.type) || "Memo";
          case Ct: {
            var y = r, R = y._payload, D = y._init;
            try {
              return dr(D(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Hy(r, a, d) {
      var p = a.displayName || a.name || "";
      return r.displayName || (p !== "" ? d + "(" + p + ")" : d);
    }
    function og(r) {
      return r.displayName || "Context";
    }
    function mn(r) {
      var a = r.tag, d = r.type;
      switch (a) {
        case q:
          return "Cache";
        case I:
          var p = d;
          return og(p) + ".Consumer";
        case $:
          var y = d;
          return og(y._context) + ".Provider";
        case H:
          return "DehydratedFragment";
        case _:
          return Hy(d, d.render, "ForwardRef");
        case O:
          return "Fragment";
        case T:
          return d;
        case E:
          return "Portal";
        case x:
          return "Root";
        case P:
          return "Text";
        case W:
          return dr(d);
        case k:
          return d === xr ? "StrictMode" : "Mode";
        case K:
          return "Offscreen";
        case z:
          return "Profiler";
        case ne:
          return "Scope";
        case V:
          return "Suspense";
        case G:
          return "SuspenseList";
        case X:
          return "TracingMarker";
        case v:
        case h:
        case Y:
        case b:
        case M:
        case A:
          if (typeof d == "function")
            return d.displayName || d.name || null;
          if (typeof d == "string")
            return d;
          break;
      }
      return null;
    }
    var Ed = o.ReactDebugCurrentFrame, Wr = null, Ga = !1;
    function Wa() {
      {
        if (Wr === null)
          return null;
        var r = Wr._debugOwner;
        if (r !== null && typeof r < "u")
          return mn(r);
      }
      return null;
    }
    function Td() {
      return Wr === null ? "" : rg(Wr);
    }
    function no() {
      Ed.getCurrentStack = null, Wr = null, Ga = !1;
    }
    function Jn(r) {
      Ed.getCurrentStack = r === null ? null : Td, Wr = r, Ga = !1;
    }
    function tw() {
      return Wr;
    }
    function wi(r) {
      Ga = r;
    }
    function Vo(r) {
      return "" + r;
    }
    function Jl(r) {
      switch (typeof r) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return r;
        case "object":
          return rt(r), r;
        default:
          return "";
      }
    }
    var Uy = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Qc(r, a) {
      Uy[a.type] || a.onChange || a.onInput || a.readOnly || a.disabled || a.value == null || f("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), a.onChange || a.readOnly || a.disabled || a.checked == null || f("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function ag(r) {
      var a = r.type, d = r.nodeName;
      return d && d.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
    }
    function Gy(r) {
      return r._valueTracker;
    }
    function Od(r) {
      r._valueTracker = null;
    }
    function Rd(r) {
      var a = "";
      return r && (ag(r) ? a = r.checked ? "true" : "false" : a = r.value), a;
    }
    function Zc(r) {
      var a = ag(r) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(r.constructor.prototype, a);
      rt(r[a]);
      var p = "" + r[a];
      if (!(r.hasOwnProperty(a) || typeof d > "u" || typeof d.get != "function" || typeof d.set != "function")) {
        var y = d.get, R = d.set;
        Object.defineProperty(r, a, {
          configurable: !0,
          get: function() {
            return y.call(this);
          },
          set: function(j) {
            rt(j), p = "" + j, R.call(this, j);
          }
        }), Object.defineProperty(r, a, {
          enumerable: d.enumerable
        });
        var D = {
          getValue: function() {
            return p;
          },
          setValue: function(j) {
            rt(j), p = "" + j;
          },
          stopTracking: function() {
            Od(r), delete r[a];
          }
        };
        return D;
      }
    }
    function Ks(r) {
      Gy(r) || (r._valueTracker = Zc(r));
    }
    function Wy(r) {
      if (!r)
        return !1;
      var a = Gy(r);
      if (!a)
        return !0;
      var d = a.getValue(), p = Rd(r);
      return p !== d ? (a.setValue(p), !0) : !1;
    }
    function gp(r) {
      if (r = r || (typeof document < "u" ? document : void 0), typeof r > "u")
        return null;
      try {
        return r.activeElement || r.body;
      } catch {
        return r.body;
      }
    }
    var vp = !1, kd = !1, bp = !1, ig = !1;
    function ul(r) {
      var a = r.type === "checkbox" || r.type === "radio";
      return a ? r.checked != null : r.value != null;
    }
    function Pd(r, a) {
      var d = r, p = a.checked, y = On({}, a, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: p ?? d._wrapperState.initialChecked
      });
      return y;
    }
    function Md(r, a) {
      Qc("input", a), a.checked !== void 0 && a.defaultChecked !== void 0 && !kd && (f("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Wa() || "A component", a.type), kd = !0), a.value !== void 0 && a.defaultValue !== void 0 && !vp && (f("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Wa() || "A component", a.type), vp = !0);
      var d = r, p = a.defaultValue == null ? "" : a.defaultValue;
      d._wrapperState = {
        initialChecked: a.checked != null ? a.checked : a.defaultChecked,
        initialValue: Jl(a.value != null ? a.value : p),
        controlled: ul(a)
      };
    }
    function lg(r, a) {
      var d = r, p = a.checked;
      p != null && Zn(d, "checked", p, !1);
    }
    function Jc(r, a) {
      var d = r;
      {
        var p = ul(a);
        !d._wrapperState.controlled && p && !ig && (f("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), ig = !0), d._wrapperState.controlled && !p && !bp && (f("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), bp = !0);
      }
      lg(r, a);
      var y = Jl(a.value), R = a.type;
      if (y != null)
        R === "number" ? (y === 0 && d.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        d.value != y) && (d.value = Vo(y)) : d.value !== Vo(y) && (d.value = Vo(y));
      else if (R === "submit" || R === "reset") {
        d.removeAttribute("value");
        return;
      }
      a.hasOwnProperty("value") ? es(d, a.type, y) : a.hasOwnProperty("defaultValue") && es(d, a.type, Jl(a.defaultValue)), a.checked == null && a.defaultChecked != null && (d.defaultChecked = !!a.defaultChecked);
    }
    function Id(r, a, d) {
      var p = r;
      if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
        var y = a.type, R = y === "submit" || y === "reset";
        if (R && (a.value === void 0 || a.value === null))
          return;
        var D = Vo(p._wrapperState.initialValue);
        d || D !== p.value && (p.value = D), p.defaultValue = D;
      }
      var j = p.name;
      j !== "" && (p.name = ""), p.defaultChecked = !p.defaultChecked, p.defaultChecked = !!p._wrapperState.initialChecked, j !== "" && (p.name = j);
    }
    function qy(r, a) {
      var d = r;
      Jc(d, a), ka(d, a);
    }
    function ka(r, a) {
      var d = a.name;
      if (a.type === "radio" && d != null) {
        for (var p = r; p.parentNode; )
          p = p.parentNode;
        Qe(d, "name");
        for (var y = p.querySelectorAll("input[name=" + JSON.stringify("" + d) + '][type="radio"]'), R = 0; R < y.length; R++) {
          var D = y[R];
          if (!(D === r || D.form !== r.form)) {
            var j = w0(D);
            if (!j)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Wy(D), Jc(D, j);
          }
        }
      }
    }
    function es(r, a, d) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (a !== "number" || gp(r.ownerDocument) !== r) && (d == null ? r.defaultValue = Vo(r._wrapperState.initialValue) : r.defaultValue !== Vo(d) && (r.defaultValue = Vo(d)));
    }
    var yp = !1, eu = !1, Yy = !1;
    function Cp(r, a) {
      a.value == null && (typeof a.children == "object" && a.children !== null ? e.Children.forEach(a.children, function(d) {
        d != null && (typeof d == "string" || typeof d == "number" || eu || (eu = !0, f("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : a.dangerouslySetInnerHTML != null && (Yy || (Yy = !0, f("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), a.selected != null && !yp && (f("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), yp = !0);
    }
    function sg(r, a) {
      a.value != null && r.setAttribute("value", Vo(Jl(a.value)));
    }
    var Nd = Array.isArray;
    function uo(r) {
      return Nd(r);
    }
    var Sp;
    Sp = !1;
    function Ky() {
      var r = Wa();
      return r ? `

Check the render method of \`` + r + "`." : "";
    }
    var Xy = ["value", "defaultValue"];
    function nw(r) {
      {
        Qc("select", r);
        for (var a = 0; a < Xy.length; a++) {
          var d = Xy[a];
          if (r[d] != null) {
            var p = uo(r[d]);
            r.multiple && !p ? f("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", d, Ky()) : !r.multiple && p && f("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", d, Ky());
          }
        }
      }
    }
    function ts(r, a, d, p) {
      var y = r.options;
      if (a) {
        for (var R = d, D = {}, j = 0; j < R.length; j++)
          D["$" + R[j]] = !0;
        for (var Q = 0; Q < y.length; Q++) {
          var re = D.hasOwnProperty("$" + y[Q].value);
          y[Q].selected !== re && (y[Q].selected = re), re && p && (y[Q].defaultSelected = !0);
        }
      } else {
        for (var ae = Vo(Jl(d)), ke = null, Ee = 0; Ee < y.length; Ee++) {
          if (y[Ee].value === ae) {
            y[Ee].selected = !0, p && (y[Ee].defaultSelected = !0);
            return;
          }
          ke === null && !y[Ee].disabled && (ke = y[Ee]);
        }
        ke !== null && (ke.selected = !0);
      }
    }
    function cg(r, a) {
      return On({}, a, {
        value: void 0
      });
    }
    function Qy(r, a) {
      var d = r;
      nw(a), d._wrapperState = {
        wasMultiple: !!a.multiple
      }, a.value !== void 0 && a.defaultValue !== void 0 && !Sp && (f("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Sp = !0);
    }
    function rw(r, a) {
      var d = r;
      d.multiple = !!a.multiple;
      var p = a.value;
      p != null ? ts(d, !!a.multiple, p, !1) : a.defaultValue != null && ts(d, !!a.multiple, a.defaultValue, !0);
    }
    function ow(r, a) {
      var d = r, p = d._wrapperState.wasMultiple;
      d._wrapperState.wasMultiple = !!a.multiple;
      var y = a.value;
      y != null ? ts(d, !!a.multiple, y, !1) : p !== !!a.multiple && (a.defaultValue != null ? ts(d, !!a.multiple, a.defaultValue, !0) : ts(d, !!a.multiple, a.multiple ? [] : "", !1));
    }
    function aw(r, a) {
      var d = r, p = a.value;
      p != null && ts(d, !!a.multiple, p, !1);
    }
    var ug = !1;
    function dg(r, a) {
      var d = r;
      if (a.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var p = On({}, a, {
        value: void 0,
        defaultValue: void 0,
        children: Vo(d._wrapperState.initialValue)
      });
      return p;
    }
    function Zy(r, a) {
      var d = r;
      Qc("textarea", a), a.value !== void 0 && a.defaultValue !== void 0 && !ug && (f("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Wa() || "A component"), ug = !0);
      var p = a.value;
      if (p == null) {
        var y = a.children, R = a.defaultValue;
        if (y != null) {
          f("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (R != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (uo(y)) {
              if (y.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              y = y[0];
            }
            R = y;
          }
        }
        R == null && (R = ""), p = R;
      }
      d._wrapperState = {
        initialValue: Jl(p)
      };
    }
    function Jy(r, a) {
      var d = r, p = Jl(a.value), y = Jl(a.defaultValue);
      if (p != null) {
        var R = Vo(p);
        R !== d.value && (d.value = R), a.defaultValue == null && d.defaultValue !== R && (d.defaultValue = R);
      }
      y != null && (d.defaultValue = Vo(y));
    }
    function eC(r, a) {
      var d = r, p = d.textContent;
      p === d._wrapperState.initialValue && p !== "" && p !== null && (d.value = p);
    }
    function fg(r, a) {
      Jy(r, a);
    }
    var dl = "http://www.w3.org/1999/xhtml", iw = "http://www.w3.org/1998/Math/MathML", pg = "http://www.w3.org/2000/svg";
    function xp(r) {
      switch (r) {
        case "svg":
          return pg;
        case "math":
          return iw;
        default:
          return dl;
      }
    }
    function mg(r, a) {
      return r == null || r === dl ? xp(a) : r === pg && a === "foreignObject" ? dl : r;
    }
    var lw = function(r) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(a, d, p, y) {
        MSApp.execUnsafeLocalFunction(function() {
          return r(a, d, p, y);
        });
      } : r;
    }, wp, tC = lw(function(r, a) {
      if (r.namespaceURI === pg && !("innerHTML" in r)) {
        wp = wp || document.createElement("div"), wp.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>";
        for (var d = wp.firstChild; r.firstChild; )
          r.removeChild(r.firstChild);
        for (; d.firstChild; )
          r.appendChild(d.firstChild);
        return;
      }
      r.innerHTML = a;
    }), sa = 1, fl = 3, qr = 8, Ei = 9, Xs = 11, Ep = function(r, a) {
      if (a) {
        var d = r.firstChild;
        if (d && d === r.lastChild && d.nodeType === fl) {
          d.nodeValue = a;
          return;
        }
      }
      r.textContent = a;
    }, nC = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, tu = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function rC(r, a) {
      return r + a.charAt(0).toUpperCase() + a.substring(1);
    }
    var oC = ["Webkit", "ms", "Moz", "O"];
    Object.keys(tu).forEach(function(r) {
      oC.forEach(function(a) {
        tu[rC(a, r)] = tu[r];
      });
    });
    function Tp(r, a, d) {
      var p = a == null || typeof a == "boolean" || a === "";
      return p ? "" : !d && typeof a == "number" && a !== 0 && !(tu.hasOwnProperty(r) && tu[r]) ? a + "px" : (Ge(a, r), ("" + a).trim());
    }
    var nu = /([A-Z])/g, sw = /^ms-/;
    function cw(r) {
      return r.replace(nu, "-$1").toLowerCase().replace(sw, "-ms-");
    }
    var aC = function() {
    };
    {
      var iC = /^(?:webkit|moz|o)[A-Z]/, lC = /^-ms-/, $d = /-(.)/g, ru = /;\s*$/, ou = {}, au = {}, sC = !1, hg = !1, gg = function(r) {
        return r.replace($d, function(a, d) {
          return d.toUpperCase();
        });
      }, vg = function(r) {
        ou.hasOwnProperty(r) && ou[r] || (ou[r] = !0, f(
          "Unsupported style property %s. Did you mean %s?",
          r,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          gg(r.replace(lC, "ms-"))
        ));
      }, cC = function(r) {
        ou.hasOwnProperty(r) && ou[r] || (ou[r] = !0, f("Unsupported vendor-prefixed style property %s. Did you mean %s?", r, r.charAt(0).toUpperCase() + r.slice(1)));
      }, uC = function(r, a) {
        au.hasOwnProperty(a) && au[a] || (au[a] = !0, f(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, r, a.replace(ru, "")));
      }, dC = function(r, a) {
        sC || (sC = !0, f("`NaN` is an invalid value for the `%s` css style property.", r));
      }, uw = function(r, a) {
        hg || (hg = !0, f("`Infinity` is an invalid value for the `%s` css style property.", r));
      };
      aC = function(r, a) {
        r.indexOf("-") > -1 ? vg(r) : iC.test(r) ? cC(r) : ru.test(a) && uC(r, a), typeof a == "number" && (isNaN(a) ? dC(r, a) : isFinite(a) || uw(r, a));
      };
    }
    var dw = aC;
    function fw(r) {
      {
        var a = "", d = "";
        for (var p in r)
          if (r.hasOwnProperty(p)) {
            var y = r[p];
            if (y != null) {
              var R = p.indexOf("--") === 0;
              a += d + (R ? p : cw(p)) + ":", a += Tp(p, y, R), d = ";";
            }
          }
        return a || null;
      }
    }
    function fC(r, a) {
      var d = r.style;
      for (var p in a)
        if (a.hasOwnProperty(p)) {
          var y = p.indexOf("--") === 0;
          y || dw(p, a[p]);
          var R = Tp(p, a[p], y);
          p === "float" && (p = "cssFloat"), y ? d.setProperty(p, R) : d[p] = R;
        }
    }
    function pw(r) {
      return r == null || typeof r == "boolean" || r === "";
    }
    function qa(r) {
      var a = {};
      for (var d in r)
        for (var p = nC[d] || [d], y = 0; y < p.length; y++)
          a[p[y]] = d;
      return a;
    }
    function Dd(r, a) {
      {
        if (!a)
          return;
        var d = qa(r), p = qa(a), y = {};
        for (var R in d) {
          var D = d[R], j = p[R];
          if (j && D !== j) {
            var Q = D + "," + j;
            if (y[Q])
              continue;
            y[Q] = !0, f("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", pw(r[D]) ? "Removing" : "Updating", D, j);
          }
        }
      }
    }
    var pC = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, mC = On({
      menuitem: !0
    }, pC), hC = "__html";
    function Op(r, a) {
      if (a) {
        if (mC[r] && (a.children != null || a.dangerouslySetInnerHTML != null))
          throw new Error(r + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (a.dangerouslySetInnerHTML != null) {
          if (a.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof a.dangerouslySetInnerHTML != "object" || !(hC in a.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!a.suppressContentEditableWarning && a.contentEditable && a.children != null && f("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), a.style != null && typeof a.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function pl(r, a) {
      if (r.indexOf("-") === -1)
        return typeof a.is == "string";
      switch (r) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Rp = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, gC = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ti = {}, bg = new RegExp("^(aria)-[" + st + "]*$"), _d = new RegExp("^(aria)[A-Z][" + st + "]*$");
    function yg(r, a) {
      {
        if (ce.call(Ti, a) && Ti[a])
          return !0;
        if (_d.test(a)) {
          var d = "aria-" + a.slice(4).toLowerCase(), p = gC.hasOwnProperty(d) ? d : null;
          if (p == null)
            return f("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", a), Ti[a] = !0, !0;
          if (a !== p)
            return f("Invalid ARIA attribute `%s`. Did you mean `%s`?", a, p), Ti[a] = !0, !0;
        }
        if (bg.test(a)) {
          var y = a.toLowerCase(), R = gC.hasOwnProperty(y) ? y : null;
          if (R == null)
            return Ti[a] = !0, !1;
          if (a !== R)
            return f("Unknown ARIA attribute `%s`. Did you mean `%s`?", a, R), Ti[a] = !0, !0;
        }
      }
      return !0;
    }
    function vC(r, a) {
      {
        var d = [];
        for (var p in a) {
          var y = yg(r, p);
          y || d.push(p);
        }
        var R = d.map(function(D) {
          return "`" + D + "`";
        }).join(", ");
        d.length === 1 ? f("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, r) : d.length > 1 && f("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, r);
      }
    }
    function kp(r, a) {
      pl(r, a) || vC(r, a);
    }
    var Qs = !1;
    function Cg(r, a) {
      {
        if (r !== "input" && r !== "textarea" && r !== "select")
          return;
        a != null && a.value === null && !Qs && (Qs = !0, r === "select" && a.multiple ? f("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", r) : f("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", r));
      }
    }
    var Sg = function() {
    };
    {
      var fo = {}, xg = /^on./, bC = /^on[^A-Z]/, yC = new RegExp("^(aria)-[" + st + "]*$"), CC = new RegExp("^(aria)[A-Z][" + st + "]*$");
      Sg = function(r, a, d, p) {
        if (ce.call(fo, a) && fo[a])
          return !0;
        var y = a.toLowerCase();
        if (y === "onfocusin" || y === "onfocusout")
          return f("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), fo[a] = !0, !0;
        if (p != null) {
          var R = p.registrationNameDependencies, D = p.possibleRegistrationNames;
          if (R.hasOwnProperty(a))
            return !0;
          var j = D.hasOwnProperty(y) ? D[y] : null;
          if (j != null)
            return f("Invalid event handler property `%s`. Did you mean `%s`?", a, j), fo[a] = !0, !0;
          if (xg.test(a))
            return f("Unknown event handler property `%s`. It will be ignored.", a), fo[a] = !0, !0;
        } else if (xg.test(a))
          return bC.test(a) && f("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", a), fo[a] = !0, !0;
        if (yC.test(a) || CC.test(a))
          return !0;
        if (y === "innerhtml")
          return f("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), fo[a] = !0, !0;
        if (y === "aria")
          return f("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), fo[a] = !0, !0;
        if (y === "is" && d !== null && d !== void 0 && typeof d != "string")
          return f("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof d), fo[a] = !0, !0;
        if (typeof d == "number" && isNaN(d))
          return f("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", a), fo[a] = !0, !0;
        var Q = Sn(a), re = Q !== null && Q.type === wt;
        if (Rp.hasOwnProperty(y)) {
          var ae = Rp[y];
          if (ae !== a)
            return f("Invalid DOM property `%s`. Did you mean `%s`?", a, ae), fo[a] = !0, !0;
        } else if (!re && a !== y)
          return f("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", a, y), fo[a] = !0, !0;
        return typeof d == "boolean" && Lt(a, d, Q, !1) ? (d ? f('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', d, a, a, d, a) : f('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', d, a, a, d, a, a, a), fo[a] = !0, !0) : re ? !0 : Lt(a, d, Q, !1) ? (fo[a] = !0, !1) : ((d === "false" || d === "true") && Q !== null && Q.type === ft && (f("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", d, a, d === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', a, d), fo[a] = !0), !0);
      };
    }
    var SC = function(r, a, d) {
      {
        var p = [];
        for (var y in a) {
          var R = Sg(r, y, a[y], d);
          R || p.push(y);
        }
        var D = p.map(function(j) {
          return "`" + j + "`";
        }).join(", ");
        p.length === 1 ? f("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", D, r) : p.length > 1 && f("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", D, r);
      }
    };
    function xC(r, a, d) {
      pl(r, a) || SC(r, a, d);
    }
    var ml = 1, Ad = 2, Zs = 4, mw = ml | Ad | Zs, Ld = null;
    function Fd(r) {
      Ld !== null && f("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Ld = r;
    }
    function hw() {
      Ld === null && f("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Ld = null;
    }
    function wC(r) {
      return r === Ld;
    }
    function Pp(r) {
      var a = r.target || r.srcElement || window;
      return a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === fl ? a.parentNode : a;
    }
    var fr = null, ns = null, hl = null;
    function iu(r) {
      var a = Nu(r);
      if (a) {
        if (typeof fr != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var d = a.stateNode;
        if (d) {
          var p = w0(d);
          fr(a.stateNode, a.type, p);
        }
      }
    }
    function EC(r) {
      fr = r;
    }
    function Mp(r) {
      ns ? hl ? hl.push(r) : hl = [r] : ns = r;
    }
    function zd() {
      return ns !== null || hl !== null;
    }
    function Vd() {
      if (ns) {
        var r = ns, a = hl;
        if (ns = null, hl = null, iu(r), a)
          for (var d = 0; d < a.length; d++)
            iu(a[d]);
      }
    }
    var Js = function(r, a) {
      return r(a);
    }, wg = function() {
    }, Eg = !1;
    function gw() {
      var r = zd();
      r && (wg(), Vd());
    }
    function Tg(r, a, d) {
      if (Eg)
        return r(a, d);
      Eg = !0;
      try {
        return Js(r, a, d);
      } finally {
        Eg = !1, gw();
      }
    }
    function Ip(r, a, d) {
      Js = r, wg = d;
    }
    function Np(r) {
      return r === "button" || r === "input" || r === "select" || r === "textarea";
    }
    function Og(r, a, d) {
      switch (r) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(d.disabled && Np(a));
        default:
          return !1;
      }
    }
    function ec(r, a) {
      var d = r.stateNode;
      if (d === null)
        return null;
      var p = w0(d);
      if (p === null)
        return null;
      var y = p[a];
      if (Og(a, r.type, p))
        return null;
      if (y && typeof y != "function")
        throw new Error("Expected `" + a + "` listener to be a function, instead got a value of `" + typeof y + "` type.");
      return y;
    }
    var Bd = !1;
    if (Fe)
      try {
        var tc = {};
        Object.defineProperty(tc, "passive", {
          get: function() {
            Bd = !0;
          }
        }), window.addEventListener("test", tc, tc), window.removeEventListener("test", tc, tc);
      } catch {
        Bd = !1;
      }
    function TC(r, a, d, p, y, R, D, j, Q) {
      var re = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(d, re);
      } catch (ae) {
        this.onError(ae);
      }
    }
    var Rg = TC;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var kg = document.createElement("react");
      Rg = function(a, d, p, y, R, D, j, Q, re) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var ae = document.createEvent("Event"), ke = !1, Ee = !0, He = window.event, Ue = Object.getOwnPropertyDescriptor(window, "event");
        function Ke() {
          kg.removeEventListener(Xe, en, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = He);
        }
        var $t = Array.prototype.slice.call(arguments, 3);
        function en() {
          ke = !0, Ke(), d.apply(p, $t), Ee = !1;
        }
        var Kt, In = !1, kn = !1;
        function Ae(Le) {
          if (Kt = Le.error, In = !0, Kt === null && Le.colno === 0 && Le.lineno === 0 && (kn = !0), Le.defaultPrevented && Kt != null && typeof Kt == "object")
            try {
              Kt._suppressLogging = !0;
            } catch {
            }
        }
        var Xe = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", Ae), kg.addEventListener(Xe, en, !1), ae.initEvent(Xe, !1, !1), kg.dispatchEvent(ae), Ue && Object.defineProperty(window, "event", Ue), ke && Ee && (In ? kn && (Kt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Kt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Kt)), window.removeEventListener("error", Ae), !ke)
          return Ke(), TC.apply(this, arguments);
      };
    }
    var vw = Rg, rs = !1, Oi = null, jd = !1, os = null, zi = {
      onError: function(r) {
        rs = !0, Oi = r;
      }
    };
    function nc(r, a, d, p, y, R, D, j, Q) {
      rs = !1, Oi = null, vw.apply(zi, arguments);
    }
    function gl(r, a, d, p, y, R, D, j, Q) {
      if (nc.apply(this, arguments), rs) {
        var re = Mg();
        jd || (jd = !0, os = re);
      }
    }
    function Pg() {
      if (jd) {
        var r = os;
        throw jd = !1, os = null, r;
      }
    }
    function bw() {
      return rs;
    }
    function Mg() {
      if (rs) {
        var r = Oi;
        return rs = !1, Oi = null, r;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ya(r) {
      return r._reactInternals;
    }
    function Hd(r) {
      return r._reactInternals !== void 0;
    }
    function lu(r, a) {
      r._reactInternals = a;
    }
    var Jt = (
      /*                      */
      0
    ), as = (
      /*                */
      1
    ), hr = (
      /*                    */
      2
    ), gn = (
      /*                       */
      4
    ), jn = (
      /*                */
      16
    ), Un = (
      /*                 */
      32
    ), Vi = (
      /*                     */
      64
    ), sn = (
      /*                   */
      128
    ), Lr = (
      /*            */
      256
    ), ca = (
      /*                          */
      512
    ), Ka = (
      /*                     */
      1024
    ), wr = (
      /*                      */
      2048
    ), Xa = (
      /*                    */
      4096
    ), is = (
      /*                   */
      8192
    ), Ud = (
      /*             */
      16384
    ), $p = wr | gn | Vi | ca | Ka | Ud, OC = (
      /*               */
      32767
    ), Pa = (
      /*                   */
      32768
    ), po = (
      /*                */
      65536
    ), Gd = (
      /* */
      131072
    ), Ig = (
      /*                       */
      1048576
    ), Ng = (
      /*                    */
      2097152
    ), ua = (
      /*                 */
      4194304
    ), ls = (
      /*                */
      8388608
    ), da = (
      /*               */
      16777216
    ), rc = (
      /*              */
      33554432
    ), su = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      gn | Ka | 0
    ), fa = hr | gn | jn | Un | ca | Xa | is, Bo = gn | Vi | ca | is, Qa = wr | jn, Eo = ua | ls | Ng, vl = o.ReactCurrentOwner;
    function Ma(r) {
      var a = r, d = r;
      if (r.alternate)
        for (; a.return; )
          a = a.return;
      else {
        var p = a;
        do
          a = p, (a.flags & (hr | Xa)) !== Jt && (d = a.return), p = a.return;
        while (p);
      }
      return a.tag === x ? d : null;
    }
    function $g(r) {
      if (r.tag === V) {
        var a = r.memoizedState;
        if (a === null) {
          var d = r.alternate;
          d !== null && (a = d.memoizedState);
        }
        if (a !== null)
          return a.dehydrated;
      }
      return null;
    }
    function Dp(r) {
      return r.tag === x ? r.stateNode.containerInfo : null;
    }
    function Dg(r) {
      return Ma(r) === r;
    }
    function Ia(r) {
      {
        var a = vl.current;
        if (a !== null && a.tag === v) {
          var d = a, p = d.stateNode;
          p._warnedAboutRefsInRender || f("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", mn(d) || "A component"), p._warnedAboutRefsInRender = !0;
        }
      }
      var y = Ya(r);
      return y ? Ma(y) === y : !1;
    }
    function pa(r) {
      if (Ma(r) !== r)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function gr(r) {
      var a = r.alternate;
      if (!a) {
        var d = Ma(r);
        if (d === null)
          throw new Error("Unable to find node on an unmounted component.");
        return d !== r ? null : r;
      }
      for (var p = r, y = a; ; ) {
        var R = p.return;
        if (R === null)
          break;
        var D = R.alternate;
        if (D === null) {
          var j = R.return;
          if (j !== null) {
            p = y = j;
            continue;
          }
          break;
        }
        if (R.child === D.child) {
          for (var Q = R.child; Q; ) {
            if (Q === p)
              return pa(R), r;
            if (Q === y)
              return pa(R), a;
            Q = Q.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (p.return !== y.return)
          p = R, y = D;
        else {
          for (var re = !1, ae = R.child; ae; ) {
            if (ae === p) {
              re = !0, p = R, y = D;
              break;
            }
            if (ae === y) {
              re = !0, y = R, p = D;
              break;
            }
            ae = ae.sibling;
          }
          if (!re) {
            for (ae = D.child; ae; ) {
              if (ae === p) {
                re = !0, p = D, y = R;
                break;
              }
              if (ae === y) {
                re = !0, y = D, p = R;
                break;
              }
              ae = ae.sibling;
            }
            if (!re)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (p.alternate !== y)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (p.tag !== x)
        throw new Error("Unable to find node on an unmounted component.");
      return p.stateNode.current === p ? r : a;
    }
    function Za(r) {
      var a = gr(r);
      return a !== null ? _g(a) : null;
    }
    function _g(r) {
      if (r.tag === T || r.tag === P)
        return r;
      for (var a = r.child; a !== null; ) {
        var d = _g(a);
        if (d !== null)
          return d;
        a = a.sibling;
      }
      return null;
    }
    function RC(r) {
      var a = gr(r);
      return a !== null ? _p(a) : null;
    }
    function _p(r) {
      if (r.tag === T || r.tag === P)
        return r;
      for (var a = r.child; a !== null; ) {
        if (a.tag !== E) {
          var d = _p(a);
          if (d !== null)
            return d;
        }
        a = a.sibling;
      }
      return null;
    }
    var Ap = t.unstable_scheduleCallback, kC = t.unstable_cancelCallback, Lp = t.unstable_shouldYield, PC = t.unstable_requestPaint, Or = t.unstable_now, Ag = t.unstable_getCurrentPriorityLevel, Fp = t.unstable_ImmediatePriority, Na = t.unstable_UserBlockingPriority, Bi = t.unstable_NormalPriority, zp = t.unstable_LowPriority, ss = t.unstable_IdlePriority, Lg = t.unstable_yieldValue, Fg = t.unstable_setDisableYieldValue, cs = null, mo = null, Ot = null, jr = !1, To = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function zg(r) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled)
        return !0;
      if (!a.supportsFiber)
        return f("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ce && (r = On({}, r, {
          getLaneLabelMap: ds,
          injectProfilingHooks: yl
        })), cs = a.inject(r), mo = a;
      } catch (d) {
        f("React instrumentation encountered an error: %s.", d);
      }
      return !!a.checkDCE;
    }
    function MC(r, a) {
      if (mo && typeof mo.onScheduleFiberRoot == "function")
        try {
          mo.onScheduleFiberRoot(cs, r, a);
        } catch (d) {
          jr || (jr = !0, f("React instrumentation encountered an error: %s", d));
        }
    }
    function bl(r, a) {
      if (mo && typeof mo.onCommitFiberRoot == "function")
        try {
          var d = (r.current.flags & sn) === sn;
          if (me) {
            var p;
            switch (a) {
              case jo:
                p = Fp;
                break;
              case Oo:
                p = Na;
                break;
              case Sl:
                p = Bi;
                break;
              case ef:
                p = ss;
                break;
              default:
                p = Bi;
                break;
            }
            mo.onCommitFiberRoot(cs, r, p, d);
          }
        } catch (y) {
          jr || (jr = !0, f("React instrumentation encountered an error: %s", y));
        }
    }
    function us(r) {
      if (mo && typeof mo.onPostCommitFiberRoot == "function")
        try {
          mo.onPostCommitFiberRoot(cs, r);
        } catch (a) {
          jr || (jr = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function Vg(r) {
      if (mo && typeof mo.onCommitFiberUnmount == "function")
        try {
          mo.onCommitFiberUnmount(cs, r);
        } catch (a) {
          jr || (jr = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function ro(r) {
      if (typeof Lg == "function" && (Fg(r), s(r)), mo && typeof mo.setStrictMode == "function")
        try {
          mo.setStrictMode(cs, r);
        } catch (a) {
          jr || (jr = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function yl(r) {
      Ot = r;
    }
    function ds() {
      {
        for (var r = /* @__PURE__ */ new Map(), a = 1, d = 0; d < vr; d++) {
          var p = yw(a);
          r.set(a, p), a *= 2;
        }
        return r;
      }
    }
    function Vp(r) {
      Ot !== null && typeof Ot.markCommitStarted == "function" && Ot.markCommitStarted(r);
    }
    function Bg() {
      Ot !== null && typeof Ot.markCommitStopped == "function" && Ot.markCommitStopped();
    }
    function fs(r) {
      Ot !== null && typeof Ot.markComponentRenderStarted == "function" && Ot.markComponentRenderStarted(r);
    }
    function oc() {
      Ot !== null && typeof Ot.markComponentRenderStopped == "function" && Ot.markComponentRenderStopped();
    }
    function IC(r) {
      Ot !== null && typeof Ot.markComponentPassiveEffectMountStarted == "function" && Ot.markComponentPassiveEffectMountStarted(r);
    }
    function jg() {
      Ot !== null && typeof Ot.markComponentPassiveEffectMountStopped == "function" && Ot.markComponentPassiveEffectMountStopped();
    }
    function Bp(r) {
      Ot !== null && typeof Ot.markComponentPassiveEffectUnmountStarted == "function" && Ot.markComponentPassiveEffectUnmountStarted(r);
    }
    function NC() {
      Ot !== null && typeof Ot.markComponentPassiveEffectUnmountStopped == "function" && Ot.markComponentPassiveEffectUnmountStopped();
    }
    function $C(r) {
      Ot !== null && typeof Ot.markComponentLayoutEffectMountStarted == "function" && Ot.markComponentLayoutEffectMountStarted(r);
    }
    function DC() {
      Ot !== null && typeof Ot.markComponentLayoutEffectMountStopped == "function" && Ot.markComponentLayoutEffectMountStopped();
    }
    function jp(r) {
      Ot !== null && typeof Ot.markComponentLayoutEffectUnmountStarted == "function" && Ot.markComponentLayoutEffectUnmountStarted(r);
    }
    function cu() {
      Ot !== null && typeof Ot.markComponentLayoutEffectUnmountStopped == "function" && Ot.markComponentLayoutEffectUnmountStopped();
    }
    function Hp(r, a, d) {
      Ot !== null && typeof Ot.markComponentErrored == "function" && Ot.markComponentErrored(r, a, d);
    }
    function _C(r, a, d) {
      Ot !== null && typeof Ot.markComponentSuspended == "function" && Ot.markComponentSuspended(r, a, d);
    }
    function AC(r) {
      Ot !== null && typeof Ot.markLayoutEffectsStarted == "function" && Ot.markLayoutEffectsStarted(r);
    }
    function uu() {
      Ot !== null && typeof Ot.markLayoutEffectsStopped == "function" && Ot.markLayoutEffectsStopped();
    }
    function LC(r) {
      Ot !== null && typeof Ot.markPassiveEffectsStarted == "function" && Ot.markPassiveEffectsStarted(r);
    }
    function Wd() {
      Ot !== null && typeof Ot.markPassiveEffectsStopped == "function" && Ot.markPassiveEffectsStopped();
    }
    function Ri(r) {
      Ot !== null && typeof Ot.markRenderStarted == "function" && Ot.markRenderStarted(r);
    }
    function qd() {
      Ot !== null && typeof Ot.markRenderYielded == "function" && Ot.markRenderYielded();
    }
    function du() {
      Ot !== null && typeof Ot.markRenderStopped == "function" && Ot.markRenderStopped();
    }
    function ac(r) {
      Ot !== null && typeof Ot.markRenderScheduled == "function" && Ot.markRenderScheduled(r);
    }
    function Hg(r, a) {
      Ot !== null && typeof Ot.markForceUpdateScheduled == "function" && Ot.markForceUpdateScheduled(r, a);
    }
    function ps(r, a) {
      Ot !== null && typeof Ot.markStateUpdateScheduled == "function" && Ot.markStateUpdateScheduled(r, a);
    }
    var tn = (
      /*                         */
      0
    ), xn = (
      /*                 */
      1
    ), nn = (
      /*                    */
      2
    ), Rr = (
      /*               */
      8
    ), Ja = (
      /*              */
      16
    ), Up = Math.clz32 ? Math.clz32 : ic, Gp = Math.log, Ug = Math.LN2;
    function ic(r) {
      var a = r >>> 0;
      return a === 0 ? 32 : 31 - (Gp(a) / Ug | 0) | 0;
    }
    var vr = 31, nt = (
      /*                        */
      0
    ), Pn = (
      /*                          */
      0
    ), on = (
      /*                        */
      1
    ), ji = (
      /*    */
      2
    ), $a = (
      /*             */
      4
    ), lc = (
      /*            */
      8
    ), br = (
      /*                     */
      16
    ), sc = (
      /*                */
      32
    ), ms = (
      /*                       */
      4194240
    ), cc = (
      /*                        */
      64
    ), ei = (
      /*                        */
      128
    ), ma = (
      /*                        */
      256
    ), uc = (
      /*                        */
      512
    ), Yd = (
      /*                        */
      1024
    ), Kd = (
      /*                        */
      2048
    ), Wp = (
      /*                        */
      4096
    ), qp = (
      /*                        */
      8192
    ), Yp = (
      /*                        */
      16384
    ), Kp = (
      /*                       */
      32768
    ), Xp = (
      /*                       */
      65536
    ), Qp = (
      /*                       */
      131072
    ), Zp = (
      /*                       */
      262144
    ), Jp = (
      /*                       */
      524288
    ), dc = (
      /*                       */
      1048576
    ), em = (
      /*                       */
      2097152
    ), fc = (
      /*                            */
      130023424
    ), Cl = (
      /*                             */
      4194304
    ), tm = (
      /*                             */
      8388608
    ), Xd = (
      /*                             */
      16777216
    ), nm = (
      /*                             */
      33554432
    ), rm = (
      /*                             */
      67108864
    ), Gg = Cl, fu = (
      /*          */
      134217728
    ), om = (
      /*                          */
      268435455
    ), pu = (
      /*               */
      268435456
    ), hs = (
      /*                        */
      536870912
    ), ha = (
      /*                   */
      1073741824
    );
    function yw(r) {
      {
        if (r & on)
          return "Sync";
        if (r & ji)
          return "InputContinuousHydration";
        if (r & $a)
          return "InputContinuous";
        if (r & lc)
          return "DefaultHydration";
        if (r & br)
          return "Default";
        if (r & sc)
          return "TransitionHydration";
        if (r & ms)
          return "Transition";
        if (r & fc)
          return "Retry";
        if (r & fu)
          return "SelectiveHydration";
        if (r & pu)
          return "IdleHydration";
        if (r & hs)
          return "Idle";
        if (r & ha)
          return "Offscreen";
      }
    }
    var pr = -1, am = cc, im = Cl;
    function mu(r) {
      switch (Yr(r)) {
        case on:
          return on;
        case ji:
          return ji;
        case $a:
          return $a;
        case lc:
          return lc;
        case br:
          return br;
        case sc:
          return sc;
        case cc:
        case ei:
        case ma:
        case uc:
        case Yd:
        case Kd:
        case Wp:
        case qp:
        case Yp:
        case Kp:
        case Xp:
        case Qp:
        case Zp:
        case Jp:
        case dc:
        case em:
          return r & ms;
        case Cl:
        case tm:
        case Xd:
        case nm:
        case rm:
          return r & fc;
        case fu:
          return fu;
        case pu:
          return pu;
        case hs:
          return hs;
        case ha:
          return ha;
        default:
          return f("Should have found matching lanes. This is a bug in React."), r;
      }
    }
    function Qd(r, a) {
      var d = r.pendingLanes;
      if (d === nt)
        return nt;
      var p = nt, y = r.suspendedLanes, R = r.pingedLanes, D = d & om;
      if (D !== nt) {
        var j = D & ~y;
        if (j !== nt)
          p = mu(j);
        else {
          var Q = D & R;
          Q !== nt && (p = mu(Q));
        }
      } else {
        var re = d & ~y;
        re !== nt ? p = mu(re) : R !== nt && (p = mu(R));
      }
      if (p === nt)
        return nt;
      if (a !== nt && a !== p && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & y) === nt) {
        var ae = Yr(p), ke = Yr(a);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          ae >= ke || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          ae === br && (ke & ms) !== nt
        )
          return a;
      }
      (p & $a) !== nt && (p |= d & br);
      var Ee = r.entangledLanes;
      if (Ee !== nt)
        for (var He = r.entanglements, Ue = p & Ee; Ue > 0; ) {
          var Ke = gs(Ue), $t = 1 << Ke;
          p |= He[Ke], Ue &= ~$t;
        }
      return p;
    }
    function FC(r, a) {
      for (var d = r.eventTimes, p = pr; a > 0; ) {
        var y = gs(a), R = 1 << y, D = d[y];
        D > p && (p = D), a &= ~R;
      }
      return p;
    }
    function lm(r, a) {
      switch (r) {
        case on:
        case ji:
        case $a:
          return a + 250;
        case lc:
        case br:
        case sc:
        case cc:
        case ei:
        case ma:
        case uc:
        case Yd:
        case Kd:
        case Wp:
        case qp:
        case Yp:
        case Kp:
        case Xp:
        case Qp:
        case Zp:
        case Jp:
        case dc:
        case em:
          return a + 5e3;
        case Cl:
        case tm:
        case Xd:
        case nm:
        case rm:
          return pr;
        case fu:
        case pu:
        case hs:
        case ha:
          return pr;
        default:
          return f("Should have found matching lanes. This is a bug in React."), pr;
      }
    }
    function Cw(r, a) {
      for (var d = r.pendingLanes, p = r.suspendedLanes, y = r.pingedLanes, R = r.expirationTimes, D = d; D > 0; ) {
        var j = gs(D), Q = 1 << j, re = R[j];
        re === pr ? ((Q & p) === nt || (Q & y) !== nt) && (R[j] = lm(Q, a)) : re <= a && (r.expiredLanes |= Q), D &= ~Q;
      }
    }
    function Sw(r) {
      return mu(r.pendingLanes);
    }
    function Wg(r) {
      var a = r.pendingLanes & ~ha;
      return a !== nt ? a : a & ha ? ha : nt;
    }
    function hu(r) {
      return (r & on) !== nt;
    }
    function Zd(r) {
      return (r & om) !== nt;
    }
    function sm(r) {
      return (r & fc) === r;
    }
    function xw(r) {
      var a = on | $a | br;
      return (r & a) === nt;
    }
    function zC(r) {
      return (r & ms) === r;
    }
    function Jd(r, a) {
      var d = ji | $a | lc | br;
      return (a & d) !== nt;
    }
    function VC(r, a) {
      return (a & r.expiredLanes) !== nt;
    }
    function qg(r) {
      return (r & ms) !== nt;
    }
    function Yg() {
      var r = am;
      return am <<= 1, (am & ms) === nt && (am = cc), r;
    }
    function ww() {
      var r = im;
      return im <<= 1, (im & fc) === nt && (im = Cl), r;
    }
    function Yr(r) {
      return r & -r;
    }
    function oo(r) {
      return Yr(r);
    }
    function gs(r) {
      return 31 - Up(r);
    }
    function cm(r) {
      return gs(r);
    }
    function ga(r, a) {
      return (r & a) !== nt;
    }
    function pc(r, a) {
      return (r & a) === a;
    }
    function vn(r, a) {
      return r | a;
    }
    function gu(r, a) {
      return r & ~a;
    }
    function Kg(r, a) {
      return r & a;
    }
    function BC(r) {
      return r;
    }
    function jC(r, a) {
      return r !== Pn && r < a ? r : a;
    }
    function um(r) {
      for (var a = [], d = 0; d < vr; d++)
        a.push(r);
      return a;
    }
    function mc(r, a, d) {
      r.pendingLanes |= a, a !== hs && (r.suspendedLanes = nt, r.pingedLanes = nt);
      var p = r.eventTimes, y = cm(a);
      p[y] = d;
    }
    function Xg(r, a) {
      r.suspendedLanes |= a, r.pingedLanes &= ~a;
      for (var d = r.expirationTimes, p = a; p > 0; ) {
        var y = gs(p), R = 1 << y;
        d[y] = pr, p &= ~R;
      }
    }
    function Qg(r, a, d) {
      r.pingedLanes |= r.suspendedLanes & a;
    }
    function Zg(r, a) {
      var d = r.pendingLanes & ~a;
      r.pendingLanes = a, r.suspendedLanes = nt, r.pingedLanes = nt, r.expiredLanes &= a, r.mutableReadLanes &= a, r.entangledLanes &= a;
      for (var p = r.entanglements, y = r.eventTimes, R = r.expirationTimes, D = d; D > 0; ) {
        var j = gs(D), Q = 1 << j;
        p[j] = nt, y[j] = pr, R[j] = pr, D &= ~Q;
      }
    }
    function vu(r, a) {
      for (var d = r.entangledLanes |= a, p = r.entanglements, y = d; y; ) {
        var R = gs(y), D = 1 << R;
        // Is this one of the newly entangled lanes?
        D & a | // Is this lane transitively entangled with the newly entangled lanes?
        p[R] & a && (p[R] |= a), y &= ~D;
      }
    }
    function Ew(r, a) {
      var d = Yr(a), p;
      switch (d) {
        case $a:
          p = ji;
          break;
        case br:
          p = lc;
          break;
        case cc:
        case ei:
        case ma:
        case uc:
        case Yd:
        case Kd:
        case Wp:
        case qp:
        case Yp:
        case Kp:
        case Xp:
        case Qp:
        case Zp:
        case Jp:
        case dc:
        case em:
        case Cl:
        case tm:
        case Xd:
        case nm:
        case rm:
          p = sc;
          break;
        case hs:
          p = pu;
          break;
        default:
          p = Pn;
          break;
      }
      return (p & (r.suspendedLanes | a)) !== Pn ? Pn : p;
    }
    function Jg(r, a, d) {
      if (To)
        for (var p = r.pendingUpdatersLaneMap; d > 0; ) {
          var y = cm(d), R = 1 << y, D = p[y];
          D.add(a), d &= ~R;
        }
    }
    function dm(r, a) {
      if (To)
        for (var d = r.pendingUpdatersLaneMap, p = r.memoizedUpdaters; a > 0; ) {
          var y = cm(a), R = 1 << y, D = d[y];
          D.size > 0 && (D.forEach(function(j) {
            var Q = j.alternate;
            (Q === null || !p.has(Q)) && p.add(j);
          }), D.clear()), a &= ~R;
        }
    }
    function ev(r, a) {
      return null;
    }
    var jo = on, Oo = $a, Sl = br, ef = hs, hc = Pn;
    function ti() {
      return hc;
    }
    function ao(r) {
      hc = r;
    }
    function tf(r, a) {
      var d = hc;
      try {
        return hc = r, a();
      } finally {
        hc = d;
      }
    }
    function Ho(r, a) {
      return r !== 0 && r < a ? r : a;
    }
    function Tw(r, a) {
      return r === 0 || r > a ? r : a;
    }
    function tv(r, a) {
      return r !== 0 && r < a;
    }
    function nf(r) {
      var a = Yr(r);
      return tv(jo, a) ? tv(Oo, a) ? Zd(a) ? Sl : ef : Oo : jo;
    }
    function io(r) {
      var a = r.current.memoizedState;
      return a.isDehydrated;
    }
    var HC;
    function Ft(r) {
      HC = r;
    }
    function bu(r) {
      HC(r);
    }
    var rf;
    function UC(r) {
      rf = r;
    }
    var GC;
    function of(r) {
      GC = r;
    }
    var af;
    function nv(r) {
      af = r;
    }
    var rv;
    function WC(r) {
      rv = r;
    }
    var fm = !1, yu = [], Hi = null, Er = null, ho = null, ni = /* @__PURE__ */ new Map(), Cu = /* @__PURE__ */ new Map(), xl = [], ki = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function qC(r) {
      return ki.indexOf(r) > -1;
    }
    function Ui(r, a, d, p, y) {
      return {
        blockedOn: r,
        domEventName: a,
        eventSystemFlags: d,
        nativeEvent: y,
        targetContainers: [p]
      };
    }
    function YC(r, a) {
      switch (r) {
        case "focusin":
        case "focusout":
          Hi = null;
          break;
        case "dragenter":
        case "dragleave":
          Er = null;
          break;
        case "mouseover":
        case "mouseout":
          ho = null;
          break;
        case "pointerover":
        case "pointerout": {
          var d = a.pointerId;
          ni.delete(d);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var p = a.pointerId;
          Cu.delete(p);
          break;
        }
      }
    }
    function Su(r, a, d, p, y, R) {
      if (r === null || r.nativeEvent !== R) {
        var D = Ui(a, d, p, y, R);
        if (a !== null) {
          var j = Nu(a);
          j !== null && rf(j);
        }
        return D;
      }
      r.eventSystemFlags |= p;
      var Q = r.targetContainers;
      return y !== null && Q.indexOf(y) === -1 && Q.push(y), r;
    }
    function KC(r, a, d, p, y) {
      switch (a) {
        case "focusin": {
          var R = y;
          return Hi = Su(Hi, r, a, d, p, R), !0;
        }
        case "dragenter": {
          var D = y;
          return Er = Su(Er, r, a, d, p, D), !0;
        }
        case "mouseover": {
          var j = y;
          return ho = Su(ho, r, a, d, p, j), !0;
        }
        case "pointerover": {
          var Q = y, re = Q.pointerId;
          return ni.set(re, Su(ni.get(re) || null, r, a, d, p, Q)), !0;
        }
        case "gotpointercapture": {
          var ae = y, ke = ae.pointerId;
          return Cu.set(ke, Su(Cu.get(ke) || null, r, a, d, p, ae)), !0;
        }
      }
      return !1;
    }
    function ov(r) {
      var a = hf(r.target);
      if (a !== null) {
        var d = Ma(a);
        if (d !== null) {
          var p = d.tag;
          if (p === V) {
            var y = $g(d);
            if (y !== null) {
              r.blockedOn = y, rv(r.priority, function() {
                GC(d);
              });
              return;
            }
          } else if (p === x) {
            var R = d.stateNode;
            if (io(R)) {
              r.blockedOn = Dp(d);
              return;
            }
          }
        }
      }
      r.blockedOn = null;
    }
    function XC(r) {
      for (var a = af(), d = {
        blockedOn: null,
        target: r,
        priority: a
      }, p = 0; p < xl.length && tv(a, xl[p].priority); p++)
        ;
      xl.splice(p, 0, d), p === 0 && ov(d);
    }
    function pm(r) {
      if (r.blockedOn !== null)
        return !1;
      for (var a = r.targetContainers; a.length > 0; ) {
        var d = a[0], p = gc(r.domEventName, r.eventSystemFlags, d, r.nativeEvent);
        if (p === null) {
          var y = r.nativeEvent, R = new y.constructor(y.type, y);
          Fd(R), y.target.dispatchEvent(R), hw();
        } else {
          var D = Nu(p);
          return D !== null && rf(D), r.blockedOn = p, !1;
        }
        a.shift();
      }
      return !0;
    }
    function lf(r, a, d) {
      pm(r) && d.delete(a);
    }
    function av() {
      fm = !1, Hi !== null && pm(Hi) && (Hi = null), Er !== null && pm(Er) && (Er = null), ho !== null && pm(ho) && (ho = null), ni.forEach(lf), Cu.forEach(lf);
    }
    function Uo(r, a) {
      r.blockedOn === a && (r.blockedOn = null, fm || (fm = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, av)));
    }
    function Rn(r) {
      if (yu.length > 0) {
        Uo(yu[0], r);
        for (var a = 1; a < yu.length; a++) {
          var d = yu[a];
          d.blockedOn === r && (d.blockedOn = null);
        }
      }
      Hi !== null && Uo(Hi, r), Er !== null && Uo(Er, r), ho !== null && Uo(ho, r);
      var p = function(j) {
        return Uo(j, r);
      };
      ni.forEach(p), Cu.forEach(p);
      for (var y = 0; y < xl.length; y++) {
        var R = xl[y];
        R.blockedOn === r && (R.blockedOn = null);
      }
      for (; xl.length > 0; ) {
        var D = xl[0];
        if (D.blockedOn !== null)
          break;
        ov(D), D.blockedOn === null && xl.shift();
      }
    }
    var kr = o.ReactCurrentBatchConfig, Fr = !0;
    function go(r) {
      Fr = !!r;
    }
    function Da() {
      return Fr;
    }
    function xu(r, a, d) {
      var p = Yo(a), y;
      switch (p) {
        case jo:
          y = lo;
          break;
        case Oo:
          y = sf;
          break;
        case Sl:
        default:
          y = wl;
          break;
      }
      return y.bind(null, a, d, r);
    }
    function lo(r, a, d, p) {
      var y = ti(), R = kr.transition;
      kr.transition = null;
      try {
        ao(jo), wl(r, a, d, p);
      } finally {
        ao(y), kr.transition = R;
      }
    }
    function sf(r, a, d, p) {
      var y = ti(), R = kr.transition;
      kr.transition = null;
      try {
        ao(Oo), wl(r, a, d, p);
      } finally {
        ao(y), kr.transition = R;
      }
    }
    function wl(r, a, d, p) {
      Fr && mm(r, a, d, p);
    }
    function mm(r, a, d, p) {
      var y = gc(r, a, d, p);
      if (y === null) {
        Gw(r, a, p, wu, d), YC(r, p);
        return;
      }
      if (KC(y, r, a, d, p)) {
        p.stopPropagation();
        return;
      }
      if (YC(r, p), a & Zs && qC(r)) {
        for (; y !== null; ) {
          var R = Nu(y);
          R !== null && bu(R);
          var D = gc(r, a, d, p);
          if (D === null && Gw(r, a, p, wu, d), D === y)
            break;
          y = D;
        }
        y !== null && p.stopPropagation();
        return;
      }
      Gw(r, a, p, null, d);
    }
    var wu = null;
    function gc(r, a, d, p) {
      wu = null;
      var y = Pp(p), R = hf(y);
      if (R !== null) {
        var D = Ma(R);
        if (D === null)
          R = null;
        else {
          var j = D.tag;
          if (j === V) {
            var Q = $g(D);
            if (Q !== null)
              return Q;
            R = null;
          } else if (j === x) {
            var re = D.stateNode;
            if (io(re))
              return Dp(D);
            R = null;
          } else
            D !== R && (R = null);
        }
      }
      return wu = R, null;
    }
    function Yo(r) {
      switch (r) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return jo;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Oo;
        case "message": {
          var a = Ag();
          switch (a) {
            case Fp:
              return jo;
            case Na:
              return Oo;
            case Bi:
            case zp:
              return Sl;
            case ss:
              return ef;
            default:
              return Sl;
          }
        }
        default:
          return Sl;
      }
    }
    function iv(r, a, d) {
      return r.addEventListener(a, d, !1), d;
    }
    function Eu(r, a, d) {
      return r.addEventListener(a, d, !0), d;
    }
    function El(r, a, d, p) {
      return r.addEventListener(a, d, {
        capture: !0,
        passive: p
      }), d;
    }
    function hm(r, a, d, p) {
      return r.addEventListener(a, d, {
        passive: p
      }), d;
    }
    var vc = null, Gi = null, vs = null;
    function bs(r) {
      return vc = r, Gi = vm(), !0;
    }
    function gm() {
      vc = null, Gi = null, vs = null;
    }
    function Tu() {
      if (vs)
        return vs;
      var r, a = Gi, d = a.length, p, y = vm(), R = y.length;
      for (r = 0; r < d && a[r] === y[r]; r++)
        ;
      var D = d - r;
      for (p = 1; p <= D && a[d - p] === y[R - p]; p++)
        ;
      var j = p > 1 ? 1 - p : void 0;
      return vs = y.slice(r, j), vs;
    }
    function vm() {
      return "value" in vc ? vc.value : vc.textContent;
    }
    function bc(r) {
      var a, d = r.keyCode;
      return "charCode" in r ? (a = r.charCode, a === 0 && d === 13 && (a = 13)) : a = d, a === 10 && (a = 13), a >= 32 || a === 13 ? a : 0;
    }
    function yc() {
      return !0;
    }
    function Go() {
      return !1;
    }
    function Kr(r) {
      function a(d, p, y, R, D) {
        this._reactName = d, this._targetInst = y, this.type = p, this.nativeEvent = R, this.target = D, this.currentTarget = null;
        for (var j in r)
          if (r.hasOwnProperty(j)) {
            var Q = r[j];
            Q ? this[j] = Q(R) : this[j] = R[j];
          }
        var re = R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1;
        return re ? this.isDefaultPrevented = yc : this.isDefaultPrevented = Go, this.isPropagationStopped = Go, this;
      }
      return On(a.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var d = this.nativeEvent;
          d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = yc);
        },
        stopPropagation: function() {
          var d = this.nativeEvent;
          d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = yc);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: yc
      }), a;
    }
    var Wo = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(r) {
        return r.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, qo = Kr(Wo), Ou = On({}, Wo, {
      view: 0,
      detail: 0
    }), lv = Kr(Ou), cf, sv, ri;
    function QC(r) {
      r !== ri && (ri && r.type === "mousemove" ? (cf = r.screenX - ri.screenX, sv = r.screenY - ri.screenY) : (cf = 0, sv = 0), ri = r);
    }
    var Ru = On({}, Ou, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Cm,
      button: 0,
      buttons: 0,
      relatedTarget: function(r) {
        return r.relatedTarget === void 0 ? r.fromElement === r.srcElement ? r.toElement : r.fromElement : r.relatedTarget;
      },
      movementX: function(r) {
        return "movementX" in r ? r.movementX : (QC(r), cf);
      },
      movementY: function(r) {
        return "movementY" in r ? r.movementY : sv;
      }
    }), ys = Kr(Ru), cv = On({}, Ru, {
      dataTransfer: 0
    }), Cc = Kr(cv), ZC = On({}, Ou, {
      relatedTarget: 0
    }), bm = Kr(ZC), uv = On({}, Wo, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), ym = Kr(uv), Ow = On({}, Wo, {
      clipboardData: function(r) {
        return "clipboardData" in r ? r.clipboardData : window.clipboardData;
      }
    }), Rw = Kr(Ow), JC = On({}, Wo, {
      data: 0
    }), dv = Kr(JC), Sc = dv, kw = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, ku = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function e0(r) {
      if (r.key) {
        var a = kw[r.key] || r.key;
        if (a !== "Unidentified")
          return a;
      }
      if (r.type === "keypress") {
        var d = bc(r);
        return d === 13 ? "Enter" : String.fromCharCode(d);
      }
      return r.type === "keydown" || r.type === "keyup" ? ku[r.keyCode] || "Unidentified" : "";
    }
    var zr = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Pw(r) {
      var a = this, d = a.nativeEvent;
      if (d.getModifierState)
        return d.getModifierState(r);
      var p = zr[r];
      return p ? !!d[p] : !1;
    }
    function Cm(r) {
      return Pw;
    }
    var Mw = On({}, Ou, {
      key: e0,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Cm,
      // Legacy Interface
      charCode: function(r) {
        return r.type === "keypress" ? bc(r) : 0;
      },
      keyCode: function(r) {
        return r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      },
      which: function(r) {
        return r.type === "keypress" ? bc(r) : r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      }
    }), Iw = Kr(Mw), t0 = On({}, Ru, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), fv = Kr(t0), Nw = On({}, Ou, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Cm
    }), oi = Kr(Nw), pv = On({}, Wo, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), $w = Kr(pv), Cs = On({}, Ru, {
      deltaX: function(r) {
        return "deltaX" in r ? r.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in r ? -r.wheelDeltaX : 0
        );
      },
      deltaY: function(r) {
        return "deltaY" in r ? r.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in r ? -r.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in r ? -r.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Sm = Kr(Cs), xc = [9, 13, 27, 32], uf = 229, df = Fe && "CompositionEvent" in window, wc = null;
    Fe && "documentMode" in document && (wc = document.documentMode);
    var Dw = Fe && "TextEvent" in window && !wc, xm = Fe && (!df || wc && wc > 8 && wc <= 11), n0 = 32, mv = String.fromCharCode(n0);
    function r0() {
      Pe("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Pe("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Pe("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Pe("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var ff = !1;
    function wm(r) {
      return (r.ctrlKey || r.altKey || r.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(r.ctrlKey && r.altKey);
    }
    function o0(r) {
      switch (r) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function hv(r, a) {
      return r === "keydown" && a.keyCode === uf;
    }
    function a0(r, a) {
      switch (r) {
        case "keyup":
          return xc.indexOf(a.keyCode) !== -1;
        case "keydown":
          return a.keyCode !== uf;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function gv(r) {
      var a = r.detail;
      return typeof a == "object" && "data" in a ? a.data : null;
    }
    function Em(r) {
      return r.locale === "ko";
    }
    var Tl = !1;
    function vv(r, a, d, p, y) {
      var R, D;
      if (df ? R = o0(a) : Tl ? a0(a, p) && (R = "onCompositionEnd") : hv(a, p) && (R = "onCompositionStart"), !R)
        return null;
      xm && !Em(p) && (!Tl && R === "onCompositionStart" ? Tl = bs(y) : R === "onCompositionEnd" && Tl && (D = Tu()));
      var j = u0(d, R);
      if (j.length > 0) {
        var Q = new dv(R, a, null, p, y);
        if (r.push({
          event: Q,
          listeners: j
        }), D)
          Q.data = D;
        else {
          var re = gv(p);
          re !== null && (Q.data = re);
        }
      }
    }
    function Tm(r, a) {
      switch (r) {
        case "compositionend":
          return gv(a);
        case "keypress":
          var d = a.which;
          return d !== n0 ? null : (ff = !0, mv);
        case "textInput":
          var p = a.data;
          return p === mv && ff ? null : p;
        default:
          return null;
      }
    }
    function i0(r, a) {
      if (Tl) {
        if (r === "compositionend" || !df && a0(r, a)) {
          var d = Tu();
          return gm(), Tl = !1, d;
        }
        return null;
      }
      switch (r) {
        case "paste":
          return null;
        case "keypress":
          if (!wm(a)) {
            if (a.char && a.char.length > 1)
              return a.char;
            if (a.which)
              return String.fromCharCode(a.which);
          }
          return null;
        case "compositionend":
          return xm && !Em(a) ? null : a.data;
        default:
          return null;
      }
    }
    function _w(r, a, d, p, y) {
      var R;
      if (Dw ? R = Tm(a, p) : R = i0(a, p), !R)
        return null;
      var D = u0(d, "onBeforeInput");
      if (D.length > 0) {
        var j = new Sc("onBeforeInput", "beforeinput", null, p, y);
        r.push({
          event: j,
          listeners: D
        }), j.data = R;
      }
    }
    function Om(r, a, d, p, y, R, D) {
      vv(r, a, d, p, y), _w(r, a, d, p, y);
    }
    var Aw = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Pu(r) {
      var a = r && r.nodeName && r.nodeName.toLowerCase();
      return a === "input" ? !!Aw[r.type] : a === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Lw(r) {
      if (!Fe)
        return !1;
      var a = "on" + r, d = a in document;
      if (!d) {
        var p = document.createElement("div");
        p.setAttribute(a, "return;"), d = typeof p[a] == "function";
      }
      return d;
    }
    function Rm() {
      Pe("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function l(r, a, d, p) {
      Mp(p);
      var y = u0(a, "onChange");
      if (y.length > 0) {
        var R = new qo("onChange", "change", null, d, p);
        r.push({
          event: R,
          listeners: y
        });
      }
    }
    var u = null, g = null;
    function w(r) {
      var a = r.nodeName && r.nodeName.toLowerCase();
      return a === "select" || a === "input" && r.type === "file";
    }
    function N(r) {
      var a = [];
      l(a, g, r, Pp(r)), Tg(F, a);
    }
    function F(r) {
      CM(r, 0);
    }
    function te(r) {
      var a = $m(r);
      if (Wy(a))
        return r;
    }
    function ue(r, a) {
      if (r === "change")
        return a;
    }
    var ye = !1;
    Fe && (ye = Lw("input") && (!document.documentMode || document.documentMode > 9));
    function qe(r, a) {
      u = r, g = a, u.attachEvent("onpropertychange", St);
    }
    function yt() {
      u && (u.detachEvent("onpropertychange", St), u = null, g = null);
    }
    function St(r) {
      r.propertyName === "value" && te(g) && N(r);
    }
    function bt(r, a, d) {
      r === "focusin" ? (yt(), qe(a, d)) : r === "focusout" && yt();
    }
    function Mt(r, a) {
      if (r === "selectionchange" || r === "keyup" || r === "keydown")
        return te(g);
    }
    function Vt(r) {
      var a = r.nodeName;
      return a && a.toLowerCase() === "input" && (r.type === "checkbox" || r.type === "radio");
    }
    function Gt(r, a) {
      if (r === "click")
        return te(a);
    }
    function Hr(r, a) {
      if (r === "input" || r === "change")
        return te(a);
    }
    function De(r) {
      var a = r._wrapperState;
      !a || !a.controlled || r.type !== "number" || es(r, "number", r.value);
    }
    function Re(r, a, d, p, y, R, D) {
      var j = d ? $m(d) : window, Q, re;
      if (w(j) ? Q = ue : Pu(j) ? ye ? Q = Hr : (Q = Mt, re = bt) : Vt(j) && (Q = Gt), Q) {
        var ae = Q(a, d);
        if (ae) {
          l(r, ae, p, y);
          return;
        }
      }
      re && re(a, j, d), a === "focusout" && De(j);
    }
    function Ve() {
      Se("onMouseEnter", ["mouseout", "mouseover"]), Se("onMouseLeave", ["mouseout", "mouseover"]), Se("onPointerEnter", ["pointerout", "pointerover"]), Se("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Tt(r, a, d, p, y, R, D) {
      var j = a === "mouseover" || a === "pointerover", Q = a === "mouseout" || a === "pointerout";
      if (j && !wC(p)) {
        var re = p.relatedTarget || p.fromElement;
        if (re && (hf(re) || Iv(re)))
          return;
      }
      if (!(!Q && !j)) {
        var ae;
        if (y.window === y)
          ae = y;
        else {
          var ke = y.ownerDocument;
          ke ? ae = ke.defaultView || ke.parentWindow : ae = window;
        }
        var Ee, He;
        if (Q) {
          var Ue = p.relatedTarget || p.toElement;
          if (Ee = d, He = Ue ? hf(Ue) : null, He !== null) {
            var Ke = Ma(He);
            (He !== Ke || He.tag !== T && He.tag !== P) && (He = null);
          }
        } else
          Ee = null, He = d;
        if (Ee !== He) {
          var $t = ys, en = "onMouseLeave", Kt = "onMouseEnter", In = "mouse";
          (a === "pointerout" || a === "pointerover") && ($t = fv, en = "onPointerLeave", Kt = "onPointerEnter", In = "pointer");
          var kn = Ee == null ? ae : $m(Ee), Ae = He == null ? ae : $m(He), Xe = new $t(en, In + "leave", Ee, p, y);
          Xe.target = kn, Xe.relatedTarget = Ae;
          var Le = null, xt = hf(y);
          if (xt === d) {
            var Dt = new $t(Kt, In + "enter", He, p, y);
            Dt.target = Ae, Dt.relatedTarget = kn, Le = Dt;
          }
          rj(r, Xe, Le, Ee, He);
        }
      }
    }
    function qt(r, a) {
      return r === a && (r !== 0 || 1 / r === 1 / a) || r !== r && a !== a;
    }
    var Bt = typeof Object.is == "function" ? Object.is : qt;
    function Zt(r, a) {
      if (Bt(r, a))
        return !0;
      if (typeof r != "object" || r === null || typeof a != "object" || a === null)
        return !1;
      var d = Object.keys(r), p = Object.keys(a);
      if (d.length !== p.length)
        return !1;
      for (var y = 0; y < d.length; y++) {
        var R = d[y];
        if (!ce.call(a, R) || !Bt(r[R], a[R]))
          return !1;
      }
      return !0;
    }
    function cn(r) {
      for (; r && r.firstChild; )
        r = r.firstChild;
      return r;
    }
    function vo(r) {
      for (; r; ) {
        if (r.nextSibling)
          return r.nextSibling;
        r = r.parentNode;
      }
    }
    function _n(r, a) {
      for (var d = cn(r), p = 0, y = 0; d; ) {
        if (d.nodeType === fl) {
          if (y = p + d.textContent.length, p <= a && y >= a)
            return {
              node: d,
              offset: a - p
            };
          p = y;
        }
        d = cn(vo(d));
      }
    }
    function Ss(r) {
      var a = r.ownerDocument, d = a && a.defaultView || window, p = d.getSelection && d.getSelection();
      if (!p || p.rangeCount === 0)
        return null;
      var y = p.anchorNode, R = p.anchorOffset, D = p.focusNode, j = p.focusOffset;
      try {
        y.nodeType, D.nodeType;
      } catch {
        return null;
      }
      return Fw(r, y, R, D, j);
    }
    function Fw(r, a, d, p, y) {
      var R = 0, D = -1, j = -1, Q = 0, re = 0, ae = r, ke = null;
      e:
        for (; ; ) {
          for (var Ee = null; ae === a && (d === 0 || ae.nodeType === fl) && (D = R + d), ae === p && (y === 0 || ae.nodeType === fl) && (j = R + y), ae.nodeType === fl && (R += ae.nodeValue.length), (Ee = ae.firstChild) !== null; )
            ke = ae, ae = Ee;
          for (; ; ) {
            if (ae === r)
              break e;
            if (ke === a && ++Q === d && (D = R), ke === p && ++re === y && (j = R), (Ee = ae.nextSibling) !== null)
              break;
            ae = ke, ke = ae.parentNode;
          }
          ae = Ee;
        }
      return D === -1 || j === -1 ? null : {
        start: D,
        end: j
      };
    }
    function FB(r, a) {
      var d = r.ownerDocument || document, p = d && d.defaultView || window;
      if (p.getSelection) {
        var y = p.getSelection(), R = r.textContent.length, D = Math.min(a.start, R), j = a.end === void 0 ? D : Math.min(a.end, R);
        if (!y.extend && D > j) {
          var Q = j;
          j = D, D = Q;
        }
        var re = _n(r, D), ae = _n(r, j);
        if (re && ae) {
          if (y.rangeCount === 1 && y.anchorNode === re.node && y.anchorOffset === re.offset && y.focusNode === ae.node && y.focusOffset === ae.offset)
            return;
          var ke = d.createRange();
          ke.setStart(re.node, re.offset), y.removeAllRanges(), D > j ? (y.addRange(ke), y.extend(ae.node, ae.offset)) : (ke.setEnd(ae.node, ae.offset), y.addRange(ke));
        }
      }
    }
    function sM(r) {
      return r && r.nodeType === fl;
    }
    function cM(r, a) {
      return !r || !a ? !1 : r === a ? !0 : sM(r) ? !1 : sM(a) ? cM(r, a.parentNode) : "contains" in r ? r.contains(a) : r.compareDocumentPosition ? !!(r.compareDocumentPosition(a) & 16) : !1;
    }
    function zB(r) {
      return r && r.ownerDocument && cM(r.ownerDocument.documentElement, r);
    }
    function VB(r) {
      try {
        return typeof r.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function uM() {
      for (var r = window, a = gp(); a instanceof r.HTMLIFrameElement; ) {
        if (VB(a))
          r = a.contentWindow;
        else
          return a;
        a = gp(r.document);
      }
      return a;
    }
    function zw(r) {
      var a = r && r.nodeName && r.nodeName.toLowerCase();
      return a && (a === "input" && (r.type === "text" || r.type === "search" || r.type === "tel" || r.type === "url" || r.type === "password") || a === "textarea" || r.contentEditable === "true");
    }
    function BB() {
      var r = uM();
      return {
        focusedElem: r,
        selectionRange: zw(r) ? HB(r) : null
      };
    }
    function jB(r) {
      var a = uM(), d = r.focusedElem, p = r.selectionRange;
      if (a !== d && zB(d)) {
        p !== null && zw(d) && UB(d, p);
        for (var y = [], R = d; R = R.parentNode; )
          R.nodeType === sa && y.push({
            element: R,
            left: R.scrollLeft,
            top: R.scrollTop
          });
        typeof d.focus == "function" && d.focus();
        for (var D = 0; D < y.length; D++) {
          var j = y[D];
          j.element.scrollLeft = j.left, j.element.scrollTop = j.top;
        }
      }
    }
    function HB(r) {
      var a;
      return "selectionStart" in r ? a = {
        start: r.selectionStart,
        end: r.selectionEnd
      } : a = Ss(r), a || {
        start: 0,
        end: 0
      };
    }
    function UB(r, a) {
      var d = a.start, p = a.end;
      p === void 0 && (p = d), "selectionStart" in r ? (r.selectionStart = d, r.selectionEnd = Math.min(p, r.value.length)) : FB(r, a);
    }
    var GB = Fe && "documentMode" in document && document.documentMode <= 11;
    function WB() {
      Pe("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var km = null, Vw = null, bv = null, Bw = !1;
    function qB(r) {
      if ("selectionStart" in r && zw(r))
        return {
          start: r.selectionStart,
          end: r.selectionEnd
        };
      var a = r.ownerDocument && r.ownerDocument.defaultView || window, d = a.getSelection();
      return {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
      };
    }
    function YB(r) {
      return r.window === r ? r.document : r.nodeType === Ei ? r : r.ownerDocument;
    }
    function dM(r, a, d) {
      var p = YB(d);
      if (!(Bw || km == null || km !== gp(p))) {
        var y = qB(km);
        if (!bv || !Zt(bv, y)) {
          bv = y;
          var R = u0(Vw, "onSelect");
          if (R.length > 0) {
            var D = new qo("onSelect", "select", null, a, d);
            r.push({
              event: D,
              listeners: R
            }), D.target = km;
          }
        }
      }
    }
    function KB(r, a, d, p, y, R, D) {
      var j = d ? $m(d) : window;
      switch (a) {
        case "focusin":
          (Pu(j) || j.contentEditable === "true") && (km = j, Vw = d, bv = null);
          break;
        case "focusout":
          km = null, Vw = null, bv = null;
          break;
        case "mousedown":
          Bw = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Bw = !1, dM(r, p, y);
          break;
        case "selectionchange":
          if (GB)
            break;
        case "keydown":
        case "keyup":
          dM(r, p, y);
      }
    }
    function l0(r, a) {
      var d = {};
      return d[r.toLowerCase()] = a.toLowerCase(), d["Webkit" + r] = "webkit" + a, d["Moz" + r] = "moz" + a, d;
    }
    var Pm = {
      animationend: l0("Animation", "AnimationEnd"),
      animationiteration: l0("Animation", "AnimationIteration"),
      animationstart: l0("Animation", "AnimationStart"),
      transitionend: l0("Transition", "TransitionEnd")
    }, jw = {}, fM = {};
    Fe && (fM = document.createElement("div").style, "AnimationEvent" in window || (delete Pm.animationend.animation, delete Pm.animationiteration.animation, delete Pm.animationstart.animation), "TransitionEvent" in window || delete Pm.transitionend.transition);
    function s0(r) {
      if (jw[r])
        return jw[r];
      if (!Pm[r])
        return r;
      var a = Pm[r];
      for (var d in a)
        if (a.hasOwnProperty(d) && d in fM)
          return jw[r] = a[d];
      return r;
    }
    var pM = s0("animationend"), mM = s0("animationiteration"), hM = s0("animationstart"), gM = s0("transitionend"), vM = /* @__PURE__ */ new Map(), bM = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Mu(r, a) {
      vM.set(r, a), Pe(a, [r]);
    }
    function XB() {
      for (var r = 0; r < bM.length; r++) {
        var a = bM[r], d = a.toLowerCase(), p = a[0].toUpperCase() + a.slice(1);
        Mu(d, "on" + p);
      }
      Mu(pM, "onAnimationEnd"), Mu(mM, "onAnimationIteration"), Mu(hM, "onAnimationStart"), Mu("dblclick", "onDoubleClick"), Mu("focusin", "onFocus"), Mu("focusout", "onBlur"), Mu(gM, "onTransitionEnd");
    }
    function QB(r, a, d, p, y, R, D) {
      var j = vM.get(a);
      if (j !== void 0) {
        var Q = qo, re = a;
        switch (a) {
          case "keypress":
            if (bc(p) === 0)
              return;
          case "keydown":
          case "keyup":
            Q = Iw;
            break;
          case "focusin":
            re = "focus", Q = bm;
            break;
          case "focusout":
            re = "blur", Q = bm;
            break;
          case "beforeblur":
          case "afterblur":
            Q = bm;
            break;
          case "click":
            if (p.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            Q = ys;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            Q = Cc;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            Q = oi;
            break;
          case pM:
          case mM:
          case hM:
            Q = ym;
            break;
          case gM:
            Q = $w;
            break;
          case "scroll":
            Q = lv;
            break;
          case "wheel":
            Q = Sm;
            break;
          case "copy":
          case "cut":
          case "paste":
            Q = Rw;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            Q = fv;
            break;
        }
        var ae = (R & Zs) !== 0;
        {
          var ke = !ae && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          a === "scroll", Ee = tj(d, j, p.type, ae, ke);
          if (Ee.length > 0) {
            var He = new Q(j, re, null, p, y);
            r.push({
              event: He,
              listeners: Ee
            });
          }
        }
      }
    }
    XB(), Ve(), Rm(), WB(), r0();
    function ZB(r, a, d, p, y, R, D) {
      QB(r, a, d, p, y, R);
      var j = (R & mw) === 0;
      j && (Tt(r, a, d, p, y), Re(r, a, d, p, y), KB(r, a, d, p, y), Om(r, a, d, p, y));
    }
    var yv = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Hw = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(yv));
    function yM(r, a, d) {
      var p = r.type || "unknown-event";
      r.currentTarget = d, gl(p, a, void 0, r), r.currentTarget = null;
    }
    function JB(r, a, d) {
      var p;
      if (d)
        for (var y = a.length - 1; y >= 0; y--) {
          var R = a[y], D = R.instance, j = R.currentTarget, Q = R.listener;
          if (D !== p && r.isPropagationStopped())
            return;
          yM(r, Q, j), p = D;
        }
      else
        for (var re = 0; re < a.length; re++) {
          var ae = a[re], ke = ae.instance, Ee = ae.currentTarget, He = ae.listener;
          if (ke !== p && r.isPropagationStopped())
            return;
          yM(r, He, Ee), p = ke;
        }
    }
    function CM(r, a) {
      for (var d = (a & Zs) !== 0, p = 0; p < r.length; p++) {
        var y = r[p], R = y.event, D = y.listeners;
        JB(R, D, d);
      }
      Pg();
    }
    function ej(r, a, d, p, y) {
      var R = Pp(d), D = [];
      ZB(D, r, p, d, R, a), CM(D, a);
    }
    function Pr(r, a) {
      Hw.has(r) || f('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', r);
      var d = !1, p = MH(a), y = oj(r, d);
      p.has(y) || (SM(a, r, Ad, d), p.add(y));
    }
    function Uw(r, a, d) {
      Hw.has(r) && !a && f('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', r);
      var p = 0;
      a && (p |= Zs), SM(d, r, p, a);
    }
    var c0 = "_reactListening" + Math.random().toString(36).slice(2);
    function Cv(r) {
      if (!r[c0]) {
        r[c0] = !0, he.forEach(function(d) {
          d !== "selectionchange" && (Hw.has(d) || Uw(d, !1, r), Uw(d, !0, r));
        });
        var a = r.nodeType === Ei ? r : r.ownerDocument;
        a !== null && (a[c0] || (a[c0] = !0, Uw("selectionchange", !1, a)));
      }
    }
    function SM(r, a, d, p, y) {
      var R = xu(r, a, d), D = void 0;
      Bd && (a === "touchstart" || a === "touchmove" || a === "wheel") && (D = !0), r = r, p ? D !== void 0 ? El(r, a, R, D) : Eu(r, a, R) : D !== void 0 ? hm(r, a, R, D) : iv(r, a, R);
    }
    function xM(r, a) {
      return r === a || r.nodeType === qr && r.parentNode === a;
    }
    function Gw(r, a, d, p, y) {
      var R = p;
      if (!(a & ml) && !(a & Ad)) {
        var D = y;
        if (p !== null) {
          var j = p;
          e:
            for (; ; ) {
              if (j === null)
                return;
              var Q = j.tag;
              if (Q === x || Q === E) {
                var re = j.stateNode.containerInfo;
                if (xM(re, D))
                  break;
                if (Q === E)
                  for (var ae = j.return; ae !== null; ) {
                    var ke = ae.tag;
                    if (ke === x || ke === E) {
                      var Ee = ae.stateNode.containerInfo;
                      if (xM(Ee, D))
                        return;
                    }
                    ae = ae.return;
                  }
                for (; re !== null; ) {
                  var He = hf(re);
                  if (He === null)
                    return;
                  var Ue = He.tag;
                  if (Ue === T || Ue === P) {
                    j = R = He;
                    continue e;
                  }
                  re = re.parentNode;
                }
              }
              j = j.return;
            }
        }
      }
      Tg(function() {
        return ej(r, a, d, R);
      });
    }
    function Sv(r, a, d) {
      return {
        instance: r,
        listener: a,
        currentTarget: d
      };
    }
    function tj(r, a, d, p, y, R) {
      for (var D = a !== null ? a + "Capture" : null, j = p ? D : a, Q = [], re = r, ae = null; re !== null; ) {
        var ke = re, Ee = ke.stateNode, He = ke.tag;
        if (He === T && Ee !== null && (ae = Ee, j !== null)) {
          var Ue = ec(re, j);
          Ue != null && Q.push(Sv(re, Ue, ae));
        }
        if (y)
          break;
        re = re.return;
      }
      return Q;
    }
    function u0(r, a) {
      for (var d = a + "Capture", p = [], y = r; y !== null; ) {
        var R = y, D = R.stateNode, j = R.tag;
        if (j === T && D !== null) {
          var Q = D, re = ec(y, d);
          re != null && p.unshift(Sv(y, re, Q));
          var ae = ec(y, a);
          ae != null && p.push(Sv(y, ae, Q));
        }
        y = y.return;
      }
      return p;
    }
    function Mm(r) {
      if (r === null)
        return null;
      do
        r = r.return;
      while (r && r.tag !== T);
      return r || null;
    }
    function nj(r, a) {
      for (var d = r, p = a, y = 0, R = d; R; R = Mm(R))
        y++;
      for (var D = 0, j = p; j; j = Mm(j))
        D++;
      for (; y - D > 0; )
        d = Mm(d), y--;
      for (; D - y > 0; )
        p = Mm(p), D--;
      for (var Q = y; Q--; ) {
        if (d === p || p !== null && d === p.alternate)
          return d;
        d = Mm(d), p = Mm(p);
      }
      return null;
    }
    function wM(r, a, d, p, y) {
      for (var R = a._reactName, D = [], j = d; j !== null && j !== p; ) {
        var Q = j, re = Q.alternate, ae = Q.stateNode, ke = Q.tag;
        if (re !== null && re === p)
          break;
        if (ke === T && ae !== null) {
          var Ee = ae;
          if (y) {
            var He = ec(j, R);
            He != null && D.unshift(Sv(j, He, Ee));
          } else if (!y) {
            var Ue = ec(j, R);
            Ue != null && D.push(Sv(j, Ue, Ee));
          }
        }
        j = j.return;
      }
      D.length !== 0 && r.push({
        event: a,
        listeners: D
      });
    }
    function rj(r, a, d, p, y) {
      var R = p && y ? nj(p, y) : null;
      p !== null && wM(r, a, p, R, !1), y !== null && d !== null && wM(r, d, y, R, !0);
    }
    function oj(r, a) {
      return r + "__" + (a ? "capture" : "bubble");
    }
    var ai = !1, xv = "dangerouslySetInnerHTML", d0 = "suppressContentEditableWarning", Iu = "suppressHydrationWarning", EM = "autoFocus", pf = "children", mf = "style", f0 = "__html", Ww, p0, wv, TM, m0, OM, RM;
    Ww = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, p0 = function(r, a) {
      kp(r, a), Cg(r, a), xC(r, a, {
        registrationNameDependencies: $e,
        possibleRegistrationNames: Ne
      });
    }, OM = Fe && !document.documentMode, wv = function(r, a, d) {
      if (!ai) {
        var p = h0(d), y = h0(a);
        y !== p && (ai = !0, f("Prop `%s` did not match. Server: %s Client: %s", r, JSON.stringify(y), JSON.stringify(p)));
      }
    }, TM = function(r) {
      if (!ai) {
        ai = !0;
        var a = [];
        r.forEach(function(d) {
          a.push(d);
        }), f("Extra attributes from the server: %s", a);
      }
    }, m0 = function(r, a) {
      a === !1 ? f("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", r, r, r) : f("Expected `%s` listener to be a function, instead got a value of `%s` type.", r, typeof a);
    }, RM = function(r, a) {
      var d = r.namespaceURI === dl ? r.ownerDocument.createElement(r.tagName) : r.ownerDocument.createElementNS(r.namespaceURI, r.tagName);
      return d.innerHTML = a, d.innerHTML;
    };
    var aj = /\r\n?/g, ij = /\u0000|\uFFFD/g;
    function h0(r) {
      Be(r);
      var a = typeof r == "string" ? r : "" + r;
      return a.replace(aj, `
`).replace(ij, "");
    }
    function g0(r, a, d, p) {
      var y = h0(a), R = h0(r);
      if (R !== y && (p && (ai || (ai = !0, f('Text content did not match. Server: "%s" Client: "%s"', R, y))), d && J))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function kM(r) {
      return r.nodeType === Ei ? r : r.ownerDocument;
    }
    function lj() {
    }
    function v0(r) {
      r.onclick = lj;
    }
    function sj(r, a, d, p, y) {
      for (var R in p)
        if (p.hasOwnProperty(R)) {
          var D = p[R];
          if (R === mf)
            D && Object.freeze(D), fC(a, D);
          else if (R === xv) {
            var j = D ? D[f0] : void 0;
            j != null && tC(a, j);
          } else if (R === pf)
            if (typeof D == "string") {
              var Q = r !== "textarea" || D !== "";
              Q && Ep(a, D);
            } else
              typeof D == "number" && Ep(a, "" + D);
          else
            R === d0 || R === Iu || R === EM || ($e.hasOwnProperty(R) ? D != null && (typeof D != "function" && m0(R, D), R === "onScroll" && Pr("scroll", a)) : D != null && Zn(a, R, D, y));
        }
    }
    function cj(r, a, d, p) {
      for (var y = 0; y < a.length; y += 2) {
        var R = a[y], D = a[y + 1];
        R === mf ? fC(r, D) : R === xv ? tC(r, D) : R === pf ? Ep(r, D) : Zn(r, R, D, p);
      }
    }
    function uj(r, a, d, p) {
      var y, R = kM(d), D, j = p;
      if (j === dl && (j = xp(r)), j === dl) {
        if (y = pl(r, a), !y && r !== r.toLowerCase() && f("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", r), r === "script") {
          var Q = R.createElement("div");
          Q.innerHTML = "<script><\/script>";
          var re = Q.firstChild;
          D = Q.removeChild(re);
        } else if (typeof a.is == "string")
          D = R.createElement(r, {
            is: a.is
          });
        else if (D = R.createElement(r), r === "select") {
          var ae = D;
          a.multiple ? ae.multiple = !0 : a.size && (ae.size = a.size);
        }
      } else
        D = R.createElementNS(j, r);
      return j === dl && !y && Object.prototype.toString.call(D) === "[object HTMLUnknownElement]" && !ce.call(Ww, r) && (Ww[r] = !0, f("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", r)), D;
    }
    function dj(r, a) {
      return kM(a).createTextNode(r);
    }
    function fj(r, a, d, p) {
      var y = pl(a, d);
      p0(a, d);
      var R;
      switch (a) {
        case "dialog":
          Pr("cancel", r), Pr("close", r), R = d;
          break;
        case "iframe":
        case "object":
        case "embed":
          Pr("load", r), R = d;
          break;
        case "video":
        case "audio":
          for (var D = 0; D < yv.length; D++)
            Pr(yv[D], r);
          R = d;
          break;
        case "source":
          Pr("error", r), R = d;
          break;
        case "img":
        case "image":
        case "link":
          Pr("error", r), Pr("load", r), R = d;
          break;
        case "details":
          Pr("toggle", r), R = d;
          break;
        case "input":
          Md(r, d), R = Pd(r, d), Pr("invalid", r);
          break;
        case "option":
          Cp(r, d), R = d;
          break;
        case "select":
          Qy(r, d), R = cg(r, d), Pr("invalid", r);
          break;
        case "textarea":
          Zy(r, d), R = dg(r, d), Pr("invalid", r);
          break;
        default:
          R = d;
      }
      switch (Op(a, R), sj(a, r, p, R, y), a) {
        case "input":
          Ks(r), Id(r, d, !1);
          break;
        case "textarea":
          Ks(r), eC(r);
          break;
        case "option":
          sg(r, d);
          break;
        case "select":
          rw(r, d);
          break;
        default:
          typeof R.onClick == "function" && v0(r);
          break;
      }
    }
    function pj(r, a, d, p, y) {
      p0(a, p);
      var R = null, D, j;
      switch (a) {
        case "input":
          D = Pd(r, d), j = Pd(r, p), R = [];
          break;
        case "select":
          D = cg(r, d), j = cg(r, p), R = [];
          break;
        case "textarea":
          D = dg(r, d), j = dg(r, p), R = [];
          break;
        default:
          D = d, j = p, typeof D.onClick != "function" && typeof j.onClick == "function" && v0(r);
          break;
      }
      Op(a, j);
      var Q, re, ae = null;
      for (Q in D)
        if (!(j.hasOwnProperty(Q) || !D.hasOwnProperty(Q) || D[Q] == null))
          if (Q === mf) {
            var ke = D[Q];
            for (re in ke)
              ke.hasOwnProperty(re) && (ae || (ae = {}), ae[re] = "");
          } else
            Q === xv || Q === pf || Q === d0 || Q === Iu || Q === EM || ($e.hasOwnProperty(Q) ? R || (R = []) : (R = R || []).push(Q, null));
      for (Q in j) {
        var Ee = j[Q], He = D != null ? D[Q] : void 0;
        if (!(!j.hasOwnProperty(Q) || Ee === He || Ee == null && He == null))
          if (Q === mf)
            if (Ee && Object.freeze(Ee), He) {
              for (re in He)
                He.hasOwnProperty(re) && (!Ee || !Ee.hasOwnProperty(re)) && (ae || (ae = {}), ae[re] = "");
              for (re in Ee)
                Ee.hasOwnProperty(re) && He[re] !== Ee[re] && (ae || (ae = {}), ae[re] = Ee[re]);
            } else
              ae || (R || (R = []), R.push(Q, ae)), ae = Ee;
          else if (Q === xv) {
            var Ue = Ee ? Ee[f0] : void 0, Ke = He ? He[f0] : void 0;
            Ue != null && Ke !== Ue && (R = R || []).push(Q, Ue);
          } else
            Q === pf ? (typeof Ee == "string" || typeof Ee == "number") && (R = R || []).push(Q, "" + Ee) : Q === d0 || Q === Iu || ($e.hasOwnProperty(Q) ? (Ee != null && (typeof Ee != "function" && m0(Q, Ee), Q === "onScroll" && Pr("scroll", r)), !R && He !== Ee && (R = [])) : (R = R || []).push(Q, Ee));
      }
      return ae && (Dd(ae, j[mf]), (R = R || []).push(mf, ae)), R;
    }
    function mj(r, a, d, p, y) {
      d === "input" && y.type === "radio" && y.name != null && lg(r, y);
      var R = pl(d, p), D = pl(d, y);
      switch (cj(r, a, R, D), d) {
        case "input":
          Jc(r, y);
          break;
        case "textarea":
          Jy(r, y);
          break;
        case "select":
          ow(r, y);
          break;
      }
    }
    function hj(r) {
      {
        var a = r.toLowerCase();
        return Rp.hasOwnProperty(a) && Rp[a] || null;
      }
    }
    function gj(r, a, d, p, y, R, D) {
      var j, Q;
      switch (j = pl(a, d), p0(a, d), a) {
        case "dialog":
          Pr("cancel", r), Pr("close", r);
          break;
        case "iframe":
        case "object":
        case "embed":
          Pr("load", r);
          break;
        case "video":
        case "audio":
          for (var re = 0; re < yv.length; re++)
            Pr(yv[re], r);
          break;
        case "source":
          Pr("error", r);
          break;
        case "img":
        case "image":
        case "link":
          Pr("error", r), Pr("load", r);
          break;
        case "details":
          Pr("toggle", r);
          break;
        case "input":
          Md(r, d), Pr("invalid", r);
          break;
        case "option":
          Cp(r, d);
          break;
        case "select":
          Qy(r, d), Pr("invalid", r);
          break;
        case "textarea":
          Zy(r, d), Pr("invalid", r);
          break;
      }
      Op(a, d);
      {
        Q = /* @__PURE__ */ new Set();
        for (var ae = r.attributes, ke = 0; ke < ae.length; ke++) {
          var Ee = ae[ke].name.toLowerCase();
          switch (Ee) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              Q.add(ae[ke].name);
          }
        }
      }
      var He = null;
      for (var Ue in d)
        if (d.hasOwnProperty(Ue)) {
          var Ke = d[Ue];
          if (Ue === pf)
            typeof Ke == "string" ? r.textContent !== Ke && (d[Iu] !== !0 && g0(r.textContent, Ke, R, D), He = [pf, Ke]) : typeof Ke == "number" && r.textContent !== "" + Ke && (d[Iu] !== !0 && g0(r.textContent, Ke, R, D), He = [pf, "" + Ke]);
          else if ($e.hasOwnProperty(Ue))
            Ke != null && (typeof Ke != "function" && m0(Ue, Ke), Ue === "onScroll" && Pr("scroll", r));
          else if (D && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof j == "boolean") {
            var $t = void 0, en = j && le ? null : Sn(Ue);
            if (d[Iu] !== !0) {
              if (!(Ue === d0 || Ue === Iu || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ue === "value" || Ue === "checked" || Ue === "selected")) {
                if (Ue === xv) {
                  var Kt = r.innerHTML, In = Ke ? Ke[f0] : void 0;
                  if (In != null) {
                    var kn = RM(r, In);
                    kn !== Kt && wv(Ue, Kt, kn);
                  }
                } else if (Ue === mf) {
                  if (Q.delete(Ue), OM) {
                    var Ae = fw(Ke);
                    $t = r.getAttribute("style"), Ae !== $t && wv(Ue, $t, Ae);
                  }
                } else if (j && !le)
                  Q.delete(Ue.toLowerCase()), $t = Dn(r, Ue, Ke), Ke !== $t && wv(Ue, $t, Ke);
                else if (!kt(Ue, en, j) && !Ut(Ue, Ke, en, j)) {
                  var Xe = !1;
                  if (en !== null)
                    Q.delete(en.attributeName), $t = Vn(r, Ue, Ke, en);
                  else {
                    var Le = p;
                    if (Le === dl && (Le = xp(a)), Le === dl)
                      Q.delete(Ue.toLowerCase());
                    else {
                      var xt = hj(Ue);
                      xt !== null && xt !== Ue && (Xe = !0, Q.delete(xt)), Q.delete(Ue);
                    }
                    $t = Dn(r, Ue, Ke);
                  }
                  var Dt = le;
                  !Dt && Ke !== $t && !Xe && wv(Ue, $t, Ke);
                }
              }
            }
          }
        }
      switch (D && // $FlowFixMe - Should be inferred as not undefined.
      Q.size > 0 && d[Iu] !== !0 && TM(Q), a) {
        case "input":
          Ks(r), Id(r, d, !0);
          break;
        case "textarea":
          Ks(r), eC(r);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof d.onClick == "function" && v0(r);
          break;
      }
      return He;
    }
    function vj(r, a, d) {
      var p = r.nodeValue !== a;
      return p;
    }
    function qw(r, a) {
      {
        if (ai)
          return;
        ai = !0, f("Did not expect server HTML to contain a <%s> in <%s>.", a.nodeName.toLowerCase(), r.nodeName.toLowerCase());
      }
    }
    function Yw(r, a) {
      {
        if (ai)
          return;
        ai = !0, f('Did not expect server HTML to contain the text node "%s" in <%s>.', a.nodeValue, r.nodeName.toLowerCase());
      }
    }
    function Kw(r, a, d) {
      {
        if (ai)
          return;
        ai = !0, f("Expected server HTML to contain a matching <%s> in <%s>.", a, r.nodeName.toLowerCase());
      }
    }
    function Xw(r, a) {
      {
        if (a === "" || ai)
          return;
        ai = !0, f('Expected server HTML to contain a matching text node for "%s" in <%s>.', a, r.nodeName.toLowerCase());
      }
    }
    function bj(r, a, d) {
      switch (a) {
        case "input":
          qy(r, d);
          return;
        case "textarea":
          fg(r, d);
          return;
        case "select":
          aw(r, d);
          return;
      }
    }
    var Ev = function() {
    }, Tv = function() {
    };
    {
      var yj = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], PM = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], Cj = PM.concat(["button"]), Sj = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], MM = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Tv = function(r, a) {
        var d = On({}, r || MM), p = {
          tag: a
        };
        return PM.indexOf(a) !== -1 && (d.aTagInScope = null, d.buttonTagInScope = null, d.nobrTagInScope = null), Cj.indexOf(a) !== -1 && (d.pTagInButtonScope = null), yj.indexOf(a) !== -1 && a !== "address" && a !== "div" && a !== "p" && (d.listItemTagAutoclosing = null, d.dlItemTagAutoclosing = null), d.current = p, a === "form" && (d.formTag = p), a === "a" && (d.aTagInScope = p), a === "button" && (d.buttonTagInScope = p), a === "nobr" && (d.nobrTagInScope = p), a === "p" && (d.pTagInButtonScope = p), a === "li" && (d.listItemTagAutoclosing = p), (a === "dd" || a === "dt") && (d.dlItemTagAutoclosing = p), d;
      };
      var xj = function(r, a) {
        switch (a) {
          case "select":
            return r === "option" || r === "optgroup" || r === "#text";
          case "optgroup":
            return r === "option" || r === "#text";
          case "option":
            return r === "#text";
          case "tr":
            return r === "th" || r === "td" || r === "style" || r === "script" || r === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return r === "tr" || r === "style" || r === "script" || r === "template";
          case "colgroup":
            return r === "col" || r === "template";
          case "table":
            return r === "caption" || r === "colgroup" || r === "tbody" || r === "tfoot" || r === "thead" || r === "style" || r === "script" || r === "template";
          case "head":
            return r === "base" || r === "basefont" || r === "bgsound" || r === "link" || r === "meta" || r === "title" || r === "noscript" || r === "noframes" || r === "style" || r === "script" || r === "template";
          case "html":
            return r === "head" || r === "body" || r === "frameset";
          case "frameset":
            return r === "frame";
          case "#document":
            return r === "html";
        }
        switch (r) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a !== "h1" && a !== "h2" && a !== "h3" && a !== "h4" && a !== "h5" && a !== "h6";
          case "rp":
          case "rt":
            return Sj.indexOf(a) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return a == null;
        }
        return !0;
      }, wj = function(r, a) {
        switch (r) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a.pTagInButtonScope;
          case "form":
            return a.formTag || a.pTagInButtonScope;
          case "li":
            return a.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return a.dlItemTagAutoclosing;
          case "button":
            return a.buttonTagInScope;
          case "a":
            return a.aTagInScope;
          case "nobr":
            return a.nobrTagInScope;
        }
        return null;
      }, IM = {};
      Ev = function(r, a, d) {
        d = d || MM;
        var p = d.current, y = p && p.tag;
        a != null && (r != null && f("validateDOMNesting: when childText is passed, childTag should be null"), r = "#text");
        var R = xj(r, y) ? null : p, D = R ? null : wj(r, d), j = R || D;
        if (j) {
          var Q = j.tag, re = !!R + "|" + r + "|" + Q;
          if (!IM[re]) {
            IM[re] = !0;
            var ae = r, ke = "";
            if (r === "#text" ? /\S/.test(a) ? ae = "Text nodes" : (ae = "Whitespace text nodes", ke = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : ae = "<" + r + ">", R) {
              var Ee = "";
              Q === "table" && r === "tr" && (Ee += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), f("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", ae, Q, ke, Ee);
            } else
              f("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", ae, Q);
          }
        }
      };
    }
    var b0 = "suppressHydrationWarning", y0 = "$", C0 = "/$", Ov = "$?", Rv = "$!", Ej = "style", Qw = null, Zw = null;
    function Tj(r) {
      var a, d, p = r.nodeType;
      switch (p) {
        case Ei:
        case Xs: {
          a = p === Ei ? "#document" : "#fragment";
          var y = r.documentElement;
          d = y ? y.namespaceURI : mg(null, "");
          break;
        }
        default: {
          var R = p === qr ? r.parentNode : r, D = R.namespaceURI || null;
          a = R.tagName, d = mg(D, a);
          break;
        }
      }
      {
        var j = a.toLowerCase(), Q = Tv(null, j);
        return {
          namespace: d,
          ancestorInfo: Q
        };
      }
    }
    function Oj(r, a, d) {
      {
        var p = r, y = mg(p.namespace, a), R = Tv(p.ancestorInfo, a);
        return {
          namespace: y,
          ancestorInfo: R
        };
      }
    }
    function rSe(r) {
      return r;
    }
    function Rj(r) {
      Qw = Da(), Zw = BB();
      var a = null;
      return go(!1), a;
    }
    function kj(r) {
      jB(Zw), go(Qw), Qw = null, Zw = null;
    }
    function Pj(r, a, d, p, y) {
      var R;
      {
        var D = p;
        if (Ev(r, null, D.ancestorInfo), typeof a.children == "string" || typeof a.children == "number") {
          var j = "" + a.children, Q = Tv(D.ancestorInfo, r);
          Ev(null, j, Q);
        }
        R = D.namespace;
      }
      var re = uj(r, a, d, R);
      return Mv(y, re), iE(re, a), re;
    }
    function Mj(r, a) {
      r.appendChild(a);
    }
    function Ij(r, a, d, p, y) {
      switch (fj(r, a, d, p), a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!d.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function Nj(r, a, d, p, y, R) {
      {
        var D = R;
        if (typeof p.children != typeof d.children && (typeof p.children == "string" || typeof p.children == "number")) {
          var j = "" + p.children, Q = Tv(D.ancestorInfo, a);
          Ev(null, j, Q);
        }
      }
      return pj(r, a, d, p);
    }
    function Jw(r, a) {
      return r === "textarea" || r === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
    }
    function $j(r, a, d, p) {
      {
        var y = d;
        Ev(null, r, y.ancestorInfo);
      }
      var R = dj(r, a);
      return Mv(p, R), R;
    }
    function Dj() {
      var r = window.event;
      return r === void 0 ? Sl : Yo(r.type);
    }
    var eE = typeof setTimeout == "function" ? setTimeout : void 0, _j = typeof clearTimeout == "function" ? clearTimeout : void 0, tE = -1, NM = typeof Promise == "function" ? Promise : void 0, Aj = typeof queueMicrotask == "function" ? queueMicrotask : typeof NM < "u" ? function(r) {
      return NM.resolve(null).then(r).catch(Lj);
    } : eE;
    function Lj(r) {
      setTimeout(function() {
        throw r;
      });
    }
    function Fj(r, a, d, p) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          d.autoFocus && r.focus();
          return;
        case "img": {
          d.src && (r.src = d.src);
          return;
        }
      }
    }
    function zj(r, a, d, p, y, R) {
      mj(r, a, d, p, y), iE(r, y);
    }
    function $M(r) {
      Ep(r, "");
    }
    function Vj(r, a, d) {
      r.nodeValue = d;
    }
    function Bj(r, a) {
      r.appendChild(a);
    }
    function jj(r, a) {
      var d;
      r.nodeType === qr ? (d = r.parentNode, d.insertBefore(a, r)) : (d = r, d.appendChild(a));
      var p = r._reactRootContainer;
      p == null && d.onclick === null && v0(d);
    }
    function Hj(r, a, d) {
      r.insertBefore(a, d);
    }
    function Uj(r, a, d) {
      r.nodeType === qr ? r.parentNode.insertBefore(a, d) : r.insertBefore(a, d);
    }
    function Gj(r, a) {
      r.removeChild(a);
    }
    function Wj(r, a) {
      r.nodeType === qr ? r.parentNode.removeChild(a) : r.removeChild(a);
    }
    function nE(r, a) {
      var d = a, p = 0;
      do {
        var y = d.nextSibling;
        if (r.removeChild(d), y && y.nodeType === qr) {
          var R = y.data;
          if (R === C0)
            if (p === 0) {
              r.removeChild(y), Rn(a);
              return;
            } else
              p--;
          else
            (R === y0 || R === Ov || R === Rv) && p++;
        }
        d = y;
      } while (d);
      Rn(a);
    }
    function qj(r, a) {
      r.nodeType === qr ? nE(r.parentNode, a) : r.nodeType === sa && nE(r, a), Rn(r);
    }
    function Yj(r) {
      r = r;
      var a = r.style;
      typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function Kj(r) {
      r.nodeValue = "";
    }
    function Xj(r, a) {
      r = r;
      var d = a[Ej], p = d != null && d.hasOwnProperty("display") ? d.display : null;
      r.style.display = Tp("display", p);
    }
    function Qj(r, a) {
      r.nodeValue = a;
    }
    function Zj(r) {
      r.nodeType === sa ? r.textContent = "" : r.nodeType === Ei && r.documentElement && r.removeChild(r.documentElement);
    }
    function Jj(r, a, d) {
      return r.nodeType !== sa || a.toLowerCase() !== r.nodeName.toLowerCase() ? null : r;
    }
    function eH(r, a) {
      return a === "" || r.nodeType !== fl ? null : r;
    }
    function tH(r) {
      return r.nodeType !== qr ? null : r;
    }
    function DM(r) {
      return r.data === Ov;
    }
    function rE(r) {
      return r.data === Rv;
    }
    function nH(r) {
      var a = r.nextSibling && r.nextSibling.dataset, d, p, y;
      return a && (d = a.dgst, p = a.msg, y = a.stck), {
        message: p,
        digest: d,
        stack: y
      };
    }
    function rH(r, a) {
      r._reactRetry = a;
    }
    function S0(r) {
      for (; r != null; r = r.nextSibling) {
        var a = r.nodeType;
        if (a === sa || a === fl)
          break;
        if (a === qr) {
          var d = r.data;
          if (d === y0 || d === Rv || d === Ov)
            break;
          if (d === C0)
            return null;
        }
      }
      return r;
    }
    function kv(r) {
      return S0(r.nextSibling);
    }
    function oH(r) {
      return S0(r.firstChild);
    }
    function aH(r) {
      return S0(r.firstChild);
    }
    function iH(r) {
      return S0(r.nextSibling);
    }
    function lH(r, a, d, p, y, R, D) {
      Mv(R, r), iE(r, d);
      var j;
      {
        var Q = y;
        j = Q.namespace;
      }
      var re = (R.mode & xn) !== tn;
      return gj(r, a, d, j, p, re, D);
    }
    function sH(r, a, d, p) {
      return Mv(d, r), d.mode & xn, vj(r, a);
    }
    function cH(r, a) {
      Mv(a, r);
    }
    function uH(r) {
      for (var a = r.nextSibling, d = 0; a; ) {
        if (a.nodeType === qr) {
          var p = a.data;
          if (p === C0) {
            if (d === 0)
              return kv(a);
            d--;
          } else
            (p === y0 || p === Rv || p === Ov) && d++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function _M(r) {
      for (var a = r.previousSibling, d = 0; a; ) {
        if (a.nodeType === qr) {
          var p = a.data;
          if (p === y0 || p === Rv || p === Ov) {
            if (d === 0)
              return a;
            d--;
          } else
            p === C0 && d++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function dH(r) {
      Rn(r);
    }
    function fH(r) {
      Rn(r);
    }
    function pH(r) {
      return r !== "head" && r !== "body";
    }
    function mH(r, a, d, p) {
      var y = !0;
      g0(a.nodeValue, d, p, y);
    }
    function hH(r, a, d, p, y, R) {
      if (a[b0] !== !0) {
        var D = !0;
        g0(p.nodeValue, y, R, D);
      }
    }
    function gH(r, a) {
      a.nodeType === sa ? qw(r, a) : a.nodeType === qr || Yw(r, a);
    }
    function vH(r, a) {
      {
        var d = r.parentNode;
        d !== null && (a.nodeType === sa ? qw(d, a) : a.nodeType === qr || Yw(d, a));
      }
    }
    function bH(r, a, d, p, y) {
      (y || a[b0] !== !0) && (p.nodeType === sa ? qw(d, p) : p.nodeType === qr || Yw(d, p));
    }
    function yH(r, a, d) {
      Kw(r, a);
    }
    function CH(r, a) {
      Xw(r, a);
    }
    function SH(r, a, d) {
      {
        var p = r.parentNode;
        p !== null && Kw(p, a);
      }
    }
    function xH(r, a) {
      {
        var d = r.parentNode;
        d !== null && Xw(d, a);
      }
    }
    function wH(r, a, d, p, y, R) {
      (R || a[b0] !== !0) && Kw(d, p);
    }
    function EH(r, a, d, p, y) {
      (y || a[b0] !== !0) && Xw(d, p);
    }
    function TH(r) {
      f("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", r.nodeName.toLowerCase());
    }
    function OH(r) {
      Cv(r);
    }
    var Im = Math.random().toString(36).slice(2), Nm = "__reactFiber$" + Im, oE = "__reactProps$" + Im, Pv = "__reactContainer$" + Im, aE = "__reactEvents$" + Im, RH = "__reactListeners$" + Im, kH = "__reactHandles$" + Im;
    function PH(r) {
      delete r[Nm], delete r[oE], delete r[aE], delete r[RH], delete r[kH];
    }
    function Mv(r, a) {
      a[Nm] = r;
    }
    function x0(r, a) {
      a[Pv] = r;
    }
    function AM(r) {
      r[Pv] = null;
    }
    function Iv(r) {
      return !!r[Pv];
    }
    function hf(r) {
      var a = r[Nm];
      if (a)
        return a;
      for (var d = r.parentNode; d; ) {
        if (a = d[Pv] || d[Nm], a) {
          var p = a.alternate;
          if (a.child !== null || p !== null && p.child !== null)
            for (var y = _M(r); y !== null; ) {
              var R = y[Nm];
              if (R)
                return R;
              y = _M(y);
            }
          return a;
        }
        r = d, d = r.parentNode;
      }
      return null;
    }
    function Nu(r) {
      var a = r[Nm] || r[Pv];
      return a && (a.tag === T || a.tag === P || a.tag === V || a.tag === x) ? a : null;
    }
    function $m(r) {
      if (r.tag === T || r.tag === P)
        return r.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function w0(r) {
      return r[oE] || null;
    }
    function iE(r, a) {
      r[oE] = a;
    }
    function MH(r) {
      var a = r[aE];
      return a === void 0 && (a = r[aE] = /* @__PURE__ */ new Set()), a;
    }
    var LM = {}, FM = o.ReactDebugCurrentFrame;
    function E0(r) {
      if (r) {
        var a = r._owner, d = wd(r.type, r._source, a ? a.type : null);
        FM.setExtraStackFrame(d);
      } else
        FM.setExtraStackFrame(null);
    }
    function Ol(r, a, d, p, y) {
      {
        var R = Function.call.bind(ce);
        for (var D in r)
          if (R(r, D)) {
            var j = void 0;
            try {
              if (typeof r[D] != "function") {
                var Q = Error((p || "React class") + ": " + d + " type `" + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[D] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Q.name = "Invariant Violation", Q;
              }
              j = r[D](a, D, p, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (re) {
              j = re;
            }
            j && !(j instanceof Error) && (E0(y), f("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", d, D, typeof j), E0(null)), j instanceof Error && !(j.message in LM) && (LM[j.message] = !0, E0(y), f("Failed %s type: %s", d, j.message), E0(null));
          }
      }
    }
    var lE = [], T0;
    T0 = [];
    var Ec = -1;
    function $u(r) {
      return {
        current: r
      };
    }
    function va(r, a) {
      if (Ec < 0) {
        f("Unexpected pop.");
        return;
      }
      a !== T0[Ec] && f("Unexpected Fiber popped."), r.current = lE[Ec], lE[Ec] = null, T0[Ec] = null, Ec--;
    }
    function ba(r, a, d) {
      Ec++, lE[Ec] = r.current, T0[Ec] = d, r.current = a;
    }
    var sE;
    sE = {};
    var Pi = {};
    Object.freeze(Pi);
    var Tc = $u(Pi), xs = $u(!1), cE = Pi;
    function Dm(r, a, d) {
      return d && ws(a) ? cE : Tc.current;
    }
    function zM(r, a, d) {
      {
        var p = r.stateNode;
        p.__reactInternalMemoizedUnmaskedChildContext = a, p.__reactInternalMemoizedMaskedChildContext = d;
      }
    }
    function _m(r, a) {
      {
        var d = r.type, p = d.contextTypes;
        if (!p)
          return Pi;
        var y = r.stateNode;
        if (y && y.__reactInternalMemoizedUnmaskedChildContext === a)
          return y.__reactInternalMemoizedMaskedChildContext;
        var R = {};
        for (var D in p)
          R[D] = a[D];
        {
          var j = mn(r) || "Unknown";
          Ol(p, R, "context", j);
        }
        return y && zM(r, a, R), R;
      }
    }
    function O0() {
      return xs.current;
    }
    function ws(r) {
      {
        var a = r.childContextTypes;
        return a != null;
      }
    }
    function R0(r) {
      va(xs, r), va(Tc, r);
    }
    function uE(r) {
      va(xs, r), va(Tc, r);
    }
    function VM(r, a, d) {
      {
        if (Tc.current !== Pi)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ba(Tc, a, r), ba(xs, d, r);
      }
    }
    function BM(r, a, d) {
      {
        var p = r.stateNode, y = a.childContextTypes;
        if (typeof p.getChildContext != "function") {
          {
            var R = mn(r) || "Unknown";
            sE[R] || (sE[R] = !0, f("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", R, R));
          }
          return d;
        }
        var D = p.getChildContext();
        for (var j in D)
          if (!(j in y))
            throw new Error((mn(r) || "Unknown") + '.getChildContext(): key "' + j + '" is not defined in childContextTypes.');
        {
          var Q = mn(r) || "Unknown";
          Ol(y, D, "child context", Q);
        }
        return On({}, d, D);
      }
    }
    function k0(r) {
      {
        var a = r.stateNode, d = a && a.__reactInternalMemoizedMergedChildContext || Pi;
        return cE = Tc.current, ba(Tc, d, r), ba(xs, xs.current, r), !0;
      }
    }
    function jM(r, a, d) {
      {
        var p = r.stateNode;
        if (!p)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (d) {
          var y = BM(r, a, cE);
          p.__reactInternalMemoizedMergedChildContext = y, va(xs, r), va(Tc, r), ba(Tc, y, r), ba(xs, d, r);
        } else
          va(xs, r), ba(xs, d, r);
      }
    }
    function IH(r) {
      {
        if (!Dg(r) || r.tag !== v)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = r;
        do {
          switch (a.tag) {
            case x:
              return a.stateNode.context;
            case v: {
              var d = a.type;
              if (ws(d))
                return a.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Du = 0, P0 = 1, Oc = null, dE = !1, fE = !1;
    function HM(r) {
      Oc === null ? Oc = [r] : Oc.push(r);
    }
    function NH(r) {
      dE = !0, HM(r);
    }
    function UM() {
      dE && _u();
    }
    function _u() {
      if (!fE && Oc !== null) {
        fE = !0;
        var r = 0, a = ti();
        try {
          var d = !0, p = Oc;
          for (ao(jo); r < p.length; r++) {
            var y = p[r];
            do
              y = y(d);
            while (y !== null);
          }
          Oc = null, dE = !1;
        } catch (R) {
          throw Oc !== null && (Oc = Oc.slice(r + 1)), Ap(Fp, _u), R;
        } finally {
          ao(a), fE = !1;
        }
      }
      return null;
    }
    var Am = [], Lm = 0, M0 = null, I0 = 0, Wi = [], qi = 0, gf = null, Rc = 1, kc = "";
    function $H(r) {
      return bf(), (r.flags & Ig) !== Jt;
    }
    function DH(r) {
      return bf(), I0;
    }
    function _H() {
      var r = kc, a = Rc, d = a & ~AH(a);
      return d.toString(32) + r;
    }
    function vf(r, a) {
      bf(), Am[Lm++] = I0, Am[Lm++] = M0, M0 = r, I0 = a;
    }
    function GM(r, a, d) {
      bf(), Wi[qi++] = Rc, Wi[qi++] = kc, Wi[qi++] = gf, gf = r;
      var p = Rc, y = kc, R = N0(p) - 1, D = p & ~(1 << R), j = d + 1, Q = N0(a) + R;
      if (Q > 30) {
        var re = R - R % 5, ae = (1 << re) - 1, ke = (D & ae).toString(32), Ee = D >> re, He = R - re, Ue = N0(a) + He, Ke = j << He, $t = Ke | Ee, en = ke + y;
        Rc = 1 << Ue | $t, kc = en;
      } else {
        var Kt = j << R, In = Kt | D, kn = y;
        Rc = 1 << Q | In, kc = kn;
      }
    }
    function pE(r) {
      bf();
      var a = r.return;
      if (a !== null) {
        var d = 1, p = 0;
        vf(r, d), GM(r, d, p);
      }
    }
    function N0(r) {
      return 32 - Up(r);
    }
    function AH(r) {
      return 1 << N0(r) - 1;
    }
    function mE(r) {
      for (; r === M0; )
        M0 = Am[--Lm], Am[Lm] = null, I0 = Am[--Lm], Am[Lm] = null;
      for (; r === gf; )
        gf = Wi[--qi], Wi[qi] = null, kc = Wi[--qi], Wi[qi] = null, Rc = Wi[--qi], Wi[qi] = null;
    }
    function LH() {
      return bf(), gf !== null ? {
        id: Rc,
        overflow: kc
      } : null;
    }
    function FH(r, a) {
      bf(), Wi[qi++] = Rc, Wi[qi++] = kc, Wi[qi++] = gf, Rc = a.id, kc = a.overflow, gf = r;
    }
    function bf() {
      Xo() || f("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Ko = null, Yi = null, Rl = !1, yf = !1, Au = null;
    function zH() {
      Rl && f("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function WM() {
      yf = !0;
    }
    function VH() {
      return yf;
    }
    function BH(r) {
      var a = r.stateNode.containerInfo;
      return Yi = aH(a), Ko = r, Rl = !0, Au = null, yf = !1, !0;
    }
    function jH(r, a, d) {
      return Yi = iH(a), Ko = r, Rl = !0, Au = null, yf = !1, d !== null && FH(r, d), !0;
    }
    function qM(r, a) {
      switch (r.tag) {
        case x: {
          gH(r.stateNode.containerInfo, a);
          break;
        }
        case T: {
          var d = (r.mode & xn) !== tn;
          bH(
            r.type,
            r.memoizedProps,
            r.stateNode,
            a,
            // TODO: Delete this argument when we remove the legacy root API.
            d
          );
          break;
        }
        case V: {
          var p = r.memoizedState;
          p.dehydrated !== null && vH(p.dehydrated, a);
          break;
        }
      }
    }
    function YM(r, a) {
      qM(r, a);
      var d = G6();
      d.stateNode = a, d.return = r;
      var p = r.deletions;
      p === null ? (r.deletions = [d], r.flags |= jn) : p.push(d);
    }
    function hE(r, a) {
      {
        if (yf)
          return;
        switch (r.tag) {
          case x: {
            var d = r.stateNode.containerInfo;
            switch (a.tag) {
              case T:
                var p = a.type;
                a.pendingProps, yH(d, p);
                break;
              case P:
                var y = a.pendingProps;
                CH(d, y);
                break;
            }
            break;
          }
          case T: {
            var R = r.type, D = r.memoizedProps, j = r.stateNode;
            switch (a.tag) {
              case T: {
                var Q = a.type, re = a.pendingProps, ae = (r.mode & xn) !== tn;
                wH(
                  R,
                  D,
                  j,
                  Q,
                  re,
                  // TODO: Delete this argument when we remove the legacy root API.
                  ae
                );
                break;
              }
              case P: {
                var ke = a.pendingProps, Ee = (r.mode & xn) !== tn;
                EH(
                  R,
                  D,
                  j,
                  ke,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ee
                );
                break;
              }
            }
            break;
          }
          case V: {
            var He = r.memoizedState, Ue = He.dehydrated;
            if (Ue !== null)
              switch (a.tag) {
                case T:
                  var Ke = a.type;
                  a.pendingProps, SH(Ue, Ke);
                  break;
                case P:
                  var $t = a.pendingProps;
                  xH(Ue, $t);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function KM(r, a) {
      a.flags = a.flags & ~Xa | hr, hE(r, a);
    }
    function XM(r, a) {
      switch (r.tag) {
        case T: {
          var d = r.type;
          r.pendingProps;
          var p = Jj(a, d);
          return p !== null ? (r.stateNode = p, Ko = r, Yi = oH(p), !0) : !1;
        }
        case P: {
          var y = r.pendingProps, R = eH(a, y);
          return R !== null ? (r.stateNode = R, Ko = r, Yi = null, !0) : !1;
        }
        case V: {
          var D = tH(a);
          if (D !== null) {
            var j = {
              dehydrated: D,
              treeContext: LH(),
              retryLane: ha
            };
            r.memoizedState = j;
            var Q = W6(D);
            return Q.return = r, r.child = Q, Ko = r, Yi = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function gE(r) {
      return (r.mode & xn) !== tn && (r.flags & sn) === Jt;
    }
    function vE(r) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function bE(r) {
      if (Rl) {
        var a = Yi;
        if (!a) {
          gE(r) && (hE(Ko, r), vE()), KM(Ko, r), Rl = !1, Ko = r;
          return;
        }
        var d = a;
        if (!XM(r, a)) {
          gE(r) && (hE(Ko, r), vE()), a = kv(d);
          var p = Ko;
          if (!a || !XM(r, a)) {
            KM(Ko, r), Rl = !1, Ko = r;
            return;
          }
          YM(p, d);
        }
      }
    }
    function HH(r, a, d) {
      var p = r.stateNode, y = !yf, R = lH(p, r.type, r.memoizedProps, a, d, r, y);
      return r.updateQueue = R, R !== null;
    }
    function UH(r) {
      var a = r.stateNode, d = r.memoizedProps, p = sH(a, d, r);
      if (p) {
        var y = Ko;
        if (y !== null)
          switch (y.tag) {
            case x: {
              var R = y.stateNode.containerInfo, D = (y.mode & xn) !== tn;
              mH(
                R,
                a,
                d,
                // TODO: Delete this argument when we remove the legacy root API.
                D
              );
              break;
            }
            case T: {
              var j = y.type, Q = y.memoizedProps, re = y.stateNode, ae = (y.mode & xn) !== tn;
              hH(
                j,
                Q,
                re,
                a,
                d,
                // TODO: Delete this argument when we remove the legacy root API.
                ae
              );
              break;
            }
          }
      }
      return p;
    }
    function GH(r) {
      var a = r.memoizedState, d = a !== null ? a.dehydrated : null;
      if (!d)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      cH(d, r);
    }
    function WH(r) {
      var a = r.memoizedState, d = a !== null ? a.dehydrated : null;
      if (!d)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return uH(d);
    }
    function QM(r) {
      for (var a = r.return; a !== null && a.tag !== T && a.tag !== x && a.tag !== V; )
        a = a.return;
      Ko = a;
    }
    function $0(r) {
      if (r !== Ko)
        return !1;
      if (!Rl)
        return QM(r), Rl = !0, !1;
      if (r.tag !== x && (r.tag !== T || pH(r.type) && !Jw(r.type, r.memoizedProps))) {
        var a = Yi;
        if (a)
          if (gE(r))
            ZM(r), vE();
          else
            for (; a; )
              YM(r, a), a = kv(a);
      }
      return QM(r), r.tag === V ? Yi = WH(r) : Yi = Ko ? kv(r.stateNode) : null, !0;
    }
    function qH() {
      return Rl && Yi !== null;
    }
    function ZM(r) {
      for (var a = Yi; a; )
        qM(r, a), a = kv(a);
    }
    function Fm() {
      Ko = null, Yi = null, Rl = !1, yf = !1;
    }
    function JM() {
      Au !== null && (qN(Au), Au = null);
    }
    function Xo() {
      return Rl;
    }
    function yE(r) {
      Au === null ? Au = [r] : Au.push(r);
    }
    var YH = o.ReactCurrentBatchConfig, KH = null;
    function XH() {
      return YH.transition;
    }
    var kl = {
      recordUnsafeLifecycleWarnings: function(r, a) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(r, a) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var QH = function(r) {
        for (var a = null, d = r; d !== null; )
          d.mode & Rr && (a = d), d = d.return;
        return a;
      }, Cf = function(r) {
        var a = [];
        return r.forEach(function(d) {
          a.push(d);
        }), a.sort().join(", ");
      }, Nv = [], $v = [], Dv = [], _v = [], Av = [], Lv = [], Sf = /* @__PURE__ */ new Set();
      kl.recordUnsafeLifecycleWarnings = function(r, a) {
        Sf.has(r.type) || (typeof a.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && Nv.push(r), r.mode & Rr && typeof a.UNSAFE_componentWillMount == "function" && $v.push(r), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Dv.push(r), r.mode & Rr && typeof a.UNSAFE_componentWillReceiveProps == "function" && _v.push(r), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && Av.push(r), r.mode & Rr && typeof a.UNSAFE_componentWillUpdate == "function" && Lv.push(r));
      }, kl.flushPendingUnsafeLifecycleWarnings = function() {
        var r = /* @__PURE__ */ new Set();
        Nv.length > 0 && (Nv.forEach(function(Ee) {
          r.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), Nv = []);
        var a = /* @__PURE__ */ new Set();
        $v.length > 0 && ($v.forEach(function(Ee) {
          a.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), $v = []);
        var d = /* @__PURE__ */ new Set();
        Dv.length > 0 && (Dv.forEach(function(Ee) {
          d.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), Dv = []);
        var p = /* @__PURE__ */ new Set();
        _v.length > 0 && (_v.forEach(function(Ee) {
          p.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), _v = []);
        var y = /* @__PURE__ */ new Set();
        Av.length > 0 && (Av.forEach(function(Ee) {
          y.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), Av = []);
        var R = /* @__PURE__ */ new Set();
        if (Lv.length > 0 && (Lv.forEach(function(Ee) {
          R.add(mn(Ee) || "Component"), Sf.add(Ee.type);
        }), Lv = []), a.size > 0) {
          var D = Cf(a);
          f(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, D);
        }
        if (p.size > 0) {
          var j = Cf(p);
          f(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, j);
        }
        if (R.size > 0) {
          var Q = Cf(R);
          f(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, Q);
        }
        if (r.size > 0) {
          var re = Cf(r);
          c(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, re);
        }
        if (d.size > 0) {
          var ae = Cf(d);
          c(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ae);
        }
        if (y.size > 0) {
          var ke = Cf(y);
          c(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ke);
        }
      };
      var D0 = /* @__PURE__ */ new Map(), eI = /* @__PURE__ */ new Set();
      kl.recordLegacyContextWarning = function(r, a) {
        var d = QH(r);
        if (d === null) {
          f("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!eI.has(r.type)) {
          var p = D0.get(d);
          (r.type.contextTypes != null || r.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (p === void 0 && (p = [], D0.set(d, p)), p.push(r));
        }
      }, kl.flushLegacyContextWarning = function() {
        D0.forEach(function(r, a) {
          if (r.length !== 0) {
            var d = r[0], p = /* @__PURE__ */ new Set();
            r.forEach(function(R) {
              p.add(mn(R) || "Component"), eI.add(R.type);
            });
            var y = Cf(p);
            try {
              Jn(d), f(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, y);
            } finally {
              no();
            }
          }
        });
      }, kl.discardPendingWarnings = function() {
        Nv = [], $v = [], Dv = [], _v = [], Av = [], Lv = [], D0 = /* @__PURE__ */ new Map();
      };
    }
    function Pl(r, a) {
      if (r && r.defaultProps) {
        var d = On({}, a), p = r.defaultProps;
        for (var y in p)
          d[y] === void 0 && (d[y] = p[y]);
        return d;
      }
      return a;
    }
    var CE = $u(null), SE;
    SE = {};
    var _0 = null, zm = null, xE = null, A0 = !1;
    function L0() {
      _0 = null, zm = null, xE = null, A0 = !1;
    }
    function tI() {
      A0 = !0;
    }
    function nI() {
      A0 = !1;
    }
    function rI(r, a, d) {
      ba(CE, a._currentValue, r), a._currentValue = d, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== SE && f("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = SE;
    }
    function wE(r, a) {
      var d = CE.current;
      va(CE, a), r._currentValue = d;
    }
    function EE(r, a, d) {
      for (var p = r; p !== null; ) {
        var y = p.alternate;
        if (pc(p.childLanes, a) ? y !== null && !pc(y.childLanes, a) && (y.childLanes = vn(y.childLanes, a)) : (p.childLanes = vn(p.childLanes, a), y !== null && (y.childLanes = vn(y.childLanes, a))), p === d)
          break;
        p = p.return;
      }
      p !== d && f("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ZH(r, a, d) {
      JH(r, a, d);
    }
    function JH(r, a, d) {
      var p = r.child;
      for (p !== null && (p.return = r); p !== null; ) {
        var y = void 0, R = p.dependencies;
        if (R !== null) {
          y = p.child;
          for (var D = R.firstContext; D !== null; ) {
            if (D.context === a) {
              if (p.tag === v) {
                var j = oo(d), Q = Pc(pr, j);
                Q.tag = z0;
                var re = p.updateQueue;
                if (re !== null) {
                  var ae = re.shared, ke = ae.pending;
                  ke === null ? Q.next = Q : (Q.next = ke.next, ke.next = Q), ae.pending = Q;
                }
              }
              p.lanes = vn(p.lanes, d);
              var Ee = p.alternate;
              Ee !== null && (Ee.lanes = vn(Ee.lanes, d)), EE(p.return, d, r), R.lanes = vn(R.lanes, d);
              break;
            }
            D = D.next;
          }
        } else if (p.tag === $)
          y = p.type === r.type ? null : p.child;
        else if (p.tag === H) {
          var He = p.return;
          if (He === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          He.lanes = vn(He.lanes, d);
          var Ue = He.alternate;
          Ue !== null && (Ue.lanes = vn(Ue.lanes, d)), EE(He, d, r), y = p.sibling;
        } else
          y = p.child;
        if (y !== null)
          y.return = p;
        else
          for (y = p; y !== null; ) {
            if (y === r) {
              y = null;
              break;
            }
            var Ke = y.sibling;
            if (Ke !== null) {
              Ke.return = y.return, y = Ke;
              break;
            }
            y = y.return;
          }
        p = y;
      }
    }
    function Vm(r, a) {
      _0 = r, zm = null, xE = null;
      var d = r.dependencies;
      if (d !== null) {
        var p = d.firstContext;
        p !== null && (ga(d.lanes, a) && Qv(), d.firstContext = null);
      }
    }
    function bo(r) {
      A0 && f("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = r._currentValue;
      if (xE !== r) {
        var d = {
          context: r,
          memoizedValue: a,
          next: null
        };
        if (zm === null) {
          if (_0 === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          zm = d, _0.dependencies = {
            lanes: nt,
            firstContext: d
          };
        } else
          zm = zm.next = d;
      }
      return a;
    }
    var xf = null;
    function TE(r) {
      xf === null ? xf = [r] : xf.push(r);
    }
    function eU() {
      if (xf !== null) {
        for (var r = 0; r < xf.length; r++) {
          var a = xf[r], d = a.interleaved;
          if (d !== null) {
            a.interleaved = null;
            var p = d.next, y = a.pending;
            if (y !== null) {
              var R = y.next;
              y.next = p, d.next = R;
            }
            a.pending = d;
          }
        }
        xf = null;
      }
    }
    function oI(r, a, d, p) {
      var y = a.interleaved;
      return y === null ? (d.next = d, TE(a)) : (d.next = y.next, y.next = d), a.interleaved = d, F0(r, p);
    }
    function tU(r, a, d, p) {
      var y = a.interleaved;
      y === null ? (d.next = d, TE(a)) : (d.next = y.next, y.next = d), a.interleaved = d;
    }
    function nU(r, a, d, p) {
      var y = a.interleaved;
      return y === null ? (d.next = d, TE(a)) : (d.next = y.next, y.next = d), a.interleaved = d, F0(r, p);
    }
    function ii(r, a) {
      return F0(r, a);
    }
    var rU = F0;
    function F0(r, a) {
      r.lanes = vn(r.lanes, a);
      var d = r.alternate;
      d !== null && (d.lanes = vn(d.lanes, a)), d === null && (r.flags & (hr | Xa)) !== Jt && a$(r);
      for (var p = r, y = r.return; y !== null; )
        y.childLanes = vn(y.childLanes, a), d = y.alternate, d !== null ? d.childLanes = vn(d.childLanes, a) : (y.flags & (hr | Xa)) !== Jt && a$(r), p = y, y = y.return;
      if (p.tag === x) {
        var R = p.stateNode;
        return R;
      } else
        return null;
    }
    var aI = 0, iI = 1, z0 = 2, OE = 3, V0 = !1, RE, B0;
    RE = !1, B0 = null;
    function kE(r) {
      var a = {
        baseState: r.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: nt
        },
        effects: null
      };
      r.updateQueue = a;
    }
    function lI(r, a) {
      var d = a.updateQueue, p = r.updateQueue;
      if (d === p) {
        var y = {
          baseState: p.baseState,
          firstBaseUpdate: p.firstBaseUpdate,
          lastBaseUpdate: p.lastBaseUpdate,
          shared: p.shared,
          effects: p.effects
        };
        a.updateQueue = y;
      }
    }
    function Pc(r, a) {
      var d = {
        eventTime: r,
        lane: a,
        tag: aI,
        payload: null,
        callback: null,
        next: null
      };
      return d;
    }
    function Lu(r, a, d) {
      var p = r.updateQueue;
      if (p === null)
        return null;
      var y = p.shared;
      if (B0 === y && !RE && (f("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), RE = !0), r6()) {
        var R = y.pending;
        return R === null ? a.next = a : (a.next = R.next, R.next = a), y.pending = a, rU(r, d);
      } else
        return nU(r, y, a, d);
    }
    function j0(r, a, d) {
      var p = a.updateQueue;
      if (p !== null) {
        var y = p.shared;
        if (qg(d)) {
          var R = y.lanes;
          R = Kg(R, r.pendingLanes);
          var D = vn(R, d);
          y.lanes = D, vu(r, D);
        }
      }
    }
    function PE(r, a) {
      var d = r.updateQueue, p = r.alternate;
      if (p !== null) {
        var y = p.updateQueue;
        if (d === y) {
          var R = null, D = null, j = d.firstBaseUpdate;
          if (j !== null) {
            var Q = j;
            do {
              var re = {
                eventTime: Q.eventTime,
                lane: Q.lane,
                tag: Q.tag,
                payload: Q.payload,
                callback: Q.callback,
                next: null
              };
              D === null ? R = D = re : (D.next = re, D = re), Q = Q.next;
            } while (Q !== null);
            D === null ? R = D = a : (D.next = a, D = a);
          } else
            R = D = a;
          d = {
            baseState: y.baseState,
            firstBaseUpdate: R,
            lastBaseUpdate: D,
            shared: y.shared,
            effects: y.effects
          }, r.updateQueue = d;
          return;
        }
      }
      var ae = d.lastBaseUpdate;
      ae === null ? d.firstBaseUpdate = a : ae.next = a, d.lastBaseUpdate = a;
    }
    function oU(r, a, d, p, y, R) {
      switch (d.tag) {
        case iI: {
          var D = d.payload;
          if (typeof D == "function") {
            tI();
            var j = D.call(R, p, y);
            {
              if (r.mode & Rr) {
                ro(!0);
                try {
                  D.call(R, p, y);
                } finally {
                  ro(!1);
                }
              }
              nI();
            }
            return j;
          }
          return D;
        }
        case OE:
          r.flags = r.flags & ~po | sn;
        case aI: {
          var Q = d.payload, re;
          if (typeof Q == "function") {
            tI(), re = Q.call(R, p, y);
            {
              if (r.mode & Rr) {
                ro(!0);
                try {
                  Q.call(R, p, y);
                } finally {
                  ro(!1);
                }
              }
              nI();
            }
          } else
            re = Q;
          return re == null ? p : On({}, p, re);
        }
        case z0:
          return V0 = !0, p;
      }
      return p;
    }
    function H0(r, a, d, p) {
      var y = r.updateQueue;
      V0 = !1, B0 = y.shared;
      var R = y.firstBaseUpdate, D = y.lastBaseUpdate, j = y.shared.pending;
      if (j !== null) {
        y.shared.pending = null;
        var Q = j, re = Q.next;
        Q.next = null, D === null ? R = re : D.next = re, D = Q;
        var ae = r.alternate;
        if (ae !== null) {
          var ke = ae.updateQueue, Ee = ke.lastBaseUpdate;
          Ee !== D && (Ee === null ? ke.firstBaseUpdate = re : Ee.next = re, ke.lastBaseUpdate = Q);
        }
      }
      if (R !== null) {
        var He = y.baseState, Ue = nt, Ke = null, $t = null, en = null, Kt = R;
        do {
          var In = Kt.lane, kn = Kt.eventTime;
          if (pc(p, In)) {
            if (en !== null) {
              var Xe = {
                eventTime: kn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Pn,
                tag: Kt.tag,
                payload: Kt.payload,
                callback: Kt.callback,
                next: null
              };
              en = en.next = Xe;
            }
            He = oU(r, y, Kt, He, a, d);
            var Le = Kt.callback;
            if (Le !== null && // If the update was already committed, we should not queue its
            // callback again.
            Kt.lane !== Pn) {
              r.flags |= Vi;
              var xt = y.effects;
              xt === null ? y.effects = [Kt] : xt.push(Kt);
            }
          } else {
            var Ae = {
              eventTime: kn,
              lane: In,
              tag: Kt.tag,
              payload: Kt.payload,
              callback: Kt.callback,
              next: null
            };
            en === null ? ($t = en = Ae, Ke = He) : en = en.next = Ae, Ue = vn(Ue, In);
          }
          if (Kt = Kt.next, Kt === null) {
            if (j = y.shared.pending, j === null)
              break;
            var Dt = j, Pt = Dt.next;
            Dt.next = null, Kt = Pt, y.lastBaseUpdate = Dt, y.shared.pending = null;
          }
        } while (!0);
        en === null && (Ke = He), y.baseState = Ke, y.firstBaseUpdate = $t, y.lastBaseUpdate = en;
        var ln = y.shared.interleaved;
        if (ln !== null) {
          var pn = ln;
          do
            Ue = vn(Ue, pn.lane), pn = pn.next;
          while (pn !== ln);
        } else
          R === null && (y.shared.lanes = nt);
        cb(Ue), r.lanes = Ue, r.memoizedState = He;
      }
      B0 = null;
    }
    function aU(r, a) {
      if (typeof r != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + r));
      r.call(a);
    }
    function sI() {
      V0 = !1;
    }
    function U0() {
      return V0;
    }
    function cI(r, a, d) {
      var p = a.effects;
      if (a.effects = null, p !== null)
        for (var y = 0; y < p.length; y++) {
          var R = p[y], D = R.callback;
          D !== null && (R.callback = null, aU(D, d));
        }
    }
    var ME = {}, uI = new e.Component().refs, IE, NE, $E, DE, _E, dI, G0, AE, LE, FE;
    {
      IE = /* @__PURE__ */ new Set(), NE = /* @__PURE__ */ new Set(), $E = /* @__PURE__ */ new Set(), DE = /* @__PURE__ */ new Set(), AE = /* @__PURE__ */ new Set(), _E = /* @__PURE__ */ new Set(), LE = /* @__PURE__ */ new Set(), FE = /* @__PURE__ */ new Set();
      var fI = /* @__PURE__ */ new Set();
      G0 = function(r, a) {
        if (!(r === null || typeof r == "function")) {
          var d = a + "_" + r;
          fI.has(d) || (fI.add(d), f("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, r));
        }
      }, dI = function(r, a) {
        if (a === void 0) {
          var d = dr(r) || "Component";
          _E.has(d) || (_E.add(d), f("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", d));
        }
      }, Object.defineProperty(ME, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(ME);
    }
    function zE(r, a, d, p) {
      var y = r.memoizedState, R = d(p, y);
      {
        if (r.mode & Rr) {
          ro(!0);
          try {
            R = d(p, y);
          } finally {
            ro(!1);
          }
        }
        dI(a, R);
      }
      var D = R == null ? y : On({}, y, R);
      if (r.memoizedState = D, r.lanes === nt) {
        var j = r.updateQueue;
        j.baseState = D;
      }
    }
    var VE = {
      isMounted: Ia,
      enqueueSetState: function(r, a, d) {
        var p = Ya(r), y = La(), R = Gu(p), D = Pc(y, R);
        D.payload = a, d != null && (G0(d, "setState"), D.callback = d);
        var j = Lu(p, D, R);
        j !== null && (Do(j, p, R, y), j0(j, p, R)), ps(p, R);
      },
      enqueueReplaceState: function(r, a, d) {
        var p = Ya(r), y = La(), R = Gu(p), D = Pc(y, R);
        D.tag = iI, D.payload = a, d != null && (G0(d, "replaceState"), D.callback = d);
        var j = Lu(p, D, R);
        j !== null && (Do(j, p, R, y), j0(j, p, R)), ps(p, R);
      },
      enqueueForceUpdate: function(r, a) {
        var d = Ya(r), p = La(), y = Gu(d), R = Pc(p, y);
        R.tag = z0, a != null && (G0(a, "forceUpdate"), R.callback = a);
        var D = Lu(d, R, y);
        D !== null && (Do(D, d, y, p), j0(D, d, y)), Hg(d, y);
      }
    };
    function pI(r, a, d, p, y, R, D) {
      var j = r.stateNode;
      if (typeof j.shouldComponentUpdate == "function") {
        var Q = j.shouldComponentUpdate(p, R, D);
        {
          if (r.mode & Rr) {
            ro(!0);
            try {
              Q = j.shouldComponentUpdate(p, R, D);
            } finally {
              ro(!1);
            }
          }
          Q === void 0 && f("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", dr(a) || "Component");
        }
        return Q;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !Zt(d, p) || !Zt(y, R) : !0;
    }
    function iU(r, a, d) {
      var p = r.stateNode;
      {
        var y = dr(a) || "Component", R = p.render;
        R || (a.prototype && typeof a.prototype.render == "function" ? f("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", y) : f("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", y)), p.getInitialState && !p.getInitialState.isReactClassApproved && !p.state && f("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", y), p.getDefaultProps && !p.getDefaultProps.isReactClassApproved && f("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", y), p.propTypes && f("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", y), p.contextType && f("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", y), p.contextTypes && f("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", y), a.contextType && a.contextTypes && !LE.has(a) && (LE.add(a), f("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", y)), typeof p.componentShouldUpdate == "function" && f("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", y), a.prototype && a.prototype.isPureReactComponent && typeof p.shouldComponentUpdate < "u" && f("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", dr(a) || "A pure component"), typeof p.componentDidUnmount == "function" && f("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", y), typeof p.componentDidReceiveProps == "function" && f("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", y), typeof p.componentWillRecieveProps == "function" && f("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", y), typeof p.UNSAFE_componentWillRecieveProps == "function" && f("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", y);
        var D = p.props !== d;
        p.props !== void 0 && D && f("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", y, y), p.defaultProps && f("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", y, y), typeof p.getSnapshotBeforeUpdate == "function" && typeof p.componentDidUpdate != "function" && !$E.has(a) && ($E.add(a), f("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", dr(a))), typeof p.getDerivedStateFromProps == "function" && f("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", y), typeof p.getDerivedStateFromError == "function" && f("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", y), typeof a.getSnapshotBeforeUpdate == "function" && f("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", y);
        var j = p.state;
        j && (typeof j != "object" || uo(j)) && f("%s.state: must be set to an object or null", y), typeof p.getChildContext == "function" && typeof a.childContextTypes != "object" && f("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", y);
      }
    }
    function mI(r, a) {
      a.updater = VE, r.stateNode = a, lu(a, r), a._reactInternalInstance = ME;
    }
    function hI(r, a, d) {
      var p = !1, y = Pi, R = Pi, D = a.contextType;
      if ("contextType" in a) {
        var j = (
          // Allow null for conditional declaration
          D === null || D !== void 0 && D.$$typeof === Et && D._context === void 0
        );
        if (!j && !FE.has(a)) {
          FE.add(a);
          var Q = "";
          D === void 0 ? Q = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof D != "object" ? Q = " However, it is set to a " + typeof D + "." : D.$$typeof === at ? Q = " Did you accidentally pass the Context.Provider instead?" : D._context !== void 0 ? Q = " Did you accidentally pass the Context.Consumer instead?" : Q = " However, it is set to an object with keys {" + Object.keys(D).join(", ") + "}.", f("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", dr(a) || "Component", Q);
        }
      }
      if (typeof D == "object" && D !== null)
        R = bo(D);
      else {
        y = Dm(r, a, !0);
        var re = a.contextTypes;
        p = re != null, R = p ? _m(r, y) : Pi;
      }
      var ae = new a(d, R);
      if (r.mode & Rr) {
        ro(!0);
        try {
          ae = new a(d, R);
        } finally {
          ro(!1);
        }
      }
      var ke = r.memoizedState = ae.state !== null && ae.state !== void 0 ? ae.state : null;
      mI(r, ae);
      {
        if (typeof a.getDerivedStateFromProps == "function" && ke === null) {
          var Ee = dr(a) || "Component";
          NE.has(Ee) || (NE.add(Ee), f("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Ee, ae.state === null ? "null" : "undefined", Ee));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof ae.getSnapshotBeforeUpdate == "function") {
          var He = null, Ue = null, Ke = null;
          if (typeof ae.componentWillMount == "function" && ae.componentWillMount.__suppressDeprecationWarning !== !0 ? He = "componentWillMount" : typeof ae.UNSAFE_componentWillMount == "function" && (He = "UNSAFE_componentWillMount"), typeof ae.componentWillReceiveProps == "function" && ae.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ue = "componentWillReceiveProps" : typeof ae.UNSAFE_componentWillReceiveProps == "function" && (Ue = "UNSAFE_componentWillReceiveProps"), typeof ae.componentWillUpdate == "function" && ae.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ke = "componentWillUpdate" : typeof ae.UNSAFE_componentWillUpdate == "function" && (Ke = "UNSAFE_componentWillUpdate"), He !== null || Ue !== null || Ke !== null) {
            var $t = dr(a) || "Component", en = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            DE.has($t) || (DE.add($t), f(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, $t, en, He !== null ? `
  ` + He : "", Ue !== null ? `
  ` + Ue : "", Ke !== null ? `
  ` + Ke : ""));
          }
        }
      }
      return p && zM(r, y, R), ae;
    }
    function lU(r, a) {
      var d = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), d !== a.state && (f("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", mn(r) || "Component"), VE.enqueueReplaceState(a, a.state, null));
    }
    function gI(r, a, d, p) {
      var y = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(d, p), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(d, p), a.state !== y) {
        {
          var R = mn(r) || "Component";
          IE.has(R) || (IE.add(R), f("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", R));
        }
        VE.enqueueReplaceState(a, a.state, null);
      }
    }
    function BE(r, a, d, p) {
      iU(r, a, d);
      var y = r.stateNode;
      y.props = d, y.state = r.memoizedState, y.refs = uI, kE(r);
      var R = a.contextType;
      if (typeof R == "object" && R !== null)
        y.context = bo(R);
      else {
        var D = Dm(r, a, !0);
        y.context = _m(r, D);
      }
      {
        if (y.state === d) {
          var j = dr(a) || "Component";
          AE.has(j) || (AE.add(j), f("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", j));
        }
        r.mode & Rr && kl.recordLegacyContextWarning(r, y), kl.recordUnsafeLifecycleWarnings(r, y);
      }
      y.state = r.memoizedState;
      var Q = a.getDerivedStateFromProps;
      if (typeof Q == "function" && (zE(r, a, Q, d), y.state = r.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof y.getSnapshotBeforeUpdate != "function" && (typeof y.UNSAFE_componentWillMount == "function" || typeof y.componentWillMount == "function") && (lU(r, y), H0(r, d, y, p), y.state = r.memoizedState), typeof y.componentDidMount == "function") {
        var re = gn;
        re |= ua, (r.mode & Ja) !== tn && (re |= da), r.flags |= re;
      }
    }
    function sU(r, a, d, p) {
      var y = r.stateNode, R = r.memoizedProps;
      y.props = R;
      var D = y.context, j = a.contextType, Q = Pi;
      if (typeof j == "object" && j !== null)
        Q = bo(j);
      else {
        var re = Dm(r, a, !0);
        Q = _m(r, re);
      }
      var ae = a.getDerivedStateFromProps, ke = typeof ae == "function" || typeof y.getSnapshotBeforeUpdate == "function";
      !ke && (typeof y.UNSAFE_componentWillReceiveProps == "function" || typeof y.componentWillReceiveProps == "function") && (R !== d || D !== Q) && gI(r, y, d, Q), sI();
      var Ee = r.memoizedState, He = y.state = Ee;
      if (H0(r, d, y, p), He = r.memoizedState, R === d && Ee === He && !O0() && !U0()) {
        if (typeof y.componentDidMount == "function") {
          var Ue = gn;
          Ue |= ua, (r.mode & Ja) !== tn && (Ue |= da), r.flags |= Ue;
        }
        return !1;
      }
      typeof ae == "function" && (zE(r, a, ae, d), He = r.memoizedState);
      var Ke = U0() || pI(r, a, R, d, Ee, He, Q);
      if (Ke) {
        if (!ke && (typeof y.UNSAFE_componentWillMount == "function" || typeof y.componentWillMount == "function") && (typeof y.componentWillMount == "function" && y.componentWillMount(), typeof y.UNSAFE_componentWillMount == "function" && y.UNSAFE_componentWillMount()), typeof y.componentDidMount == "function") {
          var $t = gn;
          $t |= ua, (r.mode & Ja) !== tn && ($t |= da), r.flags |= $t;
        }
      } else {
        if (typeof y.componentDidMount == "function") {
          var en = gn;
          en |= ua, (r.mode & Ja) !== tn && (en |= da), r.flags |= en;
        }
        r.memoizedProps = d, r.memoizedState = He;
      }
      return y.props = d, y.state = He, y.context = Q, Ke;
    }
    function cU(r, a, d, p, y) {
      var R = a.stateNode;
      lI(r, a);
      var D = a.memoizedProps, j = a.type === a.elementType ? D : Pl(a.type, D);
      R.props = j;
      var Q = a.pendingProps, re = R.context, ae = d.contextType, ke = Pi;
      if (typeof ae == "object" && ae !== null)
        ke = bo(ae);
      else {
        var Ee = Dm(a, d, !0);
        ke = _m(a, Ee);
      }
      var He = d.getDerivedStateFromProps, Ue = typeof He == "function" || typeof R.getSnapshotBeforeUpdate == "function";
      !Ue && (typeof R.UNSAFE_componentWillReceiveProps == "function" || typeof R.componentWillReceiveProps == "function") && (D !== Q || re !== ke) && gI(a, R, p, ke), sI();
      var Ke = a.memoizedState, $t = R.state = Ke;
      if (H0(a, p, R, y), $t = a.memoizedState, D === Q && Ke === $t && !O0() && !U0() && !Z)
        return typeof R.componentDidUpdate == "function" && (D !== r.memoizedProps || Ke !== r.memoizedState) && (a.flags |= gn), typeof R.getSnapshotBeforeUpdate == "function" && (D !== r.memoizedProps || Ke !== r.memoizedState) && (a.flags |= Ka), !1;
      typeof He == "function" && (zE(a, d, He, p), $t = a.memoizedState);
      var en = U0() || pI(a, d, j, p, Ke, $t, ke) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Z;
      return en ? (!Ue && (typeof R.UNSAFE_componentWillUpdate == "function" || typeof R.componentWillUpdate == "function") && (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(p, $t, ke), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(p, $t, ke)), typeof R.componentDidUpdate == "function" && (a.flags |= gn), typeof R.getSnapshotBeforeUpdate == "function" && (a.flags |= Ka)) : (typeof R.componentDidUpdate == "function" && (D !== r.memoizedProps || Ke !== r.memoizedState) && (a.flags |= gn), typeof R.getSnapshotBeforeUpdate == "function" && (D !== r.memoizedProps || Ke !== r.memoizedState) && (a.flags |= Ka), a.memoizedProps = p, a.memoizedState = $t), R.props = p, R.state = $t, R.context = ke, en;
    }
    var jE, HE, UE, GE, WE, vI = function(r, a) {
    };
    jE = !1, HE = !1, UE = {}, GE = {}, WE = {}, vI = function(r, a) {
      if (!(r === null || typeof r != "object") && !(!r._store || r._store.validated || r.key != null)) {
        if (typeof r._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        r._store.validated = !0;
        var d = mn(a) || "Component";
        GE[d] || (GE[d] = !0, f('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Fv(r, a, d) {
      var p = d.ref;
      if (p !== null && typeof p != "function" && typeof p != "object") {
        if ((r.mode & Rr || de) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(d._owner && d._self && d._owner.stateNode !== d._self)) {
          var y = mn(r) || "Component";
          UE[y] || (f('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', p), UE[y] = !0);
        }
        if (d._owner) {
          var R = d._owner, D;
          if (R) {
            var j = R;
            if (j.tag !== v)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            D = j.stateNode;
          }
          if (!D)
            throw new Error("Missing owner for string ref " + p + ". This error is likely caused by a bug in React. Please file an issue.");
          var Q = D;
          Ze(p, "ref");
          var re = "" + p;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === re)
            return a.ref;
          var ae = function(ke) {
            var Ee = Q.refs;
            Ee === uI && (Ee = Q.refs = {}), ke === null ? delete Ee[re] : Ee[re] = ke;
          };
          return ae._stringRef = re, ae;
        } else {
          if (typeof p != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!d._owner)
            throw new Error("Element ref was specified as a string (" + p + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return p;
    }
    function W0(r, a) {
      var d = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (d === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : d) + "). If you meant to render a collection of children, use an array instead.");
    }
    function q0(r) {
      {
        var a = mn(r) || "Component";
        if (WE[a])
          return;
        WE[a] = !0, f("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function bI(r) {
      var a = r._payload, d = r._init;
      return d(a);
    }
    function yI(r) {
      function a(Ae, Xe) {
        if (r) {
          var Le = Ae.deletions;
          Le === null ? (Ae.deletions = [Xe], Ae.flags |= jn) : Le.push(Xe);
        }
      }
      function d(Ae, Xe) {
        if (!r)
          return null;
        for (var Le = Xe; Le !== null; )
          a(Ae, Le), Le = Le.sibling;
        return null;
      }
      function p(Ae, Xe) {
        for (var Le = /* @__PURE__ */ new Map(), xt = Xe; xt !== null; )
          xt.key !== null ? Le.set(xt.key, xt) : Le.set(xt.index, xt), xt = xt.sibling;
        return Le;
      }
      function y(Ae, Xe) {
        var Le = Mf(Ae, Xe);
        return Le.index = 0, Le.sibling = null, Le;
      }
      function R(Ae, Xe, Le) {
        if (Ae.index = Le, !r)
          return Ae.flags |= Ig, Xe;
        var xt = Ae.alternate;
        if (xt !== null) {
          var Dt = xt.index;
          return Dt < Xe ? (Ae.flags |= hr, Xe) : Dt;
        } else
          return Ae.flags |= hr, Xe;
      }
      function D(Ae) {
        return r && Ae.alternate === null && (Ae.flags |= hr), Ae;
      }
      function j(Ae, Xe, Le, xt) {
        if (Xe === null || Xe.tag !== P) {
          var Dt = yO(Le, Ae.mode, xt);
          return Dt.return = Ae, Dt;
        } else {
          var Pt = y(Xe, Le);
          return Pt.return = Ae, Pt;
        }
      }
      function Q(Ae, Xe, Le, xt) {
        var Dt = Le.type;
        if (Dt === Bn)
          return ae(Ae, Xe, Le.props.children, xt, Le.key);
        if (Xe !== null && (Xe.elementType === Dt || // Keep this check inline so it only runs on the false path:
        c$(Xe, Le) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Dt == "object" && Dt !== null && Dt.$$typeof === Ct && bI(Dt) === Xe.type)) {
          var Pt = y(Xe, Le.props);
          return Pt.ref = Fv(Ae, Xe, Le), Pt.return = Ae, Pt._debugSource = Le._source, Pt._debugOwner = Le._owner, Pt;
        }
        var ln = bO(Le, Ae.mode, xt);
        return ln.ref = Fv(Ae, Xe, Le), ln.return = Ae, ln;
      }
      function re(Ae, Xe, Le, xt) {
        if (Xe === null || Xe.tag !== E || Xe.stateNode.containerInfo !== Le.containerInfo || Xe.stateNode.implementation !== Le.implementation) {
          var Dt = CO(Le, Ae.mode, xt);
          return Dt.return = Ae, Dt;
        } else {
          var Pt = y(Xe, Le.children || []);
          return Pt.return = Ae, Pt;
        }
      }
      function ae(Ae, Xe, Le, xt, Dt) {
        if (Xe === null || Xe.tag !== O) {
          var Pt = qu(Le, Ae.mode, xt, Dt);
          return Pt.return = Ae, Pt;
        } else {
          var ln = y(Xe, Le);
          return ln.return = Ae, ln;
        }
      }
      function ke(Ae, Xe, Le) {
        if (typeof Xe == "string" && Xe !== "" || typeof Xe == "number") {
          var xt = yO("" + Xe, Ae.mode, Le);
          return xt.return = Ae, xt;
        }
        if (typeof Xe == "object" && Xe !== null) {
          switch (Xe.$$typeof) {
            case _r: {
              var Dt = bO(Xe, Ae.mode, Le);
              return Dt.ref = Fv(Ae, null, Xe), Dt.return = Ae, Dt;
            }
            case ur: {
              var Pt = CO(Xe, Ae.mode, Le);
              return Pt.return = Ae, Pt;
            }
            case Ct: {
              var ln = Xe._payload, pn = Xe._init;
              return ke(Ae, pn(ln), Le);
            }
          }
          if (uo(Xe) || cl(Xe)) {
            var tr = qu(Xe, Ae.mode, Le, null);
            return tr.return = Ae, tr;
          }
          W0(Ae, Xe);
        }
        return typeof Xe == "function" && q0(Ae), null;
      }
      function Ee(Ae, Xe, Le, xt) {
        var Dt = Xe !== null ? Xe.key : null;
        if (typeof Le == "string" && Le !== "" || typeof Le == "number")
          return Dt !== null ? null : j(Ae, Xe, "" + Le, xt);
        if (typeof Le == "object" && Le !== null) {
          switch (Le.$$typeof) {
            case _r:
              return Le.key === Dt ? Q(Ae, Xe, Le, xt) : null;
            case ur:
              return Le.key === Dt ? re(Ae, Xe, Le, xt) : null;
            case Ct: {
              var Pt = Le._payload, ln = Le._init;
              return Ee(Ae, Xe, ln(Pt), xt);
            }
          }
          if (uo(Le) || cl(Le))
            return Dt !== null ? null : ae(Ae, Xe, Le, xt, null);
          W0(Ae, Le);
        }
        return typeof Le == "function" && q0(Ae), null;
      }
      function He(Ae, Xe, Le, xt, Dt) {
        if (typeof xt == "string" && xt !== "" || typeof xt == "number") {
          var Pt = Ae.get(Le) || null;
          return j(Xe, Pt, "" + xt, Dt);
        }
        if (typeof xt == "object" && xt !== null) {
          switch (xt.$$typeof) {
            case _r: {
              var ln = Ae.get(xt.key === null ? Le : xt.key) || null;
              return Q(Xe, ln, xt, Dt);
            }
            case ur: {
              var pn = Ae.get(xt.key === null ? Le : xt.key) || null;
              return re(Xe, pn, xt, Dt);
            }
            case Ct:
              var tr = xt._payload, Ln = xt._init;
              return He(Ae, Xe, Le, Ln(tr), Dt);
          }
          if (uo(xt) || cl(xt)) {
            var so = Ae.get(Le) || null;
            return ae(Xe, so, xt, Dt, null);
          }
          W0(Xe, xt);
        }
        return typeof xt == "function" && q0(Xe), null;
      }
      function Ue(Ae, Xe, Le) {
        {
          if (typeof Ae != "object" || Ae === null)
            return Xe;
          switch (Ae.$$typeof) {
            case _r:
            case ur:
              vI(Ae, Le);
              var xt = Ae.key;
              if (typeof xt != "string")
                break;
              if (Xe === null) {
                Xe = /* @__PURE__ */ new Set(), Xe.add(xt);
                break;
              }
              if (!Xe.has(xt)) {
                Xe.add(xt);
                break;
              }
              f("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", xt);
              break;
            case Ct:
              var Dt = Ae._payload, Pt = Ae._init;
              Ue(Pt(Dt), Xe, Le);
              break;
          }
        }
        return Xe;
      }
      function Ke(Ae, Xe, Le, xt) {
        for (var Dt = null, Pt = 0; Pt < Le.length; Pt++) {
          var ln = Le[Pt];
          Dt = Ue(ln, Dt, Ae);
        }
        for (var pn = null, tr = null, Ln = Xe, so = 0, Fn = 0, Xr = null; Ln !== null && Fn < Le.length; Fn++) {
          Ln.index > Fn ? (Xr = Ln, Ln = null) : Xr = Ln.sibling;
          var Ca = Ee(Ae, Ln, Le[Fn], xt);
          if (Ca === null) {
            Ln === null && (Ln = Xr);
            break;
          }
          r && Ln && Ca.alternate === null && a(Ae, Ln), so = R(Ca, so, Fn), tr === null ? pn = Ca : tr.sibling = Ca, tr = Ca, Ln = Xr;
        }
        if (Fn === Le.length) {
          if (d(Ae, Ln), Xo()) {
            var ra = Fn;
            vf(Ae, ra);
          }
          return pn;
        }
        if (Ln === null) {
          for (; Fn < Le.length; Fn++) {
            var Ii = ke(Ae, Le[Fn], xt);
            Ii !== null && (so = R(Ii, so, Fn), tr === null ? pn = Ii : tr.sibling = Ii, tr = Ii);
          }
          if (Xo()) {
            var Fa = Fn;
            vf(Ae, Fa);
          }
          return pn;
        }
        for (var za = p(Ae, Ln); Fn < Le.length; Fn++) {
          var Sa = He(za, Ae, Fn, Le[Fn], xt);
          Sa !== null && (r && Sa.alternate !== null && za.delete(Sa.key === null ? Fn : Sa.key), so = R(Sa, so, Fn), tr === null ? pn = Sa : tr.sibling = Sa, tr = Sa);
        }
        if (r && za.forEach(function(rh) {
          return a(Ae, rh);
        }), Xo()) {
          var _c = Fn;
          vf(Ae, _c);
        }
        return pn;
      }
      function $t(Ae, Xe, Le, xt) {
        var Dt = cl(Le);
        if (typeof Dt != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Le[Symbol.toStringTag] === "Generator" && (HE || f("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), HE = !0), Le.entries === Dt && (jE || f("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), jE = !0);
          var Pt = Dt.call(Le);
          if (Pt)
            for (var ln = null, pn = Pt.next(); !pn.done; pn = Pt.next()) {
              var tr = pn.value;
              ln = Ue(tr, ln, Ae);
            }
        }
        var Ln = Dt.call(Le);
        if (Ln == null)
          throw new Error("An iterable object provided no iterator.");
        for (var so = null, Fn = null, Xr = Xe, Ca = 0, ra = 0, Ii = null, Fa = Ln.next(); Xr !== null && !Fa.done; ra++, Fa = Ln.next()) {
          Xr.index > ra ? (Ii = Xr, Xr = null) : Ii = Xr.sibling;
          var za = Ee(Ae, Xr, Fa.value, xt);
          if (za === null) {
            Xr === null && (Xr = Ii);
            break;
          }
          r && Xr && za.alternate === null && a(Ae, Xr), Ca = R(za, Ca, ra), Fn === null ? so = za : Fn.sibling = za, Fn = za, Xr = Ii;
        }
        if (Fa.done) {
          if (d(Ae, Xr), Xo()) {
            var Sa = ra;
            vf(Ae, Sa);
          }
          return so;
        }
        if (Xr === null) {
          for (; !Fa.done; ra++, Fa = Ln.next()) {
            var _c = ke(Ae, Fa.value, xt);
            _c !== null && (Ca = R(_c, Ca, ra), Fn === null ? so = _c : Fn.sibling = _c, Fn = _c);
          }
          if (Xo()) {
            var rh = ra;
            vf(Ae, rh);
          }
          return so;
        }
        for (var mb = p(Ae, Xr); !Fa.done; ra++, Fa = Ln.next()) {
          var Is = He(mb, Ae, ra, Fa.value, xt);
          Is !== null && (r && Is.alternate !== null && mb.delete(Is.key === null ? ra : Is.key), Ca = R(Is, Ca, ra), Fn === null ? so = Is : Fn.sibling = Is, Fn = Is);
        }
        if (r && mb.forEach(function(w8) {
          return a(Ae, w8);
        }), Xo()) {
          var x8 = ra;
          vf(Ae, x8);
        }
        return so;
      }
      function en(Ae, Xe, Le, xt) {
        if (Xe !== null && Xe.tag === P) {
          d(Ae, Xe.sibling);
          var Dt = y(Xe, Le);
          return Dt.return = Ae, Dt;
        }
        d(Ae, Xe);
        var Pt = yO(Le, Ae.mode, xt);
        return Pt.return = Ae, Pt;
      }
      function Kt(Ae, Xe, Le, xt) {
        for (var Dt = Le.key, Pt = Xe; Pt !== null; ) {
          if (Pt.key === Dt) {
            var ln = Le.type;
            if (ln === Bn) {
              if (Pt.tag === O) {
                d(Ae, Pt.sibling);
                var pn = y(Pt, Le.props.children);
                return pn.return = Ae, pn._debugSource = Le._source, pn._debugOwner = Le._owner, pn;
              }
            } else if (Pt.elementType === ln || // Keep this check inline so it only runs on the false path:
            c$(Pt, Le) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof ln == "object" && ln !== null && ln.$$typeof === Ct && bI(ln) === Pt.type) {
              d(Ae, Pt.sibling);
              var tr = y(Pt, Le.props);
              return tr.ref = Fv(Ae, Pt, Le), tr.return = Ae, tr._debugSource = Le._source, tr._debugOwner = Le._owner, tr;
            }
            d(Ae, Pt);
            break;
          } else
            a(Ae, Pt);
          Pt = Pt.sibling;
        }
        if (Le.type === Bn) {
          var Ln = qu(Le.props.children, Ae.mode, xt, Le.key);
          return Ln.return = Ae, Ln;
        } else {
          var so = bO(Le, Ae.mode, xt);
          return so.ref = Fv(Ae, Xe, Le), so.return = Ae, so;
        }
      }
      function In(Ae, Xe, Le, xt) {
        for (var Dt = Le.key, Pt = Xe; Pt !== null; ) {
          if (Pt.key === Dt)
            if (Pt.tag === E && Pt.stateNode.containerInfo === Le.containerInfo && Pt.stateNode.implementation === Le.implementation) {
              d(Ae, Pt.sibling);
              var ln = y(Pt, Le.children || []);
              return ln.return = Ae, ln;
            } else {
              d(Ae, Pt);
              break;
            }
          else
            a(Ae, Pt);
          Pt = Pt.sibling;
        }
        var pn = CO(Le, Ae.mode, xt);
        return pn.return = Ae, pn;
      }
      function kn(Ae, Xe, Le, xt) {
        var Dt = typeof Le == "object" && Le !== null && Le.type === Bn && Le.key === null;
        if (Dt && (Le = Le.props.children), typeof Le == "object" && Le !== null) {
          switch (Le.$$typeof) {
            case _r:
              return D(Kt(Ae, Xe, Le, xt));
            case ur:
              return D(In(Ae, Xe, Le, xt));
            case Ct:
              var Pt = Le._payload, ln = Le._init;
              return kn(Ae, Xe, ln(Pt), xt);
          }
          if (uo(Le))
            return Ke(Ae, Xe, Le, xt);
          if (cl(Le))
            return $t(Ae, Xe, Le, xt);
          W0(Ae, Le);
        }
        return typeof Le == "string" && Le !== "" || typeof Le == "number" ? D(en(Ae, Xe, "" + Le, xt)) : (typeof Le == "function" && q0(Ae), d(Ae, Xe));
      }
      return kn;
    }
    var Bm = yI(!0), CI = yI(!1);
    function uU(r, a) {
      if (r !== null && a.child !== r.child)
        throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var d = a.child, p = Mf(d, d.pendingProps);
        for (a.child = p, p.return = a; d.sibling !== null; )
          d = d.sibling, p = p.sibling = Mf(d, d.pendingProps), p.return = a;
        p.sibling = null;
      }
    }
    function dU(r, a) {
      for (var d = r.child; d !== null; )
        V6(d, a), d = d.sibling;
    }
    var zv = {}, Fu = $u(zv), Vv = $u(zv), Y0 = $u(zv);
    function K0(r) {
      if (r === zv)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return r;
    }
    function SI() {
      var r = K0(Y0.current);
      return r;
    }
    function qE(r, a) {
      ba(Y0, a, r), ba(Vv, r, r), ba(Fu, zv, r);
      var d = Tj(a);
      va(Fu, r), ba(Fu, d, r);
    }
    function jm(r) {
      va(Fu, r), va(Vv, r), va(Y0, r);
    }
    function YE() {
      var r = K0(Fu.current);
      return r;
    }
    function xI(r) {
      K0(Y0.current);
      var a = K0(Fu.current), d = Oj(a, r.type);
      a !== d && (ba(Vv, r, r), ba(Fu, d, r));
    }
    function KE(r) {
      Vv.current === r && (va(Fu, r), va(Vv, r));
    }
    var fU = 0, wI = 1, EI = 1, Bv = 2, Ml = $u(fU);
    function XE(r, a) {
      return (r & a) !== 0;
    }
    function Hm(r) {
      return r & wI;
    }
    function QE(r, a) {
      return r & wI | a;
    }
    function pU(r, a) {
      return r | a;
    }
    function zu(r, a) {
      ba(Ml, a, r);
    }
    function Um(r) {
      va(Ml, r);
    }
    function mU(r, a) {
      var d = r.memoizedState;
      return d !== null ? d.dehydrated !== null : (r.memoizedProps, !0);
    }
    function X0(r) {
      for (var a = r; a !== null; ) {
        if (a.tag === V) {
          var d = a.memoizedState;
          if (d !== null) {
            var p = d.dehydrated;
            if (p === null || DM(p) || rE(p))
              return a;
          }
        } else if (a.tag === G && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var y = (a.flags & sn) !== Jt;
          if (y)
            return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === r)
          return null;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === r)
            return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var li = (
      /*   */
      0
    ), Ro = (
      /* */
      1
    ), Es = (
      /*  */
      2
    ), ko = (
      /*    */
      4
    ), Qo = (
      /*   */
      8
    ), ZE = [];
    function JE() {
      for (var r = 0; r < ZE.length; r++) {
        var a = ZE[r];
        a._workInProgressVersionPrimary = null;
      }
      ZE.length = 0;
    }
    function hU(r, a) {
      var d = a._getVersion, p = d(a._source);
      r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [a, p] : r.mutableSourceEagerHydrationData.push(a, p);
    }
    var It = o.ReactCurrentDispatcher, jv = o.ReactCurrentBatchConfig, eT, Gm;
    eT = /* @__PURE__ */ new Set();
    var wf = nt, er = null, Po = null, Mo = null, Q0 = !1, Hv = !1, Uv = 0, gU = 0, vU = 25, it = null, Ki = null, Vu = -1, tT = !1;
    function Gn() {
      {
        var r = it;
        Ki === null ? Ki = [r] : Ki.push(r);
      }
    }
    function Rt() {
      {
        var r = it;
        Ki !== null && (Vu++, Ki[Vu] !== r && bU(r));
      }
    }
    function Wm(r) {
      r != null && !uo(r) && f("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", it, typeof r);
    }
    function bU(r) {
      {
        var a = mn(er);
        if (!eT.has(a) && (eT.add(a), Ki !== null)) {
          for (var d = "", p = 30, y = 0; y <= Vu; y++) {
            for (var R = Ki[y], D = y === Vu ? r : R, j = y + 1 + ". " + R; j.length < p; )
              j += " ";
            j += D + `
`, d += j;
          }
          f(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, d);
        }
      }
    }
    function ya() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function nT(r, a) {
      if (tT)
        return !1;
      if (a === null)
        return f("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", it), !1;
      r.length !== a.length && f(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, it, "[" + a.join(", ") + "]", "[" + r.join(", ") + "]");
      for (var d = 0; d < a.length && d < r.length; d++)
        if (!Bt(r[d], a[d]))
          return !1;
      return !0;
    }
    function qm(r, a, d, p, y, R) {
      wf = R, er = a, Ki = r !== null ? r._debugHookTypes : null, Vu = -1, tT = r !== null && r.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = nt, r !== null && r.memoizedState !== null ? It.current = WI : Ki !== null ? It.current = GI : It.current = UI;
      var D = d(p, y);
      if (Hv) {
        var j = 0;
        do {
          if (Hv = !1, Uv = 0, j >= vU)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          j += 1, tT = !1, Po = null, Mo = null, a.updateQueue = null, Vu = -1, It.current = qI, D = d(p, y);
        } while (Hv);
      }
      It.current = uS, a._debugHookTypes = Ki;
      var Q = Po !== null && Po.next !== null;
      if (wf = nt, er = null, Po = null, Mo = null, it = null, Ki = null, Vu = -1, r !== null && (r.flags & Eo) !== (a.flags & Eo) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (r.mode & xn) !== tn && f("Internal React error: Expected static flag was missing. Please notify the React team."), Q0 = !1, Q)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return D;
    }
    function Ym() {
      var r = Uv !== 0;
      return Uv = 0, r;
    }
    function TI(r, a, d) {
      a.updateQueue = r.updateQueue, (a.mode & Ja) !== tn ? a.flags &= ~(rc | da | wr | gn) : a.flags &= ~(wr | gn), r.lanes = gu(r.lanes, d);
    }
    function OI() {
      if (It.current = uS, Q0) {
        for (var r = er.memoizedState; r !== null; ) {
          var a = r.queue;
          a !== null && (a.pending = null), r = r.next;
        }
        Q0 = !1;
      }
      wf = nt, er = null, Po = null, Mo = null, Ki = null, Vu = -1, it = null, zI = !1, Hv = !1, Uv = 0;
    }
    function Ts() {
      var r = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Mo === null ? er.memoizedState = Mo = r : Mo = Mo.next = r, Mo;
    }
    function Xi() {
      var r;
      if (Po === null) {
        var a = er.alternate;
        a !== null ? r = a.memoizedState : r = null;
      } else
        r = Po.next;
      var d;
      if (Mo === null ? d = er.memoizedState : d = Mo.next, d !== null)
        Mo = d, d = Mo.next, Po = r;
      else {
        if (r === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Po = r;
        var p = {
          memoizedState: Po.memoizedState,
          baseState: Po.baseState,
          baseQueue: Po.baseQueue,
          queue: Po.queue,
          next: null
        };
        Mo === null ? er.memoizedState = Mo = p : Mo = Mo.next = p;
      }
      return Mo;
    }
    function RI() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function rT(r, a) {
      return typeof a == "function" ? a(r) : a;
    }
    function oT(r, a, d) {
      var p = Ts(), y;
      d !== void 0 ? y = d(a) : y = a, p.memoizedState = p.baseState = y;
      var R = {
        pending: null,
        interleaved: null,
        lanes: nt,
        dispatch: null,
        lastRenderedReducer: r,
        lastRenderedState: y
      };
      p.queue = R;
      var D = R.dispatch = xU.bind(null, er, R);
      return [p.memoizedState, D];
    }
    function aT(r, a, d) {
      var p = Xi(), y = p.queue;
      if (y === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      y.lastRenderedReducer = r;
      var R = Po, D = R.baseQueue, j = y.pending;
      if (j !== null) {
        if (D !== null) {
          var Q = D.next, re = j.next;
          D.next = re, j.next = Q;
        }
        R.baseQueue !== D && f("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), R.baseQueue = D = j, y.pending = null;
      }
      if (D !== null) {
        var ae = D.next, ke = R.baseState, Ee = null, He = null, Ue = null, Ke = ae;
        do {
          var $t = Ke.lane;
          if (pc(wf, $t)) {
            if (Ue !== null) {
              var Kt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Pn,
                action: Ke.action,
                hasEagerState: Ke.hasEagerState,
                eagerState: Ke.eagerState,
                next: null
              };
              Ue = Ue.next = Kt;
            }
            if (Ke.hasEagerState)
              ke = Ke.eagerState;
            else {
              var In = Ke.action;
              ke = r(ke, In);
            }
          } else {
            var en = {
              lane: $t,
              action: Ke.action,
              hasEagerState: Ke.hasEagerState,
              eagerState: Ke.eagerState,
              next: null
            };
            Ue === null ? (He = Ue = en, Ee = ke) : Ue = Ue.next = en, er.lanes = vn(er.lanes, $t), cb($t);
          }
          Ke = Ke.next;
        } while (Ke !== null && Ke !== ae);
        Ue === null ? Ee = ke : Ue.next = He, Bt(ke, p.memoizedState) || Qv(), p.memoizedState = ke, p.baseState = Ee, p.baseQueue = Ue, y.lastRenderedState = ke;
      }
      var kn = y.interleaved;
      if (kn !== null) {
        var Ae = kn;
        do {
          var Xe = Ae.lane;
          er.lanes = vn(er.lanes, Xe), cb(Xe), Ae = Ae.next;
        } while (Ae !== kn);
      } else
        D === null && (y.lanes = nt);
      var Le = y.dispatch;
      return [p.memoizedState, Le];
    }
    function iT(r, a, d) {
      var p = Xi(), y = p.queue;
      if (y === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      y.lastRenderedReducer = r;
      var R = y.dispatch, D = y.pending, j = p.memoizedState;
      if (D !== null) {
        y.pending = null;
        var Q = D.next, re = Q;
        do {
          var ae = re.action;
          j = r(j, ae), re = re.next;
        } while (re !== Q);
        Bt(j, p.memoizedState) || Qv(), p.memoizedState = j, p.baseQueue === null && (p.baseState = j), y.lastRenderedState = j;
      }
      return [j, R];
    }
    function oSe(r, a, d) {
    }
    function aSe(r, a, d) {
    }
    function lT(r, a, d) {
      var p = er, y = Ts(), R, D = Xo();
      if (D) {
        if (d === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        R = d(), Gm || R !== d() && (f("The result of getServerSnapshot should be cached to avoid an infinite loop"), Gm = !0);
      } else {
        if (R = a(), !Gm) {
          var j = a();
          Bt(R, j) || (f("The result of getSnapshot should be cached to avoid an infinite loop"), Gm = !0);
        }
        var Q = kS();
        if (Q === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Jd(Q, wf) || kI(p, a, R);
      }
      y.memoizedState = R;
      var re = {
        value: R,
        getSnapshot: a
      };
      return y.queue = re, nS(MI.bind(null, p, re, r), [r]), p.flags |= wr, Gv(Ro | Qo, PI.bind(null, p, re, R, a), void 0, null), R;
    }
    function Z0(r, a, d) {
      var p = er, y = Xi(), R = a();
      if (!Gm) {
        var D = a();
        Bt(R, D) || (f("The result of getSnapshot should be cached to avoid an infinite loop"), Gm = !0);
      }
      var j = y.memoizedState, Q = !Bt(j, R);
      Q && (y.memoizedState = R, Qv());
      var re = y.queue;
      if (qv(MI.bind(null, p, re, r), [r]), re.getSnapshot !== a || Q || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Mo !== null && Mo.memoizedState.tag & Ro) {
        p.flags |= wr, Gv(Ro | Qo, PI.bind(null, p, re, R, a), void 0, null);
        var ae = kS();
        if (ae === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Jd(ae, wf) || kI(p, a, R);
      }
      return R;
    }
    function kI(r, a, d) {
      r.flags |= Ud;
      var p = {
        getSnapshot: a,
        value: d
      }, y = er.updateQueue;
      if (y === null)
        y = RI(), er.updateQueue = y, y.stores = [p];
      else {
        var R = y.stores;
        R === null ? y.stores = [p] : R.push(p);
      }
    }
    function PI(r, a, d, p) {
      a.value = d, a.getSnapshot = p, II(a) && NI(r);
    }
    function MI(r, a, d) {
      var p = function() {
        II(a) && NI(r);
      };
      return d(p);
    }
    function II(r) {
      var a = r.getSnapshot, d = r.value;
      try {
        var p = a();
        return !Bt(d, p);
      } catch {
        return !0;
      }
    }
    function NI(r) {
      var a = ii(r, on);
      a !== null && Do(a, r, on, pr);
    }
    function J0(r) {
      var a = Ts();
      typeof r == "function" && (r = r()), a.memoizedState = a.baseState = r;
      var d = {
        pending: null,
        interleaved: null,
        lanes: nt,
        dispatch: null,
        lastRenderedReducer: rT,
        lastRenderedState: r
      };
      a.queue = d;
      var p = d.dispatch = wU.bind(null, er, d);
      return [a.memoizedState, p];
    }
    function sT(r) {
      return aT(rT);
    }
    function cT(r) {
      return iT(rT);
    }
    function Gv(r, a, d, p) {
      var y = {
        tag: r,
        create: a,
        destroy: d,
        deps: p,
        // Circular
        next: null
      }, R = er.updateQueue;
      if (R === null)
        R = RI(), er.updateQueue = R, R.lastEffect = y.next = y;
      else {
        var D = R.lastEffect;
        if (D === null)
          R.lastEffect = y.next = y;
        else {
          var j = D.next;
          D.next = y, y.next = j, R.lastEffect = y;
        }
      }
      return y;
    }
    function uT(r) {
      var a = Ts();
      {
        var d = {
          current: r
        };
        return a.memoizedState = d, d;
      }
    }
    function eS(r) {
      var a = Xi();
      return a.memoizedState;
    }
    function Wv(r, a, d, p) {
      var y = Ts(), R = p === void 0 ? null : p;
      er.flags |= r, y.memoizedState = Gv(Ro | a, d, void 0, R);
    }
    function tS(r, a, d, p) {
      var y = Xi(), R = p === void 0 ? null : p, D = void 0;
      if (Po !== null) {
        var j = Po.memoizedState;
        if (D = j.destroy, R !== null) {
          var Q = j.deps;
          if (nT(R, Q)) {
            y.memoizedState = Gv(a, d, D, R);
            return;
          }
        }
      }
      er.flags |= r, y.memoizedState = Gv(Ro | a, d, D, R);
    }
    function nS(r, a) {
      return (er.mode & Ja) !== tn ? Wv(rc | wr | ls, Qo, r, a) : Wv(wr | ls, Qo, r, a);
    }
    function qv(r, a) {
      return tS(wr, Qo, r, a);
    }
    function dT(r, a) {
      return Wv(gn, Es, r, a);
    }
    function rS(r, a) {
      return tS(gn, Es, r, a);
    }
    function fT(r, a) {
      var d = gn;
      return d |= ua, (er.mode & Ja) !== tn && (d |= da), Wv(d, ko, r, a);
    }
    function oS(r, a) {
      return tS(gn, ko, r, a);
    }
    function $I(r, a) {
      if (typeof a == "function") {
        var d = a, p = r();
        return d(p), function() {
          d(null);
        };
      } else if (a != null) {
        var y = a;
        y.hasOwnProperty("current") || f("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(y).join(", ") + "}");
        var R = r();
        return y.current = R, function() {
          y.current = null;
        };
      }
    }
    function pT(r, a, d) {
      typeof a != "function" && f("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var p = d != null ? d.concat([r]) : null, y = gn;
      return y |= ua, (er.mode & Ja) !== tn && (y |= da), Wv(y, ko, $I.bind(null, a, r), p);
    }
    function aS(r, a, d) {
      typeof a != "function" && f("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var p = d != null ? d.concat([r]) : null;
      return tS(gn, ko, $I.bind(null, a, r), p);
    }
    function yU(r, a) {
    }
    var iS = yU;
    function mT(r, a) {
      var d = Ts(), p = a === void 0 ? null : a;
      return d.memoizedState = [r, p], r;
    }
    function lS(r, a) {
      var d = Xi(), p = a === void 0 ? null : a, y = d.memoizedState;
      if (y !== null && p !== null) {
        var R = y[1];
        if (nT(p, R))
          return y[0];
      }
      return d.memoizedState = [r, p], r;
    }
    function hT(r, a) {
      var d = Ts(), p = a === void 0 ? null : a, y = r();
      return d.memoizedState = [y, p], y;
    }
    function sS(r, a) {
      var d = Xi(), p = a === void 0 ? null : a, y = d.memoizedState;
      if (y !== null && p !== null) {
        var R = y[1];
        if (nT(p, R))
          return y[0];
      }
      var D = r();
      return d.memoizedState = [D, p], D;
    }
    function gT(r) {
      var a = Ts();
      return a.memoizedState = r, r;
    }
    function DI(r) {
      var a = Xi(), d = Po, p = d.memoizedState;
      return AI(a, p, r);
    }
    function _I(r) {
      var a = Xi();
      if (Po === null)
        return a.memoizedState = r, r;
      var d = Po.memoizedState;
      return AI(a, d, r);
    }
    function AI(r, a, d) {
      var p = !xw(wf);
      if (p) {
        if (!Bt(d, a)) {
          var y = Yg();
          er.lanes = vn(er.lanes, y), cb(y), r.baseState = !0;
        }
        return a;
      } else
        return r.baseState && (r.baseState = !1, Qv()), r.memoizedState = d, d;
    }
    function CU(r, a, d) {
      var p = ti();
      ao(Ho(p, Oo)), r(!0);
      var y = jv.transition;
      jv.transition = {};
      var R = jv.transition;
      jv.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        r(!1), a();
      } finally {
        if (ao(p), jv.transition = y, y === null && R._updatedFibers) {
          var D = R._updatedFibers.size;
          D > 10 && c("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), R._updatedFibers.clear();
        }
      }
    }
    function vT() {
      var r = J0(!1), a = r[0], d = r[1], p = CU.bind(null, d), y = Ts();
      return y.memoizedState = p, [a, p];
    }
    function LI() {
      var r = sT(), a = r[0], d = Xi(), p = d.memoizedState;
      return [a, p];
    }
    function FI() {
      var r = cT(), a = r[0], d = Xi(), p = d.memoizedState;
      return [a, p];
    }
    var zI = !1;
    function SU() {
      return zI;
    }
    function bT() {
      var r = Ts(), a = kS(), d = a.identifierPrefix, p;
      if (Xo()) {
        var y = _H();
        p = ":" + d + "R" + y;
        var R = Uv++;
        R > 0 && (p += "H" + R.toString(32)), p += ":";
      } else {
        var D = gU++;
        p = ":" + d + "r" + D.toString(32) + ":";
      }
      return r.memoizedState = p, p;
    }
    function cS() {
      var r = Xi(), a = r.memoizedState;
      return a;
    }
    function xU(r, a, d) {
      typeof arguments[3] == "function" && f("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var p = Gu(r), y = {
        lane: p,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (VI(r))
        BI(a, y);
      else {
        var R = oI(r, a, y, p);
        if (R !== null) {
          var D = La();
          Do(R, r, p, D), jI(R, a, p);
        }
      }
      HI(r, p);
    }
    function wU(r, a, d) {
      typeof arguments[3] == "function" && f("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var p = Gu(r), y = {
        lane: p,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (VI(r))
        BI(a, y);
      else {
        var R = r.alternate;
        if (r.lanes === nt && (R === null || R.lanes === nt)) {
          var D = a.lastRenderedReducer;
          if (D !== null) {
            var j;
            j = It.current, It.current = Il;
            try {
              var Q = a.lastRenderedState, re = D(Q, d);
              if (y.hasEagerState = !0, y.eagerState = re, Bt(re, Q)) {
                tU(r, a, y, p);
                return;
              }
            } catch {
            } finally {
              It.current = j;
            }
          }
        }
        var ae = oI(r, a, y, p);
        if (ae !== null) {
          var ke = La();
          Do(ae, r, p, ke), jI(ae, a, p);
        }
      }
      HI(r, p);
    }
    function VI(r) {
      var a = r.alternate;
      return r === er || a !== null && a === er;
    }
    function BI(r, a) {
      Hv = Q0 = !0;
      var d = r.pending;
      d === null ? a.next = a : (a.next = d.next, d.next = a), r.pending = a;
    }
    function jI(r, a, d) {
      if (qg(d)) {
        var p = a.lanes;
        p = Kg(p, r.pendingLanes);
        var y = vn(p, d);
        a.lanes = y, vu(r, y);
      }
    }
    function HI(r, a, d) {
      ps(r, a);
    }
    var uS = {
      readContext: bo,
      useCallback: ya,
      useContext: ya,
      useEffect: ya,
      useImperativeHandle: ya,
      useInsertionEffect: ya,
      useLayoutEffect: ya,
      useMemo: ya,
      useReducer: ya,
      useRef: ya,
      useState: ya,
      useDebugValue: ya,
      useDeferredValue: ya,
      useTransition: ya,
      useMutableSource: ya,
      useSyncExternalStore: ya,
      useId: ya,
      unstable_isNewReconciler: U
    }, UI = null, GI = null, WI = null, qI = null, Os = null, Il = null, dS = null;
    {
      var yT = function() {
        f("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, fn = function() {
        f("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      UI = {
        readContext: function(r) {
          return bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", Gn(), Wm(a), mT(r, a);
        },
        useContext: function(r) {
          return it = "useContext", Gn(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", Gn(), Wm(a), nS(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", Gn(), Wm(d), pT(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", Gn(), Wm(a), dT(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", Gn(), Wm(a), fT(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", Gn(), Wm(a);
          var d = It.current;
          It.current = Os;
          try {
            return hT(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", Gn();
          var p = It.current;
          It.current = Os;
          try {
            return oT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", Gn(), uT(r);
        },
        useState: function(r) {
          it = "useState", Gn();
          var a = It.current;
          It.current = Os;
          try {
            return J0(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", Gn(), void 0;
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", Gn(), gT(r);
        },
        useTransition: function() {
          return it = "useTransition", Gn(), vT();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", Gn(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", Gn(), lT(r, a, d);
        },
        useId: function() {
          return it = "useId", Gn(), bT();
        },
        unstable_isNewReconciler: U
      }, GI = {
        readContext: function(r) {
          return bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", Rt(), mT(r, a);
        },
        useContext: function(r) {
          return it = "useContext", Rt(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", Rt(), nS(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", Rt(), pT(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", Rt(), dT(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", Rt(), fT(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", Rt();
          var d = It.current;
          It.current = Os;
          try {
            return hT(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", Rt();
          var p = It.current;
          It.current = Os;
          try {
            return oT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", Rt(), uT(r);
        },
        useState: function(r) {
          it = "useState", Rt();
          var a = It.current;
          It.current = Os;
          try {
            return J0(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", Rt(), void 0;
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", Rt(), gT(r);
        },
        useTransition: function() {
          return it = "useTransition", Rt(), vT();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", Rt(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", Rt(), lT(r, a, d);
        },
        useId: function() {
          return it = "useId", Rt(), bT();
        },
        unstable_isNewReconciler: U
      }, WI = {
        readContext: function(r) {
          return bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", Rt(), lS(r, a);
        },
        useContext: function(r) {
          return it = "useContext", Rt(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", Rt(), qv(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", Rt(), aS(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", Rt(), rS(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", Rt(), oS(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", Rt();
          var d = It.current;
          It.current = Il;
          try {
            return sS(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", Rt();
          var p = It.current;
          It.current = Il;
          try {
            return aT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", Rt(), eS();
        },
        useState: function(r) {
          it = "useState", Rt();
          var a = It.current;
          It.current = Il;
          try {
            return sT(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", Rt(), iS();
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", Rt(), DI(r);
        },
        useTransition: function() {
          return it = "useTransition", Rt(), LI();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", Rt(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", Rt(), Z0(r, a);
        },
        useId: function() {
          return it = "useId", Rt(), cS();
        },
        unstable_isNewReconciler: U
      }, qI = {
        readContext: function(r) {
          return bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", Rt(), lS(r, a);
        },
        useContext: function(r) {
          return it = "useContext", Rt(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", Rt(), qv(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", Rt(), aS(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", Rt(), rS(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", Rt(), oS(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", Rt();
          var d = It.current;
          It.current = dS;
          try {
            return sS(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", Rt();
          var p = It.current;
          It.current = dS;
          try {
            return iT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", Rt(), eS();
        },
        useState: function(r) {
          it = "useState", Rt();
          var a = It.current;
          It.current = dS;
          try {
            return cT(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", Rt(), iS();
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", Rt(), _I(r);
        },
        useTransition: function() {
          return it = "useTransition", Rt(), FI();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", Rt(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", Rt(), Z0(r, a);
        },
        useId: function() {
          return it = "useId", Rt(), cS();
        },
        unstable_isNewReconciler: U
      }, Os = {
        readContext: function(r) {
          return yT(), bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", fn(), Gn(), mT(r, a);
        },
        useContext: function(r) {
          return it = "useContext", fn(), Gn(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", fn(), Gn(), nS(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", fn(), Gn(), pT(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", fn(), Gn(), dT(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", fn(), Gn(), fT(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", fn(), Gn();
          var d = It.current;
          It.current = Os;
          try {
            return hT(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", fn(), Gn();
          var p = It.current;
          It.current = Os;
          try {
            return oT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", fn(), Gn(), uT(r);
        },
        useState: function(r) {
          it = "useState", fn(), Gn();
          var a = It.current;
          It.current = Os;
          try {
            return J0(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", fn(), Gn(), void 0;
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", fn(), Gn(), gT(r);
        },
        useTransition: function() {
          return it = "useTransition", fn(), Gn(), vT();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", fn(), Gn(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", fn(), Gn(), lT(r, a, d);
        },
        useId: function() {
          return it = "useId", fn(), Gn(), bT();
        },
        unstable_isNewReconciler: U
      }, Il = {
        readContext: function(r) {
          return yT(), bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", fn(), Rt(), lS(r, a);
        },
        useContext: function(r) {
          return it = "useContext", fn(), Rt(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", fn(), Rt(), qv(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", fn(), Rt(), aS(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", fn(), Rt(), rS(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", fn(), Rt(), oS(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", fn(), Rt();
          var d = It.current;
          It.current = Il;
          try {
            return sS(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", fn(), Rt();
          var p = It.current;
          It.current = Il;
          try {
            return aT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", fn(), Rt(), eS();
        },
        useState: function(r) {
          it = "useState", fn(), Rt();
          var a = It.current;
          It.current = Il;
          try {
            return sT(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", fn(), Rt(), iS();
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", fn(), Rt(), DI(r);
        },
        useTransition: function() {
          return it = "useTransition", fn(), Rt(), LI();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", fn(), Rt(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", fn(), Rt(), Z0(r, a);
        },
        useId: function() {
          return it = "useId", fn(), Rt(), cS();
        },
        unstable_isNewReconciler: U
      }, dS = {
        readContext: function(r) {
          return yT(), bo(r);
        },
        useCallback: function(r, a) {
          return it = "useCallback", fn(), Rt(), lS(r, a);
        },
        useContext: function(r) {
          return it = "useContext", fn(), Rt(), bo(r);
        },
        useEffect: function(r, a) {
          return it = "useEffect", fn(), Rt(), qv(r, a);
        },
        useImperativeHandle: function(r, a, d) {
          return it = "useImperativeHandle", fn(), Rt(), aS(r, a, d);
        },
        useInsertionEffect: function(r, a) {
          return it = "useInsertionEffect", fn(), Rt(), rS(r, a);
        },
        useLayoutEffect: function(r, a) {
          return it = "useLayoutEffect", fn(), Rt(), oS(r, a);
        },
        useMemo: function(r, a) {
          it = "useMemo", fn(), Rt();
          var d = It.current;
          It.current = Il;
          try {
            return sS(r, a);
          } finally {
            It.current = d;
          }
        },
        useReducer: function(r, a, d) {
          it = "useReducer", fn(), Rt();
          var p = It.current;
          It.current = Il;
          try {
            return iT(r, a, d);
          } finally {
            It.current = p;
          }
        },
        useRef: function(r) {
          return it = "useRef", fn(), Rt(), eS();
        },
        useState: function(r) {
          it = "useState", fn(), Rt();
          var a = It.current;
          It.current = Il;
          try {
            return cT(r);
          } finally {
            It.current = a;
          }
        },
        useDebugValue: function(r, a) {
          return it = "useDebugValue", fn(), Rt(), iS();
        },
        useDeferredValue: function(r) {
          return it = "useDeferredValue", fn(), Rt(), _I(r);
        },
        useTransition: function() {
          return it = "useTransition", fn(), Rt(), FI();
        },
        useMutableSource: function(r, a, d) {
          return it = "useMutableSource", fn(), Rt(), void 0;
        },
        useSyncExternalStore: function(r, a, d) {
          return it = "useSyncExternalStore", fn(), Rt(), Z0(r, a);
        },
        useId: function() {
          return it = "useId", fn(), Rt(), cS();
        },
        unstable_isNewReconciler: U
      };
    }
    var Bu = t.unstable_now, YI = 0, fS = -1, Yv = -1, pS = -1, CT = !1, mS = !1;
    function KI() {
      return CT;
    }
    function EU() {
      mS = !0;
    }
    function TU() {
      CT = !1, mS = !1;
    }
    function OU() {
      CT = mS, mS = !1;
    }
    function XI() {
      return YI;
    }
    function QI() {
      YI = Bu();
    }
    function ST(r) {
      Yv = Bu(), r.actualStartTime < 0 && (r.actualStartTime = Bu());
    }
    function ZI(r) {
      Yv = -1;
    }
    function hS(r, a) {
      if (Yv >= 0) {
        var d = Bu() - Yv;
        r.actualDuration += d, a && (r.selfBaseDuration = d), Yv = -1;
      }
    }
    function Rs(r) {
      if (fS >= 0) {
        var a = Bu() - fS;
        fS = -1;
        for (var d = r.return; d !== null; ) {
          switch (d.tag) {
            case x:
              var p = d.stateNode;
              p.effectDuration += a;
              return;
            case z:
              var y = d.stateNode;
              y.effectDuration += a;
              return;
          }
          d = d.return;
        }
      }
    }
    function xT(r) {
      if (pS >= 0) {
        var a = Bu() - pS;
        pS = -1;
        for (var d = r.return; d !== null; ) {
          switch (d.tag) {
            case x:
              var p = d.stateNode;
              p !== null && (p.passiveEffectDuration += a);
              return;
            case z:
              var y = d.stateNode;
              y !== null && (y.passiveEffectDuration += a);
              return;
          }
          d = d.return;
        }
      }
    }
    function ks() {
      fS = Bu();
    }
    function wT() {
      pS = Bu();
    }
    function ET(r) {
      for (var a = r.child; a; )
        r.actualDuration += a.actualDuration, a = a.sibling;
    }
    function Ef(r, a) {
      return {
        value: r,
        source: a,
        stack: rg(a),
        digest: null
      };
    }
    function TT(r, a, d) {
      return {
        value: r,
        source: null,
        stack: d ?? null,
        digest: a ?? null
      };
    }
    function RU(r, a) {
      return !0;
    }
    function OT(r, a) {
      try {
        var d = RU(r, a);
        if (d === !1)
          return;
        var p = a.value, y = a.source, R = a.stack, D = R !== null ? R : "";
        if (p != null && p._suppressLogging) {
          if (r.tag === v)
            return;
          console.error(p);
        }
        var j = y ? mn(y) : null, Q = j ? "The above error occurred in the <" + j + "> component:" : "The above error occurred in one of your React components:", re;
        if (r.tag === x)
          re = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var ae = mn(r) || "Anonymous";
          re = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + ae + ".");
        }
        var ke = Q + `
` + D + `

` + ("" + re);
        console.error(ke);
      } catch (Ee) {
        setTimeout(function() {
          throw Ee;
        });
      }
    }
    var kU = typeof WeakMap == "function" ? WeakMap : Map;
    function JI(r, a, d) {
      var p = Pc(pr, d);
      p.tag = OE, p.payload = {
        element: null
      };
      var y = a.value;
      return p.callback = function() {
        C6(y), OT(r, a);
      }, p;
    }
    function RT(r, a, d) {
      var p = Pc(pr, d);
      p.tag = OE;
      var y = r.type.getDerivedStateFromError;
      if (typeof y == "function") {
        var R = a.value;
        p.payload = function() {
          return y(R);
        }, p.callback = function() {
          u$(r), OT(r, a);
        };
      }
      var D = r.stateNode;
      return D !== null && typeof D.componentDidCatch == "function" && (p.callback = function() {
        u$(r), OT(r, a), typeof y != "function" && b6(this);
        var Q = a.value, re = a.stack;
        this.componentDidCatch(Q, {
          componentStack: re !== null ? re : ""
        }), typeof y != "function" && (ga(r.lanes, on) || f("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", mn(r) || "Unknown"));
      }), p;
    }
    function eN(r, a, d) {
      var p = r.pingCache, y;
      if (p === null ? (p = r.pingCache = new kU(), y = /* @__PURE__ */ new Set(), p.set(a, y)) : (y = p.get(a), y === void 0 && (y = /* @__PURE__ */ new Set(), p.set(a, y))), !y.has(d)) {
        y.add(d);
        var R = S6.bind(null, r, a, d);
        To && ub(r, d), a.then(R, R);
      }
    }
    function PU(r, a, d, p) {
      var y = r.updateQueue;
      if (y === null) {
        var R = /* @__PURE__ */ new Set();
        R.add(d), r.updateQueue = R;
      } else
        y.add(d);
    }
    function MU(r, a) {
      var d = r.tag;
      if ((r.mode & xn) === tn && (d === h || d === _ || d === A)) {
        var p = r.alternate;
        p ? (r.updateQueue = p.updateQueue, r.memoizedState = p.memoizedState, r.lanes = p.lanes) : (r.updateQueue = null, r.memoizedState = null);
      }
    }
    function tN(r) {
      var a = r;
      do {
        if (a.tag === V && mU(a))
          return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function nN(r, a, d, p, y) {
      if ((r.mode & xn) === tn) {
        if (r === a)
          r.flags |= po;
        else {
          if (r.flags |= sn, d.flags |= Gd, d.flags &= ~($p | Pa), d.tag === v) {
            var R = d.alternate;
            if (R === null)
              d.tag = Y;
            else {
              var D = Pc(pr, on);
              D.tag = z0, Lu(d, D, on);
            }
          }
          d.lanes = vn(d.lanes, on);
        }
        return r;
      }
      return r.flags |= po, r.lanes = y, r;
    }
    function IU(r, a, d, p, y) {
      if (d.flags |= Pa, To && ub(r, y), p !== null && typeof p == "object" && typeof p.then == "function") {
        var R = p;
        MU(d), Xo() && d.mode & xn && WM();
        var D = tN(a);
        if (D !== null) {
          D.flags &= ~Lr, nN(D, a, d, r, y), D.mode & xn && eN(r, R, y), PU(D, r, R);
          return;
        } else {
          if (!hu(y)) {
            eN(r, R, y), iO();
            return;
          }
          var j = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          p = j;
        }
      } else if (Xo() && d.mode & xn) {
        WM();
        var Q = tN(a);
        if (Q !== null) {
          (Q.flags & po) === Jt && (Q.flags |= Lr), nN(Q, a, d, r, y), yE(Ef(p, d));
          return;
        }
      }
      p = Ef(p, d), u6(p);
      var re = a;
      do {
        switch (re.tag) {
          case x: {
            var ae = p;
            re.flags |= po;
            var ke = oo(y);
            re.lanes = vn(re.lanes, ke);
            var Ee = JI(re, ae, ke);
            PE(re, Ee);
            return;
          }
          case v:
            var He = p, Ue = re.type, Ke = re.stateNode;
            if ((re.flags & sn) === Jt && (typeof Ue.getDerivedStateFromError == "function" || Ke !== null && typeof Ke.componentDidCatch == "function" && !t$(Ke))) {
              re.flags |= po;
              var $t = oo(y);
              re.lanes = vn(re.lanes, $t);
              var en = RT(re, He, $t);
              PE(re, en);
              return;
            }
            break;
        }
        re = re.return;
      } while (re !== null);
    }
    function NU() {
      return null;
    }
    var Kv = o.ReactCurrentOwner, Nl = !1, kT, Xv, PT, MT, IT, Tf, NT, gS;
    kT = {}, Xv = {}, PT = {}, MT = {}, IT = {}, Tf = !1, NT = {}, gS = {};
    function _a(r, a, d, p) {
      r === null ? a.child = CI(a, null, d, p) : a.child = Bm(a, r.child, d, p);
    }
    function $U(r, a, d, p) {
      a.child = Bm(a, r.child, null, p), a.child = Bm(a, null, d, p);
    }
    function rN(r, a, d, p, y) {
      if (a.type !== a.elementType) {
        var R = d.propTypes;
        R && Ol(
          R,
          p,
          // Resolved props
          "prop",
          dr(d)
        );
      }
      var D = d.render, j = a.ref, Q, re;
      Vm(a, y), fs(a);
      {
        if (Kv.current = a, wi(!0), Q = qm(r, a, D, p, j, y), re = Ym(), a.mode & Rr) {
          ro(!0);
          try {
            Q = qm(r, a, D, p, j, y), re = Ym();
          } finally {
            ro(!1);
          }
        }
        wi(!1);
      }
      return oc(), r !== null && !Nl ? (TI(r, a, y), Mc(r, a, y)) : (Xo() && re && pE(a), a.flags |= as, _a(r, a, Q, y), a.child);
    }
    function oN(r, a, d, p, y) {
      if (r === null) {
        var R = d.type;
        if (F6(R) && d.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        d.defaultProps === void 0) {
          var D = R;
          return D = nh(R), a.tag = A, a.type = D, _T(a, R), aN(r, a, D, p, y);
        }
        {
          var j = R.propTypes;
          j && Ol(
            j,
            p,
            // Resolved props
            "prop",
            dr(R)
          );
        }
        var Q = vO(d.type, null, p, a, a.mode, y);
        return Q.ref = a.ref, Q.return = a, a.child = Q, Q;
      }
      {
        var re = d.type, ae = re.propTypes;
        ae && Ol(
          ae,
          p,
          // Resolved props
          "prop",
          dr(re)
        );
      }
      var ke = r.child, Ee = BT(r, y);
      if (!Ee) {
        var He = ke.memoizedProps, Ue = d.compare;
        if (Ue = Ue !== null ? Ue : Zt, Ue(He, p) && r.ref === a.ref)
          return Mc(r, a, y);
      }
      a.flags |= as;
      var Ke = Mf(ke, p);
      return Ke.ref = a.ref, Ke.return = a, a.child = Ke, Ke;
    }
    function aN(r, a, d, p, y) {
      if (a.type !== a.elementType) {
        var R = a.elementType;
        if (R.$$typeof === Ct) {
          var D = R, j = D._payload, Q = D._init;
          try {
            R = Q(j);
          } catch {
            R = null;
          }
          var re = R && R.propTypes;
          re && Ol(
            re,
            p,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            dr(R)
          );
        }
      }
      if (r !== null) {
        var ae = r.memoizedProps;
        if (Zt(ae, p) && r.ref === a.ref && // Prevent bailout if the implementation changed due to hot reload.
        a.type === r.type)
          if (Nl = !1, a.pendingProps = p = ae, BT(r, y))
            (r.flags & Gd) !== Jt && (Nl = !0);
          else
            return a.lanes = r.lanes, Mc(r, a, y);
      }
      return $T(r, a, d, p, y);
    }
    function iN(r, a, d) {
      var p = a.pendingProps, y = p.children, R = r !== null ? r.memoizedState : null;
      if (p.mode === "hidden" || ee)
        if ((a.mode & xn) === tn) {
          var D = {
            baseLanes: nt,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = D, PS(a, d);
        } else if (ga(d, ha)) {
          var ke = {
            baseLanes: nt,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = ke;
          var Ee = R !== null ? R.baseLanes : d;
          PS(a, Ee);
        } else {
          var j = null, Q;
          if (R !== null) {
            var re = R.baseLanes;
            Q = vn(re, d);
          } else
            Q = d;
          a.lanes = a.childLanes = ha;
          var ae = {
            baseLanes: Q,
            cachePool: j,
            transitions: null
          };
          return a.memoizedState = ae, a.updateQueue = null, PS(a, Q), null;
        }
      else {
        var He;
        R !== null ? (He = vn(R.baseLanes, d), a.memoizedState = null) : He = d, PS(a, He);
      }
      return _a(r, a, y, d), a.child;
    }
    function DU(r, a, d) {
      var p = a.pendingProps;
      return _a(r, a, p, d), a.child;
    }
    function _U(r, a, d) {
      var p = a.pendingProps.children;
      return _a(r, a, p, d), a.child;
    }
    function AU(r, a, d) {
      {
        a.flags |= gn;
        {
          var p = a.stateNode;
          p.effectDuration = 0, p.passiveEffectDuration = 0;
        }
      }
      var y = a.pendingProps, R = y.children;
      return _a(r, a, R, d), a.child;
    }
    function lN(r, a) {
      var d = a.ref;
      (r === null && d !== null || r !== null && r.ref !== d) && (a.flags |= ca, a.flags |= Ng);
    }
    function $T(r, a, d, p, y) {
      if (a.type !== a.elementType) {
        var R = d.propTypes;
        R && Ol(
          R,
          p,
          // Resolved props
          "prop",
          dr(d)
        );
      }
      var D;
      {
        var j = Dm(a, d, !0);
        D = _m(a, j);
      }
      var Q, re;
      Vm(a, y), fs(a);
      {
        if (Kv.current = a, wi(!0), Q = qm(r, a, d, p, D, y), re = Ym(), a.mode & Rr) {
          ro(!0);
          try {
            Q = qm(r, a, d, p, D, y), re = Ym();
          } finally {
            ro(!1);
          }
        }
        wi(!1);
      }
      return oc(), r !== null && !Nl ? (TI(r, a, y), Mc(r, a, y)) : (Xo() && re && pE(a), a.flags |= as, _a(r, a, Q, y), a.child);
    }
    function sN(r, a, d, p, y) {
      {
        switch (J6(a)) {
          case !1: {
            var R = a.stateNode, D = a.type, j = new D(a.memoizedProps, R.context), Q = j.state;
            R.updater.enqueueSetState(R, Q, null);
            break;
          }
          case !0: {
            a.flags |= sn, a.flags |= po;
            var re = new Error("Simulated error coming from DevTools"), ae = oo(y);
            a.lanes = vn(a.lanes, ae);
            var ke = RT(a, Ef(re, a), ae);
            PE(a, ke);
            break;
          }
        }
        if (a.type !== a.elementType) {
          var Ee = d.propTypes;
          Ee && Ol(
            Ee,
            p,
            // Resolved props
            "prop",
            dr(d)
          );
        }
      }
      var He;
      ws(d) ? (He = !0, k0(a)) : He = !1, Vm(a, y);
      var Ue = a.stateNode, Ke;
      Ue === null ? (bS(r, a), hI(a, d, p), BE(a, d, p, y), Ke = !0) : r === null ? Ke = sU(a, d, p, y) : Ke = cU(r, a, d, p, y);
      var $t = DT(r, a, d, Ke, He, y);
      {
        var en = a.stateNode;
        Ke && en.props !== p && (Tf || f("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", mn(a) || "a component"), Tf = !0);
      }
      return $t;
    }
    function DT(r, a, d, p, y, R) {
      lN(r, a);
      var D = (a.flags & sn) !== Jt;
      if (!p && !D)
        return y && jM(a, d, !1), Mc(r, a, R);
      var j = a.stateNode;
      Kv.current = a;
      var Q;
      if (D && typeof d.getDerivedStateFromError != "function")
        Q = null, ZI();
      else {
        fs(a);
        {
          if (wi(!0), Q = j.render(), a.mode & Rr) {
            ro(!0);
            try {
              j.render();
            } finally {
              ro(!1);
            }
          }
          wi(!1);
        }
        oc();
      }
      return a.flags |= as, r !== null && D ? $U(r, a, Q, R) : _a(r, a, Q, R), a.memoizedState = j.state, y && jM(a, d, !0), a.child;
    }
    function cN(r) {
      var a = r.stateNode;
      a.pendingContext ? VM(r, a.pendingContext, a.pendingContext !== a.context) : a.context && VM(r, a.context, !1), qE(r, a.containerInfo);
    }
    function LU(r, a, d) {
      if (cN(a), r === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var p = a.pendingProps, y = a.memoizedState, R = y.element;
      lI(r, a), H0(a, p, null, d);
      var D = a.memoizedState;
      a.stateNode;
      var j = D.element;
      if (y.isDehydrated) {
        var Q = {
          element: j,
          isDehydrated: !1,
          cache: D.cache,
          pendingSuspenseBoundaries: D.pendingSuspenseBoundaries,
          transitions: D.transitions
        }, re = a.updateQueue;
        if (re.baseState = Q, a.memoizedState = Q, a.flags & Lr) {
          var ae = Ef(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return uN(r, a, j, d, ae);
        } else if (j !== R) {
          var ke = Ef(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return uN(r, a, j, d, ke);
        } else {
          BH(a);
          var Ee = CI(a, null, j, d);
          a.child = Ee;
          for (var He = Ee; He; )
            He.flags = He.flags & ~hr | Xa, He = He.sibling;
        }
      } else {
        if (Fm(), j === R)
          return Mc(r, a, d);
        _a(r, a, j, d);
      }
      return a.child;
    }
    function uN(r, a, d, p, y) {
      return Fm(), yE(y), a.flags |= Lr, _a(r, a, d, p), a.child;
    }
    function FU(r, a, d) {
      xI(a), r === null && bE(a);
      var p = a.type, y = a.pendingProps, R = r !== null ? r.memoizedProps : null, D = y.children, j = Jw(p, y);
      return j ? D = null : R !== null && Jw(p, R) && (a.flags |= Un), lN(r, a), _a(r, a, D, d), a.child;
    }
    function zU(r, a) {
      return r === null && bE(a), null;
    }
    function VU(r, a, d, p) {
      bS(r, a);
      var y = a.pendingProps, R = d, D = R._payload, j = R._init, Q = j(D);
      a.type = Q;
      var re = a.tag = z6(Q), ae = Pl(Q, y), ke;
      switch (re) {
        case h:
          return _T(a, Q), a.type = Q = nh(Q), ke = $T(null, a, Q, ae, p), ke;
        case v:
          return a.type = Q = dO(Q), ke = sN(null, a, Q, ae, p), ke;
        case _:
          return a.type = Q = fO(Q), ke = rN(null, a, Q, ae, p), ke;
        case M: {
          if (a.type !== a.elementType) {
            var Ee = Q.propTypes;
            Ee && Ol(
              Ee,
              ae,
              // Resolved for outer only
              "prop",
              dr(Q)
            );
          }
          return ke = oN(
            null,
            a,
            Q,
            Pl(Q.type, ae),
            // The inner type can have defaults too
            p
          ), ke;
        }
      }
      var He = "";
      throw Q !== null && typeof Q == "object" && Q.$$typeof === Ct && (He = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + Q + ". " + ("Lazy element type must resolve to a class or function." + He));
    }
    function BU(r, a, d, p, y) {
      bS(r, a), a.tag = v;
      var R;
      return ws(d) ? (R = !0, k0(a)) : R = !1, Vm(a, y), hI(a, d, p), BE(a, d, p, y), DT(null, a, d, !0, R, y);
    }
    function jU(r, a, d, p) {
      bS(r, a);
      var y = a.pendingProps, R;
      {
        var D = Dm(a, d, !1);
        R = _m(a, D);
      }
      Vm(a, p);
      var j, Q;
      fs(a);
      {
        if (d.prototype && typeof d.prototype.render == "function") {
          var re = dr(d) || "Unknown";
          kT[re] || (f("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", re, re), kT[re] = !0);
        }
        a.mode & Rr && kl.recordLegacyContextWarning(a, null), wi(!0), Kv.current = a, j = qm(null, a, d, y, R, p), Q = Ym(), wi(!1);
      }
      if (oc(), a.flags |= as, typeof j == "object" && j !== null && typeof j.render == "function" && j.$$typeof === void 0) {
        var ae = dr(d) || "Unknown";
        Xv[ae] || (f("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ae, ae, ae), Xv[ae] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof j == "object" && j !== null && typeof j.render == "function" && j.$$typeof === void 0
      ) {
        {
          var ke = dr(d) || "Unknown";
          Xv[ke] || (f("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ke, ke, ke), Xv[ke] = !0);
        }
        a.tag = v, a.memoizedState = null, a.updateQueue = null;
        var Ee = !1;
        return ws(d) ? (Ee = !0, k0(a)) : Ee = !1, a.memoizedState = j.state !== null && j.state !== void 0 ? j.state : null, kE(a), mI(a, j), BE(a, d, y, p), DT(null, a, d, !0, Ee, p);
      } else {
        if (a.tag = h, a.mode & Rr) {
          ro(!0);
          try {
            j = qm(null, a, d, y, R, p), Q = Ym();
          } finally {
            ro(!1);
          }
        }
        return Xo() && Q && pE(a), _a(null, a, j, p), _T(a, d), a.child;
      }
    }
    function _T(r, a) {
      {
        if (a && a.childContextTypes && f("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), r.ref !== null) {
          var d = "", p = Wa();
          p && (d += `

Check the render method of \`` + p + "`.");
          var y = p || "", R = r._debugSource;
          R && (y = R.fileName + ":" + R.lineNumber), IT[y] || (IT[y] = !0, f("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", d));
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var D = dr(a) || "Unknown";
          MT[D] || (f("%s: Function components do not support getDerivedStateFromProps.", D), MT[D] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var j = dr(a) || "Unknown";
          PT[j] || (f("%s: Function components do not support contextType.", j), PT[j] = !0);
        }
      }
    }
    var AT = {
      dehydrated: null,
      treeContext: null,
      retryLane: Pn
    };
    function LT(r) {
      return {
        baseLanes: r,
        cachePool: NU(),
        transitions: null
      };
    }
    function HU(r, a) {
      var d = null;
      return {
        baseLanes: vn(r.baseLanes, a),
        cachePool: d,
        transitions: r.transitions
      };
    }
    function UU(r, a, d, p) {
      if (a !== null) {
        var y = a.memoizedState;
        if (y === null)
          return !1;
      }
      return XE(r, Bv);
    }
    function GU(r, a) {
      return gu(r.childLanes, a);
    }
    function dN(r, a, d) {
      var p = a.pendingProps;
      e8(a) && (a.flags |= sn);
      var y = Ml.current, R = !1, D = (a.flags & sn) !== Jt;
      if (D || UU(y, r) ? (R = !0, a.flags &= ~sn) : (r === null || r.memoizedState !== null) && (y = pU(y, EI)), y = Hm(y), zu(a, y), r === null) {
        bE(a);
        var j = a.memoizedState;
        if (j !== null) {
          var Q = j.dehydrated;
          if (Q !== null)
            return XU(a, Q);
        }
        var re = p.children, ae = p.fallback;
        if (R) {
          var ke = WU(a, re, ae, d), Ee = a.child;
          return Ee.memoizedState = LT(d), a.memoizedState = AT, ke;
        } else
          return FT(a, re);
      } else {
        var He = r.memoizedState;
        if (He !== null) {
          var Ue = He.dehydrated;
          if (Ue !== null)
            return QU(r, a, D, p, Ue, He, d);
        }
        if (R) {
          var Ke = p.fallback, $t = p.children, en = YU(r, a, $t, Ke, d), Kt = a.child, In = r.child.memoizedState;
          return Kt.memoizedState = In === null ? LT(d) : HU(In, d), Kt.childLanes = GU(r, d), a.memoizedState = AT, en;
        } else {
          var kn = p.children, Ae = qU(r, a, kn, d);
          return a.memoizedState = null, Ae;
        }
      }
    }
    function FT(r, a, d) {
      var p = r.mode, y = {
        mode: "visible",
        children: a
      }, R = zT(y, p);
      return R.return = r, r.child = R, R;
    }
    function WU(r, a, d, p) {
      var y = r.mode, R = r.child, D = {
        mode: "hidden",
        children: a
      }, j, Q;
      return (y & xn) === tn && R !== null ? (j = R, j.childLanes = nt, j.pendingProps = D, r.mode & nn && (j.actualDuration = 0, j.actualStartTime = -1, j.selfBaseDuration = 0, j.treeBaseDuration = 0), Q = qu(d, y, p, null)) : (j = zT(D, y), Q = qu(d, y, p, null)), j.return = r, Q.return = r, j.sibling = Q, r.child = j, Q;
    }
    function zT(r, a, d) {
      return f$(r, a, nt, null);
    }
    function fN(r, a) {
      return Mf(r, a);
    }
    function qU(r, a, d, p) {
      var y = r.child, R = y.sibling, D = fN(y, {
        mode: "visible",
        children: d
      });
      if ((a.mode & xn) === tn && (D.lanes = p), D.return = a, D.sibling = null, R !== null) {
        var j = a.deletions;
        j === null ? (a.deletions = [R], a.flags |= jn) : j.push(R);
      }
      return a.child = D, D;
    }
    function YU(r, a, d, p, y) {
      var R = a.mode, D = r.child, j = D.sibling, Q = {
        mode: "hidden",
        children: d
      }, re;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (R & xn) === tn && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        a.child !== D
      ) {
        var ae = a.child;
        re = ae, re.childLanes = nt, re.pendingProps = Q, a.mode & nn && (re.actualDuration = 0, re.actualStartTime = -1, re.selfBaseDuration = D.selfBaseDuration, re.treeBaseDuration = D.treeBaseDuration), a.deletions = null;
      } else
        re = fN(D, Q), re.subtreeFlags = D.subtreeFlags & Eo;
      var ke;
      return j !== null ? ke = Mf(j, p) : (ke = qu(p, R, y, null), ke.flags |= hr), ke.return = a, re.return = a, re.sibling = ke, a.child = re, ke;
    }
    function vS(r, a, d, p) {
      p !== null && yE(p), Bm(a, r.child, null, d);
      var y = a.pendingProps, R = y.children, D = FT(a, R);
      return D.flags |= hr, a.memoizedState = null, D;
    }
    function KU(r, a, d, p, y) {
      var R = a.mode, D = {
        mode: "visible",
        children: d
      }, j = zT(D, R), Q = qu(p, R, y, null);
      return Q.flags |= hr, j.return = a, Q.return = a, j.sibling = Q, a.child = j, (a.mode & xn) !== tn && Bm(a, r.child, null, y), Q;
    }
    function XU(r, a, d) {
      return (r.mode & xn) === tn ? (f("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), r.lanes = on) : rE(a) ? r.lanes = lc : r.lanes = ha, null;
    }
    function QU(r, a, d, p, y, R, D) {
      if (d)
        if (a.flags & Lr) {
          a.flags &= ~Lr;
          var Ae = TT(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return vS(r, a, D, Ae);
        } else {
          if (a.memoizedState !== null)
            return a.child = r.child, a.flags |= sn, null;
          var Xe = p.children, Le = p.fallback, xt = KU(r, a, Xe, Le, D), Dt = a.child;
          return Dt.memoizedState = LT(D), a.memoizedState = AT, xt;
        }
      else {
        if (zH(), (a.mode & xn) === tn)
          return vS(
            r,
            a,
            D,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (rE(y)) {
          var j, Q, re;
          {
            var ae = nH(y);
            j = ae.digest, Q = ae.message, re = ae.stack;
          }
          var ke;
          Q ? ke = new Error(Q) : ke = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Ee = TT(ke, j, re);
          return vS(r, a, D, Ee);
        }
        var He = ga(D, r.childLanes);
        if (Nl || He) {
          var Ue = kS();
          if (Ue !== null) {
            var Ke = Ew(Ue, D);
            if (Ke !== Pn && Ke !== R.retryLane) {
              R.retryLane = Ke;
              var $t = pr;
              ii(r, Ke), Do(Ue, r, Ke, $t);
            }
          }
          iO();
          var en = TT(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return vS(r, a, D, en);
        } else if (DM(y)) {
          a.flags |= sn, a.child = r.child;
          var Kt = x6.bind(null, r);
          return rH(y, Kt), null;
        } else {
          jH(a, y, R.treeContext);
          var In = p.children, kn = FT(a, In);
          return kn.flags |= Xa, kn;
        }
      }
    }
    function pN(r, a, d) {
      r.lanes = vn(r.lanes, a);
      var p = r.alternate;
      p !== null && (p.lanes = vn(p.lanes, a)), EE(r.return, a, d);
    }
    function ZU(r, a, d) {
      for (var p = a; p !== null; ) {
        if (p.tag === V) {
          var y = p.memoizedState;
          y !== null && pN(p, d, r);
        } else if (p.tag === G)
          pN(p, d, r);
        else if (p.child !== null) {
          p.child.return = p, p = p.child;
          continue;
        }
        if (p === r)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === r)
            return;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    function JU(r) {
      for (var a = r, d = null; a !== null; ) {
        var p = a.alternate;
        p !== null && X0(p) === null && (d = a), a = a.sibling;
      }
      return d;
    }
    function e3(r) {
      if (r !== void 0 && r !== "forwards" && r !== "backwards" && r !== "together" && !NT[r])
        if (NT[r] = !0, typeof r == "string")
          switch (r.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              f('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', r, r.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              f('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', r, r.toLowerCase());
              break;
            }
            default:
              f('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', r);
              break;
          }
        else
          f('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', r);
    }
    function t3(r, a) {
      r !== void 0 && !gS[r] && (r !== "collapsed" && r !== "hidden" ? (gS[r] = !0, f('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', r)) : a !== "forwards" && a !== "backwards" && (gS[r] = !0, f('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', r)));
    }
    function mN(r, a) {
      {
        var d = uo(r), p = !d && typeof cl(r) == "function";
        if (d || p) {
          var y = d ? "array" : "iterable";
          return f("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", y, a, y), !1;
        }
      }
      return !0;
    }
    function n3(r, a) {
      if ((a === "forwards" || a === "backwards") && r !== void 0 && r !== null && r !== !1)
        if (uo(r)) {
          for (var d = 0; d < r.length; d++)
            if (!mN(r[d], d))
              return;
        } else {
          var p = cl(r);
          if (typeof p == "function") {
            var y = p.call(r);
            if (y)
              for (var R = y.next(), D = 0; !R.done; R = y.next()) {
                if (!mN(R.value, D))
                  return;
                D++;
              }
          } else
            f('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
        }
    }
    function VT(r, a, d, p, y) {
      var R = r.memoizedState;
      R === null ? r.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: p,
        tail: d,
        tailMode: y
      } : (R.isBackwards = a, R.rendering = null, R.renderingStartTime = 0, R.last = p, R.tail = d, R.tailMode = y);
    }
    function hN(r, a, d) {
      var p = a.pendingProps, y = p.revealOrder, R = p.tail, D = p.children;
      e3(y), t3(R, y), n3(D, y), _a(r, a, D, d);
      var j = Ml.current, Q = XE(j, Bv);
      if (Q)
        j = QE(j, Bv), a.flags |= sn;
      else {
        var re = r !== null && (r.flags & sn) !== Jt;
        re && ZU(a, a.child, d), j = Hm(j);
      }
      if (zu(a, j), (a.mode & xn) === tn)
        a.memoizedState = null;
      else
        switch (y) {
          case "forwards": {
            var ae = JU(a.child), ke;
            ae === null ? (ke = a.child, a.child = null) : (ke = ae.sibling, ae.sibling = null), VT(
              a,
              !1,
              // isBackwards
              ke,
              ae,
              R
            );
            break;
          }
          case "backwards": {
            var Ee = null, He = a.child;
            for (a.child = null; He !== null; ) {
              var Ue = He.alternate;
              if (Ue !== null && X0(Ue) === null) {
                a.child = He;
                break;
              }
              var Ke = He.sibling;
              He.sibling = Ee, Ee = He, He = Ke;
            }
            VT(
              a,
              !0,
              // isBackwards
              Ee,
              null,
              // last
              R
            );
            break;
          }
          case "together": {
            VT(
              a,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            a.memoizedState = null;
        }
      return a.child;
    }
    function r3(r, a, d) {
      qE(a, a.stateNode.containerInfo);
      var p = a.pendingProps;
      return r === null ? a.child = Bm(a, null, p, d) : _a(r, a, p, d), a.child;
    }
    var gN = !1;
    function o3(r, a, d) {
      var p = a.type, y = p._context, R = a.pendingProps, D = a.memoizedProps, j = R.value;
      {
        "value" in R || gN || (gN = !0, f("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var Q = a.type.propTypes;
        Q && Ol(Q, R, "prop", "Context.Provider");
      }
      if (rI(a, y, j), D !== null) {
        var re = D.value;
        if (Bt(re, j)) {
          if (D.children === R.children && !O0())
            return Mc(r, a, d);
        } else
          ZH(a, y, d);
      }
      var ae = R.children;
      return _a(r, a, ae, d), a.child;
    }
    var vN = !1;
    function a3(r, a, d) {
      var p = a.type;
      p._context === void 0 ? p !== p.Consumer && (vN || (vN = !0, f("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : p = p._context;
      var y = a.pendingProps, R = y.children;
      typeof R != "function" && f("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Vm(a, d);
      var D = bo(p);
      fs(a);
      var j;
      return Kv.current = a, wi(!0), j = R(D), wi(!1), oc(), a.flags |= as, _a(r, a, j, d), a.child;
    }
    function Qv() {
      Nl = !0;
    }
    function bS(r, a) {
      (a.mode & xn) === tn && r !== null && (r.alternate = null, a.alternate = null, a.flags |= hr);
    }
    function Mc(r, a, d) {
      return r !== null && (a.dependencies = r.dependencies), ZI(), cb(a.lanes), ga(d, a.childLanes) ? (uU(r, a), a.child) : null;
    }
    function i3(r, a, d) {
      {
        var p = a.return;
        if (p === null)
          throw new Error("Cannot swap the root fiber.");
        if (r.alternate = null, a.alternate = null, d.index = a.index, d.sibling = a.sibling, d.return = a.return, d.ref = a.ref, a === p.child)
          p.child = d;
        else {
          var y = p.child;
          if (y === null)
            throw new Error("Expected parent to have a child.");
          for (; y.sibling !== a; )
            if (y = y.sibling, y === null)
              throw new Error("Expected to find the previous sibling.");
          y.sibling = d;
        }
        var R = p.deletions;
        return R === null ? (p.deletions = [r], p.flags |= jn) : R.push(r), d.flags |= hr, d;
      }
    }
    function BT(r, a) {
      var d = r.lanes;
      return !!ga(d, a);
    }
    function l3(r, a, d) {
      switch (a.tag) {
        case x:
          cN(a), a.stateNode, Fm();
          break;
        case T:
          xI(a);
          break;
        case v: {
          var p = a.type;
          ws(p) && k0(a);
          break;
        }
        case E:
          qE(a, a.stateNode.containerInfo);
          break;
        case $: {
          var y = a.memoizedProps.value, R = a.type._context;
          rI(a, R, y);
          break;
        }
        case z:
          {
            var D = ga(d, a.childLanes);
            D && (a.flags |= gn);
            {
              var j = a.stateNode;
              j.effectDuration = 0, j.passiveEffectDuration = 0;
            }
          }
          break;
        case V: {
          var Q = a.memoizedState;
          if (Q !== null) {
            if (Q.dehydrated !== null)
              return zu(a, Hm(Ml.current)), a.flags |= sn, null;
            var re = a.child, ae = re.childLanes;
            if (ga(d, ae))
              return dN(r, a, d);
            zu(a, Hm(Ml.current));
            var ke = Mc(r, a, d);
            return ke !== null ? ke.sibling : null;
          } else
            zu(a, Hm(Ml.current));
          break;
        }
        case G: {
          var Ee = (r.flags & sn) !== Jt, He = ga(d, a.childLanes);
          if (Ee) {
            if (He)
              return hN(r, a, d);
            a.flags |= sn;
          }
          var Ue = a.memoizedState;
          if (Ue !== null && (Ue.rendering = null, Ue.tail = null, Ue.lastEffect = null), zu(a, Ml.current), He)
            break;
          return null;
        }
        case K:
        case B:
          return a.lanes = nt, iN(r, a, d);
      }
      return Mc(r, a, d);
    }
    function bN(r, a, d) {
      if (a._debugNeedsRemount && r !== null)
        return i3(r, a, vO(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (r !== null) {
        var p = r.memoizedProps, y = a.pendingProps;
        if (p !== y || O0() || // Force a re-render if the implementation changed due to hot reload:
        a.type !== r.type)
          Nl = !0;
        else {
          var R = BT(r, d);
          if (!R && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & sn) === Jt)
            return Nl = !1, l3(r, a, d);
          (r.flags & Gd) !== Jt ? Nl = !0 : Nl = !1;
        }
      } else if (Nl = !1, Xo() && $H(a)) {
        var D = a.index, j = DH();
        GM(a, j, D);
      }
      switch (a.lanes = nt, a.tag) {
        case b:
          return jU(r, a, a.type, d);
        case W: {
          var Q = a.elementType;
          return VU(r, a, Q, d);
        }
        case h: {
          var re = a.type, ae = a.pendingProps, ke = a.elementType === re ? ae : Pl(re, ae);
          return $T(r, a, re, ke, d);
        }
        case v: {
          var Ee = a.type, He = a.pendingProps, Ue = a.elementType === Ee ? He : Pl(Ee, He);
          return sN(r, a, Ee, Ue, d);
        }
        case x:
          return LU(r, a, d);
        case T:
          return FU(r, a, d);
        case P:
          return zU(r, a);
        case V:
          return dN(r, a, d);
        case E:
          return r3(r, a, d);
        case _: {
          var Ke = a.type, $t = a.pendingProps, en = a.elementType === Ke ? $t : Pl(Ke, $t);
          return rN(r, a, Ke, en, d);
        }
        case O:
          return DU(r, a, d);
        case k:
          return _U(r, a, d);
        case z:
          return AU(r, a, d);
        case $:
          return o3(r, a, d);
        case I:
          return a3(r, a, d);
        case M: {
          var Kt = a.type, In = a.pendingProps, kn = Pl(Kt, In);
          if (a.type !== a.elementType) {
            var Ae = Kt.propTypes;
            Ae && Ol(
              Ae,
              kn,
              // Resolved for outer only
              "prop",
              dr(Kt)
            );
          }
          return kn = Pl(Kt.type, kn), oN(r, a, Kt, kn, d);
        }
        case A:
          return aN(r, a, a.type, a.pendingProps, d);
        case Y: {
          var Xe = a.type, Le = a.pendingProps, xt = a.elementType === Xe ? Le : Pl(Xe, Le);
          return BU(r, a, Xe, xt, d);
        }
        case G:
          return hN(r, a, d);
        case ne:
          break;
        case K:
          return iN(r, a, d);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Km(r) {
      r.flags |= gn;
    }
    function yN(r) {
      r.flags |= ca, r.flags |= Ng;
    }
    var CN, jT, SN, xN;
    CN = function(r, a, d, p) {
      for (var y = a.child; y !== null; ) {
        if (y.tag === T || y.tag === P)
          Mj(r, y.stateNode);
        else if (y.tag !== E) {
          if (y.child !== null) {
            y.child.return = y, y = y.child;
            continue;
          }
        }
        if (y === a)
          return;
        for (; y.sibling === null; ) {
          if (y.return === null || y.return === a)
            return;
          y = y.return;
        }
        y.sibling.return = y.return, y = y.sibling;
      }
    }, jT = function(r, a) {
    }, SN = function(r, a, d, p, y) {
      var R = r.memoizedProps;
      if (R !== p) {
        var D = a.stateNode, j = YE(), Q = Nj(D, d, R, p, y, j);
        a.updateQueue = Q, Q && Km(a);
      }
    }, xN = function(r, a, d, p) {
      d !== p && Km(a);
    };
    function Zv(r, a) {
      if (!Xo())
        switch (r.tailMode) {
          case "hidden": {
            for (var d = r.tail, p = null; d !== null; )
              d.alternate !== null && (p = d), d = d.sibling;
            p === null ? r.tail = null : p.sibling = null;
            break;
          }
          case "collapsed": {
            for (var y = r.tail, R = null; y !== null; )
              y.alternate !== null && (R = y), y = y.sibling;
            R === null ? !a && r.tail !== null ? r.tail.sibling = null : r.tail = null : R.sibling = null;
            break;
          }
        }
    }
    function Zo(r) {
      var a = r.alternate !== null && r.alternate.child === r.child, d = nt, p = Jt;
      if (a) {
        if ((r.mode & nn) !== tn) {
          for (var Q = r.selfBaseDuration, re = r.child; re !== null; )
            d = vn(d, vn(re.lanes, re.childLanes)), p |= re.subtreeFlags & Eo, p |= re.flags & Eo, Q += re.treeBaseDuration, re = re.sibling;
          r.treeBaseDuration = Q;
        } else
          for (var ae = r.child; ae !== null; )
            d = vn(d, vn(ae.lanes, ae.childLanes)), p |= ae.subtreeFlags & Eo, p |= ae.flags & Eo, ae.return = r, ae = ae.sibling;
        r.subtreeFlags |= p;
      } else {
        if ((r.mode & nn) !== tn) {
          for (var y = r.actualDuration, R = r.selfBaseDuration, D = r.child; D !== null; )
            d = vn(d, vn(D.lanes, D.childLanes)), p |= D.subtreeFlags, p |= D.flags, y += D.actualDuration, R += D.treeBaseDuration, D = D.sibling;
          r.actualDuration = y, r.treeBaseDuration = R;
        } else
          for (var j = r.child; j !== null; )
            d = vn(d, vn(j.lanes, j.childLanes)), p |= j.subtreeFlags, p |= j.flags, j.return = r, j = j.sibling;
        r.subtreeFlags |= p;
      }
      return r.childLanes = d, a;
    }
    function s3(r, a, d) {
      if (qH() && (a.mode & xn) !== tn && (a.flags & sn) === Jt)
        return ZM(a), Fm(), a.flags |= Lr | Pa | po, !1;
      var p = $0(a);
      if (d !== null && d.dehydrated !== null)
        if (r === null) {
          if (!p)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (GH(a), Zo(a), (a.mode & nn) !== tn) {
            var y = d !== null;
            if (y) {
              var R = a.child;
              R !== null && (a.treeBaseDuration -= R.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Fm(), (a.flags & sn) === Jt && (a.memoizedState = null), a.flags |= gn, Zo(a), (a.mode & nn) !== tn) {
            var D = d !== null;
            if (D) {
              var j = a.child;
              j !== null && (a.treeBaseDuration -= j.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return JM(), !0;
    }
    function wN(r, a, d) {
      var p = a.pendingProps;
      switch (mE(a), a.tag) {
        case b:
        case W:
        case A:
        case h:
        case _:
        case O:
        case k:
        case z:
        case I:
        case M:
          return Zo(a), null;
        case v: {
          var y = a.type;
          return ws(y) && R0(a), Zo(a), null;
        }
        case x: {
          var R = a.stateNode;
          if (jm(a), uE(a), JE(), R.pendingContext && (R.context = R.pendingContext, R.pendingContext = null), r === null || r.child === null) {
            var D = $0(a);
            if (D)
              Km(a);
            else if (r !== null) {
              var j = r.memoizedState;
              // Check if this is a client root
              (!j.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (a.flags & Lr) !== Jt) && (a.flags |= Ka, JM());
            }
          }
          return jT(r, a), Zo(a), null;
        }
        case T: {
          KE(a);
          var Q = SI(), re = a.type;
          if (r !== null && a.stateNode != null)
            SN(r, a, re, p, Q), r.ref !== a.ref && yN(a);
          else {
            if (!p) {
              if (a.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Zo(a), null;
            }
            var ae = YE(), ke = $0(a);
            if (ke)
              HH(a, Q, ae) && Km(a);
            else {
              var Ee = Pj(re, p, Q, ae, a);
              CN(Ee, a, !1, !1), a.stateNode = Ee, Ij(Ee, re, p, Q) && Km(a);
            }
            a.ref !== null && yN(a);
          }
          return Zo(a), null;
        }
        case P: {
          var He = p;
          if (r && a.stateNode != null) {
            var Ue = r.memoizedProps;
            xN(r, a, Ue, He);
          } else {
            if (typeof He != "string" && a.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Ke = SI(), $t = YE(), en = $0(a);
            en ? UH(a) && Km(a) : a.stateNode = $j(He, Ke, $t, a);
          }
          return Zo(a), null;
        }
        case V: {
          Um(a);
          var Kt = a.memoizedState;
          if (r === null || r.memoizedState !== null && r.memoizedState.dehydrated !== null) {
            var In = s3(r, a, Kt);
            if (!In)
              return a.flags & po ? a : null;
          }
          if ((a.flags & sn) !== Jt)
            return a.lanes = d, (a.mode & nn) !== tn && ET(a), a;
          var kn = Kt !== null, Ae = r !== null && r.memoizedState !== null;
          if (kn !== Ae && kn) {
            var Xe = a.child;
            if (Xe.flags |= is, (a.mode & xn) !== tn) {
              var Le = r === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !ie);
              Le || XE(Ml.current, EI) ? c6() : iO();
            }
          }
          var xt = a.updateQueue;
          if (xt !== null && (a.flags |= gn), Zo(a), (a.mode & nn) !== tn && kn) {
            var Dt = a.child;
            Dt !== null && (a.treeBaseDuration -= Dt.treeBaseDuration);
          }
          return null;
        }
        case E:
          return jm(a), jT(r, a), r === null && OH(a.stateNode.containerInfo), Zo(a), null;
        case $:
          var Pt = a.type._context;
          return wE(Pt, a), Zo(a), null;
        case Y: {
          var ln = a.type;
          return ws(ln) && R0(a), Zo(a), null;
        }
        case G: {
          Um(a);
          var pn = a.memoizedState;
          if (pn === null)
            return Zo(a), null;
          var tr = (a.flags & sn) !== Jt, Ln = pn.rendering;
          if (Ln === null)
            if (tr)
              Zv(pn, !1);
            else {
              var so = d6() && (r === null || (r.flags & sn) === Jt);
              if (!so)
                for (var Fn = a.child; Fn !== null; ) {
                  var Xr = X0(Fn);
                  if (Xr !== null) {
                    tr = !0, a.flags |= sn, Zv(pn, !1);
                    var Ca = Xr.updateQueue;
                    return Ca !== null && (a.updateQueue = Ca, a.flags |= gn), a.subtreeFlags = Jt, dU(a, d), zu(a, QE(Ml.current, Bv)), a.child;
                  }
                  Fn = Fn.sibling;
                }
              pn.tail !== null && Or() > UN() && (a.flags |= sn, tr = !0, Zv(pn, !1), a.lanes = Gg);
            }
          else {
            if (!tr) {
              var ra = X0(Ln);
              if (ra !== null) {
                a.flags |= sn, tr = !0;
                var Ii = ra.updateQueue;
                if (Ii !== null && (a.updateQueue = Ii, a.flags |= gn), Zv(pn, !0), pn.tail === null && pn.tailMode === "hidden" && !Ln.alternate && !Xo())
                  return Zo(a), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                Or() * 2 - pn.renderingStartTime > UN() && d !== ha && (a.flags |= sn, tr = !0, Zv(pn, !1), a.lanes = Gg);
            }
            if (pn.isBackwards)
              Ln.sibling = a.child, a.child = Ln;
            else {
              var Fa = pn.last;
              Fa !== null ? Fa.sibling = Ln : a.child = Ln, pn.last = Ln;
            }
          }
          if (pn.tail !== null) {
            var za = pn.tail;
            pn.rendering = za, pn.tail = za.sibling, pn.renderingStartTime = Or(), za.sibling = null;
            var Sa = Ml.current;
            return tr ? Sa = QE(Sa, Bv) : Sa = Hm(Sa), zu(a, Sa), za;
          }
          return Zo(a), null;
        }
        case ne:
          break;
        case K:
        case B: {
          aO(a);
          var _c = a.memoizedState, rh = _c !== null;
          if (r !== null) {
            var mb = r.memoizedState, Is = mb !== null;
            Is !== rh && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !ee && (a.flags |= is);
          }
          return !rh || (a.mode & xn) === tn ? Zo(a) : ga(Ms, ha) && (Zo(a), a.subtreeFlags & (hr | gn) && (a.flags |= is)), null;
        }
        case q:
          return null;
        case X:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function c3(r, a, d) {
      switch (mE(a), a.tag) {
        case v: {
          var p = a.type;
          ws(p) && R0(a);
          var y = a.flags;
          return y & po ? (a.flags = y & ~po | sn, (a.mode & nn) !== tn && ET(a), a) : null;
        }
        case x: {
          a.stateNode, jm(a), uE(a), JE();
          var R = a.flags;
          return (R & po) !== Jt && (R & sn) === Jt ? (a.flags = R & ~po | sn, a) : null;
        }
        case T:
          return KE(a), null;
        case V: {
          Um(a);
          var D = a.memoizedState;
          if (D !== null && D.dehydrated !== null) {
            if (a.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Fm();
          }
          var j = a.flags;
          return j & po ? (a.flags = j & ~po | sn, (a.mode & nn) !== tn && ET(a), a) : null;
        }
        case G:
          return Um(a), null;
        case E:
          return jm(a), null;
        case $:
          var Q = a.type._context;
          return wE(Q, a), null;
        case K:
        case B:
          return aO(a), null;
        case q:
          return null;
        default:
          return null;
      }
    }
    function EN(r, a, d) {
      switch (mE(a), a.tag) {
        case v: {
          var p = a.type.childContextTypes;
          p != null && R0(a);
          break;
        }
        case x: {
          a.stateNode, jm(a), uE(a), JE();
          break;
        }
        case T: {
          KE(a);
          break;
        }
        case E:
          jm(a);
          break;
        case V:
          Um(a);
          break;
        case G:
          Um(a);
          break;
        case $:
          var y = a.type._context;
          wE(y, a);
          break;
        case K:
        case B:
          aO(a);
          break;
      }
    }
    var TN = null;
    TN = /* @__PURE__ */ new Set();
    var yS = !1, Jo = !1, u3 = typeof WeakSet == "function" ? WeakSet : Set, jt = null, Xm = null, Qm = null;
    function d3(r) {
      nc(null, function() {
        throw r;
      }), Mg();
    }
    var f3 = function(r, a) {
      if (a.props = r.memoizedProps, a.state = r.memoizedState, r.mode & nn)
        try {
          ks(), a.componentWillUnmount();
        } finally {
          Rs(r);
        }
      else
        a.componentWillUnmount();
    };
    function ON(r, a) {
      try {
        ju(ko, r);
      } catch (d) {
        yr(r, a, d);
      }
    }
    function HT(r, a, d) {
      try {
        f3(r, d);
      } catch (p) {
        yr(r, a, p);
      }
    }
    function p3(r, a, d) {
      try {
        d.componentDidMount();
      } catch (p) {
        yr(r, a, p);
      }
    }
    function RN(r, a) {
      try {
        PN(r);
      } catch (d) {
        yr(r, a, d);
      }
    }
    function Zm(r, a) {
      var d = r.ref;
      if (d !== null)
        if (typeof d == "function") {
          var p;
          try {
            if (me && Oe && r.mode & nn)
              try {
                ks(), p = d(null);
              } finally {
                Rs(r);
              }
            else
              p = d(null);
          } catch (y) {
            yr(r, a, y);
          }
          typeof p == "function" && f("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", mn(r));
        } else
          d.current = null;
    }
    function CS(r, a, d) {
      try {
        d();
      } catch (p) {
        yr(r, a, p);
      }
    }
    var kN = !1;
    function m3(r, a) {
      Rj(r.containerInfo), jt = a, h3();
      var d = kN;
      return kN = !1, d;
    }
    function h3() {
      for (; jt !== null; ) {
        var r = jt, a = r.child;
        (r.subtreeFlags & su) !== Jt && a !== null ? (a.return = r, jt = a) : g3();
      }
    }
    function g3() {
      for (; jt !== null; ) {
        var r = jt;
        Jn(r);
        try {
          v3(r);
        } catch (d) {
          yr(r, r.return, d);
        }
        no();
        var a = r.sibling;
        if (a !== null) {
          a.return = r.return, jt = a;
          return;
        }
        jt = r.return;
      }
    }
    function v3(r) {
      var a = r.alternate, d = r.flags;
      if ((d & Ka) !== Jt) {
        switch (Jn(r), r.tag) {
          case h:
          case _:
          case A:
            break;
          case v: {
            if (a !== null) {
              var p = a.memoizedProps, y = a.memoizedState, R = r.stateNode;
              r.type === r.elementType && !Tf && (R.props !== r.memoizedProps && f("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", mn(r) || "instance"), R.state !== r.memoizedState && f("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", mn(r) || "instance"));
              var D = R.getSnapshotBeforeUpdate(r.elementType === r.type ? p : Pl(r.type, p), y);
              {
                var j = TN;
                D === void 0 && !j.has(r.type) && (j.add(r.type), f("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", mn(r)));
              }
              R.__reactInternalSnapshotBeforeUpdate = D;
            }
            break;
          }
          case x: {
            {
              var Q = r.stateNode;
              Zj(Q.containerInfo);
            }
            break;
          }
          case T:
          case P:
          case E:
          case Y:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        no();
      }
    }
    function $l(r, a, d) {
      var p = a.updateQueue, y = p !== null ? p.lastEffect : null;
      if (y !== null) {
        var R = y.next, D = R;
        do {
          if ((D.tag & r) === r) {
            var j = D.destroy;
            D.destroy = void 0, j !== void 0 && ((r & Qo) !== li ? Bp(a) : (r & ko) !== li && jp(a), (r & Es) !== li && db(!0), CS(a, d, j), (r & Es) !== li && db(!1), (r & Qo) !== li ? NC() : (r & ko) !== li && cu());
          }
          D = D.next;
        } while (D !== R);
      }
    }
    function ju(r, a) {
      var d = a.updateQueue, p = d !== null ? d.lastEffect : null;
      if (p !== null) {
        var y = p.next, R = y;
        do {
          if ((R.tag & r) === r) {
            (r & Qo) !== li ? IC(a) : (r & ko) !== li && $C(a);
            var D = R.create;
            (r & Es) !== li && db(!0), R.destroy = D(), (r & Es) !== li && db(!1), (r & Qo) !== li ? jg() : (r & ko) !== li && DC();
            {
              var j = R.destroy;
              if (j !== void 0 && typeof j != "function") {
                var Q = void 0;
                (R.tag & ko) !== Jt ? Q = "useLayoutEffect" : (R.tag & Es) !== Jt ? Q = "useInsertionEffect" : Q = "useEffect";
                var re = void 0;
                j === null ? re = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof j.then == "function" ? re = `

It looks like you wrote ` + Q + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + Q + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : re = " You returned: " + j, f("%s must not return anything besides a function, which is used for clean-up.%s", Q, re);
              }
            }
          }
          R = R.next;
        } while (R !== y);
      }
    }
    function b3(r, a) {
      if ((a.flags & gn) !== Jt)
        switch (a.tag) {
          case z: {
            var d = a.stateNode.passiveEffectDuration, p = a.memoizedProps, y = p.id, R = p.onPostCommit, D = XI(), j = a.alternate === null ? "mount" : "update";
            KI() && (j = "nested-update"), typeof R == "function" && R(y, j, d, D);
            var Q = a.return;
            e:
              for (; Q !== null; ) {
                switch (Q.tag) {
                  case x:
                    var re = Q.stateNode;
                    re.passiveEffectDuration += d;
                    break e;
                  case z:
                    var ae = Q.stateNode;
                    ae.passiveEffectDuration += d;
                    break e;
                }
                Q = Q.return;
              }
            break;
          }
        }
    }
    function y3(r, a, d, p) {
      if ((d.flags & Bo) !== Jt)
        switch (d.tag) {
          case h:
          case _:
          case A: {
            if (!Jo)
              if (d.mode & nn)
                try {
                  ks(), ju(ko | Ro, d);
                } finally {
                  Rs(d);
                }
              else
                ju(ko | Ro, d);
            break;
          }
          case v: {
            var y = d.stateNode;
            if (d.flags & gn && !Jo)
              if (a === null)
                if (d.type === d.elementType && !Tf && (y.props !== d.memoizedProps && f("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", mn(d) || "instance"), y.state !== d.memoizedState && f("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", mn(d) || "instance")), d.mode & nn)
                  try {
                    ks(), y.componentDidMount();
                  } finally {
                    Rs(d);
                  }
                else
                  y.componentDidMount();
              else {
                var R = d.elementType === d.type ? a.memoizedProps : Pl(d.type, a.memoizedProps), D = a.memoizedState;
                if (d.type === d.elementType && !Tf && (y.props !== d.memoizedProps && f("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", mn(d) || "instance"), y.state !== d.memoizedState && f("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", mn(d) || "instance")), d.mode & nn)
                  try {
                    ks(), y.componentDidUpdate(R, D, y.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Rs(d);
                  }
                else
                  y.componentDidUpdate(R, D, y.__reactInternalSnapshotBeforeUpdate);
              }
            var j = d.updateQueue;
            j !== null && (d.type === d.elementType && !Tf && (y.props !== d.memoizedProps && f("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", mn(d) || "instance"), y.state !== d.memoizedState && f("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", mn(d) || "instance")), cI(d, j, y));
            break;
          }
          case x: {
            var Q = d.updateQueue;
            if (Q !== null) {
              var re = null;
              if (d.child !== null)
                switch (d.child.tag) {
                  case T:
                    re = d.child.stateNode;
                    break;
                  case v:
                    re = d.child.stateNode;
                    break;
                }
              cI(d, Q, re);
            }
            break;
          }
          case T: {
            var ae = d.stateNode;
            if (a === null && d.flags & gn) {
              var ke = d.type, Ee = d.memoizedProps;
              Fj(ae, ke, Ee);
            }
            break;
          }
          case P:
            break;
          case E:
            break;
          case z: {
            {
              var He = d.memoizedProps, Ue = He.onCommit, Ke = He.onRender, $t = d.stateNode.effectDuration, en = XI(), Kt = a === null ? "mount" : "update";
              KI() && (Kt = "nested-update"), typeof Ke == "function" && Ke(d.memoizedProps.id, Kt, d.actualDuration, d.treeBaseDuration, d.actualStartTime, en);
              {
                typeof Ue == "function" && Ue(d.memoizedProps.id, Kt, $t, en), g6(d);
                var In = d.return;
                e:
                  for (; In !== null; ) {
                    switch (In.tag) {
                      case x:
                        var kn = In.stateNode;
                        kn.effectDuration += $t;
                        break e;
                      case z:
                        var Ae = In.stateNode;
                        Ae.effectDuration += $t;
                        break e;
                    }
                    In = In.return;
                  }
              }
            }
            break;
          }
          case V: {
            R3(r, d);
            break;
          }
          case G:
          case Y:
          case ne:
          case K:
          case B:
          case X:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Jo || d.flags & ca && PN(d);
    }
    function C3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          if (r.mode & nn)
            try {
              ks(), ON(r, r.return);
            } finally {
              Rs(r);
            }
          else
            ON(r, r.return);
          break;
        }
        case v: {
          var a = r.stateNode;
          typeof a.componentDidMount == "function" && p3(r, r.return, a), RN(r, r.return);
          break;
        }
        case T: {
          RN(r, r.return);
          break;
        }
      }
    }
    function S3(r, a) {
      for (var d = null, p = r; ; ) {
        if (p.tag === T) {
          if (d === null) {
            d = p;
            try {
              var y = p.stateNode;
              a ? Yj(y) : Xj(p.stateNode, p.memoizedProps);
            } catch (D) {
              yr(r, r.return, D);
            }
          }
        } else if (p.tag === P) {
          if (d === null)
            try {
              var R = p.stateNode;
              a ? Kj(R) : Qj(R, p.memoizedProps);
            } catch (D) {
              yr(r, r.return, D);
            }
        } else if (!((p.tag === K || p.tag === B) && p.memoizedState !== null && p !== r)) {
          if (p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
        }
        if (p === r)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === r)
            return;
          d === p && (d = null), p = p.return;
        }
        d === p && (d = null), p.sibling.return = p.return, p = p.sibling;
      }
    }
    function PN(r) {
      var a = r.ref;
      if (a !== null) {
        var d = r.stateNode, p;
        switch (r.tag) {
          case T:
            p = d;
            break;
          default:
            p = d;
        }
        if (typeof a == "function") {
          var y;
          if (r.mode & nn)
            try {
              ks(), y = a(p);
            } finally {
              Rs(r);
            }
          else
            y = a(p);
          typeof y == "function" && f("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", mn(r));
        } else
          a.hasOwnProperty("current") || f("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", mn(r)), a.current = p;
      }
    }
    function x3(r) {
      var a = r.alternate;
      a !== null && (a.return = null), r.return = null;
    }
    function MN(r) {
      var a = r.alternate;
      a !== null && (r.alternate = null, MN(a));
      {
        if (r.child = null, r.deletions = null, r.sibling = null, r.tag === T) {
          var d = r.stateNode;
          d !== null && PH(d);
        }
        r.stateNode = null, r._debugOwner = null, r.return = null, r.dependencies = null, r.memoizedProps = null, r.memoizedState = null, r.pendingProps = null, r.stateNode = null, r.updateQueue = null;
      }
    }
    function w3(r) {
      for (var a = r.return; a !== null; ) {
        if (IN(a))
          return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function IN(r) {
      return r.tag === T || r.tag === x || r.tag === E;
    }
    function NN(r) {
      var a = r;
      e:
        for (; ; ) {
          for (; a.sibling === null; ) {
            if (a.return === null || IN(a.return))
              return null;
            a = a.return;
          }
          for (a.sibling.return = a.return, a = a.sibling; a.tag !== T && a.tag !== P && a.tag !== H; ) {
            if (a.flags & hr || a.child === null || a.tag === E)
              continue e;
            a.child.return = a, a = a.child;
          }
          if (!(a.flags & hr))
            return a.stateNode;
        }
    }
    function E3(r) {
      var a = w3(r);
      switch (a.tag) {
        case T: {
          var d = a.stateNode;
          a.flags & Un && ($M(d), a.flags &= ~Un);
          var p = NN(r);
          GT(r, p, d);
          break;
        }
        case x:
        case E: {
          var y = a.stateNode.containerInfo, R = NN(r);
          UT(r, R, y);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function UT(r, a, d) {
      var p = r.tag, y = p === T || p === P;
      if (y) {
        var R = r.stateNode;
        a ? Uj(d, R, a) : jj(d, R);
      } else if (p !== E) {
        var D = r.child;
        if (D !== null) {
          UT(D, a, d);
          for (var j = D.sibling; j !== null; )
            UT(j, a, d), j = j.sibling;
        }
      }
    }
    function GT(r, a, d) {
      var p = r.tag, y = p === T || p === P;
      if (y) {
        var R = r.stateNode;
        a ? Hj(d, R, a) : Bj(d, R);
      } else if (p !== E) {
        var D = r.child;
        if (D !== null) {
          GT(D, a, d);
          for (var j = D.sibling; j !== null; )
            GT(j, a, d), j = j.sibling;
        }
      }
    }
    var ea = null, Dl = !1;
    function T3(r, a, d) {
      {
        var p = a;
        e:
          for (; p !== null; ) {
            switch (p.tag) {
              case T: {
                ea = p.stateNode, Dl = !1;
                break e;
              }
              case x: {
                ea = p.stateNode.containerInfo, Dl = !0;
                break e;
              }
              case E: {
                ea = p.stateNode.containerInfo, Dl = !0;
                break e;
              }
            }
            p = p.return;
          }
        if (ea === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        $N(r, a, d), ea = null, Dl = !1;
      }
      x3(d);
    }
    function Hu(r, a, d) {
      for (var p = d.child; p !== null; )
        $N(r, a, p), p = p.sibling;
    }
    function $N(r, a, d) {
      switch (Vg(d), d.tag) {
        case T:
          Jo || Zm(d, a);
        case P: {
          {
            var p = ea, y = Dl;
            ea = null, Hu(r, a, d), ea = p, Dl = y, ea !== null && (Dl ? Wj(ea, d.stateNode) : Gj(ea, d.stateNode));
          }
          return;
        }
        case H: {
          ea !== null && (Dl ? qj(ea, d.stateNode) : nE(ea, d.stateNode));
          return;
        }
        case E: {
          {
            var R = ea, D = Dl;
            ea = d.stateNode.containerInfo, Dl = !0, Hu(r, a, d), ea = R, Dl = D;
          }
          return;
        }
        case h:
        case _:
        case M:
        case A: {
          if (!Jo) {
            var j = d.updateQueue;
            if (j !== null) {
              var Q = j.lastEffect;
              if (Q !== null) {
                var re = Q.next, ae = re;
                do {
                  var ke = ae, Ee = ke.destroy, He = ke.tag;
                  Ee !== void 0 && ((He & Es) !== li ? CS(d, a, Ee) : (He & ko) !== li && (jp(d), d.mode & nn ? (ks(), CS(d, a, Ee), Rs(d)) : CS(d, a, Ee), cu())), ae = ae.next;
                } while (ae !== re);
              }
            }
          }
          Hu(r, a, d);
          return;
        }
        case v: {
          if (!Jo) {
            Zm(d, a);
            var Ue = d.stateNode;
            typeof Ue.componentWillUnmount == "function" && HT(d, a, Ue);
          }
          Hu(r, a, d);
          return;
        }
        case ne: {
          Hu(r, a, d);
          return;
        }
        case K: {
          if (
            // TODO: Remove this dead flag
            d.mode & xn
          ) {
            var Ke = Jo;
            Jo = Ke || d.memoizedState !== null, Hu(r, a, d), Jo = Ke;
          } else
            Hu(r, a, d);
          break;
        }
        default: {
          Hu(r, a, d);
          return;
        }
      }
    }
    function O3(r) {
      r.memoizedState;
    }
    function R3(r, a) {
      var d = a.memoizedState;
      if (d === null) {
        var p = a.alternate;
        if (p !== null) {
          var y = p.memoizedState;
          if (y !== null) {
            var R = y.dehydrated;
            R !== null && fH(R);
          }
        }
      }
    }
    function DN(r) {
      var a = r.updateQueue;
      if (a !== null) {
        r.updateQueue = null;
        var d = r.stateNode;
        d === null && (d = r.stateNode = new u3()), a.forEach(function(p) {
          var y = w6.bind(null, r, p);
          if (!d.has(p)) {
            if (d.add(p), To)
              if (Xm !== null && Qm !== null)
                ub(Qm, Xm);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            p.then(y, y);
          }
        });
      }
    }
    function k3(r, a, d) {
      Xm = d, Qm = r, Jn(a), _N(a, r), Jn(a), Xm = null, Qm = null;
    }
    function _l(r, a, d) {
      var p = a.deletions;
      if (p !== null)
        for (var y = 0; y < p.length; y++) {
          var R = p[y];
          try {
            T3(r, a, R);
          } catch (Q) {
            yr(R, a, Q);
          }
        }
      var D = tw();
      if (a.subtreeFlags & fa)
        for (var j = a.child; j !== null; )
          Jn(j), _N(j, r), j = j.sibling;
      Jn(D);
    }
    function _N(r, a, d) {
      var p = r.alternate, y = r.flags;
      switch (r.tag) {
        case h:
        case _:
        case M:
        case A: {
          if (_l(a, r), Ps(r), y & gn) {
            try {
              $l(Es | Ro, r, r.return), ju(Es | Ro, r);
            } catch (ln) {
              yr(r, r.return, ln);
            }
            if (r.mode & nn) {
              try {
                ks(), $l(ko | Ro, r, r.return);
              } catch (ln) {
                yr(r, r.return, ln);
              }
              Rs(r);
            } else
              try {
                $l(ko | Ro, r, r.return);
              } catch (ln) {
                yr(r, r.return, ln);
              }
          }
          return;
        }
        case v: {
          _l(a, r), Ps(r), y & ca && p !== null && Zm(p, p.return);
          return;
        }
        case T: {
          _l(a, r), Ps(r), y & ca && p !== null && Zm(p, p.return);
          {
            if (r.flags & Un) {
              var R = r.stateNode;
              try {
                $M(R);
              } catch (ln) {
                yr(r, r.return, ln);
              }
            }
            if (y & gn) {
              var D = r.stateNode;
              if (D != null) {
                var j = r.memoizedProps, Q = p !== null ? p.memoizedProps : j, re = r.type, ae = r.updateQueue;
                if (r.updateQueue = null, ae !== null)
                  try {
                    zj(D, ae, re, Q, j, r);
                  } catch (ln) {
                    yr(r, r.return, ln);
                  }
              }
            }
          }
          return;
        }
        case P: {
          if (_l(a, r), Ps(r), y & gn) {
            if (r.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var ke = r.stateNode, Ee = r.memoizedProps, He = p !== null ? p.memoizedProps : Ee;
            try {
              Vj(ke, He, Ee);
            } catch (ln) {
              yr(r, r.return, ln);
            }
          }
          return;
        }
        case x: {
          if (_l(a, r), Ps(r), y & gn && p !== null) {
            var Ue = p.memoizedState;
            if (Ue.isDehydrated)
              try {
                dH(a.containerInfo);
              } catch (ln) {
                yr(r, r.return, ln);
              }
          }
          return;
        }
        case E: {
          _l(a, r), Ps(r);
          return;
        }
        case V: {
          _l(a, r), Ps(r);
          var Ke = r.child;
          if (Ke.flags & is) {
            var $t = Ke.stateNode, en = Ke.memoizedState, Kt = en !== null;
            if ($t.isHidden = Kt, Kt) {
              var In = Ke.alternate !== null && Ke.alternate.memoizedState !== null;
              In || s6();
            }
          }
          if (y & gn) {
            try {
              O3(r);
            } catch (ln) {
              yr(r, r.return, ln);
            }
            DN(r);
          }
          return;
        }
        case K: {
          var kn = p !== null && p.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            r.mode & xn
          ) {
            var Ae = Jo;
            Jo = Ae || kn, _l(a, r), Jo = Ae;
          } else
            _l(a, r);
          if (Ps(r), y & is) {
            var Xe = r.stateNode, Le = r.memoizedState, xt = Le !== null, Dt = r;
            if (Xe.isHidden = xt, xt && !kn && (Dt.mode & xn) !== tn) {
              jt = Dt;
              for (var Pt = Dt.child; Pt !== null; )
                jt = Pt, M3(Pt), Pt = Pt.sibling;
            }
            S3(Dt, xt);
          }
          return;
        }
        case G: {
          _l(a, r), Ps(r), y & gn && DN(r);
          return;
        }
        case ne:
          return;
        default: {
          _l(a, r), Ps(r);
          return;
        }
      }
    }
    function Ps(r) {
      var a = r.flags;
      if (a & hr) {
        try {
          E3(r);
        } catch (d) {
          yr(r, r.return, d);
        }
        r.flags &= ~hr;
      }
      a & Xa && (r.flags &= ~Xa);
    }
    function P3(r, a, d) {
      Xm = d, Qm = a, jt = r, AN(r, a, d), Xm = null, Qm = null;
    }
    function AN(r, a, d) {
      for (var p = (r.mode & xn) !== tn; jt !== null; ) {
        var y = jt, R = y.child;
        if (y.tag === K && p) {
          var D = y.memoizedState !== null, j = D || yS;
          if (j) {
            WT(r, a, d);
            continue;
          } else {
            var Q = y.alternate, re = Q !== null && Q.memoizedState !== null, ae = re || Jo, ke = yS, Ee = Jo;
            yS = j, Jo = ae, Jo && !Ee && (jt = y, I3(y));
            for (var He = R; He !== null; )
              jt = He, AN(
                He,
                // New root; bubble back up to here and stop.
                a,
                d
              ), He = He.sibling;
            jt = y, yS = ke, Jo = Ee, WT(r, a, d);
            continue;
          }
        }
        (y.subtreeFlags & Bo) !== Jt && R !== null ? (R.return = y, jt = R) : WT(r, a, d);
      }
    }
    function WT(r, a, d) {
      for (; jt !== null; ) {
        var p = jt;
        if ((p.flags & Bo) !== Jt) {
          var y = p.alternate;
          Jn(p);
          try {
            y3(a, y, p, d);
          } catch (D) {
            yr(p, p.return, D);
          }
          no();
        }
        if (p === r) {
          jt = null;
          return;
        }
        var R = p.sibling;
        if (R !== null) {
          R.return = p.return, jt = R;
          return;
        }
        jt = p.return;
      }
    }
    function M3(r) {
      for (; jt !== null; ) {
        var a = jt, d = a.child;
        switch (a.tag) {
          case h:
          case _:
          case M:
          case A: {
            if (a.mode & nn)
              try {
                ks(), $l(ko, a, a.return);
              } finally {
                Rs(a);
              }
            else
              $l(ko, a, a.return);
            break;
          }
          case v: {
            Zm(a, a.return);
            var p = a.stateNode;
            typeof p.componentWillUnmount == "function" && HT(a, a.return, p);
            break;
          }
          case T: {
            Zm(a, a.return);
            break;
          }
          case K: {
            var y = a.memoizedState !== null;
            if (y) {
              LN(r);
              continue;
            }
            break;
          }
        }
        d !== null ? (d.return = a, jt = d) : LN(r);
      }
    }
    function LN(r) {
      for (; jt !== null; ) {
        var a = jt;
        if (a === r) {
          jt = null;
          return;
        }
        var d = a.sibling;
        if (d !== null) {
          d.return = a.return, jt = d;
          return;
        }
        jt = a.return;
      }
    }
    function I3(r) {
      for (; jt !== null; ) {
        var a = jt, d = a.child;
        if (a.tag === K) {
          var p = a.memoizedState !== null;
          if (p) {
            FN(r);
            continue;
          }
        }
        d !== null ? (d.return = a, jt = d) : FN(r);
      }
    }
    function FN(r) {
      for (; jt !== null; ) {
        var a = jt;
        Jn(a);
        try {
          C3(a);
        } catch (p) {
          yr(a, a.return, p);
        }
        if (no(), a === r) {
          jt = null;
          return;
        }
        var d = a.sibling;
        if (d !== null) {
          d.return = a.return, jt = d;
          return;
        }
        jt = a.return;
      }
    }
    function N3(r, a, d, p) {
      jt = a, $3(a, r, d, p);
    }
    function $3(r, a, d, p) {
      for (; jt !== null; ) {
        var y = jt, R = y.child;
        (y.subtreeFlags & Qa) !== Jt && R !== null ? (R.return = y, jt = R) : D3(r, a, d, p);
      }
    }
    function D3(r, a, d, p) {
      for (; jt !== null; ) {
        var y = jt;
        if ((y.flags & wr) !== Jt) {
          Jn(y);
          try {
            _3(a, y, d, p);
          } catch (D) {
            yr(y, y.return, D);
          }
          no();
        }
        if (y === r) {
          jt = null;
          return;
        }
        var R = y.sibling;
        if (R !== null) {
          R.return = y.return, jt = R;
          return;
        }
        jt = y.return;
      }
    }
    function _3(r, a, d, p) {
      switch (a.tag) {
        case h:
        case _:
        case A: {
          if (a.mode & nn) {
            wT();
            try {
              ju(Qo | Ro, a);
            } finally {
              xT(a);
            }
          } else
            ju(Qo | Ro, a);
          break;
        }
      }
    }
    function A3(r) {
      jt = r, L3();
    }
    function L3() {
      for (; jt !== null; ) {
        var r = jt, a = r.child;
        if ((jt.flags & jn) !== Jt) {
          var d = r.deletions;
          if (d !== null) {
            for (var p = 0; p < d.length; p++) {
              var y = d[p];
              jt = y, V3(y, r);
            }
            {
              var R = r.alternate;
              if (R !== null) {
                var D = R.child;
                if (D !== null) {
                  R.child = null;
                  do {
                    var j = D.sibling;
                    D.sibling = null, D = j;
                  } while (D !== null);
                }
              }
            }
            jt = r;
          }
        }
        (r.subtreeFlags & Qa) !== Jt && a !== null ? (a.return = r, jt = a) : F3();
      }
    }
    function F3() {
      for (; jt !== null; ) {
        var r = jt;
        (r.flags & wr) !== Jt && (Jn(r), z3(r), no());
        var a = r.sibling;
        if (a !== null) {
          a.return = r.return, jt = a;
          return;
        }
        jt = r.return;
      }
    }
    function z3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          r.mode & nn ? (wT(), $l(Qo | Ro, r, r.return), xT(r)) : $l(Qo | Ro, r, r.return);
          break;
        }
      }
    }
    function V3(r, a) {
      for (; jt !== null; ) {
        var d = jt;
        Jn(d), j3(d, a), no();
        var p = d.child;
        p !== null ? (p.return = d, jt = p) : B3(r);
      }
    }
    function B3(r) {
      for (; jt !== null; ) {
        var a = jt, d = a.sibling, p = a.return;
        if (MN(a), a === r) {
          jt = null;
          return;
        }
        if (d !== null) {
          d.return = p, jt = d;
          return;
        }
        jt = p;
      }
    }
    function j3(r, a) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          r.mode & nn ? (wT(), $l(Qo, r, a), xT(r)) : $l(Qo, r, a);
          break;
        }
      }
    }
    function H3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          try {
            ju(ko | Ro, r);
          } catch (d) {
            yr(r, r.return, d);
          }
          break;
        }
        case v: {
          var a = r.stateNode;
          try {
            a.componentDidMount();
          } catch (d) {
            yr(r, r.return, d);
          }
          break;
        }
      }
    }
    function U3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          try {
            ju(Qo | Ro, r);
          } catch (a) {
            yr(r, r.return, a);
          }
          break;
        }
      }
    }
    function G3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A: {
          try {
            $l(ko | Ro, r, r.return);
          } catch (d) {
            yr(r, r.return, d);
          }
          break;
        }
        case v: {
          var a = r.stateNode;
          typeof a.componentWillUnmount == "function" && HT(r, r.return, a);
          break;
        }
      }
    }
    function W3(r) {
      switch (r.tag) {
        case h:
        case _:
        case A:
          try {
            $l(Qo | Ro, r, r.return);
          } catch (a) {
            yr(r, r.return, a);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Jv = Symbol.for;
      Jv("selector.component"), Jv("selector.has_pseudo_class"), Jv("selector.role"), Jv("selector.test_id"), Jv("selector.text");
    }
    var q3 = [];
    function Y3() {
      q3.forEach(function(r) {
        return r();
      });
    }
    var K3 = o.ReactCurrentActQueue;
    function X3(r) {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), d = typeof jest < "u";
        return d && a !== !1;
      }
    }
    function zN() {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !r && K3.current !== null && f("The current testing environment is not configured to support act(...)"), r;
      }
    }
    var Q3 = Math.ceil, qT = o.ReactCurrentDispatcher, YT = o.ReactCurrentOwner, ta = o.ReactCurrentBatchConfig, Al = o.ReactCurrentActQueue, Io = (
      /*             */
      0
    ), VN = (
      /*               */
      1
    ), na = (
      /*                */
      2
    ), Qi = (
      /*                */
      4
    ), Ic = 0, eb = 1, Of = 2, SS = 3, tb = 4, BN = 5, KT = 6, Mn = Io, Aa = null, Ur = null, No = nt, Ms = nt, XT = $u(nt), $o = Ic, nb = null, xS = nt, rb = nt, wS = nt, ob = null, si = null, QT = 0, jN = 500, HN = 1 / 0, Z3 = 500, Nc = null;
    function ab() {
      HN = Or() + Z3;
    }
    function UN() {
      return HN;
    }
    var ES = !1, ZT = null, Jm = null, Rf = !1, Uu = null, ib = nt, JT = [], eO = null, J3 = 50, lb = 0, tO = null, nO = !1, TS = !1, e6 = 50, eh = 0, OS = null, sb = pr, RS = nt, GN = !1;
    function kS() {
      return Aa;
    }
    function La() {
      return (Mn & (na | Qi)) !== Io ? Or() : (sb !== pr || (sb = Or()), sb);
    }
    function Gu(r) {
      var a = r.mode;
      if ((a & xn) === tn)
        return on;
      if ((Mn & na) !== Io && No !== nt)
        return oo(No);
      var d = XH() !== KH;
      if (d) {
        if (ta.transition !== null) {
          var p = ta.transition;
          p._updatedFibers || (p._updatedFibers = /* @__PURE__ */ new Set()), p._updatedFibers.add(r);
        }
        return RS === Pn && (RS = Yg()), RS;
      }
      var y = ti();
      if (y !== Pn)
        return y;
      var R = Dj();
      return R;
    }
    function t6(r) {
      var a = r.mode;
      return (a & xn) === tn ? on : ww();
    }
    function Do(r, a, d, p) {
      T6(), GN && f("useInsertionEffect must not schedule updates."), nO && (TS = !0), mc(r, d, p), (Mn & na) !== nt && r === Aa ? k6(a) : (To && Jg(r, a, d), P6(a), r === Aa && ((Mn & na) === Io && (rb = vn(rb, d)), $o === tb && Wu(r, No)), ci(r, p), d === on && Mn === Io && (a.mode & xn) === tn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Al.isBatchingLegacy && (ab(), UM()));
    }
    function n6(r, a, d) {
      var p = r.current;
      p.lanes = a, mc(r, a, d), ci(r, d);
    }
    function r6(r) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Mn & na) !== Io
      );
    }
    function ci(r, a) {
      var d = r.callbackNode;
      Cw(r, a);
      var p = Qd(r, r === Aa ? No : nt);
      if (p === nt) {
        d !== null && l$(d), r.callbackNode = null, r.callbackPriority = Pn;
        return;
      }
      var y = Yr(p), R = r.callbackPriority;
      if (R === y && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Al.current !== null && d !== cO)) {
        d == null && R !== on && f("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      d != null && l$(d);
      var D;
      if (y === on)
        r.tag === Du ? (Al.isBatchingLegacy !== null && (Al.didScheduleLegacyUpdate = !0), NH(YN.bind(null, r))) : HM(YN.bind(null, r)), Al.current !== null ? Al.current.push(_u) : Aj(function() {
          (Mn & (na | Qi)) === Io && _u();
        }), D = null;
      else {
        var j;
        switch (nf(p)) {
          case jo:
            j = Fp;
            break;
          case Oo:
            j = Na;
            break;
          case Sl:
            j = Bi;
            break;
          case ef:
            j = ss;
            break;
          default:
            j = Bi;
            break;
        }
        D = uO(j, WN.bind(null, r));
      }
      r.callbackPriority = y, r.callbackNode = D;
    }
    function WN(r, a) {
      if (TU(), sb = pr, RS = nt, (Mn & (na | Qi)) !== Io)
        throw new Error("Should not already be working.");
      var d = r.callbackNode, p = Dc();
      if (p && r.callbackNode !== d)
        return null;
      var y = Qd(r, r === Aa ? No : nt);
      if (y === nt)
        return null;
      var R = !Jd(r, y) && !VC(r, y) && !a, D = R ? p6(r, y) : MS(r, y);
      if (D !== Ic) {
        if (D === Of) {
          var j = Wg(r);
          j !== nt && (y = j, D = rO(r, j));
        }
        if (D === eb) {
          var Q = nb;
          throw kf(r, nt), Wu(r, y), ci(r, Or()), Q;
        }
        if (D === KT)
          Wu(r, y);
        else {
          var re = !Jd(r, y), ae = r.current.alternate;
          if (re && !a6(ae)) {
            if (D = MS(r, y), D === Of) {
              var ke = Wg(r);
              ke !== nt && (y = ke, D = rO(r, ke));
            }
            if (D === eb) {
              var Ee = nb;
              throw kf(r, nt), Wu(r, y), ci(r, Or()), Ee;
            }
          }
          r.finishedWork = ae, r.finishedLanes = y, o6(r, D, y);
        }
      }
      return ci(r, Or()), r.callbackNode === d ? WN.bind(null, r) : null;
    }
    function rO(r, a) {
      var d = ob;
      if (io(r)) {
        var p = kf(r, a);
        p.flags |= Lr, TH(r.containerInfo);
      }
      var y = MS(r, a);
      if (y !== Of) {
        var R = si;
        si = d, R !== null && qN(R);
      }
      return y;
    }
    function qN(r) {
      si === null ? si = r : si.push.apply(si, r);
    }
    function o6(r, a, d) {
      switch (a) {
        case Ic:
        case eb:
          throw new Error("Root did not complete. This is a bug in React.");
        case Of: {
          Pf(r, si, Nc);
          break;
        }
        case SS: {
          if (Wu(r, d), sm(d) && // do not delay if we're inside an act() scope
          !s$()) {
            var p = QT + jN - Or();
            if (p > 10) {
              var y = Qd(r, nt);
              if (y !== nt)
                break;
              var R = r.suspendedLanes;
              if (!pc(R, d)) {
                La(), Qg(r, R);
                break;
              }
              r.timeoutHandle = eE(Pf.bind(null, r, si, Nc), p);
              break;
            }
          }
          Pf(r, si, Nc);
          break;
        }
        case tb: {
          if (Wu(r, d), zC(d))
            break;
          if (!s$()) {
            var D = FC(r, d), j = D, Q = Or() - j, re = E6(Q) - Q;
            if (re > 10) {
              r.timeoutHandle = eE(Pf.bind(null, r, si, Nc), re);
              break;
            }
          }
          Pf(r, si, Nc);
          break;
        }
        case BN: {
          Pf(r, si, Nc);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function a6(r) {
      for (var a = r; ; ) {
        if (a.flags & Ud) {
          var d = a.updateQueue;
          if (d !== null) {
            var p = d.stores;
            if (p !== null)
              for (var y = 0; y < p.length; y++) {
                var R = p[y], D = R.getSnapshot, j = R.value;
                try {
                  if (!Bt(D(), j))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var Q = a.child;
        if (a.subtreeFlags & Ud && Q !== null) {
          Q.return = a, a = Q;
          continue;
        }
        if (a === r)
          return !0;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === r)
            return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function Wu(r, a) {
      a = gu(a, wS), a = gu(a, rb), Xg(r, a);
    }
    function YN(r) {
      if (OU(), (Mn & (na | Qi)) !== Io)
        throw new Error("Should not already be working.");
      Dc();
      var a = Qd(r, nt);
      if (!ga(a, on))
        return ci(r, Or()), null;
      var d = MS(r, a);
      if (r.tag !== Du && d === Of) {
        var p = Wg(r);
        p !== nt && (a = p, d = rO(r, p));
      }
      if (d === eb) {
        var y = nb;
        throw kf(r, nt), Wu(r, a), ci(r, Or()), y;
      }
      if (d === KT)
        throw new Error("Root did not complete. This is a bug in React.");
      var R = r.current.alternate;
      return r.finishedWork = R, r.finishedLanes = a, Pf(r, si, Nc), ci(r, Or()), null;
    }
    function i6(r, a) {
      a !== nt && (vu(r, vn(a, on)), ci(r, Or()), (Mn & (na | Qi)) === Io && (ab(), _u()));
    }
    function oO(r, a) {
      var d = Mn;
      Mn |= VN;
      try {
        return r(a);
      } finally {
        Mn = d, Mn === Io && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Al.isBatchingLegacy && (ab(), UM());
      }
    }
    function l6(r, a, d, p, y) {
      var R = ti(), D = ta.transition;
      try {
        return ta.transition = null, ao(jo), r(a, d, p, y);
      } finally {
        ao(R), ta.transition = D, Mn === Io && ab();
      }
    }
    function $c(r) {
      Uu !== null && Uu.tag === Du && (Mn & (na | Qi)) === Io && Dc();
      var a = Mn;
      Mn |= VN;
      var d = ta.transition, p = ti();
      try {
        return ta.transition = null, ao(jo), r ? r() : void 0;
      } finally {
        ao(p), ta.transition = d, Mn = a, (Mn & (na | Qi)) === Io && _u();
      }
    }
    function KN() {
      return (Mn & (na | Qi)) !== Io;
    }
    function PS(r, a) {
      ba(XT, Ms, r), Ms = vn(Ms, a);
    }
    function aO(r) {
      Ms = XT.current, va(XT, r);
    }
    function kf(r, a) {
      r.finishedWork = null, r.finishedLanes = nt;
      var d = r.timeoutHandle;
      if (d !== tE && (r.timeoutHandle = tE, _j(d)), Ur !== null)
        for (var p = Ur.return; p !== null; ) {
          var y = p.alternate;
          EN(y, p), p = p.return;
        }
      Aa = r;
      var R = Mf(r.current, null);
      return Ur = R, No = Ms = a, $o = Ic, nb = null, xS = nt, rb = nt, wS = nt, ob = null, si = null, eU(), kl.discardPendingWarnings(), R;
    }
    function XN(r, a) {
      do {
        var d = Ur;
        try {
          if (L0(), OI(), no(), YT.current = null, d === null || d.return === null) {
            $o = eb, nb = a, Ur = null;
            return;
          }
          if (me && d.mode & nn && hS(d, !0), Ce)
            if (oc(), a !== null && typeof a == "object" && typeof a.then == "function") {
              var p = a;
              _C(d, p, No);
            } else
              Hp(d, a, No);
          IU(r, d.return, d, a, No), e$(d);
        } catch (y) {
          a = y, Ur === d && d !== null ? (d = d.return, Ur = d) : d = Ur;
          continue;
        }
        return;
      } while (!0);
    }
    function QN() {
      var r = qT.current;
      return qT.current = uS, r === null ? uS : r;
    }
    function ZN(r) {
      qT.current = r;
    }
    function s6() {
      QT = Or();
    }
    function cb(r) {
      xS = vn(r, xS);
    }
    function c6() {
      $o === Ic && ($o = SS);
    }
    function iO() {
      ($o === Ic || $o === SS || $o === Of) && ($o = tb), Aa !== null && (Zd(xS) || Zd(rb)) && Wu(Aa, No);
    }
    function u6(r) {
      $o !== tb && ($o = Of), ob === null ? ob = [r] : ob.push(r);
    }
    function d6() {
      return $o === Ic;
    }
    function MS(r, a) {
      var d = Mn;
      Mn |= na;
      var p = QN();
      if (Aa !== r || No !== a) {
        if (To) {
          var y = r.memoizedUpdaters;
          y.size > 0 && (ub(r, No), y.clear()), dm(r, a);
        }
        Nc = ev(), kf(r, a);
      }
      Ri(a);
      do
        try {
          f6();
          break;
        } catch (R) {
          XN(r, R);
        }
      while (!0);
      if (L0(), Mn = d, ZN(p), Ur !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return du(), Aa = null, No = nt, $o;
    }
    function f6() {
      for (; Ur !== null; )
        JN(Ur);
    }
    function p6(r, a) {
      var d = Mn;
      Mn |= na;
      var p = QN();
      if (Aa !== r || No !== a) {
        if (To) {
          var y = r.memoizedUpdaters;
          y.size > 0 && (ub(r, No), y.clear()), dm(r, a);
        }
        Nc = ev(), ab(), kf(r, a);
      }
      Ri(a);
      do
        try {
          m6();
          break;
        } catch (R) {
          XN(r, R);
        }
      while (!0);
      return L0(), ZN(p), Mn = d, Ur !== null ? (qd(), Ic) : (du(), Aa = null, No = nt, $o);
    }
    function m6() {
      for (; Ur !== null && !Lp(); )
        JN(Ur);
    }
    function JN(r) {
      var a = r.alternate;
      Jn(r);
      var d;
      (r.mode & nn) !== tn ? (ST(r), d = lO(a, r, Ms), hS(r, !0)) : d = lO(a, r, Ms), no(), r.memoizedProps = r.pendingProps, d === null ? e$(r) : Ur = d, YT.current = null;
    }
    function e$(r) {
      var a = r;
      do {
        var d = a.alternate, p = a.return;
        if ((a.flags & Pa) === Jt) {
          Jn(a);
          var y = void 0;
          if ((a.mode & nn) === tn ? y = wN(d, a, Ms) : (ST(a), y = wN(d, a, Ms), hS(a, !1)), no(), y !== null) {
            Ur = y;
            return;
          }
        } else {
          var R = c3(d, a);
          if (R !== null) {
            R.flags &= OC, Ur = R;
            return;
          }
          if ((a.mode & nn) !== tn) {
            hS(a, !1);
            for (var D = a.actualDuration, j = a.child; j !== null; )
              D += j.actualDuration, j = j.sibling;
            a.actualDuration = D;
          }
          if (p !== null)
            p.flags |= Pa, p.subtreeFlags = Jt, p.deletions = null;
          else {
            $o = KT, Ur = null;
            return;
          }
        }
        var Q = a.sibling;
        if (Q !== null) {
          Ur = Q;
          return;
        }
        a = p, Ur = a;
      } while (a !== null);
      $o === Ic && ($o = BN);
    }
    function Pf(r, a, d) {
      var p = ti(), y = ta.transition;
      try {
        ta.transition = null, ao(jo), h6(r, a, d, p);
      } finally {
        ta.transition = y, ao(p);
      }
      return null;
    }
    function h6(r, a, d, p) {
      do
        Dc();
      while (Uu !== null);
      if (O6(), (Mn & (na | Qi)) !== Io)
        throw new Error("Should not already be working.");
      var y = r.finishedWork, R = r.finishedLanes;
      if (Vp(R), y === null)
        return Bg(), null;
      if (R === nt && f("root.finishedLanes should not be empty during a commit. This is a bug in React."), r.finishedWork = null, r.finishedLanes = nt, y === r.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      r.callbackNode = null, r.callbackPriority = Pn;
      var D = vn(y.lanes, y.childLanes);
      Zg(r, D), r === Aa && (Aa = null, Ur = null, No = nt), ((y.subtreeFlags & Qa) !== Jt || (y.flags & Qa) !== Jt) && (Rf || (Rf = !0, eO = d, uO(Bi, function() {
        return Dc(), null;
      })));
      var j = (y.subtreeFlags & (su | fa | Bo | Qa)) !== Jt, Q = (y.flags & (su | fa | Bo | Qa)) !== Jt;
      if (j || Q) {
        var re = ta.transition;
        ta.transition = null;
        var ae = ti();
        ao(jo);
        var ke = Mn;
        Mn |= Qi, YT.current = null, m3(r, y), QI(), k3(r, y, R), kj(r.containerInfo), r.current = y, AC(R), P3(y, r, R), uu(), PC(), Mn = ke, ao(ae), ta.transition = re;
      } else
        r.current = y, QI();
      var Ee = Rf;
      if (Rf ? (Rf = !1, Uu = r, ib = R) : (eh = 0, OS = null), D = r.pendingLanes, D === nt && (Jm = null), Ee || o$(r.current, !1), bl(y.stateNode, p), To && r.memoizedUpdaters.clear(), Y3(), ci(r, Or()), a !== null)
        for (var He = r.onRecoverableError, Ue = 0; Ue < a.length; Ue++) {
          var Ke = a[Ue], $t = Ke.stack, en = Ke.digest;
          He(Ke.value, {
            componentStack: $t,
            digest: en
          });
        }
      if (ES) {
        ES = !1;
        var Kt = ZT;
        throw ZT = null, Kt;
      }
      return ga(ib, on) && r.tag !== Du && Dc(), D = r.pendingLanes, ga(D, on) ? (EU(), r === tO ? lb++ : (lb = 0, tO = r)) : lb = 0, _u(), Bg(), null;
    }
    function Dc() {
      if (Uu !== null) {
        var r = nf(ib), a = Tw(Sl, r), d = ta.transition, p = ti();
        try {
          return ta.transition = null, ao(a), v6();
        } finally {
          ao(p), ta.transition = d;
        }
      }
      return !1;
    }
    function g6(r) {
      JT.push(r), Rf || (Rf = !0, uO(Bi, function() {
        return Dc(), null;
      }));
    }
    function v6() {
      if (Uu === null)
        return !1;
      var r = eO;
      eO = null;
      var a = Uu, d = ib;
      if (Uu = null, ib = nt, (Mn & (na | Qi)) !== Io)
        throw new Error("Cannot flush passive effects while already rendering.");
      nO = !0, TS = !1, LC(d);
      var p = Mn;
      Mn |= Qi, A3(a.current), N3(a, a.current, d, r);
      {
        var y = JT;
        JT = [];
        for (var R = 0; R < y.length; R++) {
          var D = y[R];
          b3(a, D);
        }
      }
      Wd(), o$(a.current, !0), Mn = p, _u(), TS ? a === OS ? eh++ : (eh = 0, OS = a) : eh = 0, nO = !1, TS = !1, us(a);
      {
        var j = a.current.stateNode;
        j.effectDuration = 0, j.passiveEffectDuration = 0;
      }
      return !0;
    }
    function t$(r) {
      return Jm !== null && Jm.has(r);
    }
    function b6(r) {
      Jm === null ? Jm = /* @__PURE__ */ new Set([r]) : Jm.add(r);
    }
    function y6(r) {
      ES || (ES = !0, ZT = r);
    }
    var C6 = y6;
    function n$(r, a, d) {
      var p = Ef(d, a), y = JI(r, p, on), R = Lu(r, y, on), D = La();
      R !== null && (mc(R, on, D), ci(R, D));
    }
    function yr(r, a, d) {
      if (d3(d), db(!1), r.tag === x) {
        n$(r, r, d);
        return;
      }
      var p = null;
      for (p = a; p !== null; ) {
        if (p.tag === x) {
          n$(p, r, d);
          return;
        } else if (p.tag === v) {
          var y = p.type, R = p.stateNode;
          if (typeof y.getDerivedStateFromError == "function" || typeof R.componentDidCatch == "function" && !t$(R)) {
            var D = Ef(d, r), j = RT(p, D, on), Q = Lu(p, j, on), re = La();
            Q !== null && (mc(Q, on, re), ci(Q, re));
            return;
          }
        }
        p = p.return;
      }
      f(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, d);
    }
    function S6(r, a, d) {
      var p = r.pingCache;
      p !== null && p.delete(a);
      var y = La();
      Qg(r, d), M6(r), Aa === r && pc(No, d) && ($o === tb || $o === SS && sm(No) && Or() - QT < jN ? kf(r, nt) : wS = vn(wS, d)), ci(r, y);
    }
    function r$(r, a) {
      a === Pn && (a = t6(r));
      var d = La(), p = ii(r, a);
      p !== null && (mc(p, a, d), ci(p, d));
    }
    function x6(r) {
      var a = r.memoizedState, d = Pn;
      a !== null && (d = a.retryLane), r$(r, d);
    }
    function w6(r, a) {
      var d = Pn, p;
      switch (r.tag) {
        case V:
          p = r.stateNode;
          var y = r.memoizedState;
          y !== null && (d = y.retryLane);
          break;
        case G:
          p = r.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      p !== null && p.delete(a), r$(r, d);
    }
    function E6(r) {
      return r < 120 ? 120 : r < 480 ? 480 : r < 1080 ? 1080 : r < 1920 ? 1920 : r < 3e3 ? 3e3 : r < 4320 ? 4320 : Q3(r / 1960) * 1960;
    }
    function T6() {
      if (lb > J3)
        throw lb = 0, tO = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      eh > e6 && (eh = 0, OS = null, f("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function O6() {
      kl.flushLegacyContextWarning(), kl.flushPendingUnsafeLifecycleWarnings();
    }
    function o$(r, a) {
      Jn(r), IS(r, da, G3), a && IS(r, rc, W3), IS(r, da, H3), a && IS(r, rc, U3), no();
    }
    function IS(r, a, d) {
      for (var p = r, y = null; p !== null; ) {
        var R = p.subtreeFlags & a;
        p !== y && p.child !== null && R !== Jt ? p = p.child : ((p.flags & a) !== Jt && d(p), p.sibling !== null ? p = p.sibling : p = y = p.return);
      }
    }
    var NS = null;
    function a$(r) {
      {
        if ((Mn & na) !== Io || !(r.mode & xn))
          return;
        var a = r.tag;
        if (a !== b && a !== x && a !== v && a !== h && a !== _ && a !== M && a !== A)
          return;
        var d = mn(r) || "ReactComponent";
        if (NS !== null) {
          if (NS.has(d))
            return;
          NS.add(d);
        } else
          NS = /* @__PURE__ */ new Set([d]);
        var p = Wr;
        try {
          Jn(r), f("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          p ? Jn(r) : no();
        }
      }
    }
    var lO;
    {
      var R6 = null;
      lO = function(r, a, d) {
        var p = p$(R6, a);
        try {
          return bN(r, a, d);
        } catch (R) {
          if (VH() || R !== null && typeof R == "object" && typeof R.then == "function")
            throw R;
          if (L0(), OI(), EN(r, a), p$(a, p), a.mode & nn && ST(a), nc(null, bN, null, r, a, d), bw()) {
            var y = Mg();
            typeof y == "object" && y !== null && y._suppressLogging && typeof R == "object" && R !== null && !R._suppressLogging && (R._suppressLogging = !0);
          }
          throw R;
        }
      };
    }
    var i$ = !1, sO;
    sO = /* @__PURE__ */ new Set();
    function k6(r) {
      if (Ga && !SU())
        switch (r.tag) {
          case h:
          case _:
          case A: {
            var a = Ur && mn(Ur) || "Unknown", d = a;
            if (!sO.has(d)) {
              sO.add(d);
              var p = mn(r) || "Unknown";
              f("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", p, a, a);
            }
            break;
          }
          case v: {
            i$ || (f("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), i$ = !0);
            break;
          }
        }
    }
    function ub(r, a) {
      if (To) {
        var d = r.memoizedUpdaters;
        d.forEach(function(p) {
          Jg(r, p, a);
        });
      }
    }
    var cO = {};
    function uO(r, a) {
      {
        var d = Al.current;
        return d !== null ? (d.push(a), cO) : Ap(r, a);
      }
    }
    function l$(r) {
      if (r !== cO)
        return kC(r);
    }
    function s$() {
      return Al.current !== null;
    }
    function P6(r) {
      {
        if (r.mode & xn) {
          if (!zN())
            return;
        } else if (!X3() || Mn !== Io || r.tag !== h && r.tag !== _ && r.tag !== A)
          return;
        if (Al.current === null) {
          var a = Wr;
          try {
            Jn(r), f(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, mn(r));
          } finally {
            a ? Jn(r) : no();
          }
        }
      }
    }
    function M6(r) {
      r.tag !== Du && zN() && Al.current === null && f(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function db(r) {
      GN = r;
    }
    var Zi = null, th = null, I6 = function(r) {
      Zi = r;
    };
    function nh(r) {
      {
        if (Zi === null)
          return r;
        var a = Zi(r);
        return a === void 0 ? r : a.current;
      }
    }
    function dO(r) {
      return nh(r);
    }
    function fO(r) {
      {
        if (Zi === null)
          return r;
        var a = Zi(r);
        if (a === void 0) {
          if (r != null && typeof r.render == "function") {
            var d = nh(r.render);
            if (r.render !== d) {
              var p = {
                $$typeof: Ie,
                render: d
              };
              return r.displayName !== void 0 && (p.displayName = r.displayName), p;
            }
          }
          return r;
        }
        return a.current;
      }
    }
    function c$(r, a) {
      {
        if (Zi === null)
          return !1;
        var d = r.elementType, p = a.type, y = !1, R = typeof p == "object" && p !== null ? p.$$typeof : null;
        switch (r.tag) {
          case v: {
            typeof p == "function" && (y = !0);
            break;
          }
          case h: {
            (typeof p == "function" || R === Ct) && (y = !0);
            break;
          }
          case _: {
            (R === Ie || R === Ct) && (y = !0);
            break;
          }
          case M:
          case A: {
            (R === mt || R === Ct) && (y = !0);
            break;
          }
          default:
            return !1;
        }
        if (y) {
          var D = Zi(d);
          if (D !== void 0 && D === Zi(p))
            return !0;
        }
        return !1;
      }
    }
    function u$(r) {
      {
        if (Zi === null || typeof WeakSet != "function")
          return;
        th === null && (th = /* @__PURE__ */ new WeakSet()), th.add(r);
      }
    }
    var N6 = function(r, a) {
      {
        if (Zi === null)
          return;
        var d = a.staleFamilies, p = a.updatedFamilies;
        Dc(), $c(function() {
          pO(r.current, p, d);
        });
      }
    }, $6 = function(r, a) {
      {
        if (r.context !== Pi)
          return;
        Dc(), $c(function() {
          fb(a, r, null, null);
        });
      }
    };
    function pO(r, a, d) {
      {
        var p = r.alternate, y = r.child, R = r.sibling, D = r.tag, j = r.type, Q = null;
        switch (D) {
          case h:
          case A:
          case v:
            Q = j;
            break;
          case _:
            Q = j.render;
            break;
        }
        if (Zi === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var re = !1, ae = !1;
        if (Q !== null) {
          var ke = Zi(Q);
          ke !== void 0 && (d.has(ke) ? ae = !0 : a.has(ke) && (D === v ? ae = !0 : re = !0));
        }
        if (th !== null && (th.has(r) || p !== null && th.has(p)) && (ae = !0), ae && (r._debugNeedsRemount = !0), ae || re) {
          var Ee = ii(r, on);
          Ee !== null && Do(Ee, r, on, pr);
        }
        y !== null && !ae && pO(y, a, d), R !== null && pO(R, a, d);
      }
    }
    var D6 = function(r, a) {
      {
        var d = /* @__PURE__ */ new Set(), p = new Set(a.map(function(y) {
          return y.current;
        }));
        return mO(r.current, p, d), d;
      }
    };
    function mO(r, a, d) {
      {
        var p = r.child, y = r.sibling, R = r.tag, D = r.type, j = null;
        switch (R) {
          case h:
          case A:
          case v:
            j = D;
            break;
          case _:
            j = D.render;
            break;
        }
        var Q = !1;
        j !== null && a.has(j) && (Q = !0), Q ? _6(r, d) : p !== null && mO(p, a, d), y !== null && mO(y, a, d);
      }
    }
    function _6(r, a) {
      {
        var d = A6(r, a);
        if (d)
          return;
        for (var p = r; ; ) {
          switch (p.tag) {
            case T:
              a.add(p.stateNode);
              return;
            case E:
              a.add(p.stateNode.containerInfo);
              return;
            case x:
              a.add(p.stateNode.containerInfo);
              return;
          }
          if (p.return === null)
            throw new Error("Expected to reach root first.");
          p = p.return;
        }
      }
    }
    function A6(r, a) {
      for (var d = r, p = !1; ; ) {
        if (d.tag === T)
          p = !0, a.add(d.stateNode);
        else if (d.child !== null) {
          d.child.return = d, d = d.child;
          continue;
        }
        if (d === r)
          return p;
        for (; d.sibling === null; ) {
          if (d.return === null || d.return === r)
            return p;
          d = d.return;
        }
        d.sibling.return = d.return, d = d.sibling;
      }
      return !1;
    }
    var hO;
    {
      hO = !1;
      try {
        var d$ = Object.preventExtensions({});
      } catch {
        hO = !0;
      }
    }
    function L6(r, a, d, p) {
      this.tag = r, this.key = d, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = p, this.flags = Jt, this.subtreeFlags = Jt, this.deletions = null, this.lanes = nt, this.childLanes = nt, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !hO && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Mi = function(r, a, d, p) {
      return new L6(r, a, d, p);
    };
    function gO(r) {
      var a = r.prototype;
      return !!(a && a.isReactComponent);
    }
    function F6(r) {
      return typeof r == "function" && !gO(r) && r.defaultProps === void 0;
    }
    function z6(r) {
      if (typeof r == "function")
        return gO(r) ? v : h;
      if (r != null) {
        var a = r.$$typeof;
        if (a === Ie)
          return _;
        if (a === mt)
          return M;
      }
      return b;
    }
    function Mf(r, a) {
      var d = r.alternate;
      d === null ? (d = Mi(r.tag, a, r.key, r.mode), d.elementType = r.elementType, d.type = r.type, d.stateNode = r.stateNode, d._debugSource = r._debugSource, d._debugOwner = r._debugOwner, d._debugHookTypes = r._debugHookTypes, d.alternate = r, r.alternate = d) : (d.pendingProps = a, d.type = r.type, d.flags = Jt, d.subtreeFlags = Jt, d.deletions = null, d.actualDuration = 0, d.actualStartTime = -1), d.flags = r.flags & Eo, d.childLanes = r.childLanes, d.lanes = r.lanes, d.child = r.child, d.memoizedProps = r.memoizedProps, d.memoizedState = r.memoizedState, d.updateQueue = r.updateQueue;
      var p = r.dependencies;
      switch (d.dependencies = p === null ? null : {
        lanes: p.lanes,
        firstContext: p.firstContext
      }, d.sibling = r.sibling, d.index = r.index, d.ref = r.ref, d.selfBaseDuration = r.selfBaseDuration, d.treeBaseDuration = r.treeBaseDuration, d._debugNeedsRemount = r._debugNeedsRemount, d.tag) {
        case b:
        case h:
        case A:
          d.type = nh(r.type);
          break;
        case v:
          d.type = dO(r.type);
          break;
        case _:
          d.type = fO(r.type);
          break;
      }
      return d;
    }
    function V6(r, a) {
      r.flags &= Eo | hr;
      var d = r.alternate;
      if (d === null)
        r.childLanes = nt, r.lanes = a, r.child = null, r.subtreeFlags = Jt, r.memoizedProps = null, r.memoizedState = null, r.updateQueue = null, r.dependencies = null, r.stateNode = null, r.selfBaseDuration = 0, r.treeBaseDuration = 0;
      else {
        r.childLanes = d.childLanes, r.lanes = d.lanes, r.child = d.child, r.subtreeFlags = Jt, r.deletions = null, r.memoizedProps = d.memoizedProps, r.memoizedState = d.memoizedState, r.updateQueue = d.updateQueue, r.type = d.type;
        var p = d.dependencies;
        r.dependencies = p === null ? null : {
          lanes: p.lanes,
          firstContext: p.firstContext
        }, r.selfBaseDuration = d.selfBaseDuration, r.treeBaseDuration = d.treeBaseDuration;
      }
      return r;
    }
    function B6(r, a, d) {
      var p;
      return r === P0 ? (p = xn, a === !0 && (p |= Rr, p |= Ja)) : p = tn, To && (p |= nn), Mi(x, null, null, p);
    }
    function vO(r, a, d, p, y, R) {
      var D = b, j = r;
      if (typeof r == "function")
        gO(r) ? (D = v, j = dO(j)) : j = nh(j);
      else if (typeof r == "string")
        D = T;
      else
        e:
          switch (r) {
            case Bn:
              return qu(d.children, y, R, a);
            case xr:
              D = k, y |= Rr, (y & xn) !== tn && (y |= Ja);
              break;
            case fe:
              return j6(d, y, R, a);
            case xe:
              return H6(d, y, R, a);
            case ze:
              return U6(d, y, R, a);
            case yn:
              return f$(d, y, R, a);
            case Wt:
            case Qt:
            case Ar:
            case dp:
            case dn:
            default: {
              if (typeof r == "object" && r !== null)
                switch (r.$$typeof) {
                  case at:
                    D = $;
                    break e;
                  case Et:
                    D = I;
                    break e;
                  case Ie:
                    D = _, j = fO(j);
                    break e;
                  case mt:
                    D = M;
                    break e;
                  case Ct:
                    D = W, j = null;
                    break e;
                }
              var Q = "";
              {
                (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var re = p ? mn(p) : null;
                re && (Q += `

Check the render method of \`` + re + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (r == null ? r : typeof r) + "." + Q));
            }
          }
      var ae = Mi(D, d, a, y);
      return ae.elementType = r, ae.type = j, ae.lanes = R, ae._debugOwner = p, ae;
    }
    function bO(r, a, d) {
      var p = null;
      p = r._owner;
      var y = r.type, R = r.key, D = r.props, j = vO(y, R, D, p, a, d);
      return j._debugSource = r._source, j._debugOwner = r._owner, j;
    }
    function qu(r, a, d, p) {
      var y = Mi(O, r, p, a);
      return y.lanes = d, y;
    }
    function j6(r, a, d, p) {
      typeof r.id != "string" && f('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof r.id);
      var y = Mi(z, r, p, a | nn);
      return y.elementType = fe, y.lanes = d, y.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, y;
    }
    function H6(r, a, d, p) {
      var y = Mi(V, r, p, a);
      return y.elementType = xe, y.lanes = d, y;
    }
    function U6(r, a, d, p) {
      var y = Mi(G, r, p, a);
      return y.elementType = ze, y.lanes = d, y;
    }
    function f$(r, a, d, p) {
      var y = Mi(K, r, p, a);
      y.elementType = yn, y.lanes = d;
      var R = {
        isHidden: !1
      };
      return y.stateNode = R, y;
    }
    function yO(r, a, d) {
      var p = Mi(P, r, null, a);
      return p.lanes = d, p;
    }
    function G6() {
      var r = Mi(T, null, null, tn);
      return r.elementType = "DELETED", r;
    }
    function W6(r) {
      var a = Mi(H, null, null, tn);
      return a.stateNode = r, a;
    }
    function CO(r, a, d) {
      var p = r.children !== null ? r.children : [], y = Mi(E, p, r.key, a);
      return y.lanes = d, y.stateNode = {
        containerInfo: r.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: r.implementation
      }, y;
    }
    function p$(r, a) {
      return r === null && (r = Mi(b, null, null, tn)), r.tag = a.tag, r.key = a.key, r.elementType = a.elementType, r.type = a.type, r.stateNode = a.stateNode, r.return = a.return, r.child = a.child, r.sibling = a.sibling, r.index = a.index, r.ref = a.ref, r.pendingProps = a.pendingProps, r.memoizedProps = a.memoizedProps, r.updateQueue = a.updateQueue, r.memoizedState = a.memoizedState, r.dependencies = a.dependencies, r.mode = a.mode, r.flags = a.flags, r.subtreeFlags = a.subtreeFlags, r.deletions = a.deletions, r.lanes = a.lanes, r.childLanes = a.childLanes, r.alternate = a.alternate, r.actualDuration = a.actualDuration, r.actualStartTime = a.actualStartTime, r.selfBaseDuration = a.selfBaseDuration, r.treeBaseDuration = a.treeBaseDuration, r._debugSource = a._debugSource, r._debugOwner = a._debugOwner, r._debugNeedsRemount = a._debugNeedsRemount, r._debugHookTypes = a._debugHookTypes, r;
    }
    function q6(r, a, d, p, y) {
      this.tag = a, this.containerInfo = r, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = tE, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Pn, this.eventTimes = um(nt), this.expirationTimes = um(pr), this.pendingLanes = nt, this.suspendedLanes = nt, this.pingedLanes = nt, this.expiredLanes = nt, this.mutableReadLanes = nt, this.finishedLanes = nt, this.entangledLanes = nt, this.entanglements = um(nt), this.identifierPrefix = p, this.onRecoverableError = y, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var R = this.pendingUpdatersLaneMap = [], D = 0; D < vr; D++)
          R.push(/* @__PURE__ */ new Set());
      }
      switch (a) {
        case P0:
          this._debugRootType = d ? "hydrateRoot()" : "createRoot()";
          break;
        case Du:
          this._debugRootType = d ? "hydrate()" : "render()";
          break;
      }
    }
    function m$(r, a, d, p, y, R, D, j, Q, re) {
      var ae = new q6(r, a, d, j, Q), ke = B6(a, R);
      ae.current = ke, ke.stateNode = ae;
      {
        var Ee = {
          element: p,
          isDehydrated: d,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        ke.memoizedState = Ee;
      }
      return kE(ke), ae;
    }
    var SO = "18.2.0";
    function Y6(r, a, d) {
      var p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ct(p), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: ur,
        key: p == null ? null : "" + p,
        children: r,
        containerInfo: a,
        implementation: d
      };
    }
    var xO, wO;
    xO = !1, wO = {};
    function h$(r) {
      if (!r)
        return Pi;
      var a = Ya(r), d = IH(a);
      if (a.tag === v) {
        var p = a.type;
        if (ws(p))
          return BM(a, p, d);
      }
      return d;
    }
    function K6(r, a) {
      {
        var d = Ya(r);
        if (d === void 0) {
          if (typeof r.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var p = Object.keys(r).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + p);
        }
        var y = Za(d);
        if (y === null)
          return null;
        if (y.mode & Rr) {
          var R = mn(d) || "Component";
          if (!wO[R]) {
            wO[R] = !0;
            var D = Wr;
            try {
              Jn(y), d.mode & Rr ? f("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, R) : f("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, R);
            } finally {
              D ? Jn(D) : no();
            }
          }
        }
        return y.stateNode;
      }
    }
    function g$(r, a, d, p, y, R, D, j) {
      var Q = !1, re = null;
      return m$(r, a, Q, re, d, p, y, R, D);
    }
    function v$(r, a, d, p, y, R, D, j, Q, re) {
      var ae = !0, ke = m$(d, p, ae, r, y, R, D, j, Q);
      ke.context = h$(null);
      var Ee = ke.current, He = La(), Ue = Gu(Ee), Ke = Pc(He, Ue);
      return Ke.callback = a ?? null, Lu(Ee, Ke, Ue), n6(ke, Ue, He), ke;
    }
    function fb(r, a, d, p) {
      MC(a, r);
      var y = a.current, R = La(), D = Gu(y);
      ac(D);
      var j = h$(d);
      a.context === null ? a.context = j : a.pendingContext = j, Ga && Wr !== null && !xO && (xO = !0, f(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, mn(Wr) || "Unknown"));
      var Q = Pc(R, D);
      Q.payload = {
        element: r
      }, p = p === void 0 ? null : p, p !== null && (typeof p != "function" && f("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", p), Q.callback = p);
      var re = Lu(y, Q, D);
      return re !== null && (Do(re, y, D, R), j0(re, y, D)), D;
    }
    function $S(r) {
      var a = r.current;
      if (!a.child)
        return null;
      switch (a.child.tag) {
        case T:
          return a.child.stateNode;
        default:
          return a.child.stateNode;
      }
    }
    function X6(r) {
      switch (r.tag) {
        case x: {
          var a = r.stateNode;
          if (io(a)) {
            var d = Sw(a);
            i6(a, d);
          }
          break;
        }
        case V: {
          $c(function() {
            var y = ii(r, on);
            if (y !== null) {
              var R = La();
              Do(y, r, on, R);
            }
          });
          var p = on;
          EO(r, p);
          break;
        }
      }
    }
    function b$(r, a) {
      var d = r.memoizedState;
      d !== null && d.dehydrated !== null && (d.retryLane = jC(d.retryLane, a));
    }
    function EO(r, a) {
      b$(r, a);
      var d = r.alternate;
      d && b$(d, a);
    }
    function Q6(r) {
      if (r.tag === V) {
        var a = fu, d = ii(r, a);
        if (d !== null) {
          var p = La();
          Do(d, r, a, p);
        }
        EO(r, a);
      }
    }
    function Z6(r) {
      if (r.tag === V) {
        var a = Gu(r), d = ii(r, a);
        if (d !== null) {
          var p = La();
          Do(d, r, a, p);
        }
        EO(r, a);
      }
    }
    function y$(r) {
      var a = RC(r);
      return a === null ? null : a.stateNode;
    }
    var C$ = function(r) {
      return null;
    };
    function J6(r) {
      return C$(r);
    }
    var S$ = function(r) {
      return !1;
    };
    function e8(r) {
      return S$(r);
    }
    var x$ = null, w$ = null, E$ = null, T$ = null, O$ = null, R$ = null, k$ = null, P$ = null, M$ = null;
    {
      var I$ = function(r, a, d) {
        var p = a[d], y = uo(r) ? r.slice() : On({}, r);
        return d + 1 === a.length ? (uo(y) ? y.splice(p, 1) : delete y[p], y) : (y[p] = I$(r[p], a, d + 1), y);
      }, N$ = function(r, a) {
        return I$(r, a, 0);
      }, $$ = function(r, a, d, p) {
        var y = a[p], R = uo(r) ? r.slice() : On({}, r);
        if (p + 1 === a.length) {
          var D = d[p];
          R[D] = R[y], uo(R) ? R.splice(y, 1) : delete R[y];
        } else
          R[y] = $$(
            // $FlowFixMe number or string is fine here
            r[y],
            a,
            d,
            p + 1
          );
        return R;
      }, D$ = function(r, a, d) {
        if (a.length !== d.length) {
          c("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var p = 0; p < d.length - 1; p++)
            if (a[p] !== d[p]) {
              c("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return $$(r, a, d, 0);
      }, _$ = function(r, a, d, p) {
        if (d >= a.length)
          return p;
        var y = a[d], R = uo(r) ? r.slice() : On({}, r);
        return R[y] = _$(r[y], a, d + 1, p), R;
      }, A$ = function(r, a, d) {
        return _$(r, a, 0, d);
      }, TO = function(r, a) {
        for (var d = r.memoizedState; d !== null && a > 0; )
          d = d.next, a--;
        return d;
      };
      x$ = function(r, a, d, p) {
        var y = TO(r, a);
        if (y !== null) {
          var R = A$(y.memoizedState, d, p);
          y.memoizedState = R, y.baseState = R, r.memoizedProps = On({}, r.memoizedProps);
          var D = ii(r, on);
          D !== null && Do(D, r, on, pr);
        }
      }, w$ = function(r, a, d) {
        var p = TO(r, a);
        if (p !== null) {
          var y = N$(p.memoizedState, d);
          p.memoizedState = y, p.baseState = y, r.memoizedProps = On({}, r.memoizedProps);
          var R = ii(r, on);
          R !== null && Do(R, r, on, pr);
        }
      }, E$ = function(r, a, d, p) {
        var y = TO(r, a);
        if (y !== null) {
          var R = D$(y.memoizedState, d, p);
          y.memoizedState = R, y.baseState = R, r.memoizedProps = On({}, r.memoizedProps);
          var D = ii(r, on);
          D !== null && Do(D, r, on, pr);
        }
      }, T$ = function(r, a, d) {
        r.pendingProps = A$(r.memoizedProps, a, d), r.alternate && (r.alternate.pendingProps = r.pendingProps);
        var p = ii(r, on);
        p !== null && Do(p, r, on, pr);
      }, O$ = function(r, a) {
        r.pendingProps = N$(r.memoizedProps, a), r.alternate && (r.alternate.pendingProps = r.pendingProps);
        var d = ii(r, on);
        d !== null && Do(d, r, on, pr);
      }, R$ = function(r, a, d) {
        r.pendingProps = D$(r.memoizedProps, a, d), r.alternate && (r.alternate.pendingProps = r.pendingProps);
        var p = ii(r, on);
        p !== null && Do(p, r, on, pr);
      }, k$ = function(r) {
        var a = ii(r, on);
        a !== null && Do(a, r, on, pr);
      }, P$ = function(r) {
        C$ = r;
      }, M$ = function(r) {
        S$ = r;
      };
    }
    function t8(r) {
      var a = Za(r);
      return a === null ? null : a.stateNode;
    }
    function n8(r) {
      return null;
    }
    function r8() {
      return Wr;
    }
    function o8(r) {
      var a = r.findFiberByHostInstance, d = o.ReactCurrentDispatcher;
      return zg({
        bundleType: r.bundleType,
        version: r.version,
        rendererPackageName: r.rendererPackageName,
        rendererConfig: r.rendererConfig,
        overrideHookState: x$,
        overrideHookStateDeletePath: w$,
        overrideHookStateRenamePath: E$,
        overrideProps: T$,
        overridePropsDeletePath: O$,
        overridePropsRenamePath: R$,
        setErrorHandler: P$,
        setSuspenseHandler: M$,
        scheduleUpdate: k$,
        currentDispatcherRef: d,
        findHostInstanceByFiber: t8,
        findFiberByHostInstance: a || n8,
        // React Refresh
        findHostInstancesForRefresh: D6,
        scheduleRefresh: N6,
        scheduleRoot: $6,
        setRefreshHandler: I6,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: r8,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: SO
      });
    }
    var L$ = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(r) {
      console.error(r);
    };
    function OO(r) {
      this._internalRoot = r;
    }
    DS.prototype.render = OO.prototype.render = function(r) {
      var a = this._internalRoot;
      if (a === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? f("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : _S(arguments[1]) ? f("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && f("You passed a second argument to root.render(...) but it only accepts one argument.");
        var d = a.containerInfo;
        if (d.nodeType !== qr) {
          var p = y$(a.current);
          p && p.parentNode !== d && f("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      fb(r, a, null, null);
    }, DS.prototype.unmount = OO.prototype.unmount = function() {
      typeof arguments[0] == "function" && f("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var r = this._internalRoot;
      if (r !== null) {
        this._internalRoot = null;
        var a = r.containerInfo;
        KN() && f("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), $c(function() {
          fb(null, r, null, null);
        }), AM(a);
      }
    };
    function a8(r, a) {
      if (!_S(r))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      F$(r);
      var d = !1, p = !1, y = "", R = L$;
      a != null && (a.hydrate ? c("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof a == "object" && a !== null && a.$$typeof === _r && f(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), a.unstable_strictMode === !0 && (d = !0), a.identifierPrefix !== void 0 && (y = a.identifierPrefix), a.onRecoverableError !== void 0 && (R = a.onRecoverableError), a.transitionCallbacks !== void 0 && a.transitionCallbacks);
      var D = g$(r, P0, null, d, p, y, R);
      x0(D.current, r);
      var j = r.nodeType === qr ? r.parentNode : r;
      return Cv(j), new OO(D);
    }
    function DS(r) {
      this._internalRoot = r;
    }
    function i8(r) {
      r && XC(r);
    }
    DS.prototype.unstable_scheduleHydration = i8;
    function l8(r, a, d) {
      if (!_S(r))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      F$(r), a === void 0 && f("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var p = d ?? null, y = d != null && d.hydratedSources || null, R = !1, D = !1, j = "", Q = L$;
      d != null && (d.unstable_strictMode === !0 && (R = !0), d.identifierPrefix !== void 0 && (j = d.identifierPrefix), d.onRecoverableError !== void 0 && (Q = d.onRecoverableError));
      var re = v$(a, null, r, P0, p, R, D, j, Q);
      if (x0(re.current, r), Cv(r), y)
        for (var ae = 0; ae < y.length; ae++) {
          var ke = y[ae];
          hU(re, ke);
        }
      return new DS(re);
    }
    function _S(r) {
      return !!(r && (r.nodeType === sa || r.nodeType === Ei || r.nodeType === Xs || !oe));
    }
    function pb(r) {
      return !!(r && (r.nodeType === sa || r.nodeType === Ei || r.nodeType === Xs || r.nodeType === qr && r.nodeValue === " react-mount-point-unstable "));
    }
    function F$(r) {
      r.nodeType === sa && r.tagName && r.tagName.toUpperCase() === "BODY" && f("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Iv(r) && (r._reactRootContainer ? f("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : f("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var s8 = o.ReactCurrentOwner, z$;
    z$ = function(r) {
      if (r._reactRootContainer && r.nodeType !== qr) {
        var a = y$(r._reactRootContainer.current);
        a && a.parentNode !== r && f("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var d = !!r._reactRootContainer, p = RO(r), y = !!(p && Nu(p));
      y && !d && f("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), r.nodeType === sa && r.tagName && r.tagName.toUpperCase() === "BODY" && f("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function RO(r) {
      return r ? r.nodeType === Ei ? r.documentElement : r.firstChild : null;
    }
    function V$() {
    }
    function c8(r, a, d, p, y) {
      if (y) {
        if (typeof p == "function") {
          var R = p;
          p = function() {
            var Ee = $S(D);
            R.call(Ee);
          };
        }
        var D = v$(
          a,
          p,
          r,
          Du,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          V$
        );
        r._reactRootContainer = D, x0(D.current, r);
        var j = r.nodeType === qr ? r.parentNode : r;
        return Cv(j), $c(), D;
      } else {
        for (var Q; Q = r.lastChild; )
          r.removeChild(Q);
        if (typeof p == "function") {
          var re = p;
          p = function() {
            var Ee = $S(ae);
            re.call(Ee);
          };
        }
        var ae = g$(
          r,
          Du,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          V$
        );
        r._reactRootContainer = ae, x0(ae.current, r);
        var ke = r.nodeType === qr ? r.parentNode : r;
        return Cv(ke), $c(function() {
          fb(a, ae, d, p);
        }), ae;
      }
    }
    function u8(r, a) {
      r !== null && typeof r != "function" && f("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, r);
    }
    function AS(r, a, d, p, y) {
      z$(d), u8(y === void 0 ? null : y, "render");
      var R = d._reactRootContainer, D;
      if (!R)
        D = c8(d, a, r, y, p);
      else {
        if (D = R, typeof y == "function") {
          var j = y;
          y = function() {
            var Q = $S(D);
            j.call(Q);
          };
        }
        fb(a, D, r, y);
      }
      return $S(D);
    }
    function d8(r) {
      {
        var a = s8.current;
        if (a !== null && a.stateNode !== null) {
          var d = a.stateNode._warnedAboutRefsInRender;
          d || f("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", dr(a.type) || "A component"), a.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return r == null ? null : r.nodeType === sa ? r : K6(r, "findDOMNode");
    }
    function f8(r, a, d) {
      if (f("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !pb(a))
        throw new Error("Target container is not a DOM element.");
      {
        var p = Iv(a) && a._reactRootContainer === void 0;
        p && f("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return AS(null, r, a, !0, d);
    }
    function p8(r, a, d) {
      if (f("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !pb(a))
        throw new Error("Target container is not a DOM element.");
      {
        var p = Iv(a) && a._reactRootContainer === void 0;
        p && f("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return AS(null, r, a, !1, d);
    }
    function m8(r, a, d, p) {
      if (f("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !pb(d))
        throw new Error("Target container is not a DOM element.");
      if (r == null || !Hd(r))
        throw new Error("parentComponent must be a valid React Component");
      return AS(r, a, d, !1, p);
    }
    function h8(r) {
      if (!pb(r))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var a = Iv(r) && r._reactRootContainer === void 0;
        a && f("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (r._reactRootContainer) {
        {
          var d = RO(r), p = d && !Nu(d);
          p && f("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return $c(function() {
          AS(null, null, r, !1, function() {
            r._reactRootContainer = null, AM(r);
          });
        }), !0;
      } else {
        {
          var y = RO(r), R = !!(y && Nu(y)), D = r.nodeType === sa && pb(r.parentNode) && !!r.parentNode._reactRootContainer;
          R && f("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", D ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Ft(X6), UC(Q6), of(Z6), nv(ti), WC(tf), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && f("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), EC(bj), Ip(oO, l6, $c);
    function g8(r, a) {
      var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!_S(a))
        throw new Error("Target container is not a DOM element.");
      return Y6(r, a, null, d);
    }
    function v8(r, a, d, p) {
      return m8(r, a, d, p);
    }
    var kO = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Nu, $m, w0, Mp, Vd, oO]
    };
    function b8(r, a) {
      return kO.usingClientEntryPoint || f('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), a8(r, a);
    }
    function y8(r, a, d) {
      return kO.usingClientEntryPoint || f('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), l8(r, a, d);
    }
    function C8(r) {
      return KN() && f("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), $c(r);
    }
    var S8 = o8({
      findFiberByHostInstance: hf,
      bundleType: 1,
      version: SO,
      rendererPackageName: "react-dom"
    });
    if (!S8 && Fe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var B$ = window.location.protocol;
      /^(https?|file):$/.test(B$) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (B$ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    di.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = kO, di.createPortal = g8, di.createRoot = b8, di.findDOMNode = d8, di.flushSync = C8, di.hydrate = f8, di.hydrateRoot = y8, di.render = p8, di.unmountComponentAtNode = h8, di.unstable_batchedUpdates = oO, di.unstable_renderSubtreeIntoContainer = v8, di.version = SO, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), di;
}
function UL() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(UL);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (UL(), PR.exports = dq()) : PR.exports = fq();
var ep = PR.exports;
const BS = /* @__PURE__ */ YA(ep), Y2 = {
  disabled: !1
};
var pq = process.env.NODE_ENV !== "production" ? n.oneOfType([n.number, n.shape({
  enter: n.number,
  exit: n.number,
  appear: n.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && n.oneOfType([n.string, n.shape({
  enter: n.string,
  exit: n.string,
  active: n.string
}), n.shape({
  enter: n.string,
  enterDone: n.string,
  enterActive: n.string,
  exit: n.string,
  exitDone: n.string,
  exitActive: n.string
})]);
const N1 = Ha.createContext(null);
var mq = function(t) {
  return t.scrollTop;
}, $b = "unmounted", Ff = "exited", zf = "entering", ch = "entered", MR = "exiting", qc = /* @__PURE__ */ function(e) {
  jL(t, e);
  function t(i, s) {
    var c;
    c = e.call(this, i, s) || this;
    var f = s, m = f && !f.isMounting ? i.enter : i.appear, h;
    return c.appearStatus = null, i.in ? m ? (h = Ff, c.appearStatus = zf) : h = ch : i.unmountOnExit || i.mountOnEnter ? h = $b : h = Ff, c.state = {
      status: h
    }, c.nextCallback = null, c;
  }
  t.getDerivedStateFromProps = function(s, c) {
    var f = s.in;
    return f && c.status === $b ? {
      status: Ff
    } : null;
  };
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(s) {
    var c = null;
    if (s !== this.props) {
      var f = this.state.status;
      this.props.in ? f !== zf && f !== ch && (c = zf) : (f === zf || f === ch) && (c = MR);
    }
    this.updateStatus(!1, c);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var s = this.props.timeout, c, f, m;
    return c = f = m = s, s != null && typeof s != "number" && (c = s.exit, f = s.enter, m = s.appear !== void 0 ? s.appear : f), {
      exit: c,
      enter: f,
      appear: m
    };
  }, o.updateStatus = function(s, c) {
    if (s === void 0 && (s = !1), c !== null)
      if (this.cancelNextCallback(), c === zf) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var f = this.props.nodeRef ? this.props.nodeRef.current : BS.findDOMNode(this);
          f && mq(f);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Ff && this.setState({
        status: $b
      });
  }, o.performEnter = function(s) {
    var c = this, f = this.props.enter, m = this.context ? this.context.isMounting : s, h = this.props.nodeRef ? [m] : [BS.findDOMNode(this), m], v = h[0], b = h[1], x = this.getTimeouts(), E = m ? x.appear : x.enter;
    if (!s && !f || Y2.disabled) {
      this.safeSetState({
        status: ch
      }, function() {
        c.props.onEntered(v);
      });
      return;
    }
    this.props.onEnter(v, b), this.safeSetState({
      status: zf
    }, function() {
      c.props.onEntering(v, b), c.onTransitionEnd(E, function() {
        c.safeSetState({
          status: ch
        }, function() {
          c.props.onEntered(v, b);
        });
      });
    });
  }, o.performExit = function() {
    var s = this, c = this.props.exit, f = this.getTimeouts(), m = this.props.nodeRef ? void 0 : BS.findDOMNode(this);
    if (!c || Y2.disabled) {
      this.safeSetState({
        status: Ff
      }, function() {
        s.props.onExited(m);
      });
      return;
    }
    this.props.onExit(m), this.safeSetState({
      status: MR
    }, function() {
      s.props.onExiting(m), s.onTransitionEnd(f.exit, function() {
        s.safeSetState({
          status: Ff
        }, function() {
          s.props.onExited(m);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(s, c) {
    c = this.setNextCallback(c), this.setState(s, c);
  }, o.setNextCallback = function(s) {
    var c = this, f = !0;
    return this.nextCallback = function(m) {
      f && (f = !1, c.nextCallback = null, s(m));
    }, this.nextCallback.cancel = function() {
      f = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(s, c) {
    this.setNextCallback(c);
    var f = this.props.nodeRef ? this.props.nodeRef.current : BS.findDOMNode(this), m = s == null && !this.props.addEndListener;
    if (!f || m) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [f, this.nextCallback], v = h[0], b = h[1];
      this.props.addEndListener(v, b);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, o.render = function() {
    var s = this.state.status;
    if (s === $b)
      return null;
    var c = this.props, f = c.children;
    c.in, c.mountOnEnter, c.unmountOnExit, c.appear, c.enter, c.exit, c.timeout, c.addEndListener, c.onEnter, c.onEntering, c.onEntered, c.onExit, c.onExiting, c.onExited, c.nodeRef;
    var m = pe(c, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ha.createElement(N1.Provider, {
        value: null
      }, typeof f == "function" ? f(s, m) : Ha.cloneElement(Ha.Children.only(f), m))
    );
  }, t;
}(Ha.Component);
qc.contextType = N1;
qc.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: n.shape({
    current: typeof Element > "u" ? n.any : function(e, t, o, i, s, c) {
      var f = e[t];
      return n.instanceOf(f && "ownerDocument" in f ? f.ownerDocument.defaultView.Element : Element)(e, t, o, i, s, c);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: n.oneOfType([n.func.isRequired, n.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: n.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: n.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: n.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: n.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: n.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: n.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var o = pq;
    t.addEndListener || (o = o.isRequired);
    for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
      s[c - 1] = arguments[c];
    return o.apply(void 0, [t].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: n.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: n.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: n.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: n.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: n.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: n.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: n.func
} : {};
function ah() {
}
qc.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: ah,
  onEntering: ah,
  onEntered: ah,
  onExit: ah,
  onExiting: ah,
  onExited: ah
};
qc.UNMOUNTED = $b;
qc.EXITED = Ff;
qc.ENTERING = zf;
qc.ENTERED = ch;
qc.EXITING = MR;
const Oy = qc;
function hq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vk(e, t) {
  var o = function(c) {
    return t && m1(c) ? t(c) : c;
  }, i = /* @__PURE__ */ Object.create(null);
  return e && E8.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    i[s.key] = o(s);
  }), i;
}
function gq(e, t) {
  e = e || {}, t = t || {};
  function o(b) {
    return b in t ? t[b] : e[b];
  }
  var i = /* @__PURE__ */ Object.create(null), s = [];
  for (var c in e)
    c in t ? s.length && (i[c] = s, s = []) : s.push(c);
  var f, m = {};
  for (var h in t) {
    if (i[h])
      for (f = 0; f < i[h].length; f++) {
        var v = i[h][f];
        m[i[h][f]] = o(v);
      }
    m[h] = o(h);
  }
  for (f = 0; f < s.length; f++)
    m[s[f]] = o(s[f]);
  return m;
}
function Hf(e, t, o) {
  return o[t] != null ? o[t] : e.props[t];
}
function vq(e, t) {
  return Vk(e.children, function(o) {
    return h1(o, {
      onExited: t.bind(null, o),
      in: !0,
      appear: Hf(o, "appear", e),
      enter: Hf(o, "enter", e),
      exit: Hf(o, "exit", e)
    });
  });
}
function bq(e, t, o) {
  var i = Vk(e.children), s = gq(t, i);
  return Object.keys(s).forEach(function(c) {
    var f = s[c];
    if (m1(f)) {
      var m = c in t, h = c in i, v = t[c], b = m1(v) && !v.props.in;
      h && (!m || b) ? s[c] = h1(f, {
        onExited: o.bind(null, f),
        in: !0,
        exit: Hf(f, "exit", e),
        enter: Hf(f, "enter", e)
      }) : !h && m && !b ? s[c] = h1(f, {
        in: !1
      }) : h && m && m1(v) && (s[c] = h1(f, {
        onExited: o.bind(null, f),
        in: v.props.in,
        exit: Hf(f, "exit", e),
        enter: Hf(f, "enter", e)
      }));
    }
  }), s;
}
var yq = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, Cq = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Bk = /* @__PURE__ */ function(e) {
  jL(t, e);
  function t(i, s) {
    var c;
    c = e.call(this, i, s) || this;
    var f = c.handleExited.bind(hq(c));
    return c.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: f,
      firstRender: !0
    }, c;
  }
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(s, c) {
    var f = c.children, m = c.handleExited, h = c.firstRender;
    return {
      children: h ? vq(s, m) : bq(s, f, m),
      firstRender: !1
    };
  }, o.handleExited = function(s, c) {
    var f = Vk(this.props.children);
    s.key in f || (s.props.onExited && s.props.onExited(c), this.mounted && this.setState(function(m) {
      var h = S({}, m.children);
      return delete h[s.key], {
        children: h
      };
    }));
  }, o.render = function() {
    var s = this.props, c = s.component, f = s.childFactory, m = pe(s, ["component", "childFactory"]), h = this.state.contextValue, v = yq(this.state.children).map(f);
    return delete m.appear, delete m.enter, delete m.exit, c === null ? /* @__PURE__ */ Ha.createElement(N1.Provider, {
      value: h
    }, v) : /* @__PURE__ */ Ha.createElement(N1.Provider, {
      value: h
    }, /* @__PURE__ */ Ha.createElement(c, m, v));
  }, t;
}(Ha.Component);
Bk.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: n.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: n.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: n.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: n.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: n.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: n.func
} : {};
Bk.defaultProps = Cq;
const Sq = Bk, Ex = (e) => e.scrollTop;
function Yl(e, t) {
  var o, i;
  const {
    timeout: s,
    easing: c,
    style: f = {}
  } = e;
  return {
    duration: (o = f.transitionDuration) != null ? o : typeof s == "number" ? s : s[t.mode] || 0,
    easing: (i = f.transitionTimingFunction) != null ? i : typeof c == "object" ? c[t.mode] : c,
    delay: f.transitionDelay
  };
}
function mr() {
  const e = Sy(wx);
  return process.env.NODE_ENV !== "production" && C.useDebugValue(e), e[pd] || e;
}
function xq(e) {
  return ot("MuiSvgIcon", e);
}
const wq = lt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]), uSe = wq, Eq = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], Tq = (e) => {
  const {
    color: t,
    fontSize: o,
    classes: i
  } = e, s = {
    root: ["root", t !== "inherit" && `color${ve(t)}`, `fontSize${ve(o)}`]
  };
  return je(s, xq, i);
}, Oq = se("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "inherit" && t[`color${ve(o.color)}`], t[`fontSize${ve(o.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var o, i, s, c, f, m, h, v, b, x, E, T, P;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (o = e.transitions) == null || (i = o.create) == null ? void 0 : i.call(o, "fill", {
      duration: (s = e.transitions) == null || (s = s.duration) == null ? void 0 : s.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((c = e.typography) == null || (f = c.pxToRem) == null ? void 0 : f.call(c, 20)) || "1.25rem",
      medium: ((m = e.typography) == null || (h = m.pxToRem) == null ? void 0 : h.call(m, 24)) || "1.5rem",
      large: ((v = e.typography) == null || (b = v.pxToRem) == null ? void 0 : b.call(v, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (x = (E = (e.vars || e).palette) == null || (E = E[t.color]) == null ? void 0 : E.main) != null ? x : {
      action: (T = (e.vars || e).palette) == null || (T = T.action) == null ? void 0 : T.active,
      disabled: (P = (e.vars || e).palette) == null || (P = P.action) == null ? void 0 : P.disabled,
      inherit: void 0
    }[t.color]
  };
}), jk = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: s,
    className: c,
    color: f = "inherit",
    component: m = "svg",
    fontSize: h = "medium",
    htmlColor: v,
    inheritViewBox: b = !1,
    titleAccess: x,
    viewBox: E = "0 0 24 24"
  } = i, T = pe(i, Eq), P = /* @__PURE__ */ C.isValidElement(s) && s.type === "svg", O = S({}, i, {
    color: f,
    component: m,
    fontSize: h,
    instanceFontSize: t.fontSize,
    inheritViewBox: b,
    viewBox: E,
    hasSvgAsChild: P
  }), k = {};
  b || (k.viewBox = E);
  const I = Tq(O);
  return /* @__PURE__ */ ht(Oq, S({
    as: m,
    className: be(I.root, c),
    focusable: "false",
    color: v,
    "aria-hidden": x ? void 0 : !0,
    role: x ? "img" : void 0,
    ref: o
  }, k, T, P && s.props, {
    ownerState: O,
    children: [P ? s.props.children : s, x ? /* @__PURE__ */ L("title", {
      children: x
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (jk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: n.oneOfType([n.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: n.oneOfType([n.oneOf(["inherit", "large", "medium", "small"]), n.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: n.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: n.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: n.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: n.string
});
jk.muiName = "SvgIcon";
const IR = jk;
function rn(e, t) {
  function o(i, s) {
    return /* @__PURE__ */ L(IR, S({
      "data-testid": `${t}Icon`,
      ref: s
    }, i, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (o.displayName = `${t}Icon`), o.muiName = IR.muiName, /* @__PURE__ */ C.memo(/* @__PURE__ */ C.forwardRef(o));
}
const dSe = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), Sk.configure(e);
  }
};
function Rq(e) {
  return ot("MuiCollapse", e);
}
const kq = lt("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]), fSe = kq, Pq = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], Mq = (e) => {
  const {
    orientation: t,
    classes: o
  } = e, i = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return je(i, Rq, o);
}, Iq = se("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation], o.state === "entered" && t.entered, o.state === "exited" && !o.in && o.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && S({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), Nq = se("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => S({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), $q = se("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => S({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Hk = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: s,
    children: c,
    className: f,
    collapsedSize: m = "0px",
    component: h,
    easing: v,
    in: b,
    onEnter: x,
    onEntered: E,
    onEntering: T,
    onExit: P,
    onExited: O,
    onExiting: k,
    orientation: I = "vertical",
    style: $,
    timeout: _ = BL.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: z = Oy
  } = i, V = pe(i, Pq), M = S({}, i, {
    orientation: I,
    collapsedSize: m
  }), A = Mq(M), W = mr(), Y = C.useRef(), H = C.useRef(null), G = C.useRef(), ne = typeof m == "number" ? `${m}px` : m, K = I === "horizontal", B = K ? "width" : "height";
  C.useEffect(() => () => {
    clearTimeout(Y.current);
  }, []);
  const q = C.useRef(null), X = Cn(o, q), J = (me) => (Oe) => {
    if (me) {
      const he = q.current;
      Oe === void 0 ? me(he) : me(he, Oe);
    }
  }, U = () => H.current ? H.current[K ? "clientWidth" : "clientHeight"] : 0, Z = J((me, Oe) => {
    H.current && K && (H.current.style.position = "absolute"), me.style[B] = ne, x && x(me, Oe);
  }), ee = J((me, Oe) => {
    const he = U();
    H.current && K && (H.current.style.position = "");
    const {
      duration: $e,
      easing: Ne
    } = Yl({
      style: $,
      timeout: _,
      easing: v
    }, {
      mode: "enter"
    });
    if (_ === "auto") {
      const Pe = W.transitions.getAutoHeightDuration(he);
      me.style.transitionDuration = `${Pe}ms`, G.current = Pe;
    } else
      me.style.transitionDuration = typeof $e == "string" ? $e : `${$e}ms`;
    me.style[B] = `${he}px`, me.style.transitionTimingFunction = Ne, T && T(me, Oe);
  }), ie = J((me, Oe) => {
    me.style[B] = "auto", E && E(me, Oe);
  }), oe = J((me) => {
    me.style[B] = `${U()}px`, P && P(me);
  }), le = J(O), de = J((me) => {
    const Oe = U(), {
      duration: he,
      easing: $e
    } = Yl({
      style: $,
      timeout: _,
      easing: v
    }, {
      mode: "exit"
    });
    if (_ === "auto") {
      const Ne = W.transitions.getAutoHeightDuration(Oe);
      me.style.transitionDuration = `${Ne}ms`, G.current = Ne;
    } else
      me.style.transitionDuration = typeof he == "string" ? he : `${he}ms`;
    me.style[B] = ne, me.style.transitionTimingFunction = $e, k && k(me);
  });
  return /* @__PURE__ */ L(z, S({
    in: b,
    onEnter: Z,
    onEntered: ie,
    onEntering: ee,
    onExit: oe,
    onExited: le,
    onExiting: de,
    addEndListener: (me) => {
      _ === "auto" && (Y.current = setTimeout(me, G.current || 0)), s && s(q.current, me);
    },
    nodeRef: q,
    timeout: _ === "auto" ? null : _
  }, V, {
    children: (me, Oe) => /* @__PURE__ */ L(Iq, S({
      as: h,
      className: be(A.root, f, {
        entered: A.entered,
        exited: !b && ne === "0px" && A.hidden
      }[me]),
      style: S({
        [K ? "minWidth" : "minHeight"]: ne
      }, $),
      ownerState: S({}, M, {
        state: me
      }),
      ref: X
    }, Oe, {
      children: /* @__PURE__ */ L(Nq, {
        ownerState: S({}, M, {
          state: me
        }),
        className: A.wrapper,
        ref: H,
        children: /* @__PURE__ */ L($q, {
          ownerState: S({}, M, {
            state: me
          }),
          className: A.wrapperInner,
          children: c
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Hk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * The content node to be collapsed.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: n.oneOfType([n.number, n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: dd,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
Hk.muiSupportAuto = !0;
const Uk = Hk, Dq = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, NR = Dq;
function _q(e) {
  return ot("MuiPaper", e);
}
const Aq = lt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]), pSe = Aq, Lq = ["className", "component", "elevation", "square", "variant"], Fq = (e) => {
  const {
    square: t,
    elevation: o,
    variant: i,
    classes: s
  } = e, c = {
    root: ["root", i, !t && "rounded", i === "elevation" && `elevation${o}`]
  };
  return je(c, _q, s);
}, zq = se("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], !o.square && t.rounded, o.variant === "elevation" && t[`elevation${o.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var o;
  return S({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && S({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${_t("#fff", NR(t.elevation))}, ${_t("#fff", NR(t.elevation))})`
  }, e.vars && {
    backgroundImage: (o = e.vars.overlays) == null ? void 0 : o[t.elevation]
  }));
}), GL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiPaper"
  }), {
    className: s,
    component: c = "div",
    elevation: f = 1,
    square: m = !1,
    variant: h = "elevation"
  } = i, v = pe(i, Lq), b = S({}, i, {
    component: c,
    elevation: f,
    square: m,
    variant: h
  }), x = Fq(b);
  return process.env.NODE_ENV !== "production" && mr().shadows[f] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${f}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${f}]\` is defined.`].join(`
`)), /* @__PURE__ */ L(zq, S({
    as: c,
    ownerState: b,
    className: be(x.root, s),
    ref: o
  }, v));
});
process.env.NODE_ENV !== "production" && (GL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: co(eo, (e) => {
    const {
      elevation: t,
      variant: o
    } = e;
    return t > 0 && o === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${o}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: n.oneOfType([n.oneOf(["elevation", "outlined"]), n.string])
});
const Ci = GL, WL = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (WL.displayName = "AccordionContext");
const qL = WL;
function Vq(e) {
  return ot("MuiAccordion", e);
}
const Bq = lt("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), jS = Bq, jq = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"], Hq = (e) => {
  const {
    classes: t,
    square: o,
    expanded: i,
    disabled: s,
    disableGutters: c
  } = e;
  return je({
    root: ["root", !o && "rounded", i && "expanded", s && "disabled", !c && "gutters"],
    region: ["region"]
  }, Vq, t);
}, Uq = se(Ci, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${jS.region}`]: t.region
    }, t.root, !o.square && t.rounded, !o.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&:before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&:before": {
        display: "none"
      }
    },
    [`&.${jS.expanded}`]: {
      "&:before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&:before": {
          display: "none"
        }
      }
    },
    [`&.${jS.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e,
  ownerState: t
}) => S({}, !t.square && {
  borderRadius: 0,
  "&:first-of-type": {
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius
  },
  "&:last-of-type": {
    borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
    borderBottomRightRadius: (e.vars || e).shape.borderRadius,
    // Fix a rendering issue on Edge
    "@supports (-ms-ime-align: auto)": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
}, !t.disableGutters && {
  [`&.${jS.expanded}`]: {
    margin: "16px 0"
  }
})), YL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAccordion"
  }), {
    children: s,
    className: c,
    defaultExpanded: f = !1,
    disabled: m = !1,
    disableGutters: h = !1,
    expanded: v,
    onChange: b,
    square: x = !1,
    TransitionComponent: E = Uk,
    TransitionProps: T
  } = i, P = pe(i, jq), [O, k] = _i({
    controlled: v,
    default: f,
    name: "Accordion",
    state: "expanded"
  }), I = C.useCallback((A) => {
    k(!O), b && b(A, !O);
  }, [O, b, k]), [$, ..._] = C.Children.toArray(s), z = C.useMemo(() => ({
    expanded: O,
    disabled: m,
    disableGutters: h,
    toggle: I
  }), [O, m, h, I]), V = S({}, i, {
    square: x,
    disabled: m,
    disableGutters: h,
    expanded: O
  }), M = Hq(V);
  return /* @__PURE__ */ ht(Uq, S({
    className: be(M.root, c),
    ref: o,
    ownerState: V,
    square: x
  }, P, {
    children: [/* @__PURE__ */ L(qL.Provider, {
      value: z,
      children: $
    }), /* @__PURE__ */ L(E, S({
      in: O,
      timeout: "auto"
    }, T, {
      children: /* @__PURE__ */ L("div", {
        "aria-labelledby": $.props.id,
        id: $.props["aria-controls"],
        role: "region",
        className: M.region,
        children: _
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (YL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: co(n.node.isRequired, (e) => {
    const t = C.Children.toArray(e.children)[0];
    return Kl.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ C.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: n.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: n.func,
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   */
  TransitionComponent: n.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: n.object
});
const Gq = YL;
function KL(e) {
  const {
    className: t,
    classes: o,
    pulsate: i = !1,
    rippleX: s,
    rippleY: c,
    rippleSize: f,
    in: m,
    onExited: h,
    timeout: v
  } = e, [b, x] = C.useState(!1), E = be(t, o.ripple, o.rippleVisible, i && o.ripplePulsate), T = {
    width: f,
    height: f,
    top: -(f / 2) + c,
    left: -(f / 2) + s
  }, P = be(o.child, b && o.childLeaving, i && o.childPulsate);
  return !m && !b && x(!0), C.useEffect(() => {
    if (!m && h != null) {
      const O = setTimeout(h, v);
      return () => {
        clearTimeout(O);
      };
    }
  }, [h, m, v]), /* @__PURE__ */ L("span", {
    className: E,
    style: T,
    children: /* @__PURE__ */ L("span", {
      className: P
    })
  });
}
process.env.NODE_ENV !== "production" && (KL.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object.isRequired,
  className: n.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: n.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: n.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: n.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: n.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: n.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: n.number,
  /**
   * exit delay
   */
  timeout: n.number.isRequired
});
function mSe(e) {
  return ot("MuiTouchRipple", e);
}
const Wq = lt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), nl = Wq, qq = ["center", "classes", "className"];
let Tx = (e) => e, K2, X2, Q2, Z2;
const $R = 550, Yq = 80, Kq = Gs(K2 || (K2 = Tx`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), Xq = Gs(X2 || (X2 = Tx`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Qq = Gs(Q2 || (Q2 = Tx`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), Zq = se("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Jq = se(KL, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(Z2 || (Z2 = Tx`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), nl.rippleVisible, Kq, $R, ({
  theme: e
}) => e.transitions.easing.easeInOut, nl.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, nl.child, nl.childLeaving, Xq, $R, ({
  theme: e
}) => e.transitions.easing.easeInOut, nl.childPulsate, Qq, ({
  theme: e
}) => e.transitions.easing.easeInOut), XL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: c = {},
    className: f
  } = i, m = pe(i, qq), [h, v] = C.useState([]), b = C.useRef(0), x = C.useRef(null);
  C.useEffect(() => {
    x.current && (x.current(), x.current = null);
  }, [h]);
  const E = C.useRef(!1), T = C.useRef(0), P = C.useRef(null), O = C.useRef(null);
  C.useEffect(() => () => {
    T.current && clearTimeout(T.current);
  }, []);
  const k = C.useCallback((z) => {
    const {
      pulsate: V,
      rippleX: M,
      rippleY: A,
      rippleSize: W,
      cb: Y
    } = z;
    v((H) => [...H, /* @__PURE__ */ L(Jq, {
      classes: {
        ripple: be(c.ripple, nl.ripple),
        rippleVisible: be(c.rippleVisible, nl.rippleVisible),
        ripplePulsate: be(c.ripplePulsate, nl.ripplePulsate),
        child: be(c.child, nl.child),
        childLeaving: be(c.childLeaving, nl.childLeaving),
        childPulsate: be(c.childPulsate, nl.childPulsate)
      },
      timeout: $R,
      pulsate: V,
      rippleX: M,
      rippleY: A,
      rippleSize: W
    }, b.current)]), b.current += 1, x.current = Y;
  }, [c]), I = C.useCallback((z = {}, V = {}, M = () => {
  }) => {
    const {
      pulsate: A = !1,
      center: W = s || V.pulsate,
      fakeElement: Y = !1
      // For test purposes
    } = V;
    if ((z == null ? void 0 : z.type) === "mousedown" && E.current) {
      E.current = !1;
      return;
    }
    (z == null ? void 0 : z.type) === "touchstart" && (E.current = !0);
    const H = Y ? null : O.current, G = H ? H.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let ne, K, B;
    if (W || z === void 0 || z.clientX === 0 && z.clientY === 0 || !z.clientX && !z.touches)
      ne = Math.round(G.width / 2), K = Math.round(G.height / 2);
    else {
      const {
        clientX: q,
        clientY: X
      } = z.touches && z.touches.length > 0 ? z.touches[0] : z;
      ne = Math.round(q - G.left), K = Math.round(X - G.top);
    }
    if (W)
      B = Math.sqrt((2 * G.width ** 2 + G.height ** 2) / 3), B % 2 === 0 && (B += 1);
    else {
      const q = Math.max(Math.abs((H ? H.clientWidth : 0) - ne), ne) * 2 + 2, X = Math.max(Math.abs((H ? H.clientHeight : 0) - K), K) * 2 + 2;
      B = Math.sqrt(q ** 2 + X ** 2);
    }
    z != null && z.touches ? P.current === null && (P.current = () => {
      k({
        pulsate: A,
        rippleX: ne,
        rippleY: K,
        rippleSize: B,
        cb: M
      });
    }, T.current = setTimeout(() => {
      P.current && (P.current(), P.current = null);
    }, Yq)) : k({
      pulsate: A,
      rippleX: ne,
      rippleY: K,
      rippleSize: B,
      cb: M
    });
  }, [s, k]), $ = C.useCallback(() => {
    I({}, {
      pulsate: !0
    });
  }, [I]), _ = C.useCallback((z, V) => {
    if (clearTimeout(T.current), (z == null ? void 0 : z.type) === "touchend" && P.current) {
      P.current(), P.current = null, T.current = setTimeout(() => {
        _(z, V);
      });
      return;
    }
    P.current = null, v((M) => M.length > 0 ? M.slice(1) : M), x.current = V;
  }, []);
  return C.useImperativeHandle(o, () => ({
    pulsate: $,
    start: I,
    stop: _
  }), [$, I, _]), /* @__PURE__ */ L(Zq, S({
    className: be(nl.root, c.root, f),
    ref: O
  }, m, {
    children: /* @__PURE__ */ L(Sq, {
      component: null,
      exit: !0,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (XL.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: n.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string
});
const eY = XL;
function tY(e) {
  return ot("MuiButtonBase", e);
}
const nY = lt("MuiButtonBase", ["root", "disabled", "focusVisible"]), rY = nY, oY = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], aY = (e) => {
  const {
    disabled: t,
    focusVisible: o,
    focusVisibleClassName: i,
    classes: s
  } = e, f = je({
    root: ["root", t && "disabled", o && "focusVisible"]
  }, tY, s);
  return o && i && (f.root += ` ${i}`), f;
}, iY = se("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${rY.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), QL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: c = !1,
    children: f,
    className: m,
    component: h = "button",
    disabled: v = !1,
    disableRipple: b = !1,
    disableTouchRipple: x = !1,
    focusRipple: E = !1,
    LinkComponent: T = "a",
    onBlur: P,
    onClick: O,
    onContextMenu: k,
    onDragLeave: I,
    onFocus: $,
    onFocusVisible: _,
    onKeyDown: z,
    onKeyUp: V,
    onMouseDown: M,
    onMouseLeave: A,
    onMouseUp: W,
    onTouchEnd: Y,
    onTouchMove: H,
    onTouchStart: G,
    tabIndex: ne = 0,
    TouchRippleProps: K,
    touchRippleRef: B,
    type: q
  } = i, X = pe(i, oY), J = C.useRef(null), U = C.useRef(null), Z = Cn(U, B), {
    isFocusVisibleRef: ee,
    onFocus: ie,
    onBlur: oe,
    ref: le
  } = vy(), [de, Ce] = C.useState(!1);
  v && de && Ce(!1), C.useImperativeHandle(s, () => ({
    focusVisible: () => {
      Ce(!0), J.current.focus();
    }
  }), []);
  const [me, Oe] = C.useState(!1);
  C.useEffect(() => {
    Oe(!0);
  }, []);
  const he = me && !b && !v;
  C.useEffect(() => {
    de && E && !b && me && U.current.pulsate();
  }, [b, E, de, me]);
  function $e(pt, At, Ye = x) {
    return zn((st) => (At && At(st), !Ye && U.current && U.current[pt](st), !0));
  }
  const Ne = $e("start", M), Pe = $e("stop", k), Se = $e("stop", I), Fe = $e("stop", W), ce = $e("stop", (pt) => {
    de && pt.preventDefault(), A && A(pt);
  }), ge = $e("start", G), we = $e("stop", Y), Me = $e("stop", H), Qe = $e("stop", (pt) => {
    oe(pt), ee.current === !1 && Ce(!1), P && P(pt);
  }, !1), ct = zn((pt) => {
    J.current || (J.current = pt.currentTarget), ie(pt), ee.current === !0 && (Ce(!0), _ && _(pt)), $ && $(pt);
  }), Ze = () => {
    const pt = J.current;
    return h && h !== "button" && !(pt.tagName === "A" && pt.href);
  }, Ge = C.useRef(!1), Be = zn((pt) => {
    E && !Ge.current && de && U.current && pt.key === " " && (Ge.current = !0, U.current.stop(pt, () => {
      U.current.start(pt);
    })), pt.target === pt.currentTarget && Ze() && pt.key === " " && pt.preventDefault(), z && z(pt), pt.target === pt.currentTarget && Ze() && pt.key === "Enter" && !v && (pt.preventDefault(), O && O(pt));
  }), rt = zn((pt) => {
    E && pt.key === " " && U.current && de && !pt.defaultPrevented && (Ge.current = !1, U.current.stop(pt, () => {
      U.current.pulsate(pt);
    })), V && V(pt), O && pt.target === pt.currentTarget && Ze() && pt.key === " " && !pt.defaultPrevented && O(pt);
  });
  let wt = h;
  wt === "button" && (X.href || X.to) && (wt = T);
  const We = {};
  wt === "button" ? (We.type = q === void 0 ? "button" : q, We.disabled = v) : (!X.href && !X.to && (We.role = "button"), v && (We["aria-disabled"] = v));
  const ut = Cn(o, le, J);
  process.env.NODE_ENV !== "production" && C.useEffect(() => {
    he && !U.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [he]);
  const ft = S({}, i, {
    centerRipple: c,
    component: h,
    disabled: v,
    disableRipple: b,
    disableTouchRipple: x,
    focusRipple: E,
    tabIndex: ne,
    focusVisible: de
  }), Je = aY(ft);
  return /* @__PURE__ */ ht(iY, S({
    as: wt,
    className: be(Je.root, m),
    ownerState: ft,
    onBlur: Qe,
    onClick: O,
    onContextMenu: Pe,
    onFocus: ct,
    onKeyDown: Be,
    onKeyUp: rt,
    onMouseDown: Ne,
    onMouseLeave: ce,
    onMouseUp: Fe,
    onDragLeave: Se,
    onTouchEnd: we,
    onTouchMove: Me,
    onTouchStart: ge,
    ref: ut,
    tabIndex: v ? -1 : ne,
    type: q
  }, We, X, {
    children: [f, he ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ L(eY, S({
        ref: Z,
        center: c
      }, K))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (QL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Fo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: dd,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: n.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  href: n.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: n.elementType,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onContextMenu: n.func,
  /**
   * @ignore
   */
  onDragLeave: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * @ignore
   */
  onMouseDown: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * @ignore
   */
  onMouseUp: n.func,
  /**
   * @ignore
   */
  onTouchEnd: n.func,
  /**
   * @ignore
   */
  onTouchMove: n.func,
  /**
   * @ignore
   */
  onTouchStart: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @default 0
   */
  tabIndex: n.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: n.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: n.oneOfType([n.func, n.shape({
    current: n.shape({
      pulsate: n.func.isRequired,
      start: n.func.isRequired,
      stop: n.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: n.oneOfType([n.oneOf(["button", "reset", "submit"]), n.string])
});
const Ao = QL;
function lY(e) {
  return ot("MuiAccordionSummary", e);
}
const sY = lt("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), hh = sY, cY = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], uY = (e) => {
  const {
    classes: t,
    expanded: o,
    disabled: i,
    disableGutters: s
  } = e;
  return je({
    root: ["root", o && "expanded", i && "disabled", !s && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", o && "expanded", !s && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", o && "expanded"]
  }, lY, t);
}, dY = se(Ao, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const o = {
    duration: e.transitions.duration.shortest
  };
  return S({
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], o),
    [`&.${hh.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${hh.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${hh.disabled})`]: {
      cursor: "pointer"
    }
  }, !t.disableGutters && {
    [`&.${hh.expanded}`]: {
      minHeight: 64
    }
  });
}), fY = se("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0"
}, !t.disableGutters && {
  transition: e.transitions.create(["margin"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${hh.expanded}`]: {
    margin: "20px 0"
  }
})), pY = se("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${hh.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), ZL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: s,
    className: c,
    expandIcon: f,
    focusVisibleClassName: m,
    onClick: h
  } = i, v = pe(i, cY), {
    disabled: b = !1,
    disableGutters: x,
    expanded: E,
    toggle: T
  } = C.useContext(qL), P = (I) => {
    T && T(I), h && h(I);
  }, O = S({}, i, {
    expanded: E,
    disabled: b,
    disableGutters: x
  }), k = uY(O);
  return /* @__PURE__ */ ht(dY, S({
    focusRipple: !1,
    disableRipple: !0,
    disabled: b,
    component: "div",
    "aria-expanded": E,
    className: be(k.root, c),
    focusVisibleClassName: be(k.focusVisible, m),
    onClick: P,
    ref: o,
    ownerState: O
  }, v, {
    children: [/* @__PURE__ */ L(fY, {
      className: k.content,
      ownerState: O,
      children: s
    }), f && /* @__PURE__ */ L(pY, {
      className: k.expandIconWrapper,
      ownerState: O,
      children: f
    })]
  }));
});
process.env.NODE_ENV !== "production" && (ZL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: n.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const mY = ZL;
function hY(e) {
  return ot("MuiAccordionDetails", e);
}
const gY = lt("MuiAccordionDetails", ["root"]), hSe = gY, vY = ["className"], bY = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, hY, t);
}, yY = se("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), JL = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: s
  } = i, c = pe(i, vY), f = i, m = bY(f);
  return /* @__PURE__ */ L(yY, S({
    className: be(m.root, s),
    ref: o,
    ownerState: f
  }, c));
});
process.env.NODE_ENV !== "production" && (JL.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const CY = JL, SY = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, xY = SY, wY = {
  50: "#ede7f6",
  100: "#d1c4e9",
  200: "#b39ddb",
  300: "#9575cd",
  400: "#7e57c2",
  500: "#673ab7",
  600: "#5e35b1",
  700: "#512da8",
  800: "#4527a0",
  900: "#311b92",
  A100: "#b388ff",
  A200: "#7c4dff",
  A400: "#651fff",
  A700: "#6200ea"
}, EY = wY, TY = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, OY = TY, RY = {
  50: "#e0f7fa",
  100: "#b2ebf2",
  200: "#80deea",
  300: "#4dd0e1",
  400: "#26c6da",
  500: "#00bcd4",
  600: "#00acc1",
  700: "#0097a7",
  800: "#00838f",
  900: "#006064",
  A100: "#84ffff",
  A200: "#18ffff",
  A400: "#00e5ff",
  A700: "#00b8d4"
}, kY = RY, PY = {
  50: "#e0f2f1",
  100: "#b2dfdb",
  200: "#80cbc4",
  300: "#4db6ac",
  400: "#26a69a",
  500: "#009688",
  600: "#00897b",
  700: "#00796b",
  800: "#00695c",
  900: "#004d40",
  A100: "#a7ffeb",
  A200: "#64ffda",
  A400: "#1de9b6",
  A700: "#00bfa5"
}, MY = PY, IY = {
  50: "#f1f8e9",
  100: "#dcedc8",
  200: "#c5e1a5",
  300: "#aed581",
  400: "#9ccc65",
  500: "#8bc34a",
  600: "#7cb342",
  700: "#689f38",
  800: "#558b2f",
  900: "#33691e",
  A100: "#ccff90",
  A200: "#b2ff59",
  A400: "#76ff03",
  A700: "#64dd17"
}, NY = IY, $Y = {
  50: "#f9fbe7",
  100: "#f0f4c3",
  200: "#e6ee9c",
  300: "#dce775",
  400: "#d4e157",
  500: "#cddc39",
  600: "#c0ca33",
  700: "#afb42b",
  800: "#9e9d24",
  900: "#827717",
  A100: "#f4ff81",
  A200: "#eeff41",
  A400: "#c6ff00",
  A700: "#aeea00"
}, DY = $Y, _Y = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
}, AY = _Y, LY = {
  50: "#fff8e1",
  100: "#ffecb3",
  200: "#ffe082",
  300: "#ffd54f",
  400: "#ffca28",
  500: "#ffc107",
  600: "#ffb300",
  700: "#ffa000",
  800: "#ff8f00",
  900: "#ff6f00",
  A100: "#ffe57f",
  A200: "#ffd740",
  A400: "#ffc400",
  A700: "#ffab00"
}, FY = LY, zY = {
  50: "#fbe9e7",
  100: "#ffccbc",
  200: "#ffab91",
  300: "#ff8a65",
  400: "#ff7043",
  500: "#ff5722",
  600: "#f4511e",
  700: "#e64a19",
  800: "#d84315",
  900: "#bf360c",
  A100: "#ff9e80",
  A200: "#ff6e40",
  A400: "#ff3d00",
  A700: "#dd2c00"
}, VY = zY, BY = {
  50: "#efebe9",
  100: "#d7ccc8",
  200: "#bcaaa4",
  300: "#a1887f",
  400: "#8d6e63",
  500: "#795548",
  600: "#6d4c41",
  700: "#5d4037",
  800: "#4e342e",
  900: "#3e2723",
  A100: "#d7ccc8",
  A200: "#bcaaa4",
  A400: "#8d6e63",
  A700: "#5d4037"
}, jY = BY, HY = {
  50: "#eceff1",
  100: "#cfd8dc",
  200: "#b0bec5",
  300: "#90a4ae",
  400: "#78909c",
  500: "#607d8b",
  600: "#546e7a",
  700: "#455a64",
  800: "#37474f",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
}, UY = HY, gSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amber: FY,
  blue: _f,
  blueGrey: UY,
  brown: jY,
  common: Nh,
  cyan: kY,
  deepOrange: VY,
  deepPurple: EY,
  green: Lf,
  grey: zL,
  indigo: OY,
  lightBlue: Af,
  lightGreen: NY,
  lime: DY,
  orange: sh,
  pink: xY,
  purple: $f,
  red: Df,
  teal: MY,
  yellow: AY
}, Symbol.toStringTag, { value: "Module" })), GY = ["defaultProps", "mixins", "overrides", "palette", "props", "styleOverrides"], WY = ["type", "mode"];
function vSe(e) {
  process.env.NODE_ENV !== "production" && console.warn(["MUI: adaptV4Theme() is deprecated.", "Follow the upgrade guide on https://mui.com/r/migration-v4#theme."].join(`
`));
  const {
    defaultProps: t = {},
    mixins: o = {},
    overrides: i = {},
    palette: s = {},
    props: c = {},
    styleOverrides: f = {}
  } = e, m = pe(e, GY), h = S({}, m, {
    components: {}
  });
  Object.keys(t).forEach((O) => {
    const k = h.components[O] || {};
    k.defaultProps = t[O], h.components[O] = k;
  }), Object.keys(c).forEach((O) => {
    const k = h.components[O] || {};
    k.defaultProps = c[O], h.components[O] = k;
  }), Object.keys(f).forEach((O) => {
    const k = h.components[O] || {};
    k.styleOverrides = f[O], h.components[O] = k;
  }), Object.keys(i).forEach((O) => {
    const k = h.components[O] || {};
    k.styleOverrides = i[O], h.components[O] = k;
  }), h.spacing = PL(e.spacing);
  const v = TL(e.breakpoints || {}), b = h.spacing;
  h.mixins = S({
    gutters: (O = {}) => S({
      paddingLeft: b(2),
      paddingRight: b(2)
    }, O, {
      [v.up("sm")]: S({
        paddingLeft: b(3),
        paddingRight: b(3)
      }, O[v.up("sm")])
    })
  }, o);
  const {
    type: x,
    mode: E
  } = s, T = pe(s, WY), P = E || x || "light";
  return h.palette = S({
    // theme.palette.text.hint
    text: {
      hint: P === "dark" ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.38)"
    },
    mode: P,
    type: P
  }, T), h;
}
function bSe(e, ...t) {
  return Jf(So({
    unstable_strictMode: !0
  }, e), ...t);
}
let J2 = !1;
function ySe(e) {
  return J2 || (console.warn(["MUI: createStyles from @mui/material/styles is deprecated.", "Please use @mui/styles/createStyles"].join(`
`)), J2 = !0), e;
}
function eD(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function eF(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Ju(e) {
  return parseFloat(e);
}
function qY(e) {
  return (t, o) => {
    const i = eF(t);
    if (i === o)
      return t;
    let s = Ju(t);
    i !== "px" && (i === "em" || i === "rem") && (s = Ju(t) * Ju(e));
    let c = s;
    if (o !== "px")
      if (o === "em")
        c = s / Ju(e);
      else if (o === "rem")
        c = s / Ju(e);
      else
        return t;
    return parseFloat(c.toFixed(5)) + o;
  };
}
function YY({
  size: e,
  grid: t
}) {
  const o = e - e % t, i = o + t;
  return e - o < i - e ? o : i;
}
function KY({
  lineHeight: e,
  pixels: t,
  htmlFontSize: o
}) {
  return t / (e * o);
}
function XY({
  cssProperty: e,
  min: t,
  max: o,
  unit: i = "rem",
  breakpoints: s = [600, 900, 1200],
  transform: c = null
}) {
  const f = {
    [e]: `${t}${i}`
  }, m = (o - t) / s[s.length - 1];
  return s.forEach((h) => {
    let v = t + m * h;
    c !== null && (v = c(v)), f[`@media (min-width:${h}px)`] = {
      [e]: `${Math.round(v * 1e4) / 1e4}${i}`
    };
  }), f;
}
function CSe(e, t = {}) {
  const {
    breakpoints: o = ["sm", "md", "lg"],
    disableAlign: i = !1,
    factor: s = 2,
    variants: c = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, f = S({}, e);
  f.typography = S({}, f.typography);
  const m = f.typography, h = qY(m.htmlFontSize), v = o.map((b) => f.breakpoints.values[b]);
  return c.forEach((b) => {
    const x = m[b], E = parseFloat(h(x.fontSize, "rem"));
    if (E <= 1)
      return;
    const T = E, P = 1 + (T - 1) / s;
    let {
      lineHeight: O
    } = x;
    if (!eD(O) && !i)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported non-unitless line height with grid alignment.
Use unitless line heights instead.` : gi(6));
    eD(O) || (O = parseFloat(h(O, "rem")) / parseFloat(E));
    let k = null;
    i || (k = (I) => YY({
      size: I,
      grid: KY({
        pixels: 4,
        lineHeight: O,
        htmlFontSize: m.htmlFontSize
      })
    })), m[b] = S({}, x, XY({
      cssProperty: "fontSize",
      min: P,
      max: T,
      unit: "rem",
      breakpoints: v,
      transform: k
    }));
  }), f;
}
const QY = ["theme"];
function tF(e) {
  let {
    theme: t
  } = e, o = pe(e, QY);
  const i = t[pd];
  return /* @__PURE__ */ L(Jb, S({}, o, {
    themeId: i ? pd : void 0,
    theme: i || t
  }));
}
process.env.NODE_ENV !== "production" && (tF.propTypes = {
  /**
   * Your component tree.
   */
  children: n.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: n.oneOfType([n.object, n.func]).isRequired
});
function SSe() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: makeStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : gi(14));
}
function xSe() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : gi(15));
}
function wSe() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withTheme is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : gi(16));
}
function ZY(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const JY = ["colorSchemes", "cssVarPrefix", "shouldSkipGeneratingVar"], eK = ["palette"], tK = [...Array(25)].map((e, t) => {
  if (t === 0)
    return;
  const o = NR(t);
  return `linear-gradient(rgba(255 255 255 / ${o}), rgba(255 255 255 / ${o}))`;
});
function nK(e, t) {
  t.forEach((o) => {
    e[o] || (e[o] = {});
  });
}
function tt(e, t, o) {
  !e[t] && o && (e[t] = o);
}
function Yu(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Ib(e[t], `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, e.g. "12 12 12") or undefined if you want to remove the channel token.`));
}
const Ns = (e) => {
  try {
    return e();
  } catch {
  }
}, rK = (e = "mui") => Y7(e);
function oK(e = {}, ...t) {
  var o, i, s, c, f, m;
  const {
    colorSchemes: h = {},
    cssVarPrefix: v = "mui",
    shouldSkipGeneratingVar: b = ZY
  } = e, x = pe(e, JY), E = rK(v), T = Jf(S({}, x, h.light && {
    palette: (o = h.light) == null ? void 0 : o.palette
  })), {
    palette: P
  } = T, O = pe(T, eK), {
    palette: k
  } = Jf({
    palette: S({
      mode: "dark"
    }, (i = h.dark) == null ? void 0 : i.palette)
  });
  let I = S({}, O, {
    cssVarPrefix: v,
    getCssVar: E,
    colorSchemes: S({}, h, {
      light: S({}, h.light, {
        palette: P,
        opacity: S({
          inputPlaceholder: 0.42,
          inputUnderline: 0.42,
          switchTrackDisabled: 0.12,
          switchTrack: 0.38
        }, (s = h.light) == null ? void 0 : s.opacity),
        overlays: ((c = h.light) == null ? void 0 : c.overlays) || []
      }),
      dark: S({}, h.dark, {
        palette: k,
        opacity: S({
          inputPlaceholder: 0.5,
          inputUnderline: 0.7,
          switchTrackDisabled: 0.2,
          switchTrack: 0.3
        }, (f = h.dark) == null ? void 0 : f.opacity),
        overlays: ((m = h.dark) == null ? void 0 : m.overlays) || tK
      })
    })
  });
  Object.keys(I.colorSchemes).forEach((V) => {
    const M = I.colorSchemes[V].palette, A = (W) => {
      const Y = W.split("-"), H = Y[1], G = Y[2];
      return E(W, M[H][G]);
    };
    if (V === "light" ? (tt(M.common, "background", "#fff"), tt(M.common, "onBackground", "#000")) : (tt(M.common, "background", "#000"), tt(M.common, "onBackground", "#fff")), nK(M, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), V === "light") {
      tt(M.Alert, "errorColor", Cr(M.error.light, 0.6)), tt(M.Alert, "infoColor", Cr(M.info.light, 0.6)), tt(M.Alert, "successColor", Cr(M.success.light, 0.6)), tt(M.Alert, "warningColor", Cr(M.warning.light, 0.6)), tt(M.Alert, "errorFilledBg", A("palette-error-main")), tt(M.Alert, "infoFilledBg", A("palette-info-main")), tt(M.Alert, "successFilledBg", A("palette-success-main")), tt(M.Alert, "warningFilledBg", A("palette-warning-main")), tt(M.Alert, "errorFilledColor", Ns(() => P.getContrastText(M.error.main))), tt(M.Alert, "infoFilledColor", Ns(() => P.getContrastText(M.info.main))), tt(M.Alert, "successFilledColor", Ns(() => P.getContrastText(M.success.main))), tt(M.Alert, "warningFilledColor", Ns(() => P.getContrastText(M.warning.main))), tt(M.Alert, "errorStandardBg", Sr(M.error.light, 0.9)), tt(M.Alert, "infoStandardBg", Sr(M.info.light, 0.9)), tt(M.Alert, "successStandardBg", Sr(M.success.light, 0.9)), tt(M.Alert, "warningStandardBg", Sr(M.warning.light, 0.9)), tt(M.Alert, "errorIconColor", A("palette-error-main")), tt(M.Alert, "infoIconColor", A("palette-info-main")), tt(M.Alert, "successIconColor", A("palette-success-main")), tt(M.Alert, "warningIconColor", A("palette-warning-main")), tt(M.AppBar, "defaultBg", A("palette-grey-100")), tt(M.Avatar, "defaultBg", A("palette-grey-400")), tt(M.Button, "inheritContainedBg", A("palette-grey-300")), tt(M.Button, "inheritContainedHoverBg", A("palette-grey-A100")), tt(M.Chip, "defaultBorder", A("palette-grey-400")), tt(M.Chip, "defaultAvatarColor", A("palette-grey-700")), tt(M.Chip, "defaultIconColor", A("palette-grey-700")), tt(M.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), tt(M.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), tt(M.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), tt(M.LinearProgress, "primaryBg", Sr(M.primary.main, 0.62)), tt(M.LinearProgress, "secondaryBg", Sr(M.secondary.main, 0.62)), tt(M.LinearProgress, "errorBg", Sr(M.error.main, 0.62)), tt(M.LinearProgress, "infoBg", Sr(M.info.main, 0.62)), tt(M.LinearProgress, "successBg", Sr(M.success.main, 0.62)), tt(M.LinearProgress, "warningBg", Sr(M.warning.main, 0.62)), tt(M.Skeleton, "bg", `rgba(${A("palette-text-primaryChannel")} / 0.11)`), tt(M.Slider, "primaryTrack", Sr(M.primary.main, 0.62)), tt(M.Slider, "secondaryTrack", Sr(M.secondary.main, 0.62)), tt(M.Slider, "errorTrack", Sr(M.error.main, 0.62)), tt(M.Slider, "infoTrack", Sr(M.info.main, 0.62)), tt(M.Slider, "successTrack", Sr(M.success.main, 0.62)), tt(M.Slider, "warningTrack", Sr(M.warning.main, 0.62));
      const W = Nb(M.background.default, 0.8);
      tt(M.SnackbarContent, "bg", W), tt(M.SnackbarContent, "color", Ns(() => P.getContrastText(W))), tt(M.SpeedDialAction, "fabHoverBg", Nb(M.background.paper, 0.15)), tt(M.StepConnector, "border", A("palette-grey-400")), tt(M.StepContent, "border", A("palette-grey-400")), tt(M.Switch, "defaultColor", A("palette-common-white")), tt(M.Switch, "defaultDisabledColor", A("palette-grey-100")), tt(M.Switch, "primaryDisabledColor", Sr(M.primary.main, 0.62)), tt(M.Switch, "secondaryDisabledColor", Sr(M.secondary.main, 0.62)), tt(M.Switch, "errorDisabledColor", Sr(M.error.main, 0.62)), tt(M.Switch, "infoDisabledColor", Sr(M.info.main, 0.62)), tt(M.Switch, "successDisabledColor", Sr(M.success.main, 0.62)), tt(M.Switch, "warningDisabledColor", Sr(M.warning.main, 0.62)), tt(M.TableCell, "border", Sr(zS(M.divider, 1), 0.88)), tt(M.Tooltip, "bg", zS(M.grey[700], 0.92));
    } else {
      tt(M.Alert, "errorColor", Sr(M.error.light, 0.6)), tt(M.Alert, "infoColor", Sr(M.info.light, 0.6)), tt(M.Alert, "successColor", Sr(M.success.light, 0.6)), tt(M.Alert, "warningColor", Sr(M.warning.light, 0.6)), tt(M.Alert, "errorFilledBg", A("palette-error-dark")), tt(M.Alert, "infoFilledBg", A("palette-info-dark")), tt(M.Alert, "successFilledBg", A("palette-success-dark")), tt(M.Alert, "warningFilledBg", A("palette-warning-dark")), tt(M.Alert, "errorFilledColor", Ns(() => k.getContrastText(M.error.dark))), tt(M.Alert, "infoFilledColor", Ns(() => k.getContrastText(M.info.dark))), tt(M.Alert, "successFilledColor", Ns(() => k.getContrastText(M.success.dark))), tt(M.Alert, "warningFilledColor", Ns(() => k.getContrastText(M.warning.dark))), tt(M.Alert, "errorStandardBg", Cr(M.error.light, 0.9)), tt(M.Alert, "infoStandardBg", Cr(M.info.light, 0.9)), tt(M.Alert, "successStandardBg", Cr(M.success.light, 0.9)), tt(M.Alert, "warningStandardBg", Cr(M.warning.light, 0.9)), tt(M.Alert, "errorIconColor", A("palette-error-main")), tt(M.Alert, "infoIconColor", A("palette-info-main")), tt(M.Alert, "successIconColor", A("palette-success-main")), tt(M.Alert, "warningIconColor", A("palette-warning-main")), tt(M.AppBar, "defaultBg", A("palette-grey-900")), tt(M.AppBar, "darkBg", A("palette-background-paper")), tt(M.AppBar, "darkColor", A("palette-text-primary")), tt(M.Avatar, "defaultBg", A("palette-grey-600")), tt(M.Button, "inheritContainedBg", A("palette-grey-800")), tt(M.Button, "inheritContainedHoverBg", A("palette-grey-700")), tt(M.Chip, "defaultBorder", A("palette-grey-700")), tt(M.Chip, "defaultAvatarColor", A("palette-grey-300")), tt(M.Chip, "defaultIconColor", A("palette-grey-300")), tt(M.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), tt(M.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), tt(M.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), tt(M.LinearProgress, "primaryBg", Cr(M.primary.main, 0.5)), tt(M.LinearProgress, "secondaryBg", Cr(M.secondary.main, 0.5)), tt(M.LinearProgress, "errorBg", Cr(M.error.main, 0.5)), tt(M.LinearProgress, "infoBg", Cr(M.info.main, 0.5)), tt(M.LinearProgress, "successBg", Cr(M.success.main, 0.5)), tt(M.LinearProgress, "warningBg", Cr(M.warning.main, 0.5)), tt(M.Skeleton, "bg", `rgba(${A("palette-text-primaryChannel")} / 0.13)`), tt(M.Slider, "primaryTrack", Cr(M.primary.main, 0.5)), tt(M.Slider, "secondaryTrack", Cr(M.secondary.main, 0.5)), tt(M.Slider, "errorTrack", Cr(M.error.main, 0.5)), tt(M.Slider, "infoTrack", Cr(M.info.main, 0.5)), tt(M.Slider, "successTrack", Cr(M.success.main, 0.5)), tt(M.Slider, "warningTrack", Cr(M.warning.main, 0.5));
      const W = Nb(M.background.default, 0.98);
      tt(M.SnackbarContent, "bg", W), tt(M.SnackbarContent, "color", Ns(() => k.getContrastText(W))), tt(M.SpeedDialAction, "fabHoverBg", Nb(M.background.paper, 0.15)), tt(M.StepConnector, "border", A("palette-grey-600")), tt(M.StepContent, "border", A("palette-grey-600")), tt(M.Switch, "defaultColor", A("palette-grey-300")), tt(M.Switch, "defaultDisabledColor", A("palette-grey-600")), tt(M.Switch, "primaryDisabledColor", Cr(M.primary.main, 0.55)), tt(M.Switch, "secondaryDisabledColor", Cr(M.secondary.main, 0.55)), tt(M.Switch, "errorDisabledColor", Cr(M.error.main, 0.55)), tt(M.Switch, "infoDisabledColor", Cr(M.info.main, 0.55)), tt(M.Switch, "successDisabledColor", Cr(M.success.main, 0.55)), tt(M.Switch, "warningDisabledColor", Cr(M.warning.main, 0.55)), tt(M.TableCell, "border", Cr(zS(M.divider, 1), 0.68)), tt(M.Tooltip, "bg", zS(M.grey[700], 0.92));
    }
    Yu(M.background, "default"), Yu(M.common, "background"), Yu(M.common, "onBackground"), Yu(M, "divider"), Object.keys(M).forEach((W) => {
      const Y = M[W];
      Y && typeof Y == "object" && (Y.main && tt(M[W], "mainChannel", Ib(Y.main)), Y.light && tt(M[W], "lightChannel", Ib(Y.light)), Y.dark && tt(M[W], "darkChannel", Ib(Y.dark)), Y.contrastText && tt(M[W], "contrastTextChannel", Ib(Y.contrastText)), W === "text" && (Yu(M[W], "primary"), Yu(M[W], "secondary")), W === "action" && (Y.active && Yu(M[W], "active"), Y.selected && Yu(M[W], "selected")));
    });
  }), I = t.reduce((V, M) => So(V, M), I);
  const $ = {
    prefix: v,
    shouldSkipGeneratingVar: b
  }, {
    vars: _,
    generateCssVars: z
  } = J7(I, $);
  return I.vars = _, I.generateCssVars = z, I.shouldSkipGeneratingVar = b, I.unstable_sxConfig = S({}, Cy, x == null ? void 0 : x.unstable_sxConfig), I.unstable_sx = function(M) {
    return jh({
      sx: M,
      theme: this
    });
  }, I;
}
const aK = (e) => [...[...Array(24)].map((t, o) => `--${e ? `${e}-` : ""}overlays-${o + 1}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], iK = aK, lK = oK(), {
  CssVarsProvider: ESe,
  useColorScheme: TSe,
  getInitColorSchemeScript: OSe
} = q7({
  themeId: pd,
  theme: lK,
  attribute: "data-mui-color-scheme",
  modeStorageKey: "mui-mode",
  colorSchemeStorageKey: "mui-color-scheme",
  defaultColorScheme: {
    light: "light",
    dark: "dark"
  },
  resolveTheme: (e) => {
    const t = S({}, e, {
      typography: VL(e.palette, e.typography)
    });
    return t.unstable_sx = function(i) {
      return jh({
        sx: i,
        theme: this
      });
    }, t;
  },
  excludeVariablesFromRoot: iK
});
function RSe() {
  throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `experimental_sx` has been moved to `theme.unstable_sx`.For more details, see https://github.com/mui/material-ui/pull/35150." : gi(20));
}
function sK(e) {
  return ot("MuiAccordionActions", e);
}
const cK = lt("MuiAccordionActions", ["root", "spacing"]), kSe = cK, uK = ["className", "disableSpacing"], dK = (e) => {
  const {
    classes: t,
    disableSpacing: o
  } = e;
  return je({
    root: ["root", !o && "spacing"]
  }, sK, t);
}, fK = se("div", {
  name: "MuiAccordionActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end"
}, !e.disableSpacing && {
  "& > :not(:first-of-type)": {
    marginLeft: 8
  }
})), nF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAccordionActions"
  }), {
    className: s,
    disableSpacing: c = !1
  } = i, f = pe(i, uK), m = S({}, i, {
    disableSpacing: c
  }), h = dK(m);
  return /* @__PURE__ */ L(fK, S({
    className: be(h.root, s),
    ref: o,
    ownerState: m
  }, f));
});
process.env.NODE_ENV !== "production" && (nF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const PSe = nF;
function pK(e) {
  return ot("MuiAlert", e);
}
const mK = lt("MuiAlert", ["root", "action", "icon", "message", "filled", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]), tD = mK;
function hK(e) {
  return ot("MuiIconButton", e);
}
const gK = lt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), vK = gK, bK = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], yK = (e) => {
  const {
    classes: t,
    disabled: o,
    color: i,
    edge: s,
    size: c
  } = e, f = {
    root: ["root", o && "disabled", i !== "default" && `color${ve(i)}`, s && `edge${ve(s)}`, `size${ve(c)}`]
  };
  return je(f, hK, t);
}, CK = se(Ao, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "default" && t[`color${ve(o.color)}`], o.edge && t[`edge${ve(o.edge)}`], t[`size${ve(o.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var o;
  const i = (o = (e.vars || e).palette) == null ? void 0 : o[t.color];
  return S({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && S({
    color: i == null ? void 0 : i.main
  }, !t.disableRipple && {
    "&:hover": S({}, i && {
      backgroundColor: e.vars ? `rgba(${i.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(i.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${vK.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), rF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: c,
    className: f,
    color: m = "default",
    disabled: h = !1,
    disableFocusRipple: v = !1,
    size: b = "medium"
  } = i, x = pe(i, bK), E = S({}, i, {
    edge: s,
    color: m,
    disabled: h,
    disableFocusRipple: v,
    size: b
  }), T = yK(E);
  return /* @__PURE__ */ L(CK, S({
    className: be(T.root, f),
    centerRipple: !0,
    focusRipple: !v,
    disabled: h,
    ref: o,
    ownerState: E
  }, x, {
    children: c
  }));
});
process.env.NODE_ENV !== "production" && (rF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The icon to display.
   */
  children: co(n.node, (e) => C.Children.toArray(e.children).some((o) => /* @__PURE__ */ C.isValidElement(o) && o.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const As = rF, SK = rn(/* @__PURE__ */ L("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), xK = rn(/* @__PURE__ */ L("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), wK = rn(/* @__PURE__ */ L("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), EK = rn(/* @__PURE__ */ L("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), oF = rn(/* @__PURE__ */ L("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), TK = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], OK = (e) => {
  const {
    variant: t,
    color: o,
    severity: i,
    classes: s
  } = e, c = {
    root: ["root", `${t}${ve(o || i)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return je(c, pK, s);
}, RK = se(Ci, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`${o.variant}${ve(o.color || o.severity)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const o = e.palette.mode === "light" ? Wl : ql, i = e.palette.mode === "light" ? ql : Wl, s = t.color || t.severity;
  return S({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px"
  }, s && t.variant === "standard" && {
    color: e.vars ? e.vars.palette.Alert[`${s}Color`] : o(e.palette[s].light, 0.6),
    backgroundColor: e.vars ? e.vars.palette.Alert[`${s}StandardBg`] : i(e.palette[s].light, 0.9),
    [`& .${tD.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${s}IconColor`]
    } : {
      color: e.palette[s].main
    }
  }, s && t.variant === "outlined" && {
    color: e.vars ? e.vars.palette.Alert[`${s}Color`] : o(e.palette[s].light, 0.6),
    border: `1px solid ${(e.vars || e).palette[s].light}`,
    [`& .${tD.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${s}IconColor`]
    } : {
      color: e.palette[s].main
    }
  }, s && t.variant === "filled" && S({
    fontWeight: e.typography.fontWeightMedium
  }, e.vars ? {
    color: e.vars.palette.Alert[`${s}FilledColor`],
    backgroundColor: e.vars.palette.Alert[`${s}FilledBg`]
  } : {
    backgroundColor: e.palette.mode === "dark" ? e.palette[s].dark : e.palette[s].main,
    color: e.palette.getContrastText(e.palette[s].main)
  }));
}), kK = se("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), PK = se("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), nD = se("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), rD = {
  success: /* @__PURE__ */ L(SK, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ L(xK, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ L(wK, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ L(EK, {
    fontSize: "inherit"
  })
}, aF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h;
  const v = dt({
    props: t,
    name: "MuiAlert"
  }), {
    action: b,
    children: x,
    className: E,
    closeText: T = "Close",
    color: P,
    components: O = {},
    componentsProps: k = {},
    icon: I,
    iconMapping: $ = rD,
    onClose: _,
    role: z = "alert",
    severity: V = "success",
    slotProps: M = {},
    slots: A = {},
    variant: W = "standard"
  } = v, Y = pe(v, TK), H = S({}, v, {
    color: P,
    severity: V,
    variant: W
  }), G = OK(H), ne = (i = (s = A.closeButton) != null ? s : O.CloseButton) != null ? i : As, K = (c = (f = A.closeIcon) != null ? f : O.CloseIcon) != null ? c : oF, B = (m = M.closeButton) != null ? m : k.closeButton, q = (h = M.closeIcon) != null ? h : k.closeIcon;
  return /* @__PURE__ */ ht(RK, S({
    role: z,
    elevation: 0,
    ownerState: H,
    className: be(G.root, E),
    ref: o
  }, Y, {
    children: [I !== !1 ? /* @__PURE__ */ L(kK, {
      ownerState: H,
      className: G.icon,
      children: I || $[V] || rD[V]
    }) : null, /* @__PURE__ */ L(PK, {
      ownerState: H,
      className: G.message,
      children: x
    }), b != null ? /* @__PURE__ */ L(nD, {
      ownerState: H,
      className: G.action,
      children: b
    }) : null, b == null && _ ? /* @__PURE__ */ L(nD, {
      ownerState: H,
      className: G.action,
      children: /* @__PURE__ */ L(ne, S({
        size: "small",
        "aria-label": T,
        title: T,
        color: "inherit",
        onClick: _
      }, B, {
        children: /* @__PURE__ */ L(K, S({
          fontSize: "small"
        }, q))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (aF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: n.node,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: n.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "success", "warning"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    CloseButton: n.elementType,
    CloseIcon: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    closeButton: n.object,
    closeIcon: n.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: n.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: n.shape({
    error: n.node,
    info: n.node,
    success: n.node,
    warning: n.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: n.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: n.oneOf(["error", "info", "success", "warning"]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    closeButton: n.object,
    closeIcon: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    closeButton: n.elementType,
    closeIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined", "standard"]), n.string])
});
const MK = aF;
function IK(e) {
  return ot("MuiTypography", e);
}
const NK = lt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), MSe = NK, $K = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], DK = (e) => {
  const {
    align: t,
    gutterBottom: o,
    noWrap: i,
    paragraph: s,
    variant: c,
    classes: f
  } = e, m = {
    root: ["root", c, e.align !== "inherit" && `align${ve(t)}`, o && "gutterBottom", i && "noWrap", s && "paragraph"]
  };
  return je(m, IK, f);
}, _K = se("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.variant && t[o.variant], o.align !== "inherit" && t[`align${ve(o.align)}`], o.noWrap && t.noWrap, o.gutterBottom && t.gutterBottom, o.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), oD = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, AK = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, LK = (e) => AK[e] || e, iF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTypography"
  }), s = LK(i.color), c = xy(S({}, i, {
    color: s
  })), {
    align: f = "inherit",
    className: m,
    component: h,
    gutterBottom: v = !1,
    noWrap: b = !1,
    paragraph: x = !1,
    variant: E = "body1",
    variantMapping: T = oD
  } = c, P = pe(c, $K), O = S({}, c, {
    align: f,
    color: s,
    className: m,
    component: h,
    gutterBottom: v,
    noWrap: b,
    paragraph: x,
    variant: E,
    variantMapping: T
  }), k = h || (x ? "p" : T[E] || oD[E]) || "span", I = DK(O);
  return /* @__PURE__ */ L(_K, S({
    as: k,
    ref: o,
    ownerState: O,
    className: be(I.root, m)
  }, P));
});
process.env.NODE_ENV !== "production" && (iF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: n.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: n.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: n.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: n.oneOfType([n.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), n.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: n.object
});
const Ea = iF;
function FK(e) {
  return ot("MuiAlertTitle", e);
}
const zK = lt("MuiAlertTitle", ["root"]), ISe = zK, VK = ["className"], BK = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, FK, t);
}, jK = se(Ea, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  fontWeight: e.typography.fontWeightMedium,
  marginTop: -2
})), lF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAlertTitle"
  }), {
    className: s
  } = i, c = pe(i, VK), f = i, m = BK(f);
  return /* @__PURE__ */ L(jK, S({
    gutterBottom: !0,
    component: "div",
    ownerState: f,
    ref: o,
    className: be(m.root, s)
  }, c));
});
process.env.NODE_ENV !== "production" && (lF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const HK = lF;
function UK(e) {
  return ot("MuiAppBar", e);
}
const GK = lt("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent"]), NSe = GK, WK = ["className", "color", "enableColorOnDark", "position"], qK = (e) => {
  const {
    color: t,
    position: o,
    classes: i
  } = e, s = {
    root: ["root", `color${ve(t)}`, `position${ve(o)}`]
  };
  return je(s, UK, i);
}, HS = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, YK = se(Ci, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`position${ve(o.position)}`], t[`color${ve(o.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const o = e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[900];
  return S({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, t.position === "fixed" && {
    position: "fixed",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0,
    "@media print": {
      // Prevent the app bar to be visible on each printed page.
      position: "absolute"
    }
  }, t.position === "absolute" && {
    position: "absolute",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "sticky" && {
    // ⚠️ sticky is not supported by IE11.
    position: "sticky",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "static" && {
    position: "static"
  }, t.position === "relative" && {
    position: "relative"
  }, !e.vars && S({}, t.color === "default" && {
    backgroundColor: o,
    color: e.palette.getContrastText(o)
  }, t.color && t.color !== "default" && t.color !== "inherit" && t.color !== "transparent" && {
    backgroundColor: e.palette[t.color].main,
    color: e.palette[t.color].contrastText
  }, t.color === "inherit" && {
    color: "inherit"
  }, e.palette.mode === "dark" && !t.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, t.color === "transparent" && S({
    backgroundColor: "transparent",
    color: "inherit"
  }, e.palette.mode === "dark" && {
    backgroundImage: "none"
  })), e.vars && S({}, t.color === "default" && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette.AppBar.defaultBg : HS(e.vars.palette.AppBar.darkBg, e.vars.palette.AppBar.defaultBg),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette.text.primary : HS(e.vars.palette.AppBar.darkColor, e.vars.palette.text.primary)
  }, t.color && !t.color.match(/^(default|inherit|transparent)$/) && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette[t.color].main : HS(e.vars.palette.AppBar.darkBg, e.vars.palette[t.color].main),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette[t.color].contrastText : HS(e.vars.palette.AppBar.darkColor, e.vars.palette[t.color].contrastText)
  }, {
    backgroundColor: "var(--AppBar-background)",
    color: t.color === "inherit" ? "inherit" : "var(--AppBar-color)"
  }, t.color === "transparent" && {
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "inherit"
  }));
}), sF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAppBar"
  }), {
    className: s,
    color: c = "primary",
    enableColorOnDark: f = !1,
    position: m = "fixed"
  } = i, h = pe(i, WK), v = S({}, i, {
    color: c,
    position: m,
    enableColorOnDark: f
  }), b = qK(v);
  return /* @__PURE__ */ L(YK, S({
    square: !0,
    component: "header",
    ownerState: v,
    elevation: 4,
    className: be(b.root, s, m === "fixed" && "mui-fixed"),
    ref: o
  }, h));
});
process.env.NODE_ENV !== "production" && (sF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "inherit", "primary", "secondary", "transparent"]), n.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: n.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: n.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const $Se = sF;
function Ul(e) {
  return typeof e == "string";
}
function Db(e, t, o) {
  return e === void 0 || Ul(e) ? t : S({}, t, {
    ownerState: S({}, t.ownerState, o)
  });
}
function KK(e, t, o = (i, s) => i === s) {
  return e.length === t.length && e.every((i, s) => o(i, t[s]));
}
const XK = {
  disableDefaultClasses: !1
}, QK = /* @__PURE__ */ C.createContext(XK);
function ZK(e) {
  const {
    disableDefaultClasses: t
  } = C.useContext(QK);
  return (o) => t ? "" : e(o);
}
function $1(e, t = []) {
  if (e === void 0)
    return {};
  const o = {};
  return Object.keys(e).filter((i) => i.match(/^on[A-Z]/) && typeof e[i] == "function" && !t.includes(i)).forEach((i) => {
    o[i] = e[i];
  }), o;
}
function JK(e, t, o) {
  return typeof e == "function" ? e(t, o) : e;
}
function aD(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((o) => !(o.match(/^on[A-Z]/) && typeof e[o] == "function")).forEach((o) => {
    t[o] = e[o];
  }), t;
}
function eX(e) {
  const {
    getSlotProps: t,
    additionalProps: o,
    externalSlotProps: i,
    externalForwardedProps: s,
    className: c
  } = e;
  if (!t) {
    const T = be(s == null ? void 0 : s.className, i == null ? void 0 : i.className, c, o == null ? void 0 : o.className), P = S({}, o == null ? void 0 : o.style, s == null ? void 0 : s.style, i == null ? void 0 : i.style), O = S({}, o, s, i);
    return T.length > 0 && (O.className = T), Object.keys(P).length > 0 && (O.style = P), {
      props: O,
      internalRef: void 0
    };
  }
  const f = $1(S({}, s, i)), m = aD(i), h = aD(s), v = t(f), b = be(v == null ? void 0 : v.className, o == null ? void 0 : o.className, c, s == null ? void 0 : s.className, i == null ? void 0 : i.className), x = S({}, v == null ? void 0 : v.style, o == null ? void 0 : o.style, s == null ? void 0 : s.style, i == null ? void 0 : i.style), E = S({}, v, o, h, m);
  return b.length > 0 && (E.className = b), Object.keys(x).length > 0 && (E.style = x), {
    props: E,
    internalRef: v.ref
  };
}
const tX = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Gr(e) {
  var t;
  const {
    elementType: o,
    externalSlotProps: i,
    ownerState: s,
    skipResolvingSlotProps: c = !1
  } = e, f = pe(e, tX), m = c ? {} : JK(i, s), {
    props: h,
    internalRef: v
  } = eX(S({}, f, {
    externalSlotProps: m
  })), b = Cn(v, m == null ? void 0 : m.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return Db(o, S({}, h, {
    ref: b
  }), s);
}
function nX(e) {
  const {
    badgeContent: t,
    invisible: o = !1,
    max: i = 99,
    showZero: s = !1
  } = e, c = yk({
    badgeContent: t,
    max: i
  });
  let f = o;
  o === !1 && t === 0 && !s && (f = !0);
  const {
    badgeContent: m,
    max: h = i
  } = f ? c : e, v = m && Number(m) > h ? `${h}+` : m;
  return {
    badgeContent: m,
    invisible: f,
    max: h,
    displayValue: v
  };
}
function iD(e) {
  return e.substring(2).toLowerCase();
}
function rX(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function $h(e) {
  const {
    children: t,
    disableReactTree: o = !1,
    mouseEvent: i = "onClick",
    onClickAway: s,
    touchEvent: c = "onTouchEnd"
  } = e, f = C.useRef(!1), m = C.useRef(null), h = C.useRef(!1), v = C.useRef(!1);
  C.useEffect(() => (setTimeout(() => {
    h.current = !0;
  }, 0), () => {
    h.current = !1;
  }), []);
  const b = Cn(
    // @ts-expect-error TODO upstream fix
    t.ref,
    m
  ), x = zn((P) => {
    const O = v.current;
    v.current = !1;
    const k = qn(m.current);
    if (!h.current || !m.current || "clientX" in P && rX(P, k))
      return;
    if (f.current) {
      f.current = !1;
      return;
    }
    let I;
    P.composedPath ? I = P.composedPath().indexOf(m.current) > -1 : I = !k.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      P.target
    ) || m.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      P.target
    ), !I && (o || !O) && s(P);
  }), E = (P) => (O) => {
    v.current = !0;
    const k = t.props[P];
    k && k(O);
  }, T = {
    ref: b
  };
  return c !== !1 && (T[c] = E(c)), C.useEffect(() => {
    if (c !== !1) {
      const P = iD(c), O = qn(m.current), k = () => {
        f.current = !0;
      };
      return O.addEventListener(P, x), O.addEventListener("touchmove", k), () => {
        O.removeEventListener(P, x), O.removeEventListener("touchmove", k);
      };
    }
  }, [x, c]), i !== !1 && (T[i] = E(i)), C.useEffect(() => {
    if (i !== !1) {
      const P = iD(i), O = qn(m.current);
      return O.addEventListener(P, x), () => {
        O.removeEventListener(P, x);
      };
    }
  }, [x, i]), /* @__PURE__ */ L(C.Fragment, {
    children: /* @__PURE__ */ C.cloneElement(t, T)
  });
}
process.env.NODE_ENV !== "production" && ($h.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The wrapped element.
   */
  children: vd.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: n.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: n.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: n.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: n.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && ($h["propTypes"] = ip($h.propTypes));
const oX = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function aX(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function iX(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (i) => e.ownerDocument.querySelector(`input[type="radio"]${i}`);
  let o = t(`[name="${e.name}"]:checked`);
  return o || (o = t(`[name="${e.name}"]`)), o !== e;
}
function lX(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || iX(e));
}
function sX(e) {
  const t = [], o = [];
  return Array.from(e.querySelectorAll(oX)).forEach((i, s) => {
    const c = aX(i);
    c === -1 || !lX(i) || (c === 0 ? t.push(i) : o.push({
      documentOrder: s,
      tabIndex: c,
      node: i
    }));
  }), o.sort((i, s) => i.tabIndex === s.tabIndex ? i.documentOrder - s.documentOrder : i.tabIndex - s.tabIndex).map((i) => i.node).concat(t);
}
function cX() {
  return !0;
}
function ey(e) {
  const {
    children: t,
    disableAutoFocus: o = !1,
    disableEnforceFocus: i = !1,
    disableRestoreFocus: s = !1,
    getTabbable: c = sX,
    isEnabled: f = cX,
    open: m
  } = e, h = C.useRef(!1), v = C.useRef(null), b = C.useRef(null), x = C.useRef(null), E = C.useRef(null), T = C.useRef(!1), P = C.useRef(null), O = Cn(t.ref, P), k = C.useRef(null);
  C.useEffect(() => {
    !m || !P.current || (T.current = !o);
  }, [o, m]), C.useEffect(() => {
    if (!m || !P.current)
      return;
    const _ = qn(P.current);
    return P.current.contains(_.activeElement) || (P.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), P.current.setAttribute("tabIndex", "-1")), T.current && P.current.focus()), () => {
      s || (x.current && x.current.focus && (h.current = !0, x.current.focus()), x.current = null);
    };
  }, [m]), C.useEffect(() => {
    if (!m || !P.current)
      return;
    const _ = qn(P.current), z = (A) => {
      k.current = A, !(i || !f() || A.key !== "Tab") && _.activeElement === P.current && A.shiftKey && (h.current = !0, b.current && b.current.focus());
    }, V = () => {
      const A = P.current;
      if (A === null)
        return;
      if (!_.hasFocus() || !f() || h.current) {
        h.current = !1;
        return;
      }
      if (A.contains(_.activeElement) || i && _.activeElement !== v.current && _.activeElement !== b.current)
        return;
      if (_.activeElement !== E.current)
        E.current = null;
      else if (E.current !== null)
        return;
      if (!T.current)
        return;
      let W = [];
      if ((_.activeElement === v.current || _.activeElement === b.current) && (W = c(P.current)), W.length > 0) {
        var Y, H;
        const G = !!((Y = k.current) != null && Y.shiftKey && ((H = k.current) == null ? void 0 : H.key) === "Tab"), ne = W[0], K = W[W.length - 1];
        typeof ne != "string" && typeof K != "string" && (G ? K.focus() : ne.focus());
      } else
        A.focus();
    };
    _.addEventListener("focusin", V), _.addEventListener("keydown", z, !0);
    const M = setInterval(() => {
      _.activeElement && _.activeElement.tagName === "BODY" && V();
    }, 50);
    return () => {
      clearInterval(M), _.removeEventListener("focusin", V), _.removeEventListener("keydown", z, !0);
    };
  }, [o, i, s, f, m, c]);
  const I = (_) => {
    x.current === null && (x.current = _.relatedTarget), T.current = !0, E.current = _.target;
    const z = t.props.onFocus;
    z && z(_);
  }, $ = (_) => {
    x.current === null && (x.current = _.relatedTarget), T.current = !0;
  };
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L("div", {
      tabIndex: m ? 0 : -1,
      onFocus: $,
      ref: v,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ C.cloneElement(t, {
      ref: O,
      onFocus: I
    }), /* @__PURE__ */ L("div", {
      tabIndex: m ? 0 : -1,
      onFocus: $,
      ref: b,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (ey.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: vd,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: n.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: n.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: n.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: n.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: n.func,
  /**
   * If `true`, focus is locked.
   */
  open: n.bool.isRequired
});
process.env.NODE_ENV !== "production" && (ey["propTypes"] = ip(ey.propTypes));
var mi = "top", ll = "bottom", sl = "right", hi = "left", Gk = "auto", Ry = [mi, ll, sl, hi], Dh = "start", ty = "end", uX = "clippingParents", cF = "viewport", yb = "popper", dX = "reference", lD = /* @__PURE__ */ Ry.reduce(function(e, t) {
  return e.concat([t + "-" + Dh, t + "-" + ty]);
}, []), uF = /* @__PURE__ */ [].concat(Ry, [Gk]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Dh, t + "-" + ty]);
}, []), fX = "beforeRead", pX = "read", mX = "afterRead", hX = "beforeMain", gX = "main", vX = "afterMain", bX = "beforeWrite", yX = "write", CX = "afterWrite", SX = [fX, pX, mX, hX, gX, vX, bX, yX, CX];
function Hs(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Li(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function tp(e) {
  var t = Li(e).Element;
  return e instanceof t || e instanceof Element;
}
function ol(e) {
  var t = Li(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Wk(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Li(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xX(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(o) {
    var i = t.styles[o] || {}, s = t.attributes[o] || {}, c = t.elements[o];
    !ol(c) || !Hs(c) || (Object.assign(c.style, i), Object.keys(s).forEach(function(f) {
      var m = s[f];
      m === !1 ? c.removeAttribute(f) : c.setAttribute(f, m === !0 ? "" : m);
    }));
  });
}
function wX(e) {
  var t = e.state, o = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, o.popper), t.styles = o, t.elements.arrow && Object.assign(t.elements.arrow.style, o.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var s = t.elements[i], c = t.attributes[i] || {}, f = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : o[i]), m = f.reduce(function(h, v) {
        return h[v] = "", h;
      }, {});
      !ol(s) || !Hs(s) || (Object.assign(s.style, m), Object.keys(c).forEach(function(h) {
        s.removeAttribute(h);
      }));
    });
  };
}
const EX = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xX,
  effect: wX,
  requires: ["computeStyles"]
};
function zs(e) {
  return e.split("-")[0];
}
var qf = Math.max, D1 = Math.min, _h = Math.round;
function DR() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function dF() {
  return !/^((?!chrome|android).)*safari/i.test(DR());
}
function Ah(e, t, o) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  var i = e.getBoundingClientRect(), s = 1, c = 1;
  t && ol(e) && (s = e.offsetWidth > 0 && _h(i.width) / e.offsetWidth || 1, c = e.offsetHeight > 0 && _h(i.height) / e.offsetHeight || 1);
  var f = tp(e) ? Li(e) : window, m = f.visualViewport, h = !dF() && o, v = (i.left + (h && m ? m.offsetLeft : 0)) / s, b = (i.top + (h && m ? m.offsetTop : 0)) / c, x = i.width / s, E = i.height / c;
  return {
    width: x,
    height: E,
    top: b,
    right: v + x,
    bottom: b + E,
    left: v,
    x: v,
    y: b
  };
}
function qk(e) {
  var t = Ah(e), o = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - o) <= 1 && (o = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: o,
    height: i
  };
}
function fF(e, t) {
  var o = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (o && Wk(o)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function Hc(e) {
  return Li(e).getComputedStyle(e);
}
function TX(e) {
  return ["table", "td", "th"].indexOf(Hs(e)) >= 0;
}
function yd(e) {
  return ((tp(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ox(e) {
  return Hs(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Wk(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    yd(e)
  );
}
function sD(e) {
  return !ol(e) || // https://github.com/popperjs/popper-core/issues/837
  Hc(e).position === "fixed" ? null : e.offsetParent;
}
function OX(e) {
  var t = /firefox/i.test(DR()), o = /Trident/i.test(DR());
  if (o && ol(e)) {
    var i = Hc(e);
    if (i.position === "fixed")
      return null;
  }
  var s = Ox(e);
  for (Wk(s) && (s = s.host); ol(s) && ["html", "body"].indexOf(Hs(s)) < 0; ) {
    var c = Hc(s);
    if (c.transform !== "none" || c.perspective !== "none" || c.contain === "paint" || ["transform", "perspective"].indexOf(c.willChange) !== -1 || t && c.willChange === "filter" || t && c.filter && c.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function ky(e) {
  for (var t = Li(e), o = sD(e); o && TX(o) && Hc(o).position === "static"; )
    o = sD(o);
  return o && (Hs(o) === "html" || Hs(o) === "body" && Hc(o).position === "static") ? t : o || OX(e) || t;
}
function Yk(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function jb(e, t, o) {
  return qf(e, D1(t, o));
}
function RX(e, t, o) {
  var i = jb(e, t, o);
  return i > o ? o : i;
}
function pF() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mF(e) {
  return Object.assign({}, pF(), e);
}
function hF(e, t) {
  return t.reduce(function(o, i) {
    return o[i] = e, o;
  }, {});
}
var kX = function(t, o) {
  return t = typeof t == "function" ? t(Object.assign({}, o.rects, {
    placement: o.placement
  })) : t, mF(typeof t != "number" ? t : hF(t, Ry));
};
function PX(e) {
  var t, o = e.state, i = e.name, s = e.options, c = o.elements.arrow, f = o.modifiersData.popperOffsets, m = zs(o.placement), h = Yk(m), v = [hi, sl].indexOf(m) >= 0, b = v ? "height" : "width";
  if (!(!c || !f)) {
    var x = kX(s.padding, o), E = qk(c), T = h === "y" ? mi : hi, P = h === "y" ? ll : sl, O = o.rects.reference[b] + o.rects.reference[h] - f[h] - o.rects.popper[b], k = f[h] - o.rects.reference[h], I = ky(c), $ = I ? h === "y" ? I.clientHeight || 0 : I.clientWidth || 0 : 0, _ = O / 2 - k / 2, z = x[T], V = $ - E[b] - x[P], M = $ / 2 - E[b] / 2 + _, A = jb(z, M, V), W = h;
    o.modifiersData[i] = (t = {}, t[W] = A, t.centerOffset = A - M, t);
  }
}
function MX(e) {
  var t = e.state, o = e.options, i = o.element, s = i === void 0 ? "[data-popper-arrow]" : i;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || fF(t.elements.popper, s) && (t.elements.arrow = s));
}
const IX = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: PX,
  effect: MX,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Lh(e) {
  return e.split("-")[1];
}
var NX = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function $X(e, t) {
  var o = e.x, i = e.y, s = t.devicePixelRatio || 1;
  return {
    x: _h(o * s) / s || 0,
    y: _h(i * s) / s || 0
  };
}
function cD(e) {
  var t, o = e.popper, i = e.popperRect, s = e.placement, c = e.variation, f = e.offsets, m = e.position, h = e.gpuAcceleration, v = e.adaptive, b = e.roundOffsets, x = e.isFixed, E = f.x, T = E === void 0 ? 0 : E, P = f.y, O = P === void 0 ? 0 : P, k = typeof b == "function" ? b({
    x: T,
    y: O
  }) : {
    x: T,
    y: O
  };
  T = k.x, O = k.y;
  var I = f.hasOwnProperty("x"), $ = f.hasOwnProperty("y"), _ = hi, z = mi, V = window;
  if (v) {
    var M = ky(o), A = "clientHeight", W = "clientWidth";
    if (M === Li(o) && (M = yd(o), Hc(M).position !== "static" && m === "absolute" && (A = "scrollHeight", W = "scrollWidth")), M = M, s === mi || (s === hi || s === sl) && c === ty) {
      z = ll;
      var Y = x && M === V && V.visualViewport ? V.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[A]
      );
      O -= Y - i.height, O *= h ? 1 : -1;
    }
    if (s === hi || (s === mi || s === ll) && c === ty) {
      _ = sl;
      var H = x && M === V && V.visualViewport ? V.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[W]
      );
      T -= H - i.width, T *= h ? 1 : -1;
    }
  }
  var G = Object.assign({
    position: m
  }, v && NX), ne = b === !0 ? $X({
    x: T,
    y: O
  }, Li(o)) : {
    x: T,
    y: O
  };
  if (T = ne.x, O = ne.y, h) {
    var K;
    return Object.assign({}, G, (K = {}, K[z] = $ ? "0" : "", K[_] = I ? "0" : "", K.transform = (V.devicePixelRatio || 1) <= 1 ? "translate(" + T + "px, " + O + "px)" : "translate3d(" + T + "px, " + O + "px, 0)", K));
  }
  return Object.assign({}, G, (t = {}, t[z] = $ ? O + "px" : "", t[_] = I ? T + "px" : "", t.transform = "", t));
}
function DX(e) {
  var t = e.state, o = e.options, i = o.gpuAcceleration, s = i === void 0 ? !0 : i, c = o.adaptive, f = c === void 0 ? !0 : c, m = o.roundOffsets, h = m === void 0 ? !0 : m, v = {
    placement: zs(t.placement),
    variation: Lh(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, cD(Object.assign({}, v, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: f,
    roundOffsets: h
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, cD(Object.assign({}, v, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: h
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const _X = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: DX,
  data: {}
};
var US = {
  passive: !0
};
function AX(e) {
  var t = e.state, o = e.instance, i = e.options, s = i.scroll, c = s === void 0 ? !0 : s, f = i.resize, m = f === void 0 ? !0 : f, h = Li(t.elements.popper), v = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return c && v.forEach(function(b) {
    b.addEventListener("scroll", o.update, US);
  }), m && h.addEventListener("resize", o.update, US), function() {
    c && v.forEach(function(b) {
      b.removeEventListener("scroll", o.update, US);
    }), m && h.removeEventListener("resize", o.update, US);
  };
}
const LX = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: AX,
  data: {}
};
var FX = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function y1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return FX[t];
  });
}
var zX = {
  start: "end",
  end: "start"
};
function uD(e) {
  return e.replace(/start|end/g, function(t) {
    return zX[t];
  });
}
function Kk(e) {
  var t = Li(e), o = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: o,
    scrollTop: i
  };
}
function Xk(e) {
  return Ah(yd(e)).left + Kk(e).scrollLeft;
}
function VX(e, t) {
  var o = Li(e), i = yd(e), s = o.visualViewport, c = i.clientWidth, f = i.clientHeight, m = 0, h = 0;
  if (s) {
    c = s.width, f = s.height;
    var v = dF();
    (v || !v && t === "fixed") && (m = s.offsetLeft, h = s.offsetTop);
  }
  return {
    width: c,
    height: f,
    x: m + Xk(e),
    y: h
  };
}
function BX(e) {
  var t, o = yd(e), i = Kk(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, c = qf(o.scrollWidth, o.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), f = qf(o.scrollHeight, o.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), m = -i.scrollLeft + Xk(e), h = -i.scrollTop;
  return Hc(s || o).direction === "rtl" && (m += qf(o.clientWidth, s ? s.clientWidth : 0) - c), {
    width: c,
    height: f,
    x: m,
    y: h
  };
}
function Qk(e) {
  var t = Hc(e), o = t.overflow, i = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(o + s + i);
}
function gF(e) {
  return ["html", "body", "#document"].indexOf(Hs(e)) >= 0 ? e.ownerDocument.body : ol(e) && Qk(e) ? e : gF(Ox(e));
}
function Hb(e, t) {
  var o;
  t === void 0 && (t = []);
  var i = gF(e), s = i === ((o = e.ownerDocument) == null ? void 0 : o.body), c = Li(i), f = s ? [c].concat(c.visualViewport || [], Qk(i) ? i : []) : i, m = t.concat(f);
  return s ? m : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    m.concat(Hb(Ox(f)))
  );
}
function _R(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function jX(e, t) {
  var o = Ah(e, !1, t === "fixed");
  return o.top = o.top + e.clientTop, o.left = o.left + e.clientLeft, o.bottom = o.top + e.clientHeight, o.right = o.left + e.clientWidth, o.width = e.clientWidth, o.height = e.clientHeight, o.x = o.left, o.y = o.top, o;
}
function dD(e, t, o) {
  return t === cF ? _R(VX(e, o)) : tp(t) ? jX(t, o) : _R(BX(yd(e)));
}
function HX(e) {
  var t = Hb(Ox(e)), o = ["absolute", "fixed"].indexOf(Hc(e).position) >= 0, i = o && ol(e) ? ky(e) : e;
  return tp(i) ? t.filter(function(s) {
    return tp(s) && fF(s, i) && Hs(s) !== "body";
  }) : [];
}
function UX(e, t, o, i) {
  var s = t === "clippingParents" ? HX(e) : [].concat(t), c = [].concat(s, [o]), f = c[0], m = c.reduce(function(h, v) {
    var b = dD(e, v, i);
    return h.top = qf(b.top, h.top), h.right = D1(b.right, h.right), h.bottom = D1(b.bottom, h.bottom), h.left = qf(b.left, h.left), h;
  }, dD(e, f, i));
  return m.width = m.right - m.left, m.height = m.bottom - m.top, m.x = m.left, m.y = m.top, m;
}
function vF(e) {
  var t = e.reference, o = e.element, i = e.placement, s = i ? zs(i) : null, c = i ? Lh(i) : null, f = t.x + t.width / 2 - o.width / 2, m = t.y + t.height / 2 - o.height / 2, h;
  switch (s) {
    case mi:
      h = {
        x: f,
        y: t.y - o.height
      };
      break;
    case ll:
      h = {
        x: f,
        y: t.y + t.height
      };
      break;
    case sl:
      h = {
        x: t.x + t.width,
        y: m
      };
      break;
    case hi:
      h = {
        x: t.x - o.width,
        y: m
      };
      break;
    default:
      h = {
        x: t.x,
        y: t.y
      };
  }
  var v = s ? Yk(s) : null;
  if (v != null) {
    var b = v === "y" ? "height" : "width";
    switch (c) {
      case Dh:
        h[v] = h[v] - (t[b] / 2 - o[b] / 2);
        break;
      case ty:
        h[v] = h[v] + (t[b] / 2 - o[b] / 2);
        break;
    }
  }
  return h;
}
function ny(e, t) {
  t === void 0 && (t = {});
  var o = t, i = o.placement, s = i === void 0 ? e.placement : i, c = o.strategy, f = c === void 0 ? e.strategy : c, m = o.boundary, h = m === void 0 ? uX : m, v = o.rootBoundary, b = v === void 0 ? cF : v, x = o.elementContext, E = x === void 0 ? yb : x, T = o.altBoundary, P = T === void 0 ? !1 : T, O = o.padding, k = O === void 0 ? 0 : O, I = mF(typeof k != "number" ? k : hF(k, Ry)), $ = E === yb ? dX : yb, _ = e.rects.popper, z = e.elements[P ? $ : E], V = UX(tp(z) ? z : z.contextElement || yd(e.elements.popper), h, b, f), M = Ah(e.elements.reference), A = vF({
    reference: M,
    element: _,
    strategy: "absolute",
    placement: s
  }), W = _R(Object.assign({}, _, A)), Y = E === yb ? W : M, H = {
    top: V.top - Y.top + I.top,
    bottom: Y.bottom - V.bottom + I.bottom,
    left: V.left - Y.left + I.left,
    right: Y.right - V.right + I.right
  }, G = e.modifiersData.offset;
  if (E === yb && G) {
    var ne = G[s];
    Object.keys(H).forEach(function(K) {
      var B = [sl, ll].indexOf(K) >= 0 ? 1 : -1, q = [mi, ll].indexOf(K) >= 0 ? "y" : "x";
      H[K] += ne[q] * B;
    });
  }
  return H;
}
function GX(e, t) {
  t === void 0 && (t = {});
  var o = t, i = o.placement, s = o.boundary, c = o.rootBoundary, f = o.padding, m = o.flipVariations, h = o.allowedAutoPlacements, v = h === void 0 ? uF : h, b = Lh(i), x = b ? m ? lD : lD.filter(function(P) {
    return Lh(P) === b;
  }) : Ry, E = x.filter(function(P) {
    return v.indexOf(P) >= 0;
  });
  E.length === 0 && (E = x);
  var T = E.reduce(function(P, O) {
    return P[O] = ny(e, {
      placement: O,
      boundary: s,
      rootBoundary: c,
      padding: f
    })[zs(O)], P;
  }, {});
  return Object.keys(T).sort(function(P, O) {
    return T[P] - T[O];
  });
}
function WX(e) {
  if (zs(e) === Gk)
    return [];
  var t = y1(e);
  return [uD(e), t, uD(t)];
}
function qX(e) {
  var t = e.state, o = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var s = o.mainAxis, c = s === void 0 ? !0 : s, f = o.altAxis, m = f === void 0 ? !0 : f, h = o.fallbackPlacements, v = o.padding, b = o.boundary, x = o.rootBoundary, E = o.altBoundary, T = o.flipVariations, P = T === void 0 ? !0 : T, O = o.allowedAutoPlacements, k = t.options.placement, I = zs(k), $ = I === k, _ = h || ($ || !P ? [y1(k)] : WX(k)), z = [k].concat(_).reduce(function(de, Ce) {
      return de.concat(zs(Ce) === Gk ? GX(t, {
        placement: Ce,
        boundary: b,
        rootBoundary: x,
        padding: v,
        flipVariations: P,
        allowedAutoPlacements: O
      }) : Ce);
    }, []), V = t.rects.reference, M = t.rects.popper, A = /* @__PURE__ */ new Map(), W = !0, Y = z[0], H = 0; H < z.length; H++) {
      var G = z[H], ne = zs(G), K = Lh(G) === Dh, B = [mi, ll].indexOf(ne) >= 0, q = B ? "width" : "height", X = ny(t, {
        placement: G,
        boundary: b,
        rootBoundary: x,
        altBoundary: E,
        padding: v
      }), J = B ? K ? sl : hi : K ? ll : mi;
      V[q] > M[q] && (J = y1(J));
      var U = y1(J), Z = [];
      if (c && Z.push(X[ne] <= 0), m && Z.push(X[J] <= 0, X[U] <= 0), Z.every(function(de) {
        return de;
      })) {
        Y = G, W = !1;
        break;
      }
      A.set(G, Z);
    }
    if (W)
      for (var ee = P ? 3 : 1, ie = function(Ce) {
        var me = z.find(function(Oe) {
          var he = A.get(Oe);
          if (he)
            return he.slice(0, Ce).every(function($e) {
              return $e;
            });
        });
        if (me)
          return Y = me, "break";
      }, oe = ee; oe > 0; oe--) {
        var le = ie(oe);
        if (le === "break")
          break;
      }
    t.placement !== Y && (t.modifiersData[i]._skip = !0, t.placement = Y, t.reset = !0);
  }
}
const YX = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: qX,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function fD(e, t, o) {
  return o === void 0 && (o = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - o.y,
    right: e.right - t.width + o.x,
    bottom: e.bottom - t.height + o.y,
    left: e.left - t.width - o.x
  };
}
function pD(e) {
  return [mi, sl, ll, hi].some(function(t) {
    return e[t] >= 0;
  });
}
function KX(e) {
  var t = e.state, o = e.name, i = t.rects.reference, s = t.rects.popper, c = t.modifiersData.preventOverflow, f = ny(t, {
    elementContext: "reference"
  }), m = ny(t, {
    altBoundary: !0
  }), h = fD(f, i), v = fD(m, s, c), b = pD(h), x = pD(v);
  t.modifiersData[o] = {
    referenceClippingOffsets: h,
    popperEscapeOffsets: v,
    isReferenceHidden: b,
    hasPopperEscaped: x
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": b,
    "data-popper-escaped": x
  });
}
const XX = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: KX
};
function QX(e, t, o) {
  var i = zs(e), s = [hi, mi].indexOf(i) >= 0 ? -1 : 1, c = typeof o == "function" ? o(Object.assign({}, t, {
    placement: e
  })) : o, f = c[0], m = c[1];
  return f = f || 0, m = (m || 0) * s, [hi, sl].indexOf(i) >= 0 ? {
    x: m,
    y: f
  } : {
    x: f,
    y: m
  };
}
function ZX(e) {
  var t = e.state, o = e.options, i = e.name, s = o.offset, c = s === void 0 ? [0, 0] : s, f = uF.reduce(function(b, x) {
    return b[x] = QX(x, t.rects, c), b;
  }, {}), m = f[t.placement], h = m.x, v = m.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += h, t.modifiersData.popperOffsets.y += v), t.modifiersData[i] = f;
}
const JX = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: ZX
};
function eQ(e) {
  var t = e.state, o = e.name;
  t.modifiersData[o] = vF({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const tQ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: eQ,
  data: {}
};
function nQ(e) {
  return e === "x" ? "y" : "x";
}
function rQ(e) {
  var t = e.state, o = e.options, i = e.name, s = o.mainAxis, c = s === void 0 ? !0 : s, f = o.altAxis, m = f === void 0 ? !1 : f, h = o.boundary, v = o.rootBoundary, b = o.altBoundary, x = o.padding, E = o.tether, T = E === void 0 ? !0 : E, P = o.tetherOffset, O = P === void 0 ? 0 : P, k = ny(t, {
    boundary: h,
    rootBoundary: v,
    padding: x,
    altBoundary: b
  }), I = zs(t.placement), $ = Lh(t.placement), _ = !$, z = Yk(I), V = nQ(z), M = t.modifiersData.popperOffsets, A = t.rects.reference, W = t.rects.popper, Y = typeof O == "function" ? O(Object.assign({}, t.rects, {
    placement: t.placement
  })) : O, H = typeof Y == "number" ? {
    mainAxis: Y,
    altAxis: Y
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Y), G = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (M) {
    if (c) {
      var K, B = z === "y" ? mi : hi, q = z === "y" ? ll : sl, X = z === "y" ? "height" : "width", J = M[z], U = J + k[B], Z = J - k[q], ee = T ? -W[X] / 2 : 0, ie = $ === Dh ? A[X] : W[X], oe = $ === Dh ? -W[X] : -A[X], le = t.elements.arrow, de = T && le ? qk(le) : {
        width: 0,
        height: 0
      }, Ce = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : pF(), me = Ce[B], Oe = Ce[q], he = jb(0, A[X], de[X]), $e = _ ? A[X] / 2 - ee - he - me - H.mainAxis : ie - he - me - H.mainAxis, Ne = _ ? -A[X] / 2 + ee + he + Oe + H.mainAxis : oe + he + Oe + H.mainAxis, Pe = t.elements.arrow && ky(t.elements.arrow), Se = Pe ? z === "y" ? Pe.clientTop || 0 : Pe.clientLeft || 0 : 0, Fe = (K = G == null ? void 0 : G[z]) != null ? K : 0, ce = J + $e - Fe - Se, ge = J + Ne - Fe, we = jb(T ? D1(U, ce) : U, J, T ? qf(Z, ge) : Z);
      M[z] = we, ne[z] = we - J;
    }
    if (m) {
      var Me, Qe = z === "x" ? mi : hi, ct = z === "x" ? ll : sl, Ze = M[V], Ge = V === "y" ? "height" : "width", Be = Ze + k[Qe], rt = Ze - k[ct], wt = [mi, hi].indexOf(I) !== -1, We = (Me = G == null ? void 0 : G[V]) != null ? Me : 0, ut = wt ? Be : Ze - A[Ge] - W[Ge] - We + H.altAxis, ft = wt ? Ze + A[Ge] + W[Ge] - We - H.altAxis : rt, Je = T && wt ? RX(ut, Ze, ft) : jb(T ? ut : Be, Ze, T ? ft : rt);
      M[V] = Je, ne[V] = Je - Ze;
    }
    t.modifiersData[i] = ne;
  }
}
const oQ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: rQ,
  requiresIfExists: ["offset"]
};
function aQ(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function iQ(e) {
  return e === Li(e) || !ol(e) ? Kk(e) : aQ(e);
}
function lQ(e) {
  var t = e.getBoundingClientRect(), o = _h(t.width) / e.offsetWidth || 1, i = _h(t.height) / e.offsetHeight || 1;
  return o !== 1 || i !== 1;
}
function sQ(e, t, o) {
  o === void 0 && (o = !1);
  var i = ol(t), s = ol(t) && lQ(t), c = yd(t), f = Ah(e, s, o), m = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = {
    x: 0,
    y: 0
  };
  return (i || !i && !o) && ((Hs(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Qk(c)) && (m = iQ(t)), ol(t) ? (h = Ah(t, !0), h.x += t.clientLeft, h.y += t.clientTop) : c && (h.x = Xk(c))), {
    x: f.left + m.scrollLeft - h.x,
    y: f.top + m.scrollTop - h.y,
    width: f.width,
    height: f.height
  };
}
function cQ(e) {
  var t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(c) {
    t.set(c.name, c);
  });
  function s(c) {
    o.add(c.name);
    var f = [].concat(c.requires || [], c.requiresIfExists || []);
    f.forEach(function(m) {
      if (!o.has(m)) {
        var h = t.get(m);
        h && s(h);
      }
    }), i.push(c);
  }
  return e.forEach(function(c) {
    o.has(c.name) || s(c);
  }), i;
}
function uQ(e) {
  var t = cQ(e);
  return SX.reduce(function(o, i) {
    return o.concat(t.filter(function(s) {
      return s.phase === i;
    }));
  }, []);
}
function dQ(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(o) {
      Promise.resolve().then(function() {
        t = void 0, o(e());
      });
    })), t;
  };
}
function fQ(e) {
  var t = e.reduce(function(o, i) {
    var s = o[i.name];
    return o[i.name] = s ? Object.assign({}, s, i, {
      options: Object.assign({}, s.options, i.options),
      data: Object.assign({}, s.data, i.data)
    }) : i, o;
  }, {});
  return Object.keys(t).map(function(o) {
    return t[o];
  });
}
var mD = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function hD() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function pQ(e) {
  e === void 0 && (e = {});
  var t = e, o = t.defaultModifiers, i = o === void 0 ? [] : o, s = t.defaultOptions, c = s === void 0 ? mD : s;
  return function(m, h, v) {
    v === void 0 && (v = c);
    var b = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, mD, c),
      modifiersData: {},
      elements: {
        reference: m,
        popper: h
      },
      attributes: {},
      styles: {}
    }, x = [], E = !1, T = {
      state: b,
      setOptions: function(I) {
        var $ = typeof I == "function" ? I(b.options) : I;
        O(), b.options = Object.assign({}, c, b.options, $), b.scrollParents = {
          reference: tp(m) ? Hb(m) : m.contextElement ? Hb(m.contextElement) : [],
          popper: Hb(h)
        };
        var _ = uQ(fQ([].concat(i, b.options.modifiers)));
        return b.orderedModifiers = _.filter(function(z) {
          return z.enabled;
        }), P(), T.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!E) {
          var I = b.elements, $ = I.reference, _ = I.popper;
          if (hD($, _)) {
            b.rects = {
              reference: sQ($, ky(_), b.options.strategy === "fixed"),
              popper: qk(_)
            }, b.reset = !1, b.placement = b.options.placement, b.orderedModifiers.forEach(function(H) {
              return b.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var z = 0; z < b.orderedModifiers.length; z++) {
              if (b.reset === !0) {
                b.reset = !1, z = -1;
                continue;
              }
              var V = b.orderedModifiers[z], M = V.fn, A = V.options, W = A === void 0 ? {} : A, Y = V.name;
              typeof M == "function" && (b = M({
                state: b,
                options: W,
                name: Y,
                instance: T
              }) || b);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: dQ(function() {
        return new Promise(function(k) {
          T.forceUpdate(), k(b);
        });
      }),
      destroy: function() {
        O(), E = !0;
      }
    };
    if (!hD(m, h))
      return T;
    T.setOptions(v).then(function(k) {
      !E && v.onFirstUpdate && v.onFirstUpdate(k);
    });
    function P() {
      b.orderedModifiers.forEach(function(k) {
        var I = k.name, $ = k.options, _ = $ === void 0 ? {} : $, z = k.effect;
        if (typeof z == "function") {
          var V = z({
            state: b,
            name: I,
            instance: T,
            options: _
          }), M = function() {
          };
          x.push(V || M);
        }
      });
    }
    function O() {
      x.forEach(function(k) {
        return k();
      }), x = [];
    }
    return T;
  };
}
var mQ = [LX, tQ, _X, EX, JX, YX, oQ, IX, XX], hQ = /* @__PURE__ */ pQ({
  defaultModifiers: mQ
});
function gQ(e) {
  return typeof e == "function" ? e() : e;
}
const ry = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    children: i,
    container: s,
    disablePortal: c = !1
  } = t, [f, m] = C.useState(null), h = Cn(/* @__PURE__ */ C.isValidElement(i) ? i.ref : null, o);
  if (Hn(() => {
    c || m(gQ(s) || document.body);
  }, [s, c]), Hn(() => {
    if (f && !c)
      return O1(o, f), () => {
        O1(o, null);
      };
  }, [o, f, c]), c) {
    if (/* @__PURE__ */ C.isValidElement(i)) {
      const v = {
        ref: h
      };
      return /* @__PURE__ */ C.cloneElement(i, v);
    }
    return /* @__PURE__ */ L(C.Fragment, {
      children: i
    });
  }
  return /* @__PURE__ */ L(C.Fragment, {
    children: f && /* @__PURE__ */ ep.createPortal(i, f)
  });
});
process.env.NODE_ENV !== "production" && (ry.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: n.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([il, n.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool
});
process.env.NODE_ENV !== "production" && (ry["propTypes"] = ip(ry.propTypes));
function vQ(e) {
  return ot("MuiPopper", e);
}
lt("MuiPopper", ["root"]);
const bQ = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], yQ = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function CQ(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function _1(e) {
  return typeof e == "function" ? e() : e;
}
function Rx(e) {
  return e.nodeType !== void 0;
}
function SQ(e) {
  return !Rx(e);
}
const xQ = () => je({
  root: ["root"]
}, ZK(vQ)), wQ = {}, EQ = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const {
    anchorEl: s,
    children: c,
    direction: f,
    disablePortal: m,
    modifiers: h,
    open: v,
    placement: b,
    popperOptions: x,
    popperRef: E,
    slotProps: T = {},
    slots: P = {},
    TransitionProps: O
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, k = pe(t, bQ), I = C.useRef(null), $ = Cn(I, o), _ = C.useRef(null), z = Cn(_, E), V = C.useRef(z);
  Hn(() => {
    V.current = z;
  }, [z]), C.useImperativeHandle(E, () => _.current, []);
  const M = CQ(b, f), [A, W] = C.useState(M), [Y, H] = C.useState(_1(s));
  C.useEffect(() => {
    _.current && _.current.forceUpdate();
  }), C.useEffect(() => {
    s && H(_1(s));
  }, [s]), Hn(() => {
    if (!Y || !v)
      return;
    const q = (U) => {
      W(U.placement);
    };
    if (process.env.NODE_ENV !== "production" && Y && Rx(Y) && Y.nodeType === 1) {
      const U = Y.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && U.top === 0 && U.left === 0 && U.right === 0 && U.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let X = [{
      name: "preventOverflow",
      options: {
        altBoundary: m
      }
    }, {
      name: "flip",
      options: {
        altBoundary: m
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: U
      }) => {
        q(U);
      }
    }];
    h != null && (X = X.concat(h)), x && x.modifiers != null && (X = X.concat(x.modifiers));
    const J = hQ(Y, I.current, S({
      placement: M
    }, x, {
      modifiers: X
    }));
    return V.current(J), () => {
      J.destroy(), V.current(null);
    };
  }, [Y, m, h, v, x, M]);
  const G = {
    placement: A
  };
  O !== null && (G.TransitionProps = O);
  const ne = xQ(), K = (i = P.root) != null ? i : "div", B = Gr({
    elementType: K,
    externalSlotProps: T.root,
    externalForwardedProps: k,
    additionalProps: {
      role: "tooltip",
      ref: $
    },
    ownerState: t,
    className: ne.root
  });
  return /* @__PURE__ */ L(K, S({}, B, {
    children: typeof c == "function" ? c(G) : c
  }));
}), bF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    anchorEl: i,
    children: s,
    container: c,
    direction: f = "ltr",
    disablePortal: m = !1,
    keepMounted: h = !1,
    modifiers: v,
    open: b,
    placement: x = "bottom",
    popperOptions: E = wQ,
    popperRef: T,
    style: P,
    transition: O = !1,
    slotProps: k = {},
    slots: I = {}
  } = t, $ = pe(t, yQ), [_, z] = C.useState(!0), V = () => {
    z(!1);
  }, M = () => {
    z(!0);
  };
  if (!h && !b && (!O || _))
    return null;
  let A;
  if (c)
    A = c;
  else if (i) {
    const H = _1(i);
    A = H && Rx(H) ? qn(H).body : qn(null).body;
  }
  const W = !b && h && (!O || _) ? "none" : void 0, Y = O ? {
    in: b,
    onEnter: V,
    onExited: M
  } : void 0;
  return /* @__PURE__ */ L(ry, {
    disablePortal: m,
    container: A,
    children: /* @__PURE__ */ L(EQ, S({
      anchorEl: i,
      direction: f,
      disablePortal: m,
      modifiers: v,
      ref: o,
      open: O ? !_ : b,
      placement: x,
      popperOptions: E,
      popperRef: T,
      slotProps: k,
      slots: I
    }, $, {
      style: S({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: W
      }, P),
      TransitionProps: Y,
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (bF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: co(n.oneOfType([il, n.object, n.func]), (e) => {
    if (e.open) {
      const t = _1(e.anchorEl);
      if (t && Rx(t) && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || SQ(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: n.oneOfType([n.node, n.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([il, n.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: n.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: n.arrayOf(n.shape({
    data: n.object,
    effect: n.func,
    enabled: n.bool,
    fn: n.func,
    name: n.any,
    options: n.object,
    phase: n.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: n.arrayOf(n.string),
    requiresIfExists: n.arrayOf(n.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: n.shape({
    modifiers: n.array,
    onFirstUpdate: n.func,
    placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: n.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Fo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: n.bool
});
function TQ(e) {
  const t = qn(e);
  return t.body === e ? Ta(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Ub(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function gD(e) {
  return parseInt(Ta(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function OQ(e) {
  const o = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, i = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return o || i;
}
function vD(e, t, o, i, s) {
  const c = [t, o, ...i];
  [].forEach.call(e.children, (f) => {
    const m = c.indexOf(f) === -1, h = !OQ(f);
    m && h && Ub(f, s);
  });
}
function jO(e, t) {
  let o = -1;
  return e.some((i, s) => t(i) ? (o = s, !0) : !1), o;
}
function RQ(e, t) {
  const o = [], i = e.container;
  if (!t.disableScrollLock) {
    if (TQ(i)) {
      const f = rL(qn(i));
      o.push({
        value: i.style.paddingRight,
        property: "padding-right",
        el: i
      }), i.style.paddingRight = `${gD(i) + f}px`;
      const m = qn(i).querySelectorAll(".mui-fixed");
      [].forEach.call(m, (h) => {
        o.push({
          value: h.style.paddingRight,
          property: "padding-right",
          el: h
        }), h.style.paddingRight = `${gD(h) + f}px`;
      });
    }
    let c;
    if (i.parentNode instanceof DocumentFragment)
      c = qn(i).body;
    else {
      const f = i.parentElement, m = Ta(i);
      c = (f == null ? void 0 : f.nodeName) === "HTML" && m.getComputedStyle(f).overflowY === "scroll" ? f : i;
    }
    o.push({
      value: c.style.overflow,
      property: "overflow",
      el: c
    }, {
      value: c.style.overflowX,
      property: "overflow-x",
      el: c
    }, {
      value: c.style.overflowY,
      property: "overflow-y",
      el: c
    }), c.style.overflow = "hidden";
  }
  return () => {
    o.forEach(({
      value: c,
      el: f,
      property: m
    }) => {
      c ? f.style.setProperty(m, c) : f.style.removeProperty(m);
    });
  };
}
function kQ(e) {
  const t = [];
  return [].forEach.call(e.children, (o) => {
    o.getAttribute("aria-hidden") === "true" && t.push(o);
  }), t;
}
class PQ {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, o) {
    let i = this.modals.indexOf(t);
    if (i !== -1)
      return i;
    i = this.modals.length, this.modals.push(t), t.modalRef && Ub(t.modalRef, !1);
    const s = kQ(o);
    vD(o, t.mount, t.modalRef, s, !0);
    const c = jO(this.containers, (f) => f.container === o);
    return c !== -1 ? (this.containers[c].modals.push(t), i) : (this.containers.push({
      modals: [t],
      container: o,
      restore: null,
      hiddenSiblings: s
    }), i);
  }
  mount(t, o) {
    const i = jO(this.containers, (c) => c.modals.indexOf(t) !== -1), s = this.containers[i];
    s.restore || (s.restore = RQ(s, o));
  }
  remove(t, o = !0) {
    const i = this.modals.indexOf(t);
    if (i === -1)
      return i;
    const s = jO(this.containers, (f) => f.modals.indexOf(t) !== -1), c = this.containers[s];
    if (c.modals.splice(c.modals.indexOf(t), 1), this.modals.splice(i, 1), c.modals.length === 0)
      c.restore && c.restore(), t.modalRef && Ub(t.modalRef, o), vD(c.container, t.mount, t.modalRef, c.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const f = c.modals[c.modals.length - 1];
      f.modalRef && Ub(f.modalRef, !1);
    }
    return i;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function MQ(e) {
  return typeof e == "function" ? e() : e;
}
function IQ(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const NQ = new PQ();
function $Q(e) {
  const {
    container: t,
    disableEscapeKeyDown: o = !1,
    disableScrollLock: i = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = NQ,
    closeAfterTransition: c = !1,
    onTransitionEnter: f,
    onTransitionExited: m,
    children: h,
    onClose: v,
    open: b,
    rootRef: x
  } = e, E = C.useRef({}), T = C.useRef(null), P = C.useRef(null), O = Cn(P, x), [k, I] = C.useState(!b), $ = IQ(h);
  let _ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (_ = !1);
  const z = () => qn(T.current), V = () => (E.current.modalRef = P.current, E.current.mount = T.current, E.current), M = () => {
    s.mount(V(), {
      disableScrollLock: i
    }), P.current && (P.current.scrollTop = 0);
  }, A = zn(() => {
    const X = MQ(t) || z().body;
    s.add(V(), X), P.current && M();
  }), W = C.useCallback(() => s.isTopModal(V()), [s]), Y = zn((X) => {
    T.current = X, X && (b && W() ? M() : P.current && Ub(P.current, _));
  }), H = C.useCallback(() => {
    s.remove(V(), _);
  }, [_, s]);
  C.useEffect(() => () => {
    H();
  }, [H]), C.useEffect(() => {
    b ? A() : (!$ || !c) && H();
  }, [b, H, $, c, A]);
  const G = (X) => (J) => {
    var U;
    (U = X.onKeyDown) == null || U.call(X, J), !(J.key !== "Escape" || !W()) && (o || (J.stopPropagation(), v && v(J, "escapeKeyDown")));
  }, ne = (X) => (J) => {
    var U;
    (U = X.onClick) == null || U.call(X, J), J.target === J.currentTarget && v && v(J, "backdropClick");
  };
  return {
    getRootProps: (X = {}) => {
      const J = $1(e);
      delete J.onTransitionEnter, delete J.onTransitionExited;
      const U = S({}, J, X);
      return S({
        role: "presentation"
      }, U, {
        onKeyDown: G(U),
        ref: O
      });
    },
    getBackdropProps: (X = {}) => {
      const J = X;
      return S({
        "aria-hidden": !0
      }, J, {
        onClick: ne(J),
        open: b
      });
    },
    getTransitionProps: () => {
      const X = () => {
        I(!1), f && f();
      }, J = () => {
        I(!0), m && m(), c && H();
      };
      return {
        onEnter: CR(X, h == null ? void 0 : h.props.onEnter),
        onExited: CR(J, h == null ? void 0 : h.props.onExited)
      };
    },
    rootRef: O,
    portalRef: Y,
    isTopModal: W,
    exited: k,
    hasTransition: $
  };
}
function A1(e) {
  const {
    children: t,
    defer: o = !1,
    fallback: i = null
  } = e, [s, c] = C.useState(!1);
  return Hn(() => {
    o || c(!0);
  }, [o]), C.useEffect(() => {
    o && c(!0);
  }, [o]), /* @__PURE__ */ L(C.Fragment, {
    children: s ? t : i
  });
}
process.env.NODE_ENV !== "production" && (A1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * You can wrap a node.
   */
  children: n.node,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */
  defer: n.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: n.node
});
process.env.NODE_ENV !== "production" && (A1["propTypes"] = ip(A1.propTypes));
const DQ = 2;
function yF(e, t) {
  return e - t;
}
function Cb(e, t, o) {
  return e == null ? t : Math.min(Math.max(t, e), o);
}
function bD(e, t) {
  var o;
  const {
    index: i
  } = (o = e.reduce((s, c, f) => {
    const m = Math.abs(t - c);
    return s === null || m < s.distance || m === s.distance ? {
      distance: m,
      index: f
    } : s;
  }, null)) != null ? o : {};
  return i;
}
function GS(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const o = e;
    for (let i = 0; i < o.changedTouches.length; i += 1) {
      const s = o.changedTouches[i];
      if (s.identifier === t.current)
        return {
          x: s.clientX,
          y: s.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function L1(e, t, o) {
  return (e - t) * 100 / (o - t);
}
function _Q(e, t, o) {
  return (o - t) * e + t;
}
function AQ(e) {
  if (Math.abs(e) < 1) {
    const o = e.toExponential().split("e-"), i = o[0].split(".")[1];
    return (i ? i.length : 0) + parseInt(o[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function LQ(e, t, o) {
  const i = Math.round((e - o) / t) * t + o;
  return Number(i.toFixed(AQ(t)));
}
function yD({
  values: e,
  newValue: t,
  index: o
}) {
  const i = e.slice();
  return i[o] = t, i.sort(yF);
}
function WS({
  sliderRef: e,
  activeIndex: t,
  setActive: o
}) {
  var i, s;
  const c = qn(e.current);
  if (!((i = e.current) != null && i.contains(c.activeElement)) || Number(c == null || (s = c.activeElement) == null ? void 0 : s.getAttribute("data-index")) !== t) {
    var f;
    (f = e.current) == null || f.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  o && o(t);
}
function qS(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? KK(e, t) : !1;
}
const FQ = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, zQ = (e) => e;
let YS;
function HO() {
  return YS === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? YS = CSS.supports("touch-action", "none") : YS = !0), YS;
}
function VQ(e) {
  const {
    "aria-labelledby": t,
    defaultValue: o,
    disabled: i = !1,
    disableSwap: s = !1,
    isRtl: c = !1,
    marks: f = !1,
    max: m = 100,
    min: h = 0,
    name: v,
    onChange: b,
    onChangeCommitted: x,
    orientation: E = "horizontal",
    rootRef: T,
    scale: P = zQ,
    step: O = 1,
    tabIndex: k,
    value: I
  } = e, $ = C.useRef(), [_, z] = C.useState(-1), [V, M] = C.useState(-1), [A, W] = C.useState(!1), Y = C.useRef(0), [H, G] = _i({
    controlled: I,
    default: o ?? h,
    name: "Slider"
  }), ne = b && ((We, ut, ft) => {
    const Je = We.nativeEvent || We, pt = new Je.constructor(Je.type, Je);
    Object.defineProperty(pt, "target", {
      writable: !0,
      value: {
        value: ut,
        name: v
      }
    }), b(pt, ut, ft);
  }), K = Array.isArray(H);
  let B = K ? H.slice().sort(yF) : [H];
  B = B.map((We) => Cb(We, h, m));
  const q = f === !0 && O !== null ? [...Array(Math.floor((m - h) / O) + 1)].map((We, ut) => ({
    value: h + O * ut
  })) : f || [], X = q.map((We) => We.value), {
    isFocusVisibleRef: J,
    onBlur: U,
    onFocus: Z,
    ref: ee
  } = vy(), [ie, oe] = C.useState(-1), le = C.useRef(), de = Cn(ee, le), Ce = Cn(T, de), me = (We) => (ut) => {
    var ft;
    const Je = Number(ut.currentTarget.getAttribute("data-index"));
    Z(ut), J.current === !0 && oe(Je), M(Je), We == null || (ft = We.onFocus) == null || ft.call(We, ut);
  }, Oe = (We) => (ut) => {
    var ft;
    U(ut), J.current === !1 && oe(-1), M(-1), We == null || (ft = We.onBlur) == null || ft.call(We, ut);
  };
  Hn(() => {
    if (i && le.current.contains(document.activeElement)) {
      var We;
      (We = document.activeElement) == null || We.blur();
    }
  }, [i]), i && _ !== -1 && z(-1), i && ie !== -1 && oe(-1);
  const he = (We) => (ut) => {
    var ft;
    (ft = We.onChange) == null || ft.call(We, ut);
    const Je = Number(ut.currentTarget.getAttribute("data-index")), pt = B[Je], At = X.indexOf(pt);
    let Ye = ut.target.valueAsNumber;
    if (q && O == null) {
      const st = X[X.length - 1];
      Ye > st ? Ye = st : Ye < X[0] ? Ye = X[0] : Ye = Ye < pt ? X[At - 1] : X[At + 1];
    }
    if (Ye = Cb(Ye, h, m), K) {
      s && (Ye = Cb(Ye, B[Je - 1] || -1 / 0, B[Je + 1] || 1 / 0));
      const st = Ye;
      Ye = yD({
        values: B,
        newValue: Ye,
        index: Je
      });
      let _e = Je;
      s || (_e = Ye.indexOf(st)), WS({
        sliderRef: le,
        activeIndex: _e
      });
    }
    G(Ye), oe(Je), ne && !qS(Ye, H) && ne(ut, Ye, Je), x && x(ut, Ye);
  }, $e = C.useRef();
  let Ne = E;
  c && E === "horizontal" && (Ne += "-reverse");
  const Pe = ({
    finger: We,
    move: ut = !1
  }) => {
    const {
      current: ft
    } = le, {
      width: Je,
      height: pt,
      bottom: At,
      left: Ye
    } = ft.getBoundingClientRect();
    let st;
    Ne.indexOf("vertical") === 0 ? st = (At - We.y) / pt : st = (We.x - Ye) / Je, Ne.indexOf("-reverse") !== -1 && (st = 1 - st);
    let _e;
    if (_e = _Q(st, h, m), O)
      _e = LQ(_e, O, h);
    else {
      const et = bD(X, _e);
      _e = X[et];
    }
    _e = Cb(_e, h, m);
    let vt = 0;
    if (K) {
      ut ? vt = $e.current : vt = bD(B, _e), s && (_e = Cb(_e, B[vt - 1] || -1 / 0, B[vt + 1] || 1 / 0));
      const et = _e;
      _e = yD({
        values: B,
        newValue: _e,
        index: vt
      }), s && ut || (vt = _e.indexOf(et), $e.current = vt);
    }
    return {
      newValue: _e,
      activeIndex: vt
    };
  }, Se = zn((We) => {
    const ut = GS(We, $);
    if (!ut)
      return;
    if (Y.current += 1, We.type === "mousemove" && We.buttons === 0) {
      Fe(We);
      return;
    }
    const {
      newValue: ft,
      activeIndex: Je
    } = Pe({
      finger: ut,
      move: !0
    });
    WS({
      sliderRef: le,
      activeIndex: Je,
      setActive: z
    }), G(ft), !A && Y.current > DQ && W(!0), ne && !qS(ft, H) && ne(We, ft, Je);
  }), Fe = zn((We) => {
    const ut = GS(We, $);
    if (W(!1), !ut)
      return;
    const {
      newValue: ft
    } = Pe({
      finger: ut,
      move: !0
    });
    z(-1), We.type === "touchend" && M(-1), x && x(We, ft), $.current = void 0, ge();
  }), ce = zn((We) => {
    if (i)
      return;
    HO() || We.preventDefault();
    const ut = We.changedTouches[0];
    ut != null && ($.current = ut.identifier);
    const ft = GS(We, $);
    if (ft !== !1) {
      const {
        newValue: pt,
        activeIndex: At
      } = Pe({
        finger: ft
      });
      WS({
        sliderRef: le,
        activeIndex: At,
        setActive: z
      }), G(pt), ne && !qS(pt, H) && ne(We, pt, At);
    }
    Y.current = 0;
    const Je = qn(le.current);
    Je.addEventListener("touchmove", Se), Je.addEventListener("touchend", Fe);
  }), ge = C.useCallback(() => {
    const We = qn(le.current);
    We.removeEventListener("mousemove", Se), We.removeEventListener("mouseup", Fe), We.removeEventListener("touchmove", Se), We.removeEventListener("touchend", Fe);
  }, [Fe, Se]);
  C.useEffect(() => {
    const {
      current: We
    } = le;
    return We.addEventListener("touchstart", ce, {
      passive: HO()
    }), () => {
      We.removeEventListener("touchstart", ce, {
        passive: HO()
      }), ge();
    };
  }, [ge, ce]), C.useEffect(() => {
    i && ge();
  }, [i, ge]);
  const we = (We) => (ut) => {
    var ft;
    if ((ft = We.onMouseDown) == null || ft.call(We, ut), i || ut.defaultPrevented || ut.button !== 0)
      return;
    ut.preventDefault();
    const Je = GS(ut, $);
    if (Je !== !1) {
      const {
        newValue: At,
        activeIndex: Ye
      } = Pe({
        finger: Je
      });
      WS({
        sliderRef: le,
        activeIndex: Ye,
        setActive: z
      }), G(At), ne && !qS(At, H) && ne(ut, At, Ye);
    }
    Y.current = 0;
    const pt = qn(le.current);
    pt.addEventListener("mousemove", Se), pt.addEventListener("mouseup", Fe);
  }, Me = L1(K ? B[0] : h, h, m), Qe = L1(B[B.length - 1], h, m) - Me, ct = (We = {}) => {
    const ut = {
      onMouseDown: we(We || {})
    }, ft = S({}, We, ut);
    return S({
      ref: Ce
    }, ft);
  }, Ze = (We) => (ut) => {
    var ft;
    (ft = We.onMouseOver) == null || ft.call(We, ut);
    const Je = Number(ut.currentTarget.getAttribute("data-index"));
    M(Je);
  }, Ge = (We) => (ut) => {
    var ft;
    (ft = We.onMouseLeave) == null || ft.call(We, ut), M(-1);
  };
  return {
    active: _,
    axis: Ne,
    axisProps: FQ,
    dragging: A,
    focusedThumbIndex: ie,
    getHiddenInputProps: (We = {}) => {
      var ut;
      const ft = {
        onChange: he(We || {}),
        onFocus: me(We || {}),
        onBlur: Oe(We || {})
      }, Je = S({}, We, ft);
      return S({
        tabIndex: k,
        "aria-labelledby": t,
        "aria-orientation": E,
        "aria-valuemax": P(m),
        "aria-valuemin": P(h),
        name: v,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (ut = e.step) != null ? ut : void 0,
        disabled: i
      }, Je, {
        style: S({}, aL, {
          direction: c ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: ct,
    getThumbProps: (We = {}) => {
      const ut = {
        onMouseOver: Ze(We || {}),
        onMouseLeave: Ge(We || {})
      };
      return S({}, We, ut);
    },
    marks: q,
    open: V,
    range: K,
    rootRef: Ce,
    trackLeap: Qe,
    trackOffset: Me,
    values: B,
    getThumbStyle: (We) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: _ !== -1 && _ !== We ? "none" : void 0
    })
  };
}
function BQ(e = {}) {
  const {
    autoHideDuration: t = null,
    disableWindowBlurListener: o = !1,
    onClose: i,
    open: s,
    resumeHideDuration: c
  } = e, f = C.useRef();
  C.useEffect(() => {
    if (!s)
      return;
    function I($) {
      $.defaultPrevented || ($.key === "Escape" || $.key === "Esc") && (i == null || i($, "escapeKeyDown"));
    }
    return document.addEventListener("keydown", I), () => {
      document.removeEventListener("keydown", I);
    };
  }, [s, i]);
  const m = zn((I, $) => {
    i == null || i(I, $);
  }), h = zn((I) => {
    !i || I == null || (clearTimeout(f.current), f.current = setTimeout(() => {
      m(null, "timeout");
    }, I));
  });
  C.useEffect(() => (s && h(t), () => {
    clearTimeout(f.current);
  }), [s, t, h]);
  const v = (I) => {
    i == null || i(I, "clickaway");
  }, b = () => {
    clearTimeout(f.current);
  }, x = C.useCallback(() => {
    t != null && h(c ?? t * 0.5);
  }, [t, c, h]), E = (I) => ($) => {
    const _ = I.onBlur;
    _ == null || _($), x();
  }, T = (I) => ($) => {
    const _ = I.onFocus;
    _ == null || _($), b();
  }, P = (I) => ($) => {
    const _ = I.onMouseEnter;
    _ == null || _($), b();
  }, O = (I) => ($) => {
    const _ = I.onMouseLeave;
    _ == null || _($), x();
  };
  return C.useEffect(() => {
    if (!o && s)
      return window.addEventListener("focus", x), window.addEventListener("blur", b), () => {
        window.removeEventListener("focus", x), window.removeEventListener("blur", b);
      };
  }, [o, x, s]), {
    getRootProps: (I = {}) => {
      const $ = S({}, $1(e), $1(I));
      return S({
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation"
      }, I, $, {
        onBlur: E($),
        onFocus: T($),
        onMouseEnter: P($),
        onMouseLeave: O($)
      });
    },
    onClickAway: v
  };
}
const jQ = ["onChange", "maxRows", "minRows", "style", "value"];
function KS(e) {
  return parseInt(e, 10) || 0;
}
const HQ = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function CD(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflow;
}
const CF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    onChange: i,
    maxRows: s,
    minRows: c = 1,
    style: f,
    value: m
  } = t, h = pe(t, jQ), {
    current: v
  } = C.useRef(m != null), b = C.useRef(null), x = Cn(o, b), E = C.useRef(null), T = C.useRef(0), [P, O] = C.useState({
    outerHeightStyle: 0
  }), k = C.useCallback(() => {
    const z = b.current, M = Ta(z).getComputedStyle(z);
    if (M.width === "0px")
      return {
        outerHeightStyle: 0
      };
    const A = E.current;
    A.style.width = M.width, A.value = z.value || t.placeholder || "x", A.value.slice(-1) === `
` && (A.value += " ");
    const W = M.boxSizing, Y = KS(M.paddingBottom) + KS(M.paddingTop), H = KS(M.borderBottomWidth) + KS(M.borderTopWidth), G = A.scrollHeight;
    A.value = "x";
    const ne = A.scrollHeight;
    let K = G;
    c && (K = Math.max(Number(c) * ne, K)), s && (K = Math.min(Number(s) * ne, K)), K = Math.max(K, ne);
    const B = K + (W === "border-box" ? Y + H : 0), q = Math.abs(K - G) <= 1;
    return {
      outerHeightStyle: B,
      overflow: q
    };
  }, [s, c, t.placeholder]), I = (z, V) => {
    const {
      outerHeightStyle: M,
      overflow: A
    } = V;
    return T.current < 20 && (M > 0 && Math.abs((z.outerHeightStyle || 0) - M) > 1 || z.overflow !== A) ? (T.current += 1, {
      overflow: A,
      outerHeightStyle: M
    }) : (process.env.NODE_ENV !== "production" && T.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), z);
  }, $ = C.useCallback(() => {
    const z = k();
    CD(z) || O((V) => I(V, z));
  }, [k]);
  Hn(() => {
    const z = () => {
      const ne = k();
      CD(ne) || ep.flushSync(() => {
        O((K) => I(K, ne));
      });
    }, V = () => {
      T.current = 0, z();
    };
    let M;
    const A = () => {
      cancelAnimationFrame(M), M = requestAnimationFrame(() => {
        V();
      });
    }, W = lp(V), Y = b.current, H = Ta(Y);
    H.addEventListener("resize", W);
    let G;
    return typeof ResizeObserver < "u" && (G = new ResizeObserver(process.env.NODE_ENV === "test" ? A : V), G.observe(Y)), () => {
      W.clear(), cancelAnimationFrame(M), H.removeEventListener("resize", W), G && G.disconnect();
    };
  }, [k]), Hn(() => {
    $();
  }), C.useEffect(() => {
    T.current = 0;
  }, [m]);
  const _ = (z) => {
    T.current = 0, v || $(), i && i(z);
  };
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L("textarea", S({
      value: m,
      onChange: _,
      ref: x,
      rows: c,
      style: S({
        height: P.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: P.overflow ? "hidden" : void 0
      }, f)
    }, h)), /* @__PURE__ */ L("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: E,
      tabIndex: -1,
      style: S({}, HQ.shadow, f, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (CF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  placeholder: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * @ignore
   */
  value: n.oneOfType([n.arrayOf(n.string), n.number, n.string])
});
function SD(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function SF(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: o = !0,
    limit: i,
    matchFrom: s = "any",
    stringify: c,
    trim: f = !1
  } = e;
  return (m, {
    inputValue: h,
    getOptionLabel: v
  }) => {
    let b = f ? h.trim() : h;
    o && (b = b.toLowerCase()), t && (b = SD(b));
    const x = b ? m.filter((E) => {
      let T = (c || v)(E);
      return o && (T = T.toLowerCase()), t && (T = SD(T)), s === "start" ? T.indexOf(b) === 0 : T.indexOf(b) > -1;
    }) : m;
    return typeof i == "number" ? x.slice(0, i) : x;
  };
}
function UO(e, t) {
  for (let o = 0; o < e.length; o += 1)
    if (t(e[o]))
      return o;
  return -1;
}
const UQ = SF(), xD = 5, GQ = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
};
function WQ(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = GQ,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: o = "Mui",
    autoComplete: i = !1,
    autoHighlight: s = !1,
    autoSelect: c = !1,
    blurOnSelect: f = !1,
    clearOnBlur: m = !e.freeSolo,
    clearOnEscape: h = !1,
    componentName: v = "useAutocomplete",
    defaultValue: b = e.multiple ? [] : null,
    disableClearable: x = !1,
    disableCloseOnSelect: E = !1,
    disabled: T,
    disabledItemsFocusable: P = !1,
    disableListWrap: O = !1,
    filterOptions: k = UQ,
    filterSelectedOptions: I = !1,
    freeSolo: $ = !1,
    getOptionDisabled: _,
    getOptionLabel: z = (Ie) => {
      var xe;
      return (xe = Ie.label) != null ? xe : Ie;
    },
    groupBy: V,
    handleHomeEndKeys: M = !e.freeSolo,
    id: A,
    includeInputInList: W = !1,
    inputValue: Y,
    isOptionEqualToValue: H = (Ie, xe) => Ie === xe,
    multiple: G = !1,
    onChange: ne,
    onClose: K,
    onHighlightChange: B,
    onInputChange: q,
    onOpen: X,
    open: J,
    openOnFocus: U = !1,
    options: Z,
    readOnly: ee = !1,
    selectOnFocus: ie = !e.freeSolo,
    value: oe
  } = e, le = Qn(A);
  let de = z;
  de = (Ie) => {
    const xe = z(Ie);
    if (typeof xe != "string") {
      if (process.env.NODE_ENV !== "production") {
        const ze = xe === void 0 ? "undefined" : `${typeof xe} (${xe})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${v} returned ${ze} instead of a string for ${JSON.stringify(Ie)}.`);
      }
      return String(xe);
    }
    return xe;
  };
  const Ce = C.useRef(!1), me = C.useRef(!0), Oe = C.useRef(null), he = C.useRef(null), [$e, Ne] = C.useState(null), [Pe, Se] = C.useState(-1), Fe = s ? 0 : -1, ce = C.useRef(Fe), [ge, we] = _i({
    controlled: oe,
    default: b,
    name: v
  }), [Me, Qe] = _i({
    controlled: Y,
    default: "",
    name: v,
    state: "inputValue"
  }), [ct, Ze] = C.useState(!1), Ge = C.useCallback((Ie, xe) => {
    if (!(G ? ge.length < xe.length : xe !== null) && !m)
      return;
    let mt;
    if (G)
      mt = "";
    else if (xe == null)
      mt = "";
    else {
      const Ct = de(xe);
      mt = typeof Ct == "string" ? Ct : "";
    }
    Me !== mt && (Qe(mt), q && q(Ie, mt, "reset"));
  }, [de, Me, G, q, Qe, m, ge]), [Be, rt] = _i({
    controlled: J,
    default: !1,
    name: v,
    state: "open"
  }), [wt, We] = C.useState(!0), ut = !G && ge != null && Me === de(ge), ft = Be && !ee, Je = ft ? k(
    Z.filter((Ie) => !(I && (G ? ge : [ge]).some((xe) => xe !== null && H(Ie, xe)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: ut && wt ? "" : Me,
      getOptionLabel: de
    }
  ) : [], pt = yk({
    filteredOptions: Je,
    value: ge,
    inputValue: Me
  });
  C.useEffect(() => {
    const Ie = ge !== pt.value;
    ct && !Ie || $ && !Ie || Ge(null, ge);
  }, [ge, Ge, ct, pt.value, $]);
  const At = Be && Je.length > 0 && !ee;
  if (process.env.NODE_ENV !== "production" && ge !== null && !$ && Z.length > 0) {
    const Ie = (G ? ge : [ge]).filter((xe) => !Z.some((ze) => H(ze, xe)));
    Ie.length > 0 && console.warn([`MUI: The value provided to ${v} is invalid.`, `None of the options match with \`${Ie.length > 1 ? JSON.stringify(Ie) : JSON.stringify(Ie[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const Ye = zn((Ie) => {
    Ie === -1 ? Oe.current.focus() : $e.querySelector(`[data-tag-index="${Ie}"]`).focus();
  });
  C.useEffect(() => {
    G && Pe > ge.length - 1 && (Se(-1), Ye(-1));
  }, [ge, G, Pe, Ye]);
  function st(Ie, xe) {
    if (!he.current || Ie === -1)
      return -1;
    let ze = Ie;
    for (; ; ) {
      if (xe === "next" && ze === Je.length || xe === "previous" && ze === -1)
        return -1;
      const mt = he.current.querySelector(`[data-option-index="${ze}"]`), Ct = P ? !1 : !mt || mt.disabled || mt.getAttribute("aria-disabled") === "true";
      if (mt && !mt.hasAttribute("tabindex") || Ct)
        ze += xe === "next" ? 1 : -1;
      else
        return ze;
    }
  }
  const _e = zn(({
    event: Ie,
    index: xe,
    reason: ze = "auto"
  }) => {
    if (ce.current = xe, xe === -1 ? Oe.current.removeAttribute("aria-activedescendant") : Oe.current.setAttribute("aria-activedescendant", `${le}-option-${xe}`), B && B(Ie, xe === -1 ? null : Je[xe], ze), !he.current)
      return;
    const mt = he.current.querySelector(`[role="option"].${o}-focused`);
    mt && (mt.classList.remove(`${o}-focused`), mt.classList.remove(`${o}-focusVisible`));
    let Ct = he.current;
    if (he.current.getAttribute("role") !== "listbox" && (Ct = he.current.parentElement.querySelector('[role="listbox"]')), !Ct)
      return;
    if (xe === -1) {
      Ct.scrollTop = 0;
      return;
    }
    const Qt = he.current.querySelector(`[data-option-index="${xe}"]`);
    if (Qt && (Qt.classList.add(`${o}-focused`), ze === "keyboard" && Qt.classList.add(`${o}-focusVisible`), Ct.scrollHeight > Ct.clientHeight && ze !== "mouse" && ze !== "touch")) {
      const dn = Qt, yn = Ct.clientHeight + Ct.scrollTop, Wt = dn.offsetTop + dn.offsetHeight;
      Wt > yn ? Ct.scrollTop = Wt - Ct.clientHeight : dn.offsetTop - dn.offsetHeight * (V ? 1.3 : 0) < Ct.scrollTop && (Ct.scrollTop = dn.offsetTop - dn.offsetHeight * (V ? 1.3 : 0));
    }
  }), vt = zn(({
    event: Ie,
    diff: xe,
    direction: ze = "next",
    reason: mt = "auto"
  }) => {
    if (!ft)
      return;
    const Qt = st((() => {
      const dn = Je.length - 1;
      if (xe === "reset")
        return Fe;
      if (xe === "start")
        return 0;
      if (xe === "end")
        return dn;
      const yn = ce.current + xe;
      return yn < 0 ? yn === -1 && W ? -1 : O && ce.current !== -1 || Math.abs(xe) > 1 ? 0 : dn : yn > dn ? yn === dn + 1 && W ? -1 : O || Math.abs(xe) > 1 ? dn : 0 : yn;
    })(), ze);
    if (_e({
      index: Qt,
      reason: mt,
      event: Ie
    }), i && xe !== "reset")
      if (Qt === -1)
        Oe.current.value = Me;
      else {
        const dn = de(Je[Qt]);
        Oe.current.value = dn, dn.toLowerCase().indexOf(Me.toLowerCase()) === 0 && Me.length > 0 && Oe.current.setSelectionRange(Me.length, dn.length);
      }
  }), et = () => {
    const Ie = (xe, ze) => {
      const mt = xe ? de(xe) : "", Ct = ze ? de(ze) : "";
      return mt === Ct;
    };
    if (ce.current !== -1 && pt.filteredOptions && pt.filteredOptions.length !== Je.length && pt.inputValue === Me && (G ? ge.length === pt.value.length && pt.value.every((xe, ze) => de(ge[ze]) === de(xe)) : Ie(pt.value, ge))) {
      const xe = pt.filteredOptions[ce.current];
      if (xe && Je.some((mt) => de(mt) === de(xe)))
        return !0;
    }
    return !1;
  }, gt = C.useCallback(() => {
    if (!ft || et())
      return;
    const Ie = G ? ge[0] : ge;
    if (Je.length === 0 || Ie == null) {
      vt({
        diff: "reset"
      });
      return;
    }
    if (he.current) {
      if (Ie != null) {
        const xe = Je[ce.current];
        if (G && xe && UO(ge, (mt) => H(xe, mt)) !== -1)
          return;
        const ze = UO(Je, (mt) => H(mt, Ie));
        ze === -1 ? vt({
          diff: "reset"
        }) : _e({
          index: ze
        });
        return;
      }
      if (ce.current >= Je.length - 1) {
        _e({
          index: Je.length - 1
        });
        return;
      }
      _e({
        index: ce.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Je.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    G ? !1 : ge,
    I,
    vt,
    _e,
    ft,
    Me,
    G
  ]), kt = zn((Ie) => {
    O1(he, Ie), Ie && gt();
  });
  process.env.NODE_ENV !== "production" && C.useEffect(() => {
    (!Oe.current || Oe.current.nodeName !== "INPUT") && (Oe.current && Oe.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${v} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (e.g. enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Oe.current} while an HTMLInputElement was expected.`, `Instead, ${v} expects an input element.`, "", v === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [v]), C.useEffect(() => {
    gt();
  }, [gt]);
  const Lt = (Ie) => {
    Be || (rt(!0), We(!0), X && X(Ie));
  }, Ut = (Ie, xe) => {
    Be && (rt(!1), K && K(Ie, xe));
  }, Sn = (Ie, xe, ze, mt) => {
    if (G) {
      if (ge.length === xe.length && ge.every((Ct, Qt) => Ct === xe[Qt]))
        return;
    } else if (ge === xe)
      return;
    ne && ne(Ie, xe, ze, mt), we(xe);
  }, an = C.useRef(!1), un = (Ie, xe, ze = "selectOption", mt = "options") => {
    let Ct = ze, Qt = xe;
    if (G) {
      if (Qt = Array.isArray(ge) ? ge.slice() : [], process.env.NODE_ENV !== "production") {
        const yn = Qt.filter((Wt) => H(xe, Wt));
        yn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${v} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${yn.length} matches.`].join(`
`));
      }
      const dn = UO(Qt, (yn) => H(xe, yn));
      dn === -1 ? Qt.push(xe) : mt !== "freeSolo" && (Qt.splice(dn, 1), Ct = "removeOption");
    }
    Ge(Ie, Qt), Sn(Ie, Qt, Ct, {
      option: xe
    }), !E && (!Ie || !Ie.ctrlKey && !Ie.metaKey) && Ut(Ie, Ct), (f === !0 || f === "touch" && an.current || f === "mouse" && !an.current) && Oe.current.blur();
  };
  function wn(Ie, xe) {
    if (Ie === -1)
      return -1;
    let ze = Ie;
    for (; ; ) {
      if (xe === "next" && ze === ge.length || xe === "previous" && ze === -1)
        return -1;
      const mt = $e.querySelector(`[data-tag-index="${ze}"]`);
      if (!mt || !mt.hasAttribute("tabindex") || mt.disabled || mt.getAttribute("aria-disabled") === "true")
        ze += xe === "next" ? 1 : -1;
      else
        return ze;
    }
  }
  const hn = (Ie, xe) => {
    if (!G)
      return;
    Me === "" && Ut(Ie, "toggleInput");
    let ze = Pe;
    Pe === -1 ? Me === "" && xe === "previous" && (ze = ge.length - 1) : (ze += xe === "next" ? 1 : -1, ze < 0 && (ze = 0), ze === ge.length && (ze = -1)), ze = wn(ze, xe), Se(ze), Ye(ze);
  }, Br = (Ie) => {
    Ce.current = !0, Qe(""), q && q(Ie, "", "clear"), Sn(Ie, G ? [] : null, "clear");
  }, zo = (Ie) => (xe) => {
    if (Ie.onKeyDown && Ie.onKeyDown(xe), !xe.defaultMuiPrevented && (Pe !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(xe.key) === -1 && (Se(-1), Ye(-1)), xe.which !== 229))
      switch (xe.key) {
        case "Home":
          ft && M && (xe.preventDefault(), vt({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: xe
          }));
          break;
        case "End":
          ft && M && (xe.preventDefault(), vt({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: xe
          }));
          break;
        case "PageUp":
          xe.preventDefault(), vt({
            diff: -xD,
            direction: "previous",
            reason: "keyboard",
            event: xe
          }), Lt(xe);
          break;
        case "PageDown":
          xe.preventDefault(), vt({
            diff: xD,
            direction: "next",
            reason: "keyboard",
            event: xe
          }), Lt(xe);
          break;
        case "ArrowDown":
          xe.preventDefault(), vt({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: xe
          }), Lt(xe);
          break;
        case "ArrowUp":
          xe.preventDefault(), vt({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: xe
          }), Lt(xe);
          break;
        case "ArrowLeft":
          hn(xe, "previous");
          break;
        case "ArrowRight":
          hn(xe, "next");
          break;
        case "Enter":
          if (ce.current !== -1 && ft) {
            const ze = Je[ce.current], mt = _ ? _(ze) : !1;
            if (xe.preventDefault(), mt)
              return;
            un(xe, ze, "selectOption"), i && Oe.current.setSelectionRange(Oe.current.value.length, Oe.current.value.length);
          } else
            $ && Me !== "" && ut === !1 && (G && xe.preventDefault(), un(xe, Me, "createOption", "freeSolo"));
          break;
        case "Escape":
          ft ? (xe.preventDefault(), xe.stopPropagation(), Ut(xe, "escape")) : h && (Me !== "" || G && ge.length > 0) && (xe.preventDefault(), xe.stopPropagation(), Br(xe));
          break;
        case "Backspace":
          if (G && !ee && Me === "" && ge.length > 0) {
            const ze = Pe === -1 ? ge.length - 1 : Pe, mt = ge.slice();
            mt.splice(ze, 1), Sn(xe, mt, "removeOption", {
              option: ge[ze]
            });
          }
          break;
        case "Delete":
          if (G && !ee && Me === "" && ge.length > 0 && Pe !== -1) {
            const ze = Pe, mt = ge.slice();
            mt.splice(ze, 1), Sn(xe, mt, "removeOption", {
              option: ge[ze]
            });
          }
          break;
      }
  }, wo = (Ie) => {
    Ze(!0), U && !Ce.current && Lt(Ie);
  }, to = (Ie) => {
    if (t(he)) {
      Oe.current.focus();
      return;
    }
    Ze(!1), me.current = !0, Ce.current = !1, c && ce.current !== -1 && ft ? un(Ie, Je[ce.current], "blur") : c && $ && Me !== "" ? un(Ie, Me, "blur", "freeSolo") : m && Ge(Ie, ge), Ut(Ie, "blur");
  }, Dr = (Ie) => {
    const xe = Ie.target.value;
    Me !== xe && (Qe(xe), We(!1), q && q(Ie, xe, "input")), xe === "" ? !x && !G && Sn(Ie, null, "clear") : Lt(Ie);
  }, Vn = (Ie) => {
    const xe = Number(Ie.currentTarget.getAttribute("data-option-index"));
    ce.current !== xe && _e({
      event: Ie,
      index: xe,
      reason: "mouse"
    });
  }, Dn = (Ie) => {
    _e({
      event: Ie,
      index: Number(Ie.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), an.current = !0;
  }, Zn = (Ie) => {
    const xe = Number(Ie.currentTarget.getAttribute("data-option-index"));
    un(Ie, Je[xe], "selectOption"), an.current = !1;
  }, _r = (Ie) => (xe) => {
    const ze = ge.slice();
    ze.splice(Ie, 1), Sn(xe, ze, "removeOption", {
      option: ge[Ie]
    });
  }, ur = (Ie) => {
    Be ? Ut(Ie, "toggleInput") : Lt(Ie);
  }, Bn = (Ie) => {
    Ie.currentTarget.contains(Ie.target) && Ie.target.getAttribute("id") !== le && Ie.preventDefault();
  }, xr = (Ie) => {
    Ie.currentTarget.contains(Ie.target) && (Oe.current.focus(), ie && me.current && Oe.current.selectionEnd - Oe.current.selectionStart === 0 && Oe.current.select(), me.current = !1);
  }, fe = (Ie) => {
    !T && (Me === "" || !Be) && ur(Ie);
  };
  let at = $ && Me.length > 0;
  at = at || (G ? ge.length > 0 : ge !== null);
  let Et = Je;
  if (V) {
    const Ie = /* @__PURE__ */ new Map();
    let xe = !1;
    Et = Je.reduce((ze, mt, Ct) => {
      const Qt = V(mt);
      return ze.length > 0 && ze[ze.length - 1].group === Qt ? ze[ze.length - 1].options.push(mt) : (process.env.NODE_ENV !== "production" && (Ie.get(Qt) && !xe && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${v} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), xe = !0), Ie.set(Qt, !0)), ze.push({
        key: Ct,
        index: Ct,
        group: Qt,
        options: [mt]
      })), ze;
    }, []);
  }
  return T && ct && to(), {
    getRootProps: (Ie = {}) => S({
      "aria-owns": At ? `${le}-listbox` : null
    }, Ie, {
      onKeyDown: zo(Ie),
      onMouseDown: Bn,
      onClick: xr
    }),
    getInputLabelProps: () => ({
      id: `${le}-label`,
      htmlFor: le
    }),
    getInputProps: () => ({
      id: le,
      value: Me,
      onBlur: to,
      onFocus: wo,
      onChange: Dr,
      onMouseDown: fe,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": ft ? "" : null,
      "aria-autocomplete": i ? "both" : "list",
      "aria-controls": At ? `${le}-listbox` : void 0,
      "aria-expanded": At,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Oe,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: T
    }),
    getClearProps: () => ({
      tabIndex: -1,
      onClick: Br
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      onClick: ur
    }),
    getTagProps: ({
      index: Ie
    }) => S({
      key: Ie,
      "data-tag-index": Ie,
      tabIndex: -1
    }, !ee && {
      onDelete: _r(Ie)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${le}-listbox`,
      "aria-labelledby": `${le}-label`,
      ref: kt,
      onMouseDown: (Ie) => {
        Ie.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Ie,
      option: xe
    }) => {
      const ze = (G ? ge : [ge]).some((Ct) => Ct != null && H(xe, Ct)), mt = _ ? _(xe) : !1;
      return {
        key: de(xe),
        tabIndex: -1,
        role: "option",
        id: `${le}-option-${Ie}`,
        onMouseMove: Vn,
        onClick: Zn,
        onTouchStart: Dn,
        "data-option-index": Ie,
        "aria-disabled": mt,
        "aria-selected": ze
      };
    },
    id: le,
    inputValue: Me,
    value: ge,
    dirty: at,
    expanded: ft && $e,
    popupOpen: ft,
    focused: ct || Pe !== -1,
    anchorEl: $e,
    setAnchorEl: Ne,
    focusedTag: Pe,
    groupedOptions: Et
  };
}
const qQ = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], YQ = se(bF, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), xF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = Sx(), c = dt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: f,
    component: m,
    components: h,
    componentsProps: v,
    container: b,
    disablePortal: x,
    keepMounted: E,
    modifiers: T,
    open: P,
    placement: O,
    popperOptions: k,
    popperRef: I,
    transition: $,
    slots: _,
    slotProps: z
  } = c, V = pe(c, qQ), M = (i = _ == null ? void 0 : _.root) != null ? i : h == null ? void 0 : h.Root, A = S({
    anchorEl: f,
    container: b,
    disablePortal: x,
    keepMounted: E,
    modifiers: T,
    open: P,
    placement: O,
    popperOptions: k,
    popperRef: I,
    transition: $
  }, V);
  return /* @__PURE__ */ L(YQ, S({
    as: m,
    direction: s == null ? void 0 : s.direction,
    slots: {
      root: M
    },
    slotProps: z ?? v
  }, A, {
    ref: o
  }));
});
process.env.NODE_ENV !== "production" && (xF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: n.oneOfType([il, n.object, n.func]),
  /**
   * Popper render function or node.
   */
  children: n.oneOfType([n.node, n.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([il, n.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: n.arrayOf(n.shape({
    data: n.object,
    effect: n.func,
    enabled: n.bool,
    fn: n.func,
    name: n.any,
    options: n.object,
    phase: n.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: n.arrayOf(n.string),
    requiresIfExists: n.arrayOf(n.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: n.shape({
    modifiers: n.array,
    onFirstUpdate: n.func,
    placement: n.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: n.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Fo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: n.shape({
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: n.bool
});
const cp = xF;
function KQ(e) {
  return ot("MuiListSubheader", e);
}
const XQ = lt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]), DSe = XQ, QQ = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], ZQ = (e) => {
  const {
    classes: t,
    color: o,
    disableGutters: i,
    inset: s,
    disableSticky: c
  } = e, f = {
    root: ["root", o !== "default" && `color${ve(o)}`, !i && "gutters", s && "inset", !c && "sticky"]
  };
  return je(f, KQ, t);
}, JQ = se("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "default" && t[`color${ve(o.color)}`], !o.disableGutters && t.gutters, o.inset && t.inset, !o.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), Zk = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: s,
    color: c = "default",
    component: f = "li",
    disableGutters: m = !1,
    disableSticky: h = !1,
    inset: v = !1
  } = i, b = pe(i, QQ), x = S({}, i, {
    color: c,
    component: f,
    disableGutters: m,
    disableSticky: h,
    inset: v
  }), E = ZQ(x);
  return /* @__PURE__ */ L(JQ, S({
    as: f,
    className: be(E.root, s),
    ref: o,
    ownerState: x
  }, b));
});
Zk.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (Zk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: n.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: n.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const eZ = Zk, tZ = rn(/* @__PURE__ */ L("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function nZ(e) {
  return ot("MuiChip", e);
}
const rZ = lt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), Wn = rZ, oZ = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], aZ = (e) => {
  const {
    classes: t,
    disabled: o,
    size: i,
    color: s,
    iconColor: c,
    onDelete: f,
    clickable: m,
    variant: h
  } = e, v = {
    root: ["root", h, o && "disabled", `size${ve(i)}`, `color${ve(s)}`, m && "clickable", m && `clickableColor${ve(s)}`, f && "deletable", f && `deletableColor${ve(s)}`, `${h}${ve(s)}`],
    label: ["label", `label${ve(i)}`],
    avatar: ["avatar", `avatar${ve(i)}`, `avatarColor${ve(s)}`],
    icon: ["icon", `icon${ve(i)}`, `iconColor${ve(c)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ve(i)}`, `deleteIconColor${ve(s)}`, `deleteIcon${ve(h)}Color${ve(s)}`]
  };
  return je(v, nZ, t);
}, iZ = se("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      color: i,
      iconColor: s,
      clickable: c,
      onDelete: f,
      size: m,
      variant: h
    } = o;
    return [{
      [`& .${Wn.avatar}`]: t.avatar
    }, {
      [`& .${Wn.avatar}`]: t[`avatar${ve(m)}`]
    }, {
      [`& .${Wn.avatar}`]: t[`avatarColor${ve(i)}`]
    }, {
      [`& .${Wn.icon}`]: t.icon
    }, {
      [`& .${Wn.icon}`]: t[`icon${ve(m)}`]
    }, {
      [`& .${Wn.icon}`]: t[`iconColor${ve(s)}`]
    }, {
      [`& .${Wn.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Wn.deleteIcon}`]: t[`deleteIcon${ve(m)}`]
    }, {
      [`& .${Wn.deleteIcon}`]: t[`deleteIconColor${ve(i)}`]
    }, {
      [`& .${Wn.deleteIcon}`]: t[`deleteIcon${ve(h)}Color${ve(i)}`]
    }, t.root, t[`size${ve(m)}`], t[`color${ve(i)}`], c && t.clickable, c && i !== "default" && t[`clickableColor${ve(i)})`], f && t.deletable, f && i !== "default" && t[`deletableColor${ve(i)}`], t[h], t[`${h}${ve(i)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const o = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return S({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Wn.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Wn.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : o,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Wn.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Wn.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Wn.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Wn.icon}`]: S({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && S({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : o
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${Wn.deleteIcon}`]: S({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : _t(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : _t(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : _t(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${Wn.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${Wn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => S({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${Wn.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${Wn.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => S({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${Wn.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Wn.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${Wn.avatar}`]: {
    marginLeft: 4
  },
  [`& .${Wn.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${Wn.icon}`]: {
    marginLeft: 4
  },
  [`& .${Wn.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${Wn.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${Wn.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : _t(e.palette[t.color].main, 0.7)}`,
  [`&.${Wn.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${Wn.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : _t(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${Wn.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : _t(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), lZ = se("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      size: i
    } = o;
    return [t.label, t[`label${ve(i)}`]];
  }
})(({
  ownerState: e
}) => S({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}));
function wD(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const wF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiChip"
  }), {
    avatar: s,
    className: c,
    clickable: f,
    color: m = "default",
    component: h,
    deleteIcon: v,
    disabled: b = !1,
    icon: x,
    label: E,
    onClick: T,
    onDelete: P,
    onKeyDown: O,
    onKeyUp: k,
    size: I = "medium",
    variant: $ = "filled",
    tabIndex: _,
    skipFocusWhenDisabled: z = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = i, V = pe(i, oZ), M = C.useRef(null), A = Cn(M, o), W = (Z) => {
    Z.stopPropagation(), P && P(Z);
  }, Y = (Z) => {
    Z.currentTarget === Z.target && wD(Z) && Z.preventDefault(), O && O(Z);
  }, H = (Z) => {
    Z.currentTarget === Z.target && (P && wD(Z) ? P(Z) : Z.key === "Escape" && M.current && M.current.blur()), k && k(Z);
  }, G = f !== !1 && T ? !0 : f, ne = G || P ? Ao : h || "div", K = S({}, i, {
    component: ne,
    disabled: b,
    size: I,
    color: m,
    iconColor: /* @__PURE__ */ C.isValidElement(x) && x.props.color || m,
    onDelete: !!P,
    clickable: G,
    variant: $
  }), B = aZ(K), q = ne === Ao ? S({
    component: h || "div",
    focusVisibleClassName: B.focusVisible
  }, P && {
    disableRipple: !0
  }) : {};
  let X = null;
  P && (X = v && /* @__PURE__ */ C.isValidElement(v) ? /* @__PURE__ */ C.cloneElement(v, {
    className: be(v.props.className, B.deleteIcon),
    onClick: W
  }) : /* @__PURE__ */ L(tZ, {
    className: be(B.deleteIcon),
    onClick: W
  }));
  let J = null;
  s && /* @__PURE__ */ C.isValidElement(s) && (J = /* @__PURE__ */ C.cloneElement(s, {
    className: be(B.avatar, s.props.className)
  }));
  let U = null;
  return x && /* @__PURE__ */ C.isValidElement(x) && (U = /* @__PURE__ */ C.cloneElement(x, {
    className: be(B.icon, x.props.className)
  })), process.env.NODE_ENV !== "production" && J && U && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ ht(iZ, S({
    as: ne,
    className: be(B.root, c),
    disabled: G && b ? !0 : void 0,
    onClick: T,
    onKeyDown: Y,
    onKeyUp: H,
    ref: A,
    tabIndex: z && b ? -1 : _,
    ownerState: K
  }, q, V, {
    children: [J || U, /* @__PURE__ */ L(lZ, {
      className: be(B.label),
      ownerState: K,
      children: E
    }), X]
  }));
});
process.env.NODE_ENV !== "production" && (wF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The Avatar element to display.
   */
  avatar: n.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: bk,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: n.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: n.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Icon element.
   */
  icon: n.element,
  /**
   * The content of the component.
   */
  label: n.node,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @ignore
   */
  tabIndex: n.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined"]), n.string])
});
const EF = wF;
function Yc({
  props: e,
  states: t,
  muiFormControl: o
}) {
  return t.reduce((i, s) => (i[s] = e[s], o && typeof e[s] > "u" && (i[s] = o[s]), i), {});
}
const TF = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (TF.displayName = "FormControlContext");
const kx = TF;
function Xl() {
  return C.useContext(kx);
}
function Jk(e) {
  return /* @__PURE__ */ L(IL, S({}, e, {
    defaultTheme: wx,
    themeId: pd
  }));
}
process.env.NODE_ENV !== "production" && (Jk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The styles you want to apply globally.
   */
  styles: n.oneOfType([n.array, n.func, n.number, n.object, n.string, n.bool])
});
function ED(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function F1(e, t = !1) {
  return e && (ED(e.value) && e.value !== "" || t && ED(e.defaultValue) && e.defaultValue !== "");
}
function sZ(e) {
  return e.startAdornment;
}
function cZ(e) {
  return ot("MuiInputBase", e);
}
const uZ = lt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), Ni = uZ, dZ = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], Px = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.formControl && t.formControl, o.startAdornment && t.adornedStart, o.endAdornment && t.adornedEnd, o.error && t.error, o.size === "small" && t.sizeSmall, o.multiline && t.multiline, o.color && t[`color${ve(o.color)}`], o.fullWidth && t.fullWidth, o.hiddenLabel && t.hiddenLabel];
}, Mx = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.input, o.size === "small" && t.inputSizeSmall, o.multiline && t.inputMultiline, o.type === "search" && t.inputTypeSearch, o.startAdornment && t.inputAdornedStart, o.endAdornment && t.inputAdornedEnd, o.hiddenLabel && t.inputHiddenLabel];
}, fZ = (e) => {
  const {
    classes: t,
    color: o,
    disabled: i,
    error: s,
    endAdornment: c,
    focused: f,
    formControl: m,
    fullWidth: h,
    hiddenLabel: v,
    multiline: b,
    readOnly: x,
    size: E,
    startAdornment: T,
    type: P
  } = e, O = {
    root: ["root", `color${ve(o)}`, i && "disabled", s && "error", h && "fullWidth", f && "focused", m && "formControl", E && E !== "medium" && `size${ve(E)}`, b && "multiline", T && "adornedStart", c && "adornedEnd", v && "hiddenLabel", x && "readOnly"],
    input: ["input", i && "disabled", P === "search" && "inputTypeSearch", b && "inputMultiline", E === "small" && "inputSizeSmall", v && "inputHiddenLabel", T && "inputAdornedStart", c && "inputAdornedEnd", x && "readOnly"]
  };
  return je(O, cZ, t);
}, Ix = se("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Px
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Ni.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && S({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), Nx = se("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Mx
})(({
  theme: e,
  ownerState: t
}) => {
  const o = e.palette.mode === "light", i = S({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: o ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), s = {
    opacity: "0 !important"
  }, c = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: o ? 0.42 : 0.5
  };
  return S({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": i,
    "&::-moz-placeholder": i,
    // Firefox 19+
    "&:-ms-input-placeholder": i,
    // IE11
    "&::-ms-input-placeholder": i,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Ni.formControl} &`]: {
      "&::-webkit-input-placeholder": s,
      "&::-moz-placeholder": s,
      // Firefox 19+
      "&:-ms-input-placeholder": s,
      // IE11
      "&::-ms-input-placeholder": s,
      // Edge
      "&:focus::-webkit-input-placeholder": c,
      "&:focus::-moz-placeholder": c,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": c,
      // IE11
      "&:focus::-ms-input-placeholder": c
      // Edge
    },
    [`&.${Ni.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), pZ = /* @__PURE__ */ L(Jk, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), OF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = dt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": c,
    autoComplete: f,
    autoFocus: m,
    className: h,
    components: v = {},
    componentsProps: b = {},
    defaultValue: x,
    disabled: E,
    disableInjectingGlobalStyles: T,
    endAdornment: P,
    fullWidth: O = !1,
    id: k,
    inputComponent: I = "input",
    inputProps: $ = {},
    inputRef: _,
    maxRows: z,
    minRows: V,
    multiline: M = !1,
    name: A,
    onBlur: W,
    onChange: Y,
    onClick: H,
    onFocus: G,
    onKeyDown: ne,
    onKeyUp: K,
    placeholder: B,
    readOnly: q,
    renderSuffix: X,
    rows: J,
    slotProps: U = {},
    slots: Z = {},
    startAdornment: ee,
    type: ie = "text",
    value: oe
  } = s, le = pe(s, dZ), de = $.value != null ? $.value : oe, {
    current: Ce
  } = C.useRef(de != null), me = C.useRef(), Oe = C.useCallback((Je) => {
    process.env.NODE_ENV !== "production" && Je && Je.nodeName !== "INPUT" && !Je.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), he = Cn(me, _, $.ref, Oe), [$e, Ne] = C.useState(!1), Pe = Xl();
  process.env.NODE_ENV !== "production" && C.useEffect(() => {
    if (Pe)
      return Pe.registerEffect();
  }, [Pe]);
  const Se = Yc({
    props: s,
    muiFormControl: Pe,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Se.focused = Pe ? Pe.focused : $e, C.useEffect(() => {
    !Pe && E && $e && (Ne(!1), W && W());
  }, [Pe, E, $e, W]);
  const Fe = Pe && Pe.onFilled, ce = Pe && Pe.onEmpty, ge = C.useCallback((Je) => {
    F1(Je) ? Fe && Fe() : ce && ce();
  }, [Fe, ce]);
  Hn(() => {
    Ce && ge({
      value: de
    });
  }, [de, ge, Ce]);
  const we = (Je) => {
    if (Se.disabled) {
      Je.stopPropagation();
      return;
    }
    G && G(Je), $.onFocus && $.onFocus(Je), Pe && Pe.onFocus ? Pe.onFocus(Je) : Ne(!0);
  }, Me = (Je) => {
    W && W(Je), $.onBlur && $.onBlur(Je), Pe && Pe.onBlur ? Pe.onBlur(Je) : Ne(!1);
  }, Qe = (Je, ...pt) => {
    if (!Ce) {
      const At = Je.target || me.current;
      if (At == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : gi(1));
      ge({
        value: At.value
      });
    }
    $.onChange && $.onChange(Je, ...pt), Y && Y(Je, ...pt);
  };
  C.useEffect(() => {
    ge(me.current);
  }, []);
  const ct = (Je) => {
    me.current && Je.currentTarget === Je.target && me.current.focus(), H && H(Je);
  };
  let Ze = I, Ge = $;
  M && Ze === "input" && (J ? (process.env.NODE_ENV !== "production" && (V || z) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ge = S({
    type: void 0,
    minRows: J,
    maxRows: J
  }, Ge)) : Ge = S({
    type: void 0,
    maxRows: z,
    minRows: V
  }, Ge), Ze = CF);
  const Be = (Je) => {
    ge(Je.animationName === "mui-auto-fill-cancel" ? me.current : {
      value: "x"
    });
  };
  C.useEffect(() => {
    Pe && Pe.setAdornedStart(!!ee);
  }, [Pe, ee]);
  const rt = S({}, s, {
    color: Se.color || "primary",
    disabled: Se.disabled,
    endAdornment: P,
    error: Se.error,
    focused: Se.focused,
    formControl: Pe,
    fullWidth: O,
    hiddenLabel: Se.hiddenLabel,
    multiline: M,
    size: Se.size,
    startAdornment: ee,
    type: ie
  }), wt = fZ(rt), We = Z.root || v.Root || Ix, ut = U.root || b.root || {}, ft = Z.input || v.Input || Nx;
  return Ge = S({}, Ge, (i = U.input) != null ? i : b.input), /* @__PURE__ */ ht(C.Fragment, {
    children: [!T && pZ, /* @__PURE__ */ ht(We, S({}, ut, !Ul(We) && {
      ownerState: S({}, rt, ut.ownerState)
    }, {
      ref: o,
      onClick: ct
    }, le, {
      className: be(wt.root, ut.className, h, q && "MuiInputBase-readOnly"),
      children: [ee, /* @__PURE__ */ L(kx.Provider, {
        value: null,
        children: /* @__PURE__ */ L(ft, S({
          ownerState: rt,
          "aria-invalid": Se.error,
          "aria-describedby": c,
          autoComplete: f,
          autoFocus: m,
          defaultValue: x,
          disabled: Se.disabled,
          id: k,
          onAnimationStart: Be,
          name: A,
          placeholder: B,
          readOnly: q,
          required: Se.required,
          rows: J,
          value: de,
          onKeyDown: ne,
          onKeyUp: K,
          type: ie
        }, Ge, !Ul(ft) && {
          as: Ze,
          ownerState: S({}, rt, Ge.ownerState)
        }, {
          ref: he,
          className: be(wt.input, Ge.className, q && "MuiInputBase-readOnly"),
          onBlur: Me,
          onChange: Qe,
          onFocus: we
        }))
      }), P, X ? X(S({}, Se, {
        startAdornment: ee
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (OF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  "aria-describedby": n.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: dd,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: n.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onKeyUp: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * @ignore
   */
  renderSuffix: n.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The size of the component.
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
const Gh = OF;
function mZ(e) {
  return ot("MuiInput", e);
}
const hZ = S({}, Ni, lt("MuiInput", ["root", "underline", "input"])), ad = hZ;
function gZ(e) {
  return ot("MuiOutlinedInput", e);
}
const vZ = S({}, Ni, lt("MuiOutlinedInput", ["root", "notchedOutline", "input"])), $s = vZ;
function bZ(e) {
  return ot("MuiFilledInput", e);
}
const yZ = S({}, Ni, lt("MuiFilledInput", ["root", "underline", "input"])), $i = yZ, eP = rn(/* @__PURE__ */ L("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function CZ(e) {
  return ot("MuiAutocomplete", e);
}
const SZ = lt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]), Nn = SZ;
var TD, OD;
const xZ = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], wZ = ["ref"], EZ = (e) => {
  const {
    classes: t,
    disablePortal: o,
    expanded: i,
    focused: s,
    fullWidth: c,
    hasClearIcon: f,
    hasPopupIcon: m,
    inputFocused: h,
    popupOpen: v,
    size: b
  } = e, x = {
    root: ["root", i && "expanded", s && "focused", c && "fullWidth", f && "hasClearIcon", m && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", h && "inputFocused"],
    tag: ["tag", `tagSize${ve(b)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", v && "popupIndicatorOpen"],
    popper: ["popper", o && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return je(x, CZ, t);
}, TZ = se("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      fullWidth: i,
      hasClearIcon: s,
      hasPopupIcon: c,
      inputFocused: f,
      size: m
    } = o;
    return [{
      [`& .${Nn.tag}`]: t.tag
    }, {
      [`& .${Nn.tag}`]: t[`tagSize${ve(m)}`]
    }, {
      [`& .${Nn.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Nn.input}`]: t.input
    }, {
      [`& .${Nn.input}`]: f && t.inputFocused
    }, t.root, i && t.fullWidth, c && t.hasPopupIcon, s && t.hasClearIcon];
  }
})(({
  ownerState: e
}) => S({
  [`&.${Nn.focused} .${Nn.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Nn.clearIndicator}`]: {
      visibility: "visible"
    }
  }
}, e.fullWidth && {
  width: "100%"
}, {
  [`& .${Nn.tag}`]: S({
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  }, e.size === "small" && {
    margin: 2,
    maxWidth: "calc(100% - 4px)"
  }),
  [`& .${Nn.inputRoot}`]: {
    flexWrap: "wrap",
    [`.${Nn.hasPopupIcon}&, .${Nn.hasClearIcon}&`]: {
      paddingRight: 26 + 4
    },
    [`.${Nn.hasPopupIcon}.${Nn.hasClearIcon}&`]: {
      paddingRight: 52 + 4
    },
    [`& .${Nn.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${ad.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${ad.root}.${Ni.sizeSmall}`]: {
    [`& .${ad.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${$s.root}`]: {
    padding: 9,
    [`.${Nn.hasPopupIcon}&, .${Nn.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${Nn.hasPopupIcon}.${Nn.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${Nn.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Nn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${$s.root}.${Ni.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Nn.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${$i.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Nn.hasPopupIcon}&, .${Nn.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${Nn.hasPopupIcon}.${Nn.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${$i.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Nn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${$i.root}.${Ni.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${$i.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Ni.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${$i.root}.${Ni.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Nn.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${$i.root}.${Ni.hiddenLabel}.${Ni.sizeSmall}`]: {
    [`& .${Nn.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Nn.input}`]: S({
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  }, e.inputFocused && {
    opacity: 1
  })
})), OZ = se("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "calc(50% - 14px)"
  // Center vertically
}), RZ = se(As, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), kZ = se(As, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => S({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})(({
  ownerState: e
}) => S({
  padding: 2,
  marginRight: -2
}, e.popupOpen && {
  transform: "rotate(180deg)"
})), PZ = se(cp, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Nn.option}`]: t.option
    }, t.popper, o.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: (e.vars || e).zIndex.modal
}, t.disablePortal && {
  position: "absolute"
})), MZ = se(Ci, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => S({}, e.typography.body1, {
  overflow: "auto"
})), IZ = se("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), NZ = se("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), $Z = se("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Nn.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Nn.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Nn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Nn.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Nn.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), DZ = se(eZ, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), _Z = se("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Nn.option}`]: {
    paddingLeft: 24
  }
}), RF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f;
  const m = dt({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: h = !1,
    autoHighlight: v = !1,
    autoSelect: b = !1,
    blurOnSelect: x = !1,
    ChipProps: E,
    className: T,
    clearIcon: P = TD || (TD = /* @__PURE__ */ L(oF, {
      fontSize: "small"
    })),
    clearOnBlur: O = !m.freeSolo,
    clearOnEscape: k = !1,
    clearText: I = "Clear",
    closeText: $ = "Close",
    componentsProps: _ = {},
    defaultValue: z = m.multiple ? [] : null,
    disableClearable: V = !1,
    disableCloseOnSelect: M = !1,
    disabled: A = !1,
    disabledItemsFocusable: W = !1,
    disableListWrap: Y = !1,
    disablePortal: H = !1,
    filterSelectedOptions: G = !1,
    forcePopupIcon: ne = "auto",
    freeSolo: K = !1,
    fullWidth: B = !1,
    getLimitTagsText: q = (ze) => `+${ze}`,
    getOptionLabel: X,
    groupBy: J,
    handleHomeEndKeys: U = !m.freeSolo,
    includeInputInList: Z = !1,
    limitTags: ee = -1,
    ListboxComponent: ie = "ul",
    ListboxProps: oe,
    loading: le = !1,
    loadingText: de = "Loading…",
    multiple: Ce = !1,
    noOptionsText: me = "No options",
    openOnFocus: Oe = !1,
    openText: he = "Open",
    PaperComponent: $e = Ci,
    PopperComponent: Ne = cp,
    popupIcon: Pe = OD || (OD = /* @__PURE__ */ L(eP, {})),
    readOnly: Se = !1,
    renderGroup: Fe,
    renderInput: ce,
    renderOption: ge,
    renderTags: we,
    selectOnFocus: Me = !m.freeSolo,
    size: Qe = "medium",
    slotProps: ct = {}
  } = m, Ze = pe(m, xZ), {
    getRootProps: Ge,
    getInputProps: Be,
    getInputLabelProps: rt,
    getPopupIndicatorProps: wt,
    getClearProps: We,
    getTagProps: ut,
    getListboxProps: ft,
    getOptionProps: Je,
    value: pt,
    dirty: At,
    expanded: Ye,
    id: st,
    popupOpen: _e,
    focused: vt,
    focusedTag: et,
    anchorEl: gt,
    setAnchorEl: kt,
    inputValue: Lt,
    groupedOptions: Ut
  } = WQ(S({}, m, {
    componentName: "Autocomplete"
  })), Sn = !V && !A && At && !Se, an = (!K || ne === !0) && ne !== !1, {
    onMouseDown: un
  } = Be(), {
    ref: wn
  } = oe ?? {}, hn = ft(), {
    ref: Br
  } = hn, zo = pe(hn, wZ), wo = Cn(Br, wn), Dr = X || ((ze) => {
    var mt;
    return (mt = ze.label) != null ? mt : ze;
  }), Vn = S({}, m, {
    disablePortal: H,
    expanded: Ye,
    focused: vt,
    fullWidth: B,
    getOptionLabel: Dr,
    hasClearIcon: Sn,
    hasPopupIcon: an,
    inputFocused: et === -1,
    popupOpen: _e,
    size: Qe
  }), Dn = EZ(Vn);
  let Zn;
  if (Ce && pt.length > 0) {
    const ze = (mt) => S({
      className: Dn.tag,
      disabled: A
    }, ut(mt));
    we ? Zn = we(pt, ze, Vn) : Zn = pt.map((mt, Ct) => /* @__PURE__ */ L(EF, S({
      label: Dr(mt),
      size: Qe
    }, ze({
      index: Ct
    }), E)));
  }
  if (ee > -1 && Array.isArray(Zn)) {
    const ze = Zn.length - ee;
    !vt && ze > 0 && (Zn = Zn.splice(0, ee), Zn.push(/* @__PURE__ */ L("span", {
      className: Dn.tag,
      children: q(ze)
    }, Zn.length)));
  }
  const ur = Fe || ((ze) => /* @__PURE__ */ ht("li", {
    children: [/* @__PURE__ */ L(DZ, {
      className: Dn.groupLabel,
      ownerState: Vn,
      component: "div",
      children: ze.group
    }), /* @__PURE__ */ L(_Z, {
      className: Dn.groupUl,
      ownerState: Vn,
      children: ze.children
    })]
  }, ze.key)), xr = ge || ((ze, mt) => /* @__PURE__ */ L("li", S({}, ze, {
    children: Dr(mt)
  }))), fe = (ze, mt) => {
    const Ct = Je({
      option: ze,
      index: mt
    });
    return xr(S({}, Ct, {
      className: Dn.option
    }), ze, {
      selected: Ct["aria-selected"],
      index: mt,
      inputValue: Lt
    }, Vn);
  }, at = (i = ct.clearIndicator) != null ? i : _.clearIndicator, Et = (s = ct.paper) != null ? s : _.paper, Ie = (c = ct.popper) != null ? c : _.popper, xe = (f = ct.popupIndicator) != null ? f : _.popupIndicator;
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(TZ, S({
      ref: o,
      className: be(Dn.root, T),
      ownerState: Vn
    }, Ge(Ze), {
      children: ce({
        id: st,
        disabled: A,
        fullWidth: !0,
        size: Qe === "small" ? "small" : void 0,
        InputLabelProps: rt(),
        InputProps: S({
          ref: kt,
          className: Dn.inputRoot,
          startAdornment: Zn,
          onClick: (ze) => {
            ze.target === ze.currentTarget && un(ze);
          }
        }, (Sn || an) && {
          endAdornment: /* @__PURE__ */ ht(OZ, {
            className: Dn.endAdornment,
            ownerState: Vn,
            children: [Sn ? /* @__PURE__ */ L(RZ, S({}, We(), {
              "aria-label": I,
              title: I,
              ownerState: Vn
            }, at, {
              className: be(Dn.clearIndicator, at == null ? void 0 : at.className),
              children: P
            })) : null, an ? /* @__PURE__ */ L(kZ, S({}, wt(), {
              disabled: A,
              "aria-label": _e ? $ : he,
              title: _e ? $ : he,
              ownerState: Vn
            }, xe, {
              className: be(Dn.popupIndicator, xe == null ? void 0 : xe.className),
              children: Pe
            })) : null]
          })
        }),
        inputProps: S({
          className: Dn.input,
          disabled: A,
          readOnly: Se
        }, Be())
      })
    })), gt ? /* @__PURE__ */ L(PZ, S({
      as: Ne,
      disablePortal: H,
      style: {
        width: gt ? gt.clientWidth : null
      },
      ownerState: Vn,
      role: "presentation",
      anchorEl: gt,
      open: _e
    }, Ie, {
      className: be(Dn.popper, Ie == null ? void 0 : Ie.className),
      children: /* @__PURE__ */ ht(MZ, S({
        ownerState: Vn,
        as: $e
      }, Et, {
        className: be(Dn.paper, Et == null ? void 0 : Et.className),
        children: [le && Ut.length === 0 ? /* @__PURE__ */ L(IZ, {
          className: Dn.loading,
          ownerState: Vn,
          children: de
        }) : null, Ut.length === 0 && !K && !le ? /* @__PURE__ */ L(NZ, {
          className: Dn.noOptions,
          ownerState: Vn,
          role: "presentation",
          onMouseDown: (ze) => {
            ze.preventDefault();
          },
          children: me
        }) : null, Ut.length > 0 ? /* @__PURE__ */ L($Z, S({
          as: ie,
          className: Dn.listbox,
          ownerState: Vn
        }, zo, oe, {
          ref: wo,
          children: Ut.map((ze, mt) => J ? ur({
            key: ze.key,
            group: ze.group,
            children: ze.options.map((Ct, Qt) => fe(Ct, ze.index + Qt))
          }) : fe(ze, mt))
        })) : null]
      }))
    })) : null]
  });
});
process.env.NODE_ENV !== "production" && (RF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: n.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: n.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: n.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: n.oneOfType([n.oneOf(["mouse", "touch"]), n.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: n.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: n.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: n.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: n.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: n.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: n.shape({
    clearIndicator: n.object,
    paper: n.object,
    popper: n.object,
    popupIndicator: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: co(n.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: n.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: n.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: n.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: n.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: n.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: n.oneOfType([n.oneOf(["auto"]), n.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: n.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: n.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: n.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: n.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: n.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: n.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: n.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: n.bool,
  /**
   * The input value.
   */
  inputValue: n.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: n.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: eo,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: n.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: n.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, e.g. `options` are empty).
   * @default false
   */
  loading: n.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: n.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: n.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: n.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: n.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: n.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: n.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: n.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: n.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: n.string,
  /**
   * Array of options.
   */
  options: n.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: n.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: n.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: n.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: n.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: n.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: n.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: n.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: n.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium"]), n.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    clearIndicator: n.object,
    paper: n.object,
    popper: n.object,
    popupIndicator: n.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: co(n.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const kF = RF, AZ = rn(/* @__PURE__ */ L("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function LZ(e) {
  return ot("MuiAvatar", e);
}
const FZ = lt("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]), zZ = FZ, VZ = ["alt", "children", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"], BZ = (e) => {
  const {
    classes: t,
    variant: o,
    colorDefault: i
  } = e;
  return je({
    root: ["root", o, i && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, LZ, t);
}, jZ = se("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], o.colorDefault && t.colorDefault];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none"
}, t.variant === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "square" && {
  borderRadius: 0
}, t.colorDefault && S({
  color: (e.vars || e).palette.background.default
}, e.vars ? {
  backgroundColor: e.vars.palette.Avatar.defaultBg
} : {
  backgroundColor: e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[600]
}))), HZ = se("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), UZ = se(AZ, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function GZ({
  crossOrigin: e,
  referrerPolicy: t,
  src: o,
  srcSet: i
}) {
  const [s, c] = C.useState(!1);
  return C.useEffect(() => {
    if (!o && !i)
      return;
    c(!1);
    let f = !0;
    const m = new Image();
    return m.onload = () => {
      f && c("loaded");
    }, m.onerror = () => {
      f && c("error");
    }, m.crossOrigin = e, m.referrerPolicy = t, m.src = o, i && (m.srcset = i), () => {
      f = !1;
    };
  }, [e, t, o, i]), s;
}
const PF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: s,
    children: c,
    className: f,
    component: m = "div",
    imgProps: h,
    sizes: v,
    src: b,
    srcSet: x,
    variant: E = "circular"
  } = i, T = pe(i, VZ);
  let P = null;
  const O = GZ(S({}, h, {
    src: b,
    srcSet: x
  })), k = b || x, I = k && O !== "error", $ = S({}, i, {
    colorDefault: !I,
    component: m,
    variant: E
  }), _ = BZ($);
  return I ? P = /* @__PURE__ */ L(HZ, S({
    alt: s,
    srcSet: x,
    src: b,
    sizes: v,
    ownerState: $,
    className: _.img
  }, h)) : c != null ? P = c : k && s ? P = s[0] : P = /* @__PURE__ */ L(UZ, {
    ownerState: $,
    className: _.fallback
  }), /* @__PURE__ */ L(jZ, S({
    as: m,
    ownerState: $,
    className: be(_.root, f),
    ref: o
  }, T, {
    children: P
  }));
});
process.env.NODE_ENV !== "production" && (PF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: n.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   */
  imgProps: n.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: n.string,
  /**
   * The `src` attribute for the `img` element.
   */
  src: n.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rounded", "square"]), n.string])
});
const WZ = PF;
function qZ(e) {
  return ot("MuiAvatarGroup", e);
}
const YZ = lt("MuiAvatarGroup", ["root", "avatar"]), KZ = YZ, XZ = ["children", "className", "component", "componentsProps", "max", "slotProps", "spacing", "total", "variant"], RD = {
  small: -16,
  medium: null
}, QZ = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    avatar: ["avatar"]
  }, qZ, t);
}, ZZ = se("div", {
  name: "MuiAvatarGroup",
  slot: "Root",
  overridesResolver: (e, t) => S({
    [`& .${KZ.avatar}`]: t.avatar
  }, t.root)
})(({
  theme: e
}) => ({
  [`& .${zZ.root}`]: {
    border: `2px solid ${(e.vars || e).palette.background.default}`,
    boxSizing: "content-box",
    marginLeft: -8,
    "&:last-child": {
      marginLeft: 0
    }
  },
  display: "flex",
  flexDirection: "row-reverse"
})), JZ = se(WZ, {
  name: "MuiAvatarGroup",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})(({
  theme: e
}) => ({
  border: `2px solid ${(e.vars || e).palette.background.default}`,
  boxSizing: "content-box",
  marginLeft: -8,
  "&:last-child": {
    marginLeft: 0
  }
})), MF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = dt({
    props: t,
    name: "MuiAvatarGroup"
  }), {
    children: c,
    className: f,
    component: m = "div",
    componentsProps: h = {},
    max: v = 5,
    slotProps: b = {},
    spacing: x = "medium",
    total: E,
    variant: T = "circular"
  } = s, P = pe(s, XZ);
  let O = v < 2 ? 2 : v;
  const k = S({}, s, {
    max: v,
    spacing: x,
    component: m,
    variant: T
  }), I = QZ(k), $ = C.Children.toArray(c).filter((W) => (process.env.NODE_ENV !== "production" && Kl.isFragment(W) && console.error(["MUI: The AvatarGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ C.isValidElement(W))), _ = E || $.length;
  _ === O && (O += 1), O = Math.min(_ + 1, O);
  const z = Math.min($.length, O - 1), V = Math.max(_ - O, _ - z, 0), M = x && RD[x] !== void 0 ? RD[x] : -x, A = (i = b.additionalAvatar) != null ? i : h.additionalAvatar;
  return /* @__PURE__ */ ht(ZZ, S({
    as: m,
    ownerState: k,
    className: be(I.root, f),
    ref: o
  }, P, {
    children: [V ? /* @__PURE__ */ ht(JZ, S({
      ownerState: k,
      variant: T
    }, A, {
      className: be(I.avatar, A == null ? void 0 : A.className),
      style: S({
        marginLeft: M
      }, A == null ? void 0 : A.style),
      children: ["+", V]
    })) : null, $.slice(0, z).reverse().map((W, Y) => /* @__PURE__ */ C.cloneElement(W, {
      className: be(W.props.className, I.avatar),
      style: S({
        // Consistent with "&:last-child" styling for the default spacing,
        // we do not apply custom marginLeft spacing on the last child
        marginLeft: Y === z - 1 ? void 0 : M
      }, W.props.style),
      variant: W.props.variant || T
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (MF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The avatars to stack.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    additionalAvatar: n.object
  }),
  /**
   * Max avatars to show before +x.
   * @default 5
   */
  max: co(n.number, (e) => e.max < 2 ? new Error(["MUI: The prop `max` should be equal to 2 or above.", "A value below is clamped to 2."].join(`
`)) : null),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    additionalAvatar: n.object
  }),
  /**
   * Spacing between avatars.
   * @default 'medium'
   */
  spacing: n.oneOfType([n.oneOf(["medium", "small"]), n.number]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */
  total: n.number,
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rounded", "square"]), n.string])
});
const _Se = MF, eJ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], tJ = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, IF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = mr(), s = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: c,
    appear: f = !0,
    children: m,
    easing: h,
    in: v,
    onEnter: b,
    onEntered: x,
    onEntering: E,
    onExit: T,
    onExited: P,
    onExiting: O,
    style: k,
    timeout: I = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = Oy
  } = t, _ = pe(t, eJ), z = C.useRef(null), V = Cn(z, m.ref, o), M = (B) => (q) => {
    if (B) {
      const X = z.current;
      q === void 0 ? B(X) : B(X, q);
    }
  }, A = M(E), W = M((B, q) => {
    Ex(B);
    const X = Yl({
      style: k,
      timeout: I,
      easing: h
    }, {
      mode: "enter"
    });
    B.style.webkitTransition = i.transitions.create("opacity", X), B.style.transition = i.transitions.create("opacity", X), b && b(B, q);
  }), Y = M(x), H = M(O), G = M((B) => {
    const q = Yl({
      style: k,
      timeout: I,
      easing: h
    }, {
      mode: "exit"
    });
    B.style.webkitTransition = i.transitions.create("opacity", q), B.style.transition = i.transitions.create("opacity", q), T && T(B);
  }), ne = M(P);
  return /* @__PURE__ */ L($, S({
    appear: f,
    in: v,
    nodeRef: z,
    onEnter: W,
    onEntered: Y,
    onEntering: A,
    onExit: G,
    onExited: ne,
    onExiting: H,
    addEndListener: (B) => {
      c && c(z.current, B);
    },
    timeout: I
  }, _, {
    children: (B, q) => /* @__PURE__ */ C.cloneElement(m, S({
      style: S({
        opacity: 0,
        visibility: B === "exited" && !v ? "hidden" : void 0
      }, tJ[B], k, m.props.style),
      ref: V
    }, q))
  }));
});
process.env.NODE_ENV !== "production" && (IF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: vd.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
const NF = IF;
function nJ(e) {
  return ot("MuiBackdrop", e);
}
const rJ = lt("MuiBackdrop", ["root", "invisible"]), ASe = rJ, oJ = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], aJ = (e) => {
  const {
    classes: t,
    invisible: o
  } = e;
  return je({
    root: ["root", o && "invisible"]
  }, nJ, t);
}, iJ = se("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => S({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), $F = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c;
  const f = dt({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: m,
    className: h,
    component: v = "div",
    components: b = {},
    componentsProps: x = {},
    invisible: E = !1,
    open: T,
    slotProps: P = {},
    slots: O = {},
    TransitionComponent: k = NF,
    transitionDuration: I
  } = f, $ = pe(f, oJ), _ = S({}, f, {
    component: v,
    invisible: E
  }), z = aJ(_), V = (i = P.root) != null ? i : x.root;
  return /* @__PURE__ */ L(k, S({
    in: T,
    timeout: I
  }, $, {
    children: /* @__PURE__ */ L(iJ, S({
      "aria-hidden": !0
    }, V, {
      as: (s = (c = O.root) != null ? c : b.Root) != null ? s : v,
      className: be(z.root, h, V == null ? void 0 : V.className),
      ownerState: S({}, _, V == null ? void 0 : V.ownerState),
      classes: z,
      ref: o,
      children: m
    }))
  }));
});
process.env.NODE_ENV !== "production" && ($F.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    root: n.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: n.bool,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
const DF = $F;
function lJ(e) {
  return ot("MuiBadge", e);
}
const sJ = lt("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), Ku = sJ, cJ = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], GO = 10, WO = 4, uJ = (e) => {
  const {
    color: t,
    anchorOrigin: o,
    invisible: i,
    overlap: s,
    variant: c,
    classes: f = {}
  } = e, m = {
    root: ["root"],
    badge: ["badge", c, i && "invisible", `anchorOrigin${ve(o.vertical)}${ve(o.horizontal)}`, `anchorOrigin${ve(o.vertical)}${ve(o.horizontal)}${ve(s)}`, `overlap${ve(s)}`, t !== "default" && `color${ve(t)}`]
  };
  return je(m, lJ, f);
}, dJ = se("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), fJ = se("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.badge, t[o.variant], t[`anchorOrigin${ve(o.anchorOrigin.vertical)}${ve(o.anchorOrigin.horizontal)}${ve(o.overlap)}`], o.color !== "default" && t[`color${ve(o.color)}`], o.invisible && t.invisible];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: GO * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: GO * 2,
  borderRadius: GO,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  })
}, t.color !== "default" && {
  backgroundColor: (e.vars || e).palette[t.color].main,
  color: (e.vars || e).palette[t.color].contrastText
}, t.variant === "dot" && {
  borderRadius: WO,
  height: WO * 2,
  minWidth: WO * 2,
  padding: 0
}, t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular" && {
  top: 0,
  right: 0,
  transform: "scale(1) translate(50%, -50%)",
  transformOrigin: "100% 0%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(50%, -50%)"
  }
}, t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular" && {
  bottom: 0,
  right: 0,
  transform: "scale(1) translate(50%, 50%)",
  transformOrigin: "100% 100%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(50%, 50%)"
  }
}, t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular" && {
  top: 0,
  left: 0,
  transform: "scale(1) translate(-50%, -50%)",
  transformOrigin: "0% 0%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(-50%, -50%)"
  }
}, t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular" && {
  bottom: 0,
  left: 0,
  transform: "scale(1) translate(-50%, 50%)",
  transformOrigin: "0% 100%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(-50%, 50%)"
  }
}, t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular" && {
  top: "14%",
  right: "14%",
  transform: "scale(1) translate(50%, -50%)",
  transformOrigin: "100% 0%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(50%, -50%)"
  }
}, t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular" && {
  bottom: "14%",
  right: "14%",
  transform: "scale(1) translate(50%, 50%)",
  transformOrigin: "100% 100%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(50%, 50%)"
  }
}, t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular" && {
  top: "14%",
  left: "14%",
  transform: "scale(1) translate(-50%, -50%)",
  transformOrigin: "0% 0%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(-50%, -50%)"
  }
}, t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular" && {
  bottom: "14%",
  left: "14%",
  transform: "scale(1) translate(-50%, 50%)",
  transformOrigin: "0% 100%",
  [`&.${Ku.invisible}`]: {
    transform: "scale(0) translate(-50%, 50%)"
  }
}, t.invisible && {
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.leavingScreen
  })
})), _F = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h;
  const v = dt({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: b = {
      vertical: "top",
      horizontal: "right"
    },
    className: x,
    component: E,
    components: T = {},
    componentsProps: P = {},
    children: O,
    overlap: k = "rectangular",
    color: I = "default",
    invisible: $ = !1,
    max: _ = 99,
    badgeContent: z,
    slots: V,
    slotProps: M,
    showZero: A = !1,
    variant: W = "standard"
  } = v, Y = pe(v, cJ), {
    badgeContent: H,
    invisible: G,
    max: ne,
    displayValue: K
  } = nX({
    max: _,
    invisible: $,
    badgeContent: z,
    showZero: A
  }), B = yk({
    anchorOrigin: b,
    color: I,
    overlap: k,
    variant: W,
    badgeContent: z
  }), q = G || H == null && W !== "dot", {
    color: X = I,
    overlap: J = k,
    anchorOrigin: U = b,
    variant: Z = W
  } = q ? B : v, ee = Z !== "dot" ? K : void 0, ie = S({}, v, {
    badgeContent: H,
    invisible: q,
    max: ne,
    displayValue: ee,
    showZero: A,
    anchorOrigin: U,
    color: X,
    overlap: J,
    variant: Z
  }), oe = uJ(ie), le = (i = (s = V == null ? void 0 : V.root) != null ? s : T.Root) != null ? i : dJ, de = (c = (f = V == null ? void 0 : V.badge) != null ? f : T.Badge) != null ? c : fJ, Ce = (m = M == null ? void 0 : M.root) != null ? m : P.root, me = (h = M == null ? void 0 : M.badge) != null ? h : P.badge, Oe = Gr({
    elementType: le,
    externalSlotProps: Ce,
    externalForwardedProps: Y,
    additionalProps: {
      ref: o,
      as: E
    },
    ownerState: ie,
    className: be(Ce == null ? void 0 : Ce.className, oe.root, x)
  }), he = Gr({
    elementType: de,
    externalSlotProps: me,
    ownerState: ie,
    className: be(oe.badge, me == null ? void 0 : me.className)
  });
  return /* @__PURE__ */ ht(le, S({}, Oe, {
    children: [O, /* @__PURE__ */ L(de, S({}, he, {
      children: ee
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (_F.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOf(["left", "right"]).isRequired,
    vertical: n.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: n.node,
  /**
   * The badge will be added relative to this node.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Badge: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    badge: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: n.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: n.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: n.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: n.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: n.shape({
    badge: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    badge: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["dot", "standard"]), n.string])
});
const AF = _F;
function pJ(e) {
  return ot("MuiBottomNavigation", e);
}
const mJ = lt("MuiBottomNavigation", ["root"]), LSe = mJ, hJ = ["children", "className", "component", "onChange", "showLabels", "value"], gJ = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, pJ, t);
}, vJ = se("div", {
  name: "MuiBottomNavigation",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  height: 56,
  backgroundColor: (e.vars || e).palette.background.paper
})), LF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiBottomNavigation"
  }), {
    children: s,
    className: c,
    component: f = "div",
    onChange: m,
    showLabels: h = !1,
    value: v
  } = i, b = pe(i, hJ), x = S({}, i, {
    component: f,
    showLabels: h
  }), E = gJ(x);
  return /* @__PURE__ */ L(vJ, S({
    as: f,
    className: be(E.root, c),
    ref: o,
    ownerState: x
  }, b, {
    children: C.Children.map(s, (T, P) => {
      if (!/* @__PURE__ */ C.isValidElement(T))
        return null;
      process.env.NODE_ENV !== "production" && Kl.isFragment(T) && console.error(["MUI: The BottomNavigation component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
      const O = T.props.value === void 0 ? P : T.props.value;
      return /* @__PURE__ */ C.cloneElement(T, {
        selected: O === v,
        showLabel: T.props.showLabel !== void 0 ? T.props.showLabel : h,
        value: O,
        onChange: m
      });
    })
  }));
});
process.env.NODE_ENV !== "production" && (LF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child.
   */
  onChange: n.func,
  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   * @default false
   */
  showLabels: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: n.any
});
const FSe = LF;
function bJ(e) {
  return ot("MuiBottomNavigationAction", e);
}
const yJ = lt("MuiBottomNavigationAction", ["root", "iconOnly", "selected", "label"]), FF = yJ, CJ = ["className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"], SJ = (e) => {
  const {
    classes: t,
    showLabel: o,
    selected: i
  } = e;
  return je({
    root: ["root", !o && !i && "iconOnly", i && "selected"],
    label: ["label", !o && !i && "iconOnly", i && "selected"]
  }, bJ, t);
}, xJ = se(Ao, {
  name: "MuiBottomNavigationAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.showLabel && !o.selected && t.iconOnly];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  transition: e.transitions.create(["color", "padding-top"], {
    duration: e.transitions.duration.short
  }),
  padding: "0px 12px",
  minWidth: 80,
  maxWidth: 168,
  color: (e.vars || e).palette.text.secondary,
  flexDirection: "column",
  flex: "1"
}, !t.showLabel && !t.selected && {
  paddingTop: 14
}, !t.showLabel && !t.selected && !t.label && {
  paddingTop: 0
}, {
  [`&.${FF.selected}`]: {
    color: (e.vars || e).palette.primary.main
  }
})), wJ = se("span", {
  name: "MuiBottomNavigationAction",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e,
  ownerState: t
}) => S({
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(12),
  opacity: 1,
  transition: "font-size 0.2s, opacity 0.2s",
  transitionDelay: "0.1s"
}, !t.showLabel && !t.selected && {
  opacity: 0,
  transitionDelay: "0s"
}, {
  [`&.${FF.selected}`]: {
    fontSize: e.typography.pxToRem(14)
  }
})), zF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiBottomNavigationAction"
  }), {
    className: s,
    icon: c,
    label: f,
    onChange: m,
    onClick: h,
    value: v
  } = i, b = pe(i, CJ), x = i, E = SJ(x), T = (P) => {
    m && m(P, v), h && h(P);
  };
  return /* @__PURE__ */ ht(xJ, S({
    ref: o,
    className: be(E.root, s),
    focusRipple: !0,
    onClick: T,
    ownerState: x
  }, b, {
    children: [c, /* @__PURE__ */ L(wJ, {
      className: E.label,
      ownerState: x,
      children: f
    })]
  }));
});
process.env.NODE_ENV !== "production" && (zF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: bk,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display.
   */
  icon: n.node,
  /**
   * The label element.
   */
  label: n.node,
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   *
   * The prop defaults to the value (`false`) inherited from the parent BottomNavigation component.
   */
  showLabel: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: n.any
});
const zSe = zF, EJ = Jf(), VF = E7({
  themeId: pd,
  defaultTheme: EJ,
  defaultClassName: "MuiBox-root",
  generateClassName: Sk.generate
});
process.env.NODE_ENV !== "production" && (VF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: n.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const VSe = VF, TJ = rn(/* @__PURE__ */ L("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), OJ = ["slots", "slotProps"], RJ = se(Ao)(({
  theme: e
}) => S({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`
}, e.palette.mode === "light" ? {
  backgroundColor: e.palette.grey[100],
  color: e.palette.grey[700]
} : {
  backgroundColor: e.palette.grey[700],
  color: e.palette.grey[100]
}, {
  borderRadius: 2,
  "&:hover, &:focus": S({}, e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[200]
  } : {
    backgroundColor: e.palette.grey[600]
  }),
  "&:active": S({
    boxShadow: e.shadows[0]
  }, e.palette.mode === "light" ? {
    backgroundColor: M1(e.palette.grey[200], 0.12)
  } : {
    backgroundColor: M1(e.palette.grey[600], 0.12)
  })
})), kJ = se(TJ)({
  width: 24,
  height: 16
});
function BF(e) {
  const {
    slots: t = {},
    slotProps: o = {}
  } = e, i = pe(e, OJ), s = e;
  return /* @__PURE__ */ L("li", {
    children: /* @__PURE__ */ L(RJ, S({
      focusRipple: !0
    }, i, {
      ownerState: s,
      children: /* @__PURE__ */ L(kJ, S({
        as: t.CollapsedIcon,
        ownerState: s
      }, o.collapsedIcon))
    }))
  });
}
process.env.NODE_ENV !== "production" && (BF.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: n.shape({
    collapsedIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    CollapsedIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.object
});
function PJ(e) {
  return ot("MuiBreadcrumbs", e);
}
const MJ = lt("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), IJ = MJ, NJ = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"], $J = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, PJ, t);
}, DJ = se(Ea, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${IJ.li}`]: t.li
  }, t.root]
})({}), _J = se("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), AJ = se("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function LJ(e, t, o, i) {
  return e.reduce((s, c, f) => (f < e.length - 1 ? s = s.concat(c, /* @__PURE__ */ L(AJ, {
    "aria-hidden": !0,
    className: t,
    ownerState: i,
    children: o
  }, `separator-${f}`)) : s.push(c), s), []);
}
const jF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: s,
    className: c,
    component: f = "nav",
    slots: m = {},
    slotProps: h = {},
    expandText: v = "Show path",
    itemsAfterCollapse: b = 1,
    itemsBeforeCollapse: x = 1,
    maxItems: E = 8,
    separator: T = "/"
  } = i, P = pe(i, NJ), [O, k] = C.useState(!1), I = S({}, i, {
    component: f,
    expanded: O,
    expandText: v,
    itemsAfterCollapse: b,
    itemsBeforeCollapse: x,
    maxItems: E,
    separator: T
  }), $ = $J(I), _ = Gr({
    elementType: m.CollapsedIcon,
    externalSlotProps: h.collapsedIcon,
    ownerState: I
  }), z = C.useRef(null), V = (A) => {
    const W = () => {
      k(!0);
      const Y = z.current.querySelector("a[href],button,[tabindex]");
      Y && Y.focus();
    };
    return x + b >= A.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${b}} + itemsBeforeCollapse={${x}} >= maxItems={${E}}`].join(`
`)), A) : [...A.slice(0, x), /* @__PURE__ */ L(BF, {
      "aria-label": v,
      slots: {
        CollapsedIcon: m.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: _
      },
      onClick: W
    }, "ellipsis"), ...A.slice(A.length - b, A.length)];
  }, M = C.Children.toArray(s).filter((A) => (process.env.NODE_ENV !== "production" && Kl.isFragment(A) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ C.isValidElement(A))).map((A, W) => /* @__PURE__ */ L("li", {
    className: $.li,
    children: A
  }, `child-${W}`));
  return /* @__PURE__ */ L(DJ, S({
    ref: o,
    component: f,
    color: "text.secondary",
    className: be($.root, c),
    ownerState: I
  }, P, {
    children: /* @__PURE__ */ L(_J, {
      className: $.ol,
      ref: z,
      ownerState: I,
      children: LJ(O || E && M.length <= E ? M : V(M), $.separator, T, I)
    })
  }));
});
process.env.NODE_ENV !== "production" && (jF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: n.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: eo,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: eo,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: eo,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: n.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: n.shape({
    collapsedIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    CollapsedIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const BSe = jF;
function FJ(e) {
  return ot("MuiButton", e);
}
const zJ = lt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), XS = zJ, HF = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (HF.displayName = "ButtonGroupContext");
const UF = HF, GF = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (GF.displayName = "ButtonGroupButtonContext");
const WF = GF, VJ = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], BJ = (e) => {
  const {
    color: t,
    disableElevation: o,
    fullWidth: i,
    size: s,
    variant: c,
    classes: f
  } = e, m = {
    root: ["root", c, `${c}${ve(t)}`, `size${ve(s)}`, `${c}Size${ve(s)}`, t === "inherit" && "colorInherit", o && "disableElevation", i && "fullWidth"],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${ve(s)}`],
    endIcon: ["endIcon", `iconSize${ve(s)}`]
  }, h = je(m, FJ, f);
  return S({}, f, h);
}, qF = (e) => S({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), jJ = se(Ao, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`${o.variant}${ve(o.color)}`], t[`size${ve(o.size)}`], t[`${o.variant}Size${ve(o.size)}`], o.color === "inherit" && t.colorInherit, o.disableElevation && t.disableElevation, o.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var o, i;
  const s = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], c = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return S({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": S({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : c,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": S({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${XS.focusVisible}`]: S({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${XS.disabled}`]: S({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${_t(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (o = (i = e.palette).getContrastText) == null ? void 0 : o.call(i, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : s,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${XS.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${XS.disabled}`]: {
    boxShadow: "none"
  }
}), HJ = se("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.startIcon, t[`iconSize${ve(o.size)}`]];
  }
})(({
  ownerState: e
}) => S({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, qF(e))), UJ = se("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.endIcon, t[`iconSize${ve(o.size)}`]];
  }
})(({
  ownerState: e
}) => S({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, qF(e))), YF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = C.useContext(UF), s = C.useContext(WF), c = Ck(i, t), f = dt({
    props: c,
    name: "MuiButton"
  }), {
    children: m,
    color: h = "primary",
    component: v = "button",
    className: b,
    disabled: x = !1,
    disableElevation: E = !1,
    disableFocusRipple: T = !1,
    endIcon: P,
    focusVisibleClassName: O,
    fullWidth: k = !1,
    size: I = "medium",
    startIcon: $,
    type: _,
    variant: z = "text"
  } = f, V = pe(f, VJ), M = S({}, f, {
    color: h,
    component: v,
    disabled: x,
    disableElevation: E,
    disableFocusRipple: T,
    fullWidth: k,
    size: I,
    type: _,
    variant: z
  }), A = BJ(M), W = $ && /* @__PURE__ */ L(HJ, {
    className: A.startIcon,
    ownerState: M,
    children: $
  }), Y = P && /* @__PURE__ */ L(UJ, {
    className: A.endIcon,
    ownerState: M,
    children: P
  }), H = s || "";
  return /* @__PURE__ */ ht(jJ, S({
    ownerState: M,
    className: be(i.className, A.root, b, H),
    component: v,
    disabled: x,
    focusRipple: !T,
    focusVisibleClassName: be(A.focusVisible, O),
    ref: o,
    type: _
  }, V, {
    classes: A,
    children: [W, m, Y]
  }));
});
process.env.NODE_ENV !== "production" && (YF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * Element placed after the children.
   */
  endIcon: n.node,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: n.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * Element placed before the children.
   */
  startIcon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @ignore
   */
  type: n.oneOfType([n.oneOf(["button", "reset", "submit"]), n.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["contained", "outlined", "text"]), n.string])
});
const KF = YF;
function GJ(e) {
  return ot("MuiButtonGroup", e);
}
const WJ = lt("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), aa = WJ, qJ = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], YJ = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [{
    [`& .${aa.grouped}`]: t.grouped
  }, {
    [`& .${aa.grouped}`]: t[`grouped${ve(o.orientation)}`]
  }, {
    [`& .${aa.grouped}`]: t[`grouped${ve(o.variant)}`]
  }, {
    [`& .${aa.grouped}`]: t[`grouped${ve(o.variant)}${ve(o.orientation)}`]
  }, {
    [`& .${aa.grouped}`]: t[`grouped${ve(o.variant)}${ve(o.color)}`]
  }, {
    [`& .${aa.firstButton}`]: t.firstButton
  }, {
    [`& .${aa.lastButton}`]: t.lastButton
  }, {
    [`& .${aa.middleButton}`]: t.middleButton
  }, t.root, t[o.variant], o.disableElevation === !0 && t.disableElevation, o.fullWidth && t.fullWidth, o.orientation === "vertical" && t.vertical];
}, KJ = (e) => {
  const {
    classes: t,
    color: o,
    disabled: i,
    disableElevation: s,
    fullWidth: c,
    orientation: f,
    variant: m
  } = e, h = {
    root: ["root", m, f === "vertical" && "vertical", c && "fullWidth", s && "disableElevation"],
    grouped: ["grouped", `grouped${ve(f)}`, `grouped${ve(m)}`, `grouped${ve(m)}${ve(f)}`, `grouped${ve(m)}${ve(o)}`, i && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return je(h, GJ, t);
}, XJ = se("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: YJ
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${aa.grouped}`]: S({
    minWidth: 40,
    "&:hover": S({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  }),
  [`& .${aa.firstButton},& .${aa.middleButton}`]: S({}, t.orientation === "horizontal" && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, t.orientation === "vertical" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, t.variant === "text" && t.orientation === "horizontal" && {
    borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${aa.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.orientation === "vertical" && {
    borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${aa.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.color !== "inherit" && {
    borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : _t(e.palette[t.color].main, 0.5)
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    borderRightColor: "transparent"
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    borderBottomColor: "transparent"
  }, t.variant === "contained" && t.orientation === "horizontal" && {
    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${aa.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.orientation === "vertical" && {
    borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${aa.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.color !== "inherit" && {
    borderColor: (e.vars || e).palette[t.color].dark
  }, {
    "&:hover": S({}, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "currentColor"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "currentColor"
    })
  }),
  [`& .${aa.lastButton},& .${aa.middleButton}`]: S({}, t.orientation === "horizontal" && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, t.orientation === "vertical" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    marginLeft: -1
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    marginTop: -1
  })
})), XF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: s,
    className: c,
    color: f = "primary",
    component: m = "div",
    disabled: h = !1,
    disableElevation: v = !1,
    disableFocusRipple: b = !1,
    disableRipple: x = !1,
    fullWidth: E = !1,
    orientation: T = "horizontal",
    size: P = "medium",
    variant: O = "outlined"
  } = i, k = pe(i, qJ), I = S({}, i, {
    color: f,
    component: m,
    disabled: h,
    disableElevation: v,
    disableFocusRipple: b,
    disableRipple: x,
    fullWidth: E,
    orientation: T,
    size: P,
    variant: O
  }), $ = KJ(I), _ = C.useMemo(() => ({
    className: $.grouped,
    color: f,
    disabled: h,
    disableElevation: v,
    disableFocusRipple: b,
    disableRipple: x,
    fullWidth: E,
    size: P,
    variant: O
  }), [f, h, v, b, x, E, P, O, $.grouped]), z = (V, M) => {
    const A = V === 0, W = V === C.Children.count(M) - 1;
    return A && W ? "" : A ? $.firstButton : W ? $.lastButton : $.middleButton;
  };
  return /* @__PURE__ */ L(XJ, S({
    as: m,
    role: "group",
    className: be($.root, c),
    ref: o,
    ownerState: I
  }, k, {
    children: /* @__PURE__ */ L(UF.Provider, {
      value: _,
      children: C.Children.map(s, (V, M) => /* @__PURE__ */ C.isValidElement(V) ? /* @__PURE__ */ L(WF.Provider, {
        value: z(M, s),
        children: V
      }) : V)
    })
  }));
});
process.env.NODE_ENV !== "production" && (XF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: n.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOfType([n.oneOf(["contained", "outlined", "text"]), n.string])
});
const jSe = XF;
function QJ(e) {
  return ot("MuiCard", e);
}
const ZJ = lt("MuiCard", ["root"]), HSe = ZJ, JJ = ["className", "raised"], eee = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, QJ, t);
}, tee = se(Ci, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  overflow: "hidden"
})), QF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCard"
  }), {
    className: s,
    raised: c = !1
  } = i, f = pe(i, JJ), m = S({}, i, {
    raised: c
  }), h = eee(m);
  return /* @__PURE__ */ L(tee, S({
    className: be(h.root, s),
    elevation: c ? 8 : void 0,
    ref: o,
    ownerState: m
  }, f));
});
process.env.NODE_ENV !== "production" && (QF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: co(n.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const USe = QF;
function nee(e) {
  return ot("MuiCardActionArea", e);
}
const ree = lt("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), qO = ree, oee = ["children", "className", "focusVisibleClassName"], aee = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, nee, t);
}, iee = se(Ao, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${qO.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${qO.focusVisible} .${qO.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.focusOpacity
  }
})), lee = se("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (e, t) => t.focusHighlight
})(({
  theme: e
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: e.transitions.create("opacity", {
    duration: e.transitions.duration.short
  })
})), ZF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCardActionArea"
  }), {
    children: s,
    className: c,
    focusVisibleClassName: f
  } = i, m = pe(i, oee), h = i, v = aee(h);
  return /* @__PURE__ */ ht(iee, S({
    className: be(v.root, c),
    focusVisibleClassName: be(f, v.focusVisible),
    ref: o,
    ownerState: h
  }, m, {
    children: [s, /* @__PURE__ */ L(lee, {
      className: v.focusHighlight,
      ownerState: h
    })]
  }));
});
process.env.NODE_ENV !== "production" && (ZF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const GSe = ZF;
function see(e) {
  return ot("MuiCardActions", e);
}
const cee = lt("MuiCardActions", ["root", "spacing"]), WSe = cee, uee = ["disableSpacing", "className"], dee = (e) => {
  const {
    classes: t,
    disableSpacing: o
  } = e;
  return je({
    root: ["root", !o && "spacing"]
  }, see, t);
}, fee = se("div", {
  name: "MuiCardActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  alignItems: "center",
  padding: 8
}, !e.disableSpacing && {
  "& > :not(:first-of-type)": {
    marginLeft: 8
  }
})), JF = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCardActions"
  }), {
    disableSpacing: s = !1,
    className: c
  } = i, f = pe(i, uee), m = S({}, i, {
    disableSpacing: s
  }), h = dee(m);
  return /* @__PURE__ */ L(fee, S({
    className: be(h.root, c),
    ownerState: m,
    ref: o
  }, f));
});
process.env.NODE_ENV !== "production" && (JF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const qSe = JF;
function pee(e) {
  return ot("MuiCardContent", e);
}
const mee = lt("MuiCardContent", ["root"]), YSe = mee, hee = ["className", "component"], gee = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, pee, t);
}, vee = se("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), ez = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCardContent"
  }), {
    className: s,
    component: c = "div"
  } = i, f = pe(i, hee), m = S({}, i, {
    component: c
  }), h = gee(m);
  return /* @__PURE__ */ L(vee, S({
    as: c,
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, f));
});
process.env.NODE_ENV !== "production" && (ez.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const KSe = ez;
function bee(e) {
  return ot("MuiCardHeader", e);
}
const yee = lt("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), kD = yee, Cee = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"], See = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, bee, t);
}, xee = se("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => S({
    [`& .${kD.title}`]: t.title,
    [`& .${kD.subheader}`]: t.subheader
  }, t.root)
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), wee = se("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), Eee = se("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), Tee = se("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto"
}), tz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: s,
    avatar: c,
    className: f,
    component: m = "div",
    disableTypography: h = !1,
    subheader: v,
    subheaderTypographyProps: b,
    title: x,
    titleTypographyProps: E
  } = i, T = pe(i, Cee), P = S({}, i, {
    component: m,
    disableTypography: h
  }), O = See(P);
  let k = x;
  k != null && k.type !== Ea && !h && (k = /* @__PURE__ */ L(Ea, S({
    variant: c ? "body2" : "h5",
    className: O.title,
    component: "span",
    display: "block"
  }, E, {
    children: k
  })));
  let I = v;
  return I != null && I.type !== Ea && !h && (I = /* @__PURE__ */ L(Ea, S({
    variant: c ? "body2" : "body1",
    className: O.subheader,
    color: "text.secondary",
    component: "span",
    display: "block"
  }, b, {
    children: I
  }))), /* @__PURE__ */ ht(xee, S({
    className: be(O.root, f),
    as: m,
    ref: o,
    ownerState: P
  }, T, {
    children: [c && /* @__PURE__ */ L(wee, {
      className: O.avatar,
      ownerState: P,
      children: c
    }), /* @__PURE__ */ ht(Tee, {
      className: O.content,
      ownerState: P,
      children: [k, I]
    }), s && /* @__PURE__ */ L(Eee, {
      className: O.action,
      ownerState: P,
      children: s
    })]
  }));
});
process.env.NODE_ENV !== "production" && (tz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display in the card header.
   */
  action: n.node,
  /**
   * The Avatar element to display.
   */
  avatar: n.node,
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * The content of the component.
   */
  subheader: n.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The content of the component.
   */
  title: n.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: n.object
});
const XSe = tz;
function Oee(e) {
  return ot("MuiCardMedia", e);
}
const Ree = lt("MuiCardMedia", ["root", "media", "img"]), QSe = Ree, kee = ["children", "className", "component", "image", "src", "style"], Pee = (e) => {
  const {
    classes: t,
    isMediaComponent: o,
    isImageComponent: i
  } = e;
  return je({
    root: ["root", o && "media", i && "img"]
  }, Oee, t);
}, Mee = se("div", {
  name: "MuiCardMedia",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      isMediaComponent: i,
      isImageComponent: s
    } = o;
    return [t.root, i && t.media, s && t.img];
  }
})(({
  ownerState: e
}) => S({
  display: "block",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
}, e.isMediaComponent && {
  width: "100%"
}, e.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: "cover"
})), Iee = ["video", "audio", "picture", "iframe", "img"], Nee = ["picture", "img"], nz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCardMedia"
  }), {
    children: s,
    className: c,
    component: f = "div",
    image: m,
    src: h,
    style: v
  } = i, b = pe(i, kee), x = Iee.indexOf(f) !== -1, E = !x && m ? S({
    backgroundImage: `url("${m}")`
  }, v) : v, T = S({}, i, {
    component: f,
    isMediaComponent: x,
    isImageComponent: Nee.indexOf(f) !== -1
  }), P = Pee(T);
  return /* @__PURE__ */ L(Mee, S({
    className: be(P.root, c),
    as: f,
    role: !x && m ? "img" : void 0,
    ref: o,
    style: E,
    ownerState: T,
    src: x ? m || h : void 0
  }, b, {
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (nz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: co(n.node, (e) => !e.children && !e.image && !e.src && !e.component ? new Error("MUI: Either `children`, `image`, `src` or `component` prop must be specified.") : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: n.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const ZSe = nz;
function $ee(e) {
  return ot("PrivateSwitchBase", e);
}
lt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const Dee = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], _ee = (e) => {
  const {
    classes: t,
    checked: o,
    disabled: i,
    edge: s
  } = e, c = {
    root: ["root", o && "checked", i && "disabled", s && `edge${ve(s)}`],
    input: ["input"]
  };
  return je(c, $ee, t);
}, Aee = se(Ao)(({
  ownerState: e
}) => S({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), Lee = se("input")({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), rz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    autoFocus: i,
    checked: s,
    checkedIcon: c,
    className: f,
    defaultChecked: m,
    disabled: h,
    disableFocusRipple: v = !1,
    edge: b = !1,
    icon: x,
    id: E,
    inputProps: T,
    inputRef: P,
    name: O,
    onBlur: k,
    onChange: I,
    onFocus: $,
    readOnly: _,
    required: z = !1,
    tabIndex: V,
    type: M,
    value: A
  } = t, W = pe(t, Dee), [Y, H] = _i({
    controlled: s,
    default: !!m,
    name: "SwitchBase",
    state: "checked"
  }), G = Xl(), ne = (Z) => {
    $ && $(Z), G && G.onFocus && G.onFocus(Z);
  }, K = (Z) => {
    k && k(Z), G && G.onBlur && G.onBlur(Z);
  }, B = (Z) => {
    if (Z.nativeEvent.defaultPrevented)
      return;
    const ee = Z.target.checked;
    H(ee), I && I(Z, ee);
  };
  let q = h;
  G && typeof q > "u" && (q = G.disabled);
  const X = M === "checkbox" || M === "radio", J = S({}, t, {
    checked: Y,
    disabled: q,
    disableFocusRipple: v,
    edge: b
  }), U = _ee(J);
  return /* @__PURE__ */ ht(Aee, S({
    component: "span",
    className: be(U.root, f),
    centerRipple: !0,
    focusRipple: !v,
    disabled: q,
    tabIndex: null,
    role: void 0,
    onFocus: ne,
    onBlur: K,
    ownerState: J,
    ref: o
  }, W, {
    children: [/* @__PURE__ */ L(Lee, S({
      autoFocus: i,
      checked: s,
      defaultChecked: m,
      className: U.input,
      disabled: q,
      id: X ? E : void 0,
      name: O,
      onChange: B,
      readOnly: _,
      ref: P,
      required: z,
      ownerState: J,
      tabIndex: V,
      type: M
    }, M === "checkbox" && A === void 0 ? {} : {
      value: A
    }, T)), Y ? c : x]
  }));
});
process.env.NODE_ENV !== "production" && (rz.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: n.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: n.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /*
   * @ignore
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.object,
  /**
   * @ignore
   */
  tabIndex: n.oneOfType([n.number, n.string]),
  /**
   * The input component prop `type`.
   */
  type: n.string.isRequired,
  /**
   * The value of the component.
   */
  value: n.any
});
const tP = rz, Fee = rn(/* @__PURE__ */ L("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), zee = rn(/* @__PURE__ */ L("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), Vee = rn(/* @__PURE__ */ L("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function Bee(e) {
  return ot("MuiCheckbox", e);
}
const jee = lt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), YO = jee, Hee = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], Uee = (e) => {
  const {
    classes: t,
    indeterminate: o,
    color: i,
    size: s
  } = e, c = {
    root: ["root", o && "indeterminate", `color${ve(i)}`, `size${ve(s)}`]
  }, f = je(c, Bee, t);
  return S({}, t, f);
}, Gee = se(tP, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.indeterminate && t.indeterminate, o.color !== "default" && t[`color${ve(o.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${YO.checked}, &.${YO.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${YO.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), Wee = /* @__PURE__ */ L(zee, {}), qee = /* @__PURE__ */ L(Fee, {}), Yee = /* @__PURE__ */ L(Vee, {}), oz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = dt({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: f = Wee,
    color: m = "primary",
    icon: h = qee,
    indeterminate: v = !1,
    indeterminateIcon: b = Yee,
    inputProps: x,
    size: E = "medium",
    className: T
  } = c, P = pe(c, Hee), O = v ? b : h, k = v ? b : f, I = S({}, c, {
    color: m,
    indeterminate: v,
    size: E
  }), $ = Uee(I);
  return /* @__PURE__ */ L(Gee, S({
    type: "checkbox",
    inputProps: S({
      "data-indeterminate": v
    }, x),
    icon: /* @__PURE__ */ C.cloneElement(O, {
      fontSize: (i = O.props.fontSize) != null ? i : E
    }),
    checkedIcon: /* @__PURE__ */ C.cloneElement(k, {
      fontSize: (s = k.props.fontSize) != null ? s : E
    }),
    ownerState: I,
    ref: o,
    className: be($.root, T)
  }, P, {
    classes: $
  }));
});
process.env.NODE_ENV !== "production" && (oz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: n.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: n.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: n.any
});
const az = oz;
function Kee(e) {
  return ot("MuiCircularProgress", e);
}
const Xee = lt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]), JSe = Xee, Qee = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let $x = (e) => e, PD, MD, ID, ND;
const Xu = 44, Zee = Gs(PD || (PD = $x`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), Jee = Gs(MD || (MD = $x`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), ete = (e) => {
  const {
    classes: t,
    variant: o,
    color: i,
    disableShrink: s
  } = e, c = {
    root: ["root", o, `color${ve(i)}`],
    svg: ["svg"],
    circle: ["circle", `circle${ve(o)}`, s && "circleDisableShrink"]
  };
  return je(c, Kee, t);
}, tte = se("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`color${ve(o.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && fd(ID || (ID = $x`
      animation: ${0} 1.4s linear infinite;
    `), Zee)), nte = se("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), rte = se("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.circle, t[`circle${ve(o.variant)}`], o.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && fd(ND || (ND = $x`
      animation: ${0} 1.4s ease-in-out infinite;
    `), Jee)), iz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: s,
    color: c = "primary",
    disableShrink: f = !1,
    size: m = 40,
    style: h,
    thickness: v = 3.6,
    value: b = 0,
    variant: x = "indeterminate"
  } = i, E = pe(i, Qee), T = S({}, i, {
    color: c,
    disableShrink: f,
    size: m,
    thickness: v,
    value: b,
    variant: x
  }), P = ete(T), O = {}, k = {}, I = {};
  if (x === "determinate") {
    const $ = 2 * Math.PI * ((Xu - v) / 2);
    O.strokeDasharray = $.toFixed(3), I["aria-valuenow"] = Math.round(b), O.strokeDashoffset = `${((100 - b) / 100 * $).toFixed(3)}px`, k.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ L(tte, S({
    className: be(P.root, s),
    style: S({
      width: m,
      height: m
    }, k, h),
    ownerState: T,
    ref: o,
    role: "progressbar"
  }, I, E, {
    children: /* @__PURE__ */ L(nte, {
      className: P.svg,
      ownerState: T,
      viewBox: `${Xu / 2} ${Xu / 2} ${Xu} ${Xu}`,
      children: /* @__PURE__ */ L(rte, {
        className: P.circle,
        style: O,
        ownerState: T,
        cx: Xu,
        cy: Xu,
        r: (Xu - v) / 2,
        fill: "none",
        strokeWidth: v
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (iz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: co(n.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g. '3rem'.
   * @default 40
   */
  size: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: n.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: n.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: n.oneOf(["determinate", "indeterminate"])
});
const ote = iz, lz = aW({
  createStyledComponent: se("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: o
      } = e;
      return [t.root, t[`maxWidth${ve(String(o.maxWidth))}`], o.fixed && t.fixed, o.disableGutters && t.disableGutters];
    }
  }),
  useThemeProps: (e) => dt({
    props: e,
    name: "MuiContainer"
  })
});
process.env.NODE_ENV !== "production" && (lz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: n.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const e1e = lz;
function t1e(e) {
  return ot("MuiContainer", e);
}
const ate = lt("MuiContainer", ["root", "disableGutters", "fixed", "maxWidthXs", "maxWidthSm", "maxWidthMd", "maxWidthLg", "maxWidthXl"]), n1e = ate, sz = (e, t) => S({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, t && !e.vars && {
  colorScheme: e.palette.mode
}), cz = (e) => S({
  color: (e.vars || e).palette.text.primary
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), ite = (e, t = !1) => {
  var o;
  const i = {};
  t && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([f, m]) => {
    var h;
    i[e.getColorSchemeSelector(f).replace(/\s*&/, "")] = {
      colorScheme: (h = m.palette) == null ? void 0 : h.mode
    };
  });
  let s = S({
    html: sz(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: S({
      margin: 0
    }, cz(e), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    })
  }, i);
  const c = (o = e.components) == null || (o = o.MuiCssBaseline) == null ? void 0 : o.styleOverrides;
  return c && (s = [s, c]), s;
};
function uz(e) {
  const t = dt({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: o,
    enableColorScheme: i = !1
  } = t;
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(Jk, {
      styles: (s) => ite(s, i)
    }), o]
  });
}
process.env.NODE_ENV !== "production" && (uz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * You can wrap a node.
   */
  children: n.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: n.bool
});
const lte = {
  track: "#2b2b2b",
  thumb: "#6b6b6b",
  active: "#959595"
};
function r1e(e = lte) {
  return {
    scrollbarColor: `${e.thumb} ${e.track}`,
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
      backgroundColor: e.track
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
      borderRadius: 8,
      backgroundColor: e.thumb,
      minHeight: 24,
      border: `3px solid ${e.track}`
    },
    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
      backgroundColor: e.active
    },
    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
      backgroundColor: e.track
    }
  };
}
function ste(e) {
  return ot("MuiModal", e);
}
const cte = lt("MuiModal", ["root", "hidden", "backdrop"]), o1e = cte, ute = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], dte = (e) => {
  const {
    open: t,
    exited: o,
    classes: i
  } = e;
  return je({
    root: ["root", !t && o && "hidden"],
    backdrop: ["backdrop"]
  }, ste, i);
}, fte = se("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.open && o.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), pte = se(DF, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), dz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h;
  const v = dt({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: b = pte,
    BackdropProps: x,
    className: E,
    closeAfterTransition: T = !1,
    children: P,
    container: O,
    component: k,
    components: I = {},
    componentsProps: $ = {},
    disableAutoFocus: _ = !1,
    disableEnforceFocus: z = !1,
    disableEscapeKeyDown: V = !1,
    disablePortal: M = !1,
    disableRestoreFocus: A = !1,
    disableScrollLock: W = !1,
    hideBackdrop: Y = !1,
    keepMounted: H = !1,
    onBackdropClick: G,
    open: ne,
    slotProps: K,
    slots: B
    // eslint-disable-next-line react/prop-types
  } = v, q = pe(v, ute), X = S({}, v, {
    closeAfterTransition: T,
    disableAutoFocus: _,
    disableEnforceFocus: z,
    disableEscapeKeyDown: V,
    disablePortal: M,
    disableRestoreFocus: A,
    disableScrollLock: W,
    hideBackdrop: Y,
    keepMounted: H
  }), {
    getRootProps: J,
    getBackdropProps: U,
    getTransitionProps: Z,
    portalRef: ee,
    isTopModal: ie,
    exited: oe,
    hasTransition: le
  } = $Q(S({}, X, {
    rootRef: o
  })), de = S({}, X, {
    exited: oe
  }), Ce = dte(de), me = {};
  if (P.props.tabIndex === void 0 && (me.tabIndex = "-1"), le) {
    const {
      onEnter: Fe,
      onExited: ce
    } = Z();
    me.onEnter = Fe, me.onExited = ce;
  }
  const Oe = (i = (s = B == null ? void 0 : B.root) != null ? s : I.Root) != null ? i : fte, he = (c = (f = B == null ? void 0 : B.backdrop) != null ? f : I.Backdrop) != null ? c : b, $e = (m = K == null ? void 0 : K.root) != null ? m : $.root, Ne = (h = K == null ? void 0 : K.backdrop) != null ? h : $.backdrop, Pe = Gr({
    elementType: Oe,
    externalSlotProps: $e,
    externalForwardedProps: q,
    getSlotProps: J,
    additionalProps: {
      ref: o,
      as: k
    },
    ownerState: de,
    className: be(E, $e == null ? void 0 : $e.className, Ce == null ? void 0 : Ce.root, !de.open && de.exited && (Ce == null ? void 0 : Ce.hidden))
  }), Se = Gr({
    elementType: he,
    externalSlotProps: Ne,
    additionalProps: x,
    getSlotProps: (Fe) => U(S({}, Fe, {
      onClick: (ce) => {
        G && G(ce), Fe != null && Fe.onClick && Fe.onClick(ce);
      }
    })),
    className: be(Ne == null ? void 0 : Ne.className, x == null ? void 0 : x.className, Ce == null ? void 0 : Ce.backdrop),
    ownerState: de
  });
  return !H && !ne && (!le || oe) ? null : /* @__PURE__ */ L(ry, {
    ref: ee,
    container: O,
    disablePortal: M,
    children: /* @__PURE__ */ ht(Oe, S({}, Pe, {
      children: [!Y && b ? /* @__PURE__ */ L(he, S({}, Se)) : null, /* @__PURE__ */ L(ey, {
        disableEnforceFocus: z,
        disableAutoFocus: _,
        disableRestoreFocus: A,
        isEnabled: ie,
        open: ne,
        children: /* @__PURE__ */ C.cloneElement(P, me)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (dz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: n.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: n.object,
  /**
   * A single child content element.
   */
  children: vd.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: n.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Backdrop: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([il, n.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: n.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: n.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: n.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: n.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: n.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: n.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: n.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: n.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: n.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: n.shape({
    backdrop: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    backdrop: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const nP = dz;
function mte(e) {
  return ot("MuiDialog", e);
}
const hte = lt("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), KO = hte, fz = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (fz.displayName = "DialogContext");
const pz = fz, gte = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], vte = se(DF, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), bte = (e) => {
  const {
    classes: t,
    scroll: o,
    maxWidth: i,
    fullWidth: s,
    fullScreen: c
  } = e, f = {
    root: ["root"],
    container: ["container", `scroll${ve(o)}`],
    paper: ["paper", `paperScroll${ve(o)}`, `paperWidth${ve(String(i))}`, s && "paperFullWidth", c && "paperFullScreen"]
  };
  return je(f, mte, t);
}, yte = se(nP, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), Cte = se("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.container, t[`scroll${ve(o.scroll)}`]];
  }
})(({
  ownerState: e
}) => S({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&:after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), Ste = se(Ci, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.paper, t[`scrollPaper${ve(o.scroll)}`], t[`paperWidth${ve(String(o.maxWidth))}`], o.fullWidth && t.paperFullWidth, o.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${KO.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${KO.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${KO.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), mz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDialog"
  }), s = mr(), c = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    "aria-describedby": f,
    "aria-labelledby": m,
    BackdropComponent: h,
    BackdropProps: v,
    children: b,
    className: x,
    disableEscapeKeyDown: E = !1,
    fullScreen: T = !1,
    fullWidth: P = !1,
    maxWidth: O = "sm",
    onBackdropClick: k,
    onClose: I,
    open: $,
    PaperComponent: _ = Ci,
    PaperProps: z = {},
    scroll: V = "paper",
    TransitionComponent: M = NF,
    transitionDuration: A = c,
    TransitionProps: W
  } = i, Y = pe(i, gte), H = S({}, i, {
    disableEscapeKeyDown: E,
    fullScreen: T,
    fullWidth: P,
    maxWidth: O,
    scroll: V
  }), G = bte(H), ne = C.useRef(), K = (J) => {
    ne.current = J.target === J.currentTarget;
  }, B = (J) => {
    ne.current && (ne.current = null, k && k(J), I && I(J, "backdropClick"));
  }, q = Qn(m), X = C.useMemo(() => ({
    titleId: q
  }), [q]);
  return /* @__PURE__ */ L(yte, S({
    className: be(G.root, x),
    closeAfterTransition: !0,
    components: {
      Backdrop: vte
    },
    componentsProps: {
      backdrop: S({
        transitionDuration: A,
        as: h
      }, v)
    },
    disableEscapeKeyDown: E,
    onClose: I,
    open: $,
    ref: o,
    onClick: B,
    ownerState: H
  }, Y, {
    children: /* @__PURE__ */ L(M, S({
      appear: !0,
      in: $,
      timeout: A,
      role: "presentation"
    }, W, {
      children: /* @__PURE__ */ L(Cte, {
        className: be(G.container),
        onMouseDown: K,
        ownerState: H,
        children: /* @__PURE__ */ L(Ste, S({
          as: _,
          elevation: 24,
          role: "dialog",
          "aria-describedby": f,
          "aria-labelledby": q
        }, z, {
          className: be(G.paper, z.className),
          ownerState: H,
          children: /* @__PURE__ */ L(pz.Provider, {
            value: X,
            children: b
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (mz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": n.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": n.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: n.elementType,
  /**
   * @ignore
   */
  BackdropProps: n.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: n.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: n.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl", !1]), n.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: n.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: n.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: n.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: n.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: n.object
});
const a1e = mz;
function xte(e) {
  return ot("MuiDialogActions", e);
}
const wte = lt("MuiDialogActions", ["root", "spacing"]), i1e = wte, Ete = ["className", "disableSpacing"], Tte = (e) => {
  const {
    classes: t,
    disableSpacing: o
  } = e;
  return je({
    root: ["root", !o && "spacing"]
  }, xte, t);
}, Ote = se("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(:first-of-type)": {
    marginLeft: 8
  }
})), hz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: s,
    disableSpacing: c = !1
  } = i, f = pe(i, Ete), m = S({}, i, {
    disableSpacing: c
  }), h = Tte(m);
  return /* @__PURE__ */ L(Ote, S({
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, f));
});
process.env.NODE_ENV !== "production" && (hz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const l1e = hz;
function Rte(e) {
  return ot("MuiDialogContent", e);
}
const kte = lt("MuiDialogContent", ["root", "dividers"]), s1e = kte;
function Pte(e) {
  return ot("MuiDialogTitle", e);
}
const Mte = lt("MuiDialogTitle", ["root"]), Ite = Mte, Nte = ["className", "dividers"], $te = (e) => {
  const {
    classes: t,
    dividers: o
  } = e;
  return je({
    root: ["root", o && "dividers"]
  }, Rte, t);
}, Dte = se("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${Ite.root} + &`]: {
    paddingTop: 0
  }
})), gz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: s,
    dividers: c = !1
  } = i, f = pe(i, Nte), m = S({}, i, {
    dividers: c
  }), h = $te(m);
  return /* @__PURE__ */ L(Dte, S({
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, f));
});
process.env.NODE_ENV !== "production" && (gz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const c1e = gz;
function _te(e) {
  return ot("MuiDialogContentText", e);
}
const Ate = lt("MuiDialogContentText", ["root"]), u1e = Ate, Lte = ["children", "className"], Fte = (e) => {
  const {
    classes: t
  } = e, i = je({
    root: ["root"]
  }, _te, t);
  return S({}, t, i);
}, zte = se(Ea, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), vz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDialogContentText"
  }), {
    className: s
  } = i, c = pe(i, Lte), f = Fte(c);
  return /* @__PURE__ */ L(zte, S({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: o,
    ownerState: c,
    className: be(f.root, s)
  }, i, {
    classes: f
  }));
});
process.env.NODE_ENV !== "production" && (vz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const d1e = vz, Vte = ["className", "id"], Bte = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, Pte, t);
}, jte = se(Ea, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), bz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: s,
    id: c
  } = i, f = pe(i, Vte), m = i, h = Bte(m), {
    titleId: v = c
  } = C.useContext(pz);
  return /* @__PURE__ */ L(jte, S({
    component: "h2",
    className: be(h.root, s),
    ownerState: m,
    ref: o,
    variant: "h6",
    id: c ?? v
  }, f));
});
process.env.NODE_ENV !== "production" && (bz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  id: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const f1e = bz;
function Hte(e) {
  return ot("MuiDivider", e);
}
const Ute = lt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), $D = Ute, Gte = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], Wte = (e) => {
  const {
    absolute: t,
    children: o,
    classes: i,
    flexItem: s,
    light: c,
    orientation: f,
    textAlign: m,
    variant: h
  } = e;
  return je({
    root: ["root", t && "absolute", h, c && "light", f === "vertical" && "vertical", s && "flexItem", o && "withChildren", o && f === "vertical" && "withChildrenVertical", m === "right" && f !== "vertical" && "textAlignRight", m === "left" && f !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", f === "vertical" && "wrapperVertical"]
  }, Hte, i);
}, qte = se("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.absolute && t.absolute, t[o.variant], o.light && t.light, o.orientation === "vertical" && t.vertical, o.flexItem && t.flexItem, o.children && t.withChildren, o.children && o.orientation === "vertical" && t.withChildrenVertical, o.textAlign === "right" && o.orientation !== "vertical" && t.textAlignRight, o.textAlign === "left" && o.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : _t(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => S({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => S({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  theme: e,
  ownerState: t
}) => S({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  ownerState: e
}) => S({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), Yte = se("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.wrapper, o.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), rP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: s = !1,
    children: c,
    className: f,
    component: m = c ? "div" : "hr",
    flexItem: h = !1,
    light: v = !1,
    orientation: b = "horizontal",
    role: x = m !== "hr" ? "separator" : void 0,
    textAlign: E = "center",
    variant: T = "fullWidth"
  } = i, P = pe(i, Gte), O = S({}, i, {
    absolute: s,
    component: m,
    flexItem: h,
    light: v,
    orientation: b,
    role: x,
    textAlign: E,
    variant: T
  }), k = Wte(O);
  return /* @__PURE__ */ L(qte, S({
    as: m,
    className: be(k.root, f),
    role: x,
    ref: o,
    ownerState: O
  }, P, {
    children: c ? /* @__PURE__ */ L(Yte, {
      className: k.wrapper,
      ownerState: O,
      children: c
    }) : null
  }));
});
rP.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (rP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: n.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   */
  light: n.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: n.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: n.oneOfType([n.oneOf(["fullWidth", "inset", "middle"]), n.string])
});
const Kte = rP, Xte = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function Qte(e, t, o) {
  const i = t.getBoundingClientRect(), s = o && o.getBoundingClientRect(), c = Ta(t);
  let f;
  if (t.fakeTransform)
    f = t.fakeTransform;
  else {
    const v = c.getComputedStyle(t);
    f = v.getPropertyValue("-webkit-transform") || v.getPropertyValue("transform");
  }
  let m = 0, h = 0;
  if (f && f !== "none" && typeof f == "string") {
    const v = f.split("(")[1].split(")")[0].split(",");
    m = parseInt(v[4], 10), h = parseInt(v[5], 10);
  }
  return e === "left" ? s ? `translateX(${s.right + m - i.left}px)` : `translateX(${c.innerWidth + m - i.left}px)` : e === "right" ? s ? `translateX(-${i.right - s.left - m}px)` : `translateX(-${i.left + i.width - m}px)` : e === "up" ? s ? `translateY(${s.bottom + h - i.top}px)` : `translateY(${c.innerHeight + h - i.top}px)` : s ? `translateY(-${i.top - s.top + i.height - h}px)` : `translateY(-${i.top + i.height - h}px)`;
}
function yz(e) {
  return typeof e == "function" ? e() : e;
}
function QS(e, t, o) {
  const i = yz(o), s = Qte(e, t, i);
  s && (t.style.webkitTransform = s, t.style.transform = s);
}
const Cz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = mr(), s = {
    enter: i.transitions.easing.easeOut,
    exit: i.transitions.easing.sharp
  }, c = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: f,
    appear: m = !0,
    children: h,
    container: v,
    direction: b = "down",
    easing: x = s,
    in: E,
    onEnter: T,
    onEntered: P,
    onEntering: O,
    onExit: k,
    onExited: I,
    onExiting: $,
    style: _,
    timeout: z = c,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: V = Oy
  } = t, M = pe(t, Xte), A = C.useRef(null), W = Cn(h.ref, A, o), Y = (U) => (Z) => {
    U && (Z === void 0 ? U(A.current) : U(A.current, Z));
  }, H = Y((U, Z) => {
    QS(b, U, v), Ex(U), T && T(U, Z);
  }), G = Y((U, Z) => {
    const ee = Yl({
      timeout: z,
      style: _,
      easing: x
    }, {
      mode: "enter"
    });
    U.style.webkitTransition = i.transitions.create("-webkit-transform", S({}, ee)), U.style.transition = i.transitions.create("transform", S({}, ee)), U.style.webkitTransform = "none", U.style.transform = "none", O && O(U, Z);
  }), ne = Y(P), K = Y($), B = Y((U) => {
    const Z = Yl({
      timeout: z,
      style: _,
      easing: x
    }, {
      mode: "exit"
    });
    U.style.webkitTransition = i.transitions.create("-webkit-transform", Z), U.style.transition = i.transitions.create("transform", Z), QS(b, U, v), k && k(U);
  }), q = Y((U) => {
    U.style.webkitTransition = "", U.style.transition = "", I && I(U);
  }), X = (U) => {
    f && f(A.current, U);
  }, J = C.useCallback(() => {
    A.current && QS(b, A.current, v);
  }, [b, v]);
  return C.useEffect(() => {
    if (E || b === "down" || b === "right")
      return;
    const U = lp(() => {
      A.current && QS(b, A.current, v);
    }), Z = Ta(A.current);
    return Z.addEventListener("resize", U), () => {
      U.clear(), Z.removeEventListener("resize", U);
    };
  }, [b, E, v]), C.useEffect(() => {
    E || J();
  }, [E, J]), /* @__PURE__ */ L(V, S({
    nodeRef: A,
    onEnter: H,
    onEntered: ne,
    onEntering: G,
    onExit: B,
    onExited: q,
    onExiting: K,
    addEndListener: X,
    appear: m,
    in: E,
    timeout: z
  }, M, {
    children: (U, Z) => /* @__PURE__ */ C.cloneElement(h, S({
      ref: W,
      style: S({
        visibility: U === "exited" && !E ? "hidden" : void 0
      }, _, h.props.style)
    }, Z))
  }));
});
process.env.NODE_ENV !== "production" && (Cz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: vd.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: co(n.oneOfType([il, n.func]), (e) => {
    if (e.open) {
      const t = yz(e.container);
      if (t && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: n.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
const Zte = Cz;
function Jte(e) {
  return ot("MuiDrawer", e);
}
const ene = lt("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]), p1e = ene, tne = ["BackdropProps"], nne = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"], Sz = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, (o.variant === "permanent" || o.variant === "persistent") && t.docked, t.modal];
}, rne = (e) => {
  const {
    classes: t,
    anchor: o,
    variant: i
  } = e, s = {
    root: ["root"],
    docked: [(i === "permanent" || i === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${ve(o)}`, i !== "temporary" && `paperAnchorDocked${ve(o)}`]
  };
  return je(s, Jte, t);
}, one = se(nP, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: Sz
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
})), DD = se("div", {
  shouldForwardProp: Oa,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: Sz
})({
  flex: "0 0 auto"
}), ane = se(Ci, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.paper, t[`paperAnchor${ve(o.anchor)}`], o.variant !== "temporary" && t[`paperAnchorDocked${ve(o.anchor)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, t.anchor === "left" && {
  left: 0
}, t.anchor === "top" && {
  top: 0,
  left: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, t.anchor === "right" && {
  right: 0
}, t.anchor === "bottom" && {
  top: "auto",
  left: 0,
  bottom: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, t.anchor === "left" && t.variant !== "temporary" && {
  borderRight: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "top" && t.variant !== "temporary" && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "right" && t.variant !== "temporary" && {
  borderLeft: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "bottom" && t.variant !== "temporary" && {
  borderTop: `1px solid ${(e.vars || e).palette.divider}`
})), xz = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function jf(e) {
  return ["left", "right"].indexOf(e) !== -1;
}
function _b(e, t) {
  return e.direction === "rtl" && jf(t) ? xz[t] : t;
}
const wz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiDrawer"
  }), s = mr(), c = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    anchor: f = "left",
    BackdropProps: m,
    children: h,
    className: v,
    elevation: b = 16,
    hideBackdrop: x = !1,
    ModalProps: {
      BackdropProps: E
    } = {},
    onClose: T,
    open: P = !1,
    PaperProps: O = {},
    SlideProps: k,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: I = Zte,
    transitionDuration: $ = c,
    variant: _ = "temporary"
  } = i, z = pe(i.ModalProps, tne), V = pe(i, nne), M = C.useRef(!1);
  C.useEffect(() => {
    M.current = !0;
  }, []);
  const A = _b(s, f), Y = S({}, i, {
    anchor: f,
    elevation: b,
    open: P,
    variant: _
  }, V), H = rne(Y), G = /* @__PURE__ */ L(ane, S({
    elevation: _ === "temporary" ? b : 0,
    square: !0
  }, O, {
    className: be(H.paper, O.className),
    ownerState: Y,
    children: h
  }));
  if (_ === "permanent")
    return /* @__PURE__ */ L(DD, S({
      className: be(H.root, H.docked, v),
      ownerState: Y,
      ref: o
    }, V, {
      children: G
    }));
  const ne = /* @__PURE__ */ L(I, S({
    in: P,
    direction: xz[A],
    timeout: $,
    appear: M.current
  }, k, {
    children: G
  }));
  return _ === "persistent" ? /* @__PURE__ */ L(DD, S({
    className: be(H.root, H.docked, v),
    ownerState: Y,
    ref: o
  }, V, {
    children: ne
  })) : /* @__PURE__ */ L(one, S({
    BackdropProps: S({}, m, E, {
      transitionDuration: $
    }),
    className: be(H.root, H.modal, v),
    open: P,
    ownerState: Y,
    onClose: T,
    hideBackdrop: x,
    ref: o
  }, V, z, {
    children: ne
  }));
});
process.env.NODE_ENV !== "production" && (wz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: n.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: n.object,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: eo,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: n.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: n.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: n.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: n.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: n.oneOf(["permanent", "persistent", "temporary"])
});
const ine = wz;
function lne(e) {
  return ot("MuiFab", e);
}
const sne = lt("MuiFab", ["root", "primary", "secondary", "extended", "circular", "focusVisible", "disabled", "colorInherit", "sizeSmall", "sizeMedium", "sizeLarge", "info", "error", "warning", "success"]), _D = sne, cne = ["children", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"], une = (e) => {
  const {
    color: t,
    variant: o,
    classes: i,
    size: s
  } = e, c = {
    root: ["root", o, `size${ve(s)}`, t === "inherit" ? "colorInherit" : t]
  }, f = je(c, lne, i);
  return S({}, i, f);
}, dne = se(Ao, {
  name: "MuiFab",
  slot: "Root",
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`size${ve(o.size)}`], o.color === "inherit" && t.colorInherit, t[ve(o.size)], t[o.color]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var o, i;
  return S({}, e.typography.button, {
    minHeight: 36,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
      duration: e.transitions.duration.short
    }),
    borderRadius: "50%",
    padding: 0,
    minWidth: 0,
    width: 56,
    height: 56,
    zIndex: (e.vars || e).zIndex.fab,
    boxShadow: (e.vars || e).shadows[6],
    "&:active": {
      boxShadow: (e.vars || e).shadows[12]
    },
    color: e.vars ? e.vars.palette.text.primary : (o = (i = e.palette).getContrastText) == null ? void 0 : o.call(i, e.palette.grey[300]),
    backgroundColor: (e.vars || e).palette.grey[300],
    "&:hover": {
      backgroundColor: (e.vars || e).palette.grey.A100,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.grey[300]
      },
      textDecoration: "none"
    },
    [`&.${_D.focusVisible}`]: {
      boxShadow: (e.vars || e).shadows[6]
    }
  }, t.size === "small" && {
    width: 40,
    height: 40
  }, t.size === "medium" && {
    width: 48,
    height: 48
  }, t.variant === "extended" && {
    borderRadius: 48 / 2,
    padding: "0 16px",
    width: "auto",
    minHeight: "auto",
    minWidth: 48,
    height: 48
  }, t.variant === "extended" && t.size === "small" && {
    width: "auto",
    padding: "0 8px",
    borderRadius: 34 / 2,
    minWidth: 34,
    height: 34
  }, t.variant === "extended" && t.size === "medium" && {
    width: "auto",
    padding: "0 16px",
    borderRadius: 40 / 2,
    minWidth: 40,
    height: 40
  }, t.color === "inherit" && {
    color: "inherit"
  });
}, ({
  theme: e,
  ownerState: t
}) => S({}, t.color !== "inherit" && t.color !== "default" && (e.vars || e).palette[t.color] != null && {
  color: (e.vars || e).palette[t.color].contrastText,
  backgroundColor: (e.vars || e).palette[t.color].main,
  "&:hover": {
    backgroundColor: (e.vars || e).palette[t.color].dark,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: (e.vars || e).palette[t.color].main
    }
  }
}), ({
  theme: e
}) => ({
  [`&.${_D.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    boxShadow: (e.vars || e).shadows[0],
    backgroundColor: (e.vars || e).palette.action.disabledBackground
  }
})), Ez = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiFab"
  }), {
    children: s,
    className: c,
    color: f = "default",
    component: m = "button",
    disabled: h = !1,
    disableFocusRipple: v = !1,
    focusVisibleClassName: b,
    size: x = "large",
    variant: E = "circular"
  } = i, T = pe(i, cne), P = S({}, i, {
    color: f,
    component: m,
    disabled: h,
    disableFocusRipple: v,
    size: x,
    variant: E
  }), O = une(P);
  return /* @__PURE__ */ L(dne, S({
    className: be(O.root, c),
    component: m,
    disabled: h,
    focusRipple: !v,
    focusVisibleClassName: be(O.focusVisible, b),
    ownerState: P,
    ref: o
  }, T, {
    classes: O,
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (Ez.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: n.oneOfType([n.oneOf(["default", "error", "info", "inherit", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: n.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: n.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: n.oneOfType([n.oneOf(["circular", "extended"]), n.string])
});
const Tz = Ez, fne = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], pne = (e) => {
  const {
    classes: t,
    disableUnderline: o
  } = e, s = je({
    root: ["root", !o && "underline"],
    input: ["input"]
  }, bZ, t);
  return S({}, t, s);
}, mne = se(Ix, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...Px(e, t), !o.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var o;
  const i = e.palette.mode === "light", s = i ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", c = i ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", f = i ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", m = i ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return S({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : c,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : f,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : c
      }
    },
    [`&.${$i.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : c
    },
    [`&.${$i.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : m
    }
  }, !t.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(o = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : o.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${$i.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${$i.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : s}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${$i.disabled}, .${$i.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${$i.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && S({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
}), hne = se(Nx, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Mx
})(({
  theme: e,
  ownerState: t
}) => S({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
})), oP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f;
  const m = dt({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: h = {},
    componentsProps: v,
    fullWidth: b = !1,
    // declare here to prevent spreading to DOM
    inputComponent: x = "input",
    multiline: E = !1,
    slotProps: T,
    slots: P = {},
    type: O = "text"
  } = m, k = pe(m, fne), I = S({}, m, {
    fullWidth: b,
    inputComponent: x,
    multiline: E,
    type: O
  }), $ = pne(m), _ = {
    root: {
      ownerState: I
    },
    input: {
      ownerState: I
    }
  }, z = T ?? v ? So(T ?? v, _) : _, V = (i = (s = P.root) != null ? s : h.Root) != null ? i : mne, M = (c = (f = P.input) != null ? f : h.Input) != null ? c : hne;
  return /* @__PURE__ */ L(Gh, S({
    slots: {
      root: V,
      input: M
    },
    componentsProps: z,
    fullWidth: b,
    inputComponent: x,
    multiline: E,
    ref: o,
    type: O
  }, k, {
    classes: $
  }));
});
process.env.NODE_ENV !== "production" && (oP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
oP.muiName = "Input";
const Oz = oP;
function gne(e) {
  return ot("MuiFormControl", e);
}
const vne = lt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]), m1e = vne, bne = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], yne = (e) => {
  const {
    classes: t,
    margin: o,
    fullWidth: i
  } = e, s = {
    root: ["root", o !== "none" && `margin${ve(o)}`, i && "fullWidth"]
  };
  return je(s, gne, t);
}, Cne = se("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => S({}, t.root, t[`margin${ve(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => S({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), Rz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiFormControl"
  }), {
    children: s,
    className: c,
    color: f = "primary",
    component: m = "div",
    disabled: h = !1,
    error: v = !1,
    focused: b,
    fullWidth: x = !1,
    hiddenLabel: E = !1,
    margin: T = "none",
    required: P = !1,
    size: O = "medium",
    variant: k = "outlined"
  } = i, I = pe(i, bne), $ = S({}, i, {
    color: f,
    component: m,
    disabled: h,
    error: v,
    fullWidth: x,
    hiddenLabel: E,
    margin: T,
    required: P,
    size: O,
    variant: k
  }), _ = yne($), [z, V] = C.useState(() => {
    let K = !1;
    return s && C.Children.forEach(s, (B) => {
      if (!zc(B, ["Input", "Select"]))
        return;
      const q = zc(B, ["Select"]) ? B.props.input : B;
      q && sZ(q.props) && (K = !0);
    }), K;
  }), [M, A] = C.useState(() => {
    let K = !1;
    return s && C.Children.forEach(s, (B) => {
      zc(B, ["Input", "Select"]) && (F1(B.props, !0) || F1(B.props.inputProps, !0)) && (K = !0);
    }), K;
  }), [W, Y] = C.useState(!1);
  h && W && Y(!1);
  const H = b !== void 0 && !h ? b : W;
  let G;
  if (process.env.NODE_ENV !== "production") {
    const K = C.useRef(!1);
    G = () => (K.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), K.current = !0, () => {
      K.current = !1;
    });
  }
  const ne = C.useMemo(() => ({
    adornedStart: z,
    setAdornedStart: V,
    color: f,
    disabled: h,
    error: v,
    filled: M,
    focused: H,
    fullWidth: x,
    hiddenLabel: E,
    size: O,
    onBlur: () => {
      Y(!1);
    },
    onEmpty: () => {
      A(!1);
    },
    onFilled: () => {
      A(!0);
    },
    onFocus: () => {
      Y(!0);
    },
    registerEffect: G,
    required: P,
    variant: k
  }), [z, f, h, v, M, H, x, E, G, P, O, k]);
  return /* @__PURE__ */ L(kx.Provider, {
    value: ne,
    children: /* @__PURE__ */ L(Cne, S({
      as: m,
      ownerState: $,
      className: be(_.root, c),
      ref: o
    }, I, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (Rz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: n.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: n.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: n.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: n.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
const kz = Rz, Pz = PW({
  createStyledComponent: se("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => dt({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (Pz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
  /**
   * Add an element between each child.
   */
  divider: n.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: n.bool
});
const Sne = Pz, xne = lt("MuiStack", ["root"]), h1e = xne;
function wne(e) {
  return ot("MuiFormControlLabel", e);
}
const Ene = lt("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), Ab = Ene, Tne = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], One = (e) => {
  const {
    classes: t,
    disabled: o,
    labelPlacement: i,
    error: s,
    required: c
  } = e, f = {
    root: ["root", o && "disabled", `labelPlacement${ve(i)}`, s && "error", c && "required"],
    label: ["label", o && "disabled"],
    asterisk: ["asterisk", s && "error"]
  };
  return je(f, wne, t);
}, Rne = se("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Ab.label}`]: t.label
    }, t.root, t[`labelPlacement${ve(o.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${Ab.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${Ab.label}`]: {
    [`&.${Ab.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), kne = se("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${Ab.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Mz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = dt({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: f,
    componentsProps: m = {},
    control: h,
    disabled: v,
    disableTypography: b,
    label: x,
    labelPlacement: E = "end",
    required: T,
    slotProps: P = {}
  } = c, O = pe(c, Tne), k = Xl(), I = (i = v ?? h.props.disabled) != null ? i : k == null ? void 0 : k.disabled, $ = T ?? h.props.required, _ = {
    disabled: I,
    required: $
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((Y) => {
    typeof h.props[Y] > "u" && typeof c[Y] < "u" && (_[Y] = c[Y]);
  });
  const z = Yc({
    props: c,
    muiFormControl: k,
    states: ["error"]
  }), V = S({}, c, {
    disabled: I,
    labelPlacement: E,
    required: $,
    error: z.error
  }), M = One(V), A = (s = P.typography) != null ? s : m.typography;
  let W = x;
  return W != null && W.type !== Ea && !b && (W = /* @__PURE__ */ L(Ea, S({
    component: "span"
  }, A, {
    className: be(M.label, A == null ? void 0 : A.className),
    children: W
  }))), /* @__PURE__ */ ht(Rne, S({
    className: be(M.root, f),
    ownerState: V,
    ref: o
  }, O, {
    children: [/* @__PURE__ */ C.cloneElement(h, _), $ ? /* @__PURE__ */ ht(Sne, {
      direction: "row",
      alignItems: "center",
      children: [W, /* @__PURE__ */ ht(kne, {
        ownerState: V,
        "aria-hidden": !0,
        className: M.asterisk,
        children: [" ", "*"]
      })]
    }) : W]
  }));
});
process.env.NODE_ENV !== "production" && (Mz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component appears selected.
   */
  checked: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: n.shape({
    typography: n.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: n.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: n.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: n.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: n.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: n.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    typography: n.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component.
   */
  value: n.any
});
const Pne = Mz;
function Mne(e) {
  return ot("MuiFormGroup", e);
}
const Ine = lt("MuiFormGroup", ["root", "row", "error"]), g1e = Ine, Nne = ["className", "row"], $ne = (e) => {
  const {
    classes: t,
    row: o,
    error: i
  } = e;
  return je({
    root: ["root", o && "row", i && "error"]
  }, Mne, t);
}, Dne = se("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.row && t.row];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), Iz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: s,
    row: c = !1
  } = i, f = pe(i, Nne), m = Xl(), h = Yc({
    props: i,
    muiFormControl: m,
    states: ["error"]
  }), v = S({}, i, {
    row: c,
    error: h.error
  }), b = $ne(v);
  return /* @__PURE__ */ L(Dne, S({
    className: be(b.root, s),
    ownerState: v,
    ref: o
  }, f));
});
process.env.NODE_ENV !== "production" && (Iz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const _ne = Iz;
function Ane(e) {
  return ot("MuiFormHelperText", e);
}
const Lne = lt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]), AD = Lne;
var LD;
const Fne = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], zne = (e) => {
  const {
    classes: t,
    contained: o,
    size: i,
    disabled: s,
    error: c,
    filled: f,
    focused: m,
    required: h
  } = e, v = {
    root: ["root", s && "disabled", c && "error", i && `size${ve(i)}`, o && "contained", m && "focused", f && "filled", h && "required"]
  };
  return je(v, Ane, t);
}, Vne = se("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.size && t[`size${ve(o.size)}`], o.contained && t.contained, o.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${AD.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${AD.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), Nz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: s,
    className: c,
    component: f = "p"
  } = i, m = pe(i, Fne), h = Xl(), v = Yc({
    props: i,
    muiFormControl: h,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), b = S({}, i, {
    component: f,
    contained: v.variant === "filled" || v.variant === "outlined",
    variant: v.variant,
    size: v.size,
    disabled: v.disabled,
    error: v.error,
    filled: v.filled,
    focused: v.focused,
    required: v.required
  }), x = zne(b);
  return /* @__PURE__ */ L(Vne, S({
    as: f,
    ownerState: b,
    className: be(x.root, c),
    ref: o
  }, m, {
    children: s === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      LD || (LD = /* @__PURE__ */ L("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : s
  }));
});
process.env.NODE_ENV !== "production" && (Nz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: n.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: n.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: n.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: n.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   */
  variant: n.oneOfType([n.oneOf(["filled", "outlined", "standard"]), n.string])
});
const Bne = Nz;
function jne(e) {
  return ot("MuiFormLabel", e);
}
const Hne = lt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Gb = Hne, Une = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], Gne = (e) => {
  const {
    classes: t,
    color: o,
    focused: i,
    disabled: s,
    error: c,
    filled: f,
    required: m
  } = e, h = {
    root: ["root", `color${ve(o)}`, s && "disabled", c && "error", f && "filled", i && "focused", m && "required"],
    asterisk: ["asterisk", c && "error"]
  };
  return je(h, jne, t);
}, Wne = se("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => S({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${Gb.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${Gb.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Gb.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), qne = se("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${Gb.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), $z = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: s,
    className: c,
    component: f = "label"
  } = i, m = pe(i, Une), h = Xl(), v = Yc({
    props: i,
    muiFormControl: h,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), b = S({}, i, {
    color: v.color || "primary",
    component: f,
    disabled: v.disabled,
    error: v.error,
    filled: v.filled,
    focused: v.focused,
    required: v.required
  }), x = Gne(b);
  return /* @__PURE__ */ ht(Wne, S({
    as: f,
    ownerState: b,
    className: be(x.root, c),
    ref: o
  }, m, {
    children: [s, v.required && /* @__PURE__ */ ht(qne, {
      ownerState: b,
      "aria-hidden": !0,
      className: x.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && ($z.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: n.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: n.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Yne = $z, Dz = /* @__PURE__ */ C.createContext();
process.env.NODE_ENV !== "production" && (Dz.displayName = "GridContext");
const FD = Dz;
function Kne(e) {
  return ot("MuiGrid", e);
}
const Xne = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Qne = ["column-reverse", "column", "row-reverse", "row"], Zne = ["nowrap", "wrap-reverse", "wrap"], Sb = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Jne = lt("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...Xne.map((e) => `spacing-xs-${e}`),
  // direction values
  ...Qne.map((e) => `direction-xs-${e}`),
  // wrap values
  ...Zne.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...Sb.map((e) => `grid-xs-${e}`),
  ...Sb.map((e) => `grid-sm-${e}`),
  ...Sb.map((e) => `grid-md-${e}`),
  ...Sb.map((e) => `grid-lg-${e}`),
  ...Sb.map((e) => `grid-xl-${e}`)
]), oy = Jne, ere = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function wh(e) {
  const t = parseFloat(e);
  return `${t}${String(e).replace(String(t), "") || "px"}`;
}
function tre({
  theme: e,
  ownerState: t
}) {
  let o;
  return e.breakpoints.keys.reduce((i, s) => {
    let c = {};
    if (t[s] && (o = t[s]), !o)
      return i;
    if (o === !0)
      c = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (o === "auto")
      c = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const f = Wf({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), m = typeof f == "object" ? f[s] : f;
      if (m == null)
        return i;
      const h = `${Math.round(o / m * 1e8) / 1e6}%`;
      let v = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const b = e.spacing(t.columnSpacing);
        if (b !== "0px") {
          const x = `calc(${h} + ${wh(b)})`;
          v = {
            flexBasis: x,
            maxWidth: x
          };
        }
      }
      c = S({
        flexBasis: h,
        flexGrow: 0,
        maxWidth: h
      }, v);
    }
    return e.breakpoints.values[s] === 0 ? Object.assign(i, c) : i[e.breakpoints.up(s)] = c, i;
  }, {});
}
function nre({
  theme: e,
  ownerState: t
}) {
  const o = Wf({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return yi({
    theme: e
  }, o, (i) => {
    const s = {
      flexDirection: i
    };
    return i.indexOf("column") === 0 && (s[`& > .${oy.item}`] = {
      maxWidth: "none"
    }), s;
  });
}
function _z({
  breakpoints: e,
  values: t
}) {
  let o = "";
  Object.keys(t).forEach((s) => {
    o === "" && t[s] !== 0 && (o = s);
  });
  const i = Object.keys(e).sort((s, c) => e[s] - e[c]);
  return i.slice(0, i.indexOf(o));
}
function rre({
  theme: e,
  ownerState: t
}) {
  const {
    container: o,
    rowSpacing: i
  } = t;
  let s = {};
  if (o && i !== 0) {
    const c = Wf({
      values: i,
      breakpoints: e.breakpoints.values
    });
    let f;
    typeof c == "object" && (f = _z({
      breakpoints: e.breakpoints.values,
      values: c
    })), s = yi({
      theme: e
    }, c, (m, h) => {
      var v;
      const b = e.spacing(m);
      return b !== "0px" ? {
        marginTop: `-${wh(b)}`,
        [`& > .${oy.item}`]: {
          paddingTop: wh(b)
        }
      } : (v = f) != null && v.includes(h) ? {} : {
        marginTop: 0,
        [`& > .${oy.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return s;
}
function ore({
  theme: e,
  ownerState: t
}) {
  const {
    container: o,
    columnSpacing: i
  } = t;
  let s = {};
  if (o && i !== 0) {
    const c = Wf({
      values: i,
      breakpoints: e.breakpoints.values
    });
    let f;
    typeof c == "object" && (f = _z({
      breakpoints: e.breakpoints.values,
      values: c
    })), s = yi({
      theme: e
    }, c, (m, h) => {
      var v;
      const b = e.spacing(m);
      return b !== "0px" ? {
        width: `calc(100% + ${wh(b)})`,
        marginLeft: `-${wh(b)}`,
        [`& > .${oy.item}`]: {
          paddingLeft: wh(b)
        }
      } : (v = f) != null && v.includes(h) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${oy.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return s;
}
function are(e, t, o = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [o[`spacing-xs-${String(e)}`]];
  const i = [];
  return t.forEach((s) => {
    const c = e[s];
    Number(c) > 0 && i.push(o[`spacing-${s}-${String(c)}`]);
  }), i;
}
const ire = se("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      container: i,
      direction: s,
      item: c,
      spacing: f,
      wrap: m,
      zeroMinWidth: h,
      breakpoints: v
    } = o;
    let b = [];
    i && (b = are(f, v, t));
    const x = [];
    return v.forEach((E) => {
      const T = o[E];
      T && x.push(t[`grid-${E}-${String(T)}`]);
    }), [t.root, i && t.container, c && t.item, h && t.zeroMinWidth, ...b, s !== "row" && t[`direction-xs-${String(s)}`], m !== "wrap" && t[`wrap-xs-${String(m)}`], ...x];
  }
})(({
  ownerState: e
}) => S({
  boxSizing: "border-box"
}, e.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, e.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, e.zeroMinWidth && {
  minWidth: 0
}, e.wrap !== "wrap" && {
  flexWrap: e.wrap
}), nre, rre, ore, tre);
function lre(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const o = [];
  return t.forEach((i) => {
    const s = e[i];
    if (Number(s) > 0) {
      const c = `spacing-${i}-${String(s)}`;
      o.push(c);
    }
  }), o;
}
const sre = (e) => {
  const {
    classes: t,
    container: o,
    direction: i,
    item: s,
    spacing: c,
    wrap: f,
    zeroMinWidth: m,
    breakpoints: h
  } = e;
  let v = [];
  o && (v = lre(c, h));
  const b = [];
  h.forEach((E) => {
    const T = e[E];
    T && b.push(`grid-${E}-${String(T)}`);
  });
  const x = {
    root: ["root", o && "container", s && "item", m && "zeroMinWidth", ...v, i !== "row" && `direction-xs-${String(i)}`, f !== "wrap" && `wrap-xs-${String(f)}`, ...b]
  };
  return je(x, Kne, t);
}, Wb = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: s
  } = mr(), c = xy(i), {
    className: f,
    columns: m,
    columnSpacing: h,
    component: v = "div",
    container: b = !1,
    direction: x = "row",
    item: E = !1,
    rowSpacing: T,
    spacing: P = 0,
    wrap: O = "wrap",
    zeroMinWidth: k = !1
  } = c, I = pe(c, ere), $ = T || P, _ = h || P, z = C.useContext(FD), V = b ? m || 12 : z, M = {}, A = S({}, I);
  s.keys.forEach((H) => {
    I[H] != null && (M[H] = I[H], delete A[H]);
  });
  const W = S({}, c, {
    columns: V,
    container: b,
    direction: x,
    item: E,
    rowSpacing: $,
    columnSpacing: _,
    wrap: O,
    zeroMinWidth: k,
    spacing: P
  }, M, {
    breakpoints: s.keys
  }), Y = sre(W);
  return /* @__PURE__ */ L(FD.Provider, {
    value: V,
    children: /* @__PURE__ */ L(ire, S({
      ownerState: W,
      className: be(Y.root, f),
      as: v,
      ref: o
    }, A))
  });
});
process.env.NODE_ENV !== "production" && (Wb.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: n.oneOfType([n.arrayOf(n.number), n.number, n.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: n.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: n.oneOfType([n.oneOf(["column-reverse", "column", "row-reverse", "row"]), n.arrayOf(n.oneOf(["column-reverse", "column", "row-reverse", "row"])), n.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: n.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string])), n.number, n.object, n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: n.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: n.oneOfType([n.oneOf(["auto"]), n.number, n.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: n.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = K8("Grid", Wb);
  Wb["propTypes"] = S({}, Wb.propTypes, {
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  });
}
const v1e = Wb, Az = SW({
  createStyledComponent: se("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => dt({
    props: e,
    name: "MuiGrid2"
  })
});
process.env.NODE_ENV !== "production" && (Az.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * @ignore
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const b1e = Az;
function y1e(e) {
  return ot("MuiGrid2", e);
}
const cre = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], ure = ["column-reverse", "column", "row-reverse", "row"], dre = ["nowrap", "wrap-reverse", "wrap"], xb = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], fre = lt("MuiGrid2", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...cre.map((e) => `spacing-xs-${e}`),
  // direction values
  ...ure.map((e) => `direction-xs-${e}`),
  // wrap values
  ...dre.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...xb.map((e) => `grid-xs-${e}`),
  ...xb.map((e) => `grid-sm-${e}`),
  ...xb.map((e) => `grid-md-${e}`),
  ...xb.map((e) => `grid-lg-${e}`),
  ...xb.map((e) => `grid-xl-${e}`)
]), C1e = fre, pre = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function AR(e) {
  return `scale(${e}, ${e ** 2})`;
}
const mre = {
  entering: {
    opacity: 1,
    transform: AR(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, XO = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), aP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    addEndListener: i,
    appear: s = !0,
    children: c,
    easing: f,
    in: m,
    onEnter: h,
    onEntered: v,
    onEntering: b,
    onExit: x,
    onExited: E,
    onExiting: T,
    style: P,
    timeout: O = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: k = Oy
  } = t, I = pe(t, pre), $ = C.useRef(), _ = C.useRef(), z = mr(), V = C.useRef(null), M = Cn(V, c.ref, o), A = (q) => (X) => {
    if (q) {
      const J = V.current;
      X === void 0 ? q(J) : q(J, X);
    }
  }, W = A(b), Y = A((q, X) => {
    Ex(q);
    const {
      duration: J,
      delay: U,
      easing: Z
    } = Yl({
      style: P,
      timeout: O,
      easing: f
    }, {
      mode: "enter"
    });
    let ee;
    O === "auto" ? (ee = z.transitions.getAutoHeightDuration(q.clientHeight), _.current = ee) : ee = J, q.style.transition = [z.transitions.create("opacity", {
      duration: ee,
      delay: U
    }), z.transitions.create("transform", {
      duration: XO ? ee : ee * 0.666,
      delay: U,
      easing: Z
    })].join(","), h && h(q, X);
  }), H = A(v), G = A(T), ne = A((q) => {
    const {
      duration: X,
      delay: J,
      easing: U
    } = Yl({
      style: P,
      timeout: O,
      easing: f
    }, {
      mode: "exit"
    });
    let Z;
    O === "auto" ? (Z = z.transitions.getAutoHeightDuration(q.clientHeight), _.current = Z) : Z = X, q.style.transition = [z.transitions.create("opacity", {
      duration: Z,
      delay: J
    }), z.transitions.create("transform", {
      duration: XO ? Z : Z * 0.666,
      delay: XO ? J : J || Z * 0.333,
      easing: U
    })].join(","), q.style.opacity = 0, q.style.transform = AR(0.75), x && x(q);
  }), K = A(E), B = (q) => {
    O === "auto" && ($.current = setTimeout(q, _.current || 0)), i && i(V.current, q);
  };
  return C.useEffect(() => () => {
    clearTimeout($.current);
  }, []), /* @__PURE__ */ L(k, S({
    appear: s,
    in: m,
    nodeRef: V,
    onEnter: Y,
    onEntered: H,
    onEntering: W,
    onExit: ne,
    onExited: K,
    onExiting: G,
    addEndListener: B,
    timeout: O === "auto" ? null : O
  }, I, {
    children: (q, X) => /* @__PURE__ */ C.cloneElement(c, S({
      style: S({
        opacity: 0,
        transform: AR(0.75),
        visibility: q === "exited" && !m ? "hidden" : void 0
      }, mre[q], P, c.props.style),
      ref: M
    }, X))
  }));
});
process.env.NODE_ENV !== "production" && (aP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: vd.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
aP.muiSupportAuto = !0;
const ay = aP;
function hre(e, t, o, i, s) {
  const [c, f] = C.useState(() => s && o ? o(e).matches : i ? i(e).matches : t);
  return Hn(() => {
    let m = !0;
    if (!o)
      return;
    const h = o(e), v = () => {
      m && f(h.matches);
    };
    return v(), h.addListener(v), () => {
      m = !1, h.removeListener(v);
    };
  }, [e, o]), c;
}
const Lz = C["useSyncExternalStore"];
function gre(e, t, o, i, s) {
  const c = C.useCallback(() => t, [t]), f = C.useMemo(() => {
    if (s && o)
      return () => o(e).matches;
    if (i !== null) {
      const {
        matches: b
      } = i(e);
      return () => b;
    }
    return c;
  }, [c, e, i, s, o]), [m, h] = C.useMemo(() => {
    if (o === null)
      return [c, () => () => {
      }];
    const b = o(e);
    return [() => b.matches, (x) => (b.addListener(x), () => {
      b.removeListener(x);
    })];
  }, [c, o, e]);
  return Lz(h, m, f);
}
function vre(e, t = {}) {
  const o = Sx(), i = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: s = !1,
    matchMedia: c = i ? window.matchMedia : null,
    ssrMatchMedia: f = null,
    noSsr: m = !1
  } = $k({
    name: "MuiUseMediaQuery",
    props: t,
    theme: o
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && o === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let h = typeof e == "function" ? e(o) : e;
  h = h.replace(/^@media( ?)/m, "");
  const b = (Lz !== void 0 ? gre : hre)(h, s, c, f, m);
  return process.env.NODE_ENV !== "production" && C.useDebugValue({
    query: h,
    match: b
  }), b;
}
const bre = ["initialWidth", "width"], id = ["xs", "sm", "md", "lg", "xl"], yre = (e, t, o = !0) => o ? id.indexOf(e) <= id.indexOf(t) : id.indexOf(e) < id.indexOf(t), Cre = (e, t, o = !1) => o ? id.indexOf(t) <= id.indexOf(e) : id.indexOf(t) < id.indexOf(e), Sre = (e = {}) => (t) => {
  const {
    withTheme: o = !1,
    noSSR: i = !1,
    initialWidth: s
  } = e;
  function c(f) {
    const m = mr(), h = f.theme || m, v = $k({
      theme: h,
      name: "MuiWithWidth",
      props: f
    }), {
      initialWidth: b,
      width: x
    } = v, E = pe(v, bre), [T, P] = C.useState(!1);
    Hn(() => {
      P(!0);
    }, []);
    const k = h.breakpoints.keys.slice().reverse().reduce(($, _) => {
      const z = vre(h.breakpoints.up(_));
      return !$ && z ? _ : $;
    }, null), I = S({
      width: x || (T || i ? k : void 0) || b || s
    }, o ? {
      theme: h
    } : {}, E);
    return I.width === void 0 ? null : /* @__PURE__ */ L(t, S({}, I));
  }
  return process.env.NODE_ENV !== "production" && (c.propTypes = {
    /**
     * As `window.innerWidth` is unavailable on the server,
     * we default to rendering an empty component during the first mount.
     * You might want to use a heuristic to approximate
     * the screen width of the client browser screen width.
     *
     * For instance, you could be using the user-agent or the client-hints.
     * https://caniuse.com/#search=client%20hint
     */
    initialWidth: n.oneOf(["xs", "sm", "md", "lg", "xl"]),
    /**
     * @ignore
     */
    theme: n.object,
    /**
     * Bypass the width calculation logic.
     */
    width: n.oneOf(["xs", "sm", "md", "lg", "xl"])
  }), process.env.NODE_ENV !== "production" && (c.displayName = `WithWidth(${nL(t)})`), c;
}, xre = Sre;
function z1(e) {
  const {
    children: t,
    only: o,
    width: i
  } = e, s = mr();
  let c = !0;
  if (o)
    if (Array.isArray(o))
      for (let f = 0; f < o.length; f += 1) {
        const m = o[f];
        if (i === m) {
          c = !1;
          break;
        }
      }
    else
      o && i === o && (c = !1);
  if (c)
    for (let f = 0; f < s.breakpoints.keys.length; f += 1) {
      const m = s.breakpoints.keys[f], h = e[`${m}Up`], v = e[`${m}Down`];
      if (h && yre(m, i) || v && Cre(m, i)) {
        c = !1;
        break;
      }
    }
  return c ? /* @__PURE__ */ L(C.Fragment, {
    children: t
  }) : null;
}
process.env.NODE_ENV !== "production" && (z1.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smUp: n.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: n.string.isRequired,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsUp: n.bool
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (z1.propTypes = ip(z1.propTypes));
const wre = xre()(z1);
function Ere(e) {
  return ot("PrivateHiddenCss", e);
}
lt("PrivateHiddenCss", ["root", "xlDown", "xlUp", "onlyXl", "lgDown", "lgUp", "onlyLg", "mdDown", "mdUp", "onlyMd", "smDown", "smUp", "onlySm", "xsDown", "xsUp", "onlyXs"]);
const Tre = ["children", "className", "only"], Ore = (e) => {
  const {
    classes: t,
    breakpoints: o
  } = e, i = {
    root: ["root", ...o.map(({
      breakpoint: s,
      dir: c
    }) => c === "only" ? `${c}${ve(s)}` : `${s}${ve(c)}`)]
  };
  return je(i, Ere, t);
}, Rre = se("div", {
  name: "PrivateHiddenCss",
  slot: "Root"
})(({
  theme: e,
  ownerState: t
}) => {
  const o = {
    display: "none"
  };
  return S({}, t.breakpoints.map(({
    breakpoint: i,
    dir: s
  }) => s === "only" ? {
    [e.breakpoints.only(i)]: o
  } : s === "up" ? {
    [e.breakpoints.up(i)]: o
  } : {
    [e.breakpoints.down(i)]: o
  }).reduce((i, s) => (Object.keys(s).forEach((c) => {
    i[c] = s[c];
  }), i), {}));
});
function Fz(e) {
  const {
    children: t,
    className: o,
    only: i
  } = e, s = pe(e, Tre), c = mr();
  if (process.env.NODE_ENV !== "production") {
    const v = Object.keys(s).filter((b) => {
      const x = !c.breakpoints.keys.some((E) => `${E}Up` === b || `${E}Down` === b);
      return !["classes", "theme", "isRtl", "sx"].includes(b) && x;
    });
    v.length > 0 && console.error(`MUI: Unsupported props received by \`<Hidden implementation="css" />\`: ${v.join(", ")}. Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?`);
  }
  const f = [];
  for (let v = 0; v < c.breakpoints.keys.length; v += 1) {
    const b = c.breakpoints.keys[v], x = s[`${b}Up`], E = s[`${b}Down`];
    x && f.push({
      breakpoint: b,
      dir: "up"
    }), E && f.push({
      breakpoint: b,
      dir: "down"
    });
  }
  i && (Array.isArray(i) ? i : [i]).forEach((b) => {
    f.push({
      breakpoint: b,
      dir: "only"
    });
  });
  const m = S({}, e, {
    breakpoints: f
  }), h = Ore(m);
  return /* @__PURE__ */ L(Rre, {
    className: be(h.root, o),
    ownerState: m,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Fz.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: n.oneOf(["js", "css"]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  lgDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  lgUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  mdDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  smDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  smUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xlDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xlUp: n.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xsDown: n.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xsUp: n.bool
});
const kre = ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"];
function Pre(e) {
  const {
    implementation: t = "js",
    lgDown: o = !1,
    lgUp: i = !1,
    mdDown: s = !1,
    mdUp: c = !1,
    smDown: f = !1,
    smUp: m = !1,
    xlDown: h = !1,
    xlUp: v = !1,
    xsDown: b = !1,
    xsUp: x = !1
  } = e, E = pe(e, kre);
  return t === "js" ? /* @__PURE__ */ L(wre, S({
    lgDown: o,
    lgUp: i,
    mdDown: s,
    mdUp: c,
    smDown: f,
    smUp: m,
    xlDown: h,
    xlUp: v,
    xsDown: b,
    xsUp: x
  }, E)) : /* @__PURE__ */ L(Fz, S({
    lgDown: o,
    lgUp: i,
    mdDown: s,
    mdUp: c,
    smDown: f,
    smUp: m,
    xlDown: h,
    xlUp: v,
    xsDown: b,
    xsUp: x
  }, E));
}
process.env.NODE_ENV !== "production" && (Pre.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   * @default 'js'
   */
  implementation: n.oneOf(["css", "js"]),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use a heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: n.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  lgDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  lgUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  mdDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  mdUp: n.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: n.oneOfType([n.oneOf(["xs", "sm", "md", "lg", "xl"]), n.arrayOf(n.oneOf(["xs", "sm", "md", "lg", "xl"]).isRequired)]),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  smDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  smUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xlDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xlUp: n.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xsDown: n.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xsUp: n.bool
});
function Mre(e) {
  return ot("MuiIcon", e);
}
const Ire = lt("MuiIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]), S1e = Ire, Nre = ["baseClassName", "className", "color", "component", "fontSize"], $re = (e) => {
  const {
    color: t,
    fontSize: o,
    classes: i
  } = e, s = {
    root: ["root", t !== "inherit" && `color${ve(t)}`, `fontSize${ve(o)}`]
  };
  return je(s, Mre, i);
}, Dre = se("span", {
  name: "MuiIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "inherit" && t[`color${ve(o.color)}`], t[`fontSize${ve(o.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
  // To remove at some point.
  overflow: "hidden",
  display: "inline-block",
  // allow overflow hidden to take action
  textAlign: "center",
  // support non-square icon
  flexShrink: 0,
  fontSize: {
    inherit: "inherit",
    small: e.typography.pxToRem(20),
    medium: e.typography.pxToRem(24),
    large: e.typography.pxToRem(36)
  }[t.fontSize],
  // TODO v5 deprecate, v6 remove for sx
  color: {
    primary: (e.vars || e).palette.primary.main,
    secondary: (e.vars || e).palette.secondary.main,
    info: (e.vars || e).palette.info.main,
    success: (e.vars || e).palette.success.main,
    warning: (e.vars || e).palette.warning.main,
    action: (e.vars || e).palette.action.active,
    error: (e.vars || e).palette.error.main,
    disabled: (e.vars || e).palette.action.disabled,
    inherit: void 0
  }[t.color]
})), iP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiIcon"
  }), {
    baseClassName: s = "material-icons",
    className: c,
    color: f = "inherit",
    component: m = "span",
    fontSize: h = "medium"
  } = i, v = pe(i, Nre), b = S({}, i, {
    baseClassName: s,
    color: f,
    component: m,
    fontSize: h
  }), x = $re(b);
  return /* @__PURE__ */ L(Dre, S({
    as: m,
    className: be(
      s,
      // Prevent the translation of the text content.
      // The font relies on the exact text content to render the icon.
      "notranslate",
      x.root,
      c
    ),
    ownerState: b,
    "aria-hidden": !0,
    ref: o
  }, v));
});
process.env.NODE_ENV !== "production" && (iP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (e.g. material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: n.string,
  /**
   * The name of the icon font ligature.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'inherit'
   */
  color: n.oneOfType([n.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: n.oneOfType([n.oneOf(["inherit", "large", "medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
iP.muiName = "Icon";
const x1e = iP;
function _re(e) {
  return ot("MuiImageList", e);
}
const Are = lt("MuiImageList", ["root", "masonry", "quilted", "standard", "woven"]), w1e = Are, zz = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (zz.displayName = "ImageListContext");
const Vz = zz, Lre = ["children", "className", "cols", "component", "rowHeight", "gap", "style", "variant"], Fre = (e) => {
  const {
    classes: t,
    variant: o
  } = e;
  return je({
    root: ["root", o]
  }, _re, t);
}, zre = se("ul", {
  name: "MuiImageList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant]];
  }
})(({
  ownerState: e
}) => S({
  display: "grid",
  overflowY: "auto",
  listStyle: "none",
  padding: 0,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}, e.variant === "masonry" && {
  display: "block"
})), Bz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiImageList"
  }), {
    children: s,
    className: c,
    cols: f = 2,
    component: m = "ul",
    rowHeight: h = "auto",
    gap: v = 4,
    style: b,
    variant: x = "standard"
  } = i, E = pe(i, Lre), T = C.useMemo(() => ({
    rowHeight: h,
    gap: v,
    variant: x
  }), [h, v, x]);
  C.useEffect(() => {
    process.env.NODE_ENV !== "production" && document !== void 0 && !("objectFit" in document.documentElement.style) && console.error(["MUI: ImageList v5+ no longer natively supports Internet Explorer.", "Use v4 of this component instead, or polyfill CSS object-fit."].join(`
`));
  }, []);
  const P = S(x === "masonry" ? {
    columnCount: f,
    columnGap: v
  } : {
    gridTemplateColumns: `repeat(${f}, 1fr)`,
    gap: v
  }, b), O = S({}, i, {
    component: m,
    gap: v,
    rowHeight: h,
    variant: x
  }), k = Fre(O);
  return /* @__PURE__ */ L(zre, S({
    as: m,
    className: be(k.root, k[x], c),
    ref: o,
    style: P,
    ownerState: O
  }, E, {
    children: /* @__PURE__ */ L(Vz.Provider, {
      value: T,
      children: s
    })
  }));
});
process.env.NODE_ENV !== "production" && (Bz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `ImageListItem`s.
   */
  children: n.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Number of columns.
   * @default 2
   */
  cols: eo,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The gap between items in px.
   * @default 4
   */
  gap: n.number,
  /**
   * The height of one row in px.
   * @default 'auto'
   */
  rowHeight: n.oneOfType([n.oneOf(["auto"]), n.number]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: n.oneOfType([n.oneOf(["masonry", "quilted", "standard", "woven"]), n.string])
});
const E1e = Bz;
function Vre(e) {
  return ot("MuiImageListItem", e);
}
const Bre = lt("MuiImageListItem", ["root", "img", "standard", "woven", "masonry", "quilted"]), zD = Bre, jre = ["children", "className", "cols", "component", "rows", "style"], Hre = (e) => {
  const {
    classes: t,
    variant: o
  } = e;
  return je({
    root: ["root", o],
    img: ["img"]
  }, Vre, t);
}, Ure = se("li", {
  name: "MuiImageListItem",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${zD.img}`]: t.img
    }, t.root, t[o.variant]];
  }
})(({
  ownerState: e
}) => S({
  display: "block",
  position: "relative"
}, e.variant === "standard" && {
  // For titlebar under list item
  display: "flex",
  flexDirection: "column"
}, e.variant === "woven" && {
  height: "100%",
  alignSelf: "center",
  "&:nth-of-type(even)": {
    height: "70%"
  }
}, {
  [`& .${zD.img}`]: S({
    objectFit: "cover",
    width: "100%",
    height: "100%",
    display: "block"
  }, e.variant === "standard" && {
    height: "auto",
    flexGrow: 1
  })
})), jz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiImageListItem"
  }), {
    children: s,
    className: c,
    cols: f = 1,
    component: m = "li",
    rows: h = 1,
    style: v
  } = i, b = pe(i, jre), {
    rowHeight: x = "auto",
    gap: E,
    variant: T
  } = C.useContext(Vz);
  let P = "auto";
  T === "woven" ? P = void 0 : x !== "auto" && (P = x * h + E * (h - 1));
  const O = S({}, i, {
    cols: f,
    component: m,
    gap: E,
    rowHeight: x,
    rows: h,
    variant: T
  }), k = Hre(O);
  return /* @__PURE__ */ L(Ure, S({
    as: m,
    className: be(k.root, k[T], c),
    ref: o,
    style: S({
      height: P,
      gridColumnEnd: T !== "masonry" ? `span ${f}` : void 0,
      gridRowEnd: T !== "masonry" ? `span ${h}` : void 0,
      marginBottom: T === "masonry" ? E : void 0,
      breakInside: T === "masonry" ? "avoid" : void 0
    }, v),
    ownerState: O
  }, b, {
    children: C.Children.map(s, (I) => /* @__PURE__ */ C.isValidElement(I) ? (process.env.NODE_ENV !== "production" && Kl.isFragment(I) && console.error(["MUI: The ImageListItem component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), I.type === "img" || zc(I, ["Image"]) ? /* @__PURE__ */ C.cloneElement(I, {
      className: be(k.img, I.props.className)
    }) : I) : null)
  }));
});
process.env.NODE_ENV !== "production" && (jz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `<img>`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Width of the item in number of grid columns.
   * @default 1
   */
  cols: eo,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Height of the item in number of grid rows.
   * @default 1
   */
  rows: eo,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const T1e = jz;
function Gre(e) {
  return ot("MuiImageListItemBar", e);
}
const Wre = lt("MuiImageListItemBar", ["root", "positionBottom", "positionTop", "positionBelow", "titleWrap", "titleWrapBottom", "titleWrapTop", "titleWrapBelow", "titleWrapActionPosLeft", "titleWrapActionPosRight", "title", "subtitle", "actionIcon", "actionIconActionPosLeft", "actionIconActionPosRight"]), O1e = Wre, qre = ["actionIcon", "actionPosition", "className", "subtitle", "title", "position"], Yre = (e) => {
  const {
    classes: t,
    position: o,
    actionIcon: i,
    actionPosition: s
  } = e, c = {
    root: ["root", `position${ve(o)}`],
    titleWrap: ["titleWrap", `titleWrap${ve(o)}`, i && `titleWrapActionPos${ve(s)}`],
    title: ["title"],
    subtitle: ["subtitle"],
    actionIcon: ["actionIcon", `actionIconActionPos${ve(s)}`]
  };
  return je(c, Gre, t);
}, Kre = se("div", {
  name: "MuiImageListItemBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`position${ve(o.position)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "absolute",
  left: 0,
  right: 0,
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  fontFamily: e.typography.fontFamily
}, t.position === "bottom" && {
  bottom: 0
}, t.position === "top" && {
  top: 0
}, t.position === "below" && {
  position: "relative",
  background: "transparent",
  alignItems: "normal"
})), Xre = se("div", {
  name: "MuiImageListItemBar",
  slot: "TitleWrap",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.titleWrap, t[`titleWrap${ve(o.position)}`], o.actionIcon && t[`titleWrapActionPos${ve(o.actionPosition)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  flexGrow: 1,
  padding: "12px 16px",
  color: (e.vars || e).palette.common.white,
  overflow: "hidden"
}, t.position === "below" && {
  padding: "6px 0 12px",
  color: "inherit"
}, t.actionIcon && t.actionPosition === "left" && {
  paddingLeft: 0
}, t.actionIcon && t.actionPosition === "right" && {
  paddingRight: 0
})), Qre = se("div", {
  name: "MuiImageListItemBar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(16),
  lineHeight: "24px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
})), Zre = se("div", {
  name: "MuiImageListItemBar",
  slot: "Subtitle",
  overridesResolver: (e, t) => t.subtitle
})(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(12),
  lineHeight: 1,
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
})), Jre = se("div", {
  name: "MuiImageListItemBar",
  slot: "ActionIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.actionIcon, t[`actionIconActionPos${ve(o.actionPosition)}`]];
  }
})(({
  ownerState: e
}) => S({}, e.actionPosition === "left" && {
  order: -1
})), Hz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiImageListItemBar"
  }), {
    actionIcon: s,
    actionPosition: c = "right",
    className: f,
    subtitle: m,
    title: h,
    position: v = "bottom"
  } = i, b = pe(i, qre), x = S({}, i, {
    position: v,
    actionPosition: c
  }), E = Yre(x);
  return /* @__PURE__ */ ht(Kre, S({
    ownerState: x,
    className: be(E.root, f),
    ref: o
  }, b, {
    children: [/* @__PURE__ */ ht(Xre, {
      ownerState: x,
      className: E.titleWrap,
      children: [/* @__PURE__ */ L(Qre, {
        className: E.title,
        children: h
      }), m ? /* @__PURE__ */ L(Zre, {
        className: E.subtitle,
        children: m
      }) : null]
    }), s ? /* @__PURE__ */ L(Jre, {
      ownerState: x,
      className: E.actionIcon,
      children: s
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Hz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the item itself).
   */
  actionIcon: n.node,
  /**
   * Position of secondary action IconButton.
   * @default 'right'
   */
  actionPosition: n.oneOf(["left", "right"]),
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Position of the title bar.
   * @default 'bottom'
   */
  position: n.oneOf(["below", "bottom", "top"]),
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Title to be displayed.
   */
  title: n.node
});
const R1e = Hz, eoe = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], toe = (e) => {
  const {
    classes: t,
    disableUnderline: o
  } = e, s = je({
    root: ["root", !o && "underline"],
    input: ["input"]
  }, mZ, t);
  return S({}, t, s);
}, noe = se(Ix, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...Px(e, t), !o.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let i = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (i = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), S({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&:after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${ad.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${ad.error}`]: {
      "&:before, &:after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&:before": {
      borderBottom: `1px solid ${i}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${ad.disabled}, .${ad.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${i}`
      }
    },
    [`&.${ad.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), roe = se(Nx, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Mx
})({}), lP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f;
  const m = dt({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: h,
    components: v = {},
    componentsProps: b,
    fullWidth: x = !1,
    inputComponent: E = "input",
    multiline: T = !1,
    slotProps: P,
    slots: O = {},
    type: k = "text"
  } = m, I = pe(m, eoe), $ = toe(m), z = {
    root: {
      ownerState: {
        disableUnderline: h
      }
    }
  }, V = P ?? b ? So(P ?? b, z) : z, M = (i = (s = O.root) != null ? s : v.Root) != null ? i : noe, A = (c = (f = O.input) != null ? f : v.Input) != null ? c : roe;
  return /* @__PURE__ */ L(Gh, S({
    slots: {
      root: M,
      input: A
    },
    slotProps: V,
    fullWidth: x,
    inputComponent: E,
    multiline: T,
    ref: o,
    type: k
  }, I, {
    classes: $
  }));
});
process.env.NODE_ENV !== "production" && (lP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    input: n.object,
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
lP.muiName = "Input";
const sP = lP;
function ooe(e) {
  return ot("MuiInputAdornment", e);
}
const aoe = lt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]), VD = aoe;
var BD;
const ioe = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], loe = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, t[`position${ve(o.position)}`], o.disablePointerEvents === !0 && t.disablePointerEvents, t[o.variant]];
}, soe = (e) => {
  const {
    classes: t,
    disablePointerEvents: o,
    hiddenLabel: i,
    position: s,
    size: c,
    variant: f
  } = e, m = {
    root: ["root", o && "disablePointerEvents", s && `position${ve(s)}`, f, i && "hiddenLabel", c && `size${ve(c)}`]
  };
  return je(m, ooe, t);
}, coe = se("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: loe
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${VD.positionStart}&:not(.${VD.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), Uz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: s,
    className: c,
    component: f = "div",
    disablePointerEvents: m = !1,
    disableTypography: h = !1,
    position: v,
    variant: b
  } = i, x = pe(i, ioe), E = Xl() || {};
  let T = b;
  b && E.variant && process.env.NODE_ENV !== "production" && b === E.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), E && !T && (T = E.variant);
  const P = S({}, i, {
    hiddenLabel: E.hiddenLabel,
    size: E.size,
    disablePointerEvents: m,
    position: v,
    variant: T
  }), O = soe(P);
  return /* @__PURE__ */ L(kx.Provider, {
    value: null,
    children: /* @__PURE__ */ L(coe, S({
      as: f,
      ownerState: P,
      className: be(O.root, c),
      ref: o
    }, x, {
      children: typeof s == "string" && !h ? /* @__PURE__ */ L(Ea, {
        color: "text.secondary",
        children: s
      }) : /* @__PURE__ */ ht(C.Fragment, {
        children: [v === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          BD || (BD = /* @__PURE__ */ L("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, s]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (Uz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: n.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: n.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
const uoe = Uz;
function doe(e) {
  return ot("MuiInputLabel", e);
}
const foe = lt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]), k1e = foe, poe = ["disableAnimation", "margin", "shrink", "variant", "className"], moe = (e) => {
  const {
    classes: t,
    formControl: o,
    size: i,
    shrink: s,
    disableAnimation: c,
    variant: f,
    required: m
  } = e, h = {
    root: ["root", o && "formControl", !c && "animated", s && "shrink", i && i !== "normal" && `size${ve(i)}`, f],
    asterisk: [m && "asterisk"]
  }, v = je(h, doe, t);
  return S({}, t, v);
}, hoe = se(Yne, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Gb.asterisk}`]: t.asterisk
    }, t.root, o.formControl && t.formControl, o.size === "small" && t.sizeSmall, o.shrink && t.shrink, !o.disableAnimation && t.animated, t[o.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && S({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && S({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && S({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), Gz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: s = !1,
    shrink: c,
    className: f
  } = i, m = pe(i, poe), h = Xl();
  let v = c;
  typeof v > "u" && h && (v = h.filled || h.focused || h.adornedStart);
  const b = Yc({
    props: i,
    muiFormControl: h,
    states: ["size", "variant", "required"]
  }), x = S({}, i, {
    disableAnimation: s,
    formControl: h,
    shrink: v,
    size: b.size,
    variant: b.variant,
    required: b.required
  }), E = moe(x);
  return /* @__PURE__ */ L(hoe, S({
    "data-shrink": v,
    ownerState: x,
    ref: o,
    className: be(E.root, f)
  }, m, {
    classes: E
  }));
});
process.env.NODE_ENV !== "production" && (Gz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: n.oneOfType([n.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), n.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: n.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: n.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: n.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: n.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: n.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: n.oneOfType([n.oneOf(["normal", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
const Wz = Gz;
function goe(e) {
  return ot("MuiLinearProgress", e);
}
const voe = lt("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]), P1e = voe, boe = ["className", "color", "value", "valueBuffer", "variant"];
let Wh = (e) => e, jD, HD, UD, GD, WD, qD;
const LR = 4, yoe = Gs(jD || (jD = Wh`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), Coe = Gs(HD || (HD = Wh`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), Soe = Gs(UD || (UD = Wh`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), xoe = (e) => {
  const {
    classes: t,
    variant: o,
    color: i
  } = e, s = {
    root: ["root", `color${ve(i)}`, o],
    dashed: ["dashed", `dashedColor${ve(i)}`],
    bar1: ["bar", `barColor${ve(i)}`, (o === "indeterminate" || o === "query") && "bar1Indeterminate", o === "determinate" && "bar1Determinate", o === "buffer" && "bar1Buffer"],
    bar2: ["bar", o !== "buffer" && `barColor${ve(i)}`, o === "buffer" && `color${ve(i)}`, (o === "indeterminate" || o === "query") && "bar2Indeterminate", o === "buffer" && "bar2Buffer"]
  };
  return je(s, goe, t);
}, cP = (e, t) => t === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? ql(e.palette[t].main, 0.62) : Wl(e.palette[t].main, 0.5), woe = se("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`color${ve(o.color)}`], t[o.variant]];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: cP(t, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), Eoe = se("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.dashed, t[`dashedColor${ve(o.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const o = cP(t, e.color);
  return S({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${o} 0%, ${o} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, fd(GD || (GD = Wh`
    animation: ${0} 3s infinite linear;
  `), Soe)), Toe = se("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.bar, t[`barColor${ve(o.color)}`], (o.variant === "indeterminate" || o.variant === "query") && t.bar1Indeterminate, o.variant === "determinate" && t.bar1Determinate, o.variant === "buffer" && t.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${LR}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${LR}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && fd(WD || (WD = Wh`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), yoe)), Ooe = se("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.bar, t[`barColor${ve(o.color)}`], (o.variant === "indeterminate" || o.variant === "query") && t.bar2Indeterminate, o.variant === "buffer" && t.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: cP(t, e.color),
  transition: `transform .${LR}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && fd(qD || (qD = Wh`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), Coe)), qz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: s,
    color: c = "primary",
    value: f,
    valueBuffer: m,
    variant: h = "indeterminate"
  } = i, v = pe(i, boe), b = S({}, i, {
    color: c,
    variant: h
  }), x = xoe(b), E = mr(), T = {}, P = {
    bar1: {},
    bar2: {}
  };
  if (h === "determinate" || h === "buffer")
    if (f !== void 0) {
      T["aria-valuenow"] = Math.round(f), T["aria-valuemin"] = 0, T["aria-valuemax"] = 100;
      let O = f - 100;
      E.direction === "rtl" && (O = -O), P.bar1.transform = `translateX(${O}%)`;
    } else
      process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (h === "buffer")
    if (m !== void 0) {
      let O = (m || 0) - 100;
      E.direction === "rtl" && (O = -O), P.bar2.transform = `translateX(${O}%)`;
    } else
      process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ ht(woe, S({
    className: be(x.root, s),
    ownerState: b,
    role: "progressbar"
  }, T, {
    ref: o
  }, v, {
    children: [h === "buffer" ? /* @__PURE__ */ L(Eoe, {
      className: x.dashed,
      ownerState: b
    }) : null, /* @__PURE__ */ L(Toe, {
      className: x.bar1,
      ownerState: b,
      style: P.bar1
    }), h === "determinate" ? null : /* @__PURE__ */ L(Ooe, {
      className: x.bar2,
      ownerState: b,
      style: P.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" && (qz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["inherit", "primary", "secondary"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: n.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: n.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: n.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const Roe = qz;
function koe(e) {
  return ot("MuiLink", e);
}
const Poe = lt("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), Moe = Poe, Yz = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Ioe = (e) => Yz[e] || e, Noe = ({
  theme: e,
  ownerState: t
}) => {
  const o = Ioe(t.color), i = Ih(e, `palette.${o}`, !1) || t.color, s = Ih(e, `palette.${o}Channel`);
  return "vars" in e && s ? `rgba(${s} / 0.4)` : _t(i, 0.4);
}, $oe = Noe, Doe = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], _oe = (e) => {
  const {
    classes: t,
    component: o,
    focusVisible: i,
    underline: s
  } = e, c = {
    root: ["root", `underline${ve(s)}`, o === "button" && "button", i && "focusVisible"]
  };
  return je(c, koe, t);
}, Aoe = se(Ea, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`underline${ve(o.underline)}`], o.component === "button" && t.button];
  }
})(({
  theme: e,
  ownerState: t
}) => S({}, t.underline === "none" && {
  textDecoration: "none"
}, t.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, t.underline === "always" && S({
  textDecoration: "underline"
}, t.color !== "inherit" && {
  textDecorationColor: $oe({
    theme: e,
    ownerState: t
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), t.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Moe.focusVisible}`]: {
    outline: "auto"
  }
})), Kz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiLink"
  }), {
    className: s,
    color: c = "primary",
    component: f = "a",
    onBlur: m,
    onFocus: h,
    TypographyClasses: v,
    underline: b = "always",
    variant: x = "inherit",
    sx: E
  } = i, T = pe(i, Doe), {
    isFocusVisibleRef: P,
    onBlur: O,
    onFocus: k,
    ref: I
  } = vy(), [$, _] = C.useState(!1), z = Cn(o, I), V = (Y) => {
    O(Y), P.current === !1 && _(!1), m && m(Y);
  }, M = (Y) => {
    k(Y), P.current === !0 && _(!0), h && h(Y);
  }, A = S({}, i, {
    color: c,
    component: f,
    focusVisible: $,
    underline: b,
    variant: x
  }), W = _oe(A);
  return /* @__PURE__ */ L(Aoe, S({
    color: c,
    className: be(W.root, s),
    classes: v,
    component: f,
    onBlur: V,
    onFocus: M,
    ref: z,
    ownerState: A,
    variant: x,
    sx: [...Object.keys(Yz).includes(c) ? [] : [{
      color: c
    }], ...Array.isArray(E) ? E : [E]]
  }, T));
});
process.env.NODE_ENV !== "production" && (Kz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: n.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: dd,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: n.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: n.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: n.oneOfType([n.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), n.string])
});
const Loe = Kz, Xz = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (Xz.displayName = "ListContext");
const al = Xz;
function Foe(e) {
  return ot("MuiList", e);
}
const zoe = lt("MuiList", ["root", "padding", "dense", "subheader"]), M1e = zoe, Voe = ["children", "className", "component", "dense", "disablePadding", "subheader"], Boe = (e) => {
  const {
    classes: t,
    disablePadding: o,
    dense: i,
    subheader: s
  } = e;
  return je({
    root: ["root", !o && "padding", i && "dense", s && "subheader"]
  }, Foe, t);
}, joe = se("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disablePadding && t.padding, o.dense && t.dense, o.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => S({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), Qz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiList"
  }), {
    children: s,
    className: c,
    component: f = "ul",
    dense: m = !1,
    disablePadding: h = !1,
    subheader: v
  } = i, b = pe(i, Voe), x = C.useMemo(() => ({
    dense: m
  }), [m]), E = S({}, i, {
    component: f,
    dense: m,
    disablePadding: h
  }), T = Boe(E);
  return /* @__PURE__ */ L(al.Provider, {
    value: x,
    children: /* @__PURE__ */ ht(joe, S({
      as: f,
      className: be(T.root, c),
      ref: o,
      ownerState: E
    }, b, {
      children: [v, s]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Qz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: n.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Hoe = Qz;
function Uoe(e) {
  return ot("MuiListItem", e);
}
const Goe = lt("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), uh = Goe;
function Woe(e) {
  return ot("MuiListItemButton", e);
}
const qoe = lt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), dh = qoe, Yoe = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], Koe = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters];
}, Xoe = (e) => {
  const {
    alignItems: t,
    classes: o,
    dense: i,
    disabled: s,
    disableGutters: c,
    divider: f,
    selected: m
  } = e, v = je({
    root: ["root", i && "dense", !c && "gutters", f && "divider", s && "disabled", t === "flex-start" && "alignItemsFlexStart", m && "selected"]
  }, Woe, o);
  return S({}, o, v);
}, Qoe = se(Ao, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: Koe
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${dh.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${dh.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${dh.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${dh.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${dh.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), Zz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: s = "center",
    autoFocus: c = !1,
    component: f = "div",
    children: m,
    dense: h = !1,
    disableGutters: v = !1,
    divider: b = !1,
    focusVisibleClassName: x,
    selected: E = !1,
    className: T
  } = i, P = pe(i, Yoe), O = C.useContext(al), k = C.useMemo(() => ({
    dense: h || O.dense || !1,
    alignItems: s,
    disableGutters: v
  }), [s, O.dense, h, v]), I = C.useRef(null);
  Hn(() => {
    c && (I.current ? I.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [c]);
  const $ = S({}, i, {
    alignItems: s,
    dense: k.dense,
    disableGutters: v,
    divider: b,
    selected: E
  }), _ = Xoe($), z = Cn(I, o);
  return /* @__PURE__ */ L(al.Provider, {
    value: k,
    children: /* @__PURE__ */ L(Qoe, S({
      ref: z,
      href: P.href || P.to,
      component: (P.href || P.to) && f === "div" ? "button" : f,
      focusVisibleClassName: be(_.focusVisible, x),
      ownerState: $,
      className: be(_.root, T)
    }, P, {
      classes: _,
      children: m
    }))
  });
});
process.env.NODE_ENV !== "production" && (Zz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: n.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  href: n.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const I1e = Zz;
function Zoe(e) {
  return ot("MuiListItemSecondaryAction", e);
}
const Joe = lt("MuiListItemSecondaryAction", ["root", "disableGutters"]), N1e = Joe, eae = ["className"], tae = (e) => {
  const {
    disableGutters: t,
    classes: o
  } = e;
  return je({
    root: ["root", t && "disableGutters"]
  }, Zoe, o);
}, nae = se("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => S({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), uP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: s
  } = i, c = pe(i, eae), f = C.useContext(al), m = S({}, i, {
    disableGutters: f.disableGutters
  }), h = tae(m);
  return /* @__PURE__ */ L(nae, S({
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, c));
});
process.env.NODE_ENV !== "production" && (uP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
uP.muiName = "ListItemSecondaryAction";
const rae = uP, oae = ["className"], aae = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], iae = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters, !o.disablePadding && t.padding, o.button && t.button, o.hasSecondaryAction && t.secondaryAction];
}, lae = (e) => {
  const {
    alignItems: t,
    button: o,
    classes: i,
    dense: s,
    disabled: c,
    disableGutters: f,
    disablePadding: m,
    divider: h,
    hasSecondaryAction: v,
    selected: b
  } = e;
  return je({
    root: ["root", s && "dense", !f && "gutters", !m && "padding", h && "divider", c && "disabled", o && "button", t === "flex-start" && "alignItemsFlexStart", v && "secondaryAction", b && "selected"],
    container: ["container"]
  }, Uoe, i);
}, sae = se("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: iae
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && S({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${dh.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${uh.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${uh.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${uh.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${uh.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${uh.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), cae = se("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Jz = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: s = "center",
    autoFocus: c = !1,
    button: f = !1,
    children: m,
    className: h,
    component: v,
    components: b = {},
    componentsProps: x = {},
    ContainerComponent: E = "li",
    ContainerProps: {
      className: T
    } = {},
    dense: P = !1,
    disabled: O = !1,
    disableGutters: k = !1,
    disablePadding: I = !1,
    divider: $ = !1,
    focusVisibleClassName: _,
    secondaryAction: z,
    selected: V = !1,
    slotProps: M = {},
    slots: A = {}
  } = i, W = pe(i.ContainerProps, oae), Y = pe(i, aae), H = C.useContext(al), G = C.useMemo(() => ({
    dense: P || H.dense || !1,
    alignItems: s,
    disableGutters: k
  }), [s, H.dense, P, k]), ne = C.useRef(null);
  Hn(() => {
    c && (ne.current ? ne.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [c]);
  const K = C.Children.toArray(m), B = K.length && zc(K[K.length - 1], ["ListItemSecondaryAction"]), q = S({}, i, {
    alignItems: s,
    autoFocus: c,
    button: f,
    dense: G.dense,
    disabled: O,
    disableGutters: k,
    disablePadding: I,
    divider: $,
    hasSecondaryAction: B,
    selected: V
  }), X = lae(q), J = Cn(ne, o), U = A.root || b.Root || sae, Z = M.root || x.root || {}, ee = S({
    className: be(X.root, Z.className, h),
    disabled: O
  }, Y);
  let ie = v || "li";
  return f && (ee.component = v || "div", ee.focusVisibleClassName = be(uh.focusVisible, _), ie = Ao), B ? (ie = !ee.component && !v ? "div" : ie, E === "li" && (ie === "li" ? ie = "div" : ee.component === "li" && (ee.component = "div")), /* @__PURE__ */ L(al.Provider, {
    value: G,
    children: /* @__PURE__ */ ht(cae, S({
      as: E,
      className: be(X.container, T),
      ref: J,
      ownerState: q
    }, W, {
      children: [/* @__PURE__ */ L(U, S({}, Z, !Ul(U) && {
        as: ie,
        ownerState: S({}, q, Z.ownerState)
      }, ee, {
        children: K
      })), K.pop()]
    }))
  })) : /* @__PURE__ */ L(al.Provider, {
    value: G,
    children: /* @__PURE__ */ ht(U, S({}, Z, {
      as: ie,
      ref: J
    }, !Ul(U) && {
      ownerState: S({}, q, Z.ownerState)
    }, ee, {
      children: [K, z && /* @__PURE__ */ L(rae, {
        children: z
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Jz.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: n.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: n.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: n.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: co(n.node, (e) => {
    const t = C.Children.toArray(e.children);
    let o = -1;
    for (let i = t.length - 1; i >= 0; i -= 1) {
      const s = t[i];
      if (zc(s, ["ListItemSecondaryAction"])) {
        o = i;
        break;
      }
    }
    return o !== -1 && o !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Root: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    root: n.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: dd,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: n.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: n.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: n.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: n.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: n.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: n.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    root: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const $1e = Jz;
function uae(e) {
  return ot("MuiListItemAvatar", e);
}
const dae = lt("MuiListItemAvatar", ["root", "alignItemsFlexStart"]), D1e = dae, fae = ["className"], pae = (e) => {
  const {
    alignItems: t,
    classes: o
  } = e;
  return je({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, uae, o);
}, mae = se("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  ownerState: e
}) => S({
  minWidth: 56,
  flexShrink: 0
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), eV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: s
  } = i, c = pe(i, fae), f = C.useContext(al), m = S({}, i, {
    alignItems: f.alignItems
  }), h = pae(m);
  return /* @__PURE__ */ L(mae, S({
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, c));
});
process.env.NODE_ENV !== "production" && (eV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const _1e = eV;
function hae(e) {
  return ot("MuiListItemIcon", e);
}
const gae = lt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), YD = gae, vae = ["className"], bae = (e) => {
  const {
    alignItems: t,
    classes: o
  } = e;
  return je({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, hae, o);
}, yae = se("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex"
}, t.alignItems === "flex-start" && {
  marginTop: 8
})), tV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: s
  } = i, c = pe(i, vae), f = C.useContext(al), m = S({}, i, {
    alignItems: f.alignItems
  }), h = bae(m);
  return /* @__PURE__ */ L(yae, S({
    className: be(h.root, s),
    ownerState: m,
    ref: o
  }, c));
});
process.env.NODE_ENV !== "production" && (tV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Eh = tV;
function Cae(e) {
  return ot("MuiListItemText", e);
}
const Sae = lt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), V1 = Sae, xae = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], wae = (e) => {
  const {
    classes: t,
    inset: o,
    primary: i,
    secondary: s,
    dense: c
  } = e;
  return je({
    root: ["root", o && "inset", c && "dense", i && s && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, Cae, t);
}, Eae = se("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${V1.primary}`]: t.primary
    }, {
      [`& .${V1.secondary}`]: t.secondary
    }, t.root, o.inset && t.inset, o.primary && o.secondary && t.multiline, o.dense && t.dense];
  }
})(({
  ownerState: e
}) => S({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), nV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiListItemText"
  }), {
    children: s,
    className: c,
    disableTypography: f = !1,
    inset: m = !1,
    primary: h,
    primaryTypographyProps: v,
    secondary: b,
    secondaryTypographyProps: x
  } = i, E = pe(i, xae), {
    dense: T
  } = C.useContext(al);
  let P = h ?? s, O = b;
  const k = S({}, i, {
    disableTypography: f,
    inset: m,
    primary: !!P,
    secondary: !!O,
    dense: T
  }), I = wae(k);
  return P != null && P.type !== Ea && !f && (P = /* @__PURE__ */ L(Ea, S({
    variant: T ? "body2" : "body1",
    className: I.primary,
    component: v != null && v.variant ? void 0 : "span",
    display: "block"
  }, v, {
    children: P
  }))), O != null && O.type !== Ea && !f && (O = /* @__PURE__ */ L(Ea, S({
    variant: "body2",
    className: I.secondary,
    color: "text.secondary",
    display: "block"
  }, x, {
    children: O
  }))), /* @__PURE__ */ ht(Eae, S({
    className: be(I.root, c),
    ownerState: k,
    ref: o
  }, E, {
    children: [P, O]
  }));
});
process.env.NODE_ENV !== "production" && (nV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Alias for the `primary` prop.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: n.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: n.bool,
  /**
   * The main content element.
   */
  primary: n.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: n.object,
  /**
   * The secondary content element.
   */
  secondary: n.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Th = nV, Tae = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function QO(e, t, o) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : o ? null : e.firstChild;
}
function KD(e, t, o) {
  return e === t ? o ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : o ? null : e.lastChild;
}
function rV(e, t) {
  if (t === void 0)
    return !0;
  let o = e.innerText;
  return o === void 0 && (o = e.textContent), o = o.trim().toLowerCase(), o.length === 0 ? !1 : t.repeating ? o[0] === t.keys[0] : o.indexOf(t.keys.join("")) === 0;
}
function wb(e, t, o, i, s, c) {
  let f = !1, m = s(e, t, t ? o : !1);
  for (; m; ) {
    if (m === e.firstChild) {
      if (f)
        return !1;
      f = !0;
    }
    const h = i ? !1 : m.disabled || m.getAttribute("aria-disabled") === "true";
    if (!m.hasAttribute("tabindex") || !rV(m, c) || h)
      m = s(e, m, o);
    else
      return m.focus(), !0;
  }
  return !1;
}
const oV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: i,
    autoFocus: s = !1,
    autoFocusItem: c = !1,
    children: f,
    className: m,
    disabledItemsFocusable: h = !1,
    disableListWrap: v = !1,
    onKeyDown: b,
    variant: x = "selectedMenu"
  } = t, E = pe(t, Tae), T = C.useRef(null), P = C.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Hn(() => {
    s && T.current.focus();
  }, [s]), C.useImperativeHandle(i, () => ({
    adjustStyleForScrollbar: (_, z) => {
      const V = !T.current.style.width;
      if (_.clientHeight < T.current.clientHeight && V) {
        const M = `${rL(qn(_))}px`;
        T.current.style[z.direction === "rtl" ? "paddingLeft" : "paddingRight"] = M, T.current.style.width = `calc(100% + ${M})`;
      }
      return T.current;
    }
  }), []);
  const O = (_) => {
    const z = T.current, V = _.key, M = qn(z).activeElement;
    if (V === "ArrowDown")
      _.preventDefault(), wb(z, M, v, h, QO);
    else if (V === "ArrowUp")
      _.preventDefault(), wb(z, M, v, h, KD);
    else if (V === "Home")
      _.preventDefault(), wb(z, null, v, h, QO);
    else if (V === "End")
      _.preventDefault(), wb(z, null, v, h, KD);
    else if (V.length === 1) {
      const A = P.current, W = V.toLowerCase(), Y = performance.now();
      A.keys.length > 0 && (Y - A.lastTime > 500 ? (A.keys = [], A.repeating = !0, A.previousKeyMatched = !0) : A.repeating && W !== A.keys[0] && (A.repeating = !1)), A.lastTime = Y, A.keys.push(W);
      const H = M && !A.repeating && rV(M, A);
      A.previousKeyMatched && (H || wb(z, M, !1, h, QO, A)) ? _.preventDefault() : A.previousKeyMatched = !1;
    }
    b && b(_);
  }, k = Cn(T, o);
  let I = -1;
  C.Children.forEach(f, (_, z) => {
    if (!/* @__PURE__ */ C.isValidElement(_)) {
      I === z && (I += 1, I >= f.length && (I = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Kl.isFragment(_) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), _.props.disabled || (x === "selectedMenu" && _.props.selected || I === -1) && (I = z), I === z && (_.props.disabled || _.props.muiSkipListHighlight || _.type.muiSkipListHighlight) && (I += 1, I >= f.length && (I = -1));
  });
  const $ = C.Children.map(f, (_, z) => {
    if (z === I) {
      const V = {};
      return c && (V.autoFocus = !0), _.props.tabIndex === void 0 && x === "selectedMenu" && (V.tabIndex = 0), /* @__PURE__ */ C.cloneElement(_, V);
    }
    return _;
  });
  return /* @__PURE__ */ L(Hoe, S({
    role: "menu",
    ref: k,
    className: m,
    onKeyDown: O,
    tabIndex: s ? 0 : -1
  }, E, {
    children: $
  }));
});
process.env.NODE_ENV !== "production" && (oV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: n.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: n.node,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: n.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: n.bool,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: n.oneOf(["menu", "selectedMenu"])
});
const Dx = oV;
function Oae(e) {
  return ot("MuiPopover", e);
}
const Rae = lt("MuiPopover", ["root", "paper"]), A1e = Rae, kae = ["onEntering"], Pae = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], Mae = ["slotProps"];
function XD(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.height / 2 : t === "bottom" && (o = e.height), o;
}
function QD(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.width / 2 : t === "right" && (o = e.width), o;
}
function ZD(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function C1(e) {
  return typeof e == "function" ? e() : e;
}
const Iae = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    paper: ["paper"]
  }, Oae, t);
}, Nae = se(nP, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), aV = se(Ci, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), iV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c;
  const f = dt({
    props: t,
    name: "MuiPopover"
  }), {
    action: m,
    anchorEl: h,
    anchorOrigin: v = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: b,
    anchorReference: x = "anchorEl",
    children: E,
    className: T,
    container: P,
    elevation: O = 8,
    marginThreshold: k = 16,
    open: I,
    PaperProps: $ = {},
    slots: _,
    slotProps: z,
    transformOrigin: V = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: M = ay,
    transitionDuration: A = "auto",
    TransitionProps: {
      onEntering: W
    } = {},
    disableScrollLock: Y = !1
  } = f, H = pe(f.TransitionProps, kae), G = pe(f, Pae), ne = (i = z == null ? void 0 : z.paper) != null ? i : $, K = C.useRef(), B = Cn(K, ne.ref), q = S({}, f, {
    anchorOrigin: v,
    anchorReference: x,
    elevation: O,
    marginThreshold: k,
    externalPaperSlotProps: ne,
    transformOrigin: V,
    TransitionComponent: M,
    transitionDuration: A,
    TransitionProps: H
  }), X = Iae(q), J = C.useCallback(() => {
    if (x === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (b || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), b;
    const Fe = C1(h), ce = Fe && Fe.nodeType === 1 ? Fe : qn(K.current).body, ge = ce.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const we = ce.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && we.top === 0 && we.left === 0 && we.right === 0 && we.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: ge.top + XD(ge, v.vertical),
      left: ge.left + QD(ge, v.horizontal)
    };
  }, [h, v.horizontal, v.vertical, b, x]), U = C.useCallback((Fe) => ({
    vertical: XD(Fe, V.vertical),
    horizontal: QD(Fe, V.horizontal)
  }), [V.horizontal, V.vertical]), Z = C.useCallback((Fe) => {
    const ce = {
      width: Fe.offsetWidth,
      height: Fe.offsetHeight
    }, ge = U(ce);
    if (x === "none")
      return {
        top: null,
        left: null,
        transformOrigin: ZD(ge)
      };
    const we = J();
    let Me = we.top - ge.vertical, Qe = we.left - ge.horizontal;
    const ct = Me + ce.height, Ze = Qe + ce.width, Ge = Ta(C1(h)), Be = Ge.innerHeight - k, rt = Ge.innerWidth - k;
    if (k !== null && Me < k) {
      const wt = Me - k;
      Me -= wt, ge.vertical += wt;
    } else if (k !== null && ct > Be) {
      const wt = ct - Be;
      Me -= wt, ge.vertical += wt;
    }
    if (process.env.NODE_ENV !== "production" && ce.height > Be && ce.height && Be && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ce.height - Be}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), k !== null && Qe < k) {
      const wt = Qe - k;
      Qe -= wt, ge.horizontal += wt;
    } else if (Ze > rt) {
      const wt = Ze - rt;
      Qe -= wt, ge.horizontal += wt;
    }
    return {
      top: `${Math.round(Me)}px`,
      left: `${Math.round(Qe)}px`,
      transformOrigin: ZD(ge)
    };
  }, [h, x, J, U, k]), [ee, ie] = C.useState(I), oe = C.useCallback(() => {
    const Fe = K.current;
    if (!Fe)
      return;
    const ce = Z(Fe);
    ce.top !== null && (Fe.style.top = ce.top), ce.left !== null && (Fe.style.left = ce.left), Fe.style.transformOrigin = ce.transformOrigin, ie(!0);
  }, [Z]);
  C.useEffect(() => (Y && window.addEventListener("scroll", oe), () => window.removeEventListener("scroll", oe)), [h, Y, oe]);
  const le = (Fe, ce) => {
    W && W(Fe, ce), oe();
  }, de = () => {
    ie(!1);
  };
  C.useEffect(() => {
    I && oe();
  }), C.useImperativeHandle(m, () => I ? {
    updatePosition: () => {
      oe();
    }
  } : null, [I, oe]), C.useEffect(() => {
    if (!I)
      return;
    const Fe = lp(() => {
      oe();
    }), ce = Ta(h);
    return ce.addEventListener("resize", Fe), () => {
      Fe.clear(), ce.removeEventListener("resize", Fe);
    };
  }, [h, I, oe]);
  let Ce = A;
  A === "auto" && !M.muiSupportAuto && (Ce = void 0);
  const me = P || (h ? qn(C1(h)).body : void 0), Oe = (s = _ == null ? void 0 : _.root) != null ? s : Nae, he = (c = _ == null ? void 0 : _.paper) != null ? c : aV, $e = Gr({
    elementType: he,
    externalSlotProps: S({}, ne, {
      style: ee ? ne.style : S({}, ne.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: O,
      ref: B
    },
    ownerState: q,
    className: be(X.paper, ne == null ? void 0 : ne.className)
  }), Ne = Gr({
    elementType: Oe,
    externalSlotProps: (z == null ? void 0 : z.root) || {},
    externalForwardedProps: G,
    additionalProps: {
      ref: o,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: me,
      open: I
    },
    ownerState: q,
    className: be(X.root, T)
  }), {
    slotProps: Pe
  } = Ne, Se = pe(Ne, Mae);
  return /* @__PURE__ */ L(Oe, S({}, Se, !Ul(Oe) && {
    slotProps: Pe,
    disableScrollLock: Y
  }, {
    children: /* @__PURE__ */ L(M, S({
      appear: !0,
      in: I,
      onEntering: le,
      onExited: de,
      timeout: Ce
    }, H, {
      children: /* @__PURE__ */ L(he, S({}, $e, {
        children: E
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (iV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Fo,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: co(n.oneOfType([il, n.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = C1(e.anchorEl);
      if (t && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOfType([n.oneOf(["center", "left", "right"]), n.number]).isRequired,
    vertical: n.oneOfType([n.oneOf(["bottom", "center", "top"]), n.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: n.shape({
    left: n.number.isRequired,
    top: n.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: n.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: n.oneOfType([il, n.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: n.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: eo,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: n.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: n.shape({
    component: dd
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: n.shape({
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: n.shape({
    paper: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: n.shape({
    horizontal: n.oneOfType([n.oneOf(["center", "left", "right"]), n.number]).isRequired,
    vertical: n.oneOfType([n.oneOf(["bottom", "center", "top"]), n.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: n.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: n.object
});
const $ae = iV;
function Dae(e) {
  return ot("MuiMenu", e);
}
const _ae = lt("MuiMenu", ["root", "paper", "list"]), L1e = _ae, Aae = ["onEntering"], Lae = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], Fae = {
  vertical: "top",
  horizontal: "right"
}, zae = {
  vertical: "top",
  horizontal: "left"
}, Vae = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, Dae, t);
}, Bae = se($ae, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), jae = se(aV, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Hae = se(Dx, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), lV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = dt({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: f = !0,
    children: m,
    className: h,
    disableAutoFocusItem: v = !1,
    MenuListProps: b = {},
    onClose: x,
    open: E,
    PaperProps: T = {},
    PopoverClasses: P,
    transitionDuration: O = "auto",
    TransitionProps: {
      onEntering: k
    } = {},
    variant: I = "selectedMenu",
    slots: $ = {},
    slotProps: _ = {}
  } = c, z = pe(c.TransitionProps, Aae), V = pe(c, Lae), M = mr(), A = M.direction === "rtl", W = S({}, c, {
    autoFocus: f,
    disableAutoFocusItem: v,
    MenuListProps: b,
    onEntering: k,
    PaperProps: T,
    transitionDuration: O,
    TransitionProps: z,
    variant: I
  }), Y = Vae(W), H = f && !v && E, G = C.useRef(null), ne = (Z, ee) => {
    G.current && G.current.adjustStyleForScrollbar(Z, M), k && k(Z, ee);
  }, K = (Z) => {
    Z.key === "Tab" && (Z.preventDefault(), x && x(Z, "tabKeyDown"));
  };
  let B = -1;
  C.Children.map(m, (Z, ee) => {
    /* @__PURE__ */ C.isValidElement(Z) && (process.env.NODE_ENV !== "production" && Kl.isFragment(Z) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Z.props.disabled || (I === "selectedMenu" && Z.props.selected || B === -1) && (B = ee));
  });
  const q = (i = $.paper) != null ? i : jae, X = (s = _.paper) != null ? s : T, J = Gr({
    elementType: $.root,
    externalSlotProps: _.root,
    ownerState: W,
    className: [Y.root, h]
  }), U = Gr({
    elementType: q,
    externalSlotProps: X,
    ownerState: W,
    className: Y.paper
  });
  return /* @__PURE__ */ L(Bae, S({
    onClose: x,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: A ? "right" : "left"
    },
    transformOrigin: A ? Fae : zae,
    slots: {
      paper: q,
      root: $.root
    },
    slotProps: {
      root: J,
      paper: U
    },
    open: E,
    ref: o,
    transitionDuration: O,
    TransitionProps: S({
      onEntering: ne
    }, z),
    ownerState: W
  }, V, {
    classes: P,
    children: /* @__PURE__ */ L(Hae, S({
      onKeyDown: K,
      actions: G,
      autoFocus: f && (B === -1 || v),
      autoFocusItem: H,
      variant: I
    }, b, {
      className: be(Y.list, b.className),
      children: m
    }))
  }));
});
process.env.NODE_ENV !== "production" && (lV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: n.oneOfType([il, n.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: n.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: n.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: n.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: n.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: n.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: n.shape({
    paper: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: n.shape({
    paper: n.elementType,
    root: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: n.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: n.oneOf(["menu", "selectedMenu"])
});
const Uae = lV;
function Gae(e) {
  return ot("MuiMenuItem", e);
}
const Wae = lt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Eb = Wae, qae = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], Yae = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.divider && t.divider, !o.disableGutters && t.gutters];
}, Kae = (e) => {
  const {
    disabled: t,
    dense: o,
    divider: i,
    disableGutters: s,
    selected: c,
    classes: f
  } = e, h = je({
    root: ["root", o && "dense", t && "disabled", !s && "gutters", i && "divider", c && "selected"]
  }, Gae, f);
  return S({}, f, h);
}, Xae = se(Ao, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Yae
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Eb.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Eb.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Eb.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Eb.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Eb.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${$D.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${$D.inset}`]: {
    marginLeft: 52
  },
  [`& .${V1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${V1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${YD.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && S({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${YD.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), sV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: c = "li",
    dense: f = !1,
    divider: m = !1,
    disableGutters: h = !1,
    focusVisibleClassName: v,
    role: b = "menuitem",
    tabIndex: x,
    className: E
  } = i, T = pe(i, qae), P = C.useContext(al), O = C.useMemo(() => ({
    dense: f || P.dense || !1,
    disableGutters: h
  }), [P.dense, f, h]), k = C.useRef(null);
  Hn(() => {
    s && (k.current ? k.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const I = S({}, i, {
    dense: O.dense,
    divider: m,
    disableGutters: h
  }), $ = Kae(i), _ = Cn(k, o);
  let z;
  return i.disabled || (z = x !== void 0 ? x : -1), /* @__PURE__ */ L(al.Provider, {
    value: O,
    children: /* @__PURE__ */ L(Xae, S({
      ref: _,
      role: b,
      tabIndex: z,
      component: c,
      focusVisibleClassName: be($.focusVisible, v),
      className: be($.root, E)
    }, T, {
      ownerState: I,
      classes: $
    }))
  });
});
process.env.NODE_ENV !== "production" && (sV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: n.bool,
  /**
   * @ignore
   */
  disabled: n.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: n.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: n.string,
  /**
   * @ignore
   */
  role: n.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * @default 0
   */
  tabIndex: n.number
});
const Vs = sV;
function Qae(e) {
  return ot("MuiMobileStepper", e);
}
const Zae = lt("MuiMobileStepper", ["root", "positionBottom", "positionTop", "positionStatic", "dots", "dot", "dotActive", "progress"]), F1e = Zae, Jae = ["activeStep", "backButton", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"], eie = (e) => {
  const {
    classes: t,
    position: o
  } = e, i = {
    root: ["root", `position${ve(o)}`],
    dots: ["dots"],
    dot: ["dot"],
    dotActive: ["dotActive"],
    progress: ["progress"]
  };
  return je(i, Qae, t);
}, tie = se(Ci, {
  name: "MuiMobileStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`position${ve(o.position)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  background: (e.vars || e).palette.background.default,
  padding: 8
}, t.position === "bottom" && {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: (e.vars || e).zIndex.mobileStepper
}, t.position === "top" && {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: (e.vars || e).zIndex.mobileStepper
})), nie = se("div", {
  name: "MuiMobileStepper",
  slot: "Dots",
  overridesResolver: (e, t) => t.dots
})(({
  ownerState: e
}) => S({}, e.variant === "dots" && {
  display: "flex",
  flexDirection: "row"
})), rie = se("div", {
  name: "MuiMobileStepper",
  slot: "Dot",
  shouldForwardProp: (e) => Ty(e) && e !== "dotActive",
  overridesResolver: (e, t) => {
    const {
      dotActive: o
    } = e;
    return [t.dot, o && t.dotActive];
  }
})(({
  theme: e,
  ownerState: t,
  dotActive: o
}) => S({}, t.variant === "dots" && S({
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: (e.vars || e).palette.action.disabled,
  borderRadius: "50%",
  width: 8,
  height: 8,
  margin: "0 2px"
}, o && {
  backgroundColor: (e.vars || e).palette.primary.main
}))), oie = se(Roe, {
  name: "MuiMobileStepper",
  slot: "Progress",
  overridesResolver: (e, t) => t.progress
})(({
  ownerState: e
}) => S({}, e.variant === "progress" && {
  width: "50%"
})), cV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiMobileStepper"
  }), {
    activeStep: s = 0,
    backButton: c,
    className: f,
    LinearProgressProps: m,
    nextButton: h,
    position: v = "bottom",
    steps: b,
    variant: x = "dots"
  } = i, E = pe(i, Jae), T = S({}, i, {
    activeStep: s,
    position: v,
    variant: x
  });
  let P;
  x === "progress" && (b === 1 ? P = 100 : P = Math.ceil(s / (b - 1) * 100));
  const O = eie(T);
  return /* @__PURE__ */ ht(tie, S({
    square: !0,
    elevation: 0,
    className: be(O.root, f),
    ref: o,
    ownerState: T
  }, E, {
    children: [c, x === "text" && /* @__PURE__ */ ht(C.Fragment, {
      children: [s + 1, " / ", b]
    }), x === "dots" && /* @__PURE__ */ L(nie, {
      ownerState: T,
      className: O.dots,
      children: [...new Array(b)].map((k, I) => /* @__PURE__ */ L(rie, {
        className: be(O.dot, I === s && O.dotActive),
        ownerState: T,
        dotActive: I === s
      }, I))
    }), x === "progress" && /* @__PURE__ */ L(oie, S({
      ownerState: T,
      className: O.progress,
      variant: "determinate",
      value: P
    }, m)), h]
  }));
});
process.env.NODE_ENV !== "production" && (cV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   * @default 0
   */
  activeStep: eo,
  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: n.object,
  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: n.node,
  /**
   * Set the positioning type.
   * @default 'bottom'
   */
  position: n.oneOf(["bottom", "static", "top"]),
  /**
   * The total steps.
   */
  steps: eo.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'dots'
   */
  variant: n.oneOf(["dots", "progress", "text"])
});
const z1e = cV;
function uV(e) {
  return ot("MuiNativeSelect", e);
}
const aie = lt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), dP = aie, iie = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], lie = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: i,
    multiple: s,
    open: c,
    error: f
  } = e, m = {
    select: ["select", o, i && "disabled", s && "multiple", f && "error"],
    icon: ["icon", `icon${ve(o)}`, c && "iconOpen", i && "disabled"]
  };
  return je(m, uV, t);
}, dV = ({
  ownerState: e,
  theme: t
}) => S({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": S({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${dP.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), sie = se("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Oa,
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.select, t[o.variant], o.error && t.error, {
      [`&.${dP.multiple}`]: t.multiple
    }];
  }
})(dV), fV = ({
  ownerState: e,
  theme: t
}) => S({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${dP.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), cie = se("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${ve(o.variant)}`], o.open && t.iconOpen];
  }
})(fV), pV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i,
    disabled: s,
    error: c,
    IconComponent: f,
    inputRef: m,
    variant: h = "standard"
  } = t, v = pe(t, iie), b = S({}, t, {
    disabled: s,
    variant: h,
    error: c
  }), x = lie(b);
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(sie, S({
      ownerState: b,
      className: be(x.select, i),
      disabled: s,
      ref: m || o
    }, v)), t.multiple ? null : /* @__PURE__ */ L(cie, {
      as: f,
      ownerState: b,
      className: x.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (pV.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * The CSS class name of the select element.
   */
  className: n.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: n.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: n.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Fo,
  /**
   * @ignore
   */
  multiple: n.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: n.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The input value.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["standard", "outlined", "filled"])
});
const mV = pV, uie = ["className", "children", "classes", "IconComponent", "input", "inputProps", "variant"], die = ["root"], fie = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, uV, t);
}, pie = /* @__PURE__ */ L(sP, {}), fP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    name: "MuiNativeSelect",
    props: t
  }), {
    className: s,
    children: c,
    classes: f = {},
    IconComponent: m = eP,
    input: h = pie,
    inputProps: v
  } = i, b = pe(i, uie), x = Xl(), E = Yc({
    props: i,
    muiFormControl: x,
    states: ["variant"]
  }), T = S({}, i, {
    classes: f
  }), P = fie(T), O = pe(f, die);
  return /* @__PURE__ */ L(C.Fragment, {
    children: /* @__PURE__ */ C.cloneElement(h, S({
      // Most of the logic is implemented in `NativeSelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: mV,
      inputProps: S({
        children: c,
        classes: O,
        IconComponent: m,
        variant: E.variant,
        type: void 0
      }, v, h ? h.props.inputProps : {}),
      ref: o
    }, b, {
      className: be(P.root, h.props.className, s)
    }))
  });
});
process.env.NODE_ENV !== "production" && (fP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: n.elementType,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */
  input: n.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attributes) applied to the `select` element.
   */
  inputProps: n.object,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The `input` value. The DOM API casts this to a string.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
fP.muiName = "Select";
const V1e = fP;
var JD;
const mie = ["children", "classes", "className", "label", "notched"], hie = se("fieldset")({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), gie = se("legend")(({
  ownerState: e,
  theme: t
}) => S({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && S({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function hV(e) {
  const {
    className: t,
    label: o,
    notched: i
  } = e, s = pe(e, mie), c = o != null && o !== "", f = S({}, e, {
    notched: i,
    withLabel: c
  });
  return /* @__PURE__ */ L(hie, S({
    "aria-hidden": !0,
    className: t,
    ownerState: f
  }, s, {
    children: /* @__PURE__ */ L(gie, {
      ownerState: f,
      children: c ? /* @__PURE__ */ L("span", {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        JD || (JD = /* @__PURE__ */ L("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (hV.propTypes = {
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The label.
   */
  label: n.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: n.bool.isRequired,
  /**
   * @ignore
   */
  style: n.object
});
const vie = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], bie = (e) => {
  const {
    classes: t
  } = e, i = je({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, gZ, t);
  return S({}, t, i);
}, yie = se(Ix, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: Px
})(({
  theme: e,
  ownerState: t
}) => {
  const o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return S({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${$s.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${$s.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : o
      }
    },
    [`&.${$s.focused} .${$s.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${$s.error} .${$s.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${$s.disabled} .${$s.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && S({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), Cie = se(hV, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), Sie = se(Nx, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Mx
})(({
  theme: e,
  ownerState: t
}) => S({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), pP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m;
  const h = dt({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: v = {},
    fullWidth: b = !1,
    inputComponent: x = "input",
    label: E,
    multiline: T = !1,
    notched: P,
    slots: O = {},
    type: k = "text"
  } = h, I = pe(h, vie), $ = bie(h), _ = Xl(), z = Yc({
    props: h,
    muiFormControl: _,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), V = S({}, h, {
    color: z.color || "primary",
    disabled: z.disabled,
    error: z.error,
    focused: z.focused,
    formControl: _,
    fullWidth: b,
    hiddenLabel: z.hiddenLabel,
    multiline: T,
    size: z.size,
    type: k
  }), M = (i = (s = O.root) != null ? s : v.Root) != null ? i : yie, A = (c = (f = O.input) != null ? f : v.Input) != null ? c : Sie;
  return /* @__PURE__ */ L(Gh, S({
    slots: {
      root: M,
      input: A
    },
    renderSuffix: (W) => /* @__PURE__ */ L(Cie, {
      ownerState: V,
      className: $.notchedOutline,
      label: E != null && E !== "" && z.required ? m || (m = /* @__PURE__ */ ht(C.Fragment, {
        children: [E, " ", "*"]
      })) : E,
      notched: typeof P < "u" ? P : !!(W.startAdornment || W.filled || W.focused)
    }),
    fullWidth: b,
    inputComponent: x,
    multiline: T,
    ref: o,
    type: k
  }, I, {
    classes: S({}, $, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (pP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Root: n.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: n.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: n.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: n.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: n.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: n.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: n.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: n.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: n.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    root: n.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any
});
pP.muiName = "Input";
const gV = pP;
function xie(e) {
  return ot("MuiPagination", e);
}
const wie = lt("MuiPagination", ["root", "ul", "outlined", "text"]), B1e = wie, Eie = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function Tie(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: o = "usePagination",
    count: i = 1,
    defaultPage: s = 1,
    disabled: c = !1,
    hideNextButton: f = !1,
    hidePrevButton: m = !1,
    onChange: h,
    page: v,
    showFirstButton: b = !1,
    showLastButton: x = !1,
    siblingCount: E = 1
  } = e, T = pe(e, Eie), [P, O] = _i({
    controlled: v,
    default: s,
    name: o,
    state: "page"
  }), k = (Y, H) => {
    v || O(H), h && h(Y, H);
  }, I = (Y, H) => {
    const G = H - Y + 1;
    return Array.from({
      length: G
    }, (ne, K) => Y + K);
  }, $ = I(1, Math.min(t, i)), _ = I(Math.max(i - t + 1, t + 1), i), z = Math.max(
    Math.min(
      // Natural start
      P - E,
      // Lower boundary when page is high
      i - t - E * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), V = Math.min(
    Math.max(
      // Natural end
      P + E,
      // Upper boundary when page is low
      t + E * 2 + 2
    ),
    // Less than endPages
    _.length > 0 ? _[0] - 2 : i - 1
  ), M = [
    ...b ? ["first"] : [],
    ...m ? [] : ["previous"],
    ...$,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...z > t + 2 ? ["start-ellipsis"] : t + 1 < i - t ? [t + 1] : [],
    // Sibling pages
    ...I(z, V),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...V < i - t - 1 ? ["end-ellipsis"] : i - t > t ? [i - t] : [],
    ..._,
    ...f ? [] : ["next"],
    ...x ? ["last"] : []
  ], A = (Y) => {
    switch (Y) {
      case "first":
        return 1;
      case "previous":
        return P - 1;
      case "next":
        return P + 1;
      case "last":
        return i;
      default:
        return null;
    }
  }, W = M.map((Y) => typeof Y == "number" ? {
    onClick: (H) => {
      k(H, Y);
    },
    type: "page",
    page: Y,
    selected: Y === P,
    disabled: c,
    "aria-current": Y === P ? "true" : void 0
  } : {
    onClick: (H) => {
      k(H, A(Y));
    },
    type: Y,
    page: A(Y),
    selected: !1,
    disabled: c || Y.indexOf("ellipsis") === -1 && (Y === "next" || Y === "last" ? P >= i : P <= 1)
  });
  return S({
    items: W
  }, T);
}
function Oie(e) {
  return ot("MuiPaginationItem", e);
}
const Rie = lt("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon"]), Ji = Rie, B1 = rn(/* @__PURE__ */ L("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), j1 = rn(/* @__PURE__ */ L("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), e_ = rn(/* @__PURE__ */ L("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), t_ = rn(/* @__PURE__ */ L("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), kie = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], vV = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, t[o.variant], t[`size${ve(o.size)}`], o.variant === "text" && t[`text${ve(o.color)}`], o.variant === "outlined" && t[`outlined${ve(o.color)}`], o.shape === "rounded" && t.rounded, o.type === "page" && t.page, (o.type === "start-ellipsis" || o.type === "end-ellipsis") && t.ellipsis, (o.type === "previous" || o.type === "next") && t.previousNext, (o.type === "first" || o.type === "last") && t.firstLast];
}, Pie = (e) => {
  const {
    classes: t,
    color: o,
    disabled: i,
    selected: s,
    size: c,
    shape: f,
    type: m,
    variant: h
  } = e, v = {
    root: ["root", `size${ve(c)}`, h, f, o !== "standard" && `${h}${ve(o)}`, i && "disabled", s && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[m]],
    icon: ["icon"]
  };
  return je(v, Oie, t);
}, Mie = se("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: vV
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Ji.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
})), Iie = se(Ao, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: vV
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Ji.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ji.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ji.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selected} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Ji.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selected} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Ji.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  }
}, t.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
}, t.shape === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}), ({
  theme: e,
  ownerState: t
}) => S({}, t.variant === "text" && {
  [`&.${Ji.selected}`]: S({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    },
    [`&.${Ji.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  }, {
    [`&.${Ji.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    }
  })
}, t.variant === "outlined" && {
  border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${Ji.selected}`]: S({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].main,
    border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : _t(e.palette[t.color].main, 0.5)}`,
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : _t(e.palette[t.color].main, e.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Ji.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _t(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
    }
  }, {
    [`&.${Ji.disabled}`]: {
      borderColor: (e.vars || e).palette.action.disabledBackground,
      color: (e.vars || e).palette.action.disabled
    }
  })
})), Nie = se("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})(({
  theme: e,
  ownerState: t
}) => S({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px"
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: e.typography.pxToRem(22)
})), bV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: s,
    color: c = "standard",
    component: f,
    components: m = {},
    disabled: h = !1,
    page: v,
    selected: b = !1,
    shape: x = "circular",
    size: E = "medium",
    slots: T = {},
    type: P = "page",
    variant: O = "text"
  } = i, k = pe(i, kie), I = S({}, i, {
    color: c,
    disabled: h,
    selected: b,
    shape: x,
    size: E,
    type: P,
    variant: O
  }), $ = mr(), _ = Pie(I), V = ($.direction === "rtl" ? {
    previous: T.next || m.next || t_,
    next: T.previous || m.previous || e_,
    last: T.first || m.first || B1,
    first: T.last || m.last || j1
  } : {
    previous: T.previous || m.previous || e_,
    next: T.next || m.next || t_,
    first: T.first || m.first || B1,
    last: T.last || m.last || j1
  })[P];
  return P === "start-ellipsis" || P === "end-ellipsis" ? /* @__PURE__ */ L(Mie, {
    ref: o,
    ownerState: I,
    className: be(_.root, s),
    children: "…"
  }) : /* @__PURE__ */ ht(Iie, S({
    ref: o,
    ownerState: I,
    component: f,
    disabled: h,
    className: be(_.root, s)
  }, k, {
    children: [P === "page" && v, V ? /* @__PURE__ */ L(Nie, {
      as: V,
      ownerState: I,
      className: _.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (bV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "standard"]), n.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    first: n.elementType,
    last: n.elementType,
    next: n.elementType,
    previous: n.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The current page number.
   */
  page: n.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: n.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: n.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    first: n.elementType,
    last: n.elementType,
    next: n.elementType,
    previous: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: n.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["outlined", "text"]), n.string])
});
const $ie = bV, Die = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], _ie = (e) => {
  const {
    classes: t,
    variant: o
  } = e;
  return je({
    root: ["root", o],
    ul: ["ul"]
  }, xie, t);
}, Aie = se("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant]];
  }
})({}), Lie = se("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function Fie(e, t, o) {
  return e === "page" ? `${o ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const yV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: s = 1,
    className: c,
    color: f = "standard",
    count: m = 1,
    defaultPage: h = 1,
    disabled: v = !1,
    getItemAriaLabel: b = Fie,
    hideNextButton: x = !1,
    hidePrevButton: E = !1,
    renderItem: T = (W) => /* @__PURE__ */ L($ie, S({}, W)),
    shape: P = "circular",
    showFirstButton: O = !1,
    showLastButton: k = !1,
    siblingCount: I = 1,
    size: $ = "medium",
    variant: _ = "text"
  } = i, z = pe(i, Die), {
    items: V
  } = Tie(S({}, i, {
    componentName: "Pagination"
  })), M = S({}, i, {
    boundaryCount: s,
    color: f,
    count: m,
    defaultPage: h,
    disabled: v,
    getItemAriaLabel: b,
    hideNextButton: x,
    hidePrevButton: E,
    renderItem: T,
    shape: P,
    showFirstButton: O,
    showLastButton: k,
    siblingCount: I,
    size: $,
    variant: _
  }), A = _ie(M);
  return /* @__PURE__ */ L(Aie, S({
    "aria-label": "pagination navigation",
    className: be(A.root, c),
    ownerState: M,
    ref: o
  }, z, {
    children: /* @__PURE__ */ L(Lie, {
      className: A.ul,
      ownerState: M,
      children: V.map((W, Y) => /* @__PURE__ */ L("li", {
        children: T(S({}, W, {
          color: f,
          "aria-label": b(W.type, W.page, W.selected),
          shape: P,
          size: $,
          variant: _
        }))
      }, Y))
    })
  }));
});
process.env.NODE_ENV !== "production" && (yV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: eo,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "standard"]), n.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: eo,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: eo,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: n.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: n.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: n.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: n.func,
  /**
   * The current page.
   */
  page: eo,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: n.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: n.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: n.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: n.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: eo,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["outlined", "text"]), n.string])
});
const j1e = yV, zie = rn(/* @__PURE__ */ L("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), Vie = rn(/* @__PURE__ */ L("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Bie = se("span")({
  position: "relative",
  display: "flex"
}), jie = se(zie)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Hie = se(Vie)(({
  theme: e,
  ownerState: t
}) => S({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function mP(e) {
  const {
    checked: t = !1,
    classes: o = {},
    fontSize: i
  } = e, s = S({}, e, {
    checked: t
  });
  return /* @__PURE__ */ ht(Bie, {
    className: o.root,
    ownerState: s,
    children: [/* @__PURE__ */ L(jie, {
      fontSize: i,
      className: o.background,
      ownerState: s
    }), /* @__PURE__ */ L(Hie, {
      fontSize: i,
      className: o.dot,
      ownerState: s
    })]
  });
}
process.env.NODE_ENV !== "production" && (mP.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: n.oneOf(["small", "medium"])
});
const CV = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (CV.displayName = "RadioGroupContext");
const SV = CV;
function Uie() {
  return C.useContext(SV);
}
function Gie(e) {
  return ot("MuiRadio", e);
}
const Wie = lt("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), n_ = Wie, qie = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], Yie = (e) => {
  const {
    classes: t,
    color: o,
    size: i
  } = e, s = {
    root: ["root", `color${ve(o)}`, i !== "medium" && `size${ve(i)}`]
  };
  return S({}, t, je(s, Gie, t));
}, Kie = se(tP, {
  shouldForwardProp: (e) => Oa(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`color${ve(o.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${n_.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${n_.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function Xie(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const r_ = /* @__PURE__ */ L(mP, {
  checked: !0
}), o_ = /* @__PURE__ */ L(mP, {}), xV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = dt({
    props: t,
    name: "MuiRadio"
  }), {
    checked: f,
    checkedIcon: m = r_,
    color: h = "primary",
    icon: v = o_,
    name: b,
    onChange: x,
    size: E = "medium",
    className: T
  } = c, P = pe(c, qie), O = S({}, c, {
    color: h,
    size: E
  }), k = Yie(O), I = Uie();
  let $ = f;
  const _ = CR(x, I && I.onChange);
  let z = b;
  return I && (typeof $ > "u" && ($ = Xie(I.value, c.value)), typeof z > "u" && (z = I.name)), /* @__PURE__ */ L(Kie, S({
    type: "radio",
    icon: /* @__PURE__ */ C.cloneElement(v, {
      fontSize: (i = o_.props.fontSize) != null ? i : E
    }),
    checkedIcon: /* @__PURE__ */ C.cloneElement(m, {
      fontSize: (s = r_.props.fontSize) != null ? s : E
    }),
    ownerState: O,
    classes: k,
    name: z,
    checked: $,
    onChange: _,
    ref: o,
    className: be(k.root, T)
  }, P));
});
process.env.NODE_ENV !== "production" && (xV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: n.any
});
const H1e = xV, Qie = ["actions", "children", "defaultValue", "name", "onChange", "value"], wV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: i,
    children: s,
    defaultValue: c,
    name: f,
    onChange: m,
    value: h
  } = t, v = pe(t, Qie), b = C.useRef(null), [x, E] = _i({
    controlled: h,
    default: c,
    name: "RadioGroup"
  });
  C.useImperativeHandle(i, () => ({
    focus: () => {
      let k = b.current.querySelector("input:not(:disabled):checked");
      k || (k = b.current.querySelector("input:not(:disabled)")), k && k.focus();
    }
  }), []);
  const T = Cn(o, b), P = Qn(f), O = C.useMemo(() => ({
    name: P,
    onChange(k) {
      E(k.target.value), m && m(k, k.target.value);
    },
    value: x
  }), [P, m, E, x]);
  return /* @__PURE__ */ L(SV.Provider, {
    value: O,
    children: /* @__PURE__ */ L(_ne, S({
      role: "radiogroup",
      ref: T
    }, v, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (wV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: n.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: n.any
});
const U1e = wV, Zie = rn(/* @__PURE__ */ L("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star"), Jie = rn(/* @__PURE__ */ L("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
function ele(e) {
  return ot("MuiRating", e);
}
const tle = lt("MuiRating", ["root", "sizeSmall", "sizeMedium", "sizeLarge", "readOnly", "disabled", "focusVisible", "visuallyHidden", "pristine", "label", "labelEmptyValueActive", "icon", "iconEmpty", "iconFilled", "iconHover", "iconFocus", "iconActive", "decimal"]), Tb = tle, nle = ["value"], rle = ["className", "defaultValue", "disabled", "emptyIcon", "emptyLabelText", "getLabelText", "highlightSelectedOnly", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"];
function ole(e, t, o) {
  return e < t ? t : e > o ? o : e;
}
function ale(e) {
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function ZO(e, t) {
  if (e == null)
    return e;
  const o = Math.round(e / t) * t;
  return Number(o.toFixed(ale(t)));
}
const ile = (e) => {
  const {
    classes: t,
    size: o,
    readOnly: i,
    disabled: s,
    emptyValueFocused: c,
    focusVisible: f
  } = e, m = {
    root: ["root", `size${ve(o)}`, s && "disabled", f && "focusVisible", i && "readOnly"],
    label: ["label", "pristine"],
    labelEmptyValue: [c && "labelEmptyValueActive"],
    icon: ["icon"],
    iconEmpty: ["iconEmpty"],
    iconFilled: ["iconFilled"],
    iconHover: ["iconHover"],
    iconFocus: ["iconFocus"],
    iconActive: ["iconActive"],
    decimal: ["decimal"],
    visuallyHidden: ["visuallyHidden"]
  };
  return je(m, ele, t);
}, lle = se("span", {
  name: "MuiRating",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Tb.visuallyHidden}`]: t.visuallyHidden
    }, t.root, t[`size${ve(o.size)}`], o.readOnly && t.readOnly];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "inline-flex",
  // Required to position the pristine input absolutely
  position: "relative",
  fontSize: e.typography.pxToRem(24),
  color: "#faaf00",
  cursor: "pointer",
  textAlign: "left",
  WebkitTapHighlightColor: "transparent",
  [`&.${Tb.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    pointerEvents: "none"
  },
  [`&.${Tb.focusVisible} .${Tb.iconActive}`]: {
    outline: "1px solid #999"
  },
  [`& .${Tb.visuallyHidden}`]: aL
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: e.typography.pxToRem(30)
}, t.readOnly && {
  pointerEvents: "none"
})), EV = se("label", {
  name: "MuiRating",
  slot: "Label",
  overridesResolver: ({
    ownerState: e
  }, t) => [t.label, e.emptyValueFocused && t.labelEmptyValueActive]
})(({
  ownerState: e
}) => S({
  cursor: "inherit"
}, e.emptyValueFocused && {
  top: 0,
  bottom: 0,
  position: "absolute",
  outline: "1px solid #999",
  width: "100%"
})), sle = se("span", {
  name: "MuiRating",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.iconEmpty && t.iconEmpty, o.iconFilled && t.iconFilled, o.iconHover && t.iconHover, o.iconFocus && t.iconFocus, o.iconActive && t.iconActive];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  // Fit wrapper to actual icon size.
  display: "flex",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: "none"
}, t.iconActive && {
  transform: "scale(1.2)"
}, t.iconEmpty && {
  color: (e.vars || e).palette.action.disabled
})), cle = se("span", {
  name: "MuiRating",
  slot: "Decimal",
  shouldForwardProp: (e) => Ty(e) && e !== "iconActive",
  overridesResolver: (e, t) => {
    const {
      iconActive: o
    } = e;
    return [t.decimal, o && t.iconActive];
  }
})(({
  iconActive: e
}) => S({
  position: "relative"
}, e && {
  transform: "scale(1.2)"
}));
function TV(e) {
  const t = pe(e, nle);
  return /* @__PURE__ */ L("span", S({}, t));
}
process.env.NODE_ENV !== "production" && (TV.propTypes = {
  value: n.number.isRequired
});
function FR(e) {
  const {
    classes: t,
    disabled: o,
    emptyIcon: i,
    focus: s,
    getLabelText: c,
    highlightSelectedOnly: f,
    hover: m,
    icon: h,
    IconContainerComponent: v,
    isActive: b,
    itemValue: x,
    labelProps: E,
    name: T,
    onBlur: P,
    onChange: O,
    onClick: k,
    onFocus: I,
    readOnly: $,
    ownerState: _,
    ratingValue: z,
    ratingValueRounded: V
  } = e, M = f ? x === z : x <= z, A = x <= m, W = x <= s, Y = x === V, H = Qn(), G = /* @__PURE__ */ L(sle, {
    as: v,
    value: x,
    className: be(t.icon, M ? t.iconFilled : t.iconEmpty, A && t.iconHover, W && t.iconFocus, b && t.iconActive),
    ownerState: S({}, _, {
      iconEmpty: !M,
      iconFilled: M,
      iconHover: A,
      iconFocus: W,
      iconActive: b
    }),
    children: i && !M ? i : h
  });
  return $ ? /* @__PURE__ */ L("span", S({}, E, {
    children: G
  })) : /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ ht(EV, S({
      ownerState: S({}, _, {
        emptyValueFocused: void 0
      }),
      htmlFor: H
    }, E, {
      children: [G, /* @__PURE__ */ L("span", {
        className: t.visuallyHidden,
        children: c(x)
      })]
    })), /* @__PURE__ */ L("input", {
      className: t.visuallyHidden,
      onFocus: I,
      onBlur: P,
      onChange: O,
      onClick: k,
      disabled: o,
      value: x,
      id: H,
      type: "radio",
      name: T,
      checked: Y
    })]
  });
}
process.env.NODE_ENV !== "production" && (FR.propTypes = {
  classes: n.object.isRequired,
  disabled: n.bool.isRequired,
  emptyIcon: n.node,
  focus: n.number.isRequired,
  getLabelText: n.func.isRequired,
  highlightSelectedOnly: n.bool.isRequired,
  hover: n.number.isRequired,
  icon: n.node,
  IconContainerComponent: n.elementType.isRequired,
  isActive: n.bool.isRequired,
  itemValue: n.number.isRequired,
  labelProps: n.object,
  name: n.string,
  onBlur: n.func.isRequired,
  onChange: n.func.isRequired,
  onClick: n.func.isRequired,
  onFocus: n.func.isRequired,
  ownerState: n.object.isRequired,
  ratingValue: n.number,
  ratingValueRounded: n.number,
  readOnly: n.bool.isRequired
});
const ule = /* @__PURE__ */ L(Zie, {
  fontSize: "inherit"
}), dle = /* @__PURE__ */ L(Jie, {
  fontSize: "inherit"
});
function fle(e) {
  return `${e} Star${e !== 1 ? "s" : ""}`;
}
const OV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    name: "MuiRating",
    props: t
  }), {
    className: s,
    defaultValue: c = null,
    disabled: f = !1,
    emptyIcon: m = dle,
    emptyLabelText: h = "Empty",
    getLabelText: v = fle,
    highlightSelectedOnly: b = !1,
    icon: x = ule,
    IconContainerComponent: E = TV,
    max: T = 5,
    name: P,
    onChange: O,
    onChangeActive: k,
    onMouseLeave: I,
    onMouseMove: $,
    precision: _ = 1,
    readOnly: z = !1,
    size: V = "medium",
    value: M
  } = i, A = pe(i, rle), W = Qn(P), [Y, H] = _i({
    controlled: M,
    default: c,
    name: "Rating"
  }), G = ZO(Y, _), ne = mr(), [{
    hover: K,
    focus: B
  }, q] = C.useState({
    hover: -1,
    focus: -1
  });
  let X = G;
  K !== -1 && (X = K), B !== -1 && (X = B);
  const {
    isFocusVisibleRef: J,
    onBlur: U,
    onFocus: Z,
    ref: ee
  } = vy(), [ie, oe] = C.useState(!1), le = C.useRef(), de = Cn(ee, le, o), Ce = (ge) => {
    $ && $(ge);
    const we = le.current, {
      right: Me,
      left: Qe
    } = we.getBoundingClientRect(), {
      width: ct
    } = we.firstChild.getBoundingClientRect();
    let Ze;
    ne.direction === "rtl" ? Ze = (Me - ge.clientX) / (ct * T) : Ze = (ge.clientX - Qe) / (ct * T);
    let Ge = ZO(T * Ze + _ / 2, _);
    Ge = ole(Ge, _, T), q((Be) => Be.hover === Ge && Be.focus === Ge ? Be : {
      hover: Ge,
      focus: Ge
    }), oe(!1), k && K !== Ge && k(ge, Ge);
  }, me = (ge) => {
    I && I(ge);
    const we = -1;
    q({
      hover: we,
      focus: we
    }), k && K !== we && k(ge, we);
  }, Oe = (ge) => {
    let we = ge.target.value === "" ? null : parseFloat(ge.target.value);
    K !== -1 && (we = K), H(we), O && O(ge, we);
  }, he = (ge) => {
    ge.clientX === 0 && ge.clientY === 0 || (q({
      hover: -1,
      focus: -1
    }), H(null), O && parseFloat(ge.target.value) === G && O(ge, null));
  }, $e = (ge) => {
    Z(ge), J.current === !0 && oe(!0);
    const we = parseFloat(ge.target.value);
    q((Me) => ({
      hover: Me.hover,
      focus: we
    }));
  }, Ne = (ge) => {
    if (K !== -1)
      return;
    U(ge), J.current === !1 && oe(!1);
    const we = -1;
    q((Me) => ({
      hover: Me.hover,
      focus: we
    }));
  }, [Pe, Se] = C.useState(!1), Fe = S({}, i, {
    defaultValue: c,
    disabled: f,
    emptyIcon: m,
    emptyLabelText: h,
    emptyValueFocused: Pe,
    focusVisible: ie,
    getLabelText: v,
    icon: x,
    IconContainerComponent: E,
    max: T,
    precision: _,
    readOnly: z,
    size: V
  }), ce = ile(Fe);
  return /* @__PURE__ */ ht(lle, S({
    ref: de,
    onMouseMove: Ce,
    onMouseLeave: me,
    className: be(ce.root, s, z && "MuiRating-readOnly"),
    ownerState: Fe,
    role: z ? "img" : null,
    "aria-label": z ? v(X) : null
  }, A, {
    children: [Array.from(new Array(T)).map((ge, we) => {
      const Me = we + 1, Qe = {
        classes: ce,
        disabled: f,
        emptyIcon: m,
        focus: B,
        getLabelText: v,
        highlightSelectedOnly: b,
        hover: K,
        icon: x,
        IconContainerComponent: E,
        name: W,
        onBlur: Ne,
        onChange: Oe,
        onClick: he,
        onFocus: $e,
        ratingValue: X,
        ratingValueRounded: G,
        readOnly: z,
        ownerState: Fe
      }, ct = Me === Math.ceil(X) && (K !== -1 || B !== -1);
      if (_ < 1) {
        const Ze = Array.from(new Array(1 / _));
        return /* @__PURE__ */ L(cle, {
          className: be(ce.decimal, ct && ce.iconActive),
          ownerState: Fe,
          iconActive: ct,
          children: Ze.map((Ge, Be) => {
            const rt = ZO(Me - 1 + (Be + 1) * _, _);
            return /* @__PURE__ */ L(FR, S({}, Qe, {
              // The icon is already displayed as active
              isActive: !1,
              itemValue: rt,
              labelProps: {
                style: Ze.length - 1 === Be ? {} : {
                  width: rt === X ? `${(Be + 1) * _ * 100}%` : "0%",
                  overflow: "hidden",
                  position: "absolute"
                }
              }
            }), rt);
          })
        }, Me);
      }
      return /* @__PURE__ */ L(FR, S({}, Qe, {
        isActive: ct,
        itemValue: Me
      }), Me);
    }), !z && !f && /* @__PURE__ */ ht(EV, {
      className: be(ce.label, ce.labelEmptyValue),
      ownerState: Fe,
      children: [/* @__PURE__ */ L("input", {
        className: ce.visuallyHidden,
        value: "",
        id: `${W}-empty`,
        type: "radio",
        name: W,
        checked: G == null,
        onFocus: () => Se(!0),
        onBlur: () => Se(!1),
        onChange: Oe
      }), /* @__PURE__ */ L("span", {
        className: ce.visuallyHidden,
        children: h
      })]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (OV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The default value. Use when the component is not controlled.
   * @default null
   */
  defaultValue: n.number,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */
  emptyIcon: n.node,
  /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */
  emptyLabelText: n.node,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value} Star${value !== 1 ? 's' : ''}`;
   * }
   */
  getLabelText: n.func,
  /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */
  highlightSelectedOnly: n.bool,
  /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */
  icon: n.node,
  /**
   * The component containing the icon.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */
  IconContainerComponent: n.elementType,
  /**
   * Maximum rating.
   * @default 5
   */
  max: n.number,
  /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generated IDs.
   */
  name: n.string,
  /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */
  onChange: n.func,
  /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * @ignore
   */
  onMouseMove: n.func,
  /**
   * The minimum increment value change allowed.
   * @default 1
   */
  precision: co(n.number, (e) => e.precision < 0.1 ? new Error(["MUI: The prop `precision` should be above 0.1.", "A value below this limit has an imperceptible impact."].join(`
`)) : null),
  /**
   * Removes all hover effects and pointer events.
   * @default false
   */
  readOnly: n.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The rating value.
   */
  value: n.number
});
const G1e = OV;
function ple(e) {
  return ot("MuiScopedCssBaseline", e);
}
const mle = lt("MuiScopedCssBaseline", ["root"]), W1e = mle, hle = ["className", "component", "enableColorScheme"], gle = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, ple, t);
}, vle = se("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const o = {};
  return t.enableColorScheme && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([i, s]) => {
    var c;
    o[`&${e.getColorSchemeSelector(i).replace(/\s*&/, "")}`] = {
      colorScheme: (c = s.palette) == null ? void 0 : c.mode
    };
  }), S({}, sz(e, t.enableColorScheme), cz(e), {
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    }
  }, o);
}), RV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: s,
    component: c = "div"
  } = i, f = pe(i, hle), m = S({}, i, {
    component: c
  }), h = gle(m);
  return /* @__PURE__ */ L(vle, S({
    as: c,
    className: be(h.root, s),
    ref: o,
    ownerState: m
  }, f));
});
process.env.NODE_ENV !== "production" && (RV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const q1e = RV;
function ble(e) {
  return ot("MuiSelect", e);
}
const yle = lt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), Ob = yle;
var a_;
const Cle = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], Sle = se("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Ob.select}`]: t.select
      },
      {
        [`&.${Ob.select}`]: t[o.variant]
      },
      {
        [`&.${Ob.error}`]: t.error
      },
      {
        [`&.${Ob.multiple}`]: t.multiple
      }
    ];
  }
})(dV, {
  // Win specificity over the input base
  [`&.${Ob.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), xle = se("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${ve(o.variant)}`], o.open && t.iconOpen];
  }
})(fV), wle = se("input", {
  shouldForwardProp: (e) => Ty(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function i_(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function Ele(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const Tle = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: i,
    multiple: s,
    open: c,
    error: f
  } = e, m = {
    select: ["select", o, i && "disabled", s && "multiple", f && "error"],
    icon: ["icon", `icon${ve(o)}`, c && "iconOpen", i && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return je(m, ble, t);
}, kV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const {
    "aria-describedby": s,
    "aria-label": c,
    autoFocus: f,
    autoWidth: m,
    children: h,
    className: v,
    defaultOpen: b,
    defaultValue: x,
    disabled: E,
    displayEmpty: T,
    error: P = !1,
    IconComponent: O,
    inputRef: k,
    labelId: I,
    MenuProps: $ = {},
    multiple: _,
    name: z,
    onBlur: V,
    onChange: M,
    onClose: A,
    onFocus: W,
    onOpen: Y,
    open: H,
    readOnly: G,
    renderValue: ne,
    SelectDisplayProps: K = {},
    tabIndex: B,
    value: q,
    variant: X = "standard"
  } = t, J = pe(t, Cle), [U, Z] = _i({
    controlled: q,
    default: x,
    name: "Select"
  }), [ee, ie] = _i({
    controlled: H,
    default: b,
    name: "Select"
  }), oe = C.useRef(null), le = C.useRef(null), [de, Ce] = C.useState(null), {
    current: me
  } = C.useRef(H != null), [Oe, he] = C.useState(), $e = Cn(o, k), Ne = C.useCallback((_e) => {
    le.current = _e, _e && Ce(_e);
  }, []), Pe = de == null ? void 0 : de.parentNode;
  C.useImperativeHandle($e, () => ({
    focus: () => {
      le.current.focus();
    },
    node: oe.current,
    value: U
  }), [U]), C.useEffect(() => {
    b && ee && de && !me && (he(m ? null : Pe.clientWidth), le.current.focus());
  }, [de, m]), C.useEffect(() => {
    f && le.current.focus();
  }, [f]), C.useEffect(() => {
    if (!I)
      return;
    const _e = qn(le.current).getElementById(I);
    if (_e) {
      const vt = () => {
        getSelection().isCollapsed && le.current.focus();
      };
      return _e.addEventListener("click", vt), () => {
        _e.removeEventListener("click", vt);
      };
    }
  }, [I]);
  const Se = (_e, vt) => {
    _e ? Y && Y(vt) : A && A(vt), me || (he(m ? null : Pe.clientWidth), ie(_e));
  }, Fe = (_e) => {
    _e.button === 0 && (_e.preventDefault(), le.current.focus(), Se(!0, _e));
  }, ce = (_e) => {
    Se(!1, _e);
  }, ge = C.Children.toArray(h), we = (_e) => {
    const vt = ge.find((et) => et.props.value === _e.target.value);
    vt !== void 0 && (Z(vt.props.value), M && M(_e, vt));
  }, Me = (_e) => (vt) => {
    let et;
    if (vt.currentTarget.hasAttribute("tabindex")) {
      if (_) {
        et = Array.isArray(U) ? U.slice() : [];
        const gt = U.indexOf(_e.props.value);
        gt === -1 ? et.push(_e.props.value) : et.splice(gt, 1);
      } else
        et = _e.props.value;
      if (_e.props.onClick && _e.props.onClick(vt), U !== et && (Z(et), M)) {
        const gt = vt.nativeEvent || vt, kt = new gt.constructor(gt.type, gt);
        Object.defineProperty(kt, "target", {
          writable: !0,
          value: {
            value: et,
            name: z
          }
        }), M(kt, _e);
      }
      _ || Se(!1, vt);
    }
  }, Qe = (_e) => {
    G || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(_e.key) !== -1 && (_e.preventDefault(), Se(!0, _e));
  }, ct = de !== null && ee, Ze = (_e) => {
    !ct && V && (Object.defineProperty(_e, "target", {
      writable: !0,
      value: {
        value: U,
        name: z
      }
    }), V(_e));
  };
  delete J["aria-invalid"];
  let Ge, Be;
  const rt = [];
  let wt = !1, We = !1;
  (F1({
    value: U
  }) || T) && (ne ? Ge = ne(U) : wt = !0);
  const ut = ge.map((_e) => {
    if (!/* @__PURE__ */ C.isValidElement(_e))
      return null;
    process.env.NODE_ENV !== "production" && Kl.isFragment(_e) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let vt;
    if (_) {
      if (!Array.isArray(U))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : gi(2));
      vt = U.some((et) => i_(et, _e.props.value)), vt && wt && rt.push(_e.props.children);
    } else
      vt = i_(U, _e.props.value), vt && wt && (Be = _e.props.children);
    return vt && (We = !0), /* @__PURE__ */ C.cloneElement(_e, {
      "aria-selected": vt ? "true" : "false",
      onClick: Me(_e),
      onKeyUp: (et) => {
        et.key === " " && et.preventDefault(), _e.props.onKeyUp && _e.props.onKeyUp(et);
      },
      role: "option",
      selected: vt,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": _e.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && C.useEffect(() => {
    if (!We && !_ && U !== "") {
      const _e = ge.map((vt) => vt.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${U}\` for the select ${z ? `(name="${z}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${_e.filter((vt) => vt != null).map((vt) => `\`${vt}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [We, ge, _, z, U]), wt && (_ ? rt.length === 0 ? Ge = null : Ge = rt.reduce((_e, vt, et) => (_e.push(vt), et < rt.length - 1 && _e.push(", "), _e), []) : Ge = Be);
  let ft = Oe;
  !m && me && de && (ft = Pe.clientWidth);
  let Je;
  typeof B < "u" ? Je = B : Je = E ? null : 0;
  const pt = K.id || (z ? `mui-component-select-${z}` : void 0), At = S({}, t, {
    variant: X,
    value: U,
    open: ct,
    error: P
  }), Ye = Tle(At), st = S({}, $.PaperProps, (i = $.slotProps) == null ? void 0 : i.paper);
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(Sle, S({
      ref: Ne,
      tabIndex: Je,
      role: "button",
      "aria-disabled": E ? "true" : void 0,
      "aria-expanded": ct ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": c,
      "aria-labelledby": [I, pt].filter(Boolean).join(" ") || void 0,
      "aria-describedby": s,
      onKeyDown: Qe,
      onMouseDown: E || G ? null : Fe,
      onBlur: Ze,
      onFocus: W
    }, K, {
      ownerState: At,
      className: be(K.className, Ye.select, v),
      id: pt,
      children: Ele(Ge) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        a_ || (a_ = /* @__PURE__ */ L("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Ge
    })), /* @__PURE__ */ L(wle, S({
      "aria-invalid": P,
      value: Array.isArray(U) ? U.join(",") : U,
      name: z,
      ref: oe,
      "aria-hidden": !0,
      onChange: we,
      tabIndex: -1,
      disabled: E,
      className: Ye.nativeInput,
      autoFocus: f,
      ownerState: At
    }, J)), /* @__PURE__ */ L(xle, {
      as: O,
      className: Ye.icon,
      ownerState: At
    }), /* @__PURE__ */ L(Uae, S({
      id: `menu-${z || ""}`,
      anchorEl: Pe,
      open: ct,
      onClose: ce,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, $, {
      MenuListProps: S({
        "aria-labelledby": I,
        role: "listbox",
        "aria-multiselectable": _ ? "true" : void 0,
        disableListWrap: !0
      }, $.MenuListProps),
      slotProps: {
        paper: S({}, st, {
          style: S({
            minWidth: ft
          }, st != null ? st.style : null)
        })
      },
      children: ut
    }))]
  });
});
process.env.NODE_ENV !== "production" && (kV.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": n.string,
  /**
   * @ignore
   */
  "aria-label": n.string,
  /**
   * @ignore
   */
  autoFocus: n.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: n.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: n.object,
  /**
   * The CSS class name of the select element.
   */
  className: n.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: n.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: n.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: n.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: n.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Fo,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: n.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: n.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: n.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * @ignore
   */
  readOnly: n.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: n.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: n.object,
  /**
   * @ignore
   */
  tabIndex: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  type: n.any,
  /**
   * The input value.
   */
  value: n.any,
  /**
   * The variant to use.
   */
  variant: n.oneOf(["standard", "outlined", "filled"])
});
const Ole = kV, Rle = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], kle = ["root"], Ple = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, hP = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Oa(e) && e !== "variant",
  slot: "Root"
}, Mle = se(sP, hP)(""), Ile = se(gV, hP)(""), Nle = se(Oz, hP)(""), gP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: s = !1,
    children: c,
    classes: f = {},
    className: m,
    defaultOpen: h = !1,
    displayEmpty: v = !1,
    IconComponent: b = eP,
    id: x,
    input: E,
    inputProps: T,
    label: P,
    labelId: O,
    MenuProps: k,
    multiple: I = !1,
    native: $ = !1,
    onClose: _,
    onOpen: z,
    open: V,
    renderValue: M,
    SelectDisplayProps: A,
    variant: W = "outlined"
  } = i, Y = pe(i, Rle), H = $ ? mV : Ole, G = Xl(), ne = Yc({
    props: i,
    muiFormControl: G,
    states: ["variant", "error"]
  }), K = ne.variant || W, B = S({}, i, {
    variant: K,
    classes: f
  }), q = Ple(B), X = pe(q, kle), J = E || {
    standard: /* @__PURE__ */ L(Mle, {
      ownerState: B
    }),
    outlined: /* @__PURE__ */ L(Ile, {
      label: P,
      ownerState: B
    }),
    filled: /* @__PURE__ */ L(Nle, {
      ownerState: B
    })
  }[K], U = Cn(o, J.ref);
  return /* @__PURE__ */ L(C.Fragment, {
    children: /* @__PURE__ */ C.cloneElement(J, S({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: H,
      inputProps: S({
        children: c,
        error: ne.error,
        IconComponent: b,
        variant: K,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: I
      }, $ ? {
        id: x
      } : {
        autoWidth: s,
        defaultOpen: h,
        displayEmpty: v,
        labelId: O,
        MenuProps: k,
        onClose: _,
        onOpen: z,
        open: V,
        renderValue: M,
        SelectDisplayProps: S({
          id: x
        }, A)
      }, T, {
        classes: T ? So(X, T.classes) : X
      }, E ? E.props.inputProps : {})
    }, I && $ && K === "outlined" ? {
      notched: !0
    } : {}, {
      ref: U,
      className: be(J.props.className, m, q.root)
    }, !E && {
      variant: K
    }, Y))
  });
});
process.env.NODE_ENV !== "production" && (gP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: n.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: n.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: n.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: n.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: n.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: n.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: n.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: n.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: n.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: n.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: n.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: n.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: n.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: n.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: n.oneOfType([n.oneOf([""]), n.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
gP.muiName = "Select";
const vP = gP;
function $le(e) {
  return ot("MuiSkeleton", e);
}
const Dle = lt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]), Y1e = Dle, _le = ["animation", "className", "component", "height", "style", "variant", "width"];
let H1 = (e) => e, l_, s_, c_, u_;
const Ale = (e) => {
  const {
    classes: t,
    variant: o,
    animation: i,
    hasChildren: s,
    width: c,
    height: f
  } = e;
  return je({
    root: ["root", o, i, s && "withChildren", s && !c && "fitContent", s && !f && "heightAuto"]
  }, $le, t);
}, Lle = Gs(l_ || (l_ = H1`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), Fle = Gs(s_ || (s_ = H1`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), zle = se("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], o.animation !== !1 && t[o.animation], o.hasChildren && t.withChildren, o.hasChildren && !o.width && t.fitContent, o.hasChildren && !o.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const o = eF(e.shape.borderRadius) || "px", i = Ju(e.shape.borderRadius);
  return S({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : _t(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${i}${o}/${Math.round(i / 0.6 * 10) / 10}${o}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && fd(c_ || (c_ = H1`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), Lle), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && fd(u_ || (u_ = H1`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), Fle, (t.vars || t).palette.action.hover)), PV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: s = "pulse",
    className: c,
    component: f = "span",
    height: m,
    style: h,
    variant: v = "text",
    width: b
  } = i, x = pe(i, _le), E = S({}, i, {
    animation: s,
    component: f,
    variant: v,
    hasChildren: !!x.children
  }), T = Ale(E);
  return /* @__PURE__ */ L(zle, S({
    as: f,
    ref: o,
    className: be(T.root, c),
    ownerState: E
  }, x, {
    style: S({
      width: b,
      height: m
    }, h)
  }));
});
process.env.NODE_ENV !== "production" && (PV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: n.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: n.oneOfType([n.oneOf(["circular", "rectangular", "rounded", "text"]), n.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: n.oneOfType([n.number, n.string])
});
const Vle = PV, Ble = (e) => !e || !Ul(e), jle = Ble;
function Hle(e) {
  return ot("MuiSlider", e);
}
const Ule = lt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), Bl = Ule, Gle = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: be(t && Bl.valueLabelOpen),
    circle: Bl.valueLabelCircle,
    label: Bl.valueLabelLabel
  };
};
function MV(e) {
  const {
    children: t,
    className: o,
    value: i
  } = e, s = Gle(e);
  return t ? /* @__PURE__ */ C.cloneElement(t, {
    className: be(t.props.className)
  }, /* @__PURE__ */ ht(C.Fragment, {
    children: [t.props.children, /* @__PURE__ */ L("span", {
      className: be(s.offset, o),
      "aria-hidden": !0,
      children: /* @__PURE__ */ L("span", {
        className: s.circle,
        children: /* @__PURE__ */ L("span", {
          className: s.label,
          children: i
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (MV.propTypes = {
  children: n.element.isRequired,
  className: n.string,
  value: n.node
});
const Wle = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function d_(e) {
  return e;
}
const qle = se("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`color${ve(o.color)}`], o.size !== "medium" && t[`size${ve(o.size)}`], o.marked && t.marked, o.orientation === "vertical" && t.vertical, o.track === "inverted" && t.trackInverted, o.track === !1 && t.trackFalse];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  color: (e.vars || e).palette[t.color].main,
  WebkitTapHighlightColor: "transparent"
}, t.orientation === "horizontal" && S({
  height: 4,
  width: "100%",
  padding: "13px 0",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "20px 0"
  }
}, t.size === "small" && {
  height: 2
}, t.marked && {
  marginBottom: 20
}), t.orientation === "vertical" && S({
  height: "100%",
  width: 4,
  padding: "0 13px",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "0 20px"
  }
}, t.size === "small" && {
  width: 2
}, t.marked && {
  marginRight: 44
}), {
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${Bl.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${Bl.dragging}`]: {
    [`& .${Bl.thumb}, & .${Bl.track}`]: {
      transition: "none"
    }
  }
})), Yle = se("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})(({
  ownerState: e
}) => S({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38
}, e.orientation === "horizontal" && {
  width: "100%",
  height: "inherit",
  top: "50%",
  transform: "translateY(-50%)"
}, e.orientation === "vertical" && {
  height: "100%",
  width: "inherit",
  left: "50%",
  transform: "translateX(-50%)"
}, e.track === "inverted" && {
  opacity: 1
})), Kle = se("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e,
  ownerState: t
}) => {
  const o = (
    // Same logic as the LinearProgress track color
    e.palette.mode === "light" ? ql(e.palette[t.color].main, 0.62) : Wl(e.palette[t.color].main, 0.5)
  );
  return S({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    })
  }, t.size === "small" && {
    border: "none"
  }, t.orientation === "horizontal" && {
    height: "inherit",
    top: "50%",
    transform: "translateY(-50%)"
  }, t.orientation === "vertical" && {
    width: "inherit",
    left: "50%",
    transform: "translateX(-50%)"
  }, t.track === !1 && {
    display: "none"
  }, t.track === "inverted" && {
    backgroundColor: e.vars ? e.vars.palette.Slider[`${t.color}Track`] : o,
    borderColor: e.vars ? e.vars.palette.Slider[`${t.color}Track`] : o
  });
}), Xle = se("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.thumb, t[`thumbColor${ve(o.color)}`], o.size !== "medium" && t[`thumbSize${ve(o.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  })
}, t.size === "small" && {
  width: 12,
  height: 12
}, t.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-50%, -50%)"
}, t.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 50%)"
}, {
  "&:before": S({
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  }, t.size === "small" && {
    boxShadow: "none"
  }),
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&:hover, &.${Bl.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.16)` : _t(e.palette[t.color].main, 0.16)}`,
    "@media (hover: none)": {
      boxShadow: "none"
    }
  },
  [`&.${Bl.active}`]: {
    boxShadow: `0px 0px 0px 14px ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.16)` : _t(e.palette[t.color].main, 0.16)}`
  },
  [`&.${Bl.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  }
})), Qle = se(MV, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e,
  ownerState: t
}) => S({
  [`&.${Bl.valueLabelOpen}`]: {
    transform: `${t.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(1)`
  },
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  transform: `${t.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(0)`,
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem"
}, t.orientation === "horizontal" && {
  top: "-10px",
  transformOrigin: "bottom center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    bottom: 0,
    left: "50%"
  }
}, t.orientation === "vertical" && {
  right: t.size === "small" ? "20px" : "30px",
  top: "50%",
  transformOrigin: "right center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, -50%) rotate(45deg)",
    backgroundColor: "inherit",
    right: -8,
    top: "50%"
  }
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(12),
  padding: "0.25rem 0.5rem"
})), Zle = se("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => Ty(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: o
    } = e;
    return [t.mark, o && t.markActive];
  }
})(({
  theme: e,
  ownerState: t,
  markActive: o
}) => S({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor"
}, t.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-1px, -50%)"
}, t.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 1px)"
}, o && {
  backgroundColor: (e.vars || e).palette.background.paper,
  opacity: 0.8
})), Jle = se("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => Ty(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e,
  ownerState: t,
  markLabelActive: o
}) => S({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap"
}, t.orientation === "horizontal" && {
  top: 30,
  transform: "translateX(-50%)",
  "@media (pointer: coarse)": {
    top: 40
  }
}, t.orientation === "vertical" && {
  left: 36,
  transform: "translateY(50%)",
  "@media (pointer: coarse)": {
    left: 44
  }
}, o && {
  color: (e.vars || e).palette.text.primary
})), ese = (e) => {
  const {
    disabled: t,
    dragging: o,
    marked: i,
    orientation: s,
    track: c,
    classes: f,
    color: m,
    size: h
  } = e, v = {
    root: ["root", t && "disabled", o && "dragging", i && "marked", s === "vertical" && "vertical", c === "inverted" && "trackInverted", c === !1 && "trackFalse", m && `color${ve(m)}`, h && `size${ve(h)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", h && `thumbSize${ve(h)}`, m && `thumbColor${ve(m)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return je(v, Hle, f);
}, tse = ({
  children: e
}) => e, IV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h, v, b, x, E, T, P, O, k, I, $, _, z, V, M, A, W, Y, H;
  const G = dt({
    props: t,
    name: "MuiSlider"
  }), K = mr().direction === "rtl", {
    "aria-label": B,
    "aria-valuetext": q,
    "aria-labelledby": X,
    // eslint-disable-next-line react/prop-types
    component: J = "span",
    components: U = {},
    componentsProps: Z = {},
    color: ee = "primary",
    classes: ie,
    className: oe,
    disableSwap: le = !1,
    disabled: de = !1,
    getAriaLabel: Ce,
    getAriaValueText: me,
    marks: Oe = !1,
    max: he = 100,
    min: $e = 0,
    orientation: Ne = "horizontal",
    size: Pe = "medium",
    step: Se = 1,
    scale: Fe = d_,
    slotProps: ce,
    slots: ge,
    track: we = "normal",
    valueLabelDisplay: Me = "off",
    valueLabelFormat: Qe = d_
  } = G, ct = pe(G, Wle), Ze = S({}, G, {
    isRtl: K,
    max: he,
    min: $e,
    classes: ie,
    disabled: de,
    disableSwap: le,
    orientation: Ne,
    marks: Oe,
    color: ee,
    size: Pe,
    step: Se,
    scale: Fe,
    track: we,
    valueLabelDisplay: Me,
    valueLabelFormat: Qe
  }), {
    axisProps: Ge,
    getRootProps: Be,
    getHiddenInputProps: rt,
    getThumbProps: wt,
    open: We,
    active: ut,
    axis: ft,
    focusedThumbIndex: Je,
    range: pt,
    dragging: At,
    marks: Ye,
    values: st,
    trackOffset: _e,
    trackLeap: vt,
    getThumbStyle: et
  } = VQ(S({}, Ze, {
    rootRef: o
  }));
  Ze.marked = Ye.length > 0 && Ye.some((xe) => xe.label), Ze.dragging = At, Ze.focusedThumbIndex = Je;
  const gt = ese(Ze), kt = (i = (s = ge == null ? void 0 : ge.root) != null ? s : U.Root) != null ? i : qle, Lt = (c = (f = ge == null ? void 0 : ge.rail) != null ? f : U.Rail) != null ? c : Yle, Ut = (m = (h = ge == null ? void 0 : ge.track) != null ? h : U.Track) != null ? m : Kle, Sn = (v = (b = ge == null ? void 0 : ge.thumb) != null ? b : U.Thumb) != null ? v : Xle, an = (x = (E = ge == null ? void 0 : ge.valueLabel) != null ? E : U.ValueLabel) != null ? x : Qle, un = (T = (P = ge == null ? void 0 : ge.mark) != null ? P : U.Mark) != null ? T : Zle, wn = (O = (k = ge == null ? void 0 : ge.markLabel) != null ? k : U.MarkLabel) != null ? O : Jle, hn = (I = ($ = ge == null ? void 0 : ge.input) != null ? $ : U.Input) != null ? I : "input", Br = (_ = ce == null ? void 0 : ce.root) != null ? _ : Z.root, zo = (z = ce == null ? void 0 : ce.rail) != null ? z : Z.rail, wo = (V = ce == null ? void 0 : ce.track) != null ? V : Z.track, to = (M = ce == null ? void 0 : ce.thumb) != null ? M : Z.thumb, Dr = (A = ce == null ? void 0 : ce.valueLabel) != null ? A : Z.valueLabel, Vn = (W = ce == null ? void 0 : ce.mark) != null ? W : Z.mark, Dn = (Y = ce == null ? void 0 : ce.markLabel) != null ? Y : Z.markLabel, Zn = (H = ce == null ? void 0 : ce.input) != null ? H : Z.input, _r = Gr({
    elementType: kt,
    getSlotProps: Be,
    externalSlotProps: Br,
    externalForwardedProps: ct,
    additionalProps: S({}, jle(kt) && {
      as: J
    }),
    ownerState: S({}, Ze, Br == null ? void 0 : Br.ownerState),
    className: [gt.root, oe]
  }), ur = Gr({
    elementType: Lt,
    externalSlotProps: zo,
    ownerState: Ze,
    className: gt.rail
  }), Bn = Gr({
    elementType: Ut,
    externalSlotProps: wo,
    additionalProps: {
      style: S({}, Ge[ft].offset(_e), Ge[ft].leap(vt))
    },
    ownerState: S({}, Ze, wo == null ? void 0 : wo.ownerState),
    className: gt.track
  }), xr = Gr({
    elementType: Sn,
    getSlotProps: wt,
    externalSlotProps: to,
    ownerState: S({}, Ze, to == null ? void 0 : to.ownerState),
    className: gt.thumb
  }), fe = Gr({
    elementType: an,
    externalSlotProps: Dr,
    ownerState: S({}, Ze, Dr == null ? void 0 : Dr.ownerState),
    className: gt.valueLabel
  }), at = Gr({
    elementType: un,
    externalSlotProps: Vn,
    ownerState: Ze,
    className: gt.mark
  }), Et = Gr({
    elementType: wn,
    externalSlotProps: Dn,
    ownerState: Ze,
    className: gt.markLabel
  }), Ie = Gr({
    elementType: hn,
    getSlotProps: rt,
    externalSlotProps: Zn,
    ownerState: Ze
  });
  return /* @__PURE__ */ ht(kt, S({}, _r, {
    children: [/* @__PURE__ */ L(Lt, S({}, ur)), /* @__PURE__ */ L(Ut, S({}, Bn)), Ye.filter((xe) => xe.value >= $e && xe.value <= he).map((xe, ze) => {
      const mt = L1(xe.value, $e, he), Ct = Ge[ft].offset(mt);
      let Qt;
      return we === !1 ? Qt = st.indexOf(xe.value) !== -1 : Qt = we === "normal" && (pt ? xe.value >= st[0] && xe.value <= st[st.length - 1] : xe.value <= st[0]) || we === "inverted" && (pt ? xe.value <= st[0] || xe.value >= st[st.length - 1] : xe.value >= st[0]), /* @__PURE__ */ ht(C.Fragment, {
        children: [/* @__PURE__ */ L(un, S({
          "data-index": ze
        }, at, !Ul(un) && {
          markActive: Qt
        }, {
          style: S({}, Ct, at.style),
          className: be(at.className, Qt && gt.markActive)
        })), xe.label != null ? /* @__PURE__ */ L(wn, S({
          "aria-hidden": !0,
          "data-index": ze
        }, Et, !Ul(wn) && {
          markLabelActive: Qt
        }, {
          style: S({}, Ct, Et.style),
          className: be(gt.markLabel, Et.className, Qt && gt.markLabelActive),
          children: xe.label
        })) : null]
      }, ze);
    }), st.map((xe, ze) => {
      const mt = L1(xe, $e, he), Ct = Ge[ft].offset(mt), Qt = Me === "off" ? tse : an;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ L(Qt, S({}, !Ul(Qt) && {
          valueLabelFormat: Qe,
          valueLabelDisplay: Me,
          value: typeof Qe == "function" ? Qe(Fe(xe), ze) : Qe,
          index: ze,
          open: We === ze || ut === ze || Me === "on",
          disabled: de
        }, fe, {
          children: /* @__PURE__ */ L(Sn, S({
            "data-index": ze
          }, xr, {
            className: be(gt.thumb, xr.className, ut === ze && gt.active, Je === ze && gt.focusVisible),
            style: S({}, Ct, et(ze), xr.style),
            children: /* @__PURE__ */ L(hn, S({
              "data-index": ze,
              "aria-label": Ce ? Ce(ze) : B,
              "aria-valuenow": Fe(xe),
              "aria-labelledby": X,
              "aria-valuetext": me ? me(Fe(xe), ze) : q,
              value: st[ze]
            }, Ie))
          }))
        }), ze)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (IV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The label of the slider.
   */
  "aria-label": co(n.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": n.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": co(n.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Input: n.elementType,
    Mark: n.elementType,
    MarkLabel: n.elementType,
    Rail: n.elementType,
    Root: n.elementType,
    Thumb: n.elementType,
    Track: n.elementType,
    ValueLabel: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    mark: n.oneOfType([n.func, n.object]),
    markLabel: n.oneOfType([n.func, n.object]),
    rail: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    thumb: n.oneOfType([n.func, n.object]),
    track: n.oneOfType([n.func, n.object]),
    valueLabel: n.oneOfType([n.func, n.shape({
      children: n.element,
      className: n.string,
      open: n.bool,
      style: n.object,
      value: n.number,
      valueLabelDisplay: n.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.oneOfType([n.arrayOf(n.number), n.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: n.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: n.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: n.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: n.oneOfType([n.arrayOf(n.shape({
    label: n.node,
    value: n.number.isRequired
  })), n.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: n.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: n.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: n.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: n.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: n.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: n.func,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium"]), n.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: n.shape({
    input: n.oneOfType([n.func, n.object]),
    mark: n.oneOfType([n.func, n.object]),
    markLabel: n.oneOfType([n.func, n.object]),
    rail: n.oneOfType([n.func, n.object]),
    root: n.oneOfType([n.func, n.object]),
    thumb: n.oneOfType([n.func, n.object]),
    track: n.oneOfType([n.func, n.object]),
    valueLabel: n.oneOfType([n.func, n.shape({
      children: n.element,
      className: n.string,
      open: n.bool,
      style: n.object,
      value: n.number,
      valueLabelDisplay: n.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: n.shape({
    input: n.elementType,
    mark: n.elementType,
    markLabel: n.elementType,
    rail: n.elementType,
    root: n.elementType,
    thumb: n.elementType,
    track: n.elementType,
    valueLabel: n.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: n.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: n.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: n.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: n.oneOfType([n.arrayOf(n.number), n.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: n.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: n.oneOfType([n.func, n.string])
});
const K1e = IV;
function nse(e) {
  return ot("MuiSnackbarContent", e);
}
const rse = lt("MuiSnackbarContent", ["root", "message", "action"]), X1e = rse, ose = ["action", "className", "message", "role"], ase = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    action: ["action"],
    message: ["message"]
  }, nse, t);
}, ise = se(Ci, {
  name: "MuiSnackbarContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? 0.8 : 0.98, o = M1(e.palette.background.default, t);
  return S({}, e.typography.body2, {
    color: e.vars ? e.vars.palette.SnackbarContent.color : e.palette.getContrastText(o),
    backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : o,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    flexGrow: 1,
    [e.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 288
    }
  });
}), lse = se("div", {
  name: "MuiSnackbarContent",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0"
}), sse = se("div", {
  name: "MuiSnackbarContent",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  paddingLeft: 16,
  marginRight: -8
}), NV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSnackbarContent"
  }), {
    action: s,
    className: c,
    message: f,
    role: m = "alert"
  } = i, h = pe(i, ose), v = i, b = ase(v);
  return /* @__PURE__ */ ht(ise, S({
    role: m,
    square: !0,
    elevation: 6,
    className: be(b.root, c),
    ownerState: v,
    ref: o
  }, h, {
    children: [/* @__PURE__ */ L(lse, {
      className: b.message,
      ownerState: v,
      children: f
    }), s ? /* @__PURE__ */ L(sse, {
      className: b.action,
      ownerState: v,
      children: s
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (NV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The message to display.
   */
  message: n.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const cse = NV;
function use(e) {
  return ot("MuiSnackbar", e);
}
const dse = lt("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft"]), Q1e = dse, fse = ["onEnter", "onExited"], pse = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"], mse = (e) => {
  const {
    classes: t,
    anchorOrigin: o
  } = e, i = {
    root: ["root", `anchorOrigin${ve(o.vertical)}${ve(o.horizontal)}`]
  };
  return je(i, use, t);
}, f_ = se("div", {
  name: "MuiSnackbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`anchorOrigin${ve(o.anchorOrigin.vertical)}${ve(o.anchorOrigin.horizontal)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const o = {
    left: "50%",
    right: "auto",
    transform: "translateX(-50%)"
  };
  return S({
    zIndex: (e.vars || e).zIndex.snackbar,
    position: "fixed",
    display: "flex",
    left: 8,
    right: 8,
    justifyContent: "center",
    alignItems: "center"
  }, t.anchorOrigin.vertical === "top" ? {
    top: 8
  } : {
    bottom: 8
  }, t.anchorOrigin.horizontal === "left" && {
    justifyContent: "flex-start"
  }, t.anchorOrigin.horizontal === "right" && {
    justifyContent: "flex-end"
  }, {
    [e.breakpoints.up("sm")]: S({}, t.anchorOrigin.vertical === "top" ? {
      top: 24
    } : {
      bottom: 24
    }, t.anchorOrigin.horizontal === "center" && o, t.anchorOrigin.horizontal === "left" && {
      left: 24,
      right: "auto"
    }, t.anchorOrigin.horizontal === "right" && {
      right: 24,
      left: "auto"
    })
  });
}), $V = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSnackbar"
  }), s = mr(), c = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    action: f,
    anchorOrigin: {
      vertical: m,
      horizontal: h
    } = {
      vertical: "bottom",
      horizontal: "left"
    },
    autoHideDuration: v = null,
    children: b,
    className: x,
    ClickAwayListenerProps: E,
    ContentProps: T,
    disableWindowBlurListener: P = !1,
    message: O,
    open: k,
    TransitionComponent: I = ay,
    transitionDuration: $ = c,
    TransitionProps: {
      onEnter: _,
      onExited: z
    } = {}
  } = i, V = pe(i.TransitionProps, fse), M = pe(i, pse), A = S({}, i, {
    anchorOrigin: {
      vertical: m,
      horizontal: h
    },
    autoHideDuration: v,
    disableWindowBlurListener: P,
    TransitionComponent: I,
    transitionDuration: $
  }), W = mse(A), {
    getRootProps: Y,
    onClickAway: H
  } = BQ(S({}, A)), [G, ne] = C.useState(!0), K = Gr({
    elementType: f_,
    getSlotProps: Y,
    externalForwardedProps: M,
    ownerState: A,
    additionalProps: {
      ref: o
    },
    className: [W.root, x]
  }), B = (X) => {
    ne(!0), z && z(X);
  }, q = (X, J) => {
    ne(!1), _ && _(X, J);
  };
  return !k && G ? null : /* @__PURE__ */ L($h, S({
    onClickAway: H
  }, E, {
    children: /* @__PURE__ */ L(f_, S({}, K, {
      children: /* @__PURE__ */ L(I, S({
        appear: !0,
        in: k,
        timeout: $,
        direction: m === "top" ? "down" : "up",
        onEnter: q,
        onExited: B
      }, V, {
        children: b || /* @__PURE__ */ L(cse, S({
          message: O,
          action: f
        }, T))
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && ($V.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: n.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: n.shape({
    horizontal: n.oneOf(["center", "left", "right"]).isRequired,
    vertical: n.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: n.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: n.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: n.object,
  /**
   * Props applied to the [`SnackbarContent`](/material-ui/api/snackbar-content/) element.
   */
  ContentProps: n.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: n.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: n.node,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * @ignore
   */
  onMouseEnter: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: n.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: n.object
});
const Z1e = $V, hse = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], gse = {
  entering: {
    transform: "none"
  },
  entered: {
    transform: "none"
  }
}, DV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = mr(), s = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: c,
    appear: f = !0,
    children: m,
    easing: h,
    in: v,
    onEnter: b,
    onEntered: x,
    onEntering: E,
    onExit: T,
    onExited: P,
    onExiting: O,
    style: k,
    timeout: I = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = Oy
  } = t, _ = pe(t, hse), z = C.useRef(null), V = Cn(z, m.ref, o), M = (B) => (q) => {
    if (B) {
      const X = z.current;
      q === void 0 ? B(X) : B(X, q);
    }
  }, A = M(E), W = M((B, q) => {
    Ex(B);
    const X = Yl({
      style: k,
      timeout: I,
      easing: h
    }, {
      mode: "enter"
    });
    B.style.webkitTransition = i.transitions.create("transform", X), B.style.transition = i.transitions.create("transform", X), b && b(B, q);
  }), Y = M(x), H = M(O), G = M((B) => {
    const q = Yl({
      style: k,
      timeout: I,
      easing: h
    }, {
      mode: "exit"
    });
    B.style.webkitTransition = i.transitions.create("transform", q), B.style.transition = i.transitions.create("transform", q), T && T(B);
  }), ne = M(P);
  return /* @__PURE__ */ L($, S({
    appear: f,
    in: v,
    nodeRef: z,
    onEnter: W,
    onEntered: Y,
    onEntering: A,
    onExit: G,
    onExited: ne,
    onExiting: H,
    addEndListener: (B) => {
      c && c(z.current, B);
    },
    timeout: I
  }, _, {
    children: (B, q) => /* @__PURE__ */ C.cloneElement(m, S({
      style: S({
        transform: "scale(0)",
        visibility: B === "exited" && !v ? "hidden" : void 0
      }, gse[B], k, m.props.style),
      ref: V
    }, q))
  }));
});
process.env.NODE_ENV !== "production" && (DV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: vd.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
const vse = DV;
function bse(e) {
  return ot("MuiSpeedDial", e);
}
const yse = lt("MuiSpeedDial", ["root", "fab", "directionUp", "directionDown", "directionLeft", "directionRight", "actions", "actionsClosed"]), ZS = yse, Cse = ["ref"], Sse = ["ariaLabel", "FabProps", "children", "className", "direction", "hidden", "icon", "onBlur", "onClose", "onFocus", "onKeyDown", "onMouseEnter", "onMouseLeave", "onOpen", "open", "openIcon", "TransitionComponent", "transitionDuration", "TransitionProps"], xse = ["ref"], wse = (e) => {
  const {
    classes: t,
    open: o,
    direction: i
  } = e, s = {
    root: ["root", `direction${ve(i)}`],
    fab: ["fab"],
    actions: ["actions", !o && "actionsClosed"]
  };
  return je(s, bse, t);
};
function Rb(e) {
  if (e === "up" || e === "down")
    return "vertical";
  if (e === "right" || e === "left")
    return "horizontal";
}
function Ese(e, t, o) {
  return e < t ? t : e > o ? o : e;
}
const Qu = 32, JS = 16, Tse = se("div", {
  name: "MuiSpeedDial",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`direction${ve(o.direction)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: (e.vars || e).zIndex.speedDial,
  display: "flex",
  alignItems: "center",
  pointerEvents: "none"
}, t.direction === "up" && {
  flexDirection: "column-reverse",
  [`& .${ZS.actions}`]: {
    flexDirection: "column-reverse",
    marginBottom: -Qu,
    paddingBottom: JS + Qu
  }
}, t.direction === "down" && {
  flexDirection: "column",
  [`& .${ZS.actions}`]: {
    flexDirection: "column",
    marginTop: -Qu,
    paddingTop: JS + Qu
  }
}, t.direction === "left" && {
  flexDirection: "row-reverse",
  [`& .${ZS.actions}`]: {
    flexDirection: "row-reverse",
    marginRight: -Qu,
    paddingRight: JS + Qu
  }
}, t.direction === "right" && {
  flexDirection: "row",
  [`& .${ZS.actions}`]: {
    flexDirection: "row",
    marginLeft: -Qu,
    paddingLeft: JS + Qu
  }
})), Ose = se(Tz, {
  name: "MuiSpeedDial",
  slot: "Fab",
  overridesResolver: (e, t) => t.fab
})(() => ({
  pointerEvents: "auto"
})), Rse = se("div", {
  name: "MuiSpeedDial",
  slot: "Actions",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.actions, !o.open && t.actionsClosed];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  pointerEvents: "auto"
}, !e.open && {
  transition: "top 0s linear 0.2s",
  pointerEvents: "none"
})), _V = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSpeedDial"
  }), s = mr(), c = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    ariaLabel: f,
    FabProps: {
      ref: m
    } = {},
    children: h,
    className: v,
    direction: b = "up",
    hidden: x = !1,
    icon: E,
    onBlur: T,
    onClose: P,
    onFocus: O,
    onKeyDown: k,
    onMouseEnter: I,
    onMouseLeave: $,
    onOpen: _,
    open: z,
    TransitionComponent: V = vse,
    transitionDuration: M = c,
    TransitionProps: A
  } = i, W = pe(i.FabProps, Cse), Y = pe(i, Sse), [H, G] = _i({
    controlled: z,
    default: !1,
    name: "SpeedDial",
    state: "open"
  }), ne = S({}, i, {
    open: H,
    direction: b
  }), K = wse(ne), B = C.useRef();
  C.useEffect(() => () => {
    clearTimeout(B.current);
  }, []);
  const q = C.useRef(0), X = C.useRef(), J = C.useRef([]);
  J.current = [J.current[0]];
  const U = C.useCallback((he) => {
    J.current[0] = he;
  }, []), Z = Cn(m, U), ee = (he, $e) => (Ne) => {
    J.current[he + 1] = Ne, $e && $e(Ne);
  }, ie = (he) => {
    k && k(he);
    const $e = he.key.replace("Arrow", "").toLowerCase(), {
      current: Ne = $e
    } = X;
    if (he.key === "Escape") {
      G(!1), J.current[0].focus(), P && P(he, "escapeKeyDown");
      return;
    }
    if (Rb($e) === Rb(Ne) && Rb($e) !== void 0) {
      he.preventDefault();
      const Pe = $e === Ne ? 1 : -1, Se = Ese(q.current + Pe, 0, J.current.length - 1);
      J.current[Se].focus(), q.current = Se, X.current = Ne;
    }
  };
  C.useEffect(() => {
    H || (q.current = 0, X.current = void 0);
  }, [H]);
  const oe = (he) => {
    he.type === "mouseleave" && $ && $(he), he.type === "blur" && T && T(he), clearTimeout(B.current), he.type === "blur" ? B.current = setTimeout(() => {
      G(!1), P && P(he, "blur");
    }) : (G(!1), P && P(he, "mouseLeave"));
  }, le = (he) => {
    W.onClick && W.onClick(he), clearTimeout(B.current), H ? (G(!1), P && P(he, "toggle")) : (G(!0), _ && _(he, "toggle"));
  }, de = (he) => {
    he.type === "mouseenter" && I && I(he), he.type === "focus" && O && O(he), clearTimeout(B.current), H || (B.current = setTimeout(() => {
      G(!0), _ && _(he, {
        focus: "focus",
        mouseenter: "mouseEnter"
      }[he.type]);
    }));
  }, Ce = f.replace(/^[^a-z]+|[^\w:.-]+/gi, ""), me = C.Children.toArray(h).filter((he) => (process.env.NODE_ENV !== "production" && Kl.isFragment(he) && console.error(["MUI: The SpeedDial component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ C.isValidElement(he))), Oe = me.map((he, $e) => {
    const Ne = he.props, {
      FabProps: {
        ref: Pe
      } = {},
      tooltipPlacement: Se
    } = Ne, Fe = pe(Ne.FabProps, xse), ce = Se || (Rb(b) === "vertical" ? "left" : "top");
    return /* @__PURE__ */ C.cloneElement(he, {
      FabProps: S({}, Fe, {
        ref: ee($e, Pe)
      }),
      delay: 30 * (H ? $e : me.length - $e),
      open: H,
      tooltipPlacement: ce,
      id: `${Ce}-action-${$e}`
    });
  });
  return /* @__PURE__ */ ht(Tse, S({
    className: be(K.root, v),
    ref: o,
    role: "presentation",
    onKeyDown: ie,
    onBlur: oe,
    onFocus: de,
    onMouseEnter: de,
    onMouseLeave: oe,
    ownerState: ne
  }, Y, {
    children: [/* @__PURE__ */ L(V, S({
      in: !x,
      timeout: M,
      unmountOnExit: !0
    }, A, {
      children: /* @__PURE__ */ L(Ose, S({
        color: "primary",
        "aria-label": f,
        "aria-haspopup": "true",
        "aria-expanded": H,
        "aria-controls": `${Ce}-actions`
      }, W, {
        onClick: le,
        className: be(K.fab, W.className),
        ref: Z,
        ownerState: ne,
        children: /* @__PURE__ */ C.isValidElement(E) && zc(E, ["SpeedDialIcon"]) ? /* @__PURE__ */ C.cloneElement(E, {
          open: H
        }) : E
      }))
    })), /* @__PURE__ */ L(Rse, {
      id: `${Ce}-actions`,
      role: "menu",
      "aria-orientation": Rb(b),
      className: be(K.actions, !H && K.actionsClosed),
      ownerState: ne,
      children: Oe
    })]
  }));
});
process.env.NODE_ENV !== "production" && (_V.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */
  ariaLabel: n.string.isRequired,
  /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The direction the actions open relative to the floating action button.
   * @default 'up'
   */
  direction: n.oneOf(["down", "left", "right", "up"]),
  /**
   * Props applied to the [`Fab`](/material-ui/api/fab/) element.
   * @default {}
   */
  FabProps: n.object,
  /**
   * If `true`, the SpeedDial is hidden.
   * @default false
   */
  hidden: n.bool,
  /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */
  icon: n.node,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */
  onClose: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * @ignore
   */
  onKeyDown: n.func,
  /**
   * @ignore
   */
  onMouseEnter: n.func,
  /**
   * @ignore
   */
  onMouseLeave: n.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"focus"`, `"mouseEnter"`.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */
  openIcon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Zoom
   */
  TransitionComponent: n.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: n.object
});
const J1e = _V;
function kse(e) {
  return ot("MuiTooltip", e);
}
const Pse = lt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), ld = Pse, Mse = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function Ise(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Nse = (e) => {
  const {
    classes: t,
    disableInteractive: o,
    arrow: i,
    touch: s,
    placement: c
  } = e, f = {
    popper: ["popper", !o && "popperInteractive", i && "popperArrow"],
    tooltip: ["tooltip", i && "tooltipArrow", s && "touch", `tooltipPlacement${ve(c.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return je(f, kse, t);
}, $se = se(cp, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.popper, !o.disableInteractive && t.popperInteractive, o.arrow && t.popperArrow, !o.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: o
}) => S({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !o && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${ld.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${ld.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${ld.arrow}`]: S({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${ld.arrow}`]: S({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), Dse = se("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.tooltip, o.touch && t.touch, o.arrow && t.tooltipArrow, t[`tooltipPlacement${ve(o.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : _t(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${Ise(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${ld.popper}[data-popper-placement*="left"] &`]: S({
    transformOrigin: "right center"
  }, t.isRtl ? S({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : S({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${ld.popper}[data-popper-placement*="right"] &`]: S({
    transformOrigin: "left center"
  }, t.isRtl ? S({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : S({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${ld.popper}[data-popper-placement*="top"] &`]: S({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${ld.popper}[data-popper-placement*="bottom"] &`]: S({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), _se = se("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : _t(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let e1 = !1, JO = null, kb = {
  x: 0,
  y: 0
};
function t1(e, t) {
  return (o) => {
    t && t(o), e(o);
  };
}
const AV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h, v, b, x, E, T, P, O, k, I, $, _, z, V;
  const M = dt({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: A = !1,
    children: W,
    components: Y = {},
    componentsProps: H = {},
    describeChild: G = !1,
    disableFocusListener: ne = !1,
    disableHoverListener: K = !1,
    disableInteractive: B = !1,
    disableTouchListener: q = !1,
    enterDelay: X = 100,
    enterNextDelay: J = 0,
    enterTouchDelay: U = 700,
    followCursor: Z = !1,
    id: ee,
    leaveDelay: ie = 0,
    leaveTouchDelay: oe = 1500,
    onClose: le,
    onOpen: de,
    open: Ce,
    placement: me = "bottom",
    PopperComponent: Oe,
    PopperProps: he = {},
    slotProps: $e = {},
    slots: Ne = {},
    title: Pe,
    TransitionComponent: Se = ay,
    TransitionProps: Fe
  } = M, ce = pe(M, Mse), ge = /* @__PURE__ */ C.isValidElement(W) ? W : /* @__PURE__ */ L("span", {
    children: W
  }), we = mr(), Me = we.direction === "rtl", [Qe, ct] = C.useState(), [Ze, Ge] = C.useState(null), Be = C.useRef(!1), rt = B || Z, wt = C.useRef(), We = C.useRef(), ut = C.useRef(), ft = C.useRef(), [Je, pt] = _i({
    controlled: Ce,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let At = Je;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Wt
    } = C.useRef(Ce !== void 0);
    C.useEffect(() => {
      Qe && Qe.disabled && !Wt && Pe !== "" && Qe.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [Pe, Qe, Wt]);
  }
  const Ye = Qn(ee), st = C.useRef(), _e = C.useCallback(() => {
    st.current !== void 0 && (document.body.style.WebkitUserSelect = st.current, st.current = void 0), clearTimeout(ft.current);
  }, []);
  C.useEffect(() => () => {
    clearTimeout(wt.current), clearTimeout(We.current), clearTimeout(ut.current), _e();
  }, [_e]);
  const vt = (Wt) => {
    clearTimeout(JO), e1 = !0, pt(!0), de && !At && de(Wt);
  }, et = zn(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Wt) => {
      clearTimeout(JO), JO = setTimeout(() => {
        e1 = !1;
      }, 800 + ie), pt(!1), le && At && le(Wt), clearTimeout(wt.current), wt.current = setTimeout(() => {
        Be.current = !1;
      }, we.transitions.duration.shortest);
    }
  ), gt = (Wt) => {
    Be.current && Wt.type !== "touchstart" || (Qe && Qe.removeAttribute("title"), clearTimeout(We.current), clearTimeout(ut.current), X || e1 && J ? We.current = setTimeout(() => {
      vt(Wt);
    }, e1 ? J : X) : vt(Wt));
  }, kt = (Wt) => {
    clearTimeout(We.current), clearTimeout(ut.current), ut.current = setTimeout(() => {
      et(Wt);
    }, ie);
  }, {
    isFocusVisibleRef: Lt,
    onBlur: Ut,
    onFocus: Sn,
    ref: an
  } = vy(), [, un] = C.useState(!1), wn = (Wt) => {
    Ut(Wt), Lt.current === !1 && (un(!1), kt(Wt));
  }, hn = (Wt) => {
    Qe || ct(Wt.currentTarget), Sn(Wt), Lt.current === !0 && (un(!0), gt(Wt));
  }, Br = (Wt) => {
    Be.current = !0;
    const Ar = ge.props;
    Ar.onTouchStart && Ar.onTouchStart(Wt);
  }, zo = gt, wo = kt, to = (Wt) => {
    Br(Wt), clearTimeout(ut.current), clearTimeout(wt.current), _e(), st.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ft.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = st.current, gt(Wt);
    }, U);
  }, Dr = (Wt) => {
    ge.props.onTouchEnd && ge.props.onTouchEnd(Wt), _e(), clearTimeout(ut.current), ut.current = setTimeout(() => {
      et(Wt);
    }, oe);
  };
  C.useEffect(() => {
    if (!At)
      return;
    function Wt(Ar) {
      (Ar.key === "Escape" || Ar.key === "Esc") && et(Ar);
    }
    return document.addEventListener("keydown", Wt), () => {
      document.removeEventListener("keydown", Wt);
    };
  }, [et, At]);
  const Vn = Cn(ge.ref, an, ct, o);
  !Pe && Pe !== 0 && (At = !1);
  const Dn = C.useRef(), Zn = (Wt) => {
    const Ar = ge.props;
    Ar.onMouseMove && Ar.onMouseMove(Wt), kb = {
      x: Wt.clientX,
      y: Wt.clientY
    }, Dn.current && Dn.current.update();
  }, _r = {}, ur = typeof Pe == "string";
  G ? (_r.title = !At && ur && !K ? Pe : null, _r["aria-describedby"] = At ? Ye : null) : (_r["aria-label"] = ur ? Pe : null, _r["aria-labelledby"] = At && !ur ? Ye : null);
  const Bn = S({}, _r, ce, ge.props, {
    className: be(ce.className, ge.props.className),
    onTouchStart: Br,
    ref: Vn
  }, Z ? {
    onMouseMove: Zn
  } : {});
  process.env.NODE_ENV !== "production" && (Bn["data-mui-internal-clone-element"] = !0, C.useEffect(() => {
    Qe && !Qe.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Qe]));
  const xr = {};
  q || (Bn.onTouchStart = to, Bn.onTouchEnd = Dr), K || (Bn.onMouseOver = t1(zo, Bn.onMouseOver), Bn.onMouseLeave = t1(wo, Bn.onMouseLeave), rt || (xr.onMouseOver = zo, xr.onMouseLeave = wo)), ne || (Bn.onFocus = t1(hn, Bn.onFocus), Bn.onBlur = t1(wn, Bn.onBlur), rt || (xr.onFocus = hn, xr.onBlur = wn)), process.env.NODE_ENV !== "production" && ge.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${ge.props.title}\` or the Tooltip component.`].join(`
`));
  const fe = C.useMemo(() => {
    var Wt;
    let Ar = [{
      name: "arrow",
      enabled: !!Ze,
      options: {
        element: Ze,
        padding: 4
      }
    }];
    return (Wt = he.popperOptions) != null && Wt.modifiers && (Ar = Ar.concat(he.popperOptions.modifiers)), S({}, he.popperOptions, {
      modifiers: Ar
    });
  }, [Ze, he]), at = S({}, M, {
    isRtl: Me,
    arrow: A,
    disableInteractive: rt,
    placement: me,
    PopperComponentProp: Oe,
    touch: Be.current
  }), Et = Nse(at), Ie = (i = (s = Ne.popper) != null ? s : Y.Popper) != null ? i : $se, xe = (c = (f = (m = Ne.transition) != null ? m : Y.Transition) != null ? f : Se) != null ? c : ay, ze = (h = (v = Ne.tooltip) != null ? v : Y.Tooltip) != null ? h : Dse, mt = (b = (x = Ne.arrow) != null ? x : Y.Arrow) != null ? b : _se, Ct = Db(Ie, S({}, he, (E = $e.popper) != null ? E : H.popper, {
    className: be(Et.popper, he == null ? void 0 : he.className, (T = (P = $e.popper) != null ? P : H.popper) == null ? void 0 : T.className)
  }), at), Qt = Db(xe, S({}, Fe, (O = $e.transition) != null ? O : H.transition), at), dn = Db(ze, S({}, (k = $e.tooltip) != null ? k : H.tooltip, {
    className: be(Et.tooltip, (I = ($ = $e.tooltip) != null ? $ : H.tooltip) == null ? void 0 : I.className)
  }), at), yn = Db(mt, S({}, (_ = $e.arrow) != null ? _ : H.arrow, {
    className: be(Et.arrow, (z = (V = $e.arrow) != null ? V : H.arrow) == null ? void 0 : z.className)
  }), at);
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ C.cloneElement(ge, Bn), /* @__PURE__ */ L(Ie, S({
      as: Oe ?? cp,
      placement: me,
      anchorEl: Z ? {
        getBoundingClientRect: () => ({
          top: kb.y,
          left: kb.x,
          right: kb.x,
          bottom: kb.y,
          width: 0,
          height: 0
        })
      } : Qe,
      popperRef: Dn,
      open: Qe ? At : !1,
      id: Ye,
      transition: !0
    }, xr, Ct, {
      popperOptions: fe,
      children: ({
        TransitionProps: Wt
      }) => /* @__PURE__ */ L(xe, S({
        timeout: we.transitions.duration.shorter
      }, Wt, Qt, {
        children: /* @__PURE__ */ ht(ze, S({}, dn, {
          children: [Pe, A ? /* @__PURE__ */ L(mt, S({}, yn, {
            ref: Ge
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (AV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: n.bool,
  /**
   * Tooltip reference element.
   */
  children: vd.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: n.shape({
    Arrow: n.elementType,
    Popper: n.elementType,
    Tooltip: n.elementType,
    Transition: n.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: n.shape({
    arrow: n.object,
    popper: n.object,
    tooltip: n.object,
    transition: n.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: n.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: n.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: n.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: n.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: n.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: n.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: n.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: n.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: n.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: n.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: n.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: n.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: n.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: n.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: n.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: n.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: n.shape({
    arrow: n.object,
    popper: n.object,
    tooltip: n.object,
    transition: n.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: n.shape({
    arrow: n.elementType,
    popper: n.elementType,
    tooltip: n.elementType,
    transition: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: n.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: n.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: n.object
});
const LV = AV;
function Ase(e) {
  return ot("MuiSpeedDialAction", e);
}
const Lse = lt("MuiSpeedDialAction", ["fab", "fabClosed", "staticTooltip", "staticTooltipClosed", "staticTooltipLabel", "tooltipPlacementLeft", "tooltipPlacementRight"]), Fse = Lse, zse = ["className", "delay", "FabProps", "icon", "id", "open", "TooltipClasses", "tooltipOpen", "tooltipPlacement", "tooltipTitle"], Vse = (e) => {
  const {
    open: t,
    tooltipPlacement: o,
    classes: i
  } = e, s = {
    fab: ["fab", !t && "fabClosed"],
    staticTooltip: ["staticTooltip", `tooltipPlacement${ve(o)}`, !t && "staticTooltipClosed"],
    staticTooltipLabel: ["staticTooltipLabel"]
  };
  return je(s, Ase, i);
}, Bse = se(Tz, {
  name: "MuiSpeedDialAction",
  slot: "Fab",
  skipVariantsResolver: !1,
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.fab, !o.open && t.fabClosed];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 8,
  color: (e.vars || e).palette.text.secondary,
  backgroundColor: (e.vars || e).palette.background.paper,
  "&:hover": {
    backgroundColor: e.vars ? e.vars.palette.SpeedDialAction.fabHoverBg : M1(e.palette.background.paper, 0.15)
  },
  transition: `${e.transitions.create("transform", {
    duration: e.transitions.duration.shorter
  })}, opacity 0.8s`,
  opacity: 1
}, !t.open && {
  opacity: 0,
  transform: "scale(0)"
})), jse = se("span", {
  name: "MuiSpeedDialAction",
  slot: "StaticTooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.staticTooltip, !o.open && t.staticTooltipClosed, t[`tooltipPlacement${ve(o.tooltipPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  [`& .${Fse.staticTooltipLabel}`]: S({
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.shorter
    }),
    opacity: 1
  }, !t.open && {
    opacity: 0,
    transform: "scale(0.5)"
  }, t.tooltipPlacement === "left" && {
    transformOrigin: "100% 50%",
    right: "100%",
    marginRight: 8
  }, t.tooltipPlacement === "right" && {
    transformOrigin: "0% 50%",
    left: "100%",
    marginLeft: 8
  })
})), Hse = se("span", {
  name: "MuiSpeedDialAction",
  slot: "StaticTooltipLabel",
  overridesResolver: (e, t) => t.staticTooltipLabel
})(({
  theme: e
}) => S({
  position: "absolute"
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.paper,
  borderRadius: (e.vars || e).shape.borderRadius,
  boxShadow: (e.vars || e).shadows[1],
  color: (e.vars || e).palette.text.secondary,
  padding: "4px 16px",
  wordBreak: "keep-all"
})), FV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSpeedDialAction"
  }), {
    className: s,
    delay: c = 0,
    FabProps: f = {},
    icon: m,
    id: h,
    open: v,
    TooltipClasses: b,
    tooltipOpen: x = !1,
    tooltipPlacement: E = "left",
    tooltipTitle: T
  } = i, P = pe(i, zse), O = S({}, i, {
    tooltipPlacement: E
  }), k = Vse(O), [I, $] = C.useState(x), _ = () => {
    $(!1);
  }, z = () => {
    $(!0);
  }, V = {
    transitionDelay: `${c}ms`
  }, M = /* @__PURE__ */ L(Bse, S({
    size: "small",
    className: be(k.fab, s),
    tabIndex: -1,
    role: "menuitem",
    ownerState: O
  }, f, {
    style: S({}, V, f.style),
    children: m
  }));
  return x ? /* @__PURE__ */ ht(jse, S({
    id: h,
    ref: o,
    className: k.staticTooltip,
    ownerState: O
  }, P, {
    children: [/* @__PURE__ */ L(Hse, {
      style: V,
      id: `${h}-label`,
      className: k.staticTooltipLabel,
      ownerState: O,
      children: T
    }), /* @__PURE__ */ C.cloneElement(M, {
      "aria-labelledby": `${h}-label`
    })]
  })) : (!v && I && $(!1), /* @__PURE__ */ L(LV, S({
    id: h,
    ref: o,
    title: T,
    placement: E,
    onClose: _,
    onOpen: z,
    open: v && I,
    classes: b
  }, P, {
    children: M
  })));
});
process.env.NODE_ENV !== "production" && (FV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   * @default 0
   */
  delay: n.number,
  /**
   * Props applied to the [`Fab`](/material-ui/api/fab/) component.
   * @default {}
   */
  FabProps: n.object,
  /**
   * The icon to display in the SpeedDial Fab.
   */
  icon: n.node,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: n.string,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * `classes` prop applied to the [`Tooltip`](/material-ui/api/tooltip/) element.
   */
  TooltipClasses: n.object,
  /**
   * Make the tooltip always visible when the SpeedDial is open.
   * @default false
   */
  tooltipOpen: n.bool,
  /**
   * Placement of the tooltip.
   * @default 'left'
   */
  tooltipPlacement: n.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Label to display in the tooltip.
   */
  tooltipTitle: n.node
});
const exe = FV, Use = rn(/* @__PURE__ */ L("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
function Gse(e) {
  return ot("MuiSpeedDialIcon", e);
}
const Wse = lt("MuiSpeedDialIcon", ["root", "icon", "iconOpen", "iconWithOpenIconOpen", "openIcon", "openIconOpen"]), If = Wse, qse = ["className", "icon", "open", "openIcon"], Yse = (e) => {
  const {
    classes: t,
    open: o,
    openIcon: i
  } = e;
  return je({
    root: ["root"],
    icon: ["icon", o && "iconOpen", i && o && "iconWithOpenIconOpen"],
    openIcon: ["openIcon", o && "openIconOpen"]
  }, Gse, t);
}, Kse = se("span", {
  name: "MuiSpeedDialIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${If.icon}`]: t.icon
    }, {
      [`& .${If.icon}`]: o.open && t.iconOpen
    }, {
      [`& .${If.icon}`]: o.open && o.openIcon && t.iconWithOpenIconOpen
    }, {
      [`& .${If.openIcon}`]: t.openIcon
    }, {
      [`& .${If.openIcon}`]: o.open && t.openIconOpen
    }, t.root];
  }
})(({
  theme: e,
  ownerState: t
}) => ({
  height: 24,
  [`& .${If.icon}`]: S({
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.short
    })
  }, t.open && S({
    transform: "rotate(45deg)"
  }, t.openIcon && {
    opacity: 0
  })),
  [`& .${If.openIcon}`]: S({
    position: "absolute",
    transition: e.transitions.create(["transform", "opacity"], {
      duration: e.transitions.duration.short
    }),
    opacity: 0,
    transform: "rotate(-45deg)"
  }, t.open && {
    transform: "rotate(0deg)",
    opacity: 1
  })
})), bP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSpeedDialIcon"
  }), {
    className: s,
    icon: c,
    openIcon: f
  } = i, m = pe(i, qse), h = i, v = Yse(h);
  function b(x, E) {
    return /* @__PURE__ */ C.isValidElement(x) ? /* @__PURE__ */ C.cloneElement(x, {
      className: E
    }) : x;
  }
  return /* @__PURE__ */ ht(Kse, S({
    className: be(v.root, s),
    ref: o,
    ownerState: h
  }, m, {
    children: [f ? b(f, v.openIcon) : null, c ? b(c, v.icon) : /* @__PURE__ */ L(Use, {
      className: v.icon
    })]
  }));
});
process.env.NODE_ENV !== "production" && (bP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon to display.
   */
  icon: n.node,
  /**
   * @ignore
   * If `true`, the component is shown.
   */
  open: n.bool,
  /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */
  openIcon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
bP.muiName = "SpeedDialIcon";
const txe = bP, yP = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (yP.displayName = "StepperContext");
function nxe() {
  return C.useContext(yP);
}
const qh = yP, CP = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (CP.displayName = "StepContext");
function rxe() {
  return C.useContext(CP);
}
const Py = CP;
function Xse(e) {
  return ot("MuiStep", e);
}
const Qse = lt("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]), oxe = Qse, Zse = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"], Jse = (e) => {
  const {
    classes: t,
    orientation: o,
    alternativeLabel: i,
    completed: s
  } = e;
  return je({
    root: ["root", o, i && "alternativeLabel", s && "completed"]
  }, Xse, t);
}, ece = se("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation], o.alternativeLabel && t.alternativeLabel, o.completed && t.completed];
  }
})(({
  ownerState: e
}) => S({}, e.orientation === "horizontal" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.alternativeLabel && {
  flex: 1,
  position: "relative"
})), zV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStep"
  }), {
    active: s,
    children: c,
    className: f,
    component: m = "div",
    completed: h,
    disabled: v,
    expanded: b = !1,
    index: x,
    last: E
  } = i, T = pe(i, Zse), {
    activeStep: P,
    connector: O,
    alternativeLabel: k,
    orientation: I,
    nonLinear: $
  } = C.useContext(qh);
  let [_ = !1, z = !1, V = !1] = [s, h, v];
  P === x ? _ = s !== void 0 ? s : !0 : !$ && P > x ? z = h !== void 0 ? h : !0 : !$ && P < x && (V = v !== void 0 ? v : !0);
  const M = C.useMemo(() => ({
    index: x,
    last: E,
    expanded: b,
    icon: x + 1,
    active: _,
    completed: z,
    disabled: V
  }), [x, E, b, _, z, V]), A = S({}, i, {
    active: _,
    orientation: I,
    alternativeLabel: k,
    completed: z,
    disabled: V,
    expanded: b,
    component: m
  }), W = Jse(A), Y = /* @__PURE__ */ ht(ece, S({
    as: m,
    className: be(W.root, f),
    ref: o,
    ownerState: A
  }, T, {
    children: [O && k && x !== 0 ? O : null, c]
  }));
  return /* @__PURE__ */ L(Py.Provider, {
    value: M,
    children: O && !k && x !== 0 ? /* @__PURE__ */ ht(C.Fragment, {
      children: [O, Y]
    }) : Y
  });
});
process.env.NODE_ENV !== "production" && (zV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: n.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: n.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: n.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: n.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: eo,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const axe = zV, tce = rn(/* @__PURE__ */ L("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), nce = rn(/* @__PURE__ */ L("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function rce(e) {
  return ot("MuiStepIcon", e);
}
const oce = lt("MuiStepIcon", ["root", "active", "completed", "error", "text"]), eR = oce;
var p_;
const ace = ["active", "className", "completed", "error", "icon"], ice = (e) => {
  const {
    classes: t,
    active: o,
    completed: i,
    error: s
  } = e;
  return je({
    root: ["root", o && "active", i && "completed", s && "error"],
    text: ["text"]
  }, rce, t);
}, tR = se(IR, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${eR.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${eR.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${eR.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), lce = se("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
})), VV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: s = !1,
    className: c,
    completed: f = !1,
    error: m = !1,
    icon: h
  } = i, v = pe(i, ace), b = S({}, i, {
    active: s,
    completed: f,
    error: m
  }), x = ice(b);
  if (typeof h == "number" || typeof h == "string") {
    const E = be(c, x.root);
    return m ? /* @__PURE__ */ L(tR, S({
      as: nce,
      className: E,
      ref: o,
      ownerState: b
    }, v)) : f ? /* @__PURE__ */ L(tR, S({
      as: tce,
      className: E,
      ref: o,
      ownerState: b
    }, v)) : /* @__PURE__ */ ht(tR, S({
      className: E,
      ref: o,
      ownerState: b
    }, v, {
      children: [p_ || (p_ = /* @__PURE__ */ L("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ L(lce, {
        className: x.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: b,
        children: h
      })]
    }));
  }
  return h;
});
process.env.NODE_ENV !== "production" && (VV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Whether this step is active.
   * @default false
   */
  active: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: n.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: n.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const sce = VV;
function cce(e) {
  return ot("MuiStepLabel", e);
}
const uce = lt("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), sd = uce, dce = ["children", "className", "componentsProps", "error", "icon", "optional", "slotProps", "StepIconComponent", "StepIconProps"], fce = (e) => {
  const {
    classes: t,
    orientation: o,
    active: i,
    completed: s,
    error: c,
    disabled: f,
    alternativeLabel: m
  } = e;
  return je({
    root: ["root", o, c && "error", f && "disabled", m && "alternativeLabel"],
    label: ["label", i && "active", s && "completed", c && "error", f && "disabled", m && "alternativeLabel"],
    iconContainer: ["iconContainer", i && "active", s && "completed", c && "error", f && "disabled", m && "alternativeLabel"],
    labelContainer: ["labelContainer", m && "alternativeLabel"]
  }, cce, t);
}, pce = se("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation]];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  alignItems: "center",
  [`&.${sd.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${sd.disabled}`]: {
    cursor: "default"
  }
}, e.orientation === "vertical" && {
  textAlign: "left",
  padding: "8px 0"
})), mce = se("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e
}) => S({}, e.typography.body2, {
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${sd.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${sd.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${sd.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${sd.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), hce = se("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: "flex",
  paddingRight: 8,
  [`&.${sd.alternativeLabel}`]: {
    paddingRight: 0
  }
})), gce = se("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${sd.alternativeLabel}`]: {
    textAlign: "center"
  }
})), SP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = dt({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: c,
    className: f,
    componentsProps: m = {},
    error: h = !1,
    icon: v,
    optional: b,
    slotProps: x = {},
    StepIconComponent: E,
    StepIconProps: T
  } = s, P = pe(s, dce), {
    alternativeLabel: O,
    orientation: k
  } = C.useContext(qh), {
    active: I,
    disabled: $,
    completed: _,
    icon: z
  } = C.useContext(Py), V = v || z;
  let M = E;
  V && !M && (M = sce);
  const A = S({}, s, {
    active: I,
    alternativeLabel: O,
    completed: _,
    disabled: $,
    error: h,
    orientation: k
  }), W = fce(A), Y = (i = x.label) != null ? i : m.label;
  return /* @__PURE__ */ ht(pce, S({
    className: be(W.root, f),
    ref: o,
    ownerState: A
  }, P, {
    children: [V || M ? /* @__PURE__ */ L(hce, {
      className: W.iconContainer,
      ownerState: A,
      children: /* @__PURE__ */ L(M, S({
        completed: _,
        active: I,
        error: h,
        icon: V
      }, T))
    }) : null, /* @__PURE__ */ ht(gce, {
      className: W.labelContainer,
      ownerState: A,
      children: [c ? /* @__PURE__ */ L(mce, S({
        ownerState: A
      }, Y, {
        className: be(W.label, Y == null ? void 0 : Y.className),
        children: c
      })) : null, b]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (SP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: n.shape({
    label: n.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: n.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: n.node,
  /**
   * The optional node to display.
   */
  optional: n.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: n.shape({
    label: n.object
  }),
  /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */
  StepIconComponent: n.elementType,
  /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */
  StepIconProps: n.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
SP.muiName = "StepLabel";
const vce = SP;
function bce(e) {
  return ot("MuiStepButton", e);
}
const yce = lt("MuiStepButton", ["root", "horizontal", "vertical", "touchRipple"]), m_ = yce, Cce = ["children", "className", "icon", "optional"], Sce = (e) => {
  const {
    classes: t,
    orientation: o
  } = e;
  return je({
    root: ["root", o],
    touchRipple: ["touchRipple"]
  }, bce, t);
}, xce = se(Ao, {
  name: "MuiStepButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${m_.touchRipple}`]: t.touchRipple
    }, t.root, t[o.orientation]];
  }
})(({
  ownerState: e
}) => S({
  width: "100%",
  padding: "24px 16px",
  margin: "-24px -16px",
  boxSizing: "content-box"
}, e.orientation === "vertical" && {
  justifyContent: "flex-start",
  padding: "8px",
  margin: "-8px"
}, {
  [`& .${m_.touchRipple}`]: {
    color: "rgba(0, 0, 0, 0.3)"
  }
})), BV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStepButton"
  }), {
    children: s,
    className: c,
    icon: f,
    optional: m
  } = i, h = pe(i, Cce), {
    disabled: v,
    active: b
  } = C.useContext(Py), {
    orientation: x
  } = C.useContext(qh), E = S({}, i, {
    orientation: x
  }), T = Sce(E), P = {
    icon: f,
    optional: m
  }, O = zc(s, ["StepLabel"]) ? /* @__PURE__ */ C.cloneElement(s, P) : /* @__PURE__ */ L(vce, S({}, P, {
    children: s
  }));
  return /* @__PURE__ */ L(xce, S({
    focusRipple: !0,
    disabled: v,
    TouchRippleProps: {
      className: T.touchRipple
    },
    className: be(T.root, c),
    ref: o,
    ownerState: E,
    "aria-current": b ? "step" : void 0
  }, h, {
    children: O
  }));
});
process.env.NODE_ENV !== "production" && (BV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The icon displayed by the step label.
   */
  icon: n.node,
  /**
   * The optional node to display.
   */
  optional: n.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const ixe = BV;
function wce(e) {
  return ot("MuiStepConnector", e);
}
const Ece = lt("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]), lxe = Ece, Tce = ["className"], Oce = (e) => {
  const {
    classes: t,
    orientation: o,
    alternativeLabel: i,
    active: s,
    completed: c,
    disabled: f
  } = e, m = {
    root: ["root", o, i && "alternativeLabel", s && "active", c && "completed", f && "disabled"],
    line: ["line", `line${ve(o)}`]
  };
  return je(m, wce, t);
}, Rce = se("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation], o.alternativeLabel && t.alternativeLabel, o.completed && t.completed];
  }
})(({
  ownerState: e
}) => S({
  flex: "1 1 auto"
}, e.orientation === "vertical" && {
  marginLeft: 12
  // half icon
}, e.alternativeLabel && {
  position: "absolute",
  top: 8 + 4,
  left: "calc(-50% + 20px)",
  right: "calc(50% + 20px)"
})), kce = se("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.line, t[`line${ve(o.orientation)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const o = t.palette.mode === "light" ? t.palette.grey[400] : t.palette.grey[600];
  return S({
    display: "block",
    borderColor: t.vars ? t.vars.palette.StepConnector.border : o
  }, e.orientation === "horizontal" && {
    borderTopStyle: "solid",
    borderTopWidth: 1
  }, e.orientation === "vertical" && {
    borderLeftStyle: "solid",
    borderLeftWidth: 1,
    minHeight: 24
  });
}), jV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: s
  } = i, c = pe(i, Tce), {
    alternativeLabel: f,
    orientation: m = "horizontal"
  } = C.useContext(qh), {
    active: h,
    disabled: v,
    completed: b
  } = C.useContext(Py), x = S({}, i, {
    alternativeLabel: f,
    orientation: m,
    active: h,
    completed: b,
    disabled: v
  }), E = Oce(x);
  return /* @__PURE__ */ L(Rce, S({
    className: be(E.root, s),
    ref: o,
    ownerState: x
  }, c, {
    children: /* @__PURE__ */ L(kce, {
      className: E.line,
      ownerState: x
    })
  }));
});
process.env.NODE_ENV !== "production" && (jV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Pce = jV;
function Mce(e) {
  return ot("MuiStepContent", e);
}
const Ice = lt("MuiStepContent", ["root", "last", "transition"]), sxe = Ice, Nce = ["children", "className", "TransitionComponent", "transitionDuration", "TransitionProps"], $ce = (e) => {
  const {
    classes: t,
    last: o
  } = e;
  return je({
    root: ["root", o && "last"],
    transition: ["transition"]
  }, Mce, t);
}, Dce = se("div", {
  name: "MuiStepContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.last && t.last];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  marginLeft: 12,
  // half icon
  paddingLeft: 8 + 12,
  // margin + half icon
  paddingRight: 8,
  borderLeft: t.vars ? `1px solid ${t.vars.palette.StepContent.border}` : `1px solid ${t.palette.mode === "light" ? t.palette.grey[400] : t.palette.grey[600]}`
}, e.last && {
  borderLeft: "none"
})), _ce = se(Uk, {
  name: "MuiStepContent",
  slot: "Transition",
  overridesResolver: (e, t) => t.transition
})({}), HV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStepContent"
  }), {
    children: s,
    className: c,
    TransitionComponent: f = Uk,
    transitionDuration: m = "auto",
    TransitionProps: h
  } = i, v = pe(i, Nce), {
    orientation: b
  } = C.useContext(qh), {
    active: x,
    last: E,
    expanded: T
  } = C.useContext(Py), P = S({}, i, {
    last: E
  }), O = $ce(P);
  process.env.NODE_ENV !== "production" && b !== "vertical" && console.error("MUI: <StepContent /> is only designed for use with the vertical stepper.");
  let k = m;
  return m === "auto" && !f.muiSupportAuto && (k = void 0), /* @__PURE__ */ L(Dce, S({
    className: be(O.root, c),
    ref: o,
    ownerState: P
  }, v, {
    children: /* @__PURE__ */ L(_ce, S({
      as: f,
      in: x || T,
      className: O.transition,
      ownerState: P,
      timeout: k,
      unmountOnExit: !0
    }, h, {
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (HV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   */
  TransitionComponent: n.elementType,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: n.oneOfType([n.oneOf(["auto"]), n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: n.object
});
const cxe = HV;
function Ace(e) {
  return ot("MuiStepper", e);
}
const Lce = lt("MuiStepper", ["root", "horizontal", "vertical", "alternativeLabel"]), uxe = Lce, Fce = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"], zce = (e) => {
  const {
    orientation: t,
    alternativeLabel: o,
    classes: i
  } = e;
  return je({
    root: ["root", t, o && "alternativeLabel"]
  }, Ace, i);
}, Vce = se("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation], o.alternativeLabel && t.alternativeLabel];
  }
})(({
  ownerState: e
}) => S({
  display: "flex"
}, e.orientation === "horizontal" && {
  flexDirection: "row",
  alignItems: "center"
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.alternativeLabel && {
  alignItems: "flex-start"
})), Bce = /* @__PURE__ */ L(Pce, {}), UV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: s = 0,
    alternativeLabel: c = !1,
    children: f,
    className: m,
    component: h = "div",
    connector: v = Bce,
    nonLinear: b = !1,
    orientation: x = "horizontal"
  } = i, E = pe(i, Fce), T = S({}, i, {
    alternativeLabel: c,
    orientation: x,
    component: h
  }), P = zce(T), O = C.Children.toArray(f).filter(Boolean), k = O.map(($, _) => /* @__PURE__ */ C.cloneElement($, S({
    index: _,
    last: _ + 1 === O.length
  }, $.props))), I = C.useMemo(() => ({
    activeStep: s,
    alternativeLabel: c,
    connector: v,
    nonLinear: b,
    orientation: x
  }), [s, c, v, b, x]);
  return /* @__PURE__ */ L(qh.Provider, {
    value: I,
    children: /* @__PURE__ */ L(Vce, S({
      as: h,
      ownerState: T,
      className: be(P.root, m),
      ref: o
    }, E, {
      children: k
    }))
  });
});
process.env.NODE_ENV !== "production" && (UV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: eo,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: n.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: n.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: n.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const dxe = UV, jce = ["anchor", "classes", "className", "width", "style"], Hce = se("div")(({
  theme: e,
  ownerState: t
}) => S({
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: e.zIndex.drawer - 1
}, t.anchor === "left" && {
  right: "auto"
}, t.anchor === "right" && {
  left: "auto",
  right: 0
}, t.anchor === "top" && {
  bottom: "auto",
  right: 0
}, t.anchor === "bottom" && {
  top: "auto",
  bottom: 0,
  right: 0
})), GV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    anchor: i,
    classes: s = {},
    className: c,
    width: f,
    style: m
  } = t, h = pe(t, jce), v = t;
  return /* @__PURE__ */ L(Hce, S({
    className: be("PrivateSwipeArea-root", s.root, s[`anchor${ve(i)}`], c),
    ref: o,
    style: S({
      [jf(i) ? "width" : "height"]: f
    }, m),
    ownerState: v
  }, h));
});
process.env.NODE_ENV !== "production" && (GV.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: n.oneOf(["left", "top", "right", "bottom"]).isRequired,
  /**
   * @ignore
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */
  width: n.number.isRequired
});
const Uce = GV, Gce = ["BackdropProps"], Wce = ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "allowSwipeInChildren", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"], n1 = 3, nR = 20;
let Ac = null;
function rR(e, t, o) {
  return e === "right" ? o.body.offsetWidth - t[0].pageX : t[0].pageX;
}
function oR(e, t, o) {
  return e === "bottom" ? o.innerHeight - t[0].clientY : t[0].clientY;
}
function Pb(e, t) {
  return e ? t.clientWidth : t.clientHeight;
}
function h_(e, t, o, i) {
  return Math.min(Math.max(o ? t - e : i + t - e, 0), i);
}
function qce(e, t) {
  const o = [];
  for (; e && e !== t.parentElement; ) {
    const i = Ta(t).getComputedStyle(e);
    // Ignore the scroll children if the element is absolute positioned.
    i.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
    i.getPropertyValue("overflow-x") === "hidden" || (e.clientWidth > 0 && e.scrollWidth > e.clientWidth || e.clientHeight > 0 && e.scrollHeight > e.clientHeight) && o.push(e), e = e.parentElement;
  }
  return o;
}
function Yce({
  domTreeShapes: e,
  start: t,
  current: o,
  anchor: i
}) {
  const s = {
    scrollPosition: {
      x: "scrollLeft",
      y: "scrollTop"
    },
    scrollLength: {
      x: "scrollWidth",
      y: "scrollHeight"
    },
    clientLength: {
      x: "clientWidth",
      y: "clientHeight"
    }
  };
  return e.some((c) => {
    let f = o >= t;
    (i === "top" || i === "left") && (f = !f);
    const m = i === "left" || i === "right" ? "x" : "y", h = Math.round(c[s.scrollPosition[m]]), v = h > 0, b = h + c[s.clientLength[m]] < c[s.scrollLength[m]];
    return !!(f && b || !f && v);
  });
}
const Kce = typeof navigator < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent), WV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = wy({
    name: "MuiSwipeableDrawer",
    props: t
  }), s = mr(), c = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    anchor: f = "left",
    disableBackdropTransition: m = !1,
    disableDiscovery: h = !1,
    disableSwipeToOpen: v = Kce,
    hideBackdrop: b,
    hysteresis: x = 0.52,
    allowSwipeInChildren: E = !1,
    minFlingVelocity: T = 450,
    ModalProps: {
      BackdropProps: P
    } = {},
    onClose: O,
    onOpen: k,
    open: I = !1,
    PaperProps: $ = {},
    SwipeAreaProps: _,
    swipeAreaWidth: z = 20,
    transitionDuration: V = c,
    variant: M = "temporary"
    // Mobile first.
  } = i, A = pe(i.ModalProps, Gce), W = pe(i, Wce), [Y, H] = C.useState(!1), G = C.useRef({
    isSwiping: null
  }), ne = C.useRef(), K = C.useRef(), B = C.useRef(), q = Cn($.ref, B), X = C.useRef(!1), J = C.useRef();
  Hn(() => {
    J.current = null;
  }, [I]);
  const U = C.useCallback((le, de = {}) => {
    const {
      mode: Ce = null,
      changeTransition: me = !0
    } = de, Oe = _b(s, f), he = ["right", "bottom"].indexOf(Oe) !== -1 ? 1 : -1, $e = jf(f), Ne = $e ? `translate(${he * le}px, 0)` : `translate(0, ${he * le}px)`, Pe = B.current.style;
    Pe.webkitTransform = Ne, Pe.transform = Ne;
    let Se = "";
    if (Ce && (Se = s.transitions.create("all", Yl({
      easing: void 0,
      style: void 0,
      timeout: V
    }, {
      mode: Ce
    }))), me && (Pe.webkitTransition = Se, Pe.transition = Se), !m && !b) {
      const Fe = K.current.style;
      Fe.opacity = 1 - le / Pb($e, B.current), me && (Fe.webkitTransition = Se, Fe.transition = Se);
    }
  }, [f, m, b, s, V]), Z = zn((le) => {
    if (!X.current)
      return;
    if (Ac = null, X.current = !1, ep.flushSync(() => {
      H(!1);
    }), !G.current.isSwiping) {
      G.current.isSwiping = null;
      return;
    }
    G.current.isSwiping = null;
    const de = _b(s, f), Ce = jf(f);
    let me;
    Ce ? me = rR(de, le.changedTouches, qn(le.currentTarget)) : me = oR(de, le.changedTouches, Ta(le.currentTarget));
    const Oe = Ce ? G.current.startX : G.current.startY, he = Pb(Ce, B.current), $e = h_(me, Oe, I, he), Ne = $e / he;
    if (Math.abs(G.current.velocity) > T && (J.current = Math.abs((he - $e) / G.current.velocity) * 1e3), I) {
      G.current.velocity > T || Ne > x ? O() : U(0, {
        mode: "exit"
      });
      return;
    }
    G.current.velocity < -T || 1 - Ne > x ? k() : U(Pb(Ce, B.current), {
      mode: "enter"
    });
  }), ee = (le = !1) => {
    if (!Y) {
      (le || !(h && E)) && ep.flushSync(() => {
        H(!0);
      });
      const de = jf(f);
      !I && B.current && U(Pb(de, B.current) + (h ? 15 : -nR), {
        changeTransition: !1
      }), G.current.velocity = 0, G.current.lastTime = null, G.current.lastTranslate = null, G.current.paperHit = !1, X.current = !0;
    }
  }, ie = zn((le) => {
    if (!B.current || !X.current || Ac !== null && Ac !== G.current)
      return;
    ee(!0);
    const de = _b(s, f), Ce = jf(f), me = rR(de, le.touches, qn(le.currentTarget)), Oe = oR(de, le.touches, Ta(le.currentTarget));
    if (I && B.current.contains(le.target) && Ac === null) {
      const Se = qce(le.target, B.current);
      if (Yce({
        domTreeShapes: Se,
        start: Ce ? G.current.startX : G.current.startY,
        current: Ce ? me : Oe,
        anchor: f
      })) {
        Ac = !0;
        return;
      }
      Ac = G.current;
    }
    if (G.current.isSwiping == null) {
      const Se = Math.abs(me - G.current.startX), Fe = Math.abs(Oe - G.current.startY), ce = Ce ? Se > Fe && Se > n1 : Fe > Se && Fe > n1;
      if (ce && le.cancelable && le.preventDefault(), ce === !0 || (Ce ? Fe > n1 : Se > n1)) {
        if (G.current.isSwiping = ce, !ce) {
          Z(le);
          return;
        }
        G.current.startX = me, G.current.startY = Oe, !h && !I && (Ce ? G.current.startX -= nR : G.current.startY -= nR);
      }
    }
    if (!G.current.isSwiping)
      return;
    const he = Pb(Ce, B.current);
    let $e = Ce ? G.current.startX : G.current.startY;
    I && !G.current.paperHit && ($e = Math.min($e, he));
    const Ne = h_(Ce ? me : Oe, $e, I, he);
    if (I)
      if (G.current.paperHit)
        Ne === 0 && (G.current.startX = me, G.current.startY = Oe);
      else if (Ce ? me < he : Oe < he)
        G.current.paperHit = !0, G.current.startX = me, G.current.startY = Oe;
      else
        return;
    G.current.lastTranslate === null && (G.current.lastTranslate = Ne, G.current.lastTime = performance.now() + 1);
    const Pe = (Ne - G.current.lastTranslate) / (performance.now() - G.current.lastTime) * 1e3;
    G.current.velocity = G.current.velocity * 0.4 + Pe * 0.6, G.current.lastTranslate = Ne, G.current.lastTime = performance.now(), le.cancelable && le.preventDefault(), U(Ne);
  }), oe = zn((le) => {
    if (le.defaultPrevented || le.defaultMuiPrevented || I && (b || !K.current.contains(le.target)) && !B.current.contains(le.target))
      return;
    const de = _b(s, f), Ce = jf(f), me = rR(de, le.touches, qn(le.currentTarget)), Oe = oR(de, le.touches, Ta(le.currentTarget));
    if (!I) {
      var he;
      if (v || !(le.target === ne.current || (he = B.current) != null && he.contains(le.target) && (typeof E == "function" ? E(le, ne.current, B.current) : E)))
        return;
      if (Ce) {
        if (me > z)
          return;
      } else if (Oe > z)
        return;
    }
    le.defaultMuiPrevented = !0, Ac = null, G.current.startX = me, G.current.startY = Oe, ee();
  });
  return C.useEffect(() => {
    if (M === "temporary") {
      const le = qn(B.current);
      return le.addEventListener("touchstart", oe), le.addEventListener("touchmove", ie, {
        passive: !I
      }), le.addEventListener("touchend", Z), () => {
        le.removeEventListener("touchstart", oe), le.removeEventListener("touchmove", ie, {
          passive: !I
        }), le.removeEventListener("touchend", Z);
      };
    }
  }, [M, I, oe, ie, Z]), C.useEffect(() => () => {
    Ac === G.current && (Ac = null);
  }, []), C.useEffect(() => {
    I || H(!1);
  }, [I]), /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(ine, S({
      open: M === "temporary" && Y ? !0 : I,
      variant: M,
      ModalProps: S({
        BackdropProps: S({}, P, {
          ref: K
        })
      }, M === "temporary" && {
        keepMounted: !0
      }, A),
      hideBackdrop: b,
      PaperProps: S({}, $, {
        style: S({
          pointerEvents: M === "temporary" && !I && !E ? "none" : ""
        }, $.style),
        ref: q
      }),
      anchor: f,
      transitionDuration: J.current || V,
      onClose: O,
      ref: o
    }, W)), !v && M === "temporary" && /* @__PURE__ */ L(A1, {
      children: /* @__PURE__ */ L(Uce, S({
        anchor: f,
        ref: ne,
        width: z
      }, _))
    })]
  });
});
process.env.NODE_ENV !== "production" && (WV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If set to true, the swipe event will open the drawer even if the user begins the swipe on one of the drawer's children.
   * This can be useful in scenarios where the drawer is partially visible.
   * You can customize it further with a callback that determines which children the user can drag over to open the drawer
   * (for example, to ignore other elements that handle touch move events, like sliders).
   *
   * @param {TouchEvent} event The 'touchstart' event
   * @param {HTMLDivElement} swipeArea The swipe area element
   * @param {HTMLDivElement} paper The drawer's paper element
   *
   * @default false
   */
  allowSwipeInChildren: n.oneOfType([n.func, n.bool]),
  /**
   * @ignore
   */
  anchor: n.oneOf(["bottom", "left", "right", "top"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   * @default false
   */
  disableBackdropTransition: n.bool,
  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   * @default false
   */
  disableDiscovery: n.bool,
  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   * @default typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
   */
  disableSwipeToOpen: n.bool,
  /**
   * @ignore
   */
  hideBackdrop: n.bool,
  /**
   * Affects how far the drawer must be opened/closed to change its state.
   * Specified as percent (0-1) of the width of the drawer
   * @default 0.52
   */
  hysteresis: n.number,
  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   * @default 450
   */
  minFlingVelocity: n.number,
  /**
   * @ignore
   */
  ModalProps: n.shape({
    BackdropProps: n.shape({
      component: dd
    })
  }),
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onClose: n.func.isRequired,
  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onOpen: n.func.isRequired,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: n.bool,
  /**
   * @ignore
   */
  PaperProps: n.shape({
    component: dd,
    style: n.object
  }),
  /**
   * The element is used to intercept the touch events on the edge.
   */
  SwipeAreaProps: n.object,
  /**
   * The width of the left most (or right most) area in `px` that
   * the drawer can be swiped open from.
   * @default 20
   */
  swipeAreaWidth: n.number,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })]),
  /**
   * @ignore
   */
  variant: n.oneOf(["permanent", "persistent", "temporary"])
});
const fxe = WV;
function Xce(e) {
  return ot("MuiSwitch", e);
}
const Qce = lt("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), wa = Qce, Zce = ["className", "color", "edge", "size", "sx"], Jce = (e) => {
  const {
    classes: t,
    edge: o,
    size: i,
    color: s,
    checked: c,
    disabled: f
  } = e, m = {
    root: ["root", o && `edge${ve(o)}`, `size${ve(i)}`],
    switchBase: ["switchBase", `color${ve(s)}`, c && "checked", f && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, h = je(m, Xce, t);
  return S({}, t, h);
}, eue = se("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.edge && t[`edge${ve(o.edge)}`], t[`size${ve(o.size)}`]];
  }
})(({
  ownerState: e
}) => S({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  }
}, e.edge === "start" && {
  marginLeft: -8
}, e.edge === "end" && {
  marginRight: -8
}, e.size === "small" && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${wa.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${wa.switchBase}`]: {
    padding: 4,
    [`&.${wa.checked}`]: {
      transform: "translateX(16px)"
    }
  }
})), tue = se(tP, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.switchBase, {
      [`& .${wa.input}`]: t.input
    }, o.color !== "default" && t[`color${ve(o.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${wa.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${wa.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${wa.checked} + .${wa.track}`]: {
    opacity: 0.5
  },
  [`&.${wa.disabled} + .${wa.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${wa.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e,
  ownerState: t
}) => S({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${wa.checked}`]: {
    color: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette[t.color].main, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${wa.disabled}`]: {
      color: e.vars ? e.vars.palette.Switch[`${t.color}DisabledColor`] : `${e.palette.mode === "light" ? ql(e.palette[t.color].main, 0.62) : Wl(e.palette[t.color].main, 0.55)}`
    }
  },
  [`&.${wa.checked} + .${wa.track}`]: {
    backgroundColor: (e.vars || e).palette[t.color].main
  }
})), nue = se("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), rue = se("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), qV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiSwitch"
  }), {
    className: s,
    color: c = "primary",
    edge: f = !1,
    size: m = "medium",
    sx: h
  } = i, v = pe(i, Zce), b = S({}, i, {
    color: c,
    edge: f,
    size: m
  }), x = Jce(b), E = /* @__PURE__ */ L(rue, {
    className: x.thumb,
    ownerState: b
  });
  return /* @__PURE__ */ ht(eue, {
    className: be(x.root, s),
    sx: h,
    ownerState: b,
    children: [/* @__PURE__ */ L(tue, S({
      type: "checkbox",
      icon: E,
      checkedIcon: E,
      ref: o,
      ownerState: b
    }, v, {
      classes: S({}, x, {
        root: x.switchBase
      })
    })), /* @__PURE__ */ L(nue, {
      className: x.track,
      ownerState: b
    })]
  });
});
process.env.NODE_ENV !== "production" && (qV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: n.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: n.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: n.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: n.node,
  /**
   * The id of the `input` element.
   */
  id: n.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: n.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: n.any
});
const oue = qV;
function aue(e) {
  return ot("MuiTab", e);
}
const iue = lt("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), Nf = iue, lue = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], sue = (e) => {
  const {
    classes: t,
    textColor: o,
    fullWidth: i,
    wrapped: s,
    icon: c,
    label: f,
    selected: m,
    disabled: h
  } = e, v = {
    root: ["root", c && f && "labelIcon", `textColor${ve(o)}`, i && "fullWidth", s && "wrapped", m && "selected", h && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return je(v, aue, t);
}, cue = se(Ao, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.label && o.icon && t.labelIcon, t[`textColor${ve(o.textColor)}`], o.fullWidth && t.fullWidth, o.wrapped && t.wrapped];
  }
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${Nf.iconWrapper}`]: S({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${Nf.selected}`]: {
    opacity: 1
  },
  [`&.${Nf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Nf.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Nf.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Nf.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${Nf.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), YV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTab"
  }), {
    className: s,
    disabled: c = !1,
    disableFocusRipple: f = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: m,
    icon: h,
    iconPosition: v = "top",
    // eslint-disable-next-line react/prop-types
    indicator: b,
    label: x,
    onChange: E,
    onClick: T,
    onFocus: P,
    // eslint-disable-next-line react/prop-types
    selected: O,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: k,
    // eslint-disable-next-line react/prop-types
    textColor: I = "inherit",
    value: $,
    wrapped: _ = !1
  } = i, z = pe(i, lue), V = S({}, i, {
    disabled: c,
    disableFocusRipple: f,
    selected: O,
    icon: !!h,
    iconPosition: v,
    label: !!x,
    fullWidth: m,
    textColor: I,
    wrapped: _
  }), M = sue(V), A = h && x && /* @__PURE__ */ C.isValidElement(h) ? /* @__PURE__ */ C.cloneElement(h, {
    className: be(M.iconWrapper, h.props.className)
  }) : h, W = (H) => {
    !O && E && E(H, $), T && T(H);
  }, Y = (H) => {
    k && !O && E && E(H, $), P && P(H);
  };
  return /* @__PURE__ */ ht(cue, S({
    focusRipple: !f,
    className: be(M.root, s),
    ref: o,
    role: "tab",
    "aria-selected": O,
    disabled: c,
    onClick: W,
    onFocus: Y,
    ownerState: V,
    tabIndex: O ? 0 : -1
  }, z, {
    children: [v === "top" || v === "start" ? /* @__PURE__ */ ht(C.Fragment, {
      children: [A, x]
    }) : /* @__PURE__ */ ht(C.Fragment, {
      children: [x, A]
    }), b]
  }));
});
process.env.NODE_ENV !== "production" && (YV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: bk,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * The icon to display.
   */
  icon: n.oneOfType([n.element, n.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: n.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: n.node,
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onClick: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: n.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: n.bool
});
const pxe = YV, KV = /* @__PURE__ */ C.createContext();
process.env.NODE_ENV !== "production" && (KV.displayName = "TableContext");
const XV = KV;
function uue(e) {
  return ot("MuiTable", e);
}
const due = lt("MuiTable", ["root", "stickyHeader"]), mxe = due, fue = ["className", "component", "padding", "size", "stickyHeader"], pue = (e) => {
  const {
    classes: t,
    stickyHeader: o
  } = e;
  return je({
    root: ["root", o && "stickyHeader"]
  }, uue, t);
}, mue = se("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": S({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), g_ = "table", QV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTable"
  }), {
    className: s,
    component: c = g_,
    padding: f = "normal",
    size: m = "medium",
    stickyHeader: h = !1
  } = i, v = pe(i, fue), b = S({}, i, {
    component: c,
    padding: f,
    size: m,
    stickyHeader: h
  }), x = pue(b), E = C.useMemo(() => ({
    padding: f,
    size: m,
    stickyHeader: h
  }), [f, m, h]);
  return /* @__PURE__ */ L(XV.Provider, {
    value: E,
    children: /* @__PURE__ */ L(mue, S({
      as: c,
      role: c === g_ ? null : "table",
      ref: o,
      className: be(x.root, s),
      ownerState: b
    }, v))
  });
});
process.env.NODE_ENV !== "production" && (QV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: n.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const hxe = QV, ZV = /* @__PURE__ */ C.createContext();
process.env.NODE_ENV !== "production" && (ZV.displayName = "Tablelvl2Context");
const My = ZV;
function hue(e) {
  return ot("MuiTableBody", e);
}
const gue = lt("MuiTableBody", ["root"]), gxe = gue, vue = ["className", "component"], bue = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, hue, t);
}, yue = se("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), Cue = {
  variant: "body"
}, v_ = "tbody", JV = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableBody"
  }), {
    className: s,
    component: c = v_
  } = i, f = pe(i, vue), m = S({}, i, {
    component: c
  }), h = bue(m);
  return /* @__PURE__ */ L(My.Provider, {
    value: Cue,
    children: /* @__PURE__ */ L(yue, S({
      className: be(h.root, s),
      as: c,
      ref: o,
      role: c === v_ ? null : "rowgroup",
      ownerState: m
    }, f))
  });
});
process.env.NODE_ENV !== "production" && (JV.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const vxe = JV;
function Sue(e) {
  return ot("MuiTableCell", e);
}
const xue = lt("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), wue = xue, Eue = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], Tue = (e) => {
  const {
    classes: t,
    variant: o,
    align: i,
    padding: s,
    size: c,
    stickyHeader: f
  } = e, m = {
    root: ["root", o, f && "stickyHeader", i !== "inherit" && `align${ve(i)}`, s !== "normal" && `padding${ve(s)}`, `size${ve(c)}`]
  };
  return je(m, Sue, t);
}, Oue = se("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`size${ve(o.size)}`], o.padding !== "normal" && t[`padding${ve(o.padding)}`], o.align !== "inherit" && t[`align${ve(o.align)}`], o.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? ql(_t(e.palette.divider, 1), 0.88) : Wl(_t(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${wue.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), e5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableCell"
  }), {
    align: s = "inherit",
    className: c,
    component: f,
    padding: m,
    scope: h,
    size: v,
    sortDirection: b,
    variant: x
  } = i, E = pe(i, Eue), T = C.useContext(XV), P = C.useContext(My), O = P && P.variant === "head";
  let k;
  f ? k = f : k = O ? "th" : "td";
  let I = h;
  k === "td" ? I = void 0 : !I && O && (I = "col");
  const $ = x || P && P.variant, _ = S({}, i, {
    align: s,
    component: k,
    padding: m || (T && T.padding ? T.padding : "normal"),
    size: v || (T && T.size ? T.size : "medium"),
    sortDirection: b,
    stickyHeader: $ === "head" && T && T.stickyHeader,
    variant: $
  }), z = Tue(_);
  let V = null;
  return b && (V = b === "asc" ? "ascending" : "descending"), /* @__PURE__ */ L(Oue, S({
    as: k,
    ref: o,
    className: be(z.root, c),
    "aria-sort": V,
    scope: I,
    ownerState: _
  }, E));
});
process.env.NODE_ENV !== "production" && (e5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: n.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: n.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: n.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: n.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: n.oneOfType([n.oneOf(["body", "footer", "head"]), n.string])
});
const zR = e5;
function Rue(e) {
  return ot("MuiTableContainer", e);
}
const kue = lt("MuiTableContainer", ["root"]), bxe = kue, Pue = ["className", "component"], Mue = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, Rue, t);
}, Iue = se("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), t5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: s,
    component: c = "div"
  } = i, f = pe(i, Pue), m = S({}, i, {
    component: c
  }), h = Mue(m);
  return /* @__PURE__ */ L(Iue, S({
    ref: o,
    as: c,
    className: be(h.root, s),
    ownerState: m
  }, f));
});
process.env.NODE_ENV !== "production" && (t5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `Table`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const yxe = t5;
function Nue(e) {
  return ot("MuiTableFooter", e);
}
const $ue = lt("MuiTableFooter", ["root"]), Cxe = $ue, Due = ["className", "component"], _ue = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, Nue, t);
}, Aue = se("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-footer-group"
}), Lue = {
  variant: "footer"
}, b_ = "tfoot", n5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableFooter"
  }), {
    className: s,
    component: c = b_
  } = i, f = pe(i, Due), m = S({}, i, {
    component: c
  }), h = _ue(m);
  return /* @__PURE__ */ L(My.Provider, {
    value: Lue,
    children: /* @__PURE__ */ L(Aue, S({
      as: c,
      className: be(h.root, s),
      ref: o,
      role: c === b_ ? null : "rowgroup",
      ownerState: m
    }, f))
  });
});
process.env.NODE_ENV !== "production" && (n5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Sxe = n5;
function Fue(e) {
  return ot("MuiTableHead", e);
}
const zue = lt("MuiTableHead", ["root"]), xxe = zue, Vue = ["className", "component"], Bue = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, Fue, t);
}, jue = se("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), Hue = {
  variant: "head"
}, y_ = "thead", r5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableHead"
  }), {
    className: s,
    component: c = y_
  } = i, f = pe(i, Vue), m = S({}, i, {
    component: c
  }), h = Bue(m);
  return /* @__PURE__ */ L(My.Provider, {
    value: Hue,
    children: /* @__PURE__ */ L(jue, S({
      as: c,
      className: be(h.root, s),
      ref: o,
      role: c === y_ ? null : "rowgroup",
      ownerState: m
    }, f))
  });
});
process.env.NODE_ENV !== "production" && (r5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `TableRow`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const wxe = r5;
function Uue(e) {
  return ot("MuiToolbar", e);
}
const Gue = lt("MuiToolbar", ["root", "gutters", "regular", "dense"]), Exe = Gue, Wue = ["className", "component", "disableGutters", "variant"], que = (e) => {
  const {
    classes: t,
    disableGutters: o,
    variant: i
  } = e;
  return je({
    root: ["root", !o && "gutters", i]
  }, Uue, t);
}, Yue = se("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disableGutters && t.gutters, t[o.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), o5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiToolbar"
  }), {
    className: s,
    component: c = "div",
    disableGutters: f = !1,
    variant: m = "regular"
  } = i, h = pe(i, Wue), v = S({}, i, {
    component: c,
    disableGutters: f,
    variant: m
  }), b = que(v);
  return /* @__PURE__ */ L(Yue, S({
    as: c,
    className: be(b.root, s),
    ref: o,
    ownerState: v
  }, h));
});
process.env.NODE_ENV !== "production" && (o5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: n.oneOfType([n.oneOf(["dense", "regular"]), n.string])
});
const Kue = o5, VR = rn(/* @__PURE__ */ L("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), BR = rn(/* @__PURE__ */ L("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
var C_, S_, x_, w_, E_, T_, O_, R_;
const Xue = ["backIconButtonProps", "count", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton"], a5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    backIconButtonProps: i,
    count: s,
    getItemAriaLabel: c,
    nextIconButtonProps: f,
    onPageChange: m,
    page: h,
    rowsPerPage: v,
    showFirstButton: b,
    showLastButton: x
  } = t, E = pe(t, Xue), T = mr(), P = ($) => {
    m($, 0);
  }, O = ($) => {
    m($, h - 1);
  }, k = ($) => {
    m($, h + 1);
  }, I = ($) => {
    m($, Math.max(0, Math.ceil(s / v) - 1));
  };
  return /* @__PURE__ */ ht("div", S({
    ref: o
  }, E, {
    children: [b && /* @__PURE__ */ L(As, {
      onClick: P,
      disabled: h === 0,
      "aria-label": c("first", h),
      title: c("first", h),
      children: T.direction === "rtl" ? C_ || (C_ = /* @__PURE__ */ L(j1, {})) : S_ || (S_ = /* @__PURE__ */ L(B1, {}))
    }), /* @__PURE__ */ L(As, S({
      onClick: O,
      disabled: h === 0,
      color: "inherit",
      "aria-label": c("previous", h),
      title: c("previous", h)
    }, i, {
      children: T.direction === "rtl" ? x_ || (x_ = /* @__PURE__ */ L(BR, {})) : w_ || (w_ = /* @__PURE__ */ L(VR, {}))
    })), /* @__PURE__ */ L(As, S({
      onClick: k,
      disabled: s !== -1 ? h >= Math.ceil(s / v) - 1 : !1,
      color: "inherit",
      "aria-label": c("next", h),
      title: c("next", h)
    }, f, {
      children: T.direction === "rtl" ? E_ || (E_ = /* @__PURE__ */ L(VR, {})) : T_ || (T_ = /* @__PURE__ */ L(BR, {}))
    })), x && /* @__PURE__ */ L(As, {
      onClick: I,
      disabled: h >= Math.ceil(s / v) - 1,
      "aria-label": c("last", h),
      title: c("last", h),
      children: T.direction === "rtl" ? O_ || (O_ = /* @__PURE__ */ L(B1, {})) : R_ || (R_ = /* @__PURE__ */ L(j1, {}))
    })]
  }));
});
process.env.NODE_ENV !== "production" && (a5.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: n.object,
  /**
   * The total number of rows.
   */
  count: n.number.isRequired,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: n.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: n.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: n.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: n.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: n.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: n.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: n.bool.isRequired
});
const Que = a5;
function Zue(e) {
  return ot("MuiTablePagination", e);
}
const Jue = lt("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]), Yf = Jue;
var k_;
const ede = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton"], tde = se(zR, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
})), nde = se(Kue, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => S({
    [`& .${Yf.actions}`]: t.actions
  }, t.toolbar)
})(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${Yf.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
})), rde = se("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), ode = se("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})(({
  theme: e
}) => S({}, e.typography.body2, {
  flexShrink: 0
})), ade = se(vP, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => S({
    [`& .${Yf.selectIcon}`]: t.selectIcon,
    [`& .${Yf.select}`]: t.select
  }, t.input, t.selectRoot)
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${Yf.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), ide = se(Vs, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), lde = se("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})(({
  theme: e
}) => S({}, e.typography.body2, {
  flexShrink: 0
}));
function sde({
  from: e,
  to: t,
  count: o
}) {
  return `${e}–${t} of ${o !== -1 ? o : `more than ${t}`}`;
}
function cde(e) {
  return `Go to ${e} page`;
}
const ude = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, Zue, t);
}, i5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: s = Que,
    backIconButtonProps: c,
    className: f,
    colSpan: m,
    component: h = zR,
    count: v,
    getItemAriaLabel: b = cde,
    labelDisplayedRows: x = sde,
    labelRowsPerPage: E = "Rows per page:",
    nextIconButtonProps: T,
    onPageChange: P,
    onRowsPerPageChange: O,
    page: k,
    rowsPerPage: I,
    rowsPerPageOptions: $ = [10, 25, 50, 100],
    SelectProps: _ = {},
    showFirstButton: z = !1,
    showLastButton: V = !1
  } = i, M = pe(i, ede), A = i, W = ude(A), Y = _.native ? "option" : ide;
  let H;
  (h === zR || h === "td") && (H = m || 1e3);
  const G = Qn(_.id), ne = Qn(_.labelId), K = () => v === -1 ? (k + 1) * I : I === -1 ? v : Math.min(v, (k + 1) * I);
  return /* @__PURE__ */ L(tde, S({
    colSpan: H,
    ref: o,
    as: h,
    ownerState: A,
    className: be(W.root, f)
  }, M, {
    children: /* @__PURE__ */ ht(nde, {
      className: W.toolbar,
      children: [/* @__PURE__ */ L(rde, {
        className: W.spacer
      }), $.length > 1 && /* @__PURE__ */ L(ode, {
        className: W.selectLabel,
        id: ne,
        children: E
      }), $.length > 1 && /* @__PURE__ */ L(ade, S({
        variant: "standard"
      }, !_.variant && {
        input: k_ || (k_ = /* @__PURE__ */ L(Gh, {}))
      }, {
        value: I,
        onChange: O,
        id: G,
        labelId: ne
      }, _, {
        classes: S({}, _.classes, {
          // TODO v5 remove `classes.input`
          root: be(W.input, W.selectRoot, (_.classes || {}).root),
          select: be(W.select, (_.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: be(W.selectIcon, (_.classes || {}).icon)
        }),
        children: $.map((B) => /* @__PURE__ */ Ch(Y, S({}, !Ul(Y) && {
          ownerState: A
        }, {
          className: W.menuItem,
          key: B.label ? B.label : B,
          value: B.value ? B.value : B
        }), B.label ? B.label : B))
      })), /* @__PURE__ */ L(lde, {
        className: W.displayedRows,
        children: x({
          from: v === 0 ? 0 : k * I + 1,
          to: K(),
          count: v === -1 ? -1 : v,
          page: k
        })
      }), /* @__PURE__ */ L(s, {
        className: W.actions,
        backIconButtonProps: c,
        count: v,
        nextIconButtonProps: T,
        onPageChange: P,
        page: k,
        rowsPerPage: I,
        showFirstButton: z,
        showLastButton: V,
        getItemAriaLabel: b
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" && (i5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: n.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   */
  backIconButtonProps: n.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * @ignore
   */
  colSpan: n.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: eo.isRequired,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: n.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: n.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: n.node,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: n.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: n.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: n.func,
  /**
   * The zero-based index of the current page.
   */
  page: co(eo.isRequired, (e) => {
    const {
      count: t,
      page: o,
      rowsPerPage: i
    } = e;
    if (t === -1)
      return null;
    const s = Math.max(0, Math.ceil(t / i) - 1);
    return o < 0 || o > s ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${s}, but page is ${o}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: eo.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: n.arrayOf(n.oneOfType([n.number, n.shape({
    label: n.string.isRequired,
    value: n.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   * @default {}
   */
  SelectProps: n.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: n.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const dde = i5;
function fde(e) {
  return ot("MuiTableRow", e);
}
const pde = lt("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), P_ = pde, mde = ["className", "component", "hover", "selected"], hde = (e) => {
  const {
    classes: t,
    selected: o,
    hover: i,
    head: s,
    footer: c
  } = e;
  return je({
    root: ["root", o && "selected", i && "hover", s && "head", c && "footer"]
  }, fde, t);
}, gde = se("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.head && t.head, o.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${P_.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${P_.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), M_ = "tr", l5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableRow"
  }), {
    className: s,
    component: c = M_,
    hover: f = !1,
    selected: m = !1
  } = i, h = pe(i, mde), v = C.useContext(My), b = S({}, i, {
    component: c,
    hover: f,
    selected: m,
    head: v && v.variant === "head",
    footer: v && v.variant === "footer"
  }), x = hde(b);
  return /* @__PURE__ */ L(gde, S({
    as: c,
    ref: o,
    className: be(x.root, s),
    role: c === M_ ? null : "row",
    ownerState: b
  }, h));
});
process.env.NODE_ENV !== "production" && (l5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: n.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: n.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Txe = l5, vde = rn(/* @__PURE__ */ L("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function bde(e) {
  return ot("MuiTableSortLabel", e);
}
const yde = lt("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc"]), aR = yde, Cde = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"], Sde = (e) => {
  const {
    classes: t,
    direction: o,
    active: i
  } = e, s = {
    root: ["root", i && "active"],
    icon: ["icon", `iconDirection${ve(o)}`]
  };
  return je(s, bde, t);
}, xde = se(Ao, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.active && t.active];
  }
})(({
  theme: e
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (e.vars || e).palette.text.secondary
  },
  "&:hover": {
    color: (e.vars || e).palette.text.secondary,
    [`& .${aR.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${aR.active}`]: {
    color: (e.vars || e).palette.text.primary,
    [`& .${aR.icon}`]: {
      opacity: 1,
      color: (e.vars || e).palette.text.secondary
    }
  }
})), wde = se("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, t[`iconDirection${ve(o.direction)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: e.transitions.create(["opacity", "transform"], {
    duration: e.transitions.duration.shorter
  }),
  userSelect: "none"
}, t.direction === "desc" && {
  transform: "rotate(0deg)"
}, t.direction === "asc" && {
  transform: "rotate(180deg)"
})), s5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTableSortLabel"
  }), {
    active: s = !1,
    children: c,
    className: f,
    direction: m = "asc",
    hideSortIcon: h = !1,
    IconComponent: v = vde
  } = i, b = pe(i, Cde), x = S({}, i, {
    active: s,
    direction: m,
    hideSortIcon: h,
    IconComponent: v
  }), E = Sde(x);
  return /* @__PURE__ */ ht(xde, S({
    className: be(E.root, f),
    component: "span",
    disableRipple: !0,
    ownerState: x,
    ref: o
  }, b, {
    children: [c, h && !s ? null : /* @__PURE__ */ L(wde, {
      as: v,
      className: be(E.icon),
      ownerState: x
    })]
  }));
});
process.env.NODE_ENV !== "production" && (s5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: n.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: n.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: n.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: n.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Oxe = s5;
function Ede(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function Tde(e, t, o, i = {}, s = () => {
}) {
  const {
    ease: c = Ede,
    duration: f = 300
    // standard
  } = i;
  let m = null;
  const h = t[e];
  let v = !1;
  const b = () => {
    v = !0;
  }, x = (E) => {
    if (v) {
      s(new Error("Animation cancelled"));
      return;
    }
    m === null && (m = E);
    const T = Math.min(1, (E - m) / f);
    if (t[e] = c(T) * (o - h) + h, T >= 1) {
      requestAnimationFrame(() => {
        s(null);
      });
      return;
    }
    requestAnimationFrame(x);
  };
  return h === o ? (s(new Error("Element already at target position")), b) : (requestAnimationFrame(x), b);
}
const Ode = ["onChange"], Rde = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function c5(e) {
  const {
    onChange: t
  } = e, o = pe(e, Ode), i = C.useRef(), s = C.useRef(null), c = () => {
    i.current = s.current.offsetHeight - s.current.clientHeight;
  };
  return Hn(() => {
    const f = lp(() => {
      const h = i.current;
      c(), h !== i.current && t(i.current);
    }), m = Ta(s.current);
    return m.addEventListener("resize", f), () => {
      f.clear(), m.removeEventListener("resize", f);
    };
  }, [t]), C.useEffect(() => {
    c(), t(i.current);
  }, [t]), /* @__PURE__ */ L("div", S({
    style: Rde,
    ref: s
  }, o));
}
process.env.NODE_ENV !== "production" && (c5.propTypes = {
  onChange: n.func.isRequired
});
function kde(e) {
  return ot("MuiTabScrollButton", e);
}
const Pde = lt("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), Mde = Pde, Ide = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], Nde = (e) => {
  const {
    classes: t,
    orientation: o,
    disabled: i
  } = e;
  return je({
    root: ["root", o, i && "disabled"]
  }, kde, t);
}, $de = se(Ao, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.orientation && t[o.orientation]];
  }
})(({
  ownerState: e
}) => S({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${Mde.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), u5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = dt({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: f,
    slots: m = {},
    slotProps: h = {},
    direction: v
  } = c, b = pe(c, Ide), E = mr().direction === "rtl", T = S({
    isRtl: E
  }, c), P = Nde(T), O = (i = m.StartScrollButtonIcon) != null ? i : VR, k = (s = m.EndScrollButtonIcon) != null ? s : BR, I = Gr({
    elementType: O,
    externalSlotProps: h.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: T
  }), $ = Gr({
    elementType: k,
    externalSlotProps: h.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: T
  });
  return /* @__PURE__ */ L($de, S({
    component: "div",
    className: be(P.root, f),
    ref: o,
    role: null,
    ownerState: T,
    tabIndex: null
  }, b, {
    children: v === "left" ? /* @__PURE__ */ L(O, S({}, I)) : /* @__PURE__ */ L(k, S({}, $))
  }));
});
process.env.NODE_ENV !== "production" && (u5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The direction the button should indicate.
   */
  direction: n.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: n.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: n.shape({
    endScrollButtonIcon: n.oneOfType([n.func, n.object]),
    startScrollButtonIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    EndScrollButtonIcon: n.elementType,
    StartScrollButtonIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Dde = u5;
function _de(e) {
  return ot("MuiTabs", e);
}
const Ade = lt("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), iR = Ade, Lde = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], I_ = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, N_ = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, r1 = (e, t, o) => {
  let i = !1, s = o(e, t);
  for (; s; ) {
    if (s === e.firstChild) {
      if (i)
        return;
      i = !0;
    }
    const c = s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || c)
      s = o(e, s);
    else {
      s.focus();
      return;
    }
  }
}, Fde = (e) => {
  const {
    vertical: t,
    fixed: o,
    hideScrollbar: i,
    scrollableX: s,
    scrollableY: c,
    centered: f,
    scrollButtonsHideMobile: m,
    classes: h
  } = e;
  return je({
    root: ["root", t && "vertical"],
    scroller: ["scroller", o && "fixed", i && "hideScrollbar", s && "scrollableX", c && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", f && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", m && "scrollButtonsHideMobile"],
    scrollableX: [s && "scrollableX"],
    hideScrollbar: [i && "hideScrollbar"]
  }, _de, h);
}, zde = se("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${iR.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${iR.scrollButtons}`]: o.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, o.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${iR.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), Vde = se("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.scroller, o.fixed && t.fixed, o.hideScrollbar && t.hideScrollbar, o.scrollableX && t.scrollableX, o.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => S({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), Bde = se("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.flexContainer, o.vertical && t.flexContainerVertical, o.centered && t.centered];
  }
})(({
  ownerState: e
}) => S({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), jde = se("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => S({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), Hde = se(c5)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), $_ = {};
let D_ = !1;
const d5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTabs"
  }), s = mr(), c = s.direction === "rtl", {
    "aria-label": f,
    "aria-labelledby": m,
    action: h,
    centered: v = !1,
    children: b,
    className: x,
    component: E = "div",
    allowScrollButtonsMobile: T = !1,
    indicatorColor: P = "primary",
    onChange: O,
    orientation: k = "horizontal",
    ScrollButtonComponent: I = Dde,
    scrollButtons: $ = "auto",
    selectionFollowsFocus: _,
    slots: z = {},
    slotProps: V = {},
    TabIndicatorProps: M = {},
    TabScrollButtonProps: A = {},
    textColor: W = "primary",
    value: Y,
    variant: H = "standard",
    visibleScrollbar: G = !1
  } = i, ne = pe(i, Lde), K = H === "scrollable", B = k === "vertical", q = B ? "scrollTop" : "scrollLeft", X = B ? "top" : "left", J = B ? "bottom" : "right", U = B ? "clientHeight" : "clientWidth", Z = B ? "height" : "width", ee = S({}, i, {
    component: E,
    allowScrollButtonsMobile: T,
    indicatorColor: P,
    orientation: k,
    vertical: B,
    scrollButtons: $,
    textColor: W,
    variant: H,
    visibleScrollbar: G,
    fixed: !K,
    hideScrollbar: K && !G,
    scrollableX: K && !B,
    scrollableY: K && B,
    centered: v && !K,
    scrollButtonsHideMobile: !T
  }), ie = Fde(ee), oe = Gr({
    elementType: z.StartScrollButtonIcon,
    externalSlotProps: V.startScrollButtonIcon,
    ownerState: ee
  }), le = Gr({
    elementType: z.EndScrollButtonIcon,
    externalSlotProps: V.endScrollButtonIcon,
    ownerState: ee
  });
  process.env.NODE_ENV !== "production" && v && K && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [de, Ce] = C.useState(!1), [me, Oe] = C.useState($_), [he, $e] = C.useState(!1), [Ne, Pe] = C.useState(!1), [Se, Fe] = C.useState(!1), [ce, ge] = C.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), we = /* @__PURE__ */ new Map(), Me = C.useRef(null), Qe = C.useRef(null), ct = () => {
    const et = Me.current;
    let gt;
    if (et) {
      const Lt = et.getBoundingClientRect();
      gt = {
        clientWidth: et.clientWidth,
        scrollLeft: et.scrollLeft,
        scrollTop: et.scrollTop,
        scrollLeftNormalized: o9(et, s.direction),
        scrollWidth: et.scrollWidth,
        top: Lt.top,
        bottom: Lt.bottom,
        left: Lt.left,
        right: Lt.right
      };
    }
    let kt;
    if (et && Y !== !1) {
      const Lt = Qe.current.children;
      if (Lt.length > 0) {
        const Ut = Lt[we.get(Y)];
        process.env.NODE_ENV !== "production" && (Ut || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${Y}".`, we.keys ? `You can provide one of the following values: ${Array.from(we.keys()).join(", ")}.` : null].join(`
`))), kt = Ut ? Ut.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !D_ && kt && kt.width === 0 && kt.height === 0 && // if the whole Tabs component is hidden, don't warn
        gt.clientWidth !== 0 && (gt = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${Y}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), D_ = !0);
      }
    }
    return {
      tabsMeta: gt,
      tabMeta: kt
    };
  }, Ze = zn(() => {
    const {
      tabsMeta: et,
      tabMeta: gt
    } = ct();
    let kt = 0, Lt;
    if (B)
      Lt = "top", gt && et && (kt = gt.top - et.top + et.scrollTop);
    else if (Lt = c ? "right" : "left", gt && et) {
      const Sn = c ? et.scrollLeftNormalized + et.clientWidth - et.scrollWidth : et.scrollLeft;
      kt = (c ? -1 : 1) * (gt[Lt] - et[Lt] + Sn);
    }
    const Ut = {
      [Lt]: kt,
      // May be wrong until the font is loaded.
      [Z]: gt ? gt[Z] : 0
    };
    if (isNaN(me[Lt]) || isNaN(me[Z]))
      Oe(Ut);
    else {
      const Sn = Math.abs(me[Lt] - Ut[Lt]), an = Math.abs(me[Z] - Ut[Z]);
      (Sn >= 1 || an >= 1) && Oe(Ut);
    }
  }), Ge = (et, {
    animation: gt = !0
  } = {}) => {
    gt ? Tde(q, Me.current, et, {
      duration: s.transitions.duration.standard
    }) : Me.current[q] = et;
  }, Be = (et) => {
    let gt = Me.current[q];
    B ? gt += et : (gt += et * (c ? -1 : 1), gt *= c && oL() === "reverse" ? -1 : 1), Ge(gt);
  }, rt = () => {
    const et = Me.current[U];
    let gt = 0;
    const kt = Array.from(Qe.current.children);
    for (let Lt = 0; Lt < kt.length; Lt += 1) {
      const Ut = kt[Lt];
      if (gt + Ut[U] > et) {
        Lt === 0 && (gt = et);
        break;
      }
      gt += Ut[U];
    }
    return gt;
  }, wt = () => {
    Be(-1 * rt());
  }, We = () => {
    Be(rt());
  }, ut = C.useCallback((et) => {
    ge({
      overflow: null,
      scrollbarWidth: et
    });
  }, []), ft = () => {
    const et = {};
    et.scrollbarSizeListener = K ? /* @__PURE__ */ L(Hde, {
      onChange: ut,
      className: be(ie.scrollableX, ie.hideScrollbar)
    }) : null;
    const kt = K && ($ === "auto" && (he || Ne) || $ === !0);
    return et.scrollButtonStart = kt ? /* @__PURE__ */ L(I, S({
      slots: {
        StartScrollButtonIcon: z.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: oe
      },
      orientation: k,
      direction: c ? "right" : "left",
      onClick: wt,
      disabled: !he
    }, A, {
      className: be(ie.scrollButtons, A.className)
    })) : null, et.scrollButtonEnd = kt ? /* @__PURE__ */ L(I, S({
      slots: {
        EndScrollButtonIcon: z.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: le
      },
      orientation: k,
      direction: c ? "left" : "right",
      onClick: We,
      disabled: !Ne
    }, A, {
      className: be(ie.scrollButtons, A.className)
    })) : null, et;
  }, Je = zn((et) => {
    const {
      tabsMeta: gt,
      tabMeta: kt
    } = ct();
    if (!(!kt || !gt)) {
      if (kt[X] < gt[X]) {
        const Lt = gt[q] + (kt[X] - gt[X]);
        Ge(Lt, {
          animation: et
        });
      } else if (kt[J] > gt[J]) {
        const Lt = gt[q] + (kt[J] - gt[J]);
        Ge(Lt, {
          animation: et
        });
      }
    }
  }), pt = zn(() => {
    K && $ !== !1 && Fe(!Se);
  });
  C.useEffect(() => {
    const et = lp(() => {
      Me.current && Ze();
    }), gt = Ta(Me.current);
    gt.addEventListener("resize", et);
    let kt;
    return typeof ResizeObserver < "u" && (kt = new ResizeObserver(et), Array.from(Qe.current.children).forEach((Lt) => {
      kt.observe(Lt);
    })), () => {
      et.clear(), gt.removeEventListener("resize", et), kt && kt.disconnect();
    };
  }, [Ze]), C.useEffect(() => {
    const et = Array.from(Qe.current.children), gt = et.length;
    if (typeof IntersectionObserver < "u" && gt > 0 && K && $ !== !1) {
      const kt = et[0], Lt = et[gt - 1], Ut = {
        root: Me.current,
        threshold: 0.99
      }, Sn = (hn) => {
        $e(!hn[0].isIntersecting);
      }, an = new IntersectionObserver(Sn, Ut);
      an.observe(kt);
      const un = (hn) => {
        Pe(!hn[0].isIntersecting);
      }, wn = new IntersectionObserver(un, Ut);
      return wn.observe(Lt), () => {
        an.disconnect(), wn.disconnect();
      };
    }
  }, [K, $, Se, b == null ? void 0 : b.length]), C.useEffect(() => {
    Ce(!0);
  }, []), C.useEffect(() => {
    Ze();
  }), C.useEffect(() => {
    Je($_ !== me);
  }, [Je, me]), C.useImperativeHandle(h, () => ({
    updateIndicator: Ze,
    updateScrollButtons: pt
  }), [Ze, pt]);
  const At = /* @__PURE__ */ L(jde, S({}, M, {
    className: be(ie.indicator, M.className),
    ownerState: ee,
    style: S({}, me, M.style)
  }));
  let Ye = 0;
  const st = C.Children.map(b, (et) => {
    if (!/* @__PURE__ */ C.isValidElement(et))
      return null;
    process.env.NODE_ENV !== "production" && Kl.isFragment(et) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const gt = et.props.value === void 0 ? Ye : et.props.value;
    we.set(gt, Ye);
    const kt = gt === Y;
    return Ye += 1, /* @__PURE__ */ C.cloneElement(et, S({
      fullWidth: H === "fullWidth",
      indicator: kt && !de && At,
      selected: kt,
      selectionFollowsFocus: _,
      onChange: O,
      textColor: W,
      value: gt
    }, Ye === 1 && Y === !1 && !et.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), _e = (et) => {
    const gt = Qe.current, kt = qn(gt).activeElement;
    if (kt.getAttribute("role") !== "tab")
      return;
    let Ut = k === "horizontal" ? "ArrowLeft" : "ArrowUp", Sn = k === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (k === "horizontal" && c && (Ut = "ArrowRight", Sn = "ArrowLeft"), et.key) {
      case Ut:
        et.preventDefault(), r1(gt, kt, N_);
        break;
      case Sn:
        et.preventDefault(), r1(gt, kt, I_);
        break;
      case "Home":
        et.preventDefault(), r1(gt, null, I_);
        break;
      case "End":
        et.preventDefault(), r1(gt, null, N_);
        break;
    }
  }, vt = ft();
  return /* @__PURE__ */ ht(zde, S({
    className: be(ie.root, x),
    ownerState: ee,
    ref: o,
    as: E
  }, ne, {
    children: [vt.scrollButtonStart, vt.scrollbarSizeListener, /* @__PURE__ */ ht(Vde, {
      className: ie.scroller,
      ownerState: ee,
      style: {
        overflow: ce.overflow,
        [B ? `margin${c ? "Left" : "Right"}` : "marginBottom"]: G ? void 0 : -ce.scrollbarWidth
      },
      ref: Me,
      children: [/* @__PURE__ */ L(Bde, {
        "aria-label": f,
        "aria-labelledby": m,
        "aria-orientation": k === "vertical" ? "vertical" : null,
        className: ie.flexContainer,
        ownerState: ee,
        onKeyDown: _e,
        ref: Qe,
        role: "tablist",
        children: st
      }), de && At]
    }), vt.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" && (d5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: Fo,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: n.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": n.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": n.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: n.bool,
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: n.oneOfType([n.oneOf(["primary", "secondary"]), n.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: n.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: n.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: n.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: n.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: n.shape({
    endScrollButtonIcon: n.oneOfType([n.func, n.object]),
    startScrollButtonIcon: n.oneOfType([n.func, n.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: n.shape({
    EndScrollButtonIcon: n.elementType,
    StartScrollButtonIcon: n.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: n.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: n.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: n.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: n.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: n.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: n.bool
});
const Rxe = d5;
function Ude(e) {
  return ot("MuiTextField", e);
}
const Gde = lt("MuiTextField", ["root"]), kxe = Gde, Wde = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], qde = {
  standard: sP,
  filled: Oz,
  outlined: gV
}, Yde = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["root"]
  }, Ude, t);
}, Kde = se(kz, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), f5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: s,
    autoFocus: c = !1,
    children: f,
    className: m,
    color: h = "primary",
    defaultValue: v,
    disabled: b = !1,
    error: x = !1,
    FormHelperTextProps: E,
    fullWidth: T = !1,
    helperText: P,
    id: O,
    InputLabelProps: k,
    inputProps: I,
    InputProps: $,
    inputRef: _,
    label: z,
    maxRows: V,
    minRows: M,
    multiline: A = !1,
    name: W,
    onBlur: Y,
    onChange: H,
    onFocus: G,
    placeholder: ne,
    required: K = !1,
    rows: B,
    select: q = !1,
    SelectProps: X,
    type: J,
    value: U,
    variant: Z = "outlined"
  } = i, ee = pe(i, Wde), ie = S({}, i, {
    autoFocus: c,
    color: h,
    disabled: b,
    error: x,
    fullWidth: T,
    multiline: A,
    required: K,
    select: q,
    variant: Z
  }), oe = Yde(ie);
  process.env.NODE_ENV !== "production" && q && !f && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const le = {};
  Z === "outlined" && (k && typeof k.shrink < "u" && (le.notched = k.shrink), le.label = z), q && ((!X || !X.native) && (le.id = void 0), le["aria-describedby"] = void 0);
  const de = Qn(O), Ce = P && de ? `${de}-helper-text` : void 0, me = z && de ? `${de}-label` : void 0, Oe = qde[Z], he = /* @__PURE__ */ L(Oe, S({
    "aria-describedby": Ce,
    autoComplete: s,
    autoFocus: c,
    defaultValue: v,
    fullWidth: T,
    multiline: A,
    name: W,
    rows: B,
    maxRows: V,
    minRows: M,
    type: J,
    value: U,
    id: de,
    inputRef: _,
    onBlur: Y,
    onChange: H,
    onFocus: G,
    placeholder: ne,
    inputProps: I
  }, le, $));
  return /* @__PURE__ */ ht(Kde, S({
    className: be(oe.root, m),
    disabled: b,
    error: x,
    fullWidth: T,
    ref: o,
    required: K,
    color: h,
    variant: Z,
    ownerState: ie
  }, ee, {
    children: [z != null && z !== "" && /* @__PURE__ */ L(Wz, S({
      htmlFor: de,
      id: me
    }, k, {
      children: z
    })), q ? /* @__PURE__ */ L(vP, S({
      "aria-describedby": Ce,
      id: de,
      labelId: me,
      value: U,
      input: he
    }, X, {
      children: f
    })) : he, P && /* @__PURE__ */ L(Bne, S({
      id: Ce
    }, E, {
      children: P
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (f5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: n.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: n.bool,
  /**
   * @ignore
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: n.oneOfType([n.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: n.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: n.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: n.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * The helper text content.
   */
  helperText: n.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: n.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: n.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: n.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: n.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fo,
  /**
   * The label content.
   */
  label: n.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: n.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: n.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: n.string,
  /**
   * @ignore
   */
  onBlur: n.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: n.func,
  /**
   * @ignore
   */
  onFocus: n.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: n.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: n.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: n.oneOfType([n.number, n.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: n.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: n.object,
  /**
   * The size of the component.
   */
  size: n.oneOfType([n.oneOf(["medium", "small"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: n.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: n.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: n.oneOf(["filled", "outlined", "standard"])
});
const p5 = f5;
function Xde(e) {
  return ot("MuiToggleButton", e);
}
const Qde = lt("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge"]), __ = Qde, Zde = ["children", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "onChange", "onClick", "selected", "size", "value"], Jde = (e) => {
  const {
    classes: t,
    fullWidth: o,
    selected: i,
    disabled: s,
    size: c,
    color: f
  } = e, m = {
    root: ["root", i && "selected", s && "disabled", o && "fullWidth", `size${ve(c)}`, f]
  };
  return je(m, Xde, t);
}, efe = se(Ao, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`size${ve(o.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let o = t.color === "standard" ? e.palette.text.primary : e.palette[t.color].main, i;
  return e.vars && (o = t.color === "standard" ? e.vars.palette.text.primary : e.vars.palette[t.color].main, i = t.color === "standard" ? e.vars.palette.text.primaryChannel : e.vars.palette[t.color].mainChannel), S({}, e.typography.button, {
    borderRadius: (e.vars || e).shape.borderRadius,
    padding: 11,
    border: `1px solid ${(e.vars || e).palette.divider}`,
    color: (e.vars || e).palette.action.active
  }, t.fullWidth && {
    width: "100%"
  }, {
    [`&.${__.disabled}`]: {
      color: (e.vars || e).palette.action.disabled,
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    },
    "&:hover": {
      textDecoration: "none",
      // Reset on mouse devices
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : _t(e.palette.text.primary, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${__.selected}`]: {
      color: o,
      backgroundColor: e.vars ? `rgba(${i} / ${e.vars.palette.action.selectedOpacity})` : _t(o, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${i} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _t(o, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${i} / ${e.vars.palette.action.selectedOpacity})` : _t(o, e.palette.action.selectedOpacity)
        }
      }
    }
  }, t.size === "small" && {
    padding: 7,
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && {
    padding: 15,
    fontSize: e.typography.pxToRem(15)
  });
}), m5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiToggleButton"
  }), {
    children: s,
    className: c,
    color: f = "standard",
    disabled: m = !1,
    disableFocusRipple: h = !1,
    fullWidth: v = !1,
    onChange: b,
    onClick: x,
    selected: E,
    size: T = "medium",
    value: P
  } = i, O = pe(i, Zde), k = S({}, i, {
    color: f,
    disabled: m,
    disableFocusRipple: h,
    fullWidth: v,
    size: T
  }), I = Jde(k), $ = (_) => {
    x && (x(_, P), _.defaultPrevented) || b && b(_, P);
  };
  return /* @__PURE__ */ L(efe, S({
    className: be(I.root, c),
    disabled: m,
    focusRipple: !h,
    ref: o,
    onClick: $,
    onChange: b,
    value: P,
    ownerState: k,
    "aria-pressed": E
  }, O, {
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (m5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: n.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: n.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: n.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: n.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: n.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: n.any.isRequired
});
const Pxe = m5;
function tfe(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.indexOf(e) >= 0 : e === t;
}
function nfe(e) {
  return ot("MuiToggleButtonGroup", e);
}
const rfe = lt("MuiToggleButtonGroup", ["root", "selected", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical"]), Lc = rfe, ofe = ["children", "className", "color", "disabled", "exclusive", "fullWidth", "onChange", "orientation", "size", "value"], afe = (e) => {
  const {
    classes: t,
    orientation: o,
    fullWidth: i,
    disabled: s
  } = e, c = {
    root: ["root", o === "vertical" && "vertical", i && "fullWidth"],
    grouped: ["grouped", `grouped${ve(o)}`, s && "disabled"]
  };
  return je(c, nfe, t);
}, ife = se("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Lc.grouped}`]: t.grouped
    }, {
      [`& .${Lc.grouped}`]: t[`grouped${ve(o.orientation)}`]
    }, t.root, o.orientation === "vertical" && t.vertical, o.fullWidth && t.fullWidth];
  }
})(({
  ownerState: e,
  theme: t
}) => S({
  display: "inline-flex",
  borderRadius: (t.vars || t).shape.borderRadius
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.fullWidth && {
  width: "100%"
}, {
  [`& .${Lc.grouped}`]: S({}, e.orientation === "horizontal" ? {
    "&:not(:first-of-type)": {
      marginLeft: -1,
      borderLeft: "1px solid transparent",
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    "&:not(:last-of-type)": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    [`&.${Lc.selected} + .${Lc.grouped}.${Lc.selected}`]: {
      borderLeft: 0,
      marginLeft: 0
    }
  } : {
    "&:not(:first-of-type)": {
      marginTop: -1,
      borderTop: "1px solid transparent",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    "&:not(:last-of-type)": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    [`&.${Lc.selected} + .${Lc.grouped}.${Lc.selected}`]: {
      borderTop: 0,
      marginTop: 0
    }
  })
})), h5 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = dt({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: s,
    className: c,
    color: f = "standard",
    disabled: m = !1,
    exclusive: h = !1,
    fullWidth: v = !1,
    onChange: b,
    orientation: x = "horizontal",
    size: E = "medium",
    value: T
  } = i, P = pe(i, ofe), O = S({}, i, {
    disabled: m,
    fullWidth: v,
    orientation: x,
    size: E
  }), k = afe(O), I = (_, z) => {
    if (!b)
      return;
    const V = T && T.indexOf(z);
    let M;
    T && V >= 0 ? (M = T.slice(), M.splice(V, 1)) : M = T ? T.concat(z) : [z], b(_, M);
  }, $ = (_, z) => {
    b && b(_, T === z ? null : z);
  };
  return /* @__PURE__ */ L(ife, S({
    role: "group",
    className: be(k.root, c),
    ref: o,
    ownerState: O
  }, P, {
    children: C.Children.map(s, (_) => /* @__PURE__ */ C.isValidElement(_) ? (process.env.NODE_ENV !== "production" && Kl.isFragment(_) && console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ C.cloneElement(_, {
      className: be(k.grouped, _.props.className),
      onChange: h ? $ : I,
      selected: _.props.selected === void 0 ? tfe(_.props.value, T) : _.props.selected,
      size: _.props.size || E,
      fullWidth: v,
      color: _.props.color || f,
      disabled: _.props.disabled || m
    })) : null)
  }));
});
process.env.NODE_ENV !== "production" && (h5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * @ignore
   */
  className: n.string,
  /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: n.oneOfType([n.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), n.string]),
  /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */
  disabled: n.bool,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */
  exclusive: n.bool,
  /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */
  fullWidth: n.bool,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: n.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: n.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: n.oneOfType([n.oneOf(["small", "medium", "large"]), n.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */
  value: n.any
});
const Mxe = h5, lfe = ["getTrigger", "target"];
function sfe(e, t) {
  const {
    disableHysteresis: o = !1,
    threshold: i = 100,
    target: s
  } = t, c = e.current;
  return s && (e.current = s.pageYOffset !== void 0 ? s.pageYOffset : s.scrollTop), !o && c !== void 0 && e.current < c ? !1 : e.current > i;
}
const cfe = typeof window < "u" ? window : null;
function Ixe(e = {}) {
  const {
    getTrigger: t = sfe,
    target: o = cfe
  } = e, i = pe(e, lfe), s = C.useRef(), [c, f] = C.useState(() => t(s, i));
  return C.useEffect(() => {
    const m = () => {
      f(t(s, S({
        target: o
      }, i)));
    };
    return m(), o.addEventListener("scroll", m, {
      passive: !0
    }), () => {
      o.removeEventListener("scroll", m, {
        passive: !0
      });
    };
  }, [o, t, JSON.stringify(i)]), c;
}
function A_(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), o.push.apply(o, i);
  }
  return o;
}
function zt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A_(Object(o), !0).forEach(function(i) {
      Lo(e, i, o[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : A_(Object(o)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(o, i));
    });
  }
  return e;
}
function U1(e) {
  "@babel/helpers - typeof";
  return U1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, U1(e);
}
function ufe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function L_(e, t) {
  for (var o = 0; o < t.length; o++) {
    var i = t[o];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function dfe(e, t, o) {
  return t && L_(e.prototype, t), o && L_(e, o), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Lo(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function xP(e, t) {
  return pfe(e) || hfe(e, t) || g5(e, t) || vfe();
}
function Iy(e) {
  return ffe(e) || mfe(e) || g5(e) || gfe();
}
function ffe(e) {
  if (Array.isArray(e))
    return jR(e);
}
function pfe(e) {
  if (Array.isArray(e))
    return e;
}
function mfe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function hfe(e, t) {
  var o = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (o != null) {
    var i = [], s = !0, c = !1, f, m;
    try {
      for (o = o.call(e); !(s = (f = o.next()).done) && (i.push(f.value), !(t && i.length === t)); s = !0)
        ;
    } catch (h) {
      c = !0, m = h;
    } finally {
      try {
        !s && o.return != null && o.return();
      } finally {
        if (c)
          throw m;
      }
    }
    return i;
  }
}
function g5(e, t) {
  if (e) {
    if (typeof e == "string")
      return jR(e, t);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
      return Array.from(e);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return jR(e, t);
  }
}
function jR(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var o = 0, i = new Array(t); o < t; o++)
    i[o] = e[o];
  return i;
}
function gfe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vfe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var F_ = function() {
}, wP = {}, v5 = {}, b5 = null, y5 = {
  mark: F_,
  measure: F_
};
try {
  typeof window < "u" && (wP = window), typeof document < "u" && (v5 = document), typeof MutationObserver < "u" && (b5 = MutationObserver), typeof performance < "u" && (y5 = performance);
} catch {
}
var bfe = wP.navigator || {}, z_ = bfe.userAgent, V_ = z_ === void 0 ? "" : z_, md = wP, Nr = v5, B_ = b5, o1 = y5;
md.document;
var Kc = !!Nr.documentElement && !!Nr.head && typeof Nr.addEventListener == "function" && typeof Nr.createElement == "function", C5 = ~V_.indexOf("MSIE") || ~V_.indexOf("Trident/"), a1, i1, l1, s1, c1, Uc = "___FONT_AWESOME___", HR = 16, S5 = "fa", x5 = "svg-inline--fa", np = "data-fa-i2svg", UR = "data-fa-pseudo-element", yfe = "data-fa-pseudo-element-pending", EP = "data-prefix", TP = "data-icon", j_ = "fontawesome-i2svg", Cfe = "async", Sfe = ["HTML", "HEAD", "STYLE", "SCRIPT"], w5 = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Ir = "classic", Jr = "sharp", OP = [Ir, Jr];
function Ny(e) {
  return new Proxy(e, {
    get: function(o, i) {
      return i in o ? o[i] : o[Ir];
    }
  });
}
var iy = Ny((a1 = {}, Lo(a1, Ir, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit"
}), Lo(a1, Jr, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light"
}), a1)), ly = Ny((i1 = {}, Lo(i1, Ir, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Lo(i1, Jr, {
  solid: "fass",
  regular: "fasr",
  light: "fasl"
}), i1)), sy = Ny((l1 = {}, Lo(l1, Ir, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Lo(l1, Jr, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light"
}), l1)), xfe = Ny((s1 = {}, Lo(s1, Ir, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Lo(s1, Jr, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl"
}), s1)), wfe = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/, E5 = "fa-layers-text", Efe = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, Tfe = Ny((c1 = {}, Lo(c1, Ir, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Lo(c1, Jr, {
  900: "fass",
  400: "fasr",
  300: "fasl"
}), c1)), T5 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ofe = T5.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Rfe = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Uf = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, cy = /* @__PURE__ */ new Set();
Object.keys(ly[Ir]).map(cy.add.bind(cy));
Object.keys(ly[Jr]).map(cy.add.bind(cy));
var kfe = [].concat(OP, Iy(cy), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Uf.GROUP, Uf.SWAP_OPACITY, Uf.PRIMARY, Uf.SECONDARY]).concat(T5.map(function(e) {
  return "".concat(e, "x");
})).concat(Ofe.map(function(e) {
  return "w-".concat(e);
})), qb = md.FontAwesomeConfig || {};
function Pfe(e) {
  var t = Nr.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Mfe(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (Nr && typeof Nr.querySelector == "function") {
  var Ife = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Ife.forEach(function(e) {
    var t = xP(e, 2), o = t[0], i = t[1], s = Mfe(Pfe(o));
    s != null && (qb[i] = s);
  });
}
var O5 = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: S5,
  replacementClass: x5,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
qb.familyPrefix && (qb.cssPrefix = qb.familyPrefix);
var Fh = zt(zt({}, O5), qb);
Fh.autoReplaceSvg || (Fh.observeMutations = !1);
var Xt = {};
Object.keys(O5).forEach(function(e) {
  Object.defineProperty(Xt, e, {
    enumerable: !0,
    set: function(o) {
      Fh[e] = o, Yb.forEach(function(i) {
        return i(Xt);
      });
    },
    get: function() {
      return Fh[e];
    }
  });
});
Object.defineProperty(Xt, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    Fh.cssPrefix = t, Yb.forEach(function(o) {
      return o(Xt);
    });
  },
  get: function() {
    return Fh.cssPrefix;
  }
});
md.FontAwesomeConfig = Xt;
var Yb = [];
function Nfe(e) {
  return Yb.push(e), function() {
    Yb.splice(Yb.indexOf(e), 1);
  };
}
var Zu = HR, Ls = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function $fe(e) {
  if (!(!e || !Kc)) {
    var t = Nr.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var o = Nr.head.childNodes, i = null, s = o.length - 1; s > -1; s--) {
      var c = o[s], f = (c.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(f) > -1 && (i = c);
    }
    return Nr.head.insertBefore(t, i), e;
  }
}
var Dfe = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function uy() {
  for (var e = 12, t = ""; e-- > 0; )
    t += Dfe[Math.random() * 62 | 0];
  return t;
}
function Yh(e) {
  for (var t = [], o = (e || []).length >>> 0; o--; )
    t[o] = e[o];
  return t;
}
function RP(e) {
  return e.classList ? Yh(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function R5(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function _fe(e) {
  return Object.keys(e || {}).reduce(function(t, o) {
    return t + "".concat(o, '="').concat(R5(e[o]), '" ');
  }, "").trim();
}
function _x(e) {
  return Object.keys(e || {}).reduce(function(t, o) {
    return t + "".concat(o, ": ").concat(e[o].trim(), ";");
  }, "");
}
function kP(e) {
  return e.size !== Ls.size || e.x !== Ls.x || e.y !== Ls.y || e.rotate !== Ls.rotate || e.flipX || e.flipY;
}
function Afe(e) {
  var t = e.transform, o = e.containerWidth, i = e.iconWidth, s = {
    transform: "translate(".concat(o / 2, " 256)")
  }, c = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), f = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), m = "rotate(".concat(t.rotate, " 0 0)"), h = {
    transform: "".concat(c, " ").concat(f, " ").concat(m)
  }, v = {
    transform: "translate(".concat(i / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: h,
    path: v
  };
}
function Lfe(e) {
  var t = e.transform, o = e.width, i = o === void 0 ? HR : o, s = e.height, c = s === void 0 ? HR : s, f = e.startCentered, m = f === void 0 ? !1 : f, h = "";
  return m && C5 ? h += "translate(".concat(t.x / Zu - i / 2, "em, ").concat(t.y / Zu - c / 2, "em) ") : m ? h += "translate(calc(-50% + ".concat(t.x / Zu, "em), calc(-50% + ").concat(t.y / Zu, "em)) ") : h += "translate(".concat(t.x / Zu, "em, ").concat(t.y / Zu, "em) "), h += "scale(".concat(t.size / Zu * (t.flipX ? -1 : 1), ", ").concat(t.size / Zu * (t.flipY ? -1 : 1), ") "), h += "rotate(".concat(t.rotate, "deg) "), h;
}
var Ffe = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function k5() {
  var e = S5, t = x5, o = Xt.cssPrefix, i = Xt.replacementClass, s = Ffe;
  if (o !== e || i !== t) {
    var c = new RegExp("\\.".concat(e, "\\-"), "g"), f = new RegExp("\\--".concat(e, "\\-"), "g"), m = new RegExp("\\.".concat(t), "g");
    s = s.replace(c, ".".concat(o, "-")).replace(f, "--".concat(o, "-")).replace(m, ".".concat(i));
  }
  return s;
}
var H_ = !1;
function lR() {
  Xt.autoAddCss && !H_ && ($fe(k5()), H_ = !0);
}
var zfe = {
  mixout: function() {
    return {
      dom: {
        css: k5,
        insertCss: lR
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        lR();
      },
      beforeI2svg: function() {
        lR();
      }
    };
  }
}, Gc = md || {};
Gc[Uc] || (Gc[Uc] = {});
Gc[Uc].styles || (Gc[Uc].styles = {});
Gc[Uc].hooks || (Gc[Uc].hooks = {});
Gc[Uc].shims || (Gc[Uc].shims = []);
var jl = Gc[Uc], P5 = [], Vfe = function e() {
  Nr.removeEventListener("DOMContentLoaded", e), G1 = 1, P5.map(function(t) {
    return t();
  });
}, G1 = !1;
Kc && (G1 = (Nr.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Nr.readyState), G1 || Nr.addEventListener("DOMContentLoaded", Vfe));
function Bfe(e) {
  Kc && (G1 ? setTimeout(e, 0) : P5.push(e));
}
function $y(e) {
  var t = e.tag, o = e.attributes, i = o === void 0 ? {} : o, s = e.children, c = s === void 0 ? [] : s;
  return typeof e == "string" ? R5(e) : "<".concat(t, " ").concat(_fe(i), ">").concat(c.map($y).join(""), "</").concat(t, ">");
}
function U_(e, t, o) {
  if (e && e[t] && e[t][o])
    return {
      prefix: t,
      iconName: o,
      icon: e[t][o]
    };
}
var jfe = function(t, o) {
  return function(i, s, c, f) {
    return t.call(o, i, s, c, f);
  };
}, sR = function(t, o, i, s) {
  var c = Object.keys(t), f = c.length, m = s !== void 0 ? jfe(o, s) : o, h, v, b;
  for (i === void 0 ? (h = 1, b = t[c[0]]) : (h = 0, b = i); h < f; h++)
    v = c[h], b = m(b, t[v], v, t);
  return b;
};
function Hfe(e) {
  for (var t = [], o = 0, i = e.length; o < i; ) {
    var s = e.charCodeAt(o++);
    if (s >= 55296 && s <= 56319 && o < i) {
      var c = e.charCodeAt(o++);
      (c & 64512) == 56320 ? t.push(((s & 1023) << 10) + (c & 1023) + 65536) : (t.push(s), o--);
    } else
      t.push(s);
  }
  return t;
}
function GR(e) {
  var t = Hfe(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Ufe(e, t) {
  var o = e.length, i = e.charCodeAt(t), s;
  return i >= 55296 && i <= 56319 && o > t + 1 && (s = e.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (i - 55296) * 1024 + s - 56320 + 65536 : i;
}
function G_(e) {
  return Object.keys(e).reduce(function(t, o) {
    var i = e[o], s = !!i.icon;
    return s ? t[i.iconName] = i.icon : t[o] = i, t;
  }, {});
}
function WR(e, t) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = o.skipHooks, s = i === void 0 ? !1 : i, c = G_(t);
  typeof jl.hooks.addPack == "function" && !s ? jl.hooks.addPack(e, G_(t)) : jl.styles[e] = zt(zt({}, jl.styles[e] || {}), c), e === "fas" && WR("fa", t);
}
var u1, d1, f1, gh = jl.styles, Gfe = jl.shims, Wfe = (u1 = {}, Lo(u1, Ir, Object.values(sy[Ir])), Lo(u1, Jr, Object.values(sy[Jr])), u1), PP = null, M5 = {}, I5 = {}, N5 = {}, $5 = {}, D5 = {}, qfe = (d1 = {}, Lo(d1, Ir, Object.keys(iy[Ir])), Lo(d1, Jr, Object.keys(iy[Jr])), d1);
function Yfe(e) {
  return ~kfe.indexOf(e);
}
function Kfe(e, t) {
  var o = t.split("-"), i = o[0], s = o.slice(1).join("-");
  return i === e && s !== "" && !Yfe(s) ? s : null;
}
var _5 = function() {
  var t = function(c) {
    return sR(gh, function(f, m, h) {
      return f[h] = sR(m, c, {}), f;
    }, {});
  };
  M5 = t(function(s, c, f) {
    if (c[3] && (s[c[3]] = f), c[2]) {
      var m = c[2].filter(function(h) {
        return typeof h == "number";
      });
      m.forEach(function(h) {
        s[h.toString(16)] = f;
      });
    }
    return s;
  }), I5 = t(function(s, c, f) {
    if (s[f] = f, c[2]) {
      var m = c[2].filter(function(h) {
        return typeof h == "string";
      });
      m.forEach(function(h) {
        s[h] = f;
      });
    }
    return s;
  }), D5 = t(function(s, c, f) {
    var m = c[2];
    return s[f] = f, m.forEach(function(h) {
      s[h] = f;
    }), s;
  });
  var o = "far" in gh || Xt.autoFetchSvg, i = sR(Gfe, function(s, c) {
    var f = c[0], m = c[1], h = c[2];
    return m === "far" && !o && (m = "fas"), typeof f == "string" && (s.names[f] = {
      prefix: m,
      iconName: h
    }), typeof f == "number" && (s.unicodes[f.toString(16)] = {
      prefix: m,
      iconName: h
    }), s;
  }, {
    names: {},
    unicodes: {}
  });
  N5 = i.names, $5 = i.unicodes, PP = Ax(Xt.styleDefault, {
    family: Xt.familyDefault
  });
};
Nfe(function(e) {
  PP = Ax(e.styleDefault, {
    family: Xt.familyDefault
  });
});
_5();
function MP(e, t) {
  return (M5[e] || {})[t];
}
function Xfe(e, t) {
  return (I5[e] || {})[t];
}
function Gf(e, t) {
  return (D5[e] || {})[t];
}
function A5(e) {
  return N5[e] || {
    prefix: null,
    iconName: null
  };
}
function Qfe(e) {
  var t = $5[e], o = MP("fas", e);
  return t || (o ? {
    prefix: "fas",
    iconName: o
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function hd() {
  return PP;
}
var IP = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function Ax(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = t.family, i = o === void 0 ? Ir : o, s = iy[i][e], c = ly[i][e] || ly[i][s], f = e in jl.styles ? e : null;
  return c || f || null;
}
var W_ = (f1 = {}, Lo(f1, Ir, Object.keys(sy[Ir])), Lo(f1, Jr, Object.keys(sy[Jr])), f1);
function Lx(e) {
  var t, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = o.skipLookups, s = i === void 0 ? !1 : i, c = (t = {}, Lo(t, Ir, "".concat(Xt.cssPrefix, "-").concat(Ir)), Lo(t, Jr, "".concat(Xt.cssPrefix, "-").concat(Jr)), t), f = null, m = Ir;
  (e.includes(c[Ir]) || e.some(function(v) {
    return W_[Ir].includes(v);
  })) && (m = Ir), (e.includes(c[Jr]) || e.some(function(v) {
    return W_[Jr].includes(v);
  })) && (m = Jr);
  var h = e.reduce(function(v, b) {
    var x = Kfe(Xt.cssPrefix, b);
    if (gh[b] ? (b = Wfe[m].includes(b) ? xfe[m][b] : b, f = b, v.prefix = b) : qfe[m].indexOf(b) > -1 ? (f = b, v.prefix = Ax(b, {
      family: m
    })) : x ? v.iconName = x : b !== Xt.replacementClass && b !== c[Ir] && b !== c[Jr] && v.rest.push(b), !s && v.prefix && v.iconName) {
      var E = f === "fa" ? A5(v.iconName) : {}, T = Gf(v.prefix, v.iconName);
      E.prefix && (f = null), v.iconName = E.iconName || T || v.iconName, v.prefix = E.prefix || v.prefix, v.prefix === "far" && !gh.far && gh.fas && !Xt.autoFetchSvg && (v.prefix = "fas");
    }
    return v;
  }, IP());
  return (e.includes("fa-brands") || e.includes("fab")) && (h.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (h.prefix = "fad"), !h.prefix && m === Jr && (gh.fass || Xt.autoFetchSvg) && (h.prefix = "fass", h.iconName = Gf(h.prefix, h.iconName) || h.iconName), (h.prefix === "fa" || f === "fa") && (h.prefix = hd() || "fas"), h;
}
var Zfe = /* @__PURE__ */ function() {
  function e() {
    ufe(this, e), this.definitions = {};
  }
  return dfe(e, [{
    key: "add",
    value: function() {
      for (var o = this, i = arguments.length, s = new Array(i), c = 0; c < i; c++)
        s[c] = arguments[c];
      var f = s.reduce(this._pullDefinitions, {});
      Object.keys(f).forEach(function(m) {
        o.definitions[m] = zt(zt({}, o.definitions[m] || {}), f[m]), WR(m, f[m]);
        var h = sy[Ir][m];
        h && WR(h, f[m]), _5();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(o, i) {
      var s = i.prefix && i.iconName && i.icon ? {
        0: i
      } : i;
      return Object.keys(s).map(function(c) {
        var f = s[c], m = f.prefix, h = f.iconName, v = f.icon, b = v[2];
        o[m] || (o[m] = {}), b.length > 0 && b.forEach(function(x) {
          typeof x == "string" && (o[m][x] = v);
        }), o[m][h] = v;
      }), o;
    }
  }]), e;
}(), q_ = [], vh = {}, Oh = {}, Jfe = Object.keys(Oh);
function epe(e, t) {
  var o = t.mixoutsTo;
  return q_ = e, vh = {}, Object.keys(Oh).forEach(function(i) {
    Jfe.indexOf(i) === -1 && delete Oh[i];
  }), q_.forEach(function(i) {
    var s = i.mixout ? i.mixout() : {};
    if (Object.keys(s).forEach(function(f) {
      typeof s[f] == "function" && (o[f] = s[f]), U1(s[f]) === "object" && Object.keys(s[f]).forEach(function(m) {
        o[f] || (o[f] = {}), o[f][m] = s[f][m];
      });
    }), i.hooks) {
      var c = i.hooks();
      Object.keys(c).forEach(function(f) {
        vh[f] || (vh[f] = []), vh[f].push(c[f]);
      });
    }
    i.provides && i.provides(Oh);
  }), o;
}
function qR(e, t) {
  for (var o = arguments.length, i = new Array(o > 2 ? o - 2 : 0), s = 2; s < o; s++)
    i[s - 2] = arguments[s];
  var c = vh[e] || [];
  return c.forEach(function(f) {
    t = f.apply(null, [t].concat(i));
  }), t;
}
function rp(e) {
  for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    o[i - 1] = arguments[i];
  var s = vh[e] || [];
  s.forEach(function(c) {
    c.apply(null, o);
  });
}
function Wc() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Oh[e] ? Oh[e].apply(null, t) : void 0;
}
function YR(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, o = e.prefix || hd();
  if (t)
    return t = Gf(o, t) || t, U_(L5.definitions, o, t) || U_(jl.styles, o, t);
}
var L5 = new Zfe(), tpe = function() {
  Xt.autoReplaceSvg = !1, Xt.observeMutations = !1, rp("noAuto");
}, npe = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Kc ? (rp("beforeI2svg", t), Wc("pseudoElements2svg", t), Wc("i2svg", t)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = t.autoReplaceSvgRoot;
    Xt.autoReplaceSvg === !1 && (Xt.autoReplaceSvg = !0), Xt.observeMutations = !0, Bfe(function() {
      ope({
        autoReplaceSvgRoot: o
      }), rp("watch", t);
    });
  }
}, rpe = {
  icon: function(t) {
    if (t === null)
      return null;
    if (U1(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: Gf(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var o = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], i = Ax(t[0]);
      return {
        prefix: i,
        iconName: Gf(i, o) || o
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(Xt.cssPrefix, "-")) > -1 || t.match(wfe))) {
      var s = Lx(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: s.prefix || hd(),
        iconName: Gf(s.prefix, s.iconName) || s.iconName
      };
    }
    if (typeof t == "string") {
      var c = hd();
      return {
        prefix: c,
        iconName: Gf(c, t) || t
      };
    }
  }
}, Fi = {
  noAuto: tpe,
  config: Xt,
  dom: npe,
  parse: rpe,
  library: L5,
  findIconDefinition: YR,
  toHtml: $y
}, ope = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = t.autoReplaceSvgRoot, i = o === void 0 ? Nr : o;
  (Object.keys(jl.styles).length > 0 || Xt.autoFetchSvg) && Kc && Xt.autoReplaceSvg && Fi.dom.i2svg({
    node: i
  });
};
function Fx(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(i) {
        return $y(i);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (Kc) {
        var i = Nr.createElement("div");
        return i.innerHTML = e.html, i.children;
      }
    }
  }), e;
}
function ape(e) {
  var t = e.children, o = e.main, i = e.mask, s = e.attributes, c = e.styles, f = e.transform;
  if (kP(f) && o.found && !i.found) {
    var m = o.width, h = o.height, v = {
      x: m / h / 2,
      y: 0.5
    };
    s.style = _x(zt(zt({}, c), {}, {
      "transform-origin": "".concat(v.x + f.x / 16, "em ").concat(v.y + f.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function ipe(e) {
  var t = e.prefix, o = e.iconName, i = e.children, s = e.attributes, c = e.symbol, f = c === !0 ? "".concat(t, "-").concat(Xt.cssPrefix, "-").concat(o) : c;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: zt(zt({}, s), {}, {
        id: f
      }),
      children: i
    }]
  }];
}
function NP(e) {
  var t = e.icons, o = t.main, i = t.mask, s = e.prefix, c = e.iconName, f = e.transform, m = e.symbol, h = e.title, v = e.maskId, b = e.titleId, x = e.extra, E = e.watchable, T = E === void 0 ? !1 : E, P = i.found ? i : o, O = P.width, k = P.height, I = s === "fak", $ = [Xt.replacementClass, c ? "".concat(Xt.cssPrefix, "-").concat(c) : ""].filter(function(Y) {
    return x.classes.indexOf(Y) === -1;
  }).filter(function(Y) {
    return Y !== "" || !!Y;
  }).concat(x.classes).join(" "), _ = {
    children: [],
    attributes: zt(zt({}, x.attributes), {}, {
      "data-prefix": s,
      "data-icon": c,
      class: $,
      role: x.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(O, " ").concat(k)
    })
  }, z = I && !~x.classes.indexOf("fa-fw") ? {
    width: "".concat(O / k * 16 * 0.0625, "em")
  } : {};
  T && (_.attributes[np] = ""), h && (_.children.push({
    tag: "title",
    attributes: {
      id: _.attributes["aria-labelledby"] || "title-".concat(b || uy())
    },
    children: [h]
  }), delete _.attributes.title);
  var V = zt(zt({}, _), {}, {
    prefix: s,
    iconName: c,
    main: o,
    mask: i,
    maskId: v,
    transform: f,
    symbol: m,
    styles: zt(zt({}, z), x.styles)
  }), M = i.found && o.found ? Wc("generateAbstractMask", V) || {
    children: [],
    attributes: {}
  } : Wc("generateAbstractIcon", V) || {
    children: [],
    attributes: {}
  }, A = M.children, W = M.attributes;
  return V.children = A, V.attributes = W, m ? ipe(V) : ape(V);
}
function Y_(e) {
  var t = e.content, o = e.width, i = e.height, s = e.transform, c = e.title, f = e.extra, m = e.watchable, h = m === void 0 ? !1 : m, v = zt(zt(zt({}, f.attributes), c ? {
    title: c
  } : {}), {}, {
    class: f.classes.join(" ")
  });
  h && (v[np] = "");
  var b = zt({}, f.styles);
  kP(s) && (b.transform = Lfe({
    transform: s,
    startCentered: !0,
    width: o,
    height: i
  }), b["-webkit-transform"] = b.transform);
  var x = _x(b);
  x.length > 0 && (v.style = x);
  var E = [];
  return E.push({
    tag: "span",
    attributes: v,
    children: [t]
  }), c && E.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [c]
  }), E;
}
function lpe(e) {
  var t = e.content, o = e.title, i = e.extra, s = zt(zt(zt({}, i.attributes), o ? {
    title: o
  } : {}), {}, {
    class: i.classes.join(" ")
  }), c = _x(i.styles);
  c.length > 0 && (s.style = c);
  var f = [];
  return f.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), o && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), f;
}
var cR = jl.styles;
function KR(e) {
  var t = e[0], o = e[1], i = e.slice(4), s = xP(i, 1), c = s[0], f = null;
  return Array.isArray(c) ? f = {
    tag: "g",
    attributes: {
      class: "".concat(Xt.cssPrefix, "-").concat(Uf.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Xt.cssPrefix, "-").concat(Uf.SECONDARY),
        fill: "currentColor",
        d: c[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Xt.cssPrefix, "-").concat(Uf.PRIMARY),
        fill: "currentColor",
        d: c[1]
      }
    }]
  } : f = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: c
    }
  }, {
    found: !0,
    width: t,
    height: o,
    icon: f
  };
}
var spe = {
  found: !1,
  width: 512,
  height: 512
};
function cpe(e, t) {
  !w5 && !Xt.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function XR(e, t) {
  var o = t;
  return t === "fa" && Xt.styleDefault !== null && (t = hd()), new Promise(function(i, s) {
    if (Wc("missingIconAbstract"), o === "fa") {
      var c = A5(e) || {};
      e = c.iconName || e, t = c.prefix || t;
    }
    if (e && t && cR[t] && cR[t][e]) {
      var f = cR[t][e];
      return i(KR(f));
    }
    cpe(e, t), i(zt(zt({}, spe), {}, {
      icon: Xt.showMissingIcons && e ? Wc("missingIconAbstract") || {} : {}
    }));
  });
}
var K_ = function() {
}, QR = Xt.measurePerformance && o1 && o1.mark && o1.measure ? o1 : {
  mark: K_,
  measure: K_
}, Lb = 'FA "6.4.2"', upe = function(t) {
  return QR.mark("".concat(Lb, " ").concat(t, " begins")), function() {
    return F5(t);
  };
}, F5 = function(t) {
  QR.mark("".concat(Lb, " ").concat(t, " ends")), QR.measure("".concat(Lb, " ").concat(t), "".concat(Lb, " ").concat(t, " begins"), "".concat(Lb, " ").concat(t, " ends"));
}, $P = {
  begin: upe,
  end: F5
}, S1 = function() {
};
function X_(e) {
  var t = e.getAttribute ? e.getAttribute(np) : null;
  return typeof t == "string";
}
function dpe(e) {
  var t = e.getAttribute ? e.getAttribute(EP) : null, o = e.getAttribute ? e.getAttribute(TP) : null;
  return t && o;
}
function fpe(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Xt.replacementClass);
}
function ppe() {
  if (Xt.autoReplaceSvg === !0)
    return x1.replace;
  var e = x1[Xt.autoReplaceSvg];
  return e || x1.replace;
}
function mpe(e) {
  return Nr.createElementNS("http://www.w3.org/2000/svg", e);
}
function hpe(e) {
  return Nr.createElement(e);
}
function z5(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = t.ceFn, i = o === void 0 ? e.tag === "svg" ? mpe : hpe : o;
  if (typeof e == "string")
    return Nr.createTextNode(e);
  var s = i(e.tag);
  Object.keys(e.attributes || []).forEach(function(f) {
    s.setAttribute(f, e.attributes[f]);
  });
  var c = e.children || [];
  return c.forEach(function(f) {
    s.appendChild(z5(f, {
      ceFn: i
    }));
  }), s;
}
function gpe(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var x1 = {
  replace: function(t) {
    var o = t[0];
    if (o.parentNode)
      if (t[1].forEach(function(s) {
        o.parentNode.insertBefore(z5(s), o);
      }), o.getAttribute(np) === null && Xt.keepOriginalSource) {
        var i = Nr.createComment(gpe(o));
        o.parentNode.replaceChild(i, o);
      } else
        o.remove();
  },
  nest: function(t) {
    var o = t[0], i = t[1];
    if (~RP(o).indexOf(Xt.replacementClass))
      return x1.replace(t);
    var s = new RegExp("".concat(Xt.cssPrefix, "-.*"));
    if (delete i[0].attributes.id, i[0].attributes.class) {
      var c = i[0].attributes.class.split(" ").reduce(function(m, h) {
        return h === Xt.replacementClass || h.match(s) ? m.toSvg.push(h) : m.toNode.push(h), m;
      }, {
        toNode: [],
        toSvg: []
      });
      i[0].attributes.class = c.toSvg.join(" "), c.toNode.length === 0 ? o.removeAttribute("class") : o.setAttribute("class", c.toNode.join(" "));
    }
    var f = i.map(function(m) {
      return $y(m);
    }).join(`
`);
    o.setAttribute(np, ""), o.innerHTML = f;
  }
};
function Q_(e) {
  e();
}
function V5(e, t) {
  var o = typeof t == "function" ? t : S1;
  if (e.length === 0)
    o();
  else {
    var i = Q_;
    Xt.mutateApproach === Cfe && (i = md.requestAnimationFrame || Q_), i(function() {
      var s = ppe(), c = $P.begin("mutate");
      e.map(s), c(), o();
    });
  }
}
var DP = !1;
function B5() {
  DP = !0;
}
function ZR() {
  DP = !1;
}
var W1 = null;
function Z_(e) {
  if (B_ && Xt.observeMutations) {
    var t = e.treeCallback, o = t === void 0 ? S1 : t, i = e.nodeCallback, s = i === void 0 ? S1 : i, c = e.pseudoElementsCallback, f = c === void 0 ? S1 : c, m = e.observeMutationsRoot, h = m === void 0 ? Nr : m;
    W1 = new B_(function(v) {
      if (!DP) {
        var b = hd();
        Yh(v).forEach(function(x) {
          if (x.type === "childList" && x.addedNodes.length > 0 && !X_(x.addedNodes[0]) && (Xt.searchPseudoElements && f(x.target), o(x.target)), x.type === "attributes" && x.target.parentNode && Xt.searchPseudoElements && f(x.target.parentNode), x.type === "attributes" && X_(x.target) && ~Rfe.indexOf(x.attributeName))
            if (x.attributeName === "class" && dpe(x.target)) {
              var E = Lx(RP(x.target)), T = E.prefix, P = E.iconName;
              x.target.setAttribute(EP, T || b), P && x.target.setAttribute(TP, P);
            } else
              fpe(x.target) && s(x.target);
        });
      }
    }), Kc && W1.observe(h, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function vpe() {
  W1 && W1.disconnect();
}
function bpe(e) {
  var t = e.getAttribute("style"), o = [];
  return t && (o = t.split(";").reduce(function(i, s) {
    var c = s.split(":"), f = c[0], m = c.slice(1);
    return f && m.length > 0 && (i[f] = m.join(":").trim()), i;
  }, {})), o;
}
function ype(e) {
  var t = e.getAttribute("data-prefix"), o = e.getAttribute("data-icon"), i = e.innerText !== void 0 ? e.innerText.trim() : "", s = Lx(RP(e));
  return s.prefix || (s.prefix = hd()), t && o && (s.prefix = t, s.iconName = o), s.iconName && s.prefix || (s.prefix && i.length > 0 && (s.iconName = Xfe(s.prefix, e.innerText) || MP(s.prefix, GR(e.innerText))), !s.iconName && Xt.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function Cpe(e) {
  var t = Yh(e.attributes).reduce(function(s, c) {
    return s.name !== "class" && s.name !== "style" && (s[c.name] = c.value), s;
  }, {}), o = e.getAttribute("title"), i = e.getAttribute("data-fa-title-id");
  return Xt.autoA11y && (o ? t["aria-labelledby"] = "".concat(Xt.replacementClass, "-title-").concat(i || uy()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Spe() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ls,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function J_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, o = ype(e), i = o.iconName, s = o.prefix, c = o.rest, f = Cpe(e), m = qR("parseNodeAttributes", {}, e), h = t.styleParser ? bpe(e) : [];
  return zt({
    iconName: i,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: s,
    transform: Ls,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: c,
      styles: h,
      attributes: f
    }
  }, m);
}
var xpe = jl.styles;
function j5(e) {
  var t = Xt.autoReplaceSvg === "nest" ? J_(e, {
    styleParser: !1
  }) : J_(e);
  return ~t.extra.classes.indexOf(E5) ? Wc("generateLayersText", e, t) : Wc("generateSvgReplacementMutation", e, t);
}
var gd = /* @__PURE__ */ new Set();
OP.map(function(e) {
  gd.add("fa-".concat(e));
});
Object.keys(iy[Ir]).map(gd.add.bind(gd));
Object.keys(iy[Jr]).map(gd.add.bind(gd));
gd = Iy(gd);
function eA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Kc)
    return Promise.resolve();
  var o = Nr.documentElement.classList, i = function(x) {
    return o.add("".concat(j_, "-").concat(x));
  }, s = function(x) {
    return o.remove("".concat(j_, "-").concat(x));
  }, c = Xt.autoFetchSvg ? gd : OP.map(function(b) {
    return "fa-".concat(b);
  }).concat(Object.keys(xpe));
  c.includes("fa") || c.push("fa");
  var f = [".".concat(E5, ":not([").concat(np, "])")].concat(c.map(function(b) {
    return ".".concat(b, ":not([").concat(np, "])");
  })).join(", ");
  if (f.length === 0)
    return Promise.resolve();
  var m = [];
  try {
    m = Yh(e.querySelectorAll(f));
  } catch {
  }
  if (m.length > 0)
    i("pending"), s("complete");
  else
    return Promise.resolve();
  var h = $P.begin("onTree"), v = m.reduce(function(b, x) {
    try {
      var E = j5(x);
      E && b.push(E);
    } catch (T) {
      w5 || T.name === "MissingIcon" && console.error(T);
    }
    return b;
  }, []);
  return new Promise(function(b, x) {
    Promise.all(v).then(function(E) {
      V5(E, function() {
        i("active"), i("complete"), s("pending"), typeof t == "function" && t(), h(), b();
      });
    }).catch(function(E) {
      h(), x(E);
    });
  });
}
function wpe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  j5(e).then(function(o) {
    o && V5([o], t);
  });
}
function Epe(e) {
  return function(t) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = (t || {}).icon ? t : YR(t || {}), s = o.mask;
    return s && (s = (s || {}).icon ? s : YR(s || {})), e(i, zt(zt({}, o), {}, {
      mask: s
    }));
  };
}
var Tpe = function(t) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = o.transform, s = i === void 0 ? Ls : i, c = o.symbol, f = c === void 0 ? !1 : c, m = o.mask, h = m === void 0 ? null : m, v = o.maskId, b = v === void 0 ? null : v, x = o.title, E = x === void 0 ? null : x, T = o.titleId, P = T === void 0 ? null : T, O = o.classes, k = O === void 0 ? [] : O, I = o.attributes, $ = I === void 0 ? {} : I, _ = o.styles, z = _ === void 0 ? {} : _;
  if (t) {
    var V = t.prefix, M = t.iconName, A = t.icon;
    return Fx(zt({
      type: "icon"
    }, t), function() {
      return rp("beforeDOMElementCreation", {
        iconDefinition: t,
        params: o
      }), Xt.autoA11y && (E ? $["aria-labelledby"] = "".concat(Xt.replacementClass, "-title-").concat(P || uy()) : ($["aria-hidden"] = "true", $.focusable = "false")), NP({
        icons: {
          main: KR(A),
          mask: h ? KR(h.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: V,
        iconName: M,
        transform: zt(zt({}, Ls), s),
        symbol: f,
        title: E,
        maskId: b,
        titleId: P,
        extra: {
          attributes: $,
          styles: z,
          classes: k
        }
      });
    });
  }
}, Ope = {
  mixout: function() {
    return {
      icon: Epe(Tpe)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(o) {
        return o.treeCallback = eA, o.nodeCallback = wpe, o;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(o) {
      var i = o.node, s = i === void 0 ? Nr : i, c = o.callback, f = c === void 0 ? function() {
      } : c;
      return eA(s, f);
    }, t.generateSvgReplacementMutation = function(o, i) {
      var s = i.iconName, c = i.title, f = i.titleId, m = i.prefix, h = i.transform, v = i.symbol, b = i.mask, x = i.maskId, E = i.extra;
      return new Promise(function(T, P) {
        Promise.all([XR(s, m), b.iconName ? XR(b.iconName, b.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(O) {
          var k = xP(O, 2), I = k[0], $ = k[1];
          T([o, NP({
            icons: {
              main: I,
              mask: $
            },
            prefix: m,
            iconName: s,
            transform: h,
            symbol: v,
            maskId: x,
            title: c,
            titleId: f,
            extra: E,
            watchable: !0
          })]);
        }).catch(P);
      });
    }, t.generateAbstractIcon = function(o) {
      var i = o.children, s = o.attributes, c = o.main, f = o.transform, m = o.styles, h = _x(m);
      h.length > 0 && (s.style = h);
      var v;
      return kP(f) && (v = Wc("generateAbstractTransformGrouping", {
        main: c,
        transform: f,
        containerWidth: c.width,
        iconWidth: c.width
      })), i.push(v || c.icon), {
        children: i,
        attributes: s
      };
    };
  }
}, Rpe = {
  mixout: function() {
    return {
      layer: function(o) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = i.classes, c = s === void 0 ? [] : s;
        return Fx({
          type: "layer"
        }, function() {
          rp("beforeDOMElementCreation", {
            assembler: o,
            params: i
          });
          var f = [];
          return o(function(m) {
            Array.isArray(m) ? m.map(function(h) {
              f = f.concat(h.abstract);
            }) : f = f.concat(m.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Xt.cssPrefix, "-layers")].concat(Iy(c)).join(" ")
            },
            children: f
          }];
        });
      }
    };
  }
}, kpe = {
  mixout: function() {
    return {
      counter: function(o) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = i.title, c = s === void 0 ? null : s, f = i.classes, m = f === void 0 ? [] : f, h = i.attributes, v = h === void 0 ? {} : h, b = i.styles, x = b === void 0 ? {} : b;
        return Fx({
          type: "counter",
          content: o
        }, function() {
          return rp("beforeDOMElementCreation", {
            content: o,
            params: i
          }), lpe({
            content: o.toString(),
            title: c,
            extra: {
              attributes: v,
              styles: x,
              classes: ["".concat(Xt.cssPrefix, "-layers-counter")].concat(Iy(m))
            }
          });
        });
      }
    };
  }
}, Ppe = {
  mixout: function() {
    return {
      text: function(o) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = i.transform, c = s === void 0 ? Ls : s, f = i.title, m = f === void 0 ? null : f, h = i.classes, v = h === void 0 ? [] : h, b = i.attributes, x = b === void 0 ? {} : b, E = i.styles, T = E === void 0 ? {} : E;
        return Fx({
          type: "text",
          content: o
        }, function() {
          return rp("beforeDOMElementCreation", {
            content: o,
            params: i
          }), Y_({
            content: o,
            transform: zt(zt({}, Ls), c),
            title: m,
            extra: {
              attributes: x,
              styles: T,
              classes: ["".concat(Xt.cssPrefix, "-layers-text")].concat(Iy(v))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(o, i) {
      var s = i.title, c = i.transform, f = i.extra, m = null, h = null;
      if (C5) {
        var v = parseInt(getComputedStyle(o).fontSize, 10), b = o.getBoundingClientRect();
        m = b.width / v, h = b.height / v;
      }
      return Xt.autoA11y && !s && (f.attributes["aria-hidden"] = "true"), Promise.resolve([o, Y_({
        content: o.innerHTML,
        width: m,
        height: h,
        transform: c,
        title: s,
        extra: f,
        watchable: !0
      })]);
    };
  }
}, Mpe = new RegExp('"', "ug"), tA = [1105920, 1112319];
function Ipe(e) {
  var t = e.replace(Mpe, ""), o = Ufe(t, 0), i = o >= tA[0] && o <= tA[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: GR(s ? t[0] : t),
    isSecondary: i || s
  };
}
function nA(e, t) {
  var o = "".concat(yfe).concat(t.replace(":", "-"));
  return new Promise(function(i, s) {
    if (e.getAttribute(o) !== null)
      return i();
    var c = Yh(e.children), f = c.filter(function(A) {
      return A.getAttribute(UR) === t;
    })[0], m = md.getComputedStyle(e, t), h = m.getPropertyValue("font-family").match(Efe), v = m.getPropertyValue("font-weight"), b = m.getPropertyValue("content");
    if (f && !h)
      return e.removeChild(f), i();
    if (h && b !== "none" && b !== "") {
      var x = m.getPropertyValue("content"), E = ~["Sharp"].indexOf(h[2]) ? Jr : Ir, T = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(h[2]) ? ly[E][h[2].toLowerCase()] : Tfe[E][v], P = Ipe(x), O = P.value, k = P.isSecondary, I = h[0].startsWith("FontAwesome"), $ = MP(T, O), _ = $;
      if (I) {
        var z = Qfe(O);
        z.iconName && z.prefix && ($ = z.iconName, T = z.prefix);
      }
      if ($ && !k && (!f || f.getAttribute(EP) !== T || f.getAttribute(TP) !== _)) {
        e.setAttribute(o, _), f && e.removeChild(f);
        var V = Spe(), M = V.extra;
        M.attributes[UR] = t, XR($, T).then(function(A) {
          var W = NP(zt(zt({}, V), {}, {
            icons: {
              main: A,
              mask: IP()
            },
            prefix: T,
            iconName: _,
            extra: M,
            watchable: !0
          })), Y = Nr.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(Y, e.firstChild) : e.appendChild(Y), Y.outerHTML = W.map(function(H) {
            return $y(H);
          }).join(`
`), e.removeAttribute(o), i();
        }).catch(s);
      } else
        i();
    } else
      i();
  });
}
function Npe(e) {
  return Promise.all([nA(e, "::before"), nA(e, "::after")]);
}
function $pe(e) {
  return e.parentNode !== document.head && !~Sfe.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(UR) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function rA(e) {
  if (Kc)
    return new Promise(function(t, o) {
      var i = Yh(e.querySelectorAll("*")).filter($pe).map(Npe), s = $P.begin("searchPseudoElements");
      B5(), Promise.all(i).then(function() {
        s(), ZR(), t();
      }).catch(function() {
        s(), ZR(), o();
      });
    });
}
var Dpe = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(o) {
        return o.pseudoElementsCallback = rA, o;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(o) {
      var i = o.node, s = i === void 0 ? Nr : i;
      Xt.searchPseudoElements && rA(s);
    };
  }
}, oA = !1, _pe = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          B5(), oA = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        Z_(qR("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        vpe();
      },
      watch: function(o) {
        var i = o.observeMutationsRoot;
        oA ? ZR() : Z_(qR("mutationObserverCallbacks", {
          observeMutationsRoot: i
        }));
      }
    };
  }
}, aA = function(t) {
  var o = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(i, s) {
    var c = s.toLowerCase().split("-"), f = c[0], m = c.slice(1).join("-");
    if (f && m === "h")
      return i.flipX = !0, i;
    if (f && m === "v")
      return i.flipY = !0, i;
    if (m = parseFloat(m), isNaN(m))
      return i;
    switch (f) {
      case "grow":
        i.size = i.size + m;
        break;
      case "shrink":
        i.size = i.size - m;
        break;
      case "left":
        i.x = i.x - m;
        break;
      case "right":
        i.x = i.x + m;
        break;
      case "up":
        i.y = i.y - m;
        break;
      case "down":
        i.y = i.y + m;
        break;
      case "rotate":
        i.rotate = i.rotate + m;
        break;
    }
    return i;
  }, o);
}, Ape = {
  mixout: function() {
    return {
      parse: {
        transform: function(o) {
          return aA(o);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(o, i) {
        var s = i.getAttribute("data-fa-transform");
        return s && (o.transform = aA(s)), o;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(o) {
      var i = o.main, s = o.transform, c = o.containerWidth, f = o.iconWidth, m = {
        transform: "translate(".concat(c / 2, " 256)")
      }, h = "translate(".concat(s.x * 32, ", ").concat(s.y * 32, ") "), v = "scale(".concat(s.size / 16 * (s.flipX ? -1 : 1), ", ").concat(s.size / 16 * (s.flipY ? -1 : 1), ") "), b = "rotate(".concat(s.rotate, " 0 0)"), x = {
        transform: "".concat(h, " ").concat(v, " ").concat(b)
      }, E = {
        transform: "translate(".concat(f / 2 * -1, " -256)")
      }, T = {
        outer: m,
        inner: x,
        path: E
      };
      return {
        tag: "g",
        attributes: zt({}, T.outer),
        children: [{
          tag: "g",
          attributes: zt({}, T.inner),
          children: [{
            tag: i.icon.tag,
            children: i.icon.children,
            attributes: zt(zt({}, i.icon.attributes), T.path)
          }]
        }]
      };
    };
  }
}, uR = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function iA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function Lpe(e) {
  return e.tag === "g" ? e.children : [e];
}
var Fpe = {
  hooks: function() {
    return {
      parseNodeAttributes: function(o, i) {
        var s = i.getAttribute("data-fa-mask"), c = s ? Lx(s.split(" ").map(function(f) {
          return f.trim();
        })) : IP();
        return c.prefix || (c.prefix = hd()), o.mask = c, o.maskId = i.getAttribute("data-fa-mask-id"), o;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(o) {
      var i = o.children, s = o.attributes, c = o.main, f = o.mask, m = o.maskId, h = o.transform, v = c.width, b = c.icon, x = f.width, E = f.icon, T = Afe({
        transform: h,
        containerWidth: x,
        iconWidth: v
      }), P = {
        tag: "rect",
        attributes: zt(zt({}, uR), {}, {
          fill: "white"
        })
      }, O = b.children ? {
        children: b.children.map(iA)
      } : {}, k = {
        tag: "g",
        attributes: zt({}, T.inner),
        children: [iA(zt({
          tag: b.tag,
          attributes: zt(zt({}, b.attributes), T.path)
        }, O))]
      }, I = {
        tag: "g",
        attributes: zt({}, T.outer),
        children: [k]
      }, $ = "mask-".concat(m || uy()), _ = "clip-".concat(m || uy()), z = {
        tag: "mask",
        attributes: zt(zt({}, uR), {}, {
          id: $,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [P, I]
      }, V = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: _
          },
          children: Lpe(E)
        }, z]
      };
      return i.push(V, {
        tag: "rect",
        attributes: zt({
          fill: "currentColor",
          "clip-path": "url(#".concat(_, ")"),
          mask: "url(#".concat($, ")")
        }, uR)
      }), {
        children: i,
        attributes: s
      };
    };
  }
}, zpe = {
  provides: function(t) {
    var o = !1;
    md.matchMedia && (o = md.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var i = [], s = {
        fill: "currentColor"
      }, c = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      i.push({
        tag: "path",
        attributes: zt(zt({}, s), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var f = zt(zt({}, c), {}, {
        attributeName: "opacity"
      }), m = {
        tag: "circle",
        attributes: zt(zt({}, s), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return o || m.children.push({
        tag: "animate",
        attributes: zt(zt({}, c), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: zt(zt({}, f), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), i.push(m), i.push({
        tag: "path",
        attributes: zt(zt({}, s), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: o ? [] : [{
          tag: "animate",
          attributes: zt(zt({}, f), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), o || i.push({
        tag: "path",
        attributes: zt(zt({}, s), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: zt(zt({}, f), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: i
      };
    };
  }
}, Vpe = {
  hooks: function() {
    return {
      parseNodeAttributes: function(o, i) {
        var s = i.getAttribute("data-fa-symbol"), c = s === null ? !1 : s === "" ? !0 : s;
        return o.symbol = c, o;
      }
    };
  }
}, Bpe = [zfe, Ope, Rpe, kpe, Ppe, Dpe, _pe, Ape, Fpe, zpe, Vpe];
epe(Bpe, {
  mixoutsTo: Fi
});
Fi.noAuto;
Fi.config;
Fi.library;
Fi.dom;
var JR = Fi.parse;
Fi.findIconDefinition;
Fi.toHtml;
var jpe = Fi.icon;
Fi.layer;
Fi.text;
Fi.counter;
function lA(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), o.push.apply(o, i);
  }
  return o;
}
function cd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lA(Object(o), !0).forEach(function(i) {
      bh(e, i, o[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : lA(Object(o)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(o, i));
    });
  }
  return e;
}
function q1(e) {
  "@babel/helpers - typeof";
  return q1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, q1(e);
}
function bh(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function Hpe(e, t) {
  if (e == null)
    return {};
  var o = {}, i = Object.keys(e), s, c;
  for (c = 0; c < i.length; c++)
    s = i[c], !(t.indexOf(s) >= 0) && (o[s] = e[s]);
  return o;
}
function Upe(e, t) {
  if (e == null)
    return {};
  var o = Hpe(e, t), i, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (s = 0; s < c.length; s++)
      i = c[s], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (o[i] = e[i]);
  }
  return o;
}
function ek(e) {
  return Gpe(e) || Wpe(e) || qpe(e) || Ype();
}
function Gpe(e) {
  if (Array.isArray(e))
    return tk(e);
}
function Wpe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function qpe(e, t) {
  if (e) {
    if (typeof e == "string")
      return tk(e, t);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
      return Array.from(e);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return tk(e, t);
  }
}
function tk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var o = 0, i = new Array(t); o < t; o++)
    i[o] = e[o];
  return i;
}
function Ype() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kpe(e) {
  var t, o = e.beat, i = e.fade, s = e.beatFade, c = e.bounce, f = e.shake, m = e.flash, h = e.spin, v = e.spinPulse, b = e.spinReverse, x = e.pulse, E = e.fixedWidth, T = e.inverse, P = e.border, O = e.listItem, k = e.flip, I = e.size, $ = e.rotation, _ = e.pull, z = (t = {
    "fa-beat": o,
    "fa-fade": i,
    "fa-beat-fade": s,
    "fa-bounce": c,
    "fa-shake": f,
    "fa-flash": m,
    "fa-spin": h,
    "fa-spin-reverse": b,
    "fa-spin-pulse": v,
    "fa-pulse": x,
    "fa-fw": E,
    "fa-inverse": T,
    "fa-border": P,
    "fa-li": O,
    "fa-flip": k === !0,
    "fa-flip-horizontal": k === "horizontal" || k === "both",
    "fa-flip-vertical": k === "vertical" || k === "both"
  }, bh(t, "fa-".concat(I), typeof I < "u" && I !== null), bh(t, "fa-rotate-".concat($), typeof $ < "u" && $ !== null && $ !== 0), bh(t, "fa-pull-".concat(_), typeof _ < "u" && _ !== null), bh(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(z).map(function(V) {
    return z[V] ? V : null;
  }).filter(function(V) {
    return V;
  });
}
function Xpe(e) {
  return e = e - 0, e === e;
}
function H5(e) {
  return Xpe(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, o) {
    return o ? o.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var Qpe = ["style"];
function Zpe(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Jpe(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, o) {
    var i = o.indexOf(":"), s = H5(o.slice(0, i)), c = o.slice(i + 1).trim();
    return s.startsWith("webkit") ? t[Zpe(s)] = c : t[s] = c, t;
  }, {});
}
function U5(e, t) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var i = (t.children || []).map(function(h) {
    return U5(e, h);
  }), s = Object.keys(t.attributes || {}).reduce(function(h, v) {
    var b = t.attributes[v];
    switch (v) {
      case "class":
        h.attrs.className = b, delete t.attributes.class;
        break;
      case "style":
        h.attrs.style = Jpe(b);
        break;
      default:
        v.indexOf("aria-") === 0 || v.indexOf("data-") === 0 ? h.attrs[v.toLowerCase()] = b : h.attrs[H5(v)] = b;
    }
    return h;
  }, {
    attrs: {}
  }), c = o.style, f = c === void 0 ? {} : c, m = Upe(o, Qpe);
  return s.attrs.style = cd(cd({}, s.attrs.style), f), e.apply(void 0, [t.tag, cd(cd({}, s.attrs), m)].concat(ek(i)));
}
var G5 = !1;
try {
  G5 = process.env.NODE_ENV === "production";
} catch {
}
function eme() {
  if (!G5 && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function sA(e) {
  if (e && q1(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (JR.icon)
    return JR.icon(e);
  if (e === null)
    return null;
  if (e && q1(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function dR(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? bh({}, e, t) : {};
}
var yo = /* @__PURE__ */ Ha.forwardRef(function(e, t) {
  var o = e.icon, i = e.mask, s = e.symbol, c = e.className, f = e.title, m = e.titleId, h = e.maskId, v = sA(o), b = dR("classes", [].concat(ek(Kpe(e)), ek(c.split(" ")))), x = dR("transform", typeof e.transform == "string" ? JR.transform(e.transform) : e.transform), E = dR("mask", sA(i)), T = jpe(v, cd(cd(cd(cd({}, b), x), E), {}, {
    symbol: s,
    title: f,
    titleId: m,
    maskId: h
  }));
  if (!T)
    return eme("Could not find icon", v), null;
  var P = T.abstract, O = {
    ref: t
  };
  return Object.keys(e).forEach(function(k) {
    yo.defaultProps.hasOwnProperty(k) || (O[k] = e[k]);
  }), tme(P[0], O);
});
yo.displayName = "FontAwesomeIcon";
yo.propTypes = {
  beat: n.bool,
  border: n.bool,
  beatFade: n.bool,
  bounce: n.bool,
  className: n.string,
  fade: n.bool,
  flash: n.bool,
  mask: n.oneOfType([n.object, n.array, n.string]),
  maskId: n.string,
  fixedWidth: n.bool,
  inverse: n.bool,
  flip: n.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: n.oneOfType([n.object, n.array, n.string]),
  listItem: n.bool,
  pull: n.oneOf(["right", "left"]),
  pulse: n.bool,
  rotation: n.oneOf([0, 90, 180, 270]),
  shake: n.bool,
  size: n.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: n.bool,
  spinPulse: n.bool,
  spinReverse: n.bool,
  symbol: n.oneOfType([n.bool, n.string]),
  title: n.string,
  titleId: n.string,
  transform: n.oneOfType([n.string, n.object]),
  swapOpacity: n.bool
};
yo.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var tme = U5.bind(null, Ha.createElement), cA = {
  prefix: "fas",
  iconName: "sort-down",
  icon: [320, 512, ["sort-desc"], "f0dd", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
}, nme = {
  prefix: "fas",
  iconName: "square-minus",
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, rme = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, ome = rme, ame = {
  prefix: "fas",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, ime = {
  prefix: "fas",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
}, lme = {
  prefix: "fas",
  iconName: "table-columns",
  icon: [512, 512, ["columns"], "f0db", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"]
}, sme = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, cme = sme, ume = {
  prefix: "fas",
  iconName: "sort",
  icon: [320, 512, ["unsorted"], "f0dc", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"]
}, uA = {
  prefix: "fas",
  iconName: "sort-up",
  icon: [320, 512, ["sort-asc"], "f0de", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, dme = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, fme = dme, pme = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
}, mme = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, hme = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, gme = hme;
const Nxe = se((e) => /* @__PURE__ */ L(Gq, { disableGutters: !0, elevation: 0, square: !1, ...e }))`
  border: 1px solid ${({ theme: e }) => e.palette.divider};
  &:not(:last-child) {
    border-bottom: 0;
  }
  &:before {
    display: none;
  }
`, $xe = se((e) => /* @__PURE__ */ L(mY, { ...e, expandIcon: /* @__PURE__ */ L(yo, { icon: mme }) }))``, Dxe = se(CY)`
  border-top: 1px solid ${({ theme: e }) => e.palette.divider};
`, _xe = se((e) => /* @__PURE__ */ L(
  MK,
  {
    ...e,
    iconMapping: {
      success: /* @__PURE__ */ L(yo, { icon: cme }),
      warning: /* @__PURE__ */ L(yo, { icon: gme }),
      error: /* @__PURE__ */ L(yo, { icon: ome }),
      info: /* @__PURE__ */ L(yo, { icon: fme })
    },
    children: e.children
  }
))`
  border: 1px solid ${({ theme: e, color: t }) => e.palette[t ?? "primary"].dark};
`, Axe = (e) => /* @__PURE__ */ L(HK, { ...e, children: e.children }), vme = (e) => {
  const { variant: t = "contained", size: o = "medium", ...i } = e;
  return /* @__PURE__ */ L(KF, { sx: { textTransform: "unset" }, disableElevation: !0, disableRipple: !0, disableTouchRipple: !0, variant: t, size: o, ...i, children: e.children });
}, bme = se(vme)`
  border: 1px solid ${({ theme: e, color: t, disabled: o }) => o ? e.palette.grey[300] : e.palette[t ?? "primary"].dark};
  padding: ${({ size: e }) => ({ small: "4px 8px", medium: "6px 12px", large: "8px 16px" })[e ?? "medium"]};
  :hover {
    border-color: ${({ theme: e, color: t }) => Wl(e.palette[t ?? "primary"].dark, 1)};
  }
`, yme = (e) => /* @__PURE__ */ L(bme, { ...e, children: e.children }), Cme = hk(function(t, o) {
  const { color: i = "secondary", size: s = "medium", ...c } = t;
  return /* @__PURE__ */ L(As, { color: i, size: s, ...c, disableRipple: !0, ref: o });
}), Sme = se(Cme)`
  padding: 2px;
  :hover {
    color: ${({ theme: e, color: t = "secondary" }) => ql(e.palette[t ?? "secondary"].dark, 0.35)};
  }
`, Lxe = (e) => {
  const { underline: t = "hover", color: o = "primary", ...i } = e;
  return /* @__PURE__ */ L(Loe, { ...i, underline: t, color: o, children: e.children });
}, xme = (e) => {
  const { variant: t = "outlined", size: o = "small", label: i = null, ...s } = e;
  return /* @__PURE__ */ L(p5, { variant: t, size: o, label: i, ...s, children: e.children });
};
var wme = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
const Eme = hk(function(t, o) {
  const { iconSize: i, ...s } = t;
  return /* @__PURE__ */ L(
    az,
    {
      ref: o,
      disableRipple: !0,
      ...s,
      checkedIcon: /* @__PURE__ */ L(yo, { icon: ame, size: i }),
      icon: /* @__PURE__ */ L(yo, { icon: wme, size: i }),
      indeterminateIcon: /* @__PURE__ */ L(yo, { icon: nme, size: i })
    }
  );
}), dA = se(Eme)`
  color: ${({ theme: e }) => e.palette.divider};
`, Tme = (e) => ({
  palette: {
    mode: e,
    primary: {
      main: "#009775"
    },
    secondary: {
      main: "#495057"
    },
    error: {
      main: "#b91717"
    },
    warning: {
      main: "#bb8b06"
    },
    info: {
      main: "#309bb3"
    },
    success: {
      main: "#009775"
    },
    divider: "#ced4da"
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(",")
  }
}), W5 = T8({
  toggleColorMode: () => {
  }
}), Fxe = ({ children: e, disableCssBaseLine: t = !0 }) => {
  const [o, i] = O8("light"), s = j$(
    () => ({
      toggleColorMode: () => {
        i((f) => f === "light" ? "dark" : "light");
      }
    }),
    []
  ), c = j$(() => Jf(Tme(o)), [o]);
  return /* @__PURE__ */ L(W5.Provider, { value: s, children: /* @__PURE__ */ ht(tF, { theme: c, children: [
    t ? null : /* @__PURE__ */ L(uz, {}),
    e
  ] }) });
}, zxe = () => qA(W5), _P = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (_P.displayName = "GridApiContext");
function Tn() {
  const e = C.useContext(_P);
  if (e === void 0)
    throw new Error(["MUI: Could not find the data grid context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the data grid."].join(`
`));
  return e;
}
const AP = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (AP.displayName = "GridRootPropsContext");
const Ht = () => {
  const e = C.useContext(AP);
  if (!e)
    throw new Error("MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
  return e;
}, LP = /* @__PURE__ */ C.createContext(void 0);
process.env.NODE_ENV !== "production" && (LP.displayName = "GridPrivateApiContext");
function Cd() {
  const e = C.useContext(LP);
  if (e === void 0)
    throw new Error(["MUI: Could not find the data grid private context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the data grid."].join(`
`));
  return e;
}
const fA = {};
function FP(e, t) {
  const o = C.useRef(fA);
  return o.current === fA && (o.current = e(t)), o;
}
const Ome = [];
function q5(e) {
  C.useEffect(e, Ome);
}
const Ws = (e, t = "warning") => {
  let o = !1;
  const i = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    o || (o = !0, t === "error" ? console.error(i) : console.warn(i));
  };
}, Rme = Object.is;
function Y5(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  let o = 0, i = 0;
  for (const s in e)
    if (o += 1, !Rme(e[s], t[s]) || !(s in t))
      return !1;
  for (const s in t)
    i += 1;
  return o === i;
}
const kme = Ws(["MUI: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]);
function Pme(e) {
  return e.acceptsApiRef;
}
function pA(e, t) {
  return Pme(t) ? t(e) : t(e.current.state);
}
const Mme = Object.is, zP = Y5, Ime = () => ({
  state: null,
  equals: null,
  selector: null
}), Nt = (e, t, o = Mme) => {
  process.env.NODE_ENV !== "production" && (e.current.state || kme());
  const i = FP(Ime), s = i.current.selector !== null, [c, f] = C.useState(
    // We don't use an initialization function to avoid allocations
    s ? null : pA(e, t)
  );
  return i.current.state = c, i.current.equals = o, i.current.selector = t, q5(() => e.current.store.subscribe(() => {
    const m = pA(e, i.current.selector);
    i.current.equals(i.current.state, m) || (i.current.state = m, f(m));
  })), c;
};
function $n(e) {
  return ot("MuiDataGrid", e);
}
const Te = lt("MuiDataGrid", ["actionsCell", "aggregationColumnHeader", "aggregationColumnHeader--alignLeft", "aggregationColumnHeader--alignCenter", "aggregationColumnHeader--alignRight", "aggregationColumnHeaderLabel", "autoHeight", "booleanCell", "cell--editable", "cell--editing", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--withRenderer", "cell--rangeTop", "cell--rangeBottom", "cell--rangeLeft", "cell--rangeRight", "cell", "cellContent", "cellCheckbox", "cellSkeleton", "checkboxInput", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader--filtered", "columnHeader", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderDropZone", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaderTitleContainerContent", "columnGroupHeader", "columnHeader--filledGroup", "columnHeader--emptyGroup", "columnHeader--showColumnBorder", "columnHeaders", "columnHeadersInner", "columnHeadersInner--scrollable", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator--sideLeft", "columnSeparator--sideRight", "columnSeparator", "columnsPanel", "columnsPanelRow", "detailPanel", "detailPanels", "detailPanelToggleCell", "detailPanelToggleCell--expanded", "footerCell", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filterForm", "filterFormDeleteIcon", "filterFormLogicOperatorInput", "filterFormColumnInput", "filterFormOperatorInput", "filterFormValueInput", "filterIcon", "footerContainer", "headerFilterRow", "iconButtonContainer", "iconSeparator", "main", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "overlayWrapper", "overlayWrapperInner", "root", "root--densityStandard", "root--densityComfortable", "root--densityCompact", "root--disableUserSelection", "row", "row--editable", "row--editing", "row--lastVisible", "row--dragging", "row--dynamicHeight", "row--detailPanelExpanded", "rowReorderCellPlaceholder", "rowCount", "rowReorderCellContainer", "rowReorderCell", "rowReorderCell--draggable", "scrollArea--left", "scrollArea--right", "scrollArea", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScrollerContent", "virtualScrollerContent--overflowed", "virtualScrollerRenderZone", "pinnedColumns", "pinnedColumns--left", "pinnedColumns--right", "pinnedColumnHeaders", "pinnedColumnHeaders--left", "pinnedColumnHeaders--right", "withBorderColor", "cell--withRightBorder", "columnHeader--withRightBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle", "groupingCriteriaCell", "groupingCriteriaCellToggle", "pinnedRows", "pinnedRows--top", "pinnedRows--bottom", "pinnedRowsRenderZone"]);
var Y1 = "NOT_FOUND";
function Nme(e) {
  var t;
  return {
    get: function(i) {
      return t && e(t.key, i) ? t.value : Y1;
    },
    put: function(i, s) {
      t = {
        key: i,
        value: s
      };
    },
    getEntries: function() {
      return t ? [t] : [];
    },
    clear: function() {
      t = void 0;
    }
  };
}
function $me(e, t) {
  var o = [];
  function i(m) {
    var h = o.findIndex(function(b) {
      return t(m, b.key);
    });
    if (h > -1) {
      var v = o[h];
      return h > 0 && (o.splice(h, 1), o.unshift(v)), v.value;
    }
    return Y1;
  }
  function s(m, h) {
    i(m) === Y1 && (o.unshift({
      key: m,
      value: h
    }), o.length > e && o.pop());
  }
  function c() {
    return o;
  }
  function f() {
    o = [];
  }
  return {
    get: i,
    put: s,
    getEntries: c,
    clear: f
  };
}
var Dme = function(t, o) {
  return t === o;
};
function _me(e) {
  return function(o, i) {
    if (o === null || i === null || o.length !== i.length)
      return !1;
    for (var s = o.length, c = 0; c < s; c++)
      if (!e(o[c], i[c]))
        return !1;
    return !0;
  };
}
function zx(e, t) {
  var o = typeof t == "object" ? t : {
    equalityCheck: t
  }, i = o.equalityCheck, s = i === void 0 ? Dme : i, c = o.maxSize, f = c === void 0 ? 1 : c, m = o.resultEqualityCheck, h = _me(s), v = f === 1 ? Nme(h) : $me(f, h);
  function b() {
    var x = v.get(arguments);
    if (x === Y1) {
      if (x = e.apply(null, arguments), m) {
        var E = v.getEntries(), T = E.find(function(P) {
          return m(P.value, x);
        });
        T && (x = T.value);
      }
      v.put(arguments, x);
    }
    return x;
  }
  return b.clearCache = function() {
    return v.clear();
  }, b;
}
function Ame(e) {
  var t = Array.isArray(e[0]) ? e[0] : e;
  if (!t.every(function(i) {
    return typeof i == "function";
  })) {
    var o = t.map(function(i) {
      return typeof i == "function" ? "function " + (i.name || "unnamed") + "()" : typeof i;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + o + "]");
  }
  return t;
}
function Lme(e) {
  for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    o[i - 1] = arguments[i];
  var s = function() {
    for (var f = arguments.length, m = new Array(f), h = 0; h < f; h++)
      m[h] = arguments[h];
    var v = 0, b, x = {
      memoizeOptions: void 0
    }, E = m.pop();
    if (typeof E == "object" && (x = E, E = m.pop()), typeof E != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof E + "]");
    var T = x, P = T.memoizeOptions, O = P === void 0 ? o : P, k = Array.isArray(O) ? O : [O], I = Ame(m), $ = e.apply(void 0, [function() {
      return v++, E.apply(null, arguments);
    }].concat(k)), _ = e(function() {
      for (var V = [], M = I.length, A = 0; A < M; A++)
        V.push(I[A].apply(null, arguments));
      return b = $.apply(null, V), b;
    });
    return Object.assign(_, {
      resultFunc: E,
      memoizedResultFunc: $,
      dependencies: I,
      lastResult: function() {
        return b;
      },
      recomputations: function() {
        return v;
      },
      resetRecomputations: function() {
        return v = 0;
      }
    }), _;
  };
  return s;
}
var Fme = /* @__PURE__ */ Lme(zx);
const zme = {
  cache: /* @__PURE__ */ new WeakMap()
}, Vme = Ws(["MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g. `mySelector(state, apiRef.current.instanceId)`."]);
function fh(e) {
  return "current" in e && "instanceId" in e.current;
}
const ph = {
  id: "default"
}, bn = (e, t, o, i, s, c, ...f) => {
  if (f.length > 0)
    throw new Error("Unsupported number of selectors");
  let m;
  if (e && t && o && i && s && c)
    m = (h, v) => {
      const b = fh(h), x = v ?? (b ? h.current.instanceId : ph), E = b ? h.current.state : h, T = e(E, x), P = t(E, x), O = o(E, x), k = i(E, x), I = s(E, x);
      return c(T, P, O, k, I);
    };
  else if (e && t && o && i && s)
    m = (h, v) => {
      const b = fh(h), x = v ?? (b ? h.current.instanceId : ph), E = b ? h.current.state : h, T = e(E, x), P = t(E, x), O = o(E, x), k = i(E, x);
      return s(T, P, O, k);
    };
  else if (e && t && o && i)
    m = (h, v) => {
      const b = fh(h), x = v ?? (b ? h.current.instanceId : ph), E = b ? h.current.state : h, T = e(E, x), P = t(E, x), O = o(E, x);
      return i(T, P, O);
    };
  else if (e && t && o)
    m = (h, v) => {
      const b = fh(h), x = v ?? (b ? h.current.instanceId : ph), E = b ? h.current.state : h, T = e(E, x), P = t(E, x);
      return o(T, P);
    };
  else if (e && t)
    m = (h, v) => {
      const b = fh(h), x = v ?? (b ? h.current.instanceId : ph), E = b ? h.current.state : h, T = e(E, x);
      return t(T);
    };
  else
    throw new Error("Missing arguments");
  return m.acceptsApiRef = !0, m;
}, $r = (...e) => {
  const t = (...o) => {
    var i, s;
    const [c, f] = o, m = fh(c), h = m ? c.current.instanceId : f ?? ph, v = m ? c.current.state : c;
    process.env.NODE_ENV !== "production" && h.id === "default" && Vme();
    const {
      cache: b
    } = zme;
    if (b.get(h) && (i = b.get(h)) != null && i.get(e)) {
      var x;
      return (x = b.get(h)) == null ? void 0 : x.get(e)(v, h);
    }
    const E = Fme(...e);
    return b.get(h) || b.set(h, /* @__PURE__ */ new Map()), (s = b.get(h)) == null || s.set(e, E), E(v, h);
  };
  return t.acceptsApiRef = !0, t;
}, Kf = (e) => e.columns, Vc = bn(Kf, (e) => e.orderedFields), Kh = bn(Kf, (e) => e.lookup), Bs = $r(Vc, Kh, (e, t) => e.map((o) => t[o])), Hl = bn(Kf, (e) => e.columnVisibilityModel), la = $r(Bs, Hl, (e, t) => e.filter((o) => t[o.field] !== !1)), Vx = $r(la, (e) => e.map((t) => t.field)), zh = $r(la, (e) => {
  const t = [];
  let o = 0;
  for (let i = 0; i < e.length; i += 1)
    t.push(o), o += e[i].computedWidth;
  return t;
}), VP = bn(la, zh, (e, t) => {
  const o = e.length;
  return o === 0 ? 0 : t[o - 1] + e[o - 1].computedWidth;
}), K5 = $r(Bs, (e) => e.filter((t) => t.filterable)), Bme = $r(Bs, (e) => e.reduce((t, o) => (o.filterable && (t[o.field] = o), t), {})), Bx = (e) => e.columnGrouping, jme = $r(Bx, (e) => {
  var t;
  return (t = e == null ? void 0 : e.unwrappedGroupingModel) != null ? t : {};
}), X5 = $r(Bx, (e) => {
  var t;
  return (t = e == null ? void 0 : e.lookup) != null ? t : {};
}), Hme = $r(Bx, (e) => {
  var t;
  return (t = e == null ? void 0 : e.headerStructure) != null ? t : [];
}), Dy = bn(Bx, (e) => {
  var t;
  return (t = e == null ? void 0 : e.maxDepth) != null ? t : 0;
}), Ql = (e) => e.rows, jx = bn(Ql, (e) => e.totalRowCount), Ume = bn(Ql, (e) => e.loading), Gme = bn(Ql, (e) => e.totalTopLevelRowCount), ud = bn(Ql, (e) => e.dataRowIdToModelLookup), K1 = bn(Ql, (e) => e.dataRowIdToIdLookup), zl = bn(Ql, (e) => e.tree), Wme = bn(Ql, (e) => e.groupingName), mA = bn(Ql, (e) => e.treeDepths), Hx = $r(Ql, (e) => {
  const t = Object.entries(e.treeDepths);
  return t.length === 0 ? 1 : t.filter(([, o]) => o > 0).map(([o]) => Number(o)).sort((o, i) => i - o)[0] + 1;
}), p1 = bn(Ql, (e) => e.dataRowIds), qme = bn(Ql, (e) => e == null ? void 0 : e.additionalRowGroups), Xh = $r(qme, (e) => {
  var t, o;
  const i = e == null ? void 0 : e.pinnedRows;
  return {
    bottom: i == null || (t = i.bottom) == null ? void 0 : t.map((s) => {
      var c;
      return {
        id: s.id,
        model: (c = s.model) != null ? c : {}
      };
    }),
    top: i == null || (o = i.top) == null ? void 0 : o.map((s) => {
      var c;
      return {
        id: s.id,
        model: (c = s.model) != null ? c : {}
      };
    })
  };
}), Yme = bn(Xh, (e) => {
  var t, o;
  return ((e == null || (t = e.top) == null ? void 0 : t.length) || 0) + ((e == null || (o = e.bottom) == null ? void 0 : o.length) || 0);
}), Q5 = () => {
  var e;
  const t = Cd(), o = Ht(), i = Nt(t, la), s = Nt(t, jx), c = Nt(t, Dy), f = Nt(t, Yme);
  let m = "grid";
  return (e = o.experimentalFeatures) != null && e.ariaV7 && o.treeData && (m = "treegrid"), {
    role: m,
    "aria-colcount": i.length,
    "aria-rowcount": c + 1 + f + s,
    "aria-multiselectable": !o.disableMultipleRowSelection
  };
}, Kme = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["main"]
  }, $n, t);
}, Xme = xo("div", {
  name: "MuiDataGrid",
  slot: "Main",
  overridesResolver: (e, t) => t.main
})(() => ({
  position: "relative",
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
})), Qme = /* @__PURE__ */ C.forwardRef((e, t) => {
  var o;
  const i = Ht(), s = Kme(i), c = (o = i.experimentalFeatures) != null && o.ariaV7 ? Q5 : null, f = typeof c == "function" ? c() : null;
  return /* @__PURE__ */ L(Xme, S({
    ref: t,
    className: s.root,
    ownerState: i
  }, f, {
    children: e.children
  }));
}), Z5 = (e) => e.sorting, BP = bn(Z5, (e) => e.sortedRows), jP = $r(
  BP,
  ud,
  // TODO rows v6: Is this the best approach ?
  (e, t) => e.map((o) => {
    var i;
    return {
      id: o,
      model: (i = t[o]) != null ? i : {}
    };
  })
), el = bn(Z5, (e) => e.sortModel), Zme = $r(el, (e) => e.reduce((o, i, s) => (o[i.field] = {
  sortDirection: i.sort,
  sortIndex: e.length > 1 ? s + 1 : void 0
}, o), {})), HP = (e) => e.filter, oa = bn(HP, (e) => e.filterModel);
bn(oa, (e) => e.quickFilterValues);
const Jme = (e) => e.visibleRowsLookup, J5 = bn(HP, (e) => e.filteredRowsLookup);
bn(HP, (e) => e.filteredDescendantCountLookup);
const Sd = $r(Jme, jP, (e, t) => t.filter((o) => e[o.id] !== !1)), Kb = $r(Sd, (e) => e.map((t) => t.id)), ehe = $r(J5, jP, (e, t) => t.filter((o) => e[o.id] !== !1)), the = $r(ehe, (e) => e.map((t) => t.id)), e4 = $r(Sd, zl, Hx, (e, t, o) => o < 2 ? e : e.filter((i) => {
  var s;
  return ((s = t[i.id]) == null ? void 0 : s.depth) === 0;
})), t4 = bn(Sd, (e) => e.length), Ux = bn(e4, (e) => e.length), nhe = $r(oa, Kh, (e, t) => {
  var o;
  return (o = e.items) == null ? void 0 : o.filter((i) => {
    var s, c;
    if (!i.field)
      return !1;
    const f = t[i.field];
    if (!(f != null && f.filterOperators) || (f == null || (s = f.filterOperators) == null ? void 0 : s.length) === 0)
      return !1;
    const m = f.filterOperators.find((h) => h.value === i.operator);
    return m ? !m.InputComponent || i.value != null && ((c = i.value) == null ? void 0 : c.toString()) !== "" : !1;
  });
}), rhe = $r(nhe, (e) => e.reduce((o, i) => (o[i.field] ? o[i.field].push(i) : o[i.field] = [i], o), {})), Gx = (e) => e.focus, Va = bn(Gx, (e) => e.cell), ohe = bn(Gx, (e) => e.columnHeader);
bn(Gx, (e) => e.columnHeaderFilter);
const X1 = bn(Gx, (e) => e.columnGroupHeader), Wx = (e) => e.tabIndex, Q1 = bn(Wx, (e) => e.cell), n4 = bn(Wx, (e) => e.columnHeader);
bn(Wx, (e) => e.columnHeaderFilter);
const ahe = bn(Wx, (e) => e.columnGroupHeader), UP = (e) => e.density, ihe = bn(UP, (e) => e.value), Qh = bn(UP, (e) => e.factor), nk = (e) => e.columnMenu;
function r4(e) {
  const {
    VirtualScrollerComponent: t,
    ColumnHeadersProps: o,
    children: i
  } = e, s = Cd(), c = Ht(), f = C.useRef(null), m = Nt(s, la), h = Nt(s, rhe), v = Nt(s, Zme), b = Nt(s, zh), x = Nt(s, n4), E = Nt(s, Q1), T = Nt(s, ahe), P = Nt(s, ohe), O = Nt(s, X1), k = Nt(s, Qh), I = Nt(s, Dy), $ = Nt(s, nk), _ = Nt(s, Hl), z = Nt(s, Hme), V = !(T === null && x === null && E === null);
  Hn(() => {
    s.current.computeSizeAndPublishResizeEvent();
    const H = f.current;
    if (typeof ResizeObserver > "u")
      return () => {
      };
    let G;
    const ne = new ResizeObserver(() => {
      G = requestAnimationFrame(() => {
        s.current.computeSizeAndPublishResizeEvent();
      });
    });
    return H && ne.observe(H), () => {
      G && window.cancelAnimationFrame(G), H && ne.unobserve(H);
    };
  }, [s]);
  const M = C.useRef(null), A = C.useRef(null), W = C.useRef(null);
  s.current.register("private", {
    columnHeadersContainerElementRef: A,
    columnHeadersElementRef: M,
    virtualScrollerRef: W,
    mainElementRef: f
  });
  const Y = !!s.current.getRootDimensions();
  return /* @__PURE__ */ ht(Qme, {
    ref: f,
    children: [/* @__PURE__ */ L(c.slots.columnHeaders, S({
      ref: A,
      innerRef: M,
      visibleColumns: m,
      filterColumnLookup: h,
      sortColumnLookup: v,
      columnPositions: b,
      columnHeaderTabIndexState: x,
      columnGroupHeaderTabIndexState: T,
      columnHeaderFocus: P,
      columnGroupHeaderFocus: O,
      densityFactor: k,
      headerGroupingMaxDepth: I,
      columnMenuState: $,
      columnVisibility: _,
      columnGroupsHeaderStructure: z,
      hasOtherElementInTabSequence: V
    }, o)), Y && /* @__PURE__ */ L(
      t,
      {
        ref: W
      }
    ), i]
  });
}
process.env.NODE_ENV !== "production" && (r4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: n.node,
  ColumnHeadersProps: n.object,
  VirtualScrollerComponent: n.elementType.isRequired
});
function lhe() {
  var e;
  const t = Ht();
  return t.hideFooter ? null : /* @__PURE__ */ L(t.slots.footer, S({}, (e = t.slotProps) == null ? void 0 : e.footer));
}
const ja = "auto-generated-group-node-root", Rh = Symbol("mui.id_autogenerated"), she = () => ({
  type: "group",
  id: ja,
  depth: -1,
  groupingField: null,
  groupingKey: null,
  isAutoGenerated: !0,
  children: [],
  childrenFromPath: {},
  childrenExpanded: !0,
  parent: null
});
function che(e, t, o = "A row was provided without id in the rows prop:") {
  if (e == null)
    throw new Error(["MUI: The data grid component requires all rows to have a unique `id` property.", "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.", o, JSON.stringify(t)].join(`
`));
}
const Z1 = (e, t, o) => {
  const i = t ? t(e) : e.id;
  return che(i, e, o), i;
}, w1 = ({
  rows: e,
  getRowId: t,
  loading: o,
  rowCount: i
}) => {
  const s = {
    type: "full",
    rows: []
  }, c = {}, f = {};
  for (let m = 0; m < e.length; m += 1) {
    const h = e[m], v = Z1(h, t);
    c[v] = h, f[v] = v, s.rows.push(v);
  }
  return {
    rowsBeforePartialUpdates: e,
    loadingPropBeforePartialUpdates: o,
    rowCountPropBeforePartialUpdates: i,
    updates: s,
    dataRowIdToIdLookup: f,
    dataRowIdToModelLookup: c
  };
}, o4 = ({
  tree: e,
  rowCountProp: t = 0
}) => {
  const o = e[ja];
  return Math.max(t, o.children.length + (o.footerId == null ? 0 : 1));
}, a4 = ({
  apiRef: e,
  rowCountProp: t = 0,
  loadingProp: o,
  previousTree: i,
  previousTreeDepths: s
}) => {
  const c = e.current.caches.rows, {
    tree: f,
    treeDepths: m,
    dataRowIds: h,
    groupingName: v
  } = e.current.applyStrategyProcessor("rowTreeCreation", {
    previousTree: i,
    previousTreeDepths: s,
    updates: c.updates,
    dataRowIdToIdLookup: c.dataRowIdToIdLookup,
    dataRowIdToModelLookup: c.dataRowIdToModelLookup
  }), b = e.current.unstable_applyPipeProcessors("hydrateRows", {
    tree: f,
    treeDepths: m,
    dataRowIdToIdLookup: c.dataRowIdToIdLookup,
    dataRowIds: h,
    dataRowIdToModelLookup: c.dataRowIdToModelLookup
  });
  return e.current.caches.rows.updates = {
    type: "partial",
    actions: {
      insert: [],
      modify: [],
      remove: []
    },
    idToActionLookup: {}
  }, S({}, b, {
    totalRowCount: Math.max(t, b.dataRowIds.length),
    totalTopLevelRowCount: o4({
      tree: b.tree,
      rowCountProp: t
    }),
    groupingName: v,
    loading: o
  });
}, dy = (e) => e.type === "skeletonRow" || e.type === "footer" || e.type === "group" && e.isAutoGenerated || e.type === "pinnedRow" && e.isAutoGenerated, GP = (e, t, o) => {
  const i = e[t];
  if (i.type !== "group")
    return [];
  const s = [];
  for (let c = 0; c < i.children.length; c += 1) {
    const f = i.children[c];
    (!o || !dy(e[f])) && s.push(f), s.push(...GP(e, f, o));
  }
  return !o && i.footerId != null && s.push(i.footerId), s;
}, uhe = ({
  previousCache: e,
  getRowId: t,
  updates: o
}) => {
  var i, s, c;
  if (e.updates.type === "full")
    throw new Error("MUI: Unable to prepare a partial update if a full update is not applied yet");
  const f = /* @__PURE__ */ new Map();
  o.forEach((E) => {
    const T = Z1(E, t, "A row was provided without id when calling updateRows():");
    f.has(T) ? f.set(T, S({}, f.get(T), E)) : f.set(T, E);
  });
  const m = {
    type: "partial",
    actions: {
      insert: [...(i = e.updates.actions.insert) != null ? i : []],
      modify: [...(s = e.updates.actions.modify) != null ? s : []],
      remove: [...(c = e.updates.actions.remove) != null ? c : []]
    },
    idToActionLookup: S({}, e.updates.idToActionLookup)
  }, h = S({}, e.dataRowIdToModelLookup), v = S({}, e.dataRowIdToIdLookup), b = {
    insert: {},
    modify: {},
    remove: {}
  };
  f.forEach((E, T) => {
    const P = m.idToActionLookup[T];
    if (E._action === "delete") {
      if (P === "remove" || !h[T])
        return;
      P != null && (b[P][T] = !0), m.actions.remove.push(T), delete h[T], delete v[T];
      return;
    }
    const O = h[T];
    if (O) {
      P === "remove" ? (b.remove[T] = !0, m.actions.modify.push(T)) : P == null && m.actions.modify.push(T), h[T] = S({}, O, E);
      return;
    }
    P === "remove" ? (b.remove[T] = !0, m.actions.insert.push(T)) : P == null && m.actions.insert.push(T), h[T] = E, v[T] = T;
  });
  const x = Object.keys(b);
  for (let E = 0; E < x.length; E += 1) {
    const T = x[E], P = b[T];
    Object.keys(P).length > 0 && (m.actions[T] = m.actions[T].filter((O) => !P[O]));
  }
  return {
    dataRowIdToModelLookup: h,
    dataRowIdToIdLookup: v,
    updates: m,
    rowsBeforePartialUpdates: e.rowsBeforePartialUpdates,
    loadingPropBeforePartialUpdates: e.loadingPropBeforePartialUpdates,
    rowCountPropBeforePartialUpdates: e.rowCountPropBeforePartialUpdates
  };
};
function i4(e) {
  var t, o;
  const i = Xh(e), s = (i == null || (t = i.top) == null ? void 0 : t.reduce((f, m) => (f += e.current.unstable_getRowHeight(m.id), f), 0)) || 0, c = (i == null || (o = i.bottom) == null ? void 0 : o.reduce((f, m) => (f += e.current.unstable_getRowHeight(m.id), f), 0)) || 0;
  return {
    top: s,
    bottom: c
  };
}
function l4(e, t) {
  const o = Qh(e);
  return `var(--DataGrid-overlayHeight, ${2 * Math.floor(t * o)}px)`;
}
const dhe = xo("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapper",
  shouldForwardProp: (e) => e !== "overlayType",
  overridesResolver: (e, t) => t.overlayWrapper
})(({
  overlayType: e
}) => ({
  position: "sticky",
  // To stay in place while scrolling
  top: 0,
  left: 0,
  width: 0,
  // To stay above the content instead of shifting it down
  height: 0,
  // To stay above the content instead of shifting it down
  zIndex: e === "loadingOverlay" ? 5 : 4
  // Should be above pinned columns and detail panel
})), fhe = xo("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapperInner",
  shouldForwardProp: (e) => e !== "overlayType",
  overridesResolver: (e, t) => t.overlayWrapperInner
})({}), phe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["overlayWrapper"],
    inner: ["overlayWrapperInner"]
  }, $n, t);
};
function s4(e) {
  var t, o;
  const i = Tn(), s = Ht(), [c, f] = C.useState(() => {
    var b, x;
    return (b = (x = i.current.getRootDimensions()) == null ? void 0 : x.viewportInnerSize) != null ? b : null;
  }), m = C.useCallback(() => {
    var b, x;
    f((b = (x = i.current.getRootDimensions()) == null ? void 0 : x.viewportInnerSize) != null ? b : null);
  }, [i]);
  Hn(() => i.current.subscribeEvent("viewportInnerSizeChange", m), [i, m]);
  let h = (t = c == null ? void 0 : c.height) != null ? t : 0;
  s.autoHeight && h === 0 && (h = l4(i, s.rowHeight));
  const v = phe(S({}, e, {
    classes: s.classes
  }));
  return c ? /* @__PURE__ */ L(dhe, {
    className: be(v.root),
    overlayType: e.overlayType,
    children: /* @__PURE__ */ L(fhe, S({
      className: be(v.inner),
      style: {
        height: h,
        width: (o = c == null ? void 0 : c.width) != null ? o : 0
      }
    }, e))
  }) : null;
}
process.env.NODE_ENV !== "production" && (s4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  overlayType: n.string.isRequired
});
function mhe() {
  const e = Tn(), t = Ht(), o = Nt(e, jx), i = Nt(e, t4), s = Nt(e, Ume), c = !s && o === 0, f = !s && o > 0 && i === 0;
  let m = null, h = "";
  if (c) {
    var v;
    m = /* @__PURE__ */ L(t.slots.noRowsOverlay, S({}, (v = t.slotProps) == null ? void 0 : v.noRowsOverlay)), h = "noRowsOverlay";
  }
  if (f) {
    var b;
    m = /* @__PURE__ */ L(t.slots.noResultsOverlay, S({}, (b = t.slotProps) == null ? void 0 : b.noResultsOverlay)), h = "noResultsOverlay";
  }
  if (s) {
    var x;
    m = /* @__PURE__ */ L(t.slots.loadingOverlay, S({}, (x = t.slotProps) == null ? void 0 : x.loadingOverlay)), h = "loadingOverlay";
  }
  return m === null ? null : /* @__PURE__ */ L(s4, {
    overlayType: h,
    children: m
  });
}
function qx(e) {
  return /* @__PURE__ */ C.memo(e, Y5);
}
let fR;
function c4() {
  return fR === void 0 && document.createElement("div").focus({
    get preventScroll() {
      return fR = !0, !1;
    }
  }), fR;
}
var Us = /* @__PURE__ */ function(e) {
  return e.Cell = "cell", e.Row = "row", e;
}(Us || {}), sr = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(sr || {}), Tr = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(Tr || {}), pi = /* @__PURE__ */ function(e) {
  return e.And = "and", e.Or = "or", e;
}(pi || {}), ed = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e;
}(ed || {}), Ll = /* @__PURE__ */ function(e) {
  return e.cellFocusOut = "cellFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(Ll || {}), td = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e;
}(td || {}), Fc = /* @__PURE__ */ function(e) {
  return e.rowFocusOut = "rowFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(Fc || {});
function u4(e) {
  return e.field !== void 0;
}
function hhe(e) {
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}
function ghe(e, t) {
  return e.closest(`.${t}`);
}
function WP(e) {
  return e.replace(/["\\]/g, "\\$&");
}
function vhe(e, t) {
  return e.querySelector(`[role="columnheader"][data-field="${WP(t)}"]`);
}
function d4(e) {
  return `.${Te.row}[data-id="${WP(String(e))}"]`;
}
function bhe(e, t) {
  return e.querySelector(d4(t));
}
function yhe(e, {
  id: t,
  field: o
}) {
  const i = d4(t), s = `.${Te.cell}[data-field="${WP(o)}"]`, c = `${i} ${s}`;
  return e.querySelector(c);
}
function En(e, t, o) {
  const i = C.useRef(!0);
  C.useEffect(() => {
    i.current = !1, e.current.register(o, t);
  }, [e, o, t]), i.current && e.current.register(o, t);
}
class yh extends Error {
}
function Che(e, t) {
  const {
    getRowId: o
  } = t, i = C.useCallback((P) => ({
    field: P,
    colDef: e.current.getColumn(P)
  }), [e]), s = C.useCallback((P) => {
    const O = e.current.getRow(P);
    if (!O)
      throw new yh(`No row with id #${P} found`);
    return {
      id: P,
      columns: e.current.getAllColumns(),
      row: O
    };
  }, [e]), c = C.useCallback((P, O) => {
    const k = e.current.getRow(P), I = e.current.getRowNode(P);
    if (!k || !I)
      throw new yh(`No row with id #${P} found`);
    const $ = Va(e), _ = Q1(e);
    return {
      id: P,
      field: O,
      row: k,
      rowNode: I,
      value: k[O],
      colDef: e.current.getColumn(O),
      cellMode: e.current.getCellMode(P, O),
      api: e.current,
      hasFocus: $ !== null && $.field === O && $.id === P,
      tabIndex: _ && _.field === O && _.id === P ? 0 : -1
    };
  }, [e]), f = C.useCallback((P, O) => {
    const k = e.current.getColumn(O), I = e.current.getCellValue(P, O), $ = e.current.getRow(P), _ = e.current.getRowNode(P);
    if (!$ || !_)
      throw new yh(`No row with id #${P} found`);
    const z = Va(e), V = Q1(e), M = {
      id: P,
      field: O,
      row: $,
      rowNode: _,
      colDef: k,
      cellMode: e.current.getCellMode(P, O),
      hasFocus: z !== null && z.field === O && z.id === P,
      tabIndex: V && V.field === O && V.id === P ? 0 : -1,
      value: I,
      formattedValue: I,
      isEditable: !1
    };
    return k && k.valueFormatter && (M.formattedValue = k.valueFormatter({
      id: P,
      field: M.field,
      value: M.value,
      api: e.current
    })), M.isEditable = k && e.current.isCellEditable(M), M;
  }, [e]), m = C.useCallback((P, O) => {
    const k = e.current.getColumn(O);
    if (!k || !k.valueGetter) {
      const I = e.current.getRow(P);
      if (!I)
        throw new yh(`No row with id #${P} found`);
      return I[O];
    }
    return k.valueGetter(c(P, O));
  }, [e, c]), h = C.useCallback((P, O) => {
    var k;
    const I = Rh in P ? P[Rh] : (k = o == null ? void 0 : o(P)) != null ? k : P.id, $ = O.field;
    return !O || !O.valueGetter ? P[$] : O.valueGetter(c(I, $));
  }, [c, o]), v = C.useCallback((P, O) => {
    var k;
    const I = h(P, O);
    if (!O || !O.valueFormatter)
      return I;
    const $ = (k = o ? o(P) : P.id) != null ? k : P[Rh], _ = O.field;
    return O.valueFormatter({
      id: $,
      field: _,
      value: I,
      api: e.current
    });
  }, [e, o, h]), b = C.useCallback((P) => e.current.rootElementRef.current ? vhe(e.current.rootElementRef.current, P) : null, [e]), x = C.useCallback((P) => e.current.rootElementRef.current ? bhe(e.current.rootElementRef.current, P) : null, [e]), E = C.useCallback((P, O) => e.current.rootElementRef.current ? yhe(e.current.rootElementRef.current, {
    id: P,
    field: O
  }) : null, [e]);
  En(e, {
    getCellValue: m,
    getCellParams: f,
    getCellElement: E,
    getRowValue: h,
    getRowFormattedValue: v,
    getRowParams: s,
    getRowElement: x,
    getColumnHeaderParams: i,
    getColumnHeaderElement: b
  }, "public");
}
const She = ["changeReason", "unstable_updateValueOnRender"], xhe = ["align", "children", "editCellState", "colIndex", "column", "cellMode", "field", "formattedValue", "hasFocus", "height", "isEditable", "isSelected", "rowId", "tabIndex", "value", "width", "className", "showRightBorder", "extendRowFullWidth", "row", "colSpan", "disableDragEvents", "isNotVisible", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"], whe = ["column", "rowId", "editCellState", "align", "children", "colIndex", "height", "width", "className", "showRightBorder", "extendRowFullWidth", "row", "colSpan", "disableDragEvents", "isNotVisible", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"], Ehe = ["changeReason", "unstable_updateValueOnRender"], J1 = {
  id: -1,
  field: "__unset__",
  row: {},
  rowNode: {
    id: -1,
    depth: 0,
    type: "leaf",
    parent: -1,
    groupingKey: null
  },
  colDef: {
    type: "string",
    field: "__unset__",
    computedWidth: 0
  },
  cellMode: sr.View,
  hasFocus: !1,
  tabIndex: -1,
  value: null,
  formattedValue: "__unset__",
  isEditable: !1,
  api: {}
}, f4 = (e) => {
  const {
    align: t,
    showRightBorder: o,
    isEditable: i,
    isSelected: s,
    classes: c
  } = e, f = {
    root: ["cell", `cell--text${ve(t)}`, i && "cell--editable", s && "selected", o && "cell--withRightBorder", "withBorderColor"],
    content: ["cellContent"]
  };
  return je(f, $n, c);
};
let ex = !1;
const p4 = /* @__PURE__ */ C.forwardRef((e, t) => {
  const {
    column: o,
    rowId: i,
    editCellState: s
  } = e, c = Tn(), f = Ht(), m = o.field, h = Nt(c, () => {
    try {
      const Y = c.current.getCellParams(i, m);
      return Y.api = c.current, Y;
    } catch (W) {
      if (W instanceof yh)
        return J1;
      throw W;
    }
  }, zP), v = Nt(c, () => c.current.unstable_applyPipeProcessors("isCellSelected", !1, {
    id: i,
    field: m
  }));
  if (h === J1)
    return null;
  const {
    cellMode: b,
    hasFocus: x,
    isEditable: E,
    value: T,
    formattedValue: P
  } = h, O = o.type === "actions", k = (b === "view" || !E) && !O ? h.tabIndex : -1, {
    classes: I,
    getCellClassName: $
  } = f, _ = c.current.unstable_applyPipeProcessors("cellClassName", [], {
    id: i,
    field: m
  });
  o.cellClassName && _.push(typeof o.cellClassName == "function" ? o.cellClassName(h) : o.cellClassName), $ && _.push($(h));
  let z;
  if (s == null && o.renderCell && (z = o.renderCell(h), _.push(Te["cell--withRenderer"]), _.push(I == null ? void 0 : I["cell--withRenderer"])), s != null && o.renderEditCell) {
    const W = c.current.getRowWithUpdatedValues(i, o.field), Y = pe(s, She), H = S({}, h, {
      row: W
    }, Y);
    z = o.renderEditCell(H), _.push(Te["cell--editing"]), _.push(I == null ? void 0 : I["cell--editing"]);
  }
  const {
    slots: V
  } = f, M = V.cell, A = S({}, e, {
    ref: t,
    field: m,
    formattedValue: P,
    hasFocus: x,
    isEditable: E,
    isSelected: v,
    value: T,
    cellMode: b,
    children: z,
    tabIndex: k,
    className: be(_)
  });
  return /* @__PURE__ */ C.createElement(M, A);
}), The = /* @__PURE__ */ C.forwardRef((e, t) => {
  var o, i;
  const {
    align: s,
    children: c,
    colIndex: f,
    column: m,
    cellMode: h,
    field: v,
    formattedValue: b,
    hasFocus: x,
    height: E,
    isEditable: T,
    isSelected: P,
    rowId: O,
    tabIndex: k,
    value: I,
    width: $,
    className: _,
    showRightBorder: z,
    colSpan: V,
    disableDragEvents: M,
    isNotVisible: A,
    onClick: W,
    onDoubleClick: Y,
    onMouseDown: H,
    onMouseUp: G,
    onMouseOver: ne,
    onKeyDown: K,
    onKeyUp: B,
    onDragEnter: q,
    onDragOver: X
  } = e, J = pe(e, xhe), U = b ?? I, Z = C.useRef(null), ee = Cn(t, Z), ie = C.useRef(null), oe = Tn(), le = Ht(), de = {
    align: s,
    showRightBorder: z,
    isEditable: T,
    classes: le.classes,
    isSelected: P
  }, Ce = f4(de), me = C.useCallback((ge) => (we) => {
    const Me = oe.current.getCellParams(O, v || "");
    oe.current.publishEvent(ge, Me, we), G && G(we);
  }, [oe, v, G, O]), Oe = C.useCallback((ge) => (we) => {
    const Me = oe.current.getCellParams(O, v || "");
    oe.current.publishEvent(ge, Me, we), H && H(we);
  }, [oe, v, H, O]), he = C.useCallback((ge, we) => (Me) => {
    if (!oe.current.getRow(O))
      return;
    const Qe = oe.current.getCellParams(O, v || "");
    oe.current.publishEvent(ge, Qe, Me), we && we(Me);
  }, [oe, v, O]), $e = C.useMemo(() => A ? {
    padding: 0,
    opacity: 0,
    width: 0,
    border: 0
  } : {
    minWidth: $,
    maxWidth: $,
    minHeight: E,
    maxHeight: E === "auto" ? "none" : E
    // max-height doesn't support "auto"
  }, [$, E, A]);
  C.useEffect(() => {
    if (!x || h === sr.Edit)
      return;
    const ge = qn(oe.current.rootElementRef.current);
    if (Z.current && !Z.current.contains(ge.activeElement)) {
      const we = Z.current.querySelector('[tabindex="0"]'), Me = ie.current || we || Z.current;
      if (c4())
        Me.focus({
          preventScroll: !0
        });
      else {
        const Qe = oe.current.getScrollPosition();
        Me.focus(), oe.current.scroll(Qe);
      }
    }
  }, [x, h, oe]);
  let Ne = J.onFocus;
  process.env.NODE_ENV === "test" && (o = le.experimentalFeatures) != null && o.warnIfFocusStateIsNotSynced && (Ne = (ge) => {
    const we = Va(oe);
    if ((we == null ? void 0 : we.id) === O && we.field === v) {
      typeof J.onFocus == "function" && J.onFocus(ge);
      return;
    }
    ex || (console.warn([`MUI: The cell with id=${O} and field=${v} received focus.`, `According to the state, the focus should be at id=${we == null ? void 0 : we.id}, field=${we == null ? void 0 : we.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", "Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state."].join(`
`)), ex = !0);
  });
  const Pe = m.type === "actions";
  let Se = c;
  if (Se === void 0) {
    const ge = U == null ? void 0 : U.toString();
    Se = /* @__PURE__ */ L("div", {
      className: Ce.content,
      title: ge,
      role: "presentation",
      children: ge
    });
  }
  /* @__PURE__ */ C.isValidElement(Se) && Pe && (Se = /* @__PURE__ */ C.cloneElement(Se, {
    focusElementRef: ie
  }));
  const Fe = M ? null : {
    onDragEnter: he("cellDragEnter", q),
    onDragOver: he("cellDragOver", X)
  }, ce = (i = le.experimentalFeatures) == null ? void 0 : i.ariaV7;
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ L("div", S({
      ref: ee,
      className: be(_, Ce.root),
      role: ce ? "gridcell" : "cell",
      "data-field": v,
      "data-colindex": f,
      "aria-colindex": f + 1,
      "aria-colspan": V,
      style: $e,
      tabIndex: k,
      onClick: he("cellClick", W),
      onDoubleClick: he("cellDoubleClick", Y),
      onMouseOver: he("cellMouseOver", ne),
      onMouseDown: Oe("cellMouseDown"),
      onMouseUp: me("cellMouseUp"),
      onKeyDown: he("cellKeyDown", K),
      onKeyUp: he("cellKeyUp", B)
    }, Fe, J, {
      onFocus: Ne,
      children: Se
    }))
  );
}), Ohe = qx(p4);
process.env.NODE_ENV !== "production" && (p4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: n.oneOf(["center", "left", "right"]),
  className: n.string,
  colIndex: n.number,
  colSpan: n.number,
  column: n.object,
  disableDragEvents: n.bool,
  height: n.oneOfType([n.oneOf(["auto"]), n.number]),
  onClick: n.func,
  onDoubleClick: n.func,
  onDragEnter: n.func,
  onDragOver: n.func,
  onKeyDown: n.func,
  onMouseDown: n.func,
  onMouseUp: n.func,
  rowId: n.oneOfType([n.number, n.string]),
  showRightBorder: n.bool,
  width: n.number
});
process.env.NODE_ENV !== "production" && (The.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: n.oneOf(["center", "left", "right"]),
  cellMode: n.oneOf(["edit", "view"]),
  children: n.node,
  className: n.string,
  colIndex: n.number,
  colSpan: n.number,
  column: n.object,
  disableDragEvents: n.bool,
  editCellState: n.shape({
    changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
    isProcessingProps: n.bool,
    isValidating: n.bool,
    value: n.any
  }),
  isNotVisible: n.bool,
  height: n.oneOfType([n.oneOf(["auto"]), n.number]),
  onClick: n.func,
  onDoubleClick: n.func,
  onDragEnter: n.func,
  onDragOver: n.func,
  onKeyDown: n.func,
  onMouseDown: n.func,
  onMouseUp: n.func,
  rowId: n.oneOfType([n.number, n.string]),
  showRightBorder: n.bool,
  width: n.number
});
const m4 = /* @__PURE__ */ C.forwardRef((e, t) => {
  var o, i;
  const {
    column: s,
    rowId: c,
    editCellState: f,
    align: m,
    colIndex: h,
    height: v,
    width: b,
    className: x,
    showRightBorder: E,
    colSpan: T,
    disableDragEvents: P,
    isNotVisible: O,
    onClick: k,
    onDoubleClick: I,
    onMouseDown: $,
    onMouseUp: _,
    onMouseOver: z,
    onKeyDown: V,
    onKeyUp: M,
    onDragEnter: A,
    onDragOver: W
  } = e, Y = pe(e, whe), H = Tn(), G = Ht(), ne = s.field, K = Nt(H, () => {
    try {
      const Ze = H.current.getCellParams(c, ne);
      return Ze.api = H.current, Ze;
    } catch (ct) {
      if (ct instanceof yh)
        return J1;
      throw ct;
    }
  }, zP), B = Nt(H, () => H.current.unstable_applyPipeProcessors("isCellSelected", !1, {
    id: c,
    field: ne
  })), {
    cellMode: q,
    hasFocus: X,
    isEditable: J,
    value: U,
    formattedValue: Z
  } = K, ee = s.type === "actions", ie = (q === "view" || !J) && !ee ? K.tabIndex : -1, {
    classes: oe,
    getCellClassName: le
  } = G, de = H.current.unstable_applyPipeProcessors("cellClassName", [], {
    id: c,
    field: ne
  });
  s.cellClassName && de.push(typeof s.cellClassName == "function" ? s.cellClassName(K) : s.cellClassName), le && de.push(le(K));
  const Ce = Z ?? U, me = C.useRef(null), Oe = Cn(t, me), he = C.useRef(null), $e = {
    align: m,
    showRightBorder: E,
    isEditable: J,
    classes: G.classes,
    isSelected: B
  }, Ne = f4($e), Pe = C.useCallback((ct) => (Ze) => {
    const Ge = H.current.getCellParams(c, ne || "");
    H.current.publishEvent(ct, Ge, Ze), _ && _(Ze);
  }, [H, ne, _, c]), Se = C.useCallback((ct) => (Ze) => {
    const Ge = H.current.getCellParams(c, ne || "");
    H.current.publishEvent(ct, Ge, Ze), $ && $(Ze);
  }, [H, ne, $, c]), Fe = C.useCallback((ct, Ze) => (Ge) => {
    if (!H.current.getRow(c))
      return;
    const Be = H.current.getCellParams(c, ne || "");
    H.current.publishEvent(ct, Be, Ge), Ze && Ze(Ge);
  }, [H, ne, c]), ce = C.useMemo(() => O ? {
    padding: 0,
    opacity: 0,
    width: 0,
    border: 0
  } : {
    minWidth: b,
    maxWidth: b,
    minHeight: v,
    maxHeight: v === "auto" ? "none" : v
    // max-height doesn't support "auto"
  }, [b, v, O]);
  if (C.useEffect(() => {
    if (!X || q === sr.Edit)
      return;
    const ct = qn(H.current.rootElementRef.current);
    if (me.current && !me.current.contains(ct.activeElement)) {
      const Ze = me.current.querySelector('[tabindex="0"]'), Ge = he.current || Ze || me.current;
      if (c4())
        Ge.focus({
          preventScroll: !0
        });
      else {
        const Be = H.current.getScrollPosition();
        Ge.focus(), H.current.scroll(Be);
      }
    }
  }, [X, q, H]), K === J1)
    return null;
  let ge = Y.onFocus;
  process.env.NODE_ENV === "test" && (o = G.experimentalFeatures) != null && o.warnIfFocusStateIsNotSynced && (ge = (ct) => {
    const Ze = Va(H);
    if ((Ze == null ? void 0 : Ze.id) === c && Ze.field === ne) {
      typeof Y.onFocus == "function" && Y.onFocus(ct);
      return;
    }
    ex || (console.warn([`MUI: The cell with id=${c} and field=${ne} received focus.`, `According to the state, the focus should be at id=${Ze == null ? void 0 : Ze.id}, field=${Ze == null ? void 0 : Ze.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", "Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state."].join(`
`)), ex = !0);
  });
  let we;
  if (f == null && s.renderCell && (we = s.renderCell(K), de.push(Te["cell--withRenderer"]), de.push(oe == null ? void 0 : oe["cell--withRenderer"])), f != null && s.renderEditCell) {
    const ct = H.current.getRowWithUpdatedValues(c, s.field), Ze = pe(f, Ehe), Ge = S({}, K, {
      row: ct
    }, Ze);
    we = s.renderEditCell(Ge), de.push(Te["cell--editing"]), de.push(oe == null ? void 0 : oe["cell--editing"]);
  }
  if (we === void 0) {
    const ct = Ce == null ? void 0 : Ce.toString();
    we = /* @__PURE__ */ L("div", {
      className: Ne.content,
      title: ct,
      role: "presentation",
      children: ct
    });
  }
  /* @__PURE__ */ C.isValidElement(we) && ee && (we = /* @__PURE__ */ C.cloneElement(we, {
    focusElementRef: he
  }));
  const Me = P ? null : {
    onDragEnter: Fe("cellDragEnter", A),
    onDragOver: Fe("cellDragOver", W)
  }, Qe = (i = G.experimentalFeatures) == null ? void 0 : i.ariaV7;
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ L("div", S({
      ref: Oe,
      className: be(x, de, Ne.root),
      role: Qe ? "gridcell" : "cell",
      "data-field": ne,
      "data-colindex": h,
      "aria-colindex": h + 1,
      "aria-colspan": T,
      style: ce,
      tabIndex: ie,
      onClick: Fe("cellClick", k),
      onDoubleClick: Fe("cellDoubleClick", I),
      onMouseOver: Fe("cellMouseOver", z),
      onMouseDown: Se("cellMouseDown"),
      onMouseUp: Pe("cellMouseUp"),
      onKeyDown: Fe("cellKeyDown", V),
      onKeyUp: Fe("cellKeyUp", M)
    }, Me, Y, {
      onFocus: ge,
      children: we
    }))
  );
});
process.env.NODE_ENV !== "production" && (m4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: n.oneOf(["center", "left", "right"]).isRequired,
  className: n.string,
  colIndex: n.number.isRequired,
  colSpan: n.number,
  column: n.object.isRequired,
  disableDragEvents: n.bool,
  editCellState: n.shape({
    changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
    isProcessingProps: n.bool,
    isValidating: n.bool,
    value: n.any
  }),
  height: n.oneOfType([n.oneOf(["auto"]), n.number]).isRequired,
  isNotVisible: n.bool,
  onClick: n.func,
  onDoubleClick: n.func,
  onDragEnter: n.func,
  onDragOver: n.func,
  onKeyDown: n.func,
  onMouseDown: n.func,
  onMouseUp: n.func,
  rowId: n.oneOfType([n.number, n.string]).isRequired,
  showRightBorder: n.bool,
  width: n.number.isRequired
});
const rk = qx(m4), Rhe = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex"], khe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["booleanCell"]
  }, $n, t);
};
function h4(e) {
  const {
    value: t
  } = e, o = pe(e, Rhe), i = Tn(), s = Ht(), c = {
    classes: s.classes
  }, f = khe(c), m = C.useMemo(() => t ? s.slots.booleanCellTrueIcon : s.slots.booleanCellFalseIcon, [s.slots.booleanCellFalseIcon, s.slots.booleanCellTrueIcon, t]);
  return /* @__PURE__ */ L(m, S({
    fontSize: "small",
    className: f.root,
    titleAccess: i.current.getLocaleText(t ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
    "data-value": !!t
  }, o));
}
process.env.NODE_ENV !== "production" && (h4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: n.oneOfType([n.func, n.shape({
    current: n.shape({
      focus: n.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const Phe = /* @__PURE__ */ C.memo(h4), Mhe = (e) => dy(e.rowNode) ? "" : /* @__PURE__ */ L(Phe, S({}, e)), Ihe = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange"], Nhe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["editBooleanCell"]
  }, $n, t);
};
function g4(e) {
  var t;
  const {
    id: o,
    value: i,
    field: s,
    className: c,
    hasFocus: f,
    onValueChange: m
  } = e, h = pe(e, Ihe), v = Tn(), b = C.useRef(null), x = Qn(), [E, T] = C.useState(i), P = Ht(), O = {
    classes: P.classes
  }, k = Nhe(O), I = C.useCallback(async ($) => {
    const _ = $.target.checked;
    m && await m($, _), T(_), await v.current.setEditCellValue({
      id: o,
      field: s,
      value: _
    }, $);
  }, [v, s, o, m]);
  return C.useEffect(() => {
    T(i);
  }, [i]), Hn(() => {
    f && b.current.focus();
  }, [f]), /* @__PURE__ */ L("label", S({
    htmlFor: x,
    className: be(k.root, c)
  }, h, {
    children: /* @__PURE__ */ L(P.slots.baseCheckbox, S({
      id: x,
      inputRef: b,
      checked: !!E,
      onChange: I,
      size: "small"
    }, (t = P.slotProps) == null ? void 0 : t.baseCheckbox))
  }));
}
process.env.NODE_ENV !== "production" && (g4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  isProcessingProps: n.bool,
  isValidating: n.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: n.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const $he = (e) => /* @__PURE__ */ L(g4, S({}, e)), Dhe = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"], _he = se(Gh)({
  fontSize: "inherit"
}), Ahe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["editInputCell"]
  }, $n, t);
};
function v4(e) {
  const {
    id: t,
    value: o,
    field: i,
    colDef: s,
    hasFocus: c,
    inputProps: f,
    onValueChange: m
  } = e, h = pe(e, Dhe), v = s.type === "dateTime", b = Tn(), x = C.useRef(), E = C.useMemo(() => {
    let A;
    o == null ? A = null : o instanceof Date ? A = o : A = new Date((o ?? "").toString());
    let W;
    return A == null || Number.isNaN(A.getTime()) ? W = "" : W = new Date(A.getTime() - A.getTimezoneOffset() * 60 * 1e3).toISOString().substr(0, v ? 16 : 10), {
      parsed: A,
      formatted: W
    };
  }, [o, v]), [T, P] = C.useState(E), k = {
    classes: Ht().classes
  }, I = Ahe(k), $ = C.useRef(!1), _ = C.useCallback((A) => {
    if (A === "")
      return null;
    const [W, Y] = A.split("T"), [H, G, ne] = W.split("-"), K = /* @__PURE__ */ new Date();
    if (K.setFullYear(Number(H), Number(G) - 1, Number(ne)), K.setHours(0, 0, 0, 0), Y) {
      const [B, q] = Y.split(":");
      K.setHours(Number(B), Number(q), 0, 0);
    }
    return K;
  }, []), z = C.useCallback(async (A) => {
    const W = A.target.value, Y = _(W);
    m && await m(A, Y), P({
      parsed: Y,
      formatted: W
    }), b.current.setEditCellValue({
      id: t,
      field: i,
      value: Y
    }, A);
  }, [b, i, t, m, _]);
  C.useEffect(() => {
    P((A) => {
      var W, Y;
      return E.parsed !== A.parsed && ((W = E.parsed) == null ? void 0 : W.getTime()) !== ((Y = A.parsed) == null ? void 0 : Y.getTime()) ? E : A;
    });
  }, [E]), Hn(() => {
    c && x.current.focus();
  }, [c]);
  const V = b.current.unstable_getEditCellMeta(t, i);
  return /* @__PURE__ */ L(_he, S({
    inputRef: (A) => {
      if (x.current = A, V != null && V.unstable_updateValueOnRender && !$.current) {
        const W = x.current.value, Y = _(W);
        P({
          parsed: Y,
          formatted: W
        }), b.current.setEditCellValue({
          id: t,
          field: i,
          value: Y
        }), $.current = !0;
      }
    },
    fullWidth: !0,
    className: I.root,
    type: v ? "datetime-local" : "date",
    inputProps: S({
      max: v ? "9999-12-31T23:59" : "9999-12-31"
    }, f),
    value: T.formatted,
    onChange: z
  }, h));
}
process.env.NODE_ENV !== "production" && (v4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  isProcessingProps: n.bool,
  isValidating: n.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: n.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const b4 = (e) => /* @__PURE__ */ L(v4, S({}, e)), Lhe = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"], Fhe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["editInputCell"]
  }, $n, t);
}, zhe = se(Gh, {
  name: "MuiDataGrid",
  slot: "EditInputCell",
  overridesResolver: (e, t) => t.editInputCell
})(({
  theme: e
}) => S({}, e.typography.body2, {
  padding: "1px 0",
  "& input": {
    padding: "0 16px",
    height: "100%"
  }
})), y4 = /* @__PURE__ */ C.forwardRef((e, t) => {
  const o = Ht(), {
    id: i,
    value: s,
    field: c,
    colDef: f,
    hasFocus: m,
    debounceMs: h = 200,
    isProcessingProps: v,
    onValueChange: b
  } = e, x = pe(e, Lhe), E = Tn(), T = C.useRef(), [P, O] = C.useState(s), k = Fhe(o), I = C.useCallback(async (_) => {
    const z = _.target.value;
    b && await b(_, z);
    const V = E.current.getColumn(c);
    let M = z;
    V.valueParser && (M = V.valueParser(z, E.current.getCellParams(i, c))), O(M), E.current.setEditCellValue({
      id: i,
      field: c,
      value: M,
      debounceMs: h,
      unstable_skipValueParser: !0
    }, _);
  }, [E, h, c, i, b]), $ = E.current.unstable_getEditCellMeta(i, c);
  return C.useEffect(() => {
    ($ == null ? void 0 : $.changeReason) !== "debouncedSetEditCellValue" && O(s);
  }, [$, s]), Hn(() => {
    m && T.current.focus();
  }, [m]), /* @__PURE__ */ L(zhe, S({
    ref: t,
    inputRef: T,
    className: k.root,
    ownerState: o,
    fullWidth: !0,
    type: f.type === "number" ? f.type : "text",
    value: P ?? "",
    onChange: I,
    endAdornment: v ? /* @__PURE__ */ L(o.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : void 0
  }, x));
});
process.env.NODE_ENV !== "production" && (y4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  debounceMs: n.number,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  isProcessingProps: n.bool,
  isValidating: n.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: n.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const Vhe = (e) => /* @__PURE__ */ L(y4, S({}, e)), tx = (e) => e === "Escape", Bhe = (e) => e === "Enter", qP = (e) => e === "Tab", C4 = (e) => e === " ", jhe = (e) => e.indexOf("Arrow") === 0, Hhe = (e) => e === "Home" || e === "End", Uhe = (e) => e.indexOf("Page") === 0;
function S4(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
const nx = (e) => Hhe(e) || jhe(e) || Uhe(e) || C4(e), Ghe = (e) => !!e.key, x4 = (e) => qP(e) || tx(e);
function Xf(e) {
  return (e == null ? void 0 : e.type) === "singleSelect";
}
function ok(e, t, o) {
  if (t === void 0)
    return;
  const i = t.find((s) => {
    const c = o(s);
    return String(c) === String(e);
  });
  return o(i);
}
const Whe = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange", "initialOpen", "getOptionLabel", "getOptionValue"], qhe = ["MenuProps"];
function Yhe(e) {
  return !!e.key;
}
function w4(e) {
  var t, o, i;
  const s = Ht(), {
    id: c,
    value: f,
    field: m,
    row: h,
    colDef: v,
    hasFocus: b,
    error: x,
    onValueChange: E,
    initialOpen: T = s.editMode === Us.Cell,
    getOptionLabel: P,
    getOptionValue: O
  } = e, k = pe(e, Whe), I = Tn(), $ = C.useRef(), _ = C.useRef(), [z, V] = C.useState(T), A = (o = (((t = s.slotProps) == null ? void 0 : t.baseSelect) || {}).native) != null ? o : !1, W = ((i = s.slotProps) == null ? void 0 : i.baseSelect) || {}, {
    MenuProps: Y
  } = W, H = pe(W, qhe);
  if (Hn(() => {
    if (b) {
      var J;
      (J = _.current) == null || J.focus();
    }
  }, [b]), !Xf(v))
    return null;
  let G;
  if (typeof (v == null ? void 0 : v.valueOptions) == "function" ? G = v == null ? void 0 : v.valueOptions({
    id: c,
    row: h,
    field: m
  }) : G = v == null ? void 0 : v.valueOptions, !G)
    return null;
  const ne = O || v.getOptionValue, K = P || v.getOptionLabel, B = async (J) => {
    if (!Xf(v) || !G)
      return;
    V(!1);
    const U = J.target, Z = ok(U.value, G, ne);
    E && await E(J, Z), await I.current.setEditCellValue({
      id: c,
      field: m,
      value: Z
    }, J);
  }, q = (J, U) => {
    if (s.editMode === Us.Row) {
      V(!1);
      return;
    }
    if (U === "backdropClick" || tx(J.key)) {
      const Z = I.current.getCellParams(c, m);
      I.current.publishEvent("cellEditStop", S({}, Z, {
        reason: tx(J.key) ? Ll.escapeKeyDown : Ll.cellFocusOut
      }));
    }
  }, X = (J) => {
    Yhe(J) && J.key === "Enter" || V(!0);
  };
  return !G || !v ? null : /* @__PURE__ */ L(s.slots.baseSelect, S({
    ref: $,
    inputRef: _,
    value: f,
    onChange: B,
    open: z,
    onOpen: X,
    MenuProps: S({
      onClose: q
    }, Y),
    error: x,
    native: A,
    fullWidth: !0
  }, k, H, {
    children: G.map((J) => {
      var U;
      const Z = ne(J);
      return /* @__PURE__ */ Ch(s.slots.baseSelectOption, S({}, ((U = s.slotProps) == null ? void 0 : U.baseSelectOption) || {}, {
        native: A,
        key: Z,
        value: Z
      }), K(J));
    })
  }));
}
process.env.NODE_ENV !== "production" && (w4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  changeReason: n.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: n.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: n.func,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the select opens by default.
   */
  initialOpen: n.bool,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  isProcessingProps: n.bool,
  isValidating: n.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: n.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const Khe = (e) => /* @__PURE__ */ L(w4, S({}, e)), Xhe = ["open", "target", "onClose", "children", "position", "className", "onExited"], Qhe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["menu"]
  }, $n, t);
}, Zhe = se(cp, {
  name: "MuiDataGrid",
  slot: "Menu",
  overridesResolver: (e, t) => t.menu
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal,
  [`& .${Te.menuList}`]: {
    outline: 0
  }
})), Jhe = {
  "bottom-start": "top left",
  "bottom-end": "top right"
};
function Yx(e) {
  var t;
  const {
    open: o,
    target: i,
    onClose: s,
    children: c,
    position: f,
    className: m,
    onExited: h
  } = e, v = pe(e, Xhe), b = Tn(), x = Ht(), E = Qhe(x), T = C.useRef(null);
  Hn(() => {
    if (o)
      T.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    else {
      var k, I;
      (k = T.current) == null || (I = k.focus) == null || I.call(k), T.current = null;
    }
  }, [o]), C.useEffect(() => {
    const k = o ? "menuOpen" : "menuClose";
    b.current.publishEvent(k, {
      target: i
    });
  }, [b, o, i]);
  const P = (k) => (I) => {
    k && k(), h && h(I);
  }, O = (k) => {
    k.target && (i === k.target || i != null && i.contains(k.target)) || s(k);
  };
  return /* @__PURE__ */ L(Zhe, S({
    as: x.slots.basePopper,
    className: be(m, E.root),
    ownerState: x,
    open: o,
    anchorEl: i,
    transition: !0,
    placement: f
  }, v, (t = x.slotProps) == null ? void 0 : t.basePopper, {
    children: ({
      TransitionProps: k,
      placement: I
    }) => /* @__PURE__ */ L($h, {
      onClickAway: O,
      mouseEvent: "onMouseDown",
      children: /* @__PURE__ */ L(ay, S({}, k, {
        style: {
          transformOrigin: Jhe[I]
        },
        onExited: P(k == null ? void 0 : k.onExited),
        children: /* @__PURE__ */ L(Ci, {
          children: c
        })
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" && (Yx.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: n.node,
  onClose: n.func.isRequired,
  onExited: n.func,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  position: n.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  target: il
});
const ege = ["api", "colDef", "id", "hasFocus", "isEditable", "field", "value", "formattedValue", "row", "rowNode", "cellMode", "tabIndex", "position", "focusElementRef"], tge = (e) => typeof e.getActions == "function";
function E4(e) {
  var t;
  const {
    colDef: o,
    id: i,
    hasFocus: s,
    tabIndex: c,
    position: f = "bottom-end",
    focusElementRef: m
  } = e, h = pe(e, ege), [v, b] = C.useState(-1), [x, E] = C.useState(!1), T = Tn(), P = C.useRef(null), O = C.useRef(null), k = C.useRef(!1), I = C.useRef({}), $ = mr(), _ = Qn(), z = Qn(), V = Ht();
  if (!tge(o))
    throw new Error("MUI: Missing the `getActions` property in the `GridColDef`.");
  const M = o.getActions(T.current.getRowParams(i)), A = M.filter((X) => !X.props.showInMenu), W = M.filter((X) => X.props.showInMenu), Y = A.length + (W.length ? 1 : 0);
  C.useLayoutEffect(() => {
    s || Object.entries(I.current).forEach(([X, J]) => {
      J == null || J.stop({}, () => {
        delete I.current[X];
      });
    });
  }, [s]), C.useEffect(() => {
    if (v < 0 || !P.current || v >= P.current.children.length)
      return;
    P.current.children[v].focus({
      preventScroll: !0
    });
  }, [v]), C.useEffect(() => {
    s || (b(-1), k.current = !1);
  }, [s]), C.useImperativeHandle(m, () => ({
    focus() {
      k.current || b(0);
    }
  }), []), C.useEffect(() => {
    v >= Y && b(Y - 1);
  }, [v, Y]);
  const H = () => {
    E(!0), b(Y - 1), k.current = !0;
  }, G = () => {
    E(!1);
  }, ne = (X) => (J) => {
    I.current[X] = J;
  }, K = (X, J) => (U) => {
    b(X), k.current = !0, J && J(U);
  }, B = (X) => {
    if (Y <= 1)
      return;
    let J = v;
    X.key === "ArrowRight" ? $.direction === "rtl" ? J -= 1 : J += 1 : X.key === "ArrowLeft" && ($.direction === "rtl" ? J += 1 : J -= 1), !(J < 0 || J >= Y) && J !== v && (X.preventDefault(), X.stopPropagation(), b(J));
  }, q = (X) => {
    X.key === "Tab" && X.preventDefault(), ["Tab", "Enter", "Escape"].includes(X.key) && G();
  };
  return /* @__PURE__ */ ht("div", S({
    role: "menu",
    ref: P,
    tabIndex: -1,
    className: Te.actionsCell,
    onKeyDown: B
  }, h, {
    children: [A.map((X, J) => /* @__PURE__ */ C.cloneElement(X, {
      key: J,
      touchRippleRef: ne(J),
      onClick: K(J, X.props.onClick),
      tabIndex: v === J ? c : -1
    })), W.length > 0 && z && /* @__PURE__ */ L(V.slots.baseIconButton, S({
      ref: O,
      id: z,
      "aria-label": T.current.getLocaleText("actionsCellMore"),
      "aria-haspopup": "menu",
      "aria-expanded": x,
      "aria-controls": x ? _ : void 0,
      role: "menuitem",
      size: "small",
      onClick: H,
      touchRippleRef: ne(z),
      tabIndex: v === A.length ? c : -1
    }, (t = V.slotProps) == null ? void 0 : t.baseIconButton, {
      children: /* @__PURE__ */ L(V.slots.moreActionsIcon, {
        fontSize: "small"
      })
    })), W.length > 0 && /* @__PURE__ */ L(Yx, {
      open: x,
      target: O.current,
      position: f,
      onClose: G,
      onClick: G,
      children: /* @__PURE__ */ L(Dx, {
        id: _,
        className: Te.menuList,
        onKeyDown: q,
        "aria-labelledby": z,
        variant: "menu",
        autoFocusItem: !0,
        children: W.map((X, J) => /* @__PURE__ */ C.cloneElement(X, {
          key: J
        }))
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" && (E4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  api: n.object,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: n.oneOfType([n.func, n.shape({
    current: n.shape({
      focus: n.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  position: n.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const nge = (e) => /* @__PURE__ */ L(E4, S({}, e)), rge = ["field", "align", "width", "contentWidth"], oge = (e) => {
  const {
    align: t,
    classes: o
  } = e, i = {
    root: ["cell", "cellSkeleton", `cell--text${ve(t)}`, "withBorderColor"]
  };
  return je(i, $n, o);
};
function T4(e) {
  const {
    align: t,
    width: o,
    contentWidth: i
  } = e, s = pe(e, rge), f = {
    classes: Ht().classes,
    align: t
  }, m = oge(f);
  return /* @__PURE__ */ L("div", S({
    className: m.root,
    style: {
      width: o
    }
  }, s, {
    children: /* @__PURE__ */ L(Vle, {
      width: `${i}%`
    })
  }));
}
process.env.NODE_ENV !== "production" && (T4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: n.string.isRequired,
  contentWidth: n.number.isRequired,
  field: n.string.isRequired,
  width: n.number.isRequired
});
function age(e) {
  return e.vars ? e.vars.palette.TableCell.border : e.palette.mode === "light" ? ql(_t(e.palette.divider, 1), 0.88) : Wl(_t(e.palette.divider, 1), 0.68);
}
const hA = {
  [`.${Te.columnSeparator}, .${Te["columnSeparator--resizing"]}`]: {
    visibility: "visible",
    width: "auto"
  }
}, gA = {
  [`& .${Te.iconButtonContainer}`]: {
    visibility: "visible",
    width: "auto"
  },
  [`& .${Te.menuIcon}`]: {
    width: "auto",
    visibility: "visible"
  }
}, ige = se("div", {
  name: "MuiDataGrid",
  slot: "Root",
  overridesResolver: (e, t) => [
    {
      [`&.${Te.autoHeight}`]: t.autoHeight
    },
    {
      [`&.${Te.aggregationColumnHeader}`]: t.aggregationColumnHeader
    },
    {
      [`&.${Te["aggregationColumnHeader--alignLeft"]}`]: t["aggregationColumnHeader--alignLeft"]
    },
    {
      [`&.${Te["aggregationColumnHeader--alignCenter"]}`]: t["aggregationColumnHeader--alignCenter"]
    },
    {
      [`&.${Te["aggregationColumnHeader--alignRight"]}`]: t["aggregationColumnHeader--alignRight"]
    },
    {
      [`&.${Te.aggregationColumnHeaderLabel}`]: t.aggregationColumnHeaderLabel
    },
    {
      [`&.${Te["root--disableUserSelection"]} .${Te.cell}`]: t["root--disableUserSelection"]
    },
    {
      [`& .${Te.editBooleanCell}`]: t.editBooleanCell
    },
    {
      [`& .${Te["cell--editing"]}`]: t["cell--editing"]
    },
    {
      [`& .${Te["cell--textCenter"]}`]: t["cell--textCenter"]
    },
    {
      [`& .${Te["cell--textLeft"]}`]: t["cell--textLeft"]
    },
    {
      [`& .${Te["cell--textRight"]}`]: t["cell--textRight"]
    },
    // TODO v6: Remove
    {
      [`& .${Te["cell--withRenderer"]}`]: t["cell--withRenderer"]
    },
    {
      [`& .${Te.cell}`]: t.cell
    },
    {
      [`& .${Te["cell--rangeTop"]}`]: t["cell--rangeTop"]
    },
    {
      [`& .${Te["cell--rangeBottom"]}`]: t["cell--rangeBottom"]
    },
    {
      [`& .${Te["cell--rangeLeft"]}`]: t["cell--rangeLeft"]
    },
    {
      [`& .${Te["cell--rangeRight"]}`]: t["cell--rangeRight"]
    },
    {
      [`& .${Te["cell--withRightBorder"]}`]: t["cell--withRightBorder"]
    },
    {
      [`& .${Te.cellContent}`]: t.cellContent
    },
    {
      [`& .${Te.cellCheckbox}`]: t.cellCheckbox
    },
    {
      [`& .${Te.cellSkeleton}`]: t.cellSkeleton
    },
    {
      [`& .${Te.checkboxInput}`]: t.checkboxInput
    },
    {
      [`& .${Te["columnHeader--alignCenter"]}`]: t["columnHeader--alignCenter"]
    },
    {
      [`& .${Te["columnHeader--alignLeft"]}`]: t["columnHeader--alignLeft"]
    },
    {
      [`& .${Te["columnHeader--alignRight"]}`]: t["columnHeader--alignRight"]
    },
    {
      [`& .${Te["columnHeader--dragging"]}`]: t["columnHeader--dragging"]
    },
    {
      [`& .${Te["columnHeader--moving"]}`]: t["columnHeader--moving"]
    },
    {
      [`& .${Te["columnHeader--numeric"]}`]: t["columnHeader--numeric"]
    },
    {
      [`& .${Te["columnHeader--sortable"]}`]: t["columnHeader--sortable"]
    },
    {
      [`& .${Te["columnHeader--sorted"]}`]: t["columnHeader--sorted"]
    },
    {
      [`& .${Te["columnHeader--withRightBorder"]}`]: t["columnHeader--withRightBorder"]
    },
    {
      [`& .${Te.columnHeader}`]: t.columnHeader
    },
    {
      [`& .${Te.headerFilterRow}`]: t.headerFilterRow
    },
    {
      [`& .${Te.columnHeaderCheckbox}`]: t.columnHeaderCheckbox
    },
    {
      [`& .${Te.columnHeaderDraggableContainer}`]: t.columnHeaderDraggableContainer
    },
    {
      [`& .${Te.columnHeaderTitleContainer}`]: t.columnHeaderTitleContainer
    },
    {
      [`& .${Te["columnSeparator--resizable"]}`]: t["columnSeparator--resizable"]
    },
    {
      [`& .${Te["columnSeparator--resizing"]}`]: t["columnSeparator--resizing"]
    },
    {
      [`& .${Te.columnSeparator}`]: t.columnSeparator
    },
    {
      [`& .${Te.filterIcon}`]: t.filterIcon
    },
    {
      [`& .${Te.iconSeparator}`]: t.iconSeparator
    },
    {
      [`& .${Te.menuIcon}`]: t.menuIcon
    },
    {
      [`& .${Te.menuIconButton}`]: t.menuIconButton
    },
    {
      [`& .${Te.menuOpen}`]: t.menuOpen
    },
    {
      [`& .${Te.menuList}`]: t.menuList
    },
    {
      [`& .${Te["row--editable"]}`]: t["row--editable"]
    },
    {
      [`& .${Te["row--editing"]}`]: t["row--editing"]
    },
    {
      [`& .${Te["row--dragging"]}`]: t["row--dragging"]
    },
    {
      [`& .${Te.row}`]: t.row
    },
    {
      [`& .${Te.rowReorderCellPlaceholder}`]: t.rowReorderCellPlaceholder
    },
    {
      [`& .${Te.rowReorderCell}`]: t.rowReorderCell
    },
    {
      [`& .${Te["rowReorderCell--draggable"]}`]: t["rowReorderCell--draggable"]
    },
    {
      [`& .${Te.sortIcon}`]: t.sortIcon
    },
    {
      [`& .${Te.withBorderColor}`]: t.withBorderColor
    },
    {
      [`& .${Te.treeDataGroupingCell}`]: t.treeDataGroupingCell
    },
    {
      [`& .${Te.treeDataGroupingCellToggle}`]: t.treeDataGroupingCellToggle
    },
    {
      [`& .${Te.detailPanelToggleCell}`]: t.detailPanelToggleCell
    },
    {
      [`& .${Te["detailPanelToggleCell--expanded"]}`]: t["detailPanelToggleCell--expanded"]
    },
    t.root
  ]
})(({
  theme: e
}) => {
  const t = age(e), o = e.shape.borderRadius;
  return S({
    "--unstable_DataGrid-radius": typeof o == "number" ? `${o}px` : o,
    "--unstable_DataGrid-headWeight": e.typography.fontWeightMedium,
    "--unstable_DataGrid-overlayBackground": e.vars ? `rgba(${e.vars.palette.background.defaultChannel} / ${e.vars.palette.action.disabledOpacity})` : _t(e.palette.background.default, e.palette.action.disabledOpacity),
    "--DataGrid-cellOffsetMultiplier": 2,
    flex: 1,
    boxSizing: "border-box",
    position: "relative",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: t,
    borderRadius: "var(--unstable_DataGrid-radius)",
    color: (e.vars || e).palette.text.primary
  }, e.typography.body2, {
    outline: "none",
    height: "100%",
    display: "flex",
    minWidth: 0,
    // See https://github.com/mui/mui-x/issues/8547
    minHeight: 0,
    flexDirection: "column",
    overflowAnchor: "none",
    // Keep the same scrolling position
    [`&.${Te.autoHeight}`]: {
      height: "auto",
      [`& .${Te["row--lastVisible"]} .${Te.cell}`]: {
        borderBottomColor: "transparent"
      }
    },
    [`& .${Te["virtualScrollerContent--overflowed"]} .${Te["row--lastVisible"]} .${Te.cell}`]: {
      borderBottomColor: "transparent"
    },
    [`& .${Te.columnHeader}, & .${Te.cell}`]: {
      WebkitTapHighlightColor: "transparent",
      lineHeight: null,
      padding: "0 10px",
      boxSizing: "border-box"
    },
    [`& .${Te.columnHeader}:focus-within, & .${Te.cell}:focus-within`]: {
      outline: `solid ${e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / 0.5)` : _t(e.palette.primary.main, 0.5)} 1px`,
      outlineWidth: 1,
      outlineOffset: -1
    },
    [`& .${Te.columnHeader}:focus, & .${Te.cell}:focus`]: {
      outline: `solid ${e.palette.primary.main} 1px`
    },
    [`& .${Te.columnHeaderCheckbox}, & .${Te.cellCheckbox}`]: {
      padding: 0,
      justifyContent: "center",
      alignItems: "center"
    },
    [`& .${Te.columnHeader}`]: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    [`& .${Te["columnHeader--sorted"]} .${Te.iconButtonContainer}, & .${Te["columnHeader--filtered"]} .${Te.iconButtonContainer}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${Te.columnHeader}:not(.${Te["columnHeader--sorted"]}) .${Te.sortIcon}`]: {
      opacity: 0,
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.shorter
      })
    },
    [`& .${Te.columnHeaderTitleContainer}`]: {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      flex: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      // to anchor the aggregation label
      position: "relative"
    },
    [`& .${Te.columnHeaderTitleContainerContent}`]: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    },
    [`& .${Te["columnHeader--filledGroup"]} .${Te.columnHeaderTitleContainer}`]: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      boxSizing: "border-box"
    },
    [`& .${Te["columnHeader--filledGroup"]}.${Te["columnHeader--showColumnBorder"]} .${Te.columnHeaderTitleContainer}`]: {
      borderBottom: "none"
    },
    [`& .${Te["columnHeader--filledGroup"]}.${Te["columnHeader--showColumnBorder"]}`]: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      boxSizing: "border-box"
    },
    [`& .${Te.headerFilterRow}`]: {
      borderTop: `1px solid ${t}`
    },
    [`& .${Te.sortIcon}, & .${Te.filterIcon}`]: {
      fontSize: "inherit"
    },
    [`& .${Te["columnHeader--sortable"]}`]: {
      cursor: "pointer"
    },
    [`& .${Te["columnHeader--alignCenter"]} .${Te.columnHeaderTitleContainer}`]: {
      justifyContent: "center"
    },
    [`& .${Te["columnHeader--alignRight"]} .${Te.columnHeaderDraggableContainer}, & .${Te["columnHeader--alignRight"]} .${Te.columnHeaderTitleContainer}`]: {
      flexDirection: "row-reverse"
    },
    [`& .${Te["columnHeader--alignCenter"]} .${Te.menuIcon}, & .${Te["columnHeader--alignRight"]} .${Te.menuIcon}`]: {
      marginRight: "auto",
      marginLeft: -6
    },
    [`& .${Te["columnHeader--alignRight"]} .${Te.menuIcon}, & .${Te["columnHeader--alignRight"]} .${Te.menuIcon}`]: {
      marginRight: "auto",
      marginLeft: -10
    },
    [`& .${Te["columnHeader--moving"]}`]: {
      backgroundColor: (e.vars || e).palette.action.hover
    },
    [`& .${Te.columnSeparator}`]: {
      visibility: "hidden",
      position: "absolute",
      zIndex: 100,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      color: t
    },
    "@media (hover: hover)": {
      [`& .${Te.columnHeaders}:hover`]: hA,
      [`& .${Te.columnHeader}:hover`]: gA,
      [`& .${Te.columnHeader}:not(.${Te["columnHeader--sorted"]}):hover .${Te.sortIcon}`]: {
        opacity: 0.5
      }
    },
    "@media (hover: none)": {
      [`& .${Te.columnHeaders}`]: hA,
      [`& .${Te.columnHeader}`]: gA
    },
    [`& .${Te["columnSeparator--sideLeft"]}`]: {
      left: -12
    },
    [`& .${Te["columnSeparator--sideRight"]}`]: {
      right: -12
    },
    [`& .${Te["columnSeparator--resizable"]}`]: {
      cursor: "col-resize",
      touchAction: "none",
      "&:hover": {
        color: (e.vars || e).palette.text.primary,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          color: t
        }
      },
      [`&.${Te["columnSeparator--resizing"]}`]: {
        color: (e.vars || e).palette.text.primary
      },
      "& svg": {
        pointerEvents: "none"
      }
    },
    [`& .${Te.iconSeparator}`]: {
      color: "inherit"
    },
    [`& .${Te.menuIcon}`]: {
      width: 0,
      visibility: "hidden",
      fontSize: 20,
      marginRight: -10,
      display: "flex",
      alignItems: "center"
    },
    [`.${Te.menuOpen}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${Te.row}`]: {
      display: "flex",
      width: "fit-content",
      breakInside: "avoid",
      // Avoid the row to be broken in two different print pages.
      "&:hover, &.Mui-hovered": {
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&.Mui-selected": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
        "&:hover, &.Mui-hovered": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(
                ${e.vars.palette.action.selectedOpacity} + 
                ${e.vars.palette.action.hoverOpacity}
              ))` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity)
          }
        }
      }
    },
    [`& .${Te.cell}`]: {
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid",
      "&.Mui-selected": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity),
        "&:hover, &.Mui-hovered": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity + e.palette.action.hoverOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _t(e.palette.primary.main, e.palette.action.selectedOpacity)
          }
        }
      }
    },
    [`&.${Te["root--disableUserSelection"]} .${Te.cell}`]: {
      userSelect: "none"
    },
    [`& .${Te.row}:not(.${Te["row--dynamicHeight"]}) > .${Te.cell}`]: {
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    [`& .${Te.cellContent}`]: {
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    [`& .${Te.cell}.${Te["cell--editing"]}`]: {
      padding: 1,
      display: "flex",
      boxShadow: e.shadows[2],
      backgroundColor: (e.vars || e).palette.background.paper,
      "&:focus-within": {
        outline: `solid ${(e.vars || e).palette.primary.main} 1px`,
        outlineOffset: "-1px"
      }
    },
    [`& .${Te["row--editing"]}`]: {
      boxShadow: e.shadows[2]
    },
    [`& .${Te["row--editing"]} .${Te.cell}`]: {
      boxShadow: e.shadows[0],
      backgroundColor: (e.vars || e).palette.background.paper
    },
    [`& .${Te.editBooleanCell}`]: {
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center"
    },
    [`& .${Te.booleanCell}[data-value="true"]`]: {
      color: (e.vars || e).palette.text.secondary
    },
    [`& .${Te.booleanCell}[data-value="false"]`]: {
      color: (e.vars || e).palette.text.disabled
    },
    [`& .${Te.actionsCell}`]: {
      display: "inline-flex",
      alignItems: "center",
      gridGap: e.spacing(1)
    },
    [`& .${Te.rowReorderCell}`]: {
      display: "inline-flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${Te["rowReorderCell--draggable"]}`]: {
      cursor: "move",
      opacity: 1
    },
    [`& .${Te.rowReorderCellContainer}`]: {
      padding: 0,
      alignItems: "stretch"
    },
    [`.${Te.withBorderColor}`]: {
      borderColor: t
    },
    [`& .${Te["cell--withRightBorder"]}`]: {
      borderRightWidth: "1px",
      borderRightStyle: "solid"
    },
    [`& .${Te["columnHeader--withRightBorder"]}`]: {
      borderRightWidth: "1px",
      borderRightStyle: "solid"
    },
    [`& .${Te["cell--textLeft"]}`]: {
      justifyContent: "flex-start"
    },
    [`& .${Te["cell--textRight"]}`]: {
      justifyContent: "flex-end"
    },
    [`& .${Te["cell--textCenter"]}`]: {
      justifyContent: "center"
    },
    [`& .${Te.columnHeaderDraggableContainer}`]: {
      display: "flex",
      width: "100%",
      height: "100%"
    },
    [`& .${Te.rowReorderCellPlaceholder}`]: {
      display: "none"
    },
    [`& .${Te["columnHeader--dragging"]}, & .${Te["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${Te["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity,
      [`& .${Te.rowReorderCellPlaceholder}`]: {
        display: "flex"
      }
    },
    [`& .${Te.treeDataGroupingCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${Te.treeDataGroupingCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    },
    [`& .${Te.groupingCriteriaCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${Te.groupingCriteriaCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    }
  });
}), lge = ["children", "className"], sge = (e) => {
  const {
    autoHeight: t,
    density: o,
    classes: i
  } = e, s = {
    root: ["root", t && "autoHeight", `root--density${ve(o)}`, "withBorderColor"]
  };
  return je(s, $n, i);
}, O4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = Ht(), {
    children: c,
    className: f
  } = t, m = pe(t, lge), h = Cd(), v = Nt(h, ihe), b = C.useRef(null), x = Cn(b, o), E = (i = s.experimentalFeatures) != null && i.ariaV7 ? null : Q5, T = typeof E == "function" ? E() : null, P = S({}, s, {
    density: v
  }), O = sge(P);
  h.current.register("public", {
    rootElementRef: b
  });
  const [k, I] = C.useState(!1);
  return Hn(() => {
    I(!0);
  }, []), k ? /* @__PURE__ */ L(ige, S({
    ref: x,
    className: be(f, O.root),
    ownerState: P
  }, T, m, {
    children: c
  })) : null;
});
process.env.NODE_ENV !== "production" && (O4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const cge = ["className"], uge = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["footerContainer", "withBorderColor"]
  }, $n, t);
}, dge = xo("div", {
  name: "MuiDataGrid",
  slot: "FooterContainer",
  overridesResolver: (e, t) => t.footerContainer
})({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 52,
  borderTop: "1px solid"
}), R4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, cge), c = Ht(), f = uge(c);
  return /* @__PURE__ */ L(dge, S({
    ref: o,
    className: be(f.root, i),
    ownerState: c
  }, s));
});
process.env.NODE_ENV !== "production" && (R4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const fge = ["className"], pge = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["overlay"]
  }, $n, t);
}, mge = xo("div", {
  name: "MuiDataGrid",
  slot: "Overlay",
  overridesResolver: (e, t) => t.overlay
})({
  width: "100%",
  height: "100%",
  display: "flex",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--unstable_DataGrid-overlayBackground)"
}), Kx = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, fge), c = Ht(), f = pge(c);
  return /* @__PURE__ */ L(mge, S({
    ref: o,
    className: be(f.root, i),
    ownerState: c
  }, s));
});
process.env.NODE_ENV !== "production" && (Kx.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const hge = ["className"], gge = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["iconButtonContainer"]
  }, $n, t);
}, vge = xo("div", {
  name: "MuiDataGrid",
  slot: "IconButtonContainer",
  overridesResolver: (e, t) => t.iconButtonContainer
})(() => ({
  display: "flex",
  visibility: "hidden",
  width: 0
})), k4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, hge), c = Ht(), f = gge(c);
  return /* @__PURE__ */ L(vge, S({
    ref: o,
    className: be(f.root, i),
    ownerState: c
  }, s));
}), bge = (e) => {
  const {
    classes: t
  } = e;
  return je({
    icon: ["sortIcon"]
  }, $n, t);
};
function yge(e, t, o, i) {
  let s;
  const c = {};
  return t === "asc" ? s = e.columnSortedAscendingIcon : t === "desc" ? s = e.columnSortedDescendingIcon : (s = e.columnUnsortedIcon, c.sortingOrder = i), s ? /* @__PURE__ */ L(s, S({
    fontSize: "small",
    className: o
  }, c)) : null;
}
function P4(e) {
  var t;
  const {
    direction: o,
    index: i,
    sortingOrder: s
  } = e, c = Tn(), f = Ht(), m = S({}, e, {
    classes: f.classes
  }), h = bge(m), v = yge(f.slots, o, h.icon, s);
  if (!v)
    return null;
  const b = /* @__PURE__ */ L(f.slots.baseIconButton, S({
    tabIndex: -1,
    "aria-label": c.current.getLocaleText("columnHeaderSortIconLabel"),
    title: c.current.getLocaleText("columnHeaderSortIconLabel"),
    size: "small"
  }, (t = f.slotProps) == null ? void 0 : t.baseIconButton, {
    children: v
  }));
  return /* @__PURE__ */ ht(k4, {
    children: [i != null && /* @__PURE__ */ L(AF, {
      badgeContent: i,
      color: "default",
      children: b
    }), i == null && b]
  });
}
const Cge = /* @__PURE__ */ C.memo(P4);
process.env.NODE_ENV !== "production" && (P4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  direction: n.oneOf(["asc", "desc"]),
  index: n.number,
  sortingOrder: n.arrayOf(n.oneOf(["asc", "desc"])).isRequired
});
const Sge = (e) => {
  const {
    classes: t,
    open: o
  } = e;
  return je({
    root: ["menuIcon", o && "menuOpen"],
    button: ["menuIconButton"]
  }, $n, t);
}, xge = /* @__PURE__ */ C.memo((e) => {
  var t, o;
  const {
    colDef: i,
    open: s,
    columnMenuId: c,
    columnMenuButtonId: f,
    iconButtonRef: m
  } = e, h = Tn(), v = Ht(), b = S({}, e, {
    classes: v.classes
  }), x = Sge(b), E = C.useCallback((T) => {
    T.preventDefault(), T.stopPropagation(), h.current.toggleColumnMenu(i.field);
  }, [h, i.field]);
  return /* @__PURE__ */ L("div", {
    className: x.root,
    children: /* @__PURE__ */ L(v.slots.baseTooltip, S({
      title: h.current.getLocaleText("columnMenuLabel"),
      enterDelay: 1e3
    }, (t = v.slotProps) == null ? void 0 : t.baseTooltip, {
      children: /* @__PURE__ */ L(v.slots.baseIconButton, S({
        ref: m,
        tabIndex: -1,
        className: x.button,
        "aria-label": h.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: E,
        "aria-haspopup": "menu",
        "aria-expanded": s,
        "aria-controls": s ? c : void 0,
        id: f
      }, (o = v.slotProps) == null ? void 0 : o.baseIconButton, {
        children: /* @__PURE__ */ L(v.slots.columnMenuIcon, {
          fontSize: "small"
        })
      }))
    }))
  });
});
function M4({
  columnMenuId: e,
  columnMenuButtonId: t,
  ContentComponent: o,
  contentComponentProps: i,
  field: s,
  open: c,
  target: f,
  onExited: m
}) {
  const h = Tn(), v = h.current.getColumn(s), b = zn((x) => {
    x && (x.stopPropagation(), f != null && f.contains(x.target)) || h.current.hideColumnMenu();
  });
  return !f || !v ? null : /* @__PURE__ */ L(Yx, {
    placement: `bottom-${v.align === "right" ? "start" : "end"}`,
    open: c,
    target: f,
    onClose: b,
    onExited: m,
    children: /* @__PURE__ */ L(o, S({
      colDef: v,
      hideMenu: b,
      open: c,
      id: e,
      labelledby: t
    }, i))
  });
}
process.env.NODE_ENV !== "production" && (M4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnMenuButtonId: n.string,
  columnMenuId: n.string,
  ContentComponent: n.elementType.isRequired,
  contentComponentProps: n.any,
  field: n.string.isRequired,
  onExited: n.func,
  open: n.bool.isRequired,
  target: il
});
const wge = ["className"], Ege = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["columnHeaderTitle"]
  }, $n, t);
}, Tge = xo("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderTitle",
  overridesResolver: (e, t) => t.columnHeaderTitle
})({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontWeight: "var(--unstable_DataGrid-headWeight)"
}), Oge = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, wge), c = Ht(), f = Ege(c);
  return /* @__PURE__ */ L(Tge, S({
    ref: o,
    className: be(f.root, i),
    ownerState: c
  }, s));
});
function I4(e) {
  var t;
  const {
    label: o,
    description: i
  } = e, s = Ht(), c = C.useRef(null), [f, m] = C.useState(""), h = C.useCallback(() => {
    if (!i && c != null && c.current) {
      const v = hhe(c.current);
      m(v ? o : "");
    }
  }, [i, o]);
  return /* @__PURE__ */ L(s.slots.baseTooltip, S({
    title: i || f
  }, (t = s.slotProps) == null ? void 0 : t.baseTooltip, {
    children: /* @__PURE__ */ L(Oge, {
      onMouseOver: h,
      ref: c,
      children: o
    })
  }));
}
process.env.NODE_ENV !== "production" && (I4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnWidth: n.number.isRequired,
  description: n.node,
  label: n.string.isRequired
});
const Rge = ["resizable", "resizing", "height", "side"];
var N4 = /* @__PURE__ */ function(e) {
  return e.Left = "left", e.Right = "right", e;
}(N4 || {});
const kge = (e) => {
  const {
    resizable: t,
    resizing: o,
    classes: i,
    side: s
  } = e, c = {
    root: ["columnSeparator", t && "columnSeparator--resizable", o && "columnSeparator--resizing", s && `columnSeparator--side${ve(s)}`],
    icon: ["iconSeparator"]
  };
  return je(c, $n, i);
};
function $4(e) {
  const {
    height: t,
    side: o = N4.Right
  } = e, i = pe(e, Rge), s = Ht(), c = S({}, e, {
    side: o,
    classes: s.classes
  }), f = kge(c), m = C.useCallback((h) => {
    h.preventDefault(), h.stopPropagation();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ L("div", S({
      className: f.root,
      style: {
        minHeight: t,
        opacity: s.showColumnVerticalBorder ? 0 : 1
      }
    }, i, {
      onClick: m,
      children: /* @__PURE__ */ L(s.slots.columnResizeIcon, {
        className: f.icon
      })
    }))
  );
}
const Pge = /* @__PURE__ */ C.memo($4);
process.env.NODE_ENV !== "production" && ($4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  height: n.number.isRequired,
  resizable: n.bool.isRequired,
  resizing: n.bool.isRequired,
  side: n.oneOf(["left", "right"])
});
const Mge = ["classes", "columnMenuOpen", "colIndex", "height", "isResizing", "sortDirection", "hasFocus", "tabIndex", "separatorSide", "isDraggable", "headerComponent", "description", "elementId", "width", "columnMenuIconButton", "columnMenu", "columnTitleIconButtons", "headerClassName", "label", "resizable", "draggableContainerProps", "columnHeaderSeparatorProps"], D4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    classes: i,
    columnMenuOpen: s,
    colIndex: c,
    height: f,
    isResizing: m,
    sortDirection: h,
    hasFocus: v,
    tabIndex: b,
    separatorSide: x,
    isDraggable: E,
    headerComponent: T,
    description: P,
    width: O,
    columnMenuIconButton: k = null,
    columnMenu: I = null,
    columnTitleIconButtons: $ = null,
    headerClassName: _,
    label: z,
    resizable: V,
    draggableContainerProps: M,
    columnHeaderSeparatorProps: A
  } = t, W = pe(t, Mge), Y = Cd(), H = Ht(), G = C.useRef(null), [ne, K] = C.useState(s), B = Cn(G, o);
  let q = "none";
  return h != null && (q = h === "asc" ? "ascending" : "descending"), C.useEffect(() => {
    ne || K(s);
  }, [ne, s]), C.useLayoutEffect(() => {
    const X = Y.current.state.columnMenu;
    if (v && !X.open) {
      const U = G.current.querySelector('[tabindex="0"]') || G.current;
      U == null || U.focus(), Y.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }
  }, [Y, v]), /* @__PURE__ */ ht("div", S({
    ref: B,
    className: be(i.root, _),
    style: {
      height: f,
      width: O,
      minWidth: O,
      maxWidth: O
    },
    role: "columnheader",
    tabIndex: b,
    "aria-colindex": c + 1,
    "aria-sort": q,
    "aria-label": T == null ? z : void 0
  }, W, {
    children: [/* @__PURE__ */ ht("div", S({
      className: i.draggableContainer,
      draggable: E,
      role: "presentation"
    }, M, {
      children: [/* @__PURE__ */ ht("div", {
        className: i.titleContainer,
        role: "presentation",
        children: [/* @__PURE__ */ L("div", {
          className: i.titleContainerContent,
          children: T !== void 0 ? T : /* @__PURE__ */ L(I4, {
            label: z,
            description: P,
            columnWidth: O
          })
        }), $]
      }), k]
    })), /* @__PURE__ */ L(Pge, S({
      resizable: !H.disableColumnResize && !!V,
      resizing: m,
      height: f,
      side: x
    }, A)), I]
  }));
}), Ige = (e) => {
  const {
    colDef: t,
    classes: o,
    isDragging: i,
    sortDirection: s,
    showRightBorder: c,
    filterItemsCounter: f
  } = e, m = s != null, h = f != null && f > 0, v = t.type === "number", b = {
    root: ["columnHeader", t.headerAlign === "left" && "columnHeader--alignLeft", t.headerAlign === "center" && "columnHeader--alignCenter", t.headerAlign === "right" && "columnHeader--alignRight", t.sortable && "columnHeader--sortable", i && "columnHeader--moving", m && "columnHeader--sorted", h && "columnHeader--filtered", v && "columnHeader--numeric", "withBorderColor", c && "columnHeader--withRightBorder"],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  };
  return je(b, $n, o);
};
function _4(e) {
  var t, o, i, s;
  const {
    colDef: c,
    columnMenuOpen: f,
    colIndex: m,
    headerHeight: h,
    isResizing: v,
    sortDirection: b,
    sortIndex: x,
    filterItemsCounter: E,
    hasFocus: T,
    tabIndex: P,
    disableReorder: O,
    separatorSide: k
  } = e, I = Cd(), $ = Ht(), _ = C.useRef(null), z = Qn(), V = Qn(), M = C.useRef(null), [A, W] = C.useState(f), Y = C.useMemo(() => !$.disableColumnReorder && !O && !c.disableReorder, [$.disableColumnReorder, O, c.disableReorder]);
  let H;
  c.renderHeader && (H = c.renderHeader(I.current.getColumnHeaderParams(c.field)));
  const G = S({}, e, {
    classes: $.classes,
    showRightBorder: $.showColumnVerticalBorder
  }), ne = Ige(G), K = C.useCallback((de) => (Ce) => {
    Ce.currentTarget.contains(Ce.target) && I.current.publishEvent(de, I.current.getColumnHeaderParams(c.field), Ce);
  }, [I, c.field]), B = C.useMemo(() => ({
    onClick: K("columnHeaderClick"),
    onDoubleClick: K("columnHeaderDoubleClick"),
    onMouseOver: K("columnHeaderOver"),
    // TODO remove as it's not used
    onMouseOut: K("columnHeaderOut"),
    // TODO remove as it's not used
    onMouseEnter: K("columnHeaderEnter"),
    // TODO remove as it's not used
    onMouseLeave: K("columnHeaderLeave"),
    // TODO remove as it's not used
    onKeyDown: K("columnHeaderKeyDown"),
    onFocus: K("columnHeaderFocus"),
    onBlur: K("columnHeaderBlur")
  }), [K]), q = C.useMemo(() => Y ? {
    onDragStart: K("columnHeaderDragStart"),
    onDragEnter: K("columnHeaderDragEnter"),
    onDragOver: K("columnHeaderDragOver"),
    onDragEnd: K("columnHeaderDragEnd")
  } : {}, [Y, K]), X = C.useMemo(() => ({
    onMouseDown: K("columnSeparatorMouseDown"),
    onDoubleClick: K("columnSeparatorDoubleClick")
  }), [K]);
  C.useEffect(() => {
    A || W(f);
  }, [A, f]);
  const J = C.useCallback(() => {
    W(!1);
  }, []), U = !$.disableColumnMenu && !c.disableColumnMenu && /* @__PURE__ */ L(xge, {
    colDef: c,
    columnMenuId: z,
    columnMenuButtonId: V,
    open: A,
    iconButtonRef: M
  }), Z = /* @__PURE__ */ L(M4, {
    columnMenuId: z,
    columnMenuButtonId: V,
    field: c.field,
    open: f,
    target: M.current,
    ContentComponent: $.slots.columnMenu,
    contentComponentProps: (t = $.slotProps) == null ? void 0 : t.columnMenu,
    onExited: J
  }), ee = (o = c.sortingOrder) != null ? o : $.sortingOrder, ie = /* @__PURE__ */ ht(C.Fragment, {
    children: [!$.disableColumnFilter && /* @__PURE__ */ L($.slots.columnHeaderFilterIconButton, S({
      field: c.field,
      counter: E
    }, (i = $.slotProps) == null ? void 0 : i.columnHeaderFilterIconButton)), c.sortable && !c.hideSortIcons && /* @__PURE__ */ L(Cge, {
      direction: b,
      index: x,
      sortingOrder: ee
    })]
  });
  C.useLayoutEffect(() => {
    const de = I.current.state.columnMenu;
    if (T && !de.open) {
      const me = _.current.querySelector('[tabindex="0"]') || _.current;
      me == null || me.focus(), I.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }
  }, [I, T]);
  const oe = typeof c.headerClassName == "function" ? c.headerClassName({
    field: c.field,
    colDef: c
  }) : c.headerClassName, le = (s = c.headerName) != null ? s : c.field;
  return /* @__PURE__ */ L(D4, S({
    ref: _,
    classes: ne,
    columnMenuOpen: f,
    colIndex: m,
    height: h,
    isResizing: v,
    sortDirection: b,
    hasFocus: T,
    tabIndex: P,
    separatorSide: k,
    isDraggable: Y,
    headerComponent: H,
    description: c.description,
    elementId: c.field,
    width: c.computedWidth,
    columnMenuIconButton: U,
    columnTitleIconButtons: ie,
    headerClassName: oe,
    label: le,
    resizable: !$.disableColumnResize && !!c.resizable,
    "data-field": c.field,
    columnMenu: Z,
    draggableContainerProps: q,
    columnHeaderSeparatorProps: X
  }, B));
}
process.env.NODE_ENV !== "production" && (_4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  colIndex: n.number.isRequired,
  columnMenuOpen: n.bool.isRequired,
  disableReorder: n.bool,
  filterItemsCounter: n.number,
  hasFocus: n.bool,
  headerHeight: n.number.isRequired,
  isDragging: n.bool.isRequired,
  isResizing: n.bool.isRequired,
  separatorSide: n.oneOf(["left", "right"]),
  sortDirection: n.oneOf(["asc", "desc"]),
  sortIndex: n.number,
  tabIndex: n.oneOf([-1, 0]).isRequired
});
const fy = () => ({
  items: [],
  logicOperator: pi.And,
  quickFilterValues: [],
  quickFilterLogicOperator: pi.And
}), vA = 1e3;
class Nge {
  constructor(t = vA) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = vA, this.cleanupTimeout = t;
  }
  register(t, o, i) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const s = setTimeout(() => {
      typeof o == "function" && o(), this.timeouts.delete(i.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(i.cleanupToken, s);
  }
  unregister(t) {
    const o = this.timeouts.get(t.cleanupToken);
    o && (this.timeouts.delete(t.cleanupToken), clearTimeout(o));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, o) => {
      this.unregister({
        cleanupToken: o
      });
    }), this.timeouts = void 0);
  }
}
class $ge {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, o, i) {
    this.registry.register(t, o, i);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
var js = /* @__PURE__ */ function(e) {
  return e.DataGrid = "DataGrid", e.DataGridPro = "DataGridPro", e;
}(js || {});
class Dge {
}
function _ge(e) {
  let t = 0;
  return function(i, s, c, f) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new $ge() : new Nge());
    const [m] = C.useState(new Dge()), h = C.useRef(null), v = C.useRef();
    v.current = c;
    const b = C.useRef(null);
    if (!h.current && v.current) {
      const x = (E, T, P) => {
        if (!T.defaultMuiPrevented) {
          var O;
          (O = v.current) == null || O.call(v, E, T, P);
        }
      };
      h.current = i.current.subscribeEvent(s, x, f), t += 1, b.current = {
        cleanupToken: t
      }, e.registry.register(
        m,
        // The callback below will be called once this reference stops being retained
        () => {
          var E;
          (E = h.current) == null || E.call(h), h.current = null, b.current = null;
        },
        b.current
      );
    } else
      !v.current && h.current && (h.current(), h.current = null, b.current && (e.registry.unregister(b.current), b.current = null));
    C.useEffect(() => {
      if (!h.current && v.current) {
        const x = (E, T, P) => {
          if (!T.defaultMuiPrevented) {
            var O;
            (O = v.current) == null || O.call(v, E, T, P);
          }
        };
        h.current = i.current.subscribeEvent(s, x, f);
      }
      return b.current && e.registry && (e.registry.unregister(b.current), b.current = null), () => {
        var x;
        (x = h.current) == null || x.call(h), h.current = null;
      };
    }, [i, s, f]);
  };
}
const Age = {
  registry: null
}, Yt = _ge(Age), Lge = {
  isFirst: !0
};
function Mr(e, t, o) {
  Yt(e, t, o, Lge);
}
function Ra(e, t) {
  const o = C.useRef(null);
  if (o.current)
    return o.current;
  const i = e.current.getLogger(t);
  return o.current = i, i;
}
function Fge(e) {
  return typeof e == "number";
}
function A4(e) {
  return typeof e == "function";
}
function YP(e) {
  return typeof e == "object" && e !== null;
}
function zge() {
  try {
    const e = "__some_random_key_you_are_not_going_to_use__";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function E1(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const Vh = (e, t, o) => Math.max(t, Math.min(o, e));
function Qf(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e)) {
      const s = e.length;
      if (s !== t.length)
        return !1;
      for (let c = 0; c < s; c += 1)
        if (!Qf(e[c], t[c]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      const s = Array.from(e.entries());
      for (let c = 0; c < s.length; c += 1)
        if (!t.has(s[c][0]))
          return !1;
      for (let c = 0; c < s.length; c += 1) {
        const f = s[c];
        if (!Qf(f[1], t.get(f[0])))
          return !1;
      }
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      const s = Array.from(e.entries());
      for (let c = 0; c < s.length; c += 1)
        if (!t.has(s[c][0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      const s = e.length;
      if (s !== t.length)
        return !1;
      for (let c = 0; c < s; c += 1)
        if (e[c] !== t[c])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const o = Object.keys(e), i = o.length;
    if (i !== Object.keys(t).length)
      return !1;
    for (let s = 0; s < i; s += 1)
      if (!Object.prototype.hasOwnProperty.call(t, o[s]))
        return !1;
    for (let s = 0; s < i; s += 1) {
      const c = o[s];
      if (!Qf(e[c], t[c]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Vge(e) {
  return () => {
    let t = e += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function Bge(e, t, o) {
  const i = Vge(e);
  return () => t + (o - t) * i();
}
function L4(e) {
  return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
const jge = (e, t, o, i, s) => {
  const c = Ra(e, "useNativeEventListener"), [f, m] = C.useState(!1), h = C.useRef(i), v = C.useCallback((b) => h.current && h.current(b), []);
  C.useEffect(() => {
    h.current = i;
  }, [i]), C.useEffect(() => {
    let b;
    if (A4(t) ? b = t() : b = t && t.current ? t.current : null, b && o && !f) {
      c.debug(`Binding native ${o} event`), b.addEventListener(o, v, s);
      const x = b;
      m(!0);
      const E = () => {
        c.debug(`Clearing native ${o} event`), x.removeEventListener(o, v, s);
      };
      e.current.subscribeEvent("unmount", E);
    }
  }, [t, v, o, f, c, s, e]);
}, _y = (e) => {
  const t = C.useRef(!0);
  t.current && (t.current = !1, e());
}, Hge = 100, Uge = (e) => e ? 0 : 100, F4 = (e, t) => t > 0 && e > 0 ? Math.ceil(e / t) : 0, Gge = Ws(["MUI: the 'rowCount' prop is undefined while using paginationMode='server'", "For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation"], "error"), z4 = (e) => ({
  page: 0,
  pageSize: e ? 0 : 100
}), Wge = (e, t = 0) => t === 0 ? e : Math.max(Math.min(e, t - 1), 0), V4 = (e, t) => {
  if (t === js.DataGrid && e > Hge)
    throw new Error(["MUI: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
}, B4 = (e) => e.pagination, rl = bn(B4, (e) => e.paginationModel), qge = bn(rl, (e) => e.page), Yge = bn(rl, (e) => e.pageSize);
bn(rl, Ux, (e, t) => F4(t, e.pageSize));
const KP = $r(rl, zl, Hx, Sd, e4, (e, t, o, i, s) => {
  const c = s.length, f = Math.min(e.pageSize * e.page, c - 1), m = Math.min(f + e.pageSize - 1, c - 1);
  if (f === -1 || m === -1)
    return null;
  if (o < 2)
    return {
      firstRowIndex: f,
      lastRowIndex: m
    };
  const h = s[f], v = m - f + 1, b = i.findIndex((P) => P.id === h.id);
  let x = b, E = 0;
  for (; x < i.length && E <= v; ) {
    var T;
    const P = i[x], O = (T = t[P.id]) == null ? void 0 : T.depth;
    O === void 0 ? x += 1 : ((E < v || O > 0) && (x += 1), O === 0 && (E += 1));
  }
  return {
    firstRowIndex: b,
    lastRowIndex: x - 1
  };
}), Kge = $r(Sd, KP, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), j4 = $r(Kb, KP, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), py = (e) => e.preferencePanel;
var op = /* @__PURE__ */ function(e) {
  return e.filters = "filters", e.columns = "columns", e;
}(op || {});
const my = (e) => e.rowsMeta, tl = (e) => e.rowSelection, Xge = bn(tl, (e) => e.length), Qge = $r(tl, ud, (e, t) => new Map(e.map((o) => [o, t[o]]))), rx = $r(tl, (e) => e.reduce((t, o) => (t[o] = o, t), {})), Zge = Ws(["MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.", "If you are using the community version of the `DataGrid`, this prop is always `true`."], "error"), H4 = (e, t) => t && e.length > 1 ? (Zge(), [e[0]]) : e, bA = (e, t) => (o) => S({}, o, {
  sorting: S({}, o.sorting, {
    sortModel: H4(e, t)
  })
}), Jge = (e) => e === "desc", eve = (e, t) => {
  const o = t.current.getColumn(e.field);
  if (!o)
    return null;
  const i = Jge(e.sort) ? (...c) => -1 * o.sortComparator(...c) : o.sortComparator;
  return {
    getSortCellParams: (c) => ({
      id: c,
      field: o.field,
      rowNode: t.current.getRowNode(c),
      value: t.current.getCellValue(c, o.field),
      api: t.current
    }),
    comparator: i
  };
}, tve = (e, t, o) => e.reduce((i, s, c) => {
  if (i !== 0)
    return i;
  const f = t.params[c], m = o.params[c];
  return i = s.comparator(f.value, m.value, f, m), i;
}, 0), nve = (e, t) => {
  const o = e.map((i) => eve(i, t)).filter((i) => !!i);
  return o.length === 0 ? null : (i) => i.map((s) => ({
    node: s,
    params: o.map((c) => c.getSortCellParams(s.id))
  })).sort((s, c) => tve(o, s, c)).map((s) => s.node.id);
}, yA = (e, t) => {
  const o = e.indexOf(t);
  return !t || o === -1 || o + 1 === e.length ? e[0] : e[o + 1];
}, XP = (e, t) => e == null && t != null ? -1 : t == null && e != null ? 1 : e == null && t == null ? 0 : null, rve = new Intl.Collator(), ove = (e, t) => {
  const o = XP(e, t);
  return o !== null ? o : typeof e == "string" ? rve.compare(e.toString(), t.toString()) : e - t;
}, U4 = (e, t) => {
  const o = XP(e, t);
  return o !== null ? o : Number(e) - Number(t);
}, G4 = (e, t) => {
  const o = XP(e, t);
  return o !== null ? o : e > t ? 1 : e < t ? -1 : 0;
}, W4 = (e) => e.headerFiltering, ave = bn(W4, (e) => e.editing), ive = bn(W4, (e) => e.menuOpen), lve = (e, t) => {
  const o = {
    enabled: !t.disableVirtualization,
    enabledForColumns: !0
  };
  return S({}, e, {
    virtualization: o
  });
};
function sve(e, t) {
  const o = (c) => {
    e.current.setState((f) => S({}, f, {
      virtualization: S({}, f.virtualization, {
        enabled: c
      })
    }));
  };
  En(e, {
    unstable_setVirtualization: o,
    unstable_setColumnVirtualization: (c) => {
      e.current.setState((f) => S({}, f, {
        virtualization: S({}, f.virtualization, {
          enabledForColumns: c
        })
      }));
    }
  }, "public"), C.useEffect(() => {
    o(!t.disableVirtualization);
  }, [t.disableVirtualization]);
}
const q4 = (e) => e.virtualization, cve = bn(q4, (e) => e.enabled), Y4 = bn(q4, (e) => e.enabledForColumns), uve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    icon: ["filterIcon"]
  }, $n, t);
};
function K4(e) {
  var t, o;
  const {
    counter: i,
    field: s,
    onClick: c
  } = e, f = Tn(), m = Ht(), h = S({}, e, {
    classes: m.classes
  }), v = uve(h), b = Nt(f, py), x = Qn(), E = Qn(), T = C.useCallback((k) => {
    k.preventDefault(), k.stopPropagation();
    const {
      open: I,
      openedPanelValue: $
    } = py(f.current.state);
    I && $ === op.filters ? f.current.hideFilterPanel() : f.current.showFilterPanel(void 0, E, x), c && c(f.current.getColumnHeaderParams(s), k);
  }, [f, s, c, E, x]);
  if (!i)
    return null;
  const P = b.open && b.labelId === x, O = /* @__PURE__ */ L(m.slots.baseIconButton, S({
    id: x,
    onClick: T,
    color: "default",
    "aria-label": f.current.getLocaleText("columnHeaderFiltersLabel"),
    size: "small",
    tabIndex: -1,
    "aria-haspopup": "menu",
    "aria-expanded": P,
    "aria-controls": P ? E : void 0
  }, (t = m.slotProps) == null ? void 0 : t.baseIconButton, {
    children: /* @__PURE__ */ L(m.slots.columnFilteredIcon, {
      className: v.icon,
      fontSize: "small"
    })
  }));
  return /* @__PURE__ */ L(m.slots.baseTooltip, S({
    title: f.current.getLocaleText("columnHeaderFiltersTooltipActive")(i),
    enterDelay: 1e3
  }, (o = m.slotProps) == null ? void 0 : o.baseTooltip, {
    children: /* @__PURE__ */ ht(k4, {
      children: [i > 1 && /* @__PURE__ */ L(AF, {
        badgeContent: i,
        color: "default",
        children: O
      }), i === 1 && O]
    })
  }));
}
process.env.NODE_ENV !== "production" && (K4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  counter: n.number,
  field: n.string.isRequired,
  onClick: n.func
});
const dve = ["field", "id", "value", "formattedValue", "row", "rowNode", "colDef", "isEditable", "cellMode", "hasFocus", "tabIndex", "api"], fve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["checkboxInput"]
  }, $n, t);
}, X4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const {
    field: s,
    id: c,
    value: f,
    rowNode: m,
    hasFocus: h,
    tabIndex: v
  } = t, b = pe(t, dve), x = Tn(), E = Ht(), T = {
    classes: E.classes
  }, P = fve(T), O = C.useRef(null), k = C.useRef(null), I = Cn(O, o), $ = x.current.getCellElement(c, s), _ = (A) => {
    const W = {
      value: A.target.checked,
      id: c
    };
    x.current.publishEvent("rowSelectionCheckboxChange", W, A);
  };
  C.useLayoutEffect(() => {
    v === 0 && $ && ($.tabIndex = -1);
  }, [$, v]), C.useEffect(() => {
    if (h) {
      var A;
      const W = (A = O.current) == null ? void 0 : A.querySelector("input");
      W == null || W.focus({
        preventScroll: !0
      });
    } else
      k.current && k.current.stop({});
  }, [h]);
  const z = C.useCallback((A) => {
    C4(A.key) && A.stopPropagation();
  }, []);
  if (m.type === "footer" || m.type === "pinnedRow")
    return null;
  const V = x.current.isRowSelectable(c), M = x.current.getLocaleText(f ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
  return /* @__PURE__ */ L(E.slots.baseCheckbox, S({
    ref: I,
    tabIndex: v,
    checked: f,
    onChange: _,
    className: P.root,
    inputProps: {
      "aria-label": M
    },
    onKeyDown: z,
    disabled: !V,
    touchRippleRef: k
  }, (i = E.slotProps) == null ? void 0 : i.baseCheckbox, b));
});
process.env.NODE_ENV !== "production" && (X4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: n.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: n.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: n.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: n.oneOfType([n.func, n.shape({
    current: n.shape({
      focus: n.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: n.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: n.bool.isRequired,
  /**
   * The grid row id.
   */
  id: n.oneOfType([n.number, n.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: n.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: n.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: n.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: n.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: n.any
});
const pve = X4, mve = ["field", "colDef"], hve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["checkboxInput"]
  }, $n, t);
}, Q4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = pe(t, mve), [, c] = C.useState(!1), f = Tn(), m = Ht(), h = {
    classes: m.classes
  }, v = hve(h), b = Nt(f, n4), x = Nt(f, tl), E = Nt(f, Kb), T = Nt(f, j4), P = C.useMemo(() => typeof m.isRowSelectable != "function" ? x : x.filter((W) => f.current.getRow(W) ? m.isRowSelectable(f.current.getRowParams(W)) : !1), [f, m.isRowSelectable, x]), O = C.useMemo(() => (!m.pagination || !m.checkboxSelectionVisibleOnly ? E : T).reduce((Y, H) => (Y[H] = !0, Y), {}), [m.pagination, m.checkboxSelectionVisibleOnly, T, E]), k = C.useMemo(() => P.filter((W) => O[W]).length, [P, O]), I = k > 0 && k < Object.keys(O).length, $ = k > 0, _ = (W) => {
    const Y = {
      value: W.target.checked
    };
    f.current.publishEvent("headerSelectionCheckboxChange", Y);
  }, z = b !== null && b.field === t.field ? 0 : -1;
  C.useLayoutEffect(() => {
    const W = f.current.getColumnHeaderElement(t.field);
    z === 0 && W && (W.tabIndex = -1);
  }, [z, f, t.field]);
  const V = C.useCallback((W) => {
    W.key === " " && f.current.publishEvent("headerSelectionCheckboxChange", {
      value: !$
    });
  }, [f, $]), M = C.useCallback(() => {
    c((W) => !W);
  }, []);
  C.useEffect(() => f.current.subscribeEvent("rowSelectionChange", M), [f, M]);
  const A = f.current.getLocaleText($ ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
  return /* @__PURE__ */ L(m.slots.baseCheckbox, S({
    ref: o,
    indeterminate: I,
    checked: $,
    onChange: _,
    className: v.root,
    inputProps: {
      "aria-label": A
    },
    tabIndex: z,
    onKeyDown: V
  }, (i = m.slotProps) == null ? void 0 : i.baseCheckbox, s));
});
process.env.NODE_ENV !== "production" && (Q4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The column of the current header component.
   */
  colDef: n.object.isRequired,
  /**
   * The column field of the column that triggered the event
   */
  field: n.string.isRequired
});
const CA = rn(/* @__PURE__ */ L("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward"), SA = rn(/* @__PURE__ */ L("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"), xA = rn(/* @__PURE__ */ L("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight"), wA = rn(/* @__PURE__ */ L("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), gve = rn(/* @__PURE__ */ L("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList"), EA = rn(/* @__PURE__ */ L("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt"), vve = rn(/* @__PURE__ */ L("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
rn(/* @__PURE__ */ L("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
rn(/* @__PURE__ */ L("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const bve = rn(/* @__PURE__ */ L("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon"), yve = rn(/* @__PURE__ */ L("path", {
  d: "M11 19V5h2v14z"
}), "Separator"), Cve = rn(/* @__PURE__ */ L("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline"), Sve = rn(/* @__PURE__ */ L("path", {
  d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows"), xve = rn(/* @__PURE__ */ L("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream"), wve = rn(/* @__PURE__ */ L("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical"), pR = rn(/* @__PURE__ */ L("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), TA = rn(/* @__PURE__ */ L("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), Eve = rn(/* @__PURE__ */ L("path", {
  d: "M19 13H5v-2h14v2z"
}), "Remove"), Tve = rn(/* @__PURE__ */ L("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load"), OA = rn(/* @__PURE__ */ L("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag"), Ove = rn(/* @__PURE__ */ L("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt"), Rve = rn(/* @__PURE__ */ L("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), kve = rn(/* @__PURE__ */ L("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert"), Pve = rn(/* @__PURE__ */ L("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff"), Mve = rn(/* @__PURE__ */ L("g", {
  children: /* @__PURE__ */ L("path", {
    d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
  })
}), "ViewColumn"), Ive = rn(/* @__PURE__ */ L("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
rn(/* @__PURE__ */ L("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const Nve = rn(/* @__PURE__ */ L("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete"), $ve = ["hideMenu", "colDef", "id", "labelledby", "className", "children", "open"], Dve = se(Dx)(() => ({
  minWidth: 248
})), Z4 = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    hideMenu: i,
    id: s,
    labelledby: c,
    className: f,
    children: m,
    open: h
  } = t, v = pe(t, $ve), b = C.useCallback((x) => {
    qP(x.key) && x.preventDefault(), x4(x.key) && i(x);
  }, [i]);
  return /* @__PURE__ */ L(Dve, S({
    id: s,
    ref: o,
    className: be(Te.menuList, f),
    "aria-labelledby": c,
    onKeyDown: b,
    autoFocus: h
  }, v, {
    children: m
  }));
});
process.env.NODE_ENV !== "production" && (Z4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  hideMenu: n.func.isRequired,
  id: n.string,
  labelledby: n.string,
  open: n.bool.isRequired
});
const _ve = ["displayOrder"], Ave = (e) => {
  const t = Cd(), {
    defaultSlots: o,
    defaultSlotProps: i,
    slots: s = {},
    slotProps: c = {},
    hideMenu: f,
    colDef: m,
    addDividers: h = !0
  } = e, v = C.useMemo(() => S({}, o, s), [o, s]), b = C.useMemo(() => {
    if (!c || Object.keys(c).length === 0)
      return i;
    const T = S({}, c);
    return Object.entries(i).forEach(([P, O]) => {
      T[P] = S({}, O, c[P] || {});
    }), T;
  }, [i, c]), x = t.current.unstable_applyPipeProcessors("columnMenu", [], e.colDef), E = C.useMemo(() => {
    const T = Object.keys(o);
    return Object.keys(s).filter((P) => !T.includes(P));
  }, [s, o]);
  return C.useMemo(() => {
    const O = Array.from(/* @__PURE__ */ new Set([...x, ...E])).filter((k) => v[k] != null).sort((k, I) => {
      const $ = b[k], _ = b[I], z = Number.isFinite($ == null ? void 0 : $.displayOrder) ? $.displayOrder : 100, V = Number.isFinite(_ == null ? void 0 : _.displayOrder) ? _.displayOrder : 100;
      return z - V;
    });
    return O.reduce((k, I, $) => {
      let _ = {
        colDef: m,
        onClick: f
      };
      const z = b[I];
      if (z) {
        const V = pe(z, _ve);
        _ = S({}, _, V);
      }
      return h && $ !== O.length - 1 ? [...k, [v[I], _], [Kte, {}]] : [...k, [v[I], _]];
    }, []);
  }, [h, m, x, f, v, b, E]);
};
function J4(e) {
  const {
    colDef: t,
    onClick: o
  } = e, i = Tn(), s = Ht(), m = la(i).filter((v) => v.disableColumnMenu !== !0).length === 1, h = C.useCallback((v) => {
    m || (i.current.setColumnVisibility(t.field, !1), o(v));
  }, [i, t.field, o, m]);
  return s.disableColumnSelector || t.hideable === !1 ? null : /* @__PURE__ */ ht(Vs, {
    onClick: h,
    disabled: m,
    children: [/* @__PURE__ */ L(Eh, {
      children: /* @__PURE__ */ L(s.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ L(Th, {
      children: i.current.getLocaleText("columnMenuHideColumn")
    })]
  });
}
process.env.NODE_ENV !== "production" && (J4.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  onClick: n.func.isRequired
});
function eB(e) {
  const {
    onClick: t
  } = e, o = Tn(), i = Ht(), s = C.useCallback((c) => {
    t(c), o.current.showPreferences(op.columns);
  }, [o, t]);
  return i.disableColumnSelector ? null : /* @__PURE__ */ ht(Vs, {
    onClick: s,
    children: [/* @__PURE__ */ L(Eh, {
      children: /* @__PURE__ */ L(i.slots.columnMenuManageColumnsIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ L(Th, {
      children: o.current.getLocaleText("columnMenuManageColumns")
    })]
  });
}
process.env.NODE_ENV !== "production" && (eB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  onClick: n.func.isRequired
});
function tB(e) {
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(J4, S({}, e)), /* @__PURE__ */ L(eB, S({}, e))]
  });
}
process.env.NODE_ENV !== "production" && (tB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  onClick: n.func.isRequired
});
function nB(e) {
  const {
    colDef: t,
    onClick: o
  } = e, i = Tn(), s = Ht(), c = C.useCallback((f) => {
    o(f), i.current.showFilterPanel(t.field);
  }, [i, t.field, o]);
  return s.disableColumnFilter || !t.filterable ? null : /* @__PURE__ */ ht(Vs, {
    onClick: c,
    children: [/* @__PURE__ */ L(Eh, {
      children: /* @__PURE__ */ L(s.slots.columnMenuFilterIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ L(Th, {
      children: i.current.getLocaleText("columnMenuFilter")
    })]
  });
}
process.env.NODE_ENV !== "production" && (nB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  onClick: n.func.isRequired
});
function rB(e) {
  var t;
  const {
    colDef: o,
    onClick: i
  } = e, s = Tn(), c = Nt(s, el), f = Ht(), m = C.useMemo(() => {
    if (!o)
      return null;
    const b = c.find((x) => x.field === o.field);
    return b == null ? void 0 : b.sort;
  }, [o, c]), h = (t = o.sortingOrder) != null ? t : f.sortingOrder, v = C.useCallback((b) => {
    i(b);
    const x = b.currentTarget.getAttribute("data-value") || null;
    s.current.sortColumn(o, x === m ? null : x);
  }, [s, o, i, m]);
  return !o || !o.sortable || !h.some((b) => !!b) ? null : /* @__PURE__ */ ht(C.Fragment, {
    children: [h.includes("asc") && m !== "asc" ? /* @__PURE__ */ ht(Vs, {
      onClick: v,
      "data-value": "asc",
      children: [/* @__PURE__ */ L(Eh, {
        children: /* @__PURE__ */ L(f.slots.columnMenuSortAscendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ L(Th, {
        children: s.current.getLocaleText("columnMenuSortAsc")
      })]
    }) : null, h.includes("desc") && m !== "desc" ? /* @__PURE__ */ ht(Vs, {
      onClick: v,
      "data-value": "desc",
      children: [/* @__PURE__ */ L(Eh, {
        children: /* @__PURE__ */ L(f.slots.columnMenuSortDescendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ L(Th, {
        children: s.current.getLocaleText("columnMenuSortDesc")
      })]
    }) : null, h.includes(null) && m != null ? /* @__PURE__ */ ht(Vs, {
      onClick: v,
      children: [/* @__PURE__ */ L(Eh, {}), /* @__PURE__ */ L(Th, {
        children: s.current.getLocaleText("columnMenuUnsort")
      })]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (rB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  onClick: n.func.isRequired
});
const Lve = ["defaultSlots", "defaultSlotProps", "slots", "slotProps"], Fve = {
  columnMenuSortItem: rB,
  columnMenuFilterItem: nB,
  columnMenuColumnsItem: tB
}, zve = {
  columnMenuSortItem: {
    displayOrder: 10
  },
  columnMenuFilterItem: {
    displayOrder: 20
  },
  columnMenuColumnsItem: {
    displayOrder: 30
  }
}, Vve = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    defaultSlots: i,
    defaultSlotProps: s,
    slots: c,
    slotProps: f
  } = t, m = pe(t, Lve), h = Ave(S({}, m, {
    defaultSlots: i,
    defaultSlotProps: s,
    slots: c,
    slotProps: f
  }));
  return /* @__PURE__ */ L(Z4, S({
    ref: o
  }, m, {
    children: h.map(([v, b], x) => /* @__PURE__ */ L(v, S({}, b), x))
  }));
}), oB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  return /* @__PURE__ */ L(Vve, S({}, t, {
    ref: o,
    defaultSlots: Fve,
    defaultSlotProps: zve
  }));
});
process.env.NODE_ENV !== "production" && (oB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: n.object.isRequired,
  hideMenu: n.func.isRequired,
  id: n.string,
  labelledby: n.string,
  open: n.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: n.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: n.object
});
const Bve = ["className"], jve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["panelContent"]
  }, $n, t);
}, Hve = xo("div", {
  name: "MuiDataGrid",
  slot: "PanelContent",
  overridesResolver: (e, t) => t.panelContent
})({
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400
});
function QP(e) {
  const {
    className: t
  } = e, o = pe(e, Bve), i = Ht(), s = jve(i);
  return /* @__PURE__ */ L(Hve, S({
    className: be(t, s.root),
    ownerState: i
  }, o));
}
process.env.NODE_ENV !== "production" && (QP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Uve = ["className"], Gve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["panelFooter"]
  }, $n, t);
}, Wve = xo("div", {
  name: "MuiDataGrid",
  slot: "PanelFooter",
  overridesResolver: (e, t) => t.panelFooter
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5),
  display: "flex",
  justifyContent: "space-between"
}));
function ZP(e) {
  const {
    className: t
  } = e, o = pe(e, Uve), i = Ht(), s = Gve(i);
  return /* @__PURE__ */ L(Wve, S({
    className: be(t, s.root),
    ownerState: i
  }, o));
}
process.env.NODE_ENV !== "production" && (ZP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const qve = ["className"], Yve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["panelHeader"]
  }, $n, t);
}, Kve = xo("div", {
  name: "MuiDataGrid",
  slot: "PanelHeader",
  overridesResolver: (e, t) => t.panelHeader
})(({
  theme: e
}) => ({
  padding: e.spacing(1)
}));
function aB(e) {
  const {
    className: t
  } = e, o = pe(e, qve), i = Ht(), s = Yve(i);
  return /* @__PURE__ */ L(Kve, S({
    className: be(t, s.root),
    ownerState: i
  }, o));
}
process.env.NODE_ENV !== "production" && (aB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Xve = ["className", "slotProps"], Qve = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["panelWrapper"]
  }, $n, t);
}, Zve = se("div", {
  name: "MuiDataGrid",
  slot: "PanelWrapper",
  overridesResolver: (e, t) => t.panelWrapper
})({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  "&:focus": {
    outline: 0
  }
}), Jve = () => !0, JP = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i,
    slotProps: s = {}
  } = t, c = pe(t, Xve), f = Ht(), m = Qve(f);
  return /* @__PURE__ */ L(ey, S({
    open: !0,
    disableEnforceFocus: !0,
    isEnabled: Jve
  }, s.TrapFocus, {
    children: /* @__PURE__ */ L(Zve, S({
      ref: o,
      tabIndex: -1,
      className: be(i, m.root),
      ownerState: f
    }, c))
  }));
});
process.env.NODE_ENV !== "production" && (JP.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: n.object
});
const ebe = !1, tbe = ["sort", "searchPredicate", "autoFocusSearchField", "disableHideAllButton", "disableShowAllButton", "getTogglableColumns"], nbe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["columnsPanel"],
    columnsPanelRow: ["columnsPanelRow"]
  }, $n, t);
}, rbe = se("div", {
  name: "MuiDataGrid",
  slot: "ColumnsPanel",
  overridesResolver: (e, t) => t.columnsPanel
})({
  padding: "8px 0px 8px 8px"
}), obe = se("div", {
  name: "MuiDataGrid",
  slot: "ColumnsPanelRow",
  overridesResolver: (e, t) => t.columnsPanelRow
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "1px 8px 1px 7px",
  [`& .${wa.root}`]: {
    marginRight: e.spacing(0.5)
  }
})), abe = se(As)({
  justifyContent: "flex-end"
}), RA = new Intl.Collator(), ibe = (e, t) => (e.headerName || e.field).toLowerCase().indexOf(t) > -1;
function iB(e) {
  var t, o, i;
  const s = Tn(), c = C.useRef(null), f = Nt(s, Bs), m = Nt(s, Hl), h = Ht(), [v, b] = C.useState(""), x = nbe(h), {
    sort: E,
    searchPredicate: T = ibe,
    autoFocusSearchField: P = !0,
    disableHideAllButton: O = !1,
    disableShowAllButton: k = !1,
    getTogglableColumns: I
  } = e, $ = pe(e, tbe), _ = C.useMemo(() => {
    switch (E) {
      case "asc":
        return [...f].sort((G, ne) => RA.compare(G.headerName || G.field, ne.headerName || ne.field));
      case "desc":
        return [...f].sort((G, ne) => -RA.compare(G.headerName || G.field, ne.headerName || ne.field));
      default:
        return f;
    }
  }, [f, E]), z = (G) => {
    const {
      name: ne
    } = G.target;
    s.current.setColumnVisibility(ne, m[ne] === !1);
  }, V = C.useCallback((G) => {
    const ne = Hl(s), K = S({}, ne), B = I ? I(f) : null;
    return f.forEach((q) => {
      q.hideable && (B == null || B.includes(q.field)) && (G ? delete K[q.field] : K[q.field] = !1);
    }), s.current.setColumnVisibilityModel(K);
  }, [s, f, I]), M = C.useCallback((G) => {
    b(G.target.value);
  }, []), A = C.useMemo(() => {
    const G = I ? I(_) : null, ne = G ? _.filter(({
      field: K
    }) => G.includes(K)) : _;
    return v ? ne.filter((K) => T(K, v.toLowerCase())) : ne;
  }, [_, v, T, I]), W = C.useRef(null);
  C.useEffect(() => {
    P ? c.current.focus() : W.current && typeof W.current.focus == "function" && W.current.focus();
  }, [P]);
  let Y = !1;
  const H = (G) => Y === !1 && G.hideable !== !1 ? (Y = !0, !0) : !1;
  return /* @__PURE__ */ ht(JP, S({}, $, {
    children: [/* @__PURE__ */ L(aB, {
      children: /* @__PURE__ */ L(h.slots.baseTextField, S({
        label: s.current.getLocaleText("columnsPanelTextFieldLabel"),
        placeholder: s.current.getLocaleText("columnsPanelTextFieldPlaceholder"),
        inputRef: c,
        value: v,
        onChange: M,
        variant: "standard",
        fullWidth: !0
      }, (t = h.slotProps) == null ? void 0 : t.baseTextField))
    }), /* @__PURE__ */ L(QP, {
      children: /* @__PURE__ */ L(rbe, {
        className: x.root,
        ownerState: h,
        children: A.map((G) => {
          var ne;
          return /* @__PURE__ */ ht(obe, {
            className: x.columnsPanelRow,
            ownerState: h,
            children: [/* @__PURE__ */ L(Pne, {
              control: /* @__PURE__ */ L(h.slots.baseSwitch, S({
                disabled: G.hideable === !1,
                checked: m[G.field] !== !1,
                onClick: z,
                name: G.field,
                size: "small",
                inputRef: H(G) ? W : void 0
              }, (ne = h.slotProps) == null ? void 0 : ne.baseSwitch)),
              label: G.headerName || G.field
            }), !h.disableColumnReorder && ebe && /* @__PURE__ */ L(abe, {
              draggable: !0,
              "aria-label": s.current.getLocaleText("columnsPanelDragIconLabel"),
              title: s.current.getLocaleText("columnsPanelDragIconLabel"),
              size: "small",
              disabled: !0,
              children: /* @__PURE__ */ L(h.slots.columnReorderIcon, {})
            })]
          }, G.field);
        })
      })
    }), k && O ? null : /* @__PURE__ */ ht(ZP, {
      children: [O ? /* @__PURE__ */ L("span", {}) : /* @__PURE__ */ L(h.slots.baseButton, S({
        onClick: () => V(!1)
      }, (o = h.slotProps) == null ? void 0 : o.baseButton, {
        disabled: O,
        children: s.current.getLocaleText("columnsPanelHideAllButton")
      })), k ? null : /* @__PURE__ */ L(h.slots.baseButton, S({
        onClick: () => V(!0)
      }, (i = h.slotProps) == null ? void 0 : i.baseButton, {
        disabled: k,
        children: s.current.getLocaleText("columnsPanelShowAllButton")
      }))]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (iB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */
  autoFocusSearchField: n.bool,
  /**
   * If `true`, the `Hide all` button will not be displayed.
   * @default false
   */
  disableHideAllButton: n.bool,
  /**
   * If `true`, the `Show all` button will be disabled
   * @default false
   */
  disableShowAllButton: n.bool,
  /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */
  getTogglableColumns: n.func,
  searchPredicate: n.func,
  slotProps: n.object,
  sort: n.oneOf(["asc", "desc"])
});
const lbe = ["children", "className", "classes"], sbe = lt("MuiDataGrid", ["panel", "paper"]), cbe = se(cp, {
  name: "MuiDataGrid",
  slot: "Panel",
  overridesResolver: (e, t) => t.panel
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), ube = se(Ci, {
  name: "MuiDataGrid",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  minWidth: 300,
  maxHeight: 450,
  display: "flex"
})), lB = /* @__PURE__ */ C.forwardRef((e, t) => {
  const {
    children: o,
    className: i
  } = e, s = pe(e, lbe), c = Tn(), f = Ht(), m = sbe, [h, v] = C.useState(!1), b = C.useCallback(() => {
    c.current.hidePreferences();
  }, [c]), x = C.useCallback((O) => {
    tx(O.key) && c.current.hidePreferences();
  }, [c]), E = C.useMemo(() => [{
    name: "flip",
    enabled: !1
  }, {
    name: "isPlaced",
    enabled: !0,
    phase: "main",
    fn: () => {
      v(!0);
    },
    effect: () => () => {
      v(!1);
    }
  }], []), [T, P] = C.useState(null);
  return C.useEffect(() => {
    var O;
    const k = (O = c.current.rootElementRef) == null || (O = O.current) == null ? void 0 : O.querySelector(`.${Te.columnHeaders}`);
    k && P(k);
  }, [c]), T ? /* @__PURE__ */ L(cbe, S({
    ref: t,
    placement: "bottom-start",
    className: be(i, m.panel),
    ownerState: f,
    anchorEl: T,
    modifiers: E
  }, s, {
    children: /* @__PURE__ */ L($h, {
      mouseEvent: "onMouseUp",
      onClickAway: b,
      children: /* @__PURE__ */ L(ube, {
        className: m.paper,
        ownerState: f,
        elevation: 8,
        onKeyDown: x,
        children: h && o
      })
    })
  })) : null;
});
process.env.NODE_ENV !== "production" && (lB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Popper render function or node.
   */
  children: n.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * If `true`, the component is shown.
   */
  open: n.bool.isRequired,
  ownerState: n.object
});
const dbe = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c;
  const f = Tn(), m = Nt(f, Bs), h = Ht(), v = Nt(f, py), b = f.current.unstable_applyPipeProcessors("preferencePanel", null, (i = v.openedPanelValue) != null ? i : op.filters);
  return /* @__PURE__ */ L(h.slots.panel, S({
    ref: o,
    as: h.slots.basePopper,
    open: m.length > 0 && v.open,
    id: v.panelId,
    "aria-labelledby": v.labelId
  }, (s = h.slotProps) == null ? void 0 : s.panel, t, (c = h.slotProps) == null ? void 0 : c.basePopper, {
    children: b
  }));
}), fbe = ["item", "hasMultipleFilters", "deleteFilter", "applyFilterChanges", "multiFilterOperator", "showMultiFilterOperators", "disableMultiFilterOperator", "applyMultiFilterOperatorChanges", "focusElementRef", "logicOperators", "columnsSort", "filterColumns", "deleteIconProps", "logicOperatorInputProps", "operatorInputProps", "columnInputProps", "valueInputProps", "children"], pbe = ["InputComponentProps"], mbe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["filterForm"],
    deleteIcon: ["filterFormDeleteIcon"],
    logicOperatorInput: ["filterFormLogicOperatorInput"],
    columnInput: ["filterFormColumnInput"],
    operatorInput: ["filterFormOperatorInput"],
    valueInput: ["filterFormValueInput"]
  }, $n, t);
}, hbe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterForm",
  overridesResolver: (e, t) => t.filterForm
})(({
  theme: e
}) => ({
  display: "flex",
  padding: e.spacing(1)
})), gbe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterFormDeleteIcon",
  overridesResolver: (e, t) => t.filterFormDeleteIcon
})(({
  theme: e
}) => ({
  flexShrink: 0,
  justifyContent: "flex-end",
  marginRight: e.spacing(0.5),
  marginBottom: e.spacing(0.2)
})), vbe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterFormLogicOperatorInput",
  overridesResolver: (e, t) => t.filterFormLogicOperatorInput
})({
  minWidth: 55,
  marginRight: 5,
  justifyContent: "end"
}), bbe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterFormColumnInput",
  overridesResolver: (e, t) => t.filterFormColumnInput
})({
  width: 150
}), ybe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterFormOperatorInput",
  overridesResolver: (e, t) => t.filterFormOperatorInput
})({
  width: 120
}), Cbe = se("div", {
  name: "MuiDataGrid",
  slot: "FilterFormValueInput",
  overridesResolver: (e, t) => t.filterFormValueInput
})({
  width: 190
}), Sbe = (e) => {
  switch (e) {
    case pi.And:
      return "filterPanelOperatorAnd";
    case pi.Or:
      return "filterPanelOperatorOr";
    default:
      throw new Error("MUI: Invalid `logicOperator` property in the `GridFilterPanel`.");
  }
}, Mb = (e) => e.headerName || e.field, kA = new Intl.Collator(), sB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s, c, f, m, h, v, b, x, E;
  const {
    item: T,
    hasMultipleFilters: P,
    deleteFilter: O,
    applyFilterChanges: k,
    multiFilterOperator: I,
    showMultiFilterOperators: $,
    disableMultiFilterOperator: _,
    applyMultiFilterOperatorChanges: z,
    focusElementRef: V,
    logicOperators: M = [pi.And, pi.Or],
    columnsSort: A,
    filterColumns: W,
    deleteIconProps: Y = {},
    logicOperatorInputProps: H = {},
    operatorInputProps: G = {},
    columnInputProps: ne = {},
    valueInputProps: K = {}
  } = t, B = pe(t, fbe), q = Tn(), X = Nt(q, K5), J = Nt(q, oa), U = Qn(), Z = Qn(), ee = Qn(), ie = Qn(), oe = Ht(), le = mbe(oe), de = C.useRef(null), Ce = C.useRef(null), me = P && M.length > 0, Oe = ((i = oe.slotProps) == null ? void 0 : i.baseFormControl) || {}, $e = (c = (((s = oe.slotProps) == null ? void 0 : s.baseSelect) || {}).native) != null ? c : !0, Ne = ((f = oe.slotProps) == null ? void 0 : f.baseInputLabel) || {}, Pe = ((m = oe.slotProps) == null ? void 0 : m.baseSelectOption) || {}, {
    InputComponentProps: Se
  } = K, Fe = pe(K, pbe), ce = C.useMemo(() => {
    if (W === void 0 || typeof W != "function")
      return X;
    const Be = W({
      field: T.field,
      columns: X,
      currentFilters: (J == null ? void 0 : J.items) || []
    });
    return X.filter((rt) => Be.includes(rt.field));
  }, [W, J == null ? void 0 : J.items, X, T.field]), ge = C.useMemo(() => {
    switch (A) {
      case "asc":
        return ce.sort((Be, rt) => kA.compare(Mb(Be), Mb(rt)));
      case "desc":
        return ce.sort((Be, rt) => -kA.compare(Mb(Be), Mb(rt)));
      default:
        return ce;
    }
  }, [ce, A]), we = T.field ? q.current.getColumn(T.field) : null, Me = C.useMemo(() => {
    var Be;
    return !T.operator || !we ? null : (Be = we.filterOperators) == null ? void 0 : Be.find((rt) => rt.value === T.operator);
  }, [T, we]), Qe = C.useCallback((Be) => {
    const rt = Be.target.value, wt = q.current.getColumn(rt);
    if (wt.field === we.field)
      return;
    const We = wt.filterOperators.find((ft) => ft.value === T.operator) || wt.filterOperators[0], ut = !We.InputComponent || We.InputComponent !== (Me == null ? void 0 : Me.InputComponent);
    k(S({}, T, {
      field: rt,
      operator: We.value,
      value: ut ? void 0 : T.value
    }));
  }, [q, k, T, we, Me]), ct = C.useCallback((Be) => {
    const rt = Be.target.value, wt = we == null ? void 0 : we.filterOperators.find((ut) => ut.value === rt), We = !(wt != null && wt.InputComponent) || (wt == null ? void 0 : wt.InputComponent) !== (Me == null ? void 0 : Me.InputComponent);
    k(S({}, T, {
      operator: rt,
      value: We ? void 0 : T.value
    }));
  }, [k, T, we, Me]), Ze = C.useCallback((Be) => {
    const rt = Be.target.value === pi.And.toString() ? pi.And : pi.Or;
    z(rt);
  }, [z]), Ge = () => {
    oe.disableMultipleColumnsFiltering ? T.value === void 0 ? O(T) : k(S({}, T, {
      value: void 0
    })) : O(T);
  };
  return C.useImperativeHandle(V, () => ({
    focus: () => {
      if (Me != null && Me.InputComponent) {
        var Be;
        de == null || (Be = de.current) == null || Be.focus();
      } else
        Ce.current.focus();
    }
  }), [Me]), /* @__PURE__ */ ht(hbe, S({
    ref: o,
    className: le.root,
    "data-id": T.id,
    ownerState: oe
  }, B, {
    children: [/* @__PURE__ */ L(gbe, S({
      variant: "standard",
      as: oe.slots.baseFormControl
    }, Oe, Y, {
      className: be(le.deleteIcon, Oe.className, Y.className),
      ownerState: oe,
      children: /* @__PURE__ */ L(oe.slots.baseIconButton, S({
        "aria-label": q.current.getLocaleText("filterPanelDeleteIconLabel"),
        title: q.current.getLocaleText("filterPanelDeleteIconLabel"),
        onClick: Ge,
        size: "small"
      }, (h = oe.slotProps) == null ? void 0 : h.baseIconButton, {
        children: /* @__PURE__ */ L(oe.slots.filterPanelDeleteIcon, {
          fontSize: "small"
        })
      }))
    })), /* @__PURE__ */ L(vbe, S({
      variant: "standard",
      as: oe.slots.baseFormControl
    }, Oe, H, {
      sx: S({
        display: me ? "flex" : "none",
        visibility: $ ? "visible" : "hidden"
      }, Oe.sx || {}, H.sx || {}),
      className: be(le.logicOperatorInput, Oe.className, H.className),
      ownerState: oe,
      children: /* @__PURE__ */ L(oe.slots.baseSelect, S({
        inputProps: {
          "aria-label": q.current.getLocaleText("filterPanelLogicOperator")
        },
        value: I,
        onChange: Ze,
        disabled: !!_ || M.length === 1,
        native: $e
      }, (v = oe.slotProps) == null ? void 0 : v.baseSelect, {
        children: M.map((Be) => /* @__PURE__ */ Ch(oe.slots.baseSelectOption, S({}, Pe, {
          native: $e,
          key: Be.toString(),
          value: Be.toString()
        }), q.current.getLocaleText(Sbe(Be))))
      }))
    })), /* @__PURE__ */ ht(bbe, S({
      variant: "standard",
      as: oe.slots.baseFormControl
    }, Oe, ne, {
      className: be(le.columnInput, Oe.className, ne.className),
      ownerState: oe,
      children: [/* @__PURE__ */ L(oe.slots.baseInputLabel, S({}, Ne, {
        htmlFor: U,
        id: Z,
        children: q.current.getLocaleText("filterPanelColumns")
      })), /* @__PURE__ */ L(oe.slots.baseSelect, S({
        labelId: Z,
        id: U,
        label: q.current.getLocaleText("filterPanelColumns"),
        value: T.field || "",
        onChange: Qe,
        native: $e
      }, (b = oe.slotProps) == null ? void 0 : b.baseSelect, {
        children: ge.map((Be) => /* @__PURE__ */ Ch(oe.slots.baseSelectOption, S({}, Pe, {
          native: $e,
          key: Be.field,
          value: Be.field
        }), Mb(Be)))
      }))]
    })), /* @__PURE__ */ ht(ybe, S({
      variant: "standard",
      as: oe.slots.baseFormControl
    }, Oe, G, {
      className: be(le.operatorInput, Oe.className, G.className),
      ownerState: oe,
      children: [/* @__PURE__ */ L(oe.slots.baseInputLabel, S({}, Ne, {
        htmlFor: ee,
        id: ie,
        children: q.current.getLocaleText("filterPanelOperator")
      })), /* @__PURE__ */ L(oe.slots.baseSelect, S({
        labelId: ie,
        label: q.current.getLocaleText("filterPanelOperator"),
        id: ee,
        value: T.operator,
        onChange: ct,
        native: $e,
        inputRef: Ce
      }, (x = oe.slotProps) == null ? void 0 : x.baseSelect, {
        children: we == null || (E = we.filterOperators) == null ? void 0 : E.map((Be) => /* @__PURE__ */ Ch(oe.slots.baseSelectOption, S({}, Pe, {
          native: $e,
          key: Be.value,
          value: Be.value
        }), Be.label || q.current.getLocaleText(`filterOperator${ve(Be.value)}`)))
      }))]
    })), /* @__PURE__ */ L(Cbe, S({
      variant: "standard",
      as: oe.slots.baseFormControl
    }, Oe, Fe, {
      className: be(le.valueInput, Oe.className, Fe.className),
      ownerState: oe,
      children: Me != null && Me.InputComponent ? /* @__PURE__ */ L(Me.InputComponent, S({
        apiRef: q,
        item: T,
        applyValue: k,
        focusElementRef: de
      }, Me.InputComponentProps, Se)) : null
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (sB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */
  applyFilterChanges: n.func.isRequired,
  /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */
  applyMultiFilterOperatorChanges: n.func.isRequired,
  /**
   * @ignore - do not document.
   */
  children: n.node,
  /**
   * Props passed to the column input component.
   * @default {}
   */
  columnInputProps: n.any,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: n.oneOf(["asc", "desc"]),
  /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */
  deleteFilter: n.func.isRequired,
  /**
   * Props passed to the delete icon.
   * @default {}
   */
  deleteIconProps: n.any,
  /**
   * If `true`, disables the logic operator field but still renders it.
   */
  disableMultiFilterOperator: n.bool,
  /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */
  filterColumns: n.func,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */
  focusElementRef: n.oneOfType([n.func, n.object]),
  /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */
  hasMultipleFilters: n.bool.isRequired,
  /**
   * The [[GridFilterItem]] representing this form.
   */
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired,
  /**
   * Props passed to the logic operator input component.
   * @default {}
   */
  logicOperatorInputProps: n.any,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: n.arrayOf(n.oneOf(["and", "or"]).isRequired),
  /**
   * The current logic operator applied.
   */
  multiFilterOperator: n.oneOf(["and", "or"]),
  /**
   * Props passed to the operator input component.
   * @default {}
   */
  operatorInputProps: n.any,
  /**
   * If `true`, the logic operator field is visible.
   */
  showMultiFilterOperators: n.bool,
  /**
   * Props passed to the value input component.
   * @default {}
   */
  valueInputProps: n.any
});
class eM {
  constructor() {
    this.currentId = 0, this.clear = () => {
      this.currentId !== 0 && (clearTimeout(this.currentId), this.currentId = 0);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new eM();
  }
  start(t, o) {
    this.clear(), this.currentId = setTimeout(o, t);
  }
}
function tM() {
  const e = FP(eM.create).current;
  return q5(e.disposeEffect), e;
}
const xbe = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps"];
function Vl(e) {
  var t, o;
  const {
    item: i,
    applyValue: s,
    type: c,
    apiRef: f,
    focusElementRef: m,
    tabIndex: h,
    disabled: v,
    clearButton: b,
    InputProps: x
  } = e, E = pe(e, xbe), T = tM(), [P, O] = C.useState((t = i.value) != null ? t : ""), [k, I] = C.useState(!1), $ = Qn(), _ = Ht(), z = C.useCallback((V) => {
    const {
      value: M
    } = V.target;
    O(String(M)), I(!0), T.start(_.filterDebounceMs, () => {
      const A = S({}, i, {
        value: M,
        fromInput: $
      });
      s(A), I(!1);
    });
  }, [$, s, i, _.filterDebounceMs, T]);
  return C.useEffect(() => {
    if (i.fromInput !== $) {
      var M;
      O(String((M = i.value) != null ? M : ""));
    }
  }, [$, i]), /* @__PURE__ */ L(_.slots.baseTextField, S({
    id: $,
    label: f.current.getLocaleText("filterPanelInputLabel"),
    placeholder: f.current.getLocaleText("filterPanelInputPlaceholder"),
    value: P,
    onChange: z,
    variant: "standard",
    type: c || "text",
    InputProps: S({}, k || b ? {
      endAdornment: k ? /* @__PURE__ */ L(_.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : b
    } : {}, {
      disabled: v
    }, x, {
      inputProps: S({
        tabIndex: h
      }, x == null ? void 0 : x.inputProps)
    }),
    InputLabelProps: {
      shrink: !0
    },
    inputRef: m
  }, E, (o = _.slotProps) == null ? void 0 : o.baseTextField));
}
process.env.NODE_ENV !== "production" && (Vl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  clearButton: n.node,
  focusElementRef: n.oneOfType([n.func, n.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: n.bool,
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired
});
const wbe = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function Vf(e) {
  var t, o;
  const {
    item: i,
    applyValue: s,
    type: c,
    apiRef: f,
    focusElementRef: m,
    InputProps: h,
    clearButton: v,
    tabIndex: b,
    disabled: x
  } = e, E = pe(e, wbe), T = tM(), [P, O] = C.useState((t = i.value) != null ? t : ""), [k, I] = C.useState(!1), $ = Qn(), _ = Ht(), z = C.useCallback((V) => {
    const M = V.target.value;
    O(String(M)), I(!0), T.start(_.filterDebounceMs, () => {
      s(S({}, i, {
        value: M
      })), I(!1);
    });
  }, [s, i, _.filterDebounceMs, T]);
  return C.useEffect(() => {
    var V;
    const M = (V = i.value) != null ? V : "";
    O(String(M));
  }, [i.value]), /* @__PURE__ */ L(_.slots.baseTextField, S({
    fullWidth: !0,
    id: $,
    label: f.current.getLocaleText("filterPanelInputLabel"),
    placeholder: f.current.getLocaleText("filterPanelInputPlaceholder"),
    value: P,
    onChange: z,
    variant: "standard",
    type: c || "text",
    InputLabelProps: {
      shrink: !0
    },
    inputRef: m,
    InputProps: S({}, k || v ? {
      endAdornment: k ? /* @__PURE__ */ L(_.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : v
    } : {}, {
      disabled: x
    }, h, {
      inputProps: S({
        max: c === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
        tabIndex: b
      }, h == null ? void 0 : h.inputProps)
    })
  }, E, (o = _.slotProps) == null ? void 0 : o.baseTextField));
}
process.env.NODE_ENV !== "production" && (Vf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  clearButton: n.node,
  focusElementRef: n.oneOfType([n.func, n.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: n.bool,
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired
});
const Ebe = ["item", "applyValue", "type", "apiRef", "focusElementRef", "getOptionLabel", "getOptionValue", "placeholder", "tabIndex", "label", "isFilterActive", "clearButton", "InputLabelProps"], Tbe = ({
  column: {
    valueOptions: e,
    field: t
  },
  OptionComponent: o,
  getOptionLabel: i,
  getOptionValue: s,
  isSelectNative: c,
  baseSelectOptionProps: f
}) => (typeof e == "function" ? ["", ...e({
  field: t
})] : ["", ...e || []]).map((h) => {
  const v = s(h), b = i(h);
  return /* @__PURE__ */ Ch(o, S({}, f, {
    native: c,
    key: v,
    value: v
  }), b);
}), Obe = se("div")({
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function ak(e) {
  var t, o, i, s, c, f, m, h;
  const {
    item: v,
    applyValue: b,
    type: x,
    apiRef: E,
    focusElementRef: T,
    getOptionLabel: P,
    getOptionValue: O,
    placeholder: k,
    tabIndex: I,
    label: $,
    clearButton: _
  } = e, z = pe(e, Ebe), [V, M] = C.useState((t = v.value) != null ? t : ""), A = Qn(), W = Qn(), Y = Ht(), H = (o = (i = Y.slotProps) == null || (i = i.baseSelect) == null ? void 0 : i.native) != null ? o : !0;
  let G = null;
  if (v.field) {
    const J = E.current.getColumn(v.field);
    Xf(J) && (G = J);
  }
  const ne = O || ((s = G) == null ? void 0 : s.getOptionValue), K = P || ((c = G) == null ? void 0 : c.getOptionLabel), B = C.useMemo(() => {
    if (G)
      return typeof G.valueOptions == "function" ? G.valueOptions({
        field: G.field
      }) : G.valueOptions;
  }, [G]), q = C.useCallback((J) => {
    let U = J.target.value;
    U = ok(U, B, ne), M(String(U)), b(S({}, v, {
      value: U
    }));
  }, [B, ne, b, v]);
  if (C.useEffect(() => {
    var J;
    let U;
    if (B !== void 0) {
      if (U = ok(v.value, B, ne), U !== v.value) {
        b(S({}, v, {
          value: U
        }));
        return;
      }
    } else
      U = v.value;
    U = (J = U) != null ? J : "", M(String(U));
  }, [v, B, b, ne]), !Xf(G) || !Xf(G))
    return null;
  const X = $ ?? E.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ ht(Obe, {
    children: [/* @__PURE__ */ ht(Y.slots.baseFormControl, {
      children: [/* @__PURE__ */ L(Y.slots.baseInputLabel, S({}, (f = Y.slotProps) == null ? void 0 : f.baseInputLabel, {
        id: W,
        htmlFor: A,
        shrink: !0,
        variant: "standard",
        children: X
      })), /* @__PURE__ */ L(Y.slots.baseSelect, S({
        id: A,
        label: X,
        labelId: W,
        value: V,
        onChange: q,
        variant: "standard",
        type: x || "text",
        inputProps: {
          tabIndex: I,
          ref: T,
          placeholder: k ?? E.current.getLocaleText("filterPanelInputPlaceholder")
        },
        native: H
      }, z, (m = Y.slotProps) == null ? void 0 : m.baseSelect, {
        children: Tbe({
          column: G,
          OptionComponent: Y.slots.baseSelectOption,
          getOptionLabel: K,
          getOptionValue: ne,
          isSelectNative: H,
          baseSelectOptionProps: (h = Y.slotProps) == null ? void 0 : h.baseSelectOption
        })
      }))]
    }), _]
  });
}
process.env.NODE_ENV !== "production" && (ak.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  clearButton: n.node,
  focusElementRef: n.oneOfType([n.func, n.object]),
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: n.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: n.func,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: n.bool,
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired
});
const Rbe = ["item", "applyValue", "apiRef", "focusElementRef", "isFilterActive", "clearButton", "tabIndex", "label", "InputLabelProps"], kbe = se("div")({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function cB(e) {
  var t, o, i, s;
  const {
    item: c,
    applyValue: f,
    apiRef: m,
    focusElementRef: h,
    clearButton: v,
    tabIndex: b,
    label: x
  } = e, E = pe(e, Rbe), [T, P] = C.useState(c.value || ""), O = Ht(), k = Qn(), I = Qn(), $ = ((t = O.slotProps) == null ? void 0 : t.baseSelect) || {}, _ = (o = $.native) != null ? o : !0, z = ((i = O.slotProps) == null ? void 0 : i.baseSelectOption) || {}, V = C.useCallback((A) => {
    const W = A.target.value;
    P(W), f(S({}, c, {
      value: W
    }));
  }, [f, c]);
  C.useEffect(() => {
    P(c.value || "");
  }, [c.value]);
  const M = x ?? m.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ ht(kbe, {
    children: [/* @__PURE__ */ ht(O.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ L(O.slots.baseInputLabel, S({}, (s = O.slotProps) == null ? void 0 : s.baseInputLabel, {
        id: k,
        shrink: !0,
        variant: "standard",
        children: M
      })), /* @__PURE__ */ ht(O.slots.baseSelect, S({
        labelId: k,
        id: I,
        label: M,
        value: T,
        onChange: V,
        variant: "standard",
        native: _,
        displayEmpty: !0,
        inputProps: {
          ref: h,
          tabIndex: b
        }
      }, E, $, {
        children: [/* @__PURE__ */ L(O.slots.baseSelectOption, S({}, z, {
          native: _,
          value: "",
          children: m.current.getLocaleText("filterValueAny")
        })), /* @__PURE__ */ L(O.slots.baseSelectOption, S({}, z, {
          native: _,
          value: "true",
          children: m.current.getLocaleText("filterValueTrue")
        })), /* @__PURE__ */ L(O.slots.baseSelectOption, S({}, z, {
          native: _,
          value: "false",
          children: m.current.getLocaleText("filterValueFalse")
        }))]
      }))]
    }), v]
  });
}
process.env.NODE_ENV !== "production" && (cB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  clearButton: n.node,
  focusElementRef: Fo,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: n.bool,
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired
});
const Pbe = ["logicOperators", "columnsSort", "filterFormProps", "getColumnForNewFilter", "children", "disableAddFilterButton", "disableRemoveAllButton"], PA = (e) => ({
  field: e.field,
  operator: e.filterOperators[0].value,
  id: Math.round(Math.random() * 1e5)
}), uB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = Tn(), f = Ht(), m = Nt(c, oa), h = Nt(c, K5), v = C.useRef(null), b = C.useRef(null), {
    logicOperators: x = [pi.And, pi.Or],
    columnsSort: E,
    filterFormProps: T,
    getColumnForNewFilter: P,
    disableAddFilterButton: O = !1,
    disableRemoveAllButton: k = !1
  } = t, I = pe(t, Pbe), $ = c.current.upsertFilterItem, _ = C.useCallback((G) => {
    c.current.setFilterLogicOperator(G);
  }, [c]), z = C.useCallback(() => {
    let G;
    if (P && typeof P == "function") {
      const ne = P({
        currentFilters: (m == null ? void 0 : m.items) || [],
        columns: h
      });
      if (ne === null)
        return null;
      G = h.find(({
        field: K
      }) => K === ne);
    } else
      G = h.find((ne) => {
        var K;
        return (K = ne.filterOperators) == null ? void 0 : K.length;
      });
    return G ? PA(G) : null;
  }, [m == null ? void 0 : m.items, h, P]), V = C.useCallback(() => {
    if (P === void 0 || typeof P != "function")
      return z();
    const G = m.items.length ? m.items : [z()].filter(Boolean), ne = P({
      currentFilters: G,
      columns: h
    });
    if (ne === null)
      return null;
    const K = h.find(({
      field: B
    }) => B === ne);
    return K ? PA(K) : null;
  }, [m.items, h, P, z]), M = C.useMemo(() => m.items.length ? m.items : (b.current || (b.current = z()), b.current ? [b.current] : []), [m.items, z]), A = M.length > 1, W = () => {
    const G = V();
    G && c.current.upsertFilterItems([...M, G]);
  }, Y = C.useCallback((G) => {
    const ne = M.length === 1;
    c.current.deleteFilterItem(G), ne && c.current.hideFilterPanel();
  }, [c, M.length]), H = () => {
    M.length === 1 && M[0].value === void 0 && (c.current.deleteFilterItem(M[0]), c.current.hideFilterPanel()), c.current.setFilterModel(S({}, m, {
      items: []
    }));
  };
  return C.useEffect(() => {
    x.length > 0 && m.logicOperator && !x.includes(m.logicOperator) && _(x[0]);
  }, [x, _, m.logicOperator]), C.useEffect(() => {
    M.length > 0 && v.current.focus();
  }, [M.length]), /* @__PURE__ */ ht(JP, S({
    ref: o
  }, I, {
    children: [/* @__PURE__ */ L(QP, {
      children: M.map((G, ne) => /* @__PURE__ */ L(sB, S({
        item: G,
        applyFilterChanges: $,
        deleteFilter: Y,
        hasMultipleFilters: A,
        showMultiFilterOperators: ne > 0,
        multiFilterOperator: m.logicOperator,
        disableMultiFilterOperator: ne !== 1,
        applyMultiFilterOperatorChanges: _,
        focusElementRef: ne === M.length - 1 ? v : null,
        logicOperators: x,
        columnsSort: E
      }, T), G.id == null ? ne : G.id))
    }), !f.disableMultipleColumnsFiltering && !(O && k) ? /* @__PURE__ */ ht(ZP, {
      children: [O ? /* @__PURE__ */ L("span", {}) : /* @__PURE__ */ L(f.slots.baseButton, S({
        onClick: W,
        startIcon: /* @__PURE__ */ L(f.slots.filterPanelAddIcon, {})
      }, (i = f.slotProps) == null ? void 0 : i.baseButton, {
        children: c.current.getLocaleText("filterPanelAddFilter")
      })), k ? null : /* @__PURE__ */ L(f.slots.baseButton, S({
        onClick: H,
        startIcon: /* @__PURE__ */ L(f.slots.filterPanelRemoveAllIcon, {})
      }, (s = f.slotProps) == null ? void 0 : s.baseButton, {
        children: c.current.getLocaleText("filterPanelRemoveAll")
      }))]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (uB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore - do not document.
   */
  children: n.node,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: n.oneOf(["asc", "desc"]),
  /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */
  disableAddFilterButton: n.bool,
  /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */
  disableRemoveAllButton: n.bool,
  /**
   * Props passed to each filter form.
   */
  filterFormProps: n.shape({
    columnInputProps: n.any,
    columnsSort: n.oneOf(["asc", "desc"]),
    deleteIconProps: n.any,
    filterColumns: n.func,
    logicOperatorInputProps: n.any,
    operatorInputProps: n.any,
    valueInputProps: n.any
  }),
  /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */
  getColumnForNewFilter: n.func,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: n.arrayOf(n.oneOf(["and", "or"]).isRequired),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Mbe = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"];
function nM(e) {
  const {
    item: t,
    applyValue: o,
    type: i,
    apiRef: s,
    focusElementRef: c,
    color: f,
    error: m,
    helperText: h,
    size: v,
    variant: b
  } = e, x = pe(e, Mbe), E = {
    color: f,
    error: m,
    helperText: h,
    size: v,
    variant: b
  }, [T, P] = C.useState(t.value || []), O = Qn(), k = Ht();
  C.useEffect(() => {
    var $;
    const _ = ($ = t.value) != null ? $ : [];
    P(_.map(String));
  }, [t.value]);
  const I = C.useCallback(($, _) => {
    P(_.map(String)), o(S({}, t, {
      value: [..._]
    }));
  }, [o, t]);
  return /* @__PURE__ */ L(kF, S({
    multiple: !0,
    freeSolo: !0,
    options: [],
    filterOptions: ($, _) => {
      const {
        inputValue: z
      } = _;
      return z == null || z === "" ? [] : [z];
    },
    id: O,
    value: T,
    onChange: I,
    renderTags: ($, _) => $.map((z, V) => /* @__PURE__ */ L(k.slots.baseChip, S({
      variant: "outlined",
      size: "small",
      label: z
    }, _({
      index: V
    })))),
    renderInput: ($) => {
      var _;
      return /* @__PURE__ */ L(k.slots.baseTextField, S({}, $, {
        label: s.current.getLocaleText("filterPanelInputLabel"),
        placeholder: s.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: S({}, $.InputLabelProps, {
          shrink: !0
        }),
        inputRef: c,
        type: i || "text"
      }, E, (_ = k.slotProps) == null ? void 0 : _.baseTextField));
    }
  }, x));
}
process.env.NODE_ENV !== "production" && (nM.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  focusElementRef: n.oneOfType([n.func, n.object]),
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired,
  type: n.oneOf(["number", "text"])
});
const Ibe = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant", "getOptionLabel", "getOptionValue"], Nbe = SF();
function dB(e) {
  var t, o;
  const {
    item: i,
    applyValue: s,
    apiRef: c,
    focusElementRef: f,
    color: m,
    error: h,
    helperText: v,
    size: b,
    variant: x = "standard",
    getOptionLabel: E,
    getOptionValue: T
  } = e, P = pe(e, Ibe), O = {
    color: m,
    error: h,
    helperText: v,
    size: b,
    variant: x
  }, k = Qn(), I = Ht();
  let $ = null;
  if (i.field) {
    const H = c.current.getColumn(i.field);
    Xf(H) && ($ = H);
  }
  const _ = T || ((t = $) == null ? void 0 : t.getOptionValue), z = E || ((o = $) == null ? void 0 : o.getOptionLabel), V = C.useCallback((H, G) => _(H) === _(G), [_]), M = C.useMemo(() => {
    var H;
    return (H = $) != null && H.valueOptions ? typeof $.valueOptions == "function" ? $.valueOptions({
      field: $.field
    }) : $.valueOptions : [];
  }, [$]), A = C.useMemo(() => M == null ? void 0 : M.map(_), [M, _]), W = C.useMemo(() => Array.isArray(i.value) ? M !== void 0 ? i.value.map((G) => A == null ? void 0 : A.findIndex((ne) => ne === G)).filter((G) => G >= 0).map((G) => M[G]) : i.value : [], [i.value, M, A]);
  C.useEffect(() => {
    (!Array.isArray(i.value) || W.length !== i.value.length) && s(S({}, i, {
      value: W.map(_)
    }));
  }, [i, W, s, _]);
  const Y = C.useCallback((H, G) => {
    s(S({}, i, {
      value: G.map(_)
    }));
  }, [s, i, _]);
  return /* @__PURE__ */ L(kF, S({
    multiple: !0,
    options: M,
    isOptionEqualToValue: V,
    filterOptions: Nbe,
    id: k,
    value: W,
    onChange: Y,
    getOptionLabel: z,
    renderTags: (H, G) => H.map((ne, K) => /* @__PURE__ */ L(I.slots.baseChip, S({
      variant: "outlined",
      size: "small",
      label: z(ne)
    }, G({
      index: K
    })))),
    renderInput: (H) => {
      var G;
      return /* @__PURE__ */ L(I.slots.baseTextField, S({}, H, {
        label: c.current.getLocaleText("filterPanelInputLabel"),
        placeholder: c.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: S({}, H.InputLabelProps, {
          shrink: !0
        }),
        inputRef: f,
        type: "singleSelect"
      }, O, (G = I.slotProps) == null ? void 0 : G.baseTextField));
    }
  }, P));
}
process.env.NODE_ENV !== "production" && (dB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: n.shape({
    current: n.object.isRequired
  }).isRequired,
  applyValue: n.func.isRequired,
  focusElementRef: n.oneOfType([n.func, n.object]),
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: n.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: n.func,
  item: n.shape({
    field: n.string.isRequired,
    id: n.oneOfType([n.number, n.string]),
    operator: n.string.isRequired,
    value: n.any
  }).isRequired,
  type: n.oneOf(["singleSelect"])
});
const $be = ["children", "onClick"], Dbe = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const {
    children: s,
    onClick: c
  } = t, f = pe(t, $be), m = Tn(), h = Ht(), v = Qn(), b = Qn(), [x, E] = C.useState(!1), T = C.useRef(null), P = Cn(o, T), O = ($) => {
    E((_) => !_), c == null || c($);
  }, k = () => E(!1), I = ($) => {
    qP($.key) && $.preventDefault(), x4($.key) && k();
  };
  return s == null ? null : /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(h.slots.baseButton, S({
      ref: P,
      size: "small",
      startIcon: /* @__PURE__ */ L(h.slots.exportIcon, {}),
      "aria-expanded": x,
      "aria-label": m.current.getLocaleText("toolbarExportLabel"),
      "aria-haspopup": "menu",
      "aria-controls": x ? b : void 0,
      id: v
    }, f, {
      onClick: O
    }, (i = h.slotProps) == null ? void 0 : i.baseButton, {
      children: m.current.getLocaleText("toolbarExport")
    })), /* @__PURE__ */ L(Yx, {
      open: x,
      target: T.current,
      onClose: k,
      position: "bottom-start",
      children: /* @__PURE__ */ L(Dx, {
        id: b,
        className: Te.menuList,
        "aria-labelledby": v,
        onKeyDown: I,
        autoFocusItem: x,
        children: C.Children.map(s, ($) => /* @__PURE__ */ C.isValidElement($) ? /* @__PURE__ */ C.cloneElement($, {
          hideMenu: k
        }) : $)
      })
    })]
  });
}), _be = ["hideMenu", "options"], Abe = ["hideMenu", "options"], Lbe = ["csvOptions", "printOptions", "excelOptions"];
function Fbe(e) {
  const t = Tn(), {
    hideMenu: o,
    options: i
  } = e, s = pe(e, _be);
  return /* @__PURE__ */ L(Vs, S({
    onClick: () => {
      t.current.exportDataAsCsv(i), o == null || o();
    }
  }, s, {
    children: t.current.getLocaleText("toolbarExportCSV")
  }));
}
function zbe(e) {
  const t = Tn(), {
    hideMenu: o,
    options: i
  } = e, s = pe(e, Abe);
  return /* @__PURE__ */ L(Vs, S({
    onClick: () => {
      t.current.exportDataAsPrint(i), o == null || o();
    }
  }, s, {
    children: t.current.getLocaleText("toolbarExportPrint")
  }));
}
const Vbe = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    csvOptions: i = {},
    printOptions: s = {},
    excelOptions: c
  } = t, f = pe(t, Lbe), h = Tn().current.unstable_applyPipeProcessors("exportMenu", [], {
    excelOptions: c,
    csvOptions: i,
    printOptions: s
  }).sort((v, b) => v.componentName > b.componentName ? 1 : -1);
  return h.length === 0 ? null : /* @__PURE__ */ L(Dbe, S({}, f, {
    ref: o,
    children: h.map((v, b) => /* @__PURE__ */ C.cloneElement(v.component, {
      key: b
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Vbe.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  csvOptions: n.object,
  printOptions: n.object
});
const Bbe = ["className", "selectedRowCount"], jbe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["selectedRowCount"]
  }, $n, t);
}, Hbe = xo("div", {
  name: "MuiDataGrid",
  slot: "SelectedRowCount",
  overridesResolver: (e, t) => t.selectedRowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2),
  visibility: "hidden",
  width: 0,
  height: 0,
  [e.breakpoints.up("sm")]: {
    visibility: "visible",
    width: "auto",
    height: "auto"
  }
})), fB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i,
    selectedRowCount: s
  } = t, c = pe(t, Bbe), f = Tn(), m = Ht(), h = jbe(m), v = f.current.getLocaleText("footerRowSelected")(s);
  return /* @__PURE__ */ L(Hbe, S({
    ref: o,
    className: be(h.root, i),
    ownerState: m
  }, c, {
    children: v
  }));
});
process.env.NODE_ENV !== "production" && (fB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  selectedRowCount: n.number.isRequired,
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const pB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const c = Tn(), f = Ht(), m = Nt(c, Gme), h = Nt(c, Xge), v = Nt(c, Ux), b = !f.hideFooterSelectedRowCount && h > 0 ? /* @__PURE__ */ L(fB, {
    selectedRowCount: h
  }) : /* @__PURE__ */ L("div", {}), x = !f.hideFooterRowCount && !f.pagination ? /* @__PURE__ */ L(f.slots.footerRowCount, S({}, (i = f.slotProps) == null ? void 0 : i.footerRowCount, {
    rowCount: m,
    visibleRowCount: v
  })) : null, E = f.pagination && !f.hideFooterPagination && f.slots.pagination && /* @__PURE__ */ L(f.slots.pagination, S({}, (s = f.slotProps) == null ? void 0 : s.pagination));
  return /* @__PURE__ */ ht(R4, S({
    ref: o
  }, t, {
    children: [b, x, E]
  }));
});
process.env.NODE_ENV !== "production" && (pB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
function Ube() {
  var e, t;
  const o = Ht();
  return /* @__PURE__ */ ht(C.Fragment, {
    children: [/* @__PURE__ */ L(o.slots.preferencesPanel, S({}, (e = o.slotProps) == null ? void 0 : e.preferencesPanel)), o.slots.toolbar && /* @__PURE__ */ L(o.slots.toolbar, S({}, (t = o.slotProps) == null ? void 0 : t.toolbar))]
  });
}
const mB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  return /* @__PURE__ */ L(Kx, S({
    ref: o
  }, t, {
    children: /* @__PURE__ */ L(ote, {})
  }));
});
process.env.NODE_ENV !== "production" && (mB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const hB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const s = Tn().current.getLocaleText("noRowsLabel");
  return /* @__PURE__ */ L(Kx, S({
    ref: o
  }, t, {
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (hB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object])
});
const Gbe = se(dde)(({
  theme: e
}) => ({
  [`& .${Yf.selectLabel}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  [`& .${Yf.input}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "inline-flex"
    }
  }
})), Wbe = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = Tn(), s = Ht(), c = Nt(i, rl), f = Nt(i, Ux), m = C.useMemo(() => {
    var O, k;
    return (O = (k = s.rowCount) != null ? k : f) != null ? O : 0;
  }, [s.rowCount, f]), h = C.useMemo(() => Math.floor(m / (c.pageSize || 1)), [m, c.pageSize]), v = C.useCallback((O) => {
    const k = Number(O.target.value);
    i.current.setPageSize(k);
  }, [i]), b = C.useCallback((O, k) => {
    i.current.setPage(k);
  }, [i]), x = (O) => {
    for (let k = 0; k < s.pageSizeOptions.length; k += 1) {
      const I = s.pageSizeOptions[k];
      if (typeof I == "number") {
        if (I === O)
          return !0;
      } else if (I.value === O)
        return !0;
    }
    return !1;
  };
  if (process.env.NODE_ENV !== "production") {
    var E, T;
    const O = C.useRef(!1), k = (E = (T = s.paginationModel) == null ? void 0 : T.pageSize) != null ? E : c.pageSize;
    !O.current && !s.autoPageSize && !x(k) && (console.warn([`MUI: The page size \`${c.pageSize}\` is not preset in the \`pageSizeOptions\``, "Add it to show the pagination select."].join(`
`)), O.current = !0);
  }
  const P = x(c.pageSize) ? s.pageSizeOptions : [];
  return /* @__PURE__ */ L(Gbe, S({
    ref: o,
    component: "div",
    count: m,
    page: c.page <= h ? c.page : h,
    rowsPerPageOptions: P,
    rowsPerPage: c.pageSize,
    onPageChange: b,
    onRowsPerPageChange: v
  }, i.current.getLocaleText("MuiTablePagination"), t));
}), qbe = ["className", "rowCount", "visibleRowCount"], Ybe = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["rowCount"]
  }, $n, t);
}, Kbe = xo("div", {
  name: "MuiDataGrid",
  slot: "RowCount",
  overridesResolver: (e, t) => t.rowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2)
})), gB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i,
    rowCount: s,
    visibleRowCount: c
  } = t, f = pe(t, qbe), m = Tn(), h = Ht(), v = Ybe(h);
  if (s === 0)
    return null;
  const b = c < s ? m.current.getLocaleText("footerTotalVisibleRows")(c, s) : s.toLocaleString();
  return /* @__PURE__ */ ht(Kbe, S({
    ref: o,
    className: be(v.root, i),
    ownerState: h
  }, f, {
    children: [m.current.getLocaleText("footerTotalRows"), " ", b]
  }));
});
process.env.NODE_ENV !== "production" && (gB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  rowCount: n.number.isRequired,
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  visibleRowCount: n.number.isRequired
});
const ox = (e, t) => {
  let o, i;
  return t.pagination && t.paginationMode === "client" ? (i = KP(e), o = Kge(e)) : (o = Sd(e), o.length === 0 ? i = null : i = {
    firstRowIndex: 0,
    lastRowIndex: o.length - 1
  }), {
    rows: o,
    range: i
  };
}, up = (e, t) => {
  const o = ox(e, t);
  return C.useMemo(() => ({
    rows: o.rows,
    range: o.range
  }), [o.rows, o.range]);
}, ik = {
  current: null
};
function Ay(e) {
  return e.isInternal = !0, e;
}
function ax(e) {
  return e !== void 0 && e.isInternal === !0;
}
function Xbe(e) {
  return Ay((t, o) => {
    const i = e(t, o);
    return i && ((s) => i(s.value, s.row, o, ik.current));
  });
}
function Ly(e) {
  return e.map((t) => S({}, t, {
    getApplyFilterFn: Xbe(t.getApplyFilterFnV7),
    getApplyFilterFnV7: Ay(t.getApplyFilterFnV7)
  }));
}
function vB(e) {
  return Ay((t, o, i) => {
    const s = e(t, o, i);
    return s && ((c) => s(c.value, c.row, o, i));
  });
}
const MA = Ay((e) => {
  if (!e)
    return null;
  const t = new RegExp(E1(e), "i");
  return (o, i, s, c) => {
    const f = c.current.getRowFormattedValue(i, s);
    return f != null ? t.test(f.toString()) : !1;
  };
}), Qbe = (e = !1) => Ly([{
  value: "contains",
  getApplyFilterFnV7: (t) => {
    if (!t.value)
      return null;
    const o = e ? t.value : t.value.trim(), i = new RegExp(E1(o), "i");
    return (s) => s != null ? i.test(String(s)) : !1;
  },
  InputComponent: Vl
}, {
  value: "equals",
  getApplyFilterFnV7: (t) => {
    if (!t.value)
      return null;
    const o = e ? t.value : t.value.trim(), i = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (s) => s != null ? i.compare(o, s.toString()) === 0 : !1;
  },
  InputComponent: Vl
}, {
  value: "startsWith",
  getApplyFilterFnV7: (t) => {
    if (!t.value)
      return null;
    const o = e ? t.value : t.value.trim(), i = new RegExp(`^${E1(o)}.*$`, "i");
    return (s) => s != null ? i.test(s.toString()) : !1;
  },
  InputComponent: Vl
}, {
  value: "endsWith",
  getApplyFilterFnV7: (t) => {
    if (!t.value)
      return null;
    const o = e ? t.value : t.value.trim(), i = new RegExp(`.*${E1(o)}$`, "i");
    return (s) => s != null ? i.test(s.toString()) : !1;
  },
  InputComponent: Vl
}, {
  value: "isEmpty",
  getApplyFilterFnV7: () => (t) => t === "" || t == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFnV7: () => (t) => t !== "" && t != null,
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFnV7: (t) => {
    if (!Array.isArray(t.value) || t.value.length === 0)
      return null;
    const o = e ? t.value : t.value.map((s) => s.trim()), i = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (s) => s != null ? o.some((c) => i.compare(c, s.toString() || "") === 0) : !1;
  },
  InputComponent: nM
}]), Gl = {
  width: 100,
  minWidth: 50,
  maxWidth: 1 / 0,
  hideable: !0,
  sortable: !0,
  resizable: !0,
  filterable: !0,
  groupable: !0,
  pinnable: !0,
  // @ts-ignore
  aggregable: !0,
  editable: !1,
  sortComparator: ove,
  type: "string",
  align: "left",
  filterOperators: Qbe(),
  renderEditCell: Vhe,
  getApplyQuickFilterFn: vB(MA),
  getApplyQuickFilterFnV7: MA
}, Zbe = () => Ly([{
  value: "is",
  getApplyFilterFnV7: (e) => {
    if (!e.value)
      return null;
    const t = e.value === "true";
    return (o) => !!o === t;
  },
  InputComponent: cB
}]);
function Jbe({
  value: e,
  api: t
}) {
  return e ? t.getLocaleText("booleanCellTrueLabel") : t.getLocaleText("booleanCellFalseLabel");
}
const eye = (e) => {
  switch (e.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return !0;
    case "false":
    case "no":
    case "0":
    case "null":
    case "undefined":
      return !1;
    default:
      return;
  }
}, bB = S({}, Gl, {
  type: "boolean",
  align: "center",
  headerAlign: "center",
  renderCell: Mhe,
  renderEditCell: $he,
  sortComparator: U4,
  valueFormatter: Jbe,
  filterOperators: Zbe(),
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0,
  // @ts-ignore
  aggregable: !1,
  // @ts-ignore
  pastedValueParser: (e) => eye(e)
}), nd = "__check__", Zh = S({}, bB, {
  field: nd,
  type: "checkboxSelection",
  width: 50,
  resizable: !1,
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  disableExport: !0,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0,
  valueGetter: (e) => rx(e.api.state, e.api.instanceId)[e.id] !== void 0,
  renderHeader: (e) => /* @__PURE__ */ L(Q4, S({}, e)),
  renderCell: (e) => /* @__PURE__ */ L(pve, S({}, e))
}), Xx = "actions", tye = S({}, Gl, {
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  width: 100,
  align: "center",
  headerAlign: "center",
  headerName: "",
  disableColumnMenu: !0,
  disableExport: !0,
  renderCell: nge,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0
}), rM = "__detail_panel_toggle__", Ba = (e) => e.editRows, nye = ["selected", "hovered", "rowId", "row", "index", "style", "position", "rowHeight", "className", "visibleColumns", "renderedColumns", "containerWidth", "firstColumnToRender", "lastColumnToRender", "isLastVisible", "focusedCellColumnIndexNotInRange", "isNotVisible", "focusedCell", "tabbableCell", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave"], rye = (e) => {
  const {
    editable: t,
    editing: o,
    selected: i,
    isLastVisible: s,
    rowHeight: c,
    classes: f
  } = e;
  return je({
    root: ["row", i && "selected", t && "row--editable", o && "row--editing", s && "row--lastVisible", c === "auto" && "row--dynamicHeight"]
  }, $n, f);
};
function oye({
  width: e
}) {
  if (!e)
    return null;
  const t = {
    width: e
  };
  return /* @__PURE__ */ L("div", {
    className: `${Te.cell} ${Te.withBorderColor}`,
    style: t
  });
}
const yB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    selected: i,
    hovered: s,
    rowId: c,
    row: f,
    index: m,
    style: h,
    position: v,
    rowHeight: b,
    className: x,
    visibleColumns: E,
    renderedColumns: T,
    containerWidth: P,
    firstColumnToRender: O,
    isLastVisible: k = !1,
    focusedCellColumnIndexNotInRange: I,
    isNotVisible: $,
    focusedCell: _,
    onClick: z,
    onDoubleClick: V,
    onMouseEnter: M,
    onMouseLeave: A
  } = t, W = pe(t, nye), Y = Tn(), H = C.useRef(null), G = Ht(), ne = up(Y, G), K = Nt(Y, VP), B = Nt(Y, el), q = Nt(Y, Hx), X = Nt(Y, Dy), J = Nt(Y, Ba), U = Cn(H, o), Z = m + X + 2, ee = {
    selected: i,
    hovered: s,
    isLastVisible: k,
    classes: G.classes,
    editing: Y.current.getRowMode(c) === Tr.Edit,
    editable: G.editMode === Us.Row,
    rowHeight: b
  }, ie = rye(ee);
  C.useLayoutEffect(() => {
    b === "auto" && H.current && typeof ResizeObserver > "u" && Y.current.unstable_storeRowHeightMeasurement(c, H.current.clientHeight, v);
  }, [Y, b, c, v]), C.useLayoutEffect(() => {
    if (ne.range) {
      const wt = Y.current.getRowIndexRelativeToVisibleRows(c);
      wt != null && Y.current.unstable_setLastMeasuredRowIndex(wt);
    }
    const Ge = H.current;
    if (!Ge || b !== "auto" || typeof ResizeObserver > "u")
      return;
    const rt = new ResizeObserver((wt) => {
      const [We] = wt, ut = We.borderBoxSize && We.borderBoxSize.length > 0 ? We.borderBoxSize[0].blockSize : We.contentRect.height;
      Y.current.unstable_storeRowHeightMeasurement(c, ut, v);
    });
    return rt.observe(Ge), () => rt.disconnect();
  }, [Y, ne.range, m, b, c, v]);
  const oe = C.useCallback((Ge, Be) => (rt) => {
    rt.target.nodeType === 1 && !rt.currentTarget.contains(rt.target) || Y.current.getRow(c) && (Y.current.publishEvent(Ge, Y.current.getRowParams(c), rt), Be && Be(rt));
  }, [Y, c]), le = C.useCallback((Ge) => {
    const Be = ghe(Ge.target, Te.cell), rt = Be == null ? void 0 : Be.getAttribute("data-field");
    if (rt) {
      if (rt === Zh.field || rt === rM || rt === "__reorder__" || Y.current.getCellMode(c, rt) === sr.Edit)
        return;
      const wt = Y.current.getColumn(rt);
      if ((wt == null ? void 0 : wt.type) === Xx)
        return;
    }
    oe("rowClick", z)(Ge);
  }, [Y, z, oe, c]), {
    slots: de,
    slotProps: Ce,
    disableColumnReorder: me
  } = G, Oe = de.cell === rk ? rk : Ohe, he = G.rowReordering, $e = (Ge, Be) => {
    var rt, wt;
    const We = me && Ge.disableReorder || !he && !!B.length && q > 1 && Object.keys(J).length > 0, ut = (rt = (wt = J[c]) == null ? void 0 : wt[Ge.field]) != null ? rt : null;
    let ft = !1;
    return I !== void 0 && E[I].field === Ge.field && (ft = !0), /* @__PURE__ */ L(Oe, S({
      column: Ge,
      width: Be.width,
      rowId: c,
      height: b,
      showRightBorder: Be.showRightBorder,
      align: Ge.align || "left",
      colIndex: Be.indexRelativeToAllColumns,
      colSpan: Be.colSpan,
      disableDragEvents: We,
      editCellState: ut,
      isNotVisible: ft
    }, Ce == null ? void 0 : Ce.cell), Ge.field);
  }, Ne = Nt(Y, () => S({}, Y.current.unstable_getRowInternalSizes(c)), zP);
  let Pe = b;
  if (Pe === "auto" && Ne) {
    let Ge = 0;
    const Be = Object.entries(Ne).reduce((rt, [wt, We]) => /^base[A-Z]/.test(wt) ? (Ge += 1, We > rt ? We : rt) : rt, 0);
    Be > 0 && Ge > 1 && (Pe = Be);
  }
  const Se = C.useMemo(() => {
    if ($)
      return {
        opacity: 0,
        width: 0,
        height: 0
      };
    const Ge = S({}, h, {
      maxHeight: b === "auto" ? "none" : b,
      // max-height doesn't support "auto"
      minHeight: Pe
    });
    if (Ne != null && Ne.spacingTop) {
      const Be = G.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
      Ge[Be] = Ne.spacingTop;
    }
    if (Ne != null && Ne.spacingBottom) {
      const Be = G.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
      let rt = Ge[Be];
      typeof rt != "number" && (rt = parseInt(rt || "0", 10)), rt += Ne.spacingBottom, Ge[Be] = rt;
    }
    return Ge;
  }, [$, b, h, Pe, Ne, G.rowSpacingType]), Fe = Y.current.unstable_applyPipeProcessors("rowClassName", [], c);
  if (typeof G.getRowClassName == "function") {
    var ce;
    const Ge = m - (((ce = ne.range) == null ? void 0 : ce.firstRowIndex) || 0), Be = S({}, Y.current.getRowParams(c), {
      isFirstVisible: Ge === 0,
      isLastVisible: Ge === ne.rows.length - 1,
      indexRelativeToCurrentPage: Ge
    });
    Fe.push(G.getRowClassName(Be));
  }
  const ge = Bge(1e4, 20, 80), we = Y.current.getRowNode(c);
  if (!we)
    return null;
  const Me = we.type, Qe = [];
  for (let Ge = 0; Ge < T.length; Ge += 1) {
    const Be = T[Ge];
    let rt = O + Ge;
    I !== void 0 && _ && (E[I].field === Be.field ? rt = I : rt -= 1);
    const wt = Y.current.unstable_getCellColSpanInfo(c, rt);
    if (wt && !wt.spannedByColSpan)
      if (Me !== "skeletonRow") {
        const {
          colSpan: We,
          width: ut
        } = wt.cellProps, ft = {
          width: ut,
          colSpan: We,
          showRightBorder: G.showCellVerticalBorder,
          indexRelativeToAllColumns: rt
        };
        Qe.push($e(Be, ft));
      } else {
        const {
          width: We
        } = wt.cellProps, ut = Math.round(ge());
        Qe.push(/* @__PURE__ */ L(de.skeletonCell, {
          width: We,
          contentWidth: ut,
          field: Be.field,
          align: Be.align
        }, Be.field));
      }
  }
  const ct = P - K, Ze = f ? {
    onClick: le,
    onDoubleClick: oe("rowDoubleClick", V),
    onMouseEnter: oe("rowMouseEnter", M),
    onMouseLeave: oe("rowMouseLeave", A)
  } : null;
  return /* @__PURE__ */ ht("div", S({
    ref: U,
    "data-id": c,
    "data-rowindex": m,
    role: "row",
    className: be(...Fe, ie.root, x, s && "Mui-hovered"),
    "aria-rowindex": Z,
    "aria-selected": i,
    style: Se
  }, Ze, W, {
    children: [Qe, ct > 0 && /* @__PURE__ */ L(oye, {
      width: ct
    })]
  }));
});
process.env.NODE_ENV !== "production" && (yB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  containerWidth: n.number.isRequired,
  firstColumnToRender: n.number.isRequired,
  /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */
  focusedCell: n.string,
  focusedCellColumnIndexNotInRange: n.number,
  /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */
  index: n.number.isRequired,
  isLastVisible: n.bool,
  isNotVisible: n.bool,
  lastColumnToRender: n.number.isRequired,
  onClick: n.func,
  onDoubleClick: n.func,
  onMouseEnter: n.func,
  onMouseLeave: n.func,
  position: n.oneOf(["center", "left", "right"]).isRequired,
  renderedColumns: n.arrayOf(n.object).isRequired,
  row: n.object,
  rowHeight: n.oneOfType([n.oneOf(["auto"]), n.number]).isRequired,
  rowId: n.oneOfType([n.number, n.string]).isRequired,
  selected: n.bool.isRequired,
  /**
   * Determines which cell should be tabbable by having tabIndex=0.
   * If `null`, no cell in this row is in the tab sequence.
   */
  tabbableCell: n.string,
  visibleColumns: n.arrayOf(n.object).isRequired
});
const aye = qx(yB);
function iye({
  privateApiRef: e,
  props: t,
  children: o
}) {
  const i = C.useRef(e.current.getPublicApi());
  return /* @__PURE__ */ L(AP.Provider, {
    value: t,
    children: /* @__PURE__ */ L(LP.Provider, {
      value: e,
      children: /* @__PURE__ */ L(_P.Provider, {
        value: i,
        children: o
      })
    })
  });
}
const lye = zge() && window.localStorage.getItem("DEBUG") != null, Fb = () => {
}, sye = {
  debug: Fb,
  info: Fb,
  warn: Fb,
  error: Fb
}, IA = ["debug", "info", "warn", "error"];
function NA(e, t, o = console) {
  const i = IA.indexOf(t);
  if (i === -1)
    throw new Error(`MUI: Log level ${t} not recognized.`);
  return IA.reduce((c, f, m) => (m >= i ? c[f] = (...h) => {
    const [v, ...b] = h;
    o[f](`MUI: ${e} - ${v}`, ...b);
  } : c[f] = Fb, c), {});
}
const cye = (e, t) => {
  const o = C.useCallback((i) => lye ? NA(i, "debug", t.logger) : t.logLevel ? NA(i, t.logLevel.toString(), t.logger) : sye, [t.logLevel, t.logger]);
  En(e, {
    getLogger: o
  }, "private");
};
class oM {
  static create(t) {
    return new oM(t);
  }
  constructor(t) {
    this.value = void 0, this.listeners = void 0, this.subscribe = (o) => (this.listeners.add(o), () => {
      this.listeners.delete(o);
    }), this.getSnapshot = () => this.value, this.update = (o) => {
      this.value = o, this.listeners.forEach((i) => i(o));
    }, this.value = t, this.listeners = /* @__PURE__ */ new Set();
  }
}
class uye {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, o, i = {}) {
    let s = this.events[t];
    if (s || (s = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = s), i.isFirst ? s.highPriority.set(o, !0) : s.regular.set(o, !0), process.env.NODE_ENV !== "production") {
      const c = s.highPriority.size + s.regular.size;
      c > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${c} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, o) {
    this.events[t] && (this.events[t].regular.delete(o), this.events[t].highPriority.delete(o));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...o) {
    const i = this.events[t];
    if (!i)
      return;
    const s = Array.from(i.highPriority.keys()), c = Array.from(i.regular.keys());
    for (let f = s.length - 1; f >= 0; f -= 1) {
      const m = s[f];
      i.highPriority.has(m) && m.apply(this, o);
    }
    for (let f = 0; f < c.length; f += 1) {
      const m = c[f];
      i.regular.has(m) && m.apply(this, o);
    }
  }
  once(t, o) {
    const i = this;
    this.on(t, function s(...c) {
      i.removeListener(t, s), o.apply(i, c);
    });
  }
}
const CB = Symbol("mui.api_private"), dye = (e) => e.isPropagationStopped !== void 0;
let $A = 0;
function fye(e) {
  var t;
  const o = (t = e.current) == null ? void 0 : t[CB];
  if (o)
    return o;
  const i = {}, s = {
    state: i,
    store: oM.create(i),
    instanceId: {
      id: $A
    }
  };
  return $A += 1, s.getPublicApi = () => e.current, s.register = (c, f) => {
    Object.keys(f).forEach((m) => {
      const h = f[m], v = s[m];
      if ((v == null ? void 0 : v.spying) === !0 ? v.target = h : s[m] = h, c === "public") {
        const b = e.current, x = b[m];
        (x == null ? void 0 : x.spying) === !0 ? x.target = h : b[m] = h;
      }
    });
  }, s.register("private", {
    caches: {},
    eventManager: new uye()
  }), s;
}
function pye(e) {
  return {
    get state() {
      return e.current.state;
    },
    get store() {
      return e.current.store;
    },
    get instanceId() {
      return e.current.instanceId;
    },
    [CB]: e.current
  };
}
function mye(e, t) {
  const o = C.useRef(), i = C.useRef();
  i.current || (i.current = fye(o)), o.current || (o.current = pye(i));
  const s = C.useCallback((...f) => {
    const [m, h, v = {}] = f;
    if (v.defaultMuiPrevented = !1, dye(v) && v.isPropagationStopped())
      return;
    const b = t.signature === js.DataGridPro ? {
      api: i.current.getPublicApi()
    } : {};
    i.current.eventManager.emit(m, h, v, b);
  }, [i, t.signature]), c = C.useCallback((f, m, h) => {
    i.current.eventManager.on(f, m, h);
    const v = i.current;
    return () => {
      v.eventManager.removeListener(f, m);
    };
  }, [i]);
  return En(i, {
    subscribeEvent: c,
    publishEvent: s
  }, "public"), C.useImperativeHandle(e, () => o.current, [o]), C.useEffect(() => {
    const f = i.current;
    return () => {
      f.publishEvent("unmount");
    };
  }, [i]), i;
}
const hye = (e, t) => {
  const o = C.useCallback((i) => {
    if (t.localeText[i] == null)
      throw new Error(`Missing translation for key ${i}.`);
    return t.localeText[i];
  }, [t.localeText]);
  e.current.register("public", {
    getLocaleText: o
  });
};
function hy(e) {
  "@babel/helpers - typeof";
  return hy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hy(e);
}
function gye(e, t) {
  if (hy(e) !== "object" || e === null)
    return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var i = o.call(e, t || "default");
    if (hy(i) !== "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gy(e) {
  var t = gye(e, "string");
  return hy(t) === "symbol" ? t : String(t);
}
const vye = (e) => {
  const t = C.useRef({}), o = C.useRef(!1), i = C.useCallback((b) => {
    o.current || !b || (o.current = !0, Object.values(b.appliers).forEach((x) => {
      x();
    }), o.current = !1);
  }, []), s = C.useCallback((b, x, E) => {
    t.current[b] || (t.current[b] = {
      processors: /* @__PURE__ */ new Map(),
      appliers: {}
    });
    const T = t.current[b];
    return T.processors.get(x) !== E && (T.processors.set(x, E), i(T)), () => {
      t.current[b].processors.set(x, null);
    };
  }, [i]), c = C.useCallback((b, x, E) => (t.current[b] || (t.current[b] = {
    processors: /* @__PURE__ */ new Map(),
    appliers: {}
  }), t.current[b].appliers[x] = E, () => {
    const T = t.current[b].appliers, P = pe(T, [x].map(gy));
    t.current[b].appliers = P;
  }), []), f = C.useCallback((b) => {
    const x = t.current[b];
    i(x);
  }, [i]), m = C.useCallback((...b) => {
    const [x, E, T] = b;
    return t.current[x] ? Array.from(t.current[x].processors.values()).reduce((O, k) => k ? k(O, T) : O, E) : E;
  }, []), h = {
    registerPipeProcessor: s,
    registerPipeApplier: c,
    requestPipeProcessorsApplication: f
  }, v = {
    unstable_applyPipeProcessors: m
  };
  En(e, h, "private"), En(e, v, "public");
}, _o = (e, t, o) => {
  const i = C.useRef(), s = C.useRef(`mui-${Math.round(Math.random() * 1e9)}`), c = C.useCallback(() => {
    i.current = e.current.registerPipeProcessor(t, s.current, o);
  }, [e, o, t]);
  _y(() => {
    c();
  });
  const f = C.useRef(!0);
  C.useEffect(() => (f.current ? f.current = !1 : c(), () => {
    i.current && (i.current(), i.current = null);
  }), [c]);
}, aM = (e, t, o) => {
  const i = C.useRef(), s = C.useRef(`mui-${Math.round(Math.random() * 1e9)}`), c = C.useCallback(() => {
    i.current = e.current.registerPipeApplier(t, s.current, o);
  }, [e, o, t]);
  _y(() => {
    c();
  });
  const f = C.useRef(!0);
  C.useEffect(() => (f.current ? f.current = !1 : c(), () => {
    i.current && (i.current(), i.current = null);
  }), [c]);
}, ix = (e, t, o, i) => {
  const s = C.useCallback(() => {
    e.current.registerStrategyProcessor(t, o, i);
  }, [e, i, o, t]);
  _y(() => {
    s();
  });
  const c = C.useRef(!0);
  C.useEffect(() => {
    c.current ? c.current = !1 : s();
  }, [s]);
}, ap = "none", DA = {
  rowTreeCreation: "rowTree",
  filtering: "rowTree",
  sorting: "rowTree",
  visibleRowsLookupCreation: "rowTree"
}, bye = (e) => {
  const t = C.useRef(/* @__PURE__ */ new Map()), o = C.useRef({}), i = C.useCallback((h, v, b) => {
    const x = () => {
      const P = o.current[v], O = pe(P, [h].map(gy));
      o.current[v] = O;
    };
    o.current[v] || (o.current[v] = {});
    const E = o.current[v], T = E[h];
    return E[h] = b, !T || T === b || h === e.current.getActiveStrategy(DA[v]) && e.current.publishEvent("activeStrategyProcessorChange", v), x;
  }, [e]), s = C.useCallback((h, v) => {
    const b = e.current.getActiveStrategy(DA[h]);
    if (b == null)
      throw new Error("Can't apply a strategy processor before defining an active strategy");
    const x = o.current[h];
    if (!x || !x[b])
      throw new Error(`No processor found for processor "${h}" on strategy "${b}"`);
    const E = x[b];
    return E(v);
  }, [e]), c = C.useCallback((h) => {
    var v;
    const x = Array.from(t.current.entries()).find(([, E]) => E.group !== h ? !1 : E.isAvailable());
    return (v = x == null ? void 0 : x[0]) != null ? v : ap;
  }, []), f = C.useCallback((h, v, b) => {
    t.current.set(v, {
      group: h,
      isAvailable: b
    }), e.current.publishEvent("strategyAvailabilityChange");
  }, [e]);
  En(e, {
    registerStrategyProcessor: i,
    applyStrategyProcessor: s,
    getActiveStrategy: c,
    setStrategyAvailability: f
  }, "private");
}, yye = (e, t) => {
  const o = C.useRef({}), [, i] = C.useState(), s = C.useCallback((b) => {
    o.current[b.stateId] = b;
  }, []), c = C.useCallback((b, x) => {
    let E;
    if (A4(b) ? E = b(e.current.state) : E = b, e.current.state === E)
      return !1;
    let T = !1;
    const P = [];
    if (Object.keys(o.current).forEach((O) => {
      const k = o.current[O], I = k.stateSelector(e.current.state, e.current.instanceId), $ = k.stateSelector(E, e.current.instanceId);
      $ !== I && (P.push({
        stateId: k.stateId,
        hasPropChanged: $ !== k.propModel
      }), k.propModel !== void 0 && $ !== k.propModel && (T = !0));
    }), P.length > 1)
      throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${P[0].stateId}, therefore, you're not allowed to update ${P.map((O) => O.stateId).join(", ")} in the same transaction.`);
    if (T || (e.current.state = E, e.current.publishEvent && e.current.publishEvent("stateChange", E), e.current.store.update(E)), P.length === 1) {
      const {
        stateId: O,
        hasPropChanged: k
      } = P[0], I = o.current[O], $ = I.stateSelector(E, e.current.instanceId);
      if (I.propOnChange && k) {
        const _ = t.signature === js.DataGridPro ? {
          api: e.current,
          reason: x
        } : {
          reason: x
        };
        I.propOnChange($, _);
      }
      T || e.current.publishEvent(I.changeEvent, $, {
        reason: x
      });
    }
    return !T;
  }, [e, t.signature]), f = C.useCallback((b, x, E) => e.current.setState((T) => S({}, T, {
    [b]: x(T[b])
  }), E), [e]), m = C.useCallback(() => i(() => e.current.state), [e]), h = {
    setState: c,
    forceUpdate: m
  }, v = {
    updateControlState: f,
    registerControlState: s
  };
  En(e, h, "public"), En(e, v, "private");
}, Cye = (e, t) => {
  const o = mye(e, t);
  return cye(o, t), yye(o, t), vye(o), bye(o), hye(o, t), o;
}, fi = (e, t, o) => {
  const i = C.useRef(!1);
  i.current || (t.current.state = e(t.current.state, o, t), i.current = !0);
}, Sye = /(\d+)-(\d+)-(\d+)/, xye = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function ih(e, t, o, i) {
  if (!e.value)
    return null;
  const [s, c, f, m, h] = e.value.match(o ? xye : Sye).slice(1).map(Number), v = new Date(s, c - 1, f, m || 0, h || 0).getTime();
  return (b) => {
    if (!b)
      return !1;
    if (i)
      return t(b.getTime(), v);
    const E = new Date(b).setHours(o ? b.getHours() : 0, o ? b.getMinutes() : 0, 0, 0);
    return t(E, v);
  };
}
const SB = (e) => Ly([{
  value: "is",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o === i, e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "not",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o !== i, e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "after",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o > i, e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrAfter",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o >= i, e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "before",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o < i, e, !e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrBefore",
  getApplyFilterFnV7: (t) => ih(t, (o, i) => o <= i, e),
  InputComponent: Vf,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "isEmpty",
  getApplyFilterFnV7: () => (t) => t == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFnV7: () => (t) => t != null,
  requiresFilterValue: !1
}]);
function xB({
  value: e,
  columnType: t,
  rowId: o,
  field: i
}) {
  if (!(e instanceof Date))
    throw new Error([`MUI: \`${t}\` column type only accepts \`Date\` objects as values.`, "Use `valueGetter` to transform the value into a `Date` object.", `Row ID: ${o}, field: "${i}".`].join(`
`));
}
function wye({
  value: e,
  field: t,
  id: o
}) {
  return e ? (xB({
    value: e,
    columnType: "date",
    rowId: o,
    field: t
  }), e.toLocaleDateString()) : "";
}
function Eye({
  value: e,
  field: t,
  id: o
}) {
  return e ? (xB({
    value: e,
    columnType: "dateTime",
    rowId: o,
    field: t
  }), e.toLocaleString()) : "";
}
const Tye = S({}, Gl, {
  type: "date",
  sortComparator: G4,
  valueFormatter: wye,
  filterOperators: SB(),
  renderEditCell: b4,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), Oye = S({}, Gl, {
  type: "dateTime",
  sortComparator: G4,
  valueFormatter: Eye,
  filterOperators: SB(!0),
  renderEditCell: b4,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), rd = (e) => e == null ? null : Number(e), _A = Ay((e) => e == null || Number.isNaN(e) || e === "" ? null : (t) => rd(t) === rd(e)), Rye = () => Ly([{
  value: "=",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => rd(t) === e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "!=",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => rd(t) !== e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : rd(t) > e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">=",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : rd(t) >= e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : rd(t) < e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<=",
  getApplyFilterFnV7: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : rd(t) <= e.value,
  InputComponent: Vl,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "isEmpty",
  getApplyFilterFnV7: () => (e) => e == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFnV7: () => (e) => e != null,
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFnV7: (e) => !Array.isArray(e.value) || e.value.length === 0 ? null : (t) => t != null && e.value.includes(Number(t)),
  InputComponent: nM,
  InputComponentProps: {
    type: "number"
  }
}]), kye = S({}, Gl, {
  type: "number",
  align: "right",
  headerAlign: "right",
  sortComparator: U4,
  valueParser: (e) => e === "" ? null : Number(e),
  valueFormatter: ({
    value: e
  }) => Fge(e) ? e.toLocaleString() : e || "",
  filterOperators: Rye(),
  getApplyQuickFilterFn: vB(_A),
  getApplyQuickFilterFnV7: _A
}), lh = (e) => e == null || !YP(e) ? e : e.value, Pye = () => Ly([{
  value: "is",
  getApplyFilterFnV7: (e) => e.value == null || e.value === "" ? null : (t) => lh(t) === lh(e.value),
  InputComponent: ak
}, {
  value: "not",
  getApplyFilterFnV7: (e) => e.value == null || e.value === "" ? null : (t) => lh(t) !== lh(e.value),
  InputComponent: ak
}, {
  value: "isAnyOf",
  getApplyFilterFnV7: (e) => {
    if (!Array.isArray(e.value) || e.value.length === 0)
      return null;
    const t = e.value.map(lh);
    return (o) => t.includes(lh(o));
  },
  InputComponent: dB
}]), Mye = (e) => typeof e[0] == "object", Iye = (e) => YP(e) ? e.value : e, Nye = (e) => YP(e) ? e.label : String(e), $ye = S({}, Gl, {
  type: "singleSelect",
  getOptionLabel: Nye,
  getOptionValue: Iye,
  valueFormatter(e) {
    const {
      id: t,
      field: o,
      value: i,
      api: s
    } = e, c = e.api.getColumn(o);
    if (!Xf(c))
      return "";
    let f;
    if (typeof c.valueOptions == "function" ? f = c.valueOptions({
      id: t,
      row: t ? s.getRow(t) : null,
      field: o
    }) : f = c.valueOptions, i == null)
      return "";
    if (!f)
      return i;
    if (!Mye(f))
      return c.getOptionLabel(i);
    const m = f.find((h) => c.getOptionValue(h) === i);
    return m ? c.getOptionLabel(m) : "";
  },
  renderEditCell: Khe,
  filterOperators: Pye(),
  // @ts-ignore
  pastedValueParser: (e, t) => {
    const o = t.colDef, i = o.valueOptions, s = typeof i == "function" ? i({
      field: o.field
    }) : i || [], c = o.getOptionValue;
    if (s.find((m) => c(m) === e))
      return e;
  }
}), wB = "__default__", Dye = () => ({
  string: Gl,
  number: kye,
  date: Tye,
  dateTime: Oye,
  boolean: bB,
  singleSelect: $ye,
  [Xx]: tye,
  [wB]: Gl
});
function lk(e, t) {
  return typeof e == "string" && [t, `
`, "\r", '"'].some((o) => e.includes(o)) ? `"${e.replace(/"/g, '""')}"` : e;
}
const EB = (e, t) => {
  const {
    delimiterCharacter: o,
    ignoreValueFormatter: i
  } = t;
  let s;
  if (i) {
    var c;
    const m = e.colDef.type;
    if (m === "number")
      s = String(e.value);
    else if (m === "date" || m === "dateTime") {
      var f;
      s = (f = e.value) == null ? void 0 : f.toISOString();
    } else
      typeof ((c = e.value) == null ? void 0 : c.toString) == "function" ? s = e.value.toString() : s = e.value;
  } else
    s = e.formattedValue;
  return lk(s, o);
}, _ye = Ws(["MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]);
class sk {
  constructor(t) {
    this.options = void 0, this.rowString = "", this.isEmpty = !0, this.options = t;
  }
  addValue(t) {
    this.isEmpty || (this.rowString += this.options.delimiterCharacter), t == null ? this.rowString += "" : typeof this.options.sanitizeCellValue == "function" ? this.rowString += this.options.sanitizeCellValue(t, this.options.delimiterCharacter) : this.rowString += t, this.isEmpty = !1;
  }
  getRowString() {
    return this.rowString;
  }
}
const Aye = ({
  id: e,
  columns: t,
  getCellParams: o,
  delimiterCharacter: i,
  ignoreValueFormatter: s
}) => {
  const c = new sk({
    delimiterCharacter: i
  });
  return t.forEach((f) => {
    const m = o(e, f.field);
    process.env.NODE_ENV !== "production" && String(m.formattedValue) === "[object Object]" && _ye(), c.addValue(EB(m, {
      delimiterCharacter: i,
      ignoreValueFormatter: s
    }));
  }), c.getRowString();
};
function Lye(e) {
  const {
    columns: t,
    rowIds: o,
    delimiterCharacter: i,
    includeHeaders: s,
    includeColumnGroupsHeaders: c,
    ignoreValueFormatter: f,
    apiRef: m
  } = e, h = o.reduce((T, P) => `${T}${Aye({
    id: P,
    columns: t,
    getCellParams: m.current.getCellParams,
    delimiterCharacter: i,
    ignoreValueFormatter: f
  })}\r
`, "").trim();
  if (!s)
    return h;
  const v = t.filter((T) => T.field !== Zh.field), b = [];
  if (c) {
    const T = m.current.unstable_getAllGroupDetails();
    let P = 0;
    const O = v.reduce((k, I) => {
      const $ = m.current.unstable_getColumnGroupPath(I.field);
      return k[I.field] = $, P = Math.max(P, $.length), k;
    }, {});
    for (let k = 0; k < P; k += 1) {
      const I = new sk({
        delimiterCharacter: i,
        sanitizeCellValue: lk
      });
      b.push(I), v.forEach(($) => {
        const _ = (O[$.field] || [])[k], z = T[_];
        I.addValue(z ? z.headerName || z.groupId : "");
      });
    }
  }
  const x = new sk({
    delimiterCharacter: i,
    sanitizeCellValue: lk
  });
  return v.forEach((T) => {
    x.addValue(T.headerName || T.field);
  }), b.push(x), `${`${b.map((T) => T.getRowString()).join(`\r
`)}\r
`}${h}`.trim();
}
function AA(e) {
  const t = document.createElement("span");
  t.style.whiteSpace = "pre", t.style.userSelect = "all", t.style.opacity = "0px", t.textContent = e, document.body.appendChild(t);
  const o = document.createRange();
  o.selectNode(t);
  const i = window.getSelection();
  i.removeAllRanges(), i.addRange(o);
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(t);
  }
}
function Fye(e) {
  navigator.clipboard ? navigator.clipboard.writeText(e).catch(() => {
    AA(e);
  }) : AA(e);
}
function zye(e) {
  var t;
  return !!((t = window.getSelection()) != null && t.toString() || e && (e.selectionEnd || 0) - (e.selectionStart || 0) > 0);
}
const Vye = (e, t) => {
  const o = t.unstable_ignoreValueFormatterDuringExport, i = (typeof o == "object" ? o == null ? void 0 : o.clipboardExport : o) || !1, s = t.clipboardCopyCellDelimiter, c = C.useCallback((f) => {
    if (!((f.ctrlKey || f.metaKey) && f.key === "c") || zye(f.target))
      return;
    let m = "";
    if (e.current.getSelectedRows().size > 0)
      m = e.current.getDataAsCsv({
        includeHeaders: !1,
        // TODO: make it configurable
        delimiter: s
      });
    else {
      const v = Va(e);
      if (v) {
        const b = e.current.getCellParams(v.id, v.field);
        m = EB(b, {
          delimiterCharacter: s,
          ignoreValueFormatter: i
        });
      }
    }
    m = e.current.unstable_applyPipeProcessors("clipboardCopy", m), m && (Fye(m), e.current.publishEvent("clipboardCopy", m));
  }, [e, i, s]);
  jge(e, e.current.rootElementRef, "keydown", c), Mr(e, "clipboardCopy", t.onClipboardCopy);
}, Bye = (e) => S({}, e, {
  columnMenu: {
    open: !1
  }
}), jye = (e) => {
  const t = Ra(e, "useGridColumnMenu"), o = C.useCallback((f) => {
    e.current.setState((h) => h.columnMenu.open && h.columnMenu.field === f ? h : (t.debug("Opening Column Menu"), S({}, h, {
      columnMenu: {
        open: !0,
        field: f
      }
    }))) && (e.current.hidePreferences(), e.current.forceUpdate());
  }, [e, t]), i = C.useCallback(() => {
    const f = nk(e.current.state);
    if (f.field) {
      const h = Kh(e), v = Hl(e), b = Vc(e);
      let x = f.field;
      if (h[x] || (x = b[0]), v[x] === !1) {
        const E = b.filter((P) => P === x ? !0 : v[P] !== !1), T = E.indexOf(x);
        x = E[T + 1] || E[T - 1];
      }
      e.current.setColumnHeaderFocus(x);
    }
    e.current.setState((h) => !h.columnMenu.open && h.columnMenu.field === void 0 ? h : (t.debug("Hiding Column Menu"), S({}, h, {
      columnMenu: S({}, h.columnMenu, {
        open: !1,
        field: void 0
      })
    }))) && e.current.forceUpdate();
  }, [e, t]), s = C.useCallback((f) => {
    t.debug("Toggle Column Menu");
    const m = nk(e.current.state);
    !m.open || m.field !== f ? o(f) : i();
  }, [e, t, o, i]);
  En(e, {
    showColumnMenu: o,
    hideColumnMenu: i,
    toggleColumnMenu: s
  }, "public"), Yt(e, "columnResizeStart", i), Yt(e, "virtualScrollerWheel", e.current.hideColumnMenu), Yt(e, "virtualScrollerTouchMove", e.current.hideColumnMenu);
}, TB = ["maxWidth", "minWidth", "width", "flex"];
function Hye({
  initialFreeSpace: e,
  totalFlexUnits: t,
  flexColumns: o
}) {
  const i = new Set(o.map((f) => f.field)), s = {
    all: {},
    frozenFields: [],
    freeze: (f) => {
      const m = s.all[f];
      m && m.frozen !== !0 && (s.all[f].frozen = !0, s.frozenFields.push(f));
    }
  };
  function c() {
    if (s.frozenFields.length === i.size)
      return;
    const f = {
      min: {},
      max: {}
    };
    let m = e, h = t, v = 0;
    s.frozenFields.forEach((b) => {
      m -= s.all[b].computedWidth, h -= s.all[b].flex;
    });
    for (let b = 0; b < o.length; b += 1) {
      const x = o[b];
      if (s.all[x.field] && s.all[x.field].frozen === !0)
        continue;
      let T = m / h * x.flex;
      T < x.minWidth ? (v += x.minWidth - T, T = x.minWidth, f.min[x.field] = !0) : T > x.maxWidth && (v += x.maxWidth - T, T = x.maxWidth, f.max[x.field] = !0), s.all[x.field] = {
        frozen: !1,
        computedWidth: T,
        flex: x.flex
      };
    }
    v < 0 ? Object.keys(f.max).forEach((b) => {
      s.freeze(b);
    }) : v > 0 ? Object.keys(f.min).forEach((b) => {
      s.freeze(b);
    }) : o.forEach(({
      field: b
    }) => {
      s.freeze(b);
    }), c();
  }
  return c(), s.all;
}
const ck = (e, t) => {
  const o = {};
  let i = 0, s = 0;
  const c = [];
  e.orderedFields.forEach((m) => {
    const h = S({}, e.lookup[m]);
    if (e.columnVisibilityModel[m] === !1)
      h.computedWidth = 0;
    else {
      let v;
      h.flex && h.flex > 0 ? (i += h.flex, v = 0, c.push(h)) : v = Vh(h.width || Gl.width, h.minWidth || Gl.minWidth, h.maxWidth || Gl.maxWidth), s += v, h.computedWidth = v;
    }
    o[m] = h;
  });
  const f = Math.max(t - s, 0);
  if (i > 0 && t > 0) {
    const m = Hye({
      initialFreeSpace: f,
      totalFlexUnits: i,
      flexColumns: c
    });
    Object.keys(m).forEach((h) => {
      o[h].computedWidth = m[h].computedWidth;
    });
  }
  return S({}, e, {
    lookup: o
  });
}, Uye = (e, t) => {
  if (!t)
    return e;
  const {
    orderedFields: o = [],
    dimensions: i = {}
  } = t, s = Object.keys(i);
  if (s.length === 0 && o.length === 0)
    return e;
  const c = {}, f = [];
  for (let b = 0; b < o.length; b += 1) {
    const x = o[b];
    e.lookup[x] && (c[x] = !0, f.push(x));
  }
  const m = f.length === 0 ? e.orderedFields : [...f, ...e.orderedFields.filter((b) => !c[b])], h = S({}, e.lookup);
  for (let b = 0; b < s.length; b += 1) {
    const x = s[b], E = S({}, h[x], {
      hasBeenResized: !0
    });
    Object.entries(i[x]).forEach(([T, P]) => {
      E[T] = P === -1 ? 1 / 0 : P;
    }), h[x] = E;
  }
  return S({}, e, {
    orderedFields: m,
    lookup: h
  });
};
function LA(e, t) {
  let o = e[wB];
  return t && e[t] && (o = e[t]), o;
}
const mh = ({
  apiRef: e,
  columnsToUpsert: t,
  initialState: o,
  columnTypes: i,
  columnVisibilityModel: s = Hl(e),
  keepOnlyColumnsToUpsert: c = !1
}) => {
  var f, m, h;
  const v = !e.current.state.columns;
  let b;
  if (v)
    b = {
      orderedFields: [],
      lookup: {},
      columnVisibilityModel: s
    };
  else {
    const P = Kf(e.current.state);
    b = {
      orderedFields: c ? [] : [...P.orderedFields],
      lookup: S({}, P.lookup),
      // Will be cleaned later if keepOnlyColumnsToUpsert=true
      columnVisibilityModel: s
    };
  }
  let x = {};
  c && !v && (x = Object.keys(b.lookup).reduce((P, O) => S({}, P, {
    [O]: !1
  }), {})), t.forEach((P) => {
    const {
      field: O
    } = P;
    x[O] = !0;
    let k = b.lookup[O];
    k == null ? (k = S({}, LA(i, P.type), {
      field: O,
      hasBeenResized: !1
    }), b.orderedFields.push(O)) : c && b.orderedFields.push(O), k && k.type !== P.type && (k = S({}, LA(i, P.type), {
      field: O
    }));
    let I = k.hasBeenResized;
    TB.forEach(($) => {
      P[$] !== void 0 && (I = !0, P[$] === -1 && (P[$] = 1 / 0));
    }), b.lookup[O] = S({}, k, P, {
      hasBeenResized: I
    });
  }), c && !v && Object.keys(b.lookup).forEach((P) => {
    x[P] || delete b.lookup[P];
  });
  const E = e.current.unstable_applyPipeProcessors("hydrateColumns", b), T = Uye(E, o);
  return ck(T, (f = (m = (h = e.current).getRootDimensions) == null || (m = m.call(h)) == null ? void 0 : m.viewportInnerSize.width) != null ? f : 0);
}, FA = (e) => (t) => S({}, t, {
  columns: e
});
function uk({
  firstColumnToRender: e,
  apiRef: t,
  firstRowToRender: o,
  lastRowToRender: i,
  visibleRows: s
}) {
  let c = e;
  for (let f = o; f < i; f += 1)
    if (s[f]) {
      const h = s[f].id, v = t.current.unstable_getCellColSpanInfo(h, e);
      v && v.spannedByColSpan && (c = v.leftVisibleCellIndex);
    }
  return c;
}
function Gye({
  firstColumnIndex: e,
  minColumnIndex: t,
  columnBuffer: o,
  firstRowToRender: i,
  lastRowToRender: s,
  apiRef: c,
  visibleRows: f
}) {
  const m = Math.max(e - o, t);
  return uk({
    firstColumnToRender: m,
    apiRef: c,
    firstRowToRender: i,
    lastRowToRender: s,
    visibleRows: f
  });
}
function iM(e, t) {
  const o = Qh(e), i = Dy(e);
  return Math.floor(t * o) * ((i ?? 0) + 1);
}
const OB = Dye(), Wye = (e, t, o) => {
  var i, s, c, f;
  const m = mh({
    apiRef: o,
    columnTypes: OB,
    columnsToUpsert: t.columns,
    initialState: (i = t.initialState) == null ? void 0 : i.columns,
    columnVisibilityModel: (s = (c = t.columnVisibilityModel) != null ? c : (f = t.initialState) == null || (f = f.columns) == null ? void 0 : f.columnVisibilityModel) != null ? s : {},
    keepOnlyColumnsToUpsert: !0
  });
  return S({}, e, {
    columns: m
  });
};
function qye(e, t) {
  var o, i;
  const s = Ra(e, "useGridColumns"), c = OB, f = C.useRef(t.columns), m = C.useRef(c);
  e.current.registerControlState({
    stateId: "visibleColumns",
    propModel: t.columnVisibilityModel,
    propOnChange: t.onColumnVisibilityModelChange,
    stateSelector: Hl,
    changeEvent: "columnVisibilityModelChange"
  });
  const h = C.useCallback((B) => {
    s.debug("Updating columns state."), e.current.setState(FA(B)), e.current.forceUpdate(), e.current.publishEvent("columnsChange", B.orderedFields);
  }, [s, e]), v = C.useCallback((B) => Kh(e)[B], [e]), b = C.useCallback(() => Bs(e), [e]), x = C.useCallback(() => la(e), [e]), E = C.useCallback((B, q = !0) => (q ? la(e) : Bs(e)).findIndex((J) => J.field === B), [e]), T = C.useCallback((B) => {
    const q = E(B);
    return zh(e)[q];
  }, [e, E]), P = C.useCallback((B) => {
    Hl(e) !== B && (e.current.setState((X) => S({}, X, {
      columns: mh({
        apiRef: e,
        columnTypes: c,
        columnsToUpsert: [],
        initialState: void 0,
        columnVisibilityModel: B,
        keepOnlyColumnsToUpsert: !1
      })
    })), e.current.forceUpdate());
  }, [e, c]), O = C.useCallback((B) => {
    const q = mh({
      apiRef: e,
      columnTypes: c,
      columnsToUpsert: B,
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    h(q);
  }, [e, h, c]), k = C.useCallback((B, q) => {
    var X;
    const J = Hl(e), U = (X = J[B]) != null ? X : !0;
    if (q !== U) {
      const Z = S({}, J, {
        [B]: q
      });
      e.current.setColumnVisibilityModel(Z);
    }
  }, [e]), I = C.useCallback((B) => Vc(e).findIndex((X) => X === B), [e]), $ = C.useCallback((B, q) => {
    const X = Vc(e), J = I(B);
    if (J === q)
      return;
    s.debug(`Moving column ${B} to index ${q}`);
    const U = [...X], Z = U.splice(J, 1)[0];
    U.splice(q, 0, Z), h(S({}, Kf(e.current.state), {
      orderedFields: U
    }));
    const ee = {
      column: e.current.getColumn(B),
      targetIndex: e.current.getColumnIndexRelativeToVisibleColumns(B),
      oldIndex: J
    };
    e.current.publishEvent("columnIndexChange", ee);
  }, [e, s, h, I]), _ = C.useCallback((B, q) => {
    var X, J;
    s.debug(`Updating column ${B} width to ${q}`);
    const U = Kf(e.current.state), Z = U.lookup[B], ee = S({}, Z, {
      width: q,
      hasBeenResized: !0
    });
    h(ck(S({}, U, {
      lookup: S({}, U.lookup, {
        [B]: ee
      })
    }), (X = (J = e.current.getRootDimensions()) == null ? void 0 : J.viewportInnerSize.width) != null ? X : 0)), e.current.publishEvent("columnWidthChange", {
      element: e.current.getColumnHeaderElement(B),
      colDef: ee,
      width: q
    });
  }, [e, s, h]), z = {
    getColumn: v,
    getAllColumns: b,
    getColumnIndex: E,
    getColumnPosition: T,
    getVisibleColumns: x,
    getColumnIndexRelativeToVisibleColumns: I,
    updateColumns: O,
    setColumnVisibilityModel: P,
    setColumnVisibility: k,
    setColumnWidth: _
  }, V = {
    setColumnIndex: $
  };
  En(e, z, "public"), En(e, V, t.signature === js.DataGrid ? "private" : "public");
  const M = C.useCallback((B, q) => {
    var X, J;
    const U = {}, Z = Hl(e);
    // Always export if the `exportOnlyDirtyModels` property is not activated
    (!q.exportOnlyDirtyModels || // Always export if the model is controlled
    t.columnVisibilityModel != null || // Always export if the model has been initialized
    // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
    Object.keys((X = (J = t.initialState) == null || (J = J.columns) == null ? void 0 : J.columnVisibilityModel) != null ? X : {}).length > 0 || // Always export if the model is not empty
    Object.keys(Z).length > 0) && (U.columnVisibilityModel = Z), U.orderedFields = Vc(e);
    const ie = Bs(e), oe = {};
    return ie.forEach((le) => {
      if (le.hasBeenResized) {
        const de = {};
        TB.forEach((Ce) => {
          let me = le[Ce];
          me === 1 / 0 && (me = -1), de[Ce] = me;
        }), oe[le.field] = de;
      }
    }), Object.keys(oe).length > 0 && (U.dimensions = oe), S({}, B, {
      columns: U
    });
  }, [e, t.columnVisibilityModel, (o = t.initialState) == null ? void 0 : o.columns]), A = C.useCallback((B, q) => {
    var X;
    const J = (X = q.stateToRestore.columns) == null ? void 0 : X.columnVisibilityModel, U = q.stateToRestore.columns;
    if (J == null && U == null)
      return B;
    const Z = mh({
      apiRef: e,
      columnTypes: c,
      columnsToUpsert: [],
      initialState: U,
      columnVisibilityModel: J,
      keepOnlyColumnsToUpsert: !1
    });
    return e.current.setState(FA(Z)), U != null && e.current.publishEvent("columnsChange", Z.orderedFields), B;
  }, [e, c]), W = C.useCallback((B, q) => {
    if (q === op.columns) {
      var X;
      const J = t.slots.columnsPanel;
      return /* @__PURE__ */ L(J, S({}, (X = t.slotProps) == null ? void 0 : X.columnsPanel));
    }
    return B;
  }, [t.slots.columnsPanel, (i = t.slotProps) == null ? void 0 : i.columnsPanel]), Y = C.useCallback((B) => t.disableColumnSelector ? B : [...B, "columnMenuColumnsItem"], [t.disableColumnSelector]);
  _o(e, "columnMenu", Y), _o(e, "exportState", M), _o(e, "restoreState", A), _o(e, "preferencePanel", W);
  const H = C.useRef(null);
  Yt(e, "viewportInnerSizeChange", (B) => {
    H.current !== B.width && (H.current = B.width, h(ck(Kf(e.current.state), B.width)));
  });
  const ne = C.useCallback(() => {
    s.info("Columns pipe processing have changed, regenerating the columns");
    const B = mh({
      apiRef: e,
      columnTypes: c,
      columnsToUpsert: [],
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    h(B);
  }, [e, s, h, c]);
  aM(e, "hydrateColumns", ne);
  const K = C.useRef(!0);
  C.useEffect(() => {
    if (K.current) {
      K.current = !1;
      return;
    }
    if (s.info(`GridColumns have changed, new length ${t.columns.length}`), f.current === t.columns && m.current === c)
      return;
    const B = mh({
      apiRef: e,
      columnTypes: c,
      initialState: void 0,
      // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
      columnsToUpsert: t.columns,
      keepOnlyColumnsToUpsert: !0
    });
    f.current = t.columns, m.current = c, h(B);
  }, [s, e, h, t.columns, c]), C.useEffect(() => {
    t.columnVisibilityModel !== void 0 && e.current.setColumnVisibilityModel(t.columnVisibilityModel);
  }, [e, s, t.columnVisibilityModel]);
}
const Yye = 0.7, Kye = 1.3, RB = {
  compact: Yye,
  comfortable: Kye,
  standard: 1
}, Xye = (e, t) => S({}, e, {
  density: {
    value: t.density,
    factor: RB[t.density]
  }
}), Qye = (e, t) => {
  const o = Ra(e, "useDensity"), i = C.useCallback((c) => {
    o.debug(`Set grid density to ${c}`), e.current.setState((f) => {
      const m = UP(f), h = {
        value: c,
        factor: RB[c]
      };
      return Qf(m, h) ? f : S({}, f, {
        density: h
      });
    }), e.current.forceUpdate();
  }, [o, e]);
  C.useEffect(() => {
    e.current.setDensity(t.density);
  }, [e, t.density]), En(e, {
    setDensity: i
  }, "public");
};
function Zye(e, t = "csv", o = document.title || "untitled") {
  const i = `${o}.${t}`;
  if ("download" in HTMLAnchorElement.prototype) {
    const s = URL.createObjectURL(e), c = document.createElement("a");
    c.href = s, c.download = i, c.click(), setTimeout(() => {
      URL.revokeObjectURL(s);
    });
    return;
  }
  throw new Error("MUI: exportAs not supported");
}
const kB = ({
  apiRef: e,
  options: t
}) => {
  const o = Bs(e);
  return t.fields ? t.fields.reduce((s, c) => {
    const f = o.find((m) => m.field === c);
    return f && s.push(f), s;
  }, []) : (t.allColumns ? o : la(e)).filter((s) => !s.disableExport);
}, Jye = ({
  apiRef: e
}) => {
  var t, o;
  const i = the(e), s = zl(e), c = e.current.getSelectedRows(), f = i.filter((b) => s[b].type !== "footer"), m = Xh(e), h = (m == null || (t = m.top) == null ? void 0 : t.map((b) => b.id)) || [], v = (m == null || (o = m.bottom) == null ? void 0 : o.map((b) => b.id)) || [];
  return f.unshift(...h), f.push(...v), c.size > 0 ? f.filter((b) => c.has(b)) : f;
}, eCe = (e, t) => {
  const o = Ra(e, "useGridCsvExport"), i = t.unstable_ignoreValueFormatterDuringExport, s = (typeof i == "object" ? i == null ? void 0 : i.csvExport : i) || !1, c = C.useCallback((v = {}) => {
    var b, x, E;
    o.debug("Get data as CSV");
    const T = kB({
      apiRef: e,
      options: v
    }), O = ((b = v.getRowsToExport) != null ? b : Jye)({
      apiRef: e
    });
    return Lye({
      columns: T,
      rowIds: O,
      delimiterCharacter: v.delimiter || ",",
      includeHeaders: (x = v.includeHeaders) != null ? x : !0,
      includeColumnGroupsHeaders: (E = v.includeColumnGroupsHeaders) != null ? E : !0,
      ignoreValueFormatter: s,
      apiRef: e
    });
  }, [o, e, s]), f = C.useCallback((v) => {
    o.debug("Export data as CSV");
    const b = c(v), x = new Blob([v != null && v.utf8WithBom ? new Uint8Array([239, 187, 191]) : "", b], {
      type: "text/csv"
    });
    Zye(x, "csv", v == null ? void 0 : v.fileName);
  }, [o, c]);
  En(e, {
    getDataAsCsv: c,
    exportDataAsCsv: f
  }, "public");
  const h = C.useCallback((v, b) => {
    var x;
    return (x = b.csvOptions) != null && x.disableToolbarButton ? v : [...v, {
      component: /* @__PURE__ */ L(Fbe, {
        options: b.csvOptions
      }),
      componentName: "csvExport"
    }];
  }, []);
  _o(e, "exportMenu", h);
}, tCe = (e, t) => {
  var o, i;
  const s = S({}, z4(t.autoPageSize), (o = t.paginationModel) != null ? o : (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.paginationModel);
  return V4(s.pageSize, t.signature), S({}, e, {
    pagination: {
      paginationModel: s
    }
  });
}, T1 = (e, t, o) => (i) => {
  var s;
  let c = i.paginationModel;
  const f = (s = o == null ? void 0 : o.pageSize) != null ? s : c.pageSize, m = F4(e, f);
  o && ((o == null ? void 0 : o.page) !== c.page || (o == null ? void 0 : o.pageSize) !== c.pageSize) && (c = o);
  const h = Wge(c.page, m);
  return h !== c.page && (c = S({}, c, {
    page: h
  })), V4(c.pageSize, t), {
    paginationModel: c
  };
}, nCe = (e, t) => {
  var o;
  const i = Ra(e, "useGridPagination"), s = Nt(e, Ux), c = Nt(e, Qh), f = Math.floor(t.rowHeight * c);
  e.current.registerControlState({
    stateId: "pagination",
    propModel: t.paginationModel,
    propOnChange: t.onPaginationModelChange,
    stateSelector: rl,
    changeEvent: "paginationModelChange"
  });
  const m = C.useCallback((O) => {
    const k = rl(e);
    O !== k.page && (i.debug(`Setting page to ${O}`), e.current.setPaginationModel({
      page: O,
      pageSize: k.pageSize
    }));
  }, [e, i]), h = C.useCallback((O) => {
    const k = rl(e);
    O !== k.pageSize && (i.debug(`Setting page size to ${O}`), e.current.setPaginationModel({
      pageSize: O,
      page: k.page
    }));
  }, [e, i]), v = C.useCallback((O) => {
    var k;
    const I = rl(e);
    O !== I && (i.debug("Setting 'paginationModel' to", O), e.current.updateControlState("pagination", T1((k = t.rowCount) != null ? k : s, t.signature, O), "setPaginationModel"), e.current.forceUpdate());
  }, [e, i, t.rowCount, t.signature, s]);
  En(e, {
    setPage: m,
    setPageSize: h,
    setPaginationModel: v
  }, "public");
  const x = C.useCallback((O, k) => {
    var I;
    const $ = rl(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !k.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
      t.paginationModel != null || // Always export if the `paginationModel` has been initialized
      ((I = t.initialState) == null || (I = I.pagination) == null ? void 0 : I.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
      $.page !== 0 && $.pageSize !== Uge(t.autoPageSize) ? S({}, O, {
        pagination: S({}, O.pagination, {
          paginationModel: $
        })
      }) : O
    );
  }, [e, t.paginationModel, (o = t.initialState) == null || (o = o.pagination) == null ? void 0 : o.paginationModel, t.autoPageSize]), E = C.useCallback((O, k) => {
    var I, $, _;
    const z = (I = k.stateToRestore.pagination) != null && I.paginationModel ? S({}, z4(t.autoPageSize), ($ = k.stateToRestore.pagination) == null ? void 0 : $.paginationModel) : rl(e);
    return e.current.updateControlState("pagination", T1((_ = t.rowCount) != null ? _ : s, t.signature, z), "stateRestorePreProcessing"), O;
  }, [e, t.autoPageSize, t.rowCount, t.signature, s]);
  _o(e, "exportState", x), _o(e, "restoreState", E);
  const T = () => {
    var O;
    const k = rl(e);
    (O = e.current.virtualScrollerRef) != null && O.current && e.current.scrollToIndexes({
      rowIndex: k.page * k.pageSize
    }), e.current.forceUpdate();
  }, P = C.useCallback(() => {
    const O = e.current.getRootDimensions();
    if (!t.autoPageSize || !O)
      return;
    const k = i4(e), I = Math.floor((O.viewportInnerSize.height - k.top - k.bottom) / f);
    e.current.setPageSize(I);
  }, [e, t.autoPageSize, f]);
  Yt(e, "viewportInnerSizeChange", P), Yt(e, "paginationModelChange", T), C.useEffect(() => {
    process.env.NODE_ENV !== "production" && t.paginationMode === "server" && t.rowCount == null && Gge();
  }, [t.rowCount, t.paginationMode]), C.useEffect(() => {
    var O;
    e.current.updateControlState("pagination", T1((O = t.rowCount) != null ? O : s, t.signature, t.paginationModel));
  }, [e, t.paginationModel, t.rowCount, t.paginationMode, s, t.signature]), C.useEffect(() => {
    P();
  }, [P]);
};
function rCe() {
  return new Promise((e) => {
    requestAnimationFrame(() => {
      e();
    });
  });
}
function oCe(e) {
  const t = document.createElement("iframe");
  return t.style.position = "absolute", t.style.width = "0px", t.style.height = "0px", t.title = e || document.title, t;
}
const aCe = (e, t) => {
  const o = Ra(e, "useGridPrintExport"), i = C.useRef(null), s = C.useRef(null), c = C.useRef({}), f = C.useRef([]);
  C.useEffect(() => {
    i.current = qn(e.current.rootElementRef.current);
  }, [e]);
  const m = C.useCallback((P, O, k) => new Promise((I) => {
    const $ = kB({
      apiRef: e,
      options: {
        fields: P,
        allColumns: O
      }
    }).map((V) => V.field), _ = Bs(e), z = {};
    _.forEach((V) => {
      z[V.field] = $.includes(V.field);
    }), k && (z[Zh.field] = !0), e.current.setColumnVisibilityModel(z), I();
  }), [e]), h = C.useCallback((P) => {
    const k = P({
      apiRef: e
    }).map((I) => e.current.getRow(I));
    e.current.setRows(k);
  }, [e]), v = C.useCallback((P, O) => {
    var k, I;
    const $ = S({
      copyStyles: !0,
      hideToolbar: !1,
      hideFooter: !1,
      includeCheckboxes: !1
    }, O), _ = P.contentDocument;
    if (!_)
      return;
    const z = my(e.current.state), V = e.current.rootElementRef.current, M = V.cloneNode(!0), A = M.querySelector(`.${Te.main}`);
    A.style.overflow = "visible", M.style.contain = "size";
    const Y = M.querySelector(`.${Te.columnHeaders}`).querySelector(`.${Te.columnHeadersInner}`);
    Y.style.width = "100%";
    let H = ((k = V.querySelector(`.${Te.toolbarContainer}`)) == null ? void 0 : k.offsetHeight) || 0, G = ((I = V.querySelector(`.${Te.footerContainer}`)) == null ? void 0 : I.offsetHeight) || 0;
    if ($.hideToolbar) {
      var ne;
      (ne = M.querySelector(`.${Te.toolbarContainer}`)) == null || ne.remove(), H = 0;
    }
    if ($.hideFooter) {
      var K;
      (K = M.querySelector(`.${Te.footerContainer}`)) == null || K.remove(), G = 0;
    }
    const B = z.currentPageTotalHeight + iM(e, t.columnHeaderHeight) + H + G;
    if (M.style.height = `${B}px`, M.style.boxSizing = "content-box", O != null && O.getRowsToExport) {
      const U = M.querySelector(`.${Te.footerContainer}`);
      U.style.position = "absolute", U.style.width = "100%", U.style.top = `${B - G}px`;
    }
    const q = document.createElement("div");
    q.appendChild(M), _.body.innerHTML = q.innerHTML;
    const X = typeof $.pageStyle == "function" ? $.pageStyle() : $.pageStyle;
    if (typeof X == "string") {
      const U = _.createElement("style");
      U.appendChild(_.createTextNode(X)), _.head.appendChild(U);
    }
    $.bodyClassName && _.body.classList.add(...$.bodyClassName.split(" "));
    const J = [];
    if ($.copyStyles) {
      const U = V.getRootNode(), ee = (U.constructor.name === "ShadowRoot" ? U : i.current).querySelectorAll("style, link[rel='stylesheet']");
      for (let ie = 0; ie < ee.length; ie += 1) {
        const oe = ee[ie];
        if (oe.tagName === "STYLE") {
          const le = _.createElement(oe.tagName), de = oe.sheet;
          if (de) {
            let Ce = "";
            for (let me = 0; me < de.cssRules.length; me += 1)
              typeof de.cssRules[me].cssText == "string" && (Ce += `${de.cssRules[me].cssText}\r
`);
            le.appendChild(_.createTextNode(Ce)), _.head.appendChild(le);
          }
        } else if (oe.getAttribute("href")) {
          const le = _.createElement(oe.tagName);
          for (let de = 0; de < oe.attributes.length; de += 1) {
            const Ce = oe.attributes[de];
            Ce && le.setAttribute(Ce.nodeName, Ce.nodeValue || "");
          }
          J.push(new Promise((de) => {
            le.addEventListener("load", () => de());
          })), _.head.appendChild(le);
        }
      }
    }
    process.env.NODE_ENV !== "test" && Promise.all(J).then(() => {
      P.contentWindow.print();
    });
  }, [e, i, t.columnHeaderHeight]), b = C.useCallback((P) => {
    var O;
    i.current.body.removeChild(P), e.current.restoreState(s.current || {}), (O = s.current) != null && (O = O.columns) != null && O.columnVisibilityModel || e.current.setColumnVisibilityModel(c.current), e.current.unstable_setVirtualization(!0), e.current.setRows(f.current), s.current = null, c.current = {}, f.current = [];
  }, [e]), E = {
    exportDataAsPrint: C.useCallback(async (P) => {
      if (o.debug("Export data as Print"), !e.current.rootElementRef.current)
        throw new Error("MUI: No grid root element available.");
      if (s.current = e.current.exportState(), c.current = Hl(e), f.current = e.current.getSortedRows(), t.pagination) {
        const k = t4(e), I = {
          page: 0,
          pageSize: k
        };
        e.current.updateControlState(
          "pagination",
          // Using signature `DataGridPro` to allow more than 100 rows in the print export
          T1(k, "DataGridPro", I)
        ), e.current.forceUpdate();
      }
      await m(P == null ? void 0 : P.fields, P == null ? void 0 : P.allColumns, P == null ? void 0 : P.includeCheckboxes), P != null && P.getRowsToExport && h(P.getRowsToExport), e.current.unstable_setVirtualization(!1), await rCe();
      const O = oCe(P == null ? void 0 : P.fileName);
      process.env.NODE_ENV === "test" ? (i.current.body.appendChild(O), v(O, P), b(O)) : (O.onload = () => {
        v(O, P), O.contentWindow.matchMedia("print").addEventListener("change", (I) => {
          I.matches === !1 && b(O);
        });
      }, i.current.body.appendChild(O));
    }, [t, o, e, v, b, m, h])
  };
  En(e, E, "public");
  const T = C.useCallback((P, O) => {
    var k;
    return (k = O.printOptions) != null && k.disableToolbarButton ? P : [...P, {
      component: /* @__PURE__ */ L(zbe, {
        options: O.printOptions
      }),
      componentName: "printExport"
    }];
  }, []);
  _o(e, "exportMenu", T);
}, iCe = typeof window > "u" ? globalThis : window, PB = iCe[atob("ZXZhbA==")];
let dk;
try {
  dk = PB("true");
} catch {
  dk = !1;
}
const fk = (e, t) => {
  const o = S({}, e);
  if (o.id == null && (o.id = Math.round(Math.random() * 1e5)), o.operator == null) {
    const i = Kh(t)[o.field];
    o.operator = i && i.filterOperators[0].value;
  }
  return o;
}, lCe = Ws(["MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.", "If you are using the community version of the `DataGrid`, this prop is always `true`."], "error"), sCe = Ws("MUI: The `id` field is required on `filterModel.items` when you use multiple filters.", "error"), cCe = Ws("MUI: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error"), MB = (e, t, o) => {
  const i = e.items.length > 1;
  let s;
  i && t ? (lCe(), s = [e.items[0]]) : s = e.items;
  const c = i && s.some((m) => m.id == null), f = s.some((m) => m.operator == null);
  return c && sCe(), f && cCe(), f || c ? S({}, e, {
    items: s.map((m) => fk(m, o))
  }) : e.items !== s ? S({}, e, {
    items: s
  }) : e;
}, zA = (e, t, o) => (i) => S({}, i, {
  filterModel: MB(e, t, o)
}), IB = (e, t) => {
  if (!e.field || !e.operator)
    return null;
  const o = t.current.getColumn(e.field);
  if (!o)
    return null;
  let i;
  if (o.valueParser) {
    var s;
    const x = o.valueParser;
    i = Array.isArray(e.value) ? (s = e.value) == null ? void 0 : s.map((E) => x(E)) : x(e.value);
  } else
    i = e.value;
  const c = S({}, e, {
    value: i
  }), f = o.filterOperators;
  if (!(f != null && f.length))
    throw new Error(`MUI: No filter operators found for column '${o.field}'.`);
  const m = f.find((x) => x.value === c.operator);
  if (!m)
    throw new Error(`MUI: No filter operator found for column '${o.field}' and operator value '${c.operator}'.`);
  const h = !ax(m.getApplyFilterFn), v = !ax(m.getApplyFilterFnV7);
  if (m.getApplyFilterFnV7 && !(h && !v)) {
    const x = m.getApplyFilterFnV7(c, o);
    return typeof x != "function" ? null : {
      v7: !0,
      item: c,
      fn: (E) => {
        const T = t.current.getRowValue(E, o);
        return x(T, E, o, t);
      }
    };
  }
  const b = m.getApplyFilterFn(c, o);
  return typeof b != "function" ? null : {
    v7: !1,
    item: c,
    fn: (x) => {
      const E = t.current.getCellParams(x, c.field);
      ik.current = t;
      const T = b(E);
      return ik.current = null, T;
    }
  };
};
let VA = 1;
const uCe = (e, t, o, i) => {
  const {
    items: s
  } = t, c = s.map((v) => IB(v, o)).filter((v) => !!v);
  if (c.length === 0)
    return null;
  if (!dk || i)
    return (v, b) => {
      const x = {};
      for (let E = 0; E < c.length; E += 1) {
        const T = c[E];
        (!b || b(T.item.field)) && (x[T.item.id] = T.v7 ? T.fn(v) : T.fn(e ? e(v) : v.id));
      }
      return x;
    };
  const f = `(function filterItem$$(appliers, row, shouldApplyFilter) {
      ${c.map((v, b) => `const shouldApply${b} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(v.item.field)});`).join(`
`)}

      const result$$ = {
      ${c.map((v, b) => `${JSON.stringify(String(v.item.id))}:
          !shouldApply${b} ?
            false :
            ${v.v7 ? `appliers[${b}].fn(row)` : `appliers[${b}].fn(${e ? "getRowId(row)" : "row.id"})`},
      `).join(`
`)}};

      return result$$;
    })`, m = PB(f.replaceAll("$$", String(VA))), h = (v, b) => m(c, v, b);
  return VA += 1, h;
}, dCe = (e, t, o) => {
  var i, s, c;
  const f = (i = (s = t.quickFilterValues) == null ? void 0 : s.filter(Boolean)) != null ? i : [];
  if (f.length === 0)
    return null;
  const h = ((c = t.quickFilterExcludeHiddenColumns) != null ? c : !1) ? Vx(o) : Vc(o), v = [];
  return h.forEach((b) => {
    const x = o.current.getColumn(b), E = x == null ? void 0 : x.getApplyQuickFilterFn, T = x == null ? void 0 : x.getApplyQuickFilterFnV7, P = !ax(E), O = !ax(T);
    T && !(P && !O) ? v.push({
      column: x,
      appliers: f.map((k) => ({
        v7: !0,
        fn: T(k, x, o)
      }))
    }) : E && v.push({
      column: x,
      appliers: f.map((k) => ({
        v7: !1,
        fn: E(k, x, o)
      }))
    });
  }), function(x, E) {
    const T = {}, P = {};
    e:
      for (let k = 0; k < f.length; k += 1) {
        const I = f[k];
        for (let $ = 0; $ < v.length; $ += 1) {
          const {
            column: _,
            appliers: z
          } = v[$], {
            field: V
          } = _;
          if (E && !E(V))
            continue;
          const M = z[k], A = o.current.getRowValue(x, _);
          if (M.fn !== null)
            if (M.v7) {
              if (M.fn(A, x, _, o)) {
                T[I] = !0;
                continue e;
              }
            } else {
              var O;
              const W = (O = P[V]) != null ? O : o.current.getCellParams(e ? e(x) : x.id, V);
              if (P[V] = W, M.fn(W)) {
                T[I] = !0;
                continue e;
              }
            }
        }
        T[I] = !1;
      }
    return T;
  };
}, fCe = (e, t, o, i) => {
  const s = uCe(e, t, o, i), c = dCe(e, t, o);
  return function(m, h, v) {
    var b, x;
    v.passingFilterItems = (b = s == null ? void 0 : s(m, h)) != null ? b : null, v.passingQuickFilterValues = (x = c == null ? void 0 : c(m, h)) != null ? x : null;
  };
}, BA = (e) => e != null, pCe = (e, t, o) => (e.cleanedFilterItems || (e.cleanedFilterItems = o.filter((i) => IB(i, t) !== null)), e.cleanedFilterItems), mCe = (e, t, o, i, s) => {
  const c = pCe(s, i, o.items), f = e.filter(BA), m = t.filter(BA);
  if (f.length > 0) {
    var h;
    const b = (E) => f.some((T) => T[E.id]);
    if (((h = o.logicOperator) != null ? h : fy().logicOperator) === pi.And) {
      if (!c.every(b))
        return !1;
    } else if (!c.some(b))
      return !1;
  }
  if (m.length > 0 && o.quickFilterValues != null) {
    var v;
    const b = (E) => m.some((T) => T[E]);
    if (((v = o.quickFilterLogicOperator) != null ? v : fy().quickFilterLogicOperator) === pi.And) {
      if (!o.quickFilterValues.every(b))
        return !1;
    } else if (!o.quickFilterValues.some(b))
      return !1;
  }
  return !0;
}, hCe = (e, t, o) => {
  var i, s, c;
  const f = (i = (s = t.filterModel) != null ? s : (c = t.initialState) == null || (c = c.filter) == null ? void 0 : c.filterModel) != null ? i : fy();
  return S({}, e, {
    filter: {
      filterModel: MB(f, t.disableMultipleColumnsFiltering, o),
      filteredRowsLookup: {},
      filteredDescendantCountLookup: {}
    },
    visibleRowsLookup: {}
  });
}, gCe = (e) => e.filteredRowsLookup;
function jA(e, t) {
  return e.current.applyStrategyProcessor("visibleRowsLookupCreation", {
    tree: t.rows.tree,
    filteredRowsLookup: t.filter.filteredRowsLookup
  });
}
function vCe() {
  return zx(Object.values);
}
const bCe = (e, t) => {
  var o, i;
  const s = Ra(e, "useGridFilter");
  e.current.registerControlState({
    stateId: "filter",
    propModel: t.filterModel,
    propOnChange: t.onFilterModelChange,
    stateSelector: oa,
    changeEvent: "filterModelChange"
  });
  const c = C.useCallback(() => {
    e.current.setState((H) => {
      const G = oa(H, e.current.instanceId), ne = t.filterMode === "client" ? fCe(t.getRowId, G, e, t.disableEval) : null, K = e.current.applyStrategyProcessor("filtering", {
        isRowMatchingFilters: ne,
        filterModel: G ?? fy()
      }), B = S({}, H, {
        filter: S({}, H.filter, K)
      }), q = jA(e, B);
      return S({}, B, {
        visibleRowsLookup: q
      });
    }), e.current.publishEvent("filteredRowsSet");
  }, [e, t.filterMode, t.getRowId, t.disableEval]), f = C.useCallback((H, G) => G == null || G.filterable === !1 || t.disableColumnFilter ? H : [...H, "columnMenuFilterItem"], [t.disableColumnFilter]), m = C.useCallback(() => {
    c(), e.current.forceUpdate();
  }, [e, c]), h = C.useCallback((H) => {
    const G = oa(e), ne = [...G.items], K = ne.findIndex((B) => B.id === H.id);
    K === -1 ? ne.push(H) : ne[K] = H, e.current.setFilterModel(S({}, G, {
      items: ne
    }), "upsertFilterItem");
  }, [e]), v = C.useCallback((H) => {
    const G = oa(e), ne = [...G.items];
    H.forEach((K) => {
      const B = H.findIndex((q) => q.id === K.id);
      B === -1 ? ne.push(K) : ne[B] = K;
    }), e.current.setFilterModel(S({}, G, {
      items: H
    }), "upsertFilterItems");
  }, [e]), b = C.useCallback((H) => {
    const G = oa(e), ne = G.items.filter((K) => K.id !== H.id);
    ne.length !== G.items.length && e.current.setFilterModel(S({}, G, {
      items: ne
    }), "deleteFilterItem");
  }, [e]), x = C.useCallback((H, G, ne) => {
    if (s.debug("Displaying filter panel"), H) {
      const K = oa(e), B = K.items.filter((U) => {
        var Z;
        if (U.value !== void 0)
          return !(Array.isArray(U.value) && U.value.length === 0);
        const ie = (Z = e.current.getColumn(U.field).filterOperators) == null ? void 0 : Z.find((le) => le.value === U.operator);
        return !(typeof (ie == null ? void 0 : ie.requiresFilterValue) > "u" ? !0 : ie == null ? void 0 : ie.requiresFilterValue);
      });
      let q;
      const X = B.find((U) => U.field === H), J = e.current.getColumn(H);
      X ? q = B : t.disableMultipleColumnsFiltering ? q = [fk({
        field: H,
        operator: J.filterOperators[0].value
      }, e)] : q = [...B, fk({
        field: H,
        operator: J.filterOperators[0].value
      }, e)], e.current.setFilterModel(S({}, K, {
        items: q
      }));
    }
    e.current.showPreferences(op.filters, G, ne);
  }, [e, s, t.disableMultipleColumnsFiltering]), E = C.useCallback(() => {
    s.debug("Hiding filter panel"), e.current.hidePreferences();
  }, [e, s]), T = C.useCallback((H) => {
    const G = oa(e);
    G.logicOperator !== H && e.current.setFilterModel(S({}, G, {
      logicOperator: H
    }), "changeLogicOperator");
  }, [e]), P = C.useCallback((H) => {
    const G = oa(e);
    Qf(G.quickFilterValues, H) || e.current.setFilterModel(S({}, G, {
      quickFilterValues: [...H]
    }));
  }, [e]), O = C.useCallback((H, G) => {
    oa(e) !== H && (s.debug("Setting filter model"), e.current.updateControlState("filter", zA(H, t.disableMultipleColumnsFiltering, e), G), e.current.unstable_applyFilters());
  }, [e, s, t.disableMultipleColumnsFiltering]);
  En(e, {
    setFilterLogicOperator: T,
    unstable_applyFilters: m,
    deleteFilterItem: b,
    upsertFilterItem: h,
    upsertFilterItems: v,
    setFilterModel: O,
    showFilterPanel: x,
    hideFilterPanel: E,
    setQuickFilterValues: P
  }, "public");
  const I = C.useCallback((H, G) => {
    var ne;
    const K = oa(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !G.exportOnlyDirtyModels || // Always export if the model is controlled
      t.filterModel != null || // Always export if the model has been initialized
      ((ne = t.initialState) == null || (ne = ne.filter) == null ? void 0 : ne.filterModel) != null || // Export if the model is not equal to the default value
      !Qf(K, fy()) ? S({}, H, {
        filter: {
          filterModel: K
        }
      }) : H
    );
  }, [e, t.filterModel, (o = t.initialState) == null || (o = o.filter) == null ? void 0 : o.filterModel]), $ = C.useCallback((H, G) => {
    var ne;
    const K = (ne = G.stateToRestore.filter) == null ? void 0 : ne.filterModel;
    return K == null ? H : (e.current.updateControlState("filter", zA(K, t.disableMultipleColumnsFiltering, e), "restoreState"), S({}, H, {
      callbacks: [...H.callbacks, e.current.unstable_applyFilters]
    }));
  }, [e, t.disableMultipleColumnsFiltering]), _ = C.useCallback((H, G) => {
    if (G === op.filters) {
      var ne;
      const K = t.slots.filterPanel;
      return /* @__PURE__ */ L(K, S({}, (ne = t.slotProps) == null ? void 0 : ne.filterPanel));
    }
    return H;
  }, [t.slots.filterPanel, (i = t.slotProps) == null ? void 0 : i.filterPanel]), {
    getRowId: z
  } = t, V = FP(vCe), M = C.useCallback((H) => {
    if (t.filterMode !== "client" || !H.isRowMatchingFilters)
      return {
        filteredRowsLookup: {},
        filteredDescendantCountLookup: {}
      };
    const G = ud(e), ne = {}, {
      isRowMatchingFilters: K
    } = H, B = {}, q = {
      passingFilterItems: null,
      passingQuickFilterValues: null
    }, X = V.current(e.current.state.rows.dataRowIdToModelLookup);
    for (let Z = 0; Z < X.length; Z += 1) {
      const ee = X[Z], ie = z ? z(ee) : ee.id;
      K(ee, void 0, q);
      const oe = mCe([q.passingFilterItems], [q.passingQuickFilterValues], H.filterModel, e, B);
      ne[ie] = oe;
    }
    const J = "auto-generated-group-footer-root";
    return G[J] && (ne[J] = !0), {
      filteredRowsLookup: ne,
      filteredDescendantCountLookup: {}
    };
  }, [e, t.filterMode, z, V]);
  _o(e, "columnMenu", f), _o(e, "exportState", I), _o(e, "restoreState", $), _o(e, "preferencePanel", _), ix(e, ap, "filtering", M), ix(e, ap, "visibleRowsLookupCreation", gCe);
  const A = C.useCallback(() => {
    s.debug("onColUpdated - GridColumns changed, applying filters");
    const H = oa(e), G = Bme(e), ne = H.items.filter((K) => K.field && G[K.field]);
    ne.length < H.items.length && e.current.setFilterModel(S({}, H, {
      items: ne
    }));
  }, [e, s]), W = C.useCallback((H) => {
    H === "filtering" && e.current.unstable_applyFilters();
  }, [e]), Y = C.useCallback(() => {
    e.current.setState((H) => S({}, H, {
      visibleRowsLookup: jA(e, H)
    })), e.current.forceUpdate();
  }, [e]);
  Yt(e, "rowsSet", c), Yt(e, "columnsChange", A), Yt(e, "activeStrategyProcessorChange", W), Yt(e, "rowExpansionChange", Y), Yt(e, "columnVisibilityModelChange", () => {
    const H = oa(e);
    H.quickFilterValues && H.quickFilterExcludeHiddenColumns && e.current.unstable_applyFilters();
  }), _y(() => {
    e.current.unstable_applyFilters();
  }), Hn(() => {
    t.filterModel !== void 0 && e.current.setFilterModel(t.filterModel);
  }, [e, s, t.filterModel]);
}, yCe = (e) => S({}, e, {
  focus: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  },
  tabIndex: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  }
}), CCe = (e, t) => {
  const o = Ra(e, "useGridFocus"), i = C.useRef(null), s = C.useCallback((A, W) => {
    A && e.current.getRow(A.id) && e.current.publishEvent("cellFocusOut", e.current.getCellParams(A.id, A.field), W);
  }, [e]), c = C.useCallback((A, W) => {
    const Y = Va(e);
    (Y == null ? void 0 : Y.id) === A && (Y == null ? void 0 : Y.field) === W || (e.current.setState((H) => (o.debug(`Focusing on cell with id=${A} and field=${W}`), S({}, H, {
      tabIndex: {
        cell: {
          id: A,
          field: W
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      },
      focus: {
        cell: {
          id: A,
          field: W
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate(), e.current.getRow(A) && (Y && s(Y, {}), e.current.publishEvent("cellFocusIn", e.current.getCellParams(A, W))));
  }, [e, o, s]), f = C.useCallback((A, W = {}) => {
    const Y = Va(e);
    s(Y, W), e.current.setState((H) => (o.debug(`Focusing on column header with colIndex=${A}`), S({}, H, {
      tabIndex: {
        columnHeader: {
          field: A
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: {
          field: A
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, o, s]), m = C.useCallback((A, W = {}) => {
    const Y = Va(e);
    s(Y, W), e.current.setState((H) => (o.debug(`Focusing on column header filter with colIndex=${A}`), S({}, H, {
      tabIndex: {
        columnHeader: null,
        columnHeaderFilter: {
          field: A
        },
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: null,
        columnHeaderFilter: {
          field: A
        },
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, o, s]), h = C.useCallback((A, W, Y = {}) => {
    const H = Va(e);
    H && e.current.publishEvent("cellFocusOut", e.current.getCellParams(H.id, H.field), Y), e.current.setState((G) => S({}, G, {
      tabIndex: {
        columnGroupHeader: {
          field: A,
          depth: W
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      },
      focus: {
        columnGroupHeader: {
          field: A,
          depth: W
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      }
    })), e.current.forceUpdate();
  }, [e]), v = C.useCallback(() => X1(e), [e]), b = C.useCallback((A, W, Y) => {
    let H = e.current.getColumnIndex(W);
    const G = la(e), ne = ox(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    }), K = Xh(e), B = [].concat(K.top || [], ne.rows, K.bottom || []);
    let q = B.findIndex((Z) => Z.id === A);
    Y === "right" ? H += 1 : Y === "left" ? H -= 1 : q += 1, H >= G.length ? (q += 1, q < B.length && (H = 0)) : H < 0 && (q -= 1, q >= 0 && (H = G.length - 1)), q = Vh(q, 0, B.length - 1);
    const X = B[q];
    if (!X)
      return;
    const J = e.current.unstable_getCellColSpanInfo(X.id, H);
    J && J.spannedByColSpan && (Y === "left" || Y === "below" ? H = J.leftVisibleCellIndex : Y === "right" && (H = J.rightVisibleCellIndex)), H = Vh(H, 0, G.length - 1);
    const U = G[H];
    e.current.setCellFocus(X.id, U.field);
  }, [e, t.pagination, t.paginationMode]), x = C.useCallback(({
    id: A,
    field: W
  }) => {
    e.current.setCellFocus(A, W);
  }, [e]), E = C.useCallback((A, W) => {
    W.key === "Enter" || W.key === "Tab" || W.key === "Shift" || nx(W.key) || e.current.setCellFocus(A.id, A.field);
  }, [e]), T = C.useCallback(({
    field: A
  }, W) => {
    W.target === W.currentTarget && e.current.setColumnHeaderFocus(A, W);
  }, [e]), P = C.useCallback(({
    fields: A,
    depth: W
  }, Y) => {
    if (Y.target !== Y.currentTarget)
      return;
    const H = X1(e);
    H !== null && H.depth === W && A.includes(H.field) || e.current.setColumnGroupHeaderFocus(A[0], W, Y);
  }, [e]), O = C.useCallback((A, W) => {
    var Y;
    (Y = W.relatedTarget) != null && Y.className.includes(Te.columnHeader) || (o.debug("Clearing focus"), e.current.setState((H) => S({}, H, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })));
  }, [o, e]), k = C.useCallback((A) => {
    i.current = A;
  }, []), I = C.useCallback((A) => {
    const W = i.current;
    i.current = null;
    const Y = Va(e);
    if (!e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: A,
      cell: W
    }))
      return;
    if (!Y) {
      W && e.current.setCellFocus(W.id, W.field);
      return;
    }
    if ((W == null ? void 0 : W.id) === Y.id && (W == null ? void 0 : W.field) === Y.field)
      return;
    const G = e.current.getCellElement(Y.id, Y.field);
    G != null && G.contains(A.target) || (W ? e.current.setCellFocus(W.id, W.field) : (e.current.setState((ne) => S({}, ne, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })), e.current.forceUpdate(), s(Y, A)));
  }, [e, s]), $ = C.useCallback((A) => {
    if (A.cellMode === "view")
      return;
    const W = Va(e);
    ((W == null ? void 0 : W.id) !== A.id || (W == null ? void 0 : W.field) !== A.field) && e.current.setCellFocus(A.id, A.field);
  }, [e]), _ = C.useCallback(() => {
    const A = Va(e);
    A && !e.current.getRow(A.id) && e.current.setState((W) => S({}, W, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }));
  }, [e]), z = zn(() => {
    const A = Va(e);
    if (!A)
      return;
    const W = ox(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (W.rows.find((G) => G.id === A.id))
      return;
    const H = la(e);
    e.current.setState((G) => S({}, G, {
      tabIndex: {
        cell: {
          id: W.rows[0].id,
          field: H[0].field
        },
        columnGroupHeader: null,
        columnHeader: null,
        columnHeaderFilter: null
      }
    }));
  }), V = {
    setCellFocus: c,
    setColumnHeaderFocus: f,
    setColumnHeaderFilterFocus: m
  }, M = {
    moveFocusToRelativeCell: b,
    setColumnGroupHeaderFocus: h,
    getColumnGroupHeaderFocus: v
  };
  En(e, V, "public"), En(e, M, "private"), C.useEffect(() => {
    const A = qn(e.current.rootElementRef.current);
    return A.addEventListener("mouseup", I), () => {
      A.removeEventListener("mouseup", I);
    };
  }, [e, I]), Yt(e, "columnHeaderBlur", O), Yt(e, "cellDoubleClick", x), Yt(e, "cellMouseDown", k), Yt(e, "cellKeyDown", E), Yt(e, "cellModeChange", $), Yt(e, "columnHeaderFocus", T), Yt(e, "columnGroupHeaderFocus", P), Yt(e, "rowsSet", _), Yt(e, "paginationModelChange", z);
};
function SCe(e, t) {
  const o = Xh(e) || {};
  return [...o.top || [], ...t, ...o.bottom || []];
}
const mR = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: o,
  direction: i
}) => {
  if (i === "rtl") {
    if (e < o)
      return e + 1;
  } else if (i === "ltr" && e > t)
    return e - 1;
  return null;
}, hR = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: o,
  direction: i
}) => {
  if (i === "rtl") {
    if (e > t)
      return e - 1;
  } else if (i === "ltr" && e < o)
    return e + 1;
  return null;
}, xCe = (e, t) => {
  const o = Ra(e, "useGridKeyboardNavigation"), i = up(e, t).rows, s = mr(), c = C.useMemo(() => SCe(e, i), [e, i]), f = (
    // @ts-expect-error // TODO move relevant code to the `DataGridPro`
    t.signature !== "DataGrid" && t.unstable_headerFilters
  ), m = C.useCallback((I, $, _ = "left") => {
    const z = Sd(e), V = e.current.unstable_getCellColSpanInfo($, I);
    V && V.spannedByColSpan && (_ === "left" ? I = V.leftVisibleCellIndex : _ === "right" && (I = V.rightVisibleCellIndex));
    const M = z.findIndex((W) => W.id === $);
    o.debug(`Navigating to cell row ${M}, col ${I}`), e.current.scrollToIndexes({
      colIndex: I,
      rowIndex: M
    });
    const A = e.current.getVisibleColumns()[I].field;
    e.current.setCellFocus($, A);
  }, [e, o]), h = C.useCallback((I, $) => {
    o.debug(`Navigating to header col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const _ = e.current.getVisibleColumns()[I].field;
    e.current.setColumnHeaderFocus(_, $);
  }, [e, o]), v = C.useCallback((I, $) => {
    o.debug(`Navigating to header filter col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const _ = e.current.getVisibleColumns()[I].field;
    e.current.setColumnHeaderFilterFocus(_, $);
  }, [e, o]), b = C.useCallback((I, $, _) => {
    o.debug(`Navigating to header col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const {
      field: z
    } = e.current.getVisibleColumns()[I];
    e.current.setColumnGroupHeaderFocus(z, $, _);
  }, [e, o]), x = C.useCallback((I) => {
    var $;
    return ($ = c[I]) == null ? void 0 : $.id;
  }, [c]), E = C.useCallback((I, $) => {
    const _ = $.currentTarget.querySelector(`.${Te.columnHeaderTitleContainerContent}`);
    if (!!_ && _.contains($.target) && I.field !== Zh.field || !e.current.getRootDimensions())
      return;
    const M = e.current.getViewportPageSize(), A = I.field ? e.current.getColumnIndex(I.field) : 0, W = c.length > 0 ? 0 : null, Y = c.length - 1, H = 0, G = la(e).length - 1, ne = Dy(e);
    let K = !0;
    switch ($.key) {
      case "ArrowDown": {
        W !== null && (f ? v(A, $) : m(A, x(W)));
        break;
      }
      case "ArrowRight": {
        const B = hR({
          currentColIndex: A,
          firstColIndex: H,
          lastColIndex: G,
          direction: s.direction
        });
        B !== null && h(B, $);
        break;
      }
      case "ArrowLeft": {
        const B = mR({
          currentColIndex: A,
          firstColIndex: H,
          lastColIndex: G,
          direction: s.direction
        });
        B !== null && h(B, $);
        break;
      }
      case "ArrowUp": {
        ne > 0 && b(A, ne - 1, $);
        break;
      }
      case "PageDown": {
        W !== null && Y !== null && m(A, x(Math.min(W + M, Y)));
        break;
      }
      case "Home": {
        h(H, $);
        break;
      }
      case "End": {
        h(G, $);
        break;
      }
      case "Enter": {
        ($.ctrlKey || $.metaKey) && e.current.toggleColumnMenu(I.field);
        break;
      }
      case " ":
        break;
      default:
        K = !1;
    }
    K && $.preventDefault();
  }, [e, c.length, f, v, m, x, s.direction, h, b]), T = C.useCallback((I, $) => {
    if (!e.current.getRootDimensions())
      return;
    const z = ave(e) === I.field, V = ive(e) === I.field;
    if (z || V || !nx($.key))
      return;
    const M = e.current.getViewportPageSize(), A = I.field ? e.current.getColumnIndex(I.field) : 0, W = 0, Y = c.length - 1, H = 0, G = la(e).length - 1;
    let ne = !0;
    switch ($.key) {
      case "ArrowDown": {
        const K = x(W);
        K != null && m(A, K);
        break;
      }
      case "ArrowRight": {
        const K = hR({
          currentColIndex: A,
          firstColIndex: H,
          lastColIndex: G,
          direction: s.direction
        });
        K !== null && v(K, $);
        break;
      }
      case "ArrowLeft": {
        const K = mR({
          currentColIndex: A,
          firstColIndex: H,
          lastColIndex: G,
          direction: s.direction
        });
        K !== null ? v(K, $) : e.current.setColumnHeaderFilterFocus(I.field, $);
        break;
      }
      case "ArrowUp": {
        h(A, $);
        break;
      }
      case "PageDown": {
        Y !== null && m(A, x(Math.min(W + M, Y)));
        break;
      }
      case "Home": {
        v(H, $);
        break;
      }
      case "End": {
        v(G, $);
        break;
      }
      case " ":
        break;
      default:
        ne = !1;
    }
    ne && $.preventDefault();
  }, [e, c.length, v, s.direction, h, m, x]), P = C.useCallback((I, $) => {
    if (!e.current.getRootDimensions())
      return;
    const z = X1(e);
    if (z === null)
      return;
    const {
      field: V,
      depth: M
    } = z, {
      fields: A,
      depth: W,
      maxDepth: Y
    } = I, H = e.current.getViewportPageSize(), G = e.current.getColumnIndex(V), ne = V ? e.current.getColumnIndex(V) : 0, K = 0, B = c.length - 1, q = 0, X = la(e).length - 1;
    let J = !0;
    switch ($.key) {
      case "ArrowDown": {
        W === Y - 1 ? h(G, $) : b(G, M + 1, $);
        break;
      }
      case "ArrowUp": {
        W > 0 && b(G, M - 1, $);
        break;
      }
      case "ArrowRight": {
        const U = A.length - A.indexOf(V) - 1;
        G + U + 1 <= X && b(G + U + 1, M, $);
        break;
      }
      case "ArrowLeft": {
        const U = A.indexOf(V);
        G - U - 1 >= q && b(G - U - 1, M, $);
        break;
      }
      case "PageDown": {
        B !== null && m(ne, x(Math.min(K + H, B)));
        break;
      }
      case "Home": {
        b(q, M, $);
        break;
      }
      case "End": {
        b(X, M, $);
        break;
      }
      case " ":
        break;
      default:
        J = !1;
    }
    J && $.preventDefault();
  }, [e, c.length, h, b, m, x]), O = C.useCallback((I, $) => {
    if (!$.currentTarget.contains($.target))
      return;
    const _ = e.current.getCellParams(I.id, I.field);
    if (_.cellMode === sr.Edit || !nx($.key) || !e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: $,
      cell: _
    }))
      return;
    const V = e.current.getRootDimensions();
    if (c.length === 0 || !V)
      return;
    const M = s.direction, A = e.current.getViewportPageSize(), W = I.field ? e.current.getColumnIndex(I.field) : 0, Y = c.findIndex((q) => q.id === I.id), H = 0, G = c.length - 1, ne = 0, K = la(e).length - 1;
    let B = !0;
    switch ($.key) {
      case "ArrowDown": {
        Y < G && m(W, x(Y + 1));
        break;
      }
      case "ArrowUp": {
        Y > H ? m(W, x(Y - 1)) : f ? v(W, $) : h(W, $);
        break;
      }
      case "ArrowRight": {
        const q = hR({
          currentColIndex: W,
          firstColIndex: ne,
          lastColIndex: K,
          direction: M
        });
        q !== null && m(q, x(Y), M === "rtl" ? "left" : "right");
        break;
      }
      case "ArrowLeft": {
        const q = mR({
          currentColIndex: W,
          firstColIndex: ne,
          lastColIndex: K,
          direction: M
        });
        q !== null && m(q, x(Y), M === "rtl" ? "right" : "left");
        break;
      }
      case "Tab": {
        $.shiftKey && W > ne ? m(W - 1, x(Y), "left") : !$.shiftKey && W < K && m(W + 1, x(Y), "right");
        break;
      }
      case " ": {
        if (I.field === rM)
          break;
        const X = I.colDef;
        if (X && X.type === "treeDataGroup")
          break;
        !$.shiftKey && Y < G && m(W, x(Math.min(Y + A, G)));
        break;
      }
      case "PageDown": {
        Y < G && m(W, x(Math.min(Y + A, G)));
        break;
      }
      case "PageUp": {
        const q = Math.max(Y - A, H);
        q !== Y && q >= H ? m(W, x(q)) : h(W, $);
        break;
      }
      case "Home": {
        $.ctrlKey || $.metaKey || $.shiftKey ? m(ne, x(H)) : m(ne, x(Y));
        break;
      }
      case "End": {
        $.ctrlKey || $.metaKey || $.shiftKey ? m(K, x(G)) : m(K, x(Y));
        break;
      }
      default:
        B = !1;
    }
    B && $.preventDefault();
  }, [e, c, s.direction, m, x, f, v, h]), k = C.useCallback((I, {
    event: $
  }) => $.key === " " ? !1 : I, []);
  _o(e, "canStartEditing", k), Yt(e, "columnHeaderKeyDown", E), Yt(e, "headerFilterKeyDown", T), Yt(e, "columnGroupHeaderKeyDown", P), Yt(e, "cellKeyDown", O);
}, wCe = (e, t) => {
  var o, i;
  return S({}, e, {
    preferencePanel: (o = (i = t.initialState) == null ? void 0 : i.preferencePanel) != null ? o : {
      open: !1
    }
  });
}, ECe = (e, t) => {
  var o;
  const i = Ra(e, "useGridPreferencesPanel"), s = C.useRef(), c = C.useRef(), f = C.useCallback(() => {
    i.debug("Hiding Preferences Panel");
    const E = py(e.current.state);
    E.openedPanelValue && e.current.publishEvent("preferencePanelClose", {
      openedPanelValue: E.openedPanelValue
    }), e.current.setState((T) => S({}, T, {
      preferencePanel: {
        open: !1
      }
    })), e.current.forceUpdate();
  }, [e, i]), m = C.useCallback(() => {
    c.current = setTimeout(() => clearTimeout(s.current), 0);
  }, []), h = C.useCallback(() => {
    s.current = setTimeout(f, 100);
  }, [f]), v = C.useCallback((E, T, P) => {
    i.debug("Opening Preferences Panel"), m(), e.current.setState((O) => S({}, O, {
      preferencePanel: S({}, O.preferencePanel, {
        open: !0,
        openedPanelValue: E,
        panelId: T,
        labelId: P
      })
    })), e.current.publishEvent("preferencePanelOpen", {
      openedPanelValue: E
    }), e.current.forceUpdate();
  }, [i, m, e]);
  En(e, {
    showPreferences: v,
    hidePreferences: h
  }, "public");
  const b = C.useCallback((E, T) => {
    var P;
    const O = py(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !T.exportOnlyDirtyModels || // Always export if the panel was initialized
      ((P = t.initialState) == null ? void 0 : P.preferencePanel) != null || // Always export if the panel is opened
      O.open ? S({}, E, {
        preferencePanel: O
      }) : E
    );
  }, [e, (o = t.initialState) == null ? void 0 : o.preferencePanel]), x = C.useCallback((E, T) => {
    const P = T.stateToRestore.preferencePanel;
    return P != null && e.current.setState((O) => S({}, O, {
      preferencePanel: P
    })), E;
  }, [e]);
  _o(e, "exportState", b), _o(e, "restoreState", x), C.useEffect(() => () => {
    clearTimeout(s.current), clearTimeout(c.current);
  }, []);
}, TCe = ["id", "field"], OCe = ["id", "field"], RCe = Ws(["MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence."], "error"), kCe = (e, t) => {
  const [o, i] = C.useState({}), s = C.useRef(o), c = C.useRef({}), {
    processRowUpdate: f,
    onProcessRowUpdateError: m,
    cellModesModel: h,
    onCellModesModelChange: v
  } = t, b = (B) => (...q) => {
    t.editMode === Us.Cell && B(...q);
  }, x = C.useCallback((B, q) => {
    const X = e.current.getCellParams(B, q);
    if (!e.current.isCellEditable(X))
      throw new Error(`MUI: The cell with id=${B} and field=${q} is not editable.`);
  }, [e]), E = C.useCallback((B, q, X) => {
    if (e.current.getCellMode(B, q) !== X)
      throw new Error(`MUI: The cell with id=${B} and field=${q} is not in ${X} mode.`);
  }, [e]), T = C.useCallback((B, q) => {
    if (!B.isEditable || B.cellMode === sr.Edit)
      return;
    const X = S({}, B, {
      reason: ed.cellDoubleClick
    });
    e.current.publishEvent("cellEditStart", X, q);
  }, [e]), P = C.useCallback((B, q) => {
    if (B.cellMode === sr.View || e.current.getCellMode(B.id, B.field) === sr.View)
      return;
    const X = S({}, B, {
      reason: Ll.cellFocusOut
    });
    e.current.publishEvent("cellEditStop", X, q);
  }, [e]), O = C.useCallback((B, q) => {
    if (B.cellMode === sr.Edit) {
      if (q.which === 229)
        return;
      let X;
      if (q.key === "Escape" ? X = Ll.escapeKeyDown : q.key === "Enter" ? X = Ll.enterKeyDown : q.key === "Tab" && (X = q.shiftKey ? Ll.shiftTabKeyDown : Ll.tabKeyDown, q.preventDefault()), X) {
        const J = S({}, B, {
          reason: X
        });
        e.current.publishEvent("cellEditStop", J, q);
      }
    } else if (B.isEditable) {
      let X;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: q,
        cellParams: B,
        editMode: "cell"
      }))
        return;
      if (S4(q) || (q.ctrlKey || q.metaKey) && q.key === "v" ? X = ed.printableKeyDown : q.key === "Enter" ? X = ed.enterKeyDown : (q.key === "Delete" || q.key === "Backspace") && (X = ed.deleteKeyDown), X) {
        const U = S({}, B, {
          reason: X,
          key: q.key
        });
        e.current.publishEvent("cellEditStart", U, q);
      }
    }
  }, [e]), k = C.useCallback((B) => {
    const {
      id: q,
      field: X,
      reason: J,
      key: U,
      colDef: Z
    } = B, ee = {
      id: q,
      field: X
    };
    if (J === ed.printableKeyDown)
      if (C.version.startsWith("17"))
        ee.deleteValue = !0;
      else {
        const ie = Z.valueParser ? Z.valueParser(U) : U;
        ee.initialValue = ie;
      }
    else
      J === ed.deleteKeyDown && (ee.deleteValue = !0);
    e.current.startCellEditMode(ee);
  }, [e]), I = C.useCallback((B) => {
    const {
      id: q,
      field: X,
      reason: J
    } = B;
    e.current.runPendingEditCellValueMutation(q, X);
    let U;
    J === Ll.enterKeyDown ? U = "below" : J === Ll.tabKeyDown ? U = "right" : J === Ll.shiftTabKeyDown && (U = "left");
    const Z = J === "escapeKeyDown";
    e.current.stopCellEditMode({
      id: q,
      field: X,
      ignoreModifications: Z,
      cellToFocusAfter: U
    });
  }, [e]);
  Yt(e, "cellDoubleClick", b(T)), Yt(e, "cellFocusOut", b(P)), Yt(e, "cellKeyDown", b(O)), Yt(e, "cellEditStart", b(k)), Yt(e, "cellEditStop", b(I)), Mr(e, "cellEditStart", t.onCellEditStart), Mr(e, "cellEditStop", t.onCellEditStop);
  const $ = C.useCallback((B, q) => {
    const X = Ba(e.current.state);
    return X[B] && X[B][q] ? sr.Edit : sr.View;
  }, [e]), _ = zn((B) => {
    const q = B !== t.cellModesModel;
    v && q && v(B, {}), !(t.cellModesModel && q) && (i(B), s.current = B, e.current.publishEvent("cellModesModelChange", B));
  }), z = C.useCallback((B, q, X) => {
    const J = S({}, s.current);
    if (X !== null)
      J[B] = S({}, J[B], {
        [q]: S({}, X)
      });
    else {
      const U = J[B], Z = pe(U, [q].map(gy));
      J[B] = Z, Object.keys(J[B]).length === 0 && delete J[B];
    }
    _(J);
  }, [_]), V = C.useCallback((B, q, X) => {
    e.current.setState((J) => {
      const U = S({}, J.editRows);
      return X !== null ? U[B] = S({}, U[B], {
        [q]: S({}, X)
      }) : (delete U[B][q], Object.keys(U[B]).length === 0 && delete U[B]), S({}, J, {
        editRows: U
      });
    }), e.current.forceUpdate();
  }, [e]), M = C.useCallback((B) => {
    const {
      id: q,
      field: X
    } = B, J = pe(B, TCe);
    x(q, X), E(q, X, sr.View), z(q, X, S({
      mode: sr.Edit
    }, J));
  }, [x, E, z]), A = zn((B) => {
    const {
      id: q,
      field: X,
      deleteValue: J,
      initialValue: U
    } = B;
    let Z = e.current.getCellValue(q, X), ee = !1;
    (J || U) && (Z = J ? "" : U, ee = !0), V(q, X, {
      value: Z,
      error: !1,
      isProcessingProps: !1,
      unstable_updateValueOnRender: ee
    }), e.current.setCellFocus(q, X);
  }), W = C.useCallback((B) => {
    const {
      id: q,
      field: X
    } = B, J = pe(B, OCe);
    E(q, X, sr.Edit), z(q, X, S({
      mode: sr.View
    }, J));
  }, [E, z]), Y = zn(async (B) => {
    const {
      id: q,
      field: X,
      ignoreModifications: J,
      cellToFocusAfter: U = "none"
    } = B;
    E(q, X, sr.Edit), e.current.runPendingEditCellValueMutation(q, X);
    const Z = () => {
      V(q, X, null), z(q, X, null), U !== "none" && e.current.moveFocusToRelativeCell(q, X, U);
    };
    if (J) {
      Z();
      return;
    }
    const ee = Ba(e.current.state), {
      error: ie,
      isProcessingProps: oe
    } = ee[q][X];
    if (ie || oe) {
      c.current[q][X].mode = sr.Edit, z(q, X, {
        mode: sr.Edit
      });
      return;
    }
    const le = e.current.getRowWithUpdatedValuesFromCellEditing(q, X);
    if (f) {
      const de = (Ce) => {
        c.current[q][X].mode = sr.Edit, z(q, X, {
          mode: sr.Edit
        }), m ? m(Ce) : RCe();
      };
      try {
        const Ce = e.current.getRow(q);
        Promise.resolve(f(le, Ce)).then((me) => {
          e.current.updateRows([me]), Z();
        }).catch(de);
      } catch (Ce) {
        de(Ce);
      }
    } else
      e.current.updateRows([le]), Z();
  }), H = C.useCallback(async (B) => {
    var q;
    const {
      id: X,
      field: J,
      value: U,
      debounceMs: Z,
      unstable_skipValueParser: ee
    } = B;
    x(X, J), E(X, J, sr.Edit);
    const ie = e.current.getColumn(J), oe = e.current.getRow(X);
    let le = U;
    ie.valueParser && !ee && (le = ie.valueParser(U, e.current.getCellParams(X, J)));
    let de = Ba(e.current.state), Ce = S({}, de[X][J], {
      value: le,
      changeReason: Z ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    if (ie.preProcessEditCellProps) {
      const me = U !== de[X][J].value;
      Ce = S({}, Ce, {
        isProcessingProps: !0
      }), V(X, J, Ce), Ce = await Promise.resolve(ie.preProcessEditCellProps({
        id: X,
        row: oe,
        props: Ce,
        hasChanged: me
      }));
    }
    return e.current.getCellMode(X, J) === sr.View ? !1 : (de = Ba(e.current.state), Ce = S({}, Ce, {
      isProcessingProps: !1
    }), Ce.value = ie.preProcessEditCellProps ? de[X][J].value : le, V(X, J, Ce), de = Ba(e.current.state), !((q = de[X]) != null && (q = q[J]) != null && q.error));
  }, [e, x, E, V]), G = C.useCallback((B, q) => {
    const X = e.current.getColumn(q), J = Ba(e.current.state), U = e.current.getRow(B);
    if (!J[B] || !J[B][q])
      return e.current.getRow(B);
    const {
      value: Z
    } = J[B][q];
    return X.valueSetter ? X.valueSetter({
      value: Z,
      row: U
    }) : S({}, U, {
      [q]: Z
    });
  }, [e]), ne = {
    getCellMode: $,
    startCellEditMode: M,
    stopCellEditMode: W
  }, K = {
    setCellEditingEditCellValue: H,
    getRowWithUpdatedValuesFromCellEditing: G
  };
  En(e, ne, "public"), En(e, K, "private"), C.useEffect(() => {
    h && _(h);
  }, [h, _]), C.useEffect(() => {
    const B = K1(e), q = c.current;
    c.current = L4(o), Object.entries(o).forEach(([X, J]) => {
      Object.entries(J).forEach(([U, Z]) => {
        var ee, ie;
        const oe = ((ee = q[X]) == null || (ee = ee[U]) == null ? void 0 : ee.mode) || sr.View, le = (ie = B[X]) != null ? ie : X;
        Z.mode === sr.Edit && oe === sr.View ? A(S({
          id: le,
          field: U
        }, Z)) : Z.mode === sr.View && oe === sr.Edit && Y(S({
          id: le,
          field: U
        }, Z));
      });
    });
  }, [e, o, A, Y]);
}, PCe = ["id"], MCe = ["id"], ICe = Ws(["MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence."], "error"), NCe = (e, t) => {
  const [o, i] = C.useState({}), s = C.useRef(o), c = C.useRef({}), f = C.useRef(null), m = C.useRef(null), {
    processRowUpdate: h,
    onProcessRowUpdateError: v,
    rowModesModel: b,
    onRowModesModelChange: x
  } = t, E = (U) => (...Z) => {
    t.editMode === Us.Row && U(...Z);
  }, T = C.useCallback((U, Z) => {
    const ee = e.current.getCellParams(U, Z);
    if (!e.current.isCellEditable(ee))
      throw new Error(`MUI: The cell with id=${U} and field=${Z} is not editable.`);
  }, [e]), P = C.useCallback((U, Z) => {
    if (e.current.getRowMode(U) !== Z)
      throw new Error(`MUI: The row with id=${U} is not in ${Z} mode.`);
  }, [e]), O = C.useCallback((U, Z) => {
    if (!U.isEditable || e.current.getRowMode(U.id) === Tr.Edit)
      return;
    const ee = e.current.getRowParams(U.id), ie = S({}, ee, {
      field: U.field,
      reason: td.cellDoubleClick
    });
    e.current.publishEvent("rowEditStart", ie, Z);
  }, [e]), k = C.useCallback((U) => {
    m.current = U;
  }, []), I = C.useCallback((U, Z) => {
    U.isEditable && e.current.getRowMode(U.id) !== Tr.View && (m.current = null, f.current = setTimeout(() => {
      var ee;
      if (f.current = null, ((ee = m.current) == null ? void 0 : ee.id) !== U.id) {
        if (!e.current.getRow(U.id) || e.current.getRowMode(U.id) === Tr.View)
          return;
        const ie = e.current.getRowParams(U.id), oe = S({}, ie, {
          field: U.field,
          reason: Fc.rowFocusOut
        });
        e.current.publishEvent("rowEditStop", oe, Z);
      }
    }));
  }, [e]);
  C.useEffect(() => () => {
    clearTimeout(f.current);
  }, []);
  const $ = C.useCallback((U, Z) => {
    if (U.cellMode === Tr.Edit) {
      if (Z.which === 229)
        return;
      let ee;
      if (Z.key === "Escape")
        ee = Fc.escapeKeyDown;
      else if (Z.key === "Enter")
        ee = Fc.enterKeyDown;
      else if (Z.key === "Tab") {
        const ie = Vx(e).filter((oe) => e.current.getColumn(oe).type === Xx ? !0 : e.current.isCellEditable(e.current.getCellParams(U.id, oe)));
        if (Z.shiftKey ? U.field === ie[0] && (ee = Fc.shiftTabKeyDown) : U.field === ie[ie.length - 1] && (ee = Fc.tabKeyDown), Z.preventDefault(), !ee) {
          const oe = ie.findIndex((de) => de === U.field), le = ie[Z.shiftKey ? oe - 1 : oe + 1];
          e.current.setCellFocus(U.id, le);
        }
      }
      if (ee) {
        const ie = S({}, e.current.getRowParams(U.id), {
          reason: ee,
          field: U.field
        });
        e.current.publishEvent("rowEditStop", ie, Z);
      }
    } else if (U.isEditable) {
      let ee;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: Z,
        cellParams: U,
        editMode: "row"
      }))
        return;
      if (S4(Z) || (Z.ctrlKey || Z.metaKey) && Z.key === "v" ? ee = td.printableKeyDown : Z.key === "Enter" ? ee = td.enterKeyDown : (Z.key === "Delete" || Z.key === "Backspace") && (ee = td.deleteKeyDown), ee) {
        const oe = e.current.getRowParams(U.id), le = S({}, oe, {
          field: U.field,
          key: Z.key,
          reason: ee
        });
        e.current.publishEvent("rowEditStart", le, Z);
      }
    }
  }, [e]), _ = C.useCallback((U) => {
    const {
      id: Z,
      field: ee,
      reason: ie,
      key: oe,
      columns: le
    } = U, de = {
      id: Z,
      fieldToFocus: ee
    };
    if (ie === td.printableKeyDown)
      if (C.version.startsWith("17"))
        de.deleteValue = !!ee;
      else {
        const Ce = le.find((me) => me.field === ee);
        de.initialValue = Ce.valueParser ? Ce.valueParser(oe) : oe;
      }
    else
      ie === td.deleteKeyDown && (de.deleteValue = !!ee);
    e.current.startRowEditMode(de);
  }, [e]), z = C.useCallback((U) => {
    const {
      id: Z,
      reason: ee,
      field: ie
    } = U;
    e.current.runPendingEditCellValueMutation(Z);
    let oe;
    ee === Fc.enterKeyDown ? oe = "below" : ee === Fc.tabKeyDown ? oe = "right" : ee === Fc.shiftTabKeyDown && (oe = "left");
    const le = ee === "escapeKeyDown";
    e.current.stopRowEditMode({
      id: Z,
      ignoreModifications: le,
      field: ie,
      cellToFocusAfter: oe
    });
  }, [e]);
  Yt(e, "cellDoubleClick", E(O)), Yt(e, "cellFocusIn", E(k)), Yt(e, "cellFocusOut", E(I)), Yt(e, "cellKeyDown", E($)), Yt(e, "rowEditStart", E(_)), Yt(e, "rowEditStop", E(z)), Mr(e, "rowEditStart", t.onRowEditStart), Mr(e, "rowEditStop", t.onRowEditStop);
  const V = C.useCallback((U) => {
    if (t.editMode === Us.Cell)
      return Tr.View;
    const Z = Ba(e.current.state);
    return Z[U] && Object.keys(Z[U]).length > 0 ? Tr.Edit : Tr.View;
  }, [e, t.editMode]), M = zn((U) => {
    const Z = U !== t.rowModesModel;
    x && Z && x(U, {}), !(t.rowModesModel && Z) && (i(U), s.current = U, e.current.publishEvent("rowModesModelChange", U));
  }), A = C.useCallback((U, Z) => {
    const ee = S({}, s.current);
    Z !== null ? ee[U] = S({}, Z) : delete ee[U], M(ee);
  }, [M]), W = C.useCallback((U, Z) => {
    e.current.setState((ee) => {
      const ie = S({}, ee.editRows);
      return Z !== null ? ie[U] = Z : delete ie[U], S({}, ee, {
        editRows: ie
      });
    }), e.current.forceUpdate();
  }, [e]), Y = C.useCallback((U, Z, ee) => {
    e.current.setState((ie) => {
      const oe = S({}, ie.editRows);
      return ee !== null ? oe[U] = S({}, oe[U], {
        [Z]: S({}, ee)
      }) : (delete oe[U][Z], Object.keys(oe[U]).length === 0 && delete oe[U]), S({}, ie, {
        editRows: oe
      });
    }), e.current.forceUpdate();
  }, [e]), H = C.useCallback((U) => {
    const {
      id: Z
    } = U, ee = pe(U, PCe);
    P(Z, Tr.View), A(Z, S({
      mode: Tr.Edit
    }, ee));
  }, [P, A]), G = zn((U) => {
    const {
      id: Z,
      fieldToFocus: ee,
      deleteValue: ie,
      initialValue: oe
    } = U, de = Vc(e).reduce((Ce, me) => {
      if (!e.current.getCellParams(Z, me).isEditable)
        return Ce;
      let he = e.current.getCellValue(Z, me), $e = !1;
      return ee === me && (ie || oe) && (he = ie ? "" : oe, $e = !0), Ce[me] = {
        value: he,
        error: !1,
        isProcessingProps: !1,
        unstable_updateValueOnRender: $e
      }, Ce;
    }, {});
    W(Z, de), ee && e.current.setCellFocus(Z, ee);
  }), ne = C.useCallback((U) => {
    const {
      id: Z
    } = U, ee = pe(U, MCe);
    P(Z, Tr.Edit), A(Z, S({
      mode: Tr.View
    }, ee));
  }, [P, A]), K = zn((U) => {
    const {
      id: Z,
      ignoreModifications: ee,
      field: ie,
      cellToFocusAfter: oe = "none"
    } = U;
    e.current.runPendingEditCellValueMutation(Z);
    const le = () => {
      oe !== "none" && ie && e.current.moveFocusToRelativeCell(Z, ie, oe), W(Z, null), A(Z, null);
    };
    if (ee) {
      le();
      return;
    }
    const de = Ba(e.current.state), Ce = e.current.getRow(Z);
    if (Object.values(de[Z]).some(($e) => $e.isProcessingProps)) {
      c.current[Z].mode = Tr.Edit;
      return;
    }
    if (Object.values(de[Z]).some(($e) => $e.error)) {
      c.current[Z].mode = Tr.Edit, A(Z, {
        mode: Tr.Edit
      });
      return;
    }
    const he = e.current.getRowWithUpdatedValuesFromRowEditing(Z);
    if (h) {
      const $e = (Ne) => {
        c.current[Z].mode = Tr.Edit, A(Z, {
          mode: Tr.Edit
        }), v ? v(Ne) : ICe();
      };
      try {
        Promise.resolve(h(he, Ce)).then((Ne) => {
          e.current.updateRows([Ne]), le();
        }).catch($e);
      } catch (Ne) {
        $e(Ne);
      }
    } else
      e.current.updateRows([he]), le();
  }), B = C.useCallback((U) => {
    const {
      id: Z,
      field: ee,
      value: ie,
      debounceMs: oe,
      unstable_skipValueParser: le
    } = U;
    T(Z, ee);
    const de = e.current.getColumn(ee), Ce = e.current.getRow(Z);
    let me = ie;
    de.valueParser && !le && (me = de.valueParser(ie, e.current.getCellParams(Z, ee)));
    let Oe = Ba(e.current.state), he = S({}, Oe[Z][ee], {
      value: me,
      changeReason: oe ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    return de.preProcessEditCellProps || Y(Z, ee, he), new Promise(($e) => {
      const Ne = [];
      if (de.preProcessEditCellProps) {
        const Pe = he.value !== Oe[Z][ee].value;
        he = S({}, he, {
          isProcessingProps: !0
        }), Y(Z, ee, he);
        const Se = Oe[Z], Fe = pe(Se, [ee].map(gy)), ce = Promise.resolve(de.preProcessEditCellProps({
          id: Z,
          row: Ce,
          props: he,
          hasChanged: Pe,
          otherFieldsProps: Fe
        })).then((ge) => {
          if (e.current.getRowMode(Z) === Tr.View) {
            $e(!1);
            return;
          }
          Oe = Ba(e.current.state), ge = S({}, ge, {
            isProcessingProps: !1
          }), ge.value = de.preProcessEditCellProps ? Oe[Z][ee].value : me, Y(Z, ee, ge);
        });
        Ne.push(ce);
      }
      Object.entries(Oe[Z]).forEach(([Pe, Se]) => {
        if (Pe === ee)
          return;
        const Fe = e.current.getColumn(Pe);
        if (!Fe.preProcessEditCellProps)
          return;
        Se = S({}, Se, {
          isProcessingProps: !0
        }), Y(Z, Pe, Se), Oe = Ba(e.current.state);
        const ce = Oe[Z], ge = pe(ce, [Pe].map(gy)), we = Promise.resolve(Fe.preProcessEditCellProps({
          id: Z,
          row: Ce,
          props: Se,
          hasChanged: !1,
          otherFieldsProps: ge
        })).then((Me) => {
          if (e.current.getRowMode(Z) === Tr.View) {
            $e(!1);
            return;
          }
          Me = S({}, Me, {
            isProcessingProps: !1
          }), Y(Z, Pe, Me);
        });
        Ne.push(we);
      }), Promise.all(Ne).then(() => {
        e.current.getRowMode(Z) === Tr.Edit ? (Oe = Ba(e.current.state), $e(!Oe[Z][ee].error)) : $e(!1);
      });
    });
  }, [e, T, Y]), q = C.useCallback((U) => {
    const Z = Ba(e.current.state), ee = e.current.getRow(U);
    if (!Z[U])
      return e.current.getRow(U);
    let ie = S({}, ee);
    return Object.entries(Z[U]).forEach(([oe, le]) => {
      const de = e.current.getColumn(oe);
      de.valueSetter ? ie = de.valueSetter({
        value: le.value,
        row: ie
      }) : ie[oe] = le.value;
    }), ie;
  }, [e]), X = {
    getRowMode: V,
    startRowEditMode: H,
    stopRowEditMode: ne
  }, J = {
    setRowEditingEditCellValue: B,
    getRowWithUpdatedValuesFromRowEditing: q
  };
  En(e, X, "public"), En(e, J, "private"), C.useEffect(() => {
    b && M(b);
  }, [b, M]), C.useEffect(() => {
    const U = K1(e), Z = c.current;
    c.current = L4(o), Object.entries(o).forEach(([ee, ie]) => {
      var oe, le;
      const de = ((oe = Z[ee]) == null ? void 0 : oe.mode) || Tr.View, Ce = (le = U[ee]) != null ? le : ee;
      ie.mode === Tr.Edit && de === Tr.View ? G(S({
        id: Ce
      }, ie)) : ie.mode === Tr.View && de === Tr.Edit && K(S({
        id: Ce
      }, ie));
    });
  }, [e, o, G, K]);
}, $Ce = (e) => S({}, e, {
  editRows: {}
}), DCe = (e, t) => {
  kCe(e, t), NCe(e, t);
  const o = C.useRef({}), {
    isCellEditable: i
  } = t, s = C.useCallback((E) => dy(E.rowNode) || !E.colDef.editable || !E.colDef.renderEditCell ? !1 : i ? i(E) : !0, [i]), c = (E, T, P, O) => {
    if (!P) {
      O();
      return;
    }
    if (o.current[E] || (o.current[E] = {}), o.current[E][T]) {
      const [$] = o.current[E][T];
      clearTimeout($);
    }
    const k = () => {
      const [$] = o.current[E][T];
      clearTimeout($), O(), delete o.current[E][T];
    }, I = setTimeout(() => {
      O(), delete o.current[E][T];
    }, P);
    o.current[E][T] = [I, k];
  };
  C.useEffect(() => {
    const E = o.current;
    return () => {
      Object.entries(E).forEach(([T, P]) => {
        Object.keys(P).forEach((O) => {
          const [k] = E[T][O];
          clearTimeout(k), delete E[T][O];
        });
      });
    };
  }, []);
  const f = C.useCallback((E, T) => {
    if (o.current[E]) {
      if (!T)
        Object.keys(o.current[E]).forEach((P) => {
          const [, O] = o.current[E][P];
          O();
        });
      else if (o.current[E][T]) {
        const [, P] = o.current[E][T];
        P();
      }
    }
  }, []), m = C.useCallback((E) => {
    const {
      id: T,
      field: P,
      debounceMs: O
    } = E;
    return new Promise((k) => {
      c(T, P, O, async () => {
        const I = t.editMode === Us.Row ? e.current.setRowEditingEditCellValue : e.current.setCellEditingEditCellValue;
        if (e.current.getCellMode(T, P) === sr.Edit) {
          const $ = await I(E);
          k($);
        }
      });
    });
  }, [e, t.editMode]), h = C.useCallback((E, T) => t.editMode === Us.Cell ? e.current.getRowWithUpdatedValuesFromCellEditing(E, T) : e.current.getRowWithUpdatedValuesFromRowEditing(E), [e, t.editMode]), v = C.useCallback((E, T) => {
    var P, O;
    return (P = (O = Ba(e.current.state)[E]) == null ? void 0 : O[T]) != null ? P : null;
  }, [e]), b = {
    isCellEditable: s,
    setEditCellValue: m,
    getRowWithUpdatedValues: h,
    unstable_getEditCellMeta: v
  }, x = {
    runPendingEditCellValueMutation: f
  };
  En(e, b, "public"), En(e, x, "private");
}, _Ce = (e, t, o) => (o.current.caches.rows = w1({
  rows: t.rows,
  getRowId: t.getRowId,
  loading: t.loading,
  rowCount: t.rowCount
}), S({}, e, {
  rows: a4({
    apiRef: o,
    rowCountProp: t.rowCount,
    loadingProp: t.loading,
    previousTree: null,
    previousTreeDepths: null
  })
})), ACe = (e, t) => {
  if (process.env.NODE_ENV !== "production")
    try {
      Object.freeze(t.rows);
    } catch {
    }
  const o = Ra(e, "useGridRows"), i = up(e, t), s = C.useRef(Date.now()), c = tM(), f = C.useCallback((K) => {
    const B = ud(e)[K];
    if (B)
      return B;
    const q = e.current.getRowNode(K);
    return q && dy(q) ? {
      [Rh]: K
    } : null;
  }, [e]), m = t.getRowId, h = C.useCallback((K) => Rh in K ? K[Rh] : m ? m(K) : K.id, [m]), v = C.useMemo(() => i.rows.reduce((K, {
    id: B
  }, q) => (K[B] = q, K), {}), [i.rows]), b = C.useCallback(({
    cache: K,
    throttle: B
  }) => {
    const q = () => {
      s.current = Date.now(), e.current.setState((J) => S({}, J, {
        rows: a4({
          apiRef: e,
          rowCountProp: t.rowCount,
          loadingProp: t.loading,
          previousTree: zl(e),
          previousTreeDepths: mA(e)
        })
      })), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
    };
    if (c.clear(), e.current.caches.rows = K, !B) {
      q();
      return;
    }
    const X = t.throttleRowsMs - (Date.now() - s.current);
    if (X > 0) {
      c.start(X, q);
      return;
    }
    q();
  }, [t.throttleRowsMs, t.rowCount, t.loading, e, c]), x = C.useCallback((K) => {
    o.debug(`Updating all rows, new length ${K.length}`);
    const B = w1({
      rows: K,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), q = e.current.caches.rows;
    B.rowsBeforePartialUpdates = q.rowsBeforePartialUpdates, b({
      cache: B,
      throttle: !0
    });
  }, [o, t.getRowId, t.loading, t.rowCount, b, e]), E = C.useCallback((K) => {
    if (t.signature === js.DataGrid && K.length > 1)
      throw new Error(["MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    const B = [];
    K.forEach((X) => {
      const J = Z1(X, t.getRowId, "A row was provided without id when calling updateRows():"), U = e.current.getRowNode(J);
      if ((U == null ? void 0 : U.type) === "pinnedRow") {
        const Z = e.current.caches.pinnedRows, ee = Z.idLookup[J];
        ee && (Z.idLookup[J] = S({}, ee, X));
      } else
        B.push(X);
    });
    const q = uhe({
      updates: B,
      getRowId: t.getRowId,
      previousCache: e.current.caches.rows
    });
    b({
      cache: q,
      throttle: !0
    });
  }, [t.signature, t.getRowId, b, e]), T = C.useCallback(() => {
    const K = p1(e), B = ud(e);
    return new Map(K.map((q) => {
      var X;
      return [q, (X = B[q]) != null ? X : {}];
    }));
  }, [e]), P = C.useCallback(() => jx(e), [e]), O = C.useCallback(() => p1(e), [e]), k = C.useCallback((K) => v[K], [v]), I = C.useCallback((K, B) => {
    const q = e.current.getRowNode(K);
    if (!q)
      throw new Error(`MUI: No row with id #${K} found`);
    if (q.type !== "group")
      throw new Error("MUI: Only group nodes can be expanded or collapsed");
    const X = S({}, q, {
      childrenExpanded: B
    });
    e.current.setState((J) => S({}, J, {
      rows: S({}, J.rows, {
        tree: S({}, J.rows.tree, {
          [K]: X
        })
      })
    })), e.current.forceUpdate(), e.current.publishEvent("rowExpansionChange", X);
  }, [e]), $ = C.useCallback((K) => {
    var B;
    return (B = zl(e)[K]) != null ? B : null;
  }, [e]), _ = C.useCallback(({
    skipAutoGeneratedRows: K = !0,
    groupId: B,
    applySorting: q,
    applyFiltering: X
  }) => {
    const J = zl(e);
    let U;
    if (q) {
      const Z = J[B];
      if (!Z)
        return [];
      const ee = BP(e);
      U = [];
      const ie = ee.findIndex((oe) => oe === B) + 1;
      for (let oe = ie; oe < ee.length && J[ee[oe]].depth > Z.depth; oe += 1) {
        const le = ee[oe];
        (!K || !dy(J[le])) && U.push(le);
      }
    } else
      U = GP(J, B, K);
    if (X) {
      const Z = J5(e);
      U = U.filter((ee) => Z[ee] !== !1);
    }
    return U;
  }, [e]), z = C.useCallback((K, B) => {
    const q = e.current.getRowNode(K);
    if (!q)
      throw new Error(`MUI: No row with id #${K} found`);
    if (q.parent !== ja)
      throw new Error("MUI: The row reordering do not support reordering of grouped rows yet");
    if (q.type !== "leaf")
      throw new Error("MUI: The row reordering do not support reordering of footer or grouping rows");
    e.current.setState((X) => {
      const J = zl(X, e.current.instanceId)[ja], U = J.children, Z = U.findIndex((ie) => ie === K);
      if (Z === -1 || Z === B)
        return X;
      o.debug(`Moving row ${K} to index ${B}`);
      const ee = [...U];
      return ee.splice(B, 0, ee.splice(Z, 1)[0]), S({}, X, {
        rows: S({}, X.rows, {
          tree: S({}, X.rows.tree, {
            [ja]: S({}, J, {
              children: ee
            })
          })
        })
      });
    }), e.current.publishEvent("rowsSet");
  }, [e, o]), V = C.useCallback((K, B) => {
    if (t.signature === js.DataGrid && B.length > 1)
      throw new Error(["MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    if (B.length === 0)
      return;
    if (Hx(e) > 1)
      throw new Error("`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping");
    const X = S({}, zl(e)), J = S({}, ud(e)), U = S({}, K1(e)), Z = X[ja], ee = [...Z.children];
    for (let oe = 0; oe < B.length; oe += 1) {
      const le = B[oe], de = Z1(le, t.getRowId, "A row was provided without id when calling replaceRows()."), [Ce] = ee.splice(K + oe, 1, de);
      delete J[Ce], delete U[Ce], delete X[Ce];
      const me = {
        id: de,
        depth: 0,
        parent: ja,
        type: "leaf",
        groupingKey: null
      };
      J[de] = le, U[de] = de, X[de] = me;
    }
    X[ja] = S({}, Z, {
      children: ee
    });
    const ie = ee.filter((oe) => X[oe].type === "leaf");
    e.current.caches.rows.dataRowIdToModelLookup = J, e.current.caches.rows.dataRowIdToIdLookup = U, e.current.setState((oe) => S({}, oe, {
      rows: S({}, oe.rows, {
        dataRowIdToModelLookup: J,
        dataRowIdToIdLookup: U,
        dataRowIds: ie,
        tree: X
      })
    })), e.current.publishEvent("rowsSet");
  }, [e, t.signature, t.getRowId]), M = {
    getRow: f,
    getRowId: h,
    getRowModels: T,
    getRowsCount: P,
    getAllRowIds: O,
    setRows: x,
    updateRows: E,
    getRowNode: $,
    getRowIndexRelativeToVisibleRows: k,
    unstable_replaceRows: V
  }, A = {
    setRowIndex: z,
    setRowChildrenExpansion: I,
    getRowGroupChildren: _
  }, W = C.useCallback(() => {
    o.info("Row grouping pre-processing have changed, regenerating the row tree");
    let K;
    e.current.caches.rows.rowsBeforePartialUpdates === t.rows ? K = S({}, e.current.caches.rows, {
      updates: {
        type: "full",
        rows: p1(e)
      }
    }) : K = w1({
      rows: t.rows,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), b({
      cache: K,
      throttle: !1
    });
  }, [o, e, t.rows, t.getRowId, t.loading, t.rowCount, b]), Y = C.useCallback((K) => {
    K === "rowTreeCreation" && W();
  }, [W]), H = C.useCallback(() => {
    e.current.getActiveStrategy("rowTree") !== Wme(e) && W();
  }, [e, W]);
  Yt(e, "activeStrategyProcessorChange", Y), Yt(e, "strategyAvailabilityChange", H);
  const G = C.useCallback(() => {
    e.current.setState((K) => {
      const B = e.current.unstable_applyPipeProcessors("hydrateRows", {
        tree: zl(K, e.current.instanceId),
        treeDepths: mA(K, e.current.instanceId),
        dataRowIds: p1(K, e.current.instanceId),
        dataRowIdToModelLookup: ud(K, e.current.instanceId),
        dataRowIdToIdLookup: K1(K, e.current.instanceId)
      });
      return S({}, K, {
        rows: S({}, K.rows, B, {
          totalTopLevelRowCount: o4({
            tree: B.tree,
            rowCountProp: t.rowCount
          })
        })
      });
    }), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
  }, [e, t.rowCount]);
  aM(e, "hydrateRows", G), En(e, M, "public"), En(e, A, t.signature === js.DataGrid ? "private" : "public");
  const ne = C.useRef(!0);
  C.useEffect(() => {
    if (ne.current) {
      ne.current = !1;
      return;
    }
    const K = e.current.caches.rows.rowsBeforePartialUpdates === t.rows, B = e.current.caches.rows.loadingPropBeforePartialUpdates === t.loading, q = e.current.caches.rows.rowCountPropBeforePartialUpdates === t.rowCount;
    if (K) {
      B || (e.current.setState((X) => S({}, X, {
        rows: S({}, X.rows, {
          loading: t.loading
        })
      })), e.current.caches.rows.loadingPropBeforePartialUpdates = t.loading, e.current.forceUpdate()), q || (e.current.setState((X) => S({}, X, {
        rows: S({}, X.rows, {
          totalRowCount: Math.max(t.rowCount || 0, X.rows.totalRowCount),
          totalTopLevelRowCount: Math.max(t.rowCount || 0, X.rows.totalTopLevelRowCount)
        })
      })), e.current.caches.rows.rowCountPropBeforePartialUpdates = t.rowCount, e.current.forceUpdate());
      return;
    }
    o.debug(`Updating all rows, new length ${t.rows.length}`), b({
      cache: w1({
        rows: t.rows,
        getRowId: t.getRowId,
        loading: t.loading,
        rowCount: t.rowCount
      }),
      throttle: !1
    });
  }, [t.rows, t.rowCount, t.getRowId, t.loading, o, b, e]);
}, LCe = (e) => {
  const t = {
    [ja]: S({}, she(), {
      children: e
    })
  };
  for (let o = 0; o < e.length; o += 1) {
    const i = e[o];
    t[i] = {
      id: i,
      depth: 0,
      parent: ja,
      type: "leaf",
      groupingKey: null
    };
  }
  return {
    groupingName: ap,
    tree: t,
    treeDepths: {
      0: e.length
    },
    dataRowIds: e
  };
}, FCe = ({
  previousTree: e,
  actions: t
}) => {
  const o = S({}, e), i = {};
  for (let f = 0; f < t.remove.length; f += 1) {
    const m = t.remove[f];
    i[m] = !0, delete o[m];
  }
  for (let f = 0; f < t.insert.length; f += 1) {
    const m = t.insert[f];
    o[m] = {
      id: m,
      depth: 0,
      parent: ja,
      type: "leaf",
      groupingKey: null
    };
  }
  const s = o[ja];
  let c = [...s.children, ...t.insert];
  return Object.values(i).length && (c = c.filter((f) => !i[f])), o[ja] = S({}, s, {
    children: c
  }), {
    groupingName: ap,
    tree: o,
    treeDepths: {
      0: c.length
    },
    dataRowIds: c
  };
}, zCe = (e) => e.updates.type === "full" ? LCe(e.updates.rows) : FCe({
  previousTree: e.previousTree,
  actions: e.updates.actions
}), VCe = (e) => {
  ix(e, ap, "rowTreeCreation", zCe);
}, NB = (e, t) => e == null || Array.isArray(e) ? e : t && t[0] === e ? t : [e], BCe = (e, t) => {
  var o;
  return S({}, e, {
    rowSelection: t.rowSelection ? (o = NB(t.rowSelectionModel)) != null ? o : [] : []
  });
}, jCe = (e, t) => {
  const o = Ra(e, "useGridSelection"), i = (B) => (...q) => {
    t.rowSelection && B(...q);
  }, s = C.useMemo(() => NB(t.rowSelectionModel, tl(e.current.state)), [e, t.rowSelectionModel]), c = C.useRef(null);
  e.current.registerControlState({
    stateId: "rowSelection",
    propModel: s,
    propOnChange: t.onRowSelectionModelChange,
    stateSelector: tl,
    changeEvent: "rowSelectionChange"
  });
  const {
    checkboxSelection: f,
    disableMultipleRowSelection: m,
    disableRowSelectionOnClick: h,
    isRowSelectable: v
  } = t, b = !m || f, x = up(e, t), E = C.useCallback((B) => {
    var q;
    let X = B;
    const J = (q = c.current) != null ? q : B, U = e.current.isRowSelected(B);
    if (U) {
      const Z = Kb(e), ee = Z.findIndex((oe) => oe === J), ie = Z.findIndex((oe) => oe === X);
      if (ee === ie)
        return;
      ee > ie ? X = Z[ie + 1] : X = Z[ie - 1];
    }
    c.current = B, e.current.selectRowRange({
      startId: J,
      endId: X
    }, !U);
  }, [e]), T = C.useCallback((B) => {
    if (t.signature === js.DataGrid && !t.checkboxSelection && Array.isArray(B) && B.length > 1)
      throw new Error(["MUI: `rowSelectionModel` can only contain 1 item in DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."].join(`
`));
    tl(e.current.state) !== B && (o.debug("Setting selection model"), e.current.setState((X) => S({}, X, {
      rowSelection: t.rowSelection ? B : []
    })), e.current.forceUpdate());
  }, [e, o, t.rowSelection, t.signature, t.checkboxSelection]), P = C.useCallback((B) => tl(e.current.state).includes(B), [e]), O = C.useCallback((B) => {
    if (v && !v(e.current.getRowParams(B)))
      return !1;
    const q = e.current.getRowNode(B);
    return !((q == null ? void 0 : q.type) === "footer" || (q == null ? void 0 : q.type) === "pinnedRow");
  }, [e, v]), k = C.useCallback(() => Qge(e), [e]), I = C.useCallback((B, q = !0, X = !1) => {
    if (e.current.isRowSelectable(B))
      if (c.current = B, X)
        o.debug(`Setting selection for row ${B}`), e.current.setRowSelectionModel(q ? [B] : []);
      else {
        o.debug(`Toggling selection for row ${B}`);
        const U = tl(e.current.state).filter((ee) => ee !== B);
        q && U.push(B), (U.length < 2 || b) && e.current.setRowSelectionModel(U);
      }
  }, [e, o, b]), $ = C.useCallback((B, q = !0, X = !1) => {
    o.debug("Setting selection for several rows");
    const J = B.filter((ee) => e.current.isRowSelectable(ee));
    let U;
    if (X)
      U = q ? J : [];
    else {
      const ee = S({}, rx(e));
      J.forEach((ie) => {
        q ? ee[ie] = ie : delete ee[ie];
      }), U = Object.values(ee);
    }
    (U.length < 2 || b) && e.current.setRowSelectionModel(U);
  }, [e, o, b]), _ = C.useCallback(({
    startId: B,
    endId: q
  }, X = !0, J = !1) => {
    if (!e.current.getRow(B) || !e.current.getRow(q))
      return;
    o.debug(`Expanding selection from row ${B} to row ${q}`);
    const U = Kb(e), Z = U.indexOf(B), ee = U.indexOf(q), [ie, oe] = Z > ee ? [ee, Z] : [Z, ee], le = U.slice(ie, oe + 1);
    e.current.selectRows(le, X, J);
  }, [e, o]), z = {
    selectRow: I,
    setRowSelectionModel: T,
    getSelectedRows: k,
    isRowSelected: P,
    isRowSelectable: O
  }, V = {
    selectRows: $,
    selectRowRange: _
  };
  En(e, z, "public"), En(e, V, t.signature === js.DataGrid ? "private" : "public");
  const M = C.useCallback(() => {
    if (t.keepNonExistentRowsSelected)
      return;
    const B = tl(e.current.state), q = ud(e), X = S({}, rx(e));
    let J = !1;
    B.forEach((U) => {
      q[U] || (delete X[U], J = !0);
    }), J && e.current.setRowSelectionModel(Object.values(X));
  }, [e, t.keepNonExistentRowsSelected]), A = C.useCallback((B, q) => {
    const X = q.metaKey || q.ctrlKey, J = !f && !X && !Ghe(q), U = !b || J, Z = e.current.isRowSelected(B);
    U ? e.current.selectRow(B, J ? !0 : !Z, !0) : e.current.selectRow(B, !Z, !1);
  }, [e, b, f]), W = C.useCallback((B, q) => {
    var X;
    if (h)
      return;
    const J = (X = q.target.closest(`.${Te.cell}`)) == null ? void 0 : X.getAttribute("data-field");
    if (J === Zh.field || J === rM)
      return;
    if (J) {
      const Z = e.current.getColumn(J);
      if ((Z == null ? void 0 : Z.type) === Xx)
        return;
    }
    e.current.getRowNode(B.id).type !== "pinnedRow" && (q.shiftKey && (b || f) ? E(B.id) : A(B.id, q));
  }, [h, b, f, e, E, A]), Y = C.useCallback((B, q) => {
    if (b && q.shiftKey) {
      var X;
      (X = window.getSelection()) == null || X.removeAllRanges();
    }
  }, [b]), H = C.useCallback((B, q) => {
    q.nativeEvent.shiftKey ? E(B.id) : e.current.selectRow(B.id, B.value);
  }, [e, E]), G = C.useCallback((B) => {
    const X = t.checkboxSelectionVisibleOnly && t.pagination ? j4(e) : Kb(e);
    e.current.selectRows(X, B.value);
  }, [e, t.checkboxSelectionVisibleOnly, t.pagination]), ne = C.useCallback((B, q) => {
    if (e.current.getCellMode(B.id, B.field) !== sr.Edit && q.currentTarget.contains(q.target)) {
      if (nx(q.key) && q.shiftKey) {
        const X = Va(e);
        if (X && X.id !== B.id) {
          q.preventDefault();
          const J = e.current.isRowSelected(X.id);
          if (!b) {
            e.current.selectRow(X.id, !J, !0);
            return;
          }
          const U = e.current.getRowIndexRelativeToVisibleRows(X.id), Z = e.current.getRowIndexRelativeToVisibleRows(B.id);
          let ee, ie;
          U > Z ? J ? (ee = Z, ie = U - 1) : (ee = Z, ie = U) : J ? (ee = U + 1, ie = Z) : (ee = U, ie = Z);
          const oe = x.rows.slice(ee, ie + 1).map((le) => le.id);
          e.current.selectRows(oe, !J);
          return;
        }
      }
      if (q.key === " " && q.shiftKey) {
        q.preventDefault(), A(B.id, q);
        return;
      }
      q.key === "a" && (q.ctrlKey || q.metaKey) && (q.preventDefault(), $(e.current.getAllRowIds(), !0));
    }
  }, [e, A, $, x.rows, b]);
  Yt(e, "sortedRowsSet", i(M)), Yt(e, "rowClick", i(W)), Yt(e, "rowSelectionCheckboxChange", i(H)), Yt(e, "headerSelectionCheckboxChange", G), Yt(e, "cellMouseDown", i(Y)), Yt(e, "cellKeyDown", i(ne)), C.useEffect(() => {
    s !== void 0 && e.current.setRowSelectionModel(s);
  }, [e, s, t.rowSelection]), C.useEffect(() => {
    t.rowSelection || e.current.setRowSelectionModel([]);
  }, [e, t.rowSelection]);
  const K = s != null;
  C.useEffect(() => {
    if (K || !t.rowSelection)
      return;
    const B = tl(e.current.state);
    if (O) {
      const q = B.filter((X) => O(X));
      q.length < B.length && e.current.setRowSelectionModel(q);
    }
  }, [e, O, K, t.rowSelection]), C.useEffect(() => {
    if (!t.rowSelection || K)
      return;
    const B = tl(e.current.state);
    !b && B.length > 1 && e.current.setRowSelectionModel([]);
  }, [e, b, f, K, t.rowSelection]);
}, HCe = {
  // Root
  noRowsLabel: "No rows",
  noResultsOverlayLabel: "No results found.",
  // Density selector toolbar button text
  toolbarDensity: "Density",
  toolbarDensityLabel: "Density",
  toolbarDensityCompact: "Compact",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Comfortable",
  // Columns selector toolbar button text
  toolbarColumns: "Columns",
  toolbarColumnsLabel: "Select columns",
  // Filters toolbar button text
  toolbarFilters: "Filters",
  toolbarFiltersLabel: "Show filters",
  toolbarFiltersTooltipHide: "Hide filters",
  toolbarFiltersTooltipShow: "Show filters",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Search…",
  toolbarQuickFilterLabel: "Search",
  toolbarQuickFilterDeleteIconLabel: "Clear",
  // Export selector toolbar button text
  toolbarExport: "Export",
  toolbarExportLabel: "Export",
  toolbarExportCSV: "Download as CSV",
  toolbarExportPrint: "Print",
  toolbarExportExcel: "Download as Excel",
  // Columns panel text
  columnsPanelTextFieldLabel: "Find column",
  columnsPanelTextFieldPlaceholder: "Column title",
  columnsPanelDragIconLabel: "Reorder column",
  columnsPanelShowAllButton: "Show all",
  columnsPanelHideAllButton: "Hide all",
  // Filter panel text
  filterPanelAddFilter: "Add filter",
  filterPanelRemoveAll: "Remove all",
  filterPanelDeleteIconLabel: "Delete",
  filterPanelLogicOperator: "Logic operator",
  filterPanelOperator: "Operator",
  filterPanelOperatorAnd: "And",
  filterPanelOperatorOr: "Or",
  filterPanelColumns: "Columns",
  filterPanelInputLabel: "Value",
  filterPanelInputPlaceholder: "Filter value",
  // Filter operators text
  filterOperatorContains: "contains",
  filterOperatorEquals: "equals",
  filterOperatorStartsWith: "starts with",
  filterOperatorEndsWith: "ends with",
  filterOperatorIs: "is",
  filterOperatorNot: "is not",
  filterOperatorAfter: "is after",
  filterOperatorOnOrAfter: "is on or after",
  filterOperatorBefore: "is before",
  filterOperatorOnOrBefore: "is on or before",
  filterOperatorIsEmpty: "is empty",
  filterOperatorIsNotEmpty: "is not empty",
  filterOperatorIsAnyOf: "is any of",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators text
  headerFilterOperatorContains: "Contains",
  headerFilterOperatorEquals: "Equals",
  headerFilterOperatorStartsWith: "Starts with",
  headerFilterOperatorEndsWith: "Ends with",
  headerFilterOperatorIs: "Is",
  headerFilterOperatorNot: "Is not",
  headerFilterOperatorAfter: "Is after",
  headerFilterOperatorOnOrAfter: "Is on or after",
  headerFilterOperatorBefore: "Is before",
  headerFilterOperatorOnOrBefore: "Is on or before",
  headerFilterOperatorIsEmpty: "Is empty",
  headerFilterOperatorIsNotEmpty: "Is not empty",
  headerFilterOperatorIsAnyOf: "Is any of",
  "headerFilterOperator=": "Equals",
  "headerFilterOperator!=": "Not equals",
  "headerFilterOperator>": "Greater than",
  "headerFilterOperator>=": "Greater than or equal to",
  "headerFilterOperator<": "Less than",
  "headerFilterOperator<=": "Less than or equal to",
  // Filter values text
  filterValueAny: "any",
  filterValueTrue: "true",
  filterValueFalse: "false",
  // Column menu text
  columnMenuLabel: "Menu",
  columnMenuShowColumns: "Show columns",
  columnMenuManageColumns: "Manage columns",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Hide column",
  columnMenuUnsort: "Unsort",
  columnMenuSortAsc: "Sort by ASC",
  columnMenuSortDesc: "Sort by DESC",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  columnHeaderFiltersLabel: "Show filters",
  columnHeaderSortIconLabel: "Sort",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} rows selected` : `${e.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: "Total Rows:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} of ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox selection",
  checkboxSelectionSelectAllRows: "Select all rows",
  checkboxSelectionUnselectAllRows: "Unselect all rows",
  checkboxSelectionSelectRow: "Select row",
  checkboxSelectionUnselectRow: "Unselect row",
  // Boolean cell text
  booleanCellTrueLabel: "yes",
  booleanCellFalseLabel: "no",
  // Actions cell more text
  actionsCellMore: "more",
  // Column pinning text
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  // Tree Data
  treeDataGroupingHeaderName: "Group",
  treeDataExpand: "see children",
  treeDataCollapse: "hide children",
  // Grouping columns
  groupingColumnHeaderName: "Group",
  groupColumn: (e) => `Group by ${e}`,
  unGroupColumn: (e) => `Stop grouping by ${e}`,
  // Master/detail
  detailPanelToggle: "Detail panel toggle",
  expandDetailPanel: "Expand",
  collapseDetailPanel: "Collapse",
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: "Row reordering",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "sum",
  aggregationFunctionLabelAvg: "avg",
  aggregationFunctionLabelMin: "min",
  aggregationFunctionLabelMax: "max",
  aggregationFunctionLabelSize: "size"
}, UCe = (e) => {
  const {
    classes: t
  } = e;
  return C.useMemo(() => je({
    cellCheckbox: ["cellCheckbox"],
    columnHeaderCheckbox: ["columnHeaderCheckbox"]
  }, $n, t), [t]);
}, GCe = (e, t) => {
  const o = {
    classes: t.classes
  }, i = UCe(o), s = C.useCallback((c) => {
    const f = S({}, Zh, {
      cellClassName: i.cellCheckbox,
      headerClassName: i.columnHeaderCheckbox,
      headerName: e.current.getLocaleText("checkboxSelectionHeaderName")
    }), m = t.checkboxSelection, h = c.lookup[nd] != null;
    return m && !h ? (c.lookup[nd] = f, c.orderedFields = [nd, ...c.orderedFields]) : !m && h ? (delete c.lookup[nd], c.orderedFields = c.orderedFields.filter((v) => v !== nd)) : m && h && (c.lookup[nd] = S({}, f, c.lookup[nd])), c;
  }, [e, i, t.checkboxSelection]);
  _o(e, "hydrateColumns", s);
}, WCe = (e, t) => {
  var o, i, s;
  const c = (o = (i = t.sortModel) != null ? i : (s = t.initialState) == null || (s = s.sorting) == null ? void 0 : s.sortModel) != null ? o : [];
  return S({}, e, {
    sorting: {
      sortModel: H4(c, t.disableMultipleColumnsSorting),
      sortedRows: []
    }
  });
}, qCe = (e, t) => {
  var o;
  const i = Ra(e, "useGridSorting");
  e.current.registerControlState({
    stateId: "sortModel",
    propModel: t.sortModel,
    propOnChange: t.onSortModelChange,
    stateSelector: el,
    changeEvent: "sortModelChange"
  });
  const s = C.useCallback((M, A) => {
    const W = el(e), Y = W.findIndex((G) => G.field === M);
    let H = [...W];
    return Y > -1 ? A ? H.splice(Y, 1, A) : H.splice(Y, 1) : H = [...W, A], H;
  }, [e]), c = C.useCallback((M, A) => {
    var W;
    const H = el(e).find((ne) => ne.field === M.field);
    if (H) {
      var G;
      const ne = A === void 0 ? yA((G = M.sortingOrder) != null ? G : t.sortingOrder, H.sort) : A;
      return ne == null ? void 0 : S({}, H, {
        sort: ne
      });
    }
    return {
      field: M.field,
      sort: A === void 0 ? yA((W = M.sortingOrder) != null ? W : t.sortingOrder) : A
    };
  }, [e, t.sortingOrder]), f = C.useCallback((M, A) => A == null || A.sortable === !1 ? M : (A.sortingOrder || t.sortingOrder).some((Y) => !!Y) ? [...M, "columnMenuSortItem"] : M, [t.sortingOrder]), m = C.useCallback(() => {
    e.current.setState((M) => {
      if (t.sortingMode === "server")
        return i.debug("Skipping sorting rows as sortingMode = server"), S({}, M, {
          sorting: S({}, M.sorting, {
            sortedRows: GP(zl(e), ja, !1)
          })
        });
      const A = el(M, e.current.instanceId), W = nve(A, e), Y = e.current.applyStrategyProcessor("sorting", {
        sortRowList: W
      });
      return S({}, M, {
        sorting: S({}, M.sorting, {
          sortedRows: Y
        })
      });
    }), e.current.publishEvent("sortedRowsSet"), e.current.forceUpdate();
  }, [e, i, t.sortingMode]), h = C.useCallback((M) => {
    el(e) !== M && (i.debug("Setting sort model"), e.current.setState(bA(M, t.disableMultipleColumnsSorting)), e.current.forceUpdate(), e.current.applySorting());
  }, [e, i, t.disableMultipleColumnsSorting]), v = C.useCallback((M, A, W) => {
    if (!M.sortable)
      return;
    const Y = c(M, A);
    let H;
    !W || t.disableMultipleColumnsSorting ? H = Y ? [Y] : [] : H = s(M.field, Y), e.current.setSortModel(H);
  }, [e, s, c, t.disableMultipleColumnsSorting]), b = C.useCallback(() => el(e), [e]), x = C.useCallback(() => jP(e).map((A) => A.model), [e]), E = C.useCallback(() => BP(e), [e]), T = C.useCallback((M) => e.current.getSortedRowIds()[M], [e]);
  En(e, {
    getSortModel: b,
    getSortedRows: x,
    getSortedRowIds: E,
    getRowIdFromRowIndex: T,
    setSortModel: h,
    sortColumn: v,
    applySorting: m
  }, "public");
  const O = C.useCallback((M, A) => {
    var W;
    const Y = el(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !A.exportOnlyDirtyModels || // Always export if the model is controlled
      t.sortModel != null || // Always export if the model has been initialized
      ((W = t.initialState) == null || (W = W.sorting) == null ? void 0 : W.sortModel) != null || // Export if the model is not empty
      Y.length > 0 ? S({}, M, {
        sorting: {
          sortModel: Y
        }
      }) : M
    );
  }, [e, t.sortModel, (o = t.initialState) == null || (o = o.sorting) == null ? void 0 : o.sortModel]), k = C.useCallback((M, A) => {
    var W;
    const Y = (W = A.stateToRestore.sorting) == null ? void 0 : W.sortModel;
    return Y == null ? M : (e.current.setState(bA(Y, t.disableMultipleColumnsSorting)), S({}, M, {
      callbacks: [...M.callbacks, e.current.applySorting]
    }));
  }, [e, t.disableMultipleColumnsSorting]), I = C.useCallback((M) => {
    const A = zl(e), W = A[ja], Y = M.sortRowList ? M.sortRowList(W.children.map((H) => A[H])) : [...W.children];
    return W.footerId != null && Y.push(W.footerId), Y;
  }, [e]);
  _o(e, "exportState", O), _o(e, "restoreState", k), ix(e, ap, "sorting", I);
  const $ = C.useCallback(({
    colDef: M
  }, A) => {
    const W = A.shiftKey || A.metaKey || A.ctrlKey;
    v(M, void 0, W);
  }, [v]), _ = C.useCallback(({
    colDef: M
  }, A) => {
    Bhe(A.key) && !A.ctrlKey && !A.metaKey && v(M, void 0, A.shiftKey);
  }, [v]), z = C.useCallback(() => {
    const M = el(e), A = Kh(e);
    if (M.length > 0) {
      const W = M.filter((Y) => A[Y.field]);
      W.length < M.length && e.current.setSortModel(W);
    }
  }, [e]), V = C.useCallback((M) => {
    M === "sorting" && e.current.applySorting();
  }, [e]);
  _o(e, "columnMenu", f), Yt(e, "columnHeaderClick", $), Yt(e, "columnHeaderKeyDown", _), Yt(e, "rowsSet", e.current.applySorting), Yt(e, "columnsChange", z), Yt(e, "activeStrategyProcessorChange", V), _y(() => {
    e.current.applySorting();
  }), Hn(() => {
    t.sortModel !== void 0 && e.current.setSortModel(t.sortModel);
  }, [e, t.sortModel]);
};
function HA(e) {
  const {
    clientHeight: t,
    scrollTop: o,
    offsetHeight: i,
    offsetTop: s
  } = e, c = s + i;
  if (i > t)
    return s;
  if (c - t > o)
    return c - t;
  if (s < o)
    return s;
}
const YCe = (e, t) => {
  const o = mr(), i = Ra(e, "useGridScroll"), s = e.current.columnHeadersElementRef, c = e.current.virtualScrollerRef, f = Nt(e, Sd), m = C.useCallback((x) => {
    const E = jx(e), T = la(e);
    if (!(x.rowIndex == null) && E === 0 || T.length === 0)
      return !1;
    i.debug(`Scrolling to cell at row ${x.rowIndex}, col: ${x.colIndex} `);
    let O = {};
    if (x.colIndex != null) {
      const _ = zh(e);
      let z;
      if (typeof x.rowIndex < "u") {
        var k;
        const V = (k = f[x.rowIndex]) == null ? void 0 : k.id, M = e.current.unstable_getCellColSpanInfo(V, x.colIndex);
        M && !M.spannedByColSpan && (z = M.cellProps.width);
      }
      typeof z > "u" && (z = T[x.colIndex].computedWidth), O.left = HA({
        clientHeight: c.current.clientWidth,
        scrollTop: Math.abs(c.current.scrollLeft),
        offsetHeight: z,
        offsetTop: _[x.colIndex]
      });
    }
    if (x.rowIndex != null) {
      var I, $;
      const _ = my(e.current.state), z = qge(e), V = Yge(e), M = t.pagination ? x.rowIndex - z * V : x.rowIndex, A = _.positions[M + 1] ? _.positions[M + 1] - _.positions[M] : _.currentPageTotalHeight - _.positions[M], W = ((I = c.current.querySelector(`.${Te["pinnedRows--top"]}`)) == null ? void 0 : I.clientHeight) || 0, Y = (($ = c.current.querySelector(`.${Te["pinnedRows--bottom"]}`)) == null ? void 0 : $.clientHeight) || 0;
      O.top = HA({
        clientHeight: c.current.clientHeight - W - Y,
        scrollTop: c.current.scrollTop,
        offsetHeight: A,
        offsetTop: _.positions[M]
      });
    }
    return O = e.current.unstable_applyPipeProcessors("scrollToIndexes", O, x), typeof O.left !== void 0 || typeof O.top !== void 0 ? (e.current.scroll(O), !0) : !1;
  }, [i, e, c, t.pagination, f]), h = C.useCallback((x) => {
    if (c.current && x.left != null && s.current) {
      const E = o.direction === "rtl" ? -1 : 1;
      s.current.scrollLeft = x.left, c.current.scrollLeft = E * x.left, i.debug(`Scrolling left: ${x.left}`);
    }
    c.current && x.top != null && (c.current.scrollTop = x.top, i.debug(`Scrolling top: ${x.top}`)), i.debug("Scrolling, updating container, and viewport");
  }, [c, o.direction, s, i]), v = C.useCallback(() => c != null && c.current ? {
    top: c.current.scrollTop,
    left: c.current.scrollLeft
  } : {
    top: 0,
    left: 0
  }, [c]);
  En(e, {
    scroll: h,
    scrollToIndexes: m,
    getScrollPosition: v
  }, "public");
};
function KCe(e, t) {
  Mr(e, "columnHeaderClick", t.onColumnHeaderClick), Mr(e, "columnHeaderDoubleClick", t.onColumnHeaderDoubleClick), Mr(e, "columnHeaderOver", t.onColumnHeaderOver), Mr(e, "columnHeaderOut", t.onColumnHeaderOut), Mr(e, "columnHeaderEnter", t.onColumnHeaderEnter), Mr(e, "columnHeaderLeave", t.onColumnHeaderLeave), Mr(e, "cellClick", t.onCellClick), Mr(e, "cellDoubleClick", t.onCellDoubleClick), Mr(e, "cellKeyDown", t.onCellKeyDown), Mr(e, "preferencePanelClose", t.onPreferencePanelClose), Mr(e, "preferencePanelOpen", t.onPreferencePanelOpen), Mr(e, "menuOpen", t.onMenuOpen), Mr(e, "menuClose", t.onMenuClose), Mr(e, "rowDoubleClick", t.onRowDoubleClick), Mr(e, "rowClick", t.onRowClick), Mr(e, "stateChange", t.onStateChange);
}
const XCe = process.env.NODE_ENV === "test", QCe = ({
  content: e,
  container: t,
  scrollBarSize: o
}) => {
  const i = e.width > t.width, s = e.height > t.height;
  let c = !1, f = !1;
  return (i || s) && (c = i, f = e.height + (c ? o : 0) > t.height, f && (c = e.width + o > t.width)), {
    hasScrollX: c,
    hasScrollY: f
  };
};
function ZCe(e, t) {
  const o = Ra(e, "useResizeContainer"), i = C.useRef(!1), s = C.useRef(null), c = C.useRef(null), f = Nt(e, my), m = Nt(e, Qh), h = Math.floor(t.rowHeight * m), v = iM(e, t.columnHeaderHeight), b = C.useCallback(() => {
    var A;
    const W = (A = e.current.rootElementRef) == null ? void 0 : A.current, Y = VP(e), H = i4(e);
    if (!s.current)
      return;
    let G;
    if (t.scrollbarSize != null)
      G = t.scrollbarSize;
    else if (!Y || !W)
      G = 0;
    else {
      const Z = qn(W).createElement("div");
      Z.style.width = "99px", Z.style.height = "99px", Z.style.position = "absolute", Z.style.overflow = "scroll", Z.className = "scrollDiv", W.appendChild(Z), G = Z.offsetWidth - Z.clientWidth, W.removeChild(Z);
    }
    let ne, K, B;
    if (t.autoHeight)
      B = !1, K = Math.round(Y) > Math.round(s.current.width), ne = {
        width: s.current.width,
        height: f.currentPageTotalHeight + (K ? G : 0)
      };
    else {
      ne = {
        width: s.current.width,
        height: Math.max(s.current.height - v, 0)
      };
      const U = QCe({
        content: {
          width: Math.round(Y),
          height: f.currentPageTotalHeight
        },
        container: {
          width: Math.round(ne.width),
          height: ne.height - H.top - H.bottom
        },
        scrollBarSize: G
      });
      B = U.hasScrollY, K = U.hasScrollX;
    }
    const q = {
      width: ne.width - (B ? G : 0),
      height: ne.height - (K ? G : 0)
    }, X = {
      viewportOuterSize: ne,
      viewportInnerSize: q,
      hasScrollX: K,
      hasScrollY: B,
      scrollBarSize: G
    }, J = c.current;
    c.current = X, (X.viewportInnerSize.width !== (J == null ? void 0 : J.viewportInnerSize.width) || X.viewportInnerSize.height !== (J == null ? void 0 : J.viewportInnerSize.height)) && e.current.publishEvent("viewportInnerSizeChange", X.viewportInnerSize);
  }, [e, t.scrollbarSize, t.autoHeight, f.currentPageTotalHeight, v]), [x, E] = C.useState(), T = C.useMemo(() => lp(E, 60), []), P = C.useRef();
  Hn(() => {
    x && (b(), e.current.publishEvent("debouncedResize", s.current));
  }, [e, x, b]);
  const O = C.useCallback(() => {
    e.current.computeSizeAndPublishResizeEvent();
  }, [e]), k = C.useCallback(() => c.current, []), I = C.useCallback(() => {
    const A = e.current.getRootDimensions();
    if (!A)
      return 0;
    const W = ox(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (t.getRowHeight) {
      const H = e.current.getRenderContext(), G = H.lastRowIndex - H.firstRowIndex;
      return Math.min(G - 1, W.rows.length);
    }
    const Y = Math.floor(A.viewportInnerSize.height / h);
    return Math.min(Y, W.rows.length);
  }, [e, t.pagination, t.paginationMode, t.getRowHeight, h]), $ = C.useCallback(() => {
    var A, W, Y;
    const H = (A = e.current.mainElementRef) == null ? void 0 : A.current;
    if (!H)
      return;
    const ne = Ta(H).getComputedStyle(H), K = parseFloat(ne.height) || 0, B = parseFloat(ne.width) || 0, q = K !== ((W = P.current) == null ? void 0 : W.height), X = B !== ((Y = P.current) == null ? void 0 : Y.width);
    if (!P.current || q || X) {
      const J = {
        width: B,
        height: K
      };
      e.current.publishEvent("resize", J), P.current = J;
    }
  }, [e]), _ = {
    resize: O,
    getRootDimensions: k
  }, z = {
    getViewportPageSize: I,
    updateGridDimensionsRef: b,
    computeSizeAndPublishResizeEvent: $
  };
  En(e, _, "public"), En(e, z, "private");
  const V = C.useRef(!0), M = C.useCallback((A) => {
    s.current = A;
    const W = /jsdom/.test(window.navigator.userAgent);
    if (A.height === 0 && !i.current && !t.autoHeight && !W && (o.error(["The parent DOM element of the data grid has an empty height.", "Please make sure that this element has an intrinsic height.", "The grid displays with a height of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), i.current = !0), A.width === 0 && !i.current && !W && (o.error(["The parent DOM element of the data grid has an empty width.", "Please make sure that this element has an intrinsic width.", "The grid displays with a width of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), i.current = !0), XCe) {
      E(A), V.current = !1;
      return;
    }
    if (V.current) {
      E(A), V.current = !1;
      return;
    }
    T(A);
  }, [t.autoHeight, T, o]);
  Hn(() => b(), [b]), Mr(e, "sortedRowsSet", b), Mr(e, "paginationModelChange", b), Mr(e, "columnsChange", b), Yt(e, "resize", M), Mr(e, "debouncedResize", t.onResize);
}
const JCe = ["style"], e0e = ["style"];
function kh(e, t, o = 0, i = t.length) {
  if (t.length <= 0)
    return -1;
  if (o >= i)
    return o;
  const s = o + Math.floor((i - o) / 2), c = t[s];
  return e <= c ? kh(e, t, o, s) : kh(e, t, s + 1, i);
}
function t0e(e, t, o) {
  let i = 1;
  for (; o < t.length && Math.abs(t[o]) < e; )
    o += i, i *= 2;
  return kh(e, t, Math.floor(o / 2), Math.min(o, t.length));
}
const od = ({
  firstIndex: e,
  lastIndex: t,
  buffer: o,
  minFirstIndex: i,
  maxLastIndex: s
}) => [Vh(e - o, i, s), Vh(t + o, i, s)], $B = (e, t) => e === t ? !0 : e.firstRowIndex === t.firstRowIndex && e.lastRowIndex === t.lastRowIndex && e.firstColumnIndex === t.firstColumnIndex && e.lastColumnIndex === t.lastColumnIndex, n0e = {
  maxSize: 3
}, r0e = (e) => {
  var t, o;
  const i = Cd(), s = Ht(), c = Nt(i, la), f = Nt(i, cve), m = Nt(i, Y4), {
    ref: h,
    onRenderZonePositioning: v,
    renderZoneMinColumnIndex: b = 0,
    renderZoneMaxColumnIndex: x = c.length,
    getRowProps: E
  } = e, T = mr(), P = Nt(i, zh), O = Nt(i, VP), k = Nt(i, Va), I = Nt(i, Q1), $ = Nt(i, my), _ = Nt(i, rx), z = up(i, s), V = C.useRef(null), M = C.useRef(null), A = Cn(h, M), [W, Y] = C.useState(null), H = C.useRef(W), G = C.useRef({
    top: 0,
    left: 0
  }), [ne, K] = C.useState({
    width: null,
    height: null
  }), B = C.useRef(O), [q, X] = C.useState(null), J = C.useRef(/* @__PURE__ */ Object.create(null)), U = C.useRef(), Z = C.useRef(), ee = C.useRef(zx((we, Me, Qe, ct, Ze, Ge) => {
    let Be;
    const rt = we.slice(Me, Qe);
    return Ge > -1 && (Me > Ge && Ge >= ct || Qe < Ge && Ge < Ze) && (Be = Ge), {
      focusedCellColumnIndexNotInRange: Be,
      renderedColumns: rt
    };
  }, n0e)), ie = C.useMemo(() => k !== null ? c.findIndex((we) => we.field === k.field) : -1, [k, c]), oe = C.useCallback((we) => {
    var Me, Qe;
    const ct = i.current.getLastMeasuredRowIndex();
    let Ze = ct === 1 / 0;
    (Me = z.range) != null && Me.lastRowIndex && !Ze && (Ze = ct >= z.range.lastRowIndex);
    const Ge = Vh(ct - (((Qe = z.range) == null ? void 0 : Qe.firstRowIndex) || 0), 0, $.positions.length);
    return Ze || $.positions[Ge] >= we ? kh(we, $.positions) : t0e(we, $.positions, Ge);
  }, [i, (t = z.range) == null ? void 0 : t.firstRowIndex, (o = z.range) == null ? void 0 : o.lastRowIndex, $.positions]), le = C.useCallback(() => {
    if (!f)
      return {
        firstRowIndex: 0,
        lastRowIndex: z.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: c.length
      };
    const {
      top: we,
      left: Me
    } = G.current, Qe = Math.min(oe(we), $.positions.length - 1), ct = s.autoHeight ? Qe + z.rows.length : oe(we + ne.height);
    let Ze = 0, Ge = P.length;
    if (m) {
      let Be = !1;
      const [rt, wt] = od({
        firstIndex: Qe,
        lastIndex: ct,
        minFirstIndex: 0,
        maxLastIndex: z.rows.length,
        buffer: s.rowBuffer
      });
      for (let We = rt; We < wt && !Be; We += 1) {
        const ut = z.rows[We];
        Be = i.current.rowHasAutoHeight(ut.id);
      }
      Be || (Ze = kh(Math.abs(Me), P), Ge = kh(Math.abs(Me) + ne.width, P));
    }
    return {
      firstRowIndex: Qe,
      lastRowIndex: ct,
      firstColumnIndex: Ze,
      lastColumnIndex: Ge
    };
  }, [f, m, oe, $.positions.length, s.autoHeight, s.rowBuffer, z.rows, P, c.length, i, ne]);
  Hn(() => {
    f ? (M.current.scrollLeft = 0, M.current.scrollTop = 0) : V.current.style.transform = "translate3d(0px, 0px, 0px)";
  }, [f]), Hn(() => {
    K({
      width: M.current.clientWidth,
      height: M.current.clientHeight
    });
  }, [$.currentPageTotalHeight]);
  const de = C.useCallback(() => {
    M.current && K({
      width: M.current.clientWidth,
      height: M.current.clientHeight
    });
  }, []);
  Yt(i, "debouncedResize", de);
  const Ce = C.useCallback((we) => {
    const [Me, Qe] = od({
      firstIndex: we.firstRowIndex,
      lastIndex: we.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: z.rows.length,
      buffer: s.rowBuffer
    }), [ct] = od({
      firstIndex: we.firstColumnIndex,
      lastIndex: we.lastColumnIndex,
      minFirstIndex: b,
      maxLastIndex: x,
      buffer: s.columnBuffer
    }), Ze = uk({
      firstColumnToRender: ct,
      apiRef: i,
      firstRowToRender: Me,
      lastRowToRender: Qe,
      visibleRows: z.rows
    }), Ge = T.direction === "ltr" ? 1 : -1, Be = my(i.current.state).positions[Me], rt = Ge * zh(i)[Ze];
    V.current.style.transform = `translate3d(${rt}px, ${Be}px, 0px)`, typeof v == "function" && v({
      top: Be,
      left: rt
    });
  }, [i, z.rows, v, b, x, s.columnBuffer, s.rowBuffer, T.direction]), me = C.useCallback(() => H.current, []), Oe = C.useCallback((we) => {
    if (H.current && $B(we, H.current)) {
      Ce(we);
      return;
    }
    Y(we), Ce(we);
    const [Me, Qe] = od({
      firstIndex: we.firstRowIndex,
      lastIndex: we.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: z.rows.length,
      buffer: s.rowBuffer
    });
    i.current.publishEvent("renderedRowsIntervalChange", {
      firstRowToRender: Me,
      lastRowToRender: Qe
    }), H.current = we;
  }, [i, Y, H, z.rows.length, s.rowBuffer, Ce]);
  Hn(() => {
    if (ne.width == null)
      return;
    const we = le();
    Oe(we);
    const {
      top: Me,
      left: Qe
    } = G.current, ct = {
      top: Me,
      left: Qe,
      renderContext: we
    };
    i.current.publishEvent("scrollPositionChange", ct);
  }, [i, le, ne.width, Oe]);
  const he = zn((we) => {
    const {
      scrollTop: Me,
      scrollLeft: Qe
    } = we.currentTarget;
    if (G.current.top = Me, G.current.left = Qe, !H.current || Me < 0 || T.direction === "ltr" && Qe < 0 || T.direction === "rtl" && Qe > 0)
      return;
    const ct = f ? le() : H.current, Ze = Math.abs(ct.firstRowIndex - H.current.firstRowIndex), Ge = Math.abs(ct.lastRowIndex - H.current.lastRowIndex), Be = Math.abs(ct.firstColumnIndex - H.current.firstColumnIndex), rt = Math.abs(ct.lastColumnIndex - H.current.lastColumnIndex), wt = Ze >= s.rowThreshold || Ge >= s.rowThreshold || Be >= s.columnThreshold || rt >= s.columnThreshold || B.current !== O;
    i.current.publishEvent("scrollPositionChange", {
      top: Me,
      left: Qe,
      renderContext: wt ? ct : H.current
    }, we), wt && (ep.flushSync(() => {
      Oe(ct);
    }), B.current = O);
  }), $e = zn((we) => {
    i.current.publishEvent("virtualScrollerWheel", {}, we);
  }), Ne = zn((we) => {
    i.current.publishEvent("virtualScrollerTouchMove", {}, we);
  }), Pe = C.useMemo(() => k !== null ? z.rows.findIndex((we) => we.id === k.id) : -1, [k, z.rows]);
  Yt(i, "rowMouseEnter", (we) => {
    var Me;
    X((Me = we.id) != null ? Me : null);
  }), Yt(i, "rowMouseLeave", () => {
    X(null);
  });
  const Se = (we = {
    renderContext: W
  }) => {
    var Me;
    const {
      onRowRender: Qe,
      renderContext: ct,
      minFirstColumn: Ze = b,
      maxLastColumn: Ge = x,
      availableSpace: Be = ne.width,
      rowIndexOffset: rt = 0,
      position: wt = "center"
    } = we;
    if (!ct || Be == null)
      return null;
    const We = f ? s.rowBuffer : 0, ut = f ? s.columnBuffer : 0, [ft, Je] = od({
      firstIndex: ct.firstRowIndex,
      lastIndex: ct.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: z.rows.length,
      buffer: We
    }), pt = [];
    if (we.rows)
      we.rows.forEach((wn) => {
        pt.push(wn), i.current.calculateColSpan({
          rowId: wn.id,
          minFirstColumn: Ze,
          maxLastColumn: Ge,
          columns: c
        });
      });
    else {
      if (!z.range)
        return null;
      for (let wn = ft; wn < Je; wn += 1) {
        const hn = z.rows[wn];
        pt.push(hn), i.current.calculateColSpan({
          rowId: hn.id,
          minFirstColumn: Ze,
          maxLastColumn: Ge,
          columns: c
        });
      }
    }
    let At = !1;
    if (Pe > -1) {
      const wn = z.rows[Pe];
      (ft > Pe || Je < Pe) && (At = !0, Pe > ft ? pt.push(wn) : pt.unshift(wn), i.current.calculateColSpan({
        rowId: wn.id,
        minFirstColumn: Ze,
        maxLastColumn: Ge,
        columns: c
      }));
    }
    const [Ye, st] = od({
      firstIndex: ct.firstColumnIndex,
      lastIndex: ct.lastColumnIndex,
      minFirstIndex: Ze,
      maxLastIndex: Ge,
      buffer: ut
    }), _e = uk({
      firstColumnToRender: Ye,
      apiRef: i,
      firstRowToRender: ft,
      lastRowToRender: Je,
      visibleRows: z.rows
    });
    let vt = !1;
    (_e > ie || st < ie) && (vt = !0);
    const {
      focusedCellColumnIndexNotInRange: et,
      renderedColumns: gt
    } = ee.current(c, _e, st, Ze, Ge, vt ? ie : -1), kt = ((Me = s.slotProps) == null ? void 0 : Me.row) || {}, {
      style: Lt
    } = kt, Ut = pe(kt, JCe);
    (U.current !== E || Z.current !== Lt) && (J.current = /* @__PURE__ */ Object.create(null));
    const an = [];
    for (let wn = 0; wn < pt.length; wn += 1) {
      var un;
      const {
        id: hn,
        model: Br
      } = pt[wn], zo = At && k.id === hn, wo = At ? ft + wn === z.rows.length : ft + wn === z.rows.length - 1, to = i.current.rowHasAutoHeight(hn) ? "auto" : i.current.unstable_getRowHeight(hn);
      let Dr;
      _[hn] == null ? Dr = !1 : Dr = i.current.isRowSelectable(hn), Qe && Qe(hn);
      const Vn = k !== null && k.id === hn ? k.field : null, Dn = et !== void 0 && c[et], Zn = Dn && Vn ? [Dn, ...gt] : gt;
      let _r = null;
      I !== null && I.id === hn && (_r = i.current.getCellParams(hn, I.field).cellMode === "view" ? I.field : null);
      const ur = typeof E == "function" && E(hn, Br) || {}, {
        style: Bn
      } = ur, xr = pe(ur, e0e);
      if (!J.current[hn]) {
        const fe = S({}, Bn, Lt);
        J.current[hn] = fe;
      }
      an.push(/* @__PURE__ */ L(s.slots.row, S({
        row: Br,
        rowId: hn,
        focusedCellColumnIndexNotInRange: et,
        isNotVisible: zo,
        rowHeight: to,
        focusedCell: Vn,
        tabbableCell: _r,
        renderedColumns: Zn,
        visibleColumns: c,
        firstColumnToRender: _e,
        lastColumnToRender: st,
        selected: Dr,
        index: rt + ((z == null || (un = z.range) == null ? void 0 : un.firstRowIndex) || 0) + ft + wn,
        containerWidth: Be,
        isLastVisible: wo,
        position: wt
      }, xr, Ut, {
        hovered: q === hn,
        style: J.current[hn]
      }), hn));
    }
    return U.current = E, Z.current = Lt, an;
  }, Fe = ne.width && O >= ne.width, ce = C.useMemo(() => {
    const we = Math.max($.currentPageTotalHeight, 1);
    let Me = !1;
    M != null && M.current && we <= (M == null ? void 0 : M.current.clientHeight) && (Me = !0);
    const Qe = {
      width: Fe ? O : "auto",
      height: we,
      minHeight: Me ? "100%" : "auto"
    };
    return s.autoHeight && z.rows.length === 0 && (Qe.height = l4(i, s.rowHeight)), Qe;
  }, [i, M, O, $.currentPageTotalHeight, Fe, s.autoHeight, s.rowHeight, z.rows.length]);
  C.useEffect(() => {
    i.current.publishEvent("virtualScrollerContentSizeChange");
  }, [i, ce]);
  const ge = C.useMemo(() => {
    const we = {};
    return Fe || (we.overflowX = "hidden"), s.autoHeight && (we.overflowY = "hidden"), we;
  }, [Fe, s.autoHeight]);
  return i.current.register("private", {
    getRenderContext: me
  }), {
    renderContext: W,
    updateRenderZonePosition: Ce,
    getRows: Se,
    getRootProps: (we = {}) => S({
      ref: A,
      onScroll: he,
      onWheel: $e,
      onTouchMove: Ne
    }, we, {
      style: we.style ? S({}, we.style, ge) : ge,
      role: "presentation"
    }),
    getContentProps: ({
      style: we
    } = {}) => ({
      style: we ? S({}, we, ce) : ce,
      role: "presentation"
    }),
    getRenderZoneProps: () => ({
      ref: V,
      role: "rowgroup"
    })
  };
}, o0e = (e) => {
  const {
    classes: t,
    headerAlign: o,
    isDragging: i,
    showColumnBorder: s,
    groupId: c
  } = e;
  return je({
    root: ["columnHeader", o === "left" && "columnHeader--alignLeft", o === "center" && "columnHeader--alignCenter", o === "right" && "columnHeader--alignRight", i && "columnHeader--moving", s && "columnHeader--showColumnBorder", s && "columnHeader--withRightBorder", "withBorderColor", c === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup"],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer", "withBorderColor"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  }, $n, t);
};
function a0e(e) {
  var t;
  const {
    groupId: o,
    width: i,
    depth: s,
    maxDepth: c,
    fields: f,
    height: m,
    colIndex: h,
    hasFocus: v,
    tabIndex: b,
    isLastColumn: x
  } = e, E = Ht(), T = C.useRef(null), P = Tn(), O = Nt(P, X5), k = o ? O[o] : {}, {
    headerName: I = o ?? "",
    description: $ = "",
    headerAlign: _ = void 0
  } = k;
  let z;
  const V = o && ((t = O[o]) == null ? void 0 : t.renderHeaderGroup), M = C.useMemo(() => ({
    groupId: o,
    headerName: I,
    description: $,
    depth: s,
    maxDepth: c,
    fields: f,
    colIndex: h,
    isLastColumn: x
  }), [o, I, $, s, c, f, h, x]);
  o && V && (z = V(M));
  const A = E.showColumnVerticalBorder, W = S({}, e, {
    classes: E.classes,
    showColumnBorder: A,
    headerAlign: _,
    depth: s,
    isDragging: !1
  }), Y = I ?? o, H = Qn(), G = o === null ? `empty-group-cell-${H}` : o, ne = o0e(W);
  C.useLayoutEffect(() => {
    if (v) {
      const J = T.current.querySelector('[tabindex="0"]') || T.current;
      J == null || J.focus();
    }
  }, [P, v]);
  const K = C.useCallback(
    (X) => (J) => {
      J.currentTarget.contains(J.target) && P.current.publishEvent(X, M, J);
    },
    // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [P, M]
  ), B = C.useMemo(() => ({
    onKeyDown: K("columnGroupHeaderKeyDown"),
    onFocus: K("columnGroupHeaderFocus"),
    onBlur: K("columnGroupHeaderBlur")
  }), [K]), q = typeof k.headerClassName == "function" ? k.headerClassName(M) : k.headerClassName;
  return /* @__PURE__ */ L(D4, S({
    ref: T,
    classes: ne,
    columnMenuOpen: !1,
    colIndex: h,
    height: m,
    isResizing: !1,
    sortDirection: null,
    hasFocus: !1,
    tabIndex: b,
    isDraggable: !1,
    headerComponent: z,
    headerClassName: q,
    description: $,
    elementId: G,
    width: i,
    columnMenuIconButton: null,
    columnTitleIconButtons: null,
    resizable: !1,
    label: Y,
    "aria-colspan": f.length,
    "data-fields": `|-${f.join("-|-")}-|`
  }, B));
}
const UA = se("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderRow",
  overridesResolver: (e, t) => t.columnHeaderRow
})(() => ({
  display: "flex"
}));
function i0e(e) {
  return !!e.target;
}
const l0e = (e) => {
  const {
    innerRef: t,
    minColumnIndex: o = 0,
    visibleColumns: i,
    sortColumnLookup: s,
    filterColumnLookup: c,
    columnPositions: f,
    columnHeaderTabIndexState: m,
    columnGroupHeaderTabIndexState: h,
    columnHeaderFocus: v,
    columnGroupHeaderFocus: b,
    densityFactor: x,
    headerGroupingMaxDepth: E,
    columnMenuState: T,
    columnVisibility: P,
    columnGroupsHeaderStructure: O,
    hasOtherElementInTabSequence: k
  } = e, I = mr(), [$, _] = C.useState(""), [z, V] = C.useState(""), M = Cd(), A = Nt(M, Y4), W = Ht(), Y = C.useRef(null), H = Cn(t, Y), [G, ne] = C.useState(null), K = C.useRef(G), B = C.useRef(0), q = up(M, W), X = iM(M, W.columnHeaderHeight), J = Math.floor(W.columnHeaderHeight * x), U = C.useCallback((Ne) => {
    G && Ne && $B(G, Ne) || ne(Ne);
  }, [G]);
  C.useEffect(() => {
    M.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
  }, [M]);
  const Z = C.useRef(zx(Gye, {
    equalityCheck: (Ne, Pe) => ["firstColumnIndex", "minColumnIndex", "columnBuffer"].every((Se) => Ne[Se] === Pe[Se])
  })), ee = C.useCallback((Ne) => {
    const [Pe, Se] = od({
      firstIndex: Ne.firstRowIndex,
      lastIndex: Ne.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: q.rows.length,
      buffer: W.rowBuffer
    }), Fe = Z.current({
      firstColumnIndex: Ne.firstColumnIndex,
      minColumnIndex: o,
      columnBuffer: W.columnBuffer,
      firstRowToRender: Pe,
      lastRowToRender: Se,
      apiRef: M,
      visibleRows: q.rows
    }), ce = I.direction === "ltr" ? 1 : -1, ge = Fe > 0 ? B.current - ce * f[Fe] : B.current;
    Y.current.style.transform = `translate3d(${-ge}px, 0px, 0px)`;
  }, [f, o, W.columnBuffer, M, q.rows, W.rowBuffer, I.direction]);
  C.useLayoutEffect(() => {
    G && ee(G);
  }, [G, ee]);
  const ie = C.useCallback(({
    left: Ne,
    renderContext: Pe = null
  }, Se) => {
    var Fe, ce;
    if (!Y.current || B.current === Ne && ((Fe = K.current) == null ? void 0 : Fe.firstColumnIndex) === (Pe == null ? void 0 : Pe.firstColumnIndex) && ((ce = K.current) == null ? void 0 : ce.lastColumnIndex) === (Pe == null ? void 0 : Pe.lastColumnIndex))
      return;
    B.current = Ne;
    let ge = !1;
    Pe !== K.current || !K.current ? (i0e(Se) ? (ep.flushSync(() => {
      U(Pe);
    }), ge = !0) : U(Pe), K.current = Pe) : ge = !0, Pe && ge && ee(Pe);
  }, [ee, U]), oe = C.useCallback((Ne) => V(Ne.field), []), le = C.useCallback(() => V(""), []), de = C.useCallback((Ne) => _(Ne.field), []), Ce = C.useCallback(() => _(""), []);
  Yt(M, "columnResizeStart", oe), Yt(M, "columnResizeStop", le), Yt(M, "columnHeaderDragStart", de), Yt(M, "columnHeaderDragEnd", Ce), Yt(M, "scrollPositionChange", ie);
  const me = (Ne) => {
    const {
      renderContext: Pe = G,
      minFirstColumn: Se = o,
      maxLastColumn: Fe = i.length
    } = Ne || {};
    if (!Pe)
      return null;
    const [ce, ge] = od({
      firstIndex: Pe.firstRowIndex,
      lastIndex: Pe.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: q.rows.length,
      buffer: W.rowBuffer
    }), we = A ? Z.current({
      firstColumnIndex: Pe.firstColumnIndex,
      minColumnIndex: Se,
      columnBuffer: W.columnBuffer,
      apiRef: M,
      firstRowToRender: ce,
      lastRowToRender: ge,
      visibleRows: q.rows
    }) : 0, Me = A ? Math.min(Pe.lastColumnIndex + W.columnBuffer, Fe) : Fe;
    return {
      renderedColumns: i.slice(we, Me),
      firstColumnToRender: we,
      lastColumnToRender: Me,
      minFirstColumn: Se,
      maxLastColumn: Fe
    };
  }, Oe = (Ne, Pe = {}) => {
    const Se = me(Ne);
    if (Se == null)
      return null;
    const {
      renderedColumns: Fe,
      firstColumnToRender: ce
    } = Se, ge = [];
    for (let we = 0; we < Fe.length; we += 1) {
      const Me = Fe[we], Qe = ce + we, ct = Qe === 0, Ze = m !== null && m.field === Me.field || ct && !k ? 0 : -1, Ge = v !== null && v.field === Me.field, Be = T.open && T.field === Me.field;
      ge.push(/* @__PURE__ */ L(_4, S({}, s[Me.field], {
        columnMenuOpen: Be,
        filterItemsCounter: c[Me.field] && c[Me.field].length,
        headerHeight: J,
        isDragging: Me.field === $,
        colDef: Me,
        colIndex: Qe,
        isResizing: z === Me.field,
        hasFocus: Ge,
        tabIndex: Ze
      }, Pe), Me.field));
    }
    return /* @__PURE__ */ L(UA, {
      role: "row",
      "aria-rowindex": E + 1,
      ownerState: W,
      children: ge
    });
  }, he = (Ne) => {
    if (E === 0)
      return null;
    const Pe = me(Ne);
    if (Pe == null || Pe.renderedColumns.length === 0)
      return null;
    const {
      firstColumnToRender: Se,
      lastColumnToRender: Fe
    } = Pe, ce = [], ge = [];
    for (let Qe = 0; Qe < E; Qe += 1) {
      var we, Me;
      const ct = O[Qe], Ze = i[Se].field, Ge = (we = M.current.unstable_getColumnGroupPath(Ze)[Qe]) != null ? we : null, Be = ct.findIndex(({
        groupId: st,
        columnFields: _e
      }) => st === Ge && _e.includes(Ze)), rt = i[Fe - 1].field, wt = (Me = M.current.unstable_getColumnGroupPath(rt)[Qe]) != null ? Me : null, We = ct.findIndex(({
        groupId: st,
        columnFields: _e
      }) => st === wt && _e.includes(rt)), ut = ct.slice(Be, We + 1).map((st) => S({}, st, {
        columnFields: st.columnFields.filter((_e) => P[_e] !== !1)
      })).filter((st) => st.columnFields.length > 0), ft = ut[0].columnFields.indexOf(Ze), pt = ut[0].columnFields.slice(0, ft).reduce((st, _e) => {
        var vt;
        const et = M.current.getColumn(_e);
        return st + ((vt = et.computedWidth) != null ? vt : 0);
      }, 0);
      let At = Se;
      const Ye = ut.map(({
        groupId: st,
        columnFields: _e
      }) => {
        const vt = b !== null && b.depth === Qe && _e.includes(b.field), et = h !== null && h.depth === Qe && _e.includes(h.field) ? 0 : -1, gt = {
          groupId: st,
          width: _e.reduce((kt, Lt) => kt + M.current.getColumn(Lt).computedWidth, 0),
          fields: _e,
          colIndex: At,
          hasFocus: vt,
          tabIndex: et
        };
        return At += _e.length, gt;
      });
      ge.push({
        leftOverflow: pt,
        elements: Ye
      });
    }
    return ge.forEach((Qe, ct) => {
      ce.push(/* @__PURE__ */ L(UA, {
        style: {
          height: `${J}px`,
          transform: `translateX(-${Qe.leftOverflow}px)`
        },
        role: "row",
        "aria-rowindex": ct + 1,
        ownerState: W,
        children: Qe.elements.map(({
          groupId: Ze,
          width: Ge,
          fields: Be,
          colIndex: rt,
          hasFocus: wt,
          tabIndex: We
        }, ut) => /* @__PURE__ */ L(a0e, {
          groupId: Ze,
          width: Ge,
          fields: Be,
          colIndex: rt,
          depth: ct,
          isLastColumn: rt === i.length - Be.length,
          maxDepth: ge.length,
          height: J,
          hasFocus: wt,
          tabIndex: We
        }, ut))
      }, ct));
    }), ce;
  }, $e = {
    minHeight: X,
    maxHeight: X,
    lineHeight: `${J}px`
  };
  return {
    renderContext: G,
    getColumnHeaders: Oe,
    getColumnsToRender: me,
    getColumnGroupHeaders: he,
    isDragging: !!$,
    getRootProps: (Ne = {}) => S({
      style: $e
    }, Ne),
    getInnerProps: () => ({
      ref: H,
      role: "rowgroup"
    }),
    headerHeight: J
  };
}, s0e = ["className"], c0e = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["columnHeaders", "withBorderColor"]
  }, $n, t);
}, u0e = xo("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaders",
  overridesResolver: (e, t) => t.columnHeaders
})({
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  borderBottom: "1px solid",
  borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
  borderTopRightRadius: "var(--unstable_DataGrid-radius)"
}), d0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, s0e), c = Ht(), f = c0e(c);
  return /* @__PURE__ */ L(u0e, S({
    ref: o,
    className: be(i, f.root),
    ownerState: c
  }, s, {
    role: "presentation"
  }));
}), f0e = ["isDragging", "className"], p0e = (e) => {
  const {
    isDragging: t,
    hasScrollX: o,
    classes: i
  } = e;
  return je({
    root: ["columnHeadersInner", t && "columnHeaderDropZone", o && "columnHeadersInner--scrollable"]
  }, $n, i);
}, m0e = xo("div", {
  name: "MuiDataGrid",
  slot: "columnHeadersInner",
  overridesResolver: (e, t) => [{
    [`&.${Te.columnHeaderDropZone}`]: t.columnHeaderDropZone
  }, t.columnHeadersInner]
})(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  [`&.${Te.columnHeaderDropZone} .${Te.columnHeaderDraggableContainer}`]: {
    cursor: "move"
  },
  [`&.${Te["columnHeadersInner--scrollable"]} .${Te.columnHeader}:last-child`]: {
    borderRight: "none"
  }
})), h0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i, s;
  const {
    isDragging: c,
    className: f
  } = t, m = pe(t, f0e), h = Tn(), v = Ht(), b = S({}, v, {
    isDragging: c,
    hasScrollX: (i = (s = h.current.getRootDimensions()) == null ? void 0 : s.hasScrollX) != null ? i : !1
  }), x = p0e(b);
  return /* @__PURE__ */ L(m0e, S({
    ref: o,
    className: be(f, x.root),
    ownerState: b
  }, m));
}), g0e = ["innerRef", "className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnPositions", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "densityFactor", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"], DB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    innerRef: i,
    visibleColumns: s,
    sortColumnLookup: c,
    filterColumnLookup: f,
    columnPositions: m,
    columnHeaderTabIndexState: h,
    columnGroupHeaderTabIndexState: v,
    columnHeaderFocus: b,
    columnGroupHeaderFocus: x,
    densityFactor: E,
    headerGroupingMaxDepth: T,
    columnMenuState: P,
    columnVisibility: O,
    columnGroupsHeaderStructure: k,
    hasOtherElementInTabSequence: I
  } = t, $ = pe(t, g0e), {
    isDragging: _,
    getRootProps: z,
    getInnerProps: V,
    getColumnHeaders: M,
    getColumnGroupHeaders: A
  } = l0e({
    innerRef: i,
    visibleColumns: s,
    sortColumnLookup: c,
    filterColumnLookup: f,
    columnPositions: m,
    columnHeaderTabIndexState: h,
    columnGroupHeaderTabIndexState: v,
    columnHeaderFocus: b,
    columnGroupHeaderFocus: x,
    densityFactor: E,
    headerGroupingMaxDepth: T,
    columnMenuState: P,
    columnVisibility: O,
    columnGroupsHeaderStructure: k,
    hasOtherElementInTabSequence: I
  });
  return /* @__PURE__ */ L(d0e, S({
    ref: o
  }, z($), {
    children: /* @__PURE__ */ ht(h0e, S({
      isDragging: _
    }, V(), {
      children: [A(), M()]
    }))
  }));
});
process.env.NODE_ENV !== "production" && (DB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: n.shape({
    depth: n.number.isRequired,
    field: n.string.isRequired
  }),
  columnGroupHeaderTabIndexState: n.shape({
    depth: n.number.isRequired,
    field: n.string.isRequired
  }),
  columnGroupsHeaderStructure: n.arrayOf(n.arrayOf(n.shape({
    columnFields: n.arrayOf(n.string).isRequired,
    groupId: n.string
  }))).isRequired,
  columnHeaderFocus: n.shape({
    field: n.string.isRequired
  }),
  columnHeaderTabIndexState: n.shape({
    field: n.string.isRequired
  }),
  columnMenuState: n.shape({
    field: n.string,
    open: n.bool.isRequired
  }).isRequired,
  columnPositions: n.arrayOf(n.number).isRequired,
  columnVisibility: n.object.isRequired,
  densityFactor: n.number.isRequired,
  filterColumnLookup: n.object.isRequired,
  hasOtherElementInTabSequence: n.bool.isRequired,
  headerGroupingMaxDepth: n.number.isRequired,
  innerRef: Fo,
  minColumnIndex: n.number,
  sortColumnLookup: n.object.isRequired,
  visibleColumns: n.arrayOf(n.object).isRequired
});
const v0e = qx(DB), b0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const s = Tn().current.getLocaleText("noResultsOverlayLabel");
  return /* @__PURE__ */ L(Kx, S({
    ref: o
  }, t, {
    children: s
  }));
}), y0e = ["sortingOrder"], C0e = /* @__PURE__ */ C.memo(function(t) {
  const {
    sortingOrder: o
  } = t, i = pe(t, y0e), s = Ht(), [c] = o, f = c === "asc" ? s.slots.columnSortedAscendingIcon : s.slots.columnSortedDescendingIcon;
  return f ? /* @__PURE__ */ L(f, S({}, i)) : null;
}), S0e = ["native"];
function x0e(e) {
  let {
    native: t
  } = e, o = pe(e, S0e);
  return t ? /* @__PURE__ */ L("option", S({}, o)) : /* @__PURE__ */ L(Vs, S({}, o));
}
const w0e = {
  BooleanCellTrueIcon: Rve,
  BooleanCellFalseIcon: pR,
  ColumnMenuIcon: wve,
  OpenFilterButtonIcon: gve,
  FilterPanelDeleteIcon: pR,
  ColumnFilteredIcon: EA,
  ColumnSelectorIcon: bve,
  ColumnUnsortedIcon: C0e,
  ColumnSortedAscendingIcon: CA,
  ColumnSortedDescendingIcon: SA,
  ColumnResizeIcon: yve,
  DensityCompactIcon: Cve,
  DensityStandardIcon: Sve,
  DensityComfortableIcon: xve,
  ExportIcon: Ove,
  MoreActionsIcon: kve,
  TreeDataCollapseIcon: wA,
  TreeDataExpandIcon: xA,
  GroupingCriteriaCollapseIcon: wA,
  GroupingCriteriaExpandIcon: xA,
  DetailPanelExpandIcon: TA,
  DetailPanelCollapseIcon: Eve,
  RowReorderIcon: OA,
  QuickFilterIcon: vve,
  QuickFilterClearIcon: pR,
  ColumnMenuHideIcon: Pve,
  ColumnMenuSortAscendingIcon: CA,
  ColumnMenuSortDescendingIcon: SA,
  ColumnMenuFilterIcon: EA,
  ColumnMenuManageColumnsIcon: Mve,
  ColumnMenuClearIcon: Ive,
  LoadIcon: Tve,
  FilterPanelAddIcon: TA,
  FilterPanelRemoveAllIcon: Nve,
  ColumnReorderIcon: OA
}, E0e = S({}, w0e, {
  BaseCheckbox: az,
  BaseTextField: p5,
  BaseFormControl: kz,
  BaseSelect: vP,
  BaseSwitch: oue,
  BaseButton: KF,
  BaseIconButton: As,
  BaseInputAdornment: uoe,
  BaseTooltip: LV,
  BasePopper: cp,
  BaseInputLabel: Wz,
  BaseSelectOption: x0e,
  BaseChip: EF
}), T0e = E0e, O0e = S({}, T0e, {
  Cell: rk,
  SkeletonCell: T4,
  ColumnHeaderFilterIconButton: K4,
  ColumnMenu: oB,
  ColumnHeaders: v0e,
  Footer: pB,
  FooterRowCount: gB,
  Toolbar: null,
  PreferencesPanel: dbe,
  LoadingOverlay: mB,
  NoResultsOverlay: b0e,
  NoRowsOverlay: hB,
  Pagination: Wbe,
  FilterPanel: uB,
  ColumnsPanel: iB,
  Panel: lB,
  Row: aye
}), _B = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, o) => S({}, t, {
      [`${o.charAt(0).toLowerCase()}${o.slice(1)}`]: e[o]
    }), {});
};
function R0e({
  defaultSlots: e,
  slots: t,
  components: o
}) {
  const i = t ?? (o ? _B(o) : null);
  return !i || Object.keys(i).length === 0 ? e : S({}, e, i);
}
const k0e = ["components", "componentsProps"];
function P0e(e) {
  var t;
  const o = Object.keys(e);
  if (!o.some((c) => c.startsWith("aria-") || c.startsWith("data-")))
    return e;
  const i = {}, s = (t = e.forwardedProps) != null ? t : {};
  for (let c = 0; c < o.length; c += 1) {
    const f = o[c];
    f.startsWith("aria-") || f.startsWith("data-") ? s[f] = e[f] : i[f] = e[f];
  }
  return i.forwardedProps = s, i;
}
function M0e(e) {
  return C.useMemo(() => {
    const {
      components: t,
      componentsProps: o
    } = e, i = pe(e, k0e);
    return [t, o, P0e(i)];
  }, [e]);
}
const I0e = {
  disableMultipleColumnsFiltering: !0,
  disableMultipleColumnsSorting: !0,
  disableMultipleRowSelection: !0,
  throttleRowsMs: void 0,
  hideFooterRowCount: !1,
  pagination: !0,
  checkboxSelectionVisibleOnly: !1,
  disableColumnReorder: !0,
  disableColumnResize: !0,
  keepColumnPositionIfDraggedOutside: !1,
  signature: "DataGrid"
}, Qx = {
  autoHeight: !1,
  autoPageSize: !1,
  checkboxSelection: !1,
  checkboxSelectionVisibleOnly: !1,
  columnBuffer: 3,
  rowBuffer: 3,
  columnThreshold: 3,
  rowThreshold: 3,
  rowSelection: !0,
  density: "standard",
  disableColumnFilter: !1,
  disableColumnMenu: !1,
  disableColumnSelector: !1,
  disableDensitySelector: !1,
  disableEval: !1,
  disableMultipleColumnsFiltering: !1,
  disableMultipleRowSelection: !1,
  disableMultipleColumnsSorting: !1,
  disableRowSelectionOnClick: !1,
  disableVirtualization: !1,
  editMode: Us.Cell,
  filterMode: "client",
  filterDebounceMs: 150,
  columnHeaderHeight: 56,
  hideFooter: !1,
  hideFooterPagination: !1,
  hideFooterRowCount: !1,
  hideFooterSelectedRowCount: !1,
  logger: console,
  logLevel: process.env.NODE_ENV === "production" ? "error" : "warn",
  pagination: !1,
  paginationMode: "client",
  rowHeight: 52,
  pageSizeOptions: [25, 50, 100],
  rowSpacingType: "margin",
  showCellVerticalBorder: !1,
  showColumnVerticalBorder: !1,
  sortingOrder: ["asc", "desc", null],
  sortingMode: "client",
  throttleRowsMs: 0,
  disableColumnReorder: !1,
  disableColumnResize: !1,
  keepNonExistentRowsSelected: !1,
  keepColumnPositionIfDraggedOutside: !1,
  unstable_ignoreValueFormatterDuringExport: !1,
  clipboardCopyCellDelimiter: "	"
}, N0e = _B(O0e), $0e = (e) => {
  const [t, o, i] = M0e(dt({
    props: e,
    name: "MuiDataGrid"
  })), s = C.useMemo(() => S({}, HCe, i.localeText), [i.localeText]), c = C.useMemo(() => R0e({
    defaultSlots: N0e,
    slots: i.slots,
    components: t
  }), [t, i.slots]);
  return C.useMemo(() => {
    var f;
    return S({}, Qx, i, {
      localeText: s,
      slots: c,
      slotProps: (f = i.slotProps) != null ? f : o
    }, I0e);
  }, [i, s, c, o]);
}, D0e = (e) => S({}, e, {
  rowsMeta: {
    currentPageTotalHeight: 0,
    positions: []
  }
});
let GA = !1;
const WA = (e, t, o) => typeof e == "number" && e > 0 ? e : (process.env.NODE_ENV !== "production" && !GA && typeof e < "u" && e !== null && (console.warn(o), GA = !0), t), _0e = ["MUI: The `rowHeight` prop should be a number greater than 0.", "The default value will be used instead."].join(`
`), A0e = ["MUI: The `getRowHeight` prop should return a number greater than 0 or 'auto'.", "The default value will be used instead."].join(`
`), L0e = (e, t) => {
  const {
    getRowHeight: o,
    getRowSpacing: i,
    getEstimatedRowHeight: s
  } = t, c = C.useRef(/* @__PURE__ */ Object.create(null)), f = C.useRef(-1), m = C.useRef(!1), h = Nt(e, Qh), v = Nt(e, oa), b = Nt(e, B4), x = Nt(e, el), E = up(e, t), T = Nt(e, Xh), P = WA(t.rowHeight, Qx.rowHeight, _0e), O = Math.floor(P * h), k = C.useCallback(() => {
    var ne, K;
    m.current = !1;
    const B = (J) => {
      c.current[J.id] || (c.current[J.id] = {
        sizes: {
          baseCenter: O
        },
        isResized: !1,
        autoHeight: !1,
        needsFirstMeasurement: !0
        // Assume all rows will need to be measured by default
      });
      const {
        isResized: U,
        needsFirstMeasurement: Z,
        sizes: ee
      } = c.current[J.id];
      let ie = typeof O == "number" && O > 0 ? O : 52;
      const oe = ee.baseCenter;
      if (U)
        ie = oe;
      else if (o) {
        const Oe = o(S({}, J, {
          densityFactor: h
        }));
        if (Oe === "auto") {
          if (Z) {
            const he = s ? s(S({}, J, {
              densityFactor: h
            })) : O;
            ie = he ?? O;
          } else
            ie = oe;
          m.current = !0, c.current[J.id].autoHeight = !0;
        } else
          ie = WA(Oe, O, A0e), c.current[J.id].needsFirstMeasurement = !1, c.current[J.id].autoHeight = !1;
      } else
        c.current[J.id].needsFirstMeasurement = !1;
      const le = {};
      for (const Oe in ee)
        /^base[A-Z]/.test(Oe) && (le[Oe] = ee[Oe]);
      if (le.baseCenter = ie, i) {
        var de, Ce;
        const Oe = e.current.getRowIndexRelativeToVisibleRows(J.id), he = i(S({}, J, {
          isFirstVisible: Oe === 0,
          isLastVisible: Oe === E.rows.length - 1,
          indexRelativeToCurrentPage: Oe
        }));
        le.spacingTop = (de = he.top) != null ? de : 0, le.spacingBottom = (Ce = he.bottom) != null ? Ce : 0;
      }
      const me = e.current.unstable_applyPipeProcessors("rowHeight", le, J);
      return c.current[J.id].sizes = me, me;
    }, q = [], X = E.rows.reduce((J, U) => {
      q.push(J);
      let Z = 0, ee = 0;
      const ie = B(U);
      for (const oe in ie) {
        const le = ie[oe];
        /^base[A-Z]/.test(oe) ? Z = le > Z ? le : Z : ee += le;
      }
      return J + Z + ee;
    }, 0);
    T == null || (ne = T.top) == null || ne.forEach((J) => {
      B(J);
    }), T == null || (K = T.bottom) == null || K.forEach((J) => {
      B(J);
    }), e.current.setState((J) => S({}, J, {
      rowsMeta: {
        currentPageTotalHeight: X,
        positions: q
      }
    })), m.current || (f.current = 1 / 0), e.current.forceUpdate();
  }, [e, E.rows, O, o, i, s, T, h]), I = C.useCallback((ne) => {
    const K = c.current[ne];
    return K ? K.sizes.baseCenter : O;
  }, [O]), $ = (ne) => {
    var K;
    return (K = c.current[ne]) == null ? void 0 : K.sizes;
  }, _ = C.useCallback((ne, K) => {
    c.current[ne].sizes.baseCenter = K, c.current[ne].isResized = !0, c.current[ne].needsFirstMeasurement = !1, k();
  }, [k]), z = C.useMemo(() => lp(k), [k]), V = C.useCallback((ne, K, B) => {
    if (!c.current[ne] || !c.current[ne].autoHeight)
      return;
    const q = c.current[ne].sizes[`base${ve(B)}`] !== K;
    c.current[ne].needsFirstMeasurement = !1, c.current[ne].sizes[`base${ve(B)}`] = K, q && z();
  }, [z]), M = C.useCallback((ne) => {
    var K;
    return ((K = c.current[ne]) == null ? void 0 : K.autoHeight) || !1;
  }, []), A = C.useCallback(() => f.current, []), W = C.useCallback((ne) => {
    m.current && ne > f.current && (f.current = ne);
  }, []), Y = C.useCallback(() => {
    c.current = {}, k();
  }, [k]);
  C.useEffect(() => {
    k();
  }, [O, v, b, x, k]), aM(e, "rowHeight", k);
  const H = {
    unstable_setLastMeasuredRowIndex: W,
    unstable_getRowHeight: I,
    unstable_getRowInternalSizes: $,
    unstable_setRowHeight: _,
    unstable_storeRowHeightMeasurement: V,
    resetRowHeights: Y
  }, G = {
    getLastMeasuredRowIndex: A,
    rowHasAutoHeight: M
  };
  En(e, H, "public"), En(e, G, "private");
}, F0e = (e) => {
  const t = C.useCallback((s = {}) => e.current.unstable_applyPipeProcessors("exportState", {}, s), [e]), o = C.useCallback((s) => {
    e.current.unstable_applyPipeProcessors("restoreState", {
      callbacks: []
    }, {
      stateToRestore: s
    }).callbacks.forEach((f) => {
      f();
    }), e.current.forceUpdate();
  }, [e]);
  En(e, {
    exportState: t,
    restoreState: o
  }, "public");
}, z0e = (e) => {
  const t = C.useRef({}), o = C.useCallback((v, b, x) => {
    const E = t.current;
    E[v] || (E[v] = {}), E[v][b] = x;
  }, []), i = C.useCallback((v, b) => {
    var x;
    return (x = t.current[v]) == null ? void 0 : x[b];
  }, []), s = C.useCallback((v) => {
    const {
      columnIndex: b,
      rowId: x,
      minFirstColumnIndex: E,
      maxLastColumnIndex: T,
      columns: P
    } = v, O = P.length, k = P[b], I = typeof k.colSpan == "function" ? k.colSpan(e.current.getCellParams(x, k.field)) : k.colSpan;
    if (!I || I === 1)
      return o(x, b, {
        spannedByColSpan: !1,
        cellProps: {
          colSpan: 1,
          width: k.computedWidth
        }
      }), {
        colSpan: 1
      };
    let $ = k.computedWidth;
    for (let _ = 1; _ < I; _ += 1) {
      const z = b + _;
      if (z >= E && z < T) {
        const V = P[z];
        $ += V.computedWidth, o(x, b + _, {
          spannedByColSpan: !0,
          rightVisibleCellIndex: Math.min(b + I, O - 1),
          leftVisibleCellIndex: b
        });
      }
      o(x, b, {
        spannedByColSpan: !1,
        cellProps: {
          colSpan: I,
          width: $
        }
      });
    }
    return {
      colSpan: I
    };
  }, [e, o]), c = C.useCallback(({
    rowId: v,
    minFirstColumn: b,
    maxLastColumn: x,
    columns: E
  }) => {
    for (let T = b; T < x; T += 1) {
      const P = s({
        columnIndex: T,
        rowId: v,
        minFirstColumnIndex: b,
        maxLastColumnIndex: x,
        columns: E
      });
      P.colSpan > 1 && (T += P.colSpan - 1);
    }
  }, [s]), f = {
    unstable_getCellColSpanInfo: i
  }, m = {
    calculateColSpan: c
  };
  En(e, f, "public"), En(e, m, "private");
  const h = C.useCallback(() => {
    t.current = {};
  }, []);
  Yt(e, "columnOrderChange", h);
}, AB = (e, t, o) => {
  if (u4(e)) {
    if (o[e.field] !== void 0)
      throw new Error(["MUI: columnGroupingModel contains duplicated field", `column field ${e.field} occurs two times in the grouping model:`, `- ${o[e.field].join(" > ")}`, `- ${t.join(" > ")}`].join(`
`));
    o[e.field] = t;
    return;
  }
  const {
    groupId: i,
    children: s
  } = e;
  s.forEach((c) => {
    AB(c, [...t, i], o);
  });
}, pk = (e) => {
  if (!e)
    return {};
  const t = {};
  return e.forEach((o) => {
    AB(o, [], t);
  }), t;
}, mk = (e, t) => {
  const o = (f) => {
    var m;
    return (m = t[f]) != null ? m : [];
  }, i = [], s = Math.max(...e.map((f) => o(f).length)), c = (f, m, h) => Qf(o(f).slice(0, h + 1), o(m).slice(0, h + 1));
  for (let f = 0; f < s; f += 1) {
    const m = e.reduce((h, v) => {
      var b;
      const x = (b = o(v)[f]) != null ? b : null;
      if (h.length === 0)
        return [{
          columnFields: [v],
          groupId: x
        }];
      const E = h[h.length - 1], T = E.columnFields[E.columnFields.length - 1];
      return E.groupId !== x || !c(T, v, f) ? [...h, {
        columnFields: [v],
        groupId: x
      }] : [...h.slice(0, h.length - 1), {
        columnFields: [...E.columnFields, v],
        groupId: x
      }];
    }, []);
    i.push(m);
  }
  return i;
}, V0e = ["groupId", "children"], lM = (e) => {
  let t = {};
  return e.forEach((o) => {
    if (u4(o))
      return;
    const {
      groupId: i,
      children: s
    } = o, c = pe(o, V0e);
    if (!i)
      throw new Error("MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.");
    s || console.warn(`MUI: group groupId=${i} has no children.`);
    const f = S({}, c, {
      groupId: i
    }), m = lM(s);
    if (m[i] !== void 0 || t[i] !== void 0)
      throw new Error(`MUI: The groupId ${i} is used multiple times in the columnGroupingModel.`);
    t = S({}, t, m, {
      [i]: f
    });
  }), S({}, t);
}, B0e = (e, t, o) => {
  var i, s, c;
  if (!((i = t.experimentalFeatures) != null && i.columnGrouping))
    return e;
  const f = Vc(o), m = Vx(o), h = lM((s = t.columnGroupingModel) != null ? s : []), v = pk((c = t.columnGroupingModel) != null ? c : []), b = mk(f, v), x = m.length === 0 ? 0 : Math.max(...m.map((E) => {
    var T, P;
    return (T = (P = v[E]) == null ? void 0 : P.length) != null ? T : 0;
  }));
  return S({}, e, {
    columnGrouping: {
      lookup: h,
      unwrappedGroupingModel: v,
      headerStructure: b,
      maxDepth: x
    }
  });
}, j0e = (e, t) => {
  var o;
  const i = C.useCallback((h) => {
    var v;
    return (v = jme(e)[h]) != null ? v : [];
  }, [e]), s = C.useCallback(() => X5(e), [e]);
  En(e, {
    unstable_getColumnGroupPath: i,
    unstable_getAllGroupDetails: s
  }, "public");
  const f = C.useCallback(() => {
    var h;
    const v = pk((h = t.columnGroupingModel) != null ? h : []);
    e.current.setState((b) => {
      var x, E;
      const T = (x = (E = b.columns) == null ? void 0 : E.orderedFields) != null ? x : [], P = mk(T, v);
      return S({}, b, {
        columnGrouping: S({}, b.columnGrouping, {
          headerStructure: P
        })
      });
    });
  }, [e, t.columnGroupingModel]), m = C.useCallback((h) => {
    var v;
    if (!((v = t.experimentalFeatures) != null && v.columnGrouping))
      return;
    const b = Vc(e), x = Vx(e), E = lM(h ?? []), T = pk(h ?? []), P = mk(b, T), O = x.length === 0 ? 0 : Math.max(...x.map((k) => {
      var I, $;
      return (I = ($ = T[k]) == null ? void 0 : $.length) != null ? I : 0;
    }));
    e.current.setState((k) => S({}, k, {
      columnGrouping: {
        lookup: E,
        unwrappedGroupingModel: T,
        headerStructure: P,
        maxDepth: O
      }
    }));
  }, [e, (o = t.experimentalFeatures) == null ? void 0 : o.columnGrouping]);
  Yt(e, "columnIndexChange", f), Yt(e, "columnsChange", () => {
    m(t.columnGroupingModel);
  }), Yt(e, "columnVisibilityModelChange", () => {
    m(t.columnGroupingModel);
  }), C.useEffect(() => {
    m(t.columnGroupingModel);
  }, [m, t.columnGroupingModel]);
}, H0e = (e, t) => {
  const o = Cye(e, t);
  return GCe(o, t), VCe(o), fi(BCe, o, t), fi(Wye, o, t), fi(_Ce, o, t), fi($Ce, o, t), fi(yCe, o, t), fi(WCe, o, t), fi(wCe, o, t), fi(hCe, o, t), fi(Xye, o, t), fi(tCe, o, t), fi(D0e, o, t), fi(Bye, o, t), fi(B0e, o, t), fi(lve, o, t), xCe(o, t), jCe(o, t), qye(o, t), ACe(o, t), Che(o, t), z0e(o), j0e(o, t), DCe(o, t), CCe(o, t), ECe(o, t), bCe(o, t), qCe(o, t), Qye(o, t), nCe(o, t), L0e(o, t), YCe(o, t), jye(o), eCe(o, t), aCe(o, t), Vye(o, t), ZCe(o, t), KCe(o, t), F0e(o), sve(o, t), o;
}, U0e = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["virtualScroller"]
  }, $n, t);
}, G0e = xo("div", {
  name: "MuiDataGrid",
  slot: "VirtualScroller",
  overridesResolver: (e, t) => t.virtualScroller
})({
  overflow: "auto",
  height: "100%",
  // See https://github.com/mui/mui-x/issues/4360
  position: "relative",
  "@media print": {
    overflow: "hidden"
  }
}), W0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = Ht(), s = U0e(i);
  return /* @__PURE__ */ L(G0e, S({
    ref: o
  }, t, {
    className: be(s.root, t.className),
    ownerState: i
  }));
}), q0e = (e, t) => {
  const {
    classes: o
  } = e;
  return je({
    root: ["virtualScrollerContent", t && "virtualScrollerContent--overflowed"]
  }, $n, o);
}, Y0e = xo("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerContent",
  overridesResolver: (e, t) => t.virtualScrollerContent
})({}), K0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  var i;
  const s = Ht(), c = !s.autoHeight && ((i = t.style) == null ? void 0 : i.minHeight) === "auto", f = q0e(s, c);
  return /* @__PURE__ */ L(Y0e, S({
    ref: o
  }, t, {
    ownerState: s,
    className: be(f.root, t.className)
  }));
}), X0e = ["className"], Q0e = (e) => {
  const {
    classes: t
  } = e;
  return je({
    root: ["virtualScrollerRenderZone"]
  }, $n, t);
}, Z0e = xo("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerRenderZone",
  overridesResolver: (e, t) => t.virtualScrollerRenderZone
})({
  position: "absolute",
  display: "flex",
  // Prevents margin collapsing when using `getRowSpacing`
  flexDirection: "column"
}), J0e = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, X0e), c = Ht(), f = Q0e(c);
  return /* @__PURE__ */ L(Z0e, S({
    ref: o,
    className: be(f.root, i),
    ownerState: c
  }, s));
}), eSe = ["className"], tSe = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const {
    className: i
  } = t, s = pe(t, eSe), {
    getRootProps: c,
    getContentProps: f,
    getRenderZoneProps: m,
    getRows: h
  } = r0e({
    ref: o
  });
  return /* @__PURE__ */ ht(W0e, S({
    className: i
  }, c(s), {
    children: [/* @__PURE__ */ L(mhe, {}), /* @__PURE__ */ L(K0e, S({}, f(), {
      children: /* @__PURE__ */ L(J0e, S({}, m(), {
        children: h()
      }))
    }))]
  }));
}), LB = /* @__PURE__ */ C.forwardRef(function(t, o) {
  const i = $0e(t), s = H0e(i.apiRef, i);
  return /* @__PURE__ */ L(iye, {
    privateApiRef: s,
    props: i,
    children: /* @__PURE__ */ ht(O4, S({
      className: i.className,
      style: i.style,
      sx: i.sx,
      ref: o
    }, i.forwardedProps, {
      children: [/* @__PURE__ */ L(Ube, {}), /* @__PURE__ */ L(r4, {
        VirtualScrollerComponent: tSe
      }), /* @__PURE__ */ L(lhe, {})]
    }))
  });
}), nSe = /* @__PURE__ */ C.memo(LB);
Qx.filterDebounceMs;
Qx.filterDebounceMs;
LB.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */
  apiRef: n.shape({
    current: n.object.isRequired
  }),
  /**
   * The label of the grid.
   */
  "aria-label": n.string,
  /**
   * The id of the element containing a label for the grid.
   */
  "aria-labelledby": n.string,
  /**
   * If `true`, the grid height is dynamic and follow the number of rows in the grid.
   * @default false
   */
  autoHeight: n.bool,
  /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */
  autoPageSize: n.bool,
  /**
   * Controls the modes of the cells.
   */
  cellModesModel: n.object,
  /**
   * If `true`, the grid get a first column with a checkbox that allows to select rows.
   * @default false
   */
  checkboxSelection: n.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: n.object,
  /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */
  clipboardCopyCellDelimiter: n.string,
  /**
   * Number of extra columns to be rendered before/after the visible slice.
   * @default 3
   */
  columnBuffer: n.number,
  columnGroupingModel: n.arrayOf(n.object),
  /**
   * Sets the height in pixel of the column headers in the grid.
   * @default 56
   */
  columnHeaderHeight: n.number,
  /**
   * Set of columns of type [[GridColDef[]]].
   */
  columns: co(n.array.isRequired, (e) => e.columns && e.columns.some((t) => t.resizable) ? new Error(["MUI: `column.resizable = true` is not a valid prop.", "Column resizing is not available in the MIT version.", "", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`)) : null),
  /**
   * Number of rows from the `columnBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */
  columnThreshold: n.number,
  /**
   * Set the column visibility model of the grid.
   * If defined, the grid will ignore the `hide` property in [[GridColDef]].
   */
  columnVisibilityModel: n.object,
  /**
   * Overridable components.
   * @deprecated Use `slots` instead.
   */
  components: n.object,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   * @deprecated Use the `slotProps` prop instead.
   */
  componentsProps: n.object,
  /**
   * Set the density of the grid.
   * @default "standard"
   */
  density: n.oneOf(["comfortable", "compact", "standard"]),
  /**
   * If `true`, column filters are disabled.
   * @default false
   */
  disableColumnFilter: n.bool,
  /**
   * If `true`, the column menu is disabled.
   * @default false
   */
  disableColumnMenu: n.bool,
  /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */
  disableColumnSelector: n.bool,
  /**
   * If `true`, the density selector is disabled.
   * @default false
   */
  disableDensitySelector: n.bool,
  /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   * @ignore - do not document
   */
  disableEval: n.bool,
  /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */
  disableRowSelectionOnClick: n.bool,
  /**
   * If `true`, the virtualization is disabled.
   * @default false
   */
  disableVirtualization: n.bool,
  /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */
  editMode: n.oneOf(["cell", "row"]),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: n.shape({
    ariaV7: n.bool,
    columnGrouping: n.bool,
    warnIfFocusStateIsNotSynced: n.bool
  }),
  /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */
  filterDebounceMs: n.number,
  /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */
  filterMode: n.oneOf(["client", "server"]),
  /**
   * Set the filter model of the grid.
   */
  filterModel: n.shape({
    items: n.arrayOf(n.shape({
      field: n.string.isRequired,
      id: n.oneOfType([n.number, n.string]),
      operator: n.string.isRequired,
      value: n.any
    })).isRequired,
    logicOperator: n.oneOf(["and", "or"]),
    quickFilterExcludeHiddenColumns: n.bool,
    quickFilterLogicOperator: n.oneOf(["and", "or"]),
    quickFilterValues: n.array
  }),
  /**
   * Forwarded props for the grid root element.
   * @ignore - do not document.
   */
  forwardedProps: n.object,
  /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */
  getCellClassName: n.func,
  /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */
  getDetailPanelContent: n.func,
  /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */
  getEstimatedRowHeight: n.func,
  /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */
  getRowClassName: n.func,
  /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */
  getRowHeight: n.func,
  /**
   * Return the id of a given [[GridRowModel]].
   */
  getRowId: n.func,
  /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */
  getRowSpacing: n.func,
  /**
   * If `true`, the footer component is hidden.
   * @default false
   */
  hideFooter: n.bool,
  /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */
  hideFooterPagination: n.bool,
  /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */
  hideFooterSelectedRowCount: n.bool,
  /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */
  initialState: n.object,
  /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */
  isCellEditable: n.func,
  /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */
  isRowSelectable: n.func,
  /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */
  keepNonExistentRowsSelected: n.bool,
  /**
   * If `true`, a  loading overlay is displayed.
   */
  loading: n.bool,
  /**
   * Set the locale text of the grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/grid/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */
  localeText: n.object,
  /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */
  logger: n.shape({
    debug: n.func.isRequired,
    error: n.func.isRequired,
    info: n.func.isRequired,
    warn: n.func.isRequired
  }),
  /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */
  logLevel: n.oneOf(["debug", "error", "info", "warn", !1]),
  /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */
  nonce: n.string,
  /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellClick: n.func,
  /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellDoubleClick: n.func,
  /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStart: n.func,
  /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStop: n.func,
  /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellKeyDown: n.func,
  /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellModesModelChange: n.func,
  /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */
  onClipboardCopy: n.func,
  /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderClick: n.func,
  /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderDoubleClick: n.func,
  /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderEnter: n.func,
  /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderLeave: n.func,
  /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOut: n.func,
  /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOver: n.func,
  /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnOrderChange: n.func,
  /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnVisibilityModelChange: n.func,
  /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFilterModelChange: n.func,
  /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuClose: n.func,
  /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuOpen: n.func,
  /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPaginationModelChange: n.func,
  /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelClose: n.func,
  /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelOpen: n.func,
  /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */
  onProcessRowUpdateError: n.func,
  /**
   * Callback fired when the grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onResize: n.func,
  /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowClick: n.func,
  /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowDoubleClick: n.func,
  /**
   * Callback fired when the row changes are committed.
   * @param {GridRowId} id The row id.
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditCommit: n.func,
  /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStart: n.func,
  /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStop: n.func,
  /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowModesModelChange: n.func,
  /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowSelectionModelChange: n.func,
  /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onSortModelChange: n.func,
  /**
   * Callback fired when the state of the grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */
  onStateChange: n.func,
  /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */
  pageSizeOptions: n.arrayOf(n.oneOfType([n.number, n.shape({
    label: n.string.isRequired,
    value: n.number.isRequired
  })]).isRequired),
  pagination: (e) => e.pagination === !1 ? new Error(["MUI: `<DataGrid pagination={false} />` is not a valid prop.", "Infinite scrolling is not available in the MIT version.", "", "You need to upgrade to DataGridPro or DataGridPremium component to disable the pagination."].join(`
`)) : null,
  /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */
  paginationMode: n.oneOf(["client", "server"]),
  /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */
  paginationModel: n.shape({
    page: n.number.isRequired,
    pageSize: n.number.isRequired
  }),
  /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */
  processRowUpdate: n.func,
  /**
   * Number of extra rows to be rendered before/after the visible slice.
   * @default 3
   */
  rowBuffer: n.number,
  /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   */
  rowCount: n.number,
  /**
   * Sets the height in pixel of a row in the grid.
   * @default 52
   */
  rowHeight: n.number,
  /**
   * Controls the modes of the rows.
   */
  rowModesModel: n.object,
  /**
   * Set of rows of type [[GridRowsProp]].
   */
  rows: n.arrayOf(n.object).isRequired,
  /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */
  rowSelection: n.bool,
  /**
   * Sets the row selection model of the grid.
   */
  rowSelectionModel: n.oneOfType([n.arrayOf(n.oneOfType([n.number, n.string]).isRequired), n.number, n.string]),
  /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */
  rowSpacingType: n.oneOf(["border", "margin"]),
  /**
   * Number of rows from the `rowBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */
  rowThreshold: n.number,
  /**
   * Override the height/width of the grid inner scrollbar.
   */
  scrollbarSize: n.number,
  /**
   * If `true`, the vertical borders of the cells are displayed.
   * @default false
   */
  showCellVerticalBorder: n.bool,
  /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */
  showColumnVerticalBorder: n.bool,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   */
  slotProps: n.object,
  /**
   * Overridable components.
   */
  slots: n.object,
  /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */
  sortingMode: n.oneOf(["client", "server"]),
  /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */
  sortingOrder: n.arrayOf(n.oneOf(["asc", "desc"])),
  /**
   * Set the sort model of the grid.
   */
  sortModel: n.arrayOf(n.shape({
    field: n.string.isRequired,
    sort: n.oneOf(["asc", "desc"])
  })),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: n.oneOfType([n.arrayOf(n.oneOfType([n.func, n.object, n.bool])), n.func, n.object]),
  /**
   * If `true`, the grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default: false
   */
  unstable_ignoreValueFormatterDuringExport: n.oneOfType([n.shape({
    clipboardExport: n.bool,
    csvExport: n.bool
  }), n.bool])
};
const Vxe = se((e) => /* @__PURE__ */ L(
  nSe,
  {
    disableColumnFilter: !0,
    disableRowSelectionOnClick: !0,
    showColumnVerticalBorder: !0,
    showCellVerticalBorder: !0,
    density: "compact",
    slots: {
      baseButton: yme,
      baseTextField: xme,
      baseCheckbox: dA,
      baseSwitch: dA,
      baseIconButton: Sme,
      columnMenuIcon: () => /* @__PURE__ */ L(yo, { icon: pme, size: "sm" }),
      columnMenuSortAscendingIcon: () => /* @__PURE__ */ L(yo, { icon: uA }),
      columnMenuSortDescendingIcon: () => /* @__PURE__ */ L(yo, { icon: cA }),
      columnSortedAscendingIcon: () => /* @__PURE__ */ L(yo, { icon: uA, size: "sm" }),
      columnSortedDescendingIcon: () => /* @__PURE__ */ L(yo, { icon: cA, size: "sm" }),
      columnUnsortedIcon: () => /* @__PURE__ */ L(yo, { icon: ume, size: "sm" }),
      columnMenuHideIcon: () => /* @__PURE__ */ L(yo, { icon: ime }),
      columnMenuManageColumnsIcon: () => /* @__PURE__ */ L(yo, { icon: lme }),
      columnResizeIcon: () => null
    },
    slotProps: {
      columnsPanel: {
        disableHideAllButton: !0
      }
    },
    ...e
  }
))`
  border-color: ${({ theme: e }) => e.palette.divider};

  .MuiDataGrid-iconButtonContainer {
    margin-left: 5px;
  }
  .MuiDataGrid-columnHeader--alignRight {
    .MuiDataGrid-iconButtonContainer {
      margin-right: 5px;
    }
  }
  .MuiDataGrid-menuIcon {
    margin-right: unset;
    margin-left: unset;
  }
  .MuiDataGrid-withBorderColor {
    border-color: ${({ theme: e }) => e.palette.divider};
    &:last-child {
      border-right: 0;
    }
  }
  .MuiDataGrid-columnHeader {
    border-bottom: solid 1px ${({ theme: e }) => e.palette.divider};
  }
  .MuiDataGrid-menu {
    border: solid 1px ${({ theme: e }) => e.palette.divider};
  }
`;
export {
  Nxe as Accordion,
  PSe as AccordionActions,
  Dxe as AccordionDetails,
  $xe as AccordionSummary,
  _xe as Alert,
  Axe as AlertTitle,
  $Se as AppBar,
  kF as Autocomplete,
  WZ as Avatar,
  _Se as AvatarGroup,
  DF as Backdrop,
  AF as Badge,
  FSe as BottomNavigation,
  zSe as BottomNavigationAction,
  VSe as Box,
  BSe as Breadcrumbs,
  yme as Button,
  Ao as ButtonBase,
  jSe as ButtonGroup,
  USe as Card,
  GSe as CardActionArea,
  qSe as CardActions,
  KSe as CardContent,
  XSe as CardHeader,
  ZSe as CardMedia,
  dA as Checkbox,
  EF as Chip,
  ote as CircularProgress,
  $h as ClickAwayListener,
  Uk as Collapse,
  e1e as Container,
  uz as CssBaseline,
  Vxe as DataGrid,
  a1e as Dialog,
  l1e as DialogActions,
  c1e as DialogContent,
  d1e as DialogContentText,
  f1e as DialogTitle,
  Kte as Divider,
  ine as Drawer,
  ESe as Experimental_CssVarsProvider,
  Tz as Fab,
  NF as Fade,
  Oz as FilledInput,
  kz as FormControl,
  Pne as FormControlLabel,
  _ne as FormGroup,
  Bne as FormHelperText,
  Yne as FormLabel,
  Wne as FormLabelRoot,
  Jk as GlobalStyles,
  v1e as Grid,
  ay as Grow,
  Pre as Hidden,
  x1e as Icon,
  Sme as IconButton,
  E1e as ImageList,
  T1e as ImageListItem,
  R1e as ImageListItemBar,
  sP as Input,
  uoe as InputAdornment,
  Gh as InputBase,
  Wz as InputLabel,
  Roe as LinearProgress,
  Lxe as Link,
  Hoe as List,
  $1e as ListItem,
  _1e as ListItemAvatar,
  I1e as ListItemButton,
  Eh as ListItemIcon,
  rae as ListItemSecondaryAction,
  Th as ListItemText,
  eZ as ListSubheader,
  Uae as Menu,
  Vs as MenuItem,
  Dx as MenuList,
  Fxe as MerinioTheme,
  z1e as MobileStepper,
  nP as Modal,
  PQ as ModalManager,
  V1e as NativeSelect,
  A1 as NoSsr,
  gV as OutlinedInput,
  j1e as Pagination,
  $ie as PaginationItem,
  Ci as Paper,
  $ae as Popover,
  aV as PopoverPaper,
  Nae as PopoverRoot,
  cp as Popper,
  ry as Portal,
  H1e as Radio,
  U1e as RadioGroup,
  G1e as Rating,
  q1e as ScopedCssBaseline,
  vP as Select,
  Vle as Skeleton,
  Zte as Slide,
  K1e as Slider,
  Zle as SliderMark,
  Jle as SliderMarkLabel,
  Yle as SliderRail,
  qle as SliderRoot,
  Xle as SliderThumb,
  Kle as SliderTrack,
  Qle as SliderValueLabel,
  Z1e as Snackbar,
  cse as SnackbarContent,
  J1e as SpeedDial,
  exe as SpeedDialAction,
  txe as SpeedDialIcon,
  Sne as Stack,
  axe as Step,
  ixe as StepButton,
  Pce as StepConnector,
  cxe as StepContent,
  Py as StepContext,
  sce as StepIcon,
  vce as StepLabel,
  dxe as Stepper,
  qh as StepperContext,
  wG as StyledEngineProvider,
  IR as SvgIcon,
  fxe as SwipeableDrawer,
  oue as Switch,
  pd as THEME_ID,
  pxe as Tab,
  Dde as TabScrollButton,
  hxe as Table,
  vxe as TableBody,
  zR as TableCell,
  yxe as TableContainer,
  Sxe as TableFooter,
  wxe as TableHead,
  dde as TablePagination,
  Txe as TableRow,
  Oxe as TableSortLabel,
  Rxe as Tabs,
  xme as TextField,
  CF as TextareaAutosize,
  tF as ThemeProvider,
  Pxe as ToggleButton,
  Mxe as ToggleButtonGroup,
  Kue as Toolbar,
  LV as Tooltip,
  Ea as Typography,
  b1e as Unstable_Grid2,
  ey as Unstable_TrapFocus,
  vse as Zoom,
  kSe as accordionActionsClasses,
  jS as accordionClasses,
  hSe as accordionDetailsClasses,
  hh as accordionSummaryClasses,
  vSe as adaptV4Theme,
  tD as alertClasses,
  ISe as alertTitleClasses,
  _t as alpha,
  NSe as appBarClasses,
  Nn as autocompleteClasses,
  zZ as avatarClasses,
  KZ as avatarGroupClasses,
  ASe as backdropClasses,
  Ku as badgeClasses,
  FF as bottomNavigationActionClasses,
  LSe as bottomNavigationClasses,
  IJ as breadcrumbsClasses,
  rY as buttonBaseClasses,
  XS as buttonClasses,
  aa as buttonGroupClasses,
  ve as capitalize,
  qO as cardActionAreaClasses,
  WSe as cardActionsClasses,
  HSe as cardClasses,
  YSe as cardContentClasses,
  kD as cardHeaderClasses,
  QSe as cardMediaClasses,
  YO as checkboxClasses,
  Wn as chipClasses,
  JSe as circularProgressClasses,
  fSe as collapseClasses,
  gSe as colors,
  n1e as containerClasses,
  CR as createChainedFunction,
  SF as createFilterOptions,
  cSe as createMuiTheme,
  ySe as createStyles,
  rn as createSvgIcon,
  Jf as createTheme,
  fd as css,
  r1e as darkScrollbar,
  Wl as darken,
  lp as debounce,
  Bc as decomposeColor,
  lSe as deprecatedPropType,
  i1e as dialogActionsClasses,
  KO as dialogClasses,
  s1e as dialogContentClasses,
  u1e as dialogContentTextClasses,
  Ite as dialogTitleClasses,
  $D as dividerClasses,
  p1e as drawerClasses,
  BL as duration,
  tq as easing,
  M1 as emphasize,
  se as experimentalStyled,
  oK as experimental_extendTheme,
  RSe as experimental_sx,
  _D as fabClasses,
  $i as filledInputClasses,
  m1e as formControlClasses,
  Ab as formControlLabelClasses,
  g1e as formGroupClasses,
  AD as formHelperTextClasses,
  Gb as formLabelClasses,
  ot as generateUtilityClass,
  lt as generateUtilityClasses,
  sK as getAccordionActionsUtilityClass,
  hY as getAccordionDetailsUtilityClass,
  lY as getAccordionSummaryUtilityClass,
  Vq as getAccordionUtilityClass,
  FK as getAlertTitleUtilityClass,
  pK as getAlertUtilityClass,
  UK as getAppBarUtilityClass,
  CZ as getAutocompleteUtilityClass,
  qZ as getAvatarGroupUtilityClass,
  LZ as getAvatarUtilityClass,
  nJ as getBackdropUtilityClass,
  lJ as getBadgeUtilityClass,
  bJ as getBottomNavigationActionUtilityClass,
  pJ as getBottomNavigationUtilityClass,
  PJ as getBreadcrumbsUtilityClass,
  tY as getButtonBaseUtilityClass,
  GJ as getButtonGroupUtilityClass,
  FJ as getButtonUtilityClass,
  nee as getCardActionAreaUtilityClass,
  see as getCardActionsUtilityClass,
  pee as getCardContentUtilityClass,
  bee as getCardHeaderUtilityClass,
  Oee as getCardMediaUtilityClass,
  QJ as getCardUtilityClass,
  Bee as getCheckboxUtilityClass,
  nZ as getChipUtilityClass,
  Kee as getCircularProgressUtilityClass,
  Rq as getCollapseUtilityClass,
  t1e as getContainerUtilityClass,
  N2 as getContrastRatio,
  xte as getDialogActionsUtilityClass,
  _te as getDialogContentTextUtilityClass,
  Rte as getDialogContentUtilityClass,
  Pte as getDialogTitleUtilityClass,
  mte as getDialogUtilityClass,
  Hte as getDividerUtilityClass,
  Jte as getDrawerUtilityClass,
  lne as getFabUtilityClass,
  bZ as getFilledInputUtilityClass,
  wne as getFormControlLabelUtilityClasses,
  gne as getFormControlUtilityClasses,
  Mne as getFormGroupUtilityClass,
  Ane as getFormHelperTextUtilityClasses,
  jne as getFormLabelUtilityClasses,
  y1e as getGrid2UtilityClass,
  Kne as getGridUtilityClass,
  hK as getIconButtonUtilityClass,
  Mre as getIconUtilityClass,
  Gre as getImageListItemBarUtilityClass,
  Vre as getImageListItemUtilityClass,
  _re as getImageListUtilityClass,
  OSe as getInitColorSchemeScript,
  ooe as getInputAdornmentUtilityClass,
  cZ as getInputBaseUtilityClass,
  doe as getInputLabelUtilityClasses,
  mZ as getInputUtilityClass,
  goe as getLinearProgressUtilityClass,
  koe as getLinkUtilityClass,
  uae as getListItemAvatarUtilityClass,
  Woe as getListItemButtonUtilityClass,
  hae as getListItemIconUtilityClass,
  Zoe as getListItemSecondaryActionClassesUtilityClass,
  Cae as getListItemTextUtilityClass,
  Uoe as getListItemUtilityClass,
  KQ as getListSubheaderUtilityClass,
  Foe as getListUtilityClass,
  RR as getLuminance,
  Gae as getMenuItemUtilityClass,
  Dae as getMenuUtilityClass,
  Qae as getMobileStepperUtilityClass,
  ste as getModalUtilityClass,
  uV as getNativeSelectUtilityClasses,
  QD as getOffsetLeft,
  XD as getOffsetTop,
  gZ as getOutlinedInputUtilityClass,
  NR as getOverlayAlpha,
  Oie as getPaginationItemUtilityClass,
  xie as getPaginationUtilityClass,
  _q as getPaperUtilityClass,
  Oae as getPopoverUtilityClass,
  Gie as getRadioUtilityClass,
  ele as getRatingUtilityClass,
  ple as getScopedCssBaselineUtilityClass,
  ble as getSelectUtilityClasses,
  $le as getSkeletonUtilityClass,
  Hle as getSliderUtilityClass,
  nse as getSnackbarContentUtilityClass,
  use as getSnackbarUtilityClass,
  Ase as getSpeedDialActionUtilityClass,
  Gse as getSpeedDialIconUtilityClass,
  bse as getSpeedDialUtilityClass,
  bce as getStepButtonUtilityClass,
  wce as getStepConnectorUtilityClass,
  Mce as getStepContentUtilityClass,
  rce as getStepIconUtilityClass,
  cce as getStepLabelUtilityClass,
  Xse as getStepUtilityClass,
  Ace as getStepperUtilityClass,
  xq as getSvgIconUtilityClass,
  Xce as getSwitchUtilityClass,
  kde as getTabScrollButtonUtilityClass,
  aue as getTabUtilityClass,
  hue as getTableBodyUtilityClass,
  Sue as getTableCellUtilityClass,
  Rue as getTableContainerUtilityClass,
  Nue as getTableFooterUtilityClass,
  Fue as getTableHeadUtilityClass,
  Zue as getTablePaginationUtilityClass,
  fde as getTableRowUtilityClass,
  bde as getTableSortLabelUtilityClass,
  uue as getTableUtilityClass,
  _de as getTabsUtilityClass,
  Ude as getTextFieldUtilityClass,
  nfe as getToggleButtonGroupUtilityClass,
  Xde as getToggleButtonUtilityClass,
  Uue as getToolbarUtilityClass,
  kse as getTooltipUtilityClass,
  mSe as getTouchRippleUtilityClass,
  IK as getTypographyUtilityClass,
  C1e as grid2Classes,
  oy as gridClasses,
  _7 as hexToRgb,
  F7 as hslToRgb,
  vK as iconButtonClasses,
  S1e as iconClasses,
  w1e as imageListClasses,
  O1e as imageListItemBarClasses,
  zD as imageListItemClasses,
  VD as inputAdornmentClasses,
  Ni as inputBaseClasses,
  ad as inputClasses,
  k1e as inputLabelClasses,
  zc as isMuiElement,
  Gs as keyframes,
  ql as lighten,
  P1e as linearProgressClasses,
  Moe as linkClasses,
  M1e as listClasses,
  D1e as listItemAvatarClasses,
  dh as listItemButtonClasses,
  uh as listItemClasses,
  YD as listItemIconClasses,
  N1e as listItemSecondaryActionClasses,
  V1 as listItemTextClasses,
  DSe as listSubheaderClasses,
  SSe as makeStyles,
  L1e as menuClasses,
  Eb as menuItemClasses,
  F1e as mobileStepperClasses,
  o1e as modalClasses,
  dP as nativeSelectClasses,
  $s as outlinedInputClasses,
  qn as ownerDocument,
  Ta as ownerWindow,
  B1e as paginationClasses,
  Ji as paginationItemClasses,
  pSe as paperClasses,
  A1e as popoverClasses,
  VL as private_createTypography,
  iK as private_excludeVariablesFromRoot,
  n_ as radioClasses,
  Tb as ratingClasses,
  xx as recomposeColor,
  K8 as requirePropFactory,
  CSe as responsiveFontSizes,
  sSe as rgbToHex,
  W1e as scopedCssBaselineClasses,
  Ob as selectClasses,
  O1 as setRef,
  ZY as shouldSkipGeneratingVar,
  Y1e as skeletonClasses,
  Bl as sliderClasses,
  Q1e as snackbarClasses,
  X1e as snackbarContentClasses,
  Fse as speedDialActionClasses,
  ZS as speedDialClasses,
  If as speedDialIconClasses,
  h1e as stackClasses,
  m_ as stepButtonClasses,
  oxe as stepClasses,
  lxe as stepConnectorClasses,
  sxe as stepContentClasses,
  eR as stepIconClasses,
  sd as stepLabelClasses,
  uxe as stepperClasses,
  se as styled,
  uSe as svgIconClasses,
  wa as switchClasses,
  Nf as tabClasses,
  Mde as tabScrollButtonClasses,
  gxe as tableBodyClasses,
  wue as tableCellClasses,
  mxe as tableClasses,
  bxe as tableContainerClasses,
  Cxe as tableFooterClasses,
  xxe as tableHeadClasses,
  Yf as tablePaginationClasses,
  P_ as tableRowClasses,
  aR as tableSortLabelClasses,
  iR as tabsClasses,
  kxe as textFieldClasses,
  __ as toggleButtonClasses,
  Lc as toggleButtonGroupClasses,
  Exe as toolbarClasses,
  ld as tooltipClasses,
  nl as touchRippleClasses,
  MSe as typographyClasses,
  dSe as unstable_ClassNameGenerator,
  je as unstable_composeClasses,
  bSe as unstable_createMuiStrictModeTheme,
  eF as unstable_getUnit,
  Ju as unstable_toUnitless,
  Hn as unstable_useEnhancedEffect,
  Qn as unstable_useId,
  bk as unsupportedProp,
  WQ as useAutocomplete,
  TSe as useColorScheme,
  _i as useControlled,
  zn as useEventCallback,
  Cn as useForkRef,
  Xl as useFormControl,
  vy as useIsFocusVisible,
  vre as useMediaQuery,
  Tie as usePagination,
  Uie as useRadioGroup,
  Ixe as useScrollTrigger,
  rxe as useStepContext,
  nxe as useStepperContext,
  mr as useTheme,
  dt as useThemeProps,
  zxe as useToggleTheme,
  xSe as withStyles,
  wSe as withTheme
};
